(self["webpackChunkpharos"] = self["webpackChunkpharos"] || []).push([[179],{

/***/ "./node_modules/@storybook/addon-postcss/node_modules/css-loader/dist/cjs.js!./node_modules/@storybook/addon-postcss/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].use[2]!./packages/pharos/lib/styles/fonts.css":
/***/ ((module, exports, __webpack_require__) => {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/@storybook/addon-postcss/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@font-face{font-display:swap;font-family:GT America Standard;font-style:normal;font-weight:400;src:url(https://static.ithaka.org/pharos/assets/fonts/GT-America-Standard-Regular.woff) format(\"woff\"),url(https://static.ithaka.org/pharos/assets/fonts/GT-America-Standard-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:GT America Standard;font-style:italic;font-weight:400;src:url(https://static.ithaka.org/pharos/assets/fonts/GT-America-Standard-Regular-Italic.woff) format(\"woff\"),url(https://static.ithaka.org/pharos/assets/fonts/GT-America-Standard-Regular-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:GT America Standard;font-style:normal;font-weight:700;src:url(https://static.ithaka.org/pharos/assets/fonts/GT-America-Standard-Medium.woff) format(\"woff\"),url(https://static.ithaka.org/pharos/assets/fonts/GT-America-Standard-Medium.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:GT America Standard;font-style:italic;font-weight:700;src:url(https://static.ithaka.org/pharos/assets/fonts/GT-America-Standard-Medium-Italic.woff) format(\"woff\"),url(https://static.ithaka.org/pharos/assets/fonts/GT-America-Standard-Medium-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:Ivar Headline;font-style:normal;font-weight:400;src:url(https://static.ithaka.org/pharos/assets/fonts/IvarHeadline-Regular.woff) format(\"woff\"),url(https://static.ithaka.org/pharos/assets/fonts/IvarHeadline-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:Ivar Headline;font-style:italic;font-weight:400;src:url(https://static.ithaka.org/pharos/assets/fonts/IvarHeadline-Italic.woff) format(\"woff\"),url(https://static.ithaka.org/pharos/assets/fonts/IvarHeadline-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:Ivar Headline;font-style:normal;font-weight:700;src:url(https://static.ithaka.org/pharos/assets/fonts/IvarHeadline-Medium.woff) format(\"woff\"),url(https://static.ithaka.org/pharos/assets/fonts/IvarHeadline-Medium.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:Ivar Headline;font-style:italic;font-weight:700;src:url(https://static.ithaka.org/pharos/assets/fonts/IvarHeadline-MediumItalic.woff) format(\"woff\"),url(https://static.ithaka.org/pharos/assets/fonts/IvarHeadline-MediumItalic.woff2) format(\"woff2\")}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "./node_modules/@storybook/addon-postcss/node_modules/css-loader/dist/cjs.js!./node_modules/@storybook/addon-postcss/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].use[2]!./packages/pharos/lib/styles/pharos-alert.css":
/***/ ((module, exports, __webpack_require__) => {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/@storybook/addon-postcss/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-pharos-component=PharosAlert] .pharos-alert__link{color:var(--pharos-alert-color-link-base)}[data-pharos-component=PharosAlert] .pharos-alert__link:hover{text-decoration:none}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "./node_modules/@storybook/addon-postcss/node_modules/css-loader/dist/cjs.js!./node_modules/@storybook/addon-postcss/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].use[2]!./packages/pharos/lib/styles/pharos-footer.css":
/***/ ((module, exports, __webpack_require__) => {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/@storybook/addon-postcss/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".goog-te-gadget{display:inline-flex}div#google_translate_element div.goog-te-gadget-simple{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:transparent;border:1px solid var(--pharos-color-ui-40);border-color:var(--pharos-color-interactive-tertiary);border-radius:var(--pharos-radius-base-standard);color:var(--pharos-color-text-base);color:var(--pharos-color-interactive-tertiary);cursor:pointer;display:flex;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-font-size-base);font-weight:var(--pharos-font-weight-bold);justify-content:center;letter-spacing:calc(var(--pharos-font-size-base)*-.02);line-height:var(--pharos-line-height-medium);margin:0;padding:var(--pharos-spacing-one-quarter-x) var(--pharos-spacing-three-quarters-x);text-rendering:optimizelegibility;transition-duration:var(--pharos-transition-duration-default);transition-property:border-color,background,color;transition-timing-function:ease-in-out}div#google_translate_element div.goog-te-gadget-simple [data-pharos-component=PharosIcon]{fill:var(--pharos-color-text-base);stroke:var(--pharos-color-text-base);stroke-width:0;transition-duration:var(--pharos-transition-duration-default);transition-property:fill,stroke;transition-timing-function:ease-in-out}div#google_translate_element div.goog-te-gadget-simple [data-pharos-component=PharosIcon]:first-child:not(:only-child){margin-right:var(--pharos-spacing-one-quarter-x)}div#google_translate_element div.goog-te-gadget-simple [data-pharos-component=PharosIcon]:last-child:not(:only-child){margin-left:var(--pharos-spacing-one-quarter-x)}[data-pharos-component=PharosFooter] ul[slot] li:not(:last-child){margin-bottom:var(--pharos-spacing-three-quarters-x)}[data-pharos-component=PharosFooter] ul[slot=social-links]{align-items:center;display:flex;flex-wrap:wrap;list-style-type:none}[data-pharos-component=PharosFooter] ul[slot=social-links] li:not(:last-child){margin-bottom:0;margin-right:var(--pharos-spacing-1-x)}[data-pharos-component=PharosFooter] ul[slot=social-links] [data-pharos-component=PharosIcon]{fill:var(--pharos-color-white);transition:opacity var(--pharos-transition-duration-default) ease-in-out}[data-pharos-component=PharosFooter] ul[slot=social-links] [data-pharos-component=PharosIcon]:hover{opacity:.7}[data-pharos-component=PharosFooter] ul[slot=legal-links]{align-items:center;display:flex;flex-wrap:wrap;list-style-type:none}[data-pharos-component=PharosFooter] ul[slot=legal-links] li:not(:last-child){margin-bottom:0;margin-right:var(--pharos-spacing-one-and-a-half-x)}div#google_translate_element div.goog-te-gadget-simple a.goog-te-menu-value:focus{outline:2px solid var(--pharos-color-focus);outline-offset:2px}div#google_translate_element div.goog-te-gadget-simple a.goog-te-menu-value img,div#google_translate_element div.goog-te-gadget-simple a.goog-te-menu-value span[style]{display:none}div#google_translate_element div.goog-te-gadget-simple a.goog-te-menu-value span{color:var(--pharos-color-interactive-tertiary)}div#google_translate_element div.goog-te-gadget-simple [data-pharos-component=PharosIcon]{fill:var(--pharos-color-interactive-tertiary)}div#google_translate_element div.goog-te-gadget-simple:hover{background-color:var(--pharos-color-interactive-tertiary);border-color:var(--pharos-color-interactive-tertiary);color:var(--pharos-color-interactive-secondary)}div#google_translate_element div.goog-te-gadget-simple:hover a.goog-te-menu-value span{color:var(--pharos-color-interactive-secondary)}div#google_translate_element div.goog-te-gadget-simple:hover [data-pharos-component=PharosIcon]{fill:var(--pharos-color-interactive-secondary)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "./node_modules/@storybook/addon-postcss/node_modules/css-loader/dist/cjs.js!./node_modules/@storybook/addon-postcss/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].use[2]!./packages/pharos/lib/styles/pharos-modal.css":
/***/ ((module, exports, __webpack_require__) => {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/@storybook/addon-postcss/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pharos-modal__body{overflow:hidden}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "./node_modules/@storybook/addon-postcss/node_modules/css-loader/dist/cjs.js!./node_modules/@storybook/addon-postcss/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].use[2]!./packages/pharos/lib/styles/variables.css":
/***/ ((module, exports, __webpack_require__) => {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/@storybook/addon-postcss/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root{--pharos-type-scale-14:4.25rem;--pharos-type-scale-13:3.75rem;--pharos-type-scale-12:3.375rem;--pharos-type-scale-11:3rem;--pharos-type-scale-10:2.625rem;--pharos-type-scale-9:2.25rem;--pharos-type-scale-8:2rem;--pharos-type-scale-7:1.75rem;--pharos-type-scale-6:1.5rem;--pharos-type-scale-5:1.25rem;--pharos-type-scale-4:1.125rem;--pharos-type-scale-3:1rem;--pharos-type-scale-2:0.875rem;--pharos-type-scale-1:0.75rem;--pharos-transition-curve-base:cubic-bezier(0.17,0.67,0.83,0.67);--pharos-transition-duration-longer:1000ms;--pharos-transition-duration-long:500ms;--pharos-transition-duration-default:250ms;--pharos-transition-duration-short:100ms;--pharos-transition-duration-shorter:50ms;--pharos-transition-base:250ms cubic-bezier(0.17,0.67,0.83,0.67);--pharos-spacing-10-x:10rem;--pharos-spacing-7-x:7rem;--pharos-spacing-5-x:5rem;--pharos-spacing-three-and-a-half-x:3.5rem;--pharos-spacing-3-x:3rem;--pharos-spacing-2-x:2rem;--pharos-spacing-one-and-a-half-x:1.5rem;--pharos-spacing-1-x:1rem;--pharos-spacing-three-quarters-x:0.75rem;--pharos-spacing-one-half-x:0.5rem;--pharos-spacing-one-quarter-x:0.25rem;--pharos-spacing-one-eighth-x:0.125rem;--pharos-radius-base-standard:0.125rem;--pharos-line-height-heading-large:1;--pharos-line-height-xlarge:2.25rem;--pharos-line-height-large:1.75rem;--pharos-line-height-medium:1.5rem;--pharos-line-height-small:1.25rem;--pharos-line-height-xsmall:1rem;--pharos-font-weight-bold:700;--pharos-font-weight-regular:400;--pharos-font-family-serif:Ivar Headline,Times,Georgia,serif;--pharos-font-family-sans-serif:GT America Standard,Helvetica,Helvetica Neue,Arial,Segoe UI,Roboto,Droid Sans,sans-serif;--pharos-textarea-size-height-base:3.5rem;--pharos-modal-size-width-base:40rem;--pharos-dropdown-menu-size-width-max:17rem;--pharos-dropdown-menu-size-width-min:9rem;--pharos-combobox-size-height-clear:1.875rem;--pharos-combobox-size-height-list:15rem;--pharos-button-color-on-background-subtle-border-disabled:transparent;--pharos-button-color-on-background-subtle-border-base:transparent;--pharos-button-color-on-background-subtle-background-disabled:transparent;--pharos-button-color-on-background-subtle-background-base:transparent;--pharos-button-color-on-background-secondary-background-hover:transparent;--pharos-button-color-on-background-secondary-background-base:transparent;--pharos-button-color-on-background-primary-background-hover:transparent;--pharos-button-color-base-subtle-border-disabled:transparent;--pharos-button-color-base-subtle-border-base:transparent;--pharos-button-color-base-subtle-background-disabled:transparent;--pharos-button-color-base-subtle-background-base:transparent;--pharos-button-color-base-secondary-background-hover:transparent;--pharos-button-color-base-secondary-background-base:transparent;--pharos-button-color-base-primary-background-hover:transparent;--pharos-color-overlay:rgba(0,0,0,.5);--pharos-color-green-base:#268241;--pharos-color-green-93:#e9f1eb;--pharos-color-yellow-base:#faa926;--pharos-color-yellow-97:#fdf9f2;--pharos-color-white:#fff;--pharos-color-black:#000;--pharos-color-marble-gray-base:#eae8e1;--pharos-color-marble-gray-97:#f9f8f6;--pharos-color-marble-gray-94:#f2f1ed;--pharos-color-marble-gray-80:#d1cfc7;--pharos-color-marble-gray-50:#81807e;--pharos-color-marble-gray-40:#676765;--pharos-color-marble-gray-20:#343332;--pharos-color-marble-gray-10:#1a1a19;--pharos-color-living-coral-base:#fb4848;--pharos-color-living-coral-90:#f4d7d7;--pharos-color-living-coral-80:#fc9c9c;--pharos-color-living-coral-53:#dd3431;--pharos-color-living-coral-50:#c83737;--pharos-color-glacier-blue-base:#27cae1;--pharos-color-glacier-blue-90:#dcedef;--pharos-color-glacier-blue-80:#b4dee4;--pharos-color-glacier-blue-70:#79deec;--pharos-color-glacier-blue-40:#0ba3c1;--pharos-color-night-blue-base:#0d3071;--pharos-color-night-blue-60:#8091b3;--pharos-color-night-blue-15:#071d46;--pharos-color-jstor-red:#900;--pharos-breakpoint-max:99rem;--pharos-breakpoint-xlarge:85rem;--pharos-breakpoint-large:66rem;--pharos-breakpoint-medium:48rem;--pharos-breakpoint-small:22.5rem;--pharos-asset-icon-zoom-out:\"assets/icons/zoom-out.svg\";--pharos-asset-icon-zoom-in:\"assets/icons/zoom-in.svg\";--pharos-asset-icon-youtube:\"assets/icons/youtube.svg\";--pharos-asset-icon-workspace-selected:\"assets/icons/workspace-selected.svg\";--pharos-asset-icon-workspace:\"assets/icons/workspace.svg\";--pharos-asset-icon-view-list:\"assets/icons/view-list.svg\";--pharos-asset-icon-view-grid:\"assets/icons/view-grid.svg\";--pharos-asset-icon-view-gallery:\"assets/icons/view-gallery.svg\";--pharos-asset-icon-video:\"assets/icons/video.svg\";--pharos-asset-icon-twitter:\"assets/icons/twitter.svg\";--pharos-asset-icon-tumblr:\"assets/icons/tumblr.svg\";--pharos-asset-icon-shift-down:\"assets/icons/shift-down.svg\";--pharos-asset-icon-shift-up:\"assets/icons/shift-up.svg\";--pharos-asset-icon-shift-right:\"assets/icons/shift-right.svg\";--pharos-asset-icon-shift-left:\"assets/icons/shift-left.svg\";--pharos-asset-icon-share:\"assets/icons/share.svg\";--pharos-asset-icon-search:\"assets/icons/search.svg\";--pharos-asset-icon-saved:\"assets/icons/saved.svg\";--pharos-asset-icon-save:\"assets/icons/save.svg\";--pharos-asset-icon-question-inverse:\"assets/icons/question-inverse.svg\";--pharos-asset-icon-profile:\"assets/icons/profile.svg\";--pharos-asset-icon-primary-source:\"assets/icons/primary-source.svg\";--pharos-asset-icon-partial-circle:\"assets/icons/partial-circle.svg\";--pharos-asset-icon-new:\"assets/icons/new.svg\";--pharos-asset-icon-move:\"assets/icons/move.svg\";--pharos-asset-icon-menu:\"assets/icons/menu.svg\";--pharos-asset-icon-linkedin:\"assets/icons/linkedin.svg\";--pharos-asset-icon-link:\"assets/icons/link.svg\";--pharos-asset-icon-link-external:\"assets/icons/link-external.svg\";--pharos-asset-icon-link-add:\"assets/icons/link-add.svg\";--pharos-asset-icon-laptop:\"assets/icons/laptop.svg\";--pharos-asset-icon-instagram:\"assets/icons/instagram.svg\";--pharos-asset-icon-info-inverse:\"assets/icons/info-inverse.svg\";--pharos-asset-icon-image:\"assets/icons/image.svg\";--pharos-asset-icon-google:\"assets/icons/google.svg\";--pharos-asset-icon-google-color:\"assets/icons/google-color.svg\";--pharos-asset-icon-fullscreen:\"assets/icons/fullscreen.svg\";--pharos-asset-icon-fullscreen-minimize:\"assets/icons/fullscreen-minimize.svg\";--pharos-asset-icon-folder-selected:\"assets/icons/folder-selected.svg\";--pharos-asset-icon-folder:\"assets/icons/folder.svg\";--pharos-asset-icon-folder-new:\"assets/icons/folder-new.svg\";--pharos-asset-icon-fit-to-width:\"assets/icons/fit-to-width.svg\";--pharos-asset-icon-fit-to-view:\"assets/icons/fit-to-view.svg\";--pharos-asset-icon-filetype-zip:\"assets/icons/filetype-zip.svg\";--pharos-asset-icon-filetype-ppt:\"assets/icons/filetype-ppt.svg\";--pharos-asset-icon-filetype-pdf:\"assets/icons/filetype-pdf.svg\";--pharos-asset-icon-facebook:\"assets/icons/facebook.svg\";--pharos-asset-icon-expand:\"assets/icons/shift-left.svg\";--pharos-asset-icon-exclamation:\"assets/icons/exclamation.svg\";--pharos-asset-icon-exclamation-inverse:\"assets/icons/exclamation-inverse.svg\";--pharos-asset-icon-email:\"assets/icons/email.svg\";--pharos-asset-icon-ellipses-vertical:\"assets/icons/ellipses-vertical.svg\";--pharos-asset-icon-ellipses-horizontal:\"assets/icons/ellipses-horizontal.svg\";--pharos-asset-icon-edit:\"assets/icons/edit.svg\";--pharos-asset-icon-download:\"assets/icons/download.svg\";--pharos-asset-icon-delete:\"assets/icons/delete.svg\";--pharos-asset-icon-dash-small:\"assets/icons/dash-small.svg\";--pharos-asset-icon-copy:\"assets/icons/copy.svg\";--pharos-asset-icon-collapse:\"assets/icons/shift-right.svg\";--pharos-asset-icon-close:\"assets/icons/close.svg\";--pharos-asset-icon-close-inverse:\"assets/icons/close-inverse.svg\";--pharos-asset-icon-cite:\"assets/icons/cite.svg\";--pharos-asset-icon-circle:\"assets/icons/circle.svg\";--pharos-asset-icon-chevron-up:\"assets/icons/chevron-up.svg\";--pharos-asset-icon-chevron-right:\"assets/icons/chevron-right.svg\";--pharos-asset-icon-chevron-right-large:\"assets/icons/chevron-right-large.svg\";--pharos-asset-icon-chevron-left:\"assets/icons/chevron-left.svg\";--pharos-asset-icon-chevron-left-large:\"assets/icons/chevron-left-large.svg\";--pharos-asset-icon-chevron-down:\"assets/icons/chevron-down.svg\";--pharos-asset-icon-checkmark:\"assets/icons/checkmark.svg\";--pharos-asset-icon-checkmark-small:\"assets/icons/checkmark-small.svg\";--pharos-asset-icon-checkmark-inverse:\"assets/icons/checkmark-inverse.svg\";--pharos-asset-icon-checkmark-filled-circle:\"assets/icons/checkmark-filled-circle.svg\";--pharos-asset-icon-calendar:\"assets/icons/calendar.svg\";--pharos-asset-icon-book:\"assets/icons/book.svg\";--pharos-asset-icon-base:\"assets/icons/base.svg\";--pharos-asset-icon-attachment:\"assets/icons/attachment.svg\";--pharos-asset-icon-arrow-up:\"assets/icons/arrow-up.svg\";--pharos-asset-icon-arrow-right:\"assets/icons/arrow-right.svg\";--pharos-asset-icon-arrow-left:\"assets/icons/arrow-left.svg\";--pharos-asset-icon-arrow-down:\"assets/icons/arrow-down.svg\";--pharos-asset-icon-add:\"assets/icons/add.svg\";--pharos-asset-icon-academic-content:\"assets/icons/academic-content.svg\";--pharos-spacing-gutter:var(--pharos-spacing-3-x);--pharos-line-height-text-base-condensed:var(--pharos-line-height-small);--pharos-font-size-xlarge:var(--pharos-type-scale-6);--pharos-font-size-large:var(--pharos-type-scale-5);--pharos-font-size-base:var(--pharos-type-scale-3);--pharos-font-size-small:var(--pharos-type-scale-2);--pharos-font-size-micro:var(--pharos-type-scale-1);--pharos-font-family-body:var(--pharos-font-family-sans-serif);--pharos-tooltip-color-background-base:var(--pharos-color-marble-gray-20);--pharos-radio-group-spacing-horizontal:var(--pharos-spacing-one-and-a-half-x);--pharos-radio-group-spacing-vertical:var(--pharos-spacing-one-half-x);--pharos-modal-spacing-base:var(--pharos-spacing-2-x);--pharos-modal-color-icon-focus:var(--pharos-color-jstor-red);--pharos-modal-color-icon-close:var(--pharos-color-marble-gray-50);--pharos-modal-color-border-content:var(--pharos-color-marble-gray-base);--pharos-modal-color-background-content:var(--pharos-color-white);--pharos-loading-spinner-color-stroke-secondary:var(--pharos-color-living-coral-base);--pharos-loading-spinner-color-stroke-primary:var(--pharos-color-jstor-red);--pharos-dropdown-menu-color-border-base:var(--pharos-color-marble-gray-80);--pharos-dropdown-menu-item-color-icon-base:var(--pharos-color-black);--pharos-dropdown-menu-item-color-background-hover:var(--pharos-color-marble-gray-94);--pharos-dropdown-menu-item-color-background-disabled:var(--pharos-color-marble-gray-base);--pharos-dropdown-menu-item-color-background-active:var(--pharos-color-marble-gray-base);--pharos-dropdown-menu-item-color-background-base:var(--pharos-color-white);--pharos-dropdown-menu-item-color-border-base:var(--pharos-color-marble-gray-80);--pharos-dropdown-menu-item-color-text-description:var(--pharos-color-marble-gray-40);--pharos-dropdown-menu-item-color-text-disabled:var(--pharos-color-marble-gray-40);--pharos-dropdown-menu-item-color-text-hover:var(--pharos-color-jstor-red);--pharos-dropdown-menu-item-color-text-base:var(--pharos-color-black);--pharos-checkbox-group-spacing-horizontal:var(--pharos-spacing-one-and-a-half-x);--pharos-checkbox-group-spacing-vertical:var(--pharos-spacing-one-half-x);--pharos-button-color-on-background-overlay-border-disabled:var(--pharos-color-marble-gray-20);--pharos-button-color-on-background-overlay-border-hover:var(--pharos-color-marble-gray-20);--pharos-button-color-on-background-overlay-border-base:var(--pharos-color-marble-gray-10);--pharos-button-color-on-background-overlay-text-disabled:var(--pharos-color-marble-gray-50);--pharos-button-color-on-background-overlay-background-disabled:var(--pharos-color-marble-gray-20);--pharos-button-color-on-background-overlay-background-hover:var(--pharos-color-marble-gray-20);--pharos-button-color-on-background-overlay-background-base:var(--pharos-color-marble-gray-10);--pharos-button-color-on-background-subtle-border-hover:var(--pharos-color-marble-gray-20);--pharos-button-color-on-background-subtle-text-disabled:var(--pharos-color-marble-gray-50);--pharos-button-color-on-background-subtle-background-hover:var(--pharos-color-marble-gray-20);--pharos-button-color-on-background-secondary-border-disabled:var(--pharos-color-marble-gray-20);--pharos-button-color-on-background-secondary-border-base:var(--pharos-color-marble-gray-50);--pharos-button-color-on-background-secondary-text-disabled:var(--pharos-color-marble-gray-50);--pharos-button-color-on-background-secondary-background-disabled:var(--pharos-color-marble-gray-20);--pharos-button-color-on-background-primary-border-disabled:var(--pharos-color-marble-gray-20);--pharos-button-color-on-background-primary-text-disabled:var(--pharos-color-marble-gray-50);--pharos-button-color-on-background-primary-background-disabled:var(--pharos-color-marble-gray-20);--pharos-button-color-base-overlay-border-hover:var(--pharos-color-marble-gray-20);--pharos-button-color-base-overlay-border-base:var(--pharos-color-marble-gray-10);--pharos-button-color-base-overlay-background-hover:var(--pharos-color-marble-gray-20);--pharos-button-color-base-overlay-background-base:var(--pharos-color-marble-gray-10);--pharos-button-padding-large:var(--pharos-spacing-one-half-x);--pharos-button-padding-condensed:var(--pharos-spacing-one-eighth-x);--pharos-button-padding-base:var(--pharos-spacing-one-quarter-x);--pharos-alert-color-border-info:var(--pharos-color-glacier-blue-40);--pharos-alert-color-border-base:var(--pharos-color-marble-gray-94);--pharos-alert-color-link-inverse:var(--pharos-color-white);--pharos-alert-color-icon-info:var(--pharos-color-glacier-blue-40);--pharos-alert-color-icon-base:var(--pharos-color-black);--pharos-alert-color-background-warning:var(--pharos-color-yellow-97);--pharos-alert-color-background-success:var(--pharos-color-green-93);--pharos-alert-color-background-error:var(--pharos-color-living-coral-90);--pharos-alert-color-background-info:var(--pharos-color-glacier-blue-90);--pharos-alert-color-background-base:var(--pharos-color-marble-gray-94);--pharos-color-focus:var(--pharos-color-glacier-blue-40);--pharos-color-text-white:var(--pharos-color-white);--pharos-color-text-base:var(--pharos-color-black);--pharos-color-text-50:var(--pharos-color-marble-gray-50);--pharos-color-text-40:var(--pharos-color-marble-gray-40);--pharos-color-text-20:var(--pharos-color-marble-gray-20);--pharos-color-text-10:var(--pharos-color-marble-gray-10);--pharos-color-feedback-info:var(--pharos-color-glacier-blue-40);--pharos-color-feedback-warning:var(--pharos-color-yellow-base);--pharos-color-feedback-success:var(--pharos-color-green-base);--pharos-color-feedback-error:var(--pharos-color-living-coral-53);--pharos-color-ui-50:var(--pharos-color-marble-gray-50);--pharos-color-ui-40:var(--pharos-color-marble-gray-80);--pharos-color-ui-30:var(--pharos-color-marble-gray-base);--pharos-color-ui-20:var(--pharos-color-marble-gray-94);--pharos-color-ui-10:var(--pharos-color-white);--pharos-color-interactive-tertiary:var(--pharos-color-white);--pharos-color-interactive-secondary:var(--pharos-color-black);--pharos-color-interactive-primary:var(--pharos-color-jstor-red);--pharos-tooltip-size-text-base:var(--pharos-font-size-small);--pharos-tooltip-color-text-base:var(--pharos-color-text-white);--pharos-text-input-color-icon-invalid:var(--pharos-color-feedback-error);--pharos-text-input-color-icon-valid:var(--pharos-color-feedback-success);--pharos-radio-button-color-background-base:var(--pharos-color-ui-10);--pharos-form-element-size-text-input:var(--pharos-font-size-base);--pharos-form-element-size-text-label:var(--pharos-font-size-small);--pharos-form-element-color-border-disabled:var(--pharos-color-ui-40);--pharos-form-element-color-border-invalid:var(--pharos-color-feedback-error);--pharos-form-element-color-border-focus:var(--pharos-color-focus);--pharos-form-element-color-border-base:var(--pharos-color-ui-50);--pharos-form-element-color-background-selected:var(--pharos-color-interactive-secondary);--pharos-form-element-color-text-invalid:var(--pharos-color-feedback-error);--pharos-form-element-color-text-required:var(--pharos-color-feedback-error);--pharos-form-element-color-text-base:var(--pharos-color-text-base);--pharos-combobox-color-icon-focus:var(--pharos-color-interactive-primary);--pharos-combobox-color-icon-checkmark:var(--pharos-color-interactive-secondary);--pharos-combobox-color-icon-dropdown:var(--pharos-color-interactive-secondary);--pharos-combobox-color-icon-clear:var(--pharos-color-ui-50);--pharos-combobox-color-text-selected:var(--pharos-color-text-base);--pharos-checkbox-color-background-base:var(--pharos-color-ui-10);--pharos-button-color-on-background-overlay-text-hover:var(--pharos-color-text-white);--pharos-button-color-on-background-overlay-text-base:var(--pharos-color-text-white);--pharos-button-color-on-background-subtle-text-hover:var(--pharos-color-text-white);--pharos-button-color-on-background-subtle-text-base:var(--pharos-color-text-white);--pharos-button-color-on-background-secondary-border-hover:var(--pharos-color-ui-10);--pharos-button-color-on-background-secondary-text-hover:var(--pharos-color-text-white);--pharos-button-color-on-background-secondary-text-base:var(--pharos-color-text-white);--pharos-button-color-on-background-primary-border-hover:var(--pharos-color-ui-10);--pharos-button-color-on-background-primary-border-base:var(--pharos-color-interactive-primary);--pharos-button-color-on-background-primary-text-hover:var(--pharos-color-text-white);--pharos-button-color-on-background-primary-text-base:var(--pharos-color-text-white);--pharos-button-color-on-background-primary-background-base:var(--pharos-color-interactive-primary);--pharos-button-color-base-overlay-text-hover:var(--pharos-color-text-white);--pharos-button-color-base-overlay-text-base:var(--pharos-color-text-white);--pharos-button-color-base-subtle-border-hover:var(--pharos-color-ui-20);--pharos-button-color-base-subtle-text-hover:var(--pharos-color-interactive-primary);--pharos-button-color-base-subtle-text-base:var(--pharos-color-text-base);--pharos-button-color-base-subtle-background-hover:var(--pharos-color-ui-20);--pharos-button-color-base-secondary-border-hover:var(--pharos-color-interactive-primary);--pharos-button-color-base-secondary-border-base:var(--pharos-color-ui-40);--pharos-button-color-base-secondary-text-hover:var(--pharos-color-interactive-primary);--pharos-button-color-base-secondary-text-base:var(--pharos-color-text-base);--pharos-button-color-base-primary-border-hover:var(--pharos-color-interactive-primary);--pharos-button-color-base-primary-border-base:var(--pharos-color-interactive-primary);--pharos-button-color-base-primary-text-hover:var(--pharos-color-interactive-primary);--pharos-button-color-base-primary-text-base:var(--pharos-color-text-white);--pharos-button-color-base-primary-background-base:var(--pharos-color-interactive-primary);--pharos-alert-color-border-warning:var(--pharos-color-feedback-warning);--pharos-alert-color-border-success:var(--pharos-color-feedback-success);--pharos-alert-color-border-error:var(--pharos-color-feedback-error);--pharos-alert-color-link-base:var(--pharos-color-interactive-secondary);--pharos-alert-color-text-inverse:var(--pharos-color-text-white);--pharos-alert-color-text-base:var(--pharos-color-text-base);--pharos-alert-color-icon-warning:var(--pharos-color-feedback-warning);--pharos-alert-color-icon-success:var(--pharos-color-feedback-success);--pharos-alert-color-icon-error:var(--pharos-color-feedback-error);--pharos-color-hover-row:var(--pharos-color-ui-20);--pharos-color-hover-secondary:var(--pharos-color-ui-10);--pharos-color-hover-primary:var(--pharos-color-interactive-primary);--pharos-color-text-placeholder:var(--pharos-color-text-40);--pharos-color-text-disabled:var(--pharos-color-text-40);--pharos-color-disabled:var(--pharos-color-ui-30);--pharos-form-element-color-background-disabled:var(--pharos-color-disabled);--pharos-form-element-color-text-placeholder:var(--pharos-color-text-placeholder);--pharos-form-element-color-text-disabled:var(--pharos-color-text-disabled);--pharos-combobox-color-text-hover:var(--pharos-color-hover-primary);--pharos-button-color-base-overlay-border-disabled:var(--pharos-color-disabled);--pharos-button-color-base-overlay-text-disabled:var(--pharos-color-text-disabled);--pharos-button-color-base-overlay-background-disabled:var(--pharos-color-disabled);--pharos-button-color-base-subtle-text-disabled:var(--pharos-color-text-disabled);--pharos-button-color-base-secondary-border-disabled:var(--pharos-color-disabled);--pharos-button-color-base-secondary-text-disabled:var(--pharos-color-text-disabled);--pharos-button-color-base-secondary-background-disabled:var(--pharos-color-disabled);--pharos-button-color-base-primary-border-disabled:var(--pharos-color-disabled);--pharos-button-color-base-primary-text-disabled:var(--pharos-color-text-disabled);--pharos-button-color-base-primary-background-disabled:var(--pharos-color-disabled)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "./packages/pharos/lib/styles/fonts.css":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var api = __webpack_require__("./node_modules/@storybook/addon-postcss/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = __webpack_require__("./node_modules/@storybook/addon-postcss/node_modules/css-loader/dist/cjs.js!./node_modules/@storybook/addon-postcss/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].use[2]!./packages/pharos/lib/styles/fonts.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "./packages/pharos/lib/styles/pharos-alert.css":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var api = __webpack_require__("./node_modules/@storybook/addon-postcss/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = __webpack_require__("./node_modules/@storybook/addon-postcss/node_modules/css-loader/dist/cjs.js!./node_modules/@storybook/addon-postcss/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].use[2]!./packages/pharos/lib/styles/pharos-alert.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "./packages/pharos/lib/styles/pharos-footer.css":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var api = __webpack_require__("./node_modules/@storybook/addon-postcss/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = __webpack_require__("./node_modules/@storybook/addon-postcss/node_modules/css-loader/dist/cjs.js!./node_modules/@storybook/addon-postcss/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].use[2]!./packages/pharos/lib/styles/pharos-footer.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "./packages/pharos/lib/styles/pharos-modal.css":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var api = __webpack_require__("./node_modules/@storybook/addon-postcss/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = __webpack_require__("./node_modules/@storybook/addon-postcss/node_modules/css-loader/dist/cjs.js!./node_modules/@storybook/addon-postcss/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].use[2]!./packages/pharos/lib/styles/pharos-modal.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "./packages/pharos/lib/styles/variables.css":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var api = __webpack_require__("./node_modules/@storybook/addon-postcss/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = __webpack_require__("./node_modules/@storybook/addon-postcss/node_modules/css-loader/dist/cjs.js!./node_modules/@storybook/addon-postcss/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].use[2]!./packages/pharos/lib/styles/variables.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "./packages/pharos/docs/1.intro.docs.stories.mdx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Title": () => (/* binding */ Title),
  "__namedExportsOrder": () => (/* binding */ __namedExportsOrder),
  "__page": () => (/* binding */ __page),
  "default": () => (/* binding */ _1_intro_docs_stories)
});

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("./node_modules/core-js/modules/es.object.keys.js");
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("./node_modules/core-js/modules/es.array.index-of.js");
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("./node_modules/core-js/modules/es.symbol.js");
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.bind.js
var es_function_bind = __webpack_require__("./node_modules/core-js/modules/es.function.bind.js");
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__("./node_modules/core-js/modules/es.object.assign.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./node_modules/@mdx-js/react/dist/esm.js
var esm = __webpack_require__("./node_modules/@mdx-js/react/dist/esm.js");
// EXTERNAL MODULE: ./node_modules/@storybook/addon-docs/dist/esm/index.js
var dist_esm = __webpack_require__("./node_modules/@storybook/addon-docs/dist/esm/index.js");
;// CONCATENATED MODULE: ./packages/pharos/README.md





var _excluded = ["components"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



/* @jsxRuntime classic */
/* @jsx mdx */

var layoutProps = {};
var MDXLayout = "wrapper";
function MDXContent(_ref) {
  var components = _ref.components,
    props = _objectWithoutProperties(_ref, _excluded);
  return (0,esm/* mdx */.kt)(MDXLayout, _extends({}, layoutProps, props, {
    components: components,
    mdxType: "MDXLayout"
  }), (0,esm/* mdx */.kt)("div", {
    "class": "hide-in-storybook"
  }, (0,esm/* mdx */.kt)("h1", {
    "id": "pharos-web-components"
  }, "Pharos Web Components")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "#installation"
  }, "Installation")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "#registering-components"
  }, "Registering components")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "#using-web-components"
  }, "Using web components")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "#using-pharos-components-in-react"
  }, "Using Pharos components in React")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "#styling-components"
  }, "Styling components")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "#using-pharos-design-tokens"
  }, "Using Pharos design tokens")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "#typography-and-mixins"
  }, "Typography and mixins")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "#additional-component-styles"
  }, "Additional component styles")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "#using-pharos-form-elements-in-forms"
  }, "Using Pharos form elements in forms")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "#adoption-governance-model"
  }, "Adoption Governance Model"))), (0,esm/* mdx */.kt)("p", null, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://www.webcomponents.org/introduction",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "Web Components"), " are a set of web platform APIs that allow you to create new custom, reusable, encapsulated HTML tags to use in web pages and web apps."), (0,esm/* mdx */.kt)("p", null, "Pharos provides a web component library for building products consistent with the JSTOR brand."), (0,esm/* mdx */.kt)("p", null, "If you're using Vue, you can use these components in the same manner specified, without any additional steps!"), (0,esm/* mdx */.kt)("h2", {
    "id": "installation"
  }, "Installation"), (0,esm/* mdx */.kt)("pre", null, (0,esm/* mdx */.kt)("code", {
    parentName: "pre",
    "className": "language-shell"
  }, "$ npm install @ithaka/pharos\n")), (0,esm/* mdx */.kt)("h2", {
    "id": "registering-components"
  }, "Registering components"), (0,esm/* mdx */.kt)("ol", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ol"
  }, "To allow multiple versions of Pharos to exist on a page, this package only exports component classes for you to register on the ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://developer.mozilla.org/en-US/docs/Web/API/CustomElementRegistry",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "custom element registry"), " in your application. To register components, you can use the ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "registerComponents"), " utility to define all the Pharos components your application uses, with a consistent scoping prefix:")), (0,esm/* mdx */.kt)("pre", null, (0,esm/* mdx */.kt)("code", {
    parentName: "pre",
    "className": "language-javascript"
  }, "import { PharosAlert, PharosButton, PharosIcon } from '@ithaka/pharos';\nimport registerComponents from '@ithaka/pharos/lib/utils/registerComponents';\n\nregisterComponents('homepage', [PharosAlert, PharosButton, PharosIcon]);\n")), (0,esm/* mdx */.kt)("p", null, (0,esm/* mdx */.kt)("strong", {
    parentName: "p"
  }, "Note: When using module federation, you may only share Pharos successfully by using the ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "strong"
  }, "registerComponents"), " utility. This avoids registering elements with the same underlying class instance, which would result in an error.")), (0,esm/* mdx */.kt)("p", null, "To manually register a component, import the classes you wish to use in your application's entrypoint and define the custom element with a tag name in the form of ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "{app/bundle}-pharos-{component}"), " and a trivial subclass that extends the Pharos class wrapped in the ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "PharosComponentMixin"), ":"), (0,esm/* mdx */.kt)("pre", null, (0,esm/* mdx */.kt)("code", {
    parentName: "pre",
    "className": "language-javascript"
  }, "import { PharosAlert } from '@ithaka/pharos';\nimport PharosComponentMixin from '@ithaka/pharos/lib/utils/mixins/pharos-component';\n\ncustomElements.define('homepage-pharos-alert', class extends PharosComponentMixin(PharosAlert) {});\n")), (0,esm/* mdx */.kt)("p", null, (0,esm/* mdx */.kt)("strong", {
    parentName: "p"
  }, "Note: If you register a name that already exists the browser will throw an error about the duplicate.")), (0,esm/* mdx */.kt)("ol", {
    "start": 2
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ol"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Internally, Pharos components that are composed of other Pharos components scope their registries to their shadow root to avoid duplicate registrations. Because the ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "Scoped Custom Element Registries"), " proposal is not yet finalized, you need to apply a ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/webcomponents/polyfills/tree/master/packages/scoped-custom-element-registry",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "polyfill"), " to use our components.")), (0,esm/* mdx */.kt)("li", {
    parentName: "ol"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Every component sets a custom data attribute ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "data-pharos-component"), " on itself with its class name (such as ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "PharosAlert"), ") to allow you to query any instance of that component regardless of its defined tag. Components also use this attribute to locate slotted Pharos children. Bundlers minify these class names by default for production builds. To ensure components work as expected, update your configurations like so:"))), (0,esm/* mdx */.kt)("p", null, "Webpack (Terser):"), (0,esm/* mdx */.kt)("pre", null, (0,esm/* mdx */.kt)("code", {
    parentName: "pre",
    "className": "language-javascript"
  }, "optimization: {\n  minimizer: [\n    new TerserPlugin({\n      terserOptions: {\n        keep_classnames: /^Pharos/,\n        keep_fnames: /^Pharos/,\n      }\n    }),\n  ],\n}\n")), (0,esm/* mdx */.kt)("p", null, "Vite (ESBuild):"), (0,esm/* mdx */.kt)("pre", null, (0,esm/* mdx */.kt)("code", {
    parentName: "pre",
    "className": "language-javascript"
  }, "export default defineConfig({\n  esbuild: {\n    keepNames: true,\n  },\n});\n")), (0,esm/* mdx */.kt)("h2", {
    "id": "using-web-components"
  }, "Using web components"), (0,esm/* mdx */.kt)("p", null, "After installing Pharos and registering the components, you can render them in any of your templates:"), (0,esm/* mdx */.kt)("pre", null, (0,esm/* mdx */.kt)("code", {
    parentName: "pre",
    "className": "language-html"
  }, "<pharos-tooltip>\n  <button>Hover here!</button>\n  <span slot=\"content\">I am a tooltip</span>\n</pharos-tooltip>\n")), (0,esm/* mdx */.kt)("p", null, "See the ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://pharos.jstor.org/storybooks/wc/",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "web component Storybook"), " for details on component-specific syntax."), (0,esm/* mdx */.kt)("h2", {
    "id": "using-pharos-components-in-react"
  }, "Using Pharos components in React"), (0,esm/* mdx */.kt)("p", null, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://reactjs.org/",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "React"), " is a JavaScript library used to build encapsulated components that manage their own state. React doesn't currently play perfectly with native web components, so if you're developing a React application you need to use the wrapper components provided in the ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "lib/react-components/"), " directory of the package."), (0,esm/* mdx */.kt)("p", null, "To use the React components, first register the components using the ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "registerComponents"), " utility. Then, in your app's entry file, use the ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "PharosContext"), " context provider to indicate the scoping prefix you registered them under:"), (0,esm/* mdx */.kt)("pre", null, (0,esm/* mdx */.kt)("code", {
    parentName: "pre",
    "className": "language-javascript"
  }, "import { PharosContext } from '@ithaka/pharos/lib/utils/PharosContext';\n\nconst context = { prefix: 'homepage' };\n")), (0,esm/* mdx */.kt)("p", null, "Then, render it in your JSX:"), (0,esm/* mdx */.kt)("pre", null, (0,esm/* mdx */.kt)("code", {
    parentName: "pre",
    "className": "language-jsx"
  }, "<PharosContext.Provider value={context}>...app code</PharosContext.Provider>\n")), (0,esm/* mdx */.kt)("p", null, "To use a component, first import it:"), (0,esm/* mdx */.kt)("pre", null, (0,esm/* mdx */.kt)("code", {
    parentName: "pre",
    "className": "language-javascript"
  }, "import { PharosTooltip } from '@ithaka/pharos/lib/react-components';\n")), (0,esm/* mdx */.kt)("p", null, "Then, render the component in your JSX:"), (0,esm/* mdx */.kt)("pre", null, (0,esm/* mdx */.kt)("code", {
    parentName: "pre",
    "className": "language-jsx"
  }, "<PharosTooltip content={'I am a tooltip'}>Hover here!</PharosTooltip>\n")), (0,esm/* mdx */.kt)("p", null, "See the ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://pharos.jstor.org/storybooks/react/",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "React Storybook"), " for details on component-specific syntax."), (0,esm/* mdx */.kt)("h2", {
    "id": "styling-components"
  }, "Styling components"), (0,esm/* mdx */.kt)("p", null, "Pharos components utilize CSS variables for their styling. To style components across your app, import the variables like so in your styles entrypoint:"), (0,esm/* mdx */.kt)("pre", null, (0,esm/* mdx */.kt)("code", {
    parentName: "pre",
    "className": "language-css"
  }, "/* index.css */\n\n@import '@ithaka/pharos/lib/styles/variables.css';\n\n/* More global styles */\n")), (0,esm/* mdx */.kt)("h2", {
    "id": "using-pharos-design-tokens"
  }, "Using Pharos design tokens"), (0,esm/* mdx */.kt)("p", null, "Components in Pharos are styled using design tokens, a tech agnostic way to store design decisions such as typography, color, and spacing so that Pharos can be shared across platforms. You can use these tokens to help style your own components and pages to ensure the brand is properly expressed to users. The token files are located in the ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "lib/styles/"), " directory of the package."), (0,esm/* mdx */.kt)("p", null, "To use the tokens as SASS variables, import them like so in the file where you want to use them:"), (0,esm/* mdx */.kt)("pre", null, (0,esm/* mdx */.kt)("code", {
    parentName: "pre",
    "className": "language-scss"
  }, "/* example-page.scss */\n\n@import '@ithaka/pharos/lib/styles/_variables';\n\n/* More styling for the example page */\n")), (0,esm/* mdx */.kt)("p", null, "To use the tokens as ESM modules in your JavaScript, import them like so to ensure unused tokens are tree-shaken:"), (0,esm/* mdx */.kt)("pre", null, (0,esm/* mdx */.kt)("code", {
    parentName: "pre",
    "className": "language-js"
  }, "/* example-page.js */\n\nimport { PharosColorTextBase } from '@ithaka/pharos/lib/styles/variables';\n")), (0,esm/* mdx */.kt)("h2", {
    "id": "typography-and-mixins"
  }, "Typography and mixins"), (0,esm/* mdx */.kt)("p", null, "Pharos uses ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "Ivar"), " a serif primarily for headlines and ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "GT America"), " a sans serif for body copy. The font-face stylesheet and base typography styles are located in the ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "lib/styles/"), " directory of the package. Import them, along with the design tokens, in your app's styles entrypoint file:"), (0,esm/* mdx */.kt)("pre", null, (0,esm/* mdx */.kt)("code", {
    parentName: "pre",
    "className": "language-scss"
  }, "/* index.scss */\n\n@import '@ithaka/pharos/lib/styles/fonts.css';\n@import '@ithaka/pharos/lib/styles/variables.css';\n@import '@ithaka/pharos/lib/styles/typography';\n\n/* More global styles and imports */\n")), (0,esm/* mdx */.kt)("p", null, "Pharos also provides SASS mixins which are reusable styles shared across multiple components. Import them like so in the file where you want to use them:"), (0,esm/* mdx */.kt)("pre", null, (0,esm/* mdx */.kt)("code", {
    parentName: "pre",
    "className": "language-scss"
  }, "/* example-page.scss */\n\n@use '@ithaka/pharos/lib/styles/pharos';\n\n.some-text {\n  @include pharos.font-base;\n}\n")), (0,esm/* mdx */.kt)("p", null, "The base typography styles and mixins utilize ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://sass-lang.com/blog/the-module-system-is-launched",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "SASS modules"), " which replaces ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "@import"), " with ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "@use"), " to make CSS, variables, mixins, and functions from another stylesheet accessible in the current stylesheet. If your project uses Webpack for bundling, you will need to make sure ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "sass-loader"), " is set to use ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "dart-sass"), " instead of ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "node-sass"), " as Node Sass is ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://sass-lang.com/blog/libsass-is-deprecated",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "deprecated"), " and does not support SASS modules. If using ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "sass-loader"), " >= 9.0.0 no change is required as ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "sass"), " is set as the default. Otherwise, update your Webpack config as so:"), (0,esm/* mdx */.kt)("pre", null, (0,esm/* mdx */.kt)("code", {
    parentName: "pre",
    "className": "language-js"
  }, "/* webpack.config.js */\n\n{\n  loader: 'sass-loader',\n  options: {\n    implementation: require('sass'),\n  }\n}\n")), (0,esm/* mdx */.kt)("p", null, "You can access all Pharos variables, mixins, and functions from a single ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "pharos.scss"), " entrypoint file. Import it in the file where you want to use its modules:"), (0,esm/* mdx */.kt)("pre", null, (0,esm/* mdx */.kt)("code", {
    parentName: "pre",
    "className": "language-scss"
  }, "/* example-page.scss */\n\n@use '@ithaka/pharos/lib/styles/pharos';\n\n.some-text {\n  @include pharos.font-base;\n\n  color: pharos.$pharos-color-text-20;\n}\n")), (0,esm/* mdx */.kt)("h2", {
    "id": "additional-component-styles"
  }, "Additional component styles"), (0,esm/* mdx */.kt)("p", null, "Most components in Pharos benefit from the fully isolated styling provided by web components and CSS variables. However, some components provide slots you can populate with your own content. Content provided by application authors is rendered in the light DOM, and is not always stylable by web components."), (0,esm/* mdx */.kt)("p", null, "You may need to import additional CSS files into your project's build for components whose slots expect nested content. These files are located in the ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "lib/styles/"), " directory of the package. To use the CSS, import it in whichever bundle will be included on the same page as your component:"), (0,esm/* mdx */.kt)("pre", null, (0,esm/* mdx */.kt)("code", {
    parentName: "pre",
    "className": "language-css"
  }, "/* example-page.css */\n\n@import '@ithaka/pharos/lib/styles/pharos-alert.css';\n\n/* More styling for the example page */\n")), (0,esm/* mdx */.kt)("p", null, "Selectors in component stylesheets are scoped to the component's host element (", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "<pharos-alert>"), " in the above example)."), (0,esm/* mdx */.kt)("p", null, "Components that have corresponding stylesheets are:"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-alert")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-footer")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-modal"))), (0,esm/* mdx */.kt)("h2", {
    "id": "using-pharos-form-elements-in-forms"
  }, "Using Pharos form elements in forms"), (0,esm/* mdx */.kt)("p", null, "Pharos form elements listen to the ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://developer.mozilla.org/en-US/docs/Web/API/HTMLFormElement/formdata_event",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "formdata"), " event"), " to add their values to the enclosing ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "<form>"), ". Safari doesn't natively fire the ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "formdata"), " event, so form authors need to fire a custom event in its stead."), (0,esm/* mdx */.kt)("p", null, "Pharos provides a cross-browser ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "createFormData"), " utility function for populating forms via a custom ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "formdata"), " event. You should call ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "createFormData"), " in your form's ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "submit"), " event handler."), (0,esm/* mdx */.kt)("pre", null, (0,esm/* mdx */.kt)("code", {
    parentName: "pre",
    "className": "language-javascript"
  }, "import createFormData from '@ithaka/pharos/lib/utils/createFormData.js';\n\nconst form = document.querySelector('form');\nform.addEventListener('submit', (event) => createFormData(event.target));\n")), (0,esm/* mdx */.kt)("p", null, "If you submit your forms asynchronously, you can pass the result of ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "createFormData"), " in your request:"), (0,esm/* mdx */.kt)("pre", null, (0,esm/* mdx */.kt)("code", {
    parentName: "pre",
    "className": "language-javascript"
  }, "import createFormData from '@ithaka/pharos/lib/utils/createFormData.js';\n\nconst form = document.querySelector('form');\n\nform.addEventListener('submit', (event) => {\n  event.preventDefault();\n\n  const formData = createFormData(event.target);\n\n  const xhr = new XMLHttpRequest();\n  xhr.open('POST', 'https://some-url.com');\n  xhr.send(formData);\n});\n")), (0,esm/* mdx */.kt)("h2", {
    "id": "adoption-governance-model"
  }, "Adoption Governance Model"), (0,esm/* mdx */.kt)("p", null, "Take a look at the ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://coggle.it/diagram/XpRbDBqrZN1pBosN/t/product-team-wants-to-adopt-pharos-components",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "adoption governance model"), " for a quick overview of the adoption process."));
}
;
MDXContent.isMDXComponent = true;
;// CONCATENATED MODULE: ./packages/pharos/package.json
const package_namespaceObject = {"i8":"12.16.0"};
;// CONCATENATED MODULE: ./.storybook/pharosTitle.js

const PHAROS_TITLE = `Pharos ${package_namespaceObject.i8}`;
/* harmony default export */ const pharosTitle = (PHAROS_TITLE);

;// CONCATENATED MODULE: ./packages/pharos/docs/1.intro.docs.stories.mdx




var _1_intro_docs_stories_excluded = ["components"];

function _1_intro_docs_stories_extends() { _1_intro_docs_stories_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _1_intro_docs_stories_extends.apply(this, arguments); }
function _1_intro_docs_stories_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _1_intro_docs_stories_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _1_intro_docs_stories_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



/* @jsxRuntime classic */
/* @jsx mdx */




var Title = function Title() {
  return pharosTitle;
};
var _1_intro_docs_stories_layoutProps = {
  Title: Title
};
var _1_intro_docs_stories_MDXLayout = "wrapper";
function _1_intro_docs_stories_MDXContent(_ref) {
  var components = _ref.components,
    props = _1_intro_docs_stories_objectWithoutProperties(_ref, _1_intro_docs_stories_excluded);
  return (0,esm/* mdx */.kt)(_1_intro_docs_stories_MDXLayout, _1_intro_docs_stories_extends({}, _1_intro_docs_stories_layoutProps, props, {
    components: components,
    mdxType: "MDXLayout"
  }), (0,esm/* mdx */.kt)(dist_esm/* Meta */.h_, {
    title: "Pharos/Intro",
    mdxType: "Meta"
  }), (0,esm/* mdx */.kt)("h1", {
    "id": "title--web-components"
  }, (0,esm/* mdx */.kt)(Title, {
    mdxType: "Title"
  }), " Web Components"), (0,esm/* mdx */.kt)(MDXContent, {
    mdxType: "Intro"
  }), (0,esm/* mdx */.kt)("h2", {
    "id": "work-with-us-at-ithaka"
  }, "Work with us at ITHAKA"), (0,esm/* mdx */.kt)("p", null, "JSTOR is part of ITHAKA, a not-for-profit dedicated to expanding access to knowledge and education worldwide. Our staff makes us who we are. We\u2019re hiring \u2014 join us!"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://www.ithaka.org/careers/",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "See career opportunities")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://www.ithaka.org/",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "Learn more about ITHAKA"))));
}
;
_1_intro_docs_stories_MDXContent.isMDXComponent = true;
var __page = function __page() {
  throw new Error("Docs-only story");
};
__page.parameters = {
  docsOnly: true
};
var componentMeta = {
  title: 'Pharos/Intro',
  includeStories: ["__page"]
};
var mdxStoryNameToKey = {};
componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = Object.assign({}, componentMeta.parameters.docs || {}, {
  page: function page() {
    return (0,esm/* mdx */.kt)(dist_esm/* AddContext */.aT, {
      mdxStoryNameToKey: mdxStoryNameToKey,
      mdxComponentAnnotations: componentMeta
    }, (0,esm/* mdx */.kt)(_1_intro_docs_stories_MDXContent, null));
  }
});
/* harmony default export */ const _1_intro_docs_stories = (componentMeta);
var __namedExportsOrder = ["Title", "__page"];

/***/ }),

/***/ "./packages/pharos/docs/2.changelog.docs.stories.mdx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__namedExportsOrder": () => (/* binding */ __namedExportsOrder),
  "__page": () => (/* binding */ __page),
  "default": () => (/* binding */ _2_changelog_docs_stories)
});

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("./node_modules/core-js/modules/es.object.keys.js");
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("./node_modules/core-js/modules/es.array.index-of.js");
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("./node_modules/core-js/modules/es.symbol.js");
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.bind.js
var es_function_bind = __webpack_require__("./node_modules/core-js/modules/es.function.bind.js");
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__("./node_modules/core-js/modules/es.object.assign.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./node_modules/@mdx-js/react/dist/esm.js
var esm = __webpack_require__("./node_modules/@mdx-js/react/dist/esm.js");
// EXTERNAL MODULE: ./node_modules/@storybook/addon-docs/dist/esm/index.js
var dist_esm = __webpack_require__("./node_modules/@storybook/addon-docs/dist/esm/index.js");
;// CONCATENATED MODULE: ./packages/pharos/CHANGELOG.md





var _excluded = ["components"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



/* @jsxRuntime classic */
/* @jsx mdx */

var layoutProps = {};
var MDXLayout = "wrapper";
function MDXContent(_ref) {
  var components = _ref.components,
    props = _objectWithoutProperties(_ref, _excluded);
  return (0,esm/* mdx */.kt)(MDXLayout, _extends({}, layoutProps, props, {
    components: components,
    mdxType: "MDXLayout"
  }), (0,esm/* mdx */.kt)("h1", {
    "id": "ithakapharos"
  }, "@ithaka/pharos"), (0,esm/* mdx */.kt)("h2", {
    "id": "12160"
  }, "12.16.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/457",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#457"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/f02735b0f5237dc66e7c8823422bc132c83e58bd",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "f02735b")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Allow tabs to scroll horizontally when cramped")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/459",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#459"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/bcfd01805d24aac955a6b70e3677192b79ed9664",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "bcfd018")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/michael-iden",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@michael-iden"), "! - Add fit to width icon")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/453",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#453"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/2977fae5d5449744d1b7b3aa8ca58811c54bd043",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "2977fae")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - use queryAssignedElements and simplify focus loops"))), (0,esm/* mdx */.kt)("h2", {
    "id": "12151"
  }, "12.15.1"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/451",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#451"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/d4149c2bdee9024b204e439ce839759bd5107d01",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "d4149c2")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Apply position computation and resulting styles to the proper menu element instead of the host container")), (0,esm/* mdx */.kt)("h2", {
    "id": "12150"
  }, "12.15.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-1"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/434",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#434"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/080c496fedd4be13bd7f63c92332b9e1f6e32069",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "080c496")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - ", "*", " Replace PopperJS with Floating UI for tooltips and dropdown menus"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update GitHub Actions to use environment files instead of ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "set-output")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update GitHub Actions action versions"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Fix stylelint errors for Link, ToggleButton, TextInput"))), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/442",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#442"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/bc05bbcf3215baa78755d60436bb720b844da7fd",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "bc05bbc")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Fire pharos-tab-selected in response to tab being selected programmatically in addition to user clicks"))), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-1"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/438",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#438"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/4f56c1b062fa160cd5aac6c96d96a39a5df5fbdb",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "4f56c1b")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Improve accessibility for toggle button groups")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/435",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#435"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/6cbeb91cc5942c492222a797ab3efd710b15ed1c",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "6cbeb91")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Update Storybook stories to Component Story Format (CSF) version 3")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/449",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#449"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/50e665dbdb0a19c50df68b99e266f2fd7bb5aedd",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "50e665d")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Fix initial tab selection in more use cases"))), (0,esm/* mdx */.kt)("h2", {
    "id": "12140"
  }, "12.14.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-2"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/431",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#431"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/b3c9c3ba2870d458846ebf20301b10dfb21b714d",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "b3c9c3b")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/chrisjbrown",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@chrisjbrown"), "! - allow checkbox change event to be prevented")), (0,esm/* mdx */.kt)("h2", {
    "id": "12130"
  }, "12.13.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-3"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/428",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#428"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/3cd44b55421b89745960d11dd6e484dc412ec826",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "3cd44b5")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/chrisjbrown",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@chrisjbrown"), "! - pharos-image card will only emit selected event or click instead of both")), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-2"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/425",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#425"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/3fd8e16ed66e9c26bbbf901a114f2f50b563a1f2",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "3fd8e16")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Update ARIA attribute to improve screen reading experience for checkboxes")), (0,esm/* mdx */.kt)("h2", {
    "id": "12120"
  }, "12.12.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-4"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/421",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#421"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/79c041e6861a30f69b30369b62add826f3063b1b",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "79c041e")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/shoupeva-ithaka",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@shoupeva-ithaka"), "! - pharos-sidenav emits 'close' event when close button is clicked")), (0,esm/* mdx */.kt)("h2", {
    "id": "12110"
  }, "12.11.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-5"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/408",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#408"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/041102fe32a1093ec6e95bd13c03ac55e9535f6f",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "041102f")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/michael-iden",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@michael-iden"), "! - Add selectable states to subtle image cards")), (0,esm/* mdx */.kt)("h2", {
    "id": "12100"
  }, "12.10.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-6"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/416",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#416"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/ae1063c065490389cfa4224d0893e202fbe84671",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "ae1063c")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/rehanabbasi",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@rehanabbasi"), "! - Link: Fix visited link hover state underline color\nImage card: Add visited link support for title link")), (0,esm/* mdx */.kt)("h2", {
    "id": "1291"
  }, "12.9.1"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-3"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/414",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#414"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/26d2536555088d08343e6ef303b9aaf6833d83ed",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "26d2536")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/chrisjbrown",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@chrisjbrown"), "! - removes color inherit from pharos-heading")), (0,esm/* mdx */.kt)("h2", {
    "id": "1290"
  }, "12.9.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-7"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/409",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#409"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/c931566b6aa73ea93946b20e5a61ab06e654b2e0",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "c931566")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/rehanabbasi",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@rehanabbasi"), "! - Supports visited links style on Pharos link component, when visited")), (0,esm/* mdx */.kt)("h2", {
    "id": "1280"
  }, "12.8.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-8"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/407",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#407"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/30893f4eeb559c6c2de4fd16acfccc88c2a7f5b2",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "30893f4")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ymouzakis",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@ymouzakis"), "! - Add updateable toasts for async actions")), (0,esm/* mdx */.kt)("h2", {
    "id": "1274"
  }, "12.7.4"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-4"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/405",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#405"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/aec6483cb7732c8c88064d878dc06d307efdebe1",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "aec6483")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/michael-iden",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@michael-iden"), "! - Wait for child ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "toggle-button"), " elements to initialize before referencing their state in the ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "toggle-button-group"))), (0,esm/* mdx */.kt)("h2", {
    "id": "1273"
  }, "12.7.3"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-5"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/400",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#400"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/abe0aa1d9673ee4017cf524e2b5d1cd1c5dd720d",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "abe0aa1")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Allow scoped Pharos Link elements to be clickable within a Pharos Checkbox or RadioButton")), (0,esm/* mdx */.kt)("h2", {
    "id": "1272"
  }, "12.7.2"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-6"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/397",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#397"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/cca3159ca24e449bc9b5b218bd58f3396cbb3a8b",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "cca3159")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Explicitly set input element margins to avoid undesired user agent styling")), (0,esm/* mdx */.kt)("h2", {
    "id": "1271"
  }, "12.7.1"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-7"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/393",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#393"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/1bbe745e1b99531c8e85f294ee804378a54f9caf",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "1bbe745")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/acjreno",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@acjreno"), "! - Remove event.stopPropagation from ", "_", "cardToggleSelect and logic updates")), (0,esm/* mdx */.kt)("h2", {
    "id": "1270"
  }, "12.7.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-9"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/392",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#392"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/2c3056eb6004f4602ffe34c1c97c75efa1419309",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "2c3056e")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ymouzakis",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@ymouzakis"), "! - Add keyboard accessibility to selectable image card variants")), (0,esm/* mdx */.kt)("h2", {
    "id": "1262"
  }, "12.6.2"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-8"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/388",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#388"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/0c8d58dc9ac6893e6469f7081e8212d25a6cadce",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "0c8d58d")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/adandavati",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@adandavati"), "! - Remove overly strict contain property from text-input labels")), (0,esm/* mdx */.kt)("h2", {
    "id": "1261"
  }, "12.6.1"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-9"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/386",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#386"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/9e555e4edd965cc1965b0aeb507fea21153bacd8",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "9e555e4")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/chrisjbrown",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@chrisjbrown"), "! - Adds new variant to pharos-text-input to create an input box with more padding")), (0,esm/* mdx */.kt)("h2", {
    "id": "1260"
  }, "12.6.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-10"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/375",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#375"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/8d4d2126f3fe3525847f027aca343d0154a03447",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "8d4d212")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/satya-achanta-venkata",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@satya-achanta-venkata"), "! - Profile icon is added to our list of icons")), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-10"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/384",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#384"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/8cd06ef430f225730317aac22bf3d3573b858db0",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "8cd06ef")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/michael-iden",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@michael-iden"), "! - Restructure card dom and remove checkbox mouseevent listeners to enable subtle selection in Safari")), (0,esm/* mdx */.kt)("h2", {
    "id": "1251"
  }, "12.5.1"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-11"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/373",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#373"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/60e1fefdd7c113b9cc936ce877e544cd66317768",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "60e1fef")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ymouzakis",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@ymouzakis"), "! - Add background color to selectable disabled card")), (0,esm/* mdx */.kt)("h2", {
    "id": "1250"
  }, "12.5.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-11"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/366",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#366"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/febc324287a21c0949477c6edbc89d2ca942af03",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "febc324")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ymouzakis",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@ymouzakis"), "! - Add selectable card variants, add disabled card state, update styling of error state")), (0,esm/* mdx */.kt)("h2", {
    "id": "1240"
  }, "12.4.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-12"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/349",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#349"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/8f345353f0afacd6b334bd578ae8c74622045a1c",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "8f34535")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/acjreno",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@acjreno"), "! - Addition: new icon for ZIP filetypes")), (0,esm/* mdx */.kt)("h2", {
    "id": "1231"
  }, "12.3.1"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-12"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/342",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#342"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/f777f9e99da158f51427cad18175086f3b320645",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "f777f9e")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/jialin-he",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@jialin-he"), "! - Remove fill attribute from shift icon svg")), (0,esm/* mdx */.kt)("h2", {
    "id": "1230"
  }, "12.3.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-13"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/339",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#339"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/815c51682460782ec5f893d2e3f8f945282fcb50",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "815c516")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/jialin-he",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@jialin-he"), "! - Add new icons expand-vertical and collapse-vertical")), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-13"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/336",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#336"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/28dd444580d24c33625bfca74a7d0c0f03da3e9e",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "28dd444")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Update page-relative paths to domain-relative paths")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/338",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#338"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/54cb97be3b88c738ddecec4c5369b96f69bebbfb",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "54cb97b")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Move size-limit checks up to the project root")), (0,esm/* mdx */.kt)("h2", {
    "id": "1223"
  }, "12.2.3"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-14"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/330",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#330"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/732fe3e51cb164c7fcb416fc2a70fa80b07e99f3",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "732fe3e")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/NazimHAli",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@NazimHAli"), "! - Add optional horizontal line to the tabs component")), (0,esm/* mdx */.kt)("h2", {
    "id": "1222"
  }, "12.2.2"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-15"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/327",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#327"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/f859df698317e6f0c3cc4c6b29817dafe32f91c1",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "f859df6")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/satya-achanta-venkata",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@satya-achanta-venkata"), "! - removed fill: #color property on newly added icons to set desired fill color as needed")), (0,esm/* mdx */.kt)("h2", {
    "id": "1221"
  }, "12.2.1"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-16"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/325",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#325"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/3576dbd603248abc61c7a3b81a2c804a322b8abf",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "3576dbd")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/satya-achanta-venkata",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@satya-achanta-venkata"), "! - remove SVG tags around icon path")), (0,esm/* mdx */.kt)("h2", {
    "id": "1220"
  }, "12.2.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-14"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/322",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#322"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/a5e99c6dfff6d22992168c61c12a61a2bf4152d9",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "a5e99c6")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/jialin-he",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@jialin-he"), "! - Add info variation to toast")), (0,esm/* mdx */.kt)("h2", {
    "id": "1210"
  }, "12.1.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-15"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/320",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#320"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/dfe88f9252854265f4e66f4b3349c2b7e576a537",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "dfe88f9")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/satya-achanta-venkata",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@satya-achanta-venkata"), "! - Add new icons checkmark-filled-circle, circle and partial-circle")), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-17"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/319",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#319"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/1dc856c98514154faa6e5b8a5ad2b190deef1ee3",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "1dc856c")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/eslawski",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@eslawski"), "! - Enhance build process to minify component css")), (0,esm/* mdx */.kt)("h2", {
    "id": "1201"
  }, "12.0.1"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-18"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/297",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#297"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/1ac0374f7862c81c38f036bda3b2b70a87d74f73",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "1ac0374")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Ensure proper spacing of new end top/bottom area content")), (0,esm/* mdx */.kt)("h2", {
    "id": "1200"
  }, "12.0.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "major-changes"
  }, "Major Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/295",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#295"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/e84f4f607a52f6d0b5befb5b60a5dc337e1c5cde",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "e84f4f6")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Update the grid layout and slots to accommodate the latest branded updates for the header")), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-16"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/293",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#293"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/78f685e642c8cbd557548e43552b50a97d7009a2",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "78f685e")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/satya-achanta-venkata",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@satya-achanta-venkata"), "! - pass rel attribute from menu item to underlying anchor tag")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/290",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#290"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/0874064919d8be4d6dfa1cc690f0123b7940ccbe",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "0874064")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/satya-achanta-venkata",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@satya-achanta-venkata"), "! - Stop triggering click event on disabled dropdown menu items")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/281",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#281"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/1c2d5d6a9784c008ef1947cd90e5035991dd6851",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "1c2d5d6")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - add size-limit to measure package size")), (0,esm/* mdx */.kt)("h2", {
    "id": "1121"
  }, "11.2.1"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-19"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/277",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#277"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/915eda6c77dbd0d82621fd1d18966c924e81f817",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "915eda6")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - check href prop for rendering links")), (0,esm/* mdx */.kt)("h2", {
    "id": "1120"
  }, "11.2.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-17"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/274",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#274"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/03f222f48b4a247990239debca67e942173c4f56",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "03f222f")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/satya-achanta-venkata",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@satya-achanta-venkata"), "! - Added button that looks like link")), (0,esm/* mdx */.kt)("h2", {
    "id": "1110"
  }, "11.1.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-18"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/268",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#268"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/ffb2f63523bfe51ee2cc16de1740309590cded59",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "ffb2f63")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add register utility:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Update ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "PharosElement"), " to set ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "[data-pharos-component]"), " with ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "constructor.name"))), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Update ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "PharosComponentMixin"), " to set ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "[data-pharos-component]"), " with base class name")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Add register utility to simplify component registration and ensure trivial classes are used for custom elements:"), (0,esm/* mdx */.kt)("pre", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("code", {
    parentName: "pre",
    "className": "language-javascript"
  }, "import { PharosAlert, PharosButton, PharosIcon } from '@ithaka/pharos';\nimport registerComponents from '@ithaka/pharos/lib/utils/registerComponents';\n\nregisterComponents('{prefix}', [PharosAlert, PharosButton, PharosIcon]);\n"))), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Add a React Pharos context provider for consumers to indicate prefix used for registration:"), (0,esm/* mdx */.kt)("pre", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("code", {
    parentName: "pre",
    "className": "language-jsx"
  }, "import { PharosContext } from '@ithaka/pharos/lib/utils/PharosContext';\n\nconst context = { prefix: 'homepage' };\n\n<PharosContext.Provider value={context}>...app code</PharosContext.Provider>;\n")))))), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-20"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/262",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#262"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/c0ee52f0ec5e8a05551fa9a5f0c84d3f7d15f920",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "c0ee52f")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - use request name for dynamic import chunks")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/269",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#269"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/de1938b96d54d63a13245db0dd4554e17438ec2d",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "de1938b")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - adjust modal footer slotted content spacing")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/264",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#264"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/988881d2c10274c1fbffc23ab04f35397b6e5742",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "988881d")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - update dependencies")), (0,esm/* mdx */.kt)("h2", {
    "id": "1101"
  }, "11.0.1"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-21"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/260",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#260"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/04a32cc9e8987a79af84b826713613cd4da1d9af",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "04a32cc")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - specify package side effects")), (0,esm/* mdx */.kt)("h2", {
    "id": "1100"
  }, "11.0.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "major-changes-1"
  }, "Major Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/226",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#226"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/78435685eb15b1c88122c0c71bbc228272a6651d",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "7843568")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - require manual component registration:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Remove component self-registration"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Scope registries for components composed of other Pharos components using ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/lit/lit/tree/main/packages/labs/scoped-registry-mixin",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "scoped-registry-mixin")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update React wrapper to detect defined custom tag name"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Create ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "PharosElement"), " base class which sets a custom attribute ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "data-pharos-component"), " as a common identifier"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Set components to extend ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "PharosElement")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update documentation")), (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("strong", {
    parentName: "p"
  }, "Migration Guidelines")), (0,esm/* mdx */.kt)("ol", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ol"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Remove all individual imports of Pharos web components.")), (0,esm/* mdx */.kt)("li", {
    parentName: "ol"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Register them with a custom tag in your app's entrypoint in the form of ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "{app/bundle}-pharos-{component}"), ":"), (0,esm/* mdx */.kt)("pre", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("code", {
    parentName: "pre",
    "className": "language-javascript"
  }, "import { PharosAlert } from '@ithaka/pharos/lib/components/alert/pharos-alert';\n\ncustomElements.define('homepage-pharos-alert', PharosAlert);\n"))), (0,esm/* mdx */.kt)("li", {
    parentName: "ol"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Update templates, queries, unit tests, and integration tests with the newly defined tag names.")), (0,esm/* mdx */.kt)("li", {
    parentName: "ol"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Add the ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/webcomponents/polyfills/tree/master/packages/scoped-custom-element-registry",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "scoped custom element registry polyfill"), " to a globally available location in your project.")), (0,esm/* mdx */.kt)("li", {
    parentName: "ol"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Update your bundler's production build settings to keep class names unminified:"), (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Webpack (Terser):"), (0,esm/* mdx */.kt)("pre", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("code", {
    parentName: "pre",
    "className": "language-javascript"
  }, "optimization: {\n  minimizer: [\n    new TerserPlugin({\n      terserOptions: {\n        keep_classnames: /^Pharos/,\n        keep_fnames: /^Pharos/,\n      }\n    }),\n  ],\n}\n")), (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Vite (ESBuild):"), (0,esm/* mdx */.kt)("pre", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("code", {
    parentName: "pre",
    "className": "language-javascript"
  }, "export default defineConfig({\n  esbuild: {\n    keepNames: true,\n  },\n});\n"))), (0,esm/* mdx */.kt)("li", {
    parentName: "ol"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Import the JSDOM patch in your Jest setup file if you use Jest for unit testing:"), (0,esm/* mdx */.kt)("pre", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("code", {
    parentName: "pre",
    "className": "language-javascript"
  }, "import '@ithaka/pharos/lib/patches/jsdom';\nimport 'your-pharos-component-registration-file';\n")))))), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-22"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/243",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#243"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/2bc785d16f30c954c53fdcfcd39a65600c866476",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "2bc785d")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - update Stylelint:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Follow Stylelint ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://stylelint.io/migration-guide/to-14/",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "migration guidelines")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Address errors found")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/245",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#245"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/8bb5b8a0f89a8a4ecc34c4c6f342a58cc88d06ef",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "8bb5b8a")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - update to Node 16:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update GitHub actions to use Node 16"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, ".nvmrc")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update React build script")))), (0,esm/* mdx */.kt)("h2", {
    "id": "1082"
  }, "10.8.2"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-23"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/239",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#239"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/7ea4edd662dafb0a584127006280e85f76d11805",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "7ea4edd")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - update popper instance on trigger change for dropdown menus")), (0,esm/* mdx */.kt)("h2", {
    "id": "1081"
  }, "10.8.1"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-24"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/236",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#236"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/d189737be23a1bfd227c8284c8e4f331eb9658e8",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "d189737")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - await close transition before updating popper instance")), (0,esm/* mdx */.kt)("h2", {
    "id": "1080"
  }, "10.8.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-19"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/229",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#229"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/f4a738ff4199744c6bf11c8d0bda84e9b33b6263",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "f4a738f")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/chrisjbrown",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@chrisjbrown"), "! - added event emit for mouseenter and mouseleave on image")), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-25"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/231",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#231"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/48a35efa185ba2e5952fd181fd29179ce08a3bce",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "48a35ef")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Prevent any displayed text from overlapping with the clear icon")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/233",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#233"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/87cc04e7ef80320aab8c67c8ed1cd27ac6f6c748",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "87cc04e")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - update Lit, TypeScript, and Prettier")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/232",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#232"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/819954ce01b1a329a8e4d88c422b8e98b2a304f0",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "819954c")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Add intrinsic padding around all footer content and spacing between footer rows")), (0,esm/* mdx */.kt)("h2", {
    "id": "1070"
  }, "10.7.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-20"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/216",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#216"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/d89a692cf60c9b320a77aa27c857b2a57b608a21",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "d89a692")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/eslawski",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@eslawski"), "! - Adds overlay button variant")), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-26"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/214",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#214"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/4af1d23059ea9f48d16d199ac735bb56636f3a73",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "4af1d23")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - update Lit to latest RC")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/213",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#213"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/7298e8a208ab099464966ce61bbd5920597bffe4",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "7298e8a")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - update validation icon placement when input groups have items appended dynamically")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/215",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#215"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/e2a9c186121a13ee3dc461ef7888f7d029872637",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "e2a9c18")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/eslawski",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@eslawski"), "! - Add saved icon")), (0,esm/* mdx */.kt)("h2", {
    "id": "1063"
  }, "10.6.3"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-27"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/210",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#210"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/9aaa78a66408ea18109d29ab172d1db66ca98d7d",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "9aaa78a")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - use slots directly in the footer")), (0,esm/* mdx */.kt)("h2", {
    "id": "1062"
  }, "10.6.2"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-28"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/205",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#205"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/37780dd3ce0f3d8ba0c95ea5c9d135eee0aed6e4",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "37780dd")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - update dependencies")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/206",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#206"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/a87cfea007469b41e83bc4a595bb38bc499888e7",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "a87cfea")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Fix positioning of validity icons in the presence of appended group items (like buttons)")), (0,esm/* mdx */.kt)("h2", {
    "id": "1061"
  }, "10.6.1"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-29"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/201",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#201"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/5ed76ad968221aa1255fddfff172e114f4fea9e5",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "5ed76ad")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - update docs to instruct importing of CSS var tokens")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/202",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#202"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/3a5135074aef4d55c05b0ee08122b1a9ce57e333",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "3a51350")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Allow breadcrumb items to wrap")), (0,esm/* mdx */.kt)("h2", {
    "id": "1060"
  }, "10.6.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-21"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/194",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#194"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/efea137717110dff3c40df0138589f840588a9a6",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "efea137")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Lham42",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Lham42"), "! - Add closability function to alert component:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "closable"), " property to ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "alert"), " component")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/188",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#188"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/767d6f8f10267afcb111fa92d9a7b3a71c3fee4e",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "767d6f8")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - update to TypeScript 4.3:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update packages to use TypeScript 4.3"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "noImplicitOverride"), " flag"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update Prettier to support the new ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "override"), " keyword")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/186",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#186"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/3946ca26e0d9cc4587d7c6bfd8f6e67efb58d3ea",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "3946ca2")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - use custom elements manifest v1.0.0:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Swap ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "web-component-analyzer"), " for ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "@custom-elements-manifest/analyzer")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update Storybook to support the updated format"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update React build script")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/196",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#196"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/1fb1f99dfebaf2751110e779818de62a1e8655b6",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "1fb1f99")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/michael-iden",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@michael-iden"), "! - Add optional label for the link wrapping the image in the image card to improve accessibility")), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-30"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/185",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#185"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/6be9b5b750322c8f87c68e417189e938fb937292",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "6be9b5b")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - update dependencies")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/190",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#190"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/699b69b6686aec643c37b87dde5aad8f7e393b8c",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "699b69b")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Fix keyboard navigation behavior for Combobox")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/199",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#199"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/d37e2efbd0117877c3b320296eee0547365ba52b",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "d37e2ef")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/michael-iden",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@michael-iden"), "! - Remove containment styling for linked title in image-card component")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/189",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#189"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/483036262202e1baea2af555bc1eeb2107691a05",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "4830362")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - clear combobox input when value is reset")), (0,esm/* mdx */.kt)("h2", {
    "id": "1053"
  }, "10.5.3"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-31"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/172",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#172"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/430a84324fe636ad1ff0a3cdee09a1ff786fc697",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "430a843")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - apply margins medium and above for 1-col layout")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/171",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#171"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/d23d1b7a7eb8b967fa410a3d91e299d9163b2f98",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "d23d1b7")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - do not truncate promotional image card titles")), (0,esm/* mdx */.kt)("h2", {
    "id": "1052"
  }, "10.5.2"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-32"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/169",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#169"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/c2861506d6a7f771250a8f28648ec27a3c4c884a",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "c286150")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - set the selection when a value is initially passed for selects")), (0,esm/* mdx */.kt)("h2", {
    "id": "1051"
  }, "10.5.1"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-33"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/165",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#165"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/7c77a9dfb435d76e6833c21bc4646f68dc2662f9",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "7c77a9d")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Allow promotional image cards to have dynamic heights")), (0,esm/* mdx */.kt)("h2", {
    "id": "1050"
  }, "10.5.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-22"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/157",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#157"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/4bf0806105b3e851d8a45cddde9d9ec9e25179b9",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "4bf0806")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Add promotional variant and source-type prop")), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-34"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/163",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#163"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/4ab84799afdaa52f07be8da07673a82cf5088a8f",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "4ab8479")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/jialin-he",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@jialin-he"), "! - Fix image card title overflow")), (0,esm/* mdx */.kt)("h2", {
    "id": "1040"
  }, "10.4.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-23"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/147",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#147"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/ce4eb300946614e2e4bfc295c54df0750fb59aa6",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "ce4eb30")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Add pharos-spacing-10-x token")), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-35"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/145",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#145"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/1fb07e5dd6eb38b656f00abbe8eab6587342afa3",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "1fb07e5")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/michael-iden",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@michael-iden"), "! - expand card to be full width to fix alignment issues for cards within a wider grid")), (0,esm/* mdx */.kt)("h2", {
    "id": "1031"
  }, "10.3.1"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-36"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/140",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#140"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/91bd5bb60a8fef8d248bc8ff2bfa7242751df7cb",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "91bd5bb")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/michael-iden",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@michael-iden"), "! - link around image on card no longer has ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "contain: layout"), " style isolation")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/142",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#142"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/efdf62c10eea72b644a7f61a33cf58542884ec00",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "efdf62c")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - set max-width for toasts on mobile")), (0,esm/* mdx */.kt)("h2", {
    "id": "1030"
  }, "10.3.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-24"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/133",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#133"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/bad3ef6118fa5de333399b8f6473f4707ba20103",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "bad3ef6")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Add headingLevel to image card to change the heading level when using the ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "title"), " property")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/137",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#137"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/b5d84e6a074e20b8ba87f8f704a2d0f7c773ae6f",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "b5d84e6")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - use SassDoc to document SASS:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add a script that uses SassDoc to generate a json containing all documented SASS"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add documentation comments to mixins"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update mixin stories")))), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-37"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/136",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#136"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/5e00ece6b9da6b6fc51f81dcf803c11d4e79e5cb",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "5e00ece")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/michael-iden",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@michael-iden"), "! - image-card style updates"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "center images horizontally within image card"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "align card title to top instead of center"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "remove contain styling from the card element")))), (0,esm/* mdx */.kt)("h2", {
    "id": "1020"
  }, "10.2.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-25"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/93",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#93"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/944e8023c8e0569b8255c531f603dafddac0849b",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "944e802")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/satya-achanta-venkata",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@satya-achanta-venkata"), "! - update event stories in Storybook to default to actions tab instead of controls tab")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/128",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#128"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/1e1c1fdf368682171f8eba63a0eb55acf741a9f5",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "1e1c1fd")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/michael-iden",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@michael-iden"), "! - allow action-button to be a slotted element")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/122",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#122"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/60667c558fc476ac4df1c1c7185846e400a686af",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "60667c5")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - implement layout component on the site:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add preset ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "1-col--sidenav-comfy"), " to ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "<pharos-layout>"), " for larger margins on our breakpoints"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Implement layouts with the new preset on the site"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update site styles for responsiveness on our breakpoints")))), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-38"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/125",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#125"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/53dac6539cd97b8249ff9c0438417415005b17bc",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "53dac65")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Lham42",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Lham42"), "! - Add sass mixins section to storybook")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/130",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#130"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/f4c6e4a2567bd738168a29e230b3b7de018bc798",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "f4c6e4a")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/eslawski",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@eslawski"), "! - Prevent pharos-modal-closed event from being emitted on initial render")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/124",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#124"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/cf0b38024298fe1f60466f171334f7bef8f6d344",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "cf0b380")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - update dependencies")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/114",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#114"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/ef0cd0befcc5f558c302258758401174c92bdf33",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "ef0cd0b")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - use node in place of gulp for building Pharos")), (0,esm/* mdx */.kt)("h2", {
    "id": "1010"
  }, "10.1.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-26"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/105",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#105"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/c263ec03741654fa916886b1ef5b72e03d85dbd4",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "c263ec0")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - add slot for title to image cards")), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-39"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/104",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#104"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/8ecfcca2e08b4800b6f796c4675388050e1a8618",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "8ecfcca")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/eslawski",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@eslawski"), "! - Fix tooltip and breadcrumb overflow logic when slotted content is non-HTML")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/106",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#106"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/cc6a25ff31ca9c18eec2994f2510c690633c0c23",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "cc6a25f")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/eslawski",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@eslawski"), "! - add min-width rule when flexed for better text wrapping support")), (0,esm/* mdx */.kt)("h2", {
    "id": "1000"
  }, "10.0.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "major-changes-2"
  }, "Major Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/36",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#36"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/db6c095c7782edff521846b645b89848adcd2f2e",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "db6c095")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/satya-achanta-venkata",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@satya-achanta-venkata"), "! - add new color tokens and use them in alerts")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/81",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#81"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/28dfaaae1ad204c937e8af227bce2220d47fb484",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "28dfaaa")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/satya-achanta-venkata",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@satya-achanta-venkata"), "! - Remove 'base' variant alert and make status required property")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/83",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#83"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/c8c299b0dfd62dab4aeababfa69108b95483a640",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "c8c299b")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Remove icon height and width as public properties")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/19",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#19"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/70f42ef0776d1b0ff0ea32ae6560deef92757d8d",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "70f42ef")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - update to Lit 2:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update to Lit 2 following upgrade guide"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "@open-wc/testing"), " tools"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Target ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "es2019"), " as recommended by Lit"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Run tests on built JS package")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/50",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#50"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/81dd35c4c7b0dad5d995e9472f54c158027d151d",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "81dd35c")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - fire modal events when opened/closed via props:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Move ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-modal-opened"), " and ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-modal-closed"), " to updated lifecycle and remove trigger details")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/42",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#42"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/84e5bfad249b5e5738cf6adf03bc6f25c769628d",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "84e5bfa")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - remove support for IE11:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Remove polyfills"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Remove design token imports in components"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update documentation"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Remove IE11 related styles")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/80",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#80"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/955983f0c26c1574d79eb8934c3a239587c4a8a6",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "955983f")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Rename ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "dark"), " property to ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "on-background"), " for consistency with other components")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/91",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#91"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/1e1a86ac68a1b71094db1caa955849ba3c2af042",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "1e1a86a")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Make level a required prop for Heading")), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-27"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/79",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#79"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/b8d5dfac4f179ad7480488df768e7adb21332035",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "b8d5dfa")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/michael-iden",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@michael-iden"), "! - add pdf and ppt icons")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/89",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#89"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/d967b520e054c8dd5bfa1dbdc33ec3bd848860cb",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "d967b52")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - import icons dynamically:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Export icon tokens individually as default exports"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-icon"), " to dynamically import them")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/88",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#88"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/5435a153da40c98f031f57b76de81a820ac35ffe",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "5435a15")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Upgrade to Style Dictionary 3.0"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Use the ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "outputReferences"), " option to generate tokens by reference instead of by value.\nThat is, CSS and SCSS variables can reference other variables in turn, keeping the provenance of each token in the output."), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Rename the ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "1x"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "2x"), ", etc. tokens to ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "1-x"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "2-x"), ", etc. to maintain and match their output names.")))), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-40"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/99",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#99"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/9bd2085c62edb6cd6a93bb430c5dcd47a0a47c70",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "9bd2085")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - update styles usage for React stories")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/92",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#92"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/a95c6fd574816d8a6f2c66bd903141135516173f",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "a95c6fd")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/SMQuazi",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@SMQuazi"), "! - add name attributes to states story for combobox, text-input and textarea")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/95",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#95"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/7b4cf51054cf7647864afe5ce4e53de963660f0d",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "7b4cf51")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/gbassham",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@gbassham"), "! - update image card styles:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Change height for image in image card component from 250px to 224px"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add max-width on \"Preview not available\" text to guarantee wrapping")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/85",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#85"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/faed05f19c9b42c18e9a3f526f007d589fbf601c",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "faed05f")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - check if click is canceled for submit buttons")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/84",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#84"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/63342ae3967f58c3652f08392b465dcb57162d1b",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "63342ae")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Lham42",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Lham42"), "! - modify button and input styles in Storybook:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "<pharos-button>"), " to checkbox group, combobox, radio group and select stories"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "modify width for combobox and select in Storybook")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/94",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#94"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/aa82d00b12346d3ff852b4d74bb91445a2eee877",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "aa82d00")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - fix Storybook inconsistencies")), (0,esm/* mdx */.kt)("h2", {
    "id": "930"
  }, "9.3.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-28"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/66",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#66"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/54e9ce06e5033a1ef487e6fdbee4fb8aee25b19b",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "54e9ce0")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Lham42",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Lham42"), "! - Add skip to main content functionality for sidenav component:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "skip"), " prop to ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-link"), " to specify whether the link must be hidden until focused"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "main-content-id"), " prop to ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-sidenav"), " to render a skip link with target"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add skip links to the site sidenav and main element")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/72",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#72"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/e5652d63d0b0941e31f4847812f787d180f94117",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "e5652d6")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - enable setting elements in a shadow DOM as tooltip boundary")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/68",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#68"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/cffffc51d4592b76b0fd022e9b5070fbb88df5b4",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "cffffc5")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - update collection cards:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update collection card styles"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Wrap link around collection image"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "no-hover"), " attribute for links")))), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-41"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/58",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#58"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/630604f3e5966e75ff19764d3b4357efc4f2f3dc",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "630604f")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - set overflow for subtle image cards")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/28",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#28"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/54f38967a73c8965e8802098d255ffbf535e4930",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "54f3896")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - remove /pharos prefix from Gatsby config")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/70",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#70"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/cdb6e07b3f047a02102f0d8d4a851f9864954427",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "cdb6e07")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - add careers section to homepage")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/67",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#67"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/c528ef130b915b633c8b39b56218d5af20fb7ae7",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "c528ef1")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Lham42",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Lham42"), "! - Add CTA for career opportunities to repo and storybook")), (0,esm/* mdx */.kt)("h2", {
    "id": "921"
  }, "9.2.1"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-42"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/51",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#51"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/26562459b4911d61bd299e5be191f87ff236d3c1",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "2656245")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - render link for error image cards and allow subtle state")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/48",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#48"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/ced1c1f082e40b5e0b5c71830fb6c6cde1277b83",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "ced1c1f")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - update dependencies:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update Gatsby dependencies"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update ESLint dependencies"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update Sass"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update cli dependencies")))), (0,esm/* mdx */.kt)("h2", {
    "id": "920"
  }, "9.2.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-29"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/31",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#31"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/faf789cfa753d355a7171622b4d591df90c4fd88",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "faf789c")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - add image card component:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add card component with ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "error"), " and ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "subtle"), " states"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "action-menu"), " attribute to render an action button to act as the trigger for the menu"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "collection"), " variant to present collection in 4:3 aspect ratio"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "tag"), " prop to ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-layout"), " to specify the HTML tag to use for the inner grid"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "playwright"))))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/25",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#25"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/54c251fd1a9843e9167a4375d9d91ca1f5dfa609",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "54c251f")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/gbassham",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@gbassham"), "! - adds toggle button and toggle button group components")), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-43"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/33",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#33"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/46fbc679c16f094aef2c207e4f4c05e71552a9bb",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "46fbc67")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - update Storybook to generate React API tables:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update Storybook to 6.3 alpha"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Follow migration guidelines")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/29",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#29"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/aa77fe3d135b9f5f8d7af8da9e535b1a9664120a",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "aa77fe3")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - increase max-height of sidenav menu")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/30",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#30"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/1a32ff4c930f014141671df8704f09a9266806ce",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "1a32ff4")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/SMQuazi",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@SMQuazi"), "! - revert textarea and textinput examples to show multiple variants on state stories")), (0,esm/* mdx */.kt)("h2", {
    "id": "910"
  }, "9.1.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-30"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/17",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#17"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/4dd7f010bdad906f0d21dbd35e48378e9bceffd7",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "4dd7f01")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - add layout component:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add design tokens for breakpoints and grid gutter"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add layout component which applies a 12-column grid for a specified layout"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add Sass mixins for establishing grid styles for the breakpoints"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add Sass maps for storing column and margin design decisions"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update example Storybook pages to utilize the component")))), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-44"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/20",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#20"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/b8581b4f72309037d0182266571e527a0dec86c5",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "b8581b4")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - remove component guidelines from Storybook:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Remove component guidelines from Storybook"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add links to the guidelines"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Use React versions of components in the guidelines to render properly in Gatsby"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Move Storybook images to the ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, ".storybook"), " directory")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/18",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#18"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/3d6e99c07bcf4d46062dc781d4e812fa69c22114",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "3d6e99c")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/SMQuazi",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@SMQuazi"), "! - Update examples for storybook to align with voice and tone")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/16",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#16"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/482ac64ca0bb1876c2fb18d8586caef574a82032",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "482ac64")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - fix inconsistent unit test")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/pull/21",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#21"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ithaka/pharos/commit/8c4bd580f4dfb0136764a1030fc3b13c6ab19a58",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "8c4bd58")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/michael-iden",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@michael-iden"), "! - fix: resize modal to fill available space on mobile browsers")), (0,esm/* mdx */.kt)("h2", {
    "id": "900"
  }, "9.0.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "major-changes-3"
  }, "Major Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/329505af1475004a64b319ca29614d8a0f2177d7",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "329505a")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - rename packages to publish to Ithaka namespace:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Rename package ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "@pharos/core"), " to ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "@ithaka/pharos")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Rename package ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "@pharos/cli"), " to ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "@ithaka/pharos-cli")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Rename package ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "@pharos/site"), " to ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "@ithaka/pharos-site")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update documentation and imports")))), (0,esm/* mdx */.kt)("h2", {
    "id": "821"
  }, "8.2.1"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-45"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/pull/9",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "#9"), " ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/ithaka/pharos/commit/bd2588a3cf1fb77e68e98a5b6b8c5e2d9f14552b",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "a"
  }, "bd2588a")), " Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - update lit for forward-compatible features:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update dependencies"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Change ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "@internalProperty"), " to ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "@state"))))), (0,esm/* mdx */.kt)("h2", {
    "id": "820"
  }, "8.2.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-31"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Lint mdx and js files:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "eslint-plugin-mdx"), " for linting mdx files"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "eslint-plugin-no-smart-quotes"), " to find and replace smart quotes"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Use eslint overrides to explicitly configure settings for each file type"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Address linting errors")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Update images for open source compliance:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Replace images on Pharos site and Storybook with compliant ones"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update styles to match design")))), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-46"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/SMQuazi",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@SMQuazi"), "! - Add icon documentation to storybook and site")), (0,esm/* mdx */.kt)("h2", {
    "id": "810"
  }, "8.1.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-32"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add type styles documentation to storybook and site")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add loading spinner documentation to storybook and site")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add pagination documentation to storybook and site")), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-47"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Remove platform-native styling from buttons")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/SMQuazi",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@SMQuazi"), "! - Add Tabs documentation to pharos site and storybook")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/jialin-he",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@jialin-he"), "! - Fix toast when the toast content is very long")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/SMQuazi",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@SMQuazi"), "! - Add dropdown menu documentation to storybook and site")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Fix changeset publish for core package")), (0,esm/* mdx */.kt)("h2", {
    "id": "800"
  }, "8.0.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "major-changes-4"
  }, "Major Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Remove deprecated design tokens:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Migration guidelines can be found ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "#7200"
  }, "here"))))), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-33"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Forward Sass modules from a single entrypoint file")), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-48"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Move out functional tests and fonts:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Move functional tests to new repo ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-functional-tests"), " and update test job"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Remove fonts and pull them in from S3"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Fix site home page hero font and layout")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Remove hook from custom boundary tooltip story")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Reset sidenav host width for smaller viewports")), (0,esm/* mdx */.kt)("h2", {
    "id": "7250"
  }, "7.25.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-34"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Create Storybook example item detail page:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Create an item detail page inspired by latest designs"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update the revised header used in the example pages to allow enabling search for every breakpoint"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Upgrade ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "husky"), " to v6")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add input group documentation:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add input group documentation and guidelines"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update Gatsby babel config to fix decorator runtime error"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Remove ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "margin"), " and ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "padding"), " from ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "*"), " selector in site styles to not interfere with slotted component styles")))), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-49"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Remove display property from links for proper wrapping:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "flex"), " prop to links to enable flexbox when displaying links with an icon")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Fix item detail carousels:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update Storybook"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Fix item detail carousels styles"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Fix home page input placement")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/likwidsage",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@likwidsage"), "! - Add Modal to Pharos site and storybook")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Ensure single word wraps on overflow in tooltips")), (0,esm/* mdx */.kt)("h2", {
    "id": "7240"
  }, "7.24.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-35"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add responsive features to sidenav:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "menu"), " icon to ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-icon"), " set"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-sidenav-button"), " that is only visible when viewport goes below breakpoint 1056px"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Slide out ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-sidenav"), " when viewport goes below breakpoint 1056px or when its close button is clicked"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Slide in ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-sidenav"), " when viewport is at least 1056px or when ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-sidenav-button"), " is clicked"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update example reports page to include ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-sidenav-button")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Delegate focus correctly when open/close buttons are clicked")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Create Storybook example reports page:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Create a reports page inspired by latest designs"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Keep margin at 56px until 320px breakpoint is reached"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Remove 1440px from list of breakpoints"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update 1024px to 1056px in list of breakpoints"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update margins used in the list of breakpoints"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add a modal for creating reports and error toasts when the download buttons are clicked"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add value prop to ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-button"), " as native buttons support name and value attributes for forms")))), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-50"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Keep border for disabled inputs and textareas")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Bump chromatic delays:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Up the timeouts and snapshot delays for tooltip and dropdown menu stories for consistent results")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Update header columns to extend end column")), (0,esm/* mdx */.kt)("h2", {
    "id": "7233"
  }, "7.23.3"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-51"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Update last dropdown menu item on slot change")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Ensure dropdown menus in navs are placed at start")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Align header start slot container to end")), (0,esm/* mdx */.kt)("h2", {
    "id": "7232"
  }, "7.23.2"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-52"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Fix header responsive styles")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Wrap dropdown menu navs")), (0,esm/* mdx */.kt)("h2", {
    "id": "7231"
  }, "7.23.1"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-53"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Update header layout to center for large screens")), (0,esm/* mdx */.kt)("h2", {
    "id": "7230"
  }, "7.23.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-36"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/jialin-he",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@jialin-he"), "! - Add custom boundary to pharos tooltip")), (0,esm/* mdx */.kt)("h2", {
    "id": "7221"
  }, "7.22.1"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-54"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Update on changes to children for components without a slot:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Create a mixin that uses a ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "MutationObserver"), " to react to changes in a component's children and then call ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "requestUpdate"), " to re-render the component"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Use ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "unsafeHTML(child.outerHTML)"), " for rendering children as otherwise the list of children is lost after first render with ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "child"), " alone"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-breadcrumb"), " to utilize slots to ensure event listeners can be used on the passed items")))), (0,esm/* mdx */.kt)("h2", {
    "id": "7220"
  }, "7.22.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-37"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Upgrade to Gatsby v3:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update dependencies and verify ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "develop"), " and ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "build"), " scripts."), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Import CSS modules as ES modules"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Preload fonts for Pharos site"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Use Webpack 5 builder for Storybook"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "addon-backgrounds"), " to easily evaluate components on dark backgrounds")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/likwidsage",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@likwidsage"), "! - ", "*", " Adds pharos-breadcrumb component which sets the container for the bread crumbs as intend to be the parent to pharos-breadcrumb-item components", (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Adds pharos-breadcrumb-item component which controls the styling and logic for the individual items in the breadcrumb")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Create Storybook example home page:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Create a home page inspired by latest designs"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Create a revised header to use in the story"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Change ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "contain"), " value for ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-heading"), " to address cutoff for large headings with prop ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "no-margin")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Fix ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-footer"), " centering for larger viewports"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add additional viewports to the story to test a wider range of breakpoints"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Utilize a grid sass map for sharing layout design decisions between the home page and revised header"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Use the ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "minmax"), " CSS function to add fluidity when transitioning between margins and content widths for each breakpoint range"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Use a 12 column grid for breakpoints 1584 down to 768"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Use a 8 column grid for 768 down to 320"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Use a 4 column grid for 320")))), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-55"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/likwidsage",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@likwidsage"), "! - use pharos-link in breadcrumb and use IDs in story")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Fix homepage hero relative path")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/likwidsage",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@likwidsage"), "! - Remove spacing around breadcrumb component")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add toast documentation")), (0,esm/* mdx */.kt)("h2", {
    "id": "7211"
  }, "7.21.1"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-56"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Fix text overflow for dropdown menu descriptions")), (0,esm/* mdx */.kt)("h2", {
    "id": "7210"
  }, "7.21.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-38"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add toast component:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-toaster"), " which manages ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-toast"), " generation, focusing, and positioning"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-toast"), " which uses a cancelable debouncer to manage closing after 6 seconds"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Open toasts when ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-toaster"), " is present and custom event ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-toast-open"), " is fired on the document"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Read fields ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "status"), " and ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "content"), " from the event to generate toasts"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-toast-button"), " variant which has modified hover styles")))), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-57"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/jialin-he",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@jialin-he"), "! - Add folder-selected and workspace-selected to pharos icons")), (0,esm/* mdx */.kt)("h2", {
    "id": "7200"
  }, "7.20.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-39"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Conform design tokens:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Create new tokens without the word ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "brand"), " from color, line height, and spacing tokens"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update all styles to use the new tokens"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Mark ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "base"), " and ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "brand"), " color, line height, and spacing tokens as deprecated"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Store deprecated tokens in separate json"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Ensure token related pages in Storybook and the Pharos site display updated names")), (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("strong", {
    parentName: "p"
  }, "Migration Guidelines")), (0,esm/* mdx */.kt)("ol", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ol"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Remove ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "brand"), " from ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "pharos-color"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "pharos-line-height"), ", and ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "pharos-spacing"), " tokens:"), (0,esm/* mdx */.kt)("table", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("thead", {
    parentName: "table"
  }, (0,esm/* mdx */.kt)("tr", {
    parentName: "thead"
  }, (0,esm/* mdx */.kt)("th", {
    parentName: "tr",
    "align": null
  }, "Old Token"), (0,esm/* mdx */.kt)("th", {
    parentName: "tr",
    "align": null
  }, "New Token"))), (0,esm/* mdx */.kt)("tbody", {
    parentName: "table"
  }, (0,esm/* mdx */.kt)("tr", {
    parentName: "tbody"
  }, (0,esm/* mdx */.kt)("td", {
    parentName: "tr",
    "align": null
  }, "\\$pharos-color-brand-jstor-red"), (0,esm/* mdx */.kt)("td", {
    parentName: "tr",
    "align": null
  }, "\\$pharos-color-jstor-red"))))), (0,esm/* mdx */.kt)("li", {
    parentName: "ol"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Replace legacy ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "pharos-color-base"), " and ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "pharos-line-height-base"), " tokens with their modern equivalent:"), (0,esm/* mdx */.kt)("table", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("thead", {
    parentName: "table"
  }, (0,esm/* mdx */.kt)("tr", {
    parentName: "thead"
  }, (0,esm/* mdx */.kt)("th", {
    parentName: "tr",
    "align": null
  }, "Legacy Token"), (0,esm/* mdx */.kt)("th", {
    parentName: "tr",
    "align": null
  }, "Modern Token"))), (0,esm/* mdx */.kt)("tbody", {
    parentName: "table"
  }, (0,esm/* mdx */.kt)("tr", {
    parentName: "tbody"
  }, (0,esm/* mdx */.kt)("td", {
    parentName: "tr",
    "align": null
  }, "\\$pharos-line-height-base-xsmall"), (0,esm/* mdx */.kt)("td", {
    parentName: "tr",
    "align": null
  }, "\\$pharos-line-height-xsmall"))))), (0,esm/* mdx */.kt)("li", {
    parentName: "ol"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Replace legacy token ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "pharos-font-color-base"), " with ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "pharos-color-text-base")))), (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("em", {
    parentName: "p"
  }, "Note: Make sure to update all token types used in your app: ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "em"
  }, "scss"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "em"
  }, "css"), ", and ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "em"
  }, "es6"), " types")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/eslawski",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@eslawski"), "! - Remove border from condensed icon")), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-58"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Fix React button story formatting")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Fix pagination handling for child elements")), (0,esm/* mdx */.kt)("h2", {
    "id": "7190"
  }, "7.19.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-40"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/eslawski",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@eslawski"), "! - Enhance pharos-button to have a condensed icon only form")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add sidenav component:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Create ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "SideElement"), " base class for ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-sidenav"), " and upcoming ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-sidebar"), " components to inherit styles from"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "top"), " slot to ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-sidenav"), " for content shown above the main body"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Construct default slot to house ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-sidenav-section"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-sidenav-menu"), ", and ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-sidenav-link"), " elements"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-sidenav-section"), " with properties for adding a heading and/or divider"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-sidenav-link"), " which extends ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-link"), " and include an ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "external"), " variant"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-sidenav-menu"), " that acts as a menu of ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-sidenav-link"), " elements with appropriate accessibility features"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "onBackground"), " variant for ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-text-input"))))), (0,esm/* mdx */.kt)("h2", {
    "id": "7180"
  }, "7.18.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-41"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/eslawski",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@eslawski"), "! - Enhance pharos-dropdown-menu to allow for dynamic triggers and also add some open/close hooks")), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-59"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Instruct to import tokens to implement typography")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add dropdown menu nav documentation in site and storybook")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/michael-iden",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@michael-iden"), "! - Removes padding on the footer of the pharos modal when the footer has not slotted content")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Update to TypeScript 4.2")), (0,esm/* mdx */.kt)("h2", {
    "id": "7170"
  }, "7.17.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-42"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Create Storybook search page to test interoperability between atoms and molecules:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Create a search page inspired by latest designs"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add stories to ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "Pages"), " category to fit atomic design model"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Use ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "stories.ts"), " and ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "stories.tsx"), " format to emulate developer experience"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add full width prop to buttons")))), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-60"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/likwidsage",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@likwidsage"), "! - Add documentation for progress bar")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Fix header integration tests")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Show pixel value and remove controls from token stories")), (0,esm/* mdx */.kt)("h2", {
    "id": "7160"
  }, "7.16.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-43"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ymouzakis",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@ymouzakis"), "! - This changeset adds search mode to the combobox. Search mode makes the following changes:", (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Search icon instead of chevron icon"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Disables automatic highlighting"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Fires change events when selecting from the list of options"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "The drop down will display all options regardless of exact matches.")))), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-61"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/likwidsage",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@likwidsage"), "! - Add token story in StoryBook")), (0,esm/* mdx */.kt)("h2", {
    "id": "7150"
  }, "7.15.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-44"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Throw an error if invalid size is passed to modals")), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-62"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Keep js extension for non-entrypoint dependency imports")), (0,esm/* mdx */.kt)("h2", {
    "id": "7140"
  }, "7.14.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-45"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add size prop to modals")), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-63"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/likwidsage",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@likwidsage"), "! - Add Pharos Header documentation in site and storybook")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add chromatic viewports to applicable stories to test for regressions")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Update documentation:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add docs on Node/Typescript requirements"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add docs on importing design tokens and typography styles"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add docs on importing Sass mixins and needed Webpack config")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Address error thrown when the footer creates icons")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add slide in/out transition for modals on lower breakpoints")), (0,esm/* mdx */.kt)("h2", {
    "id": "7131"
  }, "7.13.1"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-64"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add footer documentation in site and storybook")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/michael-iden",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@michael-iden"), "! - Removes newlines preceding and following links that cause unintended spaces around the links")), (0,esm/* mdx */.kt)("h2", {
    "id": "7130"
  }, "7.13.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-46"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Update header and dropdown menu components to support a section for the PDS on JSTOR:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add slot ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "top"), " to ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-header"), " for a top section on the header"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Create base class ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "OverlayElement"), " for tooltips and dropdown menus to extend from"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-dropdown-menus"), " to support menus with no items"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Fix ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-dropdown-menus"), " screen reader experience by wrapping ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "ul"), " element with the focus trap"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Implement responsive design")))), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-65"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Center modals without CSS transform to fix Popper placements:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Center modals with flexbox and remove problematic styles"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Verify in Chrome, Firefox, Safari, and IE11")))), (0,esm/* mdx */.kt)("h2", {
    "id": "7120"
  }, "7.12.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-47"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/rehanabbasi",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@rehanabbasi"), "! - Create pagination component")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Do not close modals when overlay is clicked")), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-66"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/kelseytrabue",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@kelseytrabue"), "! - Button documentation, tooltip asset fixes:\nAdded documentation for how buttons should be used along with its variants.\nAlso changed the location of the tooltip component guidelines assets for better organization.")), (0,esm/* mdx */.kt)("h2", {
    "id": "7110"
  }, "7.11.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-48"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add header component:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add slots for sections of the header: ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "start"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "center"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "end")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Fix bugs in ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-dropdown-menu-nav"), " pertaining to opening/closing its menus"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Verify in IE11"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "bold"), " prop to ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-link")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Fix ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-input-group"), " focus/blur padding")))), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-67"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/ymouzakis",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@ymouzakis"), "! - Add autocomplete attribute to pharos text input")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Update dependencies")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Fix autocomplete type error")), (0,esm/* mdx */.kt)("h2", {
    "id": "7100"
  }, "7.10.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-49"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/likwidsage",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@likwidsage"), "! - Add new icon to pharos-icon", (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update pharos homepage styles")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Show Pharos version in Storybook")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add footer component:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add slots for various parts of the footer (many of which expect a list of links to display)"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Implement layout and responsive design using CSS grid"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Verify in IE11"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add Google icon"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add external styles to customize translate widget"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Use a ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "MutationObserver"), " to update translate widget icons when rendered")))), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-68"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Update WTR and config to handle modules resolved outside the root directory")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/likwidsage",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@likwidsage"), "! - Add token for font type scale 14", (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update pharos homepage")))), (0,esm/* mdx */.kt)("h2", {
    "id": "792"
  }, "7.9.2"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-69"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Fix tooltip and dropdown Chromatic false positives")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Update wtr and playwright launcher to run tests against latest browser versions")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Use forked version of @a11y/focus-trap to prevent duplicate component registration errors")), (0,esm/* mdx */.kt)("h2", {
    "id": "791"
  }, "7.9.1"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-70"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/jialin-he",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@jialin-he"), "! - stop propagation of key events from tab-panel to allow white space to be entered in input inside a tab-panel")), (0,esm/* mdx */.kt)("h2", {
    "id": "790"
  }, "7.9.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-50"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add link documentation")), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-71"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Enable implicit form submission with Pharos buttons")), (0,esm/* mdx */.kt)("h2", {
    "id": "780"
  }, "7.8.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-51"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add content-label mixin")), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-72"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/eslawski",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@eslawski"), "! - Refactor the implementation of tab panel scrolling to give more flexibility to the consumer.")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Remove unused types")), (0,esm/* mdx */.kt)("h2", {
    "id": "771"
  }, "7.7.1"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-73"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/eslawski",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@eslawski"), "! - Automatically overflow tab panel contents to prevent scrollbars from appearing erroneously")), (0,esm/* mdx */.kt)("h2", {
    "id": "770"
  }, "7.7.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-52"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/likwidsage",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@likwidsage"), "! - ", "*", " Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-dropdown-menu-nav"), " component", (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-dropdown-menu-nav-link"), " component, which extends ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-link")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Modify ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-dropdown-menu"), " component to account for ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-dropdown-menu-nav"), " logic")))), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-74"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/eslawski",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@eslawski"), "! - Prevents pharos-tab-panels from getting focus if they contain focusable elements.", (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Added some styling tweaks to support scrollable content in pharos-tab-panels.")))), (0,esm/* mdx */.kt)("h2", {
    "id": "760"
  }, "7.6.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-53"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add input group component:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-input-group"), " component which extends the ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-text-input"), " component"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add default slot to support appended elements such as icons, buttons, and selects"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "prepend"), " slot to support prepended elements"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update input padding based off items within the input group"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-input-group-select"), " variant component")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Upgrade to React 17:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update dependencies"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Follow guide to configure Storybook and Gatsby to use new JSX transform"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Verify Storybook and Gatsby develop/build commands"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Verify React components work as intended on JSTOR")))), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-75"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Move input group to form elements section in Storybook")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add names to input group stories")), (0,esm/* mdx */.kt)("h2", {
    "id": "751"
  }, "7.5.1"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-76"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Prevent click from firing from disabled elements")), (0,esm/* mdx */.kt)("h2", {
    "id": "750"
  }, "7.5.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-54"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add laptop icon")), (0,esm/* mdx */.kt)("h2", {
    "id": "741"
  }, "7.4.1"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-77"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Fix submit and reset buttons within forms:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "For buttons with type ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "submit"), " and ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "reset"), " in a form, on click attach a button element of the same type and click it for the desired effect on the form, and then detach it"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Prevent the click on the helper button to propagate"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add method ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "_handleFormReset"), " to the form mixin and implement the reset logic for each form element"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add submit and reset buttons within a form story")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Update select CSS containment value")), (0,esm/* mdx */.kt)("h2", {
    "id": "740"
  }, "7.4.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-55"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add calendar and close-inverse icons")), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-78"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Support ref on React components:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Use ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "forwardRef"), " and ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "useImperativeHandle"), " to support ref on our React components"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Ensure passing ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "tabIndex"), " is applied correctly")))), (0,esm/* mdx */.kt)("h2", {
    "id": "731"
  }, "7.3.1"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-79"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Remove CSS containment from combobox")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Fix space key handler in IE11 for tabs")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Fix optional string literal type prop definitions")), (0,esm/* mdx */.kt)("h2", {
    "id": "730"
  }, "7.3.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-56"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/michael-iden",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@michael-iden"), "! - Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "pharos-tabs"), " component:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add tabs component to take in the clickable tab elements and tab panels"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add functionality to change the visible panel when the tab is clicked"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Ensure proper accessibility for tabs, and the panel it controls")))), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-80"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Update TypeScript to 4.1")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Update WTR for improved coverage reports")), (0,esm/* mdx */.kt)("h2", {
    "id": "720"
  }, "7.2.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-57"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add additional icons:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "attachment"), " and ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "copy"), " icons")))), (0,esm/* mdx */.kt)("h2", {
    "id": "710"
  }, "7.1.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-58"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add additional icons:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "book"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "collapse"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "expand"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "google-color"), ", and ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "question-inverse"), " icons")))), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-81"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add names to radio state story")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Update version of WTR Playwright which fixes the concurrency focus issues with Firefox")), (0,esm/* mdx */.kt)("h2", {
    "id": "700"
  }, "7.0.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "major-changes-5"
  }, "Major Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "pharos-button"), " component:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Create button with ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "primary"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "secondary"), ", and ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "subtle"), " variants"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "large"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "on-background"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "icon"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "icon-right"), ", and ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "icon-left"), " properties to further customize buttons"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Remove ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "variant"), " property from links and instead allow buttons to be rendered as links with the ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "href"), " prop to allow for all design variations"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Create ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "AnchorElement"), " base class for links and buttons to inherit anchor properties"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Create string literal type for icon names"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update existing stories to use Pharos buttons"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "combobox"), " and ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "modal"), " components to use ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "button"), " component")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Update icons in Pharos:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Remove ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "add-link"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "checkmark-large"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "close-inverse"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "external-link"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "external-link-arrow"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "gallery"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "list"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "magnifying-glass"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "new-folder"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "x"), " icons"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "chevron-left-large"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "chevron-right-large"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "edit"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "email"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "facebook"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "fit-to-view"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "folder-new"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "fullscreen-minimize"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "fullscreen"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "instagram"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "link-add"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "link-external"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "linkedin"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "tumblr"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "twitter"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "view-grid"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "youtube"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "zoom-in"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "zoom-out"), " icons"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update existing icons"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add icon stories to show all possible icons and gain insight into regressions"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Move component status page icons to ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "site"), " package as they should not be delivered as part of ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "core")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update checkbox component to pull in icons for ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "checked"), " and ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "indeterminate"), " state"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update icon component to set dimensions to 16x16 for small icons (end with ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "-small"), ")")))), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-59"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add typography stories to Storybook:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add typography stories"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add styles for lists")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add component status page to Pharos site:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add new icons for statuses"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Create legend and status ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "json"), " files to indicate current status"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Create component status page")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "p"
  }, "pharos-link"), " component:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add link component with ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "primary"), ", ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "subtle"), ", and ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "on background"), " states"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "primary-button"), " and ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "secondary-button"), " variants"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Style links appropriately when in a non-error alert"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Create Sass mixins for links and buttons to reuse for variants"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Ensure focus outline is consistent for links that span multiple lines across all browsers")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Use CSS containment for better visual isolation and performance:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Apply ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "contain: content"), " and ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "contain: strict"), " where possible for self-contained components"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Ensure each component's ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, ":host"), " is styled correctly to best support ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "contain")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Apply ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "contain: layout"), " for components whose styles/children go outside its boundary")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/seanggani",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@seanggani"), "! - Add progress bar component")), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-82"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/likwidsage",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@likwidsage"), "! - Update README to include link to adoption governance model")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Fix disabled icon button padding on hover")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add Sweden copyright statement to fonts file")), (0,esm/* mdx */.kt)("h2", {
    "id": "600"
  }, "6.0.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "major-changes-6"
  }, "Major Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Use tokens created in #267 to style Pharos components, add a few SCSS utilities where needed. Also update the Heading component to reflect the latest decisions from the Brand team on usage, leading to an API change:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Remove ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "expressive"), " and ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "size"), " properties"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add new ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "preset"), " property to indicate to Heading which visual display to use\u2014these can be chosen quickly by designers and specified quickly in code to achieve the desired display.")))), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-60"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Create typography tokens:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Create body font-family alias token"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Create body font size alias tokens"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Create brand line-height tokens"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Create letter-spacing Sass mixins and deliver Sass utils as part of core package")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/likwidsage",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@likwidsage"), "! - Add more icons to ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-icon"), " and update iconography & imagery pages")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Deliver fonts from Pharos:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Generate font-face definitions from tokens"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Include assets with delivered package"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Create font-family tokens with fallbacks"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Pharos site uses fonts from core package")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Deliver typography styles from a separate file:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Move typography styles from ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "fonts.css"), " to ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "typography.scss"), " and deliver them as part of the package"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Set base font size to 100% to allow browser configured font sizing to apply for better accessibility")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add heading legend preset")), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-83"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Update WTR for improved speed")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Update checkbox name in story")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/likwidsage",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@likwidsage"), "! - ", "*", " Update 3 inverse icons' sizing for pharos icons", (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update exclamation and cite icons for new styles")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Update heading preset styles:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Change preset 1 ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "line-height"), " value"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "th"), " styles to ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "typography.scss"))))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Update dependencies")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Update dependencies:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update PostCSS to v8 and tools that use it as a dependency")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Update tooltip and dropdown menu default position to fixed")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Address accessibility issues found by axe-core 4:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Remove ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "aria-required"), " from the checkbox-group fieldset as this is not a valid use of the attribute"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add role ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "radiogroup"), " to the radio-group fieldset in order to allow use of ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "aria-required"))))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Update WTR config:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Bump up coverage thresholds"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Move reduced concurrency to the browser that needs it as WTR now allows per browser configuration")))), (0,esm/* mdx */.kt)("h2", {
    "id": "500"
  }, "5.0.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "major-changes-7"
  }, "Major Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Rework tooltips for better accessibility"), (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Previous API:"), (0,esm/* mdx */.kt)("pre", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("code", {
    parentName: "pre"
  }, "<pharos-tooltip>\n  <button slot=\"target\">I am a button</button>\n  <span slot\"content\">Hi there!</span>\n</pharos-tooltip>\n")), (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "New API:"), (0,esm/* mdx */.kt)("pre", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("code", {
    parentName: "pre"
  }, "<button data-tooltip-id=\"my-tooltip\">I am a button</button>\n<pharos-tooltip id=\"my-tooltip\">Hi there!</pharos-tooltip>\n")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/likwidsage",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@likwidsage"), "! - ", "*", " Update brand color page on site.", (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update color tokens."), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update spinner tokens to reflect changes in color tokens.")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Update color alias tokens:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add several new categories of color"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Remove ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "primary"), " token"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Move some colors out of ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "brand"), " into ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "feedback"), " category")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Provide design tokens in es6 format:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Rename js object design tokens to ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "tokens.js")), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add es6 design tokens as ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "variables.js"))))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Update components to use new brand color tokens:"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update component colors based off design"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Remove irrelevant component tokens"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update radio and checkbox SVG sizing to match design"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Update gulp sass task to use sass as the compiler instead of node-sass to take advantage of sass modules for shared form element mixins")))), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-61"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, (0,esm/* mdx */.kt)("p", {
    parentName: "li"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "p",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Update alert styles for consistency with new brand"), (0,esm/* mdx */.kt)("ul", {
    parentName: "li"
  }, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Alert text is now Marble Grey 20 (", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-color-text-20"), ") or White (", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-color-text-white"), ") for error alerts"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Alert links are now black (", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-color-interactive-seondary"), ") or White (", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "pharos-color-text-white"), ") for error alerts"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Alert links now remove their underline on hover"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Info alert backgrounds are now Glacier Blue 80")))), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "<pharos-dropdown-menu>"), " component")), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-84"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Toggle combobox list on input click")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Use @open-wc/dedupe-mixin util for managing mixins")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Apply styles and classes in React wrapper")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Set core package type to module to load as ES modules")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add experimental module flag to token and gulp scripts")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Set readonly props as optional in React wrapper")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Allow standard HTML and React attributes in React wrapper")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Move sass modules to utils to avoid redundant style import")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Convert Pharos site package to TypeScript")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add additional alias tokens")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add optional props and custom events to React wrapper interface")), (0,esm/* mdx */.kt)("h2", {
    "id": "432"
  }, "4.3.2"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-85"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Make radio and checkbox inputs locatable for Watir")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Update to TypeScript 4")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Update lit-html with resolutions")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add explicit keyframe for rotation of loading spinner")), (0,esm/* mdx */.kt)("h2", {
    "id": "431"
  }, "4.3.1"), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-86"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Fix decorator for safe custom element definition")), (0,esm/* mdx */.kt)("h2", {
    "id": "430"
  }, "4.3.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-62"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "<pharos-modal>"), " component")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add prop interface for React components")), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-87"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/daneah",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@daneah"), "! - Pharos components will now warn instead of raising an exception upon duplicate definition")), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Thanks ", (0,esm/* mdx */.kt)("a", {
    parentName: "li",
    "href": "https://github.com/Niznikr",
    "target": "_blank",
    "rel": "nofollow noopener noreferrer"
  }, "@Niznikr"), "! - Add .js extension to imports in built package files")), (0,esm/* mdx */.kt)("h2", {
    "id": "420"
  }, "4.2.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-63"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add dark variant and hover style for checkboxes"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add an indeterminate state for checkboxes"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add icons to pharos-icons and update site navigation")), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-88"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Fix placeholder styling for text-input and textarea"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Upgrade to Storybook 6")), (0,esm/* mdx */.kt)("h2", {
    "id": "410"
  }, "4.1.0"), (0,esm/* mdx */.kt)("h3", {
    "id": "minor-changes-64"
  }, "Minor Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Add ", (0,esm/* mdx */.kt)("inlineCode", {
    parentName: "li"
  }, "<pharos-loading-spinner>"), " component")), (0,esm/* mdx */.kt)("h3", {
    "id": "patch-changes-89"
  }, "Patch Changes"), (0,esm/* mdx */.kt)("ul", null, (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Fix multiple bindings to handleFormdata"), (0,esm/* mdx */.kt)("li", {
    parentName: "ul"
  }, "Replace Lerna with Yarn and Changesets")));
}
;
MDXContent.isMDXComponent = true;
;// CONCATENATED MODULE: ./packages/pharos/docs/2.changelog.docs.stories.mdx




var _2_changelog_docs_stories_excluded = ["components"];

function _2_changelog_docs_stories_extends() { _2_changelog_docs_stories_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _2_changelog_docs_stories_extends.apply(this, arguments); }
function _2_changelog_docs_stories_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _2_changelog_docs_stories_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _2_changelog_docs_stories_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



/* @jsxRuntime classic */
/* @jsx mdx */



var _2_changelog_docs_stories_layoutProps = {};
var _2_changelog_docs_stories_MDXLayout = "wrapper";
function _2_changelog_docs_stories_MDXContent(_ref) {
  var components = _ref.components,
    props = _2_changelog_docs_stories_objectWithoutProperties(_ref, _2_changelog_docs_stories_excluded);
  return (0,esm/* mdx */.kt)(_2_changelog_docs_stories_MDXLayout, _2_changelog_docs_stories_extends({}, _2_changelog_docs_stories_layoutProps, props, {
    components: components,
    mdxType: "MDXLayout"
  }), (0,esm/* mdx */.kt)(dist_esm/* Meta */.h_, {
    title: "Pharos/Changelog",
    mdxType: "Meta"
  }), (0,esm/* mdx */.kt)(MDXContent, {
    mdxType: "Changelog"
  }));
}
;
_2_changelog_docs_stories_MDXContent.isMDXComponent = true;
var __page = function __page() {
  throw new Error("Docs-only story");
};
__page.parameters = {
  docsOnly: true
};
var componentMeta = {
  title: 'Pharos/Changelog',
  includeStories: ["__page"]
};
var mdxStoryNameToKey = {};
componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = Object.assign({}, componentMeta.parameters.docs || {}, {
  page: function page() {
    return (0,esm/* mdx */.kt)(dist_esm/* AddContext */.aT, {
      mdxStoryNameToKey: mdxStoryNameToKey,
      mdxComponentAnnotations: componentMeta
    }, (0,esm/* mdx */.kt)(_2_changelog_docs_stories_MDXContent, null));
  }
});
/* harmony default export */ const _2_changelog_docs_stories = (componentMeta);
var __namedExportsOrder = ["__page"];

/***/ }),

/***/ "./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[12].use[1]!./node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[12].use[2]!./packages/pharos-site/static/styles/global.scss":
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pharos-storybook__image{margin-top:var(--pharos-spacing-three-quarters-x);margin-bottom:var(--pharos-spacing-three-quarters-x);max-width:100%}kbd{padding:.25rem .5rem;font-size:.875rem;color:#333;background-color:#fcfcfc;border:.1rem solid #e8e8e8;border-bottom-color:#9c9c9c;box-shadow:0 1px 0 #9c9c9c,0 0 0 2px #fcfcfc inset}.tooltip-example__target{border-radius:50%;border:none;fill:var(--pharos-color-night-blue-base);padding:0;cursor:pointer;background:none}.tooltip-example__container{display:grid;grid-template-columns:repeat(3, auto);grid-gap:5rem;margin-top:5rem;margin-bottom:5rem;justify-content:space-evenly}.alert-example__content{margin:0}p.alert-example__content+p.alert-example__content{margin-top:1rem}.alert-example__content>li{margin-top:0}.checkbox-example__container--on-background{padding:1rem;background-color:var(--pharos-color-black)}.token-table-container{width:80%;margin:auto}.token-table-container h2{font-weight:normal}.token-table{width:100%}.token-table code{background:var(--pharos-color-ui-20);border-radius:1px;padding:var(--pharos-spacing-one-quarter-x) var(--pharos-spacing-one-half-x);white-space:nowrap}.token-table pharos-icon{fill:var(--pharos-color-black);stroke:var(--pharos-color-black)}.token-table th{padding:0;padding-bottom:var(--pharos-spacing-one-half-x);border-bottom:1px solid var(--pharos-color-ui-30);margin-bottom:var(--pharos-spacing-one-half-x)}.token-table td{vertical-align:top;padding-top:var(--pharos-spacing-one-and-a-half-x);padding-right:var(--pharos-spacing-2-x);border-bottom:1px solid var(--pharos-color-ui-30);padding-bottom:var(--pharos-spacing-one-and-a-half-x)}.token-table tr:last-child td{border-bottom:1px solid rgba(0,0,0,0)}.token-table .color-example{width:10rem;height:3rem;border:1px solid #eee}.token-table .line-height-example{max-height:110px;overflow:hidden}.token-table .radius-example{background:var(--pharos-color-living-coral-80);width:2rem;height:2rem;display:inline-block}.token-table .token-type-sans-serif{line-height:normal;font-family:var(--pharos-font-family-sans-serif);white-space:nowrap}.token-table .token-type-serif{line-height:normal;font-family:var(--pharos-font-family-serif);white-space:nowrap}.token-table .spacing-example{background:var(--pharos-color-living-coral-80);width:100%;display:inline-block}.token-table .transition-example{height:3rem;display:inline-block}.token-table .transition-example :hover{background:var(--pharos-color-jstor-red)}.typography-table-example{border:1px solid var(--pharos-color-ui-40);padding:var(--pharos-spacing-one-quarter-x) var(--pharos-spacing-one-half-x)}.icon-example__icon{stroke:var(--pharos-color-black);stroke-width:0}.icon-example__container{display:flex;align-items:center;padding:var(--pharos-spacing-one-quarter-x)}.icon-example__name{margin-left:var(--pharos-spacing-three-quarters-x)}.list-example__no-bullets{list-style-type:none}.list-example__nested>li:not(:last-child){margin-bottom:var(--pharos-spacing-three-quarters-x)}.list-example__inline{list-style-type:none;display:flex;flex-wrap:wrap;align-items:center}.list-example__inline li:not(:last-child){margin-right:var(--pharos-spacing-one-and-a-half-x);margin-bottom:0}[tabindex=\"0\"]:focus{outline:2px solid var(--pharos-color-focus);outline-offset:2px}@media only screen and (max-width: 570px){.hide-for-small{display:none !important}.show-for-small{display:inherit !important}}@media(max-width: 1024px){.hide-for-large{display:none !important}.show-for-large{display:inherit !important}.header-example__split-column{display:grid;grid-template-columns:3fr 1fr;column-gap:.5rem}}@media(max-width: 570px){.header-example__split-column{grid-template-columns:1fr 1fr}}.header-example__input-group{padding-bottom:var(--pharos-spacing-one-half-x)}.layout-example__item{background:var(--pharos-color-living-coral-80);height:3rem;display:flex;align-items:center;justify-content:center}.layout-example__column{display:flex;justify-content:center;grid-column:span 1;height:100vh;background-color:rgba(244,215,215,.6);padding-top:var(--pharos-spacing-1-x)}.layout-example__container--first{grid-column:span 8;grid-row:1;background:var(--pharos-color-glacier-blue-70);height:20rem}.layout-example__container--second{grid-column:span 8;grid-row:2;background:var(--pharos-color-glacier-blue-70);height:14.5rem}.layout-example__container--third{grid-column:span 4;grid-row:span 2;background:var(--pharos-color-glacier-blue-70);height:38rem}@media screen and (max-width: 22.5rem){.layout-example__container--first,.layout-example__container--second{grid-column:span 4}}.image-card-example__card--collection{grid-column:span 3}@media screen and (max-width: 48rem){.image-card-example__card--collection{grid-column:span 4}}.image-card-example__card--promotional{grid-column:span 4}.hide-in-storybook{border:0;clip:rect(0 0 0 0);clip-path:inset(50%);height:1px;width:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap}", "",{"version":3,"sources":["webpack://./packages/pharos-site/static/styles/global.scss","webpack://./packages/pharos/lib/utils/scss/_mixins.scss"],"names":[],"mappings":"AAGA,yBACE,iDAAA,CACA,oDAAA,CACA,cAAA,CAGF,IACE,oBAAA,CACA,iBAAA,CACA,UAAA,CACA,wBAAA,CACA,0BAAA,CACA,2BAAA,CACA,kDAAA,CAGF,yBACE,iBAAA,CACA,WAAA,CACA,wCAAA,CACA,SAAA,CACA,cAAA,CACA,eAAA,CAGF,4BACE,YAAA,CACA,qCAAA,CACA,aAAA,CACA,eAAA,CACA,kBAAA,CACA,4BAAA,CAGF,wBACE,QAAA,CAGF,kDACE,eAAA,CAGF,2BACE,YAAA,CAGF,4CACE,YAAA,CACA,0CAAA,CAGF,uBACE,SAAA,CACA,WAAA,CAEA,0BACE,kBAAA,CAIJ,aACE,UAAA,CAEA,kBACE,oCAAA,CACA,iBAAA,CACA,4EAAA,CACA,kBAAA,CAGF,yBACE,8BAAA,CACA,gCAAA,CAGF,gBACE,SAAA,CACA,+CAAA,CACA,iDAAA,CACA,8CAAA,CAGF,gBACE,kBAAA,CACA,kDAAA,CACA,uCAAA,CACA,iDAAA,CACA,qDAAA,CAGF,8BACE,qCAAA,CAGF,4BACE,WAAA,CACA,WAAA,CACA,qBAAA,CAGF,kCACE,gBAAA,CACA,eAAA,CAGF,6BACE,8CAAA,CACA,UAAA,CACA,WAAA,CACA,oBAAA,CAGF,oCACE,kBAAA,CACA,gDAAA,CACA,kBAAA,CAGF,+BACE,kBAAA,CACA,2CAAA,CACA,kBAAA,CAGF,8BACE,8CAAA,CACA,UAAA,CACA,oBAAA,CAGF,iCACE,WAAA,CACA,oBAAA,CAEA,wCACE,wCAAA,CAKN,0BACE,0CAAA,CACA,4EAAA,CAGF,oBACE,gCAAA,CACA,cAAA,CAGF,yBACE,YAAA,CACA,kBAAA,CACA,2CAAA,CAGF,oBACE,kDAAA,CAGF,0BC2OE,oBAAA,CAwBA,0CACE,oDAAA,CD5PJ,sBCmOE,oBAAA,CAUA,YAAA,CACA,cAAA,CACA,kBAAA,CAEA,0CACE,mDAR8B,CAS9B,eAAA,CA7KF,qBACE,2CAAA,CACA,kBAAA,CDhEJ,0CACE,gBACE,uBAAA,CAGF,gBACE,0BAAA,CAAA,CAIJ,0BACE,gBACE,uBAAA,CAGF,gBACE,0BAAA,CAGF,8BACE,YAAA,CACA,6BAAA,CACA,gBAAA,CAAA,CAIJ,yBACE,8BACE,6BAAA,CAAA,CAIJ,6BACE,+CAAA,CAGF,sBACE,8CAAA,CACA,WAAA,CACA,YAAA,CACA,kBAAA,CACA,sBAAA,CAGF,wBACE,YAAA,CACA,sBAAA,CACA,kBAAA,CACA,YAAA,CACA,qCAAA,CACA,qCAAA,CAGF,kCACE,kBAAA,CACA,UAAA,CACA,8CAAA,CACA,YAAA,CAGF,mCACE,kBAAA,CACA,UAAA,CACA,8CAAA,CACA,cAAA,CAGF,kCACE,kBAAA,CACA,eAAA,CACA,8CAAA,CACA,YAAA,CCwNE,uCDpNF,qEAEE,kBAAA,CAAA,CAIJ,sCACE,kBAAA,CC6ME,qCDzMF,sCACE,kBAAA,CAAA,CAIJ,uCACE,kBAAA,CAGF,mBChJE,QAAA,CACA,kBAAA,CACA,oBAAA,CACA,UAAA,CACA,SAAA,CACA,WAAA,CACA,eAAA,CACA,SAAA,CACA,iBAAA,CACA,kBAAA","sourcesContent":["@use '@ithaka/pharos/lib/styles/pharos';\n@use '@ithaka/pharos/lib/utils/scss/mixins';\n\n.pharos-storybook__image {\n  margin-top: var(--pharos-spacing-three-quarters-x);\n  margin-bottom: var(--pharos-spacing-three-quarters-x);\n  max-width: 100%;\n}\n\nkbd {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  color: #333;\n  background-color: #fcfcfc;\n  border: 0.1rem solid #e8e8e8;\n  border-bottom-color: #9c9c9c;\n  box-shadow: 0 1px 0 #9c9c9c, 0 0 0 2px #fcfcfc inset;\n}\n\n.tooltip-example__target {\n  border-radius: 50%;\n  border: none;\n  fill: var(--pharos-color-night-blue-base);\n  padding: 0;\n  cursor: pointer;\n  background: none;\n}\n\n.tooltip-example__container {\n  display: grid;\n  grid-template-columns: repeat(3, auto);\n  grid-gap: 5rem;\n  margin-top: 5rem;\n  margin-bottom: 5rem;\n  justify-content: space-evenly;\n}\n\n.alert-example__content {\n  margin: 0;\n}\n\np.alert-example__content + p.alert-example__content {\n  margin-top: 1rem;\n}\n\n.alert-example__content > li {\n  margin-top: 0;\n}\n\n.checkbox-example__container--on-background {\n  padding: 1rem;\n  background-color: var(--pharos-color-black);\n}\n\n.token-table-container {\n  width: 80%;\n  margin: auto;\n\n  h2 {\n    font-weight: normal;\n  }\n}\n\n.token-table {\n  width: 100%;\n\n  code {\n    background: var(--pharos-color-ui-20);\n    border-radius: 1px;\n    padding: var(--pharos-spacing-one-quarter-x) var(--pharos-spacing-one-half-x);\n    white-space: nowrap;\n  }\n\n  pharos-icon {\n    fill: var(--pharos-color-black);\n    stroke: var(--pharos-color-black);\n  }\n\n  th {\n    padding: 0;\n    padding-bottom: var(--pharos-spacing-one-half-x);\n    border-bottom: 1px solid var(--pharos-color-ui-30);\n    margin-bottom: var(--pharos-spacing-one-half-x);\n  }\n\n  td {\n    vertical-align: top;\n    padding-top: var(--pharos-spacing-one-and-a-half-x);\n    padding-right: var(--pharos-spacing-2-x);\n    border-bottom: 1px solid var(--pharos-color-ui-30);\n    padding-bottom: var(--pharos-spacing-one-and-a-half-x);\n  }\n\n  tr:last-child td {\n    border-bottom: 1px solid transparent;\n  }\n\n  .color-example {\n    width: 10rem;\n    height: 3rem;\n    border: 1px solid #eee;\n  }\n\n  .line-height-example {\n    max-height: 110px;\n    overflow: hidden;\n  }\n\n  .radius-example {\n    background: var(--pharos-color-living-coral-80);\n    width: 2rem;\n    height: 2rem;\n    display: inline-block;\n  }\n\n  .token-type-sans-serif {\n    line-height: normal;\n    font-family: var(--pharos-font-family-sans-serif);\n    white-space: nowrap;\n  }\n\n  .token-type-serif {\n    line-height: normal;\n    font-family: var(--pharos-font-family-serif);\n    white-space: nowrap;\n  }\n\n  .spacing-example {\n    background: var(--pharos-color-living-coral-80);\n    width: 100%;\n    display: inline-block;\n  }\n\n  .transition-example {\n    height: 3rem;\n    display: inline-block;\n\n    :hover {\n      background: var(--pharos-color-jstor-red);\n    }\n  }\n}\n\n.typography-table-example {\n  border: 1px solid var(--pharos-color-ui-40);\n  padding: var(--pharos-spacing-one-quarter-x) var(--pharos-spacing-one-half-x);\n}\n\n.icon-example__icon {\n  stroke: var(--pharos-color-black);\n  stroke-width: 0;\n}\n\n.icon-example__container {\n  display: flex;\n  align-items: center;\n  padding: var(--pharos-spacing-one-quarter-x);\n}\n\n.icon-example__name {\n  margin-left: var(--pharos-spacing-three-quarters-x);\n}\n\n.list-example__no-bullets {\n  @include pharos.no-bullet;\n}\n\n.list-example__nested {\n  @include pharos.list-nested;\n}\n\n.list-example__inline {\n  @include pharos.list-inline;\n}\n\n[tabindex='0'] {\n  @include pharos.interactive-focus;\n}\n\n@media only screen and (max-width: 570px) {\n  .hide-for-small {\n    display: none !important; /* stylelint-disable-line declaration-no-important */\n  }\n\n  .show-for-small {\n    display: inherit !important; /* stylelint-disable-line declaration-no-important */\n  }\n}\n\n@media (max-width: 1024px) {\n  .hide-for-large {\n    display: none !important; /* stylelint-disable-line declaration-no-important */\n  }\n\n  .show-for-large {\n    display: inherit !important; /* stylelint-disable-line declaration-no-important */\n  }\n\n  .header-example__split-column {\n    display: grid;\n    grid-template-columns: 3fr 1fr;\n    column-gap: 0.5rem;\n  }\n}\n\n@media (max-width: 570px) {\n  .header-example__split-column {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n.header-example__input-group {\n  padding-bottom: var(--pharos-spacing-one-half-x);\n}\n\n.layout-example__item {\n  background: var(--pharos-color-living-coral-80);\n  height: 3rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.layout-example__column {\n  display: flex;\n  justify-content: center;\n  grid-column: span 1;\n  height: 100vh;\n  background-color: rgb(244 215 215 / 0.6);\n  padding-top: var(--pharos-spacing-1-x);\n}\n\n.layout-example__container--first {\n  grid-column: span 8;\n  grid-row: 1;\n  background: var(--pharos-color-glacier-blue-70);\n  height: 20rem;\n}\n\n.layout-example__container--second {\n  grid-column: span 8;\n  grid-row: 2;\n  background: var(--pharos-color-glacier-blue-70);\n  height: 14.5rem;\n}\n\n.layout-example__container--third {\n  grid-column: span 4;\n  grid-row: span 2;\n  background: var(--pharos-color-glacier-blue-70);\n  height: 38rem;\n}\n\n@include pharos.until(small) {\n  .layout-example__container--first,\n  .layout-example__container--second {\n    grid-column: span 4;\n  }\n}\n\n.image-card-example__card--collection {\n  grid-column: span 3;\n}\n\n@include pharos.until(medium) {\n  .image-card-example__card--collection {\n    grid-column: span 4;\n  }\n}\n\n.image-card-example__card--promotional {\n  grid-column: span 4;\n}\n\n.hide-in-storybook {\n  @include mixins.hidden;\n}\n","@use 'sass:map';\n@use 'sass:list';\n@use 'sass:string';\n@use './variables';\n@use './functions';\n\n/// Base styles for inputs\n/// @access public\n/// @group form-elements\n@mixin input-base {\n  @include font-base;\n\n  margin: 0;\n  padding: var(--pharos-spacing-one-half-x) var(--pharos-spacing-three-quarters-x);\n  width: 100%;\n  display: block;\n  box-sizing: border-box;\n  border: 1px solid var(--pharos-form-element-color-border-base);\n  border-radius: var(--pharos-radius-base-standard);\n  transition: transform var(--pharos-transition-base) 0s;\n  color: var(--pharos-form-element-color-text-base);\n}\n\n/// Placeholder styles for inputs\n/// @access public\n/// @group form-elements\n@mixin input-placeholder {\n  &::placeholder {\n    color: var(--pharos-form-element-color-text-placeholder);\n    opacity: 1;\n  }\n}\n\n/// Focus styles for inputs\n/// @access public\n/// @group form-elements\n@mixin input-focus {\n  outline: none;\n  border: 2px solid var(--pharos-form-element-color-border-focus);\n  transition: transform var(--pharos-transition-base) 0s;\n}\n\n/// Wrapper styles for inputs\n/// @access public\n/// @group form-elements\n@mixin input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n/// Styles for input's invalid state\n/// @access public\n/// @group form-elements\n@mixin input-invalid {\n  border: 2px solid var(--pharos-form-element-color-border-invalid);\n}\n\n/// Styles for input's disabled state\n/// @access public\n/// @group form-elements\n@mixin input-disabled {\n  color: var(--pharos-form-element-color-text-disabled);\n  background-color: var(--pharos-form-element-color-background-disabled);\n  border-color: var(--pharos-form-element-color-background-disabled);\n  pointer-events: none;\n}\n\n/// Styles for input's required state\n/// @access public\n/// @group form-elements\n@mixin input-required {\n  &:required {\n    box-shadow: none;\n  }\n}\n\n/// Styles for input states with thicker borders\n/// @access public\n/// @group form-elements\n@mixin input-padding-thick-border {\n  padding: calc(var(--pharos-spacing-one-half-x) - 1px)\n    calc(var(--pharos-spacing-three-quarters-x) - 1px);\n}\n\n/// Styles for prominent input states with thicker borders\n/// @access public\n/// @group form-elements\n@mixin input-padding-thick-border-prominent {\n  padding: calc(var(--pharos-spacing-1-x) - 1px);\n}\n\n/// Styles for inputs on a background\n/// @access public\n/// @group form-elements\n@mixin input-on-background {\n  background-color: var(--pharos-color-marble-gray-20);\n  border-color: var(--pharos-color-marble-gray-20);\n  color: var(--pharos-color-text-white);\n  caret-color: var(--pharos-color-text-white);\n\n  &::placeholder {\n    color: var(--pharos-color-marble-gray-base);\n  }\n}\n\n/// Styles for input options\n/// @access public\n/// @group form-elements\n@mixin option-input {\n  @include hidden;\n\n  display: block;\n  box-sizing: border-box;\n}\n\n/// Wrapper styles for input options\n/// @access public\n/// @group form-elements\n@mixin option-wrapper {\n  display: inline-flex;\n  align-items: flex-start;\n  position: relative;\n}\n\n/// Styles to hide an element\n/// @access public\n/// @group interaction\n@mixin hidden {\n  border: 0;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  width: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n}\n\n/// Base styles for font.\n/// @param {string} $font-family [var(--pharos-font-family-sans-serif)] - The font family of the font\n/// @param {string} $font-size [var(--pharos-font-size-base)] - The size of the font\n/// @param {string} $font-weight [var(--pharos-font-weight-regular)] - The weight of the font\n/// @param {string} $line-height [var(--pharos-line-height-medium)] - The line height of the font\n/// @access public\n/// @group typography\n@mixin font-base(\n  $font-family: var(--pharos-font-family-sans-serif),\n  $font-size: var(--pharos-font-size-base),\n  $font-weight: var(--pharos-font-weight-regular),\n  $line-height: var(--pharos-line-height-medium)\n) {\n  @if $font-family == var(--pharos-font-family-sans-serif) {\n    @include letter-spacing-sans-serif($font-size);\n  } @else if $font-family == var(--pharos-font-family-serif) {\n    @include letter-spacing-serif($font-size);\n  } @else {\n    @error 'Unknown font-family #{$font-family}.';\n  }\n\n  font-family: $font-family;\n  font-size: $font-size;\n  font-weight: $font-weight;\n  line-height: $line-height;\n  text-rendering: optimizelegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/// Letter spacing for serif type\n/// @access public\n/// @group typography\n@mixin letter-spacing-serif($font-size: 1rem) {\n  @if $font-size != inherit {\n    letter-spacing: calc(#{$font-size} * -0.01);\n  }\n}\n\n/// Letter spacing for sans-serif type\n/// @access public\n/// @group typography\n@mixin letter-spacing-sans-serif($font-size: 1rem) {\n  @if $font-size != inherit {\n    letter-spacing: calc(#{$font-size} * -0.02);\n  }\n}\n\n/// Base styles for labels\n/// @access public\n/// @group form-elements\n@mixin label-base($margin-bottom: var(--pharos-spacing-one-quarter-x), $text-transform: uppercase) {\n  color: var(--pharos-form-element-color-text-base);\n  margin-bottom: $margin-bottom;\n  display: block;\n  padding: 0;\n  text-transform: $text-transform;\n}\n\n/// Styles for labels of form elements\n/// @access public\n/// @group form-elements\n@mixin form-element-label {\n  @include font-base(\n    $font-size: var(--pharos-form-element-size-text-label),\n    $font-weight: var(--pharos-font-weight-bold),\n    $line-height: var(--pharos-line-height-small)\n  );\n  @include label-base;\n}\n\n/// Styles for labels of grouped form elements\n/// @access public\n/// @group form-elements\n@mixin groupable-element-label {\n  @include font-base;\n  @include label-base($margin-bottom: 0, $text-transform: none);\n\n  padding-left: var(--pharos-spacing-one-quarter-x);\n}\n\n/// Styles for icon buttons.\n/// @access public\n/// @group buttons\n@mixin icon-button {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-sizing: border-box;\n  background: none;\n  margin: 0;\n}\n\n/// Focus styles for most interactive components.\n/// @access public\n/// @group interaction\n@mixin interactive-focus {\n  &:focus {\n    outline: 2px solid var(--pharos-color-focus);\n    outline-offset: 2px;\n  }\n}\n\n/// Base styles for buttons.\n/// @param {string} $color [var(--pharos-button-color-base-primary-text-base)] - The color of the text\n/// @param {string} $background-color [vvar(--pharos-button-color-base-primary-background-base)] - The color of the background\n/// @param {string} $border-color [var(--pharos-button-color-base-primary-border-base)] - The color of the border\n/// @access public\n/// @group buttons\n@mixin button-base(\n  $color: var(--pharos-button-color-base-primary-text-base),\n  $background-color: var(--pharos-button-color-base-primary-background-base),\n  $border-color: var(--pharos-button-color-base-primary-border-base)\n) {\n  @include font-base($font-weight: var(--pharos-font-weight-bold));\n  @include transition-base(border-color, background, color);\n\n  color: $color;\n  background-color: $background-color;\n  border: 1px solid $border-color;\n  padding: var(--pharos-spacing-one-quarter-x) var(--pharos-spacing-three-quarters-x);\n  border-radius: var(--pharos-radius-base-standard);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  appearance: none;\n\n  [data-pharos-component='PharosIcon'] {\n    @include transition-base(fill, stroke);\n\n    fill: $color;\n    stroke: $color;\n    stroke-width: 0;\n  }\n\n  [data-pharos-component='PharosIcon']:first-child:not(:only-child) {\n    margin-right: var(--pharos-spacing-one-quarter-x);\n  }\n\n  [data-pharos-component='PharosIcon']:last-child:not(:only-child) {\n    margin-left: var(--pharos-spacing-one-quarter-x);\n  }\n}\n\n/// Hover styles for buttons.\n/// @param {string} $color [var(--pharos-button-color-base-primary-text-hover)] - The color of the text\n/// @param {string} $background-color [var(--pharos-button-color-base-primary-background-hover)] - The color of the background\n/// @param {string} $border-color [var(--pharos-button-color-base-primary-border-hover)] - The color of the border\n/// @access public\n/// @group buttons\n@mixin button-hover(\n  $color: var(--pharos-button-color-base-primary-text-hover),\n  $background-color: var(--pharos-button-color-base-primary-background-hover),\n  $border-color: var(--pharos-button-color-base-primary-border-hover)\n) {\n  &:hover:not([disabled]),\n  &:active:not([disabled]) {\n    color: $color;\n    background-color: $background-color;\n    border: 2px solid $border-color;\n    padding: calc(var(--pharos-spacing-one-quarter-x) - 1px)\n      calc(var(--pharos-spacing-three-quarters-x) - 1px);\n\n    [data-pharos-component='PharosIcon'] {\n      fill: $color;\n      stroke: $color;\n    }\n  }\n}\n\n/// Styles for large buttons.\n/// @access public\n/// @group buttons\n@mixin button-large {\n  padding: var(--pharos-spacing-one-half-x) var(--pharos-spacing-three-quarters-x);\n\n  &:hover:not([disabled]),\n  &:active:not([disabled]) {\n    padding: calc(var(--pharos-spacing-one-half-x) - 1px)\n      calc(var(--pharos-spacing-three-quarters-x) - 1px);\n  }\n}\n\n/// Color styles for buttons.\n/// @param {string} $color [var(--pharos-button-color-base-primary-text-base)] - The color of the text\n/// @param {string} $background-color [var(--pharos-button-color-base-primary-background-base)] - The color of the background\n/// @param {string} $border-color [var(--pharos-button-color-base-primary-border-base)] - The color of the border\n/// @access public\n/// @group buttons\n@mixin button-color(\n  $color: var(--pharos-button-color-base-primary-text-base),\n  $background-color: var(--pharos-button-color-base-primary-background-base),\n  $border-color: var(--pharos-button-color-base-primary-border-base)\n) {\n  color: $color;\n  background-color: $background-color;\n  border-color: $border-color;\n\n  [data-pharos-component='PharosIcon'] {\n    fill: $color;\n    stroke: $color;\n  }\n}\n\n/// Base styles for links.\n/// @access public\n/// @group links\n@mixin link-base {\n  @include font-base($font-size: inherit, $line-height: inherit);\n  @include underline;\n\n  letter-spacing: inherit;\n  color: var(--pharos-color-interactive-secondary);\n  transition-property: color, text-decoration-color;\n  transition-duration: 200ms;\n  transition-timing-function: ease-in-out;\n}\n\n/// Hover style for links.\n/// @access public\n/// @group links\n@mixin link-hover {\n  &:hover {\n    @include no-underline;\n\n    color: var(--pharos-color-hover-primary);\n  }\n}\n\n/// Base styles for underlines.\n/// @param {string} $text-decoration-color [var(--pharos-color-interactive-secondary)] - The color of the underline\n/// @access public\n/// @group links\n@mixin underline($text-decoration-color: var(--pharos-color-interactive-secondary)) {\n  text-decoration: underline;\n  text-decoration-color: $text-decoration-color;\n}\n\n/* stylelint-disable declaration-block-no-redundant-longhand-properties */\n/// Removes underlines.\n/// @access public\n/// @group links\n@mixin no-underline {\n  text-decoration-style: solid;\n  text-decoration-line: underline;\n  text-decoration-color: transparent;\n}\n\n/// Removes bullets from lists.\n/// @access public\n/// @group typography\n@mixin no-bullet {\n  list-style-type: none;\n}\n\n/// Base styles for inline lists.\n/// @param {string} $margin-right [var(--pharos-spacing-one-and-a-half-x)] - The margin between list items\n/// @access public\n/// @group typography\n@mixin list-inline($margin-right: var(--pharos-spacing-one-and-a-half-x)) {\n  @include no-bullet;\n\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n\n  li:not(:last-child) {\n    margin-right: $margin-right;\n    margin-bottom: 0;\n  }\n}\n\n/// Base style for nested lists.\n/// @access public\n/// @group typography\n@mixin list-nested {\n  > li:not(:last-child) {\n    margin-bottom: var(--pharos-spacing-three-quarters-x);\n  }\n}\n\n/// Base styles for transitions.\n/// @param {string} $properties - The transition properties to style\n/// @access public\n/// @group interaction\n@mixin transition-base($properties...) {\n  transition-property: $properties;\n  transition-duration: var(--pharos-transition-duration-default);\n  transition-timing-function: ease-in-out;\n}\n\n/// Base styles for content labels.\n/// @access public\n/// @group typography\n@mixin content-label($args...) {\n  @include form-element-label($args...);\n}\n\n/// Creates a media query that starts at the passed breakpoint.\n/// @param {string} $breakpoint - The breakpoint to use as the minimum\n/// @access public\n/// @group layout\n@mixin at-least($breakpoint) {\n  @if map-has-key(variables.$breakpoints, $breakpoint) {\n    $width: map.get(variables.$breakpoints, $breakpoint, width);\n    @media screen and (min-width: $width) {\n      @content;\n    }\n  } @else {\n    @error 'Unknown breakpoint `#{$breakpoint}`. ' + 'Available breakpoints are: #{map.keys(variables.$breakpoints)}.';\n  }\n}\n\n/// Creates a media query that ranges up to the passed breakpoint.\n/// @param {string} $breakpoint - The breakpoint to use as the maximum\n/// @access public\n/// @group layout\n@mixin until($breakpoint) {\n  @if map-has-key(variables.$breakpoints, $breakpoint) {\n    $width: map.get(variables.$breakpoints, $breakpoint, width);\n    @media screen and (max-width: $width) {\n      @content;\n    }\n  } @else {\n    @error 'Unknown breakpoint `#{$breakpoint}`. ' + 'Available breakpoints are: #{map.keys(variables.$breakpoints)}.';\n  }\n}\n\n/// Creates a media query that ranges between the two passed breakpoints.\n/// @param {string} $lower - The breakpoint to use as the lower bounds\n/// @param {string} $upper - The breakpoint to use as the upper bounds\n/// @access public\n/// @group layout\n@mixin between($lower, $upper) {\n  @if map-has-key(variables.$breakpoints, $lower) and map-has-key(variables.$breakpoints, $upper) {\n    $lower-width: functions.calculate-px(map.get(variables.$breakpoints, $lower, width));\n    $upper-width: functions.calculate-px(map.get(variables.$breakpoints, $upper, width));\n    @media screen and (min-width: $lower-width) and (max-width: $upper-width - 1) {\n      @content;\n    }\n  } @else {\n    @error 'Unknown breakpoint range `#{$lower}` - `#{$upper}`. ' + 'Available breakpoints are: #{map.keys(variables.$breakpoints)}.';\n  }\n}\n\n/// Base style for the layout's outer grid.\n/// @access public\n/// @group layout\n@mixin layout-base {\n  display: grid;\n  grid-template-areas: '. content .';\n}\n\n/// Base style for the layout's inner grid.\n/// @access public\n/// @group layout\n@mixin layout-content {\n  display: grid;\n  grid-area: content;\n  grid-template-columns: repeat(map.get(variables.$breakpoints, large, columns), 1fr);\n  grid-template-rows: auto;\n  column-gap: var(--pharos-spacing-gutter);\n  padding: 0;\n  margin: 0;\n  list-style: none;\n\n  @include until(medium) {\n    grid-template-columns: repeat(map.get(variables.$breakpoints, medium, columns), 1fr);\n    grid-template-rows: auto;\n  }\n\n  @include until(small) {\n    grid-template-columns: repeat(map.get(variables.$breakpoints, small, columns), 1fr);\n    grid-template-rows: auto;\n  }\n}\n\n/// Sets margins for the layout's outer grid.\n/// @param {string} $layout - The layout preset\n/// @access public\n/// @group layout\n@mixin layout-base-columns($layout) {\n  $breakpoints: map.get(variables.$layouts, $layout);\n  $fixed-margin: $layout != '1-col';\n\n  @each $breakpoint, $margin in $breakpoints {\n    $i: list.index($breakpoints, $breakpoint $margin);\n\n    @if $i != length($breakpoints) {\n      $upper: list.nth(map.keys($breakpoints), $i + 1);\n      $max-margin: list.nth(map.values($breakpoints), $i + 1);\n\n      @include between($breakpoint, $upper) {\n        $layout-margin: if($fixed-margin, $margin, minmax($margin, $max-margin));\n\n        grid-template-columns: $layout-margin auto $layout-margin;\n        grid-template-rows: auto;\n      }\n    } @else {\n      @include at-least($breakpoint) {\n        grid-template-columns: minmax($margin, 1fr) auto minmax($margin, 1fr);\n        grid-template-rows: auto;\n      }\n    }\n  }\n}\n\n/// Sets widths for the layout's inner grid.\n/// @param {string} $layout - The layout preset\n/// @access public\n/// @group layout\n@mixin layout-content-width($layout) {\n  $breakpoints: map.get(variables.$layouts, $layout);\n  $fixed-width: $layout == '1-col';\n  $property: if($fixed-width, width, min-width);\n\n  @if $fixed-width {\n    @include at-least(medium) {\n      margin: auto;\n    }\n  }\n\n  @each $breakpoint, $margin in $breakpoints {\n    $i: list.index($breakpoints, $breakpoint $margin);\n\n    @if $i == 1 {\n      @include until($breakpoint) {\n        #{$property}: functions.content-width(\n          map.get(variables.$breakpoints, $breakpoint, width),\n          $margin\n        );\n      }\n    } @else if $i != length($breakpoints) {\n      $upper: list.nth(map.keys($breakpoints), $i + 1);\n\n      @include between($breakpoint, $upper) {\n        #{$property}: functions.content-width(\n          map.get(variables.$breakpoints, $breakpoint, width),\n          $margin,\n          $sidenav: string.index($layout, '--sidenav') and $i > 2\n        );\n      }\n    } @else {\n      @include at-least($breakpoint) {\n        #{$property}: functions.content-width(\n          map.get(variables.$breakpoints, $breakpoint, width),\n          $margin,\n          $sidenav: string.index($layout, '--sidenav')\n        );\n      }\n    }\n  }\n}\n\n/// Truncates text based on number of lines.\n/// @param {number} $lines [1] - The number of lines allowed before truncating\n/// @access public\n/// @group typography\n@mixin truncate-text($lines: 1) {\n  overflow: hidden;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  white-space: normal;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[12].use[1]!./node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[12].use[2]!./packages/pharos/lib/styles/typography.scss":
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html{font-size:100%}body{letter-spacing:calc(var(--pharos-font-size-base) * -0.02);font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-font-size-base);font-weight:var(--pharos-font-weight-regular);line-height:var(--pharos-line-height-medium);text-rendering:optimizelegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}button,input,optgroup,select,textarea{letter-spacing:calc(var(--pharos-font-size-base) * -0.02);font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-font-size-base);font-weight:var(--pharos-font-weight-regular);line-height:var(--pharos-line-height-medium);text-rendering:optimizelegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}th{letter-spacing:calc(var(--pharos-form-element-size-text-label) * -0.02);font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-form-element-size-text-label);font-weight:var(--pharos-font-weight-bold);line-height:var(--pharos-line-height-small);text-rendering:optimizelegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:var(--pharos-form-element-color-text-base);margin-bottom:var(--pharos-spacing-one-quarter-x);display:block;padding:0;text-transform:uppercase;display:table-cell;text-align:left;padding:var(--pharos-spacing-one-quarter-x) var(--pharos-spacing-one-half-x)}small{font-size:var(--pharos-font-size-small)}ol li:not(:last-child),ul li:not(:last-child){margin-bottom:var(--pharos-spacing-one-quarter-x)}", "",{"version":3,"sources":["webpack://./packages/pharos/lib/styles/typography.scss","webpack://./packages/pharos/lib/utils/scss/_mixins.scss"],"names":[],"mappings":"AAEA,KACE,cAAA,CAGF,KCoLI,yDAAA,CAvBF,gDAbc,CAcd,sCAbY,CAcZ,6CAbc,CAcd,4CAbc,CAcd,iCAAA,CACA,kCAAA,CACA,iCAAA,CD/JF,sCCgLI,yDAAA,CAvBF,gDAbc,CAcd,sCAbY,CAcZ,6CAbc,CAcd,4CAbc,CAcd,iCAAA,CACA,kCAAA,CACA,iCAAA,CDvJF,GCwKI,uEAAA,CAvBF,gDAbc,CAcd,oDA0Cc,CAzCd,0CA0CgB,CAzChB,2CA0CgB,CAzChB,iCAAA,CACA,kCAAA,CACA,iCAAA,CAyBA,gDAAA,CACA,iDAFgC,CAGhC,aAAA,CACA,SAAA,CACA,wBALsF,CD5KtF,kBAAA,CACA,eAAA,CACA,4EAAA,CAGF,MACE,uCAAA,CAKA,8CACE,iDAAA","sourcesContent":["@use '../utils/scss/mixins';\n\nhtml {\n  font-size: 100%;\n}\n\nbody {\n  @include mixins.font-base;\n}\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  @include mixins.font-base;\n}\n\nth {\n  @include mixins.form-element-label;\n\n  display: table-cell;\n  text-align: left;\n  padding: var(--pharos-spacing-one-quarter-x) var(--pharos-spacing-one-half-x);\n}\n\nsmall {\n  font-size: var(--pharos-font-size-small);\n}\n\nol,\nul {\n  li:not(:last-child) {\n    margin-bottom: var(--pharos-spacing-one-quarter-x);\n  }\n}\n","@use 'sass:map';\n@use 'sass:list';\n@use 'sass:string';\n@use './variables';\n@use './functions';\n\n/// Base styles for inputs\n/// @access public\n/// @group form-elements\n@mixin input-base {\n  @include font-base;\n\n  margin: 0;\n  padding: var(--pharos-spacing-one-half-x) var(--pharos-spacing-three-quarters-x);\n  width: 100%;\n  display: block;\n  box-sizing: border-box;\n  border: 1px solid var(--pharos-form-element-color-border-base);\n  border-radius: var(--pharos-radius-base-standard);\n  transition: transform var(--pharos-transition-base) 0s;\n  color: var(--pharos-form-element-color-text-base);\n}\n\n/// Placeholder styles for inputs\n/// @access public\n/// @group form-elements\n@mixin input-placeholder {\n  &::placeholder {\n    color: var(--pharos-form-element-color-text-placeholder);\n    opacity: 1;\n  }\n}\n\n/// Focus styles for inputs\n/// @access public\n/// @group form-elements\n@mixin input-focus {\n  outline: none;\n  border: 2px solid var(--pharos-form-element-color-border-focus);\n  transition: transform var(--pharos-transition-base) 0s;\n}\n\n/// Wrapper styles for inputs\n/// @access public\n/// @group form-elements\n@mixin input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n/// Styles for input's invalid state\n/// @access public\n/// @group form-elements\n@mixin input-invalid {\n  border: 2px solid var(--pharos-form-element-color-border-invalid);\n}\n\n/// Styles for input's disabled state\n/// @access public\n/// @group form-elements\n@mixin input-disabled {\n  color: var(--pharos-form-element-color-text-disabled);\n  background-color: var(--pharos-form-element-color-background-disabled);\n  border-color: var(--pharos-form-element-color-background-disabled);\n  pointer-events: none;\n}\n\n/// Styles for input's required state\n/// @access public\n/// @group form-elements\n@mixin input-required {\n  &:required {\n    box-shadow: none;\n  }\n}\n\n/// Styles for input states with thicker borders\n/// @access public\n/// @group form-elements\n@mixin input-padding-thick-border {\n  padding: calc(var(--pharos-spacing-one-half-x) - 1px)\n    calc(var(--pharos-spacing-three-quarters-x) - 1px);\n}\n\n/// Styles for prominent input states with thicker borders\n/// @access public\n/// @group form-elements\n@mixin input-padding-thick-border-prominent {\n  padding: calc(var(--pharos-spacing-1-x) - 1px);\n}\n\n/// Styles for inputs on a background\n/// @access public\n/// @group form-elements\n@mixin input-on-background {\n  background-color: var(--pharos-color-marble-gray-20);\n  border-color: var(--pharos-color-marble-gray-20);\n  color: var(--pharos-color-text-white);\n  caret-color: var(--pharos-color-text-white);\n\n  &::placeholder {\n    color: var(--pharos-color-marble-gray-base);\n  }\n}\n\n/// Styles for input options\n/// @access public\n/// @group form-elements\n@mixin option-input {\n  @include hidden;\n\n  display: block;\n  box-sizing: border-box;\n}\n\n/// Wrapper styles for input options\n/// @access public\n/// @group form-elements\n@mixin option-wrapper {\n  display: inline-flex;\n  align-items: flex-start;\n  position: relative;\n}\n\n/// Styles to hide an element\n/// @access public\n/// @group interaction\n@mixin hidden {\n  border: 0;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  width: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n}\n\n/// Base styles for font.\n/// @param {string} $font-family [var(--pharos-font-family-sans-serif)] - The font family of the font\n/// @param {string} $font-size [var(--pharos-font-size-base)] - The size of the font\n/// @param {string} $font-weight [var(--pharos-font-weight-regular)] - The weight of the font\n/// @param {string} $line-height [var(--pharos-line-height-medium)] - The line height of the font\n/// @access public\n/// @group typography\n@mixin font-base(\n  $font-family: var(--pharos-font-family-sans-serif),\n  $font-size: var(--pharos-font-size-base),\n  $font-weight: var(--pharos-font-weight-regular),\n  $line-height: var(--pharos-line-height-medium)\n) {\n  @if $font-family == var(--pharos-font-family-sans-serif) {\n    @include letter-spacing-sans-serif($font-size);\n  } @else if $font-family == var(--pharos-font-family-serif) {\n    @include letter-spacing-serif($font-size);\n  } @else {\n    @error 'Unknown font-family #{$font-family}.';\n  }\n\n  font-family: $font-family;\n  font-size: $font-size;\n  font-weight: $font-weight;\n  line-height: $line-height;\n  text-rendering: optimizelegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/// Letter spacing for serif type\n/// @access public\n/// @group typography\n@mixin letter-spacing-serif($font-size: 1rem) {\n  @if $font-size != inherit {\n    letter-spacing: calc(#{$font-size} * -0.01);\n  }\n}\n\n/// Letter spacing for sans-serif type\n/// @access public\n/// @group typography\n@mixin letter-spacing-sans-serif($font-size: 1rem) {\n  @if $font-size != inherit {\n    letter-spacing: calc(#{$font-size} * -0.02);\n  }\n}\n\n/// Base styles for labels\n/// @access public\n/// @group form-elements\n@mixin label-base($margin-bottom: var(--pharos-spacing-one-quarter-x), $text-transform: uppercase) {\n  color: var(--pharos-form-element-color-text-base);\n  margin-bottom: $margin-bottom;\n  display: block;\n  padding: 0;\n  text-transform: $text-transform;\n}\n\n/// Styles for labels of form elements\n/// @access public\n/// @group form-elements\n@mixin form-element-label {\n  @include font-base(\n    $font-size: var(--pharos-form-element-size-text-label),\n    $font-weight: var(--pharos-font-weight-bold),\n    $line-height: var(--pharos-line-height-small)\n  );\n  @include label-base;\n}\n\n/// Styles for labels of grouped form elements\n/// @access public\n/// @group form-elements\n@mixin groupable-element-label {\n  @include font-base;\n  @include label-base($margin-bottom: 0, $text-transform: none);\n\n  padding-left: var(--pharos-spacing-one-quarter-x);\n}\n\n/// Styles for icon buttons.\n/// @access public\n/// @group buttons\n@mixin icon-button {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-sizing: border-box;\n  background: none;\n  margin: 0;\n}\n\n/// Focus styles for most interactive components.\n/// @access public\n/// @group interaction\n@mixin interactive-focus {\n  &:focus {\n    outline: 2px solid var(--pharos-color-focus);\n    outline-offset: 2px;\n  }\n}\n\n/// Base styles for buttons.\n/// @param {string} $color [var(--pharos-button-color-base-primary-text-base)] - The color of the text\n/// @param {string} $background-color [vvar(--pharos-button-color-base-primary-background-base)] - The color of the background\n/// @param {string} $border-color [var(--pharos-button-color-base-primary-border-base)] - The color of the border\n/// @access public\n/// @group buttons\n@mixin button-base(\n  $color: var(--pharos-button-color-base-primary-text-base),\n  $background-color: var(--pharos-button-color-base-primary-background-base),\n  $border-color: var(--pharos-button-color-base-primary-border-base)\n) {\n  @include font-base($font-weight: var(--pharos-font-weight-bold));\n  @include transition-base(border-color, background, color);\n\n  color: $color;\n  background-color: $background-color;\n  border: 1px solid $border-color;\n  padding: var(--pharos-spacing-one-quarter-x) var(--pharos-spacing-three-quarters-x);\n  border-radius: var(--pharos-radius-base-standard);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  appearance: none;\n\n  [data-pharos-component='PharosIcon'] {\n    @include transition-base(fill, stroke);\n\n    fill: $color;\n    stroke: $color;\n    stroke-width: 0;\n  }\n\n  [data-pharos-component='PharosIcon']:first-child:not(:only-child) {\n    margin-right: var(--pharos-spacing-one-quarter-x);\n  }\n\n  [data-pharos-component='PharosIcon']:last-child:not(:only-child) {\n    margin-left: var(--pharos-spacing-one-quarter-x);\n  }\n}\n\n/// Hover styles for buttons.\n/// @param {string} $color [var(--pharos-button-color-base-primary-text-hover)] - The color of the text\n/// @param {string} $background-color [var(--pharos-button-color-base-primary-background-hover)] - The color of the background\n/// @param {string} $border-color [var(--pharos-button-color-base-primary-border-hover)] - The color of the border\n/// @access public\n/// @group buttons\n@mixin button-hover(\n  $color: var(--pharos-button-color-base-primary-text-hover),\n  $background-color: var(--pharos-button-color-base-primary-background-hover),\n  $border-color: var(--pharos-button-color-base-primary-border-hover)\n) {\n  &:hover:not([disabled]),\n  &:active:not([disabled]) {\n    color: $color;\n    background-color: $background-color;\n    border: 2px solid $border-color;\n    padding: calc(var(--pharos-spacing-one-quarter-x) - 1px)\n      calc(var(--pharos-spacing-three-quarters-x) - 1px);\n\n    [data-pharos-component='PharosIcon'] {\n      fill: $color;\n      stroke: $color;\n    }\n  }\n}\n\n/// Styles for large buttons.\n/// @access public\n/// @group buttons\n@mixin button-large {\n  padding: var(--pharos-spacing-one-half-x) var(--pharos-spacing-three-quarters-x);\n\n  &:hover:not([disabled]),\n  &:active:not([disabled]) {\n    padding: calc(var(--pharos-spacing-one-half-x) - 1px)\n      calc(var(--pharos-spacing-three-quarters-x) - 1px);\n  }\n}\n\n/// Color styles for buttons.\n/// @param {string} $color [var(--pharos-button-color-base-primary-text-base)] - The color of the text\n/// @param {string} $background-color [var(--pharos-button-color-base-primary-background-base)] - The color of the background\n/// @param {string} $border-color [var(--pharos-button-color-base-primary-border-base)] - The color of the border\n/// @access public\n/// @group buttons\n@mixin button-color(\n  $color: var(--pharos-button-color-base-primary-text-base),\n  $background-color: var(--pharos-button-color-base-primary-background-base),\n  $border-color: var(--pharos-button-color-base-primary-border-base)\n) {\n  color: $color;\n  background-color: $background-color;\n  border-color: $border-color;\n\n  [data-pharos-component='PharosIcon'] {\n    fill: $color;\n    stroke: $color;\n  }\n}\n\n/// Base styles for links.\n/// @access public\n/// @group links\n@mixin link-base {\n  @include font-base($font-size: inherit, $line-height: inherit);\n  @include underline;\n\n  letter-spacing: inherit;\n  color: var(--pharos-color-interactive-secondary);\n  transition-property: color, text-decoration-color;\n  transition-duration: 200ms;\n  transition-timing-function: ease-in-out;\n}\n\n/// Hover style for links.\n/// @access public\n/// @group links\n@mixin link-hover {\n  &:hover {\n    @include no-underline;\n\n    color: var(--pharos-color-hover-primary);\n  }\n}\n\n/// Base styles for underlines.\n/// @param {string} $text-decoration-color [var(--pharos-color-interactive-secondary)] - The color of the underline\n/// @access public\n/// @group links\n@mixin underline($text-decoration-color: var(--pharos-color-interactive-secondary)) {\n  text-decoration: underline;\n  text-decoration-color: $text-decoration-color;\n}\n\n/* stylelint-disable declaration-block-no-redundant-longhand-properties */\n/// Removes underlines.\n/// @access public\n/// @group links\n@mixin no-underline {\n  text-decoration-style: solid;\n  text-decoration-line: underline;\n  text-decoration-color: transparent;\n}\n\n/// Removes bullets from lists.\n/// @access public\n/// @group typography\n@mixin no-bullet {\n  list-style-type: none;\n}\n\n/// Base styles for inline lists.\n/// @param {string} $margin-right [var(--pharos-spacing-one-and-a-half-x)] - The margin between list items\n/// @access public\n/// @group typography\n@mixin list-inline($margin-right: var(--pharos-spacing-one-and-a-half-x)) {\n  @include no-bullet;\n\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n\n  li:not(:last-child) {\n    margin-right: $margin-right;\n    margin-bottom: 0;\n  }\n}\n\n/// Base style for nested lists.\n/// @access public\n/// @group typography\n@mixin list-nested {\n  > li:not(:last-child) {\n    margin-bottom: var(--pharos-spacing-three-quarters-x);\n  }\n}\n\n/// Base styles for transitions.\n/// @param {string} $properties - The transition properties to style\n/// @access public\n/// @group interaction\n@mixin transition-base($properties...) {\n  transition-property: $properties;\n  transition-duration: var(--pharos-transition-duration-default);\n  transition-timing-function: ease-in-out;\n}\n\n/// Base styles for content labels.\n/// @access public\n/// @group typography\n@mixin content-label($args...) {\n  @include form-element-label($args...);\n}\n\n/// Creates a media query that starts at the passed breakpoint.\n/// @param {string} $breakpoint - The breakpoint to use as the minimum\n/// @access public\n/// @group layout\n@mixin at-least($breakpoint) {\n  @if map-has-key(variables.$breakpoints, $breakpoint) {\n    $width: map.get(variables.$breakpoints, $breakpoint, width);\n    @media screen and (min-width: $width) {\n      @content;\n    }\n  } @else {\n    @error 'Unknown breakpoint `#{$breakpoint}`. ' + 'Available breakpoints are: #{map.keys(variables.$breakpoints)}.';\n  }\n}\n\n/// Creates a media query that ranges up to the passed breakpoint.\n/// @param {string} $breakpoint - The breakpoint to use as the maximum\n/// @access public\n/// @group layout\n@mixin until($breakpoint) {\n  @if map-has-key(variables.$breakpoints, $breakpoint) {\n    $width: map.get(variables.$breakpoints, $breakpoint, width);\n    @media screen and (max-width: $width) {\n      @content;\n    }\n  } @else {\n    @error 'Unknown breakpoint `#{$breakpoint}`. ' + 'Available breakpoints are: #{map.keys(variables.$breakpoints)}.';\n  }\n}\n\n/// Creates a media query that ranges between the two passed breakpoints.\n/// @param {string} $lower - The breakpoint to use as the lower bounds\n/// @param {string} $upper - The breakpoint to use as the upper bounds\n/// @access public\n/// @group layout\n@mixin between($lower, $upper) {\n  @if map-has-key(variables.$breakpoints, $lower) and map-has-key(variables.$breakpoints, $upper) {\n    $lower-width: functions.calculate-px(map.get(variables.$breakpoints, $lower, width));\n    $upper-width: functions.calculate-px(map.get(variables.$breakpoints, $upper, width));\n    @media screen and (min-width: $lower-width) and (max-width: $upper-width - 1) {\n      @content;\n    }\n  } @else {\n    @error 'Unknown breakpoint range `#{$lower}` - `#{$upper}`. ' + 'Available breakpoints are: #{map.keys(variables.$breakpoints)}.';\n  }\n}\n\n/// Base style for the layout's outer grid.\n/// @access public\n/// @group layout\n@mixin layout-base {\n  display: grid;\n  grid-template-areas: '. content .';\n}\n\n/// Base style for the layout's inner grid.\n/// @access public\n/// @group layout\n@mixin layout-content {\n  display: grid;\n  grid-area: content;\n  grid-template-columns: repeat(map.get(variables.$breakpoints, large, columns), 1fr);\n  grid-template-rows: auto;\n  column-gap: var(--pharos-spacing-gutter);\n  padding: 0;\n  margin: 0;\n  list-style: none;\n\n  @include until(medium) {\n    grid-template-columns: repeat(map.get(variables.$breakpoints, medium, columns), 1fr);\n    grid-template-rows: auto;\n  }\n\n  @include until(small) {\n    grid-template-columns: repeat(map.get(variables.$breakpoints, small, columns), 1fr);\n    grid-template-rows: auto;\n  }\n}\n\n/// Sets margins for the layout's outer grid.\n/// @param {string} $layout - The layout preset\n/// @access public\n/// @group layout\n@mixin layout-base-columns($layout) {\n  $breakpoints: map.get(variables.$layouts, $layout);\n  $fixed-margin: $layout != '1-col';\n\n  @each $breakpoint, $margin in $breakpoints {\n    $i: list.index($breakpoints, $breakpoint $margin);\n\n    @if $i != length($breakpoints) {\n      $upper: list.nth(map.keys($breakpoints), $i + 1);\n      $max-margin: list.nth(map.values($breakpoints), $i + 1);\n\n      @include between($breakpoint, $upper) {\n        $layout-margin: if($fixed-margin, $margin, minmax($margin, $max-margin));\n\n        grid-template-columns: $layout-margin auto $layout-margin;\n        grid-template-rows: auto;\n      }\n    } @else {\n      @include at-least($breakpoint) {\n        grid-template-columns: minmax($margin, 1fr) auto minmax($margin, 1fr);\n        grid-template-rows: auto;\n      }\n    }\n  }\n}\n\n/// Sets widths for the layout's inner grid.\n/// @param {string} $layout - The layout preset\n/// @access public\n/// @group layout\n@mixin layout-content-width($layout) {\n  $breakpoints: map.get(variables.$layouts, $layout);\n  $fixed-width: $layout == '1-col';\n  $property: if($fixed-width, width, min-width);\n\n  @if $fixed-width {\n    @include at-least(medium) {\n      margin: auto;\n    }\n  }\n\n  @each $breakpoint, $margin in $breakpoints {\n    $i: list.index($breakpoints, $breakpoint $margin);\n\n    @if $i == 1 {\n      @include until($breakpoint) {\n        #{$property}: functions.content-width(\n          map.get(variables.$breakpoints, $breakpoint, width),\n          $margin\n        );\n      }\n    } @else if $i != length($breakpoints) {\n      $upper: list.nth(map.keys($breakpoints), $i + 1);\n\n      @include between($breakpoint, $upper) {\n        #{$property}: functions.content-width(\n          map.get(variables.$breakpoints, $breakpoint, width),\n          $margin,\n          $sidenav: string.index($layout, '--sidenav') and $i > 2\n        );\n      }\n    } @else {\n      @include at-least($breakpoint) {\n        #{$property}: functions.content-width(\n          map.get(variables.$breakpoints, $breakpoint, width),\n          $margin,\n          $sidenav: string.index($layout, '--sidenav')\n        );\n      }\n    }\n  }\n}\n\n/// Truncates text based on number of lines.\n/// @param {number} $lines [1] - The number of lines allowed before truncating\n/// @access public\n/// @group typography\n@mixin truncate-text($lines: 1) {\n  overflow: hidden;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  white-space: normal;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[12].use[1]!./node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[12].use[2]!./packages/pharos/src/pages/home/home.scss":
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".home-page__container{display:grid;grid-template-areas:\"header\" \"main\" \"footer\"}.home-page__container .header-revised__container{grid-area:header}.home-page__container main{grid-area:main}.home-page__container pharos-footer{grid-area:footer}.home-page__container--main-content{display:grid;grid-template-areas:\". top .\" \"hero hero hero\" \". content .\";margin-bottom:10rem}.home-page__hero{grid-area:hero;height:381px;background-position:center;background-repeat:no-repeat;background-size:cover;position:relative;margin-top:4.75rem;margin-bottom:var(--pharos-spacing-three-quarters-x)}.home-page__heading{margin-top:3.75rem}.home-page__container--top{grid-area:top}.home-page__hero-link{grid-column:span 12}.home-page__collection-card--open{grid-column:span 6}.home-page__collection-card--community{grid-column:span 3}.home-page__container--access{grid-column:span 12;border-bottom:1px solid var(--pharos-color-ui-30);border-top:1px solid var(--pharos-color-ui-30);padding:var(--pharos-spacing-3-x) 0;display:grid;grid-template-columns:1fr 12rem;column-gap:12rem}.home-page__list--access{list-style-type:none;padding-left:0;margin:0}.home-page__list--access li:not(:last-child){margin-bottom:var(--pharos-spacing-1-x)}.home-page__image--collection{margin-bottom:var(--pharos-spacing-1-x)}.home-page__input{padding:var(--pharos-spacing-1-x) var(--pharos-spacing-1-x) var(--pharos-spacing-1-x) 4rem;border:1px solid var(--pharos-color-ui-50);box-sizing:border-box;border-radius:var(--pharos-radius-base-standard);font-size:var(--pharos-font-size-large);width:50rem;box-shadow:0 4px 6px 0 rgba(0,0,0,.32)}.home-page__input:focus{outline:none;border:2px solid var(--pharos-form-element-color-border-focus);transition:transform var(--pharos-transition-base) 0s;padding:calc(var(--pharos-spacing-1-x) - 1px) calc(var(--pharos-spacing-1-x) - 1px) calc(var(--pharos-spacing-1-x) - 1px) calc(4rem - 1px)}.home-page__container--input{position:absolute;top:10rem;display:flex;align-items:center;width:50rem;z-index:1}.home-page__icon--search{position:absolute;left:var(--pharos-spacing-one-and-a-half-x);top:50%;transform:translateY(-50%)}@media screen and (min-width: 360px)and (max-width: 767px){.home-page__collection-card--open{grid-column:span 6}.home-page__collection-card--community{grid-column:span 6}.home-page__container--input{display:none}}@media screen and (min-width: 768px)and (max-width: 1055px){.home-page__collection-card--open{grid-column:span 6}.home-page__collection-card--community{grid-column:span 3}.home-page__input,.home-page__container--input{width:42rem}}@media screen and (max-width: 48rem){.home-page__hero-link{grid-column:span 8}.home-page__collection-card--open{grid-column:span 8}.home-page__collection-card--community{grid-column:span 4}.home-page__container--access{grid-column:span 8;column-gap:var(--pharos-spacing-3-x)}.home-page__hero{background-position:right}}@media screen and (max-width: 22.5rem){.home-page__hero-link{grid-column:span 4}.home-page__collection-card--open{grid-column:span 4}.home-page__collection-card--community{grid-column:span 4}.home-page__container--access{grid-column:span 4;grid-template-columns:auto;grid-template-rows:1fr 7rem;row-gap:var(--pharos-spacing-2-x)}.home-page__hero{background-position:85% center;margin-top:2.625rem}.home-page__heading{margin-top:var(--pharos-spacing-3-x)}}", "",{"version":3,"sources":["webpack://./packages/pharos/src/pages/home/home.scss","webpack://./packages/pharos/lib/utils/scss/_mixins.scss"],"names":[],"mappings":"AAEA,sBACE,YAAA,CACA,4CACE,CAIF,iDACE,gBAAA,CAGF,2BACE,cAAA,CAGF,oCACE,gBAAA,CAIJ,oCACE,YAAA,CACA,4DACE,CAGF,mBAAA,CAGF,iBACE,cAAA,CACA,YAAA,CACA,0BAAA,CACA,2BAAA,CACA,qBAAA,CACA,iBAAA,CACA,kBAAA,CACA,oDAAA,CAGF,oBACE,kBAAA,CAGF,2BACE,aAAA,CAGF,sBACE,mBAAA,CAGF,kCACE,kBAAA,CAGF,uCACE,kBAAA,CAGF,8BACE,mBAAA,CACA,iDAAA,CACA,8CAAA,CACA,mCAAA,CACA,YAAA,CACA,+BAAA,CACA,gBAAA,CAGF,yBCsUE,oBAAA,CDnUA,cAAA,CACA,QAAA,CAEA,6CACE,uCAAA,CAIJ,8BACE,uCAAA,CAGF,kBACE,0FAAA,CACA,0CAAA,CACA,qBAAA,CACA,gDAAA,CACA,uCAAA,CACA,WAAA,CACA,sCAAA,CAEA,wBC3DA,YAAA,CACA,8DAAA,CACA,qDAAA,CD4DE,0IAAA,CAKJ,6BACE,iBAAA,CACA,SAAA,CACA,YAAA,CACA,kBAAA,CACA,WAAA,CACA,SAAA,CAGF,yBACE,iBAAA,CACA,2CAAA,CACA,OAAA,CACA,0BAAA,CC8WE,2DD1WF,kCACE,kBAAA,CAGF,uCACE,kBAAA,CAGF,6BACE,YAAA,CAAA,CCiWA,4DD5VF,kCACE,kBAAA,CAGF,uCACE,kBAAA,CAGF,+CAEE,WAAA,CAAA,CCiUA,qCD5TF,sBACE,kBAAA,CAGF,kCACE,kBAAA,CAGF,uCACE,kBAAA,CAGF,8BACE,kBAAA,CACA,oCAAA,CAGF,iBACE,yBAAA,CAAA,CC0SA,uCDrSF,sBACE,kBAAA,CAGF,kCACE,kBAAA,CAGF,uCACE,kBAAA,CAGF,8BACE,kBAAA,CACA,0BAAA,CACA,2BAAA,CACA,iCAAA,CAGF,iBACE,8BAAA,CACA,mBAAA,CAGF,oBACE,oCAAA,CAAA","sourcesContent":["@use '@ithaka/pharos/lib/styles/pharos';\n\n.home-page__container {\n  display: grid;\n  grid-template-areas:\n    'header'\n    'main'\n    'footer';\n\n  .header-revised__container {\n    grid-area: header;\n  }\n\n  main {\n    grid-area: main;\n  }\n\n  pharos-footer {\n    grid-area: footer;\n  }\n}\n\n.home-page__container--main-content {\n  display: grid;\n  grid-template-areas:\n    '. top .'\n    'hero hero hero'\n    '. content .';\n  margin-bottom: 10rem;\n}\n\n.home-page__hero {\n  grid-area: hero;\n  height: 381px;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  position: relative;\n  margin-top: 4.75rem;\n  margin-bottom: var(--pharos-spacing-three-quarters-x);\n}\n\n.home-page__heading {\n  margin-top: 3.75rem;\n}\n\n.home-page__container--top {\n  grid-area: top;\n}\n\n.home-page__hero-link {\n  grid-column: span 12;\n}\n\n.home-page__collection-card--open {\n  grid-column: span 6;\n}\n\n.home-page__collection-card--community {\n  grid-column: span 3;\n}\n\n.home-page__container--access {\n  grid-column: span 12;\n  border-bottom: 1px solid var(--pharos-color-ui-30);\n  border-top: 1px solid var(--pharos-color-ui-30);\n  padding: var(--pharos-spacing-3-x) 0;\n  display: grid;\n  grid-template-columns: 1fr 12rem;\n  column-gap: 12rem;\n}\n\n.home-page__list--access {\n  @include pharos.no-bullet;\n\n  padding-left: 0;\n  margin: 0;\n\n  li:not(:last-child) {\n    margin-bottom: var(--pharos-spacing-1-x);\n  }\n}\n\n.home-page__image--collection {\n  margin-bottom: var(--pharos-spacing-1-x);\n}\n\n.home-page__input {\n  padding: var(--pharos-spacing-1-x) var(--pharos-spacing-1-x) var(--pharos-spacing-1-x) 4rem;\n  border: 1px solid var(--pharos-color-ui-50);\n  box-sizing: border-box;\n  border-radius: var(--pharos-radius-base-standard);\n  font-size: var(--pharos-font-size-large);\n  width: 50rem;\n  box-shadow: 0 4px 6px 0 rgb(0 0 0 / 0.32);\n\n  &:focus {\n    @include pharos.input-focus;\n\n    padding: calc(var(--pharos-spacing-1-x) - 1px) calc(var(--pharos-spacing-1-x) - 1px)\n      calc(var(--pharos-spacing-1-x) - 1px) calc(4rem - 1px);\n  }\n}\n\n.home-page__container--input {\n  position: absolute;\n  top: 10rem;\n  display: flex;\n  align-items: center;\n  width: 50rem;\n  z-index: 1;\n}\n\n.home-page__icon--search {\n  position: absolute;\n  left: var(--pharos-spacing-one-and-a-half-x);\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n@include pharos.between(small, medium) {\n  .home-page__collection-card--open {\n    grid-column: span 6;\n  }\n\n  .home-page__collection-card--community {\n    grid-column: span 6;\n  }\n\n  .home-page__container--input {\n    display: none;\n  }\n}\n\n@include pharos.between(medium, large) {\n  .home-page__collection-card--open {\n    grid-column: span 6;\n  }\n\n  .home-page__collection-card--community {\n    grid-column: span 3;\n  }\n\n  .home-page__input,\n  .home-page__container--input {\n    width: 42rem;\n  }\n}\n\n@include pharos.until(medium) {\n  .home-page__hero-link {\n    grid-column: span 8;\n  }\n\n  .home-page__collection-card--open {\n    grid-column: span 8;\n  }\n\n  .home-page__collection-card--community {\n    grid-column: span 4;\n  }\n\n  .home-page__container--access {\n    grid-column: span 8;\n    column-gap: var(--pharos-spacing-3-x);\n  }\n\n  .home-page__hero {\n    background-position: right;\n  }\n}\n\n@include pharos.until(small) {\n  .home-page__hero-link {\n    grid-column: span 4;\n  }\n\n  .home-page__collection-card--open {\n    grid-column: span 4;\n  }\n\n  .home-page__collection-card--community {\n    grid-column: span 4;\n  }\n\n  .home-page__container--access {\n    grid-column: span 4;\n    grid-template-columns: auto;\n    grid-template-rows: 1fr 7rem;\n    row-gap: var(--pharos-spacing-2-x);\n  }\n\n  .home-page__hero {\n    background-position: 85% center;\n    margin-top: 2.625rem;\n  }\n\n  .home-page__heading {\n    margin-top: var(--pharos-spacing-3-x);\n  }\n}\n","@use 'sass:map';\n@use 'sass:list';\n@use 'sass:string';\n@use './variables';\n@use './functions';\n\n/// Base styles for inputs\n/// @access public\n/// @group form-elements\n@mixin input-base {\n  @include font-base;\n\n  margin: 0;\n  padding: var(--pharos-spacing-one-half-x) var(--pharos-spacing-three-quarters-x);\n  width: 100%;\n  display: block;\n  box-sizing: border-box;\n  border: 1px solid var(--pharos-form-element-color-border-base);\n  border-radius: var(--pharos-radius-base-standard);\n  transition: transform var(--pharos-transition-base) 0s;\n  color: var(--pharos-form-element-color-text-base);\n}\n\n/// Placeholder styles for inputs\n/// @access public\n/// @group form-elements\n@mixin input-placeholder {\n  &::placeholder {\n    color: var(--pharos-form-element-color-text-placeholder);\n    opacity: 1;\n  }\n}\n\n/// Focus styles for inputs\n/// @access public\n/// @group form-elements\n@mixin input-focus {\n  outline: none;\n  border: 2px solid var(--pharos-form-element-color-border-focus);\n  transition: transform var(--pharos-transition-base) 0s;\n}\n\n/// Wrapper styles for inputs\n/// @access public\n/// @group form-elements\n@mixin input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n/// Styles for input's invalid state\n/// @access public\n/// @group form-elements\n@mixin input-invalid {\n  border: 2px solid var(--pharos-form-element-color-border-invalid);\n}\n\n/// Styles for input's disabled state\n/// @access public\n/// @group form-elements\n@mixin input-disabled {\n  color: var(--pharos-form-element-color-text-disabled);\n  background-color: var(--pharos-form-element-color-background-disabled);\n  border-color: var(--pharos-form-element-color-background-disabled);\n  pointer-events: none;\n}\n\n/// Styles for input's required state\n/// @access public\n/// @group form-elements\n@mixin input-required {\n  &:required {\n    box-shadow: none;\n  }\n}\n\n/// Styles for input states with thicker borders\n/// @access public\n/// @group form-elements\n@mixin input-padding-thick-border {\n  padding: calc(var(--pharos-spacing-one-half-x) - 1px)\n    calc(var(--pharos-spacing-three-quarters-x) - 1px);\n}\n\n/// Styles for prominent input states with thicker borders\n/// @access public\n/// @group form-elements\n@mixin input-padding-thick-border-prominent {\n  padding: calc(var(--pharos-spacing-1-x) - 1px);\n}\n\n/// Styles for inputs on a background\n/// @access public\n/// @group form-elements\n@mixin input-on-background {\n  background-color: var(--pharos-color-marble-gray-20);\n  border-color: var(--pharos-color-marble-gray-20);\n  color: var(--pharos-color-text-white);\n  caret-color: var(--pharos-color-text-white);\n\n  &::placeholder {\n    color: var(--pharos-color-marble-gray-base);\n  }\n}\n\n/// Styles for input options\n/// @access public\n/// @group form-elements\n@mixin option-input {\n  @include hidden;\n\n  display: block;\n  box-sizing: border-box;\n}\n\n/// Wrapper styles for input options\n/// @access public\n/// @group form-elements\n@mixin option-wrapper {\n  display: inline-flex;\n  align-items: flex-start;\n  position: relative;\n}\n\n/// Styles to hide an element\n/// @access public\n/// @group interaction\n@mixin hidden {\n  border: 0;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  width: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n}\n\n/// Base styles for font.\n/// @param {string} $font-family [var(--pharos-font-family-sans-serif)] - The font family of the font\n/// @param {string} $font-size [var(--pharos-font-size-base)] - The size of the font\n/// @param {string} $font-weight [var(--pharos-font-weight-regular)] - The weight of the font\n/// @param {string} $line-height [var(--pharos-line-height-medium)] - The line height of the font\n/// @access public\n/// @group typography\n@mixin font-base(\n  $font-family: var(--pharos-font-family-sans-serif),\n  $font-size: var(--pharos-font-size-base),\n  $font-weight: var(--pharos-font-weight-regular),\n  $line-height: var(--pharos-line-height-medium)\n) {\n  @if $font-family == var(--pharos-font-family-sans-serif) {\n    @include letter-spacing-sans-serif($font-size);\n  } @else if $font-family == var(--pharos-font-family-serif) {\n    @include letter-spacing-serif($font-size);\n  } @else {\n    @error 'Unknown font-family #{$font-family}.';\n  }\n\n  font-family: $font-family;\n  font-size: $font-size;\n  font-weight: $font-weight;\n  line-height: $line-height;\n  text-rendering: optimizelegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/// Letter spacing for serif type\n/// @access public\n/// @group typography\n@mixin letter-spacing-serif($font-size: 1rem) {\n  @if $font-size != inherit {\n    letter-spacing: calc(#{$font-size} * -0.01);\n  }\n}\n\n/// Letter spacing for sans-serif type\n/// @access public\n/// @group typography\n@mixin letter-spacing-sans-serif($font-size: 1rem) {\n  @if $font-size != inherit {\n    letter-spacing: calc(#{$font-size} * -0.02);\n  }\n}\n\n/// Base styles for labels\n/// @access public\n/// @group form-elements\n@mixin label-base($margin-bottom: var(--pharos-spacing-one-quarter-x), $text-transform: uppercase) {\n  color: var(--pharos-form-element-color-text-base);\n  margin-bottom: $margin-bottom;\n  display: block;\n  padding: 0;\n  text-transform: $text-transform;\n}\n\n/// Styles for labels of form elements\n/// @access public\n/// @group form-elements\n@mixin form-element-label {\n  @include font-base(\n    $font-size: var(--pharos-form-element-size-text-label),\n    $font-weight: var(--pharos-font-weight-bold),\n    $line-height: var(--pharos-line-height-small)\n  );\n  @include label-base;\n}\n\n/// Styles for labels of grouped form elements\n/// @access public\n/// @group form-elements\n@mixin groupable-element-label {\n  @include font-base;\n  @include label-base($margin-bottom: 0, $text-transform: none);\n\n  padding-left: var(--pharos-spacing-one-quarter-x);\n}\n\n/// Styles for icon buttons.\n/// @access public\n/// @group buttons\n@mixin icon-button {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-sizing: border-box;\n  background: none;\n  margin: 0;\n}\n\n/// Focus styles for most interactive components.\n/// @access public\n/// @group interaction\n@mixin interactive-focus {\n  &:focus {\n    outline: 2px solid var(--pharos-color-focus);\n    outline-offset: 2px;\n  }\n}\n\n/// Base styles for buttons.\n/// @param {string} $color [var(--pharos-button-color-base-primary-text-base)] - The color of the text\n/// @param {string} $background-color [vvar(--pharos-button-color-base-primary-background-base)] - The color of the background\n/// @param {string} $border-color [var(--pharos-button-color-base-primary-border-base)] - The color of the border\n/// @access public\n/// @group buttons\n@mixin button-base(\n  $color: var(--pharos-button-color-base-primary-text-base),\n  $background-color: var(--pharos-button-color-base-primary-background-base),\n  $border-color: var(--pharos-button-color-base-primary-border-base)\n) {\n  @include font-base($font-weight: var(--pharos-font-weight-bold));\n  @include transition-base(border-color, background, color);\n\n  color: $color;\n  background-color: $background-color;\n  border: 1px solid $border-color;\n  padding: var(--pharos-spacing-one-quarter-x) var(--pharos-spacing-three-quarters-x);\n  border-radius: var(--pharos-radius-base-standard);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  appearance: none;\n\n  [data-pharos-component='PharosIcon'] {\n    @include transition-base(fill, stroke);\n\n    fill: $color;\n    stroke: $color;\n    stroke-width: 0;\n  }\n\n  [data-pharos-component='PharosIcon']:first-child:not(:only-child) {\n    margin-right: var(--pharos-spacing-one-quarter-x);\n  }\n\n  [data-pharos-component='PharosIcon']:last-child:not(:only-child) {\n    margin-left: var(--pharos-spacing-one-quarter-x);\n  }\n}\n\n/// Hover styles for buttons.\n/// @param {string} $color [var(--pharos-button-color-base-primary-text-hover)] - The color of the text\n/// @param {string} $background-color [var(--pharos-button-color-base-primary-background-hover)] - The color of the background\n/// @param {string} $border-color [var(--pharos-button-color-base-primary-border-hover)] - The color of the border\n/// @access public\n/// @group buttons\n@mixin button-hover(\n  $color: var(--pharos-button-color-base-primary-text-hover),\n  $background-color: var(--pharos-button-color-base-primary-background-hover),\n  $border-color: var(--pharos-button-color-base-primary-border-hover)\n) {\n  &:hover:not([disabled]),\n  &:active:not([disabled]) {\n    color: $color;\n    background-color: $background-color;\n    border: 2px solid $border-color;\n    padding: calc(var(--pharos-spacing-one-quarter-x) - 1px)\n      calc(var(--pharos-spacing-three-quarters-x) - 1px);\n\n    [data-pharos-component='PharosIcon'] {\n      fill: $color;\n      stroke: $color;\n    }\n  }\n}\n\n/// Styles for large buttons.\n/// @access public\n/// @group buttons\n@mixin button-large {\n  padding: var(--pharos-spacing-one-half-x) var(--pharos-spacing-three-quarters-x);\n\n  &:hover:not([disabled]),\n  &:active:not([disabled]) {\n    padding: calc(var(--pharos-spacing-one-half-x) - 1px)\n      calc(var(--pharos-spacing-three-quarters-x) - 1px);\n  }\n}\n\n/// Color styles for buttons.\n/// @param {string} $color [var(--pharos-button-color-base-primary-text-base)] - The color of the text\n/// @param {string} $background-color [var(--pharos-button-color-base-primary-background-base)] - The color of the background\n/// @param {string} $border-color [var(--pharos-button-color-base-primary-border-base)] - The color of the border\n/// @access public\n/// @group buttons\n@mixin button-color(\n  $color: var(--pharos-button-color-base-primary-text-base),\n  $background-color: var(--pharos-button-color-base-primary-background-base),\n  $border-color: var(--pharos-button-color-base-primary-border-base)\n) {\n  color: $color;\n  background-color: $background-color;\n  border-color: $border-color;\n\n  [data-pharos-component='PharosIcon'] {\n    fill: $color;\n    stroke: $color;\n  }\n}\n\n/// Base styles for links.\n/// @access public\n/// @group links\n@mixin link-base {\n  @include font-base($font-size: inherit, $line-height: inherit);\n  @include underline;\n\n  letter-spacing: inherit;\n  color: var(--pharos-color-interactive-secondary);\n  transition-property: color, text-decoration-color;\n  transition-duration: 200ms;\n  transition-timing-function: ease-in-out;\n}\n\n/// Hover style for links.\n/// @access public\n/// @group links\n@mixin link-hover {\n  &:hover {\n    @include no-underline;\n\n    color: var(--pharos-color-hover-primary);\n  }\n}\n\n/// Base styles for underlines.\n/// @param {string} $text-decoration-color [var(--pharos-color-interactive-secondary)] - The color of the underline\n/// @access public\n/// @group links\n@mixin underline($text-decoration-color: var(--pharos-color-interactive-secondary)) {\n  text-decoration: underline;\n  text-decoration-color: $text-decoration-color;\n}\n\n/* stylelint-disable declaration-block-no-redundant-longhand-properties */\n/// Removes underlines.\n/// @access public\n/// @group links\n@mixin no-underline {\n  text-decoration-style: solid;\n  text-decoration-line: underline;\n  text-decoration-color: transparent;\n}\n\n/// Removes bullets from lists.\n/// @access public\n/// @group typography\n@mixin no-bullet {\n  list-style-type: none;\n}\n\n/// Base styles for inline lists.\n/// @param {string} $margin-right [var(--pharos-spacing-one-and-a-half-x)] - The margin between list items\n/// @access public\n/// @group typography\n@mixin list-inline($margin-right: var(--pharos-spacing-one-and-a-half-x)) {\n  @include no-bullet;\n\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n\n  li:not(:last-child) {\n    margin-right: $margin-right;\n    margin-bottom: 0;\n  }\n}\n\n/// Base style for nested lists.\n/// @access public\n/// @group typography\n@mixin list-nested {\n  > li:not(:last-child) {\n    margin-bottom: var(--pharos-spacing-three-quarters-x);\n  }\n}\n\n/// Base styles for transitions.\n/// @param {string} $properties - The transition properties to style\n/// @access public\n/// @group interaction\n@mixin transition-base($properties...) {\n  transition-property: $properties;\n  transition-duration: var(--pharos-transition-duration-default);\n  transition-timing-function: ease-in-out;\n}\n\n/// Base styles for content labels.\n/// @access public\n/// @group typography\n@mixin content-label($args...) {\n  @include form-element-label($args...);\n}\n\n/// Creates a media query that starts at the passed breakpoint.\n/// @param {string} $breakpoint - The breakpoint to use as the minimum\n/// @access public\n/// @group layout\n@mixin at-least($breakpoint) {\n  @if map-has-key(variables.$breakpoints, $breakpoint) {\n    $width: map.get(variables.$breakpoints, $breakpoint, width);\n    @media screen and (min-width: $width) {\n      @content;\n    }\n  } @else {\n    @error 'Unknown breakpoint `#{$breakpoint}`. ' + 'Available breakpoints are: #{map.keys(variables.$breakpoints)}.';\n  }\n}\n\n/// Creates a media query that ranges up to the passed breakpoint.\n/// @param {string} $breakpoint - The breakpoint to use as the maximum\n/// @access public\n/// @group layout\n@mixin until($breakpoint) {\n  @if map-has-key(variables.$breakpoints, $breakpoint) {\n    $width: map.get(variables.$breakpoints, $breakpoint, width);\n    @media screen and (max-width: $width) {\n      @content;\n    }\n  } @else {\n    @error 'Unknown breakpoint `#{$breakpoint}`. ' + 'Available breakpoints are: #{map.keys(variables.$breakpoints)}.';\n  }\n}\n\n/// Creates a media query that ranges between the two passed breakpoints.\n/// @param {string} $lower - The breakpoint to use as the lower bounds\n/// @param {string} $upper - The breakpoint to use as the upper bounds\n/// @access public\n/// @group layout\n@mixin between($lower, $upper) {\n  @if map-has-key(variables.$breakpoints, $lower) and map-has-key(variables.$breakpoints, $upper) {\n    $lower-width: functions.calculate-px(map.get(variables.$breakpoints, $lower, width));\n    $upper-width: functions.calculate-px(map.get(variables.$breakpoints, $upper, width));\n    @media screen and (min-width: $lower-width) and (max-width: $upper-width - 1) {\n      @content;\n    }\n  } @else {\n    @error 'Unknown breakpoint range `#{$lower}` - `#{$upper}`. ' + 'Available breakpoints are: #{map.keys(variables.$breakpoints)}.';\n  }\n}\n\n/// Base style for the layout's outer grid.\n/// @access public\n/// @group layout\n@mixin layout-base {\n  display: grid;\n  grid-template-areas: '. content .';\n}\n\n/// Base style for the layout's inner grid.\n/// @access public\n/// @group layout\n@mixin layout-content {\n  display: grid;\n  grid-area: content;\n  grid-template-columns: repeat(map.get(variables.$breakpoints, large, columns), 1fr);\n  grid-template-rows: auto;\n  column-gap: var(--pharos-spacing-gutter);\n  padding: 0;\n  margin: 0;\n  list-style: none;\n\n  @include until(medium) {\n    grid-template-columns: repeat(map.get(variables.$breakpoints, medium, columns), 1fr);\n    grid-template-rows: auto;\n  }\n\n  @include until(small) {\n    grid-template-columns: repeat(map.get(variables.$breakpoints, small, columns), 1fr);\n    grid-template-rows: auto;\n  }\n}\n\n/// Sets margins for the layout's outer grid.\n/// @param {string} $layout - The layout preset\n/// @access public\n/// @group layout\n@mixin layout-base-columns($layout) {\n  $breakpoints: map.get(variables.$layouts, $layout);\n  $fixed-margin: $layout != '1-col';\n\n  @each $breakpoint, $margin in $breakpoints {\n    $i: list.index($breakpoints, $breakpoint $margin);\n\n    @if $i != length($breakpoints) {\n      $upper: list.nth(map.keys($breakpoints), $i + 1);\n      $max-margin: list.nth(map.values($breakpoints), $i + 1);\n\n      @include between($breakpoint, $upper) {\n        $layout-margin: if($fixed-margin, $margin, minmax($margin, $max-margin));\n\n        grid-template-columns: $layout-margin auto $layout-margin;\n        grid-template-rows: auto;\n      }\n    } @else {\n      @include at-least($breakpoint) {\n        grid-template-columns: minmax($margin, 1fr) auto minmax($margin, 1fr);\n        grid-template-rows: auto;\n      }\n    }\n  }\n}\n\n/// Sets widths for the layout's inner grid.\n/// @param {string} $layout - The layout preset\n/// @access public\n/// @group layout\n@mixin layout-content-width($layout) {\n  $breakpoints: map.get(variables.$layouts, $layout);\n  $fixed-width: $layout == '1-col';\n  $property: if($fixed-width, width, min-width);\n\n  @if $fixed-width {\n    @include at-least(medium) {\n      margin: auto;\n    }\n  }\n\n  @each $breakpoint, $margin in $breakpoints {\n    $i: list.index($breakpoints, $breakpoint $margin);\n\n    @if $i == 1 {\n      @include until($breakpoint) {\n        #{$property}: functions.content-width(\n          map.get(variables.$breakpoints, $breakpoint, width),\n          $margin\n        );\n      }\n    } @else if $i != length($breakpoints) {\n      $upper: list.nth(map.keys($breakpoints), $i + 1);\n\n      @include between($breakpoint, $upper) {\n        #{$property}: functions.content-width(\n          map.get(variables.$breakpoints, $breakpoint, width),\n          $margin,\n          $sidenav: string.index($layout, '--sidenav') and $i > 2\n        );\n      }\n    } @else {\n      @include at-least($breakpoint) {\n        #{$property}: functions.content-width(\n          map.get(variables.$breakpoints, $breakpoint, width),\n          $margin,\n          $sidenav: string.index($layout, '--sidenav')\n        );\n      }\n    }\n  }\n}\n\n/// Truncates text based on number of lines.\n/// @param {number} $lines [1] - The number of lines allowed before truncating\n/// @access public\n/// @group typography\n@mixin truncate-text($lines: 1) {\n  overflow: hidden;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  white-space: normal;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[12].use[1]!./node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[12].use[2]!./packages/pharos/src/pages/item-detail/item-detail.scss":
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".item-detail-page__container{display:grid;grid-template-areas:\"header\" \"main\" \"footer\"}.item-detail-page__container .header-revised__container{grid-area:header}.item-detail-page__container main{grid-area:main}.item-detail-page__container pharos-footer{grid-area:footer}.item-detail-page__container--main-content{display:grid;grid-template-areas:\"top top top\" \". content .\";margin-bottom:6rem;margin-top:var(--pharos-spacing-1-x)}.item-detail-page__container--top{grid-area:top;border-bottom:1px solid var(--pharos-color-ui-30);border-top:1px solid var(--pharos-color-ui-30);display:flex;padding:var(--pharos-spacing-1-x) var(--pharos-spacing-2-x)}.item-detail-page__container--action-buttons,.item-detail-page__container--mobile-buttons{margin-left:auto;display:grid;grid-template-columns:repeat(4, max-content);column-gap:var(--pharos-spacing-three-quarters-x)}.item-detail-page__container--mobile-buttons,.item-detail-page__button--mobile-back{display:none}.item-detail-page__container--collections{grid-column:span 8;grid-row:2;overflow:hidden}.item-detail-page__container--metadata{grid-column:span 4;grid-row:span 2}.item-detail-page__container--viewer{background-color:var(--pharos-color-black);grid-column:span 8;grid-row:1;margin-left:-3.5rem;height:40rem}.item-detail-page__label--content{letter-spacing:calc(var(--pharos-form-element-size-text-label) * -0.02);font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-form-element-size-text-label);font-weight:var(--pharos-font-weight-bold);line-height:var(--pharos-line-height-small);text-rendering:optimizelegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:var(--pharos-form-element-color-text-base);margin-bottom:var(--pharos-spacing-one-quarter-x);display:block;padding:0;text-transform:uppercase}.item-detail-page__text--metadata{color:var(--pharos-color-text-40)}.item-detail-page__grid--metadata{display:grid;row-gap:var(--pharos-spacing-one-and-a-half-x)}.item-detail-page__label--type{letter-spacing:calc(var(--pharos-form-element-size-text-label) * -0.02);font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-form-element-size-text-label);font-weight:var(--pharos-font-weight-bold);line-height:var(--pharos-line-height-small);text-rendering:optimizelegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:var(--pharos-form-element-color-text-base);margin-bottom:var(--pharos-spacing-one-quarter-x);display:block;padding:0;text-transform:uppercase;color:var(--pharos-color-text-40)}.item-detail-page__heading--metadata{margin-bottom:var(--pharos-spacing-2-x)}.item-detail-page__image--collection{margin:var(--pharos-spacing-one-and-a-half-x) 0}.item-detail-page__grid--carousel-item{display:grid;grid-template-rows:13.75rem 1fr;row-gap:var(--pharos-spacing-one-half-x);justify-content:center;align-items:end;cursor:pointer}.item-detail-page__grid--open-collection{grid-template-rows:auto}.item-detail-page__text--collection-title{display:block;font-size:var(--pharos-type-scale-5)}.item-detail-page__text--collection-items{display:block;color:var(--pharos-color-text-40);margin-top:var(--pharos-spacing-one-half-x)}.item-detail-page__text--item-title{display:block;font-weight:var(--pharos-font-weight-bold)}.item-detail-page__text--item-metadata{letter-spacing:calc(var(--pharos-font-size-small) * -0.02);font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-font-size-small);font-weight:var(--pharos-font-weight-regular);line-height:var(--pharos-line-height-small);text-rendering:optimizelegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;display:block;color:var(--pharos-color-text-40);margin-top:var(--pharos-spacing-one-half-x)}.item-detail-page__list{list-style-type:none;overflow:scroll;padding:var(--pharos-spacing-one-quarter-x)}.item-detail-page__grid--collections{display:grid;grid-template-columns:repeat(3, 1fr);column-gap:var(--pharos-spacing-1-x);margin-top:var(--pharos-spacing-1-x)}.item-detail-page__container--top-bar{display:flex}.item-detail-page__grid--items{display:grid;grid-template-columns:repeat(6, 1fr);column-gap:var(--pharos-spacing-1-x);margin-bottom:var(--pharos-spacing-5-x);margin-top:var(--pharos-spacing-one-and-a-half-x)}.item-detail-page__container--carousel-buttons{margin-left:auto}.item-detail-page__button--back{display:flex;align-items:center}.item-detail-page__button--back:hover pharos-icon{fill:var(--pharos-color-hover-primary)}@media screen and (min-width: 360px)and (max-width: 1055px){.item-detail-page__container--top{padding:var(--pharos-spacing-1-x)}}@media screen and (max-width: 48rem){.item-detail-page__container--collections{display:none}.item-detail-page__container--metadata{grid-column:span 8}.item-detail-page__container--viewer{height:37.5rem;margin:0 -3.5rem}}@media screen and (min-width: 360px)and (max-width: 767px){.item-detail-page__container--action-buttons,.item-detail-page__button--back{display:none}.item-detail-page__container--mobile-buttons,.item-detail-page__button--mobile-back{display:flex}.item-detail-page__container--carousel-buttons{display:none}}@media screen and (max-width: 22.5rem){.item-detail-page__container--metadata,.item-detail-page__container--collections,.item-detail-page__container--viewer{grid-column:span 4}.item-detail-page__container--viewer{height:20rem}.item-detail-page__container--top{padding:var(--pharos-spacing-one-half-x) var(--pharos-spacing-1-x)}}", "",{"version":3,"sources":["webpack://./packages/pharos/src/pages/item-detail/item-detail.scss","webpack://./packages/pharos/lib/utils/scss/_mixins.scss"],"names":[],"mappings":"AAEA,6BACE,YAAA,CACA,4CACE,CAIF,wDACE,gBAAA,CAGF,kCACE,cAAA,CAGF,2CACE,gBAAA,CAIJ,2CACE,YAAA,CACA,+CACE,CAEF,kBAAA,CACA,oCAAA,CAGF,kCACE,aAAA,CACA,iDAAA,CACA,8CAAA,CACA,YAAA,CACA,2DAAA,CAGF,0FAEE,gBAAA,CACA,YAAA,CACA,4CAAA,CACA,iDAAA,CAGF,oFAEE,YAAA,CAGF,0CACE,kBAAA,CACA,UAAA,CACA,eAAA,CAGF,uCACE,kBAAA,CACA,eAAA,CAGF,qCACE,0CAAA,CACA,kBAAA,CACA,UAAA,CACA,mBAAA,CACA,YAAA,CAGF,kCCmHI,uEAAA,CAvBF,gDAbc,CAcd,oDA0Cc,CAzCd,0CA0CgB,CAzChB,2CA0CgB,CAzChB,iCAAA,CACA,kCAAA,CACA,iCAAA,CAyBA,gDAAA,CACA,iDAFgC,CAGhC,aAAA,CACA,SAAA,CACA,wBALsF,CDtHxF,kCACE,iCAAA,CAGF,kCACE,YAAA,CACA,8CAAA,CAGF,+BCsGI,uEAAA,CAvBF,gDAbc,CAcd,oDA0Cc,CAzCd,0CA0CgB,CAzChB,2CA0CgB,CAzChB,iCAAA,CACA,kCAAA,CACA,iCAAA,CAyBA,gDAAA,CACA,iDAFgC,CAGhC,aAAA,CACA,SAAA,CACA,wBALsF,CD1GtF,iCAAA,CAGF,qCACE,uCAAA,CAGF,qCACE,+CAAA,CAGF,uCACE,YAAA,CACA,+BAAA,CACA,wCAAA,CACA,sBAAA,CACA,eAAA,CACA,cAAA,CAGF,yCACE,uBAAA,CAGF,0CACE,aAAA,CACA,oCAAA,CAGF,0CACE,aAAA,CACA,iCAAA,CACA,2CAAA,CAGF,oCACE,aAAA,CACA,0CAAA,CAGF,uCC2DI,0DAAA,CAvBF,gDAbc,CAcd,uCDnCc,CCoCd,6CAbc,CAcd,2CDpCgB,CCqChB,iCAAA,CACA,kCAAA,CACA,iCAAA,CDpCA,aAAA,CACA,iCAAA,CACA,2CAAA,CAGF,wBCoQE,oBAAA,CDjQA,eAAA,CACA,2CAAA,CAGF,qCACE,YAAA,CACA,oCAAA,CACA,oCAAA,CACA,oCAAA,CAGF,sCACE,YAAA,CAGF,+BACE,YAAA,CACA,oCAAA,CACA,oCAAA,CACA,uCAAA,CACA,iDAAA,CAGF,+CACE,gBAAA,CAGF,gCACE,YAAA,CACA,kBAAA,CAEA,kDACE,sCAAA,CCsTA,4DDjTF,kCACE,iCAAA,CAAA,CC+RA,qCD1RF,0CACE,YAAA,CAGF,uCACE,kBAAA,CAGF,qCACE,cAAA,CACA,gBAAA,CAAA,CCiSA,2DD5RF,6EAEE,YAAA,CAGF,oFAEE,YAAA,CAGF,+CACE,YAAA,CAAA,CCgQA,uCD3PF,sHAGE,kBAAA,CAGF,qCACE,YAAA,CAGF,kCACE,kEAAA,CAAA","sourcesContent":["@use '@ithaka/pharos/lib/styles/pharos';\n\n.item-detail-page__container {\n  display: grid;\n  grid-template-areas:\n    'header'\n    'main'\n    'footer';\n\n  .header-revised__container {\n    grid-area: header;\n  }\n\n  main {\n    grid-area: main;\n  }\n\n  pharos-footer {\n    grid-area: footer;\n  }\n}\n\n.item-detail-page__container--main-content {\n  display: grid;\n  grid-template-areas:\n    'top top top'\n    '. content .';\n  margin-bottom: 6rem;\n  margin-top: var(--pharos-spacing-1-x);\n}\n\n.item-detail-page__container--top {\n  grid-area: top;\n  border-bottom: 1px solid var(--pharos-color-ui-30);\n  border-top: 1px solid var(--pharos-color-ui-30);\n  display: flex;\n  padding: var(--pharos-spacing-1-x) var(--pharos-spacing-2-x);\n}\n\n.item-detail-page__container--action-buttons,\n.item-detail-page__container--mobile-buttons {\n  margin-left: auto;\n  display: grid;\n  grid-template-columns: repeat(4, max-content);\n  column-gap: var(--pharos-spacing-three-quarters-x);\n}\n\n.item-detail-page__container--mobile-buttons,\n.item-detail-page__button--mobile-back {\n  display: none;\n}\n\n.item-detail-page__container--collections {\n  grid-column: span 8;\n  grid-row: 2;\n  overflow: hidden;\n}\n\n.item-detail-page__container--metadata {\n  grid-column: span 4;\n  grid-row: span 2;\n}\n\n.item-detail-page__container--viewer {\n  background-color: var(--pharos-color-black);\n  grid-column: span 8;\n  grid-row: 1;\n  margin-left: -3.5rem;\n  height: 40rem;\n}\n\n.item-detail-page__label--content {\n  @include pharos.content-label;\n}\n\n.item-detail-page__text--metadata {\n  color: var(--pharos-color-text-40);\n}\n\n.item-detail-page__grid--metadata {\n  display: grid;\n  row-gap: var(--pharos-spacing-one-and-a-half-x);\n}\n\n.item-detail-page__label--type {\n  @include pharos.content-label;\n\n  color: var(--pharos-color-text-40);\n}\n\n.item-detail-page__heading--metadata {\n  margin-bottom: var(--pharos-spacing-2-x);\n}\n\n.item-detail-page__image--collection {\n  margin: var(--pharos-spacing-one-and-a-half-x) 0;\n}\n\n.item-detail-page__grid--carousel-item {\n  display: grid;\n  grid-template-rows: 13.75rem 1fr;\n  row-gap: var(--pharos-spacing-one-half-x);\n  justify-content: center;\n  align-items: end;\n  cursor: pointer;\n}\n\n.item-detail-page__grid--open-collection {\n  grid-template-rows: auto;\n}\n\n.item-detail-page__text--collection-title {\n  display: block;\n  font-size: var(--pharos-type-scale-5);\n}\n\n.item-detail-page__text--collection-items {\n  display: block;\n  color: var(--pharos-color-text-40);\n  margin-top: var(--pharos-spacing-one-half-x);\n}\n\n.item-detail-page__text--item-title {\n  display: block;\n  font-weight: var(--pharos-font-weight-bold);\n}\n\n.item-detail-page__text--item-metadata {\n  @include pharos.font-base(\n    $font-size: var(--pharos-font-size-small),\n    $line-height: var(--pharos-line-height-small)\n  );\n\n  display: block;\n  color: var(--pharos-color-text-40);\n  margin-top: var(--pharos-spacing-one-half-x);\n}\n\n.item-detail-page__list {\n  @include pharos.no-bullet;\n\n  overflow: scroll;\n  padding: var(--pharos-spacing-one-quarter-x);\n}\n\n.item-detail-page__grid--collections {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  column-gap: var(--pharos-spacing-1-x);\n  margin-top: var(--pharos-spacing-1-x);\n}\n\n.item-detail-page__container--top-bar {\n  display: flex;\n}\n\n.item-detail-page__grid--items {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  column-gap: var(--pharos-spacing-1-x);\n  margin-bottom: var(--pharos-spacing-5-x);\n  margin-top: var(--pharos-spacing-one-and-a-half-x);\n}\n\n.item-detail-page__container--carousel-buttons {\n  margin-left: auto;\n}\n\n.item-detail-page__button--back {\n  display: flex;\n  align-items: center;\n\n  &:hover pharos-icon {\n    fill: var(--pharos-color-hover-primary);\n  }\n}\n\n@include pharos.between(small, large) {\n  .item-detail-page__container--top {\n    padding: var(--pharos-spacing-1-x);\n  }\n}\n\n@include pharos.until(medium) {\n  .item-detail-page__container--collections {\n    display: none;\n  }\n\n  .item-detail-page__container--metadata {\n    grid-column: span 8;\n  }\n\n  .item-detail-page__container--viewer {\n    height: 37.5rem;\n    margin: 0 -3.5rem;\n  }\n}\n\n@include pharos.between(small, medium) {\n  .item-detail-page__container--action-buttons,\n  .item-detail-page__button--back {\n    display: none;\n  }\n\n  .item-detail-page__container--mobile-buttons,\n  .item-detail-page__button--mobile-back {\n    display: flex;\n  }\n\n  .item-detail-page__container--carousel-buttons {\n    display: none;\n  }\n}\n\n@include pharos.until(small) {\n  .item-detail-page__container--metadata,\n  .item-detail-page__container--collections,\n  .item-detail-page__container--viewer {\n    grid-column: span 4;\n  }\n\n  .item-detail-page__container--viewer {\n    height: 20rem;\n  }\n\n  .item-detail-page__container--top {\n    padding: var(--pharos-spacing-one-half-x) var(--pharos-spacing-1-x);\n  }\n}\n","@use 'sass:map';\n@use 'sass:list';\n@use 'sass:string';\n@use './variables';\n@use './functions';\n\n/// Base styles for inputs\n/// @access public\n/// @group form-elements\n@mixin input-base {\n  @include font-base;\n\n  margin: 0;\n  padding: var(--pharos-spacing-one-half-x) var(--pharos-spacing-three-quarters-x);\n  width: 100%;\n  display: block;\n  box-sizing: border-box;\n  border: 1px solid var(--pharos-form-element-color-border-base);\n  border-radius: var(--pharos-radius-base-standard);\n  transition: transform var(--pharos-transition-base) 0s;\n  color: var(--pharos-form-element-color-text-base);\n}\n\n/// Placeholder styles for inputs\n/// @access public\n/// @group form-elements\n@mixin input-placeholder {\n  &::placeholder {\n    color: var(--pharos-form-element-color-text-placeholder);\n    opacity: 1;\n  }\n}\n\n/// Focus styles for inputs\n/// @access public\n/// @group form-elements\n@mixin input-focus {\n  outline: none;\n  border: 2px solid var(--pharos-form-element-color-border-focus);\n  transition: transform var(--pharos-transition-base) 0s;\n}\n\n/// Wrapper styles for inputs\n/// @access public\n/// @group form-elements\n@mixin input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n/// Styles for input's invalid state\n/// @access public\n/// @group form-elements\n@mixin input-invalid {\n  border: 2px solid var(--pharos-form-element-color-border-invalid);\n}\n\n/// Styles for input's disabled state\n/// @access public\n/// @group form-elements\n@mixin input-disabled {\n  color: var(--pharos-form-element-color-text-disabled);\n  background-color: var(--pharos-form-element-color-background-disabled);\n  border-color: var(--pharos-form-element-color-background-disabled);\n  pointer-events: none;\n}\n\n/// Styles for input's required state\n/// @access public\n/// @group form-elements\n@mixin input-required {\n  &:required {\n    box-shadow: none;\n  }\n}\n\n/// Styles for input states with thicker borders\n/// @access public\n/// @group form-elements\n@mixin input-padding-thick-border {\n  padding: calc(var(--pharos-spacing-one-half-x) - 1px)\n    calc(var(--pharos-spacing-three-quarters-x) - 1px);\n}\n\n/// Styles for prominent input states with thicker borders\n/// @access public\n/// @group form-elements\n@mixin input-padding-thick-border-prominent {\n  padding: calc(var(--pharos-spacing-1-x) - 1px);\n}\n\n/// Styles for inputs on a background\n/// @access public\n/// @group form-elements\n@mixin input-on-background {\n  background-color: var(--pharos-color-marble-gray-20);\n  border-color: var(--pharos-color-marble-gray-20);\n  color: var(--pharos-color-text-white);\n  caret-color: var(--pharos-color-text-white);\n\n  &::placeholder {\n    color: var(--pharos-color-marble-gray-base);\n  }\n}\n\n/// Styles for input options\n/// @access public\n/// @group form-elements\n@mixin option-input {\n  @include hidden;\n\n  display: block;\n  box-sizing: border-box;\n}\n\n/// Wrapper styles for input options\n/// @access public\n/// @group form-elements\n@mixin option-wrapper {\n  display: inline-flex;\n  align-items: flex-start;\n  position: relative;\n}\n\n/// Styles to hide an element\n/// @access public\n/// @group interaction\n@mixin hidden {\n  border: 0;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  width: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n}\n\n/// Base styles for font.\n/// @param {string} $font-family [var(--pharos-font-family-sans-serif)] - The font family of the font\n/// @param {string} $font-size [var(--pharos-font-size-base)] - The size of the font\n/// @param {string} $font-weight [var(--pharos-font-weight-regular)] - The weight of the font\n/// @param {string} $line-height [var(--pharos-line-height-medium)] - The line height of the font\n/// @access public\n/// @group typography\n@mixin font-base(\n  $font-family: var(--pharos-font-family-sans-serif),\n  $font-size: var(--pharos-font-size-base),\n  $font-weight: var(--pharos-font-weight-regular),\n  $line-height: var(--pharos-line-height-medium)\n) {\n  @if $font-family == var(--pharos-font-family-sans-serif) {\n    @include letter-spacing-sans-serif($font-size);\n  } @else if $font-family == var(--pharos-font-family-serif) {\n    @include letter-spacing-serif($font-size);\n  } @else {\n    @error 'Unknown font-family #{$font-family}.';\n  }\n\n  font-family: $font-family;\n  font-size: $font-size;\n  font-weight: $font-weight;\n  line-height: $line-height;\n  text-rendering: optimizelegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/// Letter spacing for serif type\n/// @access public\n/// @group typography\n@mixin letter-spacing-serif($font-size: 1rem) {\n  @if $font-size != inherit {\n    letter-spacing: calc(#{$font-size} * -0.01);\n  }\n}\n\n/// Letter spacing for sans-serif type\n/// @access public\n/// @group typography\n@mixin letter-spacing-sans-serif($font-size: 1rem) {\n  @if $font-size != inherit {\n    letter-spacing: calc(#{$font-size} * -0.02);\n  }\n}\n\n/// Base styles for labels\n/// @access public\n/// @group form-elements\n@mixin label-base($margin-bottom: var(--pharos-spacing-one-quarter-x), $text-transform: uppercase) {\n  color: var(--pharos-form-element-color-text-base);\n  margin-bottom: $margin-bottom;\n  display: block;\n  padding: 0;\n  text-transform: $text-transform;\n}\n\n/// Styles for labels of form elements\n/// @access public\n/// @group form-elements\n@mixin form-element-label {\n  @include font-base(\n    $font-size: var(--pharos-form-element-size-text-label),\n    $font-weight: var(--pharos-font-weight-bold),\n    $line-height: var(--pharos-line-height-small)\n  );\n  @include label-base;\n}\n\n/// Styles for labels of grouped form elements\n/// @access public\n/// @group form-elements\n@mixin groupable-element-label {\n  @include font-base;\n  @include label-base($margin-bottom: 0, $text-transform: none);\n\n  padding-left: var(--pharos-spacing-one-quarter-x);\n}\n\n/// Styles for icon buttons.\n/// @access public\n/// @group buttons\n@mixin icon-button {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-sizing: border-box;\n  background: none;\n  margin: 0;\n}\n\n/// Focus styles for most interactive components.\n/// @access public\n/// @group interaction\n@mixin interactive-focus {\n  &:focus {\n    outline: 2px solid var(--pharos-color-focus);\n    outline-offset: 2px;\n  }\n}\n\n/// Base styles for buttons.\n/// @param {string} $color [var(--pharos-button-color-base-primary-text-base)] - The color of the text\n/// @param {string} $background-color [vvar(--pharos-button-color-base-primary-background-base)] - The color of the background\n/// @param {string} $border-color [var(--pharos-button-color-base-primary-border-base)] - The color of the border\n/// @access public\n/// @group buttons\n@mixin button-base(\n  $color: var(--pharos-button-color-base-primary-text-base),\n  $background-color: var(--pharos-button-color-base-primary-background-base),\n  $border-color: var(--pharos-button-color-base-primary-border-base)\n) {\n  @include font-base($font-weight: var(--pharos-font-weight-bold));\n  @include transition-base(border-color, background, color);\n\n  color: $color;\n  background-color: $background-color;\n  border: 1px solid $border-color;\n  padding: var(--pharos-spacing-one-quarter-x) var(--pharos-spacing-three-quarters-x);\n  border-radius: var(--pharos-radius-base-standard);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  appearance: none;\n\n  [data-pharos-component='PharosIcon'] {\n    @include transition-base(fill, stroke);\n\n    fill: $color;\n    stroke: $color;\n    stroke-width: 0;\n  }\n\n  [data-pharos-component='PharosIcon']:first-child:not(:only-child) {\n    margin-right: var(--pharos-spacing-one-quarter-x);\n  }\n\n  [data-pharos-component='PharosIcon']:last-child:not(:only-child) {\n    margin-left: var(--pharos-spacing-one-quarter-x);\n  }\n}\n\n/// Hover styles for buttons.\n/// @param {string} $color [var(--pharos-button-color-base-primary-text-hover)] - The color of the text\n/// @param {string} $background-color [var(--pharos-button-color-base-primary-background-hover)] - The color of the background\n/// @param {string} $border-color [var(--pharos-button-color-base-primary-border-hover)] - The color of the border\n/// @access public\n/// @group buttons\n@mixin button-hover(\n  $color: var(--pharos-button-color-base-primary-text-hover),\n  $background-color: var(--pharos-button-color-base-primary-background-hover),\n  $border-color: var(--pharos-button-color-base-primary-border-hover)\n) {\n  &:hover:not([disabled]),\n  &:active:not([disabled]) {\n    color: $color;\n    background-color: $background-color;\n    border: 2px solid $border-color;\n    padding: calc(var(--pharos-spacing-one-quarter-x) - 1px)\n      calc(var(--pharos-spacing-three-quarters-x) - 1px);\n\n    [data-pharos-component='PharosIcon'] {\n      fill: $color;\n      stroke: $color;\n    }\n  }\n}\n\n/// Styles for large buttons.\n/// @access public\n/// @group buttons\n@mixin button-large {\n  padding: var(--pharos-spacing-one-half-x) var(--pharos-spacing-three-quarters-x);\n\n  &:hover:not([disabled]),\n  &:active:not([disabled]) {\n    padding: calc(var(--pharos-spacing-one-half-x) - 1px)\n      calc(var(--pharos-spacing-three-quarters-x) - 1px);\n  }\n}\n\n/// Color styles for buttons.\n/// @param {string} $color [var(--pharos-button-color-base-primary-text-base)] - The color of the text\n/// @param {string} $background-color [var(--pharos-button-color-base-primary-background-base)] - The color of the background\n/// @param {string} $border-color [var(--pharos-button-color-base-primary-border-base)] - The color of the border\n/// @access public\n/// @group buttons\n@mixin button-color(\n  $color: var(--pharos-button-color-base-primary-text-base),\n  $background-color: var(--pharos-button-color-base-primary-background-base),\n  $border-color: var(--pharos-button-color-base-primary-border-base)\n) {\n  color: $color;\n  background-color: $background-color;\n  border-color: $border-color;\n\n  [data-pharos-component='PharosIcon'] {\n    fill: $color;\n    stroke: $color;\n  }\n}\n\n/// Base styles for links.\n/// @access public\n/// @group links\n@mixin link-base {\n  @include font-base($font-size: inherit, $line-height: inherit);\n  @include underline;\n\n  letter-spacing: inherit;\n  color: var(--pharos-color-interactive-secondary);\n  transition-property: color, text-decoration-color;\n  transition-duration: 200ms;\n  transition-timing-function: ease-in-out;\n}\n\n/// Hover style for links.\n/// @access public\n/// @group links\n@mixin link-hover {\n  &:hover {\n    @include no-underline;\n\n    color: var(--pharos-color-hover-primary);\n  }\n}\n\n/// Base styles for underlines.\n/// @param {string} $text-decoration-color [var(--pharos-color-interactive-secondary)] - The color of the underline\n/// @access public\n/// @group links\n@mixin underline($text-decoration-color: var(--pharos-color-interactive-secondary)) {\n  text-decoration: underline;\n  text-decoration-color: $text-decoration-color;\n}\n\n/* stylelint-disable declaration-block-no-redundant-longhand-properties */\n/// Removes underlines.\n/// @access public\n/// @group links\n@mixin no-underline {\n  text-decoration-style: solid;\n  text-decoration-line: underline;\n  text-decoration-color: transparent;\n}\n\n/// Removes bullets from lists.\n/// @access public\n/// @group typography\n@mixin no-bullet {\n  list-style-type: none;\n}\n\n/// Base styles for inline lists.\n/// @param {string} $margin-right [var(--pharos-spacing-one-and-a-half-x)] - The margin between list items\n/// @access public\n/// @group typography\n@mixin list-inline($margin-right: var(--pharos-spacing-one-and-a-half-x)) {\n  @include no-bullet;\n\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n\n  li:not(:last-child) {\n    margin-right: $margin-right;\n    margin-bottom: 0;\n  }\n}\n\n/// Base style for nested lists.\n/// @access public\n/// @group typography\n@mixin list-nested {\n  > li:not(:last-child) {\n    margin-bottom: var(--pharos-spacing-three-quarters-x);\n  }\n}\n\n/// Base styles for transitions.\n/// @param {string} $properties - The transition properties to style\n/// @access public\n/// @group interaction\n@mixin transition-base($properties...) {\n  transition-property: $properties;\n  transition-duration: var(--pharos-transition-duration-default);\n  transition-timing-function: ease-in-out;\n}\n\n/// Base styles for content labels.\n/// @access public\n/// @group typography\n@mixin content-label($args...) {\n  @include form-element-label($args...);\n}\n\n/// Creates a media query that starts at the passed breakpoint.\n/// @param {string} $breakpoint - The breakpoint to use as the minimum\n/// @access public\n/// @group layout\n@mixin at-least($breakpoint) {\n  @if map-has-key(variables.$breakpoints, $breakpoint) {\n    $width: map.get(variables.$breakpoints, $breakpoint, width);\n    @media screen and (min-width: $width) {\n      @content;\n    }\n  } @else {\n    @error 'Unknown breakpoint `#{$breakpoint}`. ' + 'Available breakpoints are: #{map.keys(variables.$breakpoints)}.';\n  }\n}\n\n/// Creates a media query that ranges up to the passed breakpoint.\n/// @param {string} $breakpoint - The breakpoint to use as the maximum\n/// @access public\n/// @group layout\n@mixin until($breakpoint) {\n  @if map-has-key(variables.$breakpoints, $breakpoint) {\n    $width: map.get(variables.$breakpoints, $breakpoint, width);\n    @media screen and (max-width: $width) {\n      @content;\n    }\n  } @else {\n    @error 'Unknown breakpoint `#{$breakpoint}`. ' + 'Available breakpoints are: #{map.keys(variables.$breakpoints)}.';\n  }\n}\n\n/// Creates a media query that ranges between the two passed breakpoints.\n/// @param {string} $lower - The breakpoint to use as the lower bounds\n/// @param {string} $upper - The breakpoint to use as the upper bounds\n/// @access public\n/// @group layout\n@mixin between($lower, $upper) {\n  @if map-has-key(variables.$breakpoints, $lower) and map-has-key(variables.$breakpoints, $upper) {\n    $lower-width: functions.calculate-px(map.get(variables.$breakpoints, $lower, width));\n    $upper-width: functions.calculate-px(map.get(variables.$breakpoints, $upper, width));\n    @media screen and (min-width: $lower-width) and (max-width: $upper-width - 1) {\n      @content;\n    }\n  } @else {\n    @error 'Unknown breakpoint range `#{$lower}` - `#{$upper}`. ' + 'Available breakpoints are: #{map.keys(variables.$breakpoints)}.';\n  }\n}\n\n/// Base style for the layout's outer grid.\n/// @access public\n/// @group layout\n@mixin layout-base {\n  display: grid;\n  grid-template-areas: '. content .';\n}\n\n/// Base style for the layout's inner grid.\n/// @access public\n/// @group layout\n@mixin layout-content {\n  display: grid;\n  grid-area: content;\n  grid-template-columns: repeat(map.get(variables.$breakpoints, large, columns), 1fr);\n  grid-template-rows: auto;\n  column-gap: var(--pharos-spacing-gutter);\n  padding: 0;\n  margin: 0;\n  list-style: none;\n\n  @include until(medium) {\n    grid-template-columns: repeat(map.get(variables.$breakpoints, medium, columns), 1fr);\n    grid-template-rows: auto;\n  }\n\n  @include until(small) {\n    grid-template-columns: repeat(map.get(variables.$breakpoints, small, columns), 1fr);\n    grid-template-rows: auto;\n  }\n}\n\n/// Sets margins for the layout's outer grid.\n/// @param {string} $layout - The layout preset\n/// @access public\n/// @group layout\n@mixin layout-base-columns($layout) {\n  $breakpoints: map.get(variables.$layouts, $layout);\n  $fixed-margin: $layout != '1-col';\n\n  @each $breakpoint, $margin in $breakpoints {\n    $i: list.index($breakpoints, $breakpoint $margin);\n\n    @if $i != length($breakpoints) {\n      $upper: list.nth(map.keys($breakpoints), $i + 1);\n      $max-margin: list.nth(map.values($breakpoints), $i + 1);\n\n      @include between($breakpoint, $upper) {\n        $layout-margin: if($fixed-margin, $margin, minmax($margin, $max-margin));\n\n        grid-template-columns: $layout-margin auto $layout-margin;\n        grid-template-rows: auto;\n      }\n    } @else {\n      @include at-least($breakpoint) {\n        grid-template-columns: minmax($margin, 1fr) auto minmax($margin, 1fr);\n        grid-template-rows: auto;\n      }\n    }\n  }\n}\n\n/// Sets widths for the layout's inner grid.\n/// @param {string} $layout - The layout preset\n/// @access public\n/// @group layout\n@mixin layout-content-width($layout) {\n  $breakpoints: map.get(variables.$layouts, $layout);\n  $fixed-width: $layout == '1-col';\n  $property: if($fixed-width, width, min-width);\n\n  @if $fixed-width {\n    @include at-least(medium) {\n      margin: auto;\n    }\n  }\n\n  @each $breakpoint, $margin in $breakpoints {\n    $i: list.index($breakpoints, $breakpoint $margin);\n\n    @if $i == 1 {\n      @include until($breakpoint) {\n        #{$property}: functions.content-width(\n          map.get(variables.$breakpoints, $breakpoint, width),\n          $margin\n        );\n      }\n    } @else if $i != length($breakpoints) {\n      $upper: list.nth(map.keys($breakpoints), $i + 1);\n\n      @include between($breakpoint, $upper) {\n        #{$property}: functions.content-width(\n          map.get(variables.$breakpoints, $breakpoint, width),\n          $margin,\n          $sidenav: string.index($layout, '--sidenav') and $i > 2\n        );\n      }\n    } @else {\n      @include at-least($breakpoint) {\n        #{$property}: functions.content-width(\n          map.get(variables.$breakpoints, $breakpoint, width),\n          $margin,\n          $sidenav: string.index($layout, '--sidenav')\n        );\n      }\n    }\n  }\n}\n\n/// Truncates text based on number of lines.\n/// @param {number} $lines [1] - The number of lines allowed before truncating\n/// @access public\n/// @group typography\n@mixin truncate-text($lines: 1) {\n  overflow: hidden;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  white-space: normal;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[12].use[1]!./node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[12].use[2]!./packages/pharos/src/pages/reports/reports.scss":
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".reports-page__container{display:grid;grid-template-areas:\"sidenav main\";grid-template-columns:max-content 1fr}.reports-page__container main{grid-area:main}.reports-page__container .reports-page__sidenav{grid-area:sidenav}.reports-page__container--main-content{display:grid;grid-template-areas:\". top .\" \". content .\";margin-bottom:9.5rem}.reports-page__container--top{grid-area:top;display:flex;align-items:center;margin-top:var(--pharos-spacing-2-x)}.reports-page__container--disclaimer{margin-top:var(--pharos-spacing-three-and-a-half-x);grid-column:span 8}.reports-page__container--table{grid-column:span 12;position:relative}.reports-page__button--create{position:absolute;top:0;right:0;z-index:1}.reports-page__table{border-collapse:collapse;width:100%;table-layout:fixed}.reports-page__table-header{padding:var(--pharos-spacing-three-quarters-x) 0 var(--pharos-spacing-three-quarters-x) 0;text-align:left}.reports-page__table-row{border-top:1px solid var(--pharos-color-marble-gray-base)}.reports-page__table-row:hover{background-color:var(--pharos-color-hover-row)}.reports-page__table-row:last-child{border-bottom:1px solid var(--pharos-color-marble-gray-base)}.reports-page__table-cell{padding:var(--pharos-spacing-three-quarters-x) var(--pharos-spacing-three-quarters-x) var(--pharos-spacing-three-quarters-x) 0;white-space:nowrap;vertical-align:top}.reports-page__table-cell p{margin:0}.reports-page__table-cell--download{text-align:end}.reports-page__form--create-modal>*:not(:last-child){margin-bottom:var(--pharos-spacing-1-x)}.reports-page__fieldset--type{border:none;padding:0;margin-left:0}.reports-page__fieldset--date{border:1px solid var(--pharos-color-ui-40)}.reports-page__legend{letter-spacing:calc(var(--pharos-form-element-size-text-label) * -0.02);font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-form-element-size-text-label);font-weight:var(--pharos-font-weight-bold);line-height:var(--pharos-line-height-small);text-rendering:optimizelegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:var(--pharos-form-element-color-text-base);margin-bottom:var(--pharos-spacing-one-quarter-x);display:block;padding:0;text-transform:uppercase}.reports-page__grid--date-group{display:grid;grid-template-columns:1fr 1fr;column-gap:var(--pharos-spacing-2-x);padding:var(--pharos-spacing-1-x)}.reports-page__container--nav-header{display:none;grid-template-columns:repeat(4, max-content);column-gap:var(--pharos-spacing-one-half-x);align-items:center}.reports-page__container--nav-header img{margin-left:var(--pharos-spacing-one-half-x)}.reports-page__separator{font-size:var(--pharos-font-size-large);color:var(--pharos-color-marble-gray-80)}.reports-page__button--user{margin-left:auto}@media screen and (min-width: 360px)and (max-width: 767px){.reports-page__button--create{top:-58px;right:initial}.reports-page__table{border-collapse:unset;table-layout:auto}.reports-page__table thead{display:none}.reports-page__table td{display:block;text-align:left}.reports-page__button--user{display:none}}@media screen and (min-width: 360px)and (max-width: 1055px){.reports-page__container{grid-template-areas:\"main\";grid-template-columns:1fr}.reports-page__container--nav-header{display:grid}}@media screen and (max-width: 66rem){.reports-page__container--disclaimer{grid-column:span 10}}@media screen and (max-width: 48rem){.reports-page__container--disclaimer{grid-column:span 8}.reports-page__container--table{grid-column:span 8}}@media screen and (max-width: 22.5rem){.reports-page__container--disclaimer{grid-column:span 4}.reports-page__container--table{grid-column:span 4}}", "",{"version":3,"sources":["webpack://./packages/pharos/src/pages/reports/reports.scss","webpack://./packages/pharos/lib/utils/scss/_mixins.scss"],"names":[],"mappings":"AAEA,yBACE,YAAA,CACA,kCAAA,CACA,qCAAA,CAEA,8BACE,cAAA,CAGF,gDACE,iBAAA,CAIJ,uCACE,YAAA,CACA,2CACE,CAEF,oBAAA,CAGF,8BACE,aAAA,CACA,YAAA,CACA,kBAAA,CACA,oCAAA,CAGF,qCACE,mDAAA,CACA,kBAAA,CAGF,gCACE,mBAAA,CACA,iBAAA,CAGF,8BACE,iBAAA,CACA,KAAA,CACA,OAAA,CACA,SAAA,CAGF,qBACE,wBAAA,CACA,UAAA,CACA,kBAAA,CAGF,4BACE,yFAAA,CACA,eAAA,CAGF,yBACE,yDAAA,CAEA,+BACE,8CAAA,CAGF,oCACE,4DAAA,CAIJ,0BACE,8HAAA,CAEA,kBAAA,CACA,kBAAA,CAEA,4BACE,QAAA,CAIJ,oCACE,cAAA,CAIA,qDACE,uCAAA,CAIJ,8BACE,WAAA,CACA,SAAA,CACA,aAAA,CAGF,8BACE,0CAAA,CAGF,sBCoFI,uEAAA,CAvBF,gDAbc,CAcd,oDA0Cc,CAzCd,0CA0CgB,CAzChB,2CA0CgB,CAzChB,iCAAA,CACA,kCAAA,CACA,iCAAA,CAyBA,gDAAA,CACA,iDAFgC,CAGhC,aAAA,CACA,SAAA,CACA,wBALsF,CDvFxF,gCACE,YAAA,CACA,6BAAA,CACA,oCAAA,CACA,iCAAA,CAGF,qCACE,YAAA,CACA,4CAAA,CACA,2CAAA,CACA,kBAAA,CAEA,yCACE,4CAAA,CAIJ,yBACE,uCAAA,CACA,wCAAA,CAGF,4BACE,gBAAA,CCiWE,2DD7VF,8BACE,SAAA,CACA,aAAA,CAGF,qBACE,qBAAA,CACA,iBAAA,CAEA,2BACE,YAAA,CAGF,wBACE,aAAA,CACA,eAAA,CAIJ,4BACE,YAAA,CAAA,CCyUA,4DDpUF,yBACE,0BAAA,CACA,yBAAA,CAGF,qCACE,YAAA,CAAA,CC6SA,qCDxSF,qCACE,mBAAA,CAAA,CCuSA,qCDlSF,qCACE,kBAAA,CAGF,gCACE,kBAAA,CAAA,CC6RA,uCDxRF,qCACE,kBAAA,CAGF,gCACE,kBAAA,CAAA","sourcesContent":["@use '@ithaka/pharos/lib/styles/pharos';\n\n.reports-page__container {\n  display: grid;\n  grid-template-areas: 'sidenav main';\n  grid-template-columns: max-content 1fr;\n\n  main {\n    grid-area: main;\n  }\n\n  .reports-page__sidenav {\n    grid-area: sidenav;\n  }\n}\n\n.reports-page__container--main-content {\n  display: grid;\n  grid-template-areas:\n    '. top .'\n    '. content .';\n  margin-bottom: 9.5rem;\n}\n\n.reports-page__container--top {\n  grid-area: top;\n  display: flex;\n  align-items: center;\n  margin-top: var(--pharos-spacing-2-x);\n}\n\n.reports-page__container--disclaimer {\n  margin-top: var(--pharos-spacing-three-and-a-half-x);\n  grid-column: span 8;\n}\n\n.reports-page__container--table {\n  grid-column: span 12;\n  position: relative;\n}\n\n.reports-page__button--create {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 1;\n}\n\n.reports-page__table {\n  border-collapse: collapse;\n  width: 100%;\n  table-layout: fixed;\n}\n\n.reports-page__table-header {\n  padding: var(--pharos-spacing-three-quarters-x) 0 var(--pharos-spacing-three-quarters-x) 0;\n  text-align: left;\n}\n\n.reports-page__table-row {\n  border-top: 1px solid var(--pharos-color-marble-gray-base);\n\n  &:hover {\n    background-color: var(--pharos-color-hover-row);\n  }\n\n  &:last-child {\n    border-bottom: 1px solid var(--pharos-color-marble-gray-base);\n  }\n}\n\n.reports-page__table-cell {\n  padding: var(--pharos-spacing-three-quarters-x) var(--pharos-spacing-three-quarters-x)\n    var(--pharos-spacing-three-quarters-x) 0;\n  white-space: nowrap;\n  vertical-align: top;\n\n  p {\n    margin: 0;\n  }\n}\n\n.reports-page__table-cell--download {\n  text-align: end;\n}\n\n.reports-page__form--create-modal {\n  > *:not(:last-child) {\n    margin-bottom: var(--pharos-spacing-1-x);\n  }\n}\n\n.reports-page__fieldset--type {\n  border: none;\n  padding: 0;\n  margin-left: 0;\n}\n\n.reports-page__fieldset--date {\n  border: 1px solid var(--pharos-color-ui-40);\n}\n\n.reports-page__legend {\n  @include pharos.form-element-label;\n}\n\n.reports-page__grid--date-group {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: var(--pharos-spacing-2-x);\n  padding: var(--pharos-spacing-1-x);\n}\n\n.reports-page__container--nav-header {\n  display: none;\n  grid-template-columns: repeat(4, max-content);\n  column-gap: var(--pharos-spacing-one-half-x);\n  align-items: center;\n\n  img {\n    margin-left: var(--pharos-spacing-one-half-x);\n  }\n}\n\n.reports-page__separator {\n  font-size: var(--pharos-font-size-large);\n  color: var(--pharos-color-marble-gray-80);\n}\n\n.reports-page__button--user {\n  margin-left: auto;\n}\n\n@include pharos.between(small, medium) {\n  .reports-page__button--create {\n    top: -58px;\n    right: initial;\n  }\n\n  .reports-page__table {\n    border-collapse: unset;\n    table-layout: auto;\n\n    thead {\n      display: none;\n    }\n\n    td {\n      display: block;\n      text-align: left;\n    }\n  }\n\n  .reports-page__button--user {\n    display: none;\n  }\n}\n\n@include pharos.between(small, large) {\n  .reports-page__container {\n    grid-template-areas: 'main';\n    grid-template-columns: 1fr;\n  }\n\n  .reports-page__container--nav-header {\n    display: grid;\n  }\n}\n\n@include pharos.until(large) {\n  .reports-page__container--disclaimer {\n    grid-column: span 10;\n  }\n}\n\n@include pharos.until(medium) {\n  .reports-page__container--disclaimer {\n    grid-column: span 8;\n  }\n\n  .reports-page__container--table {\n    grid-column: span 8;\n  }\n}\n\n@include pharos.until(small) {\n  .reports-page__container--disclaimer {\n    grid-column: span 4;\n  }\n\n  .reports-page__container--table {\n    grid-column: span 4;\n  }\n}\n","@use 'sass:map';\n@use 'sass:list';\n@use 'sass:string';\n@use './variables';\n@use './functions';\n\n/// Base styles for inputs\n/// @access public\n/// @group form-elements\n@mixin input-base {\n  @include font-base;\n\n  margin: 0;\n  padding: var(--pharos-spacing-one-half-x) var(--pharos-spacing-three-quarters-x);\n  width: 100%;\n  display: block;\n  box-sizing: border-box;\n  border: 1px solid var(--pharos-form-element-color-border-base);\n  border-radius: var(--pharos-radius-base-standard);\n  transition: transform var(--pharos-transition-base) 0s;\n  color: var(--pharos-form-element-color-text-base);\n}\n\n/// Placeholder styles for inputs\n/// @access public\n/// @group form-elements\n@mixin input-placeholder {\n  &::placeholder {\n    color: var(--pharos-form-element-color-text-placeholder);\n    opacity: 1;\n  }\n}\n\n/// Focus styles for inputs\n/// @access public\n/// @group form-elements\n@mixin input-focus {\n  outline: none;\n  border: 2px solid var(--pharos-form-element-color-border-focus);\n  transition: transform var(--pharos-transition-base) 0s;\n}\n\n/// Wrapper styles for inputs\n/// @access public\n/// @group form-elements\n@mixin input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n/// Styles for input's invalid state\n/// @access public\n/// @group form-elements\n@mixin input-invalid {\n  border: 2px solid var(--pharos-form-element-color-border-invalid);\n}\n\n/// Styles for input's disabled state\n/// @access public\n/// @group form-elements\n@mixin input-disabled {\n  color: var(--pharos-form-element-color-text-disabled);\n  background-color: var(--pharos-form-element-color-background-disabled);\n  border-color: var(--pharos-form-element-color-background-disabled);\n  pointer-events: none;\n}\n\n/// Styles for input's required state\n/// @access public\n/// @group form-elements\n@mixin input-required {\n  &:required {\n    box-shadow: none;\n  }\n}\n\n/// Styles for input states with thicker borders\n/// @access public\n/// @group form-elements\n@mixin input-padding-thick-border {\n  padding: calc(var(--pharos-spacing-one-half-x) - 1px)\n    calc(var(--pharos-spacing-three-quarters-x) - 1px);\n}\n\n/// Styles for prominent input states with thicker borders\n/// @access public\n/// @group form-elements\n@mixin input-padding-thick-border-prominent {\n  padding: calc(var(--pharos-spacing-1-x) - 1px);\n}\n\n/// Styles for inputs on a background\n/// @access public\n/// @group form-elements\n@mixin input-on-background {\n  background-color: var(--pharos-color-marble-gray-20);\n  border-color: var(--pharos-color-marble-gray-20);\n  color: var(--pharos-color-text-white);\n  caret-color: var(--pharos-color-text-white);\n\n  &::placeholder {\n    color: var(--pharos-color-marble-gray-base);\n  }\n}\n\n/// Styles for input options\n/// @access public\n/// @group form-elements\n@mixin option-input {\n  @include hidden;\n\n  display: block;\n  box-sizing: border-box;\n}\n\n/// Wrapper styles for input options\n/// @access public\n/// @group form-elements\n@mixin option-wrapper {\n  display: inline-flex;\n  align-items: flex-start;\n  position: relative;\n}\n\n/// Styles to hide an element\n/// @access public\n/// @group interaction\n@mixin hidden {\n  border: 0;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  width: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n}\n\n/// Base styles for font.\n/// @param {string} $font-family [var(--pharos-font-family-sans-serif)] - The font family of the font\n/// @param {string} $font-size [var(--pharos-font-size-base)] - The size of the font\n/// @param {string} $font-weight [var(--pharos-font-weight-regular)] - The weight of the font\n/// @param {string} $line-height [var(--pharos-line-height-medium)] - The line height of the font\n/// @access public\n/// @group typography\n@mixin font-base(\n  $font-family: var(--pharos-font-family-sans-serif),\n  $font-size: var(--pharos-font-size-base),\n  $font-weight: var(--pharos-font-weight-regular),\n  $line-height: var(--pharos-line-height-medium)\n) {\n  @if $font-family == var(--pharos-font-family-sans-serif) {\n    @include letter-spacing-sans-serif($font-size);\n  } @else if $font-family == var(--pharos-font-family-serif) {\n    @include letter-spacing-serif($font-size);\n  } @else {\n    @error 'Unknown font-family #{$font-family}.';\n  }\n\n  font-family: $font-family;\n  font-size: $font-size;\n  font-weight: $font-weight;\n  line-height: $line-height;\n  text-rendering: optimizelegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/// Letter spacing for serif type\n/// @access public\n/// @group typography\n@mixin letter-spacing-serif($font-size: 1rem) {\n  @if $font-size != inherit {\n    letter-spacing: calc(#{$font-size} * -0.01);\n  }\n}\n\n/// Letter spacing for sans-serif type\n/// @access public\n/// @group typography\n@mixin letter-spacing-sans-serif($font-size: 1rem) {\n  @if $font-size != inherit {\n    letter-spacing: calc(#{$font-size} * -0.02);\n  }\n}\n\n/// Base styles for labels\n/// @access public\n/// @group form-elements\n@mixin label-base($margin-bottom: var(--pharos-spacing-one-quarter-x), $text-transform: uppercase) {\n  color: var(--pharos-form-element-color-text-base);\n  margin-bottom: $margin-bottom;\n  display: block;\n  padding: 0;\n  text-transform: $text-transform;\n}\n\n/// Styles for labels of form elements\n/// @access public\n/// @group form-elements\n@mixin form-element-label {\n  @include font-base(\n    $font-size: var(--pharos-form-element-size-text-label),\n    $font-weight: var(--pharos-font-weight-bold),\n    $line-height: var(--pharos-line-height-small)\n  );\n  @include label-base;\n}\n\n/// Styles for labels of grouped form elements\n/// @access public\n/// @group form-elements\n@mixin groupable-element-label {\n  @include font-base;\n  @include label-base($margin-bottom: 0, $text-transform: none);\n\n  padding-left: var(--pharos-spacing-one-quarter-x);\n}\n\n/// Styles for icon buttons.\n/// @access public\n/// @group buttons\n@mixin icon-button {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-sizing: border-box;\n  background: none;\n  margin: 0;\n}\n\n/// Focus styles for most interactive components.\n/// @access public\n/// @group interaction\n@mixin interactive-focus {\n  &:focus {\n    outline: 2px solid var(--pharos-color-focus);\n    outline-offset: 2px;\n  }\n}\n\n/// Base styles for buttons.\n/// @param {string} $color [var(--pharos-button-color-base-primary-text-base)] - The color of the text\n/// @param {string} $background-color [vvar(--pharos-button-color-base-primary-background-base)] - The color of the background\n/// @param {string} $border-color [var(--pharos-button-color-base-primary-border-base)] - The color of the border\n/// @access public\n/// @group buttons\n@mixin button-base(\n  $color: var(--pharos-button-color-base-primary-text-base),\n  $background-color: var(--pharos-button-color-base-primary-background-base),\n  $border-color: var(--pharos-button-color-base-primary-border-base)\n) {\n  @include font-base($font-weight: var(--pharos-font-weight-bold));\n  @include transition-base(border-color, background, color);\n\n  color: $color;\n  background-color: $background-color;\n  border: 1px solid $border-color;\n  padding: var(--pharos-spacing-one-quarter-x) var(--pharos-spacing-three-quarters-x);\n  border-radius: var(--pharos-radius-base-standard);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  appearance: none;\n\n  [data-pharos-component='PharosIcon'] {\n    @include transition-base(fill, stroke);\n\n    fill: $color;\n    stroke: $color;\n    stroke-width: 0;\n  }\n\n  [data-pharos-component='PharosIcon']:first-child:not(:only-child) {\n    margin-right: var(--pharos-spacing-one-quarter-x);\n  }\n\n  [data-pharos-component='PharosIcon']:last-child:not(:only-child) {\n    margin-left: var(--pharos-spacing-one-quarter-x);\n  }\n}\n\n/// Hover styles for buttons.\n/// @param {string} $color [var(--pharos-button-color-base-primary-text-hover)] - The color of the text\n/// @param {string} $background-color [var(--pharos-button-color-base-primary-background-hover)] - The color of the background\n/// @param {string} $border-color [var(--pharos-button-color-base-primary-border-hover)] - The color of the border\n/// @access public\n/// @group buttons\n@mixin button-hover(\n  $color: var(--pharos-button-color-base-primary-text-hover),\n  $background-color: var(--pharos-button-color-base-primary-background-hover),\n  $border-color: var(--pharos-button-color-base-primary-border-hover)\n) {\n  &:hover:not([disabled]),\n  &:active:not([disabled]) {\n    color: $color;\n    background-color: $background-color;\n    border: 2px solid $border-color;\n    padding: calc(var(--pharos-spacing-one-quarter-x) - 1px)\n      calc(var(--pharos-spacing-three-quarters-x) - 1px);\n\n    [data-pharos-component='PharosIcon'] {\n      fill: $color;\n      stroke: $color;\n    }\n  }\n}\n\n/// Styles for large buttons.\n/// @access public\n/// @group buttons\n@mixin button-large {\n  padding: var(--pharos-spacing-one-half-x) var(--pharos-spacing-three-quarters-x);\n\n  &:hover:not([disabled]),\n  &:active:not([disabled]) {\n    padding: calc(var(--pharos-spacing-one-half-x) - 1px)\n      calc(var(--pharos-spacing-three-quarters-x) - 1px);\n  }\n}\n\n/// Color styles for buttons.\n/// @param {string} $color [var(--pharos-button-color-base-primary-text-base)] - The color of the text\n/// @param {string} $background-color [var(--pharos-button-color-base-primary-background-base)] - The color of the background\n/// @param {string} $border-color [var(--pharos-button-color-base-primary-border-base)] - The color of the border\n/// @access public\n/// @group buttons\n@mixin button-color(\n  $color: var(--pharos-button-color-base-primary-text-base),\n  $background-color: var(--pharos-button-color-base-primary-background-base),\n  $border-color: var(--pharos-button-color-base-primary-border-base)\n) {\n  color: $color;\n  background-color: $background-color;\n  border-color: $border-color;\n\n  [data-pharos-component='PharosIcon'] {\n    fill: $color;\n    stroke: $color;\n  }\n}\n\n/// Base styles for links.\n/// @access public\n/// @group links\n@mixin link-base {\n  @include font-base($font-size: inherit, $line-height: inherit);\n  @include underline;\n\n  letter-spacing: inherit;\n  color: var(--pharos-color-interactive-secondary);\n  transition-property: color, text-decoration-color;\n  transition-duration: 200ms;\n  transition-timing-function: ease-in-out;\n}\n\n/// Hover style for links.\n/// @access public\n/// @group links\n@mixin link-hover {\n  &:hover {\n    @include no-underline;\n\n    color: var(--pharos-color-hover-primary);\n  }\n}\n\n/// Base styles for underlines.\n/// @param {string} $text-decoration-color [var(--pharos-color-interactive-secondary)] - The color of the underline\n/// @access public\n/// @group links\n@mixin underline($text-decoration-color: var(--pharos-color-interactive-secondary)) {\n  text-decoration: underline;\n  text-decoration-color: $text-decoration-color;\n}\n\n/* stylelint-disable declaration-block-no-redundant-longhand-properties */\n/// Removes underlines.\n/// @access public\n/// @group links\n@mixin no-underline {\n  text-decoration-style: solid;\n  text-decoration-line: underline;\n  text-decoration-color: transparent;\n}\n\n/// Removes bullets from lists.\n/// @access public\n/// @group typography\n@mixin no-bullet {\n  list-style-type: none;\n}\n\n/// Base styles for inline lists.\n/// @param {string} $margin-right [var(--pharos-spacing-one-and-a-half-x)] - The margin between list items\n/// @access public\n/// @group typography\n@mixin list-inline($margin-right: var(--pharos-spacing-one-and-a-half-x)) {\n  @include no-bullet;\n\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n\n  li:not(:last-child) {\n    margin-right: $margin-right;\n    margin-bottom: 0;\n  }\n}\n\n/// Base style for nested lists.\n/// @access public\n/// @group typography\n@mixin list-nested {\n  > li:not(:last-child) {\n    margin-bottom: var(--pharos-spacing-three-quarters-x);\n  }\n}\n\n/// Base styles for transitions.\n/// @param {string} $properties - The transition properties to style\n/// @access public\n/// @group interaction\n@mixin transition-base($properties...) {\n  transition-property: $properties;\n  transition-duration: var(--pharos-transition-duration-default);\n  transition-timing-function: ease-in-out;\n}\n\n/// Base styles for content labels.\n/// @access public\n/// @group typography\n@mixin content-label($args...) {\n  @include form-element-label($args...);\n}\n\n/// Creates a media query that starts at the passed breakpoint.\n/// @param {string} $breakpoint - The breakpoint to use as the minimum\n/// @access public\n/// @group layout\n@mixin at-least($breakpoint) {\n  @if map-has-key(variables.$breakpoints, $breakpoint) {\n    $width: map.get(variables.$breakpoints, $breakpoint, width);\n    @media screen and (min-width: $width) {\n      @content;\n    }\n  } @else {\n    @error 'Unknown breakpoint `#{$breakpoint}`. ' + 'Available breakpoints are: #{map.keys(variables.$breakpoints)}.';\n  }\n}\n\n/// Creates a media query that ranges up to the passed breakpoint.\n/// @param {string} $breakpoint - The breakpoint to use as the maximum\n/// @access public\n/// @group layout\n@mixin until($breakpoint) {\n  @if map-has-key(variables.$breakpoints, $breakpoint) {\n    $width: map.get(variables.$breakpoints, $breakpoint, width);\n    @media screen and (max-width: $width) {\n      @content;\n    }\n  } @else {\n    @error 'Unknown breakpoint `#{$breakpoint}`. ' + 'Available breakpoints are: #{map.keys(variables.$breakpoints)}.';\n  }\n}\n\n/// Creates a media query that ranges between the two passed breakpoints.\n/// @param {string} $lower - The breakpoint to use as the lower bounds\n/// @param {string} $upper - The breakpoint to use as the upper bounds\n/// @access public\n/// @group layout\n@mixin between($lower, $upper) {\n  @if map-has-key(variables.$breakpoints, $lower) and map-has-key(variables.$breakpoints, $upper) {\n    $lower-width: functions.calculate-px(map.get(variables.$breakpoints, $lower, width));\n    $upper-width: functions.calculate-px(map.get(variables.$breakpoints, $upper, width));\n    @media screen and (min-width: $lower-width) and (max-width: $upper-width - 1) {\n      @content;\n    }\n  } @else {\n    @error 'Unknown breakpoint range `#{$lower}` - `#{$upper}`. ' + 'Available breakpoints are: #{map.keys(variables.$breakpoints)}.';\n  }\n}\n\n/// Base style for the layout's outer grid.\n/// @access public\n/// @group layout\n@mixin layout-base {\n  display: grid;\n  grid-template-areas: '. content .';\n}\n\n/// Base style for the layout's inner grid.\n/// @access public\n/// @group layout\n@mixin layout-content {\n  display: grid;\n  grid-area: content;\n  grid-template-columns: repeat(map.get(variables.$breakpoints, large, columns), 1fr);\n  grid-template-rows: auto;\n  column-gap: var(--pharos-spacing-gutter);\n  padding: 0;\n  margin: 0;\n  list-style: none;\n\n  @include until(medium) {\n    grid-template-columns: repeat(map.get(variables.$breakpoints, medium, columns), 1fr);\n    grid-template-rows: auto;\n  }\n\n  @include until(small) {\n    grid-template-columns: repeat(map.get(variables.$breakpoints, small, columns), 1fr);\n    grid-template-rows: auto;\n  }\n}\n\n/// Sets margins for the layout's outer grid.\n/// @param {string} $layout - The layout preset\n/// @access public\n/// @group layout\n@mixin layout-base-columns($layout) {\n  $breakpoints: map.get(variables.$layouts, $layout);\n  $fixed-margin: $layout != '1-col';\n\n  @each $breakpoint, $margin in $breakpoints {\n    $i: list.index($breakpoints, $breakpoint $margin);\n\n    @if $i != length($breakpoints) {\n      $upper: list.nth(map.keys($breakpoints), $i + 1);\n      $max-margin: list.nth(map.values($breakpoints), $i + 1);\n\n      @include between($breakpoint, $upper) {\n        $layout-margin: if($fixed-margin, $margin, minmax($margin, $max-margin));\n\n        grid-template-columns: $layout-margin auto $layout-margin;\n        grid-template-rows: auto;\n      }\n    } @else {\n      @include at-least($breakpoint) {\n        grid-template-columns: minmax($margin, 1fr) auto minmax($margin, 1fr);\n        grid-template-rows: auto;\n      }\n    }\n  }\n}\n\n/// Sets widths for the layout's inner grid.\n/// @param {string} $layout - The layout preset\n/// @access public\n/// @group layout\n@mixin layout-content-width($layout) {\n  $breakpoints: map.get(variables.$layouts, $layout);\n  $fixed-width: $layout == '1-col';\n  $property: if($fixed-width, width, min-width);\n\n  @if $fixed-width {\n    @include at-least(medium) {\n      margin: auto;\n    }\n  }\n\n  @each $breakpoint, $margin in $breakpoints {\n    $i: list.index($breakpoints, $breakpoint $margin);\n\n    @if $i == 1 {\n      @include until($breakpoint) {\n        #{$property}: functions.content-width(\n          map.get(variables.$breakpoints, $breakpoint, width),\n          $margin\n        );\n      }\n    } @else if $i != length($breakpoints) {\n      $upper: list.nth(map.keys($breakpoints), $i + 1);\n\n      @include between($breakpoint, $upper) {\n        #{$property}: functions.content-width(\n          map.get(variables.$breakpoints, $breakpoint, width),\n          $margin,\n          $sidenav: string.index($layout, '--sidenav') and $i > 2\n        );\n      }\n    } @else {\n      @include at-least($breakpoint) {\n        #{$property}: functions.content-width(\n          map.get(variables.$breakpoints, $breakpoint, width),\n          $margin,\n          $sidenav: string.index($layout, '--sidenav')\n        );\n      }\n    }\n  }\n}\n\n/// Truncates text based on number of lines.\n/// @param {number} $lines [1] - The number of lines allowed before truncating\n/// @access public\n/// @group typography\n@mixin truncate-text($lines: 1) {\n  overflow: hidden;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  white-space: normal;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[12].use[1]!./node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[12].use[2]!./packages/pharos/src/pages/search/search.scss":
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-page__container{display:grid;grid-template-columns:17rem 1fr;grid-template-areas:\"header header header\" \"sidebar main .\" \"footer footer footer\";column-gap:6rem}.search-page__container pharos-header{grid-area:header}.search-page__container main{grid-column:main}.search-page__container aside{grid-row:sidebar}.search-page__container pharos-footer{grid-column:footer}.search-page__form{display:grid;grid-template-rows:1fr;row-gap:var(--pharos-spacing-one-and-a-half-x);grid-template-columns:14rem}.search-page__form .search-page__facet{border-top:1px solid var(--pharos-color-ui-30)}.search-page__form .search-page__facet pharos-checkbox-group,.search-page__form .search-page__facet pharos-radio-group,.search-page__form .search-page__facet fieldset{margin-top:var(--pharos-spacing-one-and-a-half-x)}.search-page__form .search-page__facet:last-child{border-bottom:1px solid var(--pharos-color-ui-30)}.search-page__form .search-page__facet:last-child pharos-radio-group{margin-bottom:var(--pharos-spacing-one-and-a-half-x)}.search-page__grid--result{display:grid;grid-template-columns:1rem 9fr 13rem;grid-template-rows:1fr;column-gap:var(--pharos-spacing-1-x)}.search-page__list--results{list-style-type:none;padding-left:0}.search-page__list--results .search-page__list-item--results{margin-bottom:var(--pharos-spacing-5-x)}.search-page__list--action-buttons{list-style-type:none;padding-left:0;display:grid;grid-template-columns:1fr;grid-template-rows:repeat(3, 1fr);margin-top:1.25rem;justify-items:end}.search-page__list-item--action-buttons{width:100%}.search-page__text--metadata{color:var(--pharos-color-marble-gray-40)}.search-page__text--snippet{color:var(--pharos-color-marble-gray-20);font-size:var(--pharos-font-size-small)}.search-page__text--content-type{letter-spacing:calc(var(--pharos-form-element-size-text-label) * -0.02);font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-form-element-size-text-label);font-weight:var(--pharos-font-weight-bold);line-height:var(--pharos-line-height-small);text-rendering:optimizelegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:var(--pharos-form-element-color-text-base);margin-bottom:var(--pharos-spacing-one-quarter-x);display:block;padding:0;text-transform:uppercase;color:var(--pharos-color-marble-gray-40)}.search-page__grid--facets{display:grid;justify-content:center;margin-top:var(--pharos-spacing-3-x);row-gap:var(--pharos-spacing-1-x)}.search-page__fieldset--date{padding:0;margin:0;border:none}.search-page__fieldset--date legend{padding:0;margin-bottom:var(--pharos-spacing-one-half-x)}.search-page__fieldset--date .search-page__text--description{display:block;margin-bottom:var(--pharos-spacing-1-x)}.search-page__grid--date{display:grid;grid-template-rows:1fr 1fr 1fr;row-gap:var(--pharos-spacing-one-half-x);align-items:end}.search-page__grid--image-results{display:grid;grid-template-columns:repeat(6, 1fr);column-gap:var(--pharos-spacing-one-and-a-half-x);margin:var(--pharos-spacing-3-x) 0}.search-page__text--image-title{display:block;font-weight:var(--pharos-font-weight-bold)}.search-page__grid--image{display:grid;justify-content:center;align-items:end;grid-template-rows:13.75rem 1fr;row-gap:var(--pharos-spacing-1-x);cursor:pointer}.search-page__container--image-results{grid-column:span 12}.search-page__container--search-results{margin-bottom:11rem;grid-column:span 10}.search-page__container--results-top-bar{display:flex;margin:var(--pharos-spacing-2-x) 0}.search-page__container--results-content{display:flex;margin:var(--pharos-spacing-3-x) 0 var(--pharos-spacing-one-and-a-half-x) 0;grid-column:span 12}.search-page__container--results-pagination{display:flex}.search-page__container--main-content{display:grid;grid-template-columns:repeat(12, 1fr);column-gap:var(--pharos-spacing-3-x)}.search-page__container--action-buttons{margin-left:var(--pharos-spacing-3-x)}.search-page__container--all-images{row-gap:0;align-items:center;border:1px solid var(--pharos-color-ui-40);text-align:center;padding:0 var(--pharos-spacing-1-x);font-weight:var(--pharos-font-weight-bold)}", "",{"version":3,"sources":["webpack://./packages/pharos/src/pages/search/search.scss","webpack://./packages/pharos/lib/utils/scss/_mixins.scss"],"names":[],"mappings":"AAEA,wBACE,YAAA,CACA,+BAAA,CACA,kFACE,CAGF,eAAA,CAEA,sCACE,gBAAA,CAGF,6BACE,gBAAA,CAGF,8BACE,gBAAA,CAGF,sCACE,kBAAA,CAIJ,mBACE,YAAA,CACA,sBAAA,CACA,8CAAA,CACA,2BAAA,CAEA,uCACE,8CAAA,CAEA,uKAGE,iDAAA,CAGF,kDACE,iDAAA,CAEA,qEACE,oDAAA,CAMR,2BACE,YAAA,CACA,oCAAA,CACA,sBAAA,CACA,oCAAA,CAGF,4BCkVE,oBAAA,CD/UA,cAAA,CAEA,6DACE,uCAAA,CAIJ,mCCwUE,oBAAA,CDrUA,cAAA,CACA,YAAA,CACA,yBAAA,CACA,iCAAA,CACA,kBAAA,CACA,iBAAA,CAGF,wCACE,UAAA,CAGF,6BACE,wCAAA,CAGF,4BACE,wCAAA,CACA,uCAAA,CAGF,iCC4FI,uEAAA,CAvBF,gDAbc,CAcd,oDA0Cc,CAzCd,0CA0CgB,CAzChB,2CA0CgB,CAzChB,iCAAA,CACA,kCAAA,CACA,iCAAA,CAyBA,gDAAA,CACA,iDAFgC,CAGhC,aAAA,CACA,SAAA,CACA,wBALsF,CDhGtF,wCAAA,CAGF,2BACE,YAAA,CACA,sBAAA,CACA,oCAAA,CACA,iCAAA,CAGF,6BACE,SAAA,CACA,QAAA,CACA,WAAA,CAEA,oCACE,SAAA,CACA,8CAAA,CAGF,6DACE,aAAA,CACA,uCAAA,CAIJ,yBACE,YAAA,CACA,8BAAA,CACA,wCAAA,CACA,eAAA,CAGF,kCACE,YAAA,CACA,oCAAA,CACA,iDAAA,CACA,kCAAA,CAGF,gCACE,aAAA,CACA,0CAAA,CAGF,0BACE,YAAA,CACA,sBAAA,CACA,eAAA,CACA,+BAAA,CACA,iCAAA,CACA,cAAA,CAGF,uCACE,mBAAA,CAGF,wCACE,mBAAA,CACA,mBAAA,CAGF,yCACE,YAAA,CACA,kCAAA,CAGF,yCACE,YAAA,CACA,2EAAA,CACA,mBAAA,CAGF,4CACE,YAAA,CAGF,sCACE,YAAA,CACA,qCAAA,CACA,oCAAA,CAGF,wCACE,qCAAA,CAGF,oCACE,SAAA,CACA,kBAAA,CACA,0CAAA,CACA,iBAAA,CACA,mCAAA,CACA,0CAAA","sourcesContent":["@use '@ithaka/pharos/lib/utils/scss/mixins';\n\n.search-page__container {\n  display: grid;\n  grid-template-columns: 17rem 1fr;\n  grid-template-areas:\n    'header header header'\n    'sidebar main .'\n    'footer footer footer';\n  column-gap: 6rem;\n\n  pharos-header {\n    grid-area: header;\n  }\n\n  main {\n    grid-column: main;\n  }\n\n  aside {\n    grid-row: sidebar;\n  }\n\n  pharos-footer {\n    grid-column: footer;\n  }\n}\n\n.search-page__form {\n  display: grid;\n  grid-template-rows: 1fr;\n  row-gap: var(--pharos-spacing-one-and-a-half-x);\n  grid-template-columns: 14rem;\n\n  .search-page__facet {\n    border-top: 1px solid var(--pharos-color-ui-30);\n\n    pharos-checkbox-group,\n    pharos-radio-group,\n    fieldset {\n      margin-top: var(--pharos-spacing-one-and-a-half-x);\n    }\n\n    &:last-child {\n      border-bottom: 1px solid var(--pharos-color-ui-30);\n\n      pharos-radio-group {\n        margin-bottom: var(--pharos-spacing-one-and-a-half-x);\n      }\n    }\n  }\n}\n\n.search-page__grid--result {\n  display: grid;\n  grid-template-columns: 1rem 9fr 13rem;\n  grid-template-rows: 1fr;\n  column-gap: var(--pharos-spacing-1-x);\n}\n\n.search-page__list--results {\n  @include mixins.no-bullet;\n\n  padding-left: 0;\n\n  .search-page__list-item--results {\n    margin-bottom: var(--pharos-spacing-5-x);\n  }\n}\n\n.search-page__list--action-buttons {\n  @include mixins.no-bullet;\n\n  padding-left: 0;\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: repeat(3, 1fr);\n  margin-top: 1.25rem;\n  justify-items: end;\n}\n\n.search-page__list-item--action-buttons {\n  width: 100%;\n}\n\n.search-page__text--metadata {\n  color: var(--pharos-color-marble-gray-40);\n}\n\n.search-page__text--snippet {\n  color: var(--pharos-color-marble-gray-20);\n  font-size: var(--pharos-font-size-small);\n}\n\n.search-page__text--content-type {\n  @include mixins.content-label;\n\n  color: var(--pharos-color-marble-gray-40);\n}\n\n.search-page__grid--facets {\n  display: grid;\n  justify-content: center;\n  margin-top: var(--pharos-spacing-3-x);\n  row-gap: var(--pharos-spacing-1-x);\n}\n\n.search-page__fieldset--date {\n  padding: 0;\n  margin: 0;\n  border: none;\n\n  legend {\n    padding: 0;\n    margin-bottom: var(--pharos-spacing-one-half-x);\n  }\n\n  .search-page__text--description {\n    display: block;\n    margin-bottom: var(--pharos-spacing-1-x);\n  }\n}\n\n.search-page__grid--date {\n  display: grid;\n  grid-template-rows: 1fr 1fr 1fr;\n  row-gap: var(--pharos-spacing-one-half-x);\n  align-items: end;\n}\n\n.search-page__grid--image-results {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  column-gap: var(--pharos-spacing-one-and-a-half-x);\n  margin: var(--pharos-spacing-3-x) 0;\n}\n\n.search-page__text--image-title {\n  display: block;\n  font-weight: var(--pharos-font-weight-bold);\n}\n\n.search-page__grid--image {\n  display: grid;\n  justify-content: center;\n  align-items: end;\n  grid-template-rows: 13.75rem 1fr;\n  row-gap: var(--pharos-spacing-1-x);\n  cursor: pointer;\n}\n\n.search-page__container--image-results {\n  grid-column: span 12;\n}\n\n.search-page__container--search-results {\n  margin-bottom: 11rem;\n  grid-column: span 10;\n}\n\n.search-page__container--results-top-bar {\n  display: flex;\n  margin: var(--pharos-spacing-2-x) 0;\n}\n\n.search-page__container--results-content {\n  display: flex;\n  margin: var(--pharos-spacing-3-x) 0 var(--pharos-spacing-one-and-a-half-x) 0;\n  grid-column: span 12;\n}\n\n.search-page__container--results-pagination {\n  display: flex;\n}\n\n.search-page__container--main-content {\n  display: grid;\n  grid-template-columns: repeat(12, 1fr);\n  column-gap: var(--pharos-spacing-3-x);\n}\n\n.search-page__container--action-buttons {\n  margin-left: var(--pharos-spacing-3-x);\n}\n\n.search-page__container--all-images {\n  row-gap: 0;\n  align-items: center;\n  border: 1px solid var(--pharos-color-ui-40);\n  text-align: center;\n  padding: 0 var(--pharos-spacing-1-x);\n  font-weight: var(--pharos-font-weight-bold);\n}\n","@use 'sass:map';\n@use 'sass:list';\n@use 'sass:string';\n@use './variables';\n@use './functions';\n\n/// Base styles for inputs\n/// @access public\n/// @group form-elements\n@mixin input-base {\n  @include font-base;\n\n  margin: 0;\n  padding: var(--pharos-spacing-one-half-x) var(--pharos-spacing-three-quarters-x);\n  width: 100%;\n  display: block;\n  box-sizing: border-box;\n  border: 1px solid var(--pharos-form-element-color-border-base);\n  border-radius: var(--pharos-radius-base-standard);\n  transition: transform var(--pharos-transition-base) 0s;\n  color: var(--pharos-form-element-color-text-base);\n}\n\n/// Placeholder styles for inputs\n/// @access public\n/// @group form-elements\n@mixin input-placeholder {\n  &::placeholder {\n    color: var(--pharos-form-element-color-text-placeholder);\n    opacity: 1;\n  }\n}\n\n/// Focus styles for inputs\n/// @access public\n/// @group form-elements\n@mixin input-focus {\n  outline: none;\n  border: 2px solid var(--pharos-form-element-color-border-focus);\n  transition: transform var(--pharos-transition-base) 0s;\n}\n\n/// Wrapper styles for inputs\n/// @access public\n/// @group form-elements\n@mixin input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n/// Styles for input's invalid state\n/// @access public\n/// @group form-elements\n@mixin input-invalid {\n  border: 2px solid var(--pharos-form-element-color-border-invalid);\n}\n\n/// Styles for input's disabled state\n/// @access public\n/// @group form-elements\n@mixin input-disabled {\n  color: var(--pharos-form-element-color-text-disabled);\n  background-color: var(--pharos-form-element-color-background-disabled);\n  border-color: var(--pharos-form-element-color-background-disabled);\n  pointer-events: none;\n}\n\n/// Styles for input's required state\n/// @access public\n/// @group form-elements\n@mixin input-required {\n  &:required {\n    box-shadow: none;\n  }\n}\n\n/// Styles for input states with thicker borders\n/// @access public\n/// @group form-elements\n@mixin input-padding-thick-border {\n  padding: calc(var(--pharos-spacing-one-half-x) - 1px)\n    calc(var(--pharos-spacing-three-quarters-x) - 1px);\n}\n\n/// Styles for prominent input states with thicker borders\n/// @access public\n/// @group form-elements\n@mixin input-padding-thick-border-prominent {\n  padding: calc(var(--pharos-spacing-1-x) - 1px);\n}\n\n/// Styles for inputs on a background\n/// @access public\n/// @group form-elements\n@mixin input-on-background {\n  background-color: var(--pharos-color-marble-gray-20);\n  border-color: var(--pharos-color-marble-gray-20);\n  color: var(--pharos-color-text-white);\n  caret-color: var(--pharos-color-text-white);\n\n  &::placeholder {\n    color: var(--pharos-color-marble-gray-base);\n  }\n}\n\n/// Styles for input options\n/// @access public\n/// @group form-elements\n@mixin option-input {\n  @include hidden;\n\n  display: block;\n  box-sizing: border-box;\n}\n\n/// Wrapper styles for input options\n/// @access public\n/// @group form-elements\n@mixin option-wrapper {\n  display: inline-flex;\n  align-items: flex-start;\n  position: relative;\n}\n\n/// Styles to hide an element\n/// @access public\n/// @group interaction\n@mixin hidden {\n  border: 0;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  width: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n}\n\n/// Base styles for font.\n/// @param {string} $font-family [var(--pharos-font-family-sans-serif)] - The font family of the font\n/// @param {string} $font-size [var(--pharos-font-size-base)] - The size of the font\n/// @param {string} $font-weight [var(--pharos-font-weight-regular)] - The weight of the font\n/// @param {string} $line-height [var(--pharos-line-height-medium)] - The line height of the font\n/// @access public\n/// @group typography\n@mixin font-base(\n  $font-family: var(--pharos-font-family-sans-serif),\n  $font-size: var(--pharos-font-size-base),\n  $font-weight: var(--pharos-font-weight-regular),\n  $line-height: var(--pharos-line-height-medium)\n) {\n  @if $font-family == var(--pharos-font-family-sans-serif) {\n    @include letter-spacing-sans-serif($font-size);\n  } @else if $font-family == var(--pharos-font-family-serif) {\n    @include letter-spacing-serif($font-size);\n  } @else {\n    @error 'Unknown font-family #{$font-family}.';\n  }\n\n  font-family: $font-family;\n  font-size: $font-size;\n  font-weight: $font-weight;\n  line-height: $line-height;\n  text-rendering: optimizelegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/// Letter spacing for serif type\n/// @access public\n/// @group typography\n@mixin letter-spacing-serif($font-size: 1rem) {\n  @if $font-size != inherit {\n    letter-spacing: calc(#{$font-size} * -0.01);\n  }\n}\n\n/// Letter spacing for sans-serif type\n/// @access public\n/// @group typography\n@mixin letter-spacing-sans-serif($font-size: 1rem) {\n  @if $font-size != inherit {\n    letter-spacing: calc(#{$font-size} * -0.02);\n  }\n}\n\n/// Base styles for labels\n/// @access public\n/// @group form-elements\n@mixin label-base($margin-bottom: var(--pharos-spacing-one-quarter-x), $text-transform: uppercase) {\n  color: var(--pharos-form-element-color-text-base);\n  margin-bottom: $margin-bottom;\n  display: block;\n  padding: 0;\n  text-transform: $text-transform;\n}\n\n/// Styles for labels of form elements\n/// @access public\n/// @group form-elements\n@mixin form-element-label {\n  @include font-base(\n    $font-size: var(--pharos-form-element-size-text-label),\n    $font-weight: var(--pharos-font-weight-bold),\n    $line-height: var(--pharos-line-height-small)\n  );\n  @include label-base;\n}\n\n/// Styles for labels of grouped form elements\n/// @access public\n/// @group form-elements\n@mixin groupable-element-label {\n  @include font-base;\n  @include label-base($margin-bottom: 0, $text-transform: none);\n\n  padding-left: var(--pharos-spacing-one-quarter-x);\n}\n\n/// Styles for icon buttons.\n/// @access public\n/// @group buttons\n@mixin icon-button {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-sizing: border-box;\n  background: none;\n  margin: 0;\n}\n\n/// Focus styles for most interactive components.\n/// @access public\n/// @group interaction\n@mixin interactive-focus {\n  &:focus {\n    outline: 2px solid var(--pharos-color-focus);\n    outline-offset: 2px;\n  }\n}\n\n/// Base styles for buttons.\n/// @param {string} $color [var(--pharos-button-color-base-primary-text-base)] - The color of the text\n/// @param {string} $background-color [vvar(--pharos-button-color-base-primary-background-base)] - The color of the background\n/// @param {string} $border-color [var(--pharos-button-color-base-primary-border-base)] - The color of the border\n/// @access public\n/// @group buttons\n@mixin button-base(\n  $color: var(--pharos-button-color-base-primary-text-base),\n  $background-color: var(--pharos-button-color-base-primary-background-base),\n  $border-color: var(--pharos-button-color-base-primary-border-base)\n) {\n  @include font-base($font-weight: var(--pharos-font-weight-bold));\n  @include transition-base(border-color, background, color);\n\n  color: $color;\n  background-color: $background-color;\n  border: 1px solid $border-color;\n  padding: var(--pharos-spacing-one-quarter-x) var(--pharos-spacing-three-quarters-x);\n  border-radius: var(--pharos-radius-base-standard);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  appearance: none;\n\n  [data-pharos-component='PharosIcon'] {\n    @include transition-base(fill, stroke);\n\n    fill: $color;\n    stroke: $color;\n    stroke-width: 0;\n  }\n\n  [data-pharos-component='PharosIcon']:first-child:not(:only-child) {\n    margin-right: var(--pharos-spacing-one-quarter-x);\n  }\n\n  [data-pharos-component='PharosIcon']:last-child:not(:only-child) {\n    margin-left: var(--pharos-spacing-one-quarter-x);\n  }\n}\n\n/// Hover styles for buttons.\n/// @param {string} $color [var(--pharos-button-color-base-primary-text-hover)] - The color of the text\n/// @param {string} $background-color [var(--pharos-button-color-base-primary-background-hover)] - The color of the background\n/// @param {string} $border-color [var(--pharos-button-color-base-primary-border-hover)] - The color of the border\n/// @access public\n/// @group buttons\n@mixin button-hover(\n  $color: var(--pharos-button-color-base-primary-text-hover),\n  $background-color: var(--pharos-button-color-base-primary-background-hover),\n  $border-color: var(--pharos-button-color-base-primary-border-hover)\n) {\n  &:hover:not([disabled]),\n  &:active:not([disabled]) {\n    color: $color;\n    background-color: $background-color;\n    border: 2px solid $border-color;\n    padding: calc(var(--pharos-spacing-one-quarter-x) - 1px)\n      calc(var(--pharos-spacing-three-quarters-x) - 1px);\n\n    [data-pharos-component='PharosIcon'] {\n      fill: $color;\n      stroke: $color;\n    }\n  }\n}\n\n/// Styles for large buttons.\n/// @access public\n/// @group buttons\n@mixin button-large {\n  padding: var(--pharos-spacing-one-half-x) var(--pharos-spacing-three-quarters-x);\n\n  &:hover:not([disabled]),\n  &:active:not([disabled]) {\n    padding: calc(var(--pharos-spacing-one-half-x) - 1px)\n      calc(var(--pharos-spacing-three-quarters-x) - 1px);\n  }\n}\n\n/// Color styles for buttons.\n/// @param {string} $color [var(--pharos-button-color-base-primary-text-base)] - The color of the text\n/// @param {string} $background-color [var(--pharos-button-color-base-primary-background-base)] - The color of the background\n/// @param {string} $border-color [var(--pharos-button-color-base-primary-border-base)] - The color of the border\n/// @access public\n/// @group buttons\n@mixin button-color(\n  $color: var(--pharos-button-color-base-primary-text-base),\n  $background-color: var(--pharos-button-color-base-primary-background-base),\n  $border-color: var(--pharos-button-color-base-primary-border-base)\n) {\n  color: $color;\n  background-color: $background-color;\n  border-color: $border-color;\n\n  [data-pharos-component='PharosIcon'] {\n    fill: $color;\n    stroke: $color;\n  }\n}\n\n/// Base styles for links.\n/// @access public\n/// @group links\n@mixin link-base {\n  @include font-base($font-size: inherit, $line-height: inherit);\n  @include underline;\n\n  letter-spacing: inherit;\n  color: var(--pharos-color-interactive-secondary);\n  transition-property: color, text-decoration-color;\n  transition-duration: 200ms;\n  transition-timing-function: ease-in-out;\n}\n\n/// Hover style for links.\n/// @access public\n/// @group links\n@mixin link-hover {\n  &:hover {\n    @include no-underline;\n\n    color: var(--pharos-color-hover-primary);\n  }\n}\n\n/// Base styles for underlines.\n/// @param {string} $text-decoration-color [var(--pharos-color-interactive-secondary)] - The color of the underline\n/// @access public\n/// @group links\n@mixin underline($text-decoration-color: var(--pharos-color-interactive-secondary)) {\n  text-decoration: underline;\n  text-decoration-color: $text-decoration-color;\n}\n\n/* stylelint-disable declaration-block-no-redundant-longhand-properties */\n/// Removes underlines.\n/// @access public\n/// @group links\n@mixin no-underline {\n  text-decoration-style: solid;\n  text-decoration-line: underline;\n  text-decoration-color: transparent;\n}\n\n/// Removes bullets from lists.\n/// @access public\n/// @group typography\n@mixin no-bullet {\n  list-style-type: none;\n}\n\n/// Base styles for inline lists.\n/// @param {string} $margin-right [var(--pharos-spacing-one-and-a-half-x)] - The margin between list items\n/// @access public\n/// @group typography\n@mixin list-inline($margin-right: var(--pharos-spacing-one-and-a-half-x)) {\n  @include no-bullet;\n\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n\n  li:not(:last-child) {\n    margin-right: $margin-right;\n    margin-bottom: 0;\n  }\n}\n\n/// Base style for nested lists.\n/// @access public\n/// @group typography\n@mixin list-nested {\n  > li:not(:last-child) {\n    margin-bottom: var(--pharos-spacing-three-quarters-x);\n  }\n}\n\n/// Base styles for transitions.\n/// @param {string} $properties - The transition properties to style\n/// @access public\n/// @group interaction\n@mixin transition-base($properties...) {\n  transition-property: $properties;\n  transition-duration: var(--pharos-transition-duration-default);\n  transition-timing-function: ease-in-out;\n}\n\n/// Base styles for content labels.\n/// @access public\n/// @group typography\n@mixin content-label($args...) {\n  @include form-element-label($args...);\n}\n\n/// Creates a media query that starts at the passed breakpoint.\n/// @param {string} $breakpoint - The breakpoint to use as the minimum\n/// @access public\n/// @group layout\n@mixin at-least($breakpoint) {\n  @if map-has-key(variables.$breakpoints, $breakpoint) {\n    $width: map.get(variables.$breakpoints, $breakpoint, width);\n    @media screen and (min-width: $width) {\n      @content;\n    }\n  } @else {\n    @error 'Unknown breakpoint `#{$breakpoint}`. ' + 'Available breakpoints are: #{map.keys(variables.$breakpoints)}.';\n  }\n}\n\n/// Creates a media query that ranges up to the passed breakpoint.\n/// @param {string} $breakpoint - The breakpoint to use as the maximum\n/// @access public\n/// @group layout\n@mixin until($breakpoint) {\n  @if map-has-key(variables.$breakpoints, $breakpoint) {\n    $width: map.get(variables.$breakpoints, $breakpoint, width);\n    @media screen and (max-width: $width) {\n      @content;\n    }\n  } @else {\n    @error 'Unknown breakpoint `#{$breakpoint}`. ' + 'Available breakpoints are: #{map.keys(variables.$breakpoints)}.';\n  }\n}\n\n/// Creates a media query that ranges between the two passed breakpoints.\n/// @param {string} $lower - The breakpoint to use as the lower bounds\n/// @param {string} $upper - The breakpoint to use as the upper bounds\n/// @access public\n/// @group layout\n@mixin between($lower, $upper) {\n  @if map-has-key(variables.$breakpoints, $lower) and map-has-key(variables.$breakpoints, $upper) {\n    $lower-width: functions.calculate-px(map.get(variables.$breakpoints, $lower, width));\n    $upper-width: functions.calculate-px(map.get(variables.$breakpoints, $upper, width));\n    @media screen and (min-width: $lower-width) and (max-width: $upper-width - 1) {\n      @content;\n    }\n  } @else {\n    @error 'Unknown breakpoint range `#{$lower}` - `#{$upper}`. ' + 'Available breakpoints are: #{map.keys(variables.$breakpoints)}.';\n  }\n}\n\n/// Base style for the layout's outer grid.\n/// @access public\n/// @group layout\n@mixin layout-base {\n  display: grid;\n  grid-template-areas: '. content .';\n}\n\n/// Base style for the layout's inner grid.\n/// @access public\n/// @group layout\n@mixin layout-content {\n  display: grid;\n  grid-area: content;\n  grid-template-columns: repeat(map.get(variables.$breakpoints, large, columns), 1fr);\n  grid-template-rows: auto;\n  column-gap: var(--pharos-spacing-gutter);\n  padding: 0;\n  margin: 0;\n  list-style: none;\n\n  @include until(medium) {\n    grid-template-columns: repeat(map.get(variables.$breakpoints, medium, columns), 1fr);\n    grid-template-rows: auto;\n  }\n\n  @include until(small) {\n    grid-template-columns: repeat(map.get(variables.$breakpoints, small, columns), 1fr);\n    grid-template-rows: auto;\n  }\n}\n\n/// Sets margins for the layout's outer grid.\n/// @param {string} $layout - The layout preset\n/// @access public\n/// @group layout\n@mixin layout-base-columns($layout) {\n  $breakpoints: map.get(variables.$layouts, $layout);\n  $fixed-margin: $layout != '1-col';\n\n  @each $breakpoint, $margin in $breakpoints {\n    $i: list.index($breakpoints, $breakpoint $margin);\n\n    @if $i != length($breakpoints) {\n      $upper: list.nth(map.keys($breakpoints), $i + 1);\n      $max-margin: list.nth(map.values($breakpoints), $i + 1);\n\n      @include between($breakpoint, $upper) {\n        $layout-margin: if($fixed-margin, $margin, minmax($margin, $max-margin));\n\n        grid-template-columns: $layout-margin auto $layout-margin;\n        grid-template-rows: auto;\n      }\n    } @else {\n      @include at-least($breakpoint) {\n        grid-template-columns: minmax($margin, 1fr) auto minmax($margin, 1fr);\n        grid-template-rows: auto;\n      }\n    }\n  }\n}\n\n/// Sets widths for the layout's inner grid.\n/// @param {string} $layout - The layout preset\n/// @access public\n/// @group layout\n@mixin layout-content-width($layout) {\n  $breakpoints: map.get(variables.$layouts, $layout);\n  $fixed-width: $layout == '1-col';\n  $property: if($fixed-width, width, min-width);\n\n  @if $fixed-width {\n    @include at-least(medium) {\n      margin: auto;\n    }\n  }\n\n  @each $breakpoint, $margin in $breakpoints {\n    $i: list.index($breakpoints, $breakpoint $margin);\n\n    @if $i == 1 {\n      @include until($breakpoint) {\n        #{$property}: functions.content-width(\n          map.get(variables.$breakpoints, $breakpoint, width),\n          $margin\n        );\n      }\n    } @else if $i != length($breakpoints) {\n      $upper: list.nth(map.keys($breakpoints), $i + 1);\n\n      @include between($breakpoint, $upper) {\n        #{$property}: functions.content-width(\n          map.get(variables.$breakpoints, $breakpoint, width),\n          $margin,\n          $sidenav: string.index($layout, '--sidenav') and $i > 2\n        );\n      }\n    } @else {\n      @include at-least($breakpoint) {\n        #{$property}: functions.content-width(\n          map.get(variables.$breakpoints, $breakpoint, width),\n          $margin,\n          $sidenav: string.index($layout, '--sidenav')\n        );\n      }\n    }\n  }\n}\n\n/// Truncates text based on number of lines.\n/// @param {number} $lines [1] - The number of lines allowed before truncating\n/// @access public\n/// @group typography\n@mixin truncate-text($lines: 1) {\n  overflow: hidden;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  white-space: normal;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[12].use[1]!./node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[12].use[2]!./packages/pharos/src/pages/shared/styles/header-revised.scss":
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-revised__container{display:grid;grid-template-areas:\". content .\";grid-template-columns:var(--pharos-spacing-2-x) 1fr var(--pharos-spacing-2-x);padding-top:var(--pharos-spacing-one-and-a-half-x)}.header-revised__container--content{grid-area:content;display:grid;grid-template-areas:\"logo nav account\";grid-template-columns:max-content 1fr max-content;align-items:end;column-gap:var(--pharos-spacing-2-x)}.header-revised__logo{grid-area:logo;margin-bottom:var(--pharos-spacing-one-half-x)}.header-revised__nav{grid-area:nav}.header-revised__container--account{grid-area:account;display:grid;grid-template-rows:repeat(2, 1fr);row-gap:var(--pharos-spacing-one-half-x);margin-bottom:var(--pharos-spacing-one-half-x);justify-content:end}.header-revised__button--pds{justify-self:end}.header-revised__grid--account{display:grid;grid-template-columns:1fr 1fr;column-gap:var(--pharos-spacing-one-and-a-half-x);justify-items:end}.header-revised__grid--account-links{display:grid;grid-template-columns:repeat(2, max-content);column-gap:var(--pharos-spacing-one-and-a-half-x);align-items:center}.header-revised__grid--account-buttons{display:grid;grid-template-columns:repeat(2, max-content);column-gap:var(--pharos-spacing-three-quarters-x);align-items:center}.header-revised__input-group{max-width:43.125rem}.header-revised__icon,.header-revised__image--logo-small,.header-revised__image--logo-medium,.header-revised__input-group{display:none}.header-revised__input-group--show{display:block}@media screen and (min-width: 360px)and (max-width: 1055px){.header-revised__image--logo{display:none}}@media screen and (min-width: 768px)and (max-width: 1055px){.header-revised__container{grid-template-columns:var(--pharos-spacing-1-x) 1fr var(--pharos-spacing-1-x)}.header-revised__container--content{column-gap:var(--pharos-spacing-one-half-x)}.header-revised__container--with-search .header-revised__container--content{column-gap:var(--pharos-spacing-1-x);align-items:center}.header-revised__container--with-search .header-revised__container{grid-template-columns:var(--pharos-spacing-1-x) 1fr var(--pharos-spacing-1-x)}.header-revised__container--with-search .header-revised__nav pharos-dropdown-menu-nav,.header-revised__container--with-search .header-revised__button--pds,.header-revised__container--with-search .header-revised__grid--account{display:none}.header-revised__container--with-search .header-revised__icon,.header-revised__container--with-search .header-revised__input-group{display:block}.header-revised__container--with-search .header-revised__container--account{grid-template-rows:auto;margin-bottom:0}.header-revised__container--with-search .header-revised__logo{display:grid;margin-bottom:0}.header-revised__image--logo-medium{display:block}}@media screen and (min-width: 360px)and (max-width: 767px){.header-revised__container--content{column-gap:var(--pharos-spacing-1-x);align-items:center}.header-revised__container{grid-template-columns:var(--pharos-spacing-1-x) 1fr var(--pharos-spacing-1-x)}.header-revised__nav pharos-dropdown-menu-nav,.header-revised__button--pds,.header-revised__grid--account{display:none}.header-revised__icon,.header-revised__input-group{display:block}.header-revised__container--account{grid-template-rows:auto;margin-bottom:0}.header-revised__logo{display:grid;margin-bottom:0}.header-revised__image--logo-small{display:block}}", "",{"version":3,"sources":["webpack://./packages/pharos/src/pages/shared/styles/header-revised.scss","webpack://./packages/pharos/lib/utils/scss/_mixins.scss"],"names":[],"mappings":"AAkCA,2BACE,YAAA,CACA,iCAAA,CACA,6EAAA,CACA,kDAAA,CAGF,oCACE,iBAAA,CACA,YAAA,CACA,sCAAA,CACA,iDAAA,CACA,eAAA,CACA,oCAAA,CAGF,sBACE,cAAA,CACA,8CAAA,CAGF,qBACE,aAAA,CAGF,oCACE,iBAAA,CACA,YAAA,CACA,iCAAA,CACA,wCAAA,CACA,8CAAA,CACA,mBAAA,CAGF,6BACE,gBAAA,CAGF,+BACE,YAAA,CACA,6BAAA,CACA,iDAAA,CACA,iBAAA,CAGF,qCACE,YAAA,CACA,4CAAA,CACA,iDAAA,CACA,kBAAA,CAGF,uCACE,YAAA,CACA,4CAAA,CACA,iDAAA,CACA,kBAAA,CAGF,6BACE,mBAAA,CAGF,0HAIE,YAAA,CAGF,mCACE,aAAA,CC0XE,4DDtXF,6BACE,YAAA,CAAA,CCqXA,4DDhXF,2BACE,6EAAA,CAGF,oCACE,2CAAA,CArHF,4EACE,oCAAA,CACA,kBAAA,CAGF,mEACE,6EAAA,CAGF,kOAGE,YAAA,CAGF,mIAEE,aAAA,CAGF,4EACE,uBAAA,CACA,eAAA,CAGF,8DACE,YAAA,CACA,eAAA,CAiGF,oCACE,aAAA,CAAA,CCmWA,2DDheF,oCACE,oCAAA,CACA,kBAAA,CAGF,2BACE,6EAAA,CAGF,0GAGE,YAAA,CAGF,mDAEE,aAAA,CAGF,oCACE,uBAAA,CACA,eAAA,CAGF,sBACE,YAAA,CACA,eAAA,CAyGF,mCACE,aAAA,CAAA","sourcesContent":["@use '@ithaka/pharos/lib/styles/pharos';\n\n@mixin responsive-view {\n  .header-revised__container--content {\n    column-gap: var(--pharos-spacing-1-x);\n    align-items: center;\n  }\n\n  .header-revised__container {\n    grid-template-columns: var(--pharos-spacing-1-x) 1fr var(--pharos-spacing-1-x);\n  }\n\n  .header-revised__nav pharos-dropdown-menu-nav,\n  .header-revised__button--pds,\n  .header-revised__grid--account {\n    display: none;\n  }\n\n  .header-revised__icon,\n  .header-revised__input-group {\n    display: block;\n  }\n\n  .header-revised__container--account {\n    grid-template-rows: auto;\n    margin-bottom: 0;\n  }\n\n  .header-revised__logo {\n    display: grid;\n    margin-bottom: 0;\n  }\n}\n\n.header-revised__container {\n  display: grid;\n  grid-template-areas: '. content .';\n  grid-template-columns: var(--pharos-spacing-2-x) 1fr var(--pharos-spacing-2-x);\n  padding-top: var(--pharos-spacing-one-and-a-half-x);\n}\n\n.header-revised__container--content {\n  grid-area: content;\n  display: grid;\n  grid-template-areas: 'logo nav account';\n  grid-template-columns: max-content 1fr max-content;\n  align-items: end;\n  column-gap: var(--pharos-spacing-2-x);\n}\n\n.header-revised__logo {\n  grid-area: logo;\n  margin-bottom: var(--pharos-spacing-one-half-x);\n}\n\n.header-revised__nav {\n  grid-area: nav;\n}\n\n.header-revised__container--account {\n  grid-area: account;\n  display: grid;\n  grid-template-rows: repeat(2, 1fr);\n  row-gap: var(--pharos-spacing-one-half-x);\n  margin-bottom: var(--pharos-spacing-one-half-x);\n  justify-content: end;\n}\n\n.header-revised__button--pds {\n  justify-self: end;\n}\n\n.header-revised__grid--account {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: var(--pharos-spacing-one-and-a-half-x);\n  justify-items: end;\n}\n\n.header-revised__grid--account-links {\n  display: grid;\n  grid-template-columns: repeat(2, max-content);\n  column-gap: var(--pharos-spacing-one-and-a-half-x);\n  align-items: center;\n}\n\n.header-revised__grid--account-buttons {\n  display: grid;\n  grid-template-columns: repeat(2, max-content);\n  column-gap: var(--pharos-spacing-three-quarters-x);\n  align-items: center;\n}\n\n.header-revised__input-group {\n  max-width: 43.125rem;\n}\n\n.header-revised__icon,\n.header-revised__image--logo-small,\n.header-revised__image--logo-medium,\n.header-revised__input-group {\n  display: none;\n}\n\n.header-revised__input-group--show {\n  display: block;\n}\n\n@include pharos.between(small, large) {\n  .header-revised__image--logo {\n    display: none;\n  }\n}\n\n@include pharos.between(medium, large) {\n  .header-revised__container {\n    grid-template-columns: var(--pharos-spacing-1-x) 1fr var(--pharos-spacing-1-x);\n  }\n\n  .header-revised__container--content {\n    column-gap: var(--pharos-spacing-one-half-x);\n  }\n\n  .header-revised__container--with-search {\n    @include responsive-view;\n  }\n\n  .header-revised__image--logo-medium {\n    display: block;\n  }\n}\n\n@include pharos.between(small, medium) {\n  @include responsive-view;\n\n  .header-revised__image--logo-small {\n    display: block;\n  }\n}\n","@use 'sass:map';\n@use 'sass:list';\n@use 'sass:string';\n@use './variables';\n@use './functions';\n\n/// Base styles for inputs\n/// @access public\n/// @group form-elements\n@mixin input-base {\n  @include font-base;\n\n  margin: 0;\n  padding: var(--pharos-spacing-one-half-x) var(--pharos-spacing-three-quarters-x);\n  width: 100%;\n  display: block;\n  box-sizing: border-box;\n  border: 1px solid var(--pharos-form-element-color-border-base);\n  border-radius: var(--pharos-radius-base-standard);\n  transition: transform var(--pharos-transition-base) 0s;\n  color: var(--pharos-form-element-color-text-base);\n}\n\n/// Placeholder styles for inputs\n/// @access public\n/// @group form-elements\n@mixin input-placeholder {\n  &::placeholder {\n    color: var(--pharos-form-element-color-text-placeholder);\n    opacity: 1;\n  }\n}\n\n/// Focus styles for inputs\n/// @access public\n/// @group form-elements\n@mixin input-focus {\n  outline: none;\n  border: 2px solid var(--pharos-form-element-color-border-focus);\n  transition: transform var(--pharos-transition-base) 0s;\n}\n\n/// Wrapper styles for inputs\n/// @access public\n/// @group form-elements\n@mixin input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n/// Styles for input's invalid state\n/// @access public\n/// @group form-elements\n@mixin input-invalid {\n  border: 2px solid var(--pharos-form-element-color-border-invalid);\n}\n\n/// Styles for input's disabled state\n/// @access public\n/// @group form-elements\n@mixin input-disabled {\n  color: var(--pharos-form-element-color-text-disabled);\n  background-color: var(--pharos-form-element-color-background-disabled);\n  border-color: var(--pharos-form-element-color-background-disabled);\n  pointer-events: none;\n}\n\n/// Styles for input's required state\n/// @access public\n/// @group form-elements\n@mixin input-required {\n  &:required {\n    box-shadow: none;\n  }\n}\n\n/// Styles for input states with thicker borders\n/// @access public\n/// @group form-elements\n@mixin input-padding-thick-border {\n  padding: calc(var(--pharos-spacing-one-half-x) - 1px)\n    calc(var(--pharos-spacing-three-quarters-x) - 1px);\n}\n\n/// Styles for prominent input states with thicker borders\n/// @access public\n/// @group form-elements\n@mixin input-padding-thick-border-prominent {\n  padding: calc(var(--pharos-spacing-1-x) - 1px);\n}\n\n/// Styles for inputs on a background\n/// @access public\n/// @group form-elements\n@mixin input-on-background {\n  background-color: var(--pharos-color-marble-gray-20);\n  border-color: var(--pharos-color-marble-gray-20);\n  color: var(--pharos-color-text-white);\n  caret-color: var(--pharos-color-text-white);\n\n  &::placeholder {\n    color: var(--pharos-color-marble-gray-base);\n  }\n}\n\n/// Styles for input options\n/// @access public\n/// @group form-elements\n@mixin option-input {\n  @include hidden;\n\n  display: block;\n  box-sizing: border-box;\n}\n\n/// Wrapper styles for input options\n/// @access public\n/// @group form-elements\n@mixin option-wrapper {\n  display: inline-flex;\n  align-items: flex-start;\n  position: relative;\n}\n\n/// Styles to hide an element\n/// @access public\n/// @group interaction\n@mixin hidden {\n  border: 0;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  width: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n}\n\n/// Base styles for font.\n/// @param {string} $font-family [var(--pharos-font-family-sans-serif)] - The font family of the font\n/// @param {string} $font-size [var(--pharos-font-size-base)] - The size of the font\n/// @param {string} $font-weight [var(--pharos-font-weight-regular)] - The weight of the font\n/// @param {string} $line-height [var(--pharos-line-height-medium)] - The line height of the font\n/// @access public\n/// @group typography\n@mixin font-base(\n  $font-family: var(--pharos-font-family-sans-serif),\n  $font-size: var(--pharos-font-size-base),\n  $font-weight: var(--pharos-font-weight-regular),\n  $line-height: var(--pharos-line-height-medium)\n) {\n  @if $font-family == var(--pharos-font-family-sans-serif) {\n    @include letter-spacing-sans-serif($font-size);\n  } @else if $font-family == var(--pharos-font-family-serif) {\n    @include letter-spacing-serif($font-size);\n  } @else {\n    @error 'Unknown font-family #{$font-family}.';\n  }\n\n  font-family: $font-family;\n  font-size: $font-size;\n  font-weight: $font-weight;\n  line-height: $line-height;\n  text-rendering: optimizelegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/// Letter spacing for serif type\n/// @access public\n/// @group typography\n@mixin letter-spacing-serif($font-size: 1rem) {\n  @if $font-size != inherit {\n    letter-spacing: calc(#{$font-size} * -0.01);\n  }\n}\n\n/// Letter spacing for sans-serif type\n/// @access public\n/// @group typography\n@mixin letter-spacing-sans-serif($font-size: 1rem) {\n  @if $font-size != inherit {\n    letter-spacing: calc(#{$font-size} * -0.02);\n  }\n}\n\n/// Base styles for labels\n/// @access public\n/// @group form-elements\n@mixin label-base($margin-bottom: var(--pharos-spacing-one-quarter-x), $text-transform: uppercase) {\n  color: var(--pharos-form-element-color-text-base);\n  margin-bottom: $margin-bottom;\n  display: block;\n  padding: 0;\n  text-transform: $text-transform;\n}\n\n/// Styles for labels of form elements\n/// @access public\n/// @group form-elements\n@mixin form-element-label {\n  @include font-base(\n    $font-size: var(--pharos-form-element-size-text-label),\n    $font-weight: var(--pharos-font-weight-bold),\n    $line-height: var(--pharos-line-height-small)\n  );\n  @include label-base;\n}\n\n/// Styles for labels of grouped form elements\n/// @access public\n/// @group form-elements\n@mixin groupable-element-label {\n  @include font-base;\n  @include label-base($margin-bottom: 0, $text-transform: none);\n\n  padding-left: var(--pharos-spacing-one-quarter-x);\n}\n\n/// Styles for icon buttons.\n/// @access public\n/// @group buttons\n@mixin icon-button {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-sizing: border-box;\n  background: none;\n  margin: 0;\n}\n\n/// Focus styles for most interactive components.\n/// @access public\n/// @group interaction\n@mixin interactive-focus {\n  &:focus {\n    outline: 2px solid var(--pharos-color-focus);\n    outline-offset: 2px;\n  }\n}\n\n/// Base styles for buttons.\n/// @param {string} $color [var(--pharos-button-color-base-primary-text-base)] - The color of the text\n/// @param {string} $background-color [vvar(--pharos-button-color-base-primary-background-base)] - The color of the background\n/// @param {string} $border-color [var(--pharos-button-color-base-primary-border-base)] - The color of the border\n/// @access public\n/// @group buttons\n@mixin button-base(\n  $color: var(--pharos-button-color-base-primary-text-base),\n  $background-color: var(--pharos-button-color-base-primary-background-base),\n  $border-color: var(--pharos-button-color-base-primary-border-base)\n) {\n  @include font-base($font-weight: var(--pharos-font-weight-bold));\n  @include transition-base(border-color, background, color);\n\n  color: $color;\n  background-color: $background-color;\n  border: 1px solid $border-color;\n  padding: var(--pharos-spacing-one-quarter-x) var(--pharos-spacing-three-quarters-x);\n  border-radius: var(--pharos-radius-base-standard);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  appearance: none;\n\n  [data-pharos-component='PharosIcon'] {\n    @include transition-base(fill, stroke);\n\n    fill: $color;\n    stroke: $color;\n    stroke-width: 0;\n  }\n\n  [data-pharos-component='PharosIcon']:first-child:not(:only-child) {\n    margin-right: var(--pharos-spacing-one-quarter-x);\n  }\n\n  [data-pharos-component='PharosIcon']:last-child:not(:only-child) {\n    margin-left: var(--pharos-spacing-one-quarter-x);\n  }\n}\n\n/// Hover styles for buttons.\n/// @param {string} $color [var(--pharos-button-color-base-primary-text-hover)] - The color of the text\n/// @param {string} $background-color [var(--pharos-button-color-base-primary-background-hover)] - The color of the background\n/// @param {string} $border-color [var(--pharos-button-color-base-primary-border-hover)] - The color of the border\n/// @access public\n/// @group buttons\n@mixin button-hover(\n  $color: var(--pharos-button-color-base-primary-text-hover),\n  $background-color: var(--pharos-button-color-base-primary-background-hover),\n  $border-color: var(--pharos-button-color-base-primary-border-hover)\n) {\n  &:hover:not([disabled]),\n  &:active:not([disabled]) {\n    color: $color;\n    background-color: $background-color;\n    border: 2px solid $border-color;\n    padding: calc(var(--pharos-spacing-one-quarter-x) - 1px)\n      calc(var(--pharos-spacing-three-quarters-x) - 1px);\n\n    [data-pharos-component='PharosIcon'] {\n      fill: $color;\n      stroke: $color;\n    }\n  }\n}\n\n/// Styles for large buttons.\n/// @access public\n/// @group buttons\n@mixin button-large {\n  padding: var(--pharos-spacing-one-half-x) var(--pharos-spacing-three-quarters-x);\n\n  &:hover:not([disabled]),\n  &:active:not([disabled]) {\n    padding: calc(var(--pharos-spacing-one-half-x) - 1px)\n      calc(var(--pharos-spacing-three-quarters-x) - 1px);\n  }\n}\n\n/// Color styles for buttons.\n/// @param {string} $color [var(--pharos-button-color-base-primary-text-base)] - The color of the text\n/// @param {string} $background-color [var(--pharos-button-color-base-primary-background-base)] - The color of the background\n/// @param {string} $border-color [var(--pharos-button-color-base-primary-border-base)] - The color of the border\n/// @access public\n/// @group buttons\n@mixin button-color(\n  $color: var(--pharos-button-color-base-primary-text-base),\n  $background-color: var(--pharos-button-color-base-primary-background-base),\n  $border-color: var(--pharos-button-color-base-primary-border-base)\n) {\n  color: $color;\n  background-color: $background-color;\n  border-color: $border-color;\n\n  [data-pharos-component='PharosIcon'] {\n    fill: $color;\n    stroke: $color;\n  }\n}\n\n/// Base styles for links.\n/// @access public\n/// @group links\n@mixin link-base {\n  @include font-base($font-size: inherit, $line-height: inherit);\n  @include underline;\n\n  letter-spacing: inherit;\n  color: var(--pharos-color-interactive-secondary);\n  transition-property: color, text-decoration-color;\n  transition-duration: 200ms;\n  transition-timing-function: ease-in-out;\n}\n\n/// Hover style for links.\n/// @access public\n/// @group links\n@mixin link-hover {\n  &:hover {\n    @include no-underline;\n\n    color: var(--pharos-color-hover-primary);\n  }\n}\n\n/// Base styles for underlines.\n/// @param {string} $text-decoration-color [var(--pharos-color-interactive-secondary)] - The color of the underline\n/// @access public\n/// @group links\n@mixin underline($text-decoration-color: var(--pharos-color-interactive-secondary)) {\n  text-decoration: underline;\n  text-decoration-color: $text-decoration-color;\n}\n\n/* stylelint-disable declaration-block-no-redundant-longhand-properties */\n/// Removes underlines.\n/// @access public\n/// @group links\n@mixin no-underline {\n  text-decoration-style: solid;\n  text-decoration-line: underline;\n  text-decoration-color: transparent;\n}\n\n/// Removes bullets from lists.\n/// @access public\n/// @group typography\n@mixin no-bullet {\n  list-style-type: none;\n}\n\n/// Base styles for inline lists.\n/// @param {string} $margin-right [var(--pharos-spacing-one-and-a-half-x)] - The margin between list items\n/// @access public\n/// @group typography\n@mixin list-inline($margin-right: var(--pharos-spacing-one-and-a-half-x)) {\n  @include no-bullet;\n\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n\n  li:not(:last-child) {\n    margin-right: $margin-right;\n    margin-bottom: 0;\n  }\n}\n\n/// Base style for nested lists.\n/// @access public\n/// @group typography\n@mixin list-nested {\n  > li:not(:last-child) {\n    margin-bottom: var(--pharos-spacing-three-quarters-x);\n  }\n}\n\n/// Base styles for transitions.\n/// @param {string} $properties - The transition properties to style\n/// @access public\n/// @group interaction\n@mixin transition-base($properties...) {\n  transition-property: $properties;\n  transition-duration: var(--pharos-transition-duration-default);\n  transition-timing-function: ease-in-out;\n}\n\n/// Base styles for content labels.\n/// @access public\n/// @group typography\n@mixin content-label($args...) {\n  @include form-element-label($args...);\n}\n\n/// Creates a media query that starts at the passed breakpoint.\n/// @param {string} $breakpoint - The breakpoint to use as the minimum\n/// @access public\n/// @group layout\n@mixin at-least($breakpoint) {\n  @if map-has-key(variables.$breakpoints, $breakpoint) {\n    $width: map.get(variables.$breakpoints, $breakpoint, width);\n    @media screen and (min-width: $width) {\n      @content;\n    }\n  } @else {\n    @error 'Unknown breakpoint `#{$breakpoint}`. ' + 'Available breakpoints are: #{map.keys(variables.$breakpoints)}.';\n  }\n}\n\n/// Creates a media query that ranges up to the passed breakpoint.\n/// @param {string} $breakpoint - The breakpoint to use as the maximum\n/// @access public\n/// @group layout\n@mixin until($breakpoint) {\n  @if map-has-key(variables.$breakpoints, $breakpoint) {\n    $width: map.get(variables.$breakpoints, $breakpoint, width);\n    @media screen and (max-width: $width) {\n      @content;\n    }\n  } @else {\n    @error 'Unknown breakpoint `#{$breakpoint}`. ' + 'Available breakpoints are: #{map.keys(variables.$breakpoints)}.';\n  }\n}\n\n/// Creates a media query that ranges between the two passed breakpoints.\n/// @param {string} $lower - The breakpoint to use as the lower bounds\n/// @param {string} $upper - The breakpoint to use as the upper bounds\n/// @access public\n/// @group layout\n@mixin between($lower, $upper) {\n  @if map-has-key(variables.$breakpoints, $lower) and map-has-key(variables.$breakpoints, $upper) {\n    $lower-width: functions.calculate-px(map.get(variables.$breakpoints, $lower, width));\n    $upper-width: functions.calculate-px(map.get(variables.$breakpoints, $upper, width));\n    @media screen and (min-width: $lower-width) and (max-width: $upper-width - 1) {\n      @content;\n    }\n  } @else {\n    @error 'Unknown breakpoint range `#{$lower}` - `#{$upper}`. ' + 'Available breakpoints are: #{map.keys(variables.$breakpoints)}.';\n  }\n}\n\n/// Base style for the layout's outer grid.\n/// @access public\n/// @group layout\n@mixin layout-base {\n  display: grid;\n  grid-template-areas: '. content .';\n}\n\n/// Base style for the layout's inner grid.\n/// @access public\n/// @group layout\n@mixin layout-content {\n  display: grid;\n  grid-area: content;\n  grid-template-columns: repeat(map.get(variables.$breakpoints, large, columns), 1fr);\n  grid-template-rows: auto;\n  column-gap: var(--pharos-spacing-gutter);\n  padding: 0;\n  margin: 0;\n  list-style: none;\n\n  @include until(medium) {\n    grid-template-columns: repeat(map.get(variables.$breakpoints, medium, columns), 1fr);\n    grid-template-rows: auto;\n  }\n\n  @include until(small) {\n    grid-template-columns: repeat(map.get(variables.$breakpoints, small, columns), 1fr);\n    grid-template-rows: auto;\n  }\n}\n\n/// Sets margins for the layout's outer grid.\n/// @param {string} $layout - The layout preset\n/// @access public\n/// @group layout\n@mixin layout-base-columns($layout) {\n  $breakpoints: map.get(variables.$layouts, $layout);\n  $fixed-margin: $layout != '1-col';\n\n  @each $breakpoint, $margin in $breakpoints {\n    $i: list.index($breakpoints, $breakpoint $margin);\n\n    @if $i != length($breakpoints) {\n      $upper: list.nth(map.keys($breakpoints), $i + 1);\n      $max-margin: list.nth(map.values($breakpoints), $i + 1);\n\n      @include between($breakpoint, $upper) {\n        $layout-margin: if($fixed-margin, $margin, minmax($margin, $max-margin));\n\n        grid-template-columns: $layout-margin auto $layout-margin;\n        grid-template-rows: auto;\n      }\n    } @else {\n      @include at-least($breakpoint) {\n        grid-template-columns: minmax($margin, 1fr) auto minmax($margin, 1fr);\n        grid-template-rows: auto;\n      }\n    }\n  }\n}\n\n/// Sets widths for the layout's inner grid.\n/// @param {string} $layout - The layout preset\n/// @access public\n/// @group layout\n@mixin layout-content-width($layout) {\n  $breakpoints: map.get(variables.$layouts, $layout);\n  $fixed-width: $layout == '1-col';\n  $property: if($fixed-width, width, min-width);\n\n  @if $fixed-width {\n    @include at-least(medium) {\n      margin: auto;\n    }\n  }\n\n  @each $breakpoint, $margin in $breakpoints {\n    $i: list.index($breakpoints, $breakpoint $margin);\n\n    @if $i == 1 {\n      @include until($breakpoint) {\n        #{$property}: functions.content-width(\n          map.get(variables.$breakpoints, $breakpoint, width),\n          $margin\n        );\n      }\n    } @else if $i != length($breakpoints) {\n      $upper: list.nth(map.keys($breakpoints), $i + 1);\n\n      @include between($breakpoint, $upper) {\n        #{$property}: functions.content-width(\n          map.get(variables.$breakpoints, $breakpoint, width),\n          $margin,\n          $sidenav: string.index($layout, '--sidenav') and $i > 2\n        );\n      }\n    } @else {\n      @include at-least($breakpoint) {\n        #{$property}: functions.content-width(\n          map.get(variables.$breakpoints, $breakpoint, width),\n          $margin,\n          $sidenav: string.index($layout, '--sidenav')\n        );\n      }\n    }\n  }\n}\n\n/// Truncates text based on number of lines.\n/// @param {number} $lines [1] - The number of lines allowed before truncating\n/// @access public\n/// @group typography\n@mixin truncate-text($lines: 1) {\n  overflow: hidden;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  white-space: normal;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "./.storybook/docsPageConfig.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": () => (/* binding */ configureDocsPage)
});

// EXTERNAL MODULE: ./node_modules/@storybook/addon-docs/dist/esm/index.js
var esm = __webpack_require__("./node_modules/@storybook/addon-docs/dist/esm/index.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
;// CONCATENATED MODULE: ./packages/pharos/src/utils/PharosContext.tsx

const PharosContext = (0,react.createContext)(null);

;// CONCATENATED MODULE: ./packages/pharos/src/utils/createReactComponent.tsx


const toEventName = (key) => {
  return key.replace(/^(on)/, "").toLowerCase();
};
const camelToKebab = (prop) => {
  return prop.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, "$1-$2").toLowerCase();
};
const createReactComponent = (name) => {
  return (0,react.forwardRef)(
    (props, ref) => {
      const elementRef = (0,react.useRef)(null);
      (0,react.useLayoutEffect)(() => {
        const { current } = elementRef;
        Object.entries(props).forEach(([prop, value]) => {
          if (prop === "children" || prop === "style" || current === null) {
            return;
          } else if (prop === "className" || prop === "tabIndex") {
            current[prop] = value;
          } else if (typeof value === "function" && prop.match(/^on[A-Z]/)) {
            current.addEventListener(toEventName(prop), value);
          } else if (typeof value === "string" || typeof value === "number") {
            current.setAttribute(camelToKebab(prop), value);
          } else if (typeof value === "boolean") {
            const attr = camelToKebab(prop);
            if (value) {
              current.setAttribute(attr, "");
            } else {
              current.removeAttribute(attr);
            }
          } else {
            current[prop] = value;
          }
        });
        return () => {
          Object.entries(props).forEach(([prop, value]) => {
            if (typeof value === "function" && prop.match(/^on[A-Z]/)) {
              current == null ? void 0 : current.removeEventListener(toEventName(prop), value);
            }
          });
        };
      });
      (0,react.useImperativeHandle)(ref, () => elementRef.current);
      const { children, style } = props;
      const context = (0,react.useContext)(PharosContext);
      const tagName = (context == null ? void 0 : context.prefix) ? `${context.prefix}-${name}` : name;
      return (0,react.createElement)(tagName, { ref: elementRef, style }, children);
    }
  );
};
/* harmony default export */ const utils_createReactComponent = (createReactComponent);

// EXTERNAL MODULE: ./packages/pharos/src/components/link/pharos-link.ts + 1 modules
var pharos_link = __webpack_require__("./packages/pharos/src/components/link/pharos-link.ts");
;// CONCATENATED MODULE: ./packages/pharos/src/react-components/link/pharos-link.tsx


let registeredName;
try {
  registeredName = new pharos_link/* PharosLink */.G().localName;
} catch (err) {
}
const tag = registeredName ? registeredName : "pharos-link";
const PharosLink = utils_createReactComponent(tag);
PharosLink.displayName = "PharosLink";
PharosLink.defaultProps = {
  subtle: false,
  onBackground: false,
  bold: false,
  flex: false,
  skip: false,
  noHover: false,
  indicateVisited: false
};

;// CONCATENATED MODULE: ./.storybook/GuidelineLink.tsx
/* provided dependency */ var React = __webpack_require__("./node_modules/react/index.js");

const GuidelineLink = ({ path }) => /* @__PURE__ */ React.createElement(PharosLink, {
  href: `https://pharos.jstor.org/components/${path}`,
  target: "_blank"
}, "See guidelines in Pharos");

;// CONCATENATED MODULE: ./.storybook/docsPageConfig.jsx
/* provided dependency */ var docsPageConfig_React = __webpack_require__("./node_modules/react/index.js");


const configureDocsPage = (componentName) => {
  return () => /* @__PURE__ */ docsPageConfig_React.createElement(docsPageConfig_React.Fragment, null, /* @__PURE__ */ docsPageConfig_React.createElement(esm/* Title */.Dx, null), /* @__PURE__ */ docsPageConfig_React.createElement(esm/* Subtitle */.QE, null), /* @__PURE__ */ docsPageConfig_React.createElement(esm/* Description */.dk, null), componentName && /* @__PURE__ */ docsPageConfig_React.createElement(GuidelineLink, {
    path: componentName
  }), /* @__PURE__ */ docsPageConfig_React.createElement(esm/* Primary */.sq, null), /* @__PURE__ */ docsPageConfig_React.createElement(esm/* ArgsTable */.$4, {
    story: esm/* PRIMARY_STORY */.Uh
  }), /* @__PURE__ */ docsPageConfig_React.createElement(esm/* Stories */.fQ, null));
};


/***/ }),

/***/ "./.storybook/wc/preview.js-generated-config-entry.js":
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";

// NAMESPACE OBJECT: ./.storybook/wc/preview.js
var wc_preview_namespaceObject = {};
__webpack_require__.r(wc_preview_namespaceObject);
__webpack_require__.d(wc_preview_namespaceObject, {
  "parameters": () => (parameters)
});

// EXTERNAL MODULE: ./node_modules/@storybook/client-api/dist/esm/ClientApi.js + 4 modules
var ClientApi = __webpack_require__("./node_modules/@storybook/client-api/dist/esm/ClientApi.js");
// EXTERNAL MODULE: ./node_modules/@storybook/web-components/dist/esm/client/index.js + 30 modules
var client = __webpack_require__("./node_modules/@storybook/web-components/dist/esm/client/index.js");
;// CONCATENATED MODULE: ./packages/pharos/custom-elements.json
const custom_elements_namespaceObject = JSON.parse('{"schemaVersion":"1.0.0","readme":"","modules":[{"kind":"javascript-module","path":"src/styles/tokens.ts","declarations":[{"kind":"variable","name":"tokens","type":{"text":"object"},"default":"{\\n  \\"asset\\": {\\n    \\"icon\\": {\\n      \\"academic-content\\": {\\n        \\"value\\": \\"assets/icons/academic-content.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/academic-content.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconAcademicContent\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"academic-content\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"academic-content\\"\\n        ]\\n      },\\n      \\"add\\": {\\n        \\"value\\": \\"assets/icons/add.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/add.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconAdd\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"add\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"add\\"\\n        ]\\n      },\\n      \\"arrow-down\\": {\\n        \\"value\\": \\"assets/icons/arrow-down.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/arrow-down.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconArrowDown\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"arrow-down\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"arrow-down\\"\\n        ]\\n      },\\n      \\"arrow-left\\": {\\n        \\"value\\": \\"assets/icons/arrow-left.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/arrow-left.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconArrowLeft\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"arrow-left\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"arrow-left\\"\\n        ]\\n      },\\n      \\"arrow-right\\": {\\n        \\"value\\": \\"assets/icons/arrow-right.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/arrow-right.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconArrowRight\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"arrow-right\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"arrow-right\\"\\n        ]\\n      },\\n      \\"arrow-up\\": {\\n        \\"value\\": \\"assets/icons/arrow-up.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/arrow-up.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconArrowUp\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"arrow-up\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"arrow-up\\"\\n        ]\\n      },\\n      \\"attachment\\": {\\n        \\"value\\": \\"assets/icons/attachment.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/attachment.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconAttachment\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"attachment\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"attachment\\"\\n        ]\\n      },\\n      \\"base\\": {\\n        \\"value\\": \\"assets/icons/base.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/base.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconBase\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"base\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"base\\"\\n        ]\\n      },\\n      \\"book\\": {\\n        \\"value\\": \\"assets/icons/book.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/book.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconBook\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"book\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"book\\"\\n        ]\\n      },\\n      \\"calendar\\": {\\n        \\"value\\": \\"assets/icons/calendar.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/calendar.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconCalendar\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"calendar\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"calendar\\"\\n        ]\\n      },\\n      \\"checkmark-filled-circle\\": {\\n        \\"value\\": \\"assets/icons/checkmark-filled-circle.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/checkmark-filled-circle.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconCheckmarkFilledCircle\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"checkmark-filled-circle\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"checkmark-filled-circle\\"\\n        ]\\n      },\\n      \\"checkmark-inverse\\": {\\n        \\"value\\": \\"assets/icons/checkmark-inverse.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/checkmark-inverse.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconCheckmarkInverse\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"checkmark-inverse\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"checkmark-inverse\\"\\n        ]\\n      },\\n      \\"checkmark-small\\": {\\n        \\"value\\": \\"assets/icons/checkmark-small.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/checkmark-small.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconCheckmarkSmall\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"checkmark-small\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"checkmark-small\\"\\n        ]\\n      },\\n      \\"checkmark\\": {\\n        \\"value\\": \\"assets/icons/checkmark.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/checkmark.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconCheckmark\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"checkmark\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"checkmark\\"\\n        ]\\n      },\\n      \\"chevron-down\\": {\\n        \\"value\\": \\"assets/icons/chevron-down.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/chevron-down.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconChevronDown\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"chevron-down\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"chevron-down\\"\\n        ]\\n      },\\n      \\"chevron-left-large\\": {\\n        \\"value\\": \\"assets/icons/chevron-left-large.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/chevron-left-large.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconChevronLeftLarge\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"chevron-left-large\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"chevron-left-large\\"\\n        ]\\n      },\\n      \\"chevron-left\\": {\\n        \\"value\\": \\"assets/icons/chevron-left.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/chevron-left.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconChevronLeft\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"chevron-left\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"chevron-left\\"\\n        ]\\n      },\\n      \\"chevron-right-large\\": {\\n        \\"value\\": \\"assets/icons/chevron-right-large.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/chevron-right-large.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconChevronRightLarge\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"chevron-right-large\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"chevron-right-large\\"\\n        ]\\n      },\\n      \\"chevron-right\\": {\\n        \\"value\\": \\"assets/icons/chevron-right.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/chevron-right.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconChevronRight\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"chevron-right\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"chevron-right\\"\\n        ]\\n      },\\n      \\"chevron-up\\": {\\n        \\"value\\": \\"assets/icons/chevron-up.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/chevron-up.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconChevronUp\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"chevron-up\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"chevron-up\\"\\n        ]\\n      },\\n      \\"circle\\": {\\n        \\"value\\": \\"assets/icons/circle.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/circle.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconCircle\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"circle\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"circle\\"\\n        ]\\n      },\\n      \\"cite\\": {\\n        \\"value\\": \\"assets/icons/cite.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/cite.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconCite\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"cite\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"cite\\"\\n        ]\\n      },\\n      \\"close-inverse\\": {\\n        \\"value\\": \\"assets/icons/close-inverse.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/close-inverse.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconCloseInverse\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"close-inverse\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"close-inverse\\"\\n        ]\\n      },\\n      \\"close\\": {\\n        \\"value\\": \\"assets/icons/close.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/close.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconClose\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"close\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"close\\"\\n        ]\\n      },\\n      \\"collapse\\": {\\n        \\"value\\": \\"assets/icons/shift-right.svg\\",\\n        \\"deprecated\\": true,\\n        \\"deprecated_comment\\": \\"Use shift-<direction> instead\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/shift-right.svg\\",\\n          \\"deprecated\\": true,\\n          \\"deprecated_comment\\": \\"Use shift-<direction> instead\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconCollapse\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"collapse\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"collapse\\"\\n        ]\\n      },\\n      \\"copy\\": {\\n        \\"value\\": \\"assets/icons/copy.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/copy.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconCopy\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"copy\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"copy\\"\\n        ]\\n      },\\n      \\"dash-small\\": {\\n        \\"value\\": \\"assets/icons/dash-small.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/dash-small.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconDashSmall\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"dash-small\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"dash-small\\"\\n        ]\\n      },\\n      \\"delete\\": {\\n        \\"value\\": \\"assets/icons/delete.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/delete.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconDelete\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"delete\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"delete\\"\\n        ]\\n      },\\n      \\"download\\": {\\n        \\"value\\": \\"assets/icons/download.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/download.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconDownload\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"download\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"download\\"\\n        ]\\n      },\\n      \\"edit\\": {\\n        \\"value\\": \\"assets/icons/edit.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/edit.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconEdit\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"edit\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"edit\\"\\n        ]\\n      },\\n      \\"ellipses-horizontal\\": {\\n        \\"value\\": \\"assets/icons/ellipses-horizontal.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/ellipses-horizontal.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconEllipsesHorizontal\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"ellipses-horizontal\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"ellipses-horizontal\\"\\n        ]\\n      },\\n      \\"ellipses-vertical\\": {\\n        \\"value\\": \\"assets/icons/ellipses-vertical.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/ellipses-vertical.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconEllipsesVertical\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"ellipses-vertical\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"ellipses-vertical\\"\\n        ]\\n      },\\n      \\"email\\": {\\n        \\"value\\": \\"assets/icons/email.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/email.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconEmail\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"email\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"email\\"\\n        ]\\n      },\\n      \\"exclamation-inverse\\": {\\n        \\"value\\": \\"assets/icons/exclamation-inverse.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/exclamation-inverse.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconExclamationInverse\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"exclamation-inverse\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"exclamation-inverse\\"\\n        ]\\n      },\\n      \\"exclamation\\": {\\n        \\"value\\": \\"assets/icons/exclamation.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/exclamation.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconExclamation\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"exclamation\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"exclamation\\"\\n        ]\\n      },\\n      \\"expand\\": {\\n        \\"value\\": \\"assets/icons/shift-left.svg\\",\\n        \\"deprecated\\": true,\\n        \\"deprecated_comment\\": \\"Use shift-<direction> instead\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/shift-left.svg\\",\\n          \\"deprecated\\": true,\\n          \\"deprecated_comment\\": \\"Use shift-<direction> instead\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconExpand\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"expand\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"expand\\"\\n        ]\\n      },\\n      \\"facebook\\": {\\n        \\"value\\": \\"assets/icons/facebook.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/facebook.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconFacebook\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"facebook\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"facebook\\"\\n        ]\\n      },\\n      \\"filetype-pdf\\": {\\n        \\"value\\": \\"assets/icons/filetype-pdf.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/filetype-pdf.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconFiletypePdf\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"filetype-pdf\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"filetype-pdf\\"\\n        ]\\n      },\\n      \\"filetype-ppt\\": {\\n        \\"value\\": \\"assets/icons/filetype-ppt.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/filetype-ppt.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconFiletypePpt\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"filetype-ppt\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"filetype-ppt\\"\\n        ]\\n      },\\n      \\"filetype-zip\\": {\\n        \\"value\\": \\"assets/icons/filetype-zip.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/filetype-zip.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconFiletypeZip\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"filetype-zip\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"filetype-zip\\"\\n        ]\\n      },\\n      \\"fit-to-view\\": {\\n        \\"value\\": \\"assets/icons/fit-to-view.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/fit-to-view.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconFitToView\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"fit-to-view\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"fit-to-view\\"\\n        ]\\n      },\\n      \\"fit-to-width\\": {\\n        \\"value\\": \\"assets/icons/fit-to-width.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/fit-to-width.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconFitToWidth\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"fit-to-width\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"fit-to-width\\"\\n        ]\\n      },\\n      \\"folder-new\\": {\\n        \\"value\\": \\"assets/icons/folder-new.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/folder-new.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconFolderNew\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"folder-new\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"folder-new\\"\\n        ]\\n      },\\n      \\"folder\\": {\\n        \\"value\\": \\"assets/icons/folder.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/folder.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconFolder\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"folder\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"folder\\"\\n        ]\\n      },\\n      \\"folder-selected\\": {\\n        \\"value\\": \\"assets/icons/folder-selected.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/folder-selected.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconFolderSelected\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"folder-selected\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"folder-selected\\"\\n        ]\\n      },\\n      \\"fullscreen-minimize\\": {\\n        \\"value\\": \\"assets/icons/fullscreen-minimize.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/fullscreen-minimize.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconFullscreenMinimize\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"fullscreen-minimize\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"fullscreen-minimize\\"\\n        ]\\n      },\\n      \\"fullscreen\\": {\\n        \\"value\\": \\"assets/icons/fullscreen.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/fullscreen.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconFullscreen\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"fullscreen\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"fullscreen\\"\\n        ]\\n      },\\n      \\"google-color\\": {\\n        \\"value\\": \\"assets/icons/google-color.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/google-color.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconGoogleColor\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"google-color\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"google-color\\"\\n        ]\\n      },\\n      \\"google\\": {\\n        \\"value\\": \\"assets/icons/google.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/google.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconGoogle\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"google\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"google\\"\\n        ]\\n      },\\n      \\"image\\": {\\n        \\"value\\": \\"assets/icons/image.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/image.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconImage\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"image\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"image\\"\\n        ]\\n      },\\n      \\"info-inverse\\": {\\n        \\"value\\": \\"assets/icons/info-inverse.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/info-inverse.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconInfoInverse\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"info-inverse\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"info-inverse\\"\\n        ]\\n      },\\n      \\"instagram\\": {\\n        \\"value\\": \\"assets/icons/instagram.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/instagram.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconInstagram\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"instagram\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"instagram\\"\\n        ]\\n      },\\n      \\"laptop\\": {\\n        \\"value\\": \\"assets/icons/laptop.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/laptop.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconLaptop\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"laptop\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"laptop\\"\\n        ]\\n      },\\n      \\"link-add\\": {\\n        \\"value\\": \\"assets/icons/link-add.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/link-add.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconLinkAdd\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"link-add\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"link-add\\"\\n        ]\\n      },\\n      \\"link-external\\": {\\n        \\"value\\": \\"assets/icons/link-external.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/link-external.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconLinkExternal\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"link-external\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"link-external\\"\\n        ]\\n      },\\n      \\"link\\": {\\n        \\"value\\": \\"assets/icons/link.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/link.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconLink\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"link\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"link\\"\\n        ]\\n      },\\n      \\"linkedin\\": {\\n        \\"value\\": \\"assets/icons/linkedin.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/linkedin.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconLinkedin\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"linkedin\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"linkedin\\"\\n        ]\\n      },\\n      \\"menu\\": {\\n        \\"value\\": \\"assets/icons/menu.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/menu.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconMenu\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"menu\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"menu\\"\\n        ]\\n      },\\n      \\"move\\": {\\n        \\"value\\": \\"assets/icons/move.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/move.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconMove\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"move\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"move\\"\\n        ]\\n      },\\n      \\"new\\": {\\n        \\"value\\": \\"assets/icons/new.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/new.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconNew\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"new\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"new\\"\\n        ]\\n      },\\n      \\"partial-circle\\": {\\n        \\"value\\": \\"assets/icons/partial-circle.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/partial-circle.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconPartialCircle\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"partial-circle\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"partial-circle\\"\\n        ]\\n      },\\n      \\"primary-source\\": {\\n        \\"value\\": \\"assets/icons/primary-source.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/primary-source.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconPrimarySource\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"primary-source\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"primary-source\\"\\n        ]\\n      },\\n      \\"profile\\": {\\n        \\"value\\": \\"assets/icons/profile.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/profile.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconProfile\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"profile\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"profile\\"\\n        ]\\n      },\\n      \\"question-inverse\\": {\\n        \\"value\\": \\"assets/icons/question-inverse.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/question-inverse.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconQuestionInverse\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"question-inverse\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"question-inverse\\"\\n        ]\\n      },\\n      \\"save\\": {\\n        \\"value\\": \\"assets/icons/save.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/save.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconSave\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"save\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"save\\"\\n        ]\\n      },\\n      \\"saved\\": {\\n        \\"value\\": \\"assets/icons/saved.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/saved.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconSaved\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"saved\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"saved\\"\\n        ]\\n      },\\n      \\"search\\": {\\n        \\"value\\": \\"assets/icons/search.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/search.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconSearch\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"search\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"search\\"\\n        ]\\n      },\\n      \\"share\\": {\\n        \\"value\\": \\"assets/icons/share.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/share.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconShare\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"share\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"share\\"\\n        ]\\n      },\\n      \\"shift-left\\": {\\n        \\"value\\": \\"assets/icons/shift-left.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/shift-left.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconShiftLeft\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"shift-left\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"shift-left\\"\\n        ]\\n      },\\n      \\"shift-right\\": {\\n        \\"value\\": \\"assets/icons/shift-right.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/shift-right.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconShiftRight\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"shift-right\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"shift-right\\"\\n        ]\\n      },\\n      \\"shift-up\\": {\\n        \\"value\\": \\"assets/icons/shift-up.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/shift-up.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconShiftUp\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"shift-up\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"shift-up\\"\\n        ]\\n      },\\n      \\"shift-down\\": {\\n        \\"value\\": \\"assets/icons/shift-down.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/shift-down.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconShiftDown\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"shift-down\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"shift-down\\"\\n        ]\\n      },\\n      \\"tumblr\\": {\\n        \\"value\\": \\"assets/icons/tumblr.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/tumblr.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconTumblr\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"tumblr\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"tumblr\\"\\n        ]\\n      },\\n      \\"twitter\\": {\\n        \\"value\\": \\"assets/icons/twitter.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/twitter.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconTwitter\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"twitter\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"twitter\\"\\n        ]\\n      },\\n      \\"video\\": {\\n        \\"value\\": \\"assets/icons/video.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/video.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconVideo\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"video\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"video\\"\\n        ]\\n      },\\n      \\"view-gallery\\": {\\n        \\"value\\": \\"assets/icons/view-gallery.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/view-gallery.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconViewGallery\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"view-gallery\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"view-gallery\\"\\n        ]\\n      },\\n      \\"view-grid\\": {\\n        \\"value\\": \\"assets/icons/view-grid.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/view-grid.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconViewGrid\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"view-grid\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"view-grid\\"\\n        ]\\n      },\\n      \\"view-list\\": {\\n        \\"value\\": \\"assets/icons/view-list.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/view-list.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconViewList\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"view-list\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"view-list\\"\\n        ]\\n      },\\n      \\"workspace\\": {\\n        \\"value\\": \\"assets/icons/workspace.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/workspace.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconWorkspace\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"workspace\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"workspace\\"\\n        ]\\n      },\\n      \\"workspace-selected\\": {\\n        \\"value\\": \\"assets/icons/workspace-selected.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/workspace-selected.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconWorkspaceSelected\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"workspace-selected\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"workspace-selected\\"\\n        ]\\n      },\\n      \\"youtube\\": {\\n        \\"value\\": \\"assets/icons/youtube.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/youtube.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconYoutube\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"youtube\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"youtube\\"\\n        ]\\n      },\\n      \\"zoom-in\\": {\\n        \\"value\\": \\"assets/icons/zoom-in.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/zoom-in.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconZoomIn\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"zoom-in\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"zoom-in\\"\\n        ]\\n      },\\n      \\"zoom-out\\": {\\n        \\"value\\": \\"assets/icons/zoom-out.svg\\",\\n        \\"filePath\\": \\"tokens/assets/icons.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"assets/icons/zoom-out.svg\\"\\n        },\\n        \\"name\\": \\"PharosAssetIconZoomOut\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"asset\\",\\n          \\"type\\": \\"icon\\",\\n          \\"item\\": \\"zoom-out\\"\\n        },\\n        \\"path\\": [\\n          \\"asset\\",\\n          \\"icon\\",\\n          \\"zoom-out\\"\\n        ]\\n      }\\n    }\\n  },\\n  \\"breakpoint\\": {\\n    \\"small\\": {\\n      \\"value\\": \\"22.5rem\\",\\n      \\"comment\\": \\"360px\\",\\n      \\"filePath\\": \\"tokens/breakpoint/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"22.5rem\\",\\n        \\"comment\\": \\"360px\\"\\n      },\\n      \\"name\\": \\"PharosBreakpointSmall\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"breakpoint\\",\\n        \\"type\\": \\"small\\"\\n      },\\n      \\"path\\": [\\n        \\"breakpoint\\",\\n        \\"small\\"\\n      ]\\n    },\\n    \\"medium\\": {\\n      \\"value\\": \\"48rem\\",\\n      \\"comment\\": \\"768px\\",\\n      \\"filePath\\": \\"tokens/breakpoint/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"48rem\\",\\n        \\"comment\\": \\"768px\\"\\n      },\\n      \\"name\\": \\"PharosBreakpointMedium\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"breakpoint\\",\\n        \\"type\\": \\"medium\\"\\n      },\\n      \\"path\\": [\\n        \\"breakpoint\\",\\n        \\"medium\\"\\n      ]\\n    },\\n    \\"large\\": {\\n      \\"value\\": \\"66rem\\",\\n      \\"comment\\": \\"1056px\\",\\n      \\"filePath\\": \\"tokens/breakpoint/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"66rem\\",\\n        \\"comment\\": \\"1056px\\"\\n      },\\n      \\"name\\": \\"PharosBreakpointLarge\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"breakpoint\\",\\n        \\"type\\": \\"large\\"\\n      },\\n      \\"path\\": [\\n        \\"breakpoint\\",\\n        \\"large\\"\\n      ]\\n    },\\n    \\"xlarge\\": {\\n      \\"value\\": \\"85rem\\",\\n      \\"comment\\": \\"1360px\\",\\n      \\"filePath\\": \\"tokens/breakpoint/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"85rem\\",\\n        \\"comment\\": \\"1360px\\"\\n      },\\n      \\"name\\": \\"PharosBreakpointXlarge\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"breakpoint\\",\\n        \\"type\\": \\"xlarge\\"\\n      },\\n      \\"path\\": [\\n        \\"breakpoint\\",\\n        \\"xlarge\\"\\n      ]\\n    },\\n    \\"max\\": {\\n      \\"value\\": \\"99rem\\",\\n      \\"comment\\": \\"1584px\\",\\n      \\"filePath\\": \\"tokens/breakpoint/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"99rem\\",\\n        \\"comment\\": \\"1584px\\"\\n      },\\n      \\"name\\": \\"PharosBreakpointMax\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"breakpoint\\",\\n        \\"type\\": \\"max\\"\\n      },\\n      \\"path\\": [\\n        \\"breakpoint\\",\\n        \\"max\\"\\n      ]\\n    }\\n  },\\n  \\"color\\": {\\n    \\"JSTOR red\\": {\\n      \\"value\\": \\"#990000\\",\\n      \\"group\\": \\"primary\\",\\n      \\"palette\\": \\"primary\\",\\n      \\"filePath\\": \\"tokens/color/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"hsl(0, 100%, 30%)\\",\\n        \\"group\\": \\"primary\\",\\n        \\"palette\\": \\"primary\\"\\n      },\\n      \\"name\\": \\"PharosColorJstorRed\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"color\\",\\n        \\"type\\": \\"JSTOR red\\"\\n      },\\n      \\"path\\": [\\n        \\"color\\",\\n        \\"JSTOR red\\"\\n      ]\\n    },\\n    \\"Night blue\\": {\\n      \\"15\\": {\\n        \\"value\\": \\"#071d46\\",\\n        \\"group\\": \\"tint\\",\\n        \\"palette\\": \\"secondary\\",\\n        \\"order\\": \\"1\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"hsl(219, 82%, 15%)\\",\\n          \\"group\\": \\"tint\\",\\n          \\"palette\\": \\"secondary\\",\\n          \\"order\\": \\"1\\"\\n        },\\n        \\"name\\": \\"PharosColorNightBlue15\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"Night blue\\",\\n          \\"item\\": \\"15\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"Night blue\\",\\n          \\"15\\"\\n        ]\\n      },\\n      \\"60\\": {\\n        \\"value\\": \\"#8091b3\\",\\n        \\"group\\": \\"tint\\",\\n        \\"palette\\": \\"secondary\\",\\n        \\"order\\": \\"2\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"hsl(219, 25%, 60%)\\",\\n          \\"group\\": \\"tint\\",\\n          \\"palette\\": \\"secondary\\",\\n          \\"order\\": \\"2\\"\\n        },\\n        \\"name\\": \\"PharosColorNightBlue60\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"Night blue\\",\\n          \\"item\\": \\"60\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"Night blue\\",\\n          \\"60\\"\\n        ]\\n      },\\n      \\"base\\": {\\n        \\"value\\": \\"#0d3071\\",\\n        \\"group\\": \\"primary\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"hsl(219, 79.4%, 24.7%)\\",\\n          \\"group\\": \\"primary\\"\\n        },\\n        \\"name\\": \\"PharosColorNightBlueBase\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"Night blue\\",\\n          \\"item\\": \\"base\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"Night blue\\",\\n          \\"base\\"\\n        ]\\n      }\\n    },\\n    \\"Glacier blue\\": {\\n      \\"40\\": {\\n        \\"value\\": \\"#0ba3c1\\",\\n        \\"group\\": \\"tint\\",\\n        \\"palette\\": \\"secondary\\",\\n        \\"order\\": \\"1\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"hsl(190, 89%, 40%)\\",\\n          \\"group\\": \\"tint\\",\\n          \\"palette\\": \\"secondary\\",\\n          \\"order\\": \\"1\\"\\n        },\\n        \\"name\\": \\"PharosColorGlacierBlue40\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"Glacier blue\\",\\n          \\"item\\": \\"40\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"Glacier blue\\",\\n          \\"40\\"\\n        ]\\n      },\\n      \\"70\\": {\\n        \\"value\\": \\"#79deec\\",\\n        \\"group\\": \\"tint\\",\\n        \\"palette\\": \\"secondary\\",\\n        \\"order\\": \\"1\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"hsl(187, 75%, 70%)\\",\\n          \\"group\\": \\"tint\\",\\n          \\"palette\\": \\"secondary\\",\\n          \\"order\\": \\"1\\"\\n        },\\n        \\"name\\": \\"PharosColorGlacierBlue70\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"Glacier blue\\",\\n          \\"item\\": \\"70\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"Glacier blue\\",\\n          \\"70\\"\\n        ]\\n      },\\n      \\"80\\": {\\n        \\"value\\": \\"#b4dee4\\",\\n        \\"group\\": \\"tint\\",\\n        \\"palette\\": \\"secondary\\",\\n        \\"order\\": \\"2\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"hsl(188, 47%, 80%)\\",\\n          \\"group\\": \\"tint\\",\\n          \\"palette\\": \\"secondary\\",\\n          \\"order\\": \\"2\\"\\n        },\\n        \\"name\\": \\"PharosColorGlacierBlue80\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"Glacier blue\\",\\n          \\"item\\": \\"80\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"Glacier blue\\",\\n          \\"80\\"\\n        ]\\n      },\\n      \\"90\\": {\\n        \\"value\\": \\"#dcedef\\",\\n        \\"group\\": \\"tint\\",\\n        \\"palette\\": \\"secondary\\",\\n        \\"order\\": \\"2\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"hsl(186.3,37.3%,90%)\\",\\n          \\"group\\": \\"tint\\",\\n          \\"palette\\": \\"secondary\\",\\n          \\"order\\": \\"2\\"\\n        },\\n        \\"name\\": \\"PharosColorGlacierBlue90\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"Glacier blue\\",\\n          \\"item\\": \\"90\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"Glacier blue\\",\\n          \\"90\\"\\n        ]\\n      },\\n      \\"base\\": {\\n        \\"value\\": \\"#27cae1\\",\\n        \\"group\\": \\"primary\\",\\n        \\"palette\\": \\"secondary\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"hsl(187.4, 75.6%, 51.8%)\\",\\n          \\"group\\": \\"primary\\",\\n          \\"palette\\": \\"secondary\\"\\n        },\\n        \\"name\\": \\"PharosColorGlacierBlueBase\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"Glacier blue\\",\\n          \\"item\\": \\"base\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"Glacier blue\\",\\n          \\"base\\"\\n        ]\\n      }\\n    },\\n    \\"Living coral\\": {\\n      \\"50\\": {\\n        \\"value\\": \\"#c83737\\",\\n        \\"group\\": \\"tint\\",\\n        \\"palette\\": \\"secondary\\",\\n        \\"order\\": \\"1\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"hsl(0, 57%, 50%)\\",\\n          \\"group\\": \\"tint\\",\\n          \\"palette\\": \\"secondary\\",\\n          \\"order\\": \\"1\\"\\n        },\\n        \\"name\\": \\"PharosColorLivingCoral50\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"Living coral\\",\\n          \\"item\\": \\"50\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"Living coral\\",\\n          \\"50\\"\\n        ]\\n      },\\n      \\"53\\": {\\n        \\"value\\": \\"#dd3431\\",\\n        \\"group\\": \\"tint\\",\\n        \\"palette\\": \\"secondary\\",\\n        \\"order\\": \\"1\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"hsl(1, 72%, 53%)\\",\\n          \\"group\\": \\"tint\\",\\n          \\"palette\\": \\"secondary\\",\\n          \\"order\\": \\"1\\"\\n        },\\n        \\"name\\": \\"PharosColorLivingCoral53\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"Living coral\\",\\n          \\"item\\": \\"53\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"Living coral\\",\\n          \\"53\\"\\n        ]\\n      },\\n      \\"80\\": {\\n        \\"value\\": \\"#fc9c9c\\",\\n        \\"group\\": \\"tint\\",\\n        \\"palette\\": \\"secondary\\",\\n        \\"order\\": \\"2\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"hsl(0, 94%, 80%)\\",\\n          \\"group\\": \\"tint\\",\\n          \\"palette\\": \\"secondary\\",\\n          \\"order\\": \\"2\\"\\n        },\\n        \\"name\\": \\"PharosColorLivingCoral80\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"Living coral\\",\\n          \\"item\\": \\"80\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"Living coral\\",\\n          \\"80\\"\\n        ]\\n      },\\n      \\"90\\": {\\n        \\"value\\": \\"#f4d7d7\\",\\n        \\"group\\": \\"tint\\",\\n        \\"palette\\": \\"secondary\\",\\n        \\"order\\": \\"3\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"hsl(0, 57%, 90%)\\",\\n          \\"group\\": \\"tint\\",\\n          \\"palette\\": \\"secondary\\",\\n          \\"order\\": \\"3\\"\\n        },\\n        \\"name\\": \\"PharosColorLivingCoral90\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"Living coral\\",\\n          \\"item\\": \\"90\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"Living coral\\",\\n          \\"90\\"\\n        ]\\n      },\\n      \\"base\\": {\\n        \\"value\\": \\"#fb4848\\",\\n        \\"group\\": \\"secondary\\",\\n        \\"palette\\": \\"secondary\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"hsl(0, 95.7%, 63.3%)\\",\\n          \\"group\\": \\"secondary\\",\\n          \\"palette\\": \\"secondary\\"\\n        },\\n        \\"name\\": \\"PharosColorLivingCoralBase\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"Living coral\\",\\n          \\"item\\": \\"base\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"Living coral\\",\\n          \\"base\\"\\n        ]\\n      }\\n    },\\n    \\"Marble gray\\": {\\n      \\"10\\": {\\n        \\"value\\": \\"#1a1a19\\",\\n        \\"group\\": \\"neutrals\\",\\n        \\"palette\\": \\"grayscale\\",\\n        \\"order\\": \\"1\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"hsl(60, 2%, 10%)\\",\\n          \\"group\\": \\"neutrals\\",\\n          \\"palette\\": \\"grayscale\\",\\n          \\"order\\": \\"1\\"\\n        },\\n        \\"name\\": \\"PharosColorMarbleGray10\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"Marble gray\\",\\n          \\"item\\": \\"10\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"Marble gray\\",\\n          \\"10\\"\\n        ]\\n      },\\n      \\"20\\": {\\n        \\"value\\": \\"#343332\\",\\n        \\"group\\": \\"neutrals\\",\\n        \\"palette\\": \\"grayscale\\",\\n        \\"order\\": \\"2\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"hsl(30, 2%, 20%)\\",\\n          \\"group\\": \\"neutrals\\",\\n          \\"palette\\": \\"grayscale\\",\\n          \\"order\\": \\"2\\"\\n        },\\n        \\"name\\": \\"PharosColorMarbleGray20\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"Marble gray\\",\\n          \\"item\\": \\"20\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"Marble gray\\",\\n          \\"20\\"\\n        ]\\n      },\\n      \\"40\\": {\\n        \\"value\\": \\"#676765\\",\\n        \\"group\\": \\"neutrals\\",\\n        \\"palette\\": \\"grayscale\\",\\n        \\"order\\": \\"3\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"hsl(60, 1%, 40%)\\",\\n          \\"group\\": \\"neutrals\\",\\n          \\"palette\\": \\"grayscale\\",\\n          \\"order\\": \\"3\\"\\n        },\\n        \\"name\\": \\"PharosColorMarbleGray40\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"Marble gray\\",\\n          \\"item\\": \\"40\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"Marble gray\\",\\n          \\"40\\"\\n        ]\\n      },\\n      \\"50\\": {\\n        \\"value\\": \\"#81807e\\",\\n        \\"group\\": \\"neutrals\\",\\n        \\"palette\\": \\"grayscale\\",\\n        \\"order\\": \\"4\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"hsl(40, 1.2%, 50%)\\",\\n          \\"group\\": \\"neutrals\\",\\n          \\"palette\\": \\"grayscale\\",\\n          \\"order\\": \\"4\\"\\n        },\\n        \\"name\\": \\"PharosColorMarbleGray50\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"Marble gray\\",\\n          \\"item\\": \\"50\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"Marble gray\\",\\n          \\"50\\"\\n        ]\\n      },\\n      \\"80\\": {\\n        \\"value\\": \\"#d1cfc7\\",\\n        \\"group\\": \\"neutrals\\",\\n        \\"palette\\": \\"grayscale\\",\\n        \\"order\\": \\"5\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"hsl(48, 9.8%, 80%)\\",\\n          \\"group\\": \\"neutrals\\",\\n          \\"palette\\": \\"grayscale\\",\\n          \\"order\\": \\"5\\"\\n        },\\n        \\"name\\": \\"PharosColorMarbleGray80\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"Marble gray\\",\\n          \\"item\\": \\"80\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"Marble gray\\",\\n          \\"80\\"\\n        ]\\n      },\\n      \\"94\\": {\\n        \\"value\\": \\"#f2f1ed\\",\\n        \\"group\\": \\"neutrals\\",\\n        \\"palette\\": \\"grayscale\\",\\n        \\"order\\": \\"6\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"hsl(48, 16%, 94%)\\",\\n          \\"group\\": \\"neutrals\\",\\n          \\"palette\\": \\"grayscale\\",\\n          \\"order\\": \\"6\\"\\n        },\\n        \\"name\\": \\"PharosColorMarbleGray94\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"Marble gray\\",\\n          \\"item\\": \\"94\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"Marble gray\\",\\n          \\"94\\"\\n        ]\\n      },\\n      \\"97\\": {\\n        \\"value\\": \\"#f9f8f6\\",\\n        \\"group\\": \\"neutrals\\",\\n        \\"palette\\": \\"grayscale\\",\\n        \\"order\\": \\"7\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"hsl(40, 20%, 97.1%)\\",\\n          \\"group\\": \\"neutrals\\",\\n          \\"palette\\": \\"grayscale\\",\\n          \\"order\\": \\"7\\"\\n        },\\n        \\"name\\": \\"PharosColorMarbleGray97\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"Marble gray\\",\\n          \\"item\\": \\"97\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"Marble gray\\",\\n          \\"97\\"\\n        ]\\n      },\\n      \\"base\\": {\\n        \\"value\\": \\"#eae8e1\\",\\n        \\"group\\": \\"secondary, neutrals\\",\\n        \\"palette\\": \\"grayscale\\",\\n        \\"order\\": \\"5\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"hsl(46.7, 17.6%, 90%)\\",\\n          \\"group\\": \\"secondary, neutrals\\",\\n          \\"palette\\": \\"grayscale\\",\\n          \\"order\\": \\"5\\"\\n        },\\n        \\"name\\": \\"PharosColorMarbleGrayBase\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"Marble gray\\",\\n          \\"item\\": \\"base\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"Marble gray\\",\\n          \\"base\\"\\n        ]\\n      }\\n    },\\n    \\"Black\\": {\\n      \\"value\\": \\"#000000\\",\\n      \\"group\\": \\"secondary\\",\\n      \\"palette\\": \\"primary\\",\\n      \\"filePath\\": \\"tokens/color/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"hsl(0, 0%, 0%)\\",\\n        \\"group\\": \\"secondary\\",\\n        \\"palette\\": \\"primary\\"\\n      },\\n      \\"name\\": \\"PharosColorBlack\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"color\\",\\n        \\"type\\": \\"Black\\"\\n      },\\n      \\"path\\": [\\n        \\"color\\",\\n        \\"Black\\"\\n      ]\\n    },\\n    \\"White\\": {\\n      \\"value\\": \\"#ffffff\\",\\n      \\"palette\\": \\"primary\\",\\n      \\"filePath\\": \\"tokens/color/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"hsl(0, 0%, 100%)\\",\\n        \\"palette\\": \\"primary\\"\\n      },\\n      \\"name\\": \\"PharosColorWhite\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"color\\",\\n        \\"type\\": \\"White\\"\\n      },\\n      \\"path\\": [\\n        \\"color\\",\\n        \\"White\\"\\n      ]\\n    },\\n    \\"Yellow\\": {\\n      \\"97\\": {\\n        \\"value\\": \\"#fdf9f2\\",\\n        \\"group\\": \\"\\",\\n        \\"palette\\": \\"feedback\\",\\n        \\"order\\": \\"1\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"hsl(38.2,73.3%,97.1%)\\",\\n          \\"group\\": \\"\\",\\n          \\"palette\\": \\"feedback\\",\\n          \\"order\\": \\"1\\"\\n        },\\n        \\"name\\": \\"PharosColorYellow97\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"Yellow\\",\\n          \\"item\\": \\"97\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"Yellow\\",\\n          \\"97\\"\\n        ]\\n      },\\n      \\"base\\": {\\n        \\"value\\": \\"#faa926\\",\\n        \\"group\\": \\"\\",\\n        \\"palette\\": \\"feedback\\",\\n        \\"order\\": \\"1\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"hsl(37.1, 95.5%, 56.5%)\\",\\n          \\"group\\": \\"\\",\\n          \\"palette\\": \\"feedback\\",\\n          \\"order\\": \\"1\\"\\n        },\\n        \\"name\\": \\"PharosColorYellowBase\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"Yellow\\",\\n          \\"item\\": \\"base\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"Yellow\\",\\n          \\"base\\"\\n        ]\\n      }\\n    },\\n    \\"Green\\": {\\n      \\"93\\": {\\n        \\"value\\": \\"#e9f1eb\\",\\n        \\"group\\": \\"\\",\\n        \\"palette\\": \\"feedback\\",\\n        \\"order\\": \\"1\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"hsl(135,22.2%,92.9%)\\",\\n          \\"group\\": \\"\\",\\n          \\"palette\\": \\"feedback\\",\\n          \\"order\\": \\"1\\"\\n        },\\n        \\"name\\": \\"PharosColorGreen93\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"Green\\",\\n          \\"item\\": \\"93\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"Green\\",\\n          \\"93\\"\\n        ]\\n      },\\n      \\"base\\": {\\n        \\"value\\": \\"#268241\\",\\n        \\"group\\": \\"\\",\\n        \\"palette\\": \\"feedback\\",\\n        \\"order\\": \\"1\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"hsl(137.6, 54.8%, 32.9%)\\",\\n          \\"group\\": \\"\\",\\n          \\"palette\\": \\"feedback\\",\\n          \\"order\\": \\"1\\"\\n        },\\n        \\"name\\": \\"PharosColorGreenBase\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"Green\\",\\n          \\"item\\": \\"base\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"Green\\",\\n          \\"base\\"\\n        ]\\n      }\\n    },\\n    \\"interactive\\": {\\n      \\"primary\\": {\\n        \\"value\\": \\"#990000\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{color.JSTOR red.value}\\"\\n        },\\n        \\"name\\": \\"PharosColorInteractivePrimary\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"interactive\\",\\n          \\"item\\": \\"primary\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"interactive\\",\\n          \\"primary\\"\\n        ]\\n      },\\n      \\"secondary\\": {\\n        \\"value\\": \\"#000000\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{color.Black.value}\\"\\n        },\\n        \\"name\\": \\"PharosColorInteractiveSecondary\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"interactive\\",\\n          \\"item\\": \\"secondary\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"interactive\\",\\n          \\"secondary\\"\\n        ]\\n      },\\n      \\"tertiary\\": {\\n        \\"value\\": \\"#ffffff\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{color.White.value}\\"\\n        },\\n        \\"name\\": \\"PharosColorInteractiveTertiary\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"interactive\\",\\n          \\"item\\": \\"tertiary\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"interactive\\",\\n          \\"tertiary\\"\\n        ]\\n      }\\n    },\\n    \\"ui\\": {\\n      \\"10\\": {\\n        \\"value\\": \\"#ffffff\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{color.White.value}\\"\\n        },\\n        \\"name\\": \\"PharosColorUi10\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"ui\\",\\n          \\"item\\": \\"10\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"ui\\",\\n          \\"10\\"\\n        ]\\n      },\\n      \\"20\\": {\\n        \\"value\\": \\"#f2f1ed\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{color.Marble gray.94.value}\\"\\n        },\\n        \\"name\\": \\"PharosColorUi20\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"ui\\",\\n          \\"item\\": \\"20\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"ui\\",\\n          \\"20\\"\\n        ]\\n      },\\n      \\"30\\": {\\n        \\"value\\": \\"#eae8e1\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{color.Marble gray.base.value}\\"\\n        },\\n        \\"name\\": \\"PharosColorUi30\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"ui\\",\\n          \\"item\\": \\"30\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"ui\\",\\n          \\"30\\"\\n        ]\\n      },\\n      \\"40\\": {\\n        \\"value\\": \\"#d1cfc7\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{color.Marble gray.80.value}\\"\\n        },\\n        \\"name\\": \\"PharosColorUi40\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"ui\\",\\n          \\"item\\": \\"40\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"ui\\",\\n          \\"40\\"\\n        ]\\n      },\\n      \\"50\\": {\\n        \\"value\\": \\"#81807e\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{color.Marble gray.50.value}\\"\\n        },\\n        \\"name\\": \\"PharosColorUi50\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"ui\\",\\n          \\"item\\": \\"50\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"ui\\",\\n          \\"50\\"\\n        ]\\n      }\\n    },\\n    \\"disabled\\": {\\n      \\"value\\": \\"#eae8e1\\",\\n      \\"filePath\\": \\"tokens/color/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"{color.ui.30.value}\\"\\n      },\\n      \\"name\\": \\"PharosColorDisabled\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"color\\",\\n        \\"type\\": \\"disabled\\"\\n      },\\n      \\"path\\": [\\n        \\"color\\",\\n        \\"disabled\\"\\n      ]\\n    },\\n    \\"overlay\\": {\\n      \\"value\\": \\"#000000\\",\\n      \\"filePath\\": \\"tokens/color/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"hsla(0, 0%, 0%, 0.5)\\"\\n      },\\n      \\"name\\": \\"PharosColorOverlay\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"color\\",\\n        \\"type\\": \\"overlay\\"\\n      },\\n      \\"path\\": [\\n        \\"color\\",\\n        \\"overlay\\"\\n      ]\\n    },\\n    \\"feedback\\": {\\n      \\"error\\": {\\n        \\"value\\": \\"#dd3431\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{color.Living coral.53.value}\\"\\n        },\\n        \\"name\\": \\"PharosColorFeedbackError\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"feedback\\",\\n          \\"item\\": \\"error\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"feedback\\",\\n          \\"error\\"\\n        ]\\n      },\\n      \\"success\\": {\\n        \\"value\\": \\"#268241\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{color.Green.base.value}\\"\\n        },\\n        \\"name\\": \\"PharosColorFeedbackSuccess\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"feedback\\",\\n          \\"item\\": \\"success\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"feedback\\",\\n          \\"success\\"\\n        ]\\n      },\\n      \\"warning\\": {\\n        \\"value\\": \\"#faa926\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{color.Yellow.base.value}\\"\\n        },\\n        \\"name\\": \\"PharosColorFeedbackWarning\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"feedback\\",\\n          \\"item\\": \\"warning\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"feedback\\",\\n          \\"warning\\"\\n        ]\\n      },\\n      \\"info\\": {\\n        \\"value\\": \\"#0ba3c1\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{color.Glacier blue.40.value}\\"\\n        },\\n        \\"name\\": \\"PharosColorFeedbackInfo\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"feedback\\",\\n          \\"item\\": \\"info\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"feedback\\",\\n          \\"info\\"\\n        ]\\n      }\\n    },\\n    \\"text\\": {\\n      \\"10\\": {\\n        \\"value\\": \\"#1a1a19\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{color.Marble gray.10.value}\\"\\n        },\\n        \\"name\\": \\"PharosColorText10\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"text\\",\\n          \\"item\\": \\"10\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"text\\",\\n          \\"10\\"\\n        ]\\n      },\\n      \\"20\\": {\\n        \\"value\\": \\"#343332\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{color.Marble gray.20.value}\\"\\n        },\\n        \\"name\\": \\"PharosColorText20\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"text\\",\\n          \\"item\\": \\"20\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"text\\",\\n          \\"20\\"\\n        ]\\n      },\\n      \\"40\\": {\\n        \\"value\\": \\"#676765\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{color.Marble gray.40.value}\\"\\n        },\\n        \\"name\\": \\"PharosColorText40\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"text\\",\\n          \\"item\\": \\"40\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"text\\",\\n          \\"40\\"\\n        ]\\n      },\\n      \\"50\\": {\\n        \\"value\\": \\"#81807e\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{color.Marble gray.50.value}\\"\\n        },\\n        \\"name\\": \\"PharosColorText50\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"text\\",\\n          \\"item\\": \\"50\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"text\\",\\n          \\"50\\"\\n        ]\\n      },\\n      \\"base\\": {\\n        \\"value\\": \\"#000000\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{color.Black.value}\\"\\n        },\\n        \\"name\\": \\"PharosColorTextBase\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"text\\",\\n          \\"item\\": \\"base\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"text\\",\\n          \\"base\\"\\n        ]\\n      },\\n      \\"disabled\\": {\\n        \\"value\\": \\"#676765\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{color.text.40.value}\\"\\n        },\\n        \\"name\\": \\"PharosColorTextDisabled\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"text\\",\\n          \\"item\\": \\"disabled\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"text\\",\\n          \\"disabled\\"\\n        ]\\n      },\\n      \\"placeholder\\": {\\n        \\"value\\": \\"#676765\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{color.text.40.value}\\"\\n        },\\n        \\"name\\": \\"PharosColorTextPlaceholder\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"text\\",\\n          \\"item\\": \\"placeholder\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"text\\",\\n          \\"placeholder\\"\\n        ]\\n      },\\n      \\"white\\": {\\n        \\"value\\": \\"#ffffff\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{color.White.value}\\"\\n        },\\n        \\"name\\": \\"PharosColorTextWhite\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"text\\",\\n          \\"item\\": \\"white\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"text\\",\\n          \\"white\\"\\n        ]\\n      }\\n    },\\n    \\"focus\\": {\\n      \\"value\\": \\"#0ba3c1\\",\\n      \\"filePath\\": \\"tokens/color/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"{color.Glacier blue.40.value}\\"\\n      },\\n      \\"name\\": \\"PharosColorFocus\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"color\\",\\n        \\"type\\": \\"focus\\"\\n      },\\n      \\"path\\": [\\n        \\"color\\",\\n        \\"focus\\"\\n      ]\\n    },\\n    \\"hover\\": {\\n      \\"primary\\": {\\n        \\"value\\": \\"#990000\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{color.interactive.primary.value}\\"\\n        },\\n        \\"name\\": \\"PharosColorHoverPrimary\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"hover\\",\\n          \\"item\\": \\"primary\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"hover\\",\\n          \\"primary\\"\\n        ]\\n      },\\n      \\"secondary\\": {\\n        \\"value\\": \\"#ffffff\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{color.ui.10.value}\\"\\n        },\\n        \\"name\\": \\"PharosColorHoverSecondary\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"hover\\",\\n          \\"item\\": \\"secondary\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"hover\\",\\n          \\"secondary\\"\\n        ]\\n      },\\n      \\"row\\": {\\n        \\"value\\": \\"#f2f1ed\\",\\n        \\"filePath\\": \\"tokens/color/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{color.ui.20.value}\\"\\n        },\\n        \\"name\\": \\"PharosColorHoverRow\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"color\\",\\n          \\"type\\": \\"hover\\",\\n          \\"item\\": \\"row\\"\\n        },\\n        \\"path\\": [\\n          \\"color\\",\\n          \\"hover\\",\\n          \\"row\\"\\n        ]\\n      }\\n    }\\n  },\\n  \\"alert\\": {\\n    \\"color\\": {\\n      \\"background\\": {\\n        \\"base\\": {\\n          \\"value\\": \\"#f2f1ed\\",\\n          \\"filePath\\": \\"tokens/components/alert.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.Marble gray.94.value}\\"\\n          },\\n          \\"name\\": \\"PharosAlertColorBackgroundBase\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"alert\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"background\\",\\n            \\"subitem\\": \\"base\\"\\n          },\\n          \\"path\\": [\\n            \\"alert\\",\\n            \\"color\\",\\n            \\"background\\",\\n            \\"base\\"\\n          ]\\n        },\\n        \\"info\\": {\\n          \\"value\\": \\"#dcedef\\",\\n          \\"filePath\\": \\"tokens/components/alert.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.Glacier blue.90.value}\\"\\n          },\\n          \\"name\\": \\"PharosAlertColorBackgroundInfo\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"alert\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"background\\",\\n            \\"subitem\\": \\"info\\"\\n          },\\n          \\"path\\": [\\n            \\"alert\\",\\n            \\"color\\",\\n            \\"background\\",\\n            \\"info\\"\\n          ]\\n        },\\n        \\"error\\": {\\n          \\"value\\": \\"#f4d7d7\\",\\n          \\"filePath\\": \\"tokens/components/alert.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.Living coral.90.value}\\"\\n          },\\n          \\"name\\": \\"PharosAlertColorBackgroundError\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"alert\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"background\\",\\n            \\"subitem\\": \\"error\\"\\n          },\\n          \\"path\\": [\\n            \\"alert\\",\\n            \\"color\\",\\n            \\"background\\",\\n            \\"error\\"\\n          ]\\n        },\\n        \\"success\\": {\\n          \\"value\\": \\"#e9f1eb\\",\\n          \\"filePath\\": \\"tokens/components/alert.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.Green.93.value}\\"\\n          },\\n          \\"name\\": \\"PharosAlertColorBackgroundSuccess\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"alert\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"background\\",\\n            \\"subitem\\": \\"success\\"\\n          },\\n          \\"path\\": [\\n            \\"alert\\",\\n            \\"color\\",\\n            \\"background\\",\\n            \\"success\\"\\n          ]\\n        },\\n        \\"warning\\": {\\n          \\"value\\": \\"#fdf9f2\\",\\n          \\"filePath\\": \\"tokens/components/alert.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.Yellow.97.value}\\"\\n          },\\n          \\"name\\": \\"PharosAlertColorBackgroundWarning\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"alert\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"background\\",\\n            \\"subitem\\": \\"warning\\"\\n          },\\n          \\"path\\": [\\n            \\"alert\\",\\n            \\"color\\",\\n            \\"background\\",\\n            \\"warning\\"\\n          ]\\n        }\\n      },\\n      \\"icon\\": {\\n        \\"base\\": {\\n          \\"value\\": \\"#000000\\",\\n          \\"filePath\\": \\"tokens/components/alert.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.Black.value}\\"\\n          },\\n          \\"name\\": \\"PharosAlertColorIconBase\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"alert\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"icon\\",\\n            \\"subitem\\": \\"base\\"\\n          },\\n          \\"path\\": [\\n            \\"alert\\",\\n            \\"color\\",\\n            \\"icon\\",\\n            \\"base\\"\\n          ]\\n        },\\n        \\"info\\": {\\n          \\"value\\": \\"#0ba3c1\\",\\n          \\"filePath\\": \\"tokens/components/alert.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.Glacier blue.40.value}\\"\\n          },\\n          \\"name\\": \\"PharosAlertColorIconInfo\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"alert\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"icon\\",\\n            \\"subitem\\": \\"info\\"\\n          },\\n          \\"path\\": [\\n            \\"alert\\",\\n            \\"color\\",\\n            \\"icon\\",\\n            \\"info\\"\\n          ]\\n        },\\n        \\"error\\": {\\n          \\"value\\": \\"#dd3431\\",\\n          \\"filePath\\": \\"tokens/components/alert.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.feedback.error.value}\\"\\n          },\\n          \\"name\\": \\"PharosAlertColorIconError\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"alert\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"icon\\",\\n            \\"subitem\\": \\"error\\"\\n          },\\n          \\"path\\": [\\n            \\"alert\\",\\n            \\"color\\",\\n            \\"icon\\",\\n            \\"error\\"\\n          ]\\n        },\\n        \\"success\\": {\\n          \\"value\\": \\"#268241\\",\\n          \\"filePath\\": \\"tokens/components/alert.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.feedback.success.value}\\"\\n          },\\n          \\"name\\": \\"PharosAlertColorIconSuccess\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"alert\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"icon\\",\\n            \\"subitem\\": \\"success\\"\\n          },\\n          \\"path\\": [\\n            \\"alert\\",\\n            \\"color\\",\\n            \\"icon\\",\\n            \\"success\\"\\n          ]\\n        },\\n        \\"warning\\": {\\n          \\"value\\": \\"#faa926\\",\\n          \\"filePath\\": \\"tokens/components/alert.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.feedback.warning.value}\\"\\n          },\\n          \\"name\\": \\"PharosAlertColorIconWarning\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"alert\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"icon\\",\\n            \\"subitem\\": \\"warning\\"\\n          },\\n          \\"path\\": [\\n            \\"alert\\",\\n            \\"color\\",\\n            \\"icon\\",\\n            \\"warning\\"\\n          ]\\n        }\\n      },\\n      \\"text\\": {\\n        \\"base\\": {\\n          \\"value\\": \\"#000000\\",\\n          \\"filePath\\": \\"tokens/components/alert.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.text.base.value}\\"\\n          },\\n          \\"name\\": \\"PharosAlertColorTextBase\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"alert\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"text\\",\\n            \\"subitem\\": \\"base\\"\\n          },\\n          \\"path\\": [\\n            \\"alert\\",\\n            \\"color\\",\\n            \\"text\\",\\n            \\"base\\"\\n          ]\\n        },\\n        \\"inverse\\": {\\n          \\"value\\": \\"#ffffff\\",\\n          \\"filePath\\": \\"tokens/components/alert.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.text.white.value}\\"\\n          },\\n          \\"name\\": \\"PharosAlertColorTextInverse\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"alert\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"text\\",\\n            \\"subitem\\": \\"inverse\\"\\n          },\\n          \\"path\\": [\\n            \\"alert\\",\\n            \\"color\\",\\n            \\"text\\",\\n            \\"inverse\\"\\n          ]\\n        }\\n      },\\n      \\"link\\": {\\n        \\"base\\": {\\n          \\"value\\": \\"#000000\\",\\n          \\"filePath\\": \\"tokens/components/alert.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.interactive.secondary.value}\\"\\n          },\\n          \\"name\\": \\"PharosAlertColorLinkBase\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"alert\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"link\\",\\n            \\"subitem\\": \\"base\\"\\n          },\\n          \\"path\\": [\\n            \\"alert\\",\\n            \\"color\\",\\n            \\"link\\",\\n            \\"base\\"\\n          ]\\n        },\\n        \\"inverse\\": {\\n          \\"value\\": \\"#ffffff\\",\\n          \\"filePath\\": \\"tokens/components/alert.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.White.value}\\"\\n          },\\n          \\"name\\": \\"PharosAlertColorLinkInverse\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"alert\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"link\\",\\n            \\"subitem\\": \\"inverse\\"\\n          },\\n          \\"path\\": [\\n            \\"alert\\",\\n            \\"color\\",\\n            \\"link\\",\\n            \\"inverse\\"\\n          ]\\n        }\\n      },\\n      \\"border\\": {\\n        \\"base\\": {\\n          \\"value\\": \\"#f2f1ed\\",\\n          \\"filePath\\": \\"tokens/components/alert.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.Marble gray.94.value}\\"\\n          },\\n          \\"name\\": \\"PharosAlertColorBorderBase\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"alert\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"border\\",\\n            \\"subitem\\": \\"base\\"\\n          },\\n          \\"path\\": [\\n            \\"alert\\",\\n            \\"color\\",\\n            \\"border\\",\\n            \\"base\\"\\n          ]\\n        },\\n        \\"info\\": {\\n          \\"value\\": \\"#0ba3c1\\",\\n          \\"filePath\\": \\"tokens/components/alert.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.Glacier blue.40.value}\\"\\n          },\\n          \\"name\\": \\"PharosAlertColorBorderInfo\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"alert\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"border\\",\\n            \\"subitem\\": \\"info\\"\\n          },\\n          \\"path\\": [\\n            \\"alert\\",\\n            \\"color\\",\\n            \\"border\\",\\n            \\"info\\"\\n          ]\\n        },\\n        \\"error\\": {\\n          \\"value\\": \\"#dd3431\\",\\n          \\"filePath\\": \\"tokens/components/alert.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.feedback.error.value}\\"\\n          },\\n          \\"name\\": \\"PharosAlertColorBorderError\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"alert\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"border\\",\\n            \\"subitem\\": \\"error\\"\\n          },\\n          \\"path\\": [\\n            \\"alert\\",\\n            \\"color\\",\\n            \\"border\\",\\n            \\"error\\"\\n          ]\\n        },\\n        \\"success\\": {\\n          \\"value\\": \\"#268241\\",\\n          \\"filePath\\": \\"tokens/components/alert.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.feedback.success.value}\\"\\n          },\\n          \\"name\\": \\"PharosAlertColorBorderSuccess\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"alert\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"border\\",\\n            \\"subitem\\": \\"success\\"\\n          },\\n          \\"path\\": [\\n            \\"alert\\",\\n            \\"color\\",\\n            \\"border\\",\\n            \\"success\\"\\n          ]\\n        },\\n        \\"warning\\": {\\n          \\"value\\": \\"#faa926\\",\\n          \\"filePath\\": \\"tokens/components/alert.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.feedback.warning.value}\\"\\n          },\\n          \\"name\\": \\"PharosAlertColorBorderWarning\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"alert\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"border\\",\\n            \\"subitem\\": \\"warning\\"\\n          },\\n          \\"path\\": [\\n            \\"alert\\",\\n            \\"color\\",\\n            \\"border\\",\\n            \\"warning\\"\\n          ]\\n        }\\n      }\\n    }\\n  },\\n  \\"button\\": {\\n    \\"padding\\": {\\n      \\"base\\": {\\n        \\"value\\": \\"0.25rem\\",\\n        \\"filePath\\": \\"tokens/components/button.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{spacing.one-quarter-x.value}\\"\\n        },\\n        \\"name\\": \\"PharosButtonPaddingBase\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"button\\",\\n          \\"type\\": \\"padding\\",\\n          \\"item\\": \\"base\\"\\n        },\\n        \\"path\\": [\\n          \\"button\\",\\n          \\"padding\\",\\n          \\"base\\"\\n        ]\\n      },\\n      \\"condensed\\": {\\n        \\"value\\": \\"0.125rem\\",\\n        \\"filePath\\": \\"tokens/components/button.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{spacing.one-eighth-x.value}\\"\\n        },\\n        \\"name\\": \\"PharosButtonPaddingCondensed\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"button\\",\\n          \\"type\\": \\"padding\\",\\n          \\"item\\": \\"condensed\\"\\n        },\\n        \\"path\\": [\\n          \\"button\\",\\n          \\"padding\\",\\n          \\"condensed\\"\\n        ]\\n      },\\n      \\"large\\": {\\n        \\"value\\": \\"0.5rem\\",\\n        \\"filePath\\": \\"tokens/components/button.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{spacing.one-half-x.value}\\"\\n        },\\n        \\"name\\": \\"PharosButtonPaddingLarge\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"button\\",\\n          \\"type\\": \\"padding\\",\\n          \\"item\\": \\"large\\"\\n        },\\n        \\"path\\": [\\n          \\"button\\",\\n          \\"padding\\",\\n          \\"large\\"\\n        ]\\n      }\\n    },\\n    \\"color\\": {\\n      \\"base\\": {\\n        \\"primary\\": {\\n          \\"background\\": {\\n            \\"base\\": {\\n              \\"value\\": \\"#990000\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.interactive.primary.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBasePrimaryBackgroundBase\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"primary\\",\\n                \\"state\\": \\"background\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"primary\\",\\n                \\"background\\",\\n                \\"base\\"\\n              ]\\n            },\\n            \\"hover\\": {\\n              \\"value\\": \\"transparent\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"transparent\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBasePrimaryBackgroundHover\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"primary\\",\\n                \\"state\\": \\"background\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"primary\\",\\n                \\"background\\",\\n                \\"hover\\"\\n              ]\\n            },\\n            \\"disabled\\": {\\n              \\"value\\": \\"#eae8e1\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.disabled.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBasePrimaryBackgroundDisabled\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"primary\\",\\n                \\"state\\": \\"background\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"primary\\",\\n                \\"background\\",\\n                \\"disabled\\"\\n              ]\\n            }\\n          },\\n          \\"text\\": {\\n            \\"base\\": {\\n              \\"value\\": \\"#ffffff\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.text.white.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBasePrimaryTextBase\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"primary\\",\\n                \\"state\\": \\"text\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"primary\\",\\n                \\"text\\",\\n                \\"base\\"\\n              ]\\n            },\\n            \\"hover\\": {\\n              \\"value\\": \\"#990000\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.interactive.primary.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBasePrimaryTextHover\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"primary\\",\\n                \\"state\\": \\"text\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"primary\\",\\n                \\"text\\",\\n                \\"hover\\"\\n              ]\\n            },\\n            \\"disabled\\": {\\n              \\"value\\": \\"#676765\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.text.disabled.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBasePrimaryTextDisabled\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"primary\\",\\n                \\"state\\": \\"text\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"primary\\",\\n                \\"text\\",\\n                \\"disabled\\"\\n              ]\\n            }\\n          },\\n          \\"border\\": {\\n            \\"base\\": {\\n              \\"value\\": \\"#990000\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.interactive.primary.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBasePrimaryBorderBase\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"primary\\",\\n                \\"state\\": \\"border\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"primary\\",\\n                \\"border\\",\\n                \\"base\\"\\n              ]\\n            },\\n            \\"hover\\": {\\n              \\"value\\": \\"#990000\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.interactive.primary.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBasePrimaryBorderHover\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"primary\\",\\n                \\"state\\": \\"border\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"primary\\",\\n                \\"border\\",\\n                \\"hover\\"\\n              ]\\n            },\\n            \\"disabled\\": {\\n              \\"value\\": \\"#eae8e1\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.disabled.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBasePrimaryBorderDisabled\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"primary\\",\\n                \\"state\\": \\"border\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"primary\\",\\n                \\"border\\",\\n                \\"disabled\\"\\n              ]\\n            }\\n          }\\n        },\\n        \\"secondary\\": {\\n          \\"background\\": {\\n            \\"base\\": {\\n              \\"value\\": \\"transparent\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"transparent\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBaseSecondaryBackgroundBase\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"secondary\\",\\n                \\"state\\": \\"background\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"secondary\\",\\n                \\"background\\",\\n                \\"base\\"\\n              ]\\n            },\\n            \\"hover\\": {\\n              \\"value\\": \\"transparent\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"transparent\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBaseSecondaryBackgroundHover\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"secondary\\",\\n                \\"state\\": \\"background\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"secondary\\",\\n                \\"background\\",\\n                \\"hover\\"\\n              ]\\n            },\\n            \\"disabled\\": {\\n              \\"value\\": \\"#eae8e1\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.disabled.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBaseSecondaryBackgroundDisabled\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"secondary\\",\\n                \\"state\\": \\"background\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"secondary\\",\\n                \\"background\\",\\n                \\"disabled\\"\\n              ]\\n            }\\n          },\\n          \\"text\\": {\\n            \\"base\\": {\\n              \\"value\\": \\"#000000\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.text.base.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBaseSecondaryTextBase\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"secondary\\",\\n                \\"state\\": \\"text\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"secondary\\",\\n                \\"text\\",\\n                \\"base\\"\\n              ]\\n            },\\n            \\"hover\\": {\\n              \\"value\\": \\"#990000\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.interactive.primary.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBaseSecondaryTextHover\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"secondary\\",\\n                \\"state\\": \\"text\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"secondary\\",\\n                \\"text\\",\\n                \\"hover\\"\\n              ]\\n            },\\n            \\"disabled\\": {\\n              \\"value\\": \\"#676765\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.text.disabled.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBaseSecondaryTextDisabled\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"secondary\\",\\n                \\"state\\": \\"text\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"secondary\\",\\n                \\"text\\",\\n                \\"disabled\\"\\n              ]\\n            }\\n          },\\n          \\"border\\": {\\n            \\"base\\": {\\n              \\"value\\": \\"#d1cfc7\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.ui.40.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBaseSecondaryBorderBase\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"secondary\\",\\n                \\"state\\": \\"border\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"secondary\\",\\n                \\"border\\",\\n                \\"base\\"\\n              ]\\n            },\\n            \\"hover\\": {\\n              \\"value\\": \\"#990000\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.interactive.primary.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBaseSecondaryBorderHover\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"secondary\\",\\n                \\"state\\": \\"border\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"secondary\\",\\n                \\"border\\",\\n                \\"hover\\"\\n              ]\\n            },\\n            \\"disabled\\": {\\n              \\"value\\": \\"#eae8e1\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.disabled.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBaseSecondaryBorderDisabled\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"secondary\\",\\n                \\"state\\": \\"border\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"secondary\\",\\n                \\"border\\",\\n                \\"disabled\\"\\n              ]\\n            }\\n          }\\n        },\\n        \\"subtle\\": {\\n          \\"background\\": {\\n            \\"base\\": {\\n              \\"value\\": \\"transparent\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"transparent\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBaseSubtleBackgroundBase\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"subtle\\",\\n                \\"state\\": \\"background\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"subtle\\",\\n                \\"background\\",\\n                \\"base\\"\\n              ]\\n            },\\n            \\"hover\\": {\\n              \\"value\\": \\"#f2f1ed\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.ui.20.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBaseSubtleBackgroundHover\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"subtle\\",\\n                \\"state\\": \\"background\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"subtle\\",\\n                \\"background\\",\\n                \\"hover\\"\\n              ]\\n            },\\n            \\"disabled\\": {\\n              \\"value\\": \\"transparent\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"transparent\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBaseSubtleBackgroundDisabled\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"subtle\\",\\n                \\"state\\": \\"background\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"subtle\\",\\n                \\"background\\",\\n                \\"disabled\\"\\n              ]\\n            }\\n          },\\n          \\"text\\": {\\n            \\"base\\": {\\n              \\"value\\": \\"#000000\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.text.base.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBaseSubtleTextBase\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"subtle\\",\\n                \\"state\\": \\"text\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"subtle\\",\\n                \\"text\\",\\n                \\"base\\"\\n              ]\\n            },\\n            \\"hover\\": {\\n              \\"value\\": \\"#990000\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.interactive.primary.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBaseSubtleTextHover\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"subtle\\",\\n                \\"state\\": \\"text\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"subtle\\",\\n                \\"text\\",\\n                \\"hover\\"\\n              ]\\n            },\\n            \\"disabled\\": {\\n              \\"value\\": \\"#676765\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.text.disabled.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBaseSubtleTextDisabled\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"subtle\\",\\n                \\"state\\": \\"text\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"subtle\\",\\n                \\"text\\",\\n                \\"disabled\\"\\n              ]\\n            }\\n          },\\n          \\"border\\": {\\n            \\"base\\": {\\n              \\"value\\": \\"transparent\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"transparent\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBaseSubtleBorderBase\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"subtle\\",\\n                \\"state\\": \\"border\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"subtle\\",\\n                \\"border\\",\\n                \\"base\\"\\n              ]\\n            },\\n            \\"hover\\": {\\n              \\"value\\": \\"#f2f1ed\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.ui.20.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBaseSubtleBorderHover\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"subtle\\",\\n                \\"state\\": \\"border\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"subtle\\",\\n                \\"border\\",\\n                \\"hover\\"\\n              ]\\n            },\\n            \\"disabled\\": {\\n              \\"value\\": \\"transparent\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"transparent\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBaseSubtleBorderDisabled\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"subtle\\",\\n                \\"state\\": \\"border\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"subtle\\",\\n                \\"border\\",\\n                \\"disabled\\"\\n              ]\\n            }\\n          }\\n        },\\n        \\"overlay\\": {\\n          \\"background\\": {\\n            \\"base\\": {\\n              \\"value\\": \\"#1a1a19\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.Marble gray.10.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBaseOverlayBackgroundBase\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"overlay\\",\\n                \\"state\\": \\"background\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"overlay\\",\\n                \\"background\\",\\n                \\"base\\"\\n              ]\\n            },\\n            \\"hover\\": {\\n              \\"value\\": \\"#343332\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.Marble gray.20.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBaseOverlayBackgroundHover\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"overlay\\",\\n                \\"state\\": \\"background\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"overlay\\",\\n                \\"background\\",\\n                \\"hover\\"\\n              ]\\n            },\\n            \\"disabled\\": {\\n              \\"value\\": \\"#eae8e1\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.disabled.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBaseOverlayBackgroundDisabled\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"overlay\\",\\n                \\"state\\": \\"background\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"overlay\\",\\n                \\"background\\",\\n                \\"disabled\\"\\n              ]\\n            }\\n          },\\n          \\"text\\": {\\n            \\"base\\": {\\n              \\"value\\": \\"#ffffff\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.text.white.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBaseOverlayTextBase\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"overlay\\",\\n                \\"state\\": \\"text\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"overlay\\",\\n                \\"text\\",\\n                \\"base\\"\\n              ]\\n            },\\n            \\"hover\\": {\\n              \\"value\\": \\"#ffffff\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.text.white.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBaseOverlayTextHover\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"overlay\\",\\n                \\"state\\": \\"text\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"overlay\\",\\n                \\"text\\",\\n                \\"hover\\"\\n              ]\\n            },\\n            \\"disabled\\": {\\n              \\"value\\": \\"#676765\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.text.disabled.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBaseOverlayTextDisabled\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"overlay\\",\\n                \\"state\\": \\"text\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"overlay\\",\\n                \\"text\\",\\n                \\"disabled\\"\\n              ]\\n            }\\n          },\\n          \\"border\\": {\\n            \\"base\\": {\\n              \\"value\\": \\"#1a1a19\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.Marble gray.10.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBaseOverlayBorderBase\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"overlay\\",\\n                \\"state\\": \\"border\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"overlay\\",\\n                \\"border\\",\\n                \\"base\\"\\n              ]\\n            },\\n            \\"hover\\": {\\n              \\"value\\": \\"#343332\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.Marble gray.20.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBaseOverlayBorderHover\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"overlay\\",\\n                \\"state\\": \\"border\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"overlay\\",\\n                \\"border\\",\\n                \\"hover\\"\\n              ]\\n            },\\n            \\"disabled\\": {\\n              \\"value\\": \\"#eae8e1\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.disabled.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorBaseOverlayBorderDisabled\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"base\\",\\n                \\"subitem\\": \\"overlay\\",\\n                \\"state\\": \\"border\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"base\\",\\n                \\"overlay\\",\\n                \\"border\\",\\n                \\"disabled\\"\\n              ]\\n            }\\n          }\\n        }\\n      },\\n      \\"on-background\\": {\\n        \\"primary\\": {\\n          \\"background\\": {\\n            \\"base\\": {\\n              \\"value\\": \\"#990000\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.interactive.primary.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundPrimaryBackgroundBase\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"primary\\",\\n                \\"state\\": \\"background\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"primary\\",\\n                \\"background\\",\\n                \\"base\\"\\n              ]\\n            },\\n            \\"hover\\": {\\n              \\"value\\": \\"transparent\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"transparent\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundPrimaryBackgroundHover\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"primary\\",\\n                \\"state\\": \\"background\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"primary\\",\\n                \\"background\\",\\n                \\"hover\\"\\n              ]\\n            },\\n            \\"disabled\\": {\\n              \\"value\\": \\"#343332\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.Marble gray.20.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundPrimaryBackgroundDisabled\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"primary\\",\\n                \\"state\\": \\"background\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"primary\\",\\n                \\"background\\",\\n                \\"disabled\\"\\n              ]\\n            }\\n          },\\n          \\"text\\": {\\n            \\"base\\": {\\n              \\"value\\": \\"#ffffff\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.text.white.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundPrimaryTextBase\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"primary\\",\\n                \\"state\\": \\"text\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"primary\\",\\n                \\"text\\",\\n                \\"base\\"\\n              ]\\n            },\\n            \\"hover\\": {\\n              \\"value\\": \\"#ffffff\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.text.white.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundPrimaryTextHover\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"primary\\",\\n                \\"state\\": \\"text\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"primary\\",\\n                \\"text\\",\\n                \\"hover\\"\\n              ]\\n            },\\n            \\"disabled\\": {\\n              \\"value\\": \\"#81807e\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.Marble gray.50.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundPrimaryTextDisabled\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"primary\\",\\n                \\"state\\": \\"text\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"primary\\",\\n                \\"text\\",\\n                \\"disabled\\"\\n              ]\\n            }\\n          },\\n          \\"border\\": {\\n            \\"base\\": {\\n              \\"value\\": \\"#990000\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.interactive.primary.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundPrimaryBorderBase\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"primary\\",\\n                \\"state\\": \\"border\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"primary\\",\\n                \\"border\\",\\n                \\"base\\"\\n              ]\\n            },\\n            \\"hover\\": {\\n              \\"value\\": \\"#ffffff\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.ui.10.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundPrimaryBorderHover\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"primary\\",\\n                \\"state\\": \\"border\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"primary\\",\\n                \\"border\\",\\n                \\"hover\\"\\n              ]\\n            },\\n            \\"disabled\\": {\\n              \\"value\\": \\"#343332\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.Marble gray.20.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundPrimaryBorderDisabled\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"primary\\",\\n                \\"state\\": \\"border\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"primary\\",\\n                \\"border\\",\\n                \\"disabled\\"\\n              ]\\n            }\\n          }\\n        },\\n        \\"secondary\\": {\\n          \\"background\\": {\\n            \\"base\\": {\\n              \\"value\\": \\"transparent\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"transparent\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundSecondaryBackgroundBase\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"secondary\\",\\n                \\"state\\": \\"background\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"secondary\\",\\n                \\"background\\",\\n                \\"base\\"\\n              ]\\n            },\\n            \\"hover\\": {\\n              \\"value\\": \\"transparent\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"transparent\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundSecondaryBackgroundHover\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"secondary\\",\\n                \\"state\\": \\"background\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"secondary\\",\\n                \\"background\\",\\n                \\"hover\\"\\n              ]\\n            },\\n            \\"disabled\\": {\\n              \\"value\\": \\"#343332\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.Marble gray.20.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundSecondaryBackgroundDisabled\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"secondary\\",\\n                \\"state\\": \\"background\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"secondary\\",\\n                \\"background\\",\\n                \\"disabled\\"\\n              ]\\n            }\\n          },\\n          \\"text\\": {\\n            \\"base\\": {\\n              \\"value\\": \\"#ffffff\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.text.white.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundSecondaryTextBase\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"secondary\\",\\n                \\"state\\": \\"text\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"secondary\\",\\n                \\"text\\",\\n                \\"base\\"\\n              ]\\n            },\\n            \\"hover\\": {\\n              \\"value\\": \\"#ffffff\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.text.white.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundSecondaryTextHover\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"secondary\\",\\n                \\"state\\": \\"text\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"secondary\\",\\n                \\"text\\",\\n                \\"hover\\"\\n              ]\\n            },\\n            \\"disabled\\": {\\n              \\"value\\": \\"#81807e\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.Marble gray.50.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundSecondaryTextDisabled\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"secondary\\",\\n                \\"state\\": \\"text\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"secondary\\",\\n                \\"text\\",\\n                \\"disabled\\"\\n              ]\\n            }\\n          },\\n          \\"border\\": {\\n            \\"base\\": {\\n              \\"value\\": \\"#81807e\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.Marble gray.50.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundSecondaryBorderBase\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"secondary\\",\\n                \\"state\\": \\"border\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"secondary\\",\\n                \\"border\\",\\n                \\"base\\"\\n              ]\\n            },\\n            \\"hover\\": {\\n              \\"value\\": \\"#ffffff\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.ui.10.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundSecondaryBorderHover\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"secondary\\",\\n                \\"state\\": \\"border\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"secondary\\",\\n                \\"border\\",\\n                \\"hover\\"\\n              ]\\n            },\\n            \\"disabled\\": {\\n              \\"value\\": \\"#343332\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.Marble gray.20.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundSecondaryBorderDisabled\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"secondary\\",\\n                \\"state\\": \\"border\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"secondary\\",\\n                \\"border\\",\\n                \\"disabled\\"\\n              ]\\n            }\\n          }\\n        },\\n        \\"subtle\\": {\\n          \\"background\\": {\\n            \\"base\\": {\\n              \\"value\\": \\"transparent\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"transparent\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundSubtleBackgroundBase\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"subtle\\",\\n                \\"state\\": \\"background\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"subtle\\",\\n                \\"background\\",\\n                \\"base\\"\\n              ]\\n            },\\n            \\"hover\\": {\\n              \\"value\\": \\"#343332\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.Marble gray.20.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundSubtleBackgroundHover\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"subtle\\",\\n                \\"state\\": \\"background\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"subtle\\",\\n                \\"background\\",\\n                \\"hover\\"\\n              ]\\n            },\\n            \\"disabled\\": {\\n              \\"value\\": \\"transparent\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"transparent\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundSubtleBackgroundDisabled\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"subtle\\",\\n                \\"state\\": \\"background\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"subtle\\",\\n                \\"background\\",\\n                \\"disabled\\"\\n              ]\\n            }\\n          },\\n          \\"text\\": {\\n            \\"base\\": {\\n              \\"value\\": \\"#ffffff\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.text.white.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundSubtleTextBase\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"subtle\\",\\n                \\"state\\": \\"text\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"subtle\\",\\n                \\"text\\",\\n                \\"base\\"\\n              ]\\n            },\\n            \\"hover\\": {\\n              \\"value\\": \\"#ffffff\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.text.white.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundSubtleTextHover\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"subtle\\",\\n                \\"state\\": \\"text\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"subtle\\",\\n                \\"text\\",\\n                \\"hover\\"\\n              ]\\n            },\\n            \\"disabled\\": {\\n              \\"value\\": \\"#81807e\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.Marble gray.50.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundSubtleTextDisabled\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"subtle\\",\\n                \\"state\\": \\"text\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"subtle\\",\\n                \\"text\\",\\n                \\"disabled\\"\\n              ]\\n            }\\n          },\\n          \\"border\\": {\\n            \\"base\\": {\\n              \\"value\\": \\"transparent\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"transparent\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundSubtleBorderBase\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"subtle\\",\\n                \\"state\\": \\"border\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"subtle\\",\\n                \\"border\\",\\n                \\"base\\"\\n              ]\\n            },\\n            \\"hover\\": {\\n              \\"value\\": \\"#343332\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.Marble gray.20.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundSubtleBorderHover\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"subtle\\",\\n                \\"state\\": \\"border\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"subtle\\",\\n                \\"border\\",\\n                \\"hover\\"\\n              ]\\n            },\\n            \\"disabled\\": {\\n              \\"value\\": \\"transparent\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"transparent\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundSubtleBorderDisabled\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"subtle\\",\\n                \\"state\\": \\"border\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"subtle\\",\\n                \\"border\\",\\n                \\"disabled\\"\\n              ]\\n            }\\n          }\\n        },\\n        \\"overlay\\": {\\n          \\"background\\": {\\n            \\"base\\": {\\n              \\"value\\": \\"#1a1a19\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.Marble gray.10.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundOverlayBackgroundBase\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"overlay\\",\\n                \\"state\\": \\"background\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"overlay\\",\\n                \\"background\\",\\n                \\"base\\"\\n              ]\\n            },\\n            \\"hover\\": {\\n              \\"value\\": \\"#343332\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.Marble gray.20.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundOverlayBackgroundHover\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"overlay\\",\\n                \\"state\\": \\"background\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"overlay\\",\\n                \\"background\\",\\n                \\"hover\\"\\n              ]\\n            },\\n            \\"disabled\\": {\\n              \\"value\\": \\"#343332\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.Marble gray.20.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundOverlayBackgroundDisabled\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"overlay\\",\\n                \\"state\\": \\"background\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"overlay\\",\\n                \\"background\\",\\n                \\"disabled\\"\\n              ]\\n            }\\n          },\\n          \\"text\\": {\\n            \\"base\\": {\\n              \\"value\\": \\"#ffffff\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.text.white.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundOverlayTextBase\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"overlay\\",\\n                \\"state\\": \\"text\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"overlay\\",\\n                \\"text\\",\\n                \\"base\\"\\n              ]\\n            },\\n            \\"hover\\": {\\n              \\"value\\": \\"#ffffff\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.text.white.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundOverlayTextHover\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"overlay\\",\\n                \\"state\\": \\"text\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"overlay\\",\\n                \\"text\\",\\n                \\"hover\\"\\n              ]\\n            },\\n            \\"disabled\\": {\\n              \\"value\\": \\"#81807e\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.Marble gray.50.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundOverlayTextDisabled\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"overlay\\",\\n                \\"state\\": \\"text\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"overlay\\",\\n                \\"text\\",\\n                \\"disabled\\"\\n              ]\\n            }\\n          },\\n          \\"border\\": {\\n            \\"base\\": {\\n              \\"value\\": \\"#1a1a19\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.Marble gray.10.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundOverlayBorderBase\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"overlay\\",\\n                \\"state\\": \\"border\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"overlay\\",\\n                \\"border\\",\\n                \\"base\\"\\n              ]\\n            },\\n            \\"hover\\": {\\n              \\"value\\": \\"#343332\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.Marble gray.20.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundOverlayBorderHover\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"overlay\\",\\n                \\"state\\": \\"border\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"overlay\\",\\n                \\"border\\",\\n                \\"hover\\"\\n              ]\\n            },\\n            \\"disabled\\": {\\n              \\"value\\": \\"#343332\\",\\n              \\"filePath\\": \\"tokens/components/button.json\\",\\n              \\"isSource\\": true,\\n              \\"original\\": {\\n                \\"value\\": \\"{color.Marble gray.20.value}\\"\\n              },\\n              \\"name\\": \\"PharosButtonColorOnBackgroundOverlayBorderDisabled\\",\\n              \\"attributes\\": {\\n                \\"category\\": \\"button\\",\\n                \\"type\\": \\"color\\",\\n                \\"item\\": \\"on-background\\",\\n                \\"subitem\\": \\"overlay\\",\\n                \\"state\\": \\"border\\"\\n              },\\n              \\"path\\": [\\n                \\"button\\",\\n                \\"color\\",\\n                \\"on-background\\",\\n                \\"overlay\\",\\n                \\"border\\",\\n                \\"disabled\\"\\n              ]\\n            }\\n          }\\n        }\\n      }\\n    }\\n  },\\n  \\"checkbox-group\\": {\\n    \\"spacing\\": {\\n      \\"vertical\\": {\\n        \\"value\\": \\"0.5rem\\",\\n        \\"filePath\\": \\"tokens/components/checkbox-group.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{spacing.one-half-x.value}\\"\\n        },\\n        \\"name\\": \\"PharosCheckboxGroupSpacingVertical\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"checkbox-group\\",\\n          \\"type\\": \\"spacing\\",\\n          \\"item\\": \\"vertical\\"\\n        },\\n        \\"path\\": [\\n          \\"checkbox-group\\",\\n          \\"spacing\\",\\n          \\"vertical\\"\\n        ]\\n      },\\n      \\"horizontal\\": {\\n        \\"value\\": \\"1.5rem\\",\\n        \\"filePath\\": \\"tokens/components/checkbox-group.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{spacing.one-and-a-half-x.value}\\"\\n        },\\n        \\"name\\": \\"PharosCheckboxGroupSpacingHorizontal\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"checkbox-group\\",\\n          \\"type\\": \\"spacing\\",\\n          \\"item\\": \\"horizontal\\"\\n        },\\n        \\"path\\": [\\n          \\"checkbox-group\\",\\n          \\"spacing\\",\\n          \\"horizontal\\"\\n        ]\\n      }\\n    }\\n  },\\n  \\"checkbox\\": {\\n    \\"color\\": {\\n      \\"background\\": {\\n        \\"base\\": {\\n          \\"value\\": \\"#ffffff\\",\\n          \\"filePath\\": \\"tokens/components/checkbox.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.ui.10.value}\\"\\n          },\\n          \\"name\\": \\"PharosCheckboxColorBackgroundBase\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"checkbox\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"background\\",\\n            \\"subitem\\": \\"base\\"\\n          },\\n          \\"path\\": [\\n            \\"checkbox\\",\\n            \\"color\\",\\n            \\"background\\",\\n            \\"base\\"\\n          ]\\n        }\\n      }\\n    }\\n  },\\n  \\"combobox\\": {\\n    \\"color\\": {\\n      \\"text\\": {\\n        \\"hover\\": {\\n          \\"value\\": \\"#990000\\",\\n          \\"filePath\\": \\"tokens/components/combobox.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.hover.primary.value}\\"\\n          },\\n          \\"name\\": \\"PharosComboboxColorTextHover\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"combobox\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"text\\",\\n            \\"subitem\\": \\"hover\\"\\n          },\\n          \\"path\\": [\\n            \\"combobox\\",\\n            \\"color\\",\\n            \\"text\\",\\n            \\"hover\\"\\n          ]\\n        },\\n        \\"selected\\": {\\n          \\"value\\": \\"#000000\\",\\n          \\"filePath\\": \\"tokens/components/combobox.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.text.base.value}\\"\\n          },\\n          \\"name\\": \\"PharosComboboxColorTextSelected\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"combobox\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"text\\",\\n            \\"subitem\\": \\"selected\\"\\n          },\\n          \\"path\\": [\\n            \\"combobox\\",\\n            \\"color\\",\\n            \\"text\\",\\n            \\"selected\\"\\n          ]\\n        }\\n      },\\n      \\"icon\\": {\\n        \\"clear\\": {\\n          \\"value\\": \\"#81807e\\",\\n          \\"filePath\\": \\"tokens/components/combobox.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.ui.50.value}\\"\\n          },\\n          \\"name\\": \\"PharosComboboxColorIconClear\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"combobox\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"icon\\",\\n            \\"subitem\\": \\"clear\\"\\n          },\\n          \\"path\\": [\\n            \\"combobox\\",\\n            \\"color\\",\\n            \\"icon\\",\\n            \\"clear\\"\\n          ]\\n        },\\n        \\"dropdown\\": {\\n          \\"value\\": \\"#000000\\",\\n          \\"filePath\\": \\"tokens/components/combobox.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.interactive.secondary.value}\\"\\n          },\\n          \\"name\\": \\"PharosComboboxColorIconDropdown\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"combobox\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"icon\\",\\n            \\"subitem\\": \\"dropdown\\"\\n          },\\n          \\"path\\": [\\n            \\"combobox\\",\\n            \\"color\\",\\n            \\"icon\\",\\n            \\"dropdown\\"\\n          ]\\n        },\\n        \\"checkmark\\": {\\n          \\"value\\": \\"#000000\\",\\n          \\"filePath\\": \\"tokens/components/combobox.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.interactive.secondary.value}\\"\\n          },\\n          \\"name\\": \\"PharosComboboxColorIconCheckmark\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"combobox\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"icon\\",\\n            \\"subitem\\": \\"checkmark\\"\\n          },\\n          \\"path\\": [\\n            \\"combobox\\",\\n            \\"color\\",\\n            \\"icon\\",\\n            \\"checkmark\\"\\n          ]\\n        },\\n        \\"focus\\": {\\n          \\"value\\": \\"#990000\\",\\n          \\"filePath\\": \\"tokens/components/combobox.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.interactive.primary.value}\\"\\n          },\\n          \\"name\\": \\"PharosComboboxColorIconFocus\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"combobox\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"icon\\",\\n            \\"subitem\\": \\"focus\\"\\n          },\\n          \\"path\\": [\\n            \\"combobox\\",\\n            \\"color\\",\\n            \\"icon\\",\\n            \\"focus\\"\\n          ]\\n        }\\n      }\\n    },\\n    \\"size\\": {\\n      \\"height\\": {\\n        \\"list\\": {\\n          \\"value\\": \\"15rem\\",\\n          \\"comment\\": \\"TODO: Update with core token value\\",\\n          \\"filePath\\": \\"tokens/components/combobox.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"15rem\\",\\n            \\"comment\\": \\"TODO: Update with core token value\\"\\n          },\\n          \\"name\\": \\"PharosComboboxSizeHeightList\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"combobox\\",\\n            \\"type\\": \\"size\\",\\n            \\"item\\": \\"height\\",\\n            \\"subitem\\": \\"list\\"\\n          },\\n          \\"path\\": [\\n            \\"combobox\\",\\n            \\"size\\",\\n            \\"height\\",\\n            \\"list\\"\\n          ]\\n        },\\n        \\"clear\\": {\\n          \\"value\\": \\"1.875rem\\",\\n          \\"comment\\": \\"TODO: Update with core token value\\",\\n          \\"filePath\\": \\"tokens/components/combobox.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"1.875rem\\",\\n            \\"comment\\": \\"TODO: Update with core token value\\"\\n          },\\n          \\"name\\": \\"PharosComboboxSizeHeightClear\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"combobox\\",\\n            \\"type\\": \\"size\\",\\n            \\"item\\": \\"height\\",\\n            \\"subitem\\": \\"clear\\"\\n          },\\n          \\"path\\": [\\n            \\"combobox\\",\\n            \\"size\\",\\n            \\"height\\",\\n            \\"clear\\"\\n          ]\\n        }\\n      }\\n    }\\n  },\\n  \\"dropdown-menu-item\\": {\\n    \\"color\\": {\\n      \\"text\\": {\\n        \\"base\\": {\\n          \\"value\\": \\"#000000\\",\\n          \\"filePath\\": \\"tokens/components/dropdown-menu-item.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.Black.value}\\"\\n          },\\n          \\"name\\": \\"PharosDropdownMenuItemColorTextBase\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"dropdown-menu-item\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"text\\",\\n            \\"subitem\\": \\"base\\"\\n          },\\n          \\"path\\": [\\n            \\"dropdown-menu-item\\",\\n            \\"color\\",\\n            \\"text\\",\\n            \\"base\\"\\n          ]\\n        },\\n        \\"hover\\": {\\n          \\"value\\": \\"#990000\\",\\n          \\"filePath\\": \\"tokens/components/dropdown-menu-item.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.JSTOR red.value}\\"\\n          },\\n          \\"name\\": \\"PharosDropdownMenuItemColorTextHover\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"dropdown-menu-item\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"text\\",\\n            \\"subitem\\": \\"hover\\"\\n          },\\n          \\"path\\": [\\n            \\"dropdown-menu-item\\",\\n            \\"color\\",\\n            \\"text\\",\\n            \\"hover\\"\\n          ]\\n        },\\n        \\"disabled\\": {\\n          \\"value\\": \\"#676765\\",\\n          \\"filePath\\": \\"tokens/components/dropdown-menu-item.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.Marble gray.40.value}\\"\\n          },\\n          \\"name\\": \\"PharosDropdownMenuItemColorTextDisabled\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"dropdown-menu-item\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"text\\",\\n            \\"subitem\\": \\"disabled\\"\\n          },\\n          \\"path\\": [\\n            \\"dropdown-menu-item\\",\\n            \\"color\\",\\n            \\"text\\",\\n            \\"disabled\\"\\n          ]\\n        },\\n        \\"description\\": {\\n          \\"value\\": \\"#676765\\",\\n          \\"filePath\\": \\"tokens/components/dropdown-menu-item.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.Marble gray.40.value}\\"\\n          },\\n          \\"name\\": \\"PharosDropdownMenuItemColorTextDescription\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"dropdown-menu-item\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"text\\",\\n            \\"subitem\\": \\"description\\"\\n          },\\n          \\"path\\": [\\n            \\"dropdown-menu-item\\",\\n            \\"color\\",\\n            \\"text\\",\\n            \\"description\\"\\n          ]\\n        }\\n      },\\n      \\"border\\": {\\n        \\"base\\": {\\n          \\"value\\": \\"#d1cfc7\\",\\n          \\"filePath\\": \\"tokens/components/dropdown-menu-item.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.Marble gray.80.value}\\"\\n          },\\n          \\"name\\": \\"PharosDropdownMenuItemColorBorderBase\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"dropdown-menu-item\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"border\\",\\n            \\"subitem\\": \\"base\\"\\n          },\\n          \\"path\\": [\\n            \\"dropdown-menu-item\\",\\n            \\"color\\",\\n            \\"border\\",\\n            \\"base\\"\\n          ]\\n        }\\n      },\\n      \\"background\\": {\\n        \\"base\\": {\\n          \\"value\\": \\"#ffffff\\",\\n          \\"filePath\\": \\"tokens/components/dropdown-menu-item.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.White.value}\\"\\n          },\\n          \\"name\\": \\"PharosDropdownMenuItemColorBackgroundBase\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"dropdown-menu-item\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"background\\",\\n            \\"subitem\\": \\"base\\"\\n          },\\n          \\"path\\": [\\n            \\"dropdown-menu-item\\",\\n            \\"color\\",\\n            \\"background\\",\\n            \\"base\\"\\n          ]\\n        },\\n        \\"active\\": {\\n          \\"value\\": \\"#eae8e1\\",\\n          \\"filePath\\": \\"tokens/components/dropdown-menu-item.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.Marble gray.base.value}\\"\\n          },\\n          \\"name\\": \\"PharosDropdownMenuItemColorBackgroundActive\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"dropdown-menu-item\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"background\\",\\n            \\"subitem\\": \\"active\\"\\n          },\\n          \\"path\\": [\\n            \\"dropdown-menu-item\\",\\n            \\"color\\",\\n            \\"background\\",\\n            \\"active\\"\\n          ]\\n        },\\n        \\"disabled\\": {\\n          \\"value\\": \\"#eae8e1\\",\\n          \\"filePath\\": \\"tokens/components/dropdown-menu-item.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.Marble gray.base.value}\\"\\n          },\\n          \\"name\\": \\"PharosDropdownMenuItemColorBackgroundDisabled\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"dropdown-menu-item\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"background\\",\\n            \\"subitem\\": \\"disabled\\"\\n          },\\n          \\"path\\": [\\n            \\"dropdown-menu-item\\",\\n            \\"color\\",\\n            \\"background\\",\\n            \\"disabled\\"\\n          ]\\n        },\\n        \\"hover\\": {\\n          \\"value\\": \\"#f2f1ed\\",\\n          \\"filePath\\": \\"tokens/components/dropdown-menu-item.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.Marble gray.94.value}\\"\\n          },\\n          \\"name\\": \\"PharosDropdownMenuItemColorBackgroundHover\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"dropdown-menu-item\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"background\\",\\n            \\"subitem\\": \\"hover\\"\\n          },\\n          \\"path\\": [\\n            \\"dropdown-menu-item\\",\\n            \\"color\\",\\n            \\"background\\",\\n            \\"hover\\"\\n          ]\\n        }\\n      },\\n      \\"icon\\": {\\n        \\"base\\": {\\n          \\"value\\": \\"#000000\\",\\n          \\"filePath\\": \\"tokens/components/dropdown-menu-item.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.Black.value}\\"\\n          },\\n          \\"name\\": \\"PharosDropdownMenuItemColorIconBase\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"dropdown-menu-item\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"icon\\",\\n            \\"subitem\\": \\"base\\"\\n          },\\n          \\"path\\": [\\n            \\"dropdown-menu-item\\",\\n            \\"color\\",\\n            \\"icon\\",\\n            \\"base\\"\\n          ]\\n        }\\n      }\\n    }\\n  },\\n  \\"dropdown-menu\\": {\\n    \\"color\\": {\\n      \\"border\\": {\\n        \\"base\\": {\\n          \\"value\\": \\"#d1cfc7\\",\\n          \\"filePath\\": \\"tokens/components/dropdown-menu.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.Marble gray.80.value}\\"\\n          },\\n          \\"name\\": \\"PharosDropdownMenuColorBorderBase\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"dropdown-menu\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"border\\",\\n            \\"subitem\\": \\"base\\"\\n          },\\n          \\"path\\": [\\n            \\"dropdown-menu\\",\\n            \\"color\\",\\n            \\"border\\",\\n            \\"base\\"\\n          ]\\n        }\\n      }\\n    },\\n    \\"size\\": {\\n      \\"width\\": {\\n        \\"min\\": {\\n          \\"value\\": \\"9rem\\",\\n          \\"comment\\": \\"TODO: Update with core token value\\",\\n          \\"filePath\\": \\"tokens/components/dropdown-menu.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"9rem\\",\\n            \\"comment\\": \\"TODO: Update with core token value\\"\\n          },\\n          \\"name\\": \\"PharosDropdownMenuSizeWidthMin\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"dropdown-menu\\",\\n            \\"type\\": \\"size\\",\\n            \\"item\\": \\"width\\",\\n            \\"subitem\\": \\"min\\"\\n          },\\n          \\"path\\": [\\n            \\"dropdown-menu\\",\\n            \\"size\\",\\n            \\"width\\",\\n            \\"min\\"\\n          ]\\n        },\\n        \\"max\\": {\\n          \\"value\\": \\"17rem\\",\\n          \\"comment\\": \\"TODO: Update with core token value\\",\\n          \\"filePath\\": \\"tokens/components/dropdown-menu.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"17rem\\",\\n            \\"comment\\": \\"TODO: Update with core token value\\"\\n          },\\n          \\"name\\": \\"PharosDropdownMenuSizeWidthMax\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"dropdown-menu\\",\\n            \\"type\\": \\"size\\",\\n            \\"item\\": \\"width\\",\\n            \\"subitem\\": \\"max\\"\\n          },\\n          \\"path\\": [\\n            \\"dropdown-menu\\",\\n            \\"size\\",\\n            \\"width\\",\\n            \\"max\\"\\n          ]\\n        }\\n      }\\n    }\\n  },\\n  \\"form-element\\": {\\n    \\"color\\": {\\n      \\"text\\": {\\n        \\"base\\": {\\n          \\"value\\": \\"#000000\\",\\n          \\"filePath\\": \\"tokens/components/form-element.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.text.base.value}\\"\\n          },\\n          \\"name\\": \\"PharosFormElementColorTextBase\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"form-element\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"text\\",\\n            \\"subitem\\": \\"base\\"\\n          },\\n          \\"path\\": [\\n            \\"form-element\\",\\n            \\"color\\",\\n            \\"text\\",\\n            \\"base\\"\\n          ]\\n        },\\n        \\"required\\": {\\n          \\"value\\": \\"#dd3431\\",\\n          \\"filePath\\": \\"tokens/components/form-element.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.feedback.error.value}\\"\\n          },\\n          \\"name\\": \\"PharosFormElementColorTextRequired\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"form-element\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"text\\",\\n            \\"subitem\\": \\"required\\"\\n          },\\n          \\"path\\": [\\n            \\"form-element\\",\\n            \\"color\\",\\n            \\"text\\",\\n            \\"required\\"\\n          ]\\n        },\\n        \\"invalid\\": {\\n          \\"value\\": \\"#dd3431\\",\\n          \\"filePath\\": \\"tokens/components/form-element.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.feedback.error.value}\\"\\n          },\\n          \\"name\\": \\"PharosFormElementColorTextInvalid\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"form-element\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"text\\",\\n            \\"subitem\\": \\"invalid\\"\\n          },\\n          \\"path\\": [\\n            \\"form-element\\",\\n            \\"color\\",\\n            \\"text\\",\\n            \\"invalid\\"\\n          ]\\n        },\\n        \\"disabled\\": {\\n          \\"value\\": \\"#676765\\",\\n          \\"filePath\\": \\"tokens/components/form-element.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.text.disabled.value}\\"\\n          },\\n          \\"name\\": \\"PharosFormElementColorTextDisabled\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"form-element\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"text\\",\\n            \\"subitem\\": \\"disabled\\"\\n          },\\n          \\"path\\": [\\n            \\"form-element\\",\\n            \\"color\\",\\n            \\"text\\",\\n            \\"disabled\\"\\n          ]\\n        },\\n        \\"placeholder\\": {\\n          \\"value\\": \\"#676765\\",\\n          \\"filePath\\": \\"tokens/components/form-element.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.text.placeholder.value}\\"\\n          },\\n          \\"name\\": \\"PharosFormElementColorTextPlaceholder\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"form-element\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"text\\",\\n            \\"subitem\\": \\"placeholder\\"\\n          },\\n          \\"path\\": [\\n            \\"form-element\\",\\n            \\"color\\",\\n            \\"text\\",\\n            \\"placeholder\\"\\n          ]\\n        }\\n      },\\n      \\"background\\": {\\n        \\"disabled\\": {\\n          \\"value\\": \\"#eae8e1\\",\\n          \\"filePath\\": \\"tokens/components/form-element.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.disabled.value}\\"\\n          },\\n          \\"name\\": \\"PharosFormElementColorBackgroundDisabled\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"form-element\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"background\\",\\n            \\"subitem\\": \\"disabled\\"\\n          },\\n          \\"path\\": [\\n            \\"form-element\\",\\n            \\"color\\",\\n            \\"background\\",\\n            \\"disabled\\"\\n          ]\\n        },\\n        \\"selected\\": {\\n          \\"value\\": \\"#000000\\",\\n          \\"filePath\\": \\"tokens/components/form-element.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.interactive.secondary.value}\\"\\n          },\\n          \\"name\\": \\"PharosFormElementColorBackgroundSelected\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"form-element\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"background\\",\\n            \\"subitem\\": \\"selected\\"\\n          },\\n          \\"path\\": [\\n            \\"form-element\\",\\n            \\"color\\",\\n            \\"background\\",\\n            \\"selected\\"\\n          ]\\n        }\\n      },\\n      \\"border\\": {\\n        \\"base\\": {\\n          \\"value\\": \\"#81807e\\",\\n          \\"filePath\\": \\"tokens/components/form-element.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.ui.50.value}\\"\\n          },\\n          \\"name\\": \\"PharosFormElementColorBorderBase\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"form-element\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"border\\",\\n            \\"subitem\\": \\"base\\"\\n          },\\n          \\"path\\": [\\n            \\"form-element\\",\\n            \\"color\\",\\n            \\"border\\",\\n            \\"base\\"\\n          ]\\n        },\\n        \\"focus\\": {\\n          \\"value\\": \\"#0ba3c1\\",\\n          \\"filePath\\": \\"tokens/components/form-element.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.focus.value}\\"\\n          },\\n          \\"name\\": \\"PharosFormElementColorBorderFocus\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"form-element\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"border\\",\\n            \\"subitem\\": \\"focus\\"\\n          },\\n          \\"path\\": [\\n            \\"form-element\\",\\n            \\"color\\",\\n            \\"border\\",\\n            \\"focus\\"\\n          ]\\n        },\\n        \\"invalid\\": {\\n          \\"value\\": \\"#dd3431\\",\\n          \\"filePath\\": \\"tokens/components/form-element.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.feedback.error.value}\\"\\n          },\\n          \\"name\\": \\"PharosFormElementColorBorderInvalid\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"form-element\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"border\\",\\n            \\"subitem\\": \\"invalid\\"\\n          },\\n          \\"path\\": [\\n            \\"form-element\\",\\n            \\"color\\",\\n            \\"border\\",\\n            \\"invalid\\"\\n          ]\\n        },\\n        \\"disabled\\": {\\n          \\"value\\": \\"#d1cfc7\\",\\n          \\"filePath\\": \\"tokens/components/form-element.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.ui.40.value}\\"\\n          },\\n          \\"name\\": \\"PharosFormElementColorBorderDisabled\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"form-element\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"border\\",\\n            \\"subitem\\": \\"disabled\\"\\n          },\\n          \\"path\\": [\\n            \\"form-element\\",\\n            \\"color\\",\\n            \\"border\\",\\n            \\"disabled\\"\\n          ]\\n        }\\n      }\\n    },\\n    \\"size\\": {\\n      \\"text\\": {\\n        \\"label\\": {\\n          \\"value\\": \\"2\\",\\n          \\"filePath\\": \\"tokens/components/form-element.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{font.size.small.value}\\"\\n          },\\n          \\"name\\": \\"PharosFormElementSizeTextLabel\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"form-element\\",\\n            \\"type\\": \\"size\\",\\n            \\"item\\": \\"text\\",\\n            \\"subitem\\": \\"label\\"\\n          },\\n          \\"path\\": [\\n            \\"form-element\\",\\n            \\"size\\",\\n            \\"text\\",\\n            \\"label\\"\\n          ]\\n        },\\n        \\"input\\": {\\n          \\"value\\": \\"3\\",\\n          \\"filePath\\": \\"tokens/components/form-element.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{font.size.base.value}\\"\\n          },\\n          \\"name\\": \\"PharosFormElementSizeTextInput\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"form-element\\",\\n            \\"type\\": \\"size\\",\\n            \\"item\\": \\"text\\",\\n            \\"subitem\\": \\"input\\"\\n          },\\n          \\"path\\": [\\n            \\"form-element\\",\\n            \\"size\\",\\n            \\"text\\",\\n            \\"input\\"\\n          ]\\n        }\\n      }\\n    }\\n  },\\n  \\"loading-spinner\\": {\\n    \\"color\\": {\\n      \\"stroke\\": {\\n        \\"primary\\": {\\n          \\"value\\": \\"#990000\\",\\n          \\"filePath\\": \\"tokens/components/loading-spinner.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.JSTOR red.value}\\"\\n          },\\n          \\"name\\": \\"PharosLoadingSpinnerColorStrokePrimary\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"loading-spinner\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"stroke\\",\\n            \\"subitem\\": \\"primary\\"\\n          },\\n          \\"path\\": [\\n            \\"loading-spinner\\",\\n            \\"color\\",\\n            \\"stroke\\",\\n            \\"primary\\"\\n          ]\\n        },\\n        \\"secondary\\": {\\n          \\"value\\": \\"#fb4848\\",\\n          \\"filePath\\": \\"tokens/components/loading-spinner.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.Living coral.base.value}\\"\\n          },\\n          \\"name\\": \\"PharosLoadingSpinnerColorStrokeSecondary\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"loading-spinner\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"stroke\\",\\n            \\"subitem\\": \\"secondary\\"\\n          },\\n          \\"path\\": [\\n            \\"loading-spinner\\",\\n            \\"color\\",\\n            \\"stroke\\",\\n            \\"secondary\\"\\n          ]\\n        }\\n      }\\n    }\\n  },\\n  \\"modal\\": {\\n    \\"color\\": {\\n      \\"background\\": {\\n        \\"content\\": {\\n          \\"value\\": \\"#ffffff\\",\\n          \\"filePath\\": \\"tokens/components/modal.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.White.value}\\"\\n          },\\n          \\"name\\": \\"PharosModalColorBackgroundContent\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"modal\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"background\\",\\n            \\"subitem\\": \\"content\\"\\n          },\\n          \\"path\\": [\\n            \\"modal\\",\\n            \\"color\\",\\n            \\"background\\",\\n            \\"content\\"\\n          ]\\n        }\\n      },\\n      \\"border\\": {\\n        \\"content\\": {\\n          \\"value\\": \\"#eae8e1\\",\\n          \\"filePath\\": \\"tokens/components/modal.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.Marble gray.base.value}\\"\\n          },\\n          \\"name\\": \\"PharosModalColorBorderContent\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"modal\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"border\\",\\n            \\"subitem\\": \\"content\\"\\n          },\\n          \\"path\\": [\\n            \\"modal\\",\\n            \\"color\\",\\n            \\"border\\",\\n            \\"content\\"\\n          ]\\n        }\\n      },\\n      \\"icon\\": {\\n        \\"close\\": {\\n          \\"value\\": \\"#81807e\\",\\n          \\"filePath\\": \\"tokens/components/modal.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.Marble gray.50.value}\\"\\n          },\\n          \\"name\\": \\"PharosModalColorIconClose\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"modal\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"icon\\",\\n            \\"subitem\\": \\"close\\"\\n          },\\n          \\"path\\": [\\n            \\"modal\\",\\n            \\"color\\",\\n            \\"icon\\",\\n            \\"close\\"\\n          ]\\n        },\\n        \\"focus\\": {\\n          \\"value\\": \\"#990000\\",\\n          \\"filePath\\": \\"tokens/components/modal.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.JSTOR red.value}\\"\\n          },\\n          \\"name\\": \\"PharosModalColorIconFocus\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"modal\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"icon\\",\\n            \\"subitem\\": \\"focus\\"\\n          },\\n          \\"path\\": [\\n            \\"modal\\",\\n            \\"color\\",\\n            \\"icon\\",\\n            \\"focus\\"\\n          ]\\n        }\\n      }\\n    },\\n    \\"spacing\\": {\\n      \\"base\\": {\\n        \\"value\\": \\"2rem\\",\\n        \\"filePath\\": \\"tokens/components/modal.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{spacing.2-x.value}\\"\\n        },\\n        \\"name\\": \\"PharosModalSpacingBase\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"modal\\",\\n          \\"type\\": \\"spacing\\",\\n          \\"item\\": \\"base\\"\\n        },\\n        \\"path\\": [\\n          \\"modal\\",\\n          \\"spacing\\",\\n          \\"base\\"\\n        ]\\n      }\\n    },\\n    \\"size\\": {\\n      \\"width\\": {\\n        \\"base\\": {\\n          \\"value\\": \\"40rem\\",\\n          \\"comment\\": \\"TODO: Update with core token value\\",\\n          \\"filePath\\": \\"tokens/components/modal.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"40rem\\",\\n            \\"comment\\": \\"TODO: Update with core token value\\"\\n          },\\n          \\"name\\": \\"PharosModalSizeWidthBase\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"modal\\",\\n            \\"type\\": \\"size\\",\\n            \\"item\\": \\"width\\",\\n            \\"subitem\\": \\"base\\"\\n          },\\n          \\"path\\": [\\n            \\"modal\\",\\n            \\"size\\",\\n            \\"width\\",\\n            \\"base\\"\\n          ]\\n        }\\n      }\\n    }\\n  },\\n  \\"radio-button\\": {\\n    \\"color\\": {\\n      \\"background\\": {\\n        \\"base\\": {\\n          \\"value\\": \\"#ffffff\\",\\n          \\"filePath\\": \\"tokens/components/radio-button.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.ui.10.value}\\"\\n          },\\n          \\"name\\": \\"PharosRadioButtonColorBackgroundBase\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"radio-button\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"background\\",\\n            \\"subitem\\": \\"base\\"\\n          },\\n          \\"path\\": [\\n            \\"radio-button\\",\\n            \\"color\\",\\n            \\"background\\",\\n            \\"base\\"\\n          ]\\n        }\\n      }\\n    }\\n  },\\n  \\"radio-group\\": {\\n    \\"spacing\\": {\\n      \\"vertical\\": {\\n        \\"value\\": \\"0.5rem\\",\\n        \\"filePath\\": \\"tokens/components/radio-group.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{spacing.one-half-x.value}\\"\\n        },\\n        \\"name\\": \\"PharosRadioGroupSpacingVertical\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"radio-group\\",\\n          \\"type\\": \\"spacing\\",\\n          \\"item\\": \\"vertical\\"\\n        },\\n        \\"path\\": [\\n          \\"radio-group\\",\\n          \\"spacing\\",\\n          \\"vertical\\"\\n        ]\\n      },\\n      \\"horizontal\\": {\\n        \\"value\\": \\"1.5rem\\",\\n        \\"filePath\\": \\"tokens/components/radio-group.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{spacing.one-and-a-half-x.value}\\"\\n        },\\n        \\"name\\": \\"PharosRadioGroupSpacingHorizontal\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"radio-group\\",\\n          \\"type\\": \\"spacing\\",\\n          \\"item\\": \\"horizontal\\"\\n        },\\n        \\"path\\": [\\n          \\"radio-group\\",\\n          \\"spacing\\",\\n          \\"horizontal\\"\\n        ]\\n      }\\n    }\\n  },\\n  \\"text-input\\": {\\n    \\"color\\": {\\n      \\"icon\\": {\\n        \\"valid\\": {\\n          \\"value\\": \\"#268241\\",\\n          \\"filePath\\": \\"tokens/components/text-input.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.feedback.success.value}\\"\\n          },\\n          \\"name\\": \\"PharosTextInputColorIconValid\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"text-input\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"icon\\",\\n            \\"subitem\\": \\"valid\\"\\n          },\\n          \\"path\\": [\\n            \\"text-input\\",\\n            \\"color\\",\\n            \\"icon\\",\\n            \\"valid\\"\\n          ]\\n        },\\n        \\"invalid\\": {\\n          \\"value\\": \\"#dd3431\\",\\n          \\"filePath\\": \\"tokens/components/text-input.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.feedback.error.value}\\"\\n          },\\n          \\"name\\": \\"PharosTextInputColorIconInvalid\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"text-input\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"icon\\",\\n            \\"subitem\\": \\"invalid\\"\\n          },\\n          \\"path\\": [\\n            \\"text-input\\",\\n            \\"color\\",\\n            \\"icon\\",\\n            \\"invalid\\"\\n          ]\\n        }\\n      }\\n    }\\n  },\\n  \\"textarea\\": {\\n    \\"size\\": {\\n      \\"height\\": {\\n        \\"base\\": {\\n          \\"value\\": \\"3.5rem\\",\\n          \\"comment\\": \\"TODO: Update with core token value\\",\\n          \\"filePath\\": \\"tokens/components/textarea.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"3.5rem\\",\\n            \\"comment\\": \\"TODO: Update with core token value\\"\\n          },\\n          \\"name\\": \\"PharosTextareaSizeHeightBase\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"textarea\\",\\n            \\"type\\": \\"size\\",\\n            \\"item\\": \\"height\\",\\n            \\"subitem\\": \\"base\\"\\n          },\\n          \\"path\\": [\\n            \\"textarea\\",\\n            \\"size\\",\\n            \\"height\\",\\n            \\"base\\"\\n          ]\\n        }\\n      }\\n    }\\n  },\\n  \\"tooltip\\": {\\n    \\"color\\": {\\n      \\"background\\": {\\n        \\"base\\": {\\n          \\"value\\": \\"#343332\\",\\n          \\"filePath\\": \\"tokens/components/tooltip.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.Marble gray.20.value}\\"\\n          },\\n          \\"name\\": \\"PharosTooltipColorBackgroundBase\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"tooltip\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"background\\",\\n            \\"subitem\\": \\"base\\"\\n          },\\n          \\"path\\": [\\n            \\"tooltip\\",\\n            \\"color\\",\\n            \\"background\\",\\n            \\"base\\"\\n          ]\\n        }\\n      },\\n      \\"text\\": {\\n        \\"base\\": {\\n          \\"value\\": \\"#ffffff\\",\\n          \\"filePath\\": \\"tokens/components/tooltip.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{color.text.white.value}\\"\\n          },\\n          \\"name\\": \\"PharosTooltipColorTextBase\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"tooltip\\",\\n            \\"type\\": \\"color\\",\\n            \\"item\\": \\"text\\",\\n            \\"subitem\\": \\"base\\"\\n          },\\n          \\"path\\": [\\n            \\"tooltip\\",\\n            \\"color\\",\\n            \\"text\\",\\n            \\"base\\"\\n          ]\\n        }\\n      }\\n    },\\n    \\"size\\": {\\n      \\"text\\": {\\n        \\"base\\": {\\n          \\"value\\": \\"2\\",\\n          \\"filePath\\": \\"tokens/components/tooltip.json\\",\\n          \\"isSource\\": true,\\n          \\"original\\": {\\n            \\"value\\": \\"{font.size.small.value}\\"\\n          },\\n          \\"name\\": \\"PharosTooltipSizeTextBase\\",\\n          \\"attributes\\": {\\n            \\"category\\": \\"tooltip\\",\\n            \\"type\\": \\"size\\",\\n            \\"item\\": \\"text\\",\\n            \\"subitem\\": \\"base\\"\\n          },\\n          \\"path\\": [\\n            \\"tooltip\\",\\n            \\"size\\",\\n            \\"text\\",\\n            \\"base\\"\\n          ]\\n        }\\n      }\\n    }\\n  },\\n  \\"font\\": {\\n    \\"family\\": {\\n      \\"sans-serif\\": {\\n        \\"value\\": \\"GT America Standard, Helvetica, Helvetica Neue, Arial, Segoe UI, Roboto, Droid Sans, sans-serif\\",\\n        \\"filePath\\": \\"tokens/font.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"GT America Standard, Helvetica, Helvetica Neue, Arial, Segoe UI, Roboto, Droid Sans, sans-serif\\"\\n        },\\n        \\"name\\": \\"PharosFontFamilySansSerif\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"font\\",\\n          \\"type\\": \\"family\\",\\n          \\"item\\": \\"sans-serif\\"\\n        },\\n        \\"path\\": [\\n          \\"font\\",\\n          \\"family\\",\\n          \\"sans-serif\\"\\n        ]\\n      },\\n      \\"serif\\": {\\n        \\"value\\": \\"Ivar Headline, Times, Georgia, serif\\",\\n        \\"filePath\\": \\"tokens/font.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"Ivar Headline, Times, Georgia, serif\\"\\n        },\\n        \\"name\\": \\"PharosFontFamilySerif\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"font\\",\\n          \\"type\\": \\"family\\",\\n          \\"item\\": \\"serif\\"\\n        },\\n        \\"path\\": [\\n          \\"font\\",\\n          \\"family\\",\\n          \\"serif\\"\\n        ]\\n      },\\n      \\"body\\": {\\n        \\"value\\": \\"GT America Standard, Helvetica, Helvetica Neue, Arial, Segoe UI, Roboto, Droid Sans, sans-serif\\",\\n        \\"filePath\\": \\"tokens/font.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{font.family.sans-serif.value}\\"\\n        },\\n        \\"name\\": \\"PharosFontFamilyBody\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"font\\",\\n          \\"type\\": \\"family\\",\\n          \\"item\\": \\"body\\"\\n        },\\n        \\"path\\": [\\n          \\"font\\",\\n          \\"family\\",\\n          \\"body\\"\\n        ]\\n      }\\n    },\\n    \\"weight\\": {\\n      \\"regular\\": {\\n        \\"value\\": \\"400\\",\\n        \\"filePath\\": \\"tokens/font.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"400\\"\\n        },\\n        \\"name\\": \\"PharosFontWeightRegular\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"font\\",\\n          \\"type\\": \\"weight\\",\\n          \\"item\\": \\"regular\\"\\n        },\\n        \\"path\\": [\\n          \\"font\\",\\n          \\"weight\\",\\n          \\"regular\\"\\n        ]\\n      },\\n      \\"bold\\": {\\n        \\"value\\": \\"700\\",\\n        \\"filePath\\": \\"tokens/font.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"700\\"\\n        },\\n        \\"name\\": \\"PharosFontWeightBold\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"font\\",\\n          \\"type\\": \\"weight\\",\\n          \\"item\\": \\"bold\\"\\n        },\\n        \\"path\\": [\\n          \\"font\\",\\n          \\"weight\\",\\n          \\"bold\\"\\n        ]\\n      }\\n    },\\n    \\"size\\": {\\n      \\"micro\\": {\\n        \\"value\\": \\"1\\",\\n        \\"filePath\\": \\"tokens/font.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{type.scale.1.value}\\"\\n        },\\n        \\"name\\": \\"PharosFontSizeMicro\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"font\\",\\n          \\"type\\": \\"size\\",\\n          \\"item\\": \\"micro\\"\\n        },\\n        \\"path\\": [\\n          \\"font\\",\\n          \\"size\\",\\n          \\"micro\\"\\n        ]\\n      },\\n      \\"small\\": {\\n        \\"value\\": \\"2\\",\\n        \\"filePath\\": \\"tokens/font.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{type.scale.2.value}\\"\\n        },\\n        \\"name\\": \\"PharosFontSizeSmall\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"font\\",\\n          \\"type\\": \\"size\\",\\n          \\"item\\": \\"small\\"\\n        },\\n        \\"path\\": [\\n          \\"font\\",\\n          \\"size\\",\\n          \\"small\\"\\n        ]\\n      },\\n      \\"base\\": {\\n        \\"value\\": \\"3\\",\\n        \\"filePath\\": \\"tokens/font.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{type.scale.3.value}\\"\\n        },\\n        \\"name\\": \\"PharosFontSizeBase\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"font\\",\\n          \\"type\\": \\"size\\",\\n          \\"item\\": \\"base\\"\\n        },\\n        \\"path\\": [\\n          \\"font\\",\\n          \\"size\\",\\n          \\"base\\"\\n        ]\\n      },\\n      \\"large\\": {\\n        \\"value\\": \\"5\\",\\n        \\"filePath\\": \\"tokens/font.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{type.scale.5.value}\\"\\n        },\\n        \\"name\\": \\"PharosFontSizeLarge\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"font\\",\\n          \\"type\\": \\"size\\",\\n          \\"item\\": \\"large\\"\\n        },\\n        \\"path\\": [\\n          \\"font\\",\\n          \\"size\\",\\n          \\"large\\"\\n        ]\\n      },\\n      \\"xlarge\\": {\\n        \\"value\\": \\"6\\",\\n        \\"filePath\\": \\"tokens/font.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"{type.scale.6.value}\\"\\n        },\\n        \\"name\\": \\"PharosFontSizeXlarge\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"font\\",\\n          \\"type\\": \\"size\\",\\n          \\"item\\": \\"xlarge\\"\\n        },\\n        \\"path\\": [\\n          \\"font\\",\\n          \\"size\\",\\n          \\"xlarge\\"\\n        ]\\n      }\\n    }\\n  },\\n  \\"line-height\\": {\\n    \\"xsmall\\": {\\n      \\"value\\": \\"1rem\\",\\n      \\"comment\\": \\"16px\\",\\n      \\"filePath\\": \\"tokens/line-height/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"1rem\\",\\n        \\"comment\\": \\"16px\\"\\n      },\\n      \\"name\\": \\"PharosLineHeightXsmall\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"line-height\\",\\n        \\"type\\": \\"xsmall\\"\\n      },\\n      \\"path\\": [\\n        \\"line-height\\",\\n        \\"xsmall\\"\\n      ]\\n    },\\n    \\"small\\": {\\n      \\"value\\": \\"1.25rem\\",\\n      \\"comment\\": \\"20px\\",\\n      \\"filePath\\": \\"tokens/line-height/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"1.25rem\\",\\n        \\"comment\\": \\"20px\\"\\n      },\\n      \\"name\\": \\"PharosLineHeightSmall\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"line-height\\",\\n        \\"type\\": \\"small\\"\\n      },\\n      \\"path\\": [\\n        \\"line-height\\",\\n        \\"small\\"\\n      ]\\n    },\\n    \\"medium\\": {\\n      \\"value\\": \\"1.5rem\\",\\n      \\"comment\\": \\"24px\\",\\n      \\"filePath\\": \\"tokens/line-height/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"1.5rem\\",\\n        \\"comment\\": \\"24px\\"\\n      },\\n      \\"name\\": \\"PharosLineHeightMedium\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"line-height\\",\\n        \\"type\\": \\"medium\\"\\n      },\\n      \\"path\\": [\\n        \\"line-height\\",\\n        \\"medium\\"\\n      ]\\n    },\\n    \\"large\\": {\\n      \\"value\\": \\"1.75rem\\",\\n      \\"comment\\": \\"28px\\",\\n      \\"filePath\\": \\"tokens/line-height/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"1.75rem\\",\\n        \\"comment\\": \\"28px\\"\\n      },\\n      \\"name\\": \\"PharosLineHeightLarge\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"line-height\\",\\n        \\"type\\": \\"large\\"\\n      },\\n      \\"path\\": [\\n        \\"line-height\\",\\n        \\"large\\"\\n      ]\\n    },\\n    \\"xlarge\\": {\\n      \\"value\\": \\"2.25rem\\",\\n      \\"comment\\": \\"36px\\",\\n      \\"filePath\\": \\"tokens/line-height/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"2.25rem\\",\\n        \\"comment\\": \\"36px\\"\\n      },\\n      \\"name\\": \\"PharosLineHeightXlarge\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"line-height\\",\\n        \\"type\\": \\"xlarge\\"\\n      },\\n      \\"path\\": [\\n        \\"line-height\\",\\n        \\"xlarge\\"\\n      ]\\n    },\\n    \\"heading-large\\": {\\n      \\"value\\": \\"1\\",\\n      \\"filePath\\": \\"tokens/line-height/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"1\\"\\n      },\\n      \\"name\\": \\"PharosLineHeightHeadingLarge\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"line-height\\",\\n        \\"type\\": \\"heading-large\\"\\n      },\\n      \\"path\\": [\\n        \\"line-height\\",\\n        \\"heading-large\\"\\n      ]\\n    },\\n    \\"text-base-condensed\\": {\\n      \\"value\\": \\"1.25rem\\",\\n      \\"comment\\": \\"20px\\",\\n      \\"filePath\\": \\"tokens/line-height/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"{line-height.small.value}\\",\\n        \\"comment\\": \\"20px\\"\\n      },\\n      \\"name\\": \\"PharosLineHeightTextBaseCondensed\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"line-height\\",\\n        \\"type\\": \\"text-base-condensed\\"\\n      },\\n      \\"path\\": [\\n        \\"line-height\\",\\n        \\"text-base-condensed\\"\\n      ]\\n    }\\n  },\\n  \\"radius\\": {\\n    \\"base\\": {\\n      \\"standard\\": {\\n        \\"value\\": \\"0.125rem\\",\\n        \\"comment\\": \\"2px\\",\\n        \\"filePath\\": \\"tokens/radius/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"0.125rem\\",\\n          \\"comment\\": \\"2px\\"\\n        },\\n        \\"name\\": \\"PharosRadiusBaseStandard\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"radius\\",\\n          \\"type\\": \\"base\\",\\n          \\"item\\": \\"standard\\"\\n        },\\n        \\"path\\": [\\n          \\"radius\\",\\n          \\"base\\",\\n          \\"standard\\"\\n        ]\\n      }\\n    }\\n  },\\n  \\"spacing\\": {\\n    \\"one-eighth-x\\": {\\n      \\"value\\": \\"0.125rem\\",\\n      \\"comment\\": \\"2px\\",\\n      \\"filePath\\": \\"tokens/spacing/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"0.125rem\\",\\n        \\"comment\\": \\"2px\\"\\n      },\\n      \\"name\\": \\"PharosSpacingOneEighthX\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"spacing\\",\\n        \\"type\\": \\"one-eighth-x\\"\\n      },\\n      \\"path\\": [\\n        \\"spacing\\",\\n        \\"one-eighth-x\\"\\n      ]\\n    },\\n    \\"one-quarter-x\\": {\\n      \\"value\\": \\"0.25rem\\",\\n      \\"comment\\": \\"4px\\",\\n      \\"filePath\\": \\"tokens/spacing/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"0.25rem\\",\\n        \\"comment\\": \\"4px\\"\\n      },\\n      \\"name\\": \\"PharosSpacingOneQuarterX\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"spacing\\",\\n        \\"type\\": \\"one-quarter-x\\"\\n      },\\n      \\"path\\": [\\n        \\"spacing\\",\\n        \\"one-quarter-x\\"\\n      ]\\n    },\\n    \\"one-half-x\\": {\\n      \\"value\\": \\"0.5rem\\",\\n      \\"comment\\": \\"8px\\",\\n      \\"filePath\\": \\"tokens/spacing/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"0.5rem\\",\\n        \\"comment\\": \\"8px\\"\\n      },\\n      \\"name\\": \\"PharosSpacingOneHalfX\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"spacing\\",\\n        \\"type\\": \\"one-half-x\\"\\n      },\\n      \\"path\\": [\\n        \\"spacing\\",\\n        \\"one-half-x\\"\\n      ]\\n    },\\n    \\"three-quarters-x\\": {\\n      \\"value\\": \\"0.75rem\\",\\n      \\"comment\\": \\"12px\\",\\n      \\"filePath\\": \\"tokens/spacing/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"0.75rem\\",\\n        \\"comment\\": \\"12px\\"\\n      },\\n      \\"name\\": \\"PharosSpacingThreeQuartersX\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"spacing\\",\\n        \\"type\\": \\"three-quarters-x\\"\\n      },\\n      \\"path\\": [\\n        \\"spacing\\",\\n        \\"three-quarters-x\\"\\n      ]\\n    },\\n    \\"1-x\\": {\\n      \\"value\\": \\"1rem\\",\\n      \\"comment\\": \\"16px\\",\\n      \\"filePath\\": \\"tokens/spacing/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"1rem\\",\\n        \\"comment\\": \\"16px\\"\\n      },\\n      \\"name\\": \\"PharosSpacing1X\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"spacing\\",\\n        \\"type\\": \\"1-x\\"\\n      },\\n      \\"path\\": [\\n        \\"spacing\\",\\n        \\"1-x\\"\\n      ]\\n    },\\n    \\"one-and-a-half-x\\": {\\n      \\"value\\": \\"1.5rem\\",\\n      \\"comment\\": \\"24px\\",\\n      \\"filePath\\": \\"tokens/spacing/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"1.5rem\\",\\n        \\"comment\\": \\"24px\\"\\n      },\\n      \\"name\\": \\"PharosSpacingOneAndAHalfX\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"spacing\\",\\n        \\"type\\": \\"one-and-a-half-x\\"\\n      },\\n      \\"path\\": [\\n        \\"spacing\\",\\n        \\"one-and-a-half-x\\"\\n      ]\\n    },\\n    \\"2-x\\": {\\n      \\"value\\": \\"2rem\\",\\n      \\"comment\\": \\"32px\\",\\n      \\"filePath\\": \\"tokens/spacing/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"2rem\\",\\n        \\"comment\\": \\"32px\\"\\n      },\\n      \\"name\\": \\"PharosSpacing2X\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"spacing\\",\\n        \\"type\\": \\"2-x\\"\\n      },\\n      \\"path\\": [\\n        \\"spacing\\",\\n        \\"2-x\\"\\n      ]\\n    },\\n    \\"3-x\\": {\\n      \\"value\\": \\"3rem\\",\\n      \\"comment\\": \\"48px\\",\\n      \\"filePath\\": \\"tokens/spacing/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"3rem\\",\\n        \\"comment\\": \\"48px\\"\\n      },\\n      \\"name\\": \\"PharosSpacing3X\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"spacing\\",\\n        \\"type\\": \\"3-x\\"\\n      },\\n      \\"path\\": [\\n        \\"spacing\\",\\n        \\"3-x\\"\\n      ]\\n    },\\n    \\"three-and-a-half-x\\": {\\n      \\"value\\": \\"3.5rem\\",\\n      \\"comment\\": \\"56px\\",\\n      \\"filePath\\": \\"tokens/spacing/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"3.5rem\\",\\n        \\"comment\\": \\"56px\\"\\n      },\\n      \\"name\\": \\"PharosSpacingThreeAndAHalfX\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"spacing\\",\\n        \\"type\\": \\"three-and-a-half-x\\"\\n      },\\n      \\"path\\": [\\n        \\"spacing\\",\\n        \\"three-and-a-half-x\\"\\n      ]\\n    },\\n    \\"5-x\\": {\\n      \\"value\\": \\"5rem\\",\\n      \\"comment\\": \\"80px\\",\\n      \\"filePath\\": \\"tokens/spacing/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"5rem\\",\\n        \\"comment\\": \\"80px\\"\\n      },\\n      \\"name\\": \\"PharosSpacing5X\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"spacing\\",\\n        \\"type\\": \\"5-x\\"\\n      },\\n      \\"path\\": [\\n        \\"spacing\\",\\n        \\"5-x\\"\\n      ]\\n    },\\n    \\"7-x\\": {\\n      \\"value\\": \\"7rem\\",\\n      \\"comment\\": \\"112px\\",\\n      \\"filePath\\": \\"tokens/spacing/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"7rem\\",\\n        \\"comment\\": \\"112px\\"\\n      },\\n      \\"name\\": \\"PharosSpacing7X\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"spacing\\",\\n        \\"type\\": \\"7-x\\"\\n      },\\n      \\"path\\": [\\n        \\"spacing\\",\\n        \\"7-x\\"\\n      ]\\n    },\\n    \\"10-x\\": {\\n      \\"value\\": \\"10rem\\",\\n      \\"comment\\": \\"160px\\",\\n      \\"filePath\\": \\"tokens/spacing/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"10rem\\",\\n        \\"comment\\": \\"160px\\"\\n      },\\n      \\"name\\": \\"PharosSpacing10X\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"spacing\\",\\n        \\"type\\": \\"10-x\\"\\n      },\\n      \\"path\\": [\\n        \\"spacing\\",\\n        \\"10-x\\"\\n      ]\\n    },\\n    \\"gutter\\": {\\n      \\"value\\": \\"3rem\\",\\n      \\"comment\\": \\"48px\\",\\n      \\"filePath\\": \\"tokens/spacing/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"{spacing.3-x.value}\\",\\n        \\"comment\\": \\"48px\\"\\n      },\\n      \\"name\\": \\"PharosSpacingGutter\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"spacing\\",\\n        \\"type\\": \\"gutter\\"\\n      },\\n      \\"path\\": [\\n        \\"spacing\\",\\n        \\"gutter\\"\\n      ]\\n    }\\n  },\\n  \\"transition\\": {\\n    \\"base\\": {\\n      \\"value\\": \\"250ms cubic-bezier(0.17, 0.67, 0.83, 0.67)\\",\\n      \\"filePath\\": \\"tokens/transition/base.json\\",\\n      \\"isSource\\": true,\\n      \\"original\\": {\\n        \\"value\\": \\"250ms cubic-bezier(0.17, 0.67, 0.83, 0.67)\\"\\n      },\\n      \\"name\\": \\"PharosTransitionBase\\",\\n      \\"attributes\\": {\\n        \\"category\\": \\"transition\\",\\n        \\"type\\": \\"base\\"\\n      },\\n      \\"path\\": [\\n        \\"transition\\",\\n        \\"base\\"\\n      ]\\n    },\\n    \\"duration\\": {\\n      \\"shorter\\": {\\n        \\"value\\": \\"50ms\\",\\n        \\"filePath\\": \\"tokens/transition/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"50ms\\"\\n        },\\n        \\"name\\": \\"PharosTransitionDurationShorter\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"transition\\",\\n          \\"type\\": \\"duration\\",\\n          \\"item\\": \\"shorter\\"\\n        },\\n        \\"path\\": [\\n          \\"transition\\",\\n          \\"duration\\",\\n          \\"shorter\\"\\n        ]\\n      },\\n      \\"short\\": {\\n        \\"value\\": \\"100ms\\",\\n        \\"filePath\\": \\"tokens/transition/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"100ms\\"\\n        },\\n        \\"name\\": \\"PharosTransitionDurationShort\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"transition\\",\\n          \\"type\\": \\"duration\\",\\n          \\"item\\": \\"short\\"\\n        },\\n        \\"path\\": [\\n          \\"transition\\",\\n          \\"duration\\",\\n          \\"short\\"\\n        ]\\n      },\\n      \\"default\\": {\\n        \\"value\\": \\"250ms\\",\\n        \\"filePath\\": \\"tokens/transition/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"250ms\\"\\n        },\\n        \\"name\\": \\"PharosTransitionDurationDefault\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"transition\\",\\n          \\"type\\": \\"duration\\",\\n          \\"item\\": \\"default\\"\\n        },\\n        \\"path\\": [\\n          \\"transition\\",\\n          \\"duration\\",\\n          \\"default\\"\\n        ]\\n      },\\n      \\"long\\": {\\n        \\"value\\": \\"500ms\\",\\n        \\"filePath\\": \\"tokens/transition/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"500ms\\"\\n        },\\n        \\"name\\": \\"PharosTransitionDurationLong\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"transition\\",\\n          \\"type\\": \\"duration\\",\\n          \\"item\\": \\"long\\"\\n        },\\n        \\"path\\": [\\n          \\"transition\\",\\n          \\"duration\\",\\n          \\"long\\"\\n        ]\\n      },\\n      \\"longer\\": {\\n        \\"value\\": \\"1000ms\\",\\n        \\"filePath\\": \\"tokens/transition/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"1000ms\\"\\n        },\\n        \\"name\\": \\"PharosTransitionDurationLonger\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"transition\\",\\n          \\"type\\": \\"duration\\",\\n          \\"item\\": \\"longer\\"\\n        },\\n        \\"path\\": [\\n          \\"transition\\",\\n          \\"duration\\",\\n          \\"longer\\"\\n        ]\\n      }\\n    },\\n    \\"curve\\": {\\n      \\"base\\": {\\n        \\"value\\": \\"cubic-bezier(0.17, 0.67, 0.83, 0.67)\\",\\n        \\"filePath\\": \\"tokens/transition/base.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"cubic-bezier(0.17, 0.67, 0.83, 0.67)\\"\\n        },\\n        \\"name\\": \\"PharosTransitionCurveBase\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"transition\\",\\n          \\"type\\": \\"curve\\",\\n          \\"item\\": \\"base\\"\\n        },\\n        \\"path\\": [\\n          \\"transition\\",\\n          \\"curve\\",\\n          \\"base\\"\\n        ]\\n      }\\n    }\\n  },\\n  \\"type\\": {\\n    \\"scale\\": {\\n      \\"1\\": {\\n        \\"value\\": \\"1\\",\\n        \\"comment\\": \\"12px\\",\\n        \\"filePath\\": \\"tokens/type/scale.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"1\\",\\n          \\"comment\\": \\"12px\\"\\n        },\\n        \\"name\\": \\"PharosTypeScale1\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"type\\",\\n          \\"type\\": \\"scale\\",\\n          \\"item\\": \\"1\\"\\n        },\\n        \\"path\\": [\\n          \\"type\\",\\n          \\"scale\\",\\n          \\"1\\"\\n        ]\\n      },\\n      \\"2\\": {\\n        \\"value\\": \\"2\\",\\n        \\"comment\\": \\"14px\\",\\n        \\"filePath\\": \\"tokens/type/scale.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"2\\",\\n          \\"comment\\": \\"14px\\"\\n        },\\n        \\"name\\": \\"PharosTypeScale2\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"type\\",\\n          \\"type\\": \\"scale\\",\\n          \\"item\\": \\"2\\"\\n        },\\n        \\"path\\": [\\n          \\"type\\",\\n          \\"scale\\",\\n          \\"2\\"\\n        ]\\n      },\\n      \\"3\\": {\\n        \\"value\\": \\"3\\",\\n        \\"comment\\": \\"16px\\",\\n        \\"filePath\\": \\"tokens/type/scale.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"3\\",\\n          \\"comment\\": \\"16px\\"\\n        },\\n        \\"name\\": \\"PharosTypeScale3\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"type\\",\\n          \\"type\\": \\"scale\\",\\n          \\"item\\": \\"3\\"\\n        },\\n        \\"path\\": [\\n          \\"type\\",\\n          \\"scale\\",\\n          \\"3\\"\\n        ]\\n      },\\n      \\"4\\": {\\n        \\"value\\": \\"4\\",\\n        \\"comment\\": \\"18px\\",\\n        \\"filePath\\": \\"tokens/type/scale.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"4\\",\\n          \\"comment\\": \\"18px\\"\\n        },\\n        \\"name\\": \\"PharosTypeScale4\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"type\\",\\n          \\"type\\": \\"scale\\",\\n          \\"item\\": \\"4\\"\\n        },\\n        \\"path\\": [\\n          \\"type\\",\\n          \\"scale\\",\\n          \\"4\\"\\n        ]\\n      },\\n      \\"5\\": {\\n        \\"value\\": \\"5\\",\\n        \\"comment\\": \\"20px\\",\\n        \\"filePath\\": \\"tokens/type/scale.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"5\\",\\n          \\"comment\\": \\"20px\\"\\n        },\\n        \\"name\\": \\"PharosTypeScale5\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"type\\",\\n          \\"type\\": \\"scale\\",\\n          \\"item\\": \\"5\\"\\n        },\\n        \\"path\\": [\\n          \\"type\\",\\n          \\"scale\\",\\n          \\"5\\"\\n        ]\\n      },\\n      \\"6\\": {\\n        \\"value\\": \\"6\\",\\n        \\"comment\\": \\"24px\\",\\n        \\"filePath\\": \\"tokens/type/scale.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"6\\",\\n          \\"comment\\": \\"24px\\"\\n        },\\n        \\"name\\": \\"PharosTypeScale6\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"type\\",\\n          \\"type\\": \\"scale\\",\\n          \\"item\\": \\"6\\"\\n        },\\n        \\"path\\": [\\n          \\"type\\",\\n          \\"scale\\",\\n          \\"6\\"\\n        ]\\n      },\\n      \\"7\\": {\\n        \\"value\\": \\"7\\",\\n        \\"comment\\": \\"28px\\",\\n        \\"filePath\\": \\"tokens/type/scale.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"7\\",\\n          \\"comment\\": \\"28px\\"\\n        },\\n        \\"name\\": \\"PharosTypeScale7\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"type\\",\\n          \\"type\\": \\"scale\\",\\n          \\"item\\": \\"7\\"\\n        },\\n        \\"path\\": [\\n          \\"type\\",\\n          \\"scale\\",\\n          \\"7\\"\\n        ]\\n      },\\n      \\"8\\": {\\n        \\"value\\": \\"8\\",\\n        \\"comment\\": \\"32px\\",\\n        \\"filePath\\": \\"tokens/type/scale.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"8\\",\\n          \\"comment\\": \\"32px\\"\\n        },\\n        \\"name\\": \\"PharosTypeScale8\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"type\\",\\n          \\"type\\": \\"scale\\",\\n          \\"item\\": \\"8\\"\\n        },\\n        \\"path\\": [\\n          \\"type\\",\\n          \\"scale\\",\\n          \\"8\\"\\n        ]\\n      },\\n      \\"9\\": {\\n        \\"value\\": \\"9\\",\\n        \\"comment\\": \\"36px\\",\\n        \\"filePath\\": \\"tokens/type/scale.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"9\\",\\n          \\"comment\\": \\"36px\\"\\n        },\\n        \\"name\\": \\"PharosTypeScale9\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"type\\",\\n          \\"type\\": \\"scale\\",\\n          \\"item\\": \\"9\\"\\n        },\\n        \\"path\\": [\\n          \\"type\\",\\n          \\"scale\\",\\n          \\"9\\"\\n        ]\\n      },\\n      \\"10\\": {\\n        \\"value\\": \\"10\\",\\n        \\"comment\\": \\"42px\\",\\n        \\"filePath\\": \\"tokens/type/scale.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"10\\",\\n          \\"comment\\": \\"42px\\"\\n        },\\n        \\"name\\": \\"PharosTypeScale10\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"type\\",\\n          \\"type\\": \\"scale\\",\\n          \\"item\\": \\"10\\"\\n        },\\n        \\"path\\": [\\n          \\"type\\",\\n          \\"scale\\",\\n          \\"10\\"\\n        ]\\n      },\\n      \\"11\\": {\\n        \\"value\\": \\"11\\",\\n        \\"comment\\": \\"48px\\",\\n        \\"filePath\\": \\"tokens/type/scale.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"11\\",\\n          \\"comment\\": \\"48px\\"\\n        },\\n        \\"name\\": \\"PharosTypeScale11\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"type\\",\\n          \\"type\\": \\"scale\\",\\n          \\"item\\": \\"11\\"\\n        },\\n        \\"path\\": [\\n          \\"type\\",\\n          \\"scale\\",\\n          \\"11\\"\\n        ]\\n      },\\n      \\"12\\": {\\n        \\"value\\": \\"12\\",\\n        \\"comment\\": \\"54px\\",\\n        \\"filePath\\": \\"tokens/type/scale.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"12\\",\\n          \\"comment\\": \\"54px\\"\\n        },\\n        \\"name\\": \\"PharosTypeScale12\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"type\\",\\n          \\"type\\": \\"scale\\",\\n          \\"item\\": \\"12\\"\\n        },\\n        \\"path\\": [\\n          \\"type\\",\\n          \\"scale\\",\\n          \\"12\\"\\n        ]\\n      },\\n      \\"13\\": {\\n        \\"value\\": \\"13\\",\\n        \\"comment\\": \\"60px\\",\\n        \\"filePath\\": \\"tokens/type/scale.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"13\\",\\n          \\"comment\\": \\"60px\\"\\n        },\\n        \\"name\\": \\"PharosTypeScale13\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"type\\",\\n          \\"type\\": \\"scale\\",\\n          \\"item\\": \\"13\\"\\n        },\\n        \\"path\\": [\\n          \\"type\\",\\n          \\"scale\\",\\n          \\"13\\"\\n        ]\\n      },\\n      \\"14\\": {\\n        \\"value\\": \\"14\\",\\n        \\"comment\\": \\"68px\\",\\n        \\"filePath\\": \\"tokens/type/scale.json\\",\\n        \\"isSource\\": true,\\n        \\"original\\": {\\n          \\"value\\": \\"14\\",\\n          \\"comment\\": \\"68px\\"\\n        },\\n        \\"name\\": \\"PharosTypeScale14\\",\\n        \\"attributes\\": {\\n          \\"category\\": \\"type\\",\\n          \\"type\\": \\"scale\\",\\n          \\"item\\": \\"14\\"\\n        },\\n        \\"path\\": [\\n          \\"type\\",\\n          \\"scale\\",\\n          \\"14\\"\\n        ]\\n      }\\n    }\\n  }\\n}","description":"Do not edit directly\\nGenerated on Sat, 07 Jan 2023 01:00:23 GMT"}],"exports":[{"kind":"js","name":"default","declaration":{"name":"tokens","module":"src/styles/tokens.ts"}}]},{"kind":"javascript-module","path":"src/styles/variables.ts","declarations":[{"kind":"variable","name":"PharosAssetIconAcademicContent","type":{"text":"string"},"default":"\\"assets/icons/academic-content.svg\\"","description":"Do not edit directly\\nGenerated on Sat, 07 Jan 2023 01:00:23 GMT"},{"kind":"variable","name":"PharosAssetIconAdd","type":{"text":"string"},"default":"\\"assets/icons/add.svg\\""},{"kind":"variable","name":"PharosAssetIconArrowDown","type":{"text":"string"},"default":"\\"assets/icons/arrow-down.svg\\""},{"kind":"variable","name":"PharosAssetIconArrowLeft","type":{"text":"string"},"default":"\\"assets/icons/arrow-left.svg\\""},{"kind":"variable","name":"PharosAssetIconArrowRight","type":{"text":"string"},"default":"\\"assets/icons/arrow-right.svg\\""},{"kind":"variable","name":"PharosAssetIconArrowUp","type":{"text":"string"},"default":"\\"assets/icons/arrow-up.svg\\""},{"kind":"variable","name":"PharosAssetIconAttachment","type":{"text":"string"},"default":"\\"assets/icons/attachment.svg\\""},{"kind":"variable","name":"PharosAssetIconBase","type":{"text":"string"},"default":"\\"assets/icons/base.svg\\""},{"kind":"variable","name":"PharosAssetIconBook","type":{"text":"string"},"default":"\\"assets/icons/book.svg\\""},{"kind":"variable","name":"PharosAssetIconCalendar","type":{"text":"string"},"default":"\\"assets/icons/calendar.svg\\""},{"kind":"variable","name":"PharosAssetIconCheckmarkFilledCircle","type":{"text":"string"},"default":"\\"assets/icons/checkmark-filled-circle.svg\\""},{"kind":"variable","name":"PharosAssetIconCheckmarkInverse","type":{"text":"string"},"default":"\\"assets/icons/checkmark-inverse.svg\\""},{"kind":"variable","name":"PharosAssetIconCheckmarkSmall","type":{"text":"string"},"default":"\\"assets/icons/checkmark-small.svg\\""},{"kind":"variable","name":"PharosAssetIconCheckmark","type":{"text":"string"},"default":"\\"assets/icons/checkmark.svg\\""},{"kind":"variable","name":"PharosAssetIconChevronDown","type":{"text":"string"},"default":"\\"assets/icons/chevron-down.svg\\""},{"kind":"variable","name":"PharosAssetIconChevronLeftLarge","type":{"text":"string"},"default":"\\"assets/icons/chevron-left-large.svg\\""},{"kind":"variable","name":"PharosAssetIconChevronLeft","type":{"text":"string"},"default":"\\"assets/icons/chevron-left.svg\\""},{"kind":"variable","name":"PharosAssetIconChevronRightLarge","type":{"text":"string"},"default":"\\"assets/icons/chevron-right-large.svg\\""},{"kind":"variable","name":"PharosAssetIconChevronRight","type":{"text":"string"},"default":"\\"assets/icons/chevron-right.svg\\""},{"kind":"variable","name":"PharosAssetIconChevronUp","type":{"text":"string"},"default":"\\"assets/icons/chevron-up.svg\\""},{"kind":"variable","name":"PharosAssetIconCircle","type":{"text":"string"},"default":"\\"assets/icons/circle.svg\\""},{"kind":"variable","name":"PharosAssetIconCite","type":{"text":"string"},"default":"\\"assets/icons/cite.svg\\""},{"kind":"variable","name":"PharosAssetIconCloseInverse","type":{"text":"string"},"default":"\\"assets/icons/close-inverse.svg\\""},{"kind":"variable","name":"PharosAssetIconClose","type":{"text":"string"},"default":"\\"assets/icons/close.svg\\""},{"kind":"variable","name":"PharosAssetIconCollapse","type":{"text":"string"},"default":"\\"assets/icons/shift-right.svg\\""},{"kind":"variable","name":"PharosAssetIconCopy","type":{"text":"string"},"default":"\\"assets/icons/copy.svg\\""},{"kind":"variable","name":"PharosAssetIconDashSmall","type":{"text":"string"},"default":"\\"assets/icons/dash-small.svg\\""},{"kind":"variable","name":"PharosAssetIconDelete","type":{"text":"string"},"default":"\\"assets/icons/delete.svg\\""},{"kind":"variable","name":"PharosAssetIconDownload","type":{"text":"string"},"default":"\\"assets/icons/download.svg\\""},{"kind":"variable","name":"PharosAssetIconEdit","type":{"text":"string"},"default":"\\"assets/icons/edit.svg\\""},{"kind":"variable","name":"PharosAssetIconEllipsesHorizontal","type":{"text":"string"},"default":"\\"assets/icons/ellipses-horizontal.svg\\""},{"kind":"variable","name":"PharosAssetIconEllipsesVertical","type":{"text":"string"},"default":"\\"assets/icons/ellipses-vertical.svg\\""},{"kind":"variable","name":"PharosAssetIconEmail","type":{"text":"string"},"default":"\\"assets/icons/email.svg\\""},{"kind":"variable","name":"PharosAssetIconExclamationInverse","type":{"text":"string"},"default":"\\"assets/icons/exclamation-inverse.svg\\""},{"kind":"variable","name":"PharosAssetIconExclamation","type":{"text":"string"},"default":"\\"assets/icons/exclamation.svg\\""},{"kind":"variable","name":"PharosAssetIconExpand","type":{"text":"string"},"default":"\\"assets/icons/shift-left.svg\\""},{"kind":"variable","name":"PharosAssetIconFacebook","type":{"text":"string"},"default":"\\"assets/icons/facebook.svg\\""},{"kind":"variable","name":"PharosAssetIconFiletypePdf","type":{"text":"string"},"default":"\\"assets/icons/filetype-pdf.svg\\""},{"kind":"variable","name":"PharosAssetIconFiletypePpt","type":{"text":"string"},"default":"\\"assets/icons/filetype-ppt.svg\\""},{"kind":"variable","name":"PharosAssetIconFiletypeZip","type":{"text":"string"},"default":"\\"assets/icons/filetype-zip.svg\\""},{"kind":"variable","name":"PharosAssetIconFitToView","type":{"text":"string"},"default":"\\"assets/icons/fit-to-view.svg\\""},{"kind":"variable","name":"PharosAssetIconFitToWidth","type":{"text":"string"},"default":"\\"assets/icons/fit-to-width.svg\\""},{"kind":"variable","name":"PharosAssetIconFolderNew","type":{"text":"string"},"default":"\\"assets/icons/folder-new.svg\\""},{"kind":"variable","name":"PharosAssetIconFolder","type":{"text":"string"},"default":"\\"assets/icons/folder.svg\\""},{"kind":"variable","name":"PharosAssetIconFolderSelected","type":{"text":"string"},"default":"\\"assets/icons/folder-selected.svg\\""},{"kind":"variable","name":"PharosAssetIconFullscreenMinimize","type":{"text":"string"},"default":"\\"assets/icons/fullscreen-minimize.svg\\""},{"kind":"variable","name":"PharosAssetIconFullscreen","type":{"text":"string"},"default":"\\"assets/icons/fullscreen.svg\\""},{"kind":"variable","name":"PharosAssetIconGoogleColor","type":{"text":"string"},"default":"\\"assets/icons/google-color.svg\\""},{"kind":"variable","name":"PharosAssetIconGoogle","type":{"text":"string"},"default":"\\"assets/icons/google.svg\\""},{"kind":"variable","name":"PharosAssetIconImage","type":{"text":"string"},"default":"\\"assets/icons/image.svg\\""},{"kind":"variable","name":"PharosAssetIconInfoInverse","type":{"text":"string"},"default":"\\"assets/icons/info-inverse.svg\\""},{"kind":"variable","name":"PharosAssetIconInstagram","type":{"text":"string"},"default":"\\"assets/icons/instagram.svg\\""},{"kind":"variable","name":"PharosAssetIconLaptop","type":{"text":"string"},"default":"\\"assets/icons/laptop.svg\\""},{"kind":"variable","name":"PharosAssetIconLinkAdd","type":{"text":"string"},"default":"\\"assets/icons/link-add.svg\\""},{"kind":"variable","name":"PharosAssetIconLinkExternal","type":{"text":"string"},"default":"\\"assets/icons/link-external.svg\\""},{"kind":"variable","name":"PharosAssetIconLink","type":{"text":"string"},"default":"\\"assets/icons/link.svg\\""},{"kind":"variable","name":"PharosAssetIconLinkedin","type":{"text":"string"},"default":"\\"assets/icons/linkedin.svg\\""},{"kind":"variable","name":"PharosAssetIconMenu","type":{"text":"string"},"default":"\\"assets/icons/menu.svg\\""},{"kind":"variable","name":"PharosAssetIconMove","type":{"text":"string"},"default":"\\"assets/icons/move.svg\\""},{"kind":"variable","name":"PharosAssetIconNew","type":{"text":"string"},"default":"\\"assets/icons/new.svg\\""},{"kind":"variable","name":"PharosAssetIconPartialCircle","type":{"text":"string"},"default":"\\"assets/icons/partial-circle.svg\\""},{"kind":"variable","name":"PharosAssetIconPrimarySource","type":{"text":"string"},"default":"\\"assets/icons/primary-source.svg\\""},{"kind":"variable","name":"PharosAssetIconProfile","type":{"text":"string"},"default":"\\"assets/icons/profile.svg\\""},{"kind":"variable","name":"PharosAssetIconQuestionInverse","type":{"text":"string"},"default":"\\"assets/icons/question-inverse.svg\\""},{"kind":"variable","name":"PharosAssetIconSave","type":{"text":"string"},"default":"\\"assets/icons/save.svg\\""},{"kind":"variable","name":"PharosAssetIconSaved","type":{"text":"string"},"default":"\\"assets/icons/saved.svg\\""},{"kind":"variable","name":"PharosAssetIconSearch","type":{"text":"string"},"default":"\\"assets/icons/search.svg\\""},{"kind":"variable","name":"PharosAssetIconShare","type":{"text":"string"},"default":"\\"assets/icons/share.svg\\""},{"kind":"variable","name":"PharosAssetIconShiftLeft","type":{"text":"string"},"default":"\\"assets/icons/shift-left.svg\\""},{"kind":"variable","name":"PharosAssetIconShiftRight","type":{"text":"string"},"default":"\\"assets/icons/shift-right.svg\\""},{"kind":"variable","name":"PharosAssetIconShiftUp","type":{"text":"string"},"default":"\\"assets/icons/shift-up.svg\\""},{"kind":"variable","name":"PharosAssetIconShiftDown","type":{"text":"string"},"default":"\\"assets/icons/shift-down.svg\\""},{"kind":"variable","name":"PharosAssetIconTumblr","type":{"text":"string"},"default":"\\"assets/icons/tumblr.svg\\""},{"kind":"variable","name":"PharosAssetIconTwitter","type":{"text":"string"},"default":"\\"assets/icons/twitter.svg\\""},{"kind":"variable","name":"PharosAssetIconVideo","type":{"text":"string"},"default":"\\"assets/icons/video.svg\\""},{"kind":"variable","name":"PharosAssetIconViewGallery","type":{"text":"string"},"default":"\\"assets/icons/view-gallery.svg\\""},{"kind":"variable","name":"PharosAssetIconViewGrid","type":{"text":"string"},"default":"\\"assets/icons/view-grid.svg\\""},{"kind":"variable","name":"PharosAssetIconViewList","type":{"text":"string"},"default":"\\"assets/icons/view-list.svg\\""},{"kind":"variable","name":"PharosAssetIconWorkspace","type":{"text":"string"},"default":"\\"assets/icons/workspace.svg\\""},{"kind":"variable","name":"PharosAssetIconWorkspaceSelected","type":{"text":"string"},"default":"\\"assets/icons/workspace-selected.svg\\""},{"kind":"variable","name":"PharosAssetIconYoutube","type":{"text":"string"},"default":"\\"assets/icons/youtube.svg\\""},{"kind":"variable","name":"PharosAssetIconZoomIn","type":{"text":"string"},"default":"\\"assets/icons/zoom-in.svg\\""},{"kind":"variable","name":"PharosAssetIconZoomOut","type":{"text":"string"},"default":"\\"assets/icons/zoom-out.svg\\""},{"kind":"variable","name":"PharosBreakpointSmall","type":{"text":"string"},"default":"\\"22.5rem\\""},{"kind":"variable","name":"PharosBreakpointMedium","type":{"text":"string"},"default":"\\"48rem\\""},{"kind":"variable","name":"PharosBreakpointLarge","type":{"text":"string"},"default":"\\"66rem\\""},{"kind":"variable","name":"PharosBreakpointXlarge","type":{"text":"string"},"default":"\\"85rem\\""},{"kind":"variable","name":"PharosBreakpointMax","type":{"text":"string"},"default":"\\"99rem\\""},{"kind":"variable","name":"PharosColorJstorRed","type":{"text":"string"},"default":"\\"#990000\\""},{"kind":"variable","name":"PharosColorNightBlue15","type":{"text":"string"},"default":"\\"#071d46\\""},{"kind":"variable","name":"PharosColorNightBlue60","type":{"text":"string"},"default":"\\"#8091b3\\""},{"kind":"variable","name":"PharosColorNightBlueBase","type":{"text":"string"},"default":"\\"#0d3071\\""},{"kind":"variable","name":"PharosColorGlacierBlue40","type":{"text":"string"},"default":"\\"#0ba3c1\\""},{"kind":"variable","name":"PharosColorGlacierBlue70","type":{"text":"string"},"default":"\\"#79deec\\""},{"kind":"variable","name":"PharosColorGlacierBlue80","type":{"text":"string"},"default":"\\"#b4dee4\\""},{"kind":"variable","name":"PharosColorGlacierBlue90","type":{"text":"string"},"default":"\\"#dcedef\\""},{"kind":"variable","name":"PharosColorGlacierBlueBase","type":{"text":"string"},"default":"\\"#27cae1\\""},{"kind":"variable","name":"PharosColorLivingCoral50","type":{"text":"string"},"default":"\\"#c83737\\""},{"kind":"variable","name":"PharosColorLivingCoral53","type":{"text":"string"},"default":"\\"#dd3431\\""},{"kind":"variable","name":"PharosColorLivingCoral80","type":{"text":"string"},"default":"\\"#fc9c9c\\""},{"kind":"variable","name":"PharosColorLivingCoral90","type":{"text":"string"},"default":"\\"#f4d7d7\\""},{"kind":"variable","name":"PharosColorLivingCoralBase","type":{"text":"string"},"default":"\\"#fb4848\\""},{"kind":"variable","name":"PharosColorMarbleGray10","type":{"text":"string"},"default":"\\"#1a1a19\\""},{"kind":"variable","name":"PharosColorMarbleGray20","type":{"text":"string"},"default":"\\"#343332\\""},{"kind":"variable","name":"PharosColorMarbleGray40","type":{"text":"string"},"default":"\\"#676765\\""},{"kind":"variable","name":"PharosColorMarbleGray50","type":{"text":"string"},"default":"\\"#81807e\\""},{"kind":"variable","name":"PharosColorMarbleGray80","type":{"text":"string"},"default":"\\"#d1cfc7\\""},{"kind":"variable","name":"PharosColorMarbleGray94","type":{"text":"string"},"default":"\\"#f2f1ed\\""},{"kind":"variable","name":"PharosColorMarbleGray97","type":{"text":"string"},"default":"\\"#f9f8f6\\""},{"kind":"variable","name":"PharosColorMarbleGrayBase","type":{"text":"string"},"default":"\\"#eae8e1\\""},{"kind":"variable","name":"PharosColorBlack","type":{"text":"string"},"default":"\\"#000000\\""},{"kind":"variable","name":"PharosColorWhite","type":{"text":"string"},"default":"\\"#ffffff\\""},{"kind":"variable","name":"PharosColorYellow97","type":{"text":"string"},"default":"\\"#fdf9f2\\""},{"kind":"variable","name":"PharosColorYellowBase","type":{"text":"string"},"default":"\\"#faa926\\""},{"kind":"variable","name":"PharosColorGreen93","type":{"text":"string"},"default":"\\"#e9f1eb\\""},{"kind":"variable","name":"PharosColorGreenBase","type":{"text":"string"},"default":"\\"#268241\\""},{"kind":"variable","name":"PharosColorInteractivePrimary","type":{"text":"string"},"default":"\\"#990000\\""},{"kind":"variable","name":"PharosColorInteractiveSecondary","type":{"text":"string"},"default":"\\"#000000\\""},{"kind":"variable","name":"PharosColorInteractiveTertiary","type":{"text":"string"},"default":"\\"#ffffff\\""},{"kind":"variable","name":"PharosColorUi10","type":{"text":"string"},"default":"\\"#ffffff\\""},{"kind":"variable","name":"PharosColorUi20","type":{"text":"string"},"default":"\\"#f2f1ed\\""},{"kind":"variable","name":"PharosColorUi30","type":{"text":"string"},"default":"\\"#eae8e1\\""},{"kind":"variable","name":"PharosColorUi40","type":{"text":"string"},"default":"\\"#d1cfc7\\""},{"kind":"variable","name":"PharosColorUi50","type":{"text":"string"},"default":"\\"#81807e\\""},{"kind":"variable","name":"PharosColorDisabled","type":{"text":"string"},"default":"\\"#eae8e1\\""},{"kind":"variable","name":"PharosColorOverlay","type":{"text":"string"},"default":"\\"#000000\\""},{"kind":"variable","name":"PharosColorFeedbackError","type":{"text":"string"},"default":"\\"#dd3431\\""},{"kind":"variable","name":"PharosColorFeedbackSuccess","type":{"text":"string"},"default":"\\"#268241\\""},{"kind":"variable","name":"PharosColorFeedbackWarning","type":{"text":"string"},"default":"\\"#faa926\\""},{"kind":"variable","name":"PharosColorFeedbackInfo","type":{"text":"string"},"default":"\\"#0ba3c1\\""},{"kind":"variable","name":"PharosColorText10","type":{"text":"string"},"default":"\\"#1a1a19\\""},{"kind":"variable","name":"PharosColorText20","type":{"text":"string"},"default":"\\"#343332\\""},{"kind":"variable","name":"PharosColorText40","type":{"text":"string"},"default":"\\"#676765\\""},{"kind":"variable","name":"PharosColorText50","type":{"text":"string"},"default":"\\"#81807e\\""},{"kind":"variable","name":"PharosColorTextBase","type":{"text":"string"},"default":"\\"#000000\\""},{"kind":"variable","name":"PharosColorTextDisabled","type":{"text":"string"},"default":"\\"#676765\\""},{"kind":"variable","name":"PharosColorTextPlaceholder","type":{"text":"string"},"default":"\\"#676765\\""},{"kind":"variable","name":"PharosColorTextWhite","type":{"text":"string"},"default":"\\"#ffffff\\""},{"kind":"variable","name":"PharosColorFocus","type":{"text":"string"},"default":"\\"#0ba3c1\\""},{"kind":"variable","name":"PharosColorHoverPrimary","type":{"text":"string"},"default":"\\"#990000\\""},{"kind":"variable","name":"PharosColorHoverSecondary","type":{"text":"string"},"default":"\\"#ffffff\\""},{"kind":"variable","name":"PharosColorHoverRow","type":{"text":"string"},"default":"\\"#f2f1ed\\""},{"kind":"variable","name":"PharosAlertColorBackgroundBase","type":{"text":"string"},"default":"\\"#f2f1ed\\""},{"kind":"variable","name":"PharosAlertColorBackgroundInfo","type":{"text":"string"},"default":"\\"#dcedef\\""},{"kind":"variable","name":"PharosAlertColorBackgroundError","type":{"text":"string"},"default":"\\"#f4d7d7\\""},{"kind":"variable","name":"PharosAlertColorBackgroundSuccess","type":{"text":"string"},"default":"\\"#e9f1eb\\""},{"kind":"variable","name":"PharosAlertColorBackgroundWarning","type":{"text":"string"},"default":"\\"#fdf9f2\\""},{"kind":"variable","name":"PharosAlertColorIconBase","type":{"text":"string"},"default":"\\"#000000\\""},{"kind":"variable","name":"PharosAlertColorIconInfo","type":{"text":"string"},"default":"\\"#0ba3c1\\""},{"kind":"variable","name":"PharosAlertColorIconError","type":{"text":"string"},"default":"\\"#dd3431\\""},{"kind":"variable","name":"PharosAlertColorIconSuccess","type":{"text":"string"},"default":"\\"#268241\\""},{"kind":"variable","name":"PharosAlertColorIconWarning","type":{"text":"string"},"default":"\\"#faa926\\""},{"kind":"variable","name":"PharosAlertColorTextBase","type":{"text":"string"},"default":"\\"#000000\\""},{"kind":"variable","name":"PharosAlertColorTextInverse","type":{"text":"string"},"default":"\\"#ffffff\\""},{"kind":"variable","name":"PharosAlertColorLinkBase","type":{"text":"string"},"default":"\\"#000000\\""},{"kind":"variable","name":"PharosAlertColorLinkInverse","type":{"text":"string"},"default":"\\"#ffffff\\""},{"kind":"variable","name":"PharosAlertColorBorderBase","type":{"text":"string"},"default":"\\"#f2f1ed\\""},{"kind":"variable","name":"PharosAlertColorBorderInfo","type":{"text":"string"},"default":"\\"#0ba3c1\\""},{"kind":"variable","name":"PharosAlertColorBorderError","type":{"text":"string"},"default":"\\"#dd3431\\""},{"kind":"variable","name":"PharosAlertColorBorderSuccess","type":{"text":"string"},"default":"\\"#268241\\""},{"kind":"variable","name":"PharosAlertColorBorderWarning","type":{"text":"string"},"default":"\\"#faa926\\""},{"kind":"variable","name":"PharosButtonPaddingBase","type":{"text":"string"},"default":"\\"0.25rem\\""},{"kind":"variable","name":"PharosButtonPaddingCondensed","type":{"text":"string"},"default":"\\"0.125rem\\""},{"kind":"variable","name":"PharosButtonPaddingLarge","type":{"text":"string"},"default":"\\"0.5rem\\""},{"kind":"variable","name":"PharosButtonColorBasePrimaryBackgroundBase","type":{"text":"string"},"default":"\\"#990000\\""},{"kind":"variable","name":"PharosButtonColorBasePrimaryBackgroundHover","type":{"text":"string"},"default":"\\"transparent\\""},{"kind":"variable","name":"PharosButtonColorBasePrimaryBackgroundDisabled","type":{"text":"string"},"default":"\\"#eae8e1\\""},{"kind":"variable","name":"PharosButtonColorBasePrimaryTextBase","type":{"text":"string"},"default":"\\"#ffffff\\""},{"kind":"variable","name":"PharosButtonColorBasePrimaryTextHover","type":{"text":"string"},"default":"\\"#990000\\""},{"kind":"variable","name":"PharosButtonColorBasePrimaryTextDisabled","type":{"text":"string"},"default":"\\"#676765\\""},{"kind":"variable","name":"PharosButtonColorBasePrimaryBorderBase","type":{"text":"string"},"default":"\\"#990000\\""},{"kind":"variable","name":"PharosButtonColorBasePrimaryBorderHover","type":{"text":"string"},"default":"\\"#990000\\""},{"kind":"variable","name":"PharosButtonColorBasePrimaryBorderDisabled","type":{"text":"string"},"default":"\\"#eae8e1\\""},{"kind":"variable","name":"PharosButtonColorBaseSecondaryBackgroundBase","type":{"text":"string"},"default":"\\"transparent\\""},{"kind":"variable","name":"PharosButtonColorBaseSecondaryBackgroundHover","type":{"text":"string"},"default":"\\"transparent\\""},{"kind":"variable","name":"PharosButtonColorBaseSecondaryBackgroundDisabled","type":{"text":"string"},"default":"\\"#eae8e1\\""},{"kind":"variable","name":"PharosButtonColorBaseSecondaryTextBase","type":{"text":"string"},"default":"\\"#000000\\""},{"kind":"variable","name":"PharosButtonColorBaseSecondaryTextHover","type":{"text":"string"},"default":"\\"#990000\\""},{"kind":"variable","name":"PharosButtonColorBaseSecondaryTextDisabled","type":{"text":"string"},"default":"\\"#676765\\""},{"kind":"variable","name":"PharosButtonColorBaseSecondaryBorderBase","type":{"text":"string"},"default":"\\"#d1cfc7\\""},{"kind":"variable","name":"PharosButtonColorBaseSecondaryBorderHover","type":{"text":"string"},"default":"\\"#990000\\""},{"kind":"variable","name":"PharosButtonColorBaseSecondaryBorderDisabled","type":{"text":"string"},"default":"\\"#eae8e1\\""},{"kind":"variable","name":"PharosButtonColorBaseSubtleBackgroundBase","type":{"text":"string"},"default":"\\"transparent\\""},{"kind":"variable","name":"PharosButtonColorBaseSubtleBackgroundHover","type":{"text":"string"},"default":"\\"#f2f1ed\\""},{"kind":"variable","name":"PharosButtonColorBaseSubtleBackgroundDisabled","type":{"text":"string"},"default":"\\"transparent\\""},{"kind":"variable","name":"PharosButtonColorBaseSubtleTextBase","type":{"text":"string"},"default":"\\"#000000\\""},{"kind":"variable","name":"PharosButtonColorBaseSubtleTextHover","type":{"text":"string"},"default":"\\"#990000\\""},{"kind":"variable","name":"PharosButtonColorBaseSubtleTextDisabled","type":{"text":"string"},"default":"\\"#676765\\""},{"kind":"variable","name":"PharosButtonColorBaseSubtleBorderBase","type":{"text":"string"},"default":"\\"transparent\\""},{"kind":"variable","name":"PharosButtonColorBaseSubtleBorderHover","type":{"text":"string"},"default":"\\"#f2f1ed\\""},{"kind":"variable","name":"PharosButtonColorBaseSubtleBorderDisabled","type":{"text":"string"},"default":"\\"transparent\\""},{"kind":"variable","name":"PharosButtonColorBaseOverlayBackgroundBase","type":{"text":"string"},"default":"\\"#1a1a19\\""},{"kind":"variable","name":"PharosButtonColorBaseOverlayBackgroundHover","type":{"text":"string"},"default":"\\"#343332\\""},{"kind":"variable","name":"PharosButtonColorBaseOverlayBackgroundDisabled","type":{"text":"string"},"default":"\\"#eae8e1\\""},{"kind":"variable","name":"PharosButtonColorBaseOverlayTextBase","type":{"text":"string"},"default":"\\"#ffffff\\""},{"kind":"variable","name":"PharosButtonColorBaseOverlayTextHover","type":{"text":"string"},"default":"\\"#ffffff\\""},{"kind":"variable","name":"PharosButtonColorBaseOverlayTextDisabled","type":{"text":"string"},"default":"\\"#676765\\""},{"kind":"variable","name":"PharosButtonColorBaseOverlayBorderBase","type":{"text":"string"},"default":"\\"#1a1a19\\""},{"kind":"variable","name":"PharosButtonColorBaseOverlayBorderHover","type":{"text":"string"},"default":"\\"#343332\\""},{"kind":"variable","name":"PharosButtonColorBaseOverlayBorderDisabled","type":{"text":"string"},"default":"\\"#eae8e1\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundPrimaryBackgroundBase","type":{"text":"string"},"default":"\\"#990000\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundPrimaryBackgroundHover","type":{"text":"string"},"default":"\\"transparent\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundPrimaryBackgroundDisabled","type":{"text":"string"},"default":"\\"#343332\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundPrimaryTextBase","type":{"text":"string"},"default":"\\"#ffffff\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundPrimaryTextHover","type":{"text":"string"},"default":"\\"#ffffff\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundPrimaryTextDisabled","type":{"text":"string"},"default":"\\"#81807e\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundPrimaryBorderBase","type":{"text":"string"},"default":"\\"#990000\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundPrimaryBorderHover","type":{"text":"string"},"default":"\\"#ffffff\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundPrimaryBorderDisabled","type":{"text":"string"},"default":"\\"#343332\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundSecondaryBackgroundBase","type":{"text":"string"},"default":"\\"transparent\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundSecondaryBackgroundHover","type":{"text":"string"},"default":"\\"transparent\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundSecondaryBackgroundDisabled","type":{"text":"string"},"default":"\\"#343332\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundSecondaryTextBase","type":{"text":"string"},"default":"\\"#ffffff\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundSecondaryTextHover","type":{"text":"string"},"default":"\\"#ffffff\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundSecondaryTextDisabled","type":{"text":"string"},"default":"\\"#81807e\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundSecondaryBorderBase","type":{"text":"string"},"default":"\\"#81807e\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundSecondaryBorderHover","type":{"text":"string"},"default":"\\"#ffffff\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundSecondaryBorderDisabled","type":{"text":"string"},"default":"\\"#343332\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundSubtleBackgroundBase","type":{"text":"string"},"default":"\\"transparent\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundSubtleBackgroundHover","type":{"text":"string"},"default":"\\"#343332\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundSubtleBackgroundDisabled","type":{"text":"string"},"default":"\\"transparent\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundSubtleTextBase","type":{"text":"string"},"default":"\\"#ffffff\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundSubtleTextHover","type":{"text":"string"},"default":"\\"#ffffff\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundSubtleTextDisabled","type":{"text":"string"},"default":"\\"#81807e\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundSubtleBorderBase","type":{"text":"string"},"default":"\\"transparent\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundSubtleBorderHover","type":{"text":"string"},"default":"\\"#343332\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundSubtleBorderDisabled","type":{"text":"string"},"default":"\\"transparent\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundOverlayBackgroundBase","type":{"text":"string"},"default":"\\"#1a1a19\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundOverlayBackgroundHover","type":{"text":"string"},"default":"\\"#343332\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundOverlayBackgroundDisabled","type":{"text":"string"},"default":"\\"#343332\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundOverlayTextBase","type":{"text":"string"},"default":"\\"#ffffff\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundOverlayTextHover","type":{"text":"string"},"default":"\\"#ffffff\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundOverlayTextDisabled","type":{"text":"string"},"default":"\\"#81807e\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundOverlayBorderBase","type":{"text":"string"},"default":"\\"#1a1a19\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundOverlayBorderHover","type":{"text":"string"},"default":"\\"#343332\\""},{"kind":"variable","name":"PharosButtonColorOnBackgroundOverlayBorderDisabled","type":{"text":"string"},"default":"\\"#343332\\""},{"kind":"variable","name":"PharosCheckboxGroupSpacingVertical","type":{"text":"string"},"default":"\\"0.5rem\\""},{"kind":"variable","name":"PharosCheckboxGroupSpacingHorizontal","type":{"text":"string"},"default":"\\"1.5rem\\""},{"kind":"variable","name":"PharosCheckboxColorBackgroundBase","type":{"text":"string"},"default":"\\"#ffffff\\""},{"kind":"variable","name":"PharosComboboxColorTextHover","type":{"text":"string"},"default":"\\"#990000\\""},{"kind":"variable","name":"PharosComboboxColorTextSelected","type":{"text":"string"},"default":"\\"#000000\\""},{"kind":"variable","name":"PharosComboboxColorIconClear","type":{"text":"string"},"default":"\\"#81807e\\""},{"kind":"variable","name":"PharosComboboxColorIconDropdown","type":{"text":"string"},"default":"\\"#000000\\""},{"kind":"variable","name":"PharosComboboxColorIconCheckmark","type":{"text":"string"},"default":"\\"#000000\\""},{"kind":"variable","name":"PharosComboboxColorIconFocus","type":{"text":"string"},"default":"\\"#990000\\""},{"kind":"variable","name":"PharosComboboxSizeHeightList","type":{"text":"string"},"default":"\\"15rem\\""},{"kind":"variable","name":"PharosComboboxSizeHeightClear","type":{"text":"string"},"default":"\\"1.875rem\\""},{"kind":"variable","name":"PharosDropdownMenuItemColorTextBase","type":{"text":"string"},"default":"\\"#000000\\""},{"kind":"variable","name":"PharosDropdownMenuItemColorTextHover","type":{"text":"string"},"default":"\\"#990000\\""},{"kind":"variable","name":"PharosDropdownMenuItemColorTextDisabled","type":{"text":"string"},"default":"\\"#676765\\""},{"kind":"variable","name":"PharosDropdownMenuItemColorTextDescription","type":{"text":"string"},"default":"\\"#676765\\""},{"kind":"variable","name":"PharosDropdownMenuItemColorBorderBase","type":{"text":"string"},"default":"\\"#d1cfc7\\""},{"kind":"variable","name":"PharosDropdownMenuItemColorBackgroundBase","type":{"text":"string"},"default":"\\"#ffffff\\""},{"kind":"variable","name":"PharosDropdownMenuItemColorBackgroundActive","type":{"text":"string"},"default":"\\"#eae8e1\\""},{"kind":"variable","name":"PharosDropdownMenuItemColorBackgroundDisabled","type":{"text":"string"},"default":"\\"#eae8e1\\""},{"kind":"variable","name":"PharosDropdownMenuItemColorBackgroundHover","type":{"text":"string"},"default":"\\"#f2f1ed\\""},{"kind":"variable","name":"PharosDropdownMenuItemColorIconBase","type":{"text":"string"},"default":"\\"#000000\\""},{"kind":"variable","name":"PharosDropdownMenuColorBorderBase","type":{"text":"string"},"default":"\\"#d1cfc7\\""},{"kind":"variable","name":"PharosDropdownMenuSizeWidthMin","type":{"text":"string"},"default":"\\"9rem\\""},{"kind":"variable","name":"PharosDropdownMenuSizeWidthMax","type":{"text":"string"},"default":"\\"17rem\\""},{"kind":"variable","name":"PharosFormElementColorTextBase","type":{"text":"string"},"default":"\\"#000000\\""},{"kind":"variable","name":"PharosFormElementColorTextRequired","type":{"text":"string"},"default":"\\"#dd3431\\""},{"kind":"variable","name":"PharosFormElementColorTextInvalid","type":{"text":"string"},"default":"\\"#dd3431\\""},{"kind":"variable","name":"PharosFormElementColorTextDisabled","type":{"text":"string"},"default":"\\"#676765\\""},{"kind":"variable","name":"PharosFormElementColorTextPlaceholder","type":{"text":"string"},"default":"\\"#676765\\""},{"kind":"variable","name":"PharosFormElementColorBackgroundDisabled","type":{"text":"string"},"default":"\\"#eae8e1\\""},{"kind":"variable","name":"PharosFormElementColorBackgroundSelected","type":{"text":"string"},"default":"\\"#000000\\""},{"kind":"variable","name":"PharosFormElementColorBorderBase","type":{"text":"string"},"default":"\\"#81807e\\""},{"kind":"variable","name":"PharosFormElementColorBorderFocus","type":{"text":"string"},"default":"\\"#0ba3c1\\""},{"kind":"variable","name":"PharosFormElementColorBorderInvalid","type":{"text":"string"},"default":"\\"#dd3431\\""},{"kind":"variable","name":"PharosFormElementColorBorderDisabled","type":{"text":"string"},"default":"\\"#d1cfc7\\""},{"kind":"variable","name":"PharosFormElementSizeTextLabel","type":{"text":"string"},"default":"\\"2\\""},{"kind":"variable","name":"PharosFormElementSizeTextInput","type":{"text":"string"},"default":"\\"3\\""},{"kind":"variable","name":"PharosLoadingSpinnerColorStrokePrimary","type":{"text":"string"},"default":"\\"#990000\\""},{"kind":"variable","name":"PharosLoadingSpinnerColorStrokeSecondary","type":{"text":"string"},"default":"\\"#fb4848\\""},{"kind":"variable","name":"PharosModalColorBackgroundContent","type":{"text":"string"},"default":"\\"#ffffff\\""},{"kind":"variable","name":"PharosModalColorBorderContent","type":{"text":"string"},"default":"\\"#eae8e1\\""},{"kind":"variable","name":"PharosModalColorIconClose","type":{"text":"string"},"default":"\\"#81807e\\""},{"kind":"variable","name":"PharosModalColorIconFocus","type":{"text":"string"},"default":"\\"#990000\\""},{"kind":"variable","name":"PharosModalSpacingBase","type":{"text":"string"},"default":"\\"2rem\\""},{"kind":"variable","name":"PharosModalSizeWidthBase","type":{"text":"string"},"default":"\\"40rem\\""},{"kind":"variable","name":"PharosRadioButtonColorBackgroundBase","type":{"text":"string"},"default":"\\"#ffffff\\""},{"kind":"variable","name":"PharosRadioGroupSpacingVertical","type":{"text":"string"},"default":"\\"0.5rem\\""},{"kind":"variable","name":"PharosRadioGroupSpacingHorizontal","type":{"text":"string"},"default":"\\"1.5rem\\""},{"kind":"variable","name":"PharosTextInputColorIconValid","type":{"text":"string"},"default":"\\"#268241\\""},{"kind":"variable","name":"PharosTextInputColorIconInvalid","type":{"text":"string"},"default":"\\"#dd3431\\""},{"kind":"variable","name":"PharosTextareaSizeHeightBase","type":{"text":"string"},"default":"\\"3.5rem\\""},{"kind":"variable","name":"PharosTooltipColorBackgroundBase","type":{"text":"string"},"default":"\\"#343332\\""},{"kind":"variable","name":"PharosTooltipColorTextBase","type":{"text":"string"},"default":"\\"#ffffff\\""},{"kind":"variable","name":"PharosTooltipSizeTextBase","type":{"text":"string"},"default":"\\"2\\""},{"kind":"variable","name":"PharosFontFamilySansSerif","type":{"text":"string"},"default":"\\"GT America Standard, Helvetica, Helvetica Neue, Arial, Segoe UI, Roboto, Droid Sans, sans-serif\\""},{"kind":"variable","name":"PharosFontFamilySerif","type":{"text":"string"},"default":"\\"Ivar Headline, Times, Georgia, serif\\""},{"kind":"variable","name":"PharosFontFamilyBody","type":{"text":"string"},"default":"\\"GT America Standard, Helvetica, Helvetica Neue, Arial, Segoe UI, Roboto, Droid Sans, sans-serif\\""},{"kind":"variable","name":"PharosFontWeightRegular","type":{"text":"string"},"default":"\\"400\\""},{"kind":"variable","name":"PharosFontWeightBold","type":{"text":"string"},"default":"\\"700\\""},{"kind":"variable","name":"PharosFontSizeMicro","type":{"text":"string"},"default":"\\"1\\""},{"kind":"variable","name":"PharosFontSizeSmall","type":{"text":"string"},"default":"\\"2\\""},{"kind":"variable","name":"PharosFontSizeBase","type":{"text":"string"},"default":"\\"3\\""},{"kind":"variable","name":"PharosFontSizeLarge","type":{"text":"string"},"default":"\\"5\\""},{"kind":"variable","name":"PharosFontSizeXlarge","type":{"text":"string"},"default":"\\"6\\""},{"kind":"variable","name":"PharosLineHeightXsmall","type":{"text":"string"},"default":"\\"1rem\\""},{"kind":"variable","name":"PharosLineHeightSmall","type":{"text":"string"},"default":"\\"1.25rem\\""},{"kind":"variable","name":"PharosLineHeightMedium","type":{"text":"string"},"default":"\\"1.5rem\\""},{"kind":"variable","name":"PharosLineHeightLarge","type":{"text":"string"},"default":"\\"1.75rem\\""},{"kind":"variable","name":"PharosLineHeightXlarge","type":{"text":"string"},"default":"\\"2.25rem\\""},{"kind":"variable","name":"PharosLineHeightHeadingLarge","type":{"text":"string"},"default":"\\"1\\""},{"kind":"variable","name":"PharosLineHeightTextBaseCondensed","type":{"text":"string"},"default":"\\"1.25rem\\""},{"kind":"variable","name":"PharosRadiusBaseStandard","type":{"text":"string"},"default":"\\"0.125rem\\""},{"kind":"variable","name":"PharosSpacingOneEighthX","type":{"text":"string"},"default":"\\"0.125rem\\""},{"kind":"variable","name":"PharosSpacingOneQuarterX","type":{"text":"string"},"default":"\\"0.25rem\\""},{"kind":"variable","name":"PharosSpacingOneHalfX","type":{"text":"string"},"default":"\\"0.5rem\\""},{"kind":"variable","name":"PharosSpacingThreeQuartersX","type":{"text":"string"},"default":"\\"0.75rem\\""},{"kind":"variable","name":"PharosSpacing1X","type":{"text":"string"},"default":"\\"1rem\\""},{"kind":"variable","name":"PharosSpacingOneAndAHalfX","type":{"text":"string"},"default":"\\"1.5rem\\""},{"kind":"variable","name":"PharosSpacing2X","type":{"text":"string"},"default":"\\"2rem\\""},{"kind":"variable","name":"PharosSpacing3X","type":{"text":"string"},"default":"\\"3rem\\""},{"kind":"variable","name":"PharosSpacingThreeAndAHalfX","type":{"text":"string"},"default":"\\"3.5rem\\""},{"kind":"variable","name":"PharosSpacing5X","type":{"text":"string"},"default":"\\"5rem\\""},{"kind":"variable","name":"PharosSpacing7X","type":{"text":"string"},"default":"\\"7rem\\""},{"kind":"variable","name":"PharosSpacing10X","type":{"text":"string"},"default":"\\"10rem\\""},{"kind":"variable","name":"PharosSpacingGutter","type":{"text":"string"},"default":"\\"3rem\\""},{"kind":"variable","name":"PharosTransitionBase","type":{"text":"string"},"default":"\\"250ms cubic-bezier(0.17, 0.67, 0.83, 0.67)\\""},{"kind":"variable","name":"PharosTransitionDurationShorter","type":{"text":"string"},"default":"\\"50ms\\""},{"kind":"variable","name":"PharosTransitionDurationShort","type":{"text":"string"},"default":"\\"100ms\\""},{"kind":"variable","name":"PharosTransitionDurationDefault","type":{"text":"string"},"default":"\\"250ms\\""},{"kind":"variable","name":"PharosTransitionDurationLong","type":{"text":"string"},"default":"\\"500ms\\""},{"kind":"variable","name":"PharosTransitionDurationLonger","type":{"text":"string"},"default":"\\"1000ms\\""},{"kind":"variable","name":"PharosTransitionCurveBase","type":{"text":"string"},"default":"\\"cubic-bezier(0.17, 0.67, 0.83, 0.67)\\""},{"kind":"variable","name":"PharosTypeScale1","type":{"text":"string"},"default":"\\"1\\""},{"kind":"variable","name":"PharosTypeScale2","type":{"text":"string"},"default":"\\"2\\""},{"kind":"variable","name":"PharosTypeScale3","type":{"text":"string"},"default":"\\"3\\""},{"kind":"variable","name":"PharosTypeScale4","type":{"text":"string"},"default":"\\"4\\""},{"kind":"variable","name":"PharosTypeScale5","type":{"text":"string"},"default":"\\"5\\""},{"kind":"variable","name":"PharosTypeScale6","type":{"text":"string"},"default":"\\"6\\""},{"kind":"variable","name":"PharosTypeScale7","type":{"text":"string"},"default":"\\"7\\""},{"kind":"variable","name":"PharosTypeScale8","type":{"text":"string"},"default":"\\"8\\""},{"kind":"variable","name":"PharosTypeScale9","type":{"text":"string"},"default":"\\"9\\""},{"kind":"variable","name":"PharosTypeScale10","type":{"text":"string"},"default":"\\"10\\""},{"kind":"variable","name":"PharosTypeScale11","type":{"text":"string"},"default":"\\"11\\""},{"kind":"variable","name":"PharosTypeScale12","type":{"text":"string"},"default":"\\"12\\""},{"kind":"variable","name":"PharosTypeScale13","type":{"text":"string"},"default":"\\"13\\""},{"kind":"variable","name":"PharosTypeScale14","type":{"text":"string"},"default":"\\"14\\""}],"exports":[{"kind":"js","name":"PharosAssetIconAcademicContent","declaration":{"name":"PharosAssetIconAcademicContent","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconAdd","declaration":{"name":"PharosAssetIconAdd","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconArrowDown","declaration":{"name":"PharosAssetIconArrowDown","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconArrowLeft","declaration":{"name":"PharosAssetIconArrowLeft","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconArrowRight","declaration":{"name":"PharosAssetIconArrowRight","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconArrowUp","declaration":{"name":"PharosAssetIconArrowUp","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconAttachment","declaration":{"name":"PharosAssetIconAttachment","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconBase","declaration":{"name":"PharosAssetIconBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconBook","declaration":{"name":"PharosAssetIconBook","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconCalendar","declaration":{"name":"PharosAssetIconCalendar","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconCheckmarkFilledCircle","declaration":{"name":"PharosAssetIconCheckmarkFilledCircle","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconCheckmarkInverse","declaration":{"name":"PharosAssetIconCheckmarkInverse","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconCheckmarkSmall","declaration":{"name":"PharosAssetIconCheckmarkSmall","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconCheckmark","declaration":{"name":"PharosAssetIconCheckmark","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconChevronDown","declaration":{"name":"PharosAssetIconChevronDown","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconChevronLeftLarge","declaration":{"name":"PharosAssetIconChevronLeftLarge","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconChevronLeft","declaration":{"name":"PharosAssetIconChevronLeft","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconChevronRightLarge","declaration":{"name":"PharosAssetIconChevronRightLarge","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconChevronRight","declaration":{"name":"PharosAssetIconChevronRight","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconChevronUp","declaration":{"name":"PharosAssetIconChevronUp","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconCircle","declaration":{"name":"PharosAssetIconCircle","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconCite","declaration":{"name":"PharosAssetIconCite","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconCloseInverse","declaration":{"name":"PharosAssetIconCloseInverse","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconClose","declaration":{"name":"PharosAssetIconClose","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconCollapse","declaration":{"name":"PharosAssetIconCollapse","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconCopy","declaration":{"name":"PharosAssetIconCopy","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconDashSmall","declaration":{"name":"PharosAssetIconDashSmall","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconDelete","declaration":{"name":"PharosAssetIconDelete","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconDownload","declaration":{"name":"PharosAssetIconDownload","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconEdit","declaration":{"name":"PharosAssetIconEdit","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconEllipsesHorizontal","declaration":{"name":"PharosAssetIconEllipsesHorizontal","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconEllipsesVertical","declaration":{"name":"PharosAssetIconEllipsesVertical","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconEmail","declaration":{"name":"PharosAssetIconEmail","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconExclamationInverse","declaration":{"name":"PharosAssetIconExclamationInverse","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconExclamation","declaration":{"name":"PharosAssetIconExclamation","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconExpand","declaration":{"name":"PharosAssetIconExpand","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconFacebook","declaration":{"name":"PharosAssetIconFacebook","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconFiletypePdf","declaration":{"name":"PharosAssetIconFiletypePdf","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconFiletypePpt","declaration":{"name":"PharosAssetIconFiletypePpt","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconFiletypeZip","declaration":{"name":"PharosAssetIconFiletypeZip","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconFitToView","declaration":{"name":"PharosAssetIconFitToView","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconFitToWidth","declaration":{"name":"PharosAssetIconFitToWidth","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconFolderNew","declaration":{"name":"PharosAssetIconFolderNew","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconFolder","declaration":{"name":"PharosAssetIconFolder","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconFolderSelected","declaration":{"name":"PharosAssetIconFolderSelected","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconFullscreenMinimize","declaration":{"name":"PharosAssetIconFullscreenMinimize","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconFullscreen","declaration":{"name":"PharosAssetIconFullscreen","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconGoogleColor","declaration":{"name":"PharosAssetIconGoogleColor","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconGoogle","declaration":{"name":"PharosAssetIconGoogle","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconImage","declaration":{"name":"PharosAssetIconImage","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconInfoInverse","declaration":{"name":"PharosAssetIconInfoInverse","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconInstagram","declaration":{"name":"PharosAssetIconInstagram","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconLaptop","declaration":{"name":"PharosAssetIconLaptop","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconLinkAdd","declaration":{"name":"PharosAssetIconLinkAdd","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconLinkExternal","declaration":{"name":"PharosAssetIconLinkExternal","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconLink","declaration":{"name":"PharosAssetIconLink","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconLinkedin","declaration":{"name":"PharosAssetIconLinkedin","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconMenu","declaration":{"name":"PharosAssetIconMenu","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconMove","declaration":{"name":"PharosAssetIconMove","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconNew","declaration":{"name":"PharosAssetIconNew","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconPartialCircle","declaration":{"name":"PharosAssetIconPartialCircle","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconPrimarySource","declaration":{"name":"PharosAssetIconPrimarySource","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconProfile","declaration":{"name":"PharosAssetIconProfile","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconQuestionInverse","declaration":{"name":"PharosAssetIconQuestionInverse","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconSave","declaration":{"name":"PharosAssetIconSave","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconSaved","declaration":{"name":"PharosAssetIconSaved","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconSearch","declaration":{"name":"PharosAssetIconSearch","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconShare","declaration":{"name":"PharosAssetIconShare","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconShiftLeft","declaration":{"name":"PharosAssetIconShiftLeft","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconShiftRight","declaration":{"name":"PharosAssetIconShiftRight","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconShiftUp","declaration":{"name":"PharosAssetIconShiftUp","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconShiftDown","declaration":{"name":"PharosAssetIconShiftDown","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconTumblr","declaration":{"name":"PharosAssetIconTumblr","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconTwitter","declaration":{"name":"PharosAssetIconTwitter","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconVideo","declaration":{"name":"PharosAssetIconVideo","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconViewGallery","declaration":{"name":"PharosAssetIconViewGallery","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconViewGrid","declaration":{"name":"PharosAssetIconViewGrid","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconViewList","declaration":{"name":"PharosAssetIconViewList","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconWorkspace","declaration":{"name":"PharosAssetIconWorkspace","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconWorkspaceSelected","declaration":{"name":"PharosAssetIconWorkspaceSelected","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconYoutube","declaration":{"name":"PharosAssetIconYoutube","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconZoomIn","declaration":{"name":"PharosAssetIconZoomIn","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAssetIconZoomOut","declaration":{"name":"PharosAssetIconZoomOut","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosBreakpointSmall","declaration":{"name":"PharosBreakpointSmall","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosBreakpointMedium","declaration":{"name":"PharosBreakpointMedium","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosBreakpointLarge","declaration":{"name":"PharosBreakpointLarge","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosBreakpointXlarge","declaration":{"name":"PharosBreakpointXlarge","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosBreakpointMax","declaration":{"name":"PharosBreakpointMax","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorJstorRed","declaration":{"name":"PharosColorJstorRed","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorNightBlue15","declaration":{"name":"PharosColorNightBlue15","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorNightBlue60","declaration":{"name":"PharosColorNightBlue60","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorNightBlueBase","declaration":{"name":"PharosColorNightBlueBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorGlacierBlue40","declaration":{"name":"PharosColorGlacierBlue40","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorGlacierBlue70","declaration":{"name":"PharosColorGlacierBlue70","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorGlacierBlue80","declaration":{"name":"PharosColorGlacierBlue80","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorGlacierBlue90","declaration":{"name":"PharosColorGlacierBlue90","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorGlacierBlueBase","declaration":{"name":"PharosColorGlacierBlueBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorLivingCoral50","declaration":{"name":"PharosColorLivingCoral50","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorLivingCoral53","declaration":{"name":"PharosColorLivingCoral53","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorLivingCoral80","declaration":{"name":"PharosColorLivingCoral80","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorLivingCoral90","declaration":{"name":"PharosColorLivingCoral90","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorLivingCoralBase","declaration":{"name":"PharosColorLivingCoralBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorMarbleGray10","declaration":{"name":"PharosColorMarbleGray10","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorMarbleGray20","declaration":{"name":"PharosColorMarbleGray20","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorMarbleGray40","declaration":{"name":"PharosColorMarbleGray40","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorMarbleGray50","declaration":{"name":"PharosColorMarbleGray50","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorMarbleGray80","declaration":{"name":"PharosColorMarbleGray80","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorMarbleGray94","declaration":{"name":"PharosColorMarbleGray94","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorMarbleGray97","declaration":{"name":"PharosColorMarbleGray97","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorMarbleGrayBase","declaration":{"name":"PharosColorMarbleGrayBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorBlack","declaration":{"name":"PharosColorBlack","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorWhite","declaration":{"name":"PharosColorWhite","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorYellow97","declaration":{"name":"PharosColorYellow97","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorYellowBase","declaration":{"name":"PharosColorYellowBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorGreen93","declaration":{"name":"PharosColorGreen93","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorGreenBase","declaration":{"name":"PharosColorGreenBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorInteractivePrimary","declaration":{"name":"PharosColorInteractivePrimary","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorInteractiveSecondary","declaration":{"name":"PharosColorInteractiveSecondary","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorInteractiveTertiary","declaration":{"name":"PharosColorInteractiveTertiary","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorUi10","declaration":{"name":"PharosColorUi10","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorUi20","declaration":{"name":"PharosColorUi20","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorUi30","declaration":{"name":"PharosColorUi30","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorUi40","declaration":{"name":"PharosColorUi40","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorUi50","declaration":{"name":"PharosColorUi50","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorDisabled","declaration":{"name":"PharosColorDisabled","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorOverlay","declaration":{"name":"PharosColorOverlay","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorFeedbackError","declaration":{"name":"PharosColorFeedbackError","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorFeedbackSuccess","declaration":{"name":"PharosColorFeedbackSuccess","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorFeedbackWarning","declaration":{"name":"PharosColorFeedbackWarning","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorFeedbackInfo","declaration":{"name":"PharosColorFeedbackInfo","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorText10","declaration":{"name":"PharosColorText10","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorText20","declaration":{"name":"PharosColorText20","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorText40","declaration":{"name":"PharosColorText40","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorText50","declaration":{"name":"PharosColorText50","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorTextBase","declaration":{"name":"PharosColorTextBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorTextDisabled","declaration":{"name":"PharosColorTextDisabled","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorTextPlaceholder","declaration":{"name":"PharosColorTextPlaceholder","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorTextWhite","declaration":{"name":"PharosColorTextWhite","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorFocus","declaration":{"name":"PharosColorFocus","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorHoverPrimary","declaration":{"name":"PharosColorHoverPrimary","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorHoverSecondary","declaration":{"name":"PharosColorHoverSecondary","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosColorHoverRow","declaration":{"name":"PharosColorHoverRow","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAlertColorBackgroundBase","declaration":{"name":"PharosAlertColorBackgroundBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAlertColorBackgroundInfo","declaration":{"name":"PharosAlertColorBackgroundInfo","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAlertColorBackgroundError","declaration":{"name":"PharosAlertColorBackgroundError","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAlertColorBackgroundSuccess","declaration":{"name":"PharosAlertColorBackgroundSuccess","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAlertColorBackgroundWarning","declaration":{"name":"PharosAlertColorBackgroundWarning","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAlertColorIconBase","declaration":{"name":"PharosAlertColorIconBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAlertColorIconInfo","declaration":{"name":"PharosAlertColorIconInfo","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAlertColorIconError","declaration":{"name":"PharosAlertColorIconError","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAlertColorIconSuccess","declaration":{"name":"PharosAlertColorIconSuccess","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAlertColorIconWarning","declaration":{"name":"PharosAlertColorIconWarning","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAlertColorTextBase","declaration":{"name":"PharosAlertColorTextBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAlertColorTextInverse","declaration":{"name":"PharosAlertColorTextInverse","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAlertColorLinkBase","declaration":{"name":"PharosAlertColorLinkBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAlertColorLinkInverse","declaration":{"name":"PharosAlertColorLinkInverse","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAlertColorBorderBase","declaration":{"name":"PharosAlertColorBorderBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAlertColorBorderInfo","declaration":{"name":"PharosAlertColorBorderInfo","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAlertColorBorderError","declaration":{"name":"PharosAlertColorBorderError","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAlertColorBorderSuccess","declaration":{"name":"PharosAlertColorBorderSuccess","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosAlertColorBorderWarning","declaration":{"name":"PharosAlertColorBorderWarning","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonPaddingBase","declaration":{"name":"PharosButtonPaddingBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonPaddingCondensed","declaration":{"name":"PharosButtonPaddingCondensed","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonPaddingLarge","declaration":{"name":"PharosButtonPaddingLarge","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBasePrimaryBackgroundBase","declaration":{"name":"PharosButtonColorBasePrimaryBackgroundBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBasePrimaryBackgroundHover","declaration":{"name":"PharosButtonColorBasePrimaryBackgroundHover","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBasePrimaryBackgroundDisabled","declaration":{"name":"PharosButtonColorBasePrimaryBackgroundDisabled","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBasePrimaryTextBase","declaration":{"name":"PharosButtonColorBasePrimaryTextBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBasePrimaryTextHover","declaration":{"name":"PharosButtonColorBasePrimaryTextHover","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBasePrimaryTextDisabled","declaration":{"name":"PharosButtonColorBasePrimaryTextDisabled","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBasePrimaryBorderBase","declaration":{"name":"PharosButtonColorBasePrimaryBorderBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBasePrimaryBorderHover","declaration":{"name":"PharosButtonColorBasePrimaryBorderHover","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBasePrimaryBorderDisabled","declaration":{"name":"PharosButtonColorBasePrimaryBorderDisabled","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBaseSecondaryBackgroundBase","declaration":{"name":"PharosButtonColorBaseSecondaryBackgroundBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBaseSecondaryBackgroundHover","declaration":{"name":"PharosButtonColorBaseSecondaryBackgroundHover","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBaseSecondaryBackgroundDisabled","declaration":{"name":"PharosButtonColorBaseSecondaryBackgroundDisabled","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBaseSecondaryTextBase","declaration":{"name":"PharosButtonColorBaseSecondaryTextBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBaseSecondaryTextHover","declaration":{"name":"PharosButtonColorBaseSecondaryTextHover","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBaseSecondaryTextDisabled","declaration":{"name":"PharosButtonColorBaseSecondaryTextDisabled","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBaseSecondaryBorderBase","declaration":{"name":"PharosButtonColorBaseSecondaryBorderBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBaseSecondaryBorderHover","declaration":{"name":"PharosButtonColorBaseSecondaryBorderHover","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBaseSecondaryBorderDisabled","declaration":{"name":"PharosButtonColorBaseSecondaryBorderDisabled","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBaseSubtleBackgroundBase","declaration":{"name":"PharosButtonColorBaseSubtleBackgroundBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBaseSubtleBackgroundHover","declaration":{"name":"PharosButtonColorBaseSubtleBackgroundHover","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBaseSubtleBackgroundDisabled","declaration":{"name":"PharosButtonColorBaseSubtleBackgroundDisabled","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBaseSubtleTextBase","declaration":{"name":"PharosButtonColorBaseSubtleTextBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBaseSubtleTextHover","declaration":{"name":"PharosButtonColorBaseSubtleTextHover","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBaseSubtleTextDisabled","declaration":{"name":"PharosButtonColorBaseSubtleTextDisabled","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBaseSubtleBorderBase","declaration":{"name":"PharosButtonColorBaseSubtleBorderBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBaseSubtleBorderHover","declaration":{"name":"PharosButtonColorBaseSubtleBorderHover","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBaseSubtleBorderDisabled","declaration":{"name":"PharosButtonColorBaseSubtleBorderDisabled","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBaseOverlayBackgroundBase","declaration":{"name":"PharosButtonColorBaseOverlayBackgroundBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBaseOverlayBackgroundHover","declaration":{"name":"PharosButtonColorBaseOverlayBackgroundHover","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBaseOverlayBackgroundDisabled","declaration":{"name":"PharosButtonColorBaseOverlayBackgroundDisabled","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBaseOverlayTextBase","declaration":{"name":"PharosButtonColorBaseOverlayTextBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBaseOverlayTextHover","declaration":{"name":"PharosButtonColorBaseOverlayTextHover","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBaseOverlayTextDisabled","declaration":{"name":"PharosButtonColorBaseOverlayTextDisabled","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBaseOverlayBorderBase","declaration":{"name":"PharosButtonColorBaseOverlayBorderBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBaseOverlayBorderHover","declaration":{"name":"PharosButtonColorBaseOverlayBorderHover","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorBaseOverlayBorderDisabled","declaration":{"name":"PharosButtonColorBaseOverlayBorderDisabled","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundPrimaryBackgroundBase","declaration":{"name":"PharosButtonColorOnBackgroundPrimaryBackgroundBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundPrimaryBackgroundHover","declaration":{"name":"PharosButtonColorOnBackgroundPrimaryBackgroundHover","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundPrimaryBackgroundDisabled","declaration":{"name":"PharosButtonColorOnBackgroundPrimaryBackgroundDisabled","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundPrimaryTextBase","declaration":{"name":"PharosButtonColorOnBackgroundPrimaryTextBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundPrimaryTextHover","declaration":{"name":"PharosButtonColorOnBackgroundPrimaryTextHover","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundPrimaryTextDisabled","declaration":{"name":"PharosButtonColorOnBackgroundPrimaryTextDisabled","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundPrimaryBorderBase","declaration":{"name":"PharosButtonColorOnBackgroundPrimaryBorderBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundPrimaryBorderHover","declaration":{"name":"PharosButtonColorOnBackgroundPrimaryBorderHover","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundPrimaryBorderDisabled","declaration":{"name":"PharosButtonColorOnBackgroundPrimaryBorderDisabled","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundSecondaryBackgroundBase","declaration":{"name":"PharosButtonColorOnBackgroundSecondaryBackgroundBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundSecondaryBackgroundHover","declaration":{"name":"PharosButtonColorOnBackgroundSecondaryBackgroundHover","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundSecondaryBackgroundDisabled","declaration":{"name":"PharosButtonColorOnBackgroundSecondaryBackgroundDisabled","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundSecondaryTextBase","declaration":{"name":"PharosButtonColorOnBackgroundSecondaryTextBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundSecondaryTextHover","declaration":{"name":"PharosButtonColorOnBackgroundSecondaryTextHover","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundSecondaryTextDisabled","declaration":{"name":"PharosButtonColorOnBackgroundSecondaryTextDisabled","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundSecondaryBorderBase","declaration":{"name":"PharosButtonColorOnBackgroundSecondaryBorderBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundSecondaryBorderHover","declaration":{"name":"PharosButtonColorOnBackgroundSecondaryBorderHover","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundSecondaryBorderDisabled","declaration":{"name":"PharosButtonColorOnBackgroundSecondaryBorderDisabled","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundSubtleBackgroundBase","declaration":{"name":"PharosButtonColorOnBackgroundSubtleBackgroundBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundSubtleBackgroundHover","declaration":{"name":"PharosButtonColorOnBackgroundSubtleBackgroundHover","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundSubtleBackgroundDisabled","declaration":{"name":"PharosButtonColorOnBackgroundSubtleBackgroundDisabled","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundSubtleTextBase","declaration":{"name":"PharosButtonColorOnBackgroundSubtleTextBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundSubtleTextHover","declaration":{"name":"PharosButtonColorOnBackgroundSubtleTextHover","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundSubtleTextDisabled","declaration":{"name":"PharosButtonColorOnBackgroundSubtleTextDisabled","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundSubtleBorderBase","declaration":{"name":"PharosButtonColorOnBackgroundSubtleBorderBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundSubtleBorderHover","declaration":{"name":"PharosButtonColorOnBackgroundSubtleBorderHover","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundSubtleBorderDisabled","declaration":{"name":"PharosButtonColorOnBackgroundSubtleBorderDisabled","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundOverlayBackgroundBase","declaration":{"name":"PharosButtonColorOnBackgroundOverlayBackgroundBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundOverlayBackgroundHover","declaration":{"name":"PharosButtonColorOnBackgroundOverlayBackgroundHover","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundOverlayBackgroundDisabled","declaration":{"name":"PharosButtonColorOnBackgroundOverlayBackgroundDisabled","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundOverlayTextBase","declaration":{"name":"PharosButtonColorOnBackgroundOverlayTextBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundOverlayTextHover","declaration":{"name":"PharosButtonColorOnBackgroundOverlayTextHover","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundOverlayTextDisabled","declaration":{"name":"PharosButtonColorOnBackgroundOverlayTextDisabled","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundOverlayBorderBase","declaration":{"name":"PharosButtonColorOnBackgroundOverlayBorderBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundOverlayBorderHover","declaration":{"name":"PharosButtonColorOnBackgroundOverlayBorderHover","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosButtonColorOnBackgroundOverlayBorderDisabled","declaration":{"name":"PharosButtonColorOnBackgroundOverlayBorderDisabled","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosCheckboxGroupSpacingVertical","declaration":{"name":"PharosCheckboxGroupSpacingVertical","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosCheckboxGroupSpacingHorizontal","declaration":{"name":"PharosCheckboxGroupSpacingHorizontal","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosCheckboxColorBackgroundBase","declaration":{"name":"PharosCheckboxColorBackgroundBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosComboboxColorTextHover","declaration":{"name":"PharosComboboxColorTextHover","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosComboboxColorTextSelected","declaration":{"name":"PharosComboboxColorTextSelected","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosComboboxColorIconClear","declaration":{"name":"PharosComboboxColorIconClear","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosComboboxColorIconDropdown","declaration":{"name":"PharosComboboxColorIconDropdown","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosComboboxColorIconCheckmark","declaration":{"name":"PharosComboboxColorIconCheckmark","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosComboboxColorIconFocus","declaration":{"name":"PharosComboboxColorIconFocus","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosComboboxSizeHeightList","declaration":{"name":"PharosComboboxSizeHeightList","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosComboboxSizeHeightClear","declaration":{"name":"PharosComboboxSizeHeightClear","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosDropdownMenuItemColorTextBase","declaration":{"name":"PharosDropdownMenuItemColorTextBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosDropdownMenuItemColorTextHover","declaration":{"name":"PharosDropdownMenuItemColorTextHover","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosDropdownMenuItemColorTextDisabled","declaration":{"name":"PharosDropdownMenuItemColorTextDisabled","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosDropdownMenuItemColorTextDescription","declaration":{"name":"PharosDropdownMenuItemColorTextDescription","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosDropdownMenuItemColorBorderBase","declaration":{"name":"PharosDropdownMenuItemColorBorderBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosDropdownMenuItemColorBackgroundBase","declaration":{"name":"PharosDropdownMenuItemColorBackgroundBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosDropdownMenuItemColorBackgroundActive","declaration":{"name":"PharosDropdownMenuItemColorBackgroundActive","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosDropdownMenuItemColorBackgroundDisabled","declaration":{"name":"PharosDropdownMenuItemColorBackgroundDisabled","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosDropdownMenuItemColorBackgroundHover","declaration":{"name":"PharosDropdownMenuItemColorBackgroundHover","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosDropdownMenuItemColorIconBase","declaration":{"name":"PharosDropdownMenuItemColorIconBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosDropdownMenuColorBorderBase","declaration":{"name":"PharosDropdownMenuColorBorderBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosDropdownMenuSizeWidthMin","declaration":{"name":"PharosDropdownMenuSizeWidthMin","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosDropdownMenuSizeWidthMax","declaration":{"name":"PharosDropdownMenuSizeWidthMax","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosFormElementColorTextBase","declaration":{"name":"PharosFormElementColorTextBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosFormElementColorTextRequired","declaration":{"name":"PharosFormElementColorTextRequired","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosFormElementColorTextInvalid","declaration":{"name":"PharosFormElementColorTextInvalid","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosFormElementColorTextDisabled","declaration":{"name":"PharosFormElementColorTextDisabled","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosFormElementColorTextPlaceholder","declaration":{"name":"PharosFormElementColorTextPlaceholder","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosFormElementColorBackgroundDisabled","declaration":{"name":"PharosFormElementColorBackgroundDisabled","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosFormElementColorBackgroundSelected","declaration":{"name":"PharosFormElementColorBackgroundSelected","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosFormElementColorBorderBase","declaration":{"name":"PharosFormElementColorBorderBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosFormElementColorBorderFocus","declaration":{"name":"PharosFormElementColorBorderFocus","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosFormElementColorBorderInvalid","declaration":{"name":"PharosFormElementColorBorderInvalid","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosFormElementColorBorderDisabled","declaration":{"name":"PharosFormElementColorBorderDisabled","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosFormElementSizeTextLabel","declaration":{"name":"PharosFormElementSizeTextLabel","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosFormElementSizeTextInput","declaration":{"name":"PharosFormElementSizeTextInput","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosLoadingSpinnerColorStrokePrimary","declaration":{"name":"PharosLoadingSpinnerColorStrokePrimary","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosLoadingSpinnerColorStrokeSecondary","declaration":{"name":"PharosLoadingSpinnerColorStrokeSecondary","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosModalColorBackgroundContent","declaration":{"name":"PharosModalColorBackgroundContent","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosModalColorBorderContent","declaration":{"name":"PharosModalColorBorderContent","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosModalColorIconClose","declaration":{"name":"PharosModalColorIconClose","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosModalColorIconFocus","declaration":{"name":"PharosModalColorIconFocus","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosModalSpacingBase","declaration":{"name":"PharosModalSpacingBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosModalSizeWidthBase","declaration":{"name":"PharosModalSizeWidthBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosRadioButtonColorBackgroundBase","declaration":{"name":"PharosRadioButtonColorBackgroundBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosRadioGroupSpacingVertical","declaration":{"name":"PharosRadioGroupSpacingVertical","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosRadioGroupSpacingHorizontal","declaration":{"name":"PharosRadioGroupSpacingHorizontal","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosTextInputColorIconValid","declaration":{"name":"PharosTextInputColorIconValid","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosTextInputColorIconInvalid","declaration":{"name":"PharosTextInputColorIconInvalid","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosTextareaSizeHeightBase","declaration":{"name":"PharosTextareaSizeHeightBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosTooltipColorBackgroundBase","declaration":{"name":"PharosTooltipColorBackgroundBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosTooltipColorTextBase","declaration":{"name":"PharosTooltipColorTextBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosTooltipSizeTextBase","declaration":{"name":"PharosTooltipSizeTextBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosFontFamilySansSerif","declaration":{"name":"PharosFontFamilySansSerif","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosFontFamilySerif","declaration":{"name":"PharosFontFamilySerif","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosFontFamilyBody","declaration":{"name":"PharosFontFamilyBody","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosFontWeightRegular","declaration":{"name":"PharosFontWeightRegular","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosFontWeightBold","declaration":{"name":"PharosFontWeightBold","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosFontSizeMicro","declaration":{"name":"PharosFontSizeMicro","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosFontSizeSmall","declaration":{"name":"PharosFontSizeSmall","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosFontSizeBase","declaration":{"name":"PharosFontSizeBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosFontSizeLarge","declaration":{"name":"PharosFontSizeLarge","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosFontSizeXlarge","declaration":{"name":"PharosFontSizeXlarge","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosLineHeightXsmall","declaration":{"name":"PharosLineHeightXsmall","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosLineHeightSmall","declaration":{"name":"PharosLineHeightSmall","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosLineHeightMedium","declaration":{"name":"PharosLineHeightMedium","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosLineHeightLarge","declaration":{"name":"PharosLineHeightLarge","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosLineHeightXlarge","declaration":{"name":"PharosLineHeightXlarge","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosLineHeightHeadingLarge","declaration":{"name":"PharosLineHeightHeadingLarge","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosLineHeightTextBaseCondensed","declaration":{"name":"PharosLineHeightTextBaseCondensed","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosRadiusBaseStandard","declaration":{"name":"PharosRadiusBaseStandard","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosSpacingOneEighthX","declaration":{"name":"PharosSpacingOneEighthX","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosSpacingOneQuarterX","declaration":{"name":"PharosSpacingOneQuarterX","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosSpacingOneHalfX","declaration":{"name":"PharosSpacingOneHalfX","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosSpacingThreeQuartersX","declaration":{"name":"PharosSpacingThreeQuartersX","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosSpacing1X","declaration":{"name":"PharosSpacing1X","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosSpacingOneAndAHalfX","declaration":{"name":"PharosSpacingOneAndAHalfX","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosSpacing2X","declaration":{"name":"PharosSpacing2X","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosSpacing3X","declaration":{"name":"PharosSpacing3X","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosSpacingThreeAndAHalfX","declaration":{"name":"PharosSpacingThreeAndAHalfX","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosSpacing5X","declaration":{"name":"PharosSpacing5X","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosSpacing7X","declaration":{"name":"PharosSpacing7X","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosSpacing10X","declaration":{"name":"PharosSpacing10X","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosSpacingGutter","declaration":{"name":"PharosSpacingGutter","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosTransitionBase","declaration":{"name":"PharosTransitionBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosTransitionDurationShorter","declaration":{"name":"PharosTransitionDurationShorter","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosTransitionDurationShort","declaration":{"name":"PharosTransitionDurationShort","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosTransitionDurationDefault","declaration":{"name":"PharosTransitionDurationDefault","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosTransitionDurationLong","declaration":{"name":"PharosTransitionDurationLong","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosTransitionDurationLonger","declaration":{"name":"PharosTransitionDurationLonger","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosTransitionCurveBase","declaration":{"name":"PharosTransitionCurveBase","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosTypeScale1","declaration":{"name":"PharosTypeScale1","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosTypeScale2","declaration":{"name":"PharosTypeScale2","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosTypeScale3","declaration":{"name":"PharosTypeScale3","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosTypeScale4","declaration":{"name":"PharosTypeScale4","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosTypeScale5","declaration":{"name":"PharosTypeScale5","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosTypeScale6","declaration":{"name":"PharosTypeScale6","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosTypeScale7","declaration":{"name":"PharosTypeScale7","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosTypeScale8","declaration":{"name":"PharosTypeScale8","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosTypeScale9","declaration":{"name":"PharosTypeScale9","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosTypeScale10","declaration":{"name":"PharosTypeScale10","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosTypeScale11","declaration":{"name":"PharosTypeScale11","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosTypeScale12","declaration":{"name":"PharosTypeScale12","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosTypeScale13","declaration":{"name":"PharosTypeScale13","module":"src/styles/variables.ts"}},{"kind":"js","name":"PharosTypeScale14","declaration":{"name":"PharosTypeScale14","module":"src/styles/variables.ts"}}]},{"kind":"javascript-module","path":"src/test/initComponents.ts","declarations":[],"exports":[]},{"kind":"javascript-module","path":"src/utils/createFormData.ts","declarations":[{"kind":"function","name":"createFormData","return":{"type":{"text":""}},"parameters":[{"name":"form","type":{"text":"HTMLFormElement"},"description":"The form containing Pharos form elements."}]}],"exports":[{"kind":"js","name":"default","declaration":{"name":"createFormData","module":"src/utils/createFormData.ts"}}]},{"kind":"javascript-module","path":"src/utils/debounce.ts","declarations":[{"kind":"function","name":"debounce","return":{"type":{"text":""}},"parameters":[{"name":"callback","type":{"text":"Procedure"},"description":"The callback function to wrap."},{"name":"time","type":{"text":"number"},"description":"The timeout in ms."}]}],"exports":[{"kind":"js","name":"default","declaration":{"name":"debounce","module":"src/utils/debounce.ts"}}]},{"kind":"javascript-module","path":"src/utils/deepSelector.ts","declarations":[{"kind":"function","name":"deepSelector","return":{"type":{"text":""}},"parameters":[{"name":"selectors","type":{"text":"string"},"description":"A DOMString containing one or more selectors to match."},{"name":"root","default":"document","type":{"text":"Document | ShadowRoot | null"},"description":"The node\'s root."}]}],"exports":[{"kind":"js","name":"default","declaration":{"name":"deepSelector","module":"src/utils/deepSelector.ts"}}]},{"kind":"javascript-module","path":"src/utils/focusable.ts","declarations":[{"kind":"variable","name":"focusable","default":"`\\n  a[href],\\n  area[href],\\n  button:not([disabled]),\\n  details,\\n  iframe,\\n  input:not([disabled]),\\n  select:not([disabled]),\\n  textarea:not([disabled]),\\n  [contentEditable=\\"true\\"],\\n  [tabindex]:not([tabindex=\\"-1\\"]),\\n  [data-pharos-component=\\"PharosCheckbox\\"]:not([disabled]),\\n  [data-pharos-component=\\"PharosRadioButton\\"]:not([disabled]),\\n  [data-pharos-component=\\"PharosTextInput\\"]:not([disabled]),\\n  [data-pharos-component=\\"PharosInputGroup\\"]:not([disabled]),\\n  [data-pharos-component=\\"PharosSelect\\"]:not([disabled]),\\n  [data-pharos-component=\\"PharosInputGroupSelect\\"]:not([disabled]),\\n  [data-pharos-component=\\"PharosTextarea\\"]:not([disabled]),\\n  [data-pharos-component=\\"PharosCombobox\\"]:not([disabled]),\\n  [data-pharos-component=\\"PharosAlert\\"],\\n  [data-pharos-component=\\"PharosDropdownMenuItem\\"]:not([disabled]),\\n  [data-pharos-component=\\"PharosLink\\"][href],\\n  [data-pharos-component=\\"PharosButton\\"]:not([disabled]),\\n  [data-pharos-component=\\"PharosTab\\"],\\n  [data-pharos-component=\\"PharosDropdownMenuNavLink\\"][href],\\n  [data-pharos-component=\\"PharosSidenavLink\\"][href],\\n  [data-pharos-component=\\"PharosToast\\"],\\n  [data-pharos-component=\\"PharosBreadcrumbItem\\"][href],\\n  [data-pharos-component=\\"PharosSidenavButton\\"]:not([disabled])\\n`"}],"exports":[{"kind":"js","name":"default","declaration":{"name":"focusable","module":"src/utils/focusable.ts"}}]},{"kind":"javascript-module","path":"src/utils/iconNames.ts","declarations":[{"kind":"variable","name":"iconNames","default":"Object.keys(tokens.asset.icon).sort()"}],"exports":[{"kind":"js","name":"iconNames","declaration":{"name":"iconNames","module":"src/utils/iconNames.ts"}}]},{"kind":"javascript-module","path":"src/utils/math.ts","declarations":[{"kind":"function","name":"modulo","return":{"type":{"text":"number"}},"parameters":[{"name":"num","type":{"text":"number"}},{"name":"modulus","type":{"text":"number"}}],"description":"Like the modulo operator (%), but works as expected for negative numbers."},{"kind":"function","name":"loopWrapIndex","return":{"type":{"text":"number"}},"parameters":[{"name":"items","type":{"text":"Array<Type>"}},{"name":"currentItemFilterFunction","type":{"text":"FilterFunction"}},{"name":"moveForward","type":{"text":"boolean"}}],"description":"Given an array of items and an iteration direction, return the next index in that direction when looping is allowed."}],"exports":[{"kind":"js","name":"modulo","declaration":{"name":"modulo","module":"src/utils/math.ts"}},{"kind":"js","name":"loopWrapIndex","declaration":{"name":"loopWrapIndex","module":"src/utils/math.ts"}}]},{"kind":"javascript-module","path":"src/utils/observeResize.ts","declarations":[{"kind":"function","name":"observeResize","return":{"type":{"text":""}},"parameters":[{"name":"observer","type":{"text":"ResizeObserver"},"description":"The observer used to report changes to the content box of the element."},{"name":"element","type":{"text":"Element"},"description":"The element to be observed."}]}],"exports":[{"kind":"js","name":"default","declaration":{"name":"observeResize","module":"src/utils/observeResize.ts"}}]},{"kind":"javascript-module","path":"src/utils/registerComponents.ts","declarations":[{"kind":"function","name":"registerComponents","return":{"type":{"text":"void"}},"parameters":[{"name":"prefix","type":{"text":"string"},"description":"The prefix to use in the tag name."},{"name":"classes","type":{"text":"typeof LitElement[]"},"description":"The Pharos classes to register as custom elements."}]},{"kind":"class","description":"","name":"anonymous_0","mixins":[{"name":"PharosComponentMixin","module":"/src/utils/mixins/pharos-component"}],"superclass":{"name":"clazz","module":"src/utils/registerComponents.ts"}}],"exports":[{"kind":"custom-element-definition","declaration":{"name":"anonymous_0","module":"src/utils/registerComponents.ts"}},{"kind":"js","name":"default","declaration":{"name":"registerComponents","module":"src/utils/registerComponents.ts"}}]},{"kind":"javascript-module","path":"src/components/alert/pharos-alert.ts","declarations":[{"kind":"class","description":"Pharos alert component","name":"PharosAlert","cssProperties":[{"type":{"text":"Color"},"description":"The inverted text color for messaging in a dark-colored alert","name":"--pharos-alert-color-text-inverse"},{"type":{"text":"Color"},"description":"The inverted text color for links in a dark-colored alert","name":"--pharos-alert-color-link-inverse"},{"type":{"text":"Color"},"description":"The background color of an info alert","name":"--pharos-alert-color-background-info"},{"type":{"text":"Color"},"description":"The fill color for an info alert icon","name":"--pharos-alert-color-icon-info"},{"type":{"text":"Color"},"description":"The background color of an success alert","name":"--pharos-alert-color-background-success"},{"type":{"text":"Color"},"description":"The fill color for an success alert icon","name":"--pharos-alert-color-icon-success"},{"type":{"text":"Color"},"description":"The background color of a warning alert","name":"--pharos-alert-color-background-warning"},{"type":{"text":"Color"},"description":"The fill color for a warning alert icon","name":"--pharos-alert-color-icon-warning"},{"type":{"text":"Color"},"description":"The background color of an error alert","name":"--pharos-alert-color-background-error"},{"type":{"text":"Color"},"description":"The fill color for an error alert icon","name":"--pharos-alert-color-icon-error"}],"slots":[{"description":"Contains the alert message (the default slot).","name":""}],"members":[{"kind":"field","name":"elementDefinitions","type":{"text":"object"},"static":true,"default":"{\\n    \'pharos-icon\': PharosIcon,\\n    \'pharos-button\': PharosButton,\\n  }"},{"kind":"field","name":"status","type":{"text":"AlertStatus"},"privacy":"public","description":"The status to reflect to the user","attribute":"status","reflects":true},{"kind":"field","name":"closable","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the alert is closable","attribute":"closable","reflects":true},{"kind":"field","name":"_allLinks","type":{"text":"NodeListOf<PharosLink>"},"privacy":"private"},{"kind":"method","name":"_getIcon","privacy":"private","return":{"type":{"text":"ALERT_ICON"}}},{"kind":"method","name":"_handleSlotChange","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"close","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_renderCloseButton","privacy":"private","return":{"type":{"text":"TemplateResult | typeof nothing"}}},{"kind":"method","name":"focus","privacy":"public","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"FocusMixin","module":"src/utils/mixins/focus.ts"}}],"events":[{"name":"pharos-alert-closed","type":{"text":"CustomEvent"},"description":"Fires when the alert has closed"}],"attributes":[{"name":"status","type":{"text":"AlertStatus"},"description":"The status to reflect to the user","fieldName":"status","attribute":"status"},{"name":"closable","type":{"text":"boolean"},"default":"false","description":"Indicates if the alert is closable","fieldName":"closable","attribute":"closable"}],"mixins":[{"name":"ScopedRegistryMixin","module":"/src/utils/mixins/scoped-registry"},{"name":"FocusMixin","module":"/src/utils/mixins/focus"}],"superclass":{"name":"PharosElement","module":"/src/components/base/pharos-element"},"tagName":"pharos-alert","customElement":true}],"exports":[{"kind":"js","name":"PharosAlert","declaration":{"name":"PharosAlert","module":"src/components/alert/pharos-alert.ts"}}]},{"kind":"javascript-module","path":"src/components/alert/storyArgs.ts","declarations":[{"kind":"variable","name":"argTypes","type":{"text":"object"},"default":"{\\n  status: {\\n    options: [\'info\', \'success\', \'warning\', \'error\'],\\n    control: { type: \'inline-radio\' },\\n  },\\n}"},{"kind":"variable","name":"defaultArgs","type":{"text":"object"},"default":"{\\n  status: \'base\',\\n  text: \'I am an alert.\',\\n  closable: false,\\n}"}],"exports":[{"kind":"js","name":"argTypes","declaration":{"name":"argTypes","module":"src/components/alert/storyArgs.ts"}},{"kind":"js","name":"defaultArgs","declaration":{"name":"defaultArgs","module":"src/components/alert/storyArgs.ts"}}]},{"kind":"javascript-module","path":"src/components/base/anchor-element.ts","declarations":[{"kind":"class","description":"The base anchor element class to house shared properties, styles, and methods.","name":"AnchorElement","members":[{"kind":"field","name":"download","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates to save the linked URL instead of navigating to it.","attribute":"download","reflects":true,"optional":true},{"kind":"field","name":"href","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the URL that the hyperlink points to.","attribute":"href","reflects":true,"optional":true},{"kind":"field","name":"hreflang","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the language of the linked URL.","attribute":"hreflang","reflects":true,"optional":true},{"kind":"field","name":"ping","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the URLs to ping.","attribute":"ping","reflects":true,"optional":true},{"kind":"field","name":"rel","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the type of link.","attribute":"rel","reflects":true,"optional":true},{"kind":"field","name":"target","type":{"text":"LinkTarget | undefined"},"privacy":"public","description":"Indicates where to display the linked URL.","attribute":"target","reflects":true,"optional":true}],"attributes":[{"name":"download","type":{"text":"string | undefined"},"description":"Indicates to save the linked URL instead of navigating to it.","fieldName":"download","attribute":"download"},{"name":"href","type":{"text":"string | undefined"},"description":"Indicates the URL that the hyperlink points to.","fieldName":"href","attribute":"href"},{"name":"hreflang","type":{"text":"string | undefined"},"description":"Indicates the language of the linked URL.","fieldName":"hreflang","attribute":"hreflang"},{"name":"ping","type":{"text":"string | undefined"},"description":"Indicates the URLs to ping.","fieldName":"ping","attribute":"ping"},{"name":"rel","type":{"text":"string | undefined"},"description":"Indicates the type of link.","fieldName":"rel","attribute":"rel"},{"name":"target","type":{"text":"LinkTarget | undefined"},"description":"Indicates where to display the linked URL.","fieldName":"target","attribute":"target"}],"superclass":{"name":"PharosElement","module":"/src/components/base/pharos-element"}}],"exports":[{"kind":"js","name":"AnchorElement","declaration":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}}]},{"kind":"javascript-module","path":"src/components/base/form-element.ts","declarations":[{"kind":"class","description":"The base form element class to house shared properties, styles, and methods.","name":"FormElement","cssProperties":[{"type":{"text":"Color"},"description":"Form element font color.","name":"--pharos-form-element-color-text-base"},{"type":{"text":"Color"},"description":"Required indicator color.","name":"--pharos-form-element-color-text-required"},{"type":{"text":"Color"},"description":"Invalidated form element text color.","name":"--pharos-form-element-color-text-invalid"},{"type":{"text":"Color"},"description":"Background color when form element is disabled.","name":"--pharos-form-element-color-background-disabled"},{"type":{"text":"Color"},"description":"Form element border color.","name":"--pharos-form-element-color-border-base"},{"type":{"text":"Color"},"description":"Focused form element border color.","name":"--pharos-form-element-color-border-focus"},{"type":{"text":"Color"},"description":"Invalidated form element border color.","name":"--pharos-form-element-color-border-invalid"}],"members":[{"kind":"field","name":"name","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"Name for the form element.","attribute":"name","reflects":true},{"kind":"field","name":"required","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if input is required.","attribute":"required","reflects":true},{"kind":"field","name":"disabled","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if input is disabled.","attribute":"disabled","reflects":true},{"kind":"field","name":"invalidated","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates an invalidated state.","attribute":"invalidated","reflects":true},{"kind":"field","name":"validated","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates a validated state.","attribute":"validated","reflects":true},{"kind":"field","name":"message","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"The message to display below the input.","attribute":"message","reflects":true},{"kind":"field","name":"hideLabel","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the label should be hidden.","attribute":"hide-label","reflects":true},{"kind":"field","name":"requiredIndicator","type":{"text":"TemplateResult | typeof nothing"},"privacy":"protected","readonly":true},{"kind":"field","name":"messageContent","type":{"text":"TemplateResult | typeof nothing"},"privacy":"protected","readonly":true},{"kind":"field","name":"messageId","type":{"text":"string | undefined"},"privacy":"protected","readonly":true},{"kind":"method","name":"focus","privacy":"public","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"FocusMixin","module":"src/utils/mixins/focus.ts"}}],"attributes":[{"name":"name","type":{"text":"string"},"default":"\'\'","description":"Name for the form element.","fieldName":"name","attribute":"name"},{"name":"required","type":{"text":"boolean"},"default":"false","description":"Indicates if input is required.","fieldName":"required","attribute":"required"},{"name":"disabled","type":{"text":"boolean"},"default":"false","description":"Indicates if input is disabled.","fieldName":"disabled","attribute":"disabled"},{"name":"invalidated","type":{"text":"boolean"},"default":"false","description":"Indicates an invalidated state.","fieldName":"invalidated","attribute":"invalidated"},{"name":"validated","type":{"text":"boolean"},"default":"false","description":"Indicates a validated state.","fieldName":"validated","attribute":"validated"},{"name":"message","type":{"text":"string"},"default":"\'\'","description":"The message to display below the input.","fieldName":"message","attribute":"message"},{"name":"hide-label","type":{"text":"boolean"},"default":"false","description":"Indicates if the label should be hidden.","fieldName":"hideLabel","attribute":"hide-label"}],"mixins":[{"name":"FocusMixin","module":"/src/utils/mixins/focus"}],"superclass":{"name":"PharosElement","module":"/src/components/base/pharos-element"}}],"exports":[{"kind":"js","name":"FormElement","declaration":{"name":"FormElement","module":"src/components/base/form-element.ts"}}]},{"kind":"javascript-module","path":"src/components/base/overlay-element.ts","declarations":[{"kind":"variable","name":"allStrategies","default":"[\'absolute\', \'fixed\']"},{"kind":"variable","name":"allPlacements","default":"SIDES.reduce(\\n  (acc: Placement[], side) =>\\n    acc.concat(side, `${side}-start` as AlignedPlacement, `${side}-end` as AlignedPlacement),\\n  []\\n)"},{"kind":"class","description":"The base overlay element class to house shared properties, styles, and methods.","name":"OverlayElement","members":[{"kind":"field","name":"open","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the overlay is open.","attribute":"open","reflects":true},{"kind":"field","name":"placement","type":{"text":"Placement | \'auto\'"},"privacy":"public","default":"\'top\'","description":"Describes the preferred placement of the overlay.","attribute":"placement","reflects":true},{"kind":"field","name":"fallbackPlacements","type":{"text":"(Placement | \'auto\')[] | undefined"},"privacy":"public","description":"List of placements to try in the order provided when no space is available for the preferred placement.","optional":true},{"kind":"field","name":"strategy","type":{"text":"PositioningStrategy"},"privacy":"public","default":"\'absolute\'","description":"Describes the positioning strategy to use. If your target element is in a fixed container, use the fixed strategy.","attribute":"strategy","reflects":true},{"kind":"field","name":"_filteredFallbackPlacements","type":{"text":"Placement[] | undefined"},"privacy":"protected","optional":true}],"attributes":[{"name":"open","type":{"text":"boolean"},"default":"false","description":"Indicates if the overlay is open.","fieldName":"open","attribute":"open"},{"name":"placement","type":{"text":"Placement | \'auto\'"},"default":"\'top\'","description":"Describes the preferred placement of the overlay.","fieldName":"placement","attribute":"placement"},{"name":"strategy","type":{"text":"PositioningStrategy"},"default":"\'absolute\'","description":"Describes the positioning strategy to use. If your target element is in a fixed container, use the fixed strategy.","fieldName":"strategy","attribute":"strategy"}],"superclass":{"name":"PharosElement","module":"/src/components/base/pharos-element"}}],"exports":[{"kind":"js","name":"arrow","declaration":{"name":"arrow","package":"@floating-ui/dom"}},{"kind":"js","name":"autoUpdate","declaration":{"name":"autoUpdate","package":"@floating-ui/dom"}},{"kind":"js","name":"computePosition","declaration":{"name":"computePosition","package":"@floating-ui/dom"}},{"kind":"js","name":"flip","declaration":{"name":"flip","package":"@floating-ui/dom"}},{"kind":"js","name":"offset","declaration":{"name":"offset","package":"@floating-ui/dom"}},{"kind":"js","name":"shift","declaration":{"name":"shift","package":"@floating-ui/dom"}},{"kind":"js","name":"Placement","declaration":{"name":"Placement","module":"src/components/base/overlay-element.ts"}},{"kind":"js","name":"PositioningStrategy","declaration":{"name":"PositioningStrategy","module":"src/components/base/overlay-element.ts"}},{"kind":"js","name":"Side","declaration":{"name":"Side","module":"src/components/base/overlay-element.ts"}},{"kind":"js","name":"allStrategies","declaration":{"name":"allStrategies","module":"src/components/base/overlay-element.ts"}},{"kind":"js","name":"allPlacements","declaration":{"name":"allPlacements","module":"src/components/base/overlay-element.ts"}},{"kind":"js","name":"OverlayElement","declaration":{"name":"OverlayElement","module":"src/components/base/overlay-element.ts"}}]},{"kind":"javascript-module","path":"src/components/base/pharos-element.ts","declarations":[{"kind":"class","description":"","name":"PharosElement","superclass":{"name":"LitElement","package":"lit"},"customElement":true}],"exports":[{"kind":"js","name":"PharosElement","declaration":{"name":"PharosElement","module":"src/components/base/pharos-element.ts"}}]},{"kind":"javascript-module","path":"src/components/base/side-element.ts","declarations":[{"kind":"class","description":"The base side element class to house shared properties, styles, and methods.","name":"SideElement","members":[],"superclass":{"name":"PharosElement","module":"/src/components/base/pharos-element"}}],"exports":[{"kind":"js","name":"SideElement","declaration":{"name":"SideElement","module":"src/components/base/side-element.ts"}}]},{"kind":"javascript-module","path":"src/components/breadcrumb/pharos-breadcrumb-item.ts","declarations":[{"kind":"class","description":"Pharos breadcrumb item component - Used in tandem with pharos-breadcrumb to\\ncreate a navigation element which will allow users to visit higher hierarchal\\ncontent. This component is the \\"content\\" for breadcrumbs, which handles the\\ntext and tooltip (if the text is truncated) logic and styling.","name":"PharosBreadcrumbItem","slots":[{"description":"Contains the links and text to convert into breadcrumbs","name":""}],"members":[{"kind":"field","name":"elementDefinitions","type":{"text":"object"},"static":true,"default":"{\\n    \'pharos-tooltip\': PharosTooltip,\\n    \'pharos-link\': PharosLink,\\n  }"},{"kind":"field","name":"_isTruncated","type":{"text":"boolean"},"privacy":"private","default":"false"},{"kind":"field","name":"_displayText","type":{"text":"string"},"privacy":"private","default":"\'\'"},{"kind":"field","name":"_fullText","type":{"text":"string"},"privacy":"private","default":"\'\'"},{"kind":"field","name":"_last","type":{"text":"boolean"},"privacy":"private","default":"false"},{"kind":"field","name":"_contentObserver","type":{"text":"MutationObserver"},"privacy":"private","default":"new MutationObserver(() => {\\n    this._setItem();\\n  })"},{"kind":"field","name":"content","type":{"text":"HTMLElement | Text"},"privacy":"protected","readonly":true},{"kind":"method","name":"_setItem","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"focus","privacy":"public","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"FocusMixin","module":"src/utils/mixins/focus.ts"}},{"kind":"field","name":"download","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates to save the linked URL instead of navigating to it.","attribute":"download","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"href","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the URL that the hyperlink points to.","attribute":"href","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"hreflang","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the language of the linked URL.","attribute":"hreflang","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"ping","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the URLs to ping.","attribute":"ping","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"rel","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the type of link.","attribute":"rel","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"target","type":{"text":"LinkTarget | undefined"},"privacy":"public","description":"Indicates where to display the linked URL.","attribute":"target","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}}],"mixins":[{"name":"ScopedRegistryMixin","module":"/src/utils/mixins/scoped-registry"},{"name":"FocusMixin","module":"/src/utils/mixins/focus"}],"superclass":{"name":"AnchorElement","module":"/src/components/base/anchor-element"},"tagName":"pharos-breadcrumb-item","customElement":true,"attributes":[{"name":"download","type":{"text":"string | undefined"},"description":"Indicates to save the linked URL instead of navigating to it.","fieldName":"download","attribute":"download","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"href","type":{"text":"string | undefined"},"description":"Indicates the URL that the hyperlink points to.","fieldName":"href","attribute":"href","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"hreflang","type":{"text":"string | undefined"},"description":"Indicates the language of the linked URL.","fieldName":"hreflang","attribute":"hreflang","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"ping","type":{"text":"string | undefined"},"description":"Indicates the URLs to ping.","fieldName":"ping","attribute":"ping","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"rel","type":{"text":"string | undefined"},"description":"Indicates the type of link.","fieldName":"rel","attribute":"rel","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"target","type":{"text":"LinkTarget | undefined"},"description":"Indicates where to display the linked URL.","fieldName":"target","attribute":"target","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}}]}],"exports":[{"kind":"js","name":"LinkTarget","declaration":{"name":"LinkTarget","module":"src/components/breadcrumb/pharos-breadcrumb-item.ts"}},{"kind":"js","name":"PharosBreadcrumbItem","declaration":{"name":"PharosBreadcrumbItem","module":"src/components/breadcrumb/pharos-breadcrumb-item.ts"}}]},{"kind":"javascript-module","path":"src/components/breadcrumb/pharos-breadcrumb.ts","declarations":[{"kind":"class","description":"Pharos breadcrumb component - Used in tandem with pharos-breadcrumb-item to\\ncreate a navigation element which will allow users to visit higher hierarchal\\ncontent. This component is the \\"container\\" for pharos-breadcrumb-item\\ncomponent, which handles mainly the layout of the breadcrumb.\\n\\ni.e. Language / Characters / Letters / Letter A","name":"PharosBreadcrumb","slots":[{"description":"Contains pharos-breadcrumb-items","name":""}],"members":[{"kind":"field","name":"_allBreadcrumbItems","type":{"text":"NodeListOf<PharosBreadcrumbItem>"},"privacy":"private"},{"kind":"method","name":"_handleSlotchange","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"focus","privacy":"public","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"FocusMixin","module":"src/utils/mixins/focus.ts"}}],"mixins":[{"name":"FocusMixin","module":"/src/utils/mixins/focus"}],"superclass":{"name":"PharosElement","module":"/src/components/base/pharos-element"},"tagName":"pharos-breadcrumb","customElement":true}],"exports":[{"kind":"js","name":"PharosBreadcrumb","declaration":{"name":"PharosBreadcrumb","module":"src/components/breadcrumb/pharos-breadcrumb.ts"}}]},{"kind":"javascript-module","path":"src/components/button/pharos-button.ts","declarations":[{"kind":"class","description":"Pharos button component.","name":"PharosButton","slots":[{"description":"Contains the content of the button (the default slot).","name":""}],"members":[{"kind":"field","name":"elementDefinitions","type":{"text":"object"},"static":true,"default":"{\\n    \'pharos-icon\': PharosIcon,\\n  }"},{"kind":"field","name":"autofocus","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates that the button should have input focus when the page loads.","attribute":"autofocus","reflects":true},{"kind":"field","name":"disabled","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates that the button cannot be pressed or focused by the user.","attribute":"disabled","reflects":true},{"kind":"field","name":"type","type":{"text":"ButtonType | undefined"},"privacy":"public","description":"Indicates the default behavior of the button via the HTML5 attribute.","attribute":"type","reflects":true,"optional":true},{"kind":"field","name":"variant","type":{"text":"ButtonVariant"},"privacy":"public","default":"\'primary\'","description":"Indicates the variant of button.","attribute":"variant","reflects":true},{"kind":"field","name":"icon","type":{"text":"IconName | undefined"},"privacy":"public","description":"The icon to be shown as the content of the button.","attribute":"icon","reflects":true,"optional":true},{"kind":"field","name":"iconCondensed","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Applies only to icon-only buttons. If true, the button will have minimal padding.","attribute":"icon-condensed","reflects":true},{"kind":"field","name":"iconRight","type":{"text":"IconName | undefined"},"privacy":"public","description":"The icon to be shown on the right side.","attribute":"icon-right","reflects":true,"optional":true},{"kind":"field","name":"iconLeft","type":{"text":"IconName | undefined"},"privacy":"public","description":"The icon to be shown on the left side.","attribute":"icon-left","reflects":true,"optional":true},{"kind":"field","name":"onBackground","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates the button is on a AA compliant background.","attribute":"on-background","reflects":true},{"kind":"field","name":"large","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates the button has more padding.","attribute":"large","reflects":true},{"kind":"field","name":"label","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the aria label to apply to the button.","attribute":"label","reflects":true,"optional":true},{"kind":"field","name":"fullWidth","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates the button\'s width should match its container.","attribute":"full-width","reflects":true},{"kind":"field","name":"name","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the name when submitted with form data.","attribute":"name","reflects":true,"optional":true},{"kind":"field","name":"value","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the value associated with the name when submitted with form data.","attribute":"value","reflects":true,"optional":true},{"kind":"field","name":"pressed","type":{"text":"PressedState"},"privacy":"public","default":"\'undefined\'","description":"Indicates this button is a toggle button and whether it is pressed or not.","attribute":"pressed","reflects":true},{"kind":"field","name":"_button","type":{"text":"HTMLButtonElement | HTMLAnchorElement"},"privacy":"private"},{"kind":"field","name":"_formButton","type":{"text":"HTMLButtonElement"},"privacy":"private"},{"kind":"field","name":"_form","type":{"text":"HTMLFormElement | null"},"privacy":"private"},{"kind":"method","name":"_handleKeyup","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"KeyboardEvent"}}]},{"kind":"method","name":"_handleClick","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"MouseEvent"}}]},{"kind":"method","name":"_stopClickLeak","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"MouseEvent"}}]},{"kind":"method","name":"_renderIcon","privacy":"private","return":{"type":{"text":"TemplateResult | typeof nothing"}},"parameters":[{"name":"direction","default":"\'\'"}]},{"kind":"field","name":"buttonContent","type":{"text":"TemplateResult"},"privacy":"protected","readonly":true},{"kind":"method","name":"focus","privacy":"public","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"FocusMixin","module":"src/utils/mixins/focus.ts"}},{"kind":"field","name":"download","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates to save the linked URL instead of navigating to it.","attribute":"download","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"href","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the URL that the hyperlink points to.","attribute":"href","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"hreflang","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the language of the linked URL.","attribute":"hreflang","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"ping","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the URLs to ping.","attribute":"ping","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"rel","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the type of link.","attribute":"rel","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"target","type":{"text":"LinkTarget | undefined"},"privacy":"public","description":"Indicates where to display the linked URL.","attribute":"target","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}}],"attributes":[{"name":"autofocus","type":{"text":"boolean"},"default":"false","description":"Indicates that the button should have input focus when the page loads.","fieldName":"autofocus","attribute":"autofocus"},{"name":"disabled","type":{"text":"boolean"},"default":"false","description":"Indicates that the button cannot be pressed or focused by the user.","fieldName":"disabled","attribute":"disabled"},{"name":"type","type":{"text":"ButtonType | undefined"},"description":"Indicates the default behavior of the button via the HTML5 attribute.","fieldName":"type","attribute":"type"},{"name":"variant","type":{"text":"ButtonVariant"},"default":"\'primary\'","description":"Indicates the variant of button.","fieldName":"variant","attribute":"variant"},{"name":"icon","type":{"text":"IconName | undefined"},"description":"The icon to be shown as the content of the button.","fieldName":"icon","attribute":"icon"},{"name":"icon-condensed","type":{"text":"boolean"},"default":"false","description":"Applies only to icon-only buttons. If true, the button will have minimal padding.","fieldName":"iconCondensed","attribute":"icon-condensed"},{"name":"icon-right","type":{"text":"IconName | undefined"},"description":"The icon to be shown on the right side.","fieldName":"iconRight","attribute":"icon-right"},{"name":"icon-left","type":{"text":"IconName | undefined"},"description":"The icon to be shown on the left side.","fieldName":"iconLeft","attribute":"icon-left"},{"name":"on-background","type":{"text":"boolean"},"default":"false","description":"Indicates the button is on a AA compliant background.","fieldName":"onBackground","attribute":"on-background"},{"name":"large","type":{"text":"boolean"},"default":"false","description":"Indicates the button has more padding.","fieldName":"large","attribute":"large"},{"name":"label","type":{"text":"string | undefined"},"description":"Indicates the aria label to apply to the button.","fieldName":"label","attribute":"label"},{"name":"full-width","type":{"text":"boolean"},"default":"false","description":"Indicates the button\'s width should match its container.","fieldName":"fullWidth","attribute":"full-width"},{"name":"name","type":{"text":"string | undefined"},"description":"Indicates the name when submitted with form data.","fieldName":"name","attribute":"name"},{"name":"value","type":{"text":"string | undefined"},"description":"Indicates the value associated with the name when submitted with form data.","fieldName":"value","default":"\'undefined\'","attribute":"value"},{"name":"pressed","type":{"text":"PressedState"},"default":"\'undefined\'","description":"Indicates this button is a toggle button and whether it is pressed or not.","attribute":"value","fieldName":"pressed"},{"name":"download","type":{"text":"string | undefined"},"description":"Indicates to save the linked URL instead of navigating to it.","fieldName":"download","attribute":"download","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"href","type":{"text":"string | undefined"},"description":"Indicates the URL that the hyperlink points to.","fieldName":"href","attribute":"href","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"hreflang","type":{"text":"string | undefined"},"description":"Indicates the language of the linked URL.","fieldName":"hreflang","attribute":"hreflang","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"ping","type":{"text":"string | undefined"},"description":"Indicates the URLs to ping.","fieldName":"ping","attribute":"ping","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"rel","type":{"text":"string | undefined"},"description":"Indicates the type of link.","fieldName":"rel","attribute":"rel","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"target","type":{"text":"LinkTarget | undefined"},"description":"Indicates where to display the linked URL.","fieldName":"target","attribute":"target","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}}],"mixins":[{"name":"ScopedRegistryMixin","module":"/src/utils/mixins/scoped-registry"},{"name":"FocusMixin","module":"/src/utils/mixins/focus"}],"superclass":{"name":"AnchorElement","module":"/src/components/base/anchor-element"},"tagName":"pharos-button","customElement":true}],"exports":[{"kind":"js","name":"LinkTarget","declaration":{"name":"LinkTarget","module":"src/components/button/pharos-button.ts"}},{"kind":"js","name":"IconName","declaration":{"name":"IconName","module":"src/components/button/pharos-button.ts"}},{"kind":"js","name":"PharosButton","declaration":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}}]},{"kind":"javascript-module","path":"src/components/button/storyArgs.ts","declarations":[{"kind":"variable","name":"argTypes","type":{"text":"object"},"default":"{\\n  icon: {\\n    options: iconNames,\\n    control: { type: \'select\' },\\n  },\\n  iconLeft: {\\n    options: iconNames,\\n    control: { type: \'select\' },\\n  },\\n  iconRight: {\\n    options: iconNames,\\n    control: { type: \'select\' },\\n  },\\n  pressed: {\\n    options: [\'false\', \'true\', \'mixed\', \'undefined\'],\\n    control: { type: \'inline-radio\' },\\n  },\\n  type: {\\n    options: [\'button\', \'submit\', \'reset\'],\\n    control: { type: \'inline-radio\' },\\n  },\\n  variant: {\\n    options: [\'primary\', \'secondary\', \'subtle\', \'overlay\'],\\n    control: { type: \'inline-radio\' },\\n  },\\n}"},{"kind":"variable","name":"defaultArgs","type":{"text":"object"},"default":"{\\n  // Story\\n  text: \'I am a button\',\\n  // Props\\n  autofocus: false,\\n  disabled: false,\\n  fullWidth: false,\\n  iconCondensed: false,\\n  large: false,\\n  onBackground: false,\\n  pressed: \'undefined\',\\n  type: \'button\',\\n  variant: \'primary\',\\n}"}],"exports":[{"kind":"js","name":"argTypes","declaration":{"name":"argTypes","module":"src/components/button/storyArgs.ts"}},{"kind":"js","name":"defaultArgs","declaration":{"name":"defaultArgs","module":"src/components/button/storyArgs.ts"}}]},{"kind":"javascript-module","path":"src/components/checkbox/pharos-checkbox.ts","declarations":[{"kind":"class","description":"Pharos checkbox component.","name":"PharosCheckbox","slots":[{"description":"Contains the label content.","name":"label"},{"description":"Contains message content to show below the input.","name":"message"}],"members":[{"kind":"field","name":"checked","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if checkbox is checked.","attribute":"checked","reflects":true},{"kind":"field","name":"indeterminate","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if checkbox is indeterminate.","attribute":"indeterminate","reflects":true},{"kind":"field","name":"value","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"Indicates the value for the input.","attribute":"value","reflects":true},{"kind":"field","name":"onBackground","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates the checkbox is displayed on a dark background.","attribute":"onBackground","reflects":true},{"kind":"field","name":"_checkbox","type":{"text":"HTMLInputElement"},"privacy":"private"},{"kind":"method","name":"onChange","privacy":"public","return":{"type":{"text":"void"}}},{"kind":"method","name":"_handleFormdata","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"CustomEvent"}}],"description":"Handles the `formdata` event.","inheritedFrom":{"name":"FormMixin","module":"src/utils/mixins/form.ts"}},{"kind":"method","name":"_handleFormReset","return":{"type":{"text":"void"}},"description":"Handles the `reset` event.","inheritedFrom":{"name":"FormMixin","module":"src/utils/mixins/form.ts"}},{"kind":"method","name":"_handleClick","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"Event"}}]},{"kind":"method","name":"_renderPath","privacy":"private","return":{"type":{"text":"string"}}},{"kind":"method","name":"_handleMousedown","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"MouseEvent"}}]},{"kind":"field","name":"name","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"Name for the form element.","attribute":"name","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"required","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if input is required.","attribute":"required","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"disabled","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if input is disabled.","attribute":"disabled","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"invalidated","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates an invalidated state.","attribute":"invalidated","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"validated","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates a validated state.","attribute":"validated","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"message","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"The message to display below the input.","attribute":"message","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"hideLabel","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the label should be hidden.","attribute":"hide-label","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"requiredIndicator","type":{"text":"TemplateResult | typeof nothing"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"messageContent","type":{"text":"TemplateResult | typeof nothing"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"messageId","type":{"text":"string | undefined"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"method","name":"focus","privacy":"public","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"FocusMixin","module":"src/utils/mixins/focus.ts"}}],"events":[{"name":"change","type":{"text":"CustomEvent"},"description":"Fires when the value has changed"}],"attributes":[{"name":"checked","type":{"text":"boolean"},"default":"false","description":"Indicates if checkbox is checked.","fieldName":"checked","attribute":"checked"},{"name":"indeterminate","type":{"text":"boolean"},"default":"false","description":"Indicates if checkbox is indeterminate.","fieldName":"indeterminate","attribute":"indeterminate"},{"name":"value","type":{"text":"string"},"default":"\'\'","description":"Indicates the value for the input.","fieldName":"value","attribute":"value"},{"name":"on-background","type":{"text":"boolean"},"default":"false","description":"Indicates the checkbox is displayed on a dark background.","fieldName":"onBackground"},{"name":"onBackground","type":{"text":"boolean"},"default":"false","description":"Indicates the checkbox is displayed on a dark background.","attribute":"on-background","fieldName":"onBackground"},{"name":"name","type":{"text":"string"},"default":"\'\'","description":"Name for the form element.","fieldName":"name","attribute":"name","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"required","type":{"text":"boolean"},"default":"false","description":"Indicates if input is required.","fieldName":"required","attribute":"required","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"disabled","type":{"text":"boolean"},"default":"false","description":"Indicates if input is disabled.","fieldName":"disabled","attribute":"disabled","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"invalidated","type":{"text":"boolean"},"default":"false","description":"Indicates an invalidated state.","fieldName":"invalidated","attribute":"invalidated","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"validated","type":{"text":"boolean"},"default":"false","description":"Indicates a validated state.","fieldName":"validated","attribute":"validated","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"message","type":{"text":"string"},"default":"\'\'","description":"The message to display below the input.","fieldName":"message","attribute":"message","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"hide-label","type":{"text":"boolean"},"default":"false","description":"Indicates if the label should be hidden.","fieldName":"hideLabel","attribute":"hide-label","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}}],"mixins":[{"name":"FormMixin","module":"/src/utils/mixins/form"}],"superclass":{"name":"FormElement","module":"/src/components/base/form-element"},"tagName":"pharos-checkbox","customElement":true}],"exports":[{"kind":"js","name":"PharosCheckbox","declaration":{"name":"PharosCheckbox","module":"src/components/checkbox/pharos-checkbox.ts"}}]},{"kind":"javascript-module","path":"src/components/checkbox/storyArgs.ts","declarations":[{"kind":"variable","name":"defaultArgs","type":{"text":"object"},"default":"{\\n  checked: false,\\n  disabled: false,\\n  hideLabel: false,\\n  indeterminate: false,\\n  invalidated: false,\\n  label: \'I am a label\',\\n  message: \'\',\\n  name: \'\',\\n  onBackground: false,\\n  required: false,\\n  validated: false,\\n  value: \'\',\\n}"}],"exports":[{"kind":"js","name":"defaultArgs","declaration":{"name":"defaultArgs","module":"src/components/checkbox/storyArgs.ts"}}]},{"kind":"javascript-module","path":"src/components/checkbox-group/pharos-checkbox-group.ts","declarations":[{"kind":"class","description":"Pharos checkbox group component.","name":"PharosCheckboxGroup","slots":[{"description":"Contains the fieldset legend content.","name":"legend"},{"description":"Contains the set of checkboxes (the default slot).","name":""},{"description":"Contains message content to show below the group.","name":"message"}],"members":[{"kind":"field","name":"horizontal","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Dictate if checkboxes should be displayed horizontally","attribute":"horizontal","reflects":true},{"kind":"field","name":"value","type":{"text":"string[]"},"privacy":"public","description":"Indicates the selected checkboxes for the group","readonly":true},{"kind":"field","name":"_checkboxes","type":{"text":"NodeListOf<PharosCheckbox>"},"privacy":"private"},{"kind":"method","name":"_setBoxes","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"field","name":"name","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"Name for the form element.","attribute":"name","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"required","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if input is required.","attribute":"required","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"disabled","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if input is disabled.","attribute":"disabled","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"invalidated","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates an invalidated state.","attribute":"invalidated","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"validated","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates a validated state.","attribute":"validated","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"message","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"The message to display below the input.","attribute":"message","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"hideLabel","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the label should be hidden.","attribute":"hide-label","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"requiredIndicator","type":{"text":"TemplateResult | typeof nothing"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"messageContent","type":{"text":"TemplateResult | typeof nothing"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"messageId","type":{"text":"string | undefined"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"method","name":"focus","privacy":"public","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"FocusMixin","module":"src/utils/mixins/focus.ts"}}],"events":[{"name":"change","type":{"text":"Event"},"description":"Fires when the value has changed"}],"attributes":[{"name":"horizontal","type":{"text":"boolean"},"default":"false","description":"Dictate if checkboxes should be displayed horizontally","fieldName":"horizontal","attribute":"horizontal"},{"name":"name","type":{"text":"string"},"default":"\'\'","description":"Name for the form element.","fieldName":"name","attribute":"name","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"required","type":{"text":"boolean"},"default":"false","description":"Indicates if input is required.","fieldName":"required","attribute":"required","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"disabled","type":{"text":"boolean"},"default":"false","description":"Indicates if input is disabled.","fieldName":"disabled","attribute":"disabled","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"invalidated","type":{"text":"boolean"},"default":"false","description":"Indicates an invalidated state.","fieldName":"invalidated","attribute":"invalidated","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"validated","type":{"text":"boolean"},"default":"false","description":"Indicates a validated state.","fieldName":"validated","attribute":"validated","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"message","type":{"text":"string"},"default":"\'\'","description":"The message to display below the input.","fieldName":"message","attribute":"message","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"hide-label","type":{"text":"boolean"},"default":"false","description":"Indicates if the label should be hidden.","fieldName":"hideLabel","attribute":"hide-label","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}}],"superclass":{"name":"FormElement","module":"/src/components/base/form-element"},"tagName":"pharos-checkbox-group","customElement":true}],"exports":[{"kind":"js","name":"PharosCheckboxGroup","declaration":{"name":"PharosCheckboxGroup","module":"src/components/checkbox-group/pharos-checkbox-group.ts"}}]},{"kind":"javascript-module","path":"src/components/checkbox-group/storyArgs.ts","declarations":[{"kind":"variable","name":"defaultArgs","type":{"text":"object"},"default":"{\\n  disabled: false,\\n  hideLabel: false,\\n  horizontal: false,\\n  invalidated: false,\\n  message: \'\',\\n  required: false,\\n  validated: false,\\n}"}],"exports":[{"kind":"js","name":"defaultArgs","declaration":{"name":"defaultArgs","module":"src/components/checkbox-group/storyArgs.ts"}}]},{"kind":"javascript-module","path":"src/components/combobox/pharos-combobox.ts","declarations":[{"kind":"class","description":"Pharos combobox component.","name":"PharosCombobox","cssProperties":[{"type":{"text":"Color"},"description":"Hovered combobox option font color.","name":"--pharos-combobox-color-text-hover"},{"type":{"text":"Color"},"description":"Selected combobox option font color.","name":"--pharos-combobox-color-text-selected"},{"type":{"text":"Color"},"description":"Fill color for clear icon.","name":"--pharos-combobox-color-icon-clear"},{"type":{"text":"Color"},"description":"Fill color for dropdown icon.","name":"--pharos-combobox-color-icon-dropdown"},{"type":{"text":"Color"},"description":"Fill color for checkmark icon.","name":"--pharos-combobox-color-icon-checkmark"},{"type":{"text":"Color"},"description":"Fill color for focused icon.","name":"--pharos-combobox-color-icon-focus"},{"type":{"text":"Color"},"description":"Height of the dropdown list.","name":"--pharos-combobox-size-height-list"},{"type":{"text":"Color"},"description":"Height of the clear button.","name":"--pharos-combobox-size-height-clear"}],"slots":[{"description":"Contains the label content.","name":"label"},{"description":"Contains the available options for the combobox (the default slot).","name":""},{"description":"Contains message content to show below the input.","name":"message"}],"members":[{"kind":"field","name":"elementDefinitions","type":{"text":"object"},"static":true,"default":"{\\n    \'pharos-icon\': PharosIcon,\\n    \'pharos-tooltip\': PharosTooltip,\\n    \'pharos-button\': PharosButton,\\n  }"},{"kind":"field","name":"value","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"Indicates the value for the input.","attribute":"value","reflects":true},{"kind":"field","name":"placeholder","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"Display text when input is empty","attribute":"placeholder","reflects":true},{"kind":"field","name":"open","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the dropdown is open.","attribute":"open","reflects":true},{"kind":"field","name":"searchMode","type":{"text":"boolean"},"privacy":"public","default":"false","attribute":"search-mode","reflects":true},{"kind":"field","name":"options","type":{"text":"HTMLOptionElement[]"},"privacy":"public","description":"The list of options available in the combobox dropdown list","readonly":true},{"kind":"field","name":"selectedIndex","type":{"text":"number"},"privacy":"public","description":"The index of the selected option, if any","readonly":true},{"kind":"field","name":"_input","type":{"text":"HTMLInputElement"},"privacy":"private"},{"kind":"field","name":"_button","type":{"text":"HTMLButtonElement"},"privacy":"private"},{"kind":"field","name":"_displayValue","type":{"text":"string"},"privacy":"private","default":"\'\'"},{"kind":"field","name":"_noResults","type":{"text":"boolean"},"privacy":"private","default":"false"},{"kind":"field","name":"_query","type":{"text":"string"},"privacy":"private","default":"\'\'"},{"kind":"field","name":"_defaultValue","type":{"text":"string"},"privacy":"private","default":"\'\'"},{"kind":"field","name":"_childrenObserver","type":{"text":"MutationObserver"},"privacy":"private","default":"new MutationObserver(\\n    (mutationsList: MutationRecord[]) => {\\n      this.requestUpdate();\\n\\n      if (\\n        mutationsList.some((record) =>\\n          [...record.addedNodes].some((node) => node instanceof HTMLOptionElement)\\n        )\\n      ) {\\n        this._setDisplayValue();\\n      }\\n    }\\n  )"},{"kind":"method","name":"onChange","privacy":"public","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"Event"}}]},{"kind":"method","name":"onInput","privacy":"public","return":{"type":{"text":"void"}}},{"kind":"method","name":"_renderList","privacy":"private","return":{"type":{"text":"TemplateResult | typeof nothing"}}},{"kind":"method","name":"_renderClearButton","privacy":"private","return":{"type":{"text":"TemplateResult | typeof nothing"}}},{"kind":"method","name":"_renderIconButton","privacy":"private","return":{"type":{"text":"TemplateResult"}}},{"kind":"method","name":"_handleOptionClick","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"option","type":{"text":"HTMLOptionElement"}},{"name":"event","type":{"text":"Event"}}]},{"kind":"method","name":"_closeDropdown","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_handleButtonClick","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"MouseEvent"}}]},{"kind":"method","name":"_handleButtonBlur","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"FocusEvent"}}]},{"kind":"method","name":"_handleClearClick","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"MouseEvent"}}]},{"kind":"method","name":"_handleInputBlur","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"FocusEvent"}}]},{"kind":"method","name":"_handleInputKeydown","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"KeyboardEvent"}}]},{"kind":"method","name":"_handleNavigation","privacy":"private","return":{"type":{"text":"Promise<void>"}},"parameters":[{"name":"moveForward","type":{"text":"boolean"}}]},{"kind":"method","name":"_selectHighlightedOption","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"Event"}}]},{"kind":"method","name":"_handleInputClear","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"Event"}}]},{"kind":"method","name":"_handleFormdata","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"CustomEvent"}}],"description":"Handles the `formdata` event.","inheritedFrom":{"name":"FormMixin","module":"src/utils/mixins/form.ts"}},{"kind":"method","name":"_handleFormReset","return":{"type":{"text":"void"}},"description":"Handles the `reset` event.","inheritedFrom":{"name":"FormMixin","module":"src/utils/mixins/form.ts"}},{"kind":"method","name":"_setDisplayValue","privacy":"private","parameters":[{"name":"blurred","default":"false"}]},{"kind":"method","name":"_handleInputClick","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"field","name":"name","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"Name for the form element.","attribute":"name","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"required","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if input is required.","attribute":"required","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"disabled","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if input is disabled.","attribute":"disabled","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"invalidated","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates an invalidated state.","attribute":"invalidated","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"validated","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates a validated state.","attribute":"validated","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"message","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"The message to display below the input.","attribute":"message","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"hideLabel","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the label should be hidden.","attribute":"hide-label","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"requiredIndicator","type":{"text":"TemplateResult | typeof nothing"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"messageContent","type":{"text":"TemplateResult | typeof nothing"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"messageId","type":{"text":"string | undefined"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"method","name":"focus","privacy":"public","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"FocusMixin","module":"src/utils/mixins/focus.ts"}}],"events":[{"name":"change","type":{"text":"CustomEvent"},"description":"Fires when a selection has been made or cleared"},{"description":"Fires when the value has changed via user input","name":"input"}],"attributes":[{"name":"value","type":{"text":"string"},"default":"\'\'","description":"Indicates the value for the input.","fieldName":"value","attribute":"value"},{"name":"placeholder","type":{"text":"string"},"default":"\'\'","description":"Display text when input is empty","fieldName":"placeholder","attribute":"placeholder"},{"name":"open","type":{"text":"boolean"},"default":"false","description":"Indicates if the dropdown is open.","fieldName":"open","attribute":"open"},{"name":"search-mode","type":{"text":"boolean"},"default":"false","fieldName":"searchMode"},{"name":"name","type":{"text":"string"},"default":"\'\'","description":"Name for the form element.","fieldName":"name","attribute":"name","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"required","type":{"text":"boolean"},"default":"false","description":"Indicates if input is required.","fieldName":"required","attribute":"required","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"disabled","type":{"text":"boolean"},"default":"false","description":"Indicates if input is disabled.","fieldName":"disabled","attribute":"disabled","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"invalidated","type":{"text":"boolean"},"default":"false","description":"Indicates an invalidated state.","fieldName":"invalidated","attribute":"invalidated","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"validated","type":{"text":"boolean"},"default":"false","description":"Indicates a validated state.","fieldName":"validated","attribute":"validated","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"message","type":{"text":"string"},"default":"\'\'","description":"The message to display below the input.","fieldName":"message","attribute":"message","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"hide-label","type":{"text":"boolean"},"default":"false","description":"Indicates if the label should be hidden.","fieldName":"hideLabel","attribute":"hide-label","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}}],"mixins":[{"name":"ScopedRegistryMixin","module":"/src/utils/mixins/scoped-registry"},{"name":"FormMixin","module":"/src/utils/mixins/form"}],"superclass":{"name":"FormElement","module":"/src/components/base/form-element"},"tagName":"pharos-combobox","customElement":true}],"exports":[{"kind":"js","name":"PharosCombobox","declaration":{"name":"PharosCombobox","module":"src/components/combobox/pharos-combobox.ts"}}]},{"kind":"javascript-module","path":"src/components/combobox/storyArgs.ts","declarations":[{"kind":"variable","name":"defaultArgs","type":{"text":"object"},"default":"{\\n  disabled: false,\\n  hideLabel: false,\\n  invalidated: false,\\n  label: \'Combobox Label\',\\n  message: \'\',\\n  name: \'\',\\n  open: false,\\n  placeholder: \'\',\\n  required: false,\\n  validated: false,\\n  value: \'\',\\n}"}],"exports":[{"kind":"js","name":"defaultArgs","declaration":{"name":"defaultArgs","module":"src/components/combobox/storyArgs.ts"}}]},{"kind":"javascript-module","path":"src/components/dropdown-menu/pharos-dropdown-menu-item.ts","declarations":[{"kind":"class","description":"Pharos dropdown menu item component.","name":"PharosDropdownMenuItem","slots":[{"description":"Content that describes the item.","name":"description"},{"description":"Contains the content of dropdown item.","name":""}],"members":[{"kind":"field","name":"elementDefinitions","type":{"text":"object"},"static":true,"default":"{\\n    \'pharos-icon\': PharosIcon,\\n  }"},{"kind":"field","name":"icon","type":{"text":"IconName | undefined"},"privacy":"public","description":"The icon to be used for the item","attribute":"icon","reflects":true,"optional":true},{"kind":"field","name":"selected","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the item is currently selected.","attribute":"selected","reflects":true},{"kind":"field","name":"link","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"Indicates the target URL of the link. Setting this attribute renders the item as a link.","attribute":"link","reflects":true},{"kind":"field","name":"target","type":{"text":"\'_blank\' | \'_parent\' | \'_self\' | \'_top\'"},"privacy":"public","default":"\'_self\'","description":"Indicates where to display the linked URL.","attribute":"target","reflects":true},{"kind":"field","name":"rel","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the relationship of the resource to the current document.","attribute":"rel","reflects":true,"optional":true},{"kind":"field","name":"disabled","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the item is disabled.","attribute":"disabled","reflects":true},{"kind":"field","name":"_last","type":{"text":"boolean"},"privacy":"private","default":"false"},{"kind":"field","name":"_active","type":{"text":"boolean"},"privacy":"private","default":"false"},{"kind":"field","name":"_menu","type":{"text":"PharosDropdownMenu"},"privacy":"private"},{"kind":"method","name":"_handleClick","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"MouseEvent"}}]},{"kind":"method","name":"_handleMousedown","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"MouseEvent"}}]},{"kind":"method","name":"_handleMouseup","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_renderIcon","privacy":"private","return":{"type":{"text":"TemplateResult | typeof nothing"}}},{"kind":"method","name":"_renderCheckmark","privacy":"private","return":{"type":{"text":"TemplateResult | typeof nothing"}}},{"kind":"method","name":"_renderDescription","privacy":"private","return":{"type":{"text":"TemplateResult | typeof nothing"}}},{"kind":"field","name":"itemContent","type":{"text":"TemplateResult"},"privacy":"protected","readonly":true},{"kind":"method","name":"focus","privacy":"public","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"FocusMixin","module":"src/utils/mixins/focus.ts"}}],"attributes":[{"name":"icon","type":{"text":"IconName | undefined"},"description":"The icon to be used for the item","fieldName":"icon","attribute":"icon"},{"name":"selected","type":{"text":"boolean"},"default":"false","description":"Indicates if the item is currently selected.","fieldName":"selected","attribute":"selected"},{"name":"link","type":{"text":"string"},"default":"\'\'","description":"Indicates the target URL of the link. Setting this attribute renders the item as a link.","fieldName":"link","attribute":"link"},{"name":"target","type":{"text":"\'_blank\' | \'_parent\' | \'_self\' | \'_top\'"},"default":"\'_self\'","description":"Indicates where to display the linked URL.","fieldName":"target","attribute":"target"},{"name":"rel","type":{"text":"string | undefined"},"description":"Indicates the relationship of the resource to the current document.","fieldName":"rel","attribute":"rel"},{"name":"disabled","type":{"text":"boolean"},"default":"false","description":"Indicates if the item is disabled.","fieldName":"disabled","attribute":"disabled"}],"mixins":[{"name":"ScopedRegistryMixin","module":"/src/utils/mixins/scoped-registry"},{"name":"FocusMixin","module":"/src/utils/mixins/focus"}],"superclass":{"name":"PharosElement","module":"/src/components/base/pharos-element"},"tagName":"pharos-dropdown-menu-item","customElement":true}],"exports":[{"kind":"js","name":"IconName","declaration":{"name":"IconName","module":"src/components/dropdown-menu/pharos-dropdown-menu-item.ts"}},{"kind":"js","name":"PharosDropdownMenuItem","declaration":{"name":"PharosDropdownMenuItem","module":"src/components/dropdown-menu/pharos-dropdown-menu-item.ts"}}]},{"kind":"javascript-module","path":"src/components/dropdown-menu/pharos-dropdown-menu.ts","declarations":[{"kind":"class","description":"Pharos dropdown menu component.","name":"PharosDropdownMenu","slots":[{"description":"Contains the menu items.","name":""}],"members":[{"kind":"field","name":"elementDefinitions","type":{"text":"object"},"static":true,"default":"{\\n    \'focus-trap\': FocusTrap,\\n  }"},{"kind":"field","name":"showSelected","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the dropdown should display a checkmark on the selected item.","attribute":"show-selected","reflects":true},{"kind":"field","name":"fullWidth","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the menu width should equal its trigger\'s width.","attribute":"full-width","reflects":true},{"kind":"field","name":"_navMenu","type":{"text":"boolean"},"privacy":"private","default":"false"},{"kind":"field","name":"_menu","type":{"text":"HTMLUListElement"},"privacy":"private"},{"kind":"field","name":"_allMenuItems","type":{"text":"NodeListOf<PharosDropdownMenuItem>"},"privacy":"private"},{"kind":"field","name":"_activeMenuItems","type":{"text":"NodeListOf<PharosDropdownMenuItem>"},"privacy":"private"},{"kind":"field","name":"_targetWidth","type":{"text":"number"},"privacy":"private","default":"0"},{"kind":"field","name":"_triggers","type":{"text":"HTMLElement[]"},"privacy":"private"},{"kind":"field","name":"_currentTrigger","type":{"text":"Element | null"},"privacy":"private","default":"null"},{"kind":"field","name":"_hasHover","type":{"text":"boolean"},"privacy":"private","default":"false"},{"kind":"field","name":"_moveFocusToLast","type":{"text":"boolean"},"privacy":"private","default":"false"},{"kind":"field","name":"_enterByKey","type":{"text":"boolean"},"privacy":"private","default":"false"},{"kind":"field","name":"_cleanup","type":{"text":"{ (): void } | undefined"},"privacy":"private","default":"undefined","optional":true},{"kind":"field","name":"_observeResizeTrigger","type":{"text":"Handle | null"},"privacy":"private","default":"null"},{"kind":"field","name":"_resizeObserver","type":{"text":"ResizeObserver"},"privacy":"private","default":"new ResizeObserver((entries: ResizeObserverEntry[]) => {\\n    const { offsetWidth } = entries[0].target as HTMLElement;\\n    const borderLeft = parseInt(\\n      window.getComputedStyle(this._menu, null).getPropertyValue(\'border-left-width\'),\\n      10\\n    );\\n    const borderRight = parseInt(\\n      window.getComputedStyle(this._menu, null).getPropertyValue(\'border-right-width\'),\\n      10\\n    );\\n    this._targetWidth = offsetWidth - (borderLeft + borderRight);\\n  })"},{"kind":"method","name":"removeAllTriggers","privacy":"public","return":{"type":{"text":"void"}}},{"kind":"method","name":"openWithTrigger","privacy":"public","return":{"type":{"text":"Promise<void>"}},"parameters":[{"name":"trigger","type":{"text":"HTMLElement"}}]},{"kind":"method","name":"_emitVisibilityChange","privacy":"private"},{"kind":"method","name":"_removeTriggerListeners","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_dropdownId","privacy":"private","return":{"type":{"text":"string"}}},{"kind":"method","name":"_addTriggerListeners","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_addTriggerElement","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"trigger","type":{"text":"HTMLElement"}}]},{"kind":"method","name":"_setupTriggerElement","privacy":"private","parameters":[{"name":"trigger","type":{"text":"HTMLElement"}}]},{"kind":"method","name":"_setupMenu","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_handleTriggerClick","privacy":"private","return":{"type":{"text":"Promise<void>"}},"parameters":[{"name":"event","type":{"text":"MouseEvent"}}]},{"kind":"method","name":"_handleTriggerKeydown","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"KeyboardEvent"}}]},{"kind":"method","name":"_handleTriggerHover","privacy":"private","return":{"type":{"text":"Promise<void>"}},"parameters":[{"name":"event","type":{"text":"MouseEvent"}}]},{"kind":"method","name":"_handleKeydown","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"KeyboardEvent"}}]},{"kind":"method","name":"_handleClick","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"MouseEvent"}}]},{"kind":"method","name":"_setOpen","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_handleHover","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"MouseEvent"}}]},{"kind":"method","name":"_focusContents","privacy":"private","return":{"type":{"text":"Promise<void>"}}},{"kind":"method","name":"_focusFirstItem","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_focusLastItem","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_returnTriggerFocus","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_handleMenuClick","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"MouseEvent"}}]},{"kind":"method","name":"_handleItemClick","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"clickedItem","type":{"text":"PharosDropdownMenuItem"}}]},{"kind":"method","name":"_handleMenuKeydown","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"KeyboardEvent"}}]},{"kind":"method","name":"_handleNavigation","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"moveForward","type":{"text":"boolean"}}]},{"kind":"method","name":"_setupResizeObserver","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_releaseObserver","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_setHoverListeners","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_setTriggerAttributes","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_openMenu","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"Event"}}]},{"kind":"method","name":"_resetItemsState","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_hasItems","privacy":"private","return":{"type":{"text":"boolean"}}},{"kind":"method","name":"_handleSlotChange","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_renderSlot","privacy":"private","return":{"type":{"text":"TemplateResult"}}},{"kind":"method","name":"_renderList","privacy":"private","return":{"type":{"text":"TemplateResult"}}},{"kind":"field","name":"placement","type":{"text":"Placement | \'auto\'"},"privacy":"public","default":"\'bottom-end\'","description":"Describes the preferred placement of the overlay.","attribute":"placement","reflects":true,"inheritedFrom":{"name":"OverlayElement","module":"src/components/base/overlay-element.ts"}},{"kind":"method","name":"focus","privacy":"public","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"FocusMixin","module":"src/utils/mixins/focus.ts"}},{"kind":"field","name":"open","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the overlay is open.","attribute":"open","reflects":true,"inheritedFrom":{"name":"OverlayElement","module":"src/components/base/overlay-element.ts"}},{"kind":"field","name":"fallbackPlacements","type":{"text":"(Placement | \'auto\')[] | undefined"},"privacy":"public","description":"List of placements to try in the order provided when no space is available for the preferred placement.","optional":true,"inheritedFrom":{"name":"OverlayElement","module":"src/components/base/overlay-element.ts"}},{"kind":"field","name":"strategy","type":{"text":"PositioningStrategy"},"privacy":"public","default":"\'absolute\'","description":"Describes the positioning strategy to use. If your target element is in a fixed container, use the fixed strategy.","attribute":"strategy","reflects":true,"inheritedFrom":{"name":"OverlayElement","module":"src/components/base/overlay-element.ts"}},{"kind":"field","name":"_filteredFallbackPlacements","type":{"text":"Placement[] | undefined"},"privacy":"protected","optional":true,"inheritedFrom":{"name":"OverlayElement","module":"src/components/base/overlay-element.ts"}}],"events":[{"name":"pharos-dropdown-menu-opened","type":{"text":"CustomEvent"},"description":"Fires when the dropdown menu is opened"},{"name":"pharos-dropdown-menu-closed","type":{"text":"CustomEvent"},"description":"Fires when the dropdown menu is closed"},{"name":"pharos-dropdown-menu-select","type":{"text":"CustomEvent"},"description":"Fires when an item is about to be selected - cancelable"},{"name":"pharos-dropdown-menu-selected","type":{"text":"CustomEvent"},"description":"Fires when an item has been selected"}],"attributes":[{"name":"show-selected","type":{"text":"boolean"},"default":"false","description":"Indicates if the dropdown should display a checkmark on the selected item.","fieldName":"showSelected","attribute":"show-selected"},{"name":"full-width","type":{"text":"boolean"},"default":"false","description":"Indicates if the menu width should equal its trigger\'s width.","fieldName":"fullWidth","attribute":"full-width"},{"name":"open","type":{"text":"boolean"},"default":"false","description":"Indicates if the overlay is open.","fieldName":"open","attribute":"open","inheritedFrom":{"name":"OverlayElement","module":"src/components/base/overlay-element.ts"}},{"name":"placement","type":{"text":"Placement | \'auto\'"},"default":"\'top\'","description":"Describes the preferred placement of the overlay.","fieldName":"placement","attribute":"placement","inheritedFrom":{"name":"OverlayElement","module":"src/components/base/overlay-element.ts"}},{"name":"strategy","type":{"text":"PositioningStrategy"},"default":"\'absolute\'","description":"Describes the positioning strategy to use. If your target element is in a fixed container, use the fixed strategy.","fieldName":"strategy","attribute":"strategy","inheritedFrom":{"name":"OverlayElement","module":"src/components/base/overlay-element.ts"}}],"mixins":[{"name":"ScopedRegistryMixin","module":"/src/utils/mixins/scoped-registry"},{"name":"FocusMixin","module":"/src/utils/mixins/focus"}],"superclass":{"name":"OverlayElement","module":"/src/components/base/overlay-element"},"tagName":"pharos-dropdown-menu","customElement":true}],"exports":[{"kind":"js","name":"Placement","declaration":{"name":"Placement","module":"src/components/dropdown-menu/pharos-dropdown-menu.ts"}},{"kind":"js","name":"PositioningStrategy","declaration":{"name":"PositioningStrategy","module":"src/components/dropdown-menu/pharos-dropdown-menu.ts"}},{"kind":"js","name":"PharosDropdownMenu","declaration":{"name":"PharosDropdownMenu","module":"src/components/dropdown-menu/pharos-dropdown-menu.ts"}}]},{"kind":"javascript-module","path":"src/components/dropdown-menu/storyArgs.ts","declarations":[{"kind":"variable","name":"defaultArgs","type":{"text":"object"},"default":"{\\n  open: false,\\n  showSelected: false,\\n  fullWidth: false,\\n}"}],"exports":[{"kind":"js","name":"defaultArgs","declaration":{"name":"defaultArgs","module":"src/components/dropdown-menu/storyArgs.ts"}}]},{"kind":"javascript-module","path":"src/components/dropdown-menu-nav/pharos-dropdown-menu-nav-link.ts","declarations":[{"kind":"class","description":"Pharos dropdown menu nav link component.","name":"PharosDropdownMenuNavLink","slots":[{"description":"Contains the content of the link (the default slot).","name":""}],"members":[{"kind":"field","name":"elementDefinitions","type":{"text":"object"},"static":true,"default":"{\\n    \'pharos-icon\': PharosIcon,\\n  }"},{"kind":"field","name":"isActive","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates the link is active","attribute":"is-active","reflects":true},{"kind":"field","name":"appendContent","type":{"text":"TemplateResult | typeof nothing"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"kind":"field","name":"flex","type":{"text":"boolean"},"privacy":"public","default":"true","description":"Indicates if the link should display as a flex container.","attribute":"flex","reflects":true,"inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"kind":"field","name":"type","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the MIME type of the target.","attribute":"type","reflects":true,"optional":true,"inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"kind":"field","name":"subtle","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates the link should not have text decoration by default.","attribute":"subtle","reflects":true,"inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"kind":"field","name":"onBackground","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates the link is on a AA compliant background.","attribute":"on-background","reflects":true,"inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"kind":"field","name":"label","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the aria label to apply to the link.","attribute":"label","reflects":true,"optional":true,"inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"kind":"field","name":"bold","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the link should be bold.","attribute":"bold","reflects":true,"inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"kind":"field","name":"skip","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates the link is hidden until focused and skips to another element when clicked.","attribute":"skip","reflects":true,"inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"kind":"field","name":"noHover","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates the link should not have a hover state.","attribute":"no-hover","reflects":true,"inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"kind":"field","name":"indicateVisited","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the link should render the visited link styling.","attribute":"indicateVisited","reflects":true,"inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"kind":"field","name":"_alert","type":{"text":"boolean"},"privacy":"private","default":"false","inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"kind":"field","name":"_hover","type":{"text":"boolean"},"privacy":"private","default":"false","inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"kind":"method","name":"_handleClick","privacy":"private","return":{"type":{"text":"Promise<void>"}},"inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"kind":"method","name":"focus","privacy":"public","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"FocusMixin","module":"src/utils/mixins/focus.ts"}},{"kind":"field","name":"download","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates to save the linked URL instead of navigating to it.","attribute":"download","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"href","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the URL that the hyperlink points to.","attribute":"href","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"hreflang","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the language of the linked URL.","attribute":"hreflang","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"ping","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the URLs to ping.","attribute":"ping","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"rel","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the type of link.","attribute":"rel","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"target","type":{"text":"LinkTarget | undefined"},"privacy":"public","description":"Indicates where to display the linked URL.","attribute":"target","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}}],"attributes":[{"name":"is-active","type":{"text":"boolean"},"default":"false","description":"Indicates the link is active","fieldName":"isActive","attribute":"is-active"},{"name":"type","type":{"text":"string | undefined"},"description":"Indicates the MIME type of the target.","fieldName":"type","attribute":"type","inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"name":"subtle","type":{"text":"boolean"},"default":"false","description":"Indicates the link should not have text decoration by default.","fieldName":"subtle","attribute":"subtle","inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"name":"on-background","type":{"text":"boolean"},"default":"false","description":"Indicates the link is on a AA compliant background.","fieldName":"onBackground","attribute":"on-background","inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"name":"label","type":{"text":"string | undefined"},"description":"Indicates the aria label to apply to the link.","fieldName":"label","attribute":"label","inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"name":"bold","type":{"text":"boolean"},"default":"false","description":"Indicates if the link should be bold.","fieldName":"bold","attribute":"bold","inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"name":"flex","type":{"text":"boolean"},"default":"false","description":"Indicates if the link should display as a flex container.","fieldName":"flex","attribute":"flex","inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"name":"skip","type":{"text":"boolean"},"default":"false","description":"Indicates the link is hidden until focused and skips to another element when clicked.","fieldName":"skip","attribute":"skip","inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"name":"no-hover","type":{"text":"boolean"},"default":"false","description":"Indicates the link should not have a hover state.","fieldName":"noHover","attribute":"no-hover","inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"name":"indicate-visited","type":{"text":"boolean"},"default":"false","description":"Indicates if the link should render the visited link styling.","fieldName":"indicateVisited","inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"name":"indicateVisited","type":{"text":"boolean"},"default":"false","description":"Indicates if the link should render the visited link styling.","attribute":"indicate-visited","fieldName":"indicateVisited","inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"name":"download","type":{"text":"string | undefined"},"description":"Indicates to save the linked URL instead of navigating to it.","fieldName":"download","attribute":"download","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"href","type":{"text":"string | undefined"},"description":"Indicates the URL that the hyperlink points to.","fieldName":"href","attribute":"href","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"hreflang","type":{"text":"string | undefined"},"description":"Indicates the language of the linked URL.","fieldName":"hreflang","attribute":"hreflang","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"ping","type":{"text":"string | undefined"},"description":"Indicates the URLs to ping.","fieldName":"ping","attribute":"ping","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"rel","type":{"text":"string | undefined"},"description":"Indicates the type of link.","fieldName":"rel","attribute":"rel","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"target","type":{"text":"LinkTarget | undefined"},"description":"Indicates where to display the linked URL.","fieldName":"target","attribute":"target","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}}],"mixins":[{"name":"ScopedRegistryMixin","module":"/src/utils/mixins/scoped-registry"}],"superclass":{"name":"PharosLink","module":"/src/components/link/pharos-link"},"tagName":"pharos-dropdown-menu-nav-link","customElement":true}],"exports":[{"kind":"js","name":"LinkTarget","declaration":{"name":"LinkTarget","module":"src/components/dropdown-menu-nav/pharos-dropdown-menu-nav-link.ts"}},{"kind":"js","name":"PharosDropdownMenuNavLink","declaration":{"name":"PharosDropdownMenuNavLink","module":"src/components/dropdown-menu-nav/pharos-dropdown-menu-nav-link.ts"}}]},{"kind":"javascript-module","path":"src/components/dropdown-menu-nav/pharos-dropdown-menu-nav.ts","declarations":[{"kind":"class","description":"Pharos dropdown menu nav component.","name":"PharosDropdownMenuNav","slots":[{"description":"Contains the pharos-links and associated pharos-dropdown-menu.","name":""}],"members":[{"kind":"field","name":"label","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the aria label to apply to the nav.","attribute":"label","reflects":true,"optional":true},{"kind":"field","name":"_allLinks","type":{"text":"NodeListOf<PharosDropdownMenuNavLink>"},"privacy":"private"},{"kind":"field","name":"_allMenus","type":{"text":"NodeListOf<PharosDropdownMenu>"},"privacy":"private"},{"kind":"method","name":"_closeAllMenus","privacy":"private","parameters":[{"name":"link","default":"undefined","type":{"text":"PharosDropdownMenuNavLink | undefined"}}]},{"kind":"method","name":"_handleSlotChange","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"focus","privacy":"public","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"FocusMixin","module":"src/utils/mixins/focus.ts"}}],"attributes":[{"name":"label","type":{"text":"string | undefined"},"description":"Indicates the aria label to apply to the nav.","fieldName":"label","attribute":"label"}],"mixins":[{"name":"FocusMixin","module":"/src/utils/mixins/focus"}],"superclass":{"name":"PharosElement","module":"/src/components/base/pharos-element"},"tagName":"pharos-dropdown-menu-nav","customElement":true}],"exports":[{"kind":"js","name":"PharosDropdownMenuNav","declaration":{"name":"PharosDropdownMenuNav","module":"src/components/dropdown-menu-nav/pharos-dropdown-menu-nav.ts"}}]},{"kind":"javascript-module","path":"src/components/footer/pharos-footer.ts","declarations":[{"kind":"class","description":"Pharos footer component.","name":"PharosFooter","slots":[{"description":"One or more lists of links to show in the middle of the footer.","name":"links-group"},{"description":"List of button links to show in the middle of the footer.","name":"button-links"},{"description":"List of social media related links to show on the right side of the footer.","name":"social-links"},{"description":"Contains the content of the mission statement.","name":"mission-statement"},{"description":"Contains the content of the copyright statement.","name":"copyright-statement"},{"description":"List of legal related links to show on the bottom of the footer.","name":"legal-links"},{"description":"Contains the Google translate widget.","name":"google-widget"}],"members":[{"kind":"field","name":"elementDefinitions","type":{"text":"object"},"static":true,"default":"{\\n    \'pharos-heading\': PharosHeading,\\n  }"},{"kind":"field","name":"_widgetNodes","type":{"text":"NodeListOf<HTMLElement>"},"privacy":"private"},{"kind":"field","name":"_widgetObserver","type":{"text":"MutationObserver"},"privacy":"private","default":"new MutationObserver(\\n    (mutationsList: MutationRecord[]) => {\\n      const widgetContainer = mutationsList[0].addedNodes[0] as HTMLDivElement;\\n      const widgetButton = widgetContainer?.querySelector(\\n        \'.goog-te-gadget-simple\'\\n      ) as HTMLDivElement;\\n      const googleImg = widgetButton?.querySelector(\'.goog-te-gadget-icon\') as HTMLImageElement;\\n\\n      const iconTag = this.localName.split(\'pharos-footer\')[0] + \'pharos-icon\';\\n      const googleIcon = document.createElement(iconTag);\\n      const chevronIcon = document.createElement(iconTag);\\n\\n      googleIcon.name = \'google\';\\n      chevronIcon.name = \'chevron-down\';\\n      chevronIcon.style.marginLeft = \'0\';\\n\\n      widgetButton?.appendChild(chevronIcon);\\n      widgetButton?.replaceChild(googleIcon, googleImg);\\n    }\\n  )"}],"mixins":[{"name":"ScopedRegistryMixin","module":"/src/utils/mixins/scoped-registry"}],"superclass":{"name":"PharosElement","module":"/src/components/base/pharos-element"},"tagName":"pharos-footer","customElement":true}],"exports":[{"kind":"js","name":"PharosFooter","declaration":{"name":"PharosFooter","module":"src/components/footer/pharos-footer.ts"}}]},{"kind":"javascript-module","path":"src/components/header/pharos-header.ts","declarations":[{"kind":"class","description":"Pharos header component.","name":"PharosHeader","slots":[{"description":"Content to be shown at the top of the nav.","name":"top"},{"description":"Content to be shown at the start of the nav.","name":"start"},{"description":"Content to be shown at the center of the nav.","name":"center"},{"description":"Content to be shown at the end of the nav.","name":"end"}],"members":[],"superclass":{"name":"PharosElement","module":"/src/components/base/pharos-element"},"tagName":"pharos-header","customElement":true}],"exports":[{"kind":"js","name":"PharosHeader","declaration":{"name":"PharosHeader","module":"src/components/header/pharos-header.ts"}}]},{"kind":"javascript-module","path":"src/components/heading/pharos-heading.ts","declarations":[{"kind":"variable","name":"allLevels","default":"[1, 2, 3, 4, 5, 6]"},{"kind":"variable","name":"allPresets","default":"[\\n  \'1\',\\n  \'1--bold\',\\n  \'2\',\\n  \'2--bold\',\\n  \'3\',\\n  \'3--bold\',\\n  \'4\',\\n  \'4--bold\',\\n  \'5\',\\n  \'5--bold\',\\n  \'6\',\\n  \'6--bold\',\\n  \'7\',\\n  \'7--bold\',\\n  \'legend\',\\n]"},{"kind":"class","description":"Pharos heading component.","name":"PharosHeading","slots":[{"description":"Contains the heading text (the default slot).","name":""}],"members":[{"kind":"field","name":"level","type":{"text":"HeadingLevel"},"privacy":"public","description":"Indicates the heading tag level.","attribute":"level","reflects":true},{"kind":"field","name":"preset","type":{"text":"HeadingPreset"},"privacy":"public","description":"Indicates the visual styling preset to use.","attribute":"preset","reflects":true},{"kind":"field","name":"noMargin","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the heading should not have a margin applied.","attribute":"no-margin","reflects":true}],"attributes":[{"name":"level","type":{"text":"HeadingLevel"},"description":"Indicates the heading tag level.","fieldName":"level","attribute":"level"},{"name":"preset","type":{"text":"HeadingPreset"},"description":"Indicates the visual styling preset to use.","fieldName":"preset","attribute":"preset"},{"name":"no-margin","type":{"text":"boolean"},"default":"false","description":"Indicates if the heading should not have a margin applied.","fieldName":"noMargin","attribute":"no-margin"}],"superclass":{"name":"PharosElement","module":"/src/components/base/pharos-element"},"tagName":"pharos-heading","customElement":true}],"exports":[{"kind":"js","name":"allLevels","declaration":{"name":"allLevels","module":"src/components/heading/pharos-heading.ts"}},{"kind":"js","name":"allPresets","declaration":{"name":"allPresets","module":"src/components/heading/pharos-heading.ts"}},{"kind":"js","name":"PharosHeading","declaration":{"name":"PharosHeading","module":"src/components/heading/pharos-heading.ts"}}]},{"kind":"javascript-module","path":"src/components/heading/storyArgs.ts","declarations":[{"kind":"variable","name":"argTypes","type":{"text":"object"},"default":"{\\n  level: {\\n    control: {\\n      type: \'range\',\\n      min: Math.min(...allLevels),\\n      max: Math.max(...allLevels),\\n      step: 1,\\n    },\\n  },\\n  preset: {\\n    options: allPresets,\\n    control: { type: \'inline-radio\' },\\n  },\\n}"},{"kind":"variable","name":"defaultArgs","type":{"text":"object"},"default":"{\\n  level: 1,\\n  noMargin: false,\\n  preset: \'5\',\\n  text: \'Heading style\',\\n}"}],"exports":[{"kind":"js","name":"argTypes","declaration":{"name":"argTypes","module":"src/components/heading/storyArgs.ts"}},{"kind":"js","name":"defaultArgs","declaration":{"name":"defaultArgs","module":"src/components/heading/storyArgs.ts"}}]},{"kind":"javascript-module","path":"src/components/icon/pharos-icon.ts","declarations":[{"kind":"class","description":"Pharos icon component.","name":"PharosIcon","members":[{"kind":"field","name":"name","type":{"text":"IconName | undefined"},"privacy":"public","description":"The name of the icon","attribute":"name","reflects":true,"optional":true},{"kind":"field","name":"description","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"A description of what the icon represents","attribute":"description","reflects":true},{"kind":"field","name":"_svg","type":{"text":"string"},"privacy":"private","default":"\'\'"},{"kind":"method","name":"_getIconSize","privacy":"private","return":{"type":{"text":"number"}}}],"attributes":[{"name":"name","type":{"text":"IconName | undefined"},"description":"The name of the icon","fieldName":"name","attribute":"name"},{"name":"description","type":{"text":"string"},"default":"\'\'","description":"A description of what the icon represents","fieldName":"description","attribute":"description"}],"superclass":{"name":"PharosElement","module":"/src/components/base/pharos-element"},"tagName":"pharos-icon","customElement":true}],"exports":[{"kind":"js","name":"PharosIcon","declaration":{"name":"PharosIcon","module":"src/components/icon/pharos-icon.ts"}}]},{"kind":"javascript-module","path":"src/components/icon/storyArgs.ts","declarations":[{"kind":"variable","name":"defaultArgs","type":{"text":"object"},"default":"{\\n  name: \'checkmark\',\\n  description: \'\',\\n}"},{"kind":"variable","name":"argTypes","type":{"text":"object"},"default":"{\\n  name: {\\n    options: iconNames,\\n    control: {\\n      type: \'select\',\\n    },\\n  },\\n}"}],"exports":[{"kind":"js","name":"defaultArgs","declaration":{"name":"defaultArgs","module":"src/components/icon/storyArgs.ts"}},{"kind":"js","name":"argTypes","declaration":{"name":"argTypes","module":"src/components/icon/storyArgs.ts"}}]},{"kind":"javascript-module","path":"src/components/image-card/pharos-image-card.ts","declarations":[{"kind":"class","description":"Pharos image card component.","name":"PharosImageCard","slots":[{"description":"Contains the image to display on the card.","name":"image"},{"description":"Contains the metadata for the item.","name":"metadata"},{"description":"Contains the title for the item (renders if title prop is not set).","name":"title"},{"description":"Contains the action-button for the item (renders if action-menu prop is not set).","name":"action-button"}],"members":[{"kind":"field","name":"elementDefinitions","type":{"text":"object"},"static":true,"default":"{\\n    \'pharos-heading\': PharosHeading,\\n    \'pharos-link\': PharosLink,\\n    \'pharos-icon\': PharosIcon,\\n    \'pharos-button\': PharosButton,\\n    \'pharos-checkbox\': PharosCheckbox,\\n  }"},{"kind":"field","name":"title","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"Indicates the title of the item presented in the card.","attribute":"title","reflects":true},{"kind":"field","name":"sourceType","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the item type of the source content represented by the card.","attribute":"source-type","reflects":true,"optional":true},{"kind":"field","name":"link","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"Indicates the link to apply to the title and image.","attribute":"link","reflects":true},{"kind":"field","name":"imageLinkLabel","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the label to apply to the image link.","attribute":"image-link-label","reflects":true,"optional":true},{"kind":"field","name":"variant","type":{"text":"ImageCardVariant"},"privacy":"public","default":"\'base\'","description":"Indicates the variant of card.","attribute":"variant","reflects":true},{"kind":"field","name":"error","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the image is not available or accessible.","attribute":"error","reflects":true},{"kind":"field","name":"subtle","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the metadata should only show on hover of the image.","attribute":"subtle","reflects":true},{"kind":"field","name":"actionMenu","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the action menu id to be passed to the action button.","attribute":"action-menu","reflects":true,"optional":true},{"kind":"field","name":"headingLevel","type":{"text":"HeadingLevel | undefined"},"privacy":"public","description":"The heading level to use for the card title when using the title property.","attribute":"heading-level","reflects":true,"optional":true},{"kind":"field","name":"subtleSelect","type":{"text":"boolean | undefined"},"privacy":"public","description":"Indicates subtler styling for the selectable card variant and that the card is only selectable by clicking on the checkbox.","attribute":"subtle-select","reflects":true,"optional":true},{"kind":"field","name":"_isSelected","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the image card is selected","attribute":"selected","reflects":true},{"kind":"field","name":"disabled","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the image card is in a disabled state","attribute":"disabled","reflects":true},{"kind":"field","name":"indicateLinkVisited","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the image card title link should render the visited link styling.","attribute":"indicate-link-visited","reflects":true},{"kind":"field","name":"_isSelectableHovered","type":{"text":"boolean"},"privacy":"private","default":"false"},{"kind":"field","name":"_title","type":{"text":"PharosLink"},"privacy":"private"},{"kind":"field","name":"_checkbox","type":{"text":"PharosCheckbox"},"privacy":"private"},{"kind":"method","name":"_isSelectable","privacy":"private"},{"kind":"method","name":"_handleClick","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"e","type":{"text":"MouseEvent"}}]},{"kind":"method","name":"_handleImageMouseEnter","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_handleImageMouseLeave","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_handleMouseEnterSelectable","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_handleMouseLeaveSelectable","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_renderCollectionImage","privacy":"private","return":{"type":{"text":"TemplateResult"}}},{"kind":"method","name":"_renderLinkContent","privacy":"private","return":{"type":{"text":"TemplateResult"}}},{"kind":"method","name":"_renderHoverMetadata","privacy":"private","return":{"type":{"text":"TemplateResult | typeof nothing"}}},{"kind":"method","name":"_renderBaseImage","privacy":"private","return":{"type":{"text":"TemplateResult"}}},{"kind":"method","name":"_renderImage","privacy":"private","return":{"type":{"text":"TemplateResult"}}},{"kind":"method","name":"_chooseHeadingPreset","privacy":"private","return":{"type":{"text":"HeadingPreset"}}},{"kind":"method","name":"_renderTitle","privacy":"private","return":{"type":{"text":"TemplateResult"}}},{"kind":"method","name":"_renderActionButton","privacy":"private","return":{"type":{"text":"TemplateResult"}}},{"kind":"method","name":"_renderSourceType","privacy":"private","return":{"type":{"text":"TemplateResult | typeof nothing"}}},{"kind":"method","name":"_renderMetadata","privacy":"private","return":{"type":{"text":"TemplateResult | typeof nothing"}}},{"kind":"method","name":"_handleNavigation","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"KeyboardEvent"}},{"name":"directionMatches","type":{"text":"boolean"}}]},{"kind":"method","name":"_handleBackwardNavigation","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"KeyboardEvent"}}]},{"kind":"method","name":"_handleForwardNavigation","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"KeyboardEvent"}}]},{"kind":"method","name":"_cardToggleSelect","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"Event"}}]},{"kind":"method","name":"_isSubtleSelectHover","privacy":"private","return":{"type":{"text":"boolean"}}},{"kind":"method","name":"_isSubtleAndSelectable","privacy":"private","return":{"type":{"text":"boolean"}}},{"kind":"method","name":"_showSubtleOverlay","privacy":"private","return":{"type":{"text":"boolean"}}},{"kind":"method","name":"_isSelectableCardHover","privacy":"private","return":{"type":{"text":"boolean"}}},{"kind":"method","name":"_isSelectableViaCard","privacy":"private","return":{"type":{"text":"boolean"}}},{"kind":"method","name":"_isDisabledSelectable","privacy":"private","return":{"type":{"text":"boolean"}}},{"kind":"method","name":"_isCheckboxDisplayed","privacy":"private"},{"kind":"method","name":"_renderCheckbox","privacy":"private","return":{"type":{"text":"TemplateResult | typeof nothing"}}},{"kind":"method","name":"focus","privacy":"public","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"FocusMixin","module":"src/utils/mixins/focus.ts"}}],"events":[{"name":"pharos-image-card-selected","type":{"text":"CustomEvent"}}],"attributes":[{"name":"title","type":{"text":"string"},"default":"\'\'","description":"Indicates the title of the item presented in the card.","fieldName":"title","attribute":"title"},{"name":"source-type","type":{"text":"string | undefined"},"description":"Indicates the item type of the source content represented by the card.","fieldName":"sourceType","attribute":"source-type"},{"name":"link","type":{"text":"string"},"default":"\'\'","description":"Indicates the link to apply to the title and image.","fieldName":"link","attribute":"link"},{"name":"image-link-label","type":{"text":"string | undefined"},"description":"Indicates the label to apply to the image link.","fieldName":"imageLinkLabel","attribute":"image-link-label"},{"name":"variant","type":{"text":"ImageCardVariant"},"default":"\'base\'","description":"Indicates the variant of card.","fieldName":"variant","attribute":"variant"},{"name":"error","type":{"text":"boolean"},"default":"false","description":"Indicates if the image is not available or accessible.","fieldName":"error","attribute":"error"},{"name":"subtle","type":{"text":"boolean"},"default":"false","description":"Indicates if the metadata should only show on hover of the image.","fieldName":"subtle","attribute":"subtle"},{"name":"action-menu","type":{"text":"string | undefined"},"description":"Indicates the action menu id to be passed to the action button.","fieldName":"actionMenu","attribute":"action-menu"},{"name":"heading-level","type":{"text":"HeadingLevel | undefined"},"description":"The heading level to use for the card title when using the title property.","fieldName":"headingLevel","attribute":"heading-level"},{"name":"subtle-select","type":{"text":"boolean | undefined"},"description":"Indicates subtler styling for the selectable card variant and that the card is only selectable by clicking on the checkbox.","fieldName":"subtleSelect","attribute":"subtle-select"},{"name":"selected","type":{"text":"boolean"},"default":"false","description":"Indicates if the image card is selected","fieldName":"_isSelected","attribute":"selected"},{"name":"indicate-link-visited","type":{"text":"boolean"},"default":"false","description":"Indicates if the image card title link should render the visited link styling.","fieldName":"indicateLinkVisited","attribute":"indicate-link-visited"},{"name":"disabled","type":{"text":"boolean"},"default":"false","description":"Indicates if the image card is in a disabled state","attribute":"selected","fieldName":"disabled"}],"mixins":[{"name":"ScopedRegistryMixin","module":"/src/utils/mixins/scoped-registry"},{"name":"FocusMixin","module":"/src/utils/mixins/focus"}],"superclass":{"name":"PharosElement","module":"/src/components/base/pharos-element"},"tagName":"pharos-image-card","customElement":true}],"exports":[{"kind":"js","name":"HeadingLevel","declaration":{"name":"HeadingLevel","module":"src/components/image-card/pharos-image-card.ts"}},{"kind":"js","name":"PharosImageCard","declaration":{"name":"PharosImageCard","module":"src/components/image-card/pharos-image-card.ts"}}]},{"kind":"javascript-module","path":"src/components/image-card/storyArgs.ts","declarations":[{"kind":"variable","name":"defaultArgs","type":{"text":"object"},"default":"{\\n  error: false,\\n  subtle: false,\\n  indicatedLinkVisited: false,\\n}"}],"exports":[{"kind":"js","name":"defaultArgs","declaration":{"name":"defaultArgs","module":"src/components/image-card/storyArgs.ts"}}]},{"kind":"javascript-module","path":"src/components/input-group/pharos-input-group-select.ts","declarations":[{"kind":"class","description":"Pharos input group select component.","name":"PharosInputGroupSelect","members":[{"kind":"field","name":"elementDefinitions","type":{"text":"object"},"static":true,"default":"{\\n    \'pharos-icon\': PharosIcon,\\n  }","inheritedFrom":{"name":"PharosSelect","module":"src/components/select/pharos-select.ts"}},{"kind":"field","name":"value","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"Indicates the value for the select.","attribute":"value","reflects":true,"inheritedFrom":{"name":"PharosSelect","module":"src/components/select/pharos-select.ts"}},{"kind":"field","name":"_select","type":{"text":"HTMLSelectElement"},"privacy":"private","inheritedFrom":{"name":"PharosSelect","module":"src/components/select/pharos-select.ts"}},{"kind":"field","name":"_options","type":{"text":"HTMLOptionElement[]"},"privacy":"private","readonly":true,"inheritedFrom":{"name":"PharosSelect","module":"src/components/select/pharos-select.ts"}},{"kind":"method","name":"_setOption","privacy":"private","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"PharosSelect","module":"src/components/select/pharos-select.ts"}},{"kind":"method","name":"onChange","privacy":"public","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"PharosSelect","module":"src/components/select/pharos-select.ts"}},{"kind":"method","name":"_handleFormdata","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"CustomEvent"}}],"description":"Handles the `formdata` event.","inheritedFrom":{"name":"FormMixin","module":"src/utils/mixins/form.ts"}},{"kind":"method","name":"_handleFormReset","return":{"type":{"text":"void"}},"description":"Handles the `reset` event.","inheritedFrom":{"name":"FormMixin","module":"src/utils/mixins/form.ts"}},{"kind":"field","name":"_childrenObserver","type":{"text":"MutationObserver | null"},"privacy":"private","default":"null","inheritedFrom":{"name":"ObserveChildrenMixin","module":"src/utils/mixins/observe-children.ts"}},{"kind":"field","name":"_handleMutation","privacy":"private","inheritedFrom":{"name":"ObserveChildrenMixin","module":"src/utils/mixins/observe-children.ts"}},{"kind":"field","name":"name","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"Name for the form element.","attribute":"name","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"required","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if input is required.","attribute":"required","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"disabled","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if input is disabled.","attribute":"disabled","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"invalidated","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates an invalidated state.","attribute":"invalidated","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"validated","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates a validated state.","attribute":"validated","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"message","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"The message to display below the input.","attribute":"message","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"hideLabel","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the label should be hidden.","attribute":"hide-label","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"requiredIndicator","type":{"text":"TemplateResult | typeof nothing"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"messageContent","type":{"text":"TemplateResult | typeof nothing"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"messageId","type":{"text":"string | undefined"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"method","name":"focus","privacy":"public","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"FocusMixin","module":"src/utils/mixins/focus.ts"}}],"superclass":{"name":"PharosSelect","module":"/src/components/select/pharos-select"},"tagName":"pharos-input-group-select","customElement":true,"attributes":[{"name":"value","type":{"text":"string"},"default":"\'\'","description":"Indicates the value for the select.","fieldName":"value","attribute":"value","inheritedFrom":{"name":"PharosSelect","module":"src/components/select/pharos-select.ts"}},{"name":"name","type":{"text":"string"},"default":"\'\'","description":"Name for the form element.","fieldName":"name","attribute":"name","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"required","type":{"text":"boolean"},"default":"false","description":"Indicates if input is required.","fieldName":"required","attribute":"required","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"disabled","type":{"text":"boolean"},"default":"false","description":"Indicates if input is disabled.","fieldName":"disabled","attribute":"disabled","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"invalidated","type":{"text":"boolean"},"default":"false","description":"Indicates an invalidated state.","fieldName":"invalidated","attribute":"invalidated","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"validated","type":{"text":"boolean"},"default":"false","description":"Indicates a validated state.","fieldName":"validated","attribute":"validated","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"message","type":{"text":"string"},"default":"\'\'","description":"The message to display below the input.","fieldName":"message","attribute":"message","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"hide-label","type":{"text":"boolean"},"default":"false","description":"Indicates if the label should be hidden.","fieldName":"hideLabel","attribute":"hide-label","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}}],"events":[{"name":"change","type":{"text":"Event"},"description":"Fires when the value has changed","inheritedFrom":{"name":"PharosSelect","module":"src/components/select/pharos-select.ts"}}]}],"exports":[{"kind":"js","name":"PharosInputGroupSelect","declaration":{"name":"PharosInputGroupSelect","module":"src/components/input-group/pharos-input-group-select.ts"}}]},{"kind":"javascript-module","path":"src/components/input-group/pharos-input-group.ts","declarations":[{"kind":"class","description":"Pharos input group component.","name":"PharosInputGroup","slots":[{"description":"Contains the elements to be appended to the input group (the default slot).","name":""},{"description":"Contains the elements to be prepended to the input group.","name":"prepend"}],"members":[{"kind":"field","name":"_appendGroup","type":{"text":"HTMLDivElement"},"privacy":"private"},{"kind":"field","name":"_prependGroup","type":{"text":"HTMLDivElement"},"privacy":"private"},{"kind":"field","name":"_appendGroupWidth","type":{"text":"number"},"privacy":"private","default":"0"},{"kind":"field","name":"_prependGroupWidth","type":{"text":"number"},"privacy":"private","default":"0"},{"kind":"field","name":"prependContent","type":{"text":"TemplateResult | typeof nothing"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}},{"kind":"field","name":"appendContent","type":{"text":"TemplateResult | typeof nothing"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}},{"kind":"method","name":"_updateAppendPadding","privacy":"private","return":{"type":{"text":"Promise<void>"}}},{"kind":"method","name":"_updatePrependPadding","privacy":"private","return":{"type":{"text":"Promise<void>"}}},{"kind":"method","name":"_adjustPadding","privacy":"private","parameters":[{"name":"event","type":{"text":"FocusEvent"}}]},{"kind":"field","name":"elementDefinitions","type":{"text":"object"},"static":true,"default":"{\\n    \'pharos-icon\': PharosIcon,\\n  }","inheritedFrom":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}},{"kind":"field","name":"value","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"Indicates input value.","attribute":"value","reflects":true,"inheritedFrom":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}},{"kind":"field","name":"type","type":{"text":"TextInputType"},"privacy":"public","default":"\'text\'","description":"Indicates the type of input.","attribute":"type","reflects":true,"inheritedFrom":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}},{"kind":"field","name":"variant","type":{"text":"TextInputVariant"},"privacy":"public","default":"\'primary\'","description":"Indicates the variant of text input.","attribute":"variant","reflects":true,"inheritedFrom":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}},{"kind":"field","name":"readonly","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if input is readonly.","attribute":"readonly","reflects":true,"inheritedFrom":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}},{"kind":"field","name":"autocomplete","type":{"text":"TextInputAutocomplete | undefined"},"privacy":"public","description":"Indicates if autocomplete is enabled","attribute":"autocomplete","reflects":true,"optional":true,"inheritedFrom":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}},{"kind":"field","name":"placeholder","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"Display text when input is empty","attribute":"placeholder","reflects":true,"inheritedFrom":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}},{"kind":"field","name":"minlength","type":{"text":"number | undefined"},"privacy":"public","description":"Defines the minimum number of characters the user can enter","attribute":"minlength","reflects":true,"optional":true,"inheritedFrom":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}},{"kind":"field","name":"maxlength","type":{"text":"number | undefined"},"privacy":"public","description":"Defines the maximum number of characters the user can enter","attribute":"maxlength","reflects":true,"optional":true,"inheritedFrom":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}},{"kind":"field","name":"pattern","type":{"text":"string | undefined"},"privacy":"public","description":"Pattern to validate the input against","attribute":"pattern","reflects":true,"optional":true,"inheritedFrom":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}},{"kind":"field","name":"onBackground","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates the input is on a AA compliant background.","attribute":"on-background","reflects":true,"inheritedFrom":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}},{"kind":"field","name":"_input","type":{"text":"HTMLInputElement"},"privacy":"protected","inheritedFrom":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}},{"kind":"field","name":"_inputIcon","type":{"text":"HTMLInputElement"},"privacy":"protected","inheritedFrom":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}},{"kind":"method","name":"onChange","privacy":"public","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}},{"kind":"method","name":"onInput","privacy":"public","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}},{"kind":"method","name":"_renderIcons","privacy":"private","return":{"type":{"text":"TemplateResult | typeof nothing"}},"inheritedFrom":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}},{"kind":"method","name":"_handleKeydown","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"KeyboardEvent"}}],"inheritedFrom":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}},{"kind":"method","name":"_handleFormdata","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"CustomEvent"}}],"description":"Handles the `formdata` event.","inheritedFrom":{"name":"FormMixin","module":"src/utils/mixins/form.ts"}},{"kind":"method","name":"_handleFormReset","return":{"type":{"text":"void"}},"description":"Handles the `reset` event.","inheritedFrom":{"name":"FormMixin","module":"src/utils/mixins/form.ts"}},{"kind":"field","name":"name","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"Name for the form element.","attribute":"name","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"required","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if input is required.","attribute":"required","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"disabled","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if input is disabled.","attribute":"disabled","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"invalidated","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates an invalidated state.","attribute":"invalidated","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"validated","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates a validated state.","attribute":"validated","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"message","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"The message to display below the input.","attribute":"message","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"hideLabel","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the label should be hidden.","attribute":"hide-label","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"requiredIndicator","type":{"text":"TemplateResult | typeof nothing"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"messageContent","type":{"text":"TemplateResult | typeof nothing"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"messageId","type":{"text":"string | undefined"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"method","name":"focus","privacy":"public","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"FocusMixin","module":"src/utils/mixins/focus.ts"}}],"superclass":{"name":"PharosTextInput","module":"/src/components/text-input/pharos-text-input"},"tagName":"pharos-input-group","customElement":true,"attributes":[{"name":"value","type":{"text":"string"},"default":"\'\'","description":"Indicates input value.","fieldName":"value","attribute":"value","inheritedFrom":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}},{"name":"type","type":{"text":"TextInputType"},"default":"\'text\'","description":"Indicates the type of input.","fieldName":"type","attribute":"type","inheritedFrom":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}},{"name":"variant","type":{"text":"TextInputVariant"},"default":"\'primary\'","description":"Indicates the variant of text input.","fieldName":"variant","attribute":"variant","inheritedFrom":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}},{"name":"readonly","type":{"text":"boolean"},"default":"false","description":"Indicates if input is readonly.","fieldName":"readonly","attribute":"readonly","inheritedFrom":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}},{"name":"autocomplete","type":{"text":"TextInputAutocomplete | undefined"},"description":"Indicates if autocomplete is enabled","fieldName":"autocomplete","attribute":"autocomplete","inheritedFrom":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}},{"name":"placeholder","type":{"text":"string"},"default":"\'\'","description":"Display text when input is empty","fieldName":"placeholder","attribute":"placeholder","inheritedFrom":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}},{"name":"minlength","type":{"text":"number | undefined"},"description":"Defines the minimum number of characters the user can enter","fieldName":"minlength","attribute":"minlength","inheritedFrom":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}},{"name":"maxlength","type":{"text":"number | undefined"},"description":"Defines the maximum number of characters the user can enter","fieldName":"maxlength","attribute":"maxlength","inheritedFrom":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}},{"name":"pattern","type":{"text":"string | undefined"},"description":"Pattern to validate the input against","fieldName":"pattern","attribute":"pattern","inheritedFrom":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}},{"name":"on-background","type":{"text":"boolean"},"default":"false","description":"Indicates the input is on a AA compliant background.","fieldName":"onBackground","attribute":"on-background","inheritedFrom":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}},{"name":"name","type":{"text":"string"},"default":"\'\'","description":"Name for the form element.","fieldName":"name","attribute":"name","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"required","type":{"text":"boolean"},"default":"false","description":"Indicates if input is required.","fieldName":"required","attribute":"required","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"disabled","type":{"text":"boolean"},"default":"false","description":"Indicates if input is disabled.","fieldName":"disabled","attribute":"disabled","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"invalidated","type":{"text":"boolean"},"default":"false","description":"Indicates an invalidated state.","fieldName":"invalidated","attribute":"invalidated","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"validated","type":{"text":"boolean"},"default":"false","description":"Indicates a validated state.","fieldName":"validated","attribute":"validated","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"message","type":{"text":"string"},"default":"\'\'","description":"The message to display below the input.","fieldName":"message","attribute":"message","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"hide-label","type":{"text":"boolean"},"default":"false","description":"Indicates if the label should be hidden.","fieldName":"hideLabel","attribute":"hide-label","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}}],"events":[{"name":"change","type":{"text":"Event"},"description":"Fires when the element loses focus, after the content has changed","inheritedFrom":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}},{"description":"Fires when the value has changed","name":"input","inheritedFrom":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}}]}],"exports":[{"kind":"js","name":"TextInputType","declaration":{"name":"TextInputType","module":"src/components/input-group/pharos-input-group.ts"}},{"kind":"js","name":"TextInputAutocomplete","declaration":{"name":"TextInputAutocomplete","module":"src/components/input-group/pharos-input-group.ts"}},{"kind":"js","name":"TextInputVariant","declaration":{"name":"TextInputVariant","module":"src/components/input-group/pharos-input-group.ts"}},{"kind":"js","name":"PharosInputGroup","declaration":{"name":"PharosInputGroup","module":"src/components/input-group/pharos-input-group.ts"}}]},{"kind":"javascript-module","path":"src/components/layout/pharos-layout.ts","declarations":[{"kind":"class","description":"Pharos layout component.","name":"PharosLayout","slots":[{"description":"Content to be shown above the inner grid.","name":"top"},{"description":"Content to be shown within the inner grid (the default slot).","name":""}],"members":[{"kind":"field","name":"preset","type":{"text":"LayoutPreset"},"privacy":"public","default":"\'1-col\'","description":"Indicates the type of layout to use.","attribute":"preset","reflects":true},{"kind":"field","name":"areas","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"Indicates the areas to use for the inner grid.","attribute":"areas","reflects":true},{"kind":"field","name":"rows","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"Indicates the rows to use for the inner grid.","attribute":"rows","reflects":true},{"kind":"field","name":"rowGap","privacy":"public","default":"PharosSpacingThreeAndAHalfX","description":"Indicates the row gap to use for the inner grid.","type":{"text":"string"},"attribute":"row-gap","reflects":true},{"kind":"field","name":"tag","type":{"text":"string"},"privacy":"public","default":"\'div\'","description":"Indicates the HTML tag to use for the inner grid.","attribute":"tag","reflects":true},{"kind":"field","name":"_layout","type":{"text":"HTMLElement"},"privacy":"private"}],"attributes":[{"name":"preset","type":{"text":"LayoutPreset"},"default":"\'1-col\'","description":"Indicates the type of layout to use.","fieldName":"preset","attribute":"preset"},{"name":"areas","type":{"text":"string"},"default":"\'\'","description":"Indicates the areas to use for the inner grid.","fieldName":"areas","attribute":"areas"},{"name":"rows","type":{"text":"string"},"default":"\'\'","description":"Indicates the rows to use for the inner grid.","fieldName":"rows","attribute":"rows"},{"name":"row-gap","default":"PharosSpacingThreeAndAHalfX","description":"Indicates the row gap to use for the inner grid.","type":{"text":"string"},"resolveInitializer":{"module":"/src/styles/variables"},"fieldName":"rowGap","attribute":"row-gap"},{"name":"tag","type":{"text":"string"},"default":"\'div\'","description":"Indicates the HTML tag to use for the inner grid.","fieldName":"tag","attribute":"tag"}],"superclass":{"name":"PharosElement","module":"/src/components/base/pharos-element"},"tagName":"pharos-layout","customElement":true}],"exports":[{"kind":"js","name":"PharosLayout","declaration":{"name":"PharosLayout","module":"src/components/layout/pharos-layout.ts"}}]},{"kind":"javascript-module","path":"src/components/link/pharos-link.ts","declarations":[{"kind":"class","description":"Pharos link component.","name":"PharosLink","slots":[{"description":"Contains the content of the link (the default slot).","name":""}],"members":[{"kind":"field","name":"type","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the MIME type of the target.","attribute":"type","reflects":true,"optional":true},{"kind":"field","name":"subtle","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates the link should not have text decoration by default.","attribute":"subtle","reflects":true},{"kind":"field","name":"onBackground","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates the link is on a AA compliant background.","attribute":"on-background","reflects":true},{"kind":"field","name":"label","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the aria label to apply to the link.","attribute":"label","reflects":true,"optional":true},{"kind":"field","name":"bold","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the link should be bold.","attribute":"bold","reflects":true},{"kind":"field","name":"flex","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the link should display as a flex container.","attribute":"flex","reflects":true},{"kind":"field","name":"skip","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates the link is hidden until focused and skips to another element when clicked.","attribute":"skip","reflects":true},{"kind":"field","name":"noHover","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates the link should not have a hover state.","attribute":"no-hover","reflects":true},{"kind":"field","name":"indicateVisited","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the link should render the visited link styling.","attribute":"indicateVisited","reflects":true},{"kind":"field","name":"_alert","type":{"text":"boolean"},"privacy":"private","default":"false"},{"kind":"field","name":"_hover","type":{"text":"boolean"},"privacy":"private","default":"false"},{"kind":"method","name":"_handleClick","privacy":"private","return":{"type":{"text":"Promise<void>"}}},{"kind":"field","name":"appendContent","type":{"text":"TemplateResult | typeof nothing"},"privacy":"protected","readonly":true},{"kind":"method","name":"focus","privacy":"public","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"FocusMixin","module":"src/utils/mixins/focus.ts"}},{"kind":"field","name":"download","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates to save the linked URL instead of navigating to it.","attribute":"download","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"href","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the URL that the hyperlink points to.","attribute":"href","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"hreflang","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the language of the linked URL.","attribute":"hreflang","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"ping","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the URLs to ping.","attribute":"ping","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"rel","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the type of link.","attribute":"rel","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"target","type":{"text":"LinkTarget | undefined"},"privacy":"public","description":"Indicates where to display the linked URL.","attribute":"target","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}}],"attributes":[{"name":"type","type":{"text":"string | undefined"},"description":"Indicates the MIME type of the target.","fieldName":"type","attribute":"type"},{"name":"subtle","type":{"text":"boolean"},"default":"false","description":"Indicates the link should not have text decoration by default.","fieldName":"subtle","attribute":"subtle"},{"name":"on-background","type":{"text":"boolean"},"default":"false","description":"Indicates the link is on a AA compliant background.","fieldName":"onBackground","attribute":"on-background"},{"name":"label","type":{"text":"string | undefined"},"description":"Indicates the aria label to apply to the link.","fieldName":"label","attribute":"label"},{"name":"bold","type":{"text":"boolean"},"default":"false","description":"Indicates if the link should be bold.","fieldName":"bold","attribute":"bold"},{"name":"flex","type":{"text":"boolean"},"default":"false","description":"Indicates if the link should display as a flex container.","fieldName":"flex","attribute":"flex"},{"name":"skip","type":{"text":"boolean"},"default":"false","description":"Indicates the link is hidden until focused and skips to another element when clicked.","fieldName":"skip","attribute":"skip"},{"name":"no-hover","type":{"text":"boolean"},"default":"false","description":"Indicates the link should not have a hover state.","fieldName":"noHover","attribute":"no-hover"},{"name":"indicate-visited","type":{"text":"boolean"},"default":"false","description":"Indicates if the link should render the visited link styling.","fieldName":"indicateVisited"},{"name":"indicateVisited","type":{"text":"boolean"},"default":"false","description":"Indicates if the link should render the visited link styling.","attribute":"indicate-visited","fieldName":"indicateVisited"},{"name":"download","type":{"text":"string | undefined"},"description":"Indicates to save the linked URL instead of navigating to it.","fieldName":"download","attribute":"download","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"href","type":{"text":"string | undefined"},"description":"Indicates the URL that the hyperlink points to.","fieldName":"href","attribute":"href","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"hreflang","type":{"text":"string | undefined"},"description":"Indicates the language of the linked URL.","fieldName":"hreflang","attribute":"hreflang","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"ping","type":{"text":"string | undefined"},"description":"Indicates the URLs to ping.","fieldName":"ping","attribute":"ping","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"rel","type":{"text":"string | undefined"},"description":"Indicates the type of link.","fieldName":"rel","attribute":"rel","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"target","type":{"text":"LinkTarget | undefined"},"description":"Indicates where to display the linked URL.","fieldName":"target","attribute":"target","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}}],"mixins":[{"name":"FocusMixin","module":"/src/utils/mixins/focus"}],"superclass":{"name":"AnchorElement","module":"/src/components/base/anchor-element"},"tagName":"pharos-link","customElement":true}],"exports":[{"kind":"js","name":"LinkTarget","declaration":{"name":"LinkTarget","module":"src/components/link/pharos-link.ts"}},{"kind":"js","name":"PharosLink","declaration":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}}]},{"kind":"javascript-module","path":"src/components/link/storyArgs.ts","declarations":[{"kind":"variable","name":"defaultArgs","type":{"text":"object"},"default":"{\\n  text: \'I am a link\',\\n  bold: false,\\n  flex: false,\\n  href: \'#\',\\n  indicateVisited: false,\\n  onBackground: false,\\n  noHover: false,\\n  skip: false,\\n  subtle: false,\\n}"}],"exports":[{"kind":"js","name":"defaultArgs","declaration":{"name":"defaultArgs","module":"src/components/link/storyArgs.ts"}}]},{"kind":"javascript-module","path":"src/components/loading-spinner/pharos-loading-spinner.ts","declarations":[{"kind":"class","description":"Pharos loading spinner component.","name":"PharosLoadingSpinner","cssProperties":[{"type":{"text":"Color"},"description":"The primary color of the spinner icon.","name":"--pharos-loading-spinner-color-stroke-primary"},{"type":{"text":"Color"},"description":"The secondary color of the spinner icon.","name":"--pharos-loading-spinner-color-stroke-secondary"}],"members":[{"kind":"field","name":"_icon","type":{"text":"SVGElement"},"privacy":"private"},{"kind":"field","name":"_spinner","type":{"text":"SVGCircleElement"},"privacy":"private"},{"kind":"method","name":"_setupAnimation","privacy":"private","return":{"type":{"text":"void"}}}],"superclass":{"name":"PharosElement","module":"/src/components/base/pharos-element"},"tagName":"pharos-loading-spinner","customElement":true}],"exports":[{"kind":"js","name":"PharosLoadingSpinner","declaration":{"name":"PharosLoadingSpinner","module":"src/components/loading-spinner/pharos-loading-spinner.ts"}}]},{"kind":"javascript-module","path":"src/components/modal/pharos-modal.ts","declarations":[{"kind":"variable","name":"allSizes","default":"[\'small\', \'medium\', \'large\']"},{"kind":"class","description":"Pharos modal component.","name":"PharosModal","slots":[{"description":"Content that describes the primary message or purpose of the modal.","name":"description"},{"description":"Contains the content of the modal body.","name":""},{"description":"Contains the content of the modal footer.","name":"footer"}],"members":[{"kind":"field","name":"elementDefinitions","type":{"text":"object"},"static":true,"default":"{\\n    \'pharos-button\': PharosButton,\\n    \'pharos-heading\': PharosHeading,\\n    \'focus-trap\': FocusTrap,\\n  }"},{"kind":"field","name":"open","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the modal is open.","attribute":"open","reflects":true},{"kind":"field","name":"header","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"Text content for the modal header","attribute":"header","reflects":true},{"kind":"field","name":"footerDivider","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the modal footer should contain a divider.","attribute":"footer-divider","reflects":true},{"kind":"field","name":"size","type":{"text":"ModalSize"},"privacy":"public","default":"\'medium\'","description":"Indicates the size of the modal","attribute":"size","reflects":true},{"kind":"field","name":"_currentTrigger","type":{"text":"Element | null"},"privacy":"private","default":"null"},{"kind":"field","name":"_triggers","type":{"text":"NodeListOf<HTMLElement>"},"privacy":"private"},{"kind":"field","name":"_isFooterEmpty","type":{"text":"boolean"},"privacy":"private","default":"true"},{"kind":"method","name":"_addTriggerListeners","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_closeModal","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"trigger","type":{"text":"EventTarget | null"}}]},{"kind":"method","name":"_openModal","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"trigger","type":{"text":"EventTarget | null"}}]},{"kind":"method","name":"_handleKeydown","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"KeyboardEvent"}}]},{"kind":"method","name":"_handleDialogClick","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"MouseEvent"}}]},{"kind":"method","name":"_handleTriggerClick","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"MouseEvent"}}]},{"kind":"method","name":"_focusContents","privacy":"private","return":{"type":{"text":"Promise<void>"}}},{"kind":"method","name":"_returnTriggerFocus","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_emitVisibilityChange","privacy":"private"},{"kind":"field","name":"descriptionContent","type":{"text":"TemplateResult | typeof nothing"},"privacy":"protected","readonly":true},{"kind":"field","name":"descriptionId","type":{"text":"string | undefined"},"privacy":"protected","readonly":true},{"kind":"method","name":"_handleFooterSlotchange","privacy":"private","parameters":[{"name":"e","type":{"text":"Event"}}]}],"events":[{"name":"pharos-modal-close","type":{"text":"CustomEvent"},"description":"Fires when the modal is about to close - cancelable"},{"name":"pharos-modal-open","type":{"text":"CustomEvent"},"description":"Fires when the modal is about to open - cancelable"},{"name":"pharos-modal-opened","type":{"text":"CustomEvent"},"description":"Fires when the modal has opened"},{"name":"pharos-modal-closed","type":{"text":"CustomEvent"},"description":"Fires when the modal has closed"}],"attributes":[{"name":"open","type":{"text":"boolean"},"default":"false","description":"Indicates if the modal is open.","fieldName":"open","attribute":"open"},{"name":"header","type":{"text":"string"},"default":"\'\'","description":"Text content for the modal header","fieldName":"header","attribute":"header"},{"name":"footer-divider","type":{"text":"boolean"},"default":"false","description":"Indicates if the modal footer should contain a divider.","fieldName":"footerDivider","attribute":"footer-divider"},{"name":"size","type":{"text":"ModalSize"},"default":"\'medium\'","description":"Indicates the size of the modal","fieldName":"size","attribute":"size"}],"mixins":[{"name":"ScopedRegistryMixin","module":"/src/utils/mixins/scoped-registry"}],"superclass":{"name":"PharosElement","module":"/src/components/base/pharos-element"},"tagName":"pharos-modal","customElement":true}],"exports":[{"kind":"js","name":"allSizes","declaration":{"name":"allSizes","module":"src/components/modal/pharos-modal.ts"}},{"kind":"js","name":"PharosModal","declaration":{"name":"PharosModal","module":"src/components/modal/pharos-modal.ts"}}]},{"kind":"javascript-module","path":"src/components/modal/storyArgs.ts","declarations":[{"kind":"variable","name":"defaultArgs","type":{"text":"object"},"default":"{\\n  size: \'medium\',\\n  open: false,\\n  footerDivider: true,\\n  header: \'Pharos modal\',\\n}"},{"kind":"variable","name":"argTypes","type":{"text":"object"},"default":"{\\n  size: {\\n    options: allSizes,\\n    control: {\\n      type: \'inline-radio\',\\n    },\\n  },\\n}"}],"exports":[{"kind":"js","name":"defaultArgs","declaration":{"name":"defaultArgs","module":"src/components/modal/storyArgs.ts"}},{"kind":"js","name":"argTypes","declaration":{"name":"argTypes","module":"src/components/modal/storyArgs.ts"}}]},{"kind":"javascript-module","path":"src/components/pagination/pharos-pagination.ts","declarations":[{"kind":"class","description":"Pharos pagination component.","name":"PharosPagination","members":[{"kind":"field","name":"elementDefinitions","type":{"text":"object"},"static":true,"default":"{\\n    \'pharos-icon\': PharosIcon,\\n    \'pharos-link\': PharosLink,\\n  }"},{"kind":"field","name":"totalResults","type":{"text":"number"},"privacy":"public","default":"0","description":"Indicates the total number of results.","attribute":"total-results","reflects":true},{"kind":"field","name":"pageSize","type":{"text":"number"},"privacy":"public","default":"25","description":"Indicates the maximum number of results on a page.","attribute":"page-size","reflects":true},{"kind":"field","name":"currentPage","type":{"text":"number"},"privacy":"public","default":"1","description":"Indicates the current page number.","attribute":"current-page","reflects":true},{"kind":"field","name":"totalPages","type":{"text":"number"},"privacy":"protected","readonly":true},{"kind":"method","name":"_handleClick","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"Event"}}]},{"kind":"method","name":"_renderPrevLink","privacy":"private","return":{"type":{"text":"TemplateResult | typeof nothing"}}},{"kind":"method","name":"_renderNextLink","privacy":"private","return":{"type":{"text":"TemplateResult | typeof nothing"}}}],"events":[{"name":"eventType","type":{"text":"Event"}},{"description":"Fires when the previous page link is clicked","name":"prev-page"},{"description":"Fires when the next page link is clicked","name":"next-page"}],"attributes":[{"name":"totalResults","type":{"text":"number"},"default":"0","description":"Indicates the total number of results.","fieldName":"totalResults"},{"name":"pageSize","type":{"text":"number"},"default":"25","description":"Indicates the maximum number of results on a page.","fieldName":"pageSize"},{"name":"currentPage","type":{"text":"number"},"default":"1","description":"Indicates the current page number.","fieldName":"currentPage"},{"name":"total-results","type":{"text":"number"},"default":"0","description":"Indicates the total number of results.","attribute":"totalResults","fieldName":"totalResults"},{"name":"page-size","type":{"text":"number"},"default":"25","description":"Indicates the maximum number of results on a page.","attribute":"pageSize","fieldName":"pageSize"},{"name":"current-page","type":{"text":"number"},"default":"1","description":"Indicates the current page number.","attribute":"currentPage","fieldName":"currentPage"}],"mixins":[{"name":"ScopedRegistryMixin","module":"/src/utils/mixins/scoped-registry"}],"superclass":{"name":"PharosElement","module":"/src/components/base/pharos-element"},"tagName":"pharos-pagination","customElement":true}],"exports":[{"kind":"js","name":"PharosPagination","declaration":{"name":"PharosPagination","module":"src/components/pagination/pharos-pagination.ts"}}]},{"kind":"javascript-module","path":"src/components/pagination/storyArgs.ts","declarations":[{"kind":"variable","name":"defaultArgs","type":{"text":"object"},"default":"{\\n  totalResults: 1146,\\n  pageSize: 25,\\n  currentPage: 2,\\n}"}],"exports":[{"kind":"js","name":"defaultArgs","declaration":{"name":"defaultArgs","module":"src/components/pagination/storyArgs.ts"}}]},{"kind":"javascript-module","path":"src/components/progress-bar/pharos-progress-bar.ts","declarations":[{"kind":"class","description":"Pharos progress bar component.","name":"PharosProgressBar","slots":[{"description":"Contains the title of what the progress bar pertains to.","name":"title"},{"description":"Contains additional text content to display below the bar.","name":"description"}],"members":[{"kind":"field","name":"value","type":{"text":"number"},"privacy":"public","default":"0","description":"Indicates the value for the progress bar.","attribute":"value","reflects":true}],"attributes":[{"name":"value","type":{"text":"number"},"default":"0","description":"Indicates the value for the progress bar.","fieldName":"value","attribute":"value"}],"superclass":{"name":"PharosElement","module":"/src/components/base/pharos-element"},"tagName":"pharos-progress-bar","customElement":true}],"exports":[{"kind":"js","name":"PharosProgressBar","declaration":{"name":"PharosProgressBar","module":"src/components/progress-bar/pharos-progress-bar.ts"}}]},{"kind":"javascript-module","path":"src/components/progress-bar/storyArgs.ts","declarations":[{"kind":"variable","name":"defaultArgs","type":{"text":"object"},"default":"{\\n  title: \'Title.xls\',\\n  value: 10,\\n  description: \'Processing\',\\n}"},{"kind":"variable","name":"argTypes","type":{"text":"object"},"default":"{\\n  value: {\\n    control: { type: \'range\', min: 0, max: 100, step: 10 },\\n  },\\n}"}],"exports":[{"kind":"js","name":"defaultArgs","declaration":{"name":"defaultArgs","module":"src/components/progress-bar/storyArgs.ts"}},{"kind":"js","name":"argTypes","declaration":{"name":"argTypes","module":"src/components/progress-bar/storyArgs.ts"}}]},{"kind":"javascript-module","path":"src/components/radio-button/pharos-radio-button.ts","declarations":[{"kind":"class","description":"Pharos radio button component.","name":"PharosRadioButton","slots":[{"description":"Contains the label content.","name":"label"}],"members":[{"kind":"field","name":"checked","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if radio is checked.","attribute":"checked","reflects":true},{"kind":"field","name":"value","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"Indicates the value for the input.","attribute":"value","reflects":true},{"kind":"field","name":"_radio","type":{"text":"HTMLInputElement"},"privacy":"private"},{"kind":"method","name":"onChange","privacy":"public","return":{"type":{"text":"void"}}},{"kind":"method","name":"_handleFormdata","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"CustomEvent"}}],"description":"Handles the `formdata` event.","inheritedFrom":{"name":"FormMixin","module":"src/utils/mixins/form.ts"}},{"kind":"method","name":"_handleFormReset","return":{"type":{"text":"void"}},"description":"Handles the `reset` event.","inheritedFrom":{"name":"FormMixin","module":"src/utils/mixins/form.ts"}},{"kind":"method","name":"_handleClick","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"Event"}}]},{"kind":"field","name":"name","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"Name for the form element.","attribute":"name","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"required","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if input is required.","attribute":"required","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"disabled","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if input is disabled.","attribute":"disabled","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"invalidated","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates an invalidated state.","attribute":"invalidated","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"validated","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates a validated state.","attribute":"validated","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"message","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"The message to display below the input.","attribute":"message","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"hideLabel","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the label should be hidden.","attribute":"hide-label","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"requiredIndicator","type":{"text":"TemplateResult | typeof nothing"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"messageContent","type":{"text":"TemplateResult | typeof nothing"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"messageId","type":{"text":"string | undefined"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"method","name":"focus","privacy":"public","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"FocusMixin","module":"src/utils/mixins/focus.ts"}}],"events":[{"name":"change","type":{"text":"Event"},"description":"Fires when the value has changed"}],"attributes":[{"name":"checked","type":{"text":"boolean"},"default":"false","description":"Indicates if radio is checked.","fieldName":"checked","attribute":"checked"},{"name":"value","type":{"text":"string"},"default":"\'\'","description":"Indicates the value for the input.","fieldName":"value","attribute":"value"},{"name":"name","type":{"text":"string"},"default":"\'\'","description":"Name for the form element.","fieldName":"name","attribute":"name","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"required","type":{"text":"boolean"},"default":"false","description":"Indicates if input is required.","fieldName":"required","attribute":"required","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"disabled","type":{"text":"boolean"},"default":"false","description":"Indicates if input is disabled.","fieldName":"disabled","attribute":"disabled","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"invalidated","type":{"text":"boolean"},"default":"false","description":"Indicates an invalidated state.","fieldName":"invalidated","attribute":"invalidated","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"validated","type":{"text":"boolean"},"default":"false","description":"Indicates a validated state.","fieldName":"validated","attribute":"validated","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"message","type":{"text":"string"},"default":"\'\'","description":"The message to display below the input.","fieldName":"message","attribute":"message","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"hide-label","type":{"text":"boolean"},"default":"false","description":"Indicates if the label should be hidden.","fieldName":"hideLabel","attribute":"hide-label","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}}],"mixins":[{"name":"FormMixin","module":"/src/utils/mixins/form"}],"superclass":{"name":"FormElement","module":"/src/components/base/form-element"},"tagName":"pharos-radio-button","customElement":true}],"exports":[{"kind":"js","name":"PharosRadioButton","declaration":{"name":"PharosRadioButton","module":"src/components/radio-button/pharos-radio-button.ts"}}]},{"kind":"javascript-module","path":"src/components/radio-button/storyArgs.ts","declarations":[{"kind":"variable","name":"defaultArgs","type":{"text":"object"},"default":"{\\n  label: \'Default Radio Button\',\\n  checked: false,\\n  disabled: false,\\n  hideLabel: false,\\n  invalidated: false,\\n  required: false,\\n  message: \'\',\\n}"}],"exports":[{"kind":"js","name":"defaultArgs","declaration":{"name":"defaultArgs","module":"src/components/radio-button/storyArgs.ts"}}]},{"kind":"javascript-module","path":"src/components/radio-group/pharos-radio-group.ts","declarations":[{"kind":"class","description":"Pharos radio group component.","name":"PharosRadioGroup","slots":[{"description":"Contains the fieldset legend content.","name":"legend"},{"description":"Contains the set of radio buttons (the default slot).","name":""},{"description":"Contains message content to show below the group.","name":"message"}],"members":[{"kind":"field","name":"horizontal","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Dictate if radio buttons should be displayed horizontally","attribute":"horizontal","reflects":true},{"kind":"field","name":"value","type":{"text":"string"},"privacy":"public","description":"Indicates the selected radio for the group","readonly":true},{"kind":"field","name":"_radioButtons","type":{"text":"NodeListOf<PharosRadioButton>"},"privacy":"private"},{"kind":"field","name":"_clicked","type":{"text":"boolean"},"privacy":"private","default":"false"},{"kind":"method","name":"_handleKeydown","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"KeyboardEvent"}}]},{"kind":"method","name":"_handleArrowKeys","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"moveForward","type":{"text":"boolean"}}]},{"kind":"method","name":"_updateSelection","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"value","type":{"text":"string"}}]},{"kind":"method","name":"_setRadios","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_addFocusListeners","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"field","name":"name","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"Name for the form element.","attribute":"name","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"required","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if input is required.","attribute":"required","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"disabled","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if input is disabled.","attribute":"disabled","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"invalidated","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates an invalidated state.","attribute":"invalidated","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"validated","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates a validated state.","attribute":"validated","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"message","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"The message to display below the input.","attribute":"message","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"hideLabel","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the label should be hidden.","attribute":"hide-label","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"requiredIndicator","type":{"text":"TemplateResult | typeof nothing"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"messageContent","type":{"text":"TemplateResult | typeof nothing"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"messageId","type":{"text":"string | undefined"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"method","name":"focus","privacy":"public","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"FocusMixin","module":"src/utils/mixins/focus.ts"}}],"events":[{"name":"change","type":{"text":"Event"},"description":"Fires when the value has changed"}],"attributes":[{"name":"horizontal","type":{"text":"boolean"},"default":"false","description":"Dictate if radio buttons should be displayed horizontally","fieldName":"horizontal","attribute":"horizontal"},{"name":"name","type":{"text":"string"},"default":"\'\'","description":"Name for the form element.","fieldName":"name","attribute":"name","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"required","type":{"text":"boolean"},"default":"false","description":"Indicates if input is required.","fieldName":"required","attribute":"required","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"disabled","type":{"text":"boolean"},"default":"false","description":"Indicates if input is disabled.","fieldName":"disabled","attribute":"disabled","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"invalidated","type":{"text":"boolean"},"default":"false","description":"Indicates an invalidated state.","fieldName":"invalidated","attribute":"invalidated","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"validated","type":{"text":"boolean"},"default":"false","description":"Indicates a validated state.","fieldName":"validated","attribute":"validated","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"message","type":{"text":"string"},"default":"\'\'","description":"The message to display below the input.","fieldName":"message","attribute":"message","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"hide-label","type":{"text":"boolean"},"default":"false","description":"Indicates if the label should be hidden.","fieldName":"hideLabel","attribute":"hide-label","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}}],"superclass":{"name":"FormElement","module":"/src/components/base/form-element"},"tagName":"pharos-radio-group","customElement":true}],"exports":[{"kind":"js","name":"PharosRadioGroup","declaration":{"name":"PharosRadioGroup","module":"src/components/radio-group/pharos-radio-group.ts"}}]},{"kind":"javascript-module","path":"src/components/radio-group/storyArgs.ts","declarations":[{"kind":"variable","name":"defaultArgs","type":{"text":"object"},"default":"{\\n  horizontal: false,\\n  disabled: false,\\n  hideLabel: false,\\n  required: false,\\n  invalidated: false,\\n  validated: false,\\n  name: \'group1\',\\n  message: \'\',\\n}"}],"exports":[{"kind":"js","name":"defaultArgs","declaration":{"name":"defaultArgs","module":"src/components/radio-group/storyArgs.ts"}}]},{"kind":"javascript-module","path":"src/components/select/pharos-select.ts","declarations":[{"kind":"class","description":"Pharos select component.","name":"PharosSelect","slots":[{"description":"Contains the label content.","name":"label"},{"description":"Contains the available options for the select (the default slot).","name":""},{"description":"Contains message content to show below the select.","name":"message"}],"members":[{"kind":"field","name":"elementDefinitions","type":{"text":"object"},"static":true,"default":"{\\n    \'pharos-icon\': PharosIcon,\\n  }"},{"kind":"field","name":"value","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"Indicates the value for the select.","attribute":"value","reflects":true},{"kind":"field","name":"_select","type":{"text":"HTMLSelectElement"},"privacy":"private"},{"kind":"field","name":"_options","type":{"text":"HTMLOptionElement[]"},"privacy":"private","readonly":true},{"kind":"method","name":"_setOption","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"onChange","privacy":"public","return":{"type":{"text":"void"}}},{"kind":"method","name":"_handleFormdata","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"CustomEvent"}}],"description":"Handles the `formdata` event.","inheritedFrom":{"name":"FormMixin","module":"src/utils/mixins/form.ts"}},{"kind":"method","name":"_handleFormReset","return":{"type":{"text":"void"}},"description":"Handles the `reset` event.","inheritedFrom":{"name":"FormMixin","module":"src/utils/mixins/form.ts"}},{"kind":"field","name":"_childrenObserver","type":{"text":"MutationObserver | null"},"privacy":"private","default":"null","inheritedFrom":{"name":"ObserveChildrenMixin","module":"src/utils/mixins/observe-children.ts"}},{"kind":"field","name":"_handleMutation","privacy":"private","inheritedFrom":{"name":"ObserveChildrenMixin","module":"src/utils/mixins/observe-children.ts"}},{"kind":"field","name":"name","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"Name for the form element.","attribute":"name","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"required","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if input is required.","attribute":"required","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"disabled","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if input is disabled.","attribute":"disabled","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"invalidated","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates an invalidated state.","attribute":"invalidated","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"validated","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates a validated state.","attribute":"validated","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"message","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"The message to display below the input.","attribute":"message","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"hideLabel","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the label should be hidden.","attribute":"hide-label","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"requiredIndicator","type":{"text":"TemplateResult | typeof nothing"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"messageContent","type":{"text":"TemplateResult | typeof nothing"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"messageId","type":{"text":"string | undefined"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"method","name":"focus","privacy":"public","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"FocusMixin","module":"src/utils/mixins/focus.ts"}}],"events":[{"name":"change","type":{"text":"Event"},"description":"Fires when the value has changed"}],"attributes":[{"name":"value","type":{"text":"string"},"default":"\'\'","description":"Indicates the value for the select.","fieldName":"value","attribute":"value"},{"name":"name","type":{"text":"string"},"default":"\'\'","description":"Name for the form element.","fieldName":"name","attribute":"name","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"required","type":{"text":"boolean"},"default":"false","description":"Indicates if input is required.","fieldName":"required","attribute":"required","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"disabled","type":{"text":"boolean"},"default":"false","description":"Indicates if input is disabled.","fieldName":"disabled","attribute":"disabled","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"invalidated","type":{"text":"boolean"},"default":"false","description":"Indicates an invalidated state.","fieldName":"invalidated","attribute":"invalidated","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"validated","type":{"text":"boolean"},"default":"false","description":"Indicates a validated state.","fieldName":"validated","attribute":"validated","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"message","type":{"text":"string"},"default":"\'\'","description":"The message to display below the input.","fieldName":"message","attribute":"message","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"hide-label","type":{"text":"boolean"},"default":"false","description":"Indicates if the label should be hidden.","fieldName":"hideLabel","attribute":"hide-label","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}}],"mixins":[{"name":"ScopedRegistryMixin","module":"/src/utils/mixins/scoped-registry"},{"name":"ObserveChildrenMixin","module":"/src/utils/mixins/observe-children"},{"name":"FormMixin","module":"/src/utils/mixins/form"}],"superclass":{"name":"FormElement","module":"/src/components/base/form-element"},"tagName":"pharos-select","customElement":true}],"exports":[{"kind":"js","name":"PharosSelect","declaration":{"name":"PharosSelect","module":"src/components/select/pharos-select.ts"}}]},{"kind":"javascript-module","path":"src/components/select/storyArgs.ts","declarations":[{"kind":"variable","name":"defaultArgs","type":{"text":"object"},"default":"{\\n  disabled: false,\\n  hideLabel: false,\\n  required: false,\\n  invalidated: false,\\n  validated: false,\\n  message: \'\',\\n  value: 3,\\n}"}],"exports":[{"kind":"js","name":"defaultArgs","declaration":{"name":"defaultArgs","module":"src/components/select/storyArgs.ts"}}]},{"kind":"javascript-module","path":"src/components/sidenav/pharos-sidenav-button.ts","declarations":[{"kind":"class","description":"Pharos sidenav button component.","name":"PharosSidenavButton","members":[{"kind":"method","name":"_handleClickOpen","privacy":"private","return":{"type":{"text":"Promise<void>"}}},{"kind":"field","name":"icon","type":{"text":"IconName | undefined"},"privacy":"public","description":"The icon to be shown as the content of the button.","attribute":"icon","reflects":true,"optional":true,"default":"\'menu\'","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"variant","type":{"text":"ButtonVariant"},"privacy":"public","default":"\'subtle\'","description":"Indicates the variant of button.","attribute":"variant","reflects":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"label","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the aria label to apply to the button.","attribute":"label","reflects":true,"optional":true,"default":"\'Open menu\'","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"elementDefinitions","type":{"text":"object"},"static":true,"default":"{\\n    \'pharos-icon\': PharosIcon,\\n  }","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"autofocus","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates that the button should have input focus when the page loads.","attribute":"autofocus","reflects":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"disabled","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates that the button cannot be pressed or focused by the user.","attribute":"disabled","reflects":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"type","type":{"text":"ButtonType | undefined"},"privacy":"public","description":"Indicates the default behavior of the button via the HTML5 attribute.","attribute":"type","reflects":true,"optional":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"iconCondensed","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Applies only to icon-only buttons. If true, the button will have minimal padding.","attribute":"icon-condensed","reflects":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"iconRight","type":{"text":"IconName | undefined"},"privacy":"public","description":"The icon to be shown on the right side.","attribute":"icon-right","reflects":true,"optional":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"iconLeft","type":{"text":"IconName | undefined"},"privacy":"public","description":"The icon to be shown on the left side.","attribute":"icon-left","reflects":true,"optional":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"onBackground","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates the button is on a AA compliant background.","attribute":"on-background","reflects":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"large","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates the button has more padding.","attribute":"large","reflects":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"fullWidth","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates the button\'s width should match its container.","attribute":"full-width","reflects":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"name","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the name when submitted with form data.","attribute":"name","reflects":true,"optional":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"value","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the value associated with the name when submitted with form data.","attribute":"value","reflects":true,"optional":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"pressed","type":{"text":"PressedState"},"privacy":"public","default":"\'undefined\'","description":"Indicates this button is a toggle button and whether it is pressed or not.","attribute":"pressed","reflects":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"_button","type":{"text":"HTMLButtonElement | HTMLAnchorElement"},"privacy":"private","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"_formButton","type":{"text":"HTMLButtonElement"},"privacy":"private","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"_form","type":{"text":"HTMLFormElement | null"},"privacy":"private","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"method","name":"_handleKeyup","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"KeyboardEvent"}}],"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"method","name":"_handleClick","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"MouseEvent"}}],"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"method","name":"_stopClickLeak","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"MouseEvent"}}],"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"method","name":"_renderIcon","privacy":"private","return":{"type":{"text":"TemplateResult | typeof nothing"}},"parameters":[{"name":"direction","default":"\'\'"}],"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"buttonContent","type":{"text":"TemplateResult"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"method","name":"focus","privacy":"public","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"FocusMixin","module":"src/utils/mixins/focus.ts"}},{"kind":"field","name":"download","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates to save the linked URL instead of navigating to it.","attribute":"download","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"href","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the URL that the hyperlink points to.","attribute":"href","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"hreflang","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the language of the linked URL.","attribute":"hreflang","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"ping","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the URLs to ping.","attribute":"ping","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"rel","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the type of link.","attribute":"rel","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"target","type":{"text":"LinkTarget | undefined"},"privacy":"public","description":"Indicates where to display the linked URL.","attribute":"target","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}}],"superclass":{"name":"PharosButton","module":"/src/components/button/pharos-button"},"tagName":"pharos-sidenav-button","customElement":true,"attributes":[{"name":"autofocus","type":{"text":"boolean"},"default":"false","description":"Indicates that the button should have input focus when the page loads.","fieldName":"autofocus","attribute":"autofocus","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"disabled","type":{"text":"boolean"},"default":"false","description":"Indicates that the button cannot be pressed or focused by the user.","fieldName":"disabled","attribute":"disabled","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"type","type":{"text":"ButtonType | undefined"},"description":"Indicates the default behavior of the button via the HTML5 attribute.","fieldName":"type","attribute":"type","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"variant","type":{"text":"ButtonVariant"},"default":"\'primary\'","description":"Indicates the variant of button.","fieldName":"variant","attribute":"variant","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"icon","type":{"text":"IconName | undefined"},"description":"The icon to be shown as the content of the button.","fieldName":"icon","attribute":"icon","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"icon-condensed","type":{"text":"boolean"},"default":"false","description":"Applies only to icon-only buttons. If true, the button will have minimal padding.","fieldName":"iconCondensed","attribute":"icon-condensed","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"icon-right","type":{"text":"IconName | undefined"},"description":"The icon to be shown on the right side.","fieldName":"iconRight","attribute":"icon-right","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"icon-left","type":{"text":"IconName | undefined"},"description":"The icon to be shown on the left side.","fieldName":"iconLeft","attribute":"icon-left","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"on-background","type":{"text":"boolean"},"default":"false","description":"Indicates the button is on a AA compliant background.","fieldName":"onBackground","attribute":"on-background","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"large","type":{"text":"boolean"},"default":"false","description":"Indicates the button has more padding.","fieldName":"large","attribute":"large","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"label","type":{"text":"string | undefined"},"description":"Indicates the aria label to apply to the button.","fieldName":"label","attribute":"label","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"full-width","type":{"text":"boolean"},"default":"false","description":"Indicates the button\'s width should match its container.","fieldName":"fullWidth","attribute":"full-width","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"name","type":{"text":"string | undefined"},"description":"Indicates the name when submitted with form data.","fieldName":"name","attribute":"name","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"value","type":{"text":"string | undefined"},"description":"Indicates the value associated with the name when submitted with form data.","fieldName":"value","default":"\'undefined\'","attribute":"value","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"pressed","type":{"text":"PressedState"},"default":"\'undefined\'","description":"Indicates this button is a toggle button and whether it is pressed or not.","attribute":"value","fieldName":"pressed","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"download","type":{"text":"string | undefined"},"description":"Indicates to save the linked URL instead of navigating to it.","fieldName":"download","attribute":"download","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"href","type":{"text":"string | undefined"},"description":"Indicates the URL that the hyperlink points to.","fieldName":"href","attribute":"href","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"hreflang","type":{"text":"string | undefined"},"description":"Indicates the language of the linked URL.","fieldName":"hreflang","attribute":"hreflang","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"ping","type":{"text":"string | undefined"},"description":"Indicates the URLs to ping.","fieldName":"ping","attribute":"ping","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"rel","type":{"text":"string | undefined"},"description":"Indicates the type of link.","fieldName":"rel","attribute":"rel","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"target","type":{"text":"LinkTarget | undefined"},"description":"Indicates where to display the linked URL.","fieldName":"target","attribute":"target","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}}]}],"exports":[{"kind":"js","name":"LinkTarget","declaration":{"name":"LinkTarget","module":"src/components/sidenav/pharos-sidenav-button.ts"}},{"kind":"js","name":"ButtonType","declaration":{"name":"ButtonType","module":"src/components/sidenav/pharos-sidenav-button.ts"}},{"kind":"js","name":"IconName","declaration":{"name":"IconName","module":"src/components/sidenav/pharos-sidenav-button.ts"}},{"kind":"js","name":"ButtonVariant","declaration":{"name":"ButtonVariant","module":"src/components/sidenav/pharos-sidenav-button.ts"}},{"kind":"js","name":"PressedState","declaration":{"name":"PressedState","module":"src/components/sidenav/pharos-sidenav-button.ts"}},{"kind":"js","name":"PharosSidenavButton","declaration":{"name":"PharosSidenavButton","module":"src/components/sidenav/pharos-sidenav-button.ts"}}]},{"kind":"javascript-module","path":"src/components/sidenav/pharos-sidenav-link.ts","declarations":[{"kind":"class","description":"Pharos sidenav link component.","name":"PharosSidenavLink","slots":[{"description":"Contains the content of the link (the default slot).","name":""}],"members":[{"kind":"field","name":"elementDefinitions","type":{"text":"object"},"static":true,"default":"{\\n    \'pharos-icon\': PharosIcon,\\n  }"},{"kind":"field","name":"isActive","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates the link is active","attribute":"is-active","reflects":true},{"kind":"field","name":"external","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates the link is external","attribute":"external","reflects":true},{"kind":"field","name":"menuItem","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates the link is a sidenav menu item","attribute":"menu-item","reflects":true},{"kind":"field","name":"appendContent","type":{"text":"TemplateResult | typeof nothing"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"kind":"field","name":"type","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the MIME type of the target.","attribute":"type","reflects":true,"optional":true,"inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"kind":"field","name":"subtle","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates the link should not have text decoration by default.","attribute":"subtle","reflects":true,"inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"kind":"field","name":"onBackground","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates the link is on a AA compliant background.","attribute":"on-background","reflects":true,"inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"kind":"field","name":"label","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the aria label to apply to the link.","attribute":"label","reflects":true,"optional":true,"inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"kind":"field","name":"bold","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the link should be bold.","attribute":"bold","reflects":true,"inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"kind":"field","name":"flex","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the link should display as a flex container.","attribute":"flex","reflects":true,"inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"kind":"field","name":"skip","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates the link is hidden until focused and skips to another element when clicked.","attribute":"skip","reflects":true,"inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"kind":"field","name":"noHover","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates the link should not have a hover state.","attribute":"no-hover","reflects":true,"inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"kind":"field","name":"indicateVisited","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the link should render the visited link styling.","attribute":"indicateVisited","reflects":true,"inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"kind":"field","name":"_alert","type":{"text":"boolean"},"privacy":"private","default":"false","inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"kind":"field","name":"_hover","type":{"text":"boolean"},"privacy":"private","default":"false","inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"kind":"method","name":"_handleClick","privacy":"private","return":{"type":{"text":"Promise<void>"}},"inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"kind":"method","name":"focus","privacy":"public","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"FocusMixin","module":"src/utils/mixins/focus.ts"}},{"kind":"field","name":"download","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates to save the linked URL instead of navigating to it.","attribute":"download","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"href","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the URL that the hyperlink points to.","attribute":"href","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"hreflang","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the language of the linked URL.","attribute":"hreflang","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"ping","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the URLs to ping.","attribute":"ping","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"rel","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the type of link.","attribute":"rel","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"target","type":{"text":"LinkTarget | undefined"},"privacy":"public","description":"Indicates where to display the linked URL.","attribute":"target","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}}],"attributes":[{"name":"is-active","type":{"text":"boolean"},"default":"false","description":"Indicates the link is active","fieldName":"isActive","attribute":"is-active"},{"name":"external","type":{"text":"boolean"},"default":"false","description":"Indicates the link is external","fieldName":"external","attribute":"external"},{"name":"menu-item","type":{"text":"boolean"},"default":"false","description":"Indicates the link is a sidenav menu item","attribute":"external","fieldName":"menuItem"},{"name":"type","type":{"text":"string | undefined"},"description":"Indicates the MIME type of the target.","fieldName":"type","attribute":"type","inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"name":"subtle","type":{"text":"boolean"},"default":"false","description":"Indicates the link should not have text decoration by default.","fieldName":"subtle","attribute":"subtle","inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"name":"on-background","type":{"text":"boolean"},"default":"false","description":"Indicates the link is on a AA compliant background.","fieldName":"onBackground","attribute":"on-background","inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"name":"label","type":{"text":"string | undefined"},"description":"Indicates the aria label to apply to the link.","fieldName":"label","attribute":"label","inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"name":"bold","type":{"text":"boolean"},"default":"false","description":"Indicates if the link should be bold.","fieldName":"bold","attribute":"bold","inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"name":"flex","type":{"text":"boolean"},"default":"false","description":"Indicates if the link should display as a flex container.","fieldName":"flex","attribute":"flex","inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"name":"skip","type":{"text":"boolean"},"default":"false","description":"Indicates the link is hidden until focused and skips to another element when clicked.","fieldName":"skip","attribute":"skip","inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"name":"no-hover","type":{"text":"boolean"},"default":"false","description":"Indicates the link should not have a hover state.","fieldName":"noHover","attribute":"no-hover","inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"name":"indicate-visited","type":{"text":"boolean"},"default":"false","description":"Indicates if the link should render the visited link styling.","fieldName":"indicateVisited","inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"name":"indicateVisited","type":{"text":"boolean"},"default":"false","description":"Indicates if the link should render the visited link styling.","attribute":"indicate-visited","fieldName":"indicateVisited","inheritedFrom":{"name":"PharosLink","module":"src/components/link/pharos-link.ts"}},{"name":"download","type":{"text":"string | undefined"},"description":"Indicates to save the linked URL instead of navigating to it.","fieldName":"download","attribute":"download","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"href","type":{"text":"string | undefined"},"description":"Indicates the URL that the hyperlink points to.","fieldName":"href","attribute":"href","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"hreflang","type":{"text":"string | undefined"},"description":"Indicates the language of the linked URL.","fieldName":"hreflang","attribute":"hreflang","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"ping","type":{"text":"string | undefined"},"description":"Indicates the URLs to ping.","fieldName":"ping","attribute":"ping","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"rel","type":{"text":"string | undefined"},"description":"Indicates the type of link.","fieldName":"rel","attribute":"rel","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"target","type":{"text":"LinkTarget | undefined"},"description":"Indicates where to display the linked URL.","fieldName":"target","attribute":"target","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}}],"mixins":[{"name":"ScopedRegistryMixin","module":"/src/utils/mixins/scoped-registry"}],"superclass":{"name":"PharosLink","module":"/src/components/link/pharos-link"},"tagName":"pharos-sidenav-link","customElement":true}],"exports":[{"kind":"js","name":"LinkTarget","declaration":{"name":"LinkTarget","module":"src/components/sidenav/pharos-sidenav-link.ts"}},{"kind":"js","name":"PharosSidenavLink","declaration":{"name":"PharosSidenavLink","module":"src/components/sidenav/pharos-sidenav-link.ts"}}]},{"kind":"javascript-module","path":"src/components/sidenav/pharos-sidenav-menu.ts","declarations":[{"kind":"class","description":"Pharos sidenav menu component.","name":"PharosSidenavMenu","slots":[{"description":"Contains the items of the menu (the default slot).","name":""}],"members":[{"kind":"field","name":"elementDefinitions","type":{"text":"object"},"static":true,"default":"{\\n    \'pharos-icon\': PharosIcon,\\n  }"},{"kind":"field","name":"label","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the label of the menu.","attribute":"label","reflects":true,"optional":true},{"kind":"field","name":"expanded","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates the menu is expanded","attribute":"expanded","reflects":true},{"kind":"field","name":"_allLinks","type":{"text":"NodeListOf<PharosSidenavLink>"},"privacy":"private"},{"kind":"method","name":"_handleKeydown","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"KeyboardEvent"}}]},{"kind":"method","name":"_handleClick","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_renderIcon","privacy":"private","return":{"type":{"text":"TemplateResult"}}},{"kind":"method","name":"_renderMenu","privacy":"private","return":{"type":{"text":"TemplateResult"}}},{"kind":"method","name":"focus","privacy":"public","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"FocusMixin","module":"src/utils/mixins/focus.ts"}}],"attributes":[{"name":"label","type":{"text":"string | undefined"},"description":"Indicates the label of the menu.","fieldName":"label","attribute":"label"},{"name":"expanded","type":{"text":"boolean"},"default":"false","description":"Indicates the menu is expanded","fieldName":"expanded","attribute":"expanded"}],"mixins":[{"name":"ScopedRegistryMixin","module":"/src/utils/mixins/scoped-registry"},{"name":"FocusMixin","module":"/src/utils/mixins/focus"}],"superclass":{"name":"PharosElement","module":"/src/components/base/pharos-element"},"tagName":"pharos-sidenav-menu","customElement":true}],"exports":[{"kind":"js","name":"PharosSidenavMenu","declaration":{"name":"PharosSidenavMenu","module":"src/components/sidenav/pharos-sidenav-menu.ts"}}]},{"kind":"javascript-module","path":"src/components/sidenav/pharos-sidenav-section.ts","declarations":[{"kind":"class","description":"Pharos sidenav section component.","name":"PharosSidenavSection","slots":[{"description":"Contains the content of the section (the default slot).","name":""}],"members":[{"kind":"field","name":"elementDefinitions","type":{"text":"object"},"static":true,"default":"{\\n    \'pharos-heading\': PharosHeading,\\n  }"},{"kind":"field","name":"label","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the label to apply to the section.","attribute":"label","reflects":true,"optional":true},{"kind":"field","name":"showDivider","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the section should contain a divider.","attribute":"show-divider","reflects":true},{"kind":"method","name":"_renderLabel","privacy":"private","return":{"type":{"text":"TemplateResult | typeof nothing"}}},{"kind":"method","name":"_renderDivider","privacy":"private","return":{"type":{"text":"TemplateResult | typeof nothing"}}}],"attributes":[{"name":"label","type":{"text":"string | undefined"},"description":"Indicates the label to apply to the section.","fieldName":"label","attribute":"label"},{"name":"show-divider","type":{"text":"boolean"},"default":"false","description":"Indicates if the section should contain a divider.","fieldName":"showDivider","attribute":"show-divider"}],"mixins":[{"name":"ScopedRegistryMixin","module":"/src/utils/mixins/scoped-registry"}],"superclass":{"name":"PharosElement","module":"/src/components/base/pharos-element"},"tagName":"pharos-sidenav-section","customElement":true}],"exports":[{"kind":"js","name":"PharosSidenavSection","declaration":{"name":"PharosSidenavSection","module":"src/components/sidenav/pharos-sidenav-section.ts"}}]},{"kind":"javascript-module","path":"src/components/sidenav/pharos-sidenav.ts","declarations":[{"kind":"class","description":"Pharos sidenav component.","name":"PharosSidenav","slots":[{"description":"Content to be shown at the top of the sidenav.","name":"top"},{"description":"Contains the sections of the sidenav (the default slot).","name":""}],"members":[{"kind":"field","name":"elementDefinitions","type":{"text":"object"},"static":true,"default":"{\\n    \'pharos-button\': PharosButton,\\n    \'pharos-link\': PharosLink,\\n  }"},{"kind":"field","name":"slide","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates that the sidenav should slide in.","attribute":"slide","reflects":true},{"kind":"field","name":"mainContentId","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the skip to target","attribute":"main-content-id","reflects":true,"optional":true},{"kind":"field","name":"_mediaQuery","type":{"text":"MediaQueryList"},"privacy":"private"},{"kind":"method","name":"_handleClickClose","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"Event"}}]},{"kind":"method","name":"_handleMediaChange","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"e","type":{"text":"MediaQueryListEvent"}}]},{"kind":"method","name":"_renderSkipToMain","privacy":"private","return":{"type":{"text":"TemplateResult | typeof nothing"}}},{"kind":"method","name":"focus","privacy":"public","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"FocusMixin","module":"src/utils/mixins/focus.ts"}}],"events":[{"name":"pharos-sidenav-close","type":{"text":"CustomEvent"},"description":"Fires when the sidenav has closed"}],"attributes":[{"name":"slide","type":{"text":"boolean"},"default":"false","description":"Indicates that the sidenav should slide in.","fieldName":"slide","attribute":"slide"},{"name":"main-content-id","type":{"text":"string | undefined"},"description":"Indicates the skip to target","fieldName":"mainContentId","attribute":"main-content-id"}],"mixins":[{"name":"ScopedRegistryMixin","module":"/src/utils/mixins/scoped-registry"},{"name":"FocusMixin","module":"/src/utils/mixins/focus"}],"superclass":{"name":"SideElement","module":"/src/components/base/side-element"},"tagName":"pharos-sidenav","customElement":true}],"exports":[{"kind":"js","name":"PharosSidenav","declaration":{"name":"PharosSidenav","module":"src/components/sidenav/pharos-sidenav.ts"}}]},{"kind":"javascript-module","path":"src/components/tabs/pharos-tab-panel.ts","declarations":[{"kind":"class","description":"Pharos tab panel component.","name":"PharosTabPanel","slots":[{"description":"Contains the content of the panel.","name":""}],"members":[{"kind":"field","name":"selected","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the panel is selected.","attribute":"selected","reflects":true},{"kind":"method","name":"_handleKeydown","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"KeyboardEvent"}}]}],"attributes":[{"name":"selected","type":{"text":"boolean"},"default":"false","description":"Indicates if the panel is selected.","fieldName":"selected","attribute":"selected"}],"superclass":{"name":"PharosElement","module":"/src/components/base/pharos-element"},"tagName":"pharos-tab-panel","customElement":true}],"exports":[{"kind":"js","name":"PharosTabPanel","declaration":{"name":"PharosTabPanel","module":"src/components/tabs/pharos-tab-panel.ts"}}]},{"kind":"javascript-module","path":"src/components/tabs/pharos-tab.ts","declarations":[{"kind":"class","description":"Pharos tab component.","name":"PharosTab","slots":[{"description":"Contains the content of the tab.","name":""}],"members":[{"kind":"field","name":"selected","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the tab is selected.","attribute":"selected","reflects":true},{"kind":"field","name":"_focused","type":{"text":"boolean"},"privacy":"private","default":"false"},{"kind":"method","name":"_triggerSelectedEvent","privacy":"private"},{"kind":"method","name":"_handleClick","privacy":"private","return":{"type":{"text":"void"}}}],"events":[{"name":"pharos-tab-selected","type":{"text":"CustomEvent"},"description":"Fires when the tab is selected."}],"attributes":[{"name":"selected","type":{"text":"boolean"},"default":"false","description":"Indicates if the tab is selected.","fieldName":"selected","attribute":"selected"}],"superclass":{"name":"PharosElement","module":"/src/components/base/pharos-element"},"tagName":"pharos-tab","customElement":true}],"exports":[{"kind":"js","name":"PharosTab","declaration":{"name":"PharosTab","module":"src/components/tabs/pharos-tab.ts"}}]},{"kind":"javascript-module","path":"src/components/tabs/pharos-tabs.ts","declarations":[{"kind":"class","description":"Pharos tabs component.","name":"PharosTabs","slots":[{"description":"Contains the tabs.","name":""},{"description":"Contains the panel to be shown for a tab.","name":"panel"}],"members":[{"kind":"field","name":"panelSeparator","type":{"text":"boolean"},"privacy":"public","default":"false","description":"If should display a panel separator.","attribute":"panel-separator","reflects":true},{"kind":"field","name":"_tabList","type":{"text":"HTMLElement"},"privacy":"private"},{"kind":"field","name":"_overflowingLeft","type":{"text":"boolean"},"privacy":"private","default":"false"},{"kind":"field","name":"_overflowingRight","type":{"text":"boolean"},"privacy":"private","default":"false"},{"kind":"field","name":"_tabs","type":{"text":"NodeListOf<PharosTab>"},"privacy":"private"},{"kind":"field","name":"_selectedTabs","type":{"text":"NodeListOf<PharosTab>"},"privacy":"private"},{"kind":"field","name":"_tabOverflowObserver","type":{"text":"IntersectionObserver"},"privacy":"private"},{"kind":"field","name":"_tabListResizeObserver","type":{"text":"ResizeObserver"},"privacy":"private"},{"kind":"method","name":"_watchTablistScrolling","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_makeTabVisible","privacy":"private","parameters":[{"name":"tab","type":{"text":"PharosTab"}}]},{"kind":"method","name":"_watchResize","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_selectInitialTab","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_queryPanelByTab","privacy":"private","return":{"type":{"text":"PharosTabPanel | null"}},"parameters":[{"name":"tab","type":{"text":"PharosTab"}}]},{"kind":"method","name":"_handleTabSelected","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"selectedTab","type":{"text":"PharosTab"}}]},{"kind":"method","name":"_handleKeydown","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"KeyboardEvent"}}]},{"kind":"method","name":"_handleArrowKeys","privacy":"private","return":{"type":{"text":"Promise<void>"}},"parameters":[{"name":"moveForward","type":{"text":"boolean"}}]},{"kind":"method","name":"_handleEnterKey","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_handleFocusout","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"FocusEvent"}}]},{"kind":"method","name":"_renderPanelSeparator","privacy":"private"},{"kind":"method","name":"_renderTabList","privacy":"private"},{"kind":"method","name":"_renderTabPanels","privacy":"private"}],"attributes":[{"name":"panel-separator","type":{"text":"boolean"},"default":"false","description":"If should display a panel separator.","fieldName":"panelSeparator","attribute":"panel-separator"}],"superclass":{"name":"PharosElement","module":"/src/components/base/pharos-element"},"tagName":"pharos-tabs","customElement":true}],"exports":[{"kind":"js","name":"PharosTabs","declaration":{"name":"PharosTabs","module":"src/components/tabs/pharos-tabs.ts"}}]},{"kind":"javascript-module","path":"src/components/text-input/pharos-text-input.ts","declarations":[{"kind":"variable","name":"allTypes","default":"[\\n  \'email\',\\n  \'hidden\',\\n  \'number\',\\n  \'password\',\\n  \'search\',\\n  \'tel\',\\n  \'text\',\\n  \'url\',\\n]"},{"kind":"class","description":"Pharos text input component.","name":"PharosTextInput","cssProperties":[{"type":{"text":"Length"},"description":"Text input height.","name":"--pharos-text-input-size-height-base"},{"type":{"text":"Color"},"description":"Fill color for valid state icon.","name":"--pharos-text-input-color-icon-valid"},{"type":{"text":"Color"},"description":"Fill color for invalidated state icon.","name":"--pharos-text-input-color-icon-invalid"}],"slots":[{"description":"Contains the label content.","name":"label"},{"description":"Contains message content to show below the input.","name":"message"}],"members":[{"kind":"field","name":"elementDefinitions","type":{"text":"object"},"static":true,"default":"{\\n    \'pharos-icon\': PharosIcon,\\n  }"},{"kind":"field","name":"value","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"Indicates input value.","attribute":"value","reflects":true},{"kind":"field","name":"type","type":{"text":"TextInputType"},"privacy":"public","default":"\'text\'","description":"Indicates the type of input.","attribute":"type","reflects":true},{"kind":"field","name":"variant","type":{"text":"TextInputVariant"},"privacy":"public","default":"\'primary\'","description":"Indicates the variant of text input.","attribute":"variant","reflects":true},{"kind":"field","name":"readonly","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if input is readonly.","attribute":"readonly","reflects":true},{"kind":"field","name":"autocomplete","type":{"text":"TextInputAutocomplete | undefined"},"privacy":"public","description":"Indicates if autocomplete is enabled","attribute":"autocomplete","reflects":true,"optional":true},{"kind":"field","name":"placeholder","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"Display text when input is empty","attribute":"placeholder","reflects":true},{"kind":"field","name":"minlength","type":{"text":"number | undefined"},"privacy":"public","description":"Defines the minimum number of characters the user can enter","attribute":"minlength","reflects":true,"optional":true},{"kind":"field","name":"maxlength","type":{"text":"number | undefined"},"privacy":"public","description":"Defines the maximum number of characters the user can enter","attribute":"maxlength","reflects":true,"optional":true},{"kind":"field","name":"pattern","type":{"text":"string | undefined"},"privacy":"public","description":"Pattern to validate the input against","attribute":"pattern","reflects":true,"optional":true},{"kind":"field","name":"onBackground","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates the input is on a AA compliant background.","attribute":"on-background","reflects":true},{"kind":"field","name":"_input","type":{"text":"HTMLInputElement"},"privacy":"protected"},{"kind":"field","name":"_inputIcon","type":{"text":"HTMLInputElement"},"privacy":"protected"},{"kind":"method","name":"onChange","privacy":"public","return":{"type":{"text":"void"}}},{"kind":"method","name":"onInput","privacy":"public","return":{"type":{"text":"void"}}},{"kind":"method","name":"_renderIcons","privacy":"private","return":{"type":{"text":"TemplateResult | typeof nothing"}}},{"kind":"method","name":"_handleKeydown","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"KeyboardEvent"}}]},{"kind":"method","name":"_handleFormdata","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"CustomEvent"}}],"description":"Handles the `formdata` event.","inheritedFrom":{"name":"FormMixin","module":"src/utils/mixins/form.ts"}},{"kind":"method","name":"_handleFormReset","return":{"type":{"text":"void"}},"description":"Handles the `reset` event.","inheritedFrom":{"name":"FormMixin","module":"src/utils/mixins/form.ts"}},{"kind":"field","name":"prependContent","type":{"text":"TemplateResult | typeof nothing"},"privacy":"protected","readonly":true},{"kind":"field","name":"appendContent","type":{"text":"TemplateResult | typeof nothing"},"privacy":"protected","readonly":true},{"kind":"field","name":"name","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"Name for the form element.","attribute":"name","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"required","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if input is required.","attribute":"required","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"disabled","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if input is disabled.","attribute":"disabled","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"invalidated","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates an invalidated state.","attribute":"invalidated","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"validated","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates a validated state.","attribute":"validated","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"message","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"The message to display below the input.","attribute":"message","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"hideLabel","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the label should be hidden.","attribute":"hide-label","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"requiredIndicator","type":{"text":"TemplateResult | typeof nothing"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"messageContent","type":{"text":"TemplateResult | typeof nothing"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"messageId","type":{"text":"string | undefined"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"method","name":"focus","privacy":"public","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"FocusMixin","module":"src/utils/mixins/focus.ts"}}],"events":[{"name":"change","type":{"text":"Event"},"description":"Fires when the element loses focus, after the content has changed"},{"description":"Fires when the value has changed","name":"input"}],"attributes":[{"name":"value","type":{"text":"string"},"default":"\'\'","description":"Indicates input value.","fieldName":"value","attribute":"value"},{"name":"type","type":{"text":"TextInputType"},"default":"\'text\'","description":"Indicates the type of input.","fieldName":"type","attribute":"type"},{"name":"variant","type":{"text":"TextInputVariant"},"default":"\'primary\'","description":"Indicates the variant of text input.","fieldName":"variant","attribute":"variant"},{"name":"readonly","type":{"text":"boolean"},"default":"false","description":"Indicates if input is readonly.","fieldName":"readonly","attribute":"readonly"},{"name":"autocomplete","type":{"text":"TextInputAutocomplete | undefined"},"description":"Indicates if autocomplete is enabled","fieldName":"autocomplete","attribute":"autocomplete"},{"name":"placeholder","type":{"text":"string"},"default":"\'\'","description":"Display text when input is empty","fieldName":"placeholder","attribute":"placeholder"},{"name":"minlength","type":{"text":"number | undefined"},"description":"Defines the minimum number of characters the user can enter","fieldName":"minlength","attribute":"minlength"},{"name":"maxlength","type":{"text":"number | undefined"},"description":"Defines the maximum number of characters the user can enter","fieldName":"maxlength","attribute":"maxlength"},{"name":"pattern","type":{"text":"string | undefined"},"description":"Pattern to validate the input against","fieldName":"pattern","attribute":"pattern"},{"name":"on-background","type":{"text":"boolean"},"default":"false","description":"Indicates the input is on a AA compliant background.","fieldName":"onBackground","attribute":"on-background"},{"name":"name","type":{"text":"string"},"default":"\'\'","description":"Name for the form element.","fieldName":"name","attribute":"name","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"required","type":{"text":"boolean"},"default":"false","description":"Indicates if input is required.","fieldName":"required","attribute":"required","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"disabled","type":{"text":"boolean"},"default":"false","description":"Indicates if input is disabled.","fieldName":"disabled","attribute":"disabled","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"invalidated","type":{"text":"boolean"},"default":"false","description":"Indicates an invalidated state.","fieldName":"invalidated","attribute":"invalidated","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"validated","type":{"text":"boolean"},"default":"false","description":"Indicates a validated state.","fieldName":"validated","attribute":"validated","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"message","type":{"text":"string"},"default":"\'\'","description":"The message to display below the input.","fieldName":"message","attribute":"message","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"hide-label","type":{"text":"boolean"},"default":"false","description":"Indicates if the label should be hidden.","fieldName":"hideLabel","attribute":"hide-label","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}}],"mixins":[{"name":"ScopedRegistryMixin","module":"/src/utils/mixins/scoped-registry"},{"name":"FormMixin","module":"/src/utils/mixins/form"}],"superclass":{"name":"FormElement","module":"/src/components/base/form-element"},"tagName":"pharos-text-input","customElement":true}],"exports":[{"kind":"js","name":"allTypes","declaration":{"name":"allTypes","module":"src/components/text-input/pharos-text-input.ts"}},{"kind":"js","name":"PharosTextInput","declaration":{"name":"PharosTextInput","module":"src/components/text-input/pharos-text-input.ts"}}]},{"kind":"javascript-module","path":"src/components/text-input/storyArgs.ts","declarations":[{"kind":"variable","name":"defaultArgs","type":{"text":"object"},"default":"{\\n  name: \'story-input\',\\n  type: \'text\',\\n  label: \'I am a label\',\\n  hideLabel: false,\\n  validated: false,\\n  invalidated: false,\\n  required: false,\\n  message: \'\',\\n  placeholder: \'placeholder\',\\n  disabled: false,\\n  readonly: false,\\n  value: \'\',\\n}"},{"kind":"variable","name":"argTypes","type":{"text":"object"},"default":"{\\n  type: {\\n    options: allTypes,\\n    control: {\\n      type: \'inline-radio\',\\n    },\\n  },\\n}"}],"exports":[{"kind":"js","name":"defaultArgs","declaration":{"name":"defaultArgs","module":"src/components/text-input/storyArgs.ts"}},{"kind":"js","name":"argTypes","declaration":{"name":"argTypes","module":"src/components/text-input/storyArgs.ts"}}]},{"kind":"javascript-module","path":"src/components/textarea/pharos-textarea.ts","declarations":[{"kind":"class","description":"Pharos text input component.","name":"PharosTextarea","cssProperties":[{"type":{"text":"Length"},"description":"Text input font size.","name":"--pharos-textarea-size-text-base"}],"slots":[{"description":"Contains the label content.","name":"label"},{"description":"Contains message content to show below the input.","name":"message"}],"members":[{"kind":"field","name":"value","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"Indicates textarea value.","attribute":"value","reflects":true},{"kind":"field","name":"cols","type":{"text":"number"},"privacy":"public","default":"20","description":"Indicates width of text area.","attribute":"cols","reflects":true},{"kind":"field","name":"dirname","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"Sends the direction the text is read with the name.","attribute":"dirname","reflects":true},{"kind":"field","name":"maxlength","type":{"text":"number | undefined"},"privacy":"public","description":"Defines the maximum number of characters the user can enter","attribute":"maxlength","reflects":true,"optional":true},{"kind":"field","name":"minlength","type":{"text":"number | undefined"},"privacy":"public","description":"Defines the minimum number of characters the user can enter","attribute":"minlength","reflects":true,"optional":true},{"kind":"field","name":"placeholder","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"Display text when textarea is empty","attribute":"placeholder","reflects":true},{"kind":"field","name":"readonly","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if textarea is readonly.","attribute":"readonly","reflects":true},{"kind":"field","name":"rows","type":{"text":"number"},"privacy":"public","default":"2","description":"Indicates how many rows should the textarea be.","attribute":"rows","reflects":true},{"kind":"field","name":"resize","type":{"text":"TextAreaResize"},"privacy":"public","default":"\'both\'","description":"Makes the text area resizeable","attribute":"resize","reflects":true},{"kind":"field","name":"wrap","type":{"text":"TextAreaWrap"},"privacy":"public","default":"\'soft\'","description":"Indicate whether the sumbitted value should be wrapped (Include new lines)","attribute":"wrap","reflects":true},{"kind":"field","name":"pattern","type":{"text":"string | undefined"},"privacy":"public","description":"Pattern to validate the textarea against","attribute":"pattern","reflects":true,"optional":true},{"kind":"field","name":"_textarea","type":{"text":"HTMLTextAreaElement"},"privacy":"private"},{"kind":"method","name":"onChange","privacy":"public","return":{"type":{"text":"void"}}},{"kind":"method","name":"onInput","privacy":"public","return":{"type":{"text":"void"}}},{"kind":"method","name":"_handleFormdata","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"CustomEvent"}}],"description":"Handles the `formdata` event.","inheritedFrom":{"name":"FormMixin","module":"src/utils/mixins/form.ts"}},{"kind":"method","name":"_handleFormReset","return":{"type":{"text":"void"}},"description":"Handles the `reset` event.","inheritedFrom":{"name":"FormMixin","module":"src/utils/mixins/form.ts"}},{"kind":"field","name":"name","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"Name for the form element.","attribute":"name","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"required","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if input is required.","attribute":"required","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"disabled","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if input is disabled.","attribute":"disabled","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"invalidated","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates an invalidated state.","attribute":"invalidated","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"validated","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates a validated state.","attribute":"validated","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"message","type":{"text":"string"},"privacy":"public","default":"\'\'","description":"The message to display below the input.","attribute":"message","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"hideLabel","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the label should be hidden.","attribute":"hide-label","reflects":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"requiredIndicator","type":{"text":"TemplateResult | typeof nothing"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"messageContent","type":{"text":"TemplateResult | typeof nothing"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"field","name":"messageId","type":{"text":"string | undefined"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"kind":"method","name":"focus","privacy":"public","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"FocusMixin","module":"src/utils/mixins/focus.ts"}}],"events":[{"name":"change","type":{"text":"Event"},"description":"Fires when the element loses focus, after the content has changed"},{"description":"Fires when the value has changed","name":"input"}],"attributes":[{"name":"value","type":{"text":"string"},"default":"\'\'","description":"Indicates textarea value.","fieldName":"value","attribute":"value"},{"name":"cols","type":{"text":"number"},"default":"20","description":"Indicates width of text area.","fieldName":"cols","attribute":"cols"},{"name":"dirname","type":{"text":"string"},"default":"\'\'","description":"Sends the direction the text is read with the name.","fieldName":"dirname","attribute":"dirname"},{"name":"maxlength","type":{"text":"number | undefined"},"description":"Defines the maximum number of characters the user can enter","fieldName":"maxlength","attribute":"maxlength"},{"name":"minlength","type":{"text":"number | undefined"},"description":"Defines the minimum number of characters the user can enter","fieldName":"minlength","attribute":"minlength"},{"name":"placeholder","type":{"text":"string"},"default":"\'\'","description":"Display text when textarea is empty","fieldName":"placeholder","attribute":"placeholder"},{"name":"readonly","type":{"text":"boolean"},"default":"false","description":"Indicates if textarea is readonly.","fieldName":"readonly","attribute":"readonly"},{"name":"rows","type":{"text":"number"},"default":"2","description":"Indicates how many rows should the textarea be.","fieldName":"rows","attribute":"rows"},{"name":"resize","type":{"text":"TextAreaResize"},"default":"\'both\'","description":"Makes the text area resizeable","fieldName":"resize","attribute":"resize"},{"name":"wrap","type":{"text":"TextAreaWrap"},"default":"\'soft\'","description":"Indicate whether the sumbitted value should be wrapped (Include new lines)","fieldName":"wrap","attribute":"wrap"},{"name":"pattern","type":{"text":"string | undefined"},"description":"Pattern to validate the textarea against","fieldName":"pattern","attribute":"pattern"},{"name":"name","type":{"text":"string"},"default":"\'\'","description":"Name for the form element.","fieldName":"name","attribute":"name","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"required","type":{"text":"boolean"},"default":"false","description":"Indicates if input is required.","fieldName":"required","attribute":"required","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"disabled","type":{"text":"boolean"},"default":"false","description":"Indicates if input is disabled.","fieldName":"disabled","attribute":"disabled","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"invalidated","type":{"text":"boolean"},"default":"false","description":"Indicates an invalidated state.","fieldName":"invalidated","attribute":"invalidated","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"validated","type":{"text":"boolean"},"default":"false","description":"Indicates a validated state.","fieldName":"validated","attribute":"validated","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"message","type":{"text":"string"},"default":"\'\'","description":"The message to display below the input.","fieldName":"message","attribute":"message","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}},{"name":"hide-label","type":{"text":"boolean"},"default":"false","description":"Indicates if the label should be hidden.","fieldName":"hideLabel","attribute":"hide-label","inheritedFrom":{"name":"FormElement","module":"src/components/base/form-element.ts"}}],"mixins":[{"name":"FormMixin","module":"/src/utils/mixins/form"}],"superclass":{"name":"FormElement","module":"/src/components/base/form-element"},"tagName":"pharos-textarea","customElement":true}],"exports":[{"kind":"js","name":"PharosTextarea","declaration":{"name":"PharosTextarea","module":"src/components/textarea/pharos-textarea.ts"}}]},{"kind":"javascript-module","path":"src/components/textarea/storyArgs.ts","declarations":[{"kind":"variable","name":"defaultArgs","type":{"text":"object"},"default":"{\\n  name: \'story-input\',\\n  label: \'I am a label\',\\n  disabled: false,\\n  hideLabel: false,\\n  invalidated: false,\\n  validated: false,\\n  message: \'\',\\n  placeholder: \'Enter some text\',\\n  readonly: false,\\n  required: false,\\n  value: \'Some text\',\\n  rows: 2,\\n  columns: 20,\\n}"}],"exports":[{"kind":"js","name":"defaultArgs","declaration":{"name":"defaultArgs","module":"src/components/textarea/storyArgs.ts"}}]},{"kind":"javascript-module","path":"src/components/toast/pharos-toast-button.ts","declarations":[{"kind":"class","description":"Pharos toast button component.","name":"PharosToastButton","members":[{"kind":"field","name":"icon","type":{"text":"IconName | undefined"},"privacy":"public","description":"The icon to be shown as the content of the button.","attribute":"icon","reflects":true,"optional":true,"default":"\'close\'","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"variant","type":{"text":"ButtonVariant"},"privacy":"public","default":"\'subtle\'","description":"Indicates the variant of button.","attribute":"variant","reflects":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"label","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the aria label to apply to the button.","attribute":"label","reflects":true,"optional":true,"default":"\'Dismiss\'","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"onBackground","type":{"text":"boolean"},"privacy":"public","default":"true","description":"Indicates the button is on a AA compliant background.","attribute":"on-background","reflects":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"iconCondensed","type":{"text":"boolean"},"privacy":"public","default":"true","description":"Applies only to icon-only buttons. If true, the button will have minimal padding.","attribute":"icon-condensed","reflects":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"elementDefinitions","type":{"text":"object"},"static":true,"default":"{\\n    \'pharos-icon\': PharosIcon,\\n  }","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"autofocus","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates that the button should have input focus when the page loads.","attribute":"autofocus","reflects":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"disabled","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates that the button cannot be pressed or focused by the user.","attribute":"disabled","reflects":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"type","type":{"text":"ButtonType | undefined"},"privacy":"public","description":"Indicates the default behavior of the button via the HTML5 attribute.","attribute":"type","reflects":true,"optional":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"iconRight","type":{"text":"IconName | undefined"},"privacy":"public","description":"The icon to be shown on the right side.","attribute":"icon-right","reflects":true,"optional":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"iconLeft","type":{"text":"IconName | undefined"},"privacy":"public","description":"The icon to be shown on the left side.","attribute":"icon-left","reflects":true,"optional":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"large","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates the button has more padding.","attribute":"large","reflects":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"fullWidth","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates the button\'s width should match its container.","attribute":"full-width","reflects":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"name","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the name when submitted with form data.","attribute":"name","reflects":true,"optional":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"value","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the value associated with the name when submitted with form data.","attribute":"value","reflects":true,"optional":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"pressed","type":{"text":"PressedState"},"privacy":"public","default":"\'undefined\'","description":"Indicates this button is a toggle button and whether it is pressed or not.","attribute":"pressed","reflects":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"_button","type":{"text":"HTMLButtonElement | HTMLAnchorElement"},"privacy":"private","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"_formButton","type":{"text":"HTMLButtonElement"},"privacy":"private","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"_form","type":{"text":"HTMLFormElement | null"},"privacy":"private","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"method","name":"_handleKeyup","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"KeyboardEvent"}}],"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"method","name":"_handleClick","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"MouseEvent"}}],"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"method","name":"_stopClickLeak","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"MouseEvent"}}],"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"method","name":"_renderIcon","privacy":"private","return":{"type":{"text":"TemplateResult | typeof nothing"}},"parameters":[{"name":"direction","default":"\'\'"}],"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"buttonContent","type":{"text":"TemplateResult"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"method","name":"focus","privacy":"public","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"FocusMixin","module":"src/utils/mixins/focus.ts"}},{"kind":"field","name":"download","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates to save the linked URL instead of navigating to it.","attribute":"download","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"href","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the URL that the hyperlink points to.","attribute":"href","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"hreflang","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the language of the linked URL.","attribute":"hreflang","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"ping","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the URLs to ping.","attribute":"ping","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"rel","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the type of link.","attribute":"rel","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"target","type":{"text":"LinkTarget | undefined"},"privacy":"public","description":"Indicates where to display the linked URL.","attribute":"target","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}}],"superclass":{"name":"PharosButton","module":"/src/components/button/pharos-button"},"tagName":"pharos-toast-button","customElement":true,"attributes":[{"name":"autofocus","type":{"text":"boolean"},"default":"false","description":"Indicates that the button should have input focus when the page loads.","fieldName":"autofocus","attribute":"autofocus","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"disabled","type":{"text":"boolean"},"default":"false","description":"Indicates that the button cannot be pressed or focused by the user.","fieldName":"disabled","attribute":"disabled","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"type","type":{"text":"ButtonType | undefined"},"description":"Indicates the default behavior of the button via the HTML5 attribute.","fieldName":"type","attribute":"type","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"variant","type":{"text":"ButtonVariant"},"default":"\'primary\'","description":"Indicates the variant of button.","fieldName":"variant","attribute":"variant","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"icon","type":{"text":"IconName | undefined"},"description":"The icon to be shown as the content of the button.","fieldName":"icon","attribute":"icon","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"icon-condensed","type":{"text":"boolean"},"default":"false","description":"Applies only to icon-only buttons. If true, the button will have minimal padding.","fieldName":"iconCondensed","attribute":"icon-condensed","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"icon-right","type":{"text":"IconName | undefined"},"description":"The icon to be shown on the right side.","fieldName":"iconRight","attribute":"icon-right","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"icon-left","type":{"text":"IconName | undefined"},"description":"The icon to be shown on the left side.","fieldName":"iconLeft","attribute":"icon-left","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"on-background","type":{"text":"boolean"},"default":"false","description":"Indicates the button is on a AA compliant background.","fieldName":"onBackground","attribute":"on-background","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"large","type":{"text":"boolean"},"default":"false","description":"Indicates the button has more padding.","fieldName":"large","attribute":"large","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"label","type":{"text":"string | undefined"},"description":"Indicates the aria label to apply to the button.","fieldName":"label","attribute":"label","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"full-width","type":{"text":"boolean"},"default":"false","description":"Indicates the button\'s width should match its container.","fieldName":"fullWidth","attribute":"full-width","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"name","type":{"text":"string | undefined"},"description":"Indicates the name when submitted with form data.","fieldName":"name","attribute":"name","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"value","type":{"text":"string | undefined"},"description":"Indicates the value associated with the name when submitted with form data.","fieldName":"value","default":"\'undefined\'","attribute":"value","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"pressed","type":{"text":"PressedState"},"default":"\'undefined\'","description":"Indicates this button is a toggle button and whether it is pressed or not.","attribute":"value","fieldName":"pressed","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"download","type":{"text":"string | undefined"},"description":"Indicates to save the linked URL instead of navigating to it.","fieldName":"download","attribute":"download","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"href","type":{"text":"string | undefined"},"description":"Indicates the URL that the hyperlink points to.","fieldName":"href","attribute":"href","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"hreflang","type":{"text":"string | undefined"},"description":"Indicates the language of the linked URL.","fieldName":"hreflang","attribute":"hreflang","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"ping","type":{"text":"string | undefined"},"description":"Indicates the URLs to ping.","fieldName":"ping","attribute":"ping","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"rel","type":{"text":"string | undefined"},"description":"Indicates the type of link.","fieldName":"rel","attribute":"rel","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"target","type":{"text":"LinkTarget | undefined"},"description":"Indicates where to display the linked URL.","fieldName":"target","attribute":"target","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}}]}],"exports":[{"kind":"js","name":"LinkTarget","declaration":{"name":"LinkTarget","module":"src/components/toast/pharos-toast-button.ts"}},{"kind":"js","name":"ButtonType","declaration":{"name":"ButtonType","module":"src/components/toast/pharos-toast-button.ts"}},{"kind":"js","name":"IconName","declaration":{"name":"IconName","module":"src/components/toast/pharos-toast-button.ts"}},{"kind":"js","name":"ButtonVariant","declaration":{"name":"ButtonVariant","module":"src/components/toast/pharos-toast-button.ts"}},{"kind":"js","name":"PressedState","declaration":{"name":"PressedState","module":"src/components/toast/pharos-toast-button.ts"}},{"kind":"js","name":"PharosToastButton","declaration":{"name":"PharosToastButton","module":"src/components/toast/pharos-toast-button.ts"}}]},{"kind":"javascript-module","path":"src/components/toast/pharos-toast.ts","declarations":[{"kind":"variable","name":"DEFAULT_STATUS","type":{"text":"string"},"default":"\'success\'"},{"kind":"variable","name":"DEFAULT_INDEFINITE","type":{"text":"boolean"},"default":"false"},{"kind":"class","description":"Pharos toast component.","name":"PharosToast","slots":[{"description":"Content inside the toast (the default slot).","name":""}],"members":[{"kind":"field","name":"elementDefinitions","type":{"text":"object"},"static":true,"default":"{\\n    \'pharos-icon\': PharosIcon,\\n    \'pharos-toast-button\': PharosToastButton,\\n  }"},{"kind":"field","name":"status","type":{"text":"ToastStatus"},"privacy":"public","default":"\'success\'","description":"The status to reflect to the user.","attribute":"status","reflects":true},{"kind":"field","name":"open","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the toast is open.","attribute":"open","reflects":true},{"kind":"field","name":"id","type":{"text":"string"},"privacy":"public","default":"\'toast\'","description":"The optional id passed to the toast. Can be used as a handle so the toast can be updated.","attribute":"id","reflects":true},{"kind":"field","name":"indefinite","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the toast should persist indefinitely","attribute":"indefinite","reflects":true},{"kind":"field","name":"_timer","type":{"text":"number | void"},"privacy":"private","default":"0"},{"kind":"field","name":"_debouncer","type":{"text":"Procedure"},"privacy":"private"},{"kind":"method","name":"_handleTimer","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"FocusEvent"}}]},{"kind":"method","name":"_getIcon","privacy":"private","return":{"type":{"text":"TOAST_ICON"}}},{"kind":"method","name":"close","privacy":"public","return":{"type":{"text":"void"}}},{"kind":"method","name":"focus","privacy":"public","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"FocusMixin","module":"src/utils/mixins/focus.ts"}}],"events":[{"name":"pharos-toast-close","type":{"text":"CustomEvent"},"description":"Fires when the toast has closed"}],"attributes":[{"name":"status","type":{"text":"ToastStatus"},"default":"DEFAULT_STATUS","description":"The status to reflect to the user.","resolveInitializer":{"module":"src/components/toast/pharos-toast.ts"},"fieldName":"status","attribute":"status"},{"name":"open","type":{"text":"boolean"},"default":"false","description":"Indicates if the toast is open.","fieldName":"open","attribute":"open"},{"name":"id","type":{"text":"string"},"default":"\'toast\'","description":"The optional id passed to the toast. Can be used as a handle so the toast can be updated.","fieldName":"id","attribute":"id"},{"name":"indefinite","type":{"text":"boolean"},"default":"false","description":"Indicates if the toast should persist indefinitely","fieldName":"indefinite","attribute":"indefinite"}],"mixins":[{"name":"ScopedRegistryMixin","module":"/src/utils/mixins/scoped-registry"},{"name":"FocusMixin","module":"/src/utils/mixins/focus"}],"superclass":{"name":"PharosElement","module":"/src/components/base/pharos-element"},"tagName":"pharos-toast","customElement":true}],"exports":[{"kind":"js","name":"DEFAULT_STATUS","declaration":{"name":"DEFAULT_STATUS","module":"src/components/toast/pharos-toast.ts"}},{"kind":"js","name":"DEFAULT_INDEFINITE","declaration":{"name":"DEFAULT_INDEFINITE","module":"src/components/toast/pharos-toast.ts"}},{"kind":"js","name":"PharosToast","declaration":{"name":"PharosToast","module":"src/components/toast/pharos-toast.ts"}}]},{"kind":"javascript-module","path":"src/components/toast/pharos-toaster.ts","declarations":[{"kind":"class","description":"Pharos toaster component.","name":"PharosToaster","slots":[{"description":"Contains the toasts (the default slot).","name":""}],"members":[{"kind":"method","name":"_getToastID","privacy":"private","parameters":[{"name":"id","type":{"text":"string | null"}}]},{"kind":"method","name":"_openToast","privacy":"private","return":{"type":{"text":"Promise<void>"}},"parameters":[{"name":"event","type":{"text":"Event"}}]},{"kind":"method","name":"_updateToast","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"CustomEvent"}}]},{"kind":"method","name":"_closeToast","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"CustomEvent"}}]},{"type":{"text":"ToastStatus"},"description":"The status for the toast.","name":"status","kind":"field"},{"type":{"text":"string"},"description":"The content to slot into the toast.","name":"content","kind":"field"}],"events":[{"name":"pharos-toast-open"}],"superclass":{"name":"PharosElement","module":"/src/components/base/pharos-element"},"tagName":"pharos-toaster","customElement":true}],"exports":[{"kind":"js","name":"PharosToaster","declaration":{"name":"PharosToaster","module":"src/components/toast/pharos-toaster.ts"}}]},{"kind":"javascript-module","path":"src/components/toggle-button-group/pharos-toggle-button-group.ts","declarations":[{"kind":"class","description":"Pharos toggle button group component.","name":"PharosToggleButtonGroup","slots":[{"description":"Contains the buttons.","name":""}],"members":[{"kind":"field","name":"groupLabel","type":{"text":"string"},"privacy":"public","default":"\'Options\'","description":"The label used to announce this group to assistive technologies.","attribute":"group-label","reflects":true},{"kind":"field","name":"_allToggleButtons","type":{"text":"NodeListOf<PharosToggleButton>"},"privacy":"private"},{"kind":"field","name":"_selectedToggleButtons","type":{"text":"NodeListOf<PharosToggleButton>"},"privacy":"private"},{"kind":"method","name":"_selectInitialToggleButton","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"toggleButtons","type":{"text":"PharosToggleButton[]"}}]},{"kind":"method","name":"_handleButtonSelected","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"Event"}}]},{"kind":"method","name":"_handleKeydown","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"KeyboardEvent"}}]},{"kind":"method","name":"_handleArrowKeys","privacy":"private","return":{"type":{"text":"Promise<void>"}},"parameters":[{"name":"moveForward","type":{"text":"boolean"}}]},{"kind":"method","name":"_handleEnterKey","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_handleFocusout","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"FocusEvent"}}]}],"attributes":[{"name":"group-label","type":{"text":"string"},"default":"\'Options\'","description":"The label used to announce this group to assistive technologies.","fieldName":"groupLabel","attribute":"group-label"}],"superclass":{"name":"PharosElement","module":"/src/components/base/pharos-element"},"tagName":"pharos-toggle-button-group","customElement":true}],"exports":[{"kind":"js","name":"PharosToggleButtonGroup","declaration":{"name":"PharosToggleButtonGroup","module":"src/components/toggle-button-group/pharos-toggle-button-group.ts"}}]},{"kind":"javascript-module","path":"src/components/toggle-button-group/pharos-toggle-button.ts","declarations":[{"kind":"class","description":"Pharos toggle button component.","name":"PharosToggleButton","slots":[{"description":"Contains the content of the button (the default slot).","name":""}],"members":[{"kind":"field","name":"selected","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates that the button is currently toggled on and cannot be pressed or focused by the user.","attribute":"selected","reflects":true},{"kind":"field","name":"_first","type":{"text":"boolean"},"privacy":"private","default":"false"},{"kind":"field","name":"_last","type":{"text":"boolean"},"privacy":"private","default":"false"},{"kind":"field","name":"_hideLeftBorder","type":{"text":"boolean"},"privacy":"private","default":"false"},{"kind":"field","name":"_hideRightBorder","type":{"text":"boolean"},"privacy":"private","default":"false"},{"kind":"method","name":"_handleClickToggle","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"field","name":"pressed","type":{"text":"PressedState"},"privacy":"public","default":"\'false\'","description":"Indicates this button is a toggle button and whether it is pressed or not.","attribute":"pressed","reflects":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"variant","type":{"text":"ButtonVariant"},"privacy":"public","default":"\'secondary\'","description":"Indicates the variant of button.","attribute":"variant","reflects":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"type","type":{"text":"ButtonType | undefined"},"privacy":"public","description":"Indicates the default behavior of the button via the HTML5 attribute.","attribute":"type","reflects":true,"optional":true,"default":"\'button\'","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"elementDefinitions","type":{"text":"object"},"static":true,"default":"{\\n    \'pharos-icon\': PharosIcon,\\n  }","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"autofocus","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates that the button should have input focus when the page loads.","attribute":"autofocus","reflects":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"disabled","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates that the button cannot be pressed or focused by the user.","attribute":"disabled","reflects":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"icon","type":{"text":"IconName | undefined"},"privacy":"public","description":"The icon to be shown as the content of the button.","attribute":"icon","reflects":true,"optional":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"iconCondensed","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Applies only to icon-only buttons. If true, the button will have minimal padding.","attribute":"icon-condensed","reflects":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"iconRight","type":{"text":"IconName | undefined"},"privacy":"public","description":"The icon to be shown on the right side.","attribute":"icon-right","reflects":true,"optional":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"iconLeft","type":{"text":"IconName | undefined"},"privacy":"public","description":"The icon to be shown on the left side.","attribute":"icon-left","reflects":true,"optional":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"onBackground","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates the button is on a AA compliant background.","attribute":"on-background","reflects":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"large","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates the button has more padding.","attribute":"large","reflects":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"label","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the aria label to apply to the button.","attribute":"label","reflects":true,"optional":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"fullWidth","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates the button\'s width should match its container.","attribute":"full-width","reflects":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"name","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the name when submitted with form data.","attribute":"name","reflects":true,"optional":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"value","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the value associated with the name when submitted with form data.","attribute":"value","reflects":true,"optional":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"_button","type":{"text":"HTMLButtonElement | HTMLAnchorElement"},"privacy":"private","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"_formButton","type":{"text":"HTMLButtonElement"},"privacy":"private","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"_form","type":{"text":"HTMLFormElement | null"},"privacy":"private","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"method","name":"_handleKeyup","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"KeyboardEvent"}}],"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"method","name":"_handleClick","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"MouseEvent"}}],"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"method","name":"_stopClickLeak","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"MouseEvent"}}],"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"method","name":"_renderIcon","privacy":"private","return":{"type":{"text":"TemplateResult | typeof nothing"}},"parameters":[{"name":"direction","default":"\'\'"}],"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"field","name":"buttonContent","type":{"text":"TemplateResult"},"privacy":"protected","readonly":true,"inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"kind":"method","name":"focus","privacy":"public","return":{"type":{"text":"void"}},"inheritedFrom":{"name":"FocusMixin","module":"src/utils/mixins/focus.ts"}},{"kind":"field","name":"download","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates to save the linked URL instead of navigating to it.","attribute":"download","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"href","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the URL that the hyperlink points to.","attribute":"href","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"hreflang","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the language of the linked URL.","attribute":"hreflang","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"ping","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the URLs to ping.","attribute":"ping","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"rel","type":{"text":"string | undefined"},"privacy":"public","description":"Indicates the type of link.","attribute":"rel","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"kind":"field","name":"target","type":{"text":"LinkTarget | undefined"},"privacy":"public","description":"Indicates where to display the linked URL.","attribute":"target","reflects":true,"optional":true,"inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}}],"events":[{"name":"pharos-toggle-button-selected","type":{"text":"CustomEvent"}}],"attributes":[{"name":"selected","type":{"text":"boolean"},"default":"false","description":"Indicates that the button is currently toggled on and cannot be pressed or focused by the user.","fieldName":"selected","attribute":"selected"},{"name":"autofocus","type":{"text":"boolean"},"default":"false","description":"Indicates that the button should have input focus when the page loads.","fieldName":"autofocus","attribute":"autofocus","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"disabled","type":{"text":"boolean"},"default":"false","description":"Indicates that the button cannot be pressed or focused by the user.","fieldName":"disabled","attribute":"disabled","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"type","type":{"text":"ButtonType | undefined"},"description":"Indicates the default behavior of the button via the HTML5 attribute.","fieldName":"type","attribute":"type","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"variant","type":{"text":"ButtonVariant"},"default":"\'primary\'","description":"Indicates the variant of button.","fieldName":"variant","attribute":"variant","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"icon","type":{"text":"IconName | undefined"},"description":"The icon to be shown as the content of the button.","fieldName":"icon","attribute":"icon","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"icon-condensed","type":{"text":"boolean"},"default":"false","description":"Applies only to icon-only buttons. If true, the button will have minimal padding.","fieldName":"iconCondensed","attribute":"icon-condensed","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"icon-right","type":{"text":"IconName | undefined"},"description":"The icon to be shown on the right side.","fieldName":"iconRight","attribute":"icon-right","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"icon-left","type":{"text":"IconName | undefined"},"description":"The icon to be shown on the left side.","fieldName":"iconLeft","attribute":"icon-left","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"on-background","type":{"text":"boolean"},"default":"false","description":"Indicates the button is on a AA compliant background.","fieldName":"onBackground","attribute":"on-background","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"large","type":{"text":"boolean"},"default":"false","description":"Indicates the button has more padding.","fieldName":"large","attribute":"large","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"label","type":{"text":"string | undefined"},"description":"Indicates the aria label to apply to the button.","fieldName":"label","attribute":"label","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"full-width","type":{"text":"boolean"},"default":"false","description":"Indicates the button\'s width should match its container.","fieldName":"fullWidth","attribute":"full-width","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"name","type":{"text":"string | undefined"},"description":"Indicates the name when submitted with form data.","fieldName":"name","attribute":"name","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"value","type":{"text":"string | undefined"},"description":"Indicates the value associated with the name when submitted with form data.","fieldName":"value","default":"\'undefined\'","attribute":"value","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"pressed","type":{"text":"PressedState"},"default":"\'undefined\'","description":"Indicates this button is a toggle button and whether it is pressed or not.","attribute":"value","fieldName":"pressed","inheritedFrom":{"name":"PharosButton","module":"src/components/button/pharos-button.ts"}},{"name":"download","type":{"text":"string | undefined"},"description":"Indicates to save the linked URL instead of navigating to it.","fieldName":"download","attribute":"download","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"href","type":{"text":"string | undefined"},"description":"Indicates the URL that the hyperlink points to.","fieldName":"href","attribute":"href","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"hreflang","type":{"text":"string | undefined"},"description":"Indicates the language of the linked URL.","fieldName":"hreflang","attribute":"hreflang","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"ping","type":{"text":"string | undefined"},"description":"Indicates the URLs to ping.","fieldName":"ping","attribute":"ping","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"rel","type":{"text":"string | undefined"},"description":"Indicates the type of link.","fieldName":"rel","attribute":"rel","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}},{"name":"target","type":{"text":"LinkTarget | undefined"},"description":"Indicates where to display the linked URL.","fieldName":"target","attribute":"target","inheritedFrom":{"name":"AnchorElement","module":"src/components/base/anchor-element.ts"}}],"superclass":{"name":"PharosButton","module":"/src/components/button/pharos-button"},"tagName":"pharos-toggle-button","customElement":true}],"exports":[{"kind":"js","name":"ButtonType","declaration":{"name":"ButtonType","module":"src/components/toggle-button-group/pharos-toggle-button.ts"}},{"kind":"js","name":"LinkTarget","declaration":{"name":"LinkTarget","module":"src/components/toggle-button-group/pharos-toggle-button.ts"}},{"kind":"js","name":"IconName","declaration":{"name":"IconName","module":"src/components/toggle-button-group/pharos-toggle-button.ts"}},{"kind":"js","name":"ButtonVariant","declaration":{"name":"ButtonVariant","module":"src/components/toggle-button-group/pharos-toggle-button.ts"}},{"kind":"js","name":"PressedState","declaration":{"name":"PressedState","module":"src/components/toggle-button-group/pharos-toggle-button.ts"}},{"kind":"js","name":"PharosToggleButton","declaration":{"name":"PharosToggleButton","module":"src/components/toggle-button-group/pharos-toggle-button.ts"}}]},{"kind":"javascript-module","path":"src/components/tooltip/pharos-tooltip.ts","declarations":[{"kind":"class","description":"Pharos tooltip component.","name":"PharosTooltip","cssProperties":[{"type":{"text":"Length"},"description":"Tooltip font size.","name":"--pharos-tooltip-size-text-base"},{"type":{"text":"Color"},"description":"Font color for the bubble.","name":"--pharos-tooltip-color-background-base"},{"type":{"text":"Color"},"description":"Font color for the text.","name":"--pharos-tooltip-color-text-base"}],"slots":[{"description":"Content inside the tooltip (the default slot).","name":""}],"members":[{"kind":"field","name":"fullWidth","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the tooltip width should equal its target\'s width.","attribute":"full-width","reflects":true},{"kind":"field","name":"boundary","type":{"text":"string"},"privacy":"public","default":"\'clippingAncestors\'","description":"The custom boundary that the tooltip should stay within.","attribute":"boundary","reflects":true},{"kind":"field","name":"_contentNodes","type":{"text":"NodeListOf<HTMLElement>"},"privacy":"private"},{"kind":"field","name":"_caret","type":{"text":"HTMLSpanElement"},"privacy":"private"},{"kind":"field","name":"_tooltip","type":{"text":"HTMLDivElement"},"privacy":"private"},{"kind":"field","name":"_bubble","type":{"text":"HTMLSpanElement"},"privacy":"private"},{"kind":"field","name":"_textLength","type":{"text":"number"},"privacy":"private","default":"0"},{"kind":"field","name":"_targetWidth","type":{"text":"number"},"privacy":"private","default":"0"},{"kind":"field","name":"_hasHover","type":{"text":"boolean"},"privacy":"private","default":"false"},{"kind":"field","name":"_hasFocus","type":{"text":"boolean"},"privacy":"private","default":"false"},{"kind":"field","name":"_observeResizeTrigger","type":{"text":"Handle | null"},"privacy":"private","default":"null"},{"kind":"field","name":"_triggers","type":{"text":"HTMLElement[]"},"privacy":"private"},{"kind":"field","name":"_currentTrigger","type":{"text":"Element | null"},"privacy":"private","default":"null"},{"kind":"field","name":"_cleanup","type":{"text":"{ (): void } | undefined"},"privacy":"private","default":"undefined","optional":true},{"kind":"field","name":"_resizeObserver","type":{"text":"ResizeObserver"},"privacy":"private","default":"new ResizeObserver((entries: ResizeObserverEntry[]) => {\\n    const { offsetWidth } = entries[0].target as HTMLElement;\\n    const paddingLeft = parseInt(\\n      window.getComputedStyle(this._bubble, null).getPropertyValue(\'padding-left\'),\\n      10\\n    );\\n    const paddingRight = parseInt(\\n      window.getComputedStyle(this._bubble, null).getPropertyValue(\'padding-right\'),\\n      10\\n    );\\n    this._targetWidth = offsetWidth - (paddingLeft + paddingRight);\\n  })"},{"kind":"field","name":"_contentObserver","type":{"text":"MutationObserver"},"privacy":"private","default":"new MutationObserver(\\n    (mutationsList: MutationRecord[]) => {\\n      this._textLength = (mutationsList[0].target as CharacterData).length;\\n    }\\n  )"},{"kind":"field","name":"content","type":{"text":"HTMLElement | Text"},"privacy":"protected","readonly":true},{"kind":"method","name":"_isTextLong","privacy":"private"},{"kind":"method","name":"_addTriggerListeners","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_setup","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_setOpen","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_positionCaret","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"placement","type":{"text":"Placement"}},{"name":"arrowX","type":{"text":"number | undefined"}},{"name":"arrowY","type":{"text":"number | undefined"}}]},{"kind":"method","name":"_positionTooltip","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"x","type":{"text":"number"}},{"name":"y","type":{"text":"number"}}]},{"kind":"method","name":"_positionElements","privacy":"private"},{"kind":"method","name":"_handleFocus","privacy":"private","return":{"type":{"text":"Promise<void>"}},"parameters":[{"name":"event","type":{"text":"FocusEvent"}}]},{"kind":"method","name":"_handleHover","privacy":"private","return":{"type":{"text":"Promise<void>"}},"parameters":[{"name":"event","type":{"text":"Event"}}]},{"kind":"method","name":"_setTrigger","privacy":"private","return":{"type":{"text":"Promise<void>"}},"parameters":[{"name":"target","type":{"text":"Element"}}]},{"kind":"method","name":"_handleBubbleHover","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"Event"}}]},{"kind":"method","name":"_handleKeydown","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"KeyboardEvent"}}]},{"kind":"method","name":"_setTextLength","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_closeOpenTooltips","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_handleClose","privacy":"private","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"CustomEvent"}}]},{"kind":"method","name":"_setupResizeObserver","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_releaseObserver","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"method","name":"_findSingleTrigger","privacy":"private","return":{"type":{"text":"void"}}},{"kind":"field","name":"open","type":{"text":"boolean"},"privacy":"public","default":"false","description":"Indicates if the overlay is open.","attribute":"open","reflects":true,"inheritedFrom":{"name":"OverlayElement","module":"src/components/base/overlay-element.ts"}},{"kind":"field","name":"placement","type":{"text":"Placement | \'auto\'"},"privacy":"public","default":"\'top\'","description":"Describes the preferred placement of the overlay.","attribute":"placement","reflects":true,"inheritedFrom":{"name":"OverlayElement","module":"src/components/base/overlay-element.ts"}},{"kind":"field","name":"fallbackPlacements","type":{"text":"(Placement | \'auto\')[] | undefined"},"privacy":"public","description":"List of placements to try in the order provided when no space is available for the preferred placement.","optional":true,"inheritedFrom":{"name":"OverlayElement","module":"src/components/base/overlay-element.ts"}},{"kind":"field","name":"strategy","type":{"text":"PositioningStrategy"},"privacy":"public","default":"\'absolute\'","description":"Describes the positioning strategy to use. If your target element is in a fixed container, use the fixed strategy.","attribute":"strategy","reflects":true,"inheritedFrom":{"name":"OverlayElement","module":"src/components/base/overlay-element.ts"}},{"kind":"field","name":"_filteredFallbackPlacements","type":{"text":"Placement[] | undefined"},"privacy":"protected","optional":true,"inheritedFrom":{"name":"OverlayElement","module":"src/components/base/overlay-element.ts"}}],"events":[{"name":"pharos-tooltip-close","type":{"text":"CustomEvent"}}],"attributes":[{"name":"full-width","type":{"text":"boolean"},"default":"false","description":"Indicates if the tooltip width should equal its target\'s width.","fieldName":"fullWidth","attribute":"full-width"},{"name":"boundary","type":{"text":"string"},"default":"\'clippingAncestors\'","description":"The custom boundary that the tooltip should stay within.","fieldName":"boundary","attribute":"boundary"},{"name":"open","type":{"text":"boolean"},"default":"false","description":"Indicates if the overlay is open.","fieldName":"open","attribute":"open","inheritedFrom":{"name":"OverlayElement","module":"src/components/base/overlay-element.ts"}},{"name":"placement","type":{"text":"Placement | \'auto\'"},"default":"\'top\'","description":"Describes the preferred placement of the overlay.","fieldName":"placement","attribute":"placement","inheritedFrom":{"name":"OverlayElement","module":"src/components/base/overlay-element.ts"}},{"name":"strategy","type":{"text":"PositioningStrategy"},"default":"\'absolute\'","description":"Describes the positioning strategy to use. If your target element is in a fixed container, use the fixed strategy.","fieldName":"strategy","attribute":"strategy","inheritedFrom":{"name":"OverlayElement","module":"src/components/base/overlay-element.ts"}}],"superclass":{"name":"OverlayElement","module":"/src/components/base/overlay-element"},"tagName":"pharos-tooltip","customElement":true}],"exports":[{"kind":"js","name":"Placement","declaration":{"name":"Placement","module":"src/components/tooltip/pharos-tooltip.ts"}},{"kind":"js","name":"PositioningStrategy","declaration":{"name":"PositioningStrategy","module":"src/components/tooltip/pharos-tooltip.ts"}},{"kind":"js","name":"PharosTooltip","declaration":{"name":"PharosTooltip","module":"src/components/tooltip/pharos-tooltip.ts"}}]},{"kind":"javascript-module","path":"src/components/tooltip/storyArgs.ts","declarations":[{"kind":"variable","name":"defaultArgs","type":{"text":"object"},"default":"{\\n  fullWidth: false,\\n  open: false,\\n  targetText: \'Focus here\',\\n  tooltipText: \'Hi there again!\',\\n  id: \'my-tooltip\',\\n  placement: \'top\',\\n  fallbackPlacements: [],\\n}"},{"kind":"variable","name":"argTypes","type":{"text":"object"},"default":"{\\n  placement: {\\n    options: allPlacements,\\n    control: {\\n      type: \'inline-radio\',\\n    },\\n  },\\n  fallbackPlacements: {\\n    control: { type: \'array\' },\\n  },\\n}"}],"exports":[{"kind":"js","name":"defaultArgs","declaration":{"name":"defaultArgs","module":"src/components/tooltip/storyArgs.ts"}},{"kind":"js","name":"argTypes","declaration":{"name":"argTypes","module":"src/components/tooltip/storyArgs.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/academic-content.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTcuOTQ5OTUgMTUuOTQ5N0gxMS45NVYxMy45NDk3SDcuOTQ5OTVWMTUuOTQ5N1oiLz4KPHBhdGggZD0iTTE1Ljk1IDkuOTQ5NzFINy45NDk5NVY3Ljk0OTcxSDE1Ljk1VjkuOTQ5NzFaIi8+CjxwYXRoIGQ9Ik03Ljk0OTk1IDEyLjk0OTdIMTUuOTVWMTAuOTQ5N0g3Ljk0OTk1VjEyLjk0OTdaIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTkuOTUgMy45NDk3MUgzLjk0OTk1VjE5Ljk0OTdIMTkuOTVWMy45NDk3MVpNNS45NDk5NSAxNy45NDk3VjUuOTQ5NzFIMTcuOTVWMTcuOTQ5N0g1Ljk0OTk1WiIvPgo=","module":"src/styles/icons/academic-content.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/add.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTExLjA3MDcgMTIuOTI5M1YyMEgxMy4wNzA3VjEyLjkyOTNIMjBWMTAuOTI5M0gxMy4wNzA3VjRIMTEuMDcwN1YxMC45MjkzSDRWMTIuOTI5M0gxMS4wNzA3WiIvPgo=","module":"src/styles/icons/add.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/arrow-down.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTEyLjQxNDIgMTkuNzA3MkwxOS44Mjg0IDEyLjI5M0wxOC40MTQyIDEwLjg3ODhMMTMuNDE0NCAxNS44Nzg2VjQuMjkzMDlMMTEuNDE0NCA0LjI5MzA5TDExLjQxNDQgMTUuODc4OUw2LjQxNDIxIDEwLjg3ODhMNSAxMi4yOTNMMTIuNDE0MiAxOS43MDcyWiIvPgo=","module":"src/styles/icons/arrow-down.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/arrow-left.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTguNDE0MjcgMTFMMTMuNDE0MSA2LjAwMDE1TDExLjk5OTkgNC41ODU5NEw0LjU4NTY5IDEyLjAwMDJMMTEuOTk5OSAxOS40MTQ0TDEzLjQxNDEgMTguMDAwMUw4LjQxMzk3IDEzSDIwVjExSDguNDE0MjdaIi8+Cg==","module":"src/styles/icons/arrow-left.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/arrow-right.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTE5LjQxNDEgMTIuMDAwMkwxMS45OTk5IDQuNTg1OTRMMTAuNTg1NyA2LjAwMDE1TDE1LjU4NTUgMTFINFYxM0gxNS41ODU4TDEwLjU4NTcgMTguMDAwMkwxMS45OTk5IDE5LjQxNDRMMTkuNDE0MSAxMi4wMDAyWiIvPg==","module":"src/styles/icons/arrow-right.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/arrow-up.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTEzLjI5MyA4LjEyMTU1TDE4LjI5MjkgMTMuMTIxNEwxOS43MDcxIDExLjcwNzJMMTIuMjkyOSA0LjI5Mjk3TDQuODc4NjYgMTEuNzA3Mkw2LjI5Mjg4IDEzLjEyMTRMMTEuMjkzIDguMTIxMjRMMTEuMjkzIDE5LjcwNzNIMTMuMjkzVjguMTIxNTVaIi8+Cg==","module":"src/styles/icons/arrow-up.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/attachment.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNy42NTY4IDYuMzQzMkMxNi4wOTQ3IDQuNzgxMTEgMTMuNTYyIDQuNzgxMTEgMTEuOTk5OSA2LjM0MzJMNS4xNjQ1NiAxMy4xNzg2QzQuMjUzMzMgMTQuMDg5OCA0LjI1MzMzIDE1LjU2NzIgNS4xNjQ1NiAxNi40Nzg0QzYuMDc1NzggMTcuMzg5NiA3LjU1MzE2IDE3LjM4OTYgOC40NjQzOSAxNi40Nzg0TDE1LjAzNjMgOS45MDY0NUMxNS4yOTY3IDkuNjQ2MTEgMTUuMjk2NyA5LjIyNDAxIDE1LjAzNjMgOC45NjM2N0MxNC43NzYgOC43MDMzMyAxNC4zNTM5IDguNzAzMzMgMTQuMDkzNSA4Ljk2MzY3TDcuMTQ2MDEgMTUuOTExMkw1LjczMTc5IDE0LjQ5N0wxMi42NzkzIDcuNTQ5NDZDMTMuNzIwNyA2LjUwODA3IDE1LjQwOTIgNi41MDgwNiAxNi40NTA1IDcuNTQ5NDZDMTcuNDkxOSA4LjU5MDg1IDE3LjQ5MTkgMTAuMjc5MyAxNi40NTA1IDExLjMyMDdMOS44Nzg2IDE3Ljg5MjZDOC4xODYzMyAxOS41ODQ5IDUuNDQyNjIgMTkuNTg0OSAzLjc1MDM0IDE3Ljg5MjZDMi4wNTgwNyAxNi4yMDAzIDIuMDU4MDcgMTMuNDU2NiAzLjc1MDM0IDExLjc2NDRMMTAuNTg1NyA0LjkyODk5QzEyLjkyODkgMi41ODU4NCAxNi43Mjc4IDIuNTg1ODQgMTkuMDcxIDQuOTI4OTlDMjEuNDE0MSA3LjI3MjEzIDIxLjQxNDEgMTEuMDcxMSAxOS4wNzEgMTMuNDE0M0wxMi4wMjg3IDIwLjQ1NjZMMTAuNjE0NSAxOS4wNDIzTDE3LjY1NjggMTIuMDAwMUMxOS4yMTg5IDEwLjQzOCAxOS4yMTg5IDcuOTA1MyAxNy42NTY4IDYuMzQzMloiLz4K","module":"src/styles/icons/attachment.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/base.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iOSIvPgo=","module":"src/styles/icons/base.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/book.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjcxNDI5IDNDNi4yMTUyMyAzIDUgNC4yMTUyMyA1IDUuNzE0MjlDNSA1LjcxNDQgNSA1LjcxNDUgNSA1LjcxNDYxVjE4LjAwMDNDNSAxOS42NTcyIDYuMzQzMTUgMjEuMDAwNCA4IDIxLjAwMDRIMTlWOC40Mjg1OFY3LjQyODlWNi40Mjg1OEgxNy4wNTk1VjNINy43MTQyOVpNMTcgOC40Mjg1OEg3LjcxNDI5QzcuNDY3MDggOC40Mjg1OCA3LjIyNzU5IDguMzk1NTQgNyA4LjMzMzYyVjE4LjAwMDNDNyAxOC41NTI2IDcuNDQ3NzIgMTkuMDAwNCA4IDE5LjAwMDRIMTdWOC40Mjg1OFpNNyA1LjcxNDYxQzcuMDAwMTcgNi4xMDg5NSA3LjMxOTkgNi40Mjg1OCA3LjcxNDI5IDYuNDI4NThIMTUuMDU5NVY1LjAwMDAxSDcuNzE0MjlDNy4zMTk4IDUuMDAwMDEgNyA1LjMxOTggNyA1LjcxNDI5QzcgNS43MTQ0IDcgNS43MTQ1IDcgNS43MTQ2MVoiLz4K","module":"src/styles/icons/book.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/calendar.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNCA0Ljk5OTk5TDEwIDQuOTk5OTlWM0g4VjQuOTk5OTlMNCA0Ljk5OTk5VjIwSDIwTDIwIDQuOTk5OTlMMTYgNC45OTk5OVYzSDE0VjQuOTk5OTlaTTggOC41VjYuOTk5OTlMNiA2Ljk5OTk5TDYgMTBIMThMMTggNi45OTk5OUwxNiA2Ljk5OTk5VjguNUgxNFY2Ljk5OTk5TDEwIDYuOTk5OTlWOC41SDhaTTYgMTJMNiAxOEwxOCAxOEwxOCAxMkg2WiIvPgo=","module":"src/styles/icons/calendar.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/checkmark-filled-circle.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiAyMUMxNi45NzA2IDIxIDIxIDE2Ljk3MDYgMjEgMTJDMjEgNy4wMjk0NCAxNi45NzA2IDMgMTIgM0M3LjAyOTQ0IDMgMyA3LjAyOTQ0IDMgMTJDMyAxNi45NzA2IDcuMDI5NDQgMjEgMTIgMjFaTTE1LjI5MjkgOC4yOTI5MUwxMC44MTkzIDEyLjc2NjZMOC43MDcxMiAxMC42NTQ0TDcuMjkyOTEgMTIuMDY4NkwxMC44MTkzIDE1LjU5NUwxNi43MDcxIDkuNzA3MTJMMTUuMjkyOSA4LjI5MjkxWiIvPgo=","module":"src/styles/icons/checkmark-filled-circle.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/checkmark-inverse.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTE0LjI4MjcgOS4zNTMyN0wxMS4wODQ3IDEyLjY0NTVMOS42ODcxNSAxMS4zMjM2TDguMzEyODEgMTIuNzc2NUwxMS4xNDQxIDE1LjQ1NDZMMTUuNzE3MyAxMC43NDY4TDE0LjI4MjcgOS4zNTMyN1oiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiAzQzcuMDI5NDQgMyAzIDcuMDI5NDQgMyAxMkMzIDE2Ljk3MDYgNy4wMjk0NCAyMSAxMiAyMUMxNi45NzA2IDIxIDIxIDE2Ljk3MDYgMjEgMTJDMjEgNy4wMjk0NCAxNi45NzA2IDMgMTIgM1pNNSAxMkM1IDguMTM0MDEgOC4xMzQwMSA1IDEyIDVDMTUuODY2IDUgMTkgOC4xMzQwMSAxOSAxMkMxOSAxNS44NjYgMTUuODY2IDE5IDEyIDE5QzguMTM0MDEgMTkgNSAxNS44NjYgNSAxMloiLz4K","module":"src/styles/icons/checkmark-inverse.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/checkmark-small.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTEyIDVMNi44MTkyNSAxMEw0IDcuMjc5MTEiIHN0cm9rZS13aWR0aD0iMiIgZmlsbD0ibm9uZSIvPgo=","module":"src/styles/icons/checkmark-small.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/checkmark.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOS40MTQxIDguMDAwMDNMOS43NDk5MSAxNy42NjQyTDQuNTg1NjkgMTIuNUw1Ljk5OTkxIDExLjA4NThMOS43NDk5MSAxNC44MzU4TDE3Ljk5OTkgNi41ODU4MkwxOS40MTQxIDguMDAwMDNaIi8+Cg==","module":"src/styles/icons/checkmark.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/chevron-down.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiAxNC41ODU4TDcuNzA3MDYgMTAuMjkyOUw2LjI5Mjg1IDExLjcwNzFMMTIgMTcuNDE0MkwxNy43MDcxIDExLjcwNzFMMTYuMjkyOCAxMC4yOTI5TDEyIDE0LjU4NThaIi8+Cg==","module":"src/styles/icons/chevron-down.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/chevron-left-large.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjQxNDIgMTJMMTYuNzA3MSAyMC4yOTI5TDE1LjI5MjkgMjEuNzA3MUw1LjU4NTc3IDEyTDE1LjI5MjkgMi4yOTI4OEwxNi43MDcxIDMuNzA3MDlMOC40MTQyIDEyWiIvPgo=","module":"src/styles/icons/chevron-left-large.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/chevron-left.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS40MTQyIDcuOTk5OTdMMTEuNDE0MiAxMkwxNS40MTQyIDE2TDE0IDE3LjQxNDJMOC41ODU4MiAxMkwxNCA2LjU4NTc1TDE1LjQxNDIgNy45OTk5N1oiLz4K","module":"src/styles/icons/chevron-left.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/chevron-right-large.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS41ODU4IDEyTDcuMjkyOTEgMy43MDcxMkw4LjcwNzEyIDIuMjkyOTFMMTguNDE0MiAxMkw4LjcwNzEyIDIxLjcwNzFMNy4yOTI5MSAyMC4yOTI5TDE1LjU4NTggMTJaIi8+Cg==","module":"src/styles/icons/chevron-right-large.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/chevron-right.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjU4NTgyIDcuOTk5OTdMMTIuNTg1OCAxMkw4LjU4NTgyIDE2TDEwIDE3LjQxNDJMMTUuNDE0MiAxMkwxMCA2LjU4NTc1TDguNTg1ODIgNy45OTk5N1oiLz4K","module":"src/styles/icons/chevron-right.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/chevron-up.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS45NSA4LjUzNTc3TDE3LjM2NDIgMTMuOTVMMTUuOTUgMTUuMzY0MkwxMS45NSAxMS4zNjQyTDcuOTQ5OTggMTUuMzY0Mkw2LjUzNTc3IDEzLjk1TDExLjk1IDguNTM1NzdaIi8+Cg==","module":"src/styles/icons/chevron-up.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/circle.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiAxOUMxNS44NjYgMTkgMTkgMTUuODY2IDE5IDEyQzE5IDguMTM0MDEgMTUuODY2IDUgMTIgNUM4LjEzNDAxIDUgNSA4LjEzNDAxIDUgMTJDNSAxNS44NjYgOC4xMzQwMSAxOSAxMiAxOVpNMTIgMjFDMTYuOTcwNiAyMSAyMSAxNi45NzA2IDIxIDEyQzIxIDcuMDI5NDQgMTYuOTcwNiAzIDEyIDNDNy4wMjk0NCAzIDMgNy4wMjk0NCAzIDEyQzMgMTYuOTcwNiA3LjAyOTQ0IDIxIDEyIDIxWiIvPgo=","module":"src/styles/icons/circle.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/cite.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDVIMjBWMThIMTUuNDY4NEwxMi45Njg0IDIxSDExLjAzMTZMOC41MzE2MiAxOEg0VjVaTTYgN1YxNkg5LjQ2ODM3TDExLjk2ODQgMTlIMTIuMDMxNkwxNC41MzE2IDE2SDE4VjdINlpNMTYgMTFIOFY5SDE2VjExWk0xMyAxNEg4VjEySDEzVjE0WiIvPgo=","module":"src/styles/icons/cite.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/close-inverse.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTExLjk5OTggMTMuNDE0M0w5Ljk5OTgyIDE1LjQxNDNMOC41ODU2IDE0LjAwMDFMMTAuNTg1NiAxMi4wMDAxTDguNTg1NiAxMC4wMDAxTDkuOTk5ODIgOC41ODU4NUwxMS45OTk4IDEwLjU4NThMMTMuOTk5OCA4LjU4NTg1TDE1LjQxNCAxMC4wMDAxTDEzLjQxNCAxMi4wMDAxTDE1LjQxNCAxNC4wMDAxTDEzLjk5OTggMTUuNDE0M0wxMS45OTk4IDEzLjQxNDNaIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMyAxMkMzIDcuMDI5NDQgNy4wMjk0NCAzIDEyIDNDMTYuOTcwNiAzIDIxIDcuMDI5NDQgMjEgMTJDMjEgMTYuOTcwNiAxNi45NzA2IDIxIDEyIDIxQzcuMDI5NDQgMjEgMyAxNi45NzA2IDMgMTJaTTEyIDVDOC4xMzQwMSA1IDUgOC4xMzQwMSA1IDEyQzUgMTUuODY2IDguMTM0MDEgMTkgMTIgMTlDMTUuODY2IDE5IDE5IDE1Ljg2NiAxOSAxMkMxOSA4LjEzNDAxIDE1Ljg2NiA1IDEyIDVaIi8+Cg==","module":"src/styles/icons/close-inverse.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/close.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTEzLjQxNDQgMTIuMDAwMkwxOS40MTQ0IDYuMDAwMTVMMTguMDAwMiA0LjU4NTk0TDEyLjAwMDIgMTAuNTg1OUw2LjAwMDE1IDQuNTg1OTRMNC41ODU5NCA2LjAwMDE1TDEwLjU4NTkgMTIuMDAwMkw0LjU4NTk0IDE4LjAwMDJMNi4wMDAxNSAxOS40MTQ0TDEyLjAwMDIgMTMuNDE0NEwxOC4wMDAyIDE5LjQxNDRMMTkuNDE0NCAxOC4wMDAyTDEzLjQxNDQgMTIuMDAwMloiLz4K","module":"src/styles/icons/close.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/collapse.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDIwVjRINlYyMEg0Wk0xNCA2LjU4NTc5TDE5LjQxNDIgMTJMMTQgMTcuNDE0MkwxMi41ODU4IDE2TDE1LjU4NTggMTNIOFYxMUgxNS41ODU4TDEyLjU4NTggOEwxNCA2LjU4NTc5WiIvPgo=","module":"src/styles/icons/collapse.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/copy.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMCA0LjAwMDAzSDlMOSA5LjAwMDAzTDQgOS4wMDAwM1YyMEgxNVYxNUwyMCAxNVY0LjAwMDAzWk0xNSAxM0wxOCAxM1Y2LjAwMDAzTDExIDYuMDAwMDNWOS4wMDAwM0wxNSA5LjAwMDAzVjEzWk02IDE4TDYgMTFMMTMgMTFMMTMgMThMNiAxOFoiLz4K","module":"src/styles/icons/copy.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/dash-small.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTUgOEgxMSIgc3Ryb2tlLXdpZHRoPSIyIi8+Cg==","module":"src/styles/icons/dash-small.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/delete.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTEwIDZIMTRWNEgxMFY2WiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIwIDguMDAwODVWMTAuMDAwOUgxOFYyMC4wMDA5SDZWMTAuMDAwOUg0VjguMDAwODVIMjBaTTggMTAuMDAwOVYxOC4wMDA5SDExVjEwLjAwMDlIOFpNMTMgMTAuMDAwOVYxOC4wMDA5SDE2VjEwLjAwMDlIMTNaIi8+Cg==","module":"src/styles/icons/delete.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/download.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTEzIDRWMTIuNTg1N0wxNy4wMDAxIDguNTg1NjRMMTguNDE0MyA5Ljk5OTg1TDEyLjAwMDEgMTYuNDE0MUw1LjU4NTg4IDkuOTk5ODVMNy4wMDAwOSA4LjU4NTY0TDExIDEyLjU4NTVWNEgxM1oiLz4KPHBhdGggZD0iTTIwIDE4SDRWMjBIMjBWMThaIi8+Cg==","module":"src/styles/icons/download.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/edit.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC41OTg4IDMuMDAyNzVMNC4wMDQ2NCAxMy41OTY5VjE5LjAxMTFMOS40MTg4MyAxOS4wMTExTDIwLjAxMyA4LjQxNjk0TDE0LjU5ODggMy4wMDI3NVpNNi4wMDQ2NCAxNy4wMTExVjE0LjQyNTNMMTIuMDA3OSA4LjQyMjA5TDE0LjU5MzcgMTEuMDA3OUw4LjU5MDQxIDE3LjAxMTFMNi4wMDQ2NCAxNy4wMTExWk0xNi4wMDc5IDkuNTkzNjVMMTcuMTg0NiA4LjQxNjk0TDE0LjU5ODggNS44MzExN0wxMy40MjIxIDcuMDA3ODdMMTYuMDA3OSA5LjU5MzY1WiIvPgo=","module":"src/styles/icons/edit.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/ellipses-horizontal.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDEyQzggMTMuMTA0NiA3LjEwNDU3IDE0IDYgMTRDNC44OTU0MyAxNCA0IDEzLjEwNDYgNCAxMkM0IDEwLjg5NTQgNC44OTU0MyAxMCA2IDEwQzcuMTA0NTcgMTAgOCAxMC44OTU0IDggMTJaTTE0IDEyQzE0IDEzLjEwNDYgMTMuMTA0NiAxNCAxMiAxNEMxMC44OTU0IDE0IDEwIDEzLjEwNDYgMTAgMTJDMTAgMTAuODk1NCAxMC44OTU0IDEwIDEyIDEwQzEzLjEwNDYgMTAgMTQgMTAuODk1NCAxNCAxMlpNMjAgMTJDMjAgMTMuMTA0NiAxOS4xMDQ2IDE0IDE4IDE0QzE2Ljg5NTQgMTQgMTYgMTMuMTA0NiAxNiAxMkMxNiAxMC44OTU0IDE2Ljg5NTQgMTAgMTggMTBDMTkuMTA0NiAxMCAyMCAxMC44OTU0IDIwIDEyWiIvPgo=","module":"src/styles/icons/ellipses-horizontal.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/ellipses-vertical.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiA4QzEwLjg5NTQgOCAxMCA3LjEwNDU3IDEwIDZDMTAgNC44OTU0MyAxMC44OTU0IDQgMTIgNEMxMy4xMDQ2IDQgMTQgNC44OTU0MyAxNCA2QzE0IDcuMTA0NTcgMTMuMTA0NiA4IDEyIDhaTTEyIDE0QzEwLjg5NTQgMTQgMTAgMTMuMTA0NiAxMCAxMkMxMCAxMC44OTU0IDEwLjg5NTQgMTAgMTIgMTBDMTMuMTA0NiAxMCAxNCAxMC44OTU0IDE0IDEyQzE0IDEzLjEwNDYgMTMuMTA0NiAxNCAxMiAxNFpNMTIgMjBDMTAuODk1NCAyMCAxMCAxOS4xMDQ2IDEwIDE4QzEwIDE2Ljg5NTQgMTAuODk1NCAxNiAxMiAxNkMxMy4xMDQ2IDE2IDE0IDE2Ljg5NTQgMTQgMThDMTQgMTkuMTA0NiAxMy4xMDQ2IDIwIDEyIDIwWiIvPgo=","module":"src/styles/icons/ellipses-vertical.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/email.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDE5VjVIMjBWMTlINFpNMTcuNTg1OCA3SDYuNDE0MTVMMTIgMTIuNTg1OEwxNy41ODU4IDdaTTYgOS40MTQyN1YxN0gxOFY5LjQxNDE4TDEyIDE1LjQxNDJMNiA5LjQxNDI3WiIvPgo=","module":"src/styles/icons/email.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/exclamation-inverse.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTEyLjk1IDguMDAwMDZWMTMuMDAwMUgxMC45NVY4LjAwMDA2SDEyLjk1WiIvPgo8cGF0aCBkPSJNMTIuOTUgMTUuMDAwMUMxMi45NSAxNC40NDc4IDEyLjUwMjMgMTQuMDAwMSAxMS45NSAxNC4wMDAxQzExLjM5NzcgMTQuMDAwMSAxMC45NSAxNC40NDc4IDEwLjk1IDE1LjAwMDFWMTUuMDkwMUMxMC45NSAxNS42NDIzIDExLjM5NzcgMTYuMDkwMSAxMS45NSAxNi4wOTAxQzEyLjUwMjMgMTYuMDkwMSAxMi45NSAxNS42NDIzIDEyLjk1IDE1LjA5MDFWMTUuMDAwMVoiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zIDEyQzMgNy4wMjk0NCA3LjAyOTQ0IDMgMTIgM0MxNi45NzA2IDMgMjEgNy4wMjk0NCAyMSAxMkMyMSAxNi45NzA2IDE2Ljk3MDYgMjEgMTIgMjFDNy4wMjk0NCAyMSAzIDE2Ljk3MDYgMyAxMlpNMTIgNUM4LjEzNDAxIDUgNSA4LjEzNDAxIDUgMTJDNSAxNS44NjYgOC4xMzQwMSAxOSAxMiAxOUMxNS44NjYgMTkgMTkgMTUuODY2IDE5IDEyQzE5IDguMTM0MDEgMTUuODY2IDUgMTIgNVoiLz4K","module":"src/styles/icons/exclamation-inverse.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/exclamation.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTEzIDE3Ljg2NjVDMTMgMTcuMzE0MiAxMi41NTIzIDE2Ljg2NjUgMTIgMTYuODY2NUMxMS40NDc3IDE2Ljg2NjUgMTEgMTcuMzE0MiAxMSAxNy44NjY1SDEzWk0xMSAxOEMxMSAxOC41NTIzIDExLjQ0NzcgMTkgMTIgMTlDMTIuNTUyMyAxOSAxMyAxOC41NTIzIDEzIDE4SDExWk0xMyA2VjVIMTFWNkgxM1pNMTEgMTMuNDE2NlYxNC40MTY2SDEzVjEzLjQxNjZIMTFaTTExIDE3Ljg2NjVWMThIMTNWMTcuODY2NUgxMVpNMTEgNlYxMy40MTY2SDEzVjZIMTFaIi8+Cg==","module":"src/styles/icons/exclamation.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/expand.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOCAyMFY0SDIwVjIwSDE4Wk0xMS40MTQyIDguMDAwMDJMMTAuNzA3MSA4LjcwNzEzTDguNDE0MiAxMUwxNiAxMVYxM0w4LjQxNDIxIDEzTDEwLjcwNzEgMTUuMjkyOUwxMS40MTQyIDE2TDkuOTk5OTkgMTcuNDE0M0w5LjI5Mjg5IDE2LjcwNzFMNS4yOTI4OSAxMi43MDcxTDQuNTg1NzggMTJMNS4yOTI4OSAxMS4yOTI5TDkuMjkyODkgNy4yOTI5MUw5Ljk5OTk5IDYuNTg1ODFMMTEuNDE0MiA4LjAwMDAyWiIvPgo=","module":"src/styles/icons/expand.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/facebook.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTIwIDEyLjA0ODlDMjAgNy42MDM2MSAxNi40MTgzIDQgMTIgNEM3LjU4MTcyIDQgNCA3LjYwMzYxIDQgMTIuMDQ4OUM0IDE2LjA2NjMgNi45MjU0NyAxOS4zOTYyIDEwLjc1IDIwVjE0LjM3NTVIOC43MTg3NVYxMi4wNDg5SDEwLjc1VjEwLjI3NTZDMTAuNzUgOC4yNTgzNyAxMS45NDQ0IDcuMTQ0MSAxMy43NzE3IDcuMTQ0MUMxNC42NDcgNy4xNDQxIDE1LjU2MjUgNy4zMDEzIDE1LjU2MjUgNy4zMDEzVjkuMjgyMDhIMTQuNTUzOEMxMy41NiA5LjI4MjA4IDEzLjI1IDkuOTAyNTcgMTMuMjUgMTAuNTM5MVYxMi4wNDg5SDE1LjQ2ODhMMTUuMTE0MSAxNC4zNzU1SDEzLjI1VjIwQzE3LjA3NDUgMTkuMzk2MiAyMCAxNi4wNjYzIDIwIDEyLjA0ODlaIi8+Cg==","module":"src/styles/icons/facebook.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/filetype-pdf.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"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","module":"src/styles/icons/filetype-pdf.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/filetype-ppt.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05IDE2VjhIMTEuNTg3OUMxMi40MzUyIDggMTMuMDM4NSA4LjAzNDQzIDEzLjM0ODEgOC4xMjEyQzEzLjgyMjkgOC4yNTE3NCAxNC4yMTc0IDguNTM3NDIgMTQuNTI3NiA4Ljk2MTY5QzE0Ljg1MTYgOS40MDEzNiAxNSA5Ljk1NDUzIDE1IDEwLjU5MjJDMTUgMTEuMDgxNCAxNC45MTU0IDExLjUxNzcgMTQuNzI4NCAxMS44ODU2QzE0LjU1MTcgMTIuMjMzNCAxNC4zMjA1IDEyLjUxNzkgMTQuMDMxOSAxMi43Mjg4QzEzLjc2MzcgMTIuOTIzNyAxMy40ODEyIDEzLjA1OTQgMTMuMTg2MyAxMy4xMjY3TDEzLjE4MDMgMTMuMTI4MUMxMi44MTIxIDEzLjIwNDUgMTIuMjk5NCAxMy4yMzk0IDExLjY1NDYgMTMuMjM5NEgxMS4wNjA0VjE2SDlaTTEyLjc5MjcgMTAuOTg3QzEyLjg1OTUgMTAuODg2MSAxMi44OTY3IDEwLjc2NTYgMTIuODk2NyAxMC42MTIyQzEyLjg5NjcgMTAuNDE3NiAxMi44NDQzIDEwLjI4MzMgMTIuNzU2NyAxMC4xODE4QzEyLjY1NzkgMTAuMDY3MiAxMi41MzQ2IDkuOTk0NjMgMTIuMzczMyA5Ljk2NDEzTDEyLjM3MDggOS45NjM2NUMxMi4yMzczIDkuOTM3MjUgMTEuOTI5NSA5LjkxOTYzIDExLjQxNjUgOS45MTk2M0gxMS4wNjA0VjExLjMxNDhIMTEuNTA3QzExLjc3ODggMTEuMzE0OCAxMS45OTkyIDExLjMwNTMgMTIuMTcwNiAxMS4yODc3QzEyLjM0NzUgMTEuMjY5NSAxMi40NTE5IDExLjI0NDMgMTIuNTAzNSAxMS4yMjMyQzEyLjYzMzkgMTEuMTcgMTIuNzI1MSAxMS4wOTIyIDEyLjc5MDIgMTAuOTkwOUwxMi43OTI3IDEwLjk4N1oiIC8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTUuNDE0MiA0SDRWMjBIMjBWOC41ODU3OUwxNS40MTQyIDRaTTYgMThWNkgxNC41ODU4TDE4IDkuNDE0MjFWMThINloiLz4K","module":"src/styles/icons/filetype-ppt.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/filetype-zip.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDRIMTUuNDE0MkwyMCA4LjU4NTc5VjIwSDRWNFpNNiA2VjE4SDE4VjkuNDE0MjFMMTQuNTg1OCA2SDZaTTEzLjY2NjYgMTBWMTQuNDQ0NEgxNC44MTEzVjEyLjkxMDhIMTUuMTQxNEMxNS40OTk2IDEyLjkxMDggMTUuNzg0NSAxMi44OTE0IDE1Ljk4OSAxMi44NDg5TDE1Ljk5MjQgMTIuODQ4MkMxNi4xNTYyIDEyLjgxMDggMTYuMzEzMSAxMi43MzU0IDE2LjQ2MjEgMTIuNjI3MUMxNi42MjI1IDEyLjUxIDE2Ljc1MDkgMTIuMzUxOSAxNi44NDkxIDEyLjE1ODdDMTYuOTUzIDExLjk1NDMgMTcgMTEuNzExOSAxNyAxMS40NDAxQzE3IDExLjA4NTggMTYuOTE3NSAxMC43Nzg1IDE2LjczNzUgMTAuNTM0M0MxNi41NjUyIDEwLjI5ODYgMTYuMzQ2IDEwLjEzOTkgMTYuMDgyMiAxMC4wNjczQzE1LjkxMDIgMTAuMDE5MSAxNS41NzUxIDEwIDE1LjEwNDQgMTBIMTMuNjY2NlpNMTUuODMxNCAxMS40NTEyQzE1LjgzMTQgMTEuNTM2NSAxNS44MTA4IDExLjYwMzQgMTUuNzczNyAxMS42NTk1TDE1Ljc3MjMgMTEuNjYxNkMxNS43MzYxIDExLjcxNzkgMTUuNjg1NCAxMS43NjExIDE1LjYxMyAxMS43OTA3QzE1LjU4NDMgMTEuODAyNCAxNS41MjY0IDExLjgxNjQgMTUuNDI4MSAxMS44MjY1QzE1LjMzMjggMTEuODM2MyAxNS4yMTA0IDExLjg0MTUgMTUuMDU5NCAxMS44NDE1SDE0LjgxMTNWMTEuMDY2NUgxNS4wMDkxQzE1LjI5NDEgMTEuMDY2NSAxNS40NjUxIDExLjA3NjIgMTUuNTM5MyAxMS4wOTA5TDE1LjU0MDcgMTEuMDkxMkMxNS42MzAzIDExLjEwODEgMTUuNjk4OCAxMS4xNDg0IDE1Ljc1MzcgMTEuMjEyMUMxNS44MDI0IDExLjI2ODUgMTUuODMxNCAxMS4zNDMxIDE1LjgzMTQgMTEuNDUxMlpNMTEuNDQ0NSAxMEgxMi41NTU2VjE0LjQ0NDRIMTEuNDQ0NVYxMFpNMTAuMzMzMyAxMEg3VjExLjExMTFIOC42NTA1MUw3IDEzLjMzMzNWMTQuNDQ0NEgxMC4zMzMzVjEzLjMzMzNIOC41ODc5MkwxMC4zMzMzIDExLjExMTFWMTBaIi8+Cg==","module":"src/styles/icons/filetype-zip.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/fit-to-view.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTExLjk5OTggNi4wODU4MkwxNS40MTQgOS41MDAwM0wxMy45OTk4IDEwLjkxNDJMMTEuOTk5OCA4LjkxNDI0TDkuOTk5NzUgMTAuOTE0Mkw4LjU4NTU0IDkuNTAwMDNMMTEuOTk5OCA2LjA4NTgyWiIvPgo8cGF0aCBkPSJNOS45OTk3NCAxMy4wODU4TDExLjk5OTggMTUuMDg1OEwxMy45OTk4IDEzLjA4NThMMTUuNDE0IDE0LjVMMTEuOTk5OCAxNy45MTQyTDguNTg1NTQgMTQuNUw5Ljk5OTc0IDEzLjA4NThaIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTkuOTk5OCA0LjAwMDA2SDMuOTk5NzZWMjBIMTkuOTk5OFY0LjAwMDA2Wk01Ljk5OTc2IDE4VjYuMDAwMDZIMTcuOTk5OFYxOEg1Ljk5OTc2WiIvPgo=","module":"src/styles/icons/fit-to-view.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/fit-to-width.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTYuMDg1NzUgMTIuMDAwMkw5LjQ5OTk3IDguNTg1OTdMMTAuOTE0MiAxMC4wMDAyTDguOTE0MTggMTIuMDAwMkwxMC45MTQyIDE0LjAwMDJMOS40OTk5NyAxNS40MTQ0TDYuMDg1NzUgMTIuMDAwMloiLz4KPHBhdGggZD0iTTEzLjA4NTggMTQuMDAwMkwxNS4wODU3IDEyLjAwMDJMMTMuMDg1OCAxMC4wMDAyTDE0LjUgOC41ODU5N0wxNy45MTQxIDEyLjAwMDJMMTQuNSAxNS40MTQ0TDEzLjA4NTggMTQuMDAwMloiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDQuMDAwMThMNCAyMC4wMDAyTDIwIDIwLjAwMDJMMjAgNC4wMDAxOEw0IDQuMDAwMThaTTE4IDE4LjAwMDJMNiAxOC4wMDAyTDYgNi4wMDAxOEwxOCA2LjAwMDE4TDE4IDE4LjAwMDJaIi8+Cg==","module":"src/styles/icons/fit-to-width.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/folder-new.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTEzIDEySDE1VjE0SDEzVjE2SDExVjE0SDlWMTJIMTFWMTBIMTNWMTJaIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNCA1SDEyLjYxOEwxMy42MTggN0gyMFYxOUg0VjVaTTYgN1YxN0gxOFY5SDEyLjM4MkwxMS4zODIgN0g2WiIvPgo=","module":"src/styles/icons/folder-new.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/folder-selected.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDVIMTIuNjE4TDEzLjYxOCA2Ljk5OTk5SDIwVjE5SDRWNVpNMTUuMDcxMSA5LjI5MjkxTDEwLjgyODUgMTMuNTM1Nkw4LjcwNzEyIDExLjQxNDJMNy4yOTI5MSAxMi44Mjg0TDEwLjgyODUgMTYuMzY0TDE2LjQ4NTMgMTAuNzA3MUwxNS4wNzExIDkuMjkyOTFaIi8+Cg==","module":"src/styles/icons/folder-selected.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/folder.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjk5OTg4IDQuOTk5OTRIMTIuNjE3OUwxMy42MTc5IDYuOTk5OTRIMTkuOTk5OVYxOC45OTk5SDMuOTk5ODhWNC45OTk5NFpNNS45OTk4OCA2Ljk5OTk0VjE2Ljk5OTlIMTcuOTk5OVY4Ljk5OTk0SDEyLjM4MThMMTEuMzgxOCA2Ljk5OTk0SDUuOTk5ODhaIi8+Cg==","module":"src/styles/icons/folder.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/fullscreen-minimize.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTE2LjQxNCA5LjAwMDAzTDIwLjcwNjkgNC43MDcwNkwxOS4yOTI3IDMuMjkyODVMMTQuOTk5OCA3LjU4NTc0VjQuMDAwMDNIMTIuOTk5OFYxMUgxOS45OTk4VjkuMDAwMDNIMTYuNDE0WiIvPgo8cGF0aCBkPSJNMTAuOTk5OCAyMFYxM0gzLjk5OTgzVjE1SDcuNTg1NzVMMy4yOTI5MSAxOS4yOTI5TDQuNzA3MTIgMjAuNzA3MUw4Ljk5OTgzIDE2LjQxNDRWMjBIMTAuOTk5OFoiLz4K","module":"src/styles/icons/fullscreen-minimize.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/fullscreen.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTE5Ljk5OTggMTFWNEgxMi45OTk4VjZIMTYuNTg1NUwxMi4yOTI3IDEwLjI5MjhMMTMuNzA2OSAxMS43MDdMMTcuOTk5OCA3LjQxNDE0VjExSDE5Ljk5OThaIi8+CjxwYXRoIGQ9Ik03LjQxNDE0IDE4TDExLjcwNzEgMTMuNzA3TDEwLjI5MjkgMTIuMjkyOEw1Ljk5OTgyIDE2LjU4NTlWMTNIMy45OTk4MlYyMEgxMC45OTk4VjE4SDcuNDE0MTRaIi8+Cg==","module":"src/styles/icons/fullscreen.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/google-color.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTE5LjUzNDUgMTAuNTQ1NUMxOS42MjkxIDExLjA2OTEgMTkuNjggMTEuNjE0NiAxOS42OCAxMi4xODE4QzE5LjY4IDE0LjYxODIgMTguODA3MyAxNi42NjkxIDE3LjI5NDUgMTguMDYxOEwxNC43MDkxIDE2LjA1NDZDMTUuNTU2NCAxNS40ODc0IDE2LjEyIDE0LjY0IDE2LjMwNTUgMTMuNjRIMTJWMTAuNTQ1NUgxOS41MzQ1WiIgZmlsbD0iIzQyODVGNCIvPgo8cGF0aCBkPSJNNC44NTA4NCAxNS41OTI2QzQuODUwODEgMTUuNTkyNSA0Ljg1MDg2IDE1LjU5MjcgNC44NTA4NCAxNS41OTI2TDcuNTIzNTggMTMuNTIwMUM4LjE1MjY4IDE1LjQxMSA5LjkxNjMxIDE2LjgxODIgMTEuOTk5OSAxNi44MTgyQzEzLjA3NjMgMTYuODE4MiAxMy45OTI3IDE2LjUzNDYgMTQuNzA5IDE2LjA1NDZMMTcuMjk0NSAxOC4wNjE5QzE1Ljk3MDggMTkuMjgzNyAxNC4xNTk5IDIwIDExLjk5OTkgMjBDOC44NzI2NiAyMCA2LjE2NzIgMTguMjA3MSA0Ljg1MDg0IDE1LjU5MjZaIiBmaWxsPSIjMzRBODUzIi8+CjxwYXRoIGQ9Ik00Ljg1MDg5IDguNDA3MzVMNy41MjM1NiAxMC40OEM3LjUyMzUzIDEwLjQ4MDEgNy41MjM1OCAxMC40Nzk5IDcuNTIzNTYgMTAuNDhDNy4zNjM1NiAxMC45NiA3LjI3MjczIDExLjQ3MjggNy4yNzI3MyAxMkM3LjI3MjczIDEyLjUyNzMgNy4zNjM2NCAxMy4wNCA3LjUyMzY0IDEzLjUyTDQuODUwOTEgMTUuNTkyOEM0LjMwOTA5IDE0LjUxMjggNCAxMy4yOTEgNCAxMkM0IDEwLjcwOTEgNC4zMDkwOCA5LjQ4NzM0IDQuODUwODkgOC40MDczNVoiIGZpbGw9IiNGQkJDMDUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS45OTk5IDcuMTgxODJDMTMuMTc0NSA3LjE4MTgyIDE0LjIyOSA3LjU4NTQ1IDE1LjA1ODEgOC4zNzgxOEwxNy4zNTI2IDYuMDgzNjRDMTUuOTY3MiA0Ljc5MjczIDE0LjE1NjMgNCAxMS45OTk5IDRDOC44NzI2NSA0IDYuMTY3MTkgNS43OTI3MyA0Ljg1MDgzIDguNDA3MjdMNy41MjM1NiAxMC40OEM4LjE1MjY1IDguNTg5MDkgOS45MTYyOCA3LjE4MTgyIDExLjk5OTkgNy4xODE4MloiIGZpbGw9IiNFQTQzMzUiLz4K","module":"src/styles/icons/google-color.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/google.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTE1LjA1ODEgOC4zNzgxOEMxNC4yMjkgNy41ODU0NSAxMy4xNzQ1IDcuMTgxODIgMTEuOTk5OSA3LjE4MTgyQzkuOTE2MzcgNy4xODE4MiA4LjE1MjggOC41ODg5NyA3LjUyMzY0IDEwLjQ3OThDNy4zNjM2NCAxMC45NTk4IDcuMjcyNzMgMTEuNDcyNyA3LjI3MjczIDEyQzcuMjcyNzMgMTIuNTI3MyA3LjM2MzY0IDEzLjA0IDcuNTIzNjQgMTMuNTJDOC4xNTI3NCAxNS40MTA5IDkuOTE2MyAxNi44MTgyIDExLjk5OTkgMTYuODE4MkMxMy4wNzYzIDE2LjgxODIgMTMuOTkyNiAxNi41MzQ2IDE0LjcwOSAxNi4wNTQ2QzE1LjU1NjMgMTUuNDg3MiAxNi4xMiAxNC42NCAxNi4zMDU1IDEzLjY0SDEyVjEwLjU0NTVIMTkuNTM0NUMxOS42MjkxIDExLjA2OTEgMTkuNjggMTEuNjE0NiAxOS42OCAxMi4xODE4QzE5LjY4IDE0LjYxODIgMTguODA3MyAxNi42NjkxIDE3LjI5NDUgMTguMDYxOEMxNS45NzA5IDE5LjI4MzcgMTQuMTU5OSAyMCAxMS45OTk5IDIwQzguODcyNjUgMjAgNi4xNjcxOSAxOC4yMDczIDQuODUwODMgMTUuNTkyN0M0LjMwOTA2IDE0LjUxMjggNCAxMy4yOTA5IDQgMTJDNCAxMC43MDkxIDQuMzA5MDggOS40ODczMSA0Ljg1MDg5IDguNDA3MzJDNi4xNjcyNiA1Ljc5Mjc4IDguODcyNjUgNCAxMS45OTk5IDRDMTQuMTU2MyA0IDE1Ljk2NzIgNC43OTI3MyAxNy4zNTI2IDYuMDgzNjRMMTUuMDU4MSA4LjM3ODE4WiIvPgo=","module":"src/styles/icons/google.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/image.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTE3IDE2TDEyLjk2NzkgMTBMMTEuMDA4NiAxMi44MjQ3TDEwLjE2NTYgMTEuODE3Nkw3IDE2SDE3WiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIwIDRINFYyMEgyMFY0Wk02IDE4VjZIMThWMThINloiLz4K","module":"src/styles/icons/image.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/info-inverse.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiA1QzguMTM0MDEgNSA1IDguMTM0MDEgNSAxMkM1IDE1Ljg2NiA4LjEzNDAxIDE5IDEyIDE5QzE1Ljg2NiAxOSAxOSAxNS44NjYgMTkgMTJDMTkgOC4xMzQwMSAxNS44NjYgNSAxMiA1Wk0zIDEyQzMgNy4wMjk0NCA3LjAyOTQ0IDMgMTIgM0MxNi45NzA2IDMgMjEgNy4wMjk0NCAyMSAxMkMyMSAxNi45NzA2IDE2Ljk3MDYgMjEgMTIgMjFDNy4wMjk0NCAyMSAzIDE2Ljk3MDYgMyAxMloiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi45OTk4IDExLjAwMDFWMTYuMDAwMUgxMC45OTk4VjExLjAwMDFIMTIuOTk5OFoiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS45OTk4IDguMDAwMDZDMTIuNTUyMSA4LjAwMDA2IDEyLjk5OTggOC40Mjg1IDEyLjk5OTggOC45NTdWOS4wNDMxMkMxMi45OTk4IDkuNTcxNjMgMTIuNTUyMSAxMC4wMDAxIDExLjk5OTggMTAuMDAwMUMxMS40NDc1IDEwLjAwMDEgMTAuOTk5OCA5LjU3MTYzIDEwLjk5OTggOS4wNDMxMlY4Ljk1N0MxMC45OTk4IDguNDI4NSAxMS40NDc1IDguMDAwMDYgMTEuOTk5OCA4LjAwMDA2WiIvPgo=","module":"src/styles/icons/info-inverse.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/instagram.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi41NzkyIDguMDkyNzFDMTAuODkzNiA3Ljg0Mjc2IDkuMjM3NzMgOC43MDE5NiA4LjQ3MTYyIDEwLjIyNEM3LjcwNTUxIDExLjc0NjEgOC4wMDE4OSAxMy41ODc5IDkuMjA2ODEgMTQuNzkyOUMxMC40MTE3IDE1Ljk5NzggMTIuMjUzNSAxNi4yOTQyIDEzLjc3NTYgMTUuNTI4QzE1LjI5NzcgMTQuNzYxOSAxNi4xNTY5IDEzLjEwNjEgMTUuOTA3IDExLjQyMDVDMTUuNjUxNyA5LjY5OTM1IDE0LjMwMDMgOC4zNDc5MyAxMi41NzkyIDguMDkyNzFaTTkuODExNDcgMTAuODk4NEMxMC4yODY2IDkuOTU0MzcgMTEuMzEzNyA5LjQyMTQ2IDEyLjM1OTIgOS41NzY0OUMxMy40MjY3IDkuNzM0NzkgMTQuMjY0OSAxMC41NzMgMTQuNDIzMiAxMS42NDA1QzE0LjU3ODIgMTIuNjg2IDE0LjA0NTMgMTMuNzEzIDEzLjEwMTIgMTQuMTg4MkMxMi4xNTcyIDE0LjY2MzQgMTEuMDE0OCAxNC40Nzk1IDEwLjI2NzUgMTMuNzMyMkM5LjUyMDEyIDEyLjk4NDkgOS4zMzYzIDExLjg0MjUgOS44MTE0NyAxMC44OTg0WiIvPgo8cGF0aCBkPSJNMTYuODc1MyA3LjYxOTQ1QzE2Ljg3NTMgNy4xMjk2MiAxNi40NzgyIDYuNzMyNTQgMTUuOTg4NCA2LjczMjU0TDE1Ljg4NTYgNi43Mzc2TDE1Ljg3NzkgNi43Mzg1QzE1LjQzNjYgNi43ODk3NSAxNS4wOTQyIDcuMTY0NTIgMTUuMDk0MiA3LjYxOTQ1QzE1LjA5NDIgOC4xMDkyNyAxNS40OTEzIDguNTA2NTMgMTUuOTgxMSA4LjUwNjUzTDE2LjA4MzkgOC41MDEyOUwxNi4wOTE3IDguNTAwMzlDMTYuNTMyOSA4LjQ0OTE1IDE2Ljg3NTMgOC4wNzQzNyAxNi44NzUzIDcuNjE5NDVaIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOC41NzE0MyAzLjI1QzUuNjMyNDggMy4yNSAzLjI1IDUuNjMyNDggMy4yNSA4LjU3MTQzVjE1LjQyODZDMy4yNSAxOC4zNjc1IDUuNjMyNDggMjAuNzUgOC41NzE0MyAyMC43NUgxNS40Mjg2QzE4LjM2NzUgMjAuNzUgMjAuNzUgMTguMzY3NSAyMC43NSAxNS40Mjg2VjguNTcxNDNDMjAuNzUgNS42MzI0OCAxOC4zNjc1IDMuMjUgMTUuNDI4NiAzLjI1SDguNTcxNDNaTTQuNzUgOC41NzE0M0M0Ljc1IDYuNDYwOTEgNi40NjA5MSA0Ljc1IDguNTcxNDMgNC43NUgxNS40Mjg2QzE3LjUzOTEgNC43NSAxOS4yNSA2LjQ2MDkxIDE5LjI1IDguNTcxNDNWMTUuNDI4NkMxOS4yNSAxNy41MzkxIDE3LjUzOTEgMTkuMjUgMTUuNDI4NiAxOS4yNUg4LjU3MTQzQzYuNDYwOTEgMTkuMjUgNC43NSAxNy41MzkxIDQuNzUgMTUuNDI4NlY4LjU3MTQzWiIvPgo=","module":"src/styles/icons/instagram.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/laptop.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMCA1SDRWMTZIMjBWNVpNNiAxNFY3SDE4VjE0SDZaTTIgMTlIMjJWMTdIMlYxOVoiLz4K","module":"src/styles/icons/laptop.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/link-add.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTIwLjAyOTMgMy45NzA3VjEuOTYyMzRIMTguMDI5M1YzLjk3MDdIMTYuMDIwOVY1Ljk3MDdIMTguMDI5M1Y3Ljk3OTA4SDIwLjAyOTNWNS45NzA3SDIyLjAzNzZWMy45NzA3SDIwLjAyOTNaIi8+CjxwYXRoIGQ9Ik01Ljk3MDcgMTJDNS45NzA3IDEwLjkyNjYgNi44ODkwOSA5Ljk4NzQzIDguMTA4NzggOS45ODc0M0gxMC45OTE2VjcuOTg3NDNIOC4xMDg3OEM1Ljg2MjI1IDcuOTg3NDMgMy45NzA3IDkuNzQ1ODMgMy45NzA3IDEyQzMuOTcwNyAxMy4wNzc3IDQuNDE3MDIgMTQuMTAyNSA1LjE5NzI5IDE0Ljg1MTZDNS45NzYxNyAxNS41OTkzIDcuMDI0MTcgMTYuMDEyNSA4LjEwODc4IDE2LjAxMjVIMTAuOTkxNlYxNC4wMTI1SDguMTA4NzhDNy41Mjg4NSAxNC4wMTI1IDYuOTgwNDggMTMuNzkxIDYuNTgyMzYgMTMuNDA4OEM2LjE4NTYyIDEzLjAyNzkgNS45NzA3IDEyLjUyMDMgNS45NzA3IDEyWiIvPgo8cGF0aCBkPSJNMTUuODkxMiA3Ljk4NzQzSDEzLjAwODRWOS45ODc0M0gxNS44OTEyQzE2LjQ3MTEgOS45ODc0MyAxNy4wMTk1IDEwLjIwOSAxNy40MTc2IDEwLjU5MTJDMTcuODE0NCAxMC45NzIgMTguMDI5MyAxMS40Nzk3IDE4LjAyOTMgMTJDMTguMDI5MyAxMy4wNzM0IDE3LjExMDkgMTQuMDEyNSAxNS44OTEyIDE0LjAxMjVIMTMuMDA4NFYxNi4wMTI1SDE1Ljg5MTJDMTguMTM3NyAxNi4wMTI1IDIwLjAyOTMgMTQuMjU0MSAyMC4wMjkzIDEyQzIwLjAyOTMgMTAuOTIyMyAxOS41ODMgOS44OTc0NSAxOC44MDI3IDkuMTQ4NEMxOC4wMjM4IDguNDAwNjcgMTYuOTc1OCA3Ljk4NzQzIDE1Ljg5MTIgNy45ODc0M1oiLz4KPHBhdGggZD0iTTE1LjAwODMgMTFIOC45OTE2MVYxM0gxNS4wMDgzVjExWiIvPgo=","module":"src/styles/icons/link-add.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/link-external.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTE0LjU4NTkgOEg5VjZIMThWMTVIMTZWOS40MTQzTDcuNzA3MTggMTcuNzA3MUw2LjI5Mjk3IDE2LjI5MjlMMTQuNTg1OSA4WiIvPgo=","module":"src/styles/icons/link-external.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/link.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTYgMTJDNiAxMC45MzM1IDYuOTEyNTMgMTAgOC4xMjUgMTBIMTFWOEg4LjEyNUM1Ljg4NTY5IDggNCA5Ljc1Mjc4IDQgMTJDNCAxMy4wNzQzIDQuNDQ0OTQgMTQuMDk2IDUuMjIyNzYgMTQuODQyN0M1Ljk5OTE5IDE1LjU4ODEgNy4wNDM4NSAxNiA4LjEyNSAxNkgxMVYxNEg4LjEyNUM3LjU0ODU0IDE0IDcuMDAzNSAxMy43Nzk4IDYuNjA3ODIgMTMuMzk5OUM2LjIxMzU0IDEzLjAyMTQgNiAxMi41MTcgNiAxMloiLz4KPHBhdGggZD0iTTE1Ljg3NSA4SDEzVjEwSDE1Ljg3NUMxNi40NTE1IDEwIDE2Ljk5NjUgMTAuMjIwMiAxNy4zOTIyIDEwLjYwMDFDMTcuNzg2NSAxMC45Nzg2IDE4IDExLjQ4MyAxOCAxMkMxOCAxMy4wNjY1IDE3LjA4NzUgMTQgMTUuODc1IDE0SDEzVjE2SDE1Ljg3NUMxOC4xMTQzIDE2IDIwIDE0LjI0NzIgMjAgMTJDMjAgMTAuOTI1NyAxOS41NTUxIDkuOTA0IDE4Ljc3NzIgOS4xNTcyOUMxOC4wMDA4IDguNDExOTIgMTYuOTU2MSA4IDE1Ljg3NSA4WiIvPgo8cGF0aCBkPSJNMTUgMTFIOVYxM0gxNVYxMVoiLz4K","module":"src/styles/icons/link.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/linkedin.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNi45OTM2IDE2LjY2SDE0Ljg0MTFWMTIuODY3QzE0Ljg0MTEgMTEuOTg1MyAxNC41Mjk0IDExLjM4MzQgMTMuNzUwNCAxMS4zODM0QzEzLjE1NTcgMTEuMzgzNCAxMi44MDE4IDExLjc4OTQgMTIuNjQ1OSAxMi4xODEyQzEyLjU4OTMgMTIuMzIxIDEyLjU3NSAxMi41MTcgMTIuNTc1IDEyLjcxMzFWMTYuNjZIMTAuNDIyNVYxMS45OTkxQzEwLjQyMjUgMTEuMTQ1NSAxMC4zOTQyIDEwLjQzMTcgMTAuMzY1OSA5LjgxNTc3SDEyLjIzNTFMMTIuMzM0NCAxMC43Njc2SDEyLjM3NjlDMTIuNjYwMSAxMC4zMTk2IDEzLjM1NDEgOS42NjE3MiAxNC41MTU0IDkuNjYxNzJDMTUuOTMxNiA5LjY2MTcyIDE2Ljk5MzYgMTAuNTk5NiAxNi45OTM2IDEyLjYxNTFWMTYuNjZaTTguMDQzNCA5LjEyODQ0QzcuMzYzNzkgOS4xMjg0NCA2LjkyNDc0IDguNjE4MjQgNi45MjQ3NCA3Ljk4ODM5QzYuOTI0NzQgNy4zNDM0NSA3LjM3Nzg0IDYuODQ4NDQgOC4wNzE2OSA2Ljg0ODQ0QzguNzY1NjIgNi44NDg0NCA5LjE5MDUzIDcuMzQzNDUgOS4yMDQ2NyA3Ljk4ODM5QzkuMjA0NjcgOC42MTgyNCA4Ljc2NTYyIDkuMTI4NDQgOC4wNDM0IDkuMTI4NDRWOS4xMjg0NFpNNi45ODE1MSAxNi42NTk5SDkuMTM0MTRWOS44MTU2M0g2Ljk4MTUxVjE2LjY1OTlaTTE4LjM4NjkgNEg1LjYxMzA3QzQuNzIyMDQgNCA0IDQuNzE2MDggNCA1LjU5OTU1VjE4LjQwMDVDNCAxOS4yODM5IDQuNzIyMDQgMjAgNS42MTMwNyAyMEgxOC4zODY5QzE5LjI3OCAyMCAyMCAxOS4yODM5IDIwIDE4LjQwMDVWNS41OTk1NUMyMCA0LjcxNjA4IDE5LjI3OCA0IDE4LjM4NjkgNFY0WiIvPgo=","module":"src/styles/icons/linkedin.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/menu.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTIwIDdINFY1SDIwVjdaIi8+CjxwYXRoIGQ9Ik0yMCAxOUg0VjE3SDIwVjE5WiIvPgo8cGF0aCBkPSJNNCAxM0gyMFYxMUg0VjEzWiIvPgo=","module":"src/styles/icons/menu.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/move.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDRIMjBWMjBINFY0Wk02IDZWMThIMThWNkg2Wk0xMiA3LjU4NTc5TDE2LjQxNDIgMTJMMTIgMTYuNDE0MkwxMC41ODU4IDE1TDEyLjU4NTggMTNIOFYxMUgxMi41ODU4TDEwLjU4NTggOUwxMiA3LjU4NTc5WiIvPgo=","module":"src/styles/icons/move.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/new.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMSAxNC40MTQyVjIwSDEzVjE0LjQxNDJMMTUuMjkyOCAxNi43MDdMMTYuNzA3MSAxNS4yOTI4TDE0LjQxNDIgMTNIMjBWMTFIMTQuNDE0MkwxNi43MDcxIDguNzA3MTFMMTUuMjkyOSA3LjI5MjlMMTMgOS41ODU3N1Y0SDExVjkuNTg1NzdMOC43MDcxMyA3LjI5MjlMNy4yOTI5MiA4LjcwNzExTDkuNTg1ODEgMTFINFYxM0g5LjU4NTc3TDcuMjkyOTQgMTUuMjkyOEw4LjcwNzE1IDE2LjcwN0wxMSAxNC40MTQyWiIvPgo=","module":"src/styles/icons/new.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/partial-circle.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOSAxMkMxOSA4LjEzNDAxIDE1Ljg2NiA1IDEyIDVMMTEgNUwxMSAzTDEyIDNDMTYuOTcwNiAzIDIxIDcuMDI5NDQgMjEgMTJDMjEgMTYuOTcwNiAxNi45NzA2IDIxIDEyIDIxQzcuMDI5NDQgMjEgMyAxNi45NzA2IDMgMTJMMyAxMUw1IDExTDUgMTJDNSAxNS44NjYgOC4xMzQwMSAxOSAxMiAxOUMxNS44NjYgMTkgMTkgMTUuODY2IDE5IDEyWiIvPgo=","module":"src/styles/icons/partial-circle.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/primary-source.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS40MTQyIDRINFYyMEgyMFY4LjU4NTc5TDE1LjQxNDIgNFpNNiAxOFY2SDEzVjExSDE4VjE4SDZaTTE3LjU4NTggOUwxNSA2LjQxNDIxVjlIMTcuNTg1OFoiLz4K","module":"src/styles/icons/primary-source.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/profile.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjMzMzMxIDEwLjIyMjJDOC4zMzMzMSA4LjE5NzE2IDkuOTc0OTQgNi41NTU1NCAxMiA2LjU1NTU0QzE0LjAyNSA2LjU1NTU0IDE1LjY2NjYgOC4xOTcxNiAxNS42NjY2IDEwLjIyMjJDMTUuNjY2NiAxMi4yNDczIDE0LjAyNSAxMy44ODg5IDEyIDEzLjg4ODlDOS45NzQ5NCAxMy44ODg5IDguMzMzMzEgMTIuMjQ3MyA4LjMzMzMxIDEwLjIyMjJaTTEyIDguNTU1NTRDMTEuMDc5NSA4LjU1NTU0IDEwLjMzMzMgOS4zMDE3MyAxMC4zMzMzIDEwLjIyMjJDMTAuMzMzMyAxMS4xNDI3IDExLjA3OTUgMTEuODg4OSAxMiAxMS44ODg5QzEyLjkyMDUgMTEuODg4OSAxMy42NjY2IDExLjE0MjcgMTMuNjY2NiAxMC4yMjIyQzEzLjY2NjYgOS4zMDE3MyAxMi45MjA1IDguNTU1NTQgMTIgOC41NTU1NFoiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiAzQzcuMDI5NDQgMyAzIDcuMDI5NDQgMyAxMkMzIDE2Ljk3MDYgNy4wMjk0NCAyMSAxMiAyMUMxNi45NzA2IDIxIDIxIDE2Ljk3MDYgMjEgMTJDMjEgNy4wMjk0NCAxNi45NzA2IDMgMTIgM1pNNSAxMkM1IDguMTM0MDEgOC4xMzQwMSA1IDEyIDVDMTUuODY2IDUgMTkgOC4xMzQwMSAxOSAxMkMxOSAxNC4wNjg4IDE4LjEwMjUgMTUuOTI4MSAxNi42NzU2IDE3LjIwOTZDMTUuNzI1MyAxNS42MjA0IDEzLjk4NzkgMTQuNTU1NSAxMiAxNC41NTU1QzEwLjAxMiAxNC41NTU1IDguMjc0NjEgMTUuNjIwNiA3LjMyNDM2IDE3LjIwOTVDNS44OTc0OSAxNS45MjggNSAxNC4wNjg4IDUgMTJaTTguOTkwODggMTguMzIyQzkuOTAyNDUgMTguNzU2NyAxMC45MjI4IDE5IDEyIDE5QzEzLjA3NzIgMTkgMTQuMDk3NSAxOC43NTY3IDE1LjAwOTEgMTguMzIyQzE0LjQxOTggMTcuMjY3NSAxMy4yOTIxIDE2LjU1NTUgMTIgMTYuNTU1NUMxMC43MDggMTYuNTU1NSA5LjU4MDMyIDE3LjI2NzQgOC45OTA4OCAxOC4zMjJaIi8+Cg==","module":"src/styles/icons/profile.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/question-inverse.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"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","module":"src/styles/icons/question-inverse.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/save.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS41MzMzIDE4Ljk1TDExLjk1IDE1LjExNTZMOC4zNjY2MiAxOC45NUg2Ljk0OTk1VjQuOTUwMDFIMTYuOTVWMTguOTVIMTUuNTMzM1oiIHN0cm9rZS13aWR0aD0iMiIgZmlsbD0ibm9uZSIvPgo=","module":"src/styles/icons/save.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/saved.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS41MzMzIDE4Ljk1TDExLjk1IDE1LjExNTZMOC4zNjY2MiAxOC45NUg2Ljk0OTk1VjQuOTUwMDFIMTYuOTVWMTguOTVIMTUuNTMzM1oiIHN0cm9rZS13aWR0aD0iMiIvPgo=","module":"src/styles/icons/saved.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/search.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS45MDU0IDE3LjMyMDFDMTQuNTUwNyAxOC4zNzMgMTIuODQ4NiAxOSAxMSAxOUM2LjU4MTcyIDE5IDMgMTUuNDE4MyAzIDExQzMgNi41ODE3MiA2LjU4MTcyIDMgMTEgM0MxNS40MTgzIDMgMTkgNi41ODE3MiAxOSAxMUMxOSAxMi44NDg4IDE4LjM3MjggMTQuNTUxMiAxNy4zMTk2IDE1LjkwNTlMMjEuNTIyNCAyMC4xMDg3TDIwLjEwODIgMjEuNTIyOUwxNS45MDU0IDE3LjMyMDFaTTUgMTFDNSA3LjY4NjI5IDcuNjg2MjkgNSAxMSA1QzE0LjMxMzcgNSAxNyA3LjY4NjI5IDE3IDExQzE3IDEyLjUyNDQgMTYuNDMxNSAxMy45MTYgMTUuNDk1IDE0Ljk3NDNMMTQuOTc0MyAxNS40OTVDMTMuOTE2IDE2LjQzMTUgMTIuNTI0NCAxNyAxMSAxN0M3LjY4NjI5IDE3IDUgMTQuMzEzNyA1IDExWiIvPgo=","module":"src/styles/icons/search.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/share.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTExLjk5OTkgNC4wODU5NEwxOC40MTQxIDEwLjUwMDJMMTYuOTk5OSAxMS45MTQ0TDEzIDcuOTE0NDZWMTZIMTFWNy45MTQyN0w2Ljk5OTkxIDExLjkxNDRMNS41ODU2OSAxMC41MDAyTDExLjk5OTkgNC4wODU5NFoiLz4KPHBhdGggZD0iTTYgMTVWMThIMThWMTVIMjBWMjBINFYxNUg2WiIvPgo=","module":"src/styles/icons/share.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/shift-down.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjcwNzExIDQuMjkyOTFMMTkuNzA3MSA0LjI5MjkxTDE5LjcwNzEgNi4yOTI5MUwzLjcwNzExIDYuMjkyOTFMMy43MDcxMSA0LjI5MjkxWk0xNy4xMjEzIDE0LjI5MjlMMTEuNzA3MSAxOS43MDcxTDYuMjkyODkgMTQuMjkyOUw3LjcwNzExIDEyLjg3ODdMMTAuNzA3MSAxNS44Nzg3TDEwLjcwNzEgOC4yOTI5MUwxMi43MDcxIDguMjkyOTFMMTIuNzA3MSAxNS44Nzg3TDE1LjcwNzEgMTIuODc4N0wxNy4xMjEzIDE0LjI5MjlaIiAvPg==","module":"src/styles/icons/shift-down.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/shift-left.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOCAyMFY0SDIwVjIwSDE4Wk0xMS40MTQyIDguMDAwMDJMMTAuNzA3MSA4LjcwNzEzTDguNDE0MiAxMUwxNiAxMVYxM0w4LjQxNDIxIDEzTDEwLjcwNzEgMTUuMjkyOUwxMS40MTQyIDE2TDkuOTk5OTkgMTcuNDE0M0w5LjI5Mjg5IDE2LjcwNzFMNS4yOTI4OSAxMi43MDcxTDQuNTg1NzggMTJMNS4yOTI4OSAxMS4yOTI5TDkuMjkyODkgNy4yOTI5MUw5Ljk5OTk5IDYuNTg1ODFMMTEuNDE0MiA4LjAwMDAyWiIvPgo=","module":"src/styles/icons/shift-left.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/shift-right.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDIwVjRINlYyMEg0Wk0xNCA2LjU4NTc5TDE5LjQxNDIgMTJMMTQgMTcuNDE0MkwxMi41ODU4IDE2TDE1LjU4NTggMTNIOFYxMUgxNS41ODU4TDEyLjU4NTggOEwxNCA2LjU4NTc5WiIvPgo=","module":"src/styles/icons/shift-right.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/shift-up.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjI5Mjg5IDE3LjcwNzFMMjAuMjkyOSAxNy43MDcxTDIwLjI5MjkgMTkuNzA3MUw0LjI5Mjg5IDE5LjcwNzFMNC4yOTI4OSAxNy43MDcxWk0xNi4yOTI5IDExLjEyMTNMMTUuNTg1OCAxMC40MTQyTDEzLjI5MjkgOC4xMjEzM0wxMy4yOTI5IDE1LjcwNzFMMTEuMjkyOSAxNS43MDcxTDExLjI5MjkgOC4xMjEzM0w4Ljk5OTk2IDEwLjQxNDJMOC4yOTI4NSAxMS4xMjEzTDYuODc4NjQgOS43MDcxMkw3LjU4NTc1IDkuMDAwMDFMMTEuNTg1OCA1LjAwMDAxTDEyLjI5MjkgNC4yOTI5MUwxMyA1LjAwMDAxTDE3IDkuMDAwMDFMMTcuNzA3MSA5LjcwNzEyTDE2LjI5MjkgMTEuMTIxM1oiIC8+Cg==","module":"src/styles/icons/shift-up.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/tumblr.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMy4zODc5IDIwQzEwLjk3NzQgMjAgOS4xODk1OCAxOC43NjQ2IDkuMTg5NTggMTUuODAxNlYxMS4wNjA5SDdWOC40ODk2NEM5LjQxMDU1IDcuODY2OTIgMTAuNDE0OSA1Ljc5Nzg3IDEwLjUyNTQgNEgxMy4wMjY0VjguMDc3ODRIMTUuOTM5MVYxMS4wNjA5SDEzLjAyNjRWMTUuMTg5MUMxMy4wMjY0IDE2LjQyNDQgMTMuNjQ5MiAxNi44NTYyIDE0LjY0MzQgMTYuODU2MkgxNi4wNTk3VjIwSDEzLjM4NzlaIi8+Cg==","module":"src/styles/icons/tumblr.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/twitter.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTkuMDMxNjggMTlDMTUuMDY5NCAxOSAxOC4zNzE4IDEzLjk5ODEgMTguMzcxOCA5LjY2MDQ0QzE4LjM3MTggOS41MTgzNyAxOC4zNzE4IDkuMzc2OTQgMTguMzYyMiA5LjIzNjE1QzE5LjAwNDcgOC43NzE0OCAxOS41NTkzIDguMTk2MTMgMjAgNy41MzcwNUMxOS40MDA5IDcuODAyNTEgMTguNzY1MyA3Ljk3NjYgMTguMTE0NiA4LjA1MzVDMTguNzk5OCA3LjY0MzI4IDE5LjMxMjcgNi45OTgwNiAxOS41NTc4IDYuMjM3OTRDMTguOTEzNCA2LjYyMDI4IDE4LjIwODQgNi44ODk3NCAxNy40NzMzIDcuMDM0NjlDMTYuOTc4MyA2LjUwODQ0IDE2LjMyMzcgNi4xNTk5NyAxNS42MTA4IDYuMDQzMjFDMTQuODk3OCA1LjkyNjQ0IDE0LjE2NjMgNi4wNDc4OSAxMy41MjkzIDYuMzg4NzZDMTIuODkyMyA2LjcyOTYzIDEyLjM4NTUgNy4yNzA5MiAxMi4wODcyIDcuOTI4ODZDMTEuNzg4OCA4LjU4NjggMTEuNzE1NyA5LjMyNDcyIDExLjg3OSAxMC4wMjg0QzEwLjU3MzkgOS45NjI5OSA5LjI5NzE1IDkuNjIzODUgOC4xMzE2MSA5LjAzMzAyQzYuOTY2MDcgOC40NDIxOCA1LjkzNzgyIDcuNjEyODUgNS4xMTM2IDYuNTk4ODdDNC42OTM4MiA3LjMyMTQ5IDQuNTY1MjUgOC4xNzY5MiA0Ljc1NDA3IDguOTkxQzQuOTQyODggOS44MDUwOCA1LjQzNDg5IDEwLjUxNjYgNi4xMjk5MiAxMC45ODA3QzUuNjA3NTEgMTAuOTY1MiA1LjA5NjUgMTAuODI0MyA0LjY0IDEwLjU2OThDNC42NCAxMC41ODMzIDQuNjQgMTAuNTk3MyA0LjY0IDEwLjYxMTRDNC42NDAyMSAxMS4zNjkzIDQuOTAyNTcgMTIuMTAzNyA1LjM4MjU4IDEyLjY5MDJDNS44NjI1OSAxMy4yNzY3IDYuNTMwNzEgMTMuNjc5MSA3LjI3MzYgMTMuODI5MUM2Ljc5MDMyIDEzLjk2MDkgNi4yODMyNSAxMy45ODAyIDUuNzkxMzYgMTMuODg1NEM2LjAwMTEzIDE0LjUzNzcgNi40MDk1MSAxNS4xMDggNi45NTk0MSAxNS41MTY4QzcuNTA5MyAxNS45MjU1IDguMTczMTkgMTYuMTUyMSA4Ljg1ODI0IDE2LjE2NUM3LjY5NTgzIDE3LjA3ODUgNi4yNTk4OCAxNy41NzQ0IDQuNzgxNDQgMTcuNTcyOUM0LjUyMDI2IDE3LjU3MjQgNC4yNTkzMyAxNy41NTY2IDQgMTcuNTI1NUM1LjUwMTIxIDE4LjQ4ODggNy4yNDc5NCAxOC45OTk4IDkuMDMxNjggMTguOTk3NCIvPgo=","module":"src/styles/icons/twitter.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/video.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDRIMjBWMjBINFY0Wk02IDZWMThIMThWNkg2WiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE1IDEyTDEwIDE1VjlMMTUgMTJaIi8+Cg==","module":"src/styles/icons/video.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/view-gallery.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjk5OTc2IDQuMDAwMDZIMTkuOTk5OFYyMC4wMDAxSDMuOTk5NzZWNC4wMDAwNlpNNS45OTk3NiA2LjAwMDA2VjExLjAwMDFIMTAuOTk5OFY2LjAwMDA2SDUuOTk5NzZaTTEyLjk5OTggNi4wMDAwNlYxMS4wMDAxSDE3Ljk5OThWNi4wMDAwNkgxMi45OTk4Wk0xMC45OTk4IDEzLjAwMDFINS45OTk3NlYxOC4wMDAxSDEwLjk5OThWMTMuMDAwMVpNMTIuOTk5OCAxOC4wMDAxVjEzLjAwMDFIMTcuOTk5OFYxOC4wMDAxSDEyLjk5OThaIi8+Cg==","module":"src/styles/icons/view-gallery.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/view-grid.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDRIMjAuMDE2NFYyMC4wMzIzSDRWNFpNNiAxNS4zNTQ4VjE4LjAzMjNIOC42NzIxMlYxNS4zNTQ4SDZaTTYgMTMuMzU0OEg4LjY3MjEyVjEwLjY3NzZINlYxMy4zNTQ4Wk0xMC42NzIxIDE1LjM1NDhWMTguMDMyM0gxMy4zNDQzVjE1LjM1NDhMMTAuNjcyMSAxNS4zNTQ4Wk0xMy4zNDQzIDEzLjM1NDhMMTAuNjcyMSAxMy4zNTQ4VjEwLjY3NzZIMTMuMzQ0M1YxMy4zNTQ4Wk0xNS4zNDQzIDE1LjM1NDhWMTguMDMyM0gxOC4wMTY0VjE1LjM1NDhIMTUuMzQ0M1pNMTguMDE2NCAxMy4zNTQ4SDE1LjM0NDNWMTAuNjc3NkgxOC4wMTY0VjEzLjM1NDhaTTYgOC42Nzc2NEg4LjY3MjEyVjZINlY4LjY3NzY0Wk0xOC4wMTY0IDguNjc3NjRIMTUuMzQ0M1Y2SDE4LjAxNjRWOC42Nzc2NFpNMTAuNjcyMSA2SDEzLjM0NDNWOC42Nzc2NEgxMC42NzIxVjZaIi8+Cg==","module":"src/styles/icons/view-grid.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/view-list.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjk5OTc2IDQuMDAwMDZIMTkuOTk5OFYyMC4wMDAxSDMuOTk5NzZWNC4wMDAwNlpNNS45OTk3NiA2LjAwMDA2VjE4LjAwMDFIMTcuOTk5OFY2LjAwMDA2SDUuOTk5NzZaTTkuOTk5NzYgMTAuMDAwMUg3Ljk5OTc2VjguMDAwMDZIOS45OTk3NlYxMC4wMDAxWk0xNS45OTk4IDEwLjAwMDFIMTAuOTk5OFY4LjAwMDA2SDE1Ljk5OThWMTAuMDAwMVpNOS45OTk3NiAxMy4wMDAxSDcuOTk5NzZWMTEuMDAwMUg5Ljk5OTc2VjEzLjAwMDFaTTE1Ljk5OTggMTMuMDAwMUgxMC45OTk4VjExLjAwMDFIMTUuOTk5OFYxMy4wMDAxWk05Ljk5OTc2IDE2LjAwMDFINy45OTk3NlYxNC4wMDAxSDkuOTk5NzZWMTYuMDAwMVpNMTUuOTk5OCAxNi4wMDAxSDEwLjk5OThWMTQuMDAwMUgxNS45OTk4VjE2LjAwMDFaIi8+Cg==","module":"src/styles/icons/view-list.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/workspace-selected.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTE1Ljk5OTggNC4wMDAwNkg3Ljk5OTgyVjcuNUg5Ljk5OTgyVjYuMDAwMDZIMTMuOTk5OFY3LjVIMTUuOTk5OFY0LjAwMDA2WiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE5Ljk5OTggNy4wMDAwNkgzLjk5OTgyVjIwSDE5Ljk5OThWNy4wMDAwNlpNMTAuODI4NSAxNC41MzU2TDE1LjA3MTEgMTAuMjkyOUwxNi40ODUzIDExLjcwNzFMMTAuODI4NSAxNy4zNjRMNy4yOTI5MSAxMy44Mjg0TDguNzA3MTIgMTIuNDE0MkwxMC44Mjg1IDE0LjUzNTZaIi8+Cg==","module":"src/styles/icons/workspace-selected.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/workspace.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDRIMTZWN0gyMFYyMEg0VjdIOFY0Wk0xMCA2VjdIMTRWNkgxMFpNNiA5VjEySDE4VjlINlpNMTggMTRIMTRWMTZIMTBWMTRINlYxOEgxOFYxNFoiLz4K","module":"src/styles/icons/workspace.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/youtube.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi42NjQ5IDYuMDAzMDRMMTEuODM4NCA2TDExLjEwMDQgNi4wMDU3NUwxMC41ODExIDYuMDEzMTRDMTAuMjI5NiA2LjAxOTA5IDkuODY5MTMgNi4wMjcxNSA5LjUwOTM4IDYuMDM3NjlMOC42MzY0MSA2LjA2ODYzTDguMTk5MTcgNi4wODkxQzcuMjE2NjYgNi4xMzk4NiA2LjUwMDI3IDYuMjEyMTIgNi4wOTQ3MSA2LjMxNjUxQzUuMjE2OTIgNi41NTU0NSA0LjU0NjE1IDcuMjIxIDQuMzI2OTkgOC4wNjM3M0M0LjEwMDU0IDkuMjY0MiAzLjk5NDM1IDEwLjQzOTUgNC4wMDAzOSAxMS42MTY3QzMuOTkyNjYgMTIuNzk1NiA0LjA5ODg1IDEzLjk3OTkgNC4zMTc2MiAxNS4xNDcyQzQuNTczOTYgMTYuMDI0OSA1LjI0MDggMTYuNjYwMSA2LjA5MTAxIDE2Ljg4NEM2LjU0MDk1IDE2Ljk5OTggNy4zNjM1NyAxNy4wNzU3IDguNTA1NiAxNy4xMjdMOC45NzkzMiAxNy4xNDYzQzkuNDc1NDYgMTcuMTY0NiA5Ljk5NzQyIDE3LjE3NzkgMTAuNTI1OCAxNy4xODcxTDExLjU3OTkgMTcuMkgxMi40MjAxTDEzLjQ3NDIgMTcuMTg3MUMxNC4wMDI2IDE3LjE3NzkgMTQuNTI0NSAxNy4xNjQ2IDE1LjAyMDcgMTcuMTQ2M0wxNS40OTQ0IDE3LjEyN0wxNi4xNDA4IDE3LjA5MzJDMTYuOTUwMiAxNy4wNDM4IDE3LjU0NzkgMTYuOTc2OSAxNy45MDUzIDE2Ljg4NDlDMTguNzgzMSAxNi42NDYgMTkuNDUzOCAxNS45ODA0IDE5LjY3MyAxNS4xMzc3QzE5Ljg5NzggMTMuOTQ1OSAyMC4wMDQgMTIuNzc5NiAxOS45OTk2IDExLjYxMTJDMjAuMDA3MyAxMC40MzE1IDE5LjkwMTEgOS4yNDcyNCAxOS42ODI0IDguMDc5OTVDMTkuNDUzOCA3LjE5NTMzIDE4Ljc4MzEgNi41Mjk3OSAxNy45MTQ1IDYuMjkzMjlDMTcuMzg1NiA2LjE2ODU2IDE2LjM4NTIgNi4wOTUzOCAxNC45ODA2IDYuMDQ5TDE0LjM5NzQgNi4wMzE5NEMxMy44MTEyIDYuMDE2ODkgMTMuMjIwNSA2LjAwNzcxIDEyLjY2NDkgNi4wMDMwNFpNMTQuMzMzNSAxMS42MTM0TDEwLjUwMDQgOS41MTU0MVYxMy43MTE0TDE0LjMzMzUgMTEuNjEzNFoiLz4K","module":"src/styles/icons/youtube.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/zoom-in.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTEyIDcuOTk5OTdWOS45OTk5N0gxNFYxMkgxMlYxNEgxMFYxMkg4VjkuOTk5OTdIMTBWNy45OTk5N0gxMloiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDExQzQgNy4xMzQgNy4xMzQwMSA0IDExIDRDMTQuODY2IDQgMTggNy4xMzQgMTggMTFDMTggMTIuNTcyMyAxNy40ODE2IDE0LjAyMzUgMTYuNjA2NCAxNS4xOTIxTDIxLjUyMjYgMjAuMTA4M0wyMC4xMDgzIDIxLjUyMjVMMTUuMTkyMiAxNi42MDYzQzE0LjAyMzYgMTcuNDgxNiAxMi41NzI0IDE4IDExIDE4QzcuMTM0MDEgMTggNCAxNC44NjYgNCAxMVpNMTEgNkM4LjIzODU3IDYgNiA4LjIzODU3IDYgMTFDNiAxMy43NjE0IDguMjM4NTcgMTYgMTEgMTZDMTMuNzYxNCAxNiAxNiAxMy43NjE0IDE2IDExQzE2IDguMjM4NTcgMTMuNzYxNCA2IDExIDZaIi8+Cg==","module":"src/styles/icons/zoom-in.ts"}}]},{"kind":"javascript-module","path":"src/styles/icons/zoom-out.ts","declarations":[],"exports":[{"kind":"js","name":"default","declaration":{"name":"PHBhdGggZD0iTTE0IDEyVjkuOTk5OTdIOFYxMkgxNFoiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDExQzQgNy4xMzQgNy4xMzQwMSA0IDExIDRDMTQuODY2IDQgMTggNy4xMzQgMTggMTFDMTggMTIuNTcyMyAxNy40ODE2IDE0LjAyMzUgMTYuNjA2NCAxNS4xOTIxTDIxLjUyMjYgMjAuMTA4M0wyMC4xMDgzIDIxLjUyMjVMMTUuMTkyMiAxNi42MDYzQzE0LjAyMzYgMTcuNDgxNiAxMi41NzI0IDE4IDExIDE4QzcuMTM0MDEgMTggNCAxNC44NjYgNCAxMVpNMTEgNkM4LjIzODU3IDYgNiA4LjIzODU3IDYgMTFDNiAxMy43NjE0IDguMjM4NTcgMTYgMTEgMTZDMTMuNzYxNCAxNiAxNiAxMy43NjE0IDE2IDExQzE2IDguMjM4NTcgMTMuNzYxNCA2IDExIDZaIi8+Cg==","module":"src/styles/icons/zoom-out.ts"}}]},{"kind":"javascript-module","path":"src/utils/mixins/focus.ts","declarations":[{"kind":"mixin","description":"","name":"FocusMixin","members":[{"kind":"method","name":"focus","privacy":"public","return":{"type":{"text":"void"}}}],"parameters":[{"name":"Base","type":{"text":"T"},"description":"The base class for the mixin to modify."}],"mixins":[{"name":"dedupeMixin","package":"@open-wc/dedupe-mixin"}]}],"exports":[{"kind":"js","name":"default","declaration":{"name":"FocusMixin","module":"src/utils/mixins/focus.ts"}}]},{"kind":"javascript-module","path":"src/utils/mixins/form.ts","declarations":[{"kind":"mixin","description":"","name":"FormMixin","members":[{"kind":"method","name":"_handleFormdata","return":{"type":{"text":"void"}},"parameters":[{"name":"event","type":{"text":"Event"},"description":"The event."}],"description":"Handles the `formdata` event."},{"kind":"method","name":"_handleFormReset","return":{"type":{"text":"void"}},"description":"Handles the `reset` event."}],"parameters":[{"name":"Base","type":{"text":"T"},"description":"The base class for the mixin to modify."}],"mixins":[{"name":"dedupeMixin","package":"@open-wc/dedupe-mixin"}]}],"exports":[{"kind":"js","name":"default","declaration":{"name":"FormMixin","module":"src/utils/mixins/form.ts"}}]},{"kind":"javascript-module","path":"src/utils/mixins/observe-children.ts","declarations":[{"kind":"mixin","description":"","name":"ObserveChildrenMixin","members":[{"kind":"field","name":"_childrenObserver","type":{"text":"MutationObserver | null"},"privacy":"private","default":"null"},{"kind":"field","name":"_handleMutation","privacy":"private"}],"parameters":[{"name":"Base","type":{"text":"T"},"description":"The base class for the mixin to modify."}],"mixins":[{"name":"dedupeMixin","package":"@open-wc/dedupe-mixin"}]}],"exports":[{"kind":"js","name":"default","declaration":{"name":"ObserveChildrenMixin","module":"src/utils/mixins/observe-children.ts"}}]},{"kind":"javascript-module","path":"src/utils/mixins/pharos-component.ts","declarations":[{"kind":"mixin","description":"","name":"PharosComponentMixin","parameters":[{"name":"Base","type":{"text":"T"},"description":"The base class for the mixin to modify."}],"mixins":[{"name":"dedupeMixin","package":"@open-wc/dedupe-mixin"}]}],"exports":[{"kind":"js","name":"default","declaration":{"name":"PharosComponentMixin","module":"src/utils/mixins/pharos-component.ts"}}]},{"kind":"javascript-module","path":"src/utils/mixins/scoped-registry.ts","declarations":[{"kind":"variable","name":"ScopedRegistryMixin"}],"exports":[{"kind":"js","name":"default","declaration":{"name":"ScopedRegistryMixin","module":"src/utils/mixins/scoped-registry.ts"}}]}]}');
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js
var injectStylesIntoStyleTag = __webpack_require__("./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
var injectStylesIntoStyleTag_default = /*#__PURE__*/__webpack_require__.n(injectStylesIntoStyleTag);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleDomAPI.js
var styleDomAPI = __webpack_require__("./node_modules/style-loader/dist/runtime/styleDomAPI.js");
var styleDomAPI_default = /*#__PURE__*/__webpack_require__.n(styleDomAPI);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertBySelector.js
var insertBySelector = __webpack_require__("./node_modules/style-loader/dist/runtime/insertBySelector.js");
var insertBySelector_default = /*#__PURE__*/__webpack_require__.n(insertBySelector);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js
var setAttributesWithoutAttributes = __webpack_require__("./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js");
var setAttributesWithoutAttributes_default = /*#__PURE__*/__webpack_require__.n(setAttributesWithoutAttributes);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertStyleElement.js
var insertStyleElement = __webpack_require__("./node_modules/style-loader/dist/runtime/insertStyleElement.js");
var insertStyleElement_default = /*#__PURE__*/__webpack_require__.n(insertStyleElement);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleTagTransform.js
var styleTagTransform = __webpack_require__("./node_modules/style-loader/dist/runtime/styleTagTransform.js");
var styleTagTransform_default = /*#__PURE__*/__webpack_require__.n(styleTagTransform);
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[12].use[1]!./node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[12].use[2]!./packages/pharos-site/static/styles/global.scss
var global = __webpack_require__("./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[12].use[1]!./node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[12].use[2]!./packages/pharos-site/static/styles/global.scss");
;// CONCATENATED MODULE: ./packages/pharos-site/static/styles/global.scss

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (styleTagTransform_default());
options.setAttributes = (setAttributesWithoutAttributes_default());

      options.insert = insertBySelector_default().bind(null, "head");
    
options.domAPI = (styleDomAPI_default());
options.insertStyleElement = (insertStyleElement_default());

var update = injectStylesIntoStyleTag_default()(global/* default */.Z, options);




       /* harmony default export */ const styles_global = (global/* default */.Z && global/* default.locals */.Z.locals ? global/* default.locals */.Z.locals : undefined);

// EXTERNAL MODULE: ./packages/pharos/lib/styles/fonts.css
var fonts = __webpack_require__("./packages/pharos/lib/styles/fonts.css");
// EXTERNAL MODULE: ./packages/pharos/lib/styles/variables.css
var variables = __webpack_require__("./packages/pharos/lib/styles/variables.css");
// EXTERNAL MODULE: ./packages/pharos/lib/styles/pharos-alert.css
var pharos_alert = __webpack_require__("./packages/pharos/lib/styles/pharos-alert.css");
// EXTERNAL MODULE: ./packages/pharos/lib/styles/pharos-modal.css
var pharos_modal = __webpack_require__("./packages/pharos/lib/styles/pharos-modal.css");
// EXTERNAL MODULE: ./packages/pharos/lib/styles/pharos-footer.css
var pharos_footer = __webpack_require__("./packages/pharos/lib/styles/pharos-footer.css");
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[12].use[1]!./node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[12].use[2]!./packages/pharos/lib/styles/typography.scss
var typography = __webpack_require__("./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[12].use[1]!./node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[12].use[2]!./packages/pharos/lib/styles/typography.scss");
;// CONCATENATED MODULE: ./packages/pharos/lib/styles/typography.scss

      
      
      
      
      
      
      
      
      

var typography_options = {};

typography_options.styleTagTransform = (styleTagTransform_default());
typography_options.setAttributes = (setAttributesWithoutAttributes_default());

      typography_options.insert = insertBySelector_default().bind(null, "head");
    
typography_options.domAPI = (styleDomAPI_default());
typography_options.insertStyleElement = (insertStyleElement_default());

var typography_update = injectStylesIntoStyleTag_default()(typography/* default */.Z, typography_options);




       /* harmony default export */ const styles_typography = (typography/* default */.Z && typography/* default.locals */.Z.locals ? typography/* default.locals */.Z.locals : undefined);

;// CONCATENATED MODULE: ./.storybook/styleConfig.js








// EXTERNAL MODULE: ./packages/pharos/src/components/base/pharos-element.ts
var pharos_element = __webpack_require__("./packages/pharos/src/components/base/pharos-element.ts");
// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./node_modules/lit/decorators.js + 6 modules
var decorators = __webpack_require__("./node_modules/lit/decorators.js");
// EXTERNAL MODULE: ./node_modules/lit/directives/class-map.js + 1 modules
var class_map = __webpack_require__("./node_modules/lit/directives/class-map.js");
;// CONCATENATED MODULE: ./packages/pharos/src/components/alert/pharos-alert.css.ts

const alertStyles = lit/* css */.iv`
        :host{contain:layout;display:block}.alert{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;grid-gap:var(--pharos-spacing-1-x);background:var(--pharos-alert-color-background-base);border-radius:var(--pharos-radius-base-standard);box-sizing:border-box;color:var(--pharos-alert-color-text-base);display:grid;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-font-size-base);font-weight:var(--pharos-font-weight-regular);grid-template-areas:"icon body";grid-template-columns:var(--pharos-spacing-one-and-a-half-x) 1fr;letter-spacing:calc(var(--pharos-font-size-base)*-.02);line-height:var(--pharos-line-height-medium);padding:var(--pharos-spacing-1-x);text-rendering:optimizelegibility;width:100%}.alert--closable{align-items:start;grid-template-areas:"icon body close";grid-template-columns:var(--pharos-spacing-one-and-a-half-x) 1fr 1.75rem}.alert__icon{fill:var(--pharos-alert-color-icon-base);grid-area:icon}.alert__body{grid-area:body}.alert__button{grid-area:close}.alert--info{background:var(--pharos-alert-color-background-info);border:1px solid var(--pharos-alert-color-border-info)}.alert--info .alert__icon{fill:var(--pharos-alert-color-icon-info)}.alert--success{background:var(--pharos-alert-color-background-success);border:1px solid var(--pharos-alert-color-border-success)}.alert--success .alert__icon{fill:var(--pharos-alert-color-icon-success)}.alert--warning{background:var(--pharos-alert-color-background-warning);border:1px solid var(--pharos-alert-color-border-warning)}.alert--warning .alert__icon{fill:var(--pharos-alert-color-icon-warning)}.alert--error{background:var(--pharos-alert-color-background-error);border:1px solid var(--pharos-alert-color-border-error)}.alert--error .alert__icon{fill:var(--pharos-alert-color-icon-error)}
      `;

// EXTERNAL MODULE: ./packages/pharos/src/utils/mixins/focus.ts
var mixins_focus = __webpack_require__("./packages/pharos/src/utils/mixins/focus.ts");
// EXTERNAL MODULE: ./packages/pharos/src/utils/mixins/scoped-registry.ts
var scoped_registry = __webpack_require__("./packages/pharos/src/utils/mixins/scoped-registry.ts");
// EXTERNAL MODULE: ./packages/pharos/src/components/icon/pharos-icon.ts + 1 modules
var pharos_icon = __webpack_require__("./packages/pharos/src/components/icon/pharos-icon.ts");
// EXTERNAL MODULE: ./packages/pharos/src/components/button/pharos-button.ts + 1 modules
var pharos_button = __webpack_require__("./packages/pharos/src/components/button/pharos-button.ts");
;// CONCATENATED MODULE: ./packages/pharos/src/components/alert/pharos-alert.ts
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};









var ALERT_ICON = /* @__PURE__ */ ((ALERT_ICON2) => {
  ALERT_ICON2["INFO"] = "info-inverse";
  ALERT_ICON2["ERROR"] = "exclamation-inverse";
  ALERT_ICON2["SUCCESS"] = "checkmark-inverse";
  ALERT_ICON2["WARNING"] = "exclamation-inverse";
  return ALERT_ICON2;
})(ALERT_ICON || {});
const STATUSES = ["info", "success", "warning", "error"];
class PharosAlert extends (0,scoped_registry/* default */.Z)((0,mixins_focus/* default */.Z)(pharos_element/* PharosElement */.Z)) {
  constructor() {
    super(...arguments);
    this.closable = false;
  }
  static get styles() {
    return [alertStyles];
  }
  update(changedProperties) {
    super.update && super.update(changedProperties);
    if (!this.status) {
      throw new Error(`status is a required attribute.`);
    }
    if (changedProperties.has("status") && !STATUSES.includes(this.status)) {
      throw new Error(
        `${this.status} is not a valid status. Valid statuses are: ${STATUSES.join(", ")}`
      );
    }
  }
  _getIcon() {
    var _a;
    const key = (_a = this.status) == null ? void 0 : _a.toUpperCase();
    return ALERT_ICON[key] || "info-inverse" /* INFO */;
  }
  _handleSlotChange() {
    this._allLinks.forEach((link) => {
      link["_alert"] = true;
    });
  }
  close() {
    this.remove();
    const details = {
      bubbles: true,
      composed: true
    };
    this.dispatchEvent(new CustomEvent("pharos-alert-closed", details));
  }
  _renderCloseButton() {
    return this.closable ? lit/* html */.dy` <pharos-button
          type="button"
          variant="subtle"
          icon="close"
          label="Close alert"
          class="alert__button"
          @click=${this.close}
        ></pharos-button>` : lit/* nothing */.Ld;
  }
  render() {
    return lit/* html */.dy`
      <div
        role="alert"
        class="${(0,class_map/* classMap */.$)({
      [`alert`]: true,
      [`alert--${this.status}`]: this.status || "",
      [`alert--closable`]: this.closable
    })}"
        tabindex="0"
      >
        <pharos-icon class="alert__icon" name="${this._getIcon()}"></pharos-icon>
        <div class="alert__body">
          <slot @slotchange=${this._handleSlotChange}></slot>
        </div>
        ${this._renderCloseButton()}
      </div>
    `;
  }
}
PharosAlert.elementDefinitions = {
  "pharos-icon": pharos_icon/* PharosIcon */.b,
  "pharos-button": pharos_button/* PharosButton */.b
};
__decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosAlert.prototype, "status", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], PharosAlert.prototype, "closable", 2);
__decorateClass([
  (0,decorators/* queryAssignedElements */.NH)({ selector: '[data-pharos-component="PharosLink"]' })
], PharosAlert.prototype, "_allLinks", 2);

;// CONCATENATED MODULE: ./packages/pharos/src/components/breadcrumb/pharos-breadcrumb.css.ts

const breadcrumbStyles = lit/* css */.iv`
        :host{contain:layout;display:inline-block}:host .breadcrumb{align-items:center;display:flex;flex-wrap:wrap;margin:0;padding:0}
      `;

;// CONCATENATED MODULE: ./packages/pharos/src/components/breadcrumb/pharos-breadcrumb.ts
var pharos_breadcrumb_defProp = Object.defineProperty;
var pharos_breadcrumb_getOwnPropDesc = Object.getOwnPropertyDescriptor;
var pharos_breadcrumb_decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? pharos_breadcrumb_getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    pharos_breadcrumb_defProp(target, key, result);
  return result;
};





class PharosBreadcrumb extends (0,mixins_focus/* default */.Z)(pharos_element/* PharosElement */.Z) {
  static get styles() {
    return [breadcrumbStyles];
  }
  _handleSlotchange() {
    this._allBreadcrumbItems.forEach((item, index) => {
      item["_last"] = index === this._allBreadcrumbItems.length - 1;
    });
  }
  render() {
    return lit/* html */.dy`<nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <slot @slotchange=${this._handleSlotchange}></slot>
      </ol>
    </nav>`;
  }
}
pharos_breadcrumb_decorateClass([
  (0,decorators/* queryAssignedElements */.NH)({ selector: '[data-pharos-component="PharosBreadcrumbItem"]' })
], PharosBreadcrumb.prototype, "_allBreadcrumbItems", 2);

// EXTERNAL MODULE: ./node_modules/lit/directives/if-defined.js + 1 modules
var if_defined = __webpack_require__("./node_modules/lit/directives/if-defined.js");
;// CONCATENATED MODULE: ./packages/pharos/src/components/breadcrumb/pharos-breadcrumb-item.css.ts

const breadcrumbItemStyles = lit/* css */.iv`
        :host{align-items:center;contain:layout;display:flex}.breadcrumb-item{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:var(--pharos-color-marble-gray-40);font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-font-size-small);font-weight:var(--pharos-font-weight-regular);letter-spacing:calc(var(--pharos-font-size-small)*-.02);line-height:var(--pharos-line-height-small);text-rendering:optimizelegibility;white-space:nowrap}.breadcrumb-item:after{color:var(--pharos-color-black);content:"/";margin:0 var(--pharos-spacing-one-half-x);text-decoration:none}.breadcrumb-item--last:after{content:""}
      `;

// EXTERNAL MODULE: ./packages/pharos/src/components/base/anchor-element.ts
var anchor_element = __webpack_require__("./packages/pharos/src/components/base/anchor-element.ts");
// EXTERNAL MODULE: ./node_modules/lit/directives/style-map.js + 1 modules
var style_map = __webpack_require__("./node_modules/lit/directives/style-map.js");
;// CONCATENATED MODULE: ./packages/pharos/src/utils/debounce.ts
const debounce = (callback, time) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = window.setTimeout(() => callback(...args), time);
    return timer;
  };
};
/* harmony default export */ const utils_debounce = (debounce);

;// CONCATENATED MODULE: ./packages/pharos/src/utils/observeResize.ts
const observeResize = (observer, element) => {
  observer.observe(element);
  return {
    release() {
      observer.unobserve(element);
      return null;
    }
  };
};
/* harmony default export */ const utils_observeResize = (observeResize);

// EXTERNAL MODULE: ./packages/pharos/src/utils/deepSelector.ts
var deepSelector = __webpack_require__("./packages/pharos/src/utils/deepSelector.ts");
;// CONCATENATED MODULE: ./packages/pharos/src/components/tooltip/pharos-tooltip.css.ts

const tooltipStyles = lit/* css */.iv`
        :host{display:block;left:0;pointer-events:none;position:fixed;top:0;z-index:140}.tooltip__body{opacity:0;pointer-events:none;position:relative;transform:translateZ(0);transition:visibility 0s var(--pharos-transition-duration-short),opacity var(--pharos-transition-duration-short) linear;visibility:hidden;white-space:nowrap}:host([open]) .tooltip__body{opacity:1;pointer-events:auto;transition-delay:0ms;visibility:visible}.tooltip__bubble{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:var(--pharos-tooltip-color-background-base);border-radius:var(--pharos-radius-base-standard);color:var(--pharos-tooltip-color-text-base);display:block;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-tooltip-size-text-base);font-weight:var(--pharos-font-weight-regular);letter-spacing:calc(var(--pharos-tooltip-size-text-base)*-.02);line-height:var(--pharos-line-height-small);overflow:hidden;padding:var(--pharos-spacing-one-quarter-x) var(--pharos-spacing-one-half-x);text-align:center;text-rendering:optimizelegibility;transform:scaleX(1) translateZ(0);transition:transform var(--pharos-transition-base) 0s}.tooltip__bubble--text-wrap{overflow-wrap:break-word;padding:var(--pharos-spacing-one-half-x) var(--pharos-spacing-1-x);text-align:start;white-space:normal;width:14rem}.tooltip__caret{background-color:var(--pharos-tooltip-color-background-base);height:8px;position:absolute;transform:rotate(45deg);width:8px}
      `;

// EXTERNAL MODULE: ./packages/pharos/src/components/base/overlay-element.ts
var overlay_element = __webpack_require__("./packages/pharos/src/components/base/overlay-element.ts");
// EXTERNAL MODULE: ./node_modules/@floating-ui/dom/dist/floating-ui.dom.browser.min.mjs
var floating_ui_dom_browser_min = __webpack_require__("./node_modules/@floating-ui/dom/dist/floating-ui.dom.browser.min.mjs");
// EXTERNAL MODULE: ./node_modules/@floating-ui/core/dist/floating-ui.core.browser.min.mjs
var floating_ui_core_browser_min = __webpack_require__("./node_modules/@floating-ui/core/dist/floating-ui.core.browser.min.mjs");
;// CONCATENATED MODULE: ./packages/pharos/src/components/tooltip/pharos-tooltip.ts
var pharos_tooltip_defProp = Object.defineProperty;
var pharos_tooltip_getOwnPropDesc = Object.getOwnPropertyDescriptor;
var pharos_tooltip_decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? pharos_tooltip_getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    pharos_tooltip_defProp(target, key, result);
  return result;
};









class PharosTooltip extends overlay_element/* OverlayElement */.Gm {
  constructor() {
    super();
    this.fullWidth = false;
    this.boundary = "clippingAncestors";
    this._textLength = 0;
    this._targetWidth = 0;
    this._hasHover = false;
    this._hasFocus = false;
    this._observeResizeTrigger = null;
    this._currentTrigger = null;
    this._cleanup = void 0;
    this._resizeObserver = new ResizeObserver((entries) => {
      const { offsetWidth } = entries[0].target;
      const paddingLeft = parseInt(
        window.getComputedStyle(this._bubble, null).getPropertyValue("padding-left"),
        10
      );
      const paddingRight = parseInt(
        window.getComputedStyle(this._bubble, null).getPropertyValue("padding-right"),
        10
      );
      this._targetWidth = offsetWidth - (paddingLeft + paddingRight);
    });
    this._contentObserver = new MutationObserver(
      (mutationsList) => {
        this._textLength = mutationsList[0].target.length;
      }
    );
    this._handleKeydown = this._handleKeydown.bind(this);
    this._handleHover = this._handleHover.bind(this);
    this._handleFocus = this._handleFocus.bind(this);
    this._handleClose = this._handleClose.bind(this);
  }
  get content() {
    var _a;
    return (_a = Array.prototype.slice.call(this._contentNodes)) == null ? void 0 : _a.find((node) => node.textContent && node.nodeName !== "#comment");
  }
  static get styles() {
    return [tooltipStyles];
  }
  firstUpdated() {
    this._setTextLength();
    this.addEventListener("mouseenter", this._handleBubbleHover);
    this.addEventListener("mouseleave", this._handleBubbleHover);
    this._addTriggerListeners();
    this._contentObserver.observe(this.content, {
      subtree: true,
      characterData: true
    });
  }
  update(changedProperties) {
    super.update && super.update(changedProperties);
  }
  _isTextLong() {
    return this._textLength > 30;
  }
  updated(changedProperties) {
    if (changedProperties.has("open")) {
      if (this.open) {
        this._setup();
      }
      if (!this.open) {
        this._currentTrigger = null;
      }
      this._setupResizeObserver();
    }
    if (changedProperties.has("boundary")) {
      const boundaryElement = document.querySelector(`#${this.boundary}`);
      if (boundaryElement) {
        const boundaryElementWidth = boundaryElement.clientWidth;
        const padding = this._isTextLong() ? 16 : 8;
        this._targetWidth = boundaryElementWidth - padding * 2 - 16 * 2;
      }
    }
    super.updated(changedProperties);
  }
  connectedCallback() {
    super.connectedCallback && super.connectedCallback();
    document.addEventListener("keydown", this._handleKeydown);
    document.addEventListener("pharos-tooltip-close", this._handleClose);
    this._addTriggerListeners();
  }
  disconnectedCallback() {
    document.removeEventListener("keydown", this._handleKeydown);
    document.removeEventListener("pharos-tooltip-close", this._handleClose);
    this._triggers.forEach((trigger) => {
      trigger.removeEventListener("mouseenter", this._handleHover);
      trigger.removeEventListener("mouseleave", this._handleHover);
      trigger.removeEventListener("focusin", this._handleFocus);
      trigger.removeEventListener("focusout", this._handleFocus);
      trigger.removeAttribute("aria-describedby");
    });
    this._releaseObserver();
    this._contentObserver.disconnect();
    super.disconnectedCallback && super.disconnectedCallback();
  }
  _addTriggerListeners() {
    const id = this.getAttribute("id") || "";
    const root = this.getRootNode();
    this._triggers = Array.prototype.slice.call(root.querySelectorAll(`[data-tooltip-id="${id}"]`));
    this._triggers.forEach((trigger) => {
      trigger.addEventListener("mouseenter", this._handleHover);
      trigger.addEventListener("mouseleave", this._handleHover);
      trigger.addEventListener("focusin", this._handleFocus);
      trigger.addEventListener("focusout", this._handleFocus);
      trigger.setAttribute("aria-describedby", id);
    });
  }
  _setup() {
    this._findSingleTrigger();
    this._positionElements();
  }
  _setOpen() {
    if (this._hasHover || this._hasFocus) {
      this._closeOpenTooltips();
      this.open = true;
      this._positionElements();
    } else {
      this.open = false;
      if (this._cleanup) {
        this._cleanup();
      }
    }
  }
  _positionCaret(placement, arrowX, arrowY) {
    const staticSide = {
      top: "bottom",
      right: "left",
      bottom: "top",
      left: "right"
    }[placement.split("-")[0]];
    Object.assign(this._caret.style, {
      left: arrowX ? `${arrowX}px` : "",
      top: arrowY ? `${arrowY}px` : "",
      right: "",
      bottom: "",
      [staticSide]: "-4px"
    });
  }
  _positionTooltip(x, y) {
    Object.assign(this._tooltip.style, {
      left: `${x}px`,
      top: `${y}px`
    });
  }
  _positionElements() {
    if (this._currentTrigger && this._bubble) {
      this._cleanup = (0,floating_ui_dom_browser_min/* autoUpdate */.Me)(this._currentTrigger, this._tooltip, () => {
        if (this._currentTrigger && this._bubble) {
          (0,floating_ui_dom_browser_min/* computePosition */.oo)(this._currentTrigger, this._tooltip, {
            placement: this.placement === "auto" ? "top" : this.placement,
            strategy: this.strategy,
            middleware: [
              (0,floating_ui_core_browser_min/* offset */.cv)(10),
              (0,floating_ui_core_browser_min/* flip */.RR)({
                fallbackPlacements: this._filteredFallbackPlacements
              }),
              (0,floating_ui_core_browser_min/* shift */.uY)({
                boundary: this.boundary === "clippingAncestors" ? this.boundary : (0,deepSelector/* default */.Z)(`#${this.boundary}`) || void 0
              }),
              (0,floating_ui_core_browser_min/* arrow */.x7)({ element: this._caret })
            ]
          }).then(({ middlewareData, placement, x, y }) => {
            if (middlewareData.arrow) {
              const { x: arrowX, y: arrowY } = middlewareData.arrow;
              this._positionCaret(placement, arrowX, arrowY);
            }
            this._positionTooltip(x, y);
          });
        }
      });
    }
  }
  async _handleFocus(event) {
    if (event.type === "focusin") {
      await this._setTrigger(event.target);
      this._hasFocus = true;
    } else if (event.type === "focusout") {
      this._hasFocus = false;
    }
    if (this._triggers.length > 1) {
      await new Promise((r) => setTimeout(r, 100));
    }
    this._setOpen();
  }
  async _handleHover(event) {
    if (event.type === "mouseenter") {
      await this._setTrigger(event.target);
      this._hasHover = true;
    } else if (event.type === "mouseleave") {
      this._hasHover = false;
    }
    utils_debounce(() => {
      this._setOpen();
    }, 100)();
  }
  async _setTrigger(target) {
    const otherTriggerActive = this._currentTrigger && this._currentTrigger !== target;
    this._currentTrigger = target;
    if (otherTriggerActive) {
      this._hasFocus = false;
      this._hasHover = false;
      this.open = false;
      await this.updateComplete;
      this._currentTrigger = target;
    }
  }
  _handleBubbleHover(event) {
    if (event.type === "mouseenter") {
      this._hasHover = true;
    } else if (event.type === "mouseleave") {
      this._hasHover = false;
    }
    utils_debounce(() => {
      this._setOpen();
    }, 100)();
  }
  _handleKeydown(event) {
    if ((event.key === "Escape" || event.key === "Esc") && this.open) {
      event.stopPropagation();
      this.open = false;
    }
  }
  _setTextLength() {
    var _a, _b;
    this._textLength = ((_b = (_a = this.content) == null ? void 0 : _a.textContent) == null ? void 0 : _b.trim().length) || 0;
  }
  _closeOpenTooltips() {
    const details = {
      bubbles: true,
      composed: true,
      detail: this
    };
    this.dispatchEvent(new CustomEvent("pharos-tooltip-close", details));
  }
  _handleClose(event) {
    if (event.detail !== this) {
      this.open = false;
    }
  }
  _setupResizeObserver() {
    if (this.open && this.fullWidth && this._currentTrigger) {
      this._releaseObserver();
      this._observeResizeTrigger = utils_observeResize(
        this._resizeObserver,
        this._currentTrigger
      );
    } else {
      this._releaseObserver();
    }
  }
  _releaseObserver() {
    if (this._observeResizeTrigger) {
      this._observeResizeTrigger = this._observeResizeTrigger.release();
    }
  }
  _findSingleTrigger() {
    if (!this._currentTrigger && this._triggers.length === 1) {
      this._currentTrigger = this._triggers[0];
    }
  }
  render() {
    return lit/* html */.dy`
      <div class="tooltip__body" role="tooltip" aria-hidden="${!this.open}">
        <span
          class=${(0,class_map/* classMap */.$)({
      [`tooltip__bubble`]: true,
      [`tooltip__bubble--text-wrap`]: this._isTextLong()
    })}
          style=${(0,style_map/* styleMap */.V)(this._targetWidth ? { width: `${this._targetWidth}px` } : {})}
        >
          <slot></slot>
        </span>
        <div class="tooltip__caret"></div>
      </div>
    `;
  }
}
pharos_tooltip_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true, attribute: "full-width" })
], PharosTooltip.prototype, "fullWidth", 2);
pharos_tooltip_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosTooltip.prototype, "boundary", 2);
pharos_tooltip_decorateClass([
  (0,decorators/* queryAssignedNodes */.vZ)()
], PharosTooltip.prototype, "_contentNodes", 2);
pharos_tooltip_decorateClass([
  (0,decorators/* query */.IO)(".tooltip__caret")
], PharosTooltip.prototype, "_caret", 2);
pharos_tooltip_decorateClass([
  (0,decorators/* query */.IO)(".tooltip__body")
], PharosTooltip.prototype, "_tooltip", 2);
pharos_tooltip_decorateClass([
  (0,decorators/* query */.IO)(".tooltip__bubble")
], PharosTooltip.prototype, "_bubble", 2);
pharos_tooltip_decorateClass([
  (0,decorators/* state */.SB)()
], PharosTooltip.prototype, "_textLength", 2);
pharos_tooltip_decorateClass([
  (0,decorators/* state */.SB)()
], PharosTooltip.prototype, "_targetWidth", 2);

// EXTERNAL MODULE: ./packages/pharos/src/components/link/pharos-link.ts + 1 modules
var pharos_link = __webpack_require__("./packages/pharos/src/components/link/pharos-link.ts");
;// CONCATENATED MODULE: ./packages/pharos/src/components/breadcrumb/pharos-breadcrumb-item.ts
var pharos_breadcrumb_item_defProp = Object.defineProperty;
var pharos_breadcrumb_item_getOwnPropDesc = Object.getOwnPropertyDescriptor;
var pharos_breadcrumb_item_decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? pharos_breadcrumb_item_getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    pharos_breadcrumb_item_defProp(target, key, result);
  return result;
};










const MAX_LENGTH = 40;
class PharosBreadcrumbItem extends (0,scoped_registry/* default */.Z)((0,mixins_focus/* default */.Z)(anchor_element/* AnchorElement */.u)) {
  constructor() {
    super(...arguments);
    this._isTruncated = false;
    this._displayText = "";
    this._fullText = "";
    this._last = false;
    this._contentObserver = new MutationObserver(() => {
      this._setItem();
    });
  }
  static get styles() {
    return [breadcrumbItemStyles];
  }
  get content() {
    var _a;
    return (_a = Array.prototype.slice.call(this.childNodes)) == null ? void 0 : _a.find((node) => node.textContent && node.nodeName !== "#comment");
  }
  firstUpdated() {
    this.setAttribute("role", "listitem");
    this._setItem();
    this._contentObserver.observe(this.content, {
      subtree: true,
      characterData: true
    });
  }
  _setItem() {
    this._fullText = this.content.textContent;
    this._isTruncated = this._fullText.length > MAX_LENGTH;
    this._displayText = this._isTruncated ? `${this._fullText.substr(0, MAX_LENGTH)}...` : this._fullText || "";
  }
  render() {
    const classes = {
      [`breadcrumb-item`]: true,
      [`breadcrumb-item--last`]: this._last
    };
    return lit/* html */.dy`
      ${this.href ? lit/* html */.dy`<pharos-link
            class=${(0,class_map/* classMap */.$)(classes)}
            href=${(0,if_defined/* ifDefined */.o)(this.href)}
            target=${(0,if_defined/* ifDefined */.o)(this.target)}
            data-tooltip-id=${(0,if_defined/* ifDefined */.o)(this._isTruncated ? "truncate-tooltip" : void 0)}
            >${this._displayText}</pharos-link
          >` : lit/* html */.dy`<span
            class=${(0,class_map/* classMap */.$)(classes)}
            data-tooltip-id=${(0,if_defined/* ifDefined */.o)(this._isTruncated ? "truncate-tooltip" : void 0)}
            >${this._displayText}</span
          >`}
      ${this._isTruncated ? lit/* html */.dy`<pharos-tooltip id="truncate-tooltip">${this._fullText}</pharos-tooltip>` : null}
    `;
  }
}
PharosBreadcrumbItem.elementDefinitions = {
  "pharos-tooltip": PharosTooltip,
  "pharos-link": pharos_link/* PharosLink */.G
};
pharos_breadcrumb_item_decorateClass([
  (0,decorators/* state */.SB)()
], PharosBreadcrumbItem.prototype, "_isTruncated", 2);
pharos_breadcrumb_item_decorateClass([
  (0,decorators/* state */.SB)()
], PharosBreadcrumbItem.prototype, "_displayText", 2);
pharos_breadcrumb_item_decorateClass([
  (0,decorators/* state */.SB)()
], PharosBreadcrumbItem.prototype, "_fullText", 2);
pharos_breadcrumb_item_decorateClass([
  (0,decorators/* state */.SB)()
], PharosBreadcrumbItem.prototype, "_last", 2);

;// CONCATENATED MODULE: ./packages/pharos/src/components/checkbox/pharos-checkbox.css.ts

const checkboxStyles = lit/* css */.iv`
        :host{contain:layout;display:inline-flex;flex-direction:column}.input-wrapper{align-items:flex-start;display:inline-flex;position:relative}.input__icon{box-sizing:border-box;cursor:pointer;display:block;overflow:visible}.input__icon .box{stroke:var(--pharos-form-element-color-border-base);fill:var(--pharos-checkbox-color-background-base)}.input__icon .checkmark,.input__icon .dash,.input__icon .focus,.input__icon .hover{stroke:none;fill:none}.input__icon .checkmark,.input__icon .dash,.input__icon .focus{stroke-width:2}:host([indeterminate]) .input__icon .box{stroke:var(--pharos-form-element-color-background-selected)}:host([indeterminate]) .input__icon .dash{stroke:var(--pharos-color-interactive-tertiary)}:host([invalidated]) .input__icon .box{stroke:var(--pharos-form-element-color-border-invalid)}:host([disabled]) .input__icon{pointer-events:none}:host([disabled]) .input__icon .box{fill:var(--pharos-form-element-color-background-disabled)}:host([checked][on-background]) .input__icon .checkmark{stroke:var(--pharos-form-element-color-background-selected)}:host([indeterminate][on-background]) .input__icon .box{fill:var(--pharos-color-interactive-tertiary);stroke:var(--pharos-color-interactive-tertiary)}:host([indeterminate][on-background]) .input__icon .dash{stroke:var(--pharos-form-element-color-background-selected)}:host([checked][disabled]) .input__icon .checkmark{stroke:var(--pharos-color-text-disabled)}:host([checked][invalidated]) .input__icon .checkmark{stroke:var(--pharos-form-element-color-border-invalid)}:host([on-background]:not([checked]):not([indeterminate])) .input__icon .box{fill:var(--pharos-form-element-color-background-selected)}:host([on-background]:not([invalidated]):not([disabled])) .input__icon .box{stroke:var(--pharos-color-interactive-tertiary)}:host([checked]:not([on-background]):not([invalidated]):not([disabled])) .input__icon .box{stroke:var(--pharos-form-element-color-background-selected)}:host([checked]:not([on-background]):not([invalidated]):not([disabled])) .input__icon .checkmark{stroke:var(--pharos-color-interactive-tertiary)}:host([indeterminate]:not([invalidated]):not([disabled]):not([on-background])) .input__icon .box{fill:var(--pharos-form-element-color-background-selected)}:host([checked]:not([invalidated]):not([disabled]):not([on-background])) .input__icon .box{fill:var(--pharos-form-element-color-background-selected)}#checkbox-element{clip:rect(0 0 0 0);border:0;box-sizing:border-box;-webkit-clip-path:inset(50%);clip-path:inset(50%);display:block;height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}:host(:not([on-background])) #checkbox-element:focus+.input-wrapper .input__icon .box,:host(:not([on-background])) #checkbox-element:focus+.input-wrapper .input__icon .focus{stroke:var(--pharos-form-element-color-border-focus)}:host([on-background]) #checkbox-element:focus+.input-wrapper .input__icon .box,:host([on-background]) #checkbox-element:focus+.input-wrapper .input__icon .focus{stroke:var(--pharos-form-element-color-border-focus)}:host([on-background]:not([disabled]):not([checked]):not([indeterminate])) #checkbox-element:not(:focus)+.input-wrapper:hover .input__icon .box,:host([on-background]:not([disabled]):not([checked]):not([indeterminate])) #checkbox-element:not(:focus)+.input-wrapper:hover .input__icon .hover{stroke:var(--pharos-color-interactive-tertiary)}:host(:not([checked]):not([disabled]):not([indeterminate]):not([on-background])) #checkbox-element:not(:focus)+.input-wrapper:hover .input__icon .box,:host(:not([checked]):not([disabled]):not([indeterminate]):not([on-background])) #checkbox-element:not(:focus)+.input-wrapper:hover .input__icon .hover{stroke:var(--pharos-color-hover-primary)}
      `;

// EXTERNAL MODULE: ./node_modules/lit/directives/unsafe-svg.js + 1 modules
var unsafe_svg = __webpack_require__("./node_modules/lit/directives/unsafe-svg.js");
// EXTERNAL MODULE: ./packages/pharos/src/styles/icons/dash-small.ts
var dash_small = __webpack_require__("./packages/pharos/src/styles/icons/dash-small.ts");
// EXTERNAL MODULE: ./packages/pharos/src/styles/icons/checkmark-small.ts
var checkmark_small = __webpack_require__("./packages/pharos/src/styles/icons/checkmark-small.ts");
// EXTERNAL MODULE: ./packages/pharos/src/components/base/form-element.ts + 1 modules
var form_element = __webpack_require__("./packages/pharos/src/components/base/form-element.ts");
// EXTERNAL MODULE: ./packages/pharos/src/utils/mixins/form.ts
var mixins_form = __webpack_require__("./packages/pharos/src/utils/mixins/form.ts");
;// CONCATENATED MODULE: ./packages/pharos/src/components/checkbox/pharos-checkbox.ts
var pharos_checkbox_defProp = Object.defineProperty;
var pharos_checkbox_getOwnPropDesc = Object.getOwnPropertyDescriptor;
var pharos_checkbox_decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? pharos_checkbox_getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    pharos_checkbox_defProp(target, key, result);
  return result;
};










const LINKS = `a[href],pharos-link[href],[data-pharos-component='PharosLink'][href]`;
class PharosCheckbox extends (0,mixins_form/* default */.Z)(form_element/* FormElement */.W) {
  constructor() {
    super(...arguments);
    this.checked = false;
    this.indeterminate = false;
    this.value = "";
    this.onBackground = false;
  }
  static get styles() {
    return [super.styles, checkboxStyles];
  }
  firstUpdated() {
    this._checkbox.defaultChecked = this.checked;
  }
  onChange() {
    const originalIndeterminateState = this.indeterminate;
    const originalCheckedState = !this._checkbox.checked;
    this.indeterminate = false;
    this.checked = this._checkbox.checked;
    const notCancelled = this.dispatchEvent(
      new CustomEvent("change", {
        bubbles: true,
        cancelable: true,
        composed: true,
        detail: {
          target: this._checkbox
        }
      })
    );
    if (!notCancelled) {
      this.indeterminate = originalIndeterminateState;
      this.checked = originalCheckedState;
    }
  }
  _handleFormdata(event) {
    const { formData } = event;
    if (!this.disabled && this.checked) {
      formData.append(this.name, this.value || "on");
    }
  }
  _handleFormReset() {
    this.checked = this._checkbox.defaultChecked;
  }
  _handleClick(event) {
    if (!event.target.matches(LINKS)) {
      event.preventDefault();
      event.stopPropagation();
      this._checkbox.click();
      this._checkbox.focus();
    }
  }
  _renderPath() {
    if (this.indeterminate) {
      return atob(dash_small["default"]);
    } else {
      return atob(checkmark_small["default"]);
    }
  }
  _handleMousedown(event) {
    if (!event.target.matches(LINKS)) {
      event.preventDefault();
    }
  }
  render() {
    return lit/* html */.dy`
      <input
        id="checkbox-element"
        name=${this.name}
        type="checkbox"
        .value=${this.value}
        .checked=${this.checked}
        .indeterminate=${this.indeterminate}
        ?required="${this.required}"
        ?disabled=${this.disabled}
        aria-required="${this.required}"
        aria-invalid="${this.invalidated}"
        aria-describedby="${(0,if_defined/* ifDefined */.o)(this.messageId)}"
        @change=${this.onChange}
      />
      <div class="input-wrapper">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          viewBox="0 0 24 24"
          width="24"
          height="24"
          class="input__icon"
          role="img"
          aria-hidden="true"
          focusable="false"
          @click="${this._handleClick}"
          @mousedown=${this._handleMousedown}
        >
          <rect x="3" y="3" width="18" height="18" rx="3" class="focus" />
          <rect x="4" y="4" width="16" height="16" rx="2" class="box" />
          <rect x="5" y="5" width="14" height="14" rx="1" class="hover" />
          <svg
            x="4"
            y="4"
            class=${(0,class_map/* classMap */.$)({
      [`checkmark`]: !this.indeterminate,
      [`dash`]: this.indeterminate
    })}
          >
            ${(0,unsafe_svg/* unsafeSVG */.c)(this._renderPath())}
          </svg>
        </svg>
        <label
          for="checkbox-element"
          @click="${this._handleClick}"
          @mousedown=${this._handleMousedown}
        >
          <slot name="label"></slot>
          ${this.requiredIndicator}
        </label>
      </div>
      ${this.messageContent}
    `;
  }
}
pharos_checkbox_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], PharosCheckbox.prototype, "checked", 2);
pharos_checkbox_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], PharosCheckbox.prototype, "indeterminate", 2);
pharos_checkbox_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosCheckbox.prototype, "value", 2);
pharos_checkbox_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], PharosCheckbox.prototype, "onBackground", 2);
pharos_checkbox_decorateClass([
  (0,decorators/* query */.IO)("#checkbox-element")
], PharosCheckbox.prototype, "_checkbox", 2);

;// CONCATENATED MODULE: ./packages/pharos/src/components/checkbox-group/pharos-checkbox-group.css.ts

const checkboxGroupStyles = lit/* css */.iv`
        :host{contain:layout;display:flex}.checkbox-group{border:0;padding:0}.checkbox-group__checkboxes{display:flex}.checkbox-group--vertical .checkbox-group__checkboxes{flex-direction:column}.checkbox-group--horizontal .checkbox-group__checkboxes{flex-direction:row}::slotted([data-pharos-component=PharosCheckbox]){align-self:flex-start}.checkbox-group--vertical ::slotted([data-pharos-component=PharosCheckbox]:not(:last-child)){margin-bottom:var(--pharos-checkbox-group-spacing-vertical)}.checkbox-group--horizontal ::slotted([data-pharos-component=PharosCheckbox]:not(:last-child)){margin-right:var(--pharos-checkbox-group-spacing-horizontal)}
      `;

;// CONCATENATED MODULE: ./packages/pharos/src/components/checkbox-group/pharos-checkbox-group.ts
var pharos_checkbox_group_defProp = Object.defineProperty;
var pharos_checkbox_group_getOwnPropDesc = Object.getOwnPropertyDescriptor;
var pharos_checkbox_group_decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? pharos_checkbox_group_getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    pharos_checkbox_group_defProp(target, key, result);
  return result;
};




class PharosCheckboxGroup extends form_element/* FormElement */.W {
  constructor() {
    super(...arguments);
    this.horizontal = false;
  }
  get value() {
    return [...this.children].filter((child) => !child.slot && child.checked).map((box) => box.value);
  }
  static get styles() {
    return [super.styles, checkboxGroupStyles];
  }
  firstUpdated() {
    this._setBoxes();
    this._checkboxes.forEach((box) => {
      box.addEventListener("change", (event) => {
        event.stopPropagation();
        this.dispatchEvent(
          new Event("change", {
            bubbles: true,
            composed: true
          })
        );
      });
    });
  }
  update(changedProperties) {
    super.update && super.update(changedProperties);
    if (changedProperties.has("name") || changedProperties.has("disabled") || changedProperties.has("invalidated") || changedProperties.has("validated")) {
      this._setBoxes();
    }
  }
  _setBoxes() {
    this._checkboxes.forEach((box) => {
      box.name = this.name;
      box.disabled = this.disabled;
      box.validated = this.validated;
      box.invalidated = this.invalidated;
    });
  }
  render() {
    const labels = ["legend"];
    if (this.messageId) {
      labels.push(this.messageId);
    }
    return lit/* html */.dy`
      <fieldset
        class="checkbox-group checkbox-group--${this.horizontal ? "horizontal" : "vertical"}"
        aria-invalid="${this.invalidated}"
        aria-labelledby="${labels.join(" ")}"
      >
        <legend id="legend" class="checkbox-group__legend">
          <slot name="legend"></slot>
          ${this.requiredIndicator}
        </legend>
        <div class="checkbox-group__checkboxes">
          <slot></slot>
        </div>
        ${this.messageContent}
      </fieldset>
    `;
  }
}
pharos_checkbox_group_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], PharosCheckboxGroup.prototype, "horizontal", 2);
pharos_checkbox_group_decorateClass([
  (0,decorators/* property */.Cb)({ type: Array, attribute: false })
], PharosCheckboxGroup.prototype, "value", 1);
pharos_checkbox_group_decorateClass([
  (0,decorators/* queryAssignedElements */.NH)({ selector: '[data-pharos-component="PharosCheckbox"]' })
], PharosCheckboxGroup.prototype, "_checkboxes", 2);

// EXTERNAL MODULE: ./node_modules/lit/directives/unsafe-html.js
var unsafe_html = __webpack_require__("./node_modules/lit/directives/unsafe-html.js");
;// CONCATENATED MODULE: ./packages/pharos/src/components/combobox/pharos-combobox.css.ts

const comboboxStyles = lit/* css */.iv`
        :host{display:block;width:100%}.combobox__icon{fill:var(--pharos-combobox-color-icon-dropdown)}.combobox__button{align-items:center;background:none;background-color:var(--pharos-color-interactive-tertiary);border:1px solid var(--pharos-form-element-color-border-base);border-radius:0 var(--pharos-radius-base-standard) var(--pharos-radius-base-standard) 0;box-sizing:border-box;cursor:pointer;display:flex;flex-direction:column;justify-content:center;margin:0;padding:var(--pharos-spacing-one-half-x)}.combobox__button:focus,.combobox__button:hover{border:2px solid var(--pharos-color-hover-primary);outline:none;padding:calc(var(--pharos-spacing-one-half-x) - 1px);transition:background-color var(--pharos-transition-duration-default) ease-in-out,outline var(--pharos-transition-duration-default) ease-in-out}.combobox__button:focus .combobox__icon,.combobox__button:hover .combobox__icon{fill:var(--pharos-combobox-color-icon-focus)}:host([disabled]) .combobox__button{background-color:var(--pharos-form-element-color-background-disabled);border-color:var(--pharos-form-element-color-border-disabled);color:var(--pharos-form-element-color-text-disabled);pointer-events:none}:host([disabled]) .combobox__button .combobox__icon{fill:var(--pharos-form-element-color-text-disabled)}:host([invalidated]) .combobox__button{border:1px solid var(--pharos-form-element-color-border-invalid);border-left-width:2px}:host([invalidated]) .combobox__button:focus,:host([invalidated]) .combobox__button:hover{border:2px solid var(--pharos-form-element-color-border-invalid);padding:calc(var(--pharos-spacing-one-half-x) - 1px);padding-left:var(--pharos-spacing-one-half-x)}:host([invalidated]) .combobox__button .combobox__icon{fill:var(--pharos-form-element-color-border-invalid)}.input-wrapper{align-items:center;display:flex;position:relative;width:100%}.input-element{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;border:1px solid var(--pharos-form-element-color-border-base);border-radius:var(--pharos-radius-base-standard);border-radius:var(--pharos-radius-base-standard) 0 0 var(--pharos-radius-base-standard);border-right:none;box-sizing:border-box;color:var(--pharos-form-element-color-text-base);display:block;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-font-size-base);font-weight:var(--pharos-font-weight-regular);letter-spacing:calc(var(--pharos-font-size-base)*-.02);line-height:var(--pharos-line-height-medium);margin:0;padding:var(--pharos-spacing-one-half-x) var(--pharos-spacing-three-quarters-x);text-rendering:optimizelegibility;transition:transform var(--pharos-transition-base) 0s;width:100%}.input-element:required{box-shadow:none}.input-element::-moz-placeholder{color:var(--pharos-form-element-color-text-placeholder);opacity:1}.input-element::placeholder{color:var(--pharos-form-element-color-text-placeholder);opacity:1}.input-element:focus{border:2px solid var(--pharos-form-element-color-border-focus);outline:none;padding:calc(var(--pharos-spacing-one-half-x) - 1px) calc(var(--pharos-spacing-three-quarters-x) - 1px);transition:transform var(--pharos-transition-base) 0s}.input-element--populated,.input-element--populated:focus{padding-right:var(--pharos-spacing-3-x)}:host([disabled]) .input-element{background-color:var(--pharos-form-element-color-background-disabled);border-color:var(--pharos-form-element-color-border-disabled);color:var(--pharos-form-element-color-text-disabled);pointer-events:none}:host([invalidated]) .input-element{border:2px solid var(--pharos-form-element-color-border-invalid);border-right:0;padding:calc(var(--pharos-spacing-one-half-x) - 1px) calc(var(--pharos-spacing-three-quarters-x) - 1px)}:host([invalidated]) .input-element--populated{padding-right:var(--pharos-spacing-3-x)}.combobox__list{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;-webkit-margin-before:var(--pharos-spacing-one-half-x);-webkit-margin-after:var(--pharos-spacing-one-half-x);-webkit-padding-start:0;animation:fadeIn .3s ease-in-out both;background-color:var(--pharos-color-ui-10);border:1px solid var(--pharos-form-element-color-border-base);border-radius:var(--pharos-radius-base-standard);box-sizing:border-box;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-font-size-base);font-weight:var(--pharos-font-weight-regular);left:0;letter-spacing:calc(var(--pharos-font-size-base)*-.02);line-height:var(--pharos-line-height-medium);list-style-type:none;margin-block-end:var(--pharos-spacing-one-half-x);margin-block-start:var(--pharos-spacing-one-half-x);max-height:var(--pharos-combobox-size-height-list);overflow-y:scroll;padding-inline-start:0;padding-left:0;position:absolute;text-rendering:optimizelegibility;top:100%;transform-origin:top left;width:100%;z-index:1}@keyframes fadeIn{0%{opacity:0;transform:scaleY(.5)}to{opacity:1;transform:scaleY(1)}}.combobox__mark{background-color:var(--pharos-color-glacier-blue-80)}.combobox__mark--selected{color:var(--pharos-combobox-color-text-selected);font-weight:var(--pharos-font-weight-bold)}.combobox__option{cursor:pointer;padding:var(--pharos-spacing-one-quarter-x) var(--pharos-spacing-1-x);position:relative}.combobox__option:hover,.combobox__option[highlighted]{background-color:var(--pharos-color-ui-20);color:var(--pharos-combobox-color-text-hover)}.combobox__option:hover .combobox__mark,.combobox__option[highlighted] .combobox__mark{color:var(--pharos-combobox-color-text-hover)}.combobox__clear-button{position:absolute;right:calc(var(--pharos-spacing-3-x) + var(--pharos-spacing-one-eighth-x));top:50%;transform:translateY(-50%)}.combobox__clear-button--search{right:calc(var(--pharos-spacing-2-x) + var(--pharos-spacing-three-quarters-x) + var(--pharos-spacing-one-eighth-x))}.combobox__option--selected{color:var(--pharos-combobox-color-text-selected);font-weight:var(--pharos-font-weight-bold)}.combobox__option__icon{fill:var(--pharos-combobox-color-icon-checkmark);position:absolute;right:var(--pharos-spacing-1-x);top:50%;transform:translateY(-50%)}.visually-hidden{clip:rect(0 0 0 0);border:0;-webkit-clip-path:inset(50%);clip-path:inset(50%);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}.search__button{border:1px solid var(--pharos-form-element-color-border-base);border-left:0;border-radius:0 var(--pharos-radius-base-standard) var(--pharos-radius-base-standard) 0;padding:calc(var(--pharos-spacing-one-quarter-x) - 1px)}:host([disabled]) .search__button{background-color:var(--pharos-form-element-color-background-disabled);border-color:var(--pharos-form-element-color-border-disabled);pointer-events:none}:host([invalidated]) .search__button{border:2px solid var(--pharos-form-element-color-border-invalid);border-left:0;padding:var(--pharos-spacing-one-eighth-x)}
      `;

;// CONCATENATED MODULE: ./packages/pharos/src/utils/math.ts
const modulo = (num, modulus) => {
  return (num % modulus + modulus) % modulus;
};
const loopWrapIndex = (items, currentItemFilterFunction, moveForward) => {
  let index = items.findIndex(currentItemFilterFunction);
  index = moveForward ? index : Math.max(index, 0);
  return modulo(index + (moveForward ? 1 : -1), items.length);
};

;// CONCATENATED MODULE: ./packages/pharos/src/components/combobox/pharos-combobox.ts
var pharos_combobox_defProp = Object.defineProperty;
var pharos_combobox_getOwnPropDesc = Object.getOwnPropertyDescriptor;
var pharos_combobox_decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? pharos_combobox_getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    pharos_combobox_defProp(target, key, result);
  return result;
};














class PharosCombobox extends (0,scoped_registry/* default */.Z)((0,mixins_form/* default */.Z)(form_element/* FormElement */.W)) {
  constructor() {
    super(...arguments);
    this.value = "";
    this.placeholder = "";
    this.open = false;
    this.searchMode = false;
    this._displayValue = "";
    this._noResults = false;
    this._query = "";
    this._defaultValue = "";
    this._childrenObserver = new MutationObserver(
      (mutationsList) => {
        this.requestUpdate();
        if (mutationsList.some(
          (record) => [...record.addedNodes].some((node) => node instanceof HTMLOptionElement)
        )) {
          this._setDisplayValue();
        }
      }
    );
  }
  get options() {
    return [...this.children].filter((child) => !child.slot);
  }
  get selectedIndex() {
    return this.options.findIndex((o) => o.value === this.value);
  }
  static get styles() {
    return [super.styles, comboboxStyles];
  }
  firstUpdated() {
    this._setDisplayValue();
    this._input.defaultValue = this._displayValue;
    this._defaultValue = this.value;
    this._childrenObserver.observe(this, {
      subtree: true,
      childList: true
    });
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    if (changedProperties.has("open") && !this.open) {
      this._query = "";
      this._input.setAttribute("aria-activedescendant", "");
    }
    if (changedProperties.has("value")) {
      this._setDisplayValue();
    }
  }
  disconnectedCallback() {
    this._childrenObserver.disconnect();
    super.disconnectedCallback && super.disconnectedCallback();
  }
  onChange(event) {
    this.dispatchEvent(
      new CustomEvent("change", {
        bubbles: true,
        composed: true,
        detail: event
      })
    );
  }
  onInput() {
    if (this.searchMode) {
      this.value = this._input.value;
    }
    this._displayValue = this._input.value;
    this._query = this._input.value;
    this.open = true;
  }
  _renderList() {
    if (this.open) {
      const regex = new RegExp(this._query, "gi");
      const matchingOptions = this.options.filter((child) => {
        return this.searchMode ? child : child.text.match(regex);
      });
      this._noResults = matchingOptions.length === 0;
      if (this.searchMode && !matchingOptions.length) {
        return lit/* html */.dy``;
      }
      return lit/* html */.dy`
        <ul aria-labelledby="input-label" role="listbox" id="combobox-list" class="combobox__list">
          ${matchingOptions.length ? matchingOptions.map((child, index) => {
        const option = child;
        const exactMatch = this.value === option.value;
        const optionText = this._query ? option.text.replace(regex, (str) => {
          const classes = exactMatch ? "combobox__mark combobox__mark--selected" : "combobox__mark";
          return this.searchMode ? `${str}` : `<mark class="${classes}">${str}</mark>`;
        }) : option.text;
        return lit/* html */.dy`
                  <li
                    id="${`result-item-${index}`}"
                    class=${(0,class_map/* classMap */.$)({
          [`combobox__option`]: true,
          [`combobox__option--selected`]: exactMatch
        })}
                    role="option"
                    aria-selected="false"
                    aria-label="${option.text}"
                    @click=${(event) => this._handleOptionClick(option, event)}
                    @mousedown=${(event) => {
          event.preventDefault();
        }}
                  >
                    ${(0,unsafe_html/* unsafeHTML */.A)(optionText)}
                    ${exactMatch && !this.searchMode ? lit/* html */.dy`
                          <pharos-icon
                            class="combobox__option__icon"
                            name="checkmark"
                          ></pharos-icon>
                        ` : lit/* nothing */.Ld}
                  </li>
                `;
      }) : lit/* html */.dy`<li class="combobox__option">No results found</li>`}
        </ul>
        <div aria-live="polite" role="status" class="visually-hidden">
          ${matchingOptions.length ? `${matchingOptions.length} results available.` : `No results found`}
        </div>
      `;
    }
    return lit/* nothing */.Ld;
  }
  _renderClearButton() {
    const classes = this.searchMode ? "combobox__clear-button combobox__clear-button--search" : "combobox__clear-button";
    if (this._displayValue) {
      return lit/* html */.dy`
        <pharos-button
          data-tooltip-id="clear-tooltip"
          type="button"
          class=${classes}
          variant="subtle"
          icon="close"
          ?disabled=${this.disabled}
          label="Clear option"
          @click=${this._handleClearClick}
          @mousedown=${this._handleClearClick}
        >
        </pharos-button>
        <pharos-tooltip id="clear-tooltip" placement="bottom">Clear option</pharos-tooltip>
      `;
    }
    return lit/* nothing */.Ld;
  }
  _renderIconButton() {
    if (this.searchMode) {
      return lit/* html */.dy`
        <pharos-button
          icon="search"
          type="button"
          variant="subtle"
          class="search__button"
          label="Search"
          ?disabled=${this.disabled}
          @click=${this.onChange}
        ></pharos-button>
      `;
    } else {
      return lit/* html */.dy`
        <button
          tabindex="-1"
          type="button"
          class="combobox__button"
          ?disabled=${this.disabled}
          @click=${this._handleButtonClick}
          @blur=${this._handleButtonBlur}
        >
          <pharos-icon
            class="combobox__icon"
            name="chevron-down"
            description="Dropdown"
          ></pharos-icon>
        </button>
      `;
    }
  }
  _handleOptionClick(option, event) {
    this.value = option.value;
    this._displayValue = option.text.trim();
    this.open = false;
    this.onChange(event);
  }
  _closeDropdown() {
    utils_debounce(() => {
      this.open = false;
    }, 100)();
  }
  _handleButtonClick(event) {
    event.preventDefault();
    this._input.focus();
    this.open = true;
  }
  _handleButtonBlur(event) {
    if (event.relatedTarget !== this._input) {
      this._closeDropdown();
    }
  }
  _handleClearClick(event) {
    event.preventDefault();
    this._handleInputClear(event);
    this._input.focus();
  }
  _handleInputBlur(event) {
    this._setDisplayValue(true);
    if (event.relatedTarget !== this._button) {
      this._closeDropdown();
    }
  }
  _handleInputKeydown(event) {
    event.stopPropagation();
    switch (event.key) {
      case "Enter":
        event.preventDefault();
        this._selectHighlightedOption(event);
        break;
      case "Escape":
      case "Esc":
        event.preventDefault();
        this._handleInputClear(event);
        break;
      case "Down":
      case "ArrowDown":
        event.preventDefault();
        this._handleNavigation(true);
        break;
      case "Up":
      case "ArrowUp":
        event.preventDefault();
        this._handleNavigation(false);
        break;
    }
  }
  async _handleNavigation(moveForward) {
    if (!this.open) {
      this.open = true;
      await this.updateComplete;
    }
    if (this._noResults) {
      return;
    }
    const options = Array.prototype.slice.call(
      this.renderRoot.querySelectorAll(".combobox__option")
    );
    const values = options.map((option) => option.innerText.trim());
    const highlightedOption = this.renderRoot.querySelector(
      ".combobox__option[highlighted]"
    );
    const nextOptionIndex = loopWrapIndex(
      values,
      (v) => v === (highlightedOption == null ? void 0 : highlightedOption.innerText.trim()),
      moveForward
    );
    highlightedOption == null ? void 0 : highlightedOption.removeAttribute("highlighted");
    highlightedOption == null ? void 0 : highlightedOption.setAttribute("aria-selected", "false");
    const nextOption = options[nextOptionIndex];
    nextOption.scrollIntoView({ behavior: "smooth", block: "nearest" });
    nextOption.setAttribute("highlighted", "");
    nextOption.setAttribute("aria-selected", "true");
    this._input.setAttribute("aria-activedescendant", nextOption.id);
  }
  _selectHighlightedOption(event) {
    const highlightedOption = this.renderRoot.querySelector(
      ".combobox__option[highlighted]"
    );
    if (highlightedOption) {
      highlightedOption.click();
    } else {
      this.open = false;
    }
    if (this.searchMode) {
      this.onChange(event);
    }
  }
  _handleInputClear(event) {
    this.open = false;
    this.value = "";
    this._displayValue = "";
    this.onChange(event);
  }
  _handleFormdata(event) {
    const { formData } = event;
    if (!this.disabled) {
      formData.append(this.name, this.value);
    }
  }
  _handleFormReset() {
    this.value = this._defaultValue;
    this._displayValue = this._input.defaultValue;
  }
  _setDisplayValue(blurred = false) {
    if (this.value && this.selectedIndex >= 0) {
      this._displayValue = this.options[this.selectedIndex].text.trim();
    } else if (this.value === "" && !blurred) {
      this._displayValue = "";
    }
  }
  _handleInputClick() {
    this.open = !this.open;
  }
  render() {
    return lit/* html */.dy`
      <label for="input-element" id="input-label">
        <slot name="label"></slot>
        ${this.requiredIndicator}
      </label>
      <div class="input-wrapper">
        <input
          id="input-element"
          class="input-element ${this._displayValue ? "input-element--populated" : null}"
          name="${this.name}"
          type="text"
          .value="${this._displayValue}"
          ?required="${this.required}"
          ?disabled="${this.disabled}"
          placeholder="${this.placeholder}"
          role="combobox"
          aria-expanded="${this.open}"
          aria-controls="combobox-list"
          aria-autocomplete="list"
          aria-activedescendant=""
          aria-required="${this.required}"
          aria-invalid="${this.invalidated}"
          aria-describedby="${(0,if_defined/* ifDefined */.o)(this.messageId)}"
          @input=${this.onInput}
          @change=${this.onChange}
          @blur=${this._handleInputBlur}
          @keydown=${this._handleInputKeydown}
          @click=${this._handleInputClick}
        />
        ${this._renderClearButton()} ${this._renderIconButton()} ${this._renderList()}
      </div>
      ${this.messageContent}
    `;
  }
}
PharosCombobox.elementDefinitions = {
  "pharos-icon": pharos_icon/* PharosIcon */.b,
  "pharos-tooltip": PharosTooltip,
  "pharos-button": pharos_button/* PharosButton */.b
};
pharos_combobox_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosCombobox.prototype, "value", 2);
pharos_combobox_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosCombobox.prototype, "placeholder", 2);
pharos_combobox_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], PharosCombobox.prototype, "open", 2);
pharos_combobox_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true, attribute: "search-mode" })
], PharosCombobox.prototype, "searchMode", 2);
pharos_combobox_decorateClass([
  (0,decorators/* property */.Cb)({ attribute: false, reflect: false })
], PharosCombobox.prototype, "options", 1);
pharos_combobox_decorateClass([
  (0,decorators/* property */.Cb)({ attribute: false, reflect: false })
], PharosCombobox.prototype, "selectedIndex", 1);
pharos_combobox_decorateClass([
  (0,decorators/* query */.IO)("#input-element")
], PharosCombobox.prototype, "_input", 2);
pharos_combobox_decorateClass([
  (0,decorators/* query */.IO)(".combobox__button")
], PharosCombobox.prototype, "_button", 2);
pharos_combobox_decorateClass([
  (0,decorators/* state */.SB)()
], PharosCombobox.prototype, "_displayValue", 2);

;// CONCATENATED MODULE: ./packages/pharos/src/components/dropdown-menu/pharos-dropdown-menu.css.ts

const dropdownMenuStyles = lit/* css */.iv`
        :host{display:block;left:0;pointer-events:none;position:fixed;top:0;z-index:140}.dropdown-menu__list{-webkit-padding-start:0;background-color:var(--pharos-color-ui-10);border:1px solid var(--pharos-dropdown-menu-color-border-base);border-radius:2px;list-style-type:none;margin:0;opacity:0;padding-left:0;padding-inline-start:0;pointer-events:none;position:relative;transform:translateZ(0);transition:visibility 0s var(--pharos-transition-duration-short),opacity var(--pharos-transition-duration-short) linear;visibility:hidden}.dropdown-menu__list:focus{outline:2px solid var(--pharos-color-focus);outline-offset:2px}:host([open]) .dropdown-menu__list{opacity:1;pointer-events:auto;transition-delay:0ms;visibility:visible}:host(:not([full-width])) .dropdown-menu__list{min-width:var(--pharos-dropdown-menu-size-width-min)}:host(:not([full-width])) ::slotted([data-pharos-component=PharosDropdownMenuItem]){max-width:var(--pharos-dropdown-menu-size-width-max)}
      `;

// EXTERNAL MODULE: ./node_modules/@ithaka/focus-trap/index.js + 4 modules
var focus_trap = __webpack_require__("./node_modules/@ithaka/focus-trap/index.js");
;// CONCATENATED MODULE: ./packages/pharos/src/components/dropdown-menu/pharos-dropdown-menu.ts
var pharos_dropdown_menu_defProp = Object.defineProperty;
var pharos_dropdown_menu_getOwnPropDesc = Object.getOwnPropertyDescriptor;
var pharos_dropdown_menu_decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? pharos_dropdown_menu_getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    pharos_dropdown_menu_defProp(target, key, result);
  return result;
};












const _allMenuItemsSelector = '[data-pharos-component="PharosDropdownMenuItem"]';
class PharosDropdownMenu extends (0,scoped_registry/* default */.Z)((0,mixins_focus/* default */.Z)(overlay_element/* OverlayElement */.Gm)) {
  constructor() {
    super();
    this.showSelected = false;
    this.fullWidth = false;
    this._navMenu = false;
    this._targetWidth = 0;
    this._currentTrigger = null;
    this._hasHover = false;
    this._moveFocusToLast = false;
    this._enterByKey = false;
    this._cleanup = void 0;
    this._observeResizeTrigger = null;
    this._resizeObserver = new ResizeObserver((entries) => {
      const { offsetWidth } = entries[0].target;
      const borderLeft = parseInt(
        window.getComputedStyle(this._menu, null).getPropertyValue("border-left-width"),
        10
      );
      const borderRight = parseInt(
        window.getComputedStyle(this._menu, null).getPropertyValue("border-right-width"),
        10
      );
      this._targetWidth = offsetWidth - (borderLeft + borderRight);
    });
    this.placement = "bottom-end";
    this._handleClick = this._handleClick.bind(this);
    this._handleKeydown = this._handleKeydown.bind(this);
    this._handleTriggerClick = this._handleTriggerClick.bind(this);
    this._handleTriggerHover = this._handleTriggerHover.bind(this);
    this._handleTriggerKeydown = this._handleTriggerKeydown.bind(this);
  }
  static get styles() {
    return [dropdownMenuStyles];
  }
  removeAllTriggers() {
    this._removeTriggerListeners();
  }
  async openWithTrigger(trigger) {
    if (this._currentTrigger !== trigger) {
      await new Promise((r) => setTimeout(r, 100));
      this.removeAllTriggers();
      this._addTriggerElement(trigger);
      this._currentTrigger = trigger;
      this.open = true;
    }
  }
  firstUpdated() {
    this.addEventListener("click", this._handleMenuClick);
    this.addEventListener("keydown", this._handleMenuKeydown);
    this._addTriggerListeners();
  }
  update(changedProperties) {
    super.update && super.update(changedProperties);
  }
  _emitVisibilityChange() {
    const details = {
      bubbles: true,
      composed: true
    };
    if (this.open) {
      this.dispatchEvent(new CustomEvent("pharos-dropdown-menu-opened", details));
    } else {
      this.dispatchEvent(new CustomEvent("pharos-dropdown-menu-closed", details));
    }
  }
  updated(changedProperties) {
    var _a;
    if (changedProperties.has("open")) {
      if (this._currentTrigger && this._navMenu) {
        this._currentTrigger.isActive = this.open;
      }
      if (this.open) {
        this._setupMenu();
      }
      if (!((_a = this._currentTrigger) == null ? void 0 : _a.hasAttribute("data-dropdown-menu-hover")) || this._enterByKey) {
        if (this.open) {
          utils_debounce(() => {
            this._focusContents();
          }, 1)();
        } else if (!this._navMenu) {
          this._returnTriggerFocus();
        }
      }
      if (!this.open) {
        this._currentTrigger = null;
        this._enterByKey = false;
        this._resetItemsState();
        if (this._cleanup) {
          this._cleanup();
        }
      }
      this._setHoverListeners();
      this._setupResizeObserver();
      this._setTriggerAttributes();
      this._emitVisibilityChange();
    }
    super.updated(changedProperties);
  }
  connectedCallback() {
    super.connectedCallback && super.connectedCallback();
    document.addEventListener("click", this._handleClick);
    document.addEventListener("keydown", this._handleKeydown);
    this._addTriggerListeners();
  }
  _removeTriggerListeners() {
    this._triggers.forEach((trigger) => {
      trigger.removeEventListener("click", this._handleTriggerClick);
      trigger.removeEventListener("keydown", this._handleTriggerKeydown);
      trigger.removeAttribute("aria-haspopup");
      trigger.removeAttribute("aria-controls");
      if (trigger.hasAttribute("data-dropdown-menu-hover")) {
        trigger.removeEventListener("mouseenter", this._handleTriggerHover);
        trigger.removeEventListener("mouseleave", this._handleTriggerHover);
      }
    });
    this._triggers = [];
  }
  disconnectedCallback() {
    document.removeEventListener("click", this._handleClick);
    document.removeEventListener("keydown", this._handleKeydown);
    this._removeTriggerListeners();
    super.disconnectedCallback && super.disconnectedCallback();
  }
  _dropdownId() {
    return this.getAttribute("id") || "";
  }
  _addTriggerListeners() {
    this._triggers = Array.prototype.slice.call(
      document.querySelectorAll(`[data-dropdown-menu-id="${this._dropdownId()}"]`)
    );
    this._triggers.forEach((trigger) => {
      this._setupTriggerElement(trigger);
    });
  }
  _addTriggerElement(trigger) {
    this._setupTriggerElement(trigger);
    this._triggers.push(trigger);
  }
  _setupTriggerElement(trigger) {
    trigger.addEventListener("click", this._handleTriggerClick);
    trigger.addEventListener("keydown", this._handleTriggerKeydown);
    trigger.setAttribute("aria-haspopup", "true");
    trigger.setAttribute("aria-controls", this._dropdownId());
    if (trigger.hasAttribute("data-dropdown-menu-hover")) {
      trigger.addEventListener("mouseenter", this._handleTriggerHover);
      trigger.addEventListener("mouseleave", this._handleTriggerHover);
    }
  }
  _setupMenu() {
    const yOffset = this._navMenu ? 0 : 8;
    const placement = this.placement === "auto" ? "bottom-start" : this.placement;
    if (this._currentTrigger) {
      this._cleanup = (0,floating_ui_dom_browser_min/* autoUpdate */.Me)(this._currentTrigger, this, () => {
        if (this._currentTrigger && this._menu) {
          (0,floating_ui_dom_browser_min/* computePosition */.oo)(this._currentTrigger, this._menu, {
            placement: this._navMenu ? "bottom-start" : placement,
            strategy: this.strategy,
            middleware: [
              (0,floating_ui_core_browser_min/* offset */.cv)(yOffset),
              (0,floating_ui_core_browser_min/* flip */.RR)({
                fallbackPlacements: this._filteredFallbackPlacements
              })
            ]
          }).then(({ x, y }) => {
            Object.assign(this._menu.style, {
              left: `${x}px`,
              top: `${y}px`
            });
          });
        }
      });
    }
  }
  async _handleTriggerClick(event) {
    const trigger = event.currentTarget;
    const otherTriggerClicked = this._currentTrigger && this._currentTrigger !== trigger;
    this._currentTrigger = trigger;
    if (this._hasHover && this.open) {
      return;
    } else if (!otherTriggerClicked) {
      this.open = !this.open;
    } else {
      this.open = false;
      await this.updateComplete;
      utils_debounce(() => {
        this._currentTrigger = trigger;
        this.open = true;
      }, 150)();
    }
  }
  _handleTriggerKeydown(event) {
    var _a;
    switch (event.key) {
      case "Enter":
      case " ":
      case "Spacebar":
        if ((_a = event.target) == null ? void 0 : _a.hasAttribute("data-dropdown-menu-hover")) {
          event.preventDefault();
          this._openMenu(event);
        }
        break;
      case "Down":
      case "ArrowDown":
        event.preventDefault();
        this._openMenu(event);
        break;
      case "Up":
      case "ArrowUp":
        event.preventDefault();
        this._moveFocusToLast = true;
        this._openMenu(event);
        break;
    }
  }
  async _handleTriggerHover(event) {
    if (event.type === "mouseenter") {
      const otherTriggerClicked = this._currentTrigger && this._currentTrigger !== event.target;
      this._currentTrigger = event.target;
      this._hasHover = true;
      if (otherTriggerClicked) {
        this.open = false;
        await this.updateComplete;
        this._currentTrigger = event.target;
      }
    } else if (event.type === "mouseleave") {
      this._hasHover = false;
    }
    utils_debounce(() => {
      this._setOpen();
    }, 150)();
  }
  _handleKeydown(event) {
    if ((event.key === "Escape" || event.key === "Esc") && this.open) {
      event.stopPropagation();
      this.open = false;
      if (this._navMenu) {
        this._returnTriggerFocus();
      }
    }
  }
  _handleClick(event) {
    var _a;
    const targetClicked = this._triggers.find(
      (trigger) => {
        var _a2;
        return trigger === ((_a2 = event.target) == null ? void 0 : _a2.closest(trigger.tagName));
      }
    );
    const menuClicked = this === ((_a = event.target) == null ? void 0 : _a.closest('[data-pharos-component="PharosDropdownMenu"]'));
    if (!targetClicked && !menuClicked && this.open) {
      event.stopPropagation();
      this.open = false;
    }
  }
  _setOpen() {
    this.open = this._hasHover;
  }
  _handleHover(event) {
    if (event.type === "mouseenter") {
      this._hasHover = true;
    } else if (event.type === "mouseleave") {
      this._hasHover = false;
    }
    utils_debounce(() => {
      this._setOpen();
    }, 150)();
  }
  async _focusContents() {
    if (this._moveFocusToLast) {
      this._focusLastItem();
    } else {
      this._focusFirstItem();
    }
  }
  _focusFirstItem() {
    const item = this._activeMenuItems[0];
    (item || this).focus();
  }
  _focusLastItem() {
    const items = Array.prototype.slice.call(this._activeMenuItems);
    if (items.length) {
      items[items.length - 1].focus();
      this._moveFocusToLast = false;
    } else {
      this.focus();
    }
  }
  _returnTriggerFocus() {
    if (this._currentTrigger && typeof this._currentTrigger.focus === "function") {
      this._currentTrigger.focus();
    }
  }
  _handleMenuClick(event) {
    var _a;
    const clickedItem = (_a = event.target) == null ? void 0 : _a.closest(
      _allMenuItemsSelector
    );
    if (clickedItem) {
      this._handleItemClick(clickedItem);
    }
  }
  _handleItemClick(clickedItem) {
    const items = Array.prototype.slice.call(this._allMenuItems);
    const details = {
      bubbles: true,
      composed: true,
      detail: clickedItem
    };
    if (this.dispatchEvent(
      new CustomEvent("pharos-dropdown-menu-select", {
        ...details,
        cancelable: true
      })
    )) {
      this.open = false;
      this.dispatchEvent(new CustomEvent("pharos-dropdown-menu-selected", details));
      utils_debounce(() => {
        items.forEach((item) => {
          item.selected = item === clickedItem;
        });
      }, 150)();
    }
  }
  _handleMenuKeydown(event) {
    switch (event.key) {
      case "Down":
      case "ArrowDown":
        event.preventDefault();
        this._handleNavigation(true);
        break;
      case "Up":
      case "ArrowUp":
        event.preventDefault();
        this._handleNavigation(false);
        break;
      case "Escape":
      case "Esc":
        event.preventDefault();
        this._handleKeydown(event);
        break;
    }
    event.stopPropagation();
  }
  _handleNavigation(moveForward) {
    var _a;
    const current = this.ownerDocument.activeElement;
    const items = Array.prototype.slice.call(this._activeMenuItems);
    const nextItemIndex = loopWrapIndex(items, (item) => item === current, moveForward);
    (_a = items[nextItemIndex]) == null ? void 0 : _a.focus();
  }
  _setupResizeObserver() {
    if (this.open && this.fullWidth && this._currentTrigger) {
      this._releaseObserver();
      this._observeResizeTrigger = utils_observeResize(
        this._resizeObserver,
        this._currentTrigger
      );
    } else {
      this._releaseObserver();
    }
  }
  _releaseObserver() {
    if (this._observeResizeTrigger) {
      this._observeResizeTrigger = this._observeResizeTrigger.release();
    }
  }
  _setHoverListeners() {
    var _a;
    if (((_a = this._currentTrigger) == null ? void 0 : _a.hasAttribute("data-dropdown-menu-hover")) && this.open) {
      this.addEventListener("mouseenter", this._handleHover);
      this.addEventListener("mouseleave", this._handleHover);
    } else {
      this.removeEventListener("mouseenter", this._handleHover);
      this.removeEventListener("mouseleave", this._handleHover);
    }
  }
  _setTriggerAttributes() {
    var _a, _b;
    if (this.open) {
      (_a = this._currentTrigger) == null ? void 0 : _a.setAttribute("aria-expanded", "true");
    } else {
      (_b = this._triggers) == null ? void 0 : _b.forEach((trigger) => {
        if (trigger !== this._currentTrigger) {
          trigger.removeAttribute("aria-expanded");
        }
      });
    }
  }
  _openMenu(event) {
    this._enterByKey = true;
    this._handleTriggerClick(event);
  }
  _resetItemsState() {
    const items = Array.prototype.slice.call(this._allMenuItems);
    utils_debounce(() => {
      items.forEach((item) => item["_active"] = false);
    }, 150)();
  }
  _hasItems() {
    return this._allMenuItems.length > 0;
  }
  _handleSlotChange() {
    const items = Array.prototype.slice.call(this._allMenuItems);
    items.forEach((item, index) => {
      item["_last"] = index === items.length - 1;
    });
  }
  _renderSlot() {
    return lit/* html */.dy`<slot @slotchange=${this._handleSlotChange}></slot>`;
  }
  _renderList() {
    return lit/* html */.dy`
      <ul
        class="dropdown-menu__list"
        style=${(0,style_map/* styleMap */.V)(this.fullWidth ? { width: `${this._targetWidth}px` } : {})}
        role="menu"
        tabindex=${this._hasItems() ? "-1" : "0"}
      >
        ${this._hasItems() ? this._renderSlot() : lit/* html */.dy`<li role="menuitem">${this._renderSlot()}</li>`}
      </ul>
    `;
  }
  render() {
    return this._navMenu ? lit/* html */.dy`${this._renderList()}` : lit/* html */.dy`<focus-trap>${this._renderList()}</focus-trap>`;
  }
}
PharosDropdownMenu.elementDefinitions = {
  "focus-trap": focus_trap/* FocusTrap */.iQ
};
pharos_dropdown_menu_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true, attribute: "show-selected" })
], PharosDropdownMenu.prototype, "showSelected", 2);
pharos_dropdown_menu_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true, attribute: "full-width" })
], PharosDropdownMenu.prototype, "fullWidth", 2);
pharos_dropdown_menu_decorateClass([
  (0,decorators/* state */.SB)()
], PharosDropdownMenu.prototype, "_navMenu", 2);
pharos_dropdown_menu_decorateClass([
  (0,decorators/* query */.IO)(".dropdown-menu__list")
], PharosDropdownMenu.prototype, "_menu", 2);
pharos_dropdown_menu_decorateClass([
  (0,decorators/* queryAssignedElements */.NH)({ selector: _allMenuItemsSelector })
], PharosDropdownMenu.prototype, "_allMenuItems", 2);
pharos_dropdown_menu_decorateClass([
  (0,decorators/* queryAssignedElements */.NH)({ selector: `${_allMenuItemsSelector}:not([disabled])` })
], PharosDropdownMenu.prototype, "_activeMenuItems", 2);
pharos_dropdown_menu_decorateClass([
  (0,decorators/* state */.SB)()
], PharosDropdownMenu.prototype, "_targetWidth", 2);

;// CONCATENATED MODULE: ./packages/pharos/src/components/dropdown-menu/pharos-dropdown-menu-item.css.ts

const dropdownMenuItemStyles = lit/* css */.iv`
        :host{contain:layout;display:block}.dropdown-menu-item{display:block}.dropdown-menu-item:not(.dropdown-menu-item--last){border-bottom:1px solid var(--pharos-dropdown-menu-item-color-border-base)}.dropdown-menu-item__button{width:100%}.dropdown-menu-item__button,.dropdown-menu-item__link{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:var(--pharos-dropdown-menu-item-color-background-base);border:none;color:var(--pharos-dropdown-menu-item-color-text-base);cursor:pointer;display:flex;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-font-size-base);font-weight:var(--pharos-font-weight-regular);letter-spacing:calc(var(--pharos-font-size-base)*-.02);line-height:var(--pharos-line-height-medium);margin:0;padding:var(--pharos-spacing-one-half-x) var(--pharos-spacing-1-x);text-align:left;text-decoration:none;text-rendering:optimizelegibility}.dropdown-menu-item__button:focus,.dropdown-menu-item__link:focus{outline:2px solid var(--pharos-color-focus);outline-offset:-1px}.dropdown-menu-item--selected .dropdown-menu-item__button,.dropdown-menu-item--selected .dropdown-menu-item__link{font-weight:var(--pharos-font-weight-bold)}.dropdown-menu-item--active .dropdown-menu-item__button,.dropdown-menu-item--active .dropdown-menu-item__link{background-color:var(--pharos-dropdown-menu-item-color-background-active);color:var(--pharos-dropdown-menu-item-color-text-base)}.dropdown-menu-item__icon{fill:var(--pharos-dropdown-menu-item-color-icon-base);stroke:var(--pharos-dropdown-menu-item-color-icon-base);stroke-width:0;margin-right:var(--pharos-spacing-one-half-x)}.dropdown-menu-item__icon--selected{fill:var(--pharos-dropdown-menu-item-color-icon-base);margin-left:auto}.dropdown-menu-item__text{margin-right:var(--pharos-spacing-one-half-x)}:host([disabled]){pointer-events:none}:host([disabled]) .dropdown-menu-item__button,:host([disabled]) .dropdown-menu-item__link{background-color:var(--pharos-dropdown-menu-item-color-background-disabled);color:var(--pharos-dropdown-menu-item-color-text-disabled)}:host(:not([selected])) .dropdown-menu-item__description{color:var(--pharos-dropdown-menu-item-color-text-description)}:host(:not([disabled])) .dropdown-menu-item:hover:not(.dropdown-menu-item--active) .dropdown-menu-item__button,:host(:not([disabled])) .dropdown-menu-item:hover:not(.dropdown-menu-item--active) .dropdown-menu-item__link{background-color:var(--pharos-dropdown-menu-item-color-background-hover);color:var(--pharos-dropdown-menu-item-color-text-hover)}:host(:not([disabled])) .dropdown-menu-item:hover:not(.dropdown-menu-item--active) .dropdown-menu-item__icon{fill:var(--pharos-dropdown-menu-item-color-text-hover);stroke:var(--pharos-dropdown-menu-item-color-text-hover)}:host(:not([disabled])) .dropdown-menu-item:hover:not(.dropdown-menu-item--active) .dropdown-menu-item__description{color:var(--pharos-dropdown-menu-item-color-text-hover)}
      `;

;// CONCATENATED MODULE: ./packages/pharos/src/components/dropdown-menu/pharos-dropdown-menu-item.ts
var pharos_dropdown_menu_item_defProp = Object.defineProperty;
var pharos_dropdown_menu_item_getOwnPropDesc = Object.getOwnPropertyDescriptor;
var pharos_dropdown_menu_item_decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? pharos_dropdown_menu_item_getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    pharos_dropdown_menu_item_defProp(target, key, result);
  return result;
};









class PharosDropdownMenuItem extends (0,scoped_registry/* default */.Z)((0,mixins_focus/* default */.Z)(pharos_element/* PharosElement */.Z)) {
  constructor() {
    super(...arguments);
    this.selected = false;
    this.link = "";
    this.target = "_self";
    this.disabled = false;
    this._last = false;
    this._active = false;
  }
  static get styles() {
    return [dropdownMenuItemStyles];
  }
  firstUpdated() {
    this.addEventListener("click", this._handleClick);
    this.addEventListener("mousedown", this._handleMousedown);
    this.addEventListener("mouseup", this._handleMouseup);
    this._menu = this.closest('[data-pharos-component="PharosDropdownMenu"]');
  }
  _handleClick(event) {
    if (this.disabled) {
      event.preventDefault();
      event.stopPropagation();
    }
  }
  _handleMousedown(event) {
    event.preventDefault();
    if (!this.disabled) {
      this.focus();
      this._active = true;
    }
  }
  _handleMouseup() {
    if (!this.disabled) {
      this._active = false;
    }
  }
  _renderIcon() {
    if (this.icon) {
      return lit/* html */.dy`
        <pharos-icon class="dropdown-menu-item__icon" name="${this.icon}"></pharos-icon>
      `;
    }
    return lit/* nothing */.Ld;
  }
  _renderCheckmark() {
    var _a;
    if (((_a = this._menu) == null ? void 0 : _a.showSelected) && this.selected) {
      return lit/* html */.dy`
        <pharos-icon
          class="${(0,class_map/* classMap */.$)({
        [`dropdown-menu-item__icon--selected`]: true
      })}"
          name="checkmark"
        ></pharos-icon>
      `;
    }
    return lit/* nothing */.Ld;
  }
  _renderDescription() {
    const descriptionSlot = [...this.children].filter((child) => child.slot === "description");
    const content = descriptionSlot.length ? lit/* html */.dy` <div class="dropdown-menu-item__description">
          <slot name="description"></slot>
        </div>` : lit/* nothing */.Ld;
    return content;
  }
  get itemContent() {
    return lit/* html */.dy`
      ${this._renderIcon()}
      <div class="dropdown-menu-item__text">
        <slot></slot>
        ${this._renderDescription()}
      </div>
      ${this._renderCheckmark()}
    `;
  }
  render() {
    var _a;
    return lit/* html */.dy`
      <li
        class="${(0,class_map/* classMap */.$)({
      [`dropdown-menu-item`]: true,
      [`dropdown-menu-item--last`]: this._last,
      [`dropdown-menu-item--selected`]: ((_a = this._menu) == null ? void 0 : _a.showSelected) && this.selected,
      [`dropdown-menu-item--active`]: this._active
    })}"
        role=${this.link ? "none" : "menuitem"}
      >
        ${this.link ? lit/* html */.dy`<a
              role="menuitem"
              href="${this.link}"
              target="${this.target}"
              rel=${(0,if_defined/* ifDefined */.o)(this.rel)}
              class="dropdown-menu-item__link"
            >
              ${this.itemContent}
            </a> ` : lit/* html */.dy`<button ?disabled=${this.disabled} class="dropdown-menu-item__button">
              ${this.itemContent}
            </button>`}
      </li>
    `;
  }
}
PharosDropdownMenuItem.elementDefinitions = {
  "pharos-icon": pharos_icon/* PharosIcon */.b
};
pharos_dropdown_menu_item_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosDropdownMenuItem.prototype, "icon", 2);
pharos_dropdown_menu_item_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], PharosDropdownMenuItem.prototype, "selected", 2);
pharos_dropdown_menu_item_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosDropdownMenuItem.prototype, "link", 2);
pharos_dropdown_menu_item_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosDropdownMenuItem.prototype, "target", 2);
pharos_dropdown_menu_item_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosDropdownMenuItem.prototype, "rel", 2);
pharos_dropdown_menu_item_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], PharosDropdownMenuItem.prototype, "disabled", 2);
pharos_dropdown_menu_item_decorateClass([
  (0,decorators/* state */.SB)()
], PharosDropdownMenuItem.prototype, "_last", 2);
pharos_dropdown_menu_item_decorateClass([
  (0,decorators/* state */.SB)()
], PharosDropdownMenuItem.prototype, "_active", 2);
pharos_dropdown_menu_item_decorateClass([
  (0,decorators/* state */.SB)()
], PharosDropdownMenuItem.prototype, "_menu", 2);

;// CONCATENATED MODULE: ./packages/pharos/src/components/dropdown-menu-nav/pharos-dropdown-menu-nav.css.ts

const dropdownMenuNavStyles = lit/* css */.iv`
        :host{display:block}.dropdown-menu-nav__container{display:flex;flex-wrap:wrap}
      `;

;// CONCATENATED MODULE: ./packages/pharos/src/components/dropdown-menu-nav/pharos-dropdown-menu-nav.ts
var pharos_dropdown_menu_nav_defProp = Object.defineProperty;
var pharos_dropdown_menu_nav_getOwnPropDesc = Object.getOwnPropertyDescriptor;
var pharos_dropdown_menu_nav_decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? pharos_dropdown_menu_nav_getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    pharos_dropdown_menu_nav_defProp(target, key, result);
  return result;
};






class PharosDropdownMenuNav extends (0,mixins_focus/* default */.Z)(pharos_element/* PharosElement */.Z) {
  static get styles() {
    return [dropdownMenuNavStyles];
  }
  firstUpdated() {
    this.addEventListener("focus", () => this._closeAllMenus());
  }
  _closeAllMenus(link = void 0) {
    const menu = this.querySelector(
      '[data-pharos-component="PharosDropdownMenu"][open]'
    );
    if (menu && menu.id !== (link == null ? void 0 : link.getAttribute("data-dropdown-menu-id"))) {
      menu.open = false;
    }
  }
  _handleSlotChange() {
    this._allLinks.forEach((link) => {
      link.addEventListener("focusin", () => this._closeAllMenus());
      link.addEventListener("mouseenter", () => this._closeAllMenus(link));
    });
    this._allMenus.forEach((menu) => {
      menu["_navMenu"] = true;
      menu.addEventListener("focusout", (event) => {
        if (event.relatedTarget && !event.relatedTarget.closest(
          '[data-pharos-component="PharosDropdownMenuNav"]'
        )) {
          this._closeAllMenus();
        }
      });
    });
  }
  render() {
    return lit/* html */.dy`
      <nav class="dropdown-menu-nav__container" aria-label=${(0,if_defined/* ifDefined */.o)(this.label)}>
        <slot @slotchange=${this._handleSlotChange}></slot>
      </nav>
    `;
  }
}
pharos_dropdown_menu_nav_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosDropdownMenuNav.prototype, "label", 2);
pharos_dropdown_menu_nav_decorateClass([
  (0,decorators/* queryAssignedElements */.NH)({ selector: '[data-pharos-component="PharosDropdownMenuNavLink"]' })
], PharosDropdownMenuNav.prototype, "_allLinks", 2);
pharos_dropdown_menu_nav_decorateClass([
  (0,decorators/* queryAssignedElements */.NH)({ selector: '[data-pharos-component="PharosDropdownMenu"]' })
], PharosDropdownMenuNav.prototype, "_allMenus", 2);

;// CONCATENATED MODULE: ./packages/pharos/src/components/dropdown-menu-nav/pharos-dropdown-menu-nav-link.css.ts

const dropdownMenuNavLinkStyles = lit/* css */.iv`
        #link-element{font-weight:var(--pharos-font-weight-bold);padding:var(--pharos-spacing-three-quarters-x);text-decoration:none}#link-element:hover,:host([is-active]) #link-element{fill:var(--pharos-color-interactive-primary);background-color:var(--pharos-color-marble-gray-94);border-bottom:2px solid var(--pharos-color-hover-primary);color:var(--pharos-color-interactive-primary);padding-bottom:calc(var(--pharos-spacing-three-quarters-x) - 2px);text-decoration:none}.link__icon{fill:var(--pharos-color-interactive-secondary);margin-left:var(--pharos-spacing-one-quarter-x)}#link-element:hover .link__icon,:host([is-active]) .link__icon{fill:var(--pharos-color-interactive-primary)}
      `;

;// CONCATENATED MODULE: ./packages/pharos/src/components/dropdown-menu-nav/pharos-dropdown-menu-nav-link.ts
var pharos_dropdown_menu_nav_link_defProp = Object.defineProperty;
var pharos_dropdown_menu_nav_link_getOwnPropDesc = Object.getOwnPropertyDescriptor;
var pharos_dropdown_menu_nav_link_decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? pharos_dropdown_menu_nav_link_getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    pharos_dropdown_menu_nav_link_defProp(target, key, result);
  return result;
};






class PharosDropdownMenuNavLink extends (0,scoped_registry/* default */.Z)(pharos_link/* PharosLink */.G) {
  constructor() {
    super();
    this.isActive = false;
    this.flex = true;
  }
  static get styles() {
    return [super.styles, dropdownMenuNavLinkStyles];
  }
  get appendContent() {
    if (this.hasAttribute("data-dropdown-menu-id")) {
      return lit/* html */.dy`<pharos-icon name="chevron-down" class="link__icon"></pharos-icon>`;
    }
    return lit/* nothing */.Ld;
  }
  render() {
    return lit/* html */.dy`${super.render()}`;
  }
}
PharosDropdownMenuNavLink.elementDefinitions = {
  "pharos-icon": pharos_icon/* PharosIcon */.b
};
pharos_dropdown_menu_nav_link_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true, attribute: "is-active" })
], PharosDropdownMenuNavLink.prototype, "isActive", 2);

;// CONCATENATED MODULE: ./packages/pharos/src/components/footer/pharos-footer.css.ts

const footerStyles = lit/* css */.iv`
        :host{contain:content;display:block}#footer-element{background-color:var(--pharos-color-marble-gray-10);color:var(--pharos-color-white);display:grid;grid-template-areas:". main .";grid-template-columns:1fr 8fr 1fr;padding:var(--pharos-spacing-2-x) var(--pharos-spacing-1-x)}.footer__content{grid-area:main;justify-self:center;max-width:70rem}.footer__row{display:grid}.footer__row--top{grid-template-columns:1fr;grid-template-rows:auto}.footer__row--main{-moz-column-gap:var(--pharos-spacing-one-half-x);column-gap:var(--pharos-spacing-one-half-x);grid-template-columns:1fr 1fr 1fr 1fr 1.25fr 1.75fr;grid-template-rows:auto}.footer__row--bottom{grid-template-columns:.79fr .25fr;grid-template-rows:auto;margin-top:var(--pharos-spacing-one-half-x)}@media (max-width:1024px){.footer__row--main{-moz-column-gap:0;column-gap:0;grid-template-columns:1fr 1fr;grid-template-rows:auto auto auto}.footer__row--bottom{grid-template-columns:1fr 1fr;grid-template-rows:auto}}@media only screen and (max-width:570px){.footer__row--main{grid-template-columns:1fr;grid-template-rows:auto auto auto auto auto auto}.footer__row--bottom{grid-template-columns:1fr;grid-template-rows:auto auto}}.footer__statement{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:var(--pharos-color-marble-gray-80);font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-font-size-small);font-weight:var(--pharos-font-weight-regular);letter-spacing:calc(var(--pharos-font-size-small)*-.02);line-height:var(--pharos-line-height-small);text-rendering:optimizelegibility}::slotted(ul){-webkit-padding-start:0;list-style-type:none;padding-inline-start:0;padding-left:0}
      `;

// EXTERNAL MODULE: ./packages/pharos/src/components/heading/pharos-heading.ts + 1 modules
var pharos_heading = __webpack_require__("./packages/pharos/src/components/heading/pharos-heading.ts");
;// CONCATENATED MODULE: ./packages/pharos/src/components/footer/pharos-footer.ts
var pharos_footer_defProp = Object.defineProperty;
var pharos_footer_getOwnPropDesc = Object.getOwnPropertyDescriptor;
var pharos_footer_decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? pharos_footer_getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    pharos_footer_defProp(target, key, result);
  return result;
};






class PharosFooter extends (0,scoped_registry/* default */.Z)(pharos_element/* PharosElement */.Z) {
  constructor() {
    super(...arguments);
    this._widgetObserver = new MutationObserver(
      (mutationsList) => {
        const widgetContainer = mutationsList[0].addedNodes[0];
        const widgetButton = widgetContainer == null ? void 0 : widgetContainer.querySelector(
          ".goog-te-gadget-simple"
        );
        const googleImg = widgetButton == null ? void 0 : widgetButton.querySelector(".goog-te-gadget-icon");
        const iconTag = this.localName.split("pharos-footer")[0] + "pharos-icon";
        const googleIcon = document.createElement(iconTag);
        const chevronIcon = document.createElement(iconTag);
        googleIcon.name = "google";
        chevronIcon.name = "chevron-down";
        chevronIcon.style.marginLeft = "0";
        widgetButton == null ? void 0 : widgetButton.appendChild(chevronIcon);
        widgetButton == null ? void 0 : widgetButton.replaceChild(googleIcon, googleImg);
      }
    );
  }
  static get styles() {
    return [footerStyles];
  }
  firstUpdated() {
    if (this._widgetNodes.length) {
      this._widgetObserver.observe(this._widgetNodes[0], {
        childList: true
      });
    }
  }
  disconnectedCallback() {
    this._widgetObserver.disconnect();
    super.disconnectedCallback && super.disconnectedCallback();
  }
  render() {
    return lit/* html */.dy`
      <footer id="footer-element">
        <div class="footer__content">
          <div class="footer__row footer__row--top">
            <pharos-heading level="2" preset="5--bold">Explore JSTOR</pharos-heading>
          </div>
          <div class="footer__row footer__row--main">
            <slot name="links-group"></slot>
            <div>
              <slot name="button-links"></slot>
            </div>
            <div>
              <slot name="social-links"></slot>
              <p class="footer__statement">
                <slot name="mission-statement"></slot>
              </p>
              <p class="footer__statement">
                <slot name="copyright-statement"></slot>
              </p>
            </div>
          </div>
          <div class="footer__row footer__row--bottom">
            <slot name="legal-links"></slot>
            <slot name="google-widget"></slot>
          </div>
        </div>
      </footer>
    `;
  }
}
PharosFooter.elementDefinitions = {
  "pharos-heading": pharos_heading/* PharosHeading */.rW
};
pharos_footer_decorateClass([
  (0,decorators/* queryAssignedNodes */.vZ)("google-widget", false, "#google_translate_element")
], PharosFooter.prototype, "_widgetNodes", 2);

;// CONCATENATED MODULE: ./packages/pharos/src/components/header/pharos-header.css.ts

const headerStyles = lit/* css */.iv`
        :host{display:block}.header__content{border-bottom:1px solid var(--pharos-color-ui-40);border-top:1px solid var(--pharos-color-ui-40);-moz-column-gap:var(--pharos-spacing-1-x);column-gap:var(--pharos-spacing-1-x);display:grid;grid-area:main;grid-template:"start center end-top" auto "start center end-bottom" auto/65px minmax(auto,650px) auto;padding:var(--pharos-spacing-one-half-x) var(--pharos-spacing-one-and-a-half-x) 0}@media screen and (max-width:48rem){.header__content{grid-template:". . end-top" auto "start center center" auto ". end-bottom end-bottom" auto/65px minmax(auto,650px) auto}.header__content--end{display:none}}.header__top{display:flex;justify-content:center;margin-bottom:var(--pharos-spacing-one-half-x);margin-top:var(--pharos-spacing-one-half-x)}.header__content--start{align-self:end;grid-area:start}.header__content--center{align-self:end;grid-area:center}.header__content--end-top{align-self:start;grid-area:end-top;justify-self:end}.header__content--end-bottom{align-self:end;display:flex;grid-area:end-bottom;justify-self:end}
      `;

;// CONCATENATED MODULE: ./packages/pharos/src/components/header/pharos-header.ts



class PharosHeader extends pharos_element/* PharosElement */.Z {
  static get styles() {
    return [headerStyles];
  }
  render() {
    return lit/* html */.dy`
      <header id="header-element">
        <div class="header__top">
          <slot name="top"></slot>
        </div>
        <div class="header__content">
          <div class="header__content--start">
            <slot name="start"></slot>
          </div>
          <div class="header__content--center">
            <slot name="center"></slot>
          </div>
          <div class="header__content--end-top">
            <slot name="end-top"></slot>
          </div>
          <div class="header__content--end-bottom">
            <slot name="end-bottom"></slot>
          </div>
        </div>
      </header>
    `;
  }
}

;// CONCATENATED MODULE: ./packages/pharos/src/components/image-card/pharos-image-card.css.ts

const imageCardStyles = lit/* css */.iv`
        :host{display:inline-flex;width:100%}.card{display:inline-flex;flex-direction:column;width:100%}.card__link-container{display:flex;margin-bottom:var(--pharos-spacing-1-x)}.card__link--image{contain:unset;display:block;height:14rem;position:relative;width:100%}.card__link--title{contain:unset;display:inline-flex;min-width:0}.card__link--image.card__link--selected{background-color:var(--pharos-color-white);box-sizing:border-box;outline:solid 2px var(--pharos-color-interactive-secondary);transition:background-color var(--pharos-transition-duration-short) ease-in-out}.card__link--image.card__link--selected slot[name=image]::slotted(*){height:calc(100% - var(--pharos-spacing-three-quarters-x)*2);padding:var(--pharos-spacing-three-quarters-x);width:calc(100% - var(--pharos-spacing-three-quarters-x)*2)}:host([disabled]) .card__link--image.card__link--selected{outline:solid 2px var(--pharos-color-marble-gray-50)}:host([disabled]) .card__link--image{color:var(--pharos-color-marble-gray-50);cursor:not-allowed;pointer-events:none;text-decoration:none}:host([disabled]) .card__link--image slot[name=image]::slotted(*){opacity:.5}slot[name=image]::slotted(img){height:100%;-o-object-fit:contain;object-fit:contain;-o-object-position:bottom;object-position:bottom;width:100%}:host([disabled]) .card__link--title{color:var(--pharos-color-marble-gray-50);cursor:not-allowed;pointer-events:none;text-decoration:none}:host([disabled]) .card__heading{color:var(--pharos-color-marble-gray-50)}:host([variant=promotional]) .card__link--image{height:unset}.card__metadata{color:var(--pharos-color-text-40)}.card__metadata,.card__metadata--hover{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-font-size-small);font-weight:var(--pharos-font-weight-regular);letter-spacing:calc(var(--pharos-font-size-small)*-.02);line-height:var(--pharos-line-height-small);text-rendering:optimizelegibility}.card__metadata--hover{background-color:transparent;box-sizing:border-box;color:var(--pharos-color-text-white);height:100%;opacity:0;overflow:auto;padding:var(--pharos-spacing-one-half-x);pointer-events:none;position:absolute;top:0;transform:translateZ(0);transition:visibility var(--pharos-transition-duration-default) ease-in-out,opacity var(--pharos-transition-duration-default) ease-in-out,background-color var(--pharos-transition-duration-default) ease-in-out;visibility:hidden;width:100%}.card__container--error{align-items:center;align-self:flex-end;background-color:var(--pharos-color-marble-gray-94);display:flex;flex-direction:column;height:14rem;justify-content:center;row-gap:var(--pharos-spacing-1-x);text-align:center;width:100%}.card__container--error .unavailable-text{max-width:9rem}.card__container--error.card__container--selectable-hover{background-color:inherit;transition:background-color var(--pharos-transition-duration-short) ease-in-out}.card__container--error.card__container--selected{background-color:var(--pharos-color-white);transition:background-color var(--pharos-transition-duration-short) ease-in-out}.card__source-type{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:var(--pharos-color-text-40);font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-font-size-small);font-weight:var(--pharos-font-weight-bold);letter-spacing:calc(var(--pharos-font-size-small)*-.02);line-height:var(--pharos-line-height-small);margin-bottom:var(--pharos-spacing-one-quarter-x);text-rendering:optimizelegibility;text-transform:uppercase}.card__title{display:flex;justify-content:space-between;margin-bottom:var(--pharos-spacing-one-half-x)}.card__link--collection{display:grid;height:auto;position:relative}.card__link--collection.card__link--selected{background-color:var(--pharos-color-white);box-sizing:border-box;outline:solid 2px var(--pharos-color-interactive-secondary);transition:background-color var(--pharos-transition-duration-short) ease-in-out}.card__link--collection.card__link--selected slot[name=image]::slotted(*){height:calc(100% - var(--pharos-spacing-three-quarters-x)*2);padding:var(--pharos-spacing-three-quarters-x);width:calc(100% - var(--pharos-spacing-three-quarters-x)*2)}:host([disabled]) .card__link--collection.card__link--selected{outline:solid 2px var(--pharos-color-marble-gray-50)}:host([disabled]) .card__link--collection{color:var(--pharos-color-marble-gray-50);cursor:not-allowed;pointer-events:none;text-decoration:none}:host([disabled]) .card__link--collection slot[name=image]::slotted(*){opacity:.5}.card__title--hover{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;display:block;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-font-size-base);font-weight:var(--pharos-font-weight-bold);letter-spacing:calc(var(--pharos-font-size-base)*-.02);line-height:var(--pharos-line-height-medium);margin-bottom:var(--pharos-spacing-one-half-x);text-rendering:optimizelegibility}:host(:not([variant=promotional])) .card__heading,:host(:not([variant=promotional])) .card__title--hover{-webkit-line-clamp:2;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden;white-space:normal}.card__svg{display:block;height:100%;width:100%}.card__checkbox--subtle{margin:-4px 0 0 -4px}.card__checkbox{margin-left:var(--pharos-spacing-one-quarter-x);margin-top:var(--pharos-spacing-one-quarter-x);position:absolute;z-index:1}.card__link--image.card__link--selectable{background-color:var(--pharos-color-marble-gray-94)}.card__link--image.card__link--select-hover{background-color:var(--pharos-color-marble-gray-base);transition:background-color var(--pharos-transition-duration-short) ease-in-out}:host([subtle]) .card__link--image:hover .card__metadata--hover{background-color:rgba(0,0,0,.75);opacity:1;pointer-events:auto;visibility:visible}slot[name=metadata]::slotted(:not(:last-child)){margin-bottom:var(--pharos-spacing-one-half-x)}slot[name=metadata]::slotted(strong){color:var(--pharos-color-text-base);display:block}:host([variant=collection]) .card__title,:host([variant=selectable-collection]) .card__title{margin-bottom:var(--pharos-spacing-1-x)}:host([variant=collection]) .card__metadata,:host([variant=selectable-collection]) .card__metadata{color:var(--pharos-color-text-20)}:host([variant=promotional]) .card__metadata{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-font-size-base);font-weight:var(--pharos-font-weight-regular);letter-spacing:calc(var(--pharos-font-size-base)*-.02);line-height:var(--pharos-line-height-medium);text-rendering:optimizelegibility}:host([variant=collection]) slot[name=image]::slotted(img),:host([variant=selectable-collection]) slot[name=image]::slotted(img){-o-object-fit:cover;object-fit:cover;-o-object-position:50% 30%;object-position:50% 30%;position:absolute}
      `;

;// CONCATENATED MODULE: ./packages/pharos/src/components/image-card/pharos-image-card.ts
var pharos_image_card_defProp = Object.defineProperty;
var pharos_image_card_getOwnPropDesc = Object.getOwnPropertyDescriptor;
var pharos_image_card_decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? pharos_image_card_getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    pharos_image_card_defProp(target, key, result);
  return result;
};














const VARIANTS = [
  "base",
  "collection",
  "promotional",
  "selectable",
  "selectable-collection"
];
const DEFAULT_HEADING_LEVEL = 3;
class PharosImageCard extends (0,scoped_registry/* default */.Z)((0,mixins_focus/* default */.Z)(pharos_element/* PharosElement */.Z)) {
  constructor() {
    super(...arguments);
    this.title = "";
    this.link = "";
    this.variant = "base";
    this.error = false;
    this.subtle = false;
    this._isSelected = false;
    this.disabled = false;
    this.indicateLinkVisited = false;
    this._isSelectableHovered = false;
  }
  static get styles() {
    return [imageCardStyles];
  }
  update(changedProperties) {
    super.update && super.update(changedProperties);
    if (changedProperties.has("variant") && this.variant && !VARIANTS.includes(this.variant)) {
      throw new Error(
        `${this.variant} is not a valid variant. Valid variants are: ${VARIANTS.join(", ")}`
      );
    }
    if (changedProperties.has("subtleSelect") && this.subtleSelect && !this._isSelectable()) {
      throw new Error(
        `${this.variant} is not a valid variant to use with subtle-select. Only the selectable variants can be used with subtle-select.}`
      );
    }
    if (this.selected && this._isSelectable()) {
      throw new Error(
        `Image card with variant type ${this.variant} cannot be selected. Only the selectable variants can be selected.}`
      );
    }
  }
  _isSelectable() {
    return this.variant.includes("selectable");
  }
  _handleClick(e) {
    const trigger = e.target;
    const menu = document.querySelector(
      `[data-pharos-component="PharosDropdownMenu"]#${this.actionMenu}`
    );
    menu == null ? void 0 : menu.openWithTrigger(trigger);
  }
  _handleImageMouseEnter() {
    if (!this.disabled) {
      this._title["_hover"] = true;
      this._handleMouseEnterSelectable();
      const mouseEvent = new CustomEvent("pharos-image-card-image-mouseenter");
      this.dispatchEvent(mouseEvent);
    }
  }
  _handleImageMouseLeave() {
    if (!this.disabled) {
      this._title["_hover"] = false;
      this._handleMouseLeaveSelectable();
      const mouseEvent = new CustomEvent("pharos-image-card-image-mouseleave");
      this.dispatchEvent(mouseEvent);
    }
  }
  _handleMouseEnterSelectable() {
    this._isSelectableHovered = true;
  }
  _handleMouseLeaveSelectable() {
    this._isSelectableHovered = false;
  }
  _renderCollectionImage() {
    return lit/* html */.dy`<div
      class="card__link-container"
      @keydown=${this._handleForwardNavigation}
      @mouseenter=${this._handleImageMouseEnter}
      @mouseleave=${this._handleImageMouseLeave}
      @click=${this._cardToggleSelect}
    >
      <pharos-link
        class=${(0,class_map/* classMap */.$)({
      [`card__link--collection`]: true,
      [`card__link--selected`]: this._isSelected
    })}
        href="${this.link}"
        label="${(0,if_defined/* ifDefined */.o)(this.imageLinkLabel)}"
        subtle
        flex
        no-hover
      >
        <svg class="card__svg" role="presentation" viewBox="0 0 4 3"></svg>
        <slot name="image"></slot>
      </pharos-link>
      ${this._renderCheckbox()}
    </div>`;
  }
  _renderLinkContent() {
    return this.error ? lit/* html */.dy`<div
          class=${(0,class_map/* classMap */.$)({
      [`card__container--error`]: true,
      [`card__container--selected`]: this._isSelected,
      [`card__container--selectable-hover`]: this._isSelectableCardHover()
    })}
        >
          <pharos-icon name="exclamation-inverse"></pharos-icon>
          <span class="unavailable-text">Preview not available</span>
        </div>` : lit/* html */.dy`<slot name="image"></slot>`;
  }
  _renderHoverMetadata() {
    return this._showSubtleOverlay() ? lit/* html */.dy`<div class="card__metadata--hover">
          ${this._renderCheckbox()}
          <strong class="card__title--hover">${this.title}</strong>
          <slot name="metadata"></slot>
        </div>` : lit/* nothing */.Ld;
  }
  _renderBaseImage() {
    return lit/* html */.dy`<div
      class="card__link-container"
      @keydown=${this._handleForwardNavigation}
      @mouseenter=${this._handleImageMouseEnter}
      @mouseleave=${this._handleImageMouseLeave}
      @click=${this._cardToggleSelect}
    >
      <pharos-link
        class=${(0,class_map/* classMap */.$)({
      [`card__link--image`]: true,
      [`card__link--selectable`]: (this._isSubtleSelectHover() || this._isSelectableViaCard() || this._isDisabledSelectable()) && !this._isSelected,
      [`card__link--selected`]: this._isSelected,
      [`card__link--select-hover`]: this._isSelectableCardHover() && !this._isSelected
    })}
        href="${this.link}"
        label=${(0,if_defined/* ifDefined */.o)(this.imageLinkLabel)}
        subtle
        no-hover
      >
        ${this._renderLinkContent()}${this._renderHoverMetadata()}
        <slot name="overlay"></slot>
      </pharos-link>
      ${this._showSubtleOverlay() ? lit/* nothing */.Ld : this._renderCheckbox()}
    </div>`;
  }
  _renderImage() {
    return this.variant.includes("collection") ? this._renderCollectionImage() : this._renderBaseImage();
  }
  _chooseHeadingPreset() {
    return {
      collection: "2",
      "selectable-collection": "2",
      promotional: "4",
      base: "1--bold",
      selectable: "1--bold"
    }[this.variant];
  }
  _renderTitle() {
    return lit/* html */.dy`<pharos-link
      @keydown=${this._handleBackwardNavigation}
      class="card__link--title"
      href="${this.link}"
      subtle
      flex
      indicate-visited="${this.indicateLinkVisited}"
      @click=${this._cardToggleSelect}
      >${this.title ? lit/* html */.dy`<pharos-heading
            class="card__heading"
            preset="${this._chooseHeadingPreset()}"
            level="${this.headingLevel || DEFAULT_HEADING_LEVEL}"
            no-margin
            >${this.title}</pharos-heading
          >` : lit/* html */.dy`<slot name="title"></slot>`}
    </pharos-link>`;
  }
  _renderActionButton() {
    return this.actionMenu ? lit/* html */.dy`<pharos-button
          class="card__action-button"
          icon="ellipses-vertical"
          variant="subtle"
          icon-condensed
          label="More actions"
          @click=${this._handleClick}
        ></pharos-button>` : lit/* html */.dy`<slot name="action-button"></slot>`;
  }
  _renderSourceType() {
    return this.sourceType ? lit/* html */.dy`<div class="card__source-type">${this.sourceType}</div>` : lit/* nothing */.Ld;
  }
  _renderMetadata() {
    return this.subtle ? lit/* nothing */.Ld : lit/* html */.dy`<div class="card__metadata">
          <slot name="metadata"></slot>
        </div>`;
  }
  render() {
    return lit/* html */.dy`<div class="card">
      ${this._renderImage()} ${this._renderSourceType()}
      <div
        class="card__title"
        @mouseenter=${this._handleMouseEnterSelectable}
        @mouseleave=${this._handleMouseLeaveSelectable}
      >
        ${this._renderTitle()} ${this._renderActionButton()}
      </div>
      ${this._renderMetadata()}
    </div>`;
  }
  _handleNavigation(event, directionMatches) {
    if (!this.subtleSelect || this._isCheckboxDisplayed()) {
      return;
    }
    if (event.key == "Tab" && directionMatches) {
      event.preventDefault();
      this._isSelectableHovered = true;
      new Promise((resolve) => requestAnimationFrame(resolve)).then(() => {
        this._checkbox.focus();
      });
    }
  }
  _handleBackwardNavigation(event) {
    this._handleNavigation(event, event.shiftKey);
  }
  _handleForwardNavigation(event) {
    this._handleNavigation(event, !event.shiftKey);
  }
  _cardToggleSelect(event) {
    const cardClicked = this._isSelectableViaCard() && event.target !== this._checkbox;
    const checkboxClicked = event.currentTarget === this._checkbox;
    if (!this.disabled && (cardClicked || checkboxClicked)) {
      event.preventDefault();
      event.stopPropagation();
      this._isSelected = !this._isSelected;
      this.dispatchEvent(
        new CustomEvent("pharos-image-card-selected", {
          bubbles: true,
          composed: true,
          detail: {
            event,
            cardSelected: this._isSelected
          }
        })
      );
    }
  }
  _isSubtleSelectHover() {
    return Boolean(
      this._isSelectable() && this._isSelectableHovered && this.subtleSelect && !this.disabled
    );
  }
  _isSubtleAndSelectable() {
    return Boolean(this._isSelectable() && this.subtle && !this.disabled);
  }
  _showSubtleOverlay() {
    return Boolean(
      this.subtle && (this.subtleSelect && !this._isSelected || !this._isSelectable())
    );
  }
  _isSelectableCardHover() {
    return Boolean(this._isSelectableViaCard() && this._isSelectableHovered) && !this.disabled;
  }
  _isSelectableViaCard() {
    return Boolean(
      this._isSelectable() && !this.subtleSelect && !this.disabled || this.subtleSelect && this._isSelected && !this.disabled
    );
  }
  _isDisabledSelectable() {
    return this.disabled && this._isSelectable();
  }
  _isCheckboxDisplayed() {
    return this._isSubtleSelectHover() || this._isSubtleAndSelectable() || this._isSelectableViaCard() || this._isSelected || this.disabled && this._isSelectable();
  }
  _renderCheckbox() {
    return this._isCheckboxDisplayed() ? lit/* html */.dy`<pharos-checkbox
          @blur=${this._handleMouseLeaveSelectable}
          class="${this._showSubtleOverlay() ? "card__checkbox--subtle" : "card__checkbox"}"
          hide-label="true"
          ?checked=${this._isSelected}
          ?disabled=${this.disabled}
          name="Select ${this.title}"
          @click="${this._cardToggleSelect}"
          ><span slot="label">Select ${this.title}</span></pharos-checkbox
        >` : lit/* nothing */.Ld;
  }
}
PharosImageCard.elementDefinitions = {
  "pharos-heading": pharos_heading/* PharosHeading */.rW,
  "pharos-link": pharos_link/* PharosLink */.G,
  "pharos-icon": pharos_icon/* PharosIcon */.b,
  "pharos-button": pharos_button/* PharosButton */.b,
  "pharos-checkbox": PharosCheckbox
};
pharos_image_card_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosImageCard.prototype, "title", 2);
pharos_image_card_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true, attribute: "source-type" })
], PharosImageCard.prototype, "sourceType", 2);
pharos_image_card_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosImageCard.prototype, "link", 2);
pharos_image_card_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true, attribute: "image-link-label" })
], PharosImageCard.prototype, "imageLinkLabel", 2);
pharos_image_card_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosImageCard.prototype, "variant", 2);
pharos_image_card_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], PharosImageCard.prototype, "error", 2);
pharos_image_card_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], PharosImageCard.prototype, "subtle", 2);
pharos_image_card_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true, attribute: "action-menu" })
], PharosImageCard.prototype, "actionMenu", 2);
pharos_image_card_decorateClass([
  (0,decorators/* property */.Cb)({ type: Number, reflect: true, attribute: "heading-level" })
], PharosImageCard.prototype, "headingLevel", 2);
pharos_image_card_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true, attribute: "subtle-select" })
], PharosImageCard.prototype, "subtleSelect", 2);
pharos_image_card_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true, attribute: "selected" })
], PharosImageCard.prototype, "_isSelected", 2);
pharos_image_card_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true, attribute: "disabled" })
], PharosImageCard.prototype, "disabled", 2);
pharos_image_card_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true, attribute: "indicate-link-visited" })
], PharosImageCard.prototype, "indicateLinkVisited", 2);
pharos_image_card_decorateClass([
  (0,decorators/* state */.SB)()
], PharosImageCard.prototype, "_isSelectableHovered", 2);
pharos_image_card_decorateClass([
  (0,decorators/* query */.IO)(".card__link--title")
], PharosImageCard.prototype, "_title", 2);
pharos_image_card_decorateClass([
  (0,decorators/* query */.IO)('[data-pharos-component="PharosCheckbox"]')
], PharosImageCard.prototype, "_checkbox", 2);

;// CONCATENATED MODULE: ./packages/pharos/src/components/input-group/pharos-input-group.css.ts

const inputGroupStyles = lit/* css */.iv`
        :host{contain:paint;display:block;width:100%}.input-group{align-items:center;box-sizing:border-box;display:flex;justify-content:center;position:absolute;top:50%;transform:translateY(-50%)}.input-group--append{right:0}.input-group--prepend{left:0}slot[name=prepend]::slotted(*){margin-left:var(--pharos-spacing-one-quarter-x)}slot:not([name])::slotted(*){margin-right:var(--pharos-spacing-one-quarter-x)}slot[name=prepend]::slotted([data-pharos-component=PharosIcon]:first-child){margin-left:calc(var(--pharos-spacing-three-quarters-x) + 1px)}slot:not([name])::slotted([data-pharos-component=PharosIcon]:last-child){margin-right:calc(var(--pharos-spacing-three-quarters-x) + 1px)}:host([variant=prominent]) slot[name=prepend]::slotted(*){margin-left:var(--pharos-spacing-three-quarters-x)}:host([variant=prominent]) slot[name=prepend]::slotted([data-pharos-component=PharosIcon]:first-child){margin-left:var(--pharos-spacing-three-quarters-x)}:host([variant=prominent]) slot:not([name])::slotted(:last-child){margin-right:var(--pharos-spacing-three-quarters-x)}:host([variant=prominent]) slot:not([name])::slotted([data-pharos-component=PharosIcon]:last-child){margin-right:var(--pharos-spacing-three-quarters-x)}
      `;

// EXTERNAL MODULE: ./packages/pharos/src/components/text-input/pharos-text-input.ts + 1 modules
var pharos_text_input = __webpack_require__("./packages/pharos/src/components/text-input/pharos-text-input.ts");
// EXTERNAL MODULE: ./packages/pharos/src/styles/variables.ts
var styles_variables = __webpack_require__("./packages/pharos/src/styles/variables.ts");
;// CONCATENATED MODULE: ./packages/pharos/src/components/input-group/pharos-input-group.ts
var pharos_input_group_defProp = Object.defineProperty;
var pharos_input_group_getOwnPropDesc = Object.getOwnPropertyDescriptor;
var pharos_input_group_decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? pharos_input_group_getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    pharos_input_group_defProp(target, key, result);
  return result;
};





class PharosInputGroup extends pharos_text_input/* PharosTextInput */.e {
  constructor() {
    super(...arguments);
    this._appendGroupWidth = 0;
    this._prependGroupWidth = 0;
  }
  static get styles() {
    return [super.styles, inputGroupStyles];
  }
  firstUpdated() {
    this.addEventListener("focus", this._adjustPadding);
    this.addEventListener("blur", this._adjustPadding);
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    if (changedProperties.has("_prependGroupWidth")) {
      const updatedPaddingLeft = this.variant === "prominent" ? styles_variables/* PharosSpacing1X */.cnU : styles_variables/* PharosSpacingThreeQuartersX */.eEy;
      this._input.style.paddingLeft = `calc(${updatedPaddingLeft} + ${this._prependGroupWidth}px)`;
    }
    if (["invalidated", "validated", "_appendGroupWidth"].some((key) => changedProperties.has(key))) {
      if (this._inputIcon) {
        this._inputIcon.style.right = `${this._appendGroupWidth}px`;
        this._input.style.paddingRight = `calc(${styles_variables/* PharosSpacingOneAndAHalfX */.wGb} + ${this._appendGroupWidth}px)`;
      } else {
        this._input.style.paddingRight = `calc(${styles_variables/* PharosSpacingThreeQuartersX */.eEy} + ${this._appendGroupWidth}px)`;
      }
    }
  }
  get prependContent() {
    return lit/* html */.dy`
      <div class="input-group input-group--prepend">
        <slot name="prepend" @slotchange=${this._updatePrependPadding}></slot>
      </div>
    `;
  }
  get appendContent() {
    return lit/* html */.dy`
      <div class="input-group input-group--append">
        <slot @slotchange=${this._updateAppendPadding}></slot>
      </div>
    `;
  }
  async _updateAppendPadding() {
    await new Promise((resolve) => requestAnimationFrame(resolve));
    this._appendGroupWidth = this._appendGroup.getBoundingClientRect().width;
  }
  async _updatePrependPadding() {
    await new Promise((resolve) => requestAnimationFrame(resolve));
    this._prependGroupWidth = this._prependGroup.getBoundingClientRect().width;
  }
  _adjustPadding(event) {
    const amount = this.invalidated ? 0 : event.type === "focus" ? -1 : 1;
    this._input.style.paddingLeft = `${parseInt(window.getComputedStyle(this._input, null).getPropertyValue("padding-left"), 10) + amount}px`;
    this._input.style.paddingRight = `${parseInt(window.getComputedStyle(this._input, null).getPropertyValue("padding-right"), 10) + amount}px`;
  }
  render() {
    return lit/* html */.dy` ${super.render()} `;
  }
}
pharos_input_group_decorateClass([
  (0,decorators/* query */.IO)(".input-group--append")
], PharosInputGroup.prototype, "_appendGroup", 2);
pharos_input_group_decorateClass([
  (0,decorators/* query */.IO)(".input-group--prepend")
], PharosInputGroup.prototype, "_prependGroup", 2);
pharos_input_group_decorateClass([
  (0,decorators/* state */.SB)()
], PharosInputGroup.prototype, "_appendGroupWidth", 2);
pharos_input_group_decorateClass([
  (0,decorators/* state */.SB)()
], PharosInputGroup.prototype, "_prependGroupWidth", 2);

;// CONCATENATED MODULE: ./packages/pharos/src/components/input-group/pharos-input-group-select.css.ts

const inputGroupSelectStyles = lit/* css */.iv`
        #select-element{border-bottom-width:0;border-radius:0;border-top-width:0}.select__icon{right:var(--pharos-spacing-three-quarters-x)}
      `;

;// CONCATENATED MODULE: ./packages/pharos/src/components/select/pharos-select.css.ts

const selectStyles = lit/* css */.iv`
        :host{contain:paint;display:block;width:100%}#select-element{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:1px solid var(--pharos-form-element-color-border-base);border-radius:var(--pharos-radius-base-standard);box-sizing:border-box;color:var(--pharos-form-element-color-text-base);cursor:pointer;display:block;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-font-size-base);font-weight:var(--pharos-font-weight-regular);letter-spacing:calc(var(--pharos-font-size-base)*-.02);line-height:var(--pharos-line-height-medium);margin:0;padding:var(--pharos-spacing-one-half-x) var(--pharos-spacing-three-quarters-x);padding-right:2.5rem;text-rendering:optimizelegibility;transition:transform var(--pharos-transition-base) 0s;transition-duration:var(--pharos-transition-duration-default);transition-property:border-color,color;transition-timing-function:ease-in-out;width:100%}#select-element:required{box-shadow:none}#select-element:focus{border:2px solid var(--pharos-form-element-color-border-focus);outline:none;padding:calc(var(--pharos-spacing-one-half-x) - 1px) calc(var(--pharos-spacing-three-quarters-x) - 1px);padding-right:calc(2.5rem - 1px);transition:transform var(--pharos-transition-base) 0s}:host([disabled]) #select-element{background-color:var(--pharos-form-element-color-background-disabled);border-color:var(--pharos-form-element-color-border-disabled);color:var(--pharos-form-element-color-text-disabled);pointer-events:none}.select-wrapper{align-items:center;display:flex;position:relative;width:100%}.select__icon{fill:var(--pharos-color-black);pointer-events:none;position:absolute;right:var(--pharos-spacing-1-x);top:50%;transform:translateY(-50%);transition-duration:var(--pharos-transition-duration-default);transition-property:fill;transition-timing-function:ease-in-out}:host([disabled]) .select__icon{fill:var(--pharos-color-text-disabled)}:host([invalidated]) .select__icon{fill:var(--pharos-form-element-color-border-invalid)}:host(:not([disabled]):not([invalidated])) .select-wrapper:hover .select__icon{fill:var(--pharos-color-hover-primary)}:host([invalidated]) #select-element{border:2px solid var(--pharos-form-element-color-border-invalid);padding:calc(var(--pharos-spacing-one-half-x) - 1px) calc(var(--pharos-spacing-three-quarters-x) - 1px);padding-right:calc(2.5rem - 1px)}:host(:not([disabled]):not([invalidated])) .select-wrapper:hover #select-element{border:2px solid var(--pharos-color-hover-primary);color:var(--pharos-color-hover-primary);padding:calc(var(--pharos-spacing-one-half-x) - 1px) calc(var(--pharos-spacing-three-quarters-x) - 1px);padding-right:calc(2.5rem - 1px)}optgroup,option{color:var(--pharos-form-element-color-text-base)}
      `;

// EXTERNAL MODULE: ./node_modules/@open-wc/dedupe-mixin/src/dedupeMixin.js
var dedupeMixin = __webpack_require__("./node_modules/@open-wc/dedupe-mixin/src/dedupeMixin.js");
;// CONCATENATED MODULE: ./packages/pharos/src/utils/mixins/observe-children.ts

const ObserveChildrenMixinImplementation = (Base) => {
  class ObserveChildren extends Base {
    constructor() {
      super(...arguments);
      this._childrenObserver = null;
      this._handleMutation = () => {
        this.requestUpdate();
      };
    }
    connectedCallback() {
      var _a;
      super.connectedCallback && super.connectedCallback();
      this._childrenObserver = new MutationObserver(this._handleMutation);
      (_a = this._childrenObserver) == null ? void 0 : _a.observe(this, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }
    disconnectedCallback() {
      if (this._childrenObserver) {
        this._childrenObserver.disconnect();
        this._childrenObserver = null;
      }
      super.disconnectedCallback && super.disconnectedCallback();
    }
  }
  return ObserveChildren;
};
const ObserveChildrenMixin = (0,dedupeMixin/* dedupeMixin */.S)(ObserveChildrenMixinImplementation);
/* harmony default export */ const observe_children = (ObserveChildrenMixin);

;// CONCATENATED MODULE: ./packages/pharos/src/components/select/pharos-select.ts
var pharos_select_defProp = Object.defineProperty;
var pharos_select_getOwnPropDesc = Object.getOwnPropertyDescriptor;
var pharos_select_decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? pharos_select_getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    pharos_select_defProp(target, key, result);
  return result;
};










class PharosSelect extends (0,scoped_registry/* default */.Z)(
  observe_children((0,mixins_form/* default */.Z)(form_element/* FormElement */.W))
) {
  constructor() {
    super(...arguments);
    this.value = "";
  }
  get _options() {
    return [...this.children].filter(
      (child) => !child.slot && child instanceof HTMLOptionElement
    );
  }
  static get styles() {
    return [super.styles, selectStyles];
  }
  firstUpdated() {
    if (this.value && this._options.find((o) => o.value === this.value)) {
      this._select.value = this.value;
    } else {
      this._setOption();
    }
    this._options.forEach((option) => option.defaultSelected = option.hasAttribute("selected"));
  }
  _setOption() {
    const selected = this.querySelector("option[selected]") || this.querySelector("option:not([disabled])");
    this.value = selected == null ? void 0 : selected.value;
  }
  onChange() {
    this.value = this._select.value;
    this.dispatchEvent(
      new Event("change", {
        bubbles: true,
        composed: true
      })
    );
  }
  _handleFormdata(event) {
    const { formData } = event;
    if (!this.disabled) {
      formData.append(this.name, this.value);
    }
  }
  _handleFormReset() {
    this._options.forEach((option) => option.selected = option.defaultSelected);
    this._setOption();
  }
  render() {
    return lit/* html */.dy`
      <label for="select-element">
        <slot name="label"></slot>
        ${this.requiredIndicator}
      </label>
      <div class="select-wrapper">
        <select
          id="select-element"
          name=${this.name}
          .value=${this.value}
          ?required="${this.required}"
          ?disabled=${this.disabled}
          aria-required="${this.required}"
          aria-invalid="${this.invalidated}"
          aria-describedby="${(0,if_defined/* ifDefined */.o)(this.messageId)}"
          @change=${this.onChange}
        >
          ${[...this.children].filter((child) => !child.slot).map((child) => {
      return lit/* html */.dy`${(0,unsafe_html/* unsafeHTML */.A)(child.outerHTML)}`;
    })}
        </select>
        <pharos-icon class="select__icon" name="chevron-down"></pharos-icon>
      </div>
      ${this.messageContent}
    `;
  }
}
PharosSelect.elementDefinitions = {
  "pharos-icon": pharos_icon/* PharosIcon */.b
};
pharos_select_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosSelect.prototype, "value", 2);
pharos_select_decorateClass([
  (0,decorators/* query */.IO)("#select-element")
], PharosSelect.prototype, "_select", 2);

;// CONCATENATED MODULE: ./packages/pharos/src/components/input-group/pharos-input-group-select.ts



class PharosInputGroupSelect extends PharosSelect {
  static get styles() {
    return [super.styles, inputGroupSelectStyles];
  }
  render() {
    return lit/* html */.dy` ${super.render()} `;
  }
}

;// CONCATENATED MODULE: ./packages/pharos/src/components/layout/pharos-layout.css.ts

const layoutStyles = lit/* css */.iv`
        :host{contain:layout;display:grid;grid-template-areas:". content ."}.layout{-moz-column-gap:var(--pharos-spacing-gutter);column-gap:var(--pharos-spacing-gutter);display:grid;grid-area:content;grid-template-columns:repeat(12,1fr);grid-template-rows:auto;list-style:none;margin:0;padding:0}@media screen and (max-width:48rem){.layout{grid-template-columns:repeat(8,1fr);grid-template-rows:auto}}@media screen and (max-width:22.5rem){.layout{grid-template-columns:repeat(4,1fr);grid-template-rows:auto}}@media screen and (min-width:360px) and (max-width:767px){:host([preset="1-col"]){grid-template-columns:minmax(1.25rem,1.5rem) auto minmax(1.25rem,1.5rem);grid-template-rows:auto}}@media screen and (min-width:768px) and (max-width:1055px){:host([preset="1-col"]){grid-template-columns:minmax(1.5rem,4.5rem) auto minmax(1.5rem,4.5rem);grid-template-rows:auto}}@media screen and (min-width:1056px) and (max-width:1359px){:host([preset="1-col"]){grid-template-columns:minmax(4.5rem,8rem) auto minmax(4.5rem,8rem);grid-template-rows:auto}}@media screen and (min-width:1360px) and (max-width:1583px){:host([preset="1-col"]){grid-template-columns:minmax(8rem,9rem) auto minmax(8rem,9rem);grid-template-rows:auto}}@media screen and (min-width:99rem){:host([preset="1-col"]){grid-template-columns:minmax(9rem,1fr) auto minmax(9rem,1fr);grid-template-rows:auto}}@media screen and (min-width:48rem){:host([preset="1-col"]) .layout{margin:auto}}@media screen and (max-width:22.5rem){:host([preset="1-col"]) .layout{width:20rem}}@media screen and (min-width:768px) and (max-width:1055px){:host([preset="1-col"]) .layout{width:45rem}}@media screen and (min-width:1056px) and (max-width:1359px){:host([preset="1-col"]) .layout{width:57rem}}@media screen and (min-width:1360px) and (max-width:1583px){:host([preset="1-col"]) .layout{width:69rem}}@media screen and (min-width:99rem){:host([preset="1-col"]) .layout{width:81rem}}@media screen and (min-width:360px) and (max-width:767px){:host([preset="1-col--sidenav"]){grid-template-columns:1.5rem auto 1.5rem;grid-template-rows:auto}}@media screen and (min-width:768px) and (max-width:1055px){:host([preset="1-col--sidenav"]){grid-template-columns:3rem auto 3rem;grid-template-rows:auto}}@media screen and (min-width:1056px) and (max-width:1359px){:host([preset="1-col--sidenav"]){grid-template-columns:3rem auto 3rem;grid-template-rows:auto}}@media screen and (min-width:1360px) and (max-width:1583px){:host([preset="1-col--sidenav"]){grid-template-columns:3rem auto 3rem;grid-template-rows:auto}}@media screen and (min-width:99rem){:host([preset="1-col--sidenav"]){grid-template-columns:minmax(3rem,1fr) auto minmax(3rem,1fr);grid-template-rows:auto}}@media screen and (max-width:22.5rem){:host([preset="1-col--sidenav"]) .layout{min-width:19.5rem}}@media screen and (min-width:768px) and (max-width:1055px){:host([preset="1-col--sidenav"]) .layout{min-width:42rem}}@media screen and (min-width:1056px) and (max-width:1359px){:host([preset="1-col--sidenav"]) .layout{min-width:43rem}}@media screen and (min-width:1360px) and (max-width:1583px){:host([preset="1-col--sidenav"]) .layout{min-width:62rem}}@media screen and (min-width:99rem){:host([preset="1-col--sidenav"]) .layout{min-width:76rem}}@media screen and (min-width:360px) and (max-width:767px){:host([preset="1-col--sidenav-comfy"]){grid-template-columns:1.25rem auto 1.25rem;grid-template-rows:auto}}@media screen and (min-width:768px) and (max-width:1055px){:host([preset="1-col--sidenav-comfy"]){grid-template-columns:1.5rem auto 1.5rem;grid-template-rows:auto}}@media screen and (min-width:1056px) and (max-width:1359px){:host([preset="1-col--sidenav-comfy"]){grid-template-columns:3.75rem auto 3.75rem;grid-template-rows:auto}}@media screen and (min-width:1360px) and (max-width:1583px){:host([preset="1-col--sidenav-comfy"]){grid-template-columns:5.25rem auto 5.25rem;grid-template-rows:auto}}@media screen and (min-width:99rem){:host([preset="1-col--sidenav-comfy"]){grid-template-columns:minmax(7.75rem,1fr) auto minmax(7.75rem,1fr);grid-template-rows:auto}}@media screen and (max-width:22.5rem){:host([preset="1-col--sidenav-comfy"]) .layout{min-width:20rem}}@media screen and (min-width:768px) and (max-width:1055px){:host([preset="1-col--sidenav-comfy"]) .layout{min-width:45rem}}@media screen and (min-width:1056px) and (max-width:1359px){:host([preset="1-col--sidenav-comfy"]) .layout{min-width:41.5rem}}@media screen and (min-width:1360px) and (max-width:1583px){:host([preset="1-col--sidenav-comfy"]) .layout{min-width:57.5rem}}@media screen and (min-width:99rem){:host([preset="1-col--sidenav-comfy"]) .layout{min-width:66.5rem}}@media screen and (min-width:360px) and (max-width:767px){:host([preset="2-col"]){grid-template-columns:1.5rem auto 1.5rem;grid-template-rows:auto}}@media screen and (min-width:768px) and (max-width:1055px){:host([preset="2-col"]){grid-template-columns:3rem auto 3rem;grid-template-rows:auto}}@media screen and (min-width:1056px) and (max-width:1359px){:host([preset="2-col"]){grid-template-columns:3rem auto 3rem;grid-template-rows:auto}}@media screen and (min-width:1360px) and (max-width:1583px){:host([preset="2-col"]){grid-template-columns:3rem auto 3rem;grid-template-rows:auto}}@media screen and (min-width:99rem){:host([preset="2-col"]){grid-template-columns:minmax(3rem,1fr) auto minmax(3rem,1fr);grid-template-rows:auto}}@media screen and (max-width:22.5rem){:host([preset="2-col"]) .layout{min-width:19.5rem}}@media screen and (min-width:768px) and (max-width:1055px){:host([preset="2-col"]) .layout{min-width:42rem}}@media screen and (min-width:1056px) and (max-width:1359px){:host([preset="2-col"]) .layout{min-width:60rem}}@media screen and (min-width:1360px) and (max-width:1583px){:host([preset="2-col"]) .layout{min-width:79rem}}@media screen and (min-width:99rem){:host([preset="2-col"]) .layout{min-width:93rem}}
      `;

;// CONCATENATED MODULE: ./packages/pharos/src/components/layout/pharos-layout.ts
var pharos_layout_defProp = Object.defineProperty;
var pharos_layout_getOwnPropDesc = Object.getOwnPropertyDescriptor;
var pharos_layout_decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? pharos_layout_getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    pharos_layout_defProp(target, key, result);
  return result;
};






const PRESETS = ["1-col", "1-col--sidenav", "1-col--sidenav-comfy", "2-col"];
class PharosLayout extends pharos_element/* PharosElement */.Z {
  constructor() {
    super(...arguments);
    this.preset = "1-col";
    this.areas = "";
    this.rows = "";
    this.rowGap = styles_variables/* PharosSpacingThreeAndAHalfX */.rrP;
    this.tag = "div";
  }
  static get styles() {
    return [layoutStyles];
  }
  update(changedProperties) {
    super.update && super.update(changedProperties);
    if (changedProperties.has("preset") && !PRESETS.includes(this.preset)) {
      throw new Error(
        `${this.preset} is not a valid preset.
        Available presets are ${PRESETS.join(", ")}.`
      );
    }
  }
  updated(changedProperties) {
    if (changedProperties.has("areas")) {
      this._layout.style.gridTemplateAreas = this.areas;
    }
    if (changedProperties.has("rows")) {
      this._layout.style.gridTemplateRows = this.rows;
    }
    if (changedProperties.has("rowGap")) {
      this._layout.style.rowGap = this.rowGap;
    }
  }
  render() {
    const template = `<slot name="top"></slot><${this.tag} id="layout-container" class="layout"><slot></slot></${this.tag}>`;
    return lit/* html */.dy`${(0,unsafe_html/* unsafeHTML */.A)(template)}`;
  }
}
pharos_layout_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosLayout.prototype, "preset", 2);
pharos_layout_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosLayout.prototype, "areas", 2);
pharos_layout_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosLayout.prototype, "rows", 2);
pharos_layout_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true, attribute: "row-gap" })
], PharosLayout.prototype, "rowGap", 2);
pharos_layout_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosLayout.prototype, "tag", 2);
pharos_layout_decorateClass([
  (0,decorators/* query */.IO)(".layout")
], PharosLayout.prototype, "_layout", 2);

;// CONCATENATED MODULE: ./packages/pharos/src/components/loading-spinner/pharos-loading-spinner.css.ts

const loadingSpinnerStyles = lit/* css */.iv`
        :host{bottom:0;contain:layout;display:block;left:0;position:absolute;right:0;top:0;z-index:1000}.loading-spinner__wrapper{align-items:center;background-color:hsla(0,0%,100%,.8);display:flex;height:100%;width:100%}.loading-spinner__icon{margin:0 auto;opacity:1}.loading-spinner__animation{stroke-linecap:square}
      `;

;// CONCATENATED MODULE: ./packages/pharos/src/components/loading-spinner/pharos-loading-spinner.ts
var pharos_loading_spinner_defProp = Object.defineProperty;
var pharos_loading_spinner_getOwnPropDesc = Object.getOwnPropertyDescriptor;
var pharos_loading_spinner_decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? pharos_loading_spinner_getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    pharos_loading_spinner_defProp(target, key, result);
  return result;
};





class PharosLoadingSpinner extends pharos_element/* PharosElement */.Z {
  static get styles() {
    return [loadingSpinnerStyles];
  }
  firstUpdated() {
    this._setupAnimation();
  }
  _setupAnimation() {
    const dashKeys = [
      { strokeDasharray: "1px, 200px", strokeDashoffset: "0px" },
      { strokeDasharray: "89px, 200px", strokeDashoffset: "-35px" },
      { strokeDasharray: "89px, 200px", strokeDashoffset: "-124px" }
    ];
    const dashTiming = {
      easing: "ease-in-out",
      duration: 1500,
      iterations: Infinity
    };
    const colorKeys = [
      { stroke: styles_variables/* PharosLoadingSpinnerColorStrokePrimary */.$m_, offset: 0 },
      { stroke: styles_variables/* PharosLoadingSpinnerColorStrokeSecondary */.Crc, offset: 0.4 },
      { stroke: styles_variables/* PharosLoadingSpinnerColorStrokePrimary */.$m_, offset: 0.66 },
      { stroke: styles_variables/* PharosLoadingSpinnerColorStrokeSecondary */.Crc, offset: 0.8 },
      { stroke: styles_variables/* PharosLoadingSpinnerColorStrokeSecondary */.Crc, offset: 0.9 },
      { stroke: styles_variables/* PharosLoadingSpinnerColorStrokePrimary */.$m_, offset: 1 }
    ];
    const colorTiming = {
      easing: "ease-in-out",
      duration: 6e3,
      iterations: Infinity
    };
    const rotateKeys = [{ transform: "rotate(0deg)" }, { transform: "rotate(360deg)" }];
    const rotateTiming = {
      easing: "linear",
      duration: 2e3,
      iterations: Infinity
    };
    this._spinner.animate(dashKeys, dashTiming);
    this._spinner.animate(colorKeys, colorTiming);
    this._icon.animate(rotateKeys, rotateTiming);
  }
  render() {
    return lit/* html */.dy`
      <div
        class="loading-spinner__wrapper"
        role="alert"
        aria-live="assertive"
        aria-label="Content is loading..."
        tabindex="0"
      >
        <svg
          class="loading-spinner__icon"
          viewBox="25 25 50 50"
          height="56"
          width="56"
          focusable="false"
        >
          <circle
            class="loading-spinner__animation"
            cx="50"
            cy="50"
            r="20"
            fill="none"
            stroke-width="3"
            stroke-miterlimit="10"
          />
        </svg>
      </div>
    `;
  }
}
pharos_loading_spinner_decorateClass([
  (0,decorators/* query */.IO)(".loading-spinner__icon")
], PharosLoadingSpinner.prototype, "_icon", 2);
pharos_loading_spinner_decorateClass([
  (0,decorators/* query */.IO)(".loading-spinner__animation")
], PharosLoadingSpinner.prototype, "_spinner", 2);

// EXTERNAL MODULE: ./packages/pharos/src/components/modal/pharos-modal.ts + 1 modules
var modal_pharos_modal = __webpack_require__("./packages/pharos/src/components/modal/pharos-modal.ts");
;// CONCATENATED MODULE: ./packages/pharos/src/components/pagination/pharos-pagination.css.ts

const paginationStyles = lit/* css */.iv`
        :host{contain:layout;display:inline-flex}.pagination__wrapper{display:inline-flex;width:100%}.pagination__info{padding:0 var(--pharos-spacing-1-x)}.pagination__link{cursor:pointer}.pagination__link pharos-icon{transition-duration:.2s;transition-property:background-color;transition-timing-function:ease-in-out}.pagination__link pharos-icon[name=chevron-left]{margin-right:var(--pharos-spacing-one-half-x)}.pagination__link pharos-icon[name=chevron-right]{margin-left:var(--pharos-spacing-one-half-x)}.pagination__link:hover pharos-icon{stroke:var(--pharos-color-interactive-primary);fill:var(--pharos-color-interactive-primary);stroke-width:0}
      `;

;// CONCATENATED MODULE: ./packages/pharos/src/components/pagination/pharos-pagination.ts
var pharos_pagination_defProp = Object.defineProperty;
var pharos_pagination_getOwnPropDesc = Object.getOwnPropertyDescriptor;
var pharos_pagination_decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? pharos_pagination_getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    pharos_pagination_defProp(target, key, result);
  return result;
};







class PharosPagination extends (0,scoped_registry/* default */.Z)(pharos_element/* PharosElement */.Z) {
  constructor() {
    super(...arguments);
    this.totalResults = 0;
    this.pageSize = 25;
    this.currentPage = 1;
  }
  static get styles() {
    return [paginationStyles];
  }
  get totalPages() {
    return Math.ceil(this.totalResults / this.pageSize);
  }
  update(changedProperties) {
    super.update && super.update(changedProperties);
    if (changedProperties.has("totalResults") && (!Number.isInteger(this.totalResults) || this.totalResults < 0)) {
      throw new Error(
        `totalResults value '${this.totalResults}' is invalid. Can only be a number greater than or equal to 0`
      );
    }
    if (changedProperties.has("pageSize") && (!Number.isInteger(this.pageSize) || this.pageSize < 1)) {
      throw new Error(
        `pageSize value '${this.pageSize}' is invalid. Can only be a number greater than or equal to 1`
      );
    }
    if (changedProperties.has("currentPage") && (!Number.isInteger(this.currentPage) || this.currentPage < 1)) {
      throw new Error(
        `currentPage value '${this.currentPage}' is invalid. Can only be a number greater than or equal to 1`
      );
    }
  }
  _handleClick(event) {
    event.preventDefault();
    event.stopPropagation();
    const targetElement = event.currentTarget;
    let eventType;
    if (targetElement.classList.contains("prev")) {
      eventType = "prev-page";
    } else if (targetElement.classList.contains("next")) {
      eventType = "next-page";
    } else {
      throw new Error(
        `Unexpected click target during pagination handling: ${targetElement.tagName}`
      );
    }
    this.dispatchEvent(
      new Event(eventType, {
        bubbles: true,
        composed: true
      })
    );
  }
  _renderPrevLink() {
    if (this.currentPage > 1) {
      return lit/* html */.dy`
        <pharos-link
          class="pagination__link prev"
          bold
          subtle
          flex
          href=""
          @click="${this._handleClick}"
        >
          <pharos-icon name="chevron-left"></pharos-icon>
          Previous
        </pharos-link>
      `;
    }
    return lit/* nothing */.Ld;
  }
  _renderNextLink() {
    if (this.currentPage < this.totalPages) {
      return lit/* html */.dy`
        <pharos-link
          class="pagination__link next"
          bold
          subtle
          flex
          href=""
          @click="${this._handleClick}"
        >
          Next
          <pharos-icon name="chevron-right"></pharos-icon>
        </pharos-link>
      `;
    }
    return lit/* nothing */.Ld;
  }
  render() {
    return lit/* html */.dy`
      <div class="pagination__wrapper" role="navigation" aria-label="pagination">
        ${this._renderPrevLink()}
        <span class="pagination__info">${this.currentPage} of ${this.totalPages}</span>
        ${this._renderNextLink()}
      </div>
    `;
  }
}
PharosPagination.elementDefinitions = {
  "pharos-icon": pharos_icon/* PharosIcon */.b,
  "pharos-link": pharos_link/* PharosLink */.G
};
pharos_pagination_decorateClass([
  (0,decorators/* property */.Cb)({ type: Number, reflect: true, attribute: "total-results" })
], PharosPagination.prototype, "totalResults", 2);
pharos_pagination_decorateClass([
  (0,decorators/* property */.Cb)({ type: Number, reflect: true, attribute: "page-size" })
], PharosPagination.prototype, "pageSize", 2);
pharos_pagination_decorateClass([
  (0,decorators/* property */.Cb)({ type: Number, reflect: true, attribute: "current-page" })
], PharosPagination.prototype, "currentPage", 2);

;// CONCATENATED MODULE: ./packages/pharos/src/components/progress-bar/pharos-progress-bar.css.ts

const progressBarStyles = lit/* css */.iv`
        :host{contain:content;display:block}.progress-bar__wrapper{background-color:var(--pharos-color-ui-20);margin:var(--pharos-spacing-one-half-x) 0;width:100%}.progress-bar,.progress-bar__wrapper{border-radius:var(--pharos-radius-base-standard);height:.75rem}.progress-bar{transition:width .6s ease}.progress-bar__title{font-size:var(--pharos-type-scale-4);font-weight:var(--pharos-font-weight-bold);letter-spacing:calc(var(--pharos-type-scale-4)*-.02)}.progress-bar__description,.progress-bar__title{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:var(--pharos-font-family-sans-serif);line-height:var(--pharos-line-height-medium);text-rendering:optimizelegibility}.progress-bar__description{color:var(--pharos-color-text-40);font-size:var(--pharos-font-size-base);font-weight:var(--pharos-font-weight-regular);letter-spacing:calc(var(--pharos-font-size-base)*-.02)}
      `;

;// CONCATENATED MODULE: ./packages/pharos/src/components/progress-bar/pharos-progress-bar.ts
var pharos_progress_bar_defProp = Object.defineProperty;
var pharos_progress_bar_getOwnPropDesc = Object.getOwnPropertyDescriptor;
var pharos_progress_bar_decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? pharos_progress_bar_getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    pharos_progress_bar_defProp(target, key, result);
  return result;
};






class PharosProgressBar extends pharos_element/* PharosElement */.Z {
  constructor() {
    super(...arguments);
    this.value = 0;
  }
  static get styles() {
    return [progressBarStyles];
  }
  render() {
    return lit/* html */.dy`
      <div id="title" class="progress-bar__title"><slot name="title"></slot></div>
      <div
        role="progressbar"
        aria-valuemin="0"
        aria-valuemax="100"
        aria-valuenow=${this.value}
        aria-labelledby="title"
        class="progress-bar__wrapper"
      >
        <div
          class="progress-bar"
          style=${(0,style_map/* styleMap */.V)({
      background: `linear-gradient(
              to right,
              ${styles_variables/* PharosColorGlacierBlueBase */.gyN} ${this.value < 35 ? "100%" : 135 - this.value + "%"},
              ${styles_variables/* PharosColorNightBlueBase */.I8l}
            )`,
      width: `${this.value}%`
    })}
        ></div>
      </div>
      <div class="progress-bar__description">
        <slot name="description"></slot>
      </div>
    `;
  }
}
pharos_progress_bar_decorateClass([
  (0,decorators/* property */.Cb)({ type: Number, reflect: true })
], PharosProgressBar.prototype, "value", 2);

;// CONCATENATED MODULE: ./packages/pharos/src/components/radio-button/pharos-radio-button.css.ts

const radioButtonStyles = lit/* css */.iv`
        :host{contain:layout;display:inline-flex;flex-direction:column}.input-wrapper{align-items:flex-start;display:inline-flex;position:relative}.input__icon{border-radius:50%;cursor:pointer;display:block;overflow:visible}.input__icon .outer{stroke:var(--pharos-form-element-color-border-base);fill:var(--pharos-radio-button-color-background-base)}.input__icon .focus,.input__icon .hover,.input__icon .inner{stroke:none;fill:none}:host([invalidated]) .input__icon .outer{stroke:var(--pharos-form-element-color-border-invalid)}:host([disabled]) .input__icon{pointer-events:none}:host([disabled]) .input__icon .outer{fill:var(--pharos-form-element-color-background-disabled)}:host([checked]:not([disabled])) .input__icon .outer{stroke:var(--pharos-color-interactive-secondary)}:host([checked][disabled]) .input__icon .inner{fill:var(--pharos-color-text-disabled)}:host([checked][invalidated]) .input__icon .inner{fill:var(--pharos-form-element-color-border-invalid)}:host([checked]:not([invalidated]):not([disabled])) .input__icon .inner{fill:var(--pharos-color-interactive-secondary)}#radio-element{clip:rect(0 0 0 0);border:0;box-sizing:border-box;-webkit-clip-path:inset(50%);clip-path:inset(50%);display:block;height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}#radio-element:focus+.input-wrapper .input__icon .focus,#radio-element:focus+.input-wrapper .input__icon .outer{stroke:var(--pharos-form-element-color-border-focus)}:host(:not([checked]):not([disabled])) #radio-element:not(:focus)+.input-wrapper:hover .input__icon .hover,:host(:not([checked]):not([disabled])) #radio-element:not(:focus)+.input-wrapper:hover .input__icon .outer{stroke:var(--pharos-color-hover-primary)}
      `;

;// CONCATENATED MODULE: ./packages/pharos/src/components/radio-button/pharos-radio-button.ts
var pharos_radio_button_defProp = Object.defineProperty;
var pharos_radio_button_getOwnPropDesc = Object.getOwnPropertyDescriptor;
var pharos_radio_button_decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? pharos_radio_button_getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    pharos_radio_button_defProp(target, key, result);
  return result;
};





const pharos_radio_button_LINKS = `a[href],pharos-link[href],[data-pharos-component='PharosLink'][href]`;
class PharosRadioButton extends (0,mixins_form/* default */.Z)(form_element/* FormElement */.W) {
  constructor() {
    super(...arguments);
    this.checked = false;
    this.value = "";
  }
  static get styles() {
    return [super.styles, radioButtonStyles];
  }
  firstUpdated() {
    this._radio.defaultChecked = this.checked;
  }
  onChange() {
    this.checked = this._radio.checked;
    this.dispatchEvent(
      new Event("change", {
        bubbles: true,
        composed: true
      })
    );
  }
  _handleFormdata(event) {
    const { formData } = event;
    if (!this.disabled && this.checked) {
      formData.append(this.name, this.value);
    }
  }
  _handleFormReset() {
    this.checked = this._radio.defaultChecked;
  }
  _handleClick(event) {
    if (!event.target.matches(pharos_radio_button_LINKS)) {
      event.preventDefault();
      event.stopPropagation();
      this._radio.click();
      this._radio.focus();
    }
  }
  render() {
    return lit/* html */.dy`
      <input
        id="radio-element"
        name=${this.name}
        type="radio"
        .value=${this.value}
        .checked=${this.checked}
        ?required="${this.required}"
        ?disabled=${this.disabled}
        @change=${this.onChange}
      />
      <div class="input-wrapper">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          viewBox="0 0 24 24"
          width="24"
          height="24"
          class="input__icon"
          role="img"
          aria-label="radio button"
          focusable="false"
          @click="${this._handleClick}"
        >
          <circle cx="50%" cy="50%" r="9" class="focus" />
          <circle cx="50%" cy="50%" r="8" class="outer" />
          <circle cx="50%" cy="50%" r="7" class="hover" />
          <circle cx="50%" cy="50%" r="5" class="inner" />
        </svg>
        <label for="radio-element" @click="${this._handleClick}">
          <slot name="label"></slot>
          ${this.requiredIndicator}
        </label>
      </div>
      ${this.messageContent}
    `;
  }
}
pharos_radio_button_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], PharosRadioButton.prototype, "checked", 2);
pharos_radio_button_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosRadioButton.prototype, "value", 2);
pharos_radio_button_decorateClass([
  (0,decorators/* query */.IO)("#radio-element")
], PharosRadioButton.prototype, "_radio", 2);

;// CONCATENATED MODULE: ./packages/pharos/src/components/radio-group/pharos-radio-group.css.ts

const radioGroupStyles = lit/* css */.iv`
        :host{contain:layout;display:flex}.radio-group{border:0;padding:0}.radio-group__radios{display:flex}.radio-group--vertical .radio-group__radios{flex-direction:column}.radio-group--horizontal .radio-group__radios{flex-direction:row}::slotted([data-pharos-component=PharosRadioButton]){align-self:flex-start}.radio-group--vertical ::slotted([data-pharos-component=PharosRadioButton]:not(:last-child)){margin-bottom:var(--pharos-radio-group-spacing-vertical)}.radio-group--horizontal ::slotted([data-pharos-component=PharosRadioButton]:not(:last-child)){margin-right:var(--pharos-radio-group-spacing-horizontal)}
      `;

;// CONCATENATED MODULE: ./packages/pharos/src/components/radio-group/pharos-radio-group.ts
var pharos_radio_group_defProp = Object.defineProperty;
var pharos_radio_group_getOwnPropDesc = Object.getOwnPropertyDescriptor;
var pharos_radio_group_decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? pharos_radio_group_getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    pharos_radio_group_defProp(target, key, result);
  return result;
};





const _allRadioButtonsSelector = '[data-pharos-component="PharosRadioButton"]';
class PharosRadioGroup extends form_element/* FormElement */.W {
  constructor() {
    super(...arguments);
    this.horizontal = false;
    this._clicked = false;
  }
  get value() {
    var _a;
    return (_a = [...this.children].find(
      (child) => !child.slot && child.checked
    )) == null ? void 0 : _a.value;
  }
  static get styles() {
    return [super.styles, radioGroupStyles];
  }
  firstUpdated() {
    this._setRadios();
    this._addFocusListeners();
    this._radioButtons.forEach((radio) => {
      radio.addEventListener("change", (event) => {
        event.stopPropagation();
        const target = event.target;
        target.focus();
        this._updateSelection(target.value);
        this._clicked = false;
        this.dispatchEvent(
          new Event("change", {
            bubbles: true,
            composed: true
          })
        );
      });
    });
    this.addEventListener("keydown", this._handleKeydown);
  }
  update(changedProperties) {
    super.update && super.update(changedProperties);
    if (changedProperties.has("name") || changedProperties.has("disabled") || changedProperties.has("invalidated") || changedProperties.has("validated")) {
      this._setRadios();
    }
  }
  _handleKeydown(event) {
    switch (event.key) {
      case "Down":
      case "Right":
      case "ArrowDown":
      case "ArrowRight":
        event.preventDefault();
        this._handleArrowKeys(true);
        break;
      case "Up":
      case "Left":
      case "ArrowUp":
      case "ArrowLeft":
        event.preventDefault();
        this._handleArrowKeys(false);
        break;
    }
  }
  _handleArrowKeys(moveForward) {
    const radios = Array.prototype.slice.call(
      this.querySelectorAll(`${_allRadioButtonsSelector}:not([disabled])`)
    );
    const values = radios.map((radio) => radio.value);
    const focusedRadio = document.activeElement;
    const nextRadioIndex = loopWrapIndex(values, (v) => v === focusedRadio.value, moveForward);
    const checkedRadio = radios[nextRadioIndex];
    checkedRadio["_radio"].click();
    checkedRadio["_radio"].focus();
  }
  _updateSelection(value) {
    const previouslyChecked = this.querySelector(
      `${_allRadioButtonsSelector}[checked]:not([value="${value}"])`
    );
    if (previouslyChecked) {
      previouslyChecked.checked = false;
    }
  }
  _setRadios() {
    this._radioButtons.forEach((radio) => {
      radio.name = this.name;
      radio.disabled = this.disabled;
      radio.validated = this.validated;
      radio.invalidated = this.invalidated;
    });
  }
  _addFocusListeners() {
    this._radioButtons.forEach((radio) => {
      radio.addEventListener("mousedown", () => {
        this._clicked = true;
      });
      radio.addEventListener("focusin", (event) => {
        var _a, _b;
        const checkedRadio = this.querySelector(
          `${_allRadioButtonsSelector}[checked]`
        );
        const withinGroup = ((_a = event.relatedTarget) == null ? void 0 : _a.tagName) === ((_b = event.target) == null ? void 0 : _b.tagName);
        if (!this._clicked && !withinGroup && !radio.checked && checkedRadio) {
          event.preventDefault();
          if (checkedRadio !== document.activeElement) {
            checkedRadio["_radio"].focus();
          }
        }
      });
    });
  }
  render() {
    const labels = ["legend"];
    if (this.messageId) {
      labels.push(this.messageId);
    }
    return lit/* html */.dy`
      <fieldset
        class="radio-group radio-group--${this.horizontal ? "horizontal" : "vertical"}"
        aria-required="${this.required}"
        aria-invalid="${this.invalidated}"
        aria-labelledby="${labels.join(" ")}"
        role="radiogroup"
      >
        <legend id="legend" class="radio-group__legend">
          <slot name="legend"></slot>
          ${this.requiredIndicator}
        </legend>
        <div class="radio-group__radios">
          <slot></slot>
        </div>
        ${this.messageContent}
      </fieldset>
    `;
  }
}
pharos_radio_group_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], PharosRadioGroup.prototype, "horizontal", 2);
pharos_radio_group_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, attribute: false })
], PharosRadioGroup.prototype, "value", 1);
pharos_radio_group_decorateClass([
  (0,decorators/* queryAssignedElements */.NH)({ selector: _allRadioButtonsSelector })
], PharosRadioGroup.prototype, "_radioButtons", 2);

;// CONCATENATED MODULE: ./packages/pharos/src/components/sidenav/pharos-sidenav.css.ts

const sidenavStyles = lit/* css */.iv`
        :host{position:relative;z-index:9000}#nav-element{background-color:var(--pharos-color-black);color:var(--pharos-color-text-white);height:100vh;left:0;overflow:scroll;position:fixed;top:0;transition:visibility 0s linear 0s,left var(--pharos-transition-duration-long) ease-in-out;visibility:visible}.side-element__container{grid-template-areas:". content ." "section section section";grid-template-rows:auto auto 1fr}.side-element__content{display:grid;grid-template-columns:auto;grid-template-rows:auto;row-gap:var(--pharos-spacing-2-x)}.sidenav__sections{grid-area:section}.side-element__button{left:var(--pharos-spacing-one-quarter-x);opacity:0;position:absolute;top:var(--pharos-spacing-one-quarter-x);visibility:hidden}@media screen and (max-width:1055px){:host{width:auto}#nav-element{left:-17rem;transition:visibility var(--pharos-transition-duration-long) linear var(--pharos-transition-duration-long),left var(--pharos-transition-duration-long) ease-in-out;visibility:hidden}.side-element__button{opacity:1;transition:visibility 0s var(--pharos-transition-duration-short),opacity var(--pharos-transition-duration-long) linear var(--pharos-transition-duration-short);visibility:visible}}:host([slide]) #nav-element{left:0;transition:visibility 0s linear 0s,left var(--pharos-transition-duration-long) ease-in-out;visibility:visible}
      `;

;// CONCATENATED MODULE: ./packages/pharos/src/components/base/side-element.css.ts

const sideElementStyles = lit/* css */.iv`
        :host{display:block;width:17rem}.side-element__container{display:grid;grid-template:". content ." auto/var(--pharos-spacing-2-x) 1fr var(--pharos-spacing-2-x);width:17rem}.side-element__content{grid-area:content;margin-top:var(--pharos-spacing-3-x)}
      `;

;// CONCATENATED MODULE: ./packages/pharos/src/components/base/side-element.ts


class SideElement extends pharos_element/* PharosElement */.Z {
  static get styles() {
    return [sideElementStyles];
  }
}

;// CONCATENATED MODULE: ./packages/pharos/src/components/sidenav/pharos-sidenav.ts
var pharos_sidenav_defProp = Object.defineProperty;
var pharos_sidenav_getOwnPropDesc = Object.getOwnPropertyDescriptor;
var pharos_sidenav_decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? pharos_sidenav_getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    pharos_sidenav_defProp(target, key, result);
  return result;
};








class PharosSidenav extends (0,scoped_registry/* default */.Z)((0,mixins_focus/* default */.Z)(SideElement)) {
  constructor() {
    super();
    this.slide = false;
    this._mediaQuery = window.matchMedia(`(max-width: 1055px)`);
    this._handleMediaChange = this._handleMediaChange.bind(this);
  }
  connectedCallback() {
    super.connectedCallback && super.connectedCallback();
    this._mediaQuery.addEventListener("change", this._handleMediaChange);
  }
  disconnectedCallback() {
    this._mediaQuery.removeEventListener("change", this._handleMediaChange);
    super.disconnectedCallback && super.disconnectedCallback();
  }
  static get styles() {
    return [super.styles, sidenavStyles];
  }
  _handleClickClose(event) {
    event.preventDefault();
    event.stopPropagation();
    this.slide = false;
    const button = document.querySelector(
      '[data-pharos-component="PharosSidenavButton"]'
    );
    button == null ? void 0 : button.focus();
    const details = {
      bubbles: true,
      composed: true,
      detail: this
    };
    this.dispatchEvent(new CustomEvent("pharos-sidenav-close", details));
  }
  _handleMediaChange(e) {
    if (!e.matches) {
      this.slide = false;
    }
  }
  _renderSkipToMain() {
    return this.mainContentId ? lit/* html */.dy`<pharos-link id="sidenav-skip-link" on-background skip href="#${this.mainContentId}">
          Skip to main content</pharos-link
        > ` : lit/* nothing */.Ld;
  }
  render() {
    return lit/* html */.dy`
      <nav id="nav-element" class="side-element__container">
        <div class="side-element__content">
          <pharos-button
            class="side-element__button"
            icon="close"
            variant="subtle"
            label="Close menu"
            on-background
            icon-condensed
            @click=${this._handleClickClose}
          ></pharos-button>
          ${this._renderSkipToMain()}
          <slot name="top"></slot>
        </div>
        <div class="sidenav__sections">
          <slot></slot>
        </div>
      </nav>
    `;
  }
}
PharosSidenav.elementDefinitions = {
  "pharos-button": pharos_button/* PharosButton */.b,
  "pharos-link": pharos_link/* PharosLink */.G
};
pharos_sidenav_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], PharosSidenav.prototype, "slide", 2);
pharos_sidenav_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true, attribute: "main-content-id" })
], PharosSidenav.prototype, "mainContentId", 2);

;// CONCATENATED MODULE: ./packages/pharos/src/components/sidenav/pharos-sidenav-button.css.ts

const sidenavButtonStyles = lit/* css */.iv`
        :host{display:none}@media screen and (max-width:1055px){:host{display:inline-flex}}
      `;

;// CONCATENATED MODULE: ./packages/pharos/src/components/sidenav/pharos-sidenav-button.ts


class PharosSidenavButton extends pharos_button/* PharosButton */.b {
  constructor() {
    super();
    this.icon = "menu";
    this.variant = "subtle";
    this.label = "Open menu";
  }
  static get styles() {
    return [super.styles, sidenavButtonStyles];
  }
  firstUpdated() {
    this.addEventListener("click", this._handleClickOpen);
  }
  async _handleClickOpen() {
    const sidenav = document.querySelector(
      '[data-pharos-component="PharosSidenav"]'
    );
    if (sidenav) {
      sidenav.slide = true;
      await sidenav.updateComplete;
      sidenav.focus();
    }
  }
}

;// CONCATENATED MODULE: ./packages/pharos/src/components/sidenav/pharos-sidenav-link.css.ts

const sidenavLinkStyles = lit/* css */.iv`
        #link-element{color:var(--pharos-color-interactive-tertiary);display:grid;grid-template-columns:auto 1.5rem;grid-template-rows:auto;padding:var(--pharos-spacing-one-quarter-x) var(--pharos-spacing-2-x);text-decoration:none;transition-duration:var(--pharos-transition-duration-default);transition-property:background-color,visibility}#link-element:focus{outline-offset:-2px}#link-element:hover{background-color:var(--pharos-color-marble-gray-20);color:var(--pharos-color-interactive-tertiary);text-decoration:none}.link__icon{fill:var(--pharos-color-interactive-tertiary)}:host([menu-item]) #link-element{padding:var(--pharos-spacing-one-quarter-x) var(--pharos-spacing-3-x)}:host([is-active]) #link-element{background-color:var(--pharos-color-marble-gray-94);color:var(--pharos-color-marble-gray-10)}
      `;

;// CONCATENATED MODULE: ./packages/pharos/src/components/sidenav/pharos-sidenav-link.ts
var pharos_sidenav_link_defProp = Object.defineProperty;
var pharos_sidenav_link_getOwnPropDesc = Object.getOwnPropertyDescriptor;
var pharos_sidenav_link_decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? pharos_sidenav_link_getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    pharos_sidenav_link_defProp(target, key, result);
  return result;
};






class PharosSidenavLink extends (0,scoped_registry/* default */.Z)(pharos_link/* PharosLink */.G) {
  constructor() {
    super(...arguments);
    this.isActive = false;
    this.external = false;
    this.menuItem = false;
  }
  static get styles() {
    return [super.styles, sidenavLinkStyles];
  }
  get appendContent() {
    if (this.external) {
      return lit/* html */.dy`<pharos-icon name="link-external" class="link__icon"></pharos-icon>`;
    }
    return lit/* nothing */.Ld;
  }
  render() {
    return lit/* html */.dy`${super.render()}`;
  }
}
PharosSidenavLink.elementDefinitions = {
  "pharos-icon": pharos_icon/* PharosIcon */.b
};
pharos_sidenav_link_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true, attribute: "is-active" })
], PharosSidenavLink.prototype, "isActive", 2);
pharos_sidenav_link_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], PharosSidenavLink.prototype, "external", 2);
pharos_sidenav_link_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true, attribute: "menu-item" })
], PharosSidenavLink.prototype, "menuItem", 2);

;// CONCATENATED MODULE: ./packages/pharos/src/components/sidenav/pharos-sidenav-menu.css.ts

const sidenavMenuStyles = lit/* css */.iv`
        :host{contain:content;display:block}#button-element{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background:none;border:none;color:var(--pharos-color-interactive-tertiary);cursor:pointer;display:grid;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-font-size-base);font-weight:var(--pharos-font-weight-regular);grid-template-columns:auto 1.5rem;grid-template-rows:auto;letter-spacing:calc(var(--pharos-font-size-base)*-.02);line-height:var(--pharos-line-height-medium);padding:var(--pharos-spacing-one-quarter-x) var(--pharos-spacing-2-x);text-align:start;text-decoration:none;text-rendering:optimizelegibility;transition-duration:var(--pharos-transition-duration-default);transition-property:background-color;width:100%}#button-element:focus{outline:2px solid var(--pharos-color-focus);outline-offset:2px;outline-offset:-2px}#button-element:hover{background-color:var(--pharos-color-marble-gray-20);color:var(--pharos-color-interactive-tertiary);text-decoration:none}.button__icon{fill:var(--pharos-color-interactive-tertiary)}.menu__container{max-height:0;overflow:hidden;transition:max-height var(--pharos-transition-duration-default) ease-out;visibility:hidden}.menu__container--show{max-height:100rem;transition:max-height var(--pharos-transition-duration-long) ease-in;visibility:visible}.menu__list{list-style-type:none;margin-bottom:var(--pharos-spacing-1-x);margin-top:0;padding-left:0}
      `;

;// CONCATENATED MODULE: ./packages/pharos/src/components/sidenav/pharos-sidenav-menu.ts
var pharos_sidenav_menu_defProp = Object.defineProperty;
var pharos_sidenav_menu_getOwnPropDesc = Object.getOwnPropertyDescriptor;
var pharos_sidenav_menu_decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? pharos_sidenav_menu_getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    pharos_sidenav_menu_defProp(target, key, result);
  return result;
};








class PharosSidenavMenu extends (0,scoped_registry/* default */.Z)((0,mixins_focus/* default */.Z)(pharos_element/* PharosElement */.Z)) {
  constructor() {
    super(...arguments);
    this.expanded = false;
  }
  static get styles() {
    return [sidenavMenuStyles];
  }
  firstUpdated() {
    this._allLinks.forEach((link) => {
      link.menuItem = true;
      link.setAttribute("role", "menuitem");
    });
    this.addEventListener("keydown", this._handleKeydown);
  }
  _handleKeydown(event) {
    if ((event.key === "Escape" || event.key === "Esc") && this.expanded) {
      event.stopPropagation();
      this.expanded = false;
      this.focus();
    }
  }
  _handleClick() {
    this.expanded = !this.expanded;
  }
  _renderIcon() {
    if (this.expanded) {
      return lit/* html */.dy` <pharos-icon class="button__icon" name="chevron-up"></pharos-icon> `;
    }
    return lit/* html */.dy` <pharos-icon class="button__icon" name="chevron-down"></pharos-icon> `;
  }
  _renderMenu() {
    return lit/* html */.dy`
      <div
        class="${(0,class_map/* classMap */.$)({
      [`menu__container`]: true,
      [`menu__container--show`]: this.expanded
    })}"
        aria-hidden="${!this.expanded}"
      >
        <ul role="menu" class="menu__list">
          <slot></slot>
        </ul>
      </div>
    `;
  }
  render() {
    return lit/* html */.dy`
      <button
        id="button-element"
        aria-haspopup="true"
        aria-expanded="${this.expanded}"
        @click=${this._handleClick}
      >
        ${this.label}${this._renderIcon()}
      </button>
      ${this._renderMenu()}
    `;
  }
}
PharosSidenavMenu.elementDefinitions = {
  "pharos-icon": pharos_icon/* PharosIcon */.b
};
pharos_sidenav_menu_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosSidenavMenu.prototype, "label", 2);
pharos_sidenav_menu_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], PharosSidenavMenu.prototype, "expanded", 2);
pharos_sidenav_menu_decorateClass([
  (0,decorators/* queryAssignedElements */.NH)({ selector: '[data-pharos-component="PharosSidenavLink"]' })
], PharosSidenavMenu.prototype, "_allLinks", 2);

;// CONCATENATED MODULE: ./packages/pharos/src/components/sidenav/pharos-sidenav-section.css.ts

const sidenavSectionStyles = lit/* css */.iv`
        :host{contain:content;display:block}.section__container{margin:var(--pharos-spacing-one-and-a-half-x) 0}.section__heading{color:var(--pharos-color-marble-gray-80);margin-bottom:var(--pharos-spacing-one-half-x);padding:0 var(--pharos-spacing-2-x)}.section__divider{background:var(--pharos-color-marble-gray-40);border:none;height:1px;margin:0 var(--pharos-spacing-2-x)}
      `;

;// CONCATENATED MODULE: ./packages/pharos/src/components/sidenav/pharos-sidenav-section.ts
var pharos_sidenav_section_defProp = Object.defineProperty;
var pharos_sidenav_section_getOwnPropDesc = Object.getOwnPropertyDescriptor;
var pharos_sidenav_section_decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? pharos_sidenav_section_getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    pharos_sidenav_section_defProp(target, key, result);
  return result;
};






class PharosSidenavSection extends (0,scoped_registry/* default */.Z)(pharos_element/* PharosElement */.Z) {
  constructor() {
    super(...arguments);
    this.showDivider = false;
  }
  static get styles() {
    return [sidenavSectionStyles];
  }
  _renderLabel() {
    if (this.label) {
      return lit/* html */.dy`
        <pharos-heading class="section__heading" level="3" preset="legend"
          >${this.label}</pharos-heading
        >
      `;
    }
    return lit/* nothing */.Ld;
  }
  _renderDivider() {
    if (this.showDivider) {
      return lit/* html */.dy`<hr class="section__divider" />`;
    }
    return lit/* nothing */.Ld;
  }
  render() {
    return lit/* html */.dy`
      <div class="section__container">
        ${this._renderLabel()}
        <slot></slot>
      </div>
      ${this._renderDivider()}
    `;
  }
}
PharosSidenavSection.elementDefinitions = {
  "pharos-heading": pharos_heading/* PharosHeading */.rW
};
pharos_sidenav_section_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosSidenavSection.prototype, "label", 2);
pharos_sidenav_section_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true, attribute: "show-divider" })
], PharosSidenavSection.prototype, "showDivider", 2);

;// CONCATENATED MODULE: ./packages/pharos/src/components/tabs/pharos-tabs.css.ts

const tabsStyles = lit/* css */.iv`
        :host{contain:layout;display:inline-flex;flex-direction:column}.cloak{--cloak-distance:20%;--cloak-antidistance:calc(100% - var(--cloak-distance))}.cloak--cloak-left{-webkit-mask-image:linear-gradient(to right,transparent,gray var(--cloak-distance));mask-image:linear-gradient(to right,transparent,gray var(--cloak-distance))}.cloak--cloak-right{-webkit-mask-image:linear-gradient(to left,transparent,gray var(--cloak-distance));mask-image:linear-gradient(to left,transparent,gray var(--cloak-distance))}.cloak--cloak-left.cloak--cloak-right{-webkit-mask-image:linear-gradient(to right,transparent,gray var(--cloak-distance),gray var(--cloak-antidistance),transparent);mask-image:linear-gradient(to right,transparent,gray var(--cloak-distance),gray var(--cloak-antidistance),transparent)}.tab__list{display:flex;margin-bottom:var(--pharos-spacing-one-half-x);overflow-x:scroll;padding-bottom:var(--pharos-spacing-1-x);scroll-behavior:smooth}.tab__panels{display:flex;flex-direction:column;overflow-y:hidden;padding:var(--pharos-spacing-one-quarter-x)}.panel-separator{border-bottom:1px solid var(--pharos-color-ui-40);flex:2;width:100%}
      `;

;// CONCATENATED MODULE: ./packages/pharos/src/components/tabs/pharos-tabs.ts
var pharos_tabs_defProp = Object.defineProperty;
var pharos_tabs_getOwnPropDesc = Object.getOwnPropertyDescriptor;
var pharos_tabs_decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? pharos_tabs_getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    pharos_tabs_defProp(target, key, result);
  return result;
};






const _allTabsSelector = '[data-pharos-component="PharosTab"]';
const _allTabPanelsSelector = '[data-pharos-component="PharosTabPanel"]';
class PharosTabs extends pharos_element/* PharosElement */.Z {
  constructor() {
    super(...arguments);
    this.panelSeparator = false;
    this._overflowingLeft = false;
    this._overflowingRight = false;
  }
  static get styles() {
    return [tabsStyles];
  }
  async firstUpdated() {
    this.addEventListener(
      "pharos-tab-selected",
      (e) => this._handleTabSelected(e.target)
    );
    this.addEventListener("keydown", this._handleKeydown);
    this.addEventListener("focusout", this._handleFocusout);
    for (const tab of this._tabs) {
      const panel = this._queryPanelByTab(tab);
      tab.setAttribute("aria-controls", (panel == null ? void 0 : panel.id) || "");
      panel == null ? void 0 : panel.setAttribute("aria-labelledby", tab.id);
      await tab.updateComplete;
      await (panel == null ? void 0 : panel.updateComplete);
    }
    this._selectInitialTab();
    this._watchTablistScrolling();
    this._watchResize();
  }
  _watchTablistScrolling() {
    this._tabOverflowObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.target === this._tabs[0]) {
            this._overflowingLeft = entry.intersectionRatio < 1;
          }
          if (entry.target === this._tabs[this._tabs.length - 1]) {
            this._overflowingRight = entry.intersectionRatio < 1;
          }
        });
      },
      {
        root: this._tabList,
        rootMargin: "1px",
        threshold: 1
      }
    );
    this._tabOverflowObserver.observe(this._tabs[0]);
    this._tabOverflowObserver.observe(this._tabs[this._tabs.length - 1]);
  }
  _makeTabVisible(tab) {
    this._tabList.scroll({ left: tab.offsetLeft - 3 * 16, behavior: "smooth" });
  }
  _watchResize() {
    this._tabListResizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === this._tabList) {
          this._makeTabVisible(this._selectedTabs[0]);
        }
      });
    });
    this._tabListResizeObserver.observe(this._tabList);
  }
  disconnectedCallback() {
    this._tabOverflowObserver.disconnect();
    this._tabListResizeObserver.disconnect();
    super.disconnectedCallback();
  }
  _selectInitialTab() {
    const selected = this.querySelector(`${_allTabsSelector}[selected]`);
    const selectedTab = selected || this._tabs[0];
    this._handleTabSelected(selectedTab);
  }
  _queryPanelByTab(tab) {
    const panelId = tab.dataset.panelId;
    return this.querySelector(`#${panelId}`);
  }
  _handleTabSelected(selectedTab) {
    selectedTab.selected = true;
    this._makeTabVisible(selectedTab);
    const previousTab = this.querySelector(
      `${_allTabsSelector}[selected]:not([id="${selectedTab.id}"])`
    );
    if (previousTab && previousTab != selectedTab) {
      previousTab.selected = false;
      const previousPanel = this.querySelector(
        `${_allTabPanelsSelector}[id="${previousTab.getAttribute("aria-controls")}"]`
      );
      if (previousPanel) {
        previousPanel.selected = false;
      }
    }
    const selectedPanel = this.querySelector(
      `${_allTabPanelsSelector}[id="${selectedTab.getAttribute("aria-controls")}"]`
    );
    if (selectedPanel) {
      selectedPanel.selected = true;
    }
  }
  _handleKeydown(event) {
    switch (event.key) {
      case "Right":
      case "ArrowRight":
        event.preventDefault();
        this._handleArrowKeys(true);
        break;
      case "Left":
      case "ArrowLeft":
        event.preventDefault();
        this._handleArrowKeys(false);
        break;
      case "Enter":
      case " ":
      case "Spacebar":
        event.preventDefault();
        this._handleEnterKey();
        break;
    }
  }
  async _handleArrowKeys(moveForward) {
    const tabs = Array.prototype.slice.call(this._tabs);
    const ids = tabs.map((tab) => tab.id);
    const focused = document.activeElement;
    if (!focused.matches(_allTabsSelector)) {
      return;
    }
    const nextTabIndex = loopWrapIndex(ids, (v) => v === focused.id, moveForward);
    focused["_focused"] = false;
    const moveFocusTo = tabs[nextTabIndex];
    moveFocusTo["_focused"] = true;
    await moveFocusTo.updateComplete;
    moveFocusTo.focus();
    this._makeTabVisible(moveFocusTo);
  }
  _handleEnterKey() {
    const focused = document.activeElement;
    focused.click();
  }
  _handleFocusout(event) {
    if (event.relatedTarget && event.relatedTarget.matches(_allTabsSelector)) {
      return;
    }
    this._tabs.forEach((tab) => {
      tab["_focused"] = tab.hasAttribute("selected");
    });
  }
  _renderPanelSeparator() {
    return this.panelSeparator ? lit/* html */.dy`<span class="panel-separator"></span>` : null;
  }
  _renderTabList() {
    return lit/* html */.dy`
      <div
        class="${(0,class_map/* classMap */.$)({
      ["cloak"]: true,
      ["cloak--cloak-left"]: this._overflowingLeft,
      ["cloak--cloak-right"]: this._overflowingRight
    })}"
      >
        <div class="tab__list" role="tablist">
          <slot></slot>
          ${this._renderPanelSeparator()}
        </div>
      </div>
    `;
  }
  _renderTabPanels() {
    return lit/* html */.dy`
      <div class="tab__panels">
        <slot name="panel"></slot>
      </div>
    `;
  }
  render() {
    return lit/* html */.dy` ${this._renderTabList()} ${this._renderTabPanels()} `;
  }
}
pharos_tabs_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true, attribute: "panel-separator" })
], PharosTabs.prototype, "panelSeparator", 2);
pharos_tabs_decorateClass([
  (0,decorators/* query */.IO)(".tab__list")
], PharosTabs.prototype, "_tabList", 2);
pharos_tabs_decorateClass([
  (0,decorators/* state */.SB)()
], PharosTabs.prototype, "_overflowingLeft", 2);
pharos_tabs_decorateClass([
  (0,decorators/* state */.SB)()
], PharosTabs.prototype, "_overflowingRight", 2);
pharos_tabs_decorateClass([
  (0,decorators/* queryAssignedElements */.NH)({ selector: _allTabsSelector })
], PharosTabs.prototype, "_tabs", 2);
pharos_tabs_decorateClass([
  (0,decorators/* queryAssignedElements */.NH)({ selector: `${_allTabsSelector}[selected]` })
], PharosTabs.prototype, "_selectedTabs", 2);

;// CONCATENATED MODULE: ./packages/pharos/src/components/tabs/pharos-tab.css.ts

const tabStyles = lit/* css */.iv`
        :host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background:none;border:none;border-bottom:1px solid var(--pharos-color-ui-40);color:var(--pharos-color-text-20);contain:content;display:grid;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-font-size-base);font-weight:var(--pharos-font-weight-regular);grid-template-columns:max-content;letter-spacing:calc(var(--pharos-font-size-base)*-.02);line-height:var(--pharos-line-height-medium);padding:var(--pharos-spacing-one-half-x) var(--pharos-spacing-1-x);text-rendering:optimizelegibility;transition-duration:var(--pharos-transition-duration-default);transition-property:color,border-bottom-color;transition-timing-function:ease-in-out}:host:after{content:attr(data-text);content:attr(data-text)/"";display:block;font-weight:var(--pharos-font-weight-bold);height:0;overflow:hidden;pointer-events:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;visibility:hidden}@media speech{:host:after{display:none}}:host(:focus){outline:2px solid var(--pharos-color-focus);outline-offset:2px}:host(:hover){border-bottom-color:var(--pharos-color-hover-primary);color:var(--pharos-color-hover-primary);cursor:pointer}:host([selected]){border-bottom:2px solid var(--pharos-color-interactive-secondary);color:var(--pharos-color-text-base);font-weight:var(--pharos-font-weight-bold);padding-bottom:calc(var(--pharos-spacing-one-half-x) - 1px)}
      `;

;// CONCATENATED MODULE: ./packages/pharos/src/components/tabs/pharos-tab.ts
var pharos_tab_defProp = Object.defineProperty;
var pharos_tab_getOwnPropDesc = Object.getOwnPropertyDescriptor;
var pharos_tab_decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? pharos_tab_getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    pharos_tab_defProp(target, key, result);
  return result;
};




class PharosTab extends pharos_element/* PharosElement */.Z {
  constructor() {
    super(...arguments);
    this.selected = false;
    this._focused = false;
  }
  static get styles() {
    return [tabStyles];
  }
  firstUpdated() {
    this.addEventListener("click", this._handleClick);
    this.setAttribute("role", "tab");
    this.setAttribute("aria-selected", "false");
    this.setAttribute("tabindex", "-1");
    this.dataset.text = this.textContent || "";
  }
  async updated(changedProperties) {
    if (changedProperties.has("selected")) {
      this._focused = this.selected;
      this.setAttribute("aria-selected", this.selected ? "true" : "false");
      if (this.selected) {
        this._triggerSelectedEvent();
      }
    }
    if (changedProperties.has("_focused")) {
      this.setAttribute("tabindex", this._focused ? "0" : "-1");
    }
  }
  _triggerSelectedEvent() {
    const details = {
      bubbles: true,
      composed: true
    };
    this.dispatchEvent(new CustomEvent("pharos-tab-selected", details));
  }
  _handleClick() {
    this._triggerSelectedEvent();
  }
  render() {
    return lit/* html */.dy` <slot></slot> `;
  }
}
pharos_tab_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], PharosTab.prototype, "selected", 2);
pharos_tab_decorateClass([
  (0,decorators/* state */.SB)()
], PharosTab.prototype, "_focused", 2);

;// CONCATENATED MODULE: ./packages/pharos/src/components/tabs/pharos-tab-panel.css.ts

const tabPanelStyles = lit/* css */.iv`
        :host{contain:layout;display:none;overflow-y:hidden;visibility:hidden}:host(:focus){outline:2px solid var(--pharos-color-focus);outline-offset:2px}:host([selected]){display:flex;visibility:visible}
      `;

// EXTERNAL MODULE: ./packages/pharos/src/utils/focusable.ts
var focusable = __webpack_require__("./packages/pharos/src/utils/focusable.ts");
;// CONCATENATED MODULE: ./packages/pharos/src/components/tabs/pharos-tab-panel.ts
var pharos_tab_panel_defProp = Object.defineProperty;
var pharos_tab_panel_getOwnPropDesc = Object.getOwnPropertyDescriptor;
var pharos_tab_panel_decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? pharos_tab_panel_getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    pharos_tab_panel_defProp(target, key, result);
  return result;
};





class PharosTabPanel extends pharos_element/* PharosElement */.Z {
  constructor() {
    super(...arguments);
    this.selected = false;
  }
  static get styles() {
    return [tabPanelStyles];
  }
  firstUpdated() {
    this.setAttribute("role", "tabpanel");
    this.addEventListener("keydown", this._handleKeydown);
    const focusableElements = this.querySelector(focusable/* default */.Z);
    if (!focusableElements) {
      this.setAttribute("tabindex", "0");
    }
  }
  _handleKeydown(event) {
    event.stopPropagation();
  }
  render() {
    return lit/* html */.dy` <slot></slot> `;
  }
}
pharos_tab_panel_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], PharosTabPanel.prototype, "selected", 2);

;// CONCATENATED MODULE: ./packages/pharos/src/components/textarea/pharos-textarea.css.ts

const textareaStyles = lit/* css */.iv`
        :host{contain:content;display:block;width:100%}.textarea{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;border:1px solid var(--pharos-form-element-color-border-base);border-radius:var(--pharos-radius-base-standard);box-sizing:border-box;color:var(--pharos-form-element-color-text-base);display:block;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-font-size-base);font-weight:var(--pharos-font-weight-regular);letter-spacing:calc(var(--pharos-font-size-base)*-.02);line-height:var(--pharos-line-height-medium);margin:0;min-height:var(--pharos-textarea-size-height-base);overflow:auto;padding:var(--pharos-spacing-one-half-x) var(--pharos-spacing-three-quarters-x);text-rendering:optimizelegibility;transition:transform var(--pharos-transition-base) 0s;width:100%}.textarea:required{box-shadow:none}.textarea::-moz-placeholder{color:var(--pharos-form-element-color-text-placeholder);opacity:1}.textarea::placeholder{color:var(--pharos-form-element-color-text-placeholder);opacity:1}.textarea:focus{border:2px solid var(--pharos-form-element-color-border-focus);outline:none;padding:calc(var(--pharos-spacing-one-half-x) - 1px) calc(var(--pharos-spacing-three-quarters-x) - 1px);transition:transform var(--pharos-transition-base) 0s}:host([disabled]) .textarea{background-color:var(--pharos-form-element-color-background-disabled);border-color:var(--pharos-form-element-color-background-disabled);color:var(--pharos-form-element-color-text-disabled);pointer-events:none}.textarea--resize-both{resize:both}.textarea--resize-horizontal{resize:horizontal}.textarea--resize-vertical{resize:vertical}.textarea--resize-none{resize:none}.textarea-wrapper{align-items:center;display:flex;position:relative;width:100%}:host([invalidated]) .textarea{border:2px solid var(--pharos-form-element-color-border-invalid);padding:calc(var(--pharos-spacing-one-half-x) - 1px) calc(var(--pharos-spacing-three-quarters-x) - 1px)}
      `;

;// CONCATENATED MODULE: ./packages/pharos/src/components/textarea/pharos-textarea.ts
var pharos_textarea_defProp = Object.defineProperty;
var pharos_textarea_getOwnPropDesc = Object.getOwnPropertyDescriptor;
var pharos_textarea_decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? pharos_textarea_getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    pharos_textarea_defProp(target, key, result);
  return result;
};







const RESIZES = ["none", "vertical", "horizontal", "both"];
const WRAPS = ["soft", "hard"];
class PharosTextarea extends (0,mixins_form/* default */.Z)(form_element/* FormElement */.W) {
  constructor() {
    super(...arguments);
    this.value = "";
    this.cols = 20;
    this.dirname = "";
    this.placeholder = "";
    this.readonly = false;
    this.rows = 2;
    this.resize = "both";
    this.wrap = "soft";
  }
  static get styles() {
    return [super.styles, textareaStyles];
  }
  firstUpdated() {
    this._textarea.defaultValue = this.value;
  }
  update(changedProperties) {
    super.update && super.update(changedProperties);
    if (changedProperties.has("resize") && !RESIZES.includes(this.resize)) {
      throw new Error(
        `${this.resize} is not a valid resize value. Valid values are: ${RESIZES.join(", ")}`
      );
    }
    if (changedProperties.has("wrap") && !WRAPS.includes(this.wrap)) {
      throw new Error(
        `${this.wrap} is not a valid wrap value. Valid values are: ${WRAPS.join(", ")}`
      );
    }
  }
  onChange() {
    this.dispatchEvent(
      new Event("change", {
        bubbles: true,
        composed: true
      })
    );
  }
  onInput() {
    this.value = this._textarea.value;
  }
  _handleFormdata(event) {
    const { formData } = event;
    if (!this.disabled) {
      formData.append(this.name, this.value);
    }
  }
  _handleFormReset() {
    this.value = this._textarea.defaultValue;
  }
  render() {
    return lit/* html */.dy`
      <label for="textarea-element">
        <slot name="label"></slot>
        ${this.requiredIndicator}
      </label>
      <div class="textarea-wrapper">
        <textarea
          id="textarea-element"
          class=${(0,class_map/* classMap */.$)({
      [`textarea`]: true,
      [`textarea--resize-${this.resize}`]: this.resize
    })}
          cols=${(0,if_defined/* ifDefined */.o)(this.cols)}
          rows=${(0,if_defined/* ifDefined */.o)(this.rows)}
          dirname=${(0,if_defined/* ifDefined */.o)(this.dirname)}
          name="${this.name}"
          .value=${this.value}
          ?required="${this.required}"
          ?disabled=${this.disabled}
          ?readonly=${this.readonly}
          placeholder="${this.placeholder}"
          maxlength=${(0,if_defined/* ifDefined */.o)(this.maxlength)}
          minlength=${(0,if_defined/* ifDefined */.o)(this.minlength)}
          .wrap=${this.wrap}
          aria-required="${this.required}"
          aria-invalid="${this.invalidated}"
          aria-describedby="${(0,if_defined/* ifDefined */.o)(this.messageId)}"
          @change=${this.onChange}
          @input=${this.onInput}
        ></textarea>
      </div>
      ${this.messageContent}
    `;
  }
}
pharos_textarea_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosTextarea.prototype, "value", 2);
pharos_textarea_decorateClass([
  (0,decorators/* property */.Cb)({ type: Number, reflect: true })
], PharosTextarea.prototype, "cols", 2);
pharos_textarea_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosTextarea.prototype, "dirname", 2);
pharos_textarea_decorateClass([
  (0,decorators/* property */.Cb)({ type: Number, reflect: true })
], PharosTextarea.prototype, "maxlength", 2);
pharos_textarea_decorateClass([
  (0,decorators/* property */.Cb)({ type: Number, reflect: true })
], PharosTextarea.prototype, "minlength", 2);
pharos_textarea_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosTextarea.prototype, "placeholder", 2);
pharos_textarea_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], PharosTextarea.prototype, "readonly", 2);
pharos_textarea_decorateClass([
  (0,decorators/* property */.Cb)({ type: Number, reflect: true })
], PharosTextarea.prototype, "rows", 2);
pharos_textarea_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosTextarea.prototype, "resize", 2);
pharos_textarea_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosTextarea.prototype, "wrap", 2);
pharos_textarea_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosTextarea.prototype, "pattern", 2);
pharos_textarea_decorateClass([
  (0,decorators/* query */.IO)("#textarea-element")
], PharosTextarea.prototype, "_textarea", 2);

;// CONCATENATED MODULE: ./packages/pharos/src/components/toast/pharos-toast.css.ts

const toastStyles = lit/* css */.iv`
        :host{contain:layout;display:inline-flex;flex-direction:row;position:relative}.toast{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;grid-gap:var(--pharos-spacing-1-x);align-items:start;background:var(--pharos-color-marble-gray-10);border-radius:var(--pharos-radius-base-standard);box-sizing:border-box;color:var(--pharos-color-text-white);display:grid;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-font-size-base);font-weight:var(--pharos-font-weight-regular);grid-template-areas:"icon body dismiss";grid-template-columns:var(--pharos-spacing-one-and-a-half-x) 1fr 1.75rem;justify-content:center;letter-spacing:calc(var(--pharos-font-size-base)*-.02);line-height:var(--pharos-line-height-medium);opacity:0;padding:var(--pharos-spacing-1-x);text-rendering:optimizelegibility;transform:translateY(calc(var(--pharos-spacing-1-x)*-1));transition:opacity var(--pharos-transition-duration-long) ease-in-out,transform var(--pharos-transition-duration-long) ease-in-out;width:25rem}.toast__body{grid-area:body;overflow:hidden;overflow-wrap:break-word}.toast__icon{grid-area:icon}.toast__button{grid-area:dismiss}.toast--success .toast__icon{fill:var(--pharos-color-feedback-success)}.toast--error .toast__icon{fill:var(--pharos-color-feedback-error)}.toast--info .toast__icon{fill:var(--pharos-color-feedback-info)}:host([open]) .toast{opacity:1;transform:translateY(0)}@media only screen and (max-width:570px){.toast{max-width:90vw}}
      `;

;// CONCATENATED MODULE: ./packages/pharos/src/components/toast/pharos-toast-button.css.ts

const toastButtonStyles = lit/* css */.iv`
        :host([on-background][variant=subtle]:not([disabled])) #button-element:active,:host([on-background][variant=subtle]:not([disabled])) #button-element:hover{background-color:transparent;border-color:transparent;color:var(--pharos-color-marble-gray-50)}:host([on-background][variant=subtle]:not([disabled])) #button-element:active [data-pharos-component=PharosIcon],:host([on-background][variant=subtle]:not([disabled])) #button-element:hover [data-pharos-component=PharosIcon]{fill:var(--pharos-color-marble-gray-50);stroke:var(--pharos-color-marble-gray-50)}
      `;

;// CONCATENATED MODULE: ./packages/pharos/src/components/toast/pharos-toast-button.ts


class PharosToastButton extends pharos_button/* PharosButton */.b {
  constructor() {
    super();
    this.icon = "close";
    this.variant = "subtle";
    this.label = "Dismiss";
    this.onBackground = true;
    this.iconCondensed = true;
  }
  static get styles() {
    return [super.styles, toastButtonStyles];
  }
}

;// CONCATENATED MODULE: ./packages/pharos/src/components/toast/pharos-toast.ts
var pharos_toast_defProp = Object.defineProperty;
var pharos_toast_getOwnPropDesc = Object.getOwnPropertyDescriptor;
var pharos_toast_decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? pharos_toast_getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    pharos_toast_defProp(target, key, result);
  return result;
};










var TOAST_ICON = /* @__PURE__ */ ((TOAST_ICON2) => {
  TOAST_ICON2["ERROR"] = "exclamation-inverse";
  TOAST_ICON2["SUCCESS"] = "checkmark-inverse";
  TOAST_ICON2["INFO"] = "exclamation-inverse";
  return TOAST_ICON2;
})(TOAST_ICON || {});
const pharos_toast_STATUSES = ["success", "error", "info"];
const TOAST_LIFE = 6e3;
const DEFAULT_STATUS = "success";
const DEFAULT_INDEFINITE = false;
class PharosToast extends (0,scoped_registry/* default */.Z)((0,mixins_focus/* default */.Z)(pharos_element/* PharosElement */.Z)) {
  constructor() {
    super(...arguments);
    this.status = DEFAULT_STATUS;
    this.open = false;
    this.id = "toast";
    this.indefinite = false;
    this._timer = 0;
    this._debouncer = utils_debounce(() => {
      this.close();
    }, TOAST_LIFE);
  }
  static get styles() {
    return [toastStyles];
  }
  firstUpdated() {
    if (!this.indefinite) {
      this.addEventListener("focusin", this._handleTimer);
      this.addEventListener("focusout", this._handleTimer);
    }
    this.open = true;
  }
  update(changedProperties) {
    super.update && super.update(changedProperties);
    if (changedProperties.has("status") && !pharos_toast_STATUSES.includes(this.status)) {
      throw new Error(
        `${this.status} is not a valid status. Valid statuses are: ${pharos_toast_STATUSES.join(", ")}`
      );
    }
  }
  _handleTimer(event) {
    if (event.type === "focusin") {
      clearTimeout(this._timer);
    } else {
      this._timer = this._debouncer();
    }
  }
  _getIcon() {
    const key = this.status.toUpperCase();
    return TOAST_ICON[key] || "checkmark-inverse" /* SUCCESS */;
  }
  close() {
    const details = {
      bubbles: true,
      composed: true,
      detail: this
    };
    this.open = false;
    utils_debounce(() => {
      this.dispatchEvent(new CustomEvent("pharos-toast-close", details));
    }, 500)();
  }
  render() {
    return lit/* html */.dy`
      <div
        role="alert"
        id="${this.id}"
        class="${(0,class_map/* classMap */.$)({
      [`toast`]: true,
      [`toast--${this.status}`]: this.status
    })}"
        tabindex="0"
      >
        <pharos-icon class="toast__icon" name="${this._getIcon()}"></pharos-icon>
        <div class="toast__body">
          <slot></slot>
        </div>
        <pharos-toast-button class="toast__button" @click=${this.close}></pharos-toast-button>
      </div>
    `;
  }
}
PharosToast.elementDefinitions = {
  "pharos-icon": pharos_icon/* PharosIcon */.b,
  "pharos-toast-button": PharosToastButton
};
pharos_toast_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosToast.prototype, "status", 2);
pharos_toast_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], PharosToast.prototype, "open", 2);
pharos_toast_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosToast.prototype, "id", 2);
pharos_toast_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], PharosToast.prototype, "indefinite", 2);

;// CONCATENATED MODULE: ./packages/pharos/src/components/toast/pharos-toaster.css.ts

const toasterStyles = lit/* css */.iv`
        :host{contain:layout;display:block;position:fixed;right:var(--pharos-spacing-1-x);top:var(--pharos-spacing-1-x);z-index:1000}.toaster__container{align-items:flex-end;display:inline-flex;flex-direction:column}::slotted([data-pharos-component=PharosToast]:not(:last-child)){margin-bottom:var(--pharos-spacing-1-x)}
      `;

// EXTERNAL MODULE: ./packages/pharos/node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__("./packages/pharos/node_modules/uuid/dist/esm-browser/v4.js");
;// CONCATENATED MODULE: ./packages/pharos/src/components/toast/pharos-toaster.ts





class PharosToaster extends pharos_element/* PharosElement */.Z {
  constructor() {
    super();
    this._openToast = this._openToast.bind(this);
    this._updateToast = this._updateToast.bind(this);
    this._closeToast = this._closeToast.bind(this);
  }
  static get styles() {
    return [toasterStyles];
  }
  connectedCallback() {
    super.connectedCallback && super.connectedCallback();
    document.addEventListener("pharos-toast-open", this._openToast);
    document.addEventListener("pharos-toast-update", this._updateToast);
    document.addEventListener("pharos-toast-close", this._closeToast);
  }
  disconnectedCallback() {
    document.removeEventListener("pharos-toast-open", this._openToast);
    document.removeEventListener("pharos-toast-update", this._updateToast);
    document.removeEventListener("pharos-toast-close", this._closeToast);
    super.disconnectedCallback && super.disconnectedCallback();
  }
  _getToastID(id) {
    return id || `toast_${(0,v4/* default */.Z)()}`;
  }
  async _openToast(event) {
    const toastTag = this.localName.split("pharos-toaster")[0] + "pharos-toast";
    const toast = document.createElement(toastTag);
    const { content, status, id, indefinite } = event.detail;
    toast.innerHTML = content;
    toast.status = status || DEFAULT_STATUS;
    toast.id = this._getToastID(id);
    toast.indefinite = indefinite || DEFAULT_INDEFINITE;
    this.insertBefore(toast, this.childNodes[0] || null);
    await this.updateComplete;
    toast.focus();
  }
  _updateToast(event) {
    const { content, status, id } = event.detail;
    const toast = document.getElementById(this._getToastID(id));
    if (toast) {
      toast.innerHTML = content;
      toast.status = status;
    }
  }
  _closeToast(event) {
    const { id } = event.detail || {};
    const toast = document.getElementById(this._getToastID(id));
    if (toast) {
      this.removeChild(toast);
    }
  }
  render() {
    return lit/* html */.dy`
      <div class="toaster__container">
        <slot></slot>
      </div>
    `;
  }
}

;// CONCATENATED MODULE: ./packages/pharos/src/components/toggle-button-group/pharos-toggle-button.css.ts

const toggleButtonStyles = lit/* css */.iv`
        :host([variant=secondary]) #button-element{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:transparent;border:1px solid var(--pharos-color-black);border-radius:var(--pharos-radius-base-standard);border-radius:0;border-width:1px;color:var(--pharos-color-text-base);cursor:pointer;display:flex;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-font-size-base);font-weight:var(--pharos-font-weight-bold);justify-content:center;letter-spacing:calc(var(--pharos-font-size-base)*-.02);line-height:var(--pharos-line-height-medium);margin:0;outline-offset:0;padding:var(--pharos-spacing-one-quarter-x) var(--pharos-spacing-three-quarters-x);text-rendering:optimizelegibility;transition-duration:var(--pharos-transition-duration-default);transition-property:border-color,background,color;transition-timing-function:ease-in-out}:host([variant=secondary]) #button-element [data-pharos-component=PharosIcon]{fill:var(--pharos-color-text-base);stroke:var(--pharos-color-text-base);stroke-width:0;transition-duration:var(--pharos-transition-duration-default);transition-property:fill,stroke;transition-timing-function:ease-in-out}:host([variant=secondary]) #button-element [data-pharos-component=PharosIcon]:first-child:not(:only-child){margin-right:var(--pharos-spacing-one-quarter-x)}:host([variant=secondary]) #button-element [data-pharos-component=PharosIcon]:last-child:not(:only-child){margin-left:var(--pharos-spacing-one-quarter-x)}:host([variant=secondary][first=true]) #button-element{border-radius:var(--pharos-radius-base-standard) 0 0 var(--pharos-radius-base-standard)}:host([variant=secondary][last=true]) #button-element{border-radius:0 var(--pharos-radius-base-standard) var(--pharos-radius-base-standard) 0}:host([variant=secondary]:not([selected])) #button-element{background-color:transparent;border-color:var(--pharos-color-ui-40);color:var(--pharos-color-text-40)}:host([variant=secondary]:not([selected])) #button-element [data-pharos-component=PharosIcon]{fill:var(--pharos-color-text-40);stroke:var(--pharos-color-text-40)}:host([variant=secondary]:not([selected])) #button-element [data-pharos-component=PharosIcon]{fill:var(--pharos-color-ui-40);stroke:var(--pharos-color-ui-40)}:host([variant=secondary][icon]:not([selected])) #button-element [data-pharos-component=PharosIcon]{fill:var(--pharos-color-ui-50);stroke:var(--pharos-color-ui-50)}:host([variant=secondary][first=false]:not([selected])) #button-element{border-left-width:0}:host([variant=secondary][hide-left-border=true]:not([selected])) #button-element,:host([variant=secondary][hide-left-border=true][selected]) #button-element{border-left-width:0}:host([variant=secondary][hide-right-border=true]:not([selected])) #button-element,:host([variant=secondary][hide-right-border=true][selected]) #button-element{border-right-width:0}:host([variant=secondary]) #button-element:active,:host([variant=secondary]) #button-element:hover{border-width:1px}:host([variant=secondary][hide-left-border=true]:not([selected])) #button-element:active{border-left-width:0}:host([variant=secondary]) #button-element:focus{z-index:100}:host([variant=secondary][hide-right-border=true]:not([selected])) #button-element:active{border-right-width:0}:host([variant=secondary]:not([disabled])) #button-element:hover,:host([variant=secondary]:not([selected])) #button-element:active,:host([variant=secondary]:not([selected])) #button-element:hover{background-color:var(--pharos-color-marble-gray-97);color:var(--pharos-color-hover-primary);padding:var(--pharos-spacing-one-quarter-x) var(--pharos-spacing-three-quarters-x)}:host([variant=secondary]:not([disabled])) #button-element:hover [data-pharos-component=PharosIcon],:host([variant=secondary]:not([selected])) #button-element:active [data-pharos-component=PharosIcon],:host([variant=secondary]:not([selected])) #button-element:hover [data-pharos-component=PharosIcon]{fill:var(--pharos-color-hover-primary);stroke:var(--pharos-color-hover-primary)}:host([variant=secondary][selected]){pointer-events:none}:host([variant=secondary][icon][selected]) #button-element:active{border-width:1px;padding:var(--pharos-spacing-one-quarter-x) var(--pharos-spacing-three-quarters-x)}:host([variant=secondary][icon]:not([disabled])) #button-element:hover,:host([variant=secondary][icon]:not([selected])) #button-element:active,:host([variant=secondary][icon]:not([selected])) #button-element:hover{padding:var(--pharos-spacing-one-quarter-x) var(--pharos-spacing-three-quarters-x)}:host([variant=secondary][on-background]:not([selected])) #button-element:active,:host([variant=secondary][on-background]:not([selected])) #button-element:hover{background-color:var(--pharos-color-interactive-tertiary);border-color:var(--pharos-color-interactive-tertiary);color:var(--pharos-color-interactive-secondary)}:host([variant=secondary][on-background]:not([selected])) #button-element:active [data-pharos-component=PharosIcon],:host([variant=secondary][on-background]:not([selected])) #button-element:hover [data-pharos-component=PharosIcon]{fill:var(--pharos-color-interactive-secondary);stroke:var(--pharos-color-interactive-secondary)}:host([variant=secondary][icon-condensed][icon]:not([selected])) #toggle-button-element:active,:host([variant=secondary][icon-condensed][icon]:not([selected])) #toggle-button-element:hover{padding:var(--pharos-spacing-one-eighth-x)}:host([variant=secondary][icon][large]:not([selected])) #toggle-button-element:active,:host([variant=secondary][icon][large]:not([selected])) #toggle-button-element:hover{padding:calc(var(--pharos-spacing-one-half-x) - 1px)}
      `;

;// CONCATENATED MODULE: ./packages/pharos/src/components/toggle-button-group/pharos-toggle-button.ts
var pharos_toggle_button_defProp = Object.defineProperty;
var pharos_toggle_button_getOwnPropDesc = Object.getOwnPropertyDescriptor;
var pharos_toggle_button_decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? pharos_toggle_button_getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    pharos_toggle_button_defProp(target, key, result);
  return result;
};



class PharosToggleButton extends pharos_button/* PharosButton */.b {
  constructor() {
    super();
    this.selected = false;
    this._first = false;
    this._last = false;
    this._hideLeftBorder = false;
    this._hideRightBorder = false;
    this.pressed = "false";
    this.variant = "secondary";
    this.type = "button";
  }
  static get styles() {
    return [super.styles, toggleButtonStyles];
  }
  update(changedProperties) {
    super.update && super.update(changedProperties);
    if (changedProperties.has("href") || changedProperties.has("hreflang") || changedProperties.has("ping") || changedProperties.has("rel") || changedProperties.has("target")) {
      throw new Error(
        "The toggle button component does not support these properties: href, hreflang, ping, rel, and target."
      );
    }
    if (changedProperties.has("_first")) {
      this.setAttribute("first", this._first ? "true" : "false");
    }
    if (changedProperties.has("_last")) {
      this.setAttribute("last", this._last ? "true" : "false");
    }
    if (changedProperties.has("_hideLeftBorder")) {
      this.setAttribute("hide-left-border", this._hideLeftBorder ? "true" : "false");
    }
    if (changedProperties.has("_hideRightBorder")) {
      this.setAttribute("hide-right-border", this._hideRightBorder ? "true" : "false");
    }
  }
  firstUpdated() {
    this.addEventListener("click", this._handleClickToggle);
  }
  _handleClickToggle() {
    const details = {
      bubbles: true,
      composed: true
    };
    this.selected = true;
    this.pressed = "true";
    this.dispatchEvent(new CustomEvent("pharos-toggle-button-selected", details));
  }
}
pharos_toggle_button_decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], PharosToggleButton.prototype, "selected", 2);
pharos_toggle_button_decorateClass([
  (0,decorators/* state */.SB)()
], PharosToggleButton.prototype, "_first", 2);
pharos_toggle_button_decorateClass([
  (0,decorators/* state */.SB)()
], PharosToggleButton.prototype, "_last", 2);
pharos_toggle_button_decorateClass([
  (0,decorators/* state */.SB)()
], PharosToggleButton.prototype, "_hideLeftBorder", 2);
pharos_toggle_button_decorateClass([
  (0,decorators/* state */.SB)()
], PharosToggleButton.prototype, "_hideRightBorder", 2);

;// CONCATENATED MODULE: ./packages/pharos/src/components/toggle-button-group/pharos-toggle-button-group.css.ts

const toggleButtonGroupStyles = lit/* css */.iv`
        :host{contain:layout;display:inline-flex;flex-direction:column}.toggle-button__list{border-collapse:collapse;display:inline-table;flex-direction:row}
      `;

;// CONCATENATED MODULE: ./packages/pharos/src/components/toggle-button-group/pharos-toggle-button-group.ts
var pharos_toggle_button_group_defProp = Object.defineProperty;
var pharos_toggle_button_group_getOwnPropDesc = Object.getOwnPropertyDescriptor;
var pharos_toggle_button_group_decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? pharos_toggle_button_group_getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    pharos_toggle_button_group_defProp(target, key, result);
  return result;
};





const _allToggleButtonsSelector = '[data-pharos-component="PharosToggleButton"]';
class PharosToggleButtonGroup extends pharos_element/* PharosElement */.Z {
  constructor() {
    super(...arguments);
    this.groupLabel = "Options";
  }
  static get styles() {
    return [toggleButtonGroupStyles];
  }
  async firstUpdated() {
    this.addEventListener("pharos-toggle-button-selected", this._handleButtonSelected);
    this.addEventListener("keydown", this._handleKeydown);
    this.addEventListener("focusout", this._handleFocusout);
    const toggleButtons = Array.from(this._allToggleButtons);
    await Promise.all(toggleButtons.map((el) => el.updateComplete));
    this._selectInitialToggleButton(toggleButtons);
    const maxIdx = toggleButtons.length - 1;
    toggleButtons.forEach((button, idx) => {
      button["_first"] = idx === 0;
      button["_last"] = idx === maxIdx;
    });
  }
  _selectInitialToggleButton(toggleButtons) {
    const selected = this._selectedToggleButtons[0];
    const selectedButton = selected || toggleButtons[0];
    selectedButton.selected = true;
    selectedButton.pressed = "true";
  }
  _handleButtonSelected(event) {
    const selected = event.target;
    const previous = this.querySelector(
      `${_allToggleButtonsSelector}[selected]:not([id="${selected.id}"])`
    );
    if (previous) {
      previous.selected = false;
      previous.pressed = "false";
    }
    const toggleButtons = Array.prototype.slice.call(this._allToggleButtons);
    const selectIdx = toggleButtons.findIndex((button) => button.id === selected.id);
    toggleButtons.forEach((button, index) => {
      button["_hideLeftBorder"] = index === selectIdx + 1;
      button["_hideRightBorder"] = index === selectIdx - 1;
    });
  }
  _handleKeydown(event) {
    switch (event.key) {
      case "Right":
      case "ArrowRight":
        event.preventDefault();
        this._handleArrowKeys(true);
        break;
      case "Left":
      case "ArrowLeft":
        event.preventDefault();
        this._handleArrowKeys(false);
        break;
      case "Enter":
      case " ":
      case "Spacebar":
        event.preventDefault();
        this._handleEnterKey();
        break;
    }
  }
  async _handleArrowKeys(moveForward) {
    const toggleButtons = Array.prototype.slice.call(this._allToggleButtons);
    const focused = document.activeElement;
    if (!focused.matches(_allToggleButtonsSelector)) {
      return;
    }
    let index = toggleButtons.findIndex((button) => button.id === focused.id);
    index = moveForward ? index : Math.max(index, 0);
    const nextButtonIndex = modulo(index + (moveForward ? 1 : -1), toggleButtons.length);
    focused["_focused"] = false;
    const moveFocusTo = toggleButtons[nextButtonIndex];
    moveFocusTo["_focused"] = true;
    await moveFocusTo.updateComplete;
    moveFocusTo.focus();
  }
  _handleEnterKey() {
    const focused = document.activeElement;
    focused.click();
  }
  _handleFocusout(event) {
    if (event.relatedTarget && event.relatedTarget.matches('[data-pharos-component="PharosToggleButton"]')) {
      return;
    }
    this._allToggleButtons.forEach((button) => {
      button["_focused"] = button.hasAttribute("selected");
    });
  }
  render() {
    return lit/* html */.dy`
      <div class="toggle-button__list" role="group" aria-label="${this.groupLabel}">
        <slot></slot>
      </div>
    `;
  }
}
pharos_toggle_button_group_decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true, attribute: "group-label" })
], PharosToggleButtonGroup.prototype, "groupLabel", 2);
pharos_toggle_button_group_decorateClass([
  (0,decorators/* queryAssignedElements */.NH)({ selector: _allToggleButtonsSelector })
], PharosToggleButtonGroup.prototype, "_allToggleButtons", 2);
pharos_toggle_button_group_decorateClass([
  (0,decorators/* queryAssignedElements */.NH)({ selector: `${_allToggleButtonsSelector}[selected]` })
], PharosToggleButtonGroup.prototype, "_selectedToggleButtons", 2);

;// CONCATENATED MODULE: ./packages/pharos/src/utils/mixins/pharos-component.ts

const PharosComponentImplementation = (Base) => {
  class PharosComponent extends Base {
    connectedCallback() {
      super.connectedCallback && super.connectedCallback();
      this.dataset.pharosComponent = Base.name;
    }
  }
  return PharosComponent;
};
const PharosComponentMixin = (0,dedupeMixin/* dedupeMixin */.S)(PharosComponentImplementation);
/* harmony default export */ const pharos_component = (PharosComponentMixin);

;// CONCATENATED MODULE: ./packages/pharos/src/utils/registerComponents.ts

const registerComponents = (prefix, classes) => {
  classes.forEach((clazz) => {
    const kebab = clazz.name.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase();
    customElements.define(
      `${prefix ? prefix + "-" : ""}${kebab}`,
      class extends pharos_component(clazz) {
      }
    );
  });
};
/* harmony default export */ const utils_registerComponents = (registerComponents);

;// CONCATENATED MODULE: ./packages/pharos/src/test/initComponents.ts


utils_registerComponents("", [
  PharosAlert,
  PharosBreadcrumb,
  PharosBreadcrumbItem,
  pharos_button/* PharosButton */.b,
  PharosCheckbox,
  PharosCheckboxGroup,
  PharosCombobox,
  PharosDropdownMenu,
  PharosDropdownMenuItem,
  PharosDropdownMenuNav,
  PharosDropdownMenuNavLink,
  PharosFooter,
  PharosHeader,
  pharos_heading/* PharosHeading */.rW,
  pharos_icon/* PharosIcon */.b,
  PharosImageCard,
  PharosInputGroup,
  PharosInputGroupSelect,
  PharosLayout,
  pharos_link/* PharosLink */.G,
  PharosLoadingSpinner,
  modal_pharos_modal/* PharosModal */.d,
  PharosPagination,
  PharosProgressBar,
  PharosRadioButton,
  PharosRadioGroup,
  PharosSelect,
  PharosSidenav,
  PharosSidenavButton,
  PharosSidenavLink,
  PharosSidenavMenu,
  PharosSidenavSection,
  PharosTabs,
  PharosTab,
  PharosTabPanel,
  pharos_text_input/* PharosTextInput */.e,
  PharosTextarea,
  PharosToast,
  PharosToaster,
  PharosToastButton,
  PharosToggleButton,
  PharosToggleButtonGroup,
  PharosTooltip
]);

// EXTERNAL MODULE: ./node_modules/@storybook/addon-docs/dist/esm/index.js
var esm = __webpack_require__("./node_modules/@storybook/addon-docs/dist/esm/index.js");
// EXTERNAL MODULE: ./node_modules/@storybook/addon-viewport/dist/esm/preview.js + 1 modules
var preview = __webpack_require__("./node_modules/@storybook/addon-viewport/dist/esm/preview.js");
;// CONCATENATED MODULE: ./.storybook/a11yConfig.js
const a11yConfig = {
  options: {
    runOnly: {
      type: "tag",
      values: ["wcag2a", "wcag2aa", "wcag21a", "wcag21aa", "section508", "best-practice"]
    }
  }
};
/* harmony default export */ const _storybook_a11yConfig = (a11yConfig);

// EXTERNAL MODULE: ./node_modules/@storybook/theming/dist/esm/index.js
var dist_esm = __webpack_require__("./node_modules/@storybook/theming/dist/esm/index.js");
;// CONCATENATED MODULE: ./packages/pharos/lib/styles/variables.js
const PharosAssetIconAcademicContent = "assets/icons/academic-content.svg";
const PharosAssetIconAdd = "assets/icons/add.svg";
const PharosAssetIconArrowDown = "assets/icons/arrow-down.svg";
const PharosAssetIconArrowLeft = "assets/icons/arrow-left.svg";
const PharosAssetIconArrowRight = "assets/icons/arrow-right.svg";
const PharosAssetIconArrowUp = "assets/icons/arrow-up.svg";
const PharosAssetIconAttachment = "assets/icons/attachment.svg";
const PharosAssetIconBase = "assets/icons/base.svg";
const PharosAssetIconBook = "assets/icons/book.svg";
const PharosAssetIconCalendar = "assets/icons/calendar.svg";
const PharosAssetIconCheckmarkFilledCircle = "assets/icons/checkmark-filled-circle.svg";
const PharosAssetIconCheckmarkInverse = "assets/icons/checkmark-inverse.svg";
const PharosAssetIconCheckmarkSmall = "assets/icons/checkmark-small.svg";
const PharosAssetIconCheckmark = "assets/icons/checkmark.svg";
const PharosAssetIconChevronDown = "assets/icons/chevron-down.svg";
const PharosAssetIconChevronLeftLarge = "assets/icons/chevron-left-large.svg";
const PharosAssetIconChevronLeft = "assets/icons/chevron-left.svg";
const PharosAssetIconChevronRightLarge = "assets/icons/chevron-right-large.svg";
const PharosAssetIconChevronRight = "assets/icons/chevron-right.svg";
const PharosAssetIconChevronUp = "assets/icons/chevron-up.svg";
const PharosAssetIconCircle = "assets/icons/circle.svg";
const PharosAssetIconCite = "assets/icons/cite.svg";
const PharosAssetIconCloseInverse = "assets/icons/close-inverse.svg";
const PharosAssetIconClose = "assets/icons/close.svg";
const PharosAssetIconCollapse = "assets/icons/shift-right.svg";
const PharosAssetIconCopy = "assets/icons/copy.svg";
const PharosAssetIconDashSmall = "assets/icons/dash-small.svg";
const PharosAssetIconDelete = "assets/icons/delete.svg";
const PharosAssetIconDownload = "assets/icons/download.svg";
const PharosAssetIconEdit = "assets/icons/edit.svg";
const PharosAssetIconEllipsesHorizontal = "assets/icons/ellipses-horizontal.svg";
const PharosAssetIconEllipsesVertical = "assets/icons/ellipses-vertical.svg";
const PharosAssetIconEmail = "assets/icons/email.svg";
const PharosAssetIconExclamationInverse = "assets/icons/exclamation-inverse.svg";
const PharosAssetIconExclamation = "assets/icons/exclamation.svg";
const PharosAssetIconExpand = "assets/icons/shift-left.svg";
const PharosAssetIconFacebook = "assets/icons/facebook.svg";
const PharosAssetIconFiletypePdf = "assets/icons/filetype-pdf.svg";
const PharosAssetIconFiletypePpt = "assets/icons/filetype-ppt.svg";
const PharosAssetIconFiletypeZip = "assets/icons/filetype-zip.svg";
const PharosAssetIconFitToView = "assets/icons/fit-to-view.svg";
const PharosAssetIconFitToWidth = "assets/icons/fit-to-width.svg";
const PharosAssetIconFolderNew = "assets/icons/folder-new.svg";
const PharosAssetIconFolder = "assets/icons/folder.svg";
const PharosAssetIconFolderSelected = "assets/icons/folder-selected.svg";
const PharosAssetIconFullscreenMinimize = "assets/icons/fullscreen-minimize.svg";
const PharosAssetIconFullscreen = "assets/icons/fullscreen.svg";
const PharosAssetIconGoogleColor = "assets/icons/google-color.svg";
const PharosAssetIconGoogle = "assets/icons/google.svg";
const PharosAssetIconImage = "assets/icons/image.svg";
const PharosAssetIconInfoInverse = "assets/icons/info-inverse.svg";
const PharosAssetIconInstagram = "assets/icons/instagram.svg";
const PharosAssetIconLaptop = "assets/icons/laptop.svg";
const PharosAssetIconLinkAdd = "assets/icons/link-add.svg";
const PharosAssetIconLinkExternal = "assets/icons/link-external.svg";
const PharosAssetIconLink = "assets/icons/link.svg";
const PharosAssetIconLinkedin = "assets/icons/linkedin.svg";
const PharosAssetIconMenu = "assets/icons/menu.svg";
const PharosAssetIconMove = "assets/icons/move.svg";
const PharosAssetIconNew = "assets/icons/new.svg";
const PharosAssetIconPartialCircle = "assets/icons/partial-circle.svg";
const PharosAssetIconPrimarySource = "assets/icons/primary-source.svg";
const PharosAssetIconProfile = "assets/icons/profile.svg";
const PharosAssetIconQuestionInverse = "assets/icons/question-inverse.svg";
const PharosAssetIconSave = "assets/icons/save.svg";
const PharosAssetIconSaved = "assets/icons/saved.svg";
const PharosAssetIconSearch = "assets/icons/search.svg";
const PharosAssetIconShare = "assets/icons/share.svg";
const PharosAssetIconShiftLeft = "assets/icons/shift-left.svg";
const PharosAssetIconShiftRight = "assets/icons/shift-right.svg";
const PharosAssetIconShiftUp = "assets/icons/shift-up.svg";
const PharosAssetIconShiftDown = "assets/icons/shift-down.svg";
const PharosAssetIconTumblr = "assets/icons/tumblr.svg";
const PharosAssetIconTwitter = "assets/icons/twitter.svg";
const PharosAssetIconVideo = "assets/icons/video.svg";
const PharosAssetIconViewGallery = "assets/icons/view-gallery.svg";
const PharosAssetIconViewGrid = "assets/icons/view-grid.svg";
const PharosAssetIconViewList = "assets/icons/view-list.svg";
const PharosAssetIconWorkspace = "assets/icons/workspace.svg";
const PharosAssetIconWorkspaceSelected = "assets/icons/workspace-selected.svg";
const PharosAssetIconYoutube = "assets/icons/youtube.svg";
const PharosAssetIconZoomIn = "assets/icons/zoom-in.svg";
const PharosAssetIconZoomOut = "assets/icons/zoom-out.svg";
const PharosBreakpointSmall = "22.5rem";
const PharosBreakpointMedium = "48rem";
const PharosBreakpointLarge = "66rem";
const PharosBreakpointXlarge = "85rem";
const PharosBreakpointMax = "99rem";
const PharosColorJstorRed = "#990000";
const PharosColorNightBlue15 = "#071d46";
const PharosColorNightBlue60 = "#8091b3";
const PharosColorNightBlueBase = "#0d3071";
const PharosColorGlacierBlue40 = "#0ba3c1";
const PharosColorGlacierBlue70 = "#79deec";
const PharosColorGlacierBlue80 = "#b4dee4";
const PharosColorGlacierBlue90 = "#dcedef";
const PharosColorGlacierBlueBase = "#27cae1";
const PharosColorLivingCoral50 = "#c83737";
const PharosColorLivingCoral53 = "#dd3431";
const PharosColorLivingCoral80 = "#fc9c9c";
const PharosColorLivingCoral90 = "#f4d7d7";
const PharosColorLivingCoralBase = "#fb4848";
const PharosColorMarbleGray10 = "#1a1a19";
const PharosColorMarbleGray20 = "#343332";
const PharosColorMarbleGray40 = "#676765";
const PharosColorMarbleGray50 = "#81807e";
const PharosColorMarbleGray80 = "#d1cfc7";
const PharosColorMarbleGray94 = "#f2f1ed";
const PharosColorMarbleGray97 = "#f9f8f6";
const PharosColorMarbleGrayBase = "#eae8e1";
const PharosColorBlack = "#000000";
const PharosColorWhite = "#ffffff";
const PharosColorYellow97 = "#fdf9f2";
const PharosColorYellowBase = "#faa926";
const PharosColorGreen93 = "#e9f1eb";
const PharosColorGreenBase = "#268241";
const PharosColorInteractivePrimary = "#990000";
const PharosColorInteractiveSecondary = "#000000";
const PharosColorInteractiveTertiary = "#ffffff";
const PharosColorUi10 = "#ffffff";
const PharosColorUi20 = "#f2f1ed";
const PharosColorUi30 = "#eae8e1";
const PharosColorUi40 = "#d1cfc7";
const PharosColorUi50 = "#81807e";
const PharosColorDisabled = "#eae8e1";
const PharosColorOverlay = "#000000";
const PharosColorFeedbackError = "#dd3431";
const PharosColorFeedbackSuccess = "#268241";
const PharosColorFeedbackWarning = "#faa926";
const PharosColorFeedbackInfo = "#0ba3c1";
const PharosColorText10 = "#1a1a19";
const PharosColorText20 = "#343332";
const PharosColorText40 = "#676765";
const PharosColorText50 = "#81807e";
const PharosColorTextBase = "#000000";
const PharosColorTextDisabled = "#676765";
const PharosColorTextPlaceholder = "#676765";
const PharosColorTextWhite = "#ffffff";
const PharosColorFocus = "#0ba3c1";
const PharosColorHoverPrimary = "#990000";
const PharosColorHoverSecondary = "#ffffff";
const PharosColorHoverRow = "#f2f1ed";
const PharosAlertColorBackgroundBase = "#f2f1ed";
const PharosAlertColorBackgroundInfo = "#dcedef";
const PharosAlertColorBackgroundError = "#f4d7d7";
const PharosAlertColorBackgroundSuccess = "#e9f1eb";
const PharosAlertColorBackgroundWarning = "#fdf9f2";
const PharosAlertColorIconBase = "#000000";
const PharosAlertColorIconInfo = "#0ba3c1";
const PharosAlertColorIconError = "#dd3431";
const PharosAlertColorIconSuccess = "#268241";
const PharosAlertColorIconWarning = "#faa926";
const PharosAlertColorTextBase = "#000000";
const PharosAlertColorTextInverse = "#ffffff";
const PharosAlertColorLinkBase = "#000000";
const PharosAlertColorLinkInverse = "#ffffff";
const PharosAlertColorBorderBase = "#f2f1ed";
const PharosAlertColorBorderInfo = "#0ba3c1";
const PharosAlertColorBorderError = "#dd3431";
const PharosAlertColorBorderSuccess = "#268241";
const PharosAlertColorBorderWarning = "#faa926";
const PharosButtonPaddingBase = "0.25rem";
const PharosButtonPaddingCondensed = "0.125rem";
const PharosButtonPaddingLarge = "0.5rem";
const PharosButtonColorBasePrimaryBackgroundBase = "#990000";
const PharosButtonColorBasePrimaryBackgroundHover = "transparent";
const PharosButtonColorBasePrimaryBackgroundDisabled = "#eae8e1";
const PharosButtonColorBasePrimaryTextBase = "#ffffff";
const PharosButtonColorBasePrimaryTextHover = "#990000";
const PharosButtonColorBasePrimaryTextDisabled = "#676765";
const PharosButtonColorBasePrimaryBorderBase = "#990000";
const PharosButtonColorBasePrimaryBorderHover = "#990000";
const PharosButtonColorBasePrimaryBorderDisabled = "#eae8e1";
const PharosButtonColorBaseSecondaryBackgroundBase = "transparent";
const PharosButtonColorBaseSecondaryBackgroundHover = "transparent";
const PharosButtonColorBaseSecondaryBackgroundDisabled = "#eae8e1";
const PharosButtonColorBaseSecondaryTextBase = "#000000";
const PharosButtonColorBaseSecondaryTextHover = "#990000";
const PharosButtonColorBaseSecondaryTextDisabled = "#676765";
const PharosButtonColorBaseSecondaryBorderBase = "#d1cfc7";
const PharosButtonColorBaseSecondaryBorderHover = "#990000";
const PharosButtonColorBaseSecondaryBorderDisabled = "#eae8e1";
const PharosButtonColorBaseSubtleBackgroundBase = "transparent";
const PharosButtonColorBaseSubtleBackgroundHover = "#f2f1ed";
const PharosButtonColorBaseSubtleBackgroundDisabled = "transparent";
const PharosButtonColorBaseSubtleTextBase = "#000000";
const PharosButtonColorBaseSubtleTextHover = "#990000";
const PharosButtonColorBaseSubtleTextDisabled = "#676765";
const PharosButtonColorBaseSubtleBorderBase = "transparent";
const PharosButtonColorBaseSubtleBorderHover = "#f2f1ed";
const PharosButtonColorBaseSubtleBorderDisabled = "transparent";
const PharosButtonColorBaseOverlayBackgroundBase = "#1a1a19";
const PharosButtonColorBaseOverlayBackgroundHover = "#343332";
const PharosButtonColorBaseOverlayBackgroundDisabled = "#eae8e1";
const PharosButtonColorBaseOverlayTextBase = "#ffffff";
const PharosButtonColorBaseOverlayTextHover = "#ffffff";
const PharosButtonColorBaseOverlayTextDisabled = "#676765";
const PharosButtonColorBaseOverlayBorderBase = "#1a1a19";
const PharosButtonColorBaseOverlayBorderHover = "#343332";
const PharosButtonColorBaseOverlayBorderDisabled = "#eae8e1";
const PharosButtonColorOnBackgroundPrimaryBackgroundBase = "#990000";
const PharosButtonColorOnBackgroundPrimaryBackgroundHover = "transparent";
const PharosButtonColorOnBackgroundPrimaryBackgroundDisabled = "#343332";
const PharosButtonColorOnBackgroundPrimaryTextBase = "#ffffff";
const PharosButtonColorOnBackgroundPrimaryTextHover = "#ffffff";
const PharosButtonColorOnBackgroundPrimaryTextDisabled = "#81807e";
const PharosButtonColorOnBackgroundPrimaryBorderBase = "#990000";
const PharosButtonColorOnBackgroundPrimaryBorderHover = "#ffffff";
const PharosButtonColorOnBackgroundPrimaryBorderDisabled = "#343332";
const PharosButtonColorOnBackgroundSecondaryBackgroundBase = "transparent";
const PharosButtonColorOnBackgroundSecondaryBackgroundHover = "transparent";
const PharosButtonColorOnBackgroundSecondaryBackgroundDisabled = "#343332";
const PharosButtonColorOnBackgroundSecondaryTextBase = "#ffffff";
const PharosButtonColorOnBackgroundSecondaryTextHover = "#ffffff";
const PharosButtonColorOnBackgroundSecondaryTextDisabled = "#81807e";
const PharosButtonColorOnBackgroundSecondaryBorderBase = "#81807e";
const PharosButtonColorOnBackgroundSecondaryBorderHover = "#ffffff";
const PharosButtonColorOnBackgroundSecondaryBorderDisabled = "#343332";
const PharosButtonColorOnBackgroundSubtleBackgroundBase = "transparent";
const PharosButtonColorOnBackgroundSubtleBackgroundHover = "#343332";
const PharosButtonColorOnBackgroundSubtleBackgroundDisabled = "transparent";
const PharosButtonColorOnBackgroundSubtleTextBase = "#ffffff";
const PharosButtonColorOnBackgroundSubtleTextHover = "#ffffff";
const PharosButtonColorOnBackgroundSubtleTextDisabled = "#81807e";
const PharosButtonColorOnBackgroundSubtleBorderBase = "transparent";
const PharosButtonColorOnBackgroundSubtleBorderHover = "#343332";
const PharosButtonColorOnBackgroundSubtleBorderDisabled = "transparent";
const PharosButtonColorOnBackgroundOverlayBackgroundBase = "#1a1a19";
const PharosButtonColorOnBackgroundOverlayBackgroundHover = "#343332";
const PharosButtonColorOnBackgroundOverlayBackgroundDisabled = "#343332";
const PharosButtonColorOnBackgroundOverlayTextBase = "#ffffff";
const PharosButtonColorOnBackgroundOverlayTextHover = "#ffffff";
const PharosButtonColorOnBackgroundOverlayTextDisabled = "#81807e";
const PharosButtonColorOnBackgroundOverlayBorderBase = "#1a1a19";
const PharosButtonColorOnBackgroundOverlayBorderHover = "#343332";
const PharosButtonColorOnBackgroundOverlayBorderDisabled = "#343332";
const PharosCheckboxGroupSpacingVertical = "0.5rem";
const PharosCheckboxGroupSpacingHorizontal = "1.5rem";
const PharosCheckboxColorBackgroundBase = "#ffffff";
const PharosComboboxColorTextHover = "#990000";
const PharosComboboxColorTextSelected = "#000000";
const PharosComboboxColorIconClear = "#81807e";
const PharosComboboxColorIconDropdown = "#000000";
const PharosComboboxColorIconCheckmark = "#000000";
const PharosComboboxColorIconFocus = "#990000";
const PharosComboboxSizeHeightList = "15rem";
const PharosComboboxSizeHeightClear = "1.875rem";
const PharosDropdownMenuItemColorTextBase = "#000000";
const PharosDropdownMenuItemColorTextHover = "#990000";
const PharosDropdownMenuItemColorTextDisabled = "#676765";
const PharosDropdownMenuItemColorTextDescription = "#676765";
const PharosDropdownMenuItemColorBorderBase = "#d1cfc7";
const PharosDropdownMenuItemColorBackgroundBase = "#ffffff";
const PharosDropdownMenuItemColorBackgroundActive = "#eae8e1";
const PharosDropdownMenuItemColorBackgroundDisabled = "#eae8e1";
const PharosDropdownMenuItemColorBackgroundHover = "#f2f1ed";
const PharosDropdownMenuItemColorIconBase = "#000000";
const PharosDropdownMenuColorBorderBase = "#d1cfc7";
const PharosDropdownMenuSizeWidthMin = "9rem";
const PharosDropdownMenuSizeWidthMax = "17rem";
const PharosFormElementColorTextBase = "#000000";
const PharosFormElementColorTextRequired = "#dd3431";
const PharosFormElementColorTextInvalid = "#dd3431";
const PharosFormElementColorTextDisabled = "#676765";
const PharosFormElementColorTextPlaceholder = "#676765";
const PharosFormElementColorBackgroundDisabled = "#eae8e1";
const PharosFormElementColorBackgroundSelected = "#000000";
const PharosFormElementColorBorderBase = "#81807e";
const PharosFormElementColorBorderFocus = "#0ba3c1";
const PharosFormElementColorBorderInvalid = "#dd3431";
const PharosFormElementColorBorderDisabled = "#d1cfc7";
const PharosFormElementSizeTextLabel = "2";
const PharosFormElementSizeTextInput = "3";
const PharosLoadingSpinnerColorStrokePrimary = "#990000";
const PharosLoadingSpinnerColorStrokeSecondary = "#fb4848";
const PharosModalColorBackgroundContent = "#ffffff";
const PharosModalColorBorderContent = "#eae8e1";
const PharosModalColorIconClose = "#81807e";
const PharosModalColorIconFocus = "#990000";
const PharosModalSpacingBase = "2rem";
const PharosModalSizeWidthBase = "40rem";
const PharosRadioButtonColorBackgroundBase = "#ffffff";
const PharosRadioGroupSpacingVertical = "0.5rem";
const PharosRadioGroupSpacingHorizontal = "1.5rem";
const PharosTextInputColorIconValid = "#268241";
const PharosTextInputColorIconInvalid = "#dd3431";
const PharosTextareaSizeHeightBase = "3.5rem";
const PharosTooltipColorBackgroundBase = "#343332";
const PharosTooltipColorTextBase = "#ffffff";
const PharosTooltipSizeTextBase = "2";
const PharosFontFamilySansSerif = "GT America Standard, Helvetica, Helvetica Neue, Arial, Segoe UI, Roboto, Droid Sans, sans-serif";
const PharosFontFamilySerif = "Ivar Headline, Times, Georgia, serif";
const PharosFontFamilyBody = "GT America Standard, Helvetica, Helvetica Neue, Arial, Segoe UI, Roboto, Droid Sans, sans-serif";
const PharosFontWeightRegular = "400";
const PharosFontWeightBold = "700";
const PharosFontSizeMicro = "1";
const PharosFontSizeSmall = "2";
const PharosFontSizeBase = "3";
const PharosFontSizeLarge = "5";
const PharosFontSizeXlarge = "6";
const PharosLineHeightXsmall = "1rem";
const PharosLineHeightSmall = "1.25rem";
const PharosLineHeightMedium = "1.5rem";
const PharosLineHeightLarge = "1.75rem";
const PharosLineHeightXlarge = "2.25rem";
const PharosLineHeightHeadingLarge = "1";
const PharosLineHeightTextBaseCondensed = "1.25rem";
const PharosRadiusBaseStandard = "0.125rem";
const PharosSpacingOneEighthX = "0.125rem";
const PharosSpacingOneQuarterX = "0.25rem";
const PharosSpacingOneHalfX = "0.5rem";
const PharosSpacingThreeQuartersX = "0.75rem";
const PharosSpacing1X = "1rem";
const PharosSpacingOneAndAHalfX = "1.5rem";
const PharosSpacing2X = "2rem";
const PharosSpacing3X = "3rem";
const PharosSpacingThreeAndAHalfX = "3.5rem";
const PharosSpacing5X = "5rem";
const PharosSpacing7X = "7rem";
const PharosSpacing10X = "10rem";
const PharosSpacingGutter = "3rem";
const PharosTransitionBase = "250ms cubic-bezier(0.17, 0.67, 0.83, 0.67)";
const PharosTransitionDurationShorter = "50ms";
const PharosTransitionDurationShort = "100ms";
const PharosTransitionDurationDefault = "250ms";
const PharosTransitionDurationLong = "500ms";
const PharosTransitionDurationLonger = "1000ms";
const PharosTransitionCurveBase = "cubic-bezier(0.17, 0.67, 0.83, 0.67)";
const PharosTypeScale1 = "1";
const PharosTypeScale2 = "2";
const PharosTypeScale3 = "3";
const PharosTypeScale4 = "4";
const PharosTypeScale5 = "5";
const PharosTypeScale6 = "6";
const PharosTypeScale7 = "7";
const PharosTypeScale8 = "8";
const PharosTypeScale9 = "9";
const PharosTypeScale10 = "10";
const PharosTypeScale11 = "11";
const PharosTypeScale12 = "12";
const PharosTypeScale13 = "13";
const PharosTypeScale14 = "14";

;// CONCATENATED MODULE: ./.storybook/theme.js



/* harmony default export */ const theme = ((0,dist_esm/* create */.Ue)({
  base: "light",
  colorPrimary: PharosColorJstorRed,
  colorSecondary: PharosColorJstorRed,
  appBg: PharosColorWhite,
  appContentBg: PharosColorWhite,
  appBorderColor: PharosColorMarbleGray50,
  appBorderRadius: 4,
  fontBase: PharosFontFamilyBody,
  fontCode: "monospace",
  textColor: PharosColorBlack,
  textInverseColor: PharosColorWhite,
  barTextColor: PharosColorMarbleGray20,
  barSelectedColor: PharosColorBlack,
  barBg: PharosColorWhite,
  inputBg: PharosColorWhite,
  inputBorder: PharosColorMarbleGray50,
  inputTextColor: PharosColorBlack,
  inputBorderRadius: 4,
  brandTitle: "Pharos Storybook",
  brandUrl: "#",
  brandImage: "./images/jstor-logo.svg"
}));

;// CONCATENATED MODULE: ./.storybook/main/preview.js








window.process = window.process || {};
window.process.env = window.process.env || {};
window.process.env.NODE_ENV = window.process.env.NODE_ENV || "production";
(0,client.setCustomElements)(custom_elements_namespaceObject);
const parameters = {
  a11y: _storybook_a11yConfig,
  controls: { expanded: true },
  docs: {
    inlineStories: true,
    theme: theme,
    components: {
      Canvas: esm/* Canvas */.Xz
    }
  },
  viewport: {
    viewports: {
      ...preview/* MINIMAL_VIEWPORTS */.kp,
      ...preview/* INITIAL_VIEWPORTS */.p
    }
  },
  backgrounds: {
    default: "White",
    values: [
      {
        name: "White",
        value: "#FFFFFF"
      },
      {
        name: "Black",
        value: "#000000"
      }
    ]
  }
};

;// CONCATENATED MODULE: ./.storybook/wc/preview.js




window.process = window.process || {};
window.process.env = window.process.env || {};
window.process.env.NODE_ENV = window.process.env.NODE_ENV || "production";
(0,client.setCustomElementsManifest)(custom_elements_namespaceObject);


;// CONCATENATED MODULE: ./.storybook/wc/preview.js-generated-config-entry.js
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}


Object.keys(wc_preview_namespaceObject).forEach(function(key) {
  var value = wc_preview_namespaceObject[key];
  switch (key) {
    case "args": {
      return (0,ClientApi/* addArgs */.uc)(value);
    }
    case "argTypes": {
      return (0,ClientApi/* addArgTypes */.v9)(value);
    }
    case "decorators": {
      return value.forEach(function(decorator) {
        return (0,ClientApi/* addDecorator */.$9)(decorator, false);
      });
    }
    case "loaders": {
      return value.forEach(function(loader) {
        return (0,ClientApi/* addLoader */.HZ)(loader, false);
      });
    }
    case "parameters": {
      return (0,ClientApi/* addParameters */.h1)(_objectSpread({}, value), false);
    }
    case "argTypesEnhancers": {
      return value.forEach(function(enhancer) {
        return (0,ClientApi/* addArgTypesEnhancer */.My)(enhancer);
      });
    }
    case "argsEnhancers": {
      return value.forEach(function(enhancer) {
        return (0,ClientApi/* addArgsEnhancer */._C)(enhancer);
      });
    }
    case "render": {
      return (0,ClientApi/* setGlobalRender */.$P)(value);
    }
    case "globals":
    case "globalTypes": {
      var v = {};
      v[key] = value;
      return (0,ClientApi/* addParameters */.h1)(v, false);
    }
    case "__namedExportsOrder":
    case "decorateStory":
    case "renderToDOM": {
      return null;
    }
    default: {
      return console.log(key + " was not supported :( !");
    }
  }
});


/***/ }),

/***/ "./packages/pharos/src/components/alert/pharos-alert.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Closable": () => (/* binding */ Closable),
  "Error": () => (/* binding */ Error),
  "Info": () => (/* binding */ Info),
  "Success": () => (/* binding */ Success),
  "Warning": () => (/* binding */ Warning),
  "default": () => (/* binding */ pharos_alert_wc_stories)
});

// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./.storybook/docsPageConfig.jsx + 4 modules
var docsPageConfig = __webpack_require__("./.storybook/docsPageConfig.jsx");
;// CONCATENATED MODULE: ./packages/pharos/src/components/alert/storyArgs.ts
const argTypes = {
  status: {
    options: ["info", "success", "warning", "error"],
    control: { type: "inline-radio" }
  }
};
const defaultArgs = {
  status: "base",
  text: "I am an alert.",
  closable: false
};

;// CONCATENATED MODULE: ./packages/pharos/src/components/alert/pharos-alert.wc.stories.jsx



/* harmony default export */ const pharos_alert_wc_stories = ({
  title: "Components/Alert",
  component: "pharos-alert",
  parameters: {
    docs: {
      page: (0,docsPageConfig/* configureDocsPage */.k)("alert")
    }
  },
  argTypes: argTypes
});
const Base = {
  render: ({ status, text, closable }) => lit/* html */.dy`<pharos-alert status=${status} ?closable=${closable}>${text}</pharos-alert>`,
  args: defaultArgs
};
const Info = {
  ...Base,
  args: {
    status: "info",
    text: "There will be maintenance tomorrow."
  }
};
const Success = {
  ...Base,
  args: {
    status: "success",
    text: "Success!"
  }
};
const Warning = {
  render: ({ status, text, closable }) => lit/* html */.dy` <pharos-alert status=${status} ?closable=${closable}>
      <p class="alert-example__content">${text}</p>
      <p class="alert-example__content">See <pharos-link href="#">how to fix this</pharos-link>.</p>
    </pharos-alert>`,
  args: {
    status: "warning",
    text: "Your profile is incomplete."
  }
};
const Error = {
  render: ({ status, text, closable }) => lit/* html */.dy` <pharos-alert status=${status} ?closable=${closable}>
      <p class="alert-example__content">${text}</p>
      <p class="alert-example__content">
        For more information,
        <pharos-link href="#">read the documentation</pharos-link>.
      </p>
    </pharos-alert>`,
  args: {
    status: "error",
    text: "Your password didn't meet the minimum requirements."
  }
};
const Closable = {
  ...Error,
  args: {
    ...Error.args,
    closable: true
  }
};


/***/ }),

/***/ "./packages/pharos/src/components/breadcrumb/pharos-breadcrumb.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Base": () => (/* binding */ Base),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/lit/index.js");
/* harmony import */ var _config_docsPageConfig__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./.storybook/docsPageConfig.jsx");


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  title: "Components/Breadcrumb",
  component: "pharos-breadcrumb",
  parameters: {
    docs: {
      page: (0,_config_docsPageConfig__WEBPACK_IMPORTED_MODULE_1__/* .configureDocsPage */ .k)("breadcrumb")
    }
  }
});
const Base = {
  render: ({ firstCrumb, secondCrumb, thirdCrumb }) => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy` <pharos-breadcrumb>
      <pharos-breadcrumb-item href="#" id="firstBreadcrumb">${firstCrumb}</pharos-breadcrumb-item>
      <pharos-breadcrumb-item href="#" id="secondBreadcrumb">${secondCrumb}</pharos-breadcrumb-item>
      <pharos-breadcrumb-item id="thirdBreadcrumb">${thirdCrumb}</pharos-breadcrumb-item>
    </pharos-breadcrumb>`,
  args: {
    firstCrumb: "Hover to see the full text of long content, which are truncated",
    secondCrumb: "Short texts will not",
    thirdCrumb: "Current"
  }
};


/***/ }),

/***/ "./packages/pharos/src/components/button/pharos-button.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Base": () => (/* binding */ Base),
  "Forms": () => (/* binding */ Forms),
  "IconOnly": () => (/* binding */ IconOnly),
  "IconOnlyCondensed": () => (/* binding */ IconOnlyCondensed),
  "Large": () => (/* binding */ Large),
  "Link": () => (/* binding */ Link),
  "Variants": () => (/* binding */ Variants),
  "WithIcons": () => (/* binding */ WithIcons),
  "default": () => (/* binding */ pharos_button_wc_stories)
});

// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./node_modules/lit/directives/if-defined.js + 1 modules
var if_defined = __webpack_require__("./node_modules/lit/directives/if-defined.js");
// EXTERNAL MODULE: ./node_modules/@storybook/addon-actions/dist/esm/index.js + 8 modules
var esm = __webpack_require__("./node_modules/@storybook/addon-actions/dist/esm/index.js");
// EXTERNAL MODULE: ./.storybook/docsPageConfig.jsx + 4 modules
var docsPageConfig = __webpack_require__("./.storybook/docsPageConfig.jsx");
// EXTERNAL MODULE: ./packages/pharos/src/utils/iconNames.ts
var iconNames = __webpack_require__("./packages/pharos/src/utils/iconNames.ts");
;// CONCATENATED MODULE: ./packages/pharos/src/components/button/storyArgs.ts

const argTypes = {
  icon: {
    options: iconNames/* iconNames */.W,
    control: { type: "select" }
  },
  iconLeft: {
    options: iconNames/* iconNames */.W,
    control: { type: "select" }
  },
  iconRight: {
    options: iconNames/* iconNames */.W,
    control: { type: "select" }
  },
  pressed: {
    options: ["false", "true", "mixed", "undefined"],
    control: { type: "inline-radio" }
  },
  type: {
    options: ["button", "submit", "reset"],
    control: { type: "inline-radio" }
  },
  variant: {
    options: ["primary", "secondary", "subtle", "overlay"],
    control: { type: "inline-radio" }
  }
};
const defaultArgs = {
  text: "I am a button",
  autofocus: false,
  disabled: false,
  fullWidth: false,
  iconCondensed: false,
  large: false,
  onBackground: false,
  pressed: "undefined",
  type: "button",
  variant: "primary"
};

;// CONCATENATED MODULE: ./packages/pharos/src/components/button/pharos-button.wc.stories.jsx





/* harmony default export */ const pharos_button_wc_stories = ({
  title: "Components/Button",
  component: "pharos-button",
  parameters: {
    docs: {
      page: (0,docsPageConfig/* configureDocsPage */.k)("button")
    },
    options: { selectedPanel: "addon-controls" }
  },
  argTypes: argTypes
});
const Base = {
  render: (args) => lit/* html */.dy`
      <pharos-button
        ?disabled=${(0,if_defined/* ifDefined */.o)(args.disabled)}
        download=${(0,if_defined/* ifDefined */.o)(args.download)}
        icon=${(0,if_defined/* ifDefined */.o)(args.icon)}
        ?icon-condensed=${(0,if_defined/* ifDefined */.o)(args.iconCondensed)}
        icon-left=${(0,if_defined/* ifDefined */.o)(args.iconLeft)}
        icon-right=${(0,if_defined/* ifDefined */.o)(args.iconRight)}
        ?full-width=${(0,if_defined/* ifDefined */.o)(args.fullWidth)}
        href=${(0,if_defined/* ifDefined */.o)(args.href)}
        hreflang=${(0,if_defined/* ifDefined */.o)(args.hreflang)}
        label=${(0,if_defined/* ifDefined */.o)(args.label)}
        ?large=${(0,if_defined/* ifDefined */.o)(args.large)}
        ?on-background=${(0,if_defined/* ifDefined */.o)(args.onBackground)}
        ping=${(0,if_defined/* ifDefined */.o)(args.ping)}
        pressed=${(0,if_defined/* ifDefined */.o)(args.pressed)}
        target=${(0,if_defined/* ifDefined */.o)(args.target)}
        type=${(0,if_defined/* ifDefined */.o)(args.type)}
        variant=${(0,if_defined/* ifDefined */.o)(args.variant)}
        @click="${(e) => (0,esm.action)("Click")(e.target)}"
      >
        ${args.text}
      </pharos-button>
    `,
  args: defaultArgs
};
const Variants = {
  render: () => lit/* html */.dy`
      <div style="display: grid; grid-gap: 2rem; grid-template-columns: repeat(3, 200px);">
        <div style="padding: 1rem; display: grid; grid-gap: 1.5rem;">
          <pharos-button name="primary">Primary</pharos-button>
          <pharos-button name="secondary" variant="secondary">Secondary</pharos-button>
          <pharos-button name="subtle" variant="subtle">Subtle</pharos-button>
          <pharos-button name="overlay" variant="overlay">Overlay</pharos-button>
        </div>
        <div style="padding: 1rem; display: grid; grid-gap: 1.5rem;">
          <pharos-button name="primary-disabled" disabled>Primary</pharos-button>
          <pharos-button name="secondary-disabled" variant="secondary" disabled
            >Secondary</pharos-button
          >
          <pharos-button name="subtle-disabled" variant="subtle" disabled>Subtle</pharos-button>
          <pharos-button name="overlay-disabled" variant="overlay" disabled>Overlay</pharos-button>
        </div>
        <div style="background-color: #000000; padding: 1rem; display: grid; grid-gap: 1.5rem;">
          <pharos-button name="primary-on-background" on-background>Primary</pharos-button>
          <pharos-button name="secondary-on-background" variant="secondary" on-background
            >Secondary</pharos-button
          >
          <pharos-button name="subtle-on-background" variant="subtle" on-background
            >Subtle</pharos-button
          >
          <pharos-button name="overlay-on-background" variant="overlay" on-background
            >Overlay</pharos-button
          >
        </div>
      </div>
    `
};
const Large = {
  render: () => lit/* html */.dy`
      <div style="display: grid; grid-gap: 2rem; grid-template-columns: repeat(3, 200px);">
        <div style="padding: 1rem; display: grid; grid-gap: 1.5rem;">
          <pharos-button name="large-primary" large>Primary</pharos-button>
          <pharos-button name="large-secondary" variant="secondary" large>Secondary</pharos-button>
          <pharos-button name="large-subtle" variant="subtle" large>Subtle</pharos-button>
          <pharos-button name="large-overlay" variant="overlay" large>Overlay</pharos-button>
        </div>
        <div style="padding: 1rem; display: grid; grid-gap: 1.5rem;">
          <pharos-button name="large-primary-disabled" large disabled>Primary</pharos-button>
          <pharos-button name="large-secondary-disabled" variant="secondary" large disabled
            >Secondary
          </pharos-button>
          <pharos-button name="large-subtle-disabled" variant="subtle" large disabled
            >Subtle
          </pharos-button>
          <pharos-button name="large-overlay" variant="overlay" large disabled
            >Overlay
          </pharos-button>
        </div>
        <div style="background-color: #000000; padding: 1rem; display: grid; grid-gap: 1.5rem;">
          <pharos-button name="large-primary-on-background" large on-background
            >Primary
          </pharos-button>
          <pharos-button
            name="large-secondary-on-background"
            variant="secondary"
            large
            on-background
            >Secondary
          </pharos-button>
          <pharos-button name="large-subtle-on-background" variant="subtle" large on-background
            >Subtle
          </pharos-button>
          <pharos-button name="large-overlay" variant="overlay" large on-background
            >Overlay
          </pharos-button>
        </div>
      </div>
    `
};
const WithIcons = {
  render: () => lit/* html */.dy`
      <div style="display: grid; grid-gap: 2rem; grid-template-columns: repeat(3, 200px);">
        <div style="padding: 1rem; display: grid; grid-gap: 1.5rem;">
          <pharos-button name="primary-icon-left" icon-left="download">Icon left</pharos-button>
          <pharos-button name="primary-icon-right" icon-right="chevron-down"
            >Icon right
          </pharos-button>
          <pharos-button name="primary-icon-both" icon-right="chevron-down" icon-left="view-gallery"
            >Icon both
          </pharos-button>
        </div>
        <div style="padding: 1rem; display: grid; grid-gap: 1.5rem;">
          <pharos-button name="primary-icon-left-disabled" icon-left="download" disabled
            >Icon left
          </pharos-button>
          <pharos-button name="primary-icon-right-disabled" icon-right="chevron-down" disabled
            >Icon right
          </pharos-button>
          <pharos-button
            name="primary-icon-both-disabled"
            icon-right="chevron-down"
            icon-left="view-gallery"
            disabled
            >Icon both
          </pharos-button>
        </div>
        <div style="background-color: #000000; padding: 1rem; display: grid; grid-gap: 1.5rem;">
          <pharos-button name="primary-icon-left-on-background" icon-left="download" on-background
            >Icon left
          </pharos-button>
          <pharos-button
            name="primary-icon-right-on-background"
            icon-right="chevron-down"
            on-background
            >Icon right
          </pharos-button>
          <pharos-button
            name="primary-icon-both-on-background"
            icon-right="chevron-down"
            icon-left="view-gallery"
            on-background
            >Icon both
          </pharos-button>
        </div>
      </div>
    `
};
const IconOnly = {
  ...Base,
  name: "Icon only",
  args: {
    ...Base.args,
    text: void 0,
    icon: "download",
    label: "download"
  }
};
const IconOnlyCondensed = {
  ...IconOnly,
  name: "Icon only (condensed)",
  args: {
    ...IconOnly.args,
    iconCondensed: true
  }
};
const Link = {
  ...Base,
  args: {
    ...Base.args,
    href: "https://google.com",
    target: "_blank"
  }
};
const Forms = {
  render: () => lit/* html */.dy`
      <div style="display: grid; grid-gap: 1rem; grid-template-columns: 300px;">
        <form name="my-form" action="https://httpbin.org/post" method="POST">
          <pharos-text-input name="my-text-input" required>
            <span slot="label">Name</span>
          </pharos-text-input>
          <pharos-select name="my-select" required style="margin-top: 1.5rem">
            <span slot="label">Role</span>
            <option value="1">Student</option>
            <option value="2">Teacher</option>
            <option value="3" selected>Librarian</option>
          </pharos-select>
          <pharos-combobox name="my-combobox" value="2" required style="margin-top: 1.5rem">
            <span slot="label">State</span>
            <option value="1">New York</option>
            <option value="2">Michigan</option>
            <option value="3">New Jersey</option>
          </pharos-combobox>
          <pharos-radio-group name="my-radio-group" style="margin-top: 1.5rem">
            <span slot="legend">Degree</span>
            <pharos-radio-button value="1"
              ><span slot="label">Undergraduate</span></pharos-radio-button
            >
            <pharos-radio-button value="2"><span slot="label">Graduate</span></pharos-radio-button>
          </pharos-radio-group>
          <pharos-checkbox-group name="my-checkbox-group" style="margin-top: 1.5rem">
            <span slot="legend">Preferences</span>
            <pharos-checkbox value="1"
              ><span slot="label">Send me promotions and discounts</span></pharos-checkbox
            >
            <pharos-checkbox value="2" checked
              ><span slot="label">Send me weekly updates</span></pharos-checkbox
            >
          </pharos-checkbox-group>
          <pharos-textarea name="comments" style="margin-top: 1.5rem">
            <span slot="label">Comments</span>
          </pharos-textarea>
          <pharos-button type="reset" variant="secondary" style="margin-top: 1.5rem"
            >Reset
          </pharos-button>
          <pharos-button type="submit" style="margin-top: 1.5rem">Submit</pharos-button>
        </form>
      </div>
    `
};


/***/ }),

/***/ "./packages/pharos/src/components/checkbox-group/pharos-checkbox-group.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Base": () => (/* binding */ Base),
  "Events": () => (/* binding */ Events),
  "FormData": () => (/* binding */ FormData),
  "Validity": () => (/* binding */ Validity),
  "default": () => (/* binding */ pharos_checkbox_group_wc_stories)
});

// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./node_modules/@storybook/addon-actions/dist/esm/index.js + 8 modules
var esm = __webpack_require__("./node_modules/@storybook/addon-actions/dist/esm/index.js");
// EXTERNAL MODULE: ./packages/pharos/src/utils/createFormData.ts
var createFormData = __webpack_require__("./packages/pharos/src/utils/createFormData.ts");
// EXTERNAL MODULE: ./.storybook/docsPageConfig.jsx + 4 modules
var docsPageConfig = __webpack_require__("./.storybook/docsPageConfig.jsx");
;// CONCATENATED MODULE: ./packages/pharos/src/components/checkbox-group/storyArgs.ts
const defaultArgs = {
  disabled: false,
  hideLabel: false,
  horizontal: false,
  invalidated: false,
  message: "",
  required: false,
  validated: false
};

;// CONCATENATED MODULE: ./packages/pharos/src/components/checkbox-group/pharos-checkbox-group.wc.stories.jsx





/* harmony default export */ const pharos_checkbox_group_wc_stories = ({
  title: "Forms/Checkbox Group",
  component: "pharos-checkbox-group",
  subcomponents: { PharosCheckbox: "pharos-checkbox" },
  parameters: {
    options: { selectedPanel: "addon-controls" },
    docs: {
      page: (0,docsPageConfig/* configureDocsPage */.k)("checkbox")
    }
  }
});
const Base = {
  render: (args) => lit/* html */.dy` <pharos-checkbox-group
      ?disabled=${args.disabled}
      ?hide-label="${args.hideLabel}"
      ?horizontal=${args.horizontal}
      ?invalidated=${args.invalidated}
      .message="${args.message}"
      ?required=${args.required}
      ?validated=${args.validated}
    >
      <span slot="legend">Checkbox Group Header</span>
      <pharos-checkbox value="1"><span slot="label">Checkbox 1</span></pharos-checkbox>
      <pharos-checkbox value="2"><span slot="label">Checkbox 2</span></pharos-checkbox>
    </pharos-checkbox-group>`,
  args: defaultArgs
};
const Events = {
  render: () => lit/* html */.dy` <pharos-checkbox-group
      @change="${(e) => (0,esm.action)("Change")(JSON.stringify(e.target.value))}"
      name="checkbox-group2"
    >
      <span slot="legend">Checkbox Group Header</span>
      <pharos-checkbox value="1"><span slot="label">Checkbox 1</span></pharos-checkbox>
      <pharos-checkbox value="2"><span slot="label">Checkbox 2</span></pharos-checkbox>
      <pharos-checkbox value="3"><span slot="label">Checkbox 3</span></pharos-checkbox>
    </pharos-checkbox-group>`,
  args: {},
  parameters: { options: { selectedPanel: "addon-actions" } }
};
const Validity = {
  ...Base,
  args: {
    ...Base.args,
    required: true,
    invalidated: true,
    message: "This field is required, please make a selection"
  }
};
const FormData = {
  render: () => lit/* html */.dy` <form name="my-form" action="https://httpbin.org/post" method="POST">
      <pharos-checkbox-group
        @change="${(e) => (0,esm.action)("Change")(e.target.value)}"
        name="checkbox-group4"
        style="margin-bottom: 0.5rem;"
        required
      >
        <span slot="legend">Checkbox Group Header</span>
        <pharos-checkbox value="1"><span slot="label">Checkbox 1</span></pharos-checkbox>
        <pharos-checkbox value="2"><span slot="label">Checkbox 2</span></pharos-checkbox>
        <pharos-checkbox value="3"><span slot="label">Checkbox 3</span></pharos-checkbox>
      </pharos-checkbox-group>
      <pharos-button
        type="submit"
        value="Submit"
        @click="${(e) => {
    e.preventDefault();
    const form = document.querySelector('form[name="my-form"]');
    const formData = (0,createFormData/* default */.Z)(form);
    const xhr = new XMLHttpRequest();
    xhr.open("POST", "https://httpbin.org/post", true);
    xhr.onload = function() {
      const response = JSON.parse(this.responseText);
      (0,esm.action)("FormData")(JSON.stringify(response.form));
    };
    xhr.send(formData);
  }}"
        >Submit</pharos-button
      >
    </form>`,
  parameters: { options: { selectedPanel: "addon-actions" } }
};


/***/ }),

/***/ "./packages/pharos/src/components/checkbox/pharos-checkbox.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Base": () => (/* binding */ Base),
  "Events": () => (/* binding */ Events),
  "OnBackground": () => (/* binding */ OnBackground),
  "States": () => (/* binding */ States),
  "Validity": () => (/* binding */ Validity),
  "default": () => (/* binding */ pharos_checkbox_wc_stories)
});

// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./node_modules/@storybook/addon-actions/dist/esm/index.js + 8 modules
var esm = __webpack_require__("./node_modules/@storybook/addon-actions/dist/esm/index.js");
// EXTERNAL MODULE: ./.storybook/docsPageConfig.jsx + 4 modules
var docsPageConfig = __webpack_require__("./.storybook/docsPageConfig.jsx");
;// CONCATENATED MODULE: ./packages/pharos/src/components/checkbox/storyArgs.ts
const defaultArgs = {
  checked: false,
  disabled: false,
  hideLabel: false,
  indeterminate: false,
  invalidated: false,
  label: "I am a label",
  message: "",
  name: "",
  onBackground: false,
  required: false,
  validated: false,
  value: ""
};

;// CONCATENATED MODULE: ./packages/pharos/src/components/checkbox/pharos-checkbox.wc.stories.jsx




/* harmony default export */ const pharos_checkbox_wc_stories = ({
  title: "Forms/Checkbox",
  component: "pharos-checkbox",
  parameters: {
    docs: { page: (0,docsPageConfig/* configureDocsPage */.k)("checkbox") },
    options: {
      selectedPanel: "addon-controls"
    }
  }
});
const Base = {
  render: (args) => lit/* html */.dy`<pharos-checkbox
      ?checked=${args.checked}
      ?disabled=${args.disabled}
      ?hide-label=${args.hideLabel}
      ?required=${args.required}
      ?invalidated=${args.invalidated}
      .message=${args.message}
    >
      <span slot="label">${args.label}</span>
    </pharos-checkbox>`,
  args: defaultArgs
};
const States = {
  render: () => lit/* html */.dy`
      <div>
        <pharos-checkbox name="one"><span slot="label">Normal Checkbox</span></pharos-checkbox>
      </div>
      <div>
        <pharos-checkbox name="two" disabled
          ><span slot="label">Disabled Checkbox</span></pharos-checkbox
        >
      </div>
      <div>
        <pharos-checkbox name="three" checked><span slot="label">Checked</span></pharos-checkbox>
      </div>
      <div>
        <pharos-checkbox name="four" checked disabled
          ><span slot="label">Checked & Disabled</span></pharos-checkbox
        >
      </div>
      <div>
        <pharos-checkbox name="five" checked>
          <div slot="label">
            <div>Multiple lined</div>
            <div>Checkbox</div>
          </div>
        </pharos-checkbox>
      </div>
      <div>
        <pharos-checkbox name="six" invalidated
          ><span slot="label">Error checkbox</span></pharos-checkbox
        >
      </div>
      <div>
        <pharos-checkbox name="seven"
          ><span slot="label"
            >Label with a <pharos-link href="#">link</pharos-link></span
          ></pharos-checkbox
        >
      </div>
      <div>
        <pharos-checkbox name="eight" indeterminate
          ><span slot="label">Indeterminate checkbox</span></pharos-checkbox
        >
      </div>
    `
};
const Events = {
  render: () => lit/* html */.dy` <pharos-checkbox
      value="My value"
      @change="${(e) => (0,esm.action)("Change")(e.target.checked)}"
      @input="${(e) => (0,esm.action)("Input")(e.target.value)}"
      @click="${(e) => (0,esm.action)("Click")(e.target.checked)}"
    >
      <span slot="label">I fire events</span>
    </pharos-checkbox>`,
  parameters: {
    options: { selectedPanel: "addon-actions" }
  }
};
const Validity = {
  ...Base,
  args: {
    ...Base.args,
    required: true,
    invalidated: true,
    message: "This field is required, please make a selection"
  }
};
const OnBackground = {
  name: "On background",
  render: () => lit/* html */.dy`
      <div style="background-color: #000000; padding: 1rem;">
        <pharos-checkbox name="on-background" on-background>
          <span slot="label">Unchecked</span>
        </pharos-checkbox>
      </div>
      <div style="background-color: #000000; padding: 1rem;">
        <pharos-checkbox name="on-background" on-background checked>
          <span slot="label">Checked</span>
        </pharos-checkbox>
      </div>
      <div style="background-color: #000000; padding: 1rem;">
        <pharos-checkbox name="indeterminate" on-background indeterminate>
          <span slot="label">Indeterminate</span>
        </pharos-checkbox>
      </div>
    `
};


/***/ }),

/***/ "./packages/pharos/src/components/combobox/pharos-combobox.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Base": () => (/* binding */ Base),
  "Events": () => (/* binding */ Events),
  "FormData": () => (/* binding */ FormData),
  "SearchMode": () => (/* binding */ SearchMode),
  "States": () => (/* binding */ States),
  "Validity": () => (/* binding */ Validity),
  "default": () => (/* binding */ pharos_combobox_wc_stories)
});

// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./node_modules/@storybook/addon-actions/dist/esm/index.js + 8 modules
var esm = __webpack_require__("./node_modules/@storybook/addon-actions/dist/esm/index.js");
// EXTERNAL MODULE: ./node_modules/lit/directives/if-defined.js + 1 modules
var if_defined = __webpack_require__("./node_modules/lit/directives/if-defined.js");
// EXTERNAL MODULE: ./packages/pharos/src/utils/createFormData.ts
var createFormData = __webpack_require__("./packages/pharos/src/utils/createFormData.ts");
// EXTERNAL MODULE: ./.storybook/docsPageConfig.jsx + 4 modules
var docsPageConfig = __webpack_require__("./.storybook/docsPageConfig.jsx");
;// CONCATENATED MODULE: ./packages/pharos/src/components/combobox/storyArgs.ts
const defaultArgs = {
  disabled: false,
  hideLabel: false,
  invalidated: false,
  label: "Combobox Label",
  message: "",
  name: "",
  open: false,
  placeholder: "",
  required: false,
  validated: false,
  value: ""
};

;// CONCATENATED MODULE: ./packages/pharos/src/components/combobox/pharos-combobox.wc.stories.jsx






/* harmony default export */ const pharos_combobox_wc_stories = ({
  title: "Forms/Combobox",
  component: "pharos-combobox",
  parameters: {
    docs: {
      page: (0,docsPageConfig/* configureDocsPage */.k)("combobox")
    },
    options: { selectedPanel: "addon-controls" },
    controls: { expanded: true }
  }
});
const Base = {
  render: (args) => lit/* html */.dy`
      <pharos-combobox
        .value=${(0,if_defined/* ifDefined */.o)(args.value)}
        .name=${(0,if_defined/* ifDefined */.o)(args.name)}
        ?open=${args.open}
        ?disabled=${args.disabled}
        ?hide-label=${args.hideLabel}
        ?invalidated=${args.invalidated}
        ?validated=${args.validated}
        .placeholder=${(0,if_defined/* ifDefined */.o)(args.placeholder)}
        message=${(0,if_defined/* ifDefined */.o)(args.message)}
        ?required=${args.required}
        style="display: grid; grid-template-columns: 300px;"
      >
        <span slot="label">${args.label}</span>
        <option value="1">New Hampshire</option>
        <option value="2">Massachusetts</option>
        <option value="3">Connecticut</option>
        <option value="4">Rhode Island</option>
        <option value="5">New York</option>
        <option value="6">New Jersey</option>
        <option value="7">Pennsylvania</option>
        <option value="8">Delaware</option>
        <option value="9">Maryland</option>
        <option value="10">Virginia</option>
        <option value="11">North Carolina</option>
        <option value="12">South Carolina</option>
        <option value="13">Georgia</option>
      </pharos-combobox>
    `,
  args: defaultArgs
};
const States = {
  render: () => lit/* html */.dy`
      <div style="display: grid; grid-gap: 7rem; grid-template-columns: repeat(2, 300px);">
        <pharos-combobox name="default">
          <span slot="label">I am empty</span>
          <option value="1">Option 1</option>
          <option value="2">Option 2</option>
          <option value="3">Option 3</option>
        </pharos-combobox>
        <pharos-combobox name="disabled" disabled>
          <span slot="label">I am disabled</span>
          <option value="1">Option 1</option>
          <option value="2">Option 2</option>
          <option value="3">Option 3</option>
        </pharos-combobox>
        <pharos-combobox name="placeholder" placeholder="Enter some text">
          <span slot="label">I have a placeholder</span>
          <option value="1">Option 1</option>
          <option value="2">Option 2</option>
          <option value="3">Option 3</option>
        </pharos-combobox>
        <pharos-combobox name="provided" value="2">
          <span slot="label">I have a value provided</span>
          <option value="1">Option 1</option>
          <option value="2">Option 2</option>
          <option value="3">Option 3</option>
        </pharos-combobox>
        <pharos-combobox name="hidden" hide-label>
          <span slot="label">My label is hidden</span>
          <option value="1">Option 1</option>
          <option value="2">Option 2</option>
          <option value="3">Option 3</option>
        </pharos-combobox>
      </div>
    `
};
const Events = {
  render: () => lit/* html */.dy`
      <div style="display: grid; grid-template-columns: 300px;">
        <pharos-combobox
          placeholder="Select a state"
          @change="${(e) => (0,esm.action)("Change")(e.target.value)}"
          @input="${(e) => (0,esm.action)("Input")(e.target["_input"].value)}"
        >
          <span slot="label">Events fire on selection</span>
          <option value="NH">New Hampshire</option>
          <option value="MA">Massachusetts</option>
          <option value="CT">Connecticut</option>
          <option value="RI">Rhode Island</option>
          <option value="NY">New York</option>
          <option value="NJ">New Jersey</option>
          <option value="PA">Pennsylvania</option>
          <option value="DE">Delaware</option>
          <option value="MD">Maryland</option>
          <option value="VA">Virginia</option>
          <option value="NC">North Carolina</option>
          <option value="SC">South Carolina</option>
          <option value="GA">Georgia</option>
        </pharos-combobox>
      </div>
    `,
  parameters: {
    options: { selectedPanel: "addon-actions" }
  }
};
const SearchMode = {
  render: () => lit/* html */.dy`
      <pharos-combobox
        placeholder="Search..."
        search-mode
        style="display: grid; grid-template-columns: 300px;"
      >
        <span slot="label">I'm searching for</span>
        <option value="1">Option 1</option>
        <option value="2">Option 2</option>
        <option value="3">Option 3</option>
      </pharos-combobox>
    `
};
const Validity = {
  render: (args) => lit/* html */.dy`
      <div style="display: grid; grid-template-columns: 300px;">
        <pharos-combobox
          name="my-combobox"
          placeholder="Enter some text"
          @change="${(e) => (0,esm.action)("Change")(e.target.value)}"
          @input="${(e) => (0,esm.action)("Input")(e.target["_input"].value)}"
          ?required="${args.required}"
          ?invalidated="${args.invalidated}"
          ?validated="${args.validated}"
          message="${args.message}"
        >
          <span slot="label">Test me out</span>
          <option value="1">Option 1</option>
          <option value="2">Option 2</option>
          <option value="3">Option 3</option>
        </pharos-combobox>
      </div>
    `,
  args: {
    required: true,
    invalidated: true,
    validated: false,
    message: "This field is required, please make a selection"
  }
};
const FormData = {
  render: () => lit/* html */.dy`
      <div style="display: grid; grid-template-columns: 300px;">
        <form name="my-form" action="https://httpbin.org/post" method="POST">
          <pharos-combobox
            name="my-combobox"
            style="margin-bottom: 0.5rem;"
            placeholder="Enter some text"
            @change="${(e) => (0,esm.action)("Change")(e.target.value)}"
            @input="${(e) => (0,esm.action)("Input")(e.target["_input"].value)}"
            required
          >
            <span slot="label">Test me out</span>
            <option value="1">Option 1</option>
            <option value="2">Option 2</option>
            <option value="3">Option 3</option>
          </pharos-combobox>
          <pharos-button
            type="submit"
            value="Submit"
            @click="${(e) => {
    e.preventDefault();
    const form = document.querySelector('form[name="my-form"]');
    const formData = (0,createFormData/* default */.Z)(form);
    const xhr = new XMLHttpRequest();
    xhr.open("POST", "https://httpbin.org/post", true);
    xhr.onload = function() {
      const response = JSON.parse(this.responseText);
      (0,esm.action)("FormData")(JSON.stringify(response.form));
    };
    xhr.send(formData);
  }}"
          >
            Submit
          </pharos-button>
        </form>
      </div>
    `
};


/***/ }),

/***/ "./packages/pharos/src/components/dropdown-menu-nav/pharos-dropdown-menu-nav.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Base": () => (/* binding */ Base),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/lit/index.js");
/* harmony import */ var _config_docsPageConfig__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./.storybook/docsPageConfig.jsx");


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  title: "Components/Dropdown Menu Nav",
  component: "pharos-dropdown-menu-nav",
  subcomponents: {
    PharosDropdownMenuNavLink: "pharos-dropdown-menu-nav-link",
    PharosDropdownMenu: "pharos-dropdown-menu",
    PharosDropdownMenuItem: "pharos-dropdown-menu-item"
  },
  parameters: {
    docs: { page: (0,_config_docsPageConfig__WEBPACK_IMPORTED_MODULE_1__/* .configureDocsPage */ .k)("dropdown-menu-nav") }
  }
});
const Base = {
  render: () => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
      <pharos-dropdown-menu-nav>
        <pharos-dropdown-menu-nav-link
          href="#"
          id="category1-link"
          data-dropdown-menu-id="category1-menu"
          data-dropdown-menu-hover
          target="_blank"
          >Category 1</pharos-dropdown-menu-nav-link
        >
        <pharos-dropdown-menu id="category1-menu" data-dropdown-menu-hover>
          <pharos-dropdown-menu-item>Item 1.1</pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item>Item 1.2</pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item>Item 1.3</pharos-dropdown-menu-item>
        </pharos-dropdown-menu>
        <pharos-dropdown-menu-nav-link
          href="#"
          id="category2-link"
          data-dropdown-menu-id="category2-menu"
          data-dropdown-menu-hover
          target="_blank"
          >Category 2</pharos-dropdown-menu-nav-link
        >
        <pharos-dropdown-menu id="category2-menu">
          <pharos-dropdown-menu-item>Item 2.1</pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item>Item 2.2</pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item>Item 2.3</pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item>Item 2.4</pharos-dropdown-menu-item>
        </pharos-dropdown-menu>
        <pharos-dropdown-menu-nav-link href="#" id="other-link" target="_blank"
          >Link</pharos-dropdown-menu-nav-link
        >
      </pharos-dropdown-menu-nav>
    `,
  parameters: { chromatic: { viewports: [320, 1200] } }
};


/***/ }),

/***/ "./packages/pharos/src/components/dropdown-menu/pharos-dropdown-menu.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Base": () => (/* binding */ Base),
  "Composition": () => (/* binding */ Composition),
  "CoordinatingDropdowns": () => (/* binding */ CoordinatingDropdowns),
  "Descriptions": () => (/* binding */ Descriptions),
  "Events": () => (/* binding */ Events),
  "FullWidth": () => (/* binding */ FullWidth),
  "Icons": () => (/* binding */ Icons),
  "Links": () => (/* binding */ Links),
  "MultipleDynamicTriggers": () => (/* binding */ MultipleDynamicTriggers),
  "MultipleTriggers": () => (/* binding */ MultipleTriggers),
  "default": () => (/* binding */ pharos_dropdown_menu_wc_stories)
});

// EXTERNAL MODULE: ./node_modules/@storybook/addon-actions/dist/esm/index.js + 8 modules
var esm = __webpack_require__("./node_modules/@storybook/addon-actions/dist/esm/index.js");
// EXTERNAL MODULE: ./node_modules/@storybook/addons/dist/esm/hooks.js
var hooks = __webpack_require__("./node_modules/@storybook/addons/dist/esm/hooks.js");
// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./.storybook/docsPageConfig.jsx + 4 modules
var docsPageConfig = __webpack_require__("./.storybook/docsPageConfig.jsx");
;// CONCATENATED MODULE: ./packages/pharos/src/components/dropdown-menu/storyArgs.ts
const defaultArgs = {
  open: false,
  showSelected: false,
  fullWidth: false
};

;// CONCATENATED MODULE: ./packages/pharos/src/components/dropdown-menu/pharos-dropdown-menu.wc.stories.jsx





/* harmony default export */ const pharos_dropdown_menu_wc_stories = ({
  title: "Components/Dropdown Menu",
  component: "pharos-dropdown-menu",
  subcomponents: { PharosDropdownMenuItem: "pharos-dropdown-menu-item" },
  parameters: {
    docs: { page: (0,docsPageConfig/* configureDocsPage */.k)("dropdown-menu") },
    options: { selectedPanel: "addon-controls" },
    chromatic: { delay: 800 }
  }
});
const Base = {
  render: () => lit/* html */.dy`
      <div style="display: grid; grid-gap: 8rem; margin-top: 5rem; justify-content: space-evenly;">
        <pharos-button id="my-button" data-dropdown-menu-id="my-menu" icon-right="chevron-down"
          >Click Me</pharos-button
        >
        <pharos-dropdown-menu id="my-menu">
          <pharos-dropdown-menu-item>Menu item 1</pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item>Menu item 2</pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item>Menu item 3</pharos-dropdown-menu-item>
        </pharos-dropdown-menu>
      </div>
    `,
  args: defaultArgs
};
const Events = {
  render: () => lit/* html */.dy`
      <div style="display: grid; grid-gap: 8rem; margin-top: 5rem; justify-content: space-evenly;">
        <pharos-button
          id="my-button-events"
          data-dropdown-menu-id="my-menu-events"
          icon-right="chevron-down"
        >
          Click Me
        </pharos-button>
        <pharos-dropdown-menu
          id="my-menu-events"
          show-selected
          @pharos-dropdown-menu-select="${(e) => (0,esm.action)("Select")(e.detail)}"
          @pharos-dropdown-menu-selected="${(e) => (0,esm.action)("Selected")(e.detail)}"
        >
          <pharos-dropdown-menu-item>Menu item 1</pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item>Menu item 2</pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item>Menu item 3</pharos-dropdown-menu-item>
        </pharos-dropdown-menu>
      </div>
    `,
  parameters: { options: { selectedPanel: "addon-actions" } }
};
const Icons = {
  render: () => {
    const effect = () => {
      (0,hooks/* useEffect */.d4)(() => {
        setTimeout(() => {
          document.querySelector("#my-button-icons").click();
        }, 700);
      });
    };
    effect();
    return lit/* html */.dy`
      <div style="display: grid; grid-gap: 8rem; margin-top: 5rem; justify-content: space-evenly;">
        <pharos-button
          id="my-button-icons"
          data-dropdown-menu-id="my-menu-icons"
          icon-right="chevron-down"
        >
          With icons
        </pharos-button>
        <pharos-dropdown-menu id="my-menu-icons" show-selected>
          <pharos-dropdown-menu-item icon="view-gallery">Item one</pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item icon="view-list" selected>Item two</pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item icon="image">Item three</pharos-dropdown-menu-item>
        </pharos-dropdown-menu>
      </div>
    `;
  }
};
const Descriptions = {
  render: () => {
    const effect = () => {
      (0,hooks/* useEffect */.d4)(() => {
        setTimeout(() => {
          document.querySelector("#my-button-descriptions").click();
        }, 700);
      });
    };
    effect();
    return lit/* html */.dy`
      <div style="display: grid; grid-gap: 8rem; margin-top: 5rem; justify-content: space-evenly;">
        <pharos-button
          id="my-button-descriptions"
          data-dropdown-menu-id="my-menu-descriptions"
          icon-right="chevron-down"
        >
          With descriptions
        </pharos-button>
        <pharos-dropdown-menu id="my-menu-descriptions" show-selected>
          <pharos-dropdown-menu-item selected>
            Item 1
            <span slot="description">Description for item 1</span>
          </pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item>
            Item 2
            <span slot="description">Description for item 2</span>
          </pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item>
            Item 3
            <span slot="description">Description for item 3</span>
          </pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item>
            Item 4
            <span slot="description">Description for item 4</span>
          </pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item disabled>
            Disabled
            <span slot="description">This item has been disabled</span>
          </pharos-dropdown-menu-item>
        </pharos-dropdown-menu>
      </div>
    `;
  }
};
const FullWidth = {
  render: () => {
    const effect = () => {
      (0,hooks/* useEffect */.d4)(() => {
        setTimeout(() => {
          document.querySelector("#my-button-full").click();
        }, 700);
      });
    };
    effect();
    return lit/* html */.dy`
      <div style="display: grid; grid-gap: 8rem; margin-top: 5rem; justify-content: space-evenly;">
        <pharos-button
          id="my-button-full"
          data-dropdown-menu-id="my-menu-full"
          icon-right="chevron-down"
        >
          With attribute full-width to match the width of the trigger
        </pharos-button>
        <pharos-dropdown-menu id="my-menu-full" full-width>
          <pharos-dropdown-menu-item>
            Use full-width to display lengthy text
          </pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item>
            <span style="white-space: normal">
              Even if longer text is placed in the item, it will span multiple lines to keep the
              width of the item the same size as the trigger
            </span>
          </pharos-dropdown-menu-item>
        </pharos-dropdown-menu>
      </div>
    `;
  }
};
const Links = {
  render: () => {
    const effect = () => {
      (0,hooks/* useEffect */.d4)(() => {
        setTimeout(() => {
          document.querySelector("#my-link").dispatchEvent(new Event("mouseenter"));
        }, 700);
      });
    };
    effect();
    return lit/* html */.dy`
      <div style="display: grid; grid-gap: 8rem; margin-top: 5rem; justify-content: space-evenly;">
        <pharos-link
          id="my-link"
          href="https://www.google.com/"
          target="_blank"
          data-dropdown-menu-id="my-menu-links"
          data-dropdown-menu-hover
        >
          With links
        </pharos-link>
        <pharos-dropdown-menu id="my-menu-links">
          <pharos-dropdown-menu-item
            link="https://www.youtube.com/watch?v=gkTb9GP9lVI"
            target="_blank"
            >Menu item 1</pharos-dropdown-menu-item
          >
          <pharos-dropdown-menu-item
            link="https://www.youtube.com/watch?v=ZXsQAXx_ao0"
            target="_blank"
            >Menu item 2</pharos-dropdown-menu-item
          >
          <pharos-dropdown-menu-item
            link="https://www.youtube.com/watch?v=dQw4w9WgXcQ"
            target="_blank"
            >Menu item 3</pharos-dropdown-menu-item
          >
        </pharos-dropdown-menu>
      </div>
    `;
  }
};
const MultipleTriggers = {
  render: () => lit/* html */.dy`
      <div
        style="display: grid; grid-template-columns: repeat(3, auto); grid-gap: 8rem; margin-top: 5rem; justify-content: space-evenly;"
      >
        <pharos-button data-dropdown-menu-id="my-menu-multiple" icon-right="chevron-down">
          Click Me
        </pharos-button>
        <pharos-dropdown-menu id="my-menu-multiple">
          <pharos-dropdown-menu-item>Item 1</pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item>Item 2</pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item>Item 3</pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item>Item 4</pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item>Item 5</pharos-dropdown-menu-item>
        </pharos-dropdown-menu>
        <pharos-button
          data-dropdown-menu-id="my-menu-multiple"
          data-dropdown-menu-hover
          icon-right="chevron-down"
        >
          Hover here
        </pharos-button>
        <pharos-button data-dropdown-menu-id="my-menu-multiple" icon-right="chevron-down">
          Click Me Too
        </pharos-button>
      </div>
    `
};
const MultipleDynamicTriggers = {
  render: () => lit/* html */.dy`
      <div
        style="display: grid; grid-template-columns: repeat(3, auto); grid-gap: 8rem; margin-top: 5rem; justify-content: space-evenly;"
      >
        <pharos-dropdown-menu id="my-menu-multiple-dynamic-triggers">
          <pharos-dropdown-menu-item>Item 1</pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item>Item 2</pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item>Item 3</pharos-dropdown-menu-item>
        </pharos-dropdown-menu>
        <pharos-button
          @click="${(e) => {
    const trigger = e.target;
    const menu = document.querySelector("#my-menu-multiple-dynamic-triggers");
    menu.openWithTrigger(trigger);
  }}"
        >
          One
        </pharos-button>
        <pharos-button
          @click="${(e) => {
    const trigger = e.target;
    const menu = document.querySelector("#my-menu-multiple-dynamic-triggers");
    menu.openWithTrigger(trigger);
  }}"
        >
          Two
        </pharos-button>
        <pharos-button
          @click="${(e) => {
    const trigger = e.target;
    const menu = document.querySelector("#my-menu-multiple-dynamic-triggers");
    menu.openWithTrigger(trigger);
  }}"
        >
          Three
        </pharos-button>
      </div>
    `
};
const Composition = {
  render: () => {
    const effect = () => {
      (0,hooks/* useEffect */.d4)(() => {
        setTimeout(() => {
          document.querySelector("#my-button-composition").click();
        }, 700);
      });
    };
    effect();
    return lit/* html */.dy`
      <div style="display: grid; grid-gap: 8rem; margin-top: 5rem; justify-content: space-evenly;">
        <pharos-button
          id="my-button-composition"
          data-dropdown-menu-id="my-menu-composition"
          icon-right="chevron-down"
        >
          Save
        </pharos-button>
        <pharos-dropdown-menu id="my-menu-composition">
          <div
            style="padding: 1rem; padding-bottom: 0.5rem; border-bottom: 1px solid var(--pharos-dropdown-menu-item-color-border-base)"
          >
            <pharos-heading level="1" preset="2">Save to...</pharos-heading>
          </div>
          <pharos-dropdown-menu-item>Workspace</pharos-dropdown-menu-item>
          <div style="margin: 0.5rem 1rem; display: flex; flex-grow: 1; flex-direction: column;">
            <pharos-text-input hide-label placeholder="New folder name" style="margin: 0.5rem 0"
              ><span slot="label">My label is hidden</span></pharos-text-input
            >
            <div style="display: flex; align-items: center;">
              <pharos-button
                type="button"
                style="margin-right: auto"
                @click="${() => {
      const menu = document.querySelector("pharos-dropdown-menu");
      menu.open = false;
    }}"
              >
                Create
              </pharos-button>
              <pharos-button
                type="button"
                variant="secondary"
                style="margin-left: auto"
                @click="${() => {
      const menu = document.querySelector("pharos-dropdown-menu");
      menu.open = false;
    }}"
              >
                Cancel
              </pharos-button>
            </div>
          </div>
        </pharos-dropdown-menu>
      </div>
    `;
  }
};
const CoordinatingDropdowns = {
  render: () => lit/* html */.dy`
      <div style="display: grid; grid-gap: 8rem; margin-top: 5rem; justify-content: space-evenly;">
        <pharos-button
          id="coordinating-dropdown-trigger-button"
          data-dropdown-menu-id="first-dropdown"
        >
          Click Me
        </pharos-button>
        <pharos-dropdown-menu
          id="first-dropdown"
          @pharos-dropdown-menu-selected="${() => {
    const triggerElement = document.querySelector("#coordinating-dropdown-trigger-button");
    const secondDropdown = document.querySelector("#second-dropdown");
    secondDropdown.openWithTrigger(triggerElement);
  }}"
        >
          <pharos-dropdown-menu-item>Click</pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item>any of these</pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item>options</pharos-dropdown-menu-item>
        </pharos-dropdown-menu>
        <pharos-dropdown-menu
          id="second-dropdown"
          @pharos-dropdown-menu-closed="${() => {
    const secondDropdown = document.querySelector("#second-dropdown");
    secondDropdown.removeAllTriggers();
  }}"
        >
          <pharos-dropdown-menu-item>I am</pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item>a new</pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item>dropdown!</pharos-dropdown-menu-item>
        </pharos-dropdown-menu>
      </div>
    `
};


/***/ }),

/***/ "./packages/pharos/src/components/footer/pharos-footer.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Base": () => (/* binding */ Base),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _pages_shared_wc_footer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./packages/pharos/src/pages/shared/wc/footer.ts");
/* harmony import */ var _config_docsPageConfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./.storybook/docsPageConfig.jsx");


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  title: "Organisms/Footer",
  component: "pharos-footer",
  parameters: {
    docs: { page: (0,_config_docsPageConfig__WEBPACK_IMPORTED_MODULE_0__/* .configureDocsPage */ .k)("footer") },
    layout: "fullscreen"
  }
});
const Base = {
  render: () => (0,_pages_shared_wc_footer__WEBPACK_IMPORTED_MODULE_1__/* .Footer */ .$)(),
  parameters: {
    chromatic: { viewports: [320, 1024, 1200] }
  }
};


/***/ }),

/***/ "./packages/pharos/src/components/header/pharos-header.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Base": () => (/* binding */ Base),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/lit/index.js");
/* harmony import */ var _config_docsPageConfig__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./.storybook/docsPageConfig.jsx");


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  title: "Organisms/Header",
  component: "pharos-header",
  parameters: {
    docs: { page: (0,_config_docsPageConfig__WEBPACK_IMPORTED_MODULE_1__/* .configureDocsPage */ .k)("header") },
    layout: "fullscreen"
  }
});
const Base = {
  render: () => {
    const accountNav = (section) => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
      <pharos-dropdown-menu-nav label="profile">
        <pharos-dropdown-menu-nav-link
          href="/account/profile"
          id="profile-link-${section}"
          data-dropdown-menu-id="profile-menu-${section}"
          data-dropdown-menu-hover
          ><span class="hide-for-small">human@ithaka.org</span
          ><span class="show-for-small" style="display: none"
            >Account</span
          ></pharos-dropdown-menu-nav-link
        >
        <pharos-dropdown-menu id="profile-menu-${section}">
          <pharos-dropdown-menu-item link="/account/profile" id="profile-link-${section}"
            >Profile</pharos-dropdown-menu-item
          >
          <pharos-dropdown-menu-item link="/account/workspace" id="workspace-link-${section}"
            >Workspace</pharos-dropdown-menu-item
          >
          <pharos-dropdown-menu-item link="/account/read-online" id="article-link-${section}"
            >Free Article Views</pharos-dropdown-menu-item
          >
          <pharos-dropdown-menu-item link="/account/subscriptions" id="jpass-link-${section}"
            >JPASS Downloads</pharos-dropdown-menu-item
          >
          <pharos-dropdown-menu-item link="/account/purchases" id="purchase-link-${section}"
            >Purchase History</pharos-dropdown-menu-item
          >
          <pharos-dropdown-menu-item link="/action/doLogout" id="logout-link-${section}"
            >Logout</pharos-dropdown-menu-item
          >
        </pharos-dropdown-menu>
      </pharos-dropdown-menu-nav>
    `;
    return lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
      <pharos-header>
        <div id="pds" slot="top" class="hide-for-small">
          <div
            tabindex="0"
            style="display: flex"
            data-dropdown-menu-id="pds-menu"
            data-dropdown-menu-hover
          >
            <span>Access provided by&nbsp;</span>
            <span style="font-weight: bold">JSTOR</span>
            <pharos-icon name="chevron-down" style="margin-left: 1rem"></pharos-icon>
          </div>
          <pharos-dropdown-menu id="pds-menu" placement="bottom">
            <div style="padding: 1rem">
              <p>
                Please contact
                <pharos-link href="//jstor.org">JSTOR</pharos-link> for additional help and
                information.
              </p>
            </div>
          </pharos-dropdown-menu>
        </div>
        <span slot="top" class="show-for-small" style="display: none; font-weight: bold"
          >JSTOR</span
        >
        <pharos-link slot="start" href="/" id="jstor-logo">
          <img src="./images/jstor-logo.svg" alt="JSTOR Home" width="65" height="90" />
        </pharos-link>
        <div slot="center">
          <pharos-input-group
            name="my-input-group"
            hide-label
            placeholder="Search JSTOR"
            class="header-example__input-group"
          >
            <span slot="label">Search JSTOR</span>
            <pharos-button
              name="search-button"
              icon="search"
              variant="subtle"
              label="search"
            ></pharos-button>
          </pharos-input-group>
        </div>
        <div slot="end-top"">
          <div>${accountNav("end")}</div>
        </div>
        <div slot="end-bottom" style="display: flex;">
          <pharos-dropdown-menu-nav label="main navigation" style="display: inline-block">
            <pharos-dropdown-menu-nav-link
              href="action/showAdvancedSearch"
              id="adv-search-link"
              >Advanced Search</pharos-dropdown-menu-nav-link
            >
            <pharos-dropdown-menu-nav-link
              href="/subjects"
              id="browse-link"
              data-dropdown-menu-id="browse-menu"
              data-dropdown-menu-hover
              >Browse</pharos-dropdown-menu-nav-link
            >
            <pharos-dropdown-menu id="browse-menu">
              <pharos-dropdown-menu-item link="/subjects">by Subject</pharos-dropdown-menu-item>
              <pharos-dropdown-menu-item link="/action/showJournals?browseType=title"
                >by Title</pharos-dropdown-menu-item
              >
              <pharos-dropdown-menu-item link="/site/collection-list"
                >by Collections</pharos-dropdown-menu-item
              >
              <pharos-dropdown-menu-item link="/publishers"
                >by Publisher</pharos-dropdown-menu-item
              >
            </pharos-dropdown-menu>
            <pharos-dropdown-menu-nav-link
              href="/account/workspace"
              id="tools-link"
              data-dropdown-menu-id="tools-menu"
              data-dropdown-menu-hover
              >Tools</pharos-dropdown-menu-nav-link
            >
            <pharos-dropdown-menu id="tools-menu">
              <pharos-dropdown-menu-item link="/account/workspace"
                >Workspace</pharos-dropdown-menu-item
              >
              <pharos-dropdown-menu-item link="/analyze"
                >Text Analyzer</pharos-dropdown-menu-item
              >
              <pharos-dropdown-menu-item link="/understand"
                >The JSTOR Understanding Series</pharos-dropdown-menu-item
              >
              <pharos-dropdown-menu-item link="/dfr"
                >Data for Research</pharos-dropdown-menu-item
              >
            </pharos-dropdown-menu>
          </pharos-dropdown-menu-nav>
        </div>
      </pharos-header>
    `;
  },
  parameters: { chromatic: { viewports: [320, 1200] } }
};


/***/ }),

/***/ "./packages/pharos/src/components/heading/pharos-heading.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Base": () => (/* binding */ Base),
  "Bold": () => (/* binding */ Bold),
  "Legend": () => (/* binding */ Legend),
  "default": () => (/* binding */ pharos_heading_wc_stories)
});

// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./.storybook/docsPageConfig.jsx + 4 modules
var docsPageConfig = __webpack_require__("./.storybook/docsPageConfig.jsx");
// EXTERNAL MODULE: ./packages/pharos/src/components/heading/pharos-heading.ts + 1 modules
var pharos_heading = __webpack_require__("./packages/pharos/src/components/heading/pharos-heading.ts");
;// CONCATENATED MODULE: ./packages/pharos/src/components/heading/storyArgs.ts

const argTypes = {
  level: {
    control: {
      type: "range",
      min: Math.min(...pharos_heading/* allLevels */.Mk),
      max: Math.max(...pharos_heading/* allLevels */.Mk),
      step: 1
    }
  },
  preset: {
    options: pharos_heading/* allPresets */.KX,
    control: { type: "inline-radio" }
  }
};
const defaultArgs = {
  level: 1,
  noMargin: false,
  preset: "5",
  text: "Heading style"
};

;// CONCATENATED MODULE: ./packages/pharos/src/components/heading/pharos-heading.wc.stories.jsx




/* harmony default export */ const pharos_heading_wc_stories = ({
  title: "Components/Heading",
  component: "pharos-heading",
  parameters: {
    docs: { page: (0,docsPageConfig/* configureDocsPage */.k)("heading") },
    options: { selectedPanel: "addon-controls" }
  },
  argTypes: argTypes
});
const Base = {
  render: (args) => lit/* html */.dy`
      <pharos-heading level=${args.level} preset=${args.preset} ?no-margin=${args.noMargin}>
        ${args.text}<br />second line
      </pharos-heading>
    `,
  args: defaultArgs,
  argTypes: {
    ...argTypes,
    preset: {
      options: pharos_heading/* allPresets.filter */.KX.filter((preset) => !preset.includes("--bold")),
      control: { type: "inline-radio" }
    }
  }
};
const Bold = {
  ...Base,
  args: {
    ...Base.args,
    preset: "5--bold"
  },
  argTypes: {
    ...argTypes,
    preset: {
      options: pharos_heading/* allPresets.filter */.KX.filter((preset) => preset.includes("--bold")),
      control: { type: "inline-radio" }
    }
  }
};
const Legend = {
  render: (args) => lit/* html */.dy`
      <pharos-checkbox-group>
        <pharos-heading slot="legend" level="${args.level}" preset="${args.preset}"
          >${args.text}</pharos-heading
        >
        <pharos-checkbox value="1"><span slot="label">Checkbox 1</span></pharos-checkbox>
        <pharos-checkbox value="2"><span slot="label">Checkbox 2</span></pharos-checkbox>
      </pharos-checkbox-group>
    `,
  args: {
    ...Base.args,
    text: "I am legend",
    level: 2,
    preset: "legend"
  }
};


/***/ }),

/***/ "./packages/pharos/src/components/icon/pharos-icon.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Base": () => (/* binding */ Base),
  "Names": () => (/* binding */ Names),
  "default": () => (/* binding */ pharos_icon_wc_stories)
});

// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./packages/pharos/src/utils/iconNames.ts
var iconNames = __webpack_require__("./packages/pharos/src/utils/iconNames.ts");
// EXTERNAL MODULE: ./.storybook/docsPageConfig.jsx + 4 modules
var docsPageConfig = __webpack_require__("./.storybook/docsPageConfig.jsx");
;// CONCATENATED MODULE: ./packages/pharos/src/components/icon/storyArgs.ts

const defaultArgs = {
  name: "checkmark",
  description: ""
};
const argTypes = {
  name: {
    options: iconNames/* iconNames */.W,
    control: {
      type: "select"
    }
  }
};

;// CONCATENATED MODULE: ./packages/pharos/src/components/icon/pharos-icon.wc.stories.jsx




/* harmony default export */ const pharos_icon_wc_stories = ({
  title: "Components/Icon",
  component: "pharos-icon",
  parameters: {
    docs: { page: (0,docsPageConfig/* configureDocsPage */.k)("icon") },
    options: { selectedPanel: "addon-controls" }
  },
  argTypes: argTypes
});
const Base = {
  render: (args) => lit/* html */.dy` <pharos-icon name=${args.name} class="icon-example__icon"></pharos-icon> `,
  args: defaultArgs
};
const Names = {
  render: () => lit/* html */.dy`
      <div
        style="display: grid; grid-template-columns: repeat(4, auto); grid-gap: 2rem; margin-top: 2rem; justify-content: space-evenly;"
      >
        ${iconNames/* iconNames.map */.W.map((name) => {
    return lit/* html */.dy` <div class="icon-example__container">
            <pharos-icon name="${name}" class="icon-example__icon"></pharos-icon>
            <div class="icon-example__name">${name}</div>
          </div>`;
  })}
      </div>
    `
};


/***/ }),

/***/ "./packages/pharos/src/components/image-card/pharos-image-card.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Base": () => (/* binding */ Base),
  "Collection": () => (/* binding */ Collection),
  "Disabled": () => (/* binding */ Disabled),
  "ErrorState": () => (/* binding */ ErrorState),
  "Promotional": () => (/* binding */ Promotional),
  "Selectable": () => (/* binding */ Selectable),
  "SelectableCollection": () => (/* binding */ SelectableCollection),
  "SubtleSelectable": () => (/* binding */ SubtleSelectable),
  "SubtleState": () => (/* binding */ SubtleState),
  "VisitedTitleLink": () => (/* binding */ VisitedTitleLink),
  "WithActionButtonSlot": () => (/* binding */ WithActionButtonSlot),
  "WithActionMenu": () => (/* binding */ WithActionMenu),
  "WithSourceTypes": () => (/* binding */ WithSourceTypes),
  "default": () => (/* binding */ pharos_image_card_wc_stories)
});

// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./packages/pharos/src/pages/shared/viewports.ts
var viewports = __webpack_require__("./packages/pharos/src/pages/shared/viewports.ts");
// EXTERNAL MODULE: ./packages/pharos/src/pages/item-detail/mocks.ts
var mocks = __webpack_require__("./packages/pharos/src/pages/item-detail/mocks.ts");
// EXTERNAL MODULE: ./.storybook/docsPageConfig.jsx + 4 modules
var docsPageConfig = __webpack_require__("./.storybook/docsPageConfig.jsx");
;// CONCATENATED MODULE: ./packages/pharos/src/components/image-card/storyArgs.ts
const defaultArgs = {
  error: false,
  subtle: false,
  indicatedLinkVisited: false
};

;// CONCATENATED MODULE: ./packages/pharos/src/components/image-card/pharos-image-card.wc.stories.jsx





/* harmony default export */ const pharos_image_card_wc_stories = ({
  title: "Components/Image Card",
  component: "pharos-image-card",
  parameters: {
    docs: { page: (0,docsPageConfig/* configureDocsPage */.k)("image-card") },
    viewport: viewports/* viewports */.U
  }
});
const Template = {
  render: (args) => lit/* html */.dy`<pharos-layout style="margin: 1rem 0"
      ><pharos-image-card
        title="South Hall"
        link="https://www.jstor.org/stable/10.2307/community.26220188"
        ?error=${args.error}
        ?subtle=${args.subtle}
        style="grid-column: span 2"
      >
        <img id="image" src="./images/item-detail/collection_5.png" alt="south hall" slot="image" />
        <div id="creator" slot="metadata">Tubby, William Bunker (American architect,...</div>
        <div id="item-date" slot="metadata">1889-1892 (creation)</div>
        <div id="collection" slot="metadata">
          Part of
          <pharos-link
            href="https://www.jstor.org/site/pratt/buildings-image"
            ?on-background=${args.subtle}
            >Pratt Institute Buildings Image Collection</pharos-link
          >
        </div>
      </pharos-image-card></pharos-layout
    >`,
  args: defaultArgs
};
const Base = {
  render: () => lit/* html */.dy` <pharos-layout tag="ol" style="margin: 1rem 0">
      ${mocks/* items.map */.ev.map((item, index) => {
    return lit/* html */.dy` <li style="grid-column: span 2">
          <pharos-image-card id="card-${index}" title="Card Title" link="#">
            <img
              id="image-${index}"
              src="./images/item-detail/${item.image}"
              alt="Card Title ${index}"
              slot="image"
            />
            <div id="creator-${index}" slot="metadata">Creator of the item</div>
            <div id="item-date-${index}" slot="metadata">1990-2000</div>
            <div id="collection-${index}" slot="metadata">
              Part of
              <pharos-link href="https://www.jstor.org/site/pratt/buildings-image"
                >An Example Collection
              </pharos-link>
            </div>
          </pharos-image-card>
        </li>`;
  })}
    </pharos-layout>`
};
const WithSourceTypes = {
  render: () => lit/* html */.dy` <pharos-layout tag="ol" style="margin: 1rem 0">
      ${mocks/* items.map */.ev.map((item, index) => {
    return lit/* html */.dy` <li style="grid-column: span 2">
          <pharos-image-card id="card-${index}" title="Card Title" link="#" source-type="Image">
            <img
              id="image-${index}"
              src="./images/item-detail/${item.image}"
              alt="Card Title ${index}"
              slot="image"
            />
            <div id="creator-${index}" slot="metadata">Creator of the item</div>
            <div id="item-date-${index}" slot="metadata">1990-2000</div>
            <div id="collection-${index}" slot="metadata">
              Part of
              <pharos-link href="https://www.jstor.org/site/pratt/buildings-image"
                >An Example Collection
              </pharos-link>
            </div>
          </pharos-image-card>
        </li>`;
  })}
    </pharos-layout>`
};
const Collection = {
  render: () => lit/* html */.dy` <pharos-layout tag="ol" style="margin: 1rem 0">
      ${mocks/* collections.map */.sh.map((collection, index) => {
    return lit/* html */.dy` <li class="image-card-example__card--collection">
          <pharos-image-card
            id="card-${index}"
            title="${collection.title}"
            link="#"
            variant="collection"
          >
            <img
              id="image-${index}"
              src="./images/item-detail/${collection.image}"
              alt="${collection.title}"
              slot="image"
            />
            <strong id="items-${index}" slot="metadata">${collection.items} items</strong>
            <div id="description-${index}" slot="metadata">
              Selections from the global permanent collection.
            </div>
          </pharos-image-card>
        </li>`;
  })}
    </pharos-layout>`
};
const Promotional = {
  render: () => lit/* html */.dy` <pharos-layout style="margin: 1rem 0">
      <div class="image-card-example__card--promotional">
        <pharos-image-card
          title="Bring your work to life with images"
          link="#"
          variant="promotional"
        >
          <img src="./images/item-detail/open_collection_3.png" alt="" slot="image" />
          <p slot="metadata">
            Harness the power of visual materials—explore more than 3 million images now on JSTOR.
          </p>
        </pharos-image-card>
        <pharos-button variant="secondary">Search for images</pharos-button>
      </div>
    </pharos-layout>`
};
const Selectable = {
  render: () => lit/* html */.dy` <pharos-layout tag="ol" style="margin: 1rem 0">
      <li style="grid-column: span 3">
        <pharos-image-card title="Selectable" link="#" source-type="Image" variant="selectable">
          <img src="./images/item-detail/collection_5.png" alt="Card Title" slot="image" />
        </pharos-image-card>
      </li>
      <li style="grid-column: span 3">
        <pharos-image-card
          title="Subtle select"
          link="#"
          source-type="Image"
          variant="selectable"
          subtle-select="true"
        >
          <img src="./images/item-detail/collection_5.png" alt="Card Title" slot="image" />
        </pharos-image-card>
      </li>
      <li style="grid-column: span 3">
        <pharos-image-card
          title="Selected Disabled"
          link="#"
          source-type="Image"
          variant="selectable"
          disabled="true"
          selected="true"
        >
          <img src="./images/item-detail/collection_5.png" alt="Card Title" slot="image" />
        </pharos-image-card>
      </li>
      <li style="grid-column: span 3">
        <pharos-image-card
          title="Selectable Error State"
          link="#"
          source-type="Image"
          variant="selectable"
          error="true"
        >
          <img src="./images/item-detail/collection_5.png" alt="Card Title" slot="image" />
        </pharos-image-card>
      </li>
      <li style="grid-column: span 3">
        <pharos-image-card
          title="Subtle Select Error State"
          link="#"
          source-type="Image"
          variant="selectable"
          error="true"
          subtle-select="true"
        >
          <img src="./images/item-detail/collection_5.png" alt="Card Title" slot="image" />
        </pharos-image-card>
      </li>
    </pharos-layout>`
};
const SubtleSelectable = {
  render: () => lit/* html */.dy` <pharos-layout tag="ol" style="margin: 1rem 0">
      <li style="grid-column: span 3">
        <pharos-image-card
          title="Selectable"
          link="#"
          source-type="Image"
          variant="selectable"
          subtle="true"
        >
          <img src="./images/item-detail/collection_5.png" alt="Card Title" slot="image" />
        </pharos-image-card>
      </li>
      <li style="grid-column: span 3">
        <pharos-image-card
          title="Subtle select"
          link="#"
          source-type="Image"
          variant="selectable"
          subtle="true"
          subtle-select="true"
        >
          <img src="./images/item-detail/collection_5.png" alt="Card Title" slot="image" />
        </pharos-image-card>
      </li>
      <li style="grid-column: span 3">
        <pharos-image-card
          title="Selected Disabled"
          link="#"
          source-type="Image"
          variant="selectable"
          subtle="true"
          disabled="true"
          selected="true"
        >
          <img src="./images/item-detail/collection_5.png" alt="Card Title" slot="image" />
        </pharos-image-card>
      </li>
      <li style="grid-column: span 3">
        <pharos-image-card
          title="Selectable Error State"
          link="#"
          source-type="Image"
          variant="selectable"
          subtle="true"
          error="true"
        >
          <img src="./images/item-detail/collection_5.png" alt="Card Title" slot="image" />
        </pharos-image-card>
      </li>
      <li style="grid-column: span 3">
        <pharos-image-card
          title="Subtle Select Error State"
          link="#"
          source-type="Image"
          variant="selectable"
          subtle="true"
          error="true"
          subtle-select="true"
        >
          <img src="./images/item-detail/collection_5.png" alt="Card Title" slot="image" />
        </pharos-image-card>
      </li>
    </pharos-layout>`
};
const ErrorState = {
  ...Template,
  args: {
    ...Template.args,
    error: true
  }
};
const SubtleState = {
  ...Template,
  args: {
    ...Template.args,
    subtle: true
  }
};
const VisitedTitleLink = {
  ...Template,
  args: {
    ...Template.args,
    indicatedLinkVisited: true
  }
};
const WithActionMenu = {
  render: () => lit/* html */.dy`
      <pharos-layout style="margin: 1rem 0">
        <pharos-image-card
          title="South Hall"
          link="https://www.jstor.org/stable/10.2307/community.26220188"
          action-menu="my-dropdown-menu"
          style="grid-column: span 2"
        >
          <img
            id="image"
            src="./images/item-detail/collection_5.png"
            alt="south hall"
            slot="image"
          />
          <div id="creator" slot="metadata">Tubby, William Bunker (American architect,...</div>
          <div id="item-date" slot="metadata">1889-1892 (creation)</div>
          <div id="collection" slot="metadata">
            Part of
            <pharos-link href="https://www.jstor.org/site/pratt/buildings-image"
              >Pratt Institute Buildings Image Collection</pharos-link
            >
          </div>
        </pharos-image-card>
      </pharos-layout>
      <pharos-dropdown-menu id="my-dropdown-menu">
        <pharos-dropdown-menu-item>Item 1</pharos-dropdown-menu-item>
        <pharos-dropdown-menu-item>Item 2</pharos-dropdown-menu-item>
        <pharos-dropdown-menu-item>Item 3</pharos-dropdown-menu-item>
      </pharos-dropdown-menu>
    `
};
const WithActionButtonSlot = {
  render: () => lit/* html */.dy`
      <pharos-layout style="margin: 1rem 0">
        <pharos-image-card
          title="South Hall"
          link="https://www.jstor.org/stable/10.2307/community.26220188"
          style="grid-column: span 2"
        >
          <img
            id="image"
            src="./images/item-detail/collection_5.png"
            alt="south hall"
            slot="image"
          />
          <div id="creator" slot="metadata">Tubby, William Bunker (American architect,...</div>
          <div id="item-date" slot="metadata">1889-1892 (creation)</div>
          <div id="collection" slot="metadata">
            Part of
            <pharos-link href="https://www.jstor.org/site/pratt/buildings-image"
              >Pratt Institute Buildings Image Collection</pharos-link
            >
          </div>
          <pharos-button
            slot="action-button"
            data-dropdown-menu-id="dropdownId"
            icon="ellipses-vertical"
            icon-condensed
            variant="subtle"
          ></pharos-button>
        </pharos-image-card>
        <pharos-dropdown-menu id="dropdownId">
          <pharos-dropdown-menu-item>Item 1</pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item>Item 2</pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item>Item 3</pharos-dropdown-menu-item>
        </pharos-dropdown-menu>
      </pharos-layout>
    `
};
const SelectableCollection = {
  render: () => lit/* html */.dy` <pharos-layout tag="ol" style="margin: 1rem 0">
      <li class="image-card-example__card--collection">
        <pharos-image-card title="Selectable" link="#" variant="selectable-collection">
          <img src="./images/item-detail/open_collection_1.png" slot="image" />
          <strong slot="metadata">50 items</strong>
          <div slot="metadata">Selections from the global permanent collection.</div>
        </pharos-image-card>
      </li>
      <li class="image-card-example__card--collection">
        <pharos-image-card
          title="Subtle Select"
          link="#"
          variant="selectable-collection"
          subtle-select="true"
        >
          <img src="./images/item-detail/open_collection_2.png" slot="image" />
          <strong slot="metadata">50 items</strong>
          <div slot="metadata">Selections from the global permanent collection.</div>
        </pharos-image-card>
      </li>
      <li class="image-card-example__card--collection">
        <pharos-image-card
          title="Selected Disabled"
          link="#"
          variant="selectable-collection"
          disabled="true"
          selected="true"
        >
          <img src="./images/item-detail/open_collection_3.png" slot="image" />
          <strong slot="metadata">50 items</strong>
          <div slot="metadata">Selections from the global permanent collection.</div>
        </pharos-image-card>
      </li>
    </pharos-layout>`
};
const Disabled = {
  render: () => lit/* html */.dy` <pharos-layout tag="ol" style="margin: 1rem 0">
      <li style="grid-column: span 3">
        <pharos-image-card title="Disabled" link="#" source-type="Image" disabled="true">
          <img src="./images/item-detail/collection_5.png" alt="Card Title" slot="image" />
        </pharos-image-card>
      </li>
      <li style="grid-column: span 3">
        <pharos-image-card
          title="Selectable Disabled"
          link="#"
          source-type="Image"
          disabled="true"
          variant="selectable"
        >
          <img src="./images/item-detail/collection_5.png" alt="Card Title" slot="image" />
        </pharos-image-card>
      </li>
      <li style="grid-column: span 3">
        <pharos-image-card
          title="Selected Disabled"
          link="#"
          source-type="Image"
          variant="selectable"
          disabled="true"
          selected="true"
        >
          <img src="./images/item-detail/collection_5.png" alt="Card Title" slot="image" />
        </pharos-image-card>
      </li>
    </pharos-layout>`
};


/***/ }),

/***/ "./packages/pharos/src/components/input-group/pharos-input-group.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Base": () => (/* binding */ Base),
/* harmony export */   "Composition": () => (/* binding */ Composition),
/* harmony export */   "Prominent": () => (/* binding */ Prominent),
/* harmony export */   "Validity": () => (/* binding */ Validity),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/lit/index.js");
/* harmony import */ var _config_docsPageConfig__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./.storybook/docsPageConfig.jsx");


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  title: "Forms/Input Group",
  component: "pharos-input-group",
  subcomponents: { PharosInputGroupSelect: "pharos-input-group-select" },
  parameters: {
    docs: { page: (0,_config_docsPageConfig__WEBPACK_IMPORTED_MODULE_1__/* .configureDocsPage */ .k)("input-group") }
  }
});
const Base = {
  render: () => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
      <div style="display: grid; grid-gap: 1rem; grid-template-columns: 524px;">
        <pharos-input-group name="my-input-group">
          <span slot="label">Search</span>
          <pharos-button
            name="search-button"
            icon="search"
            variant="subtle"
            label="search"
          ></pharos-button>
        </pharos-input-group>
      </div>
    `
};
const Prominent = {
  render: () => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
      <div style="display: grid; grid-gap: 1rem; grid-template-columns: 524px;">
        <pharos-input-group name="my-input-group" variant="prominent">
          <span slot="label">Basic</span>
          <pharos-button
            name="search-button"
            icon="search"
            variant="subtle"
            label="search"
          ></pharos-button>
        </pharos-input-group>
        <pharos-input-group name="my-input-group" variant="prominent" invalidated>
          <span slot="label">invalidated</span>
          <pharos-button
            name="search-button"
            icon="search"
            variant="subtle"
            label="search"
          ></pharos-button>
        </pharos-input-group>
        <pharos-input-group name="prominent-prepend" variant="prominent">
          <pharos-button
            name="book-button"
            slot="prepend"
            icon="book"
            variant="subtle"
            label="book"
          ></pharos-button>
          <span slot="label">prominent Prepend</span>
        </pharos-input-group>
        <pharos-input-group name="prominent-buttons" variant="prominent">
          <pharos-button
            name="book-button"
            slot="prepend"
            icon="book"
            variant="subtle"
            label="book"
          ></pharos-button>
          <span slot="label">Multiple buttons</span>
          <pharos-button
            name="close-button"
            icon="close"
            variant="subtle"
            label="close"
          ></pharos-button>
          <pharos-button
            name="search-button"
            icon="search"
            variant="subtle"
            label="search"
          ></pharos-button>
        </pharos-input-group>
      </div>
    `
};
const Validity = {
  render: () => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
      <div style="display: grid; grid-gap: 1rem; grid-template-columns: 524px;">
        <pharos-input-group invalidated value="not an email" name="my-input-group">
          <span slot="label">Email</span>
          <pharos-button
            name="search-button"
            icon="search"
            variant="subtle"
            label="search"
          ></pharos-button>
        </pharos-input-group>
        <pharos-input-group validated value="here@there.com" name="my-input-group">
          <span slot="label">Email</span>
          <pharos-button
            name="search-button"
            icon="search"
            variant="subtle"
            label="search"
          ></pharos-button>
        </pharos-input-group>
      </div>
    `
};
const Composition = {
  render: () => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
      <div style="display: grid; grid-gap: 1rem; grid-template-columns: 524px;">
        <pharos-input-group name="my-input-group-icon">
          <span slot="label">With icons</span>
          <pharos-icon id="calendar" name="calendar"></pharos-icon>
        </pharos-input-group>
        <pharos-input-group name="my-input-group-buttons">
          <span slot="label">Multiple buttons</span>
          <pharos-button
            name="close-button"
            icon="close"
            variant="subtle"
            label="close"
          ></pharos-button>
          <pharos-button
            name="search-button"
            icon="search"
            variant="subtle"
            label="search"
          ></pharos-button>
        </pharos-input-group>
        <pharos-input-group name="my-input-group-select">
          <span slot="label">With select</span>
          <pharos-input-group-select name="my-group-select" hide-label>
            <span slot="label">Search</span>
            <option value="">Search all content</option>
            <option value="book">Search within this book</option>
          </pharos-input-group-select>
          <pharos-button
            name="search-with-select-button"
            icon="search"
            variant="subtle"
            label="search"
          ></pharos-button>
        </pharos-input-group>
        <pharos-input-group name="my-input-group-prepend">
          <pharos-button
            name="book-button"
            slot="prepend"
            icon="book"
            variant="subtle"
            label="book"
          ></pharos-button>
          <span slot="label">Prepend</span>
        </pharos-input-group>
      </div>
    `
};


/***/ }),

/***/ "./packages/pharos/src/components/layout/pharos-layout.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ColumnLayouts": () => (/* binding */ ColumnLayouts),
/* harmony export */   "OneColumn": () => (/* binding */ OneColumn),
/* harmony export */   "OneColumnWithSidenav": () => (/* binding */ OneColumnWithSidenav),
/* harmony export */   "OneColumnWithSidenavAndComfySpacing": () => (/* binding */ OneColumnWithSidenavAndComfySpacing),
/* harmony export */   "TwoColumn": () => (/* binding */ TwoColumn),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/lit/index.js");
/* harmony import */ var _pages_shared_viewports__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./packages/pharos/src/pages/shared/viewports.ts");
/* harmony import */ var _config_docsPageConfig__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./.storybook/docsPageConfig.jsx");



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  title: "Components/Layout",
  component: "pharos-layout",
  parameters: {
    docs: { page: (0,_config_docsPageConfig__WEBPACK_IMPORTED_MODULE_1__/* .configureDocsPage */ .k)("layout") },
    chromatic: { viewports: _pages_shared_viewports__WEBPACK_IMPORTED_MODULE_2__/* .breakpoints */ .A },
    viewport: {
      viewports: _pages_shared_viewports__WEBPACK_IMPORTED_MODULE_2__/* .viewports */ .U
    },
    layout: "fullscreen"
  }
});
const _gridItems = (rows) => {
  const arr = [];
  rows.forEach((items) => {
    for (let i = 0; i < items; i++) {
      arr.push({ span: 12 / items, cols: items });
    }
  });
  return arr.map(
    (item) => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`<div class="layout-example__item" style="grid-column: span ${item.span}">
      ${item.cols}
    </div>`
  );
};
const _comboItems = (rows) => {
  const arr = [];
  rows.forEach((item) => {
    arr.push({ span: item, cols: item });
    arr.push({ span: 12 - item, cols: 12 - item });
  });
  return arr.map(
    (item) => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`<div class="layout-example__item" style="grid-column: span ${item.span}">
      Span ${item.cols}
    </div>`
  );
};
const _gridColumns = () => {
  const arr = [];
  for (let i = 1; i <= 12; i++) {
    arr.push(lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`<div class="layout-example__column">${i}</div>`);
  }
  return arr;
};
const OneColumn = {
  name: "One column",
  render: () => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy` <pharos-layout>${_gridColumns()}</pharos-layout> `
};
const OneColumnWithSidenav = {
  name: "One column with sidenav",
  render: () => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
      <div
        style="display: grid; grid-template-areas: 'sidenav main'; grid-template-columns: max-content 1fr"
      >
        <pharos-sidenav style="grid-area: sidenav">
          <pharos-link slot="top" href="/" id="jstor-logo">
            <img src="./images/jstor-logo-inverse.svg" alt="Pharos Home" width="72" height="100" />
          </pharos-link>
        </pharos-sidenav>
        <main style="grid-area: main">
          <pharos-layout preset="1-col--sidenav">${_gridColumns()}</pharos-layout>
        </main>
      </div>
    `
};
const OneColumnWithSidenavAndComfySpacing = {
  name: "One column with sidenav and comfy spacing",
  render: () => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
      <div
        style="display: grid; grid-template-areas: 'sidenav main'; grid-template-columns: max-content 1fr"
      >
        <pharos-sidenav style="grid-area: sidenav">
          <pharos-link slot="top" href="/" id="jstor-logo">
            <img src="./images/jstor-logo-inverse.svg" alt="Pharos Home" width="72" height="100" />
          </pharos-link>
        </pharos-sidenav>
        <main style="grid-area: main">
          <pharos-layout preset="1-col--sidenav-comfy">${_gridColumns()}</pharos-layout>
        </main>
      </div>
    `
};
const TwoColumn = {
  name: "Two column",
  render: () => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
      <pharos-layout preset="2-col">
        <div class="layout-example__container--first"></div>
        <div class="layout-example__container--second"></div>
        <div class="layout-example__container--third"></div>
      </pharos-layout>
      <pharos-layout preset="2-col" style="position: absolute; top: 0; width: 100%"
        >${_gridColumns()}</pharos-layout
      >
    `
};
const ColumnLayouts = {
  name: "Column layouts",
  render: () => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
      <pharos-layout style="margin: 1rem 0">
        ${_gridItems([1, 2, 3, 4, 6])} ${_comboItems([7, 8, 9, 10])}
      </pharos-layout>
    `
};


/***/ }),

/***/ "./packages/pharos/src/components/link/pharos-link.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Base": () => (/* binding */ Base),
  "Button": () => (/* binding */ Button),
  "Variants": () => (/* binding */ Variants),
  "VisitedLink": () => (/* binding */ VisitedLink),
  "VisitedLinkHeading": () => (/* binding */ VisitedLinkHeading),
  "default": () => (/* binding */ pharos_link_wc_stories)
});

// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./node_modules/lit/directives/if-defined.js + 1 modules
var if_defined = __webpack_require__("./node_modules/lit/directives/if-defined.js");
// EXTERNAL MODULE: ./.storybook/docsPageConfig.jsx + 4 modules
var docsPageConfig = __webpack_require__("./.storybook/docsPageConfig.jsx");
;// CONCATENATED MODULE: ./packages/pharos/src/components/link/storyArgs.ts
const defaultArgs = {
  text: "I am a link",
  bold: false,
  flex: false,
  href: "#",
  indicateVisited: false,
  onBackground: false,
  noHover: false,
  skip: false,
  subtle: false
};

;// CONCATENATED MODULE: ./packages/pharos/src/components/link/pharos-link.wc.stories.jsx




/* harmony default export */ const pharos_link_wc_stories = ({
  title: "Components/Link",
  component: "pharos-link",
  parameters: {
    docs: { page: (0,docsPageConfig/* configureDocsPage */.k)("link") }
  }
});
const Base = {
  render: (args) => lit/* html */.dy` <div style="display: grid; grid-gap: 1rem; grid-template-columns: 300px;">
      <pharos-link
        ?bold=${args.bold}
        download=${(0,if_defined/* ifDefined */.o)(args.download)}
        ?flex=${args.flex}
        href=${(0,if_defined/* ifDefined */.o)(args.href)}
        hreflang=${(0,if_defined/* ifDefined */.o)(args.hreflang)}
        ?indicate-visited=${args.indicateVisited}
        label=${(0,if_defined/* ifDefined */.o)(args.label)}
        ?no-hover=${args.noHover}
        ?on-background=${args.onBackground}
        ping=${(0,if_defined/* ifDefined */.o)(args.ping)}
        rel=${(0,if_defined/* ifDefined */.o)(args.rel)}
        ?skip=${args.skip}
        ?subtle=${args.subtle}
        target=${(0,if_defined/* ifDefined */.o)(args.target)}
        type=${(0,if_defined/* ifDefined */.o)(args.type)}
      >
        ${args.text}
      </pharos-link>
    </div>`,
  args: defaultArgs
};
const VisitedLink = {
  render: () => lit/* html */.dy`
      <div style="margin-bottom: 1rem">
        <pharos-link href="https://www.google.com" target="_blank" indicate-visited
          >Visited link</pharos-link
        >
      </div>
    `
};
const VisitedLinkHeading = {
  render: () => lit/* html */.dy`
      <div style="margin-bottom: 1rem">
        <pharos-link href="https://www.google.com" target="_blank" indicate-visited>
          <pharos-heading level="1"> Visited link heading </pharos-heading>
        </pharos-link>
      </div>
    `
};
const Button = {
  render: () => lit/* html */.dy`
      <div style="margin-bottom: 1rem">
        <pharos-link name="primary">I am a button</pharos-link>
      </div>
      <div style="background-color: #000000; padding: 1rem; margin-bottom: 1rem">
        <pharos-link name="on-background" on-background>On compliant background</pharos-link>
      </div>
    `
};
const Variants = {
  render: () => lit/* html */.dy`
      <div style="margin-bottom: 1rem">
        <pharos-link name="primary" href="#">Primary link</pharos-link>
      </div>
      <div style="margin-bottom: 1rem">
        <pharos-link name="subtle" href="#" subtle>Subtle link</pharos-link>
      </div>
      <div style="width:100px; margin-bottom: 1rem">
        <pharos-link name="multi" href="#">I have text that spans multiple lines</pharos-link>
      </div>
      <div style="background-color: #000000; padding: 1rem; margin-bottom: 1rem">
        <pharos-link name="on-background" href="#" on-background
          >On compliant background</pharos-link
        >
      </div>
      <div style="background-color: #000000; padding: 1rem; margin-bottom: 1rem">
        <pharos-link name="on-background-subtle" href="#" on-background subtle
          >On compliant background with subtle</pharos-link
        >
      </div>
    `
};


/***/ }),

/***/ "./packages/pharos/src/components/loading-spinner/pharos-loading-spinner.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Base": () => (/* binding */ Base),
/* harmony export */   "Scoped": () => (/* binding */ Scoped),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _storybook_addon_actions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/@storybook/addon-actions/dist/esm/index.js");
/* harmony import */ var lit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/lit/index.js");
/* harmony import */ var _config_docsPageConfig__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./.storybook/docsPageConfig.jsx");



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  title: "Components/Loading Spinner",
  component: "pharos-loading-spinner",
  parameters: {
    docs: { page: (0,_config_docsPageConfig__WEBPACK_IMPORTED_MODULE_2__/* .configureDocsPage */ .k)("loading-spinner") },
    options: { selectedPanel: "addon-controls" },
    chromatic: { disable: true }
  }
});
const Base = {
  render: () => lit__WEBPACK_IMPORTED_MODULE_1__/* .html */ .dy`
      <pharos-loading-spinner></pharos-loading-spinner>
      <pharos-heading level="1" preset="5">Loading spinner demonstration</pharos-heading>
      <pharos-button @click="${() => (0,_storybook_addon_actions__WEBPACK_IMPORTED_MODULE_0__.action)("Click")("Clicked")}">Can't press me!</pharos-button>
    `
};
const Scoped = {
  render: () => lit__WEBPACK_IMPORTED_MODULE_1__/* .html */ .dy`
      <div style="height: 5rem; width: 5rem; border: 1px solid black; position: relative;">
        <pharos-loading-spinner></pharos-loading-spinner>
      </div>
    `
};


/***/ }),

/***/ "./packages/pharos/src/components/modal/pharos-modal.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Base": () => (/* binding */ Base),
  "Composition": () => (/* binding */ Composition),
  "Events": () => (/* binding */ Events),
  "NoFooter": () => (/* binding */ NoFooter),
  "default": () => (/* binding */ pharos_modal_wc_stories)
});

// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./node_modules/lit/directives/if-defined.js + 1 modules
var if_defined = __webpack_require__("./node_modules/lit/directives/if-defined.js");
// EXTERNAL MODULE: ./node_modules/@storybook/addon-actions/dist/esm/index.js + 8 modules
var esm = __webpack_require__("./node_modules/@storybook/addon-actions/dist/esm/index.js");
// EXTERNAL MODULE: ./packages/pharos/src/components/modal/pharos-modal.ts + 1 modules
var pharos_modal = __webpack_require__("./packages/pharos/src/components/modal/pharos-modal.ts");
;// CONCATENATED MODULE: ./packages/pharos/src/components/modal/storyArgs.ts

const defaultArgs = {
  size: "medium",
  open: false,
  footerDivider: true,
  header: "Pharos modal"
};
const argTypes = {
  size: {
    options: pharos_modal/* allSizes */.g,
    control: {
      type: "inline-radio"
    }
  }
};

// EXTERNAL MODULE: ./.storybook/docsPageConfig.jsx + 4 modules
var docsPageConfig = __webpack_require__("./.storybook/docsPageConfig.jsx");
;// CONCATENATED MODULE: ./packages/pharos/src/components/modal/pharos-modal.wc.stories.jsx





/* harmony default export */ const pharos_modal_wc_stories = ({
  title: "Components/Modal",
  component: "pharos-modal",
  parameters: {
    docs: { page: (0,docsPageConfig/* configureDocsPage */.k)("modal") },
    options: { selectedPanel: "addon-controls" }
  },
  argTypes: argTypes
});
const Base = {
  render: (args) => lit/* html */.dy`
      <pharos-button
        @click="${(e) => {
    e.target.focus();
    const modal = document.querySelector("pharos-modal");
    modal.open = true;
  }}"
      >
        Open modal
      </pharos-button>
      <pharos-modal
        ?footer-divider=${(0,if_defined/* ifDefined */.o)(args.footerDivider)}
        header=${(0,if_defined/* ifDefined */.o)(args.header)}
        ?open=${(0,if_defined/* ifDefined */.o)(args.open)}
        size=${(0,if_defined/* ifDefined */.o)(args.size)}
      >
        <p>I am a modal</p>
        <pharos-button slot="footer" type="button" variant="secondary" data-modal-close>
          Cancel
        </pharos-button>
        <pharos-button
          slot="footer"
          type="button"
          @click="${() => {
    const modal = document.querySelector("pharos-modal");
    modal.open = false;
  }}"
        >
          Ok
        </pharos-button>
      </pharos-modal>
    `,
  args: defaultArgs
};
const NoFooter = {
  render: () => lit/* html */.dy`
      <pharos-button
        @click="${(e) => {
    e.target.focus();
    const modal = document.querySelector("pharos-modal");
    modal.open = true;
  }}"
      >
        Open modal
      </pharos-button>
      <pharos-modal header="Pharos modal" size="medium">
        <p>I am a modal</p>
      </pharos-modal>
    `
};
const Events = {
  render: () => lit/* html */.dy`
      <pharos-button
        type="button"
        data-modal-id="my-event-modal"
        @click="${(e) => {
    e.target.focus();
  }}"
      >
        Open modal
      </pharos-button>
      <pharos-modal
        id="my-event-modal"
        header="Event modal"
        open
        @pharos-modal-open="${(e) => (0,esm.action)("Open")(e.detail)}"
        @pharos-modal-opened="${(e) => (0,esm.action)("Opened")(e.detail)}"
        @pharos-modal-close="${(e) => (0,esm.action)("Close")(e.detail)}"
        @pharos-modal-closed="${(e) => (0,esm.action)("Closed")(e.detail)}"
      >
        <p slot="description">Description for the modal</p>
        <pharos-text-input style="margin-bottom: 1rem" data-modal-focus>
          <span slot="label">Name</span>
        </pharos-text-input>
        <pharos-text-input style="margin-bottom: 1rem">
          <span slot="label">User ID</span>
        </pharos-text-input>
        <pharos-text-input style="margin-bottom: 1rem">
          <span slot="label">Favorite Color</span>
        </pharos-text-input>
        <pharos-button slot="footer" type="button" variant="secondary" data-modal-close>
          Cancel
        </pharos-button>
        <pharos-button slot="footer" type="button">Submit</pharos-button>
      </pharos-modal>
    `,
  parameters: { selectedPanel: "addon-actions" }
};
const Composition = {
  render: () => lit/* html */.dy`
      <pharos-button
        type="button"
        data-modal-id="my-alert-modal"
        @click="${(e) => {
    e.target.focus();
  }}"
      >
        Open modal
      </pharos-button>
      <pharos-modal id="my-alert-modal" header="Add external link" open>
        <div>
          <pharos-alert style="margin-bottom: 1rem" status="error"
            >We're sorry, we experienced an issue submitting your report. Please try again. If the
            issue persists, contact
            <pharos-link id="support-link" href="#">support@jstor.org</pharos-link>.
          </pharos-alert>
          <pharos-text-input name="link" required style="margin-bottom: 1rem">
            <span slot="label">Link</span>
          </pharos-text-input>
          <pharos-text-input name="text" required style="margin-bottom: 1rem">
            <span slot="label">Text</span>
          </pharos-text-input>
        </div>
        <pharos-button
          id="cancel-button"
          slot="footer"
          type="button"
          variant="secondary"
          data-modal-close
        >
          Cancel
        </pharos-button>
        <pharos-button id="add-button" slot="footer" type="button">Add</pharos-button>
      </pharos-modal>
    `,
  parameters: { chromatic: { viewports: [320, 1200] } }
};


/***/ }),

/***/ "./packages/pharos/src/components/pagination/pharos-pagination.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Base": () => (/* binding */ Base),
  "Events": () => (/* binding */ Events),
  "default": () => (/* binding */ pharos_pagination_wc_stories)
});

// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./node_modules/@storybook/addon-actions/dist/esm/index.js + 8 modules
var esm = __webpack_require__("./node_modules/@storybook/addon-actions/dist/esm/index.js");
// EXTERNAL MODULE: ./.storybook/docsPageConfig.jsx + 4 modules
var docsPageConfig = __webpack_require__("./.storybook/docsPageConfig.jsx");
;// CONCATENATED MODULE: ./packages/pharos/src/components/pagination/storyArgs.ts
const defaultArgs = {
  totalResults: 1146,
  pageSize: 25,
  currentPage: 2
};

;// CONCATENATED MODULE: ./packages/pharos/src/components/pagination/pharos-pagination.wc.stories.jsx




/* harmony default export */ const pharos_pagination_wc_stories = ({
  title: "Components/Pagination",
  component: "pharos-pagination",
  parameters: {
    docs: { page: (0,docsPageConfig/* configureDocsPage */.k)("pagination") },
    options: { selectedPanel: "addon-controls" }
  }
});
const Base = {
  render: (args) => lit/* html */.dy`
      <pharos-pagination
        total-results=${args.totalResults}
        page-size=${args.pageSize}
        current-page=${args.currentPage}
        @prev-page="${(e) => (0,esm.action)("Prev Page")(JSON.stringify(e))}"
        @next-page="${(e) => (0,esm.action)("Next Page")(JSON.stringify(e))}"
      ></pharos-pagination>
    `,
  args: defaultArgs
};
const Events = {
  ...Base,
  parameters: { options: { selectedPanel: "addon-actions" } }
};


/***/ }),

/***/ "./packages/pharos/src/components/progress-bar/pharos-progress-bar.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Base": () => (/* binding */ Base),
  "Plain": () => (/* binding */ Plain),
  "default": () => (/* binding */ pharos_progress_bar_wc_stories)
});

// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./.storybook/docsPageConfig.jsx + 4 modules
var docsPageConfig = __webpack_require__("./.storybook/docsPageConfig.jsx");
;// CONCATENATED MODULE: ./packages/pharos/src/components/progress-bar/storyArgs.ts
const defaultArgs = {
  title: "Title.xls",
  value: 10,
  description: "Processing"
};
const argTypes = {
  value: {
    control: { type: "range", min: 0, max: 100, step: 10 }
  }
};

;// CONCATENATED MODULE: ./packages/pharos/src/components/progress-bar/pharos-progress-bar.wc.stories.jsx



/* harmony default export */ const pharos_progress_bar_wc_stories = ({
  title: "Components/Progress Bar",
  component: "pharos-progress-bar",
  parameters: {
    docs: { page: (0,docsPageConfig/* configureDocsPage */.k)("progress-bar") },
    options: { selectedPanel: "addon-controls" }
  },
  argTypes: argTypes
});
const Base = {
  render: (args) => lit/* html */.dy`
      <pharos-progress-bar value=${args.value}>
        <div slot="title">${args.title}</div>
        <div slot="description">${args.description}</div>
      </pharos-progress-bar>
    `,
  args: defaultArgs
};
const Plain = {
  ...Base,
  args: {
    value: 10
  }
};


/***/ }),

/***/ "./packages/pharos/src/components/radio-button/pharos-radio-button.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Base": () => (/* binding */ Base),
  "Events": () => (/* binding */ Events),
  "States": () => (/* binding */ States),
  "Validity": () => (/* binding */ Validity),
  "default": () => (/* binding */ pharos_radio_button_wc_stories)
});

// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./node_modules/@storybook/addon-actions/dist/esm/index.js + 8 modules
var esm = __webpack_require__("./node_modules/@storybook/addon-actions/dist/esm/index.js");
// EXTERNAL MODULE: ./.storybook/docsPageConfig.jsx + 4 modules
var docsPageConfig = __webpack_require__("./.storybook/docsPageConfig.jsx");
;// CONCATENATED MODULE: ./packages/pharos/src/components/radio-button/storyArgs.ts
const defaultArgs = {
  label: "Default Radio Button",
  checked: false,
  disabled: false,
  hideLabel: false,
  invalidated: false,
  required: false,
  message: ""
};

;// CONCATENATED MODULE: ./packages/pharos/src/components/radio-button/pharos-radio-button.wc.stories.jsx




/* harmony default export */ const pharos_radio_button_wc_stories = ({
  title: "Forms/Radio Button",
  parameters: {
    docs: { page: (0,docsPageConfig/* configureDocsPage */.k)("radio-button") },
    options: { selectedPanel: "addon-controls" }
  }
});
const Base = {
  render: (args) => lit/* html */.dy`
      <pharos-radio-button
        ?checked=${args.checked}
        ?disabled=${args.disabled}
        ?hide-label=${args.hideLabel}
        ?invalidated=${args.invalidated}
        ?required=${args.required}
        .message=${args.message}
      >
        <span slot="label">${args.label}</span>
      </pharos-radio-button>
    `,
  args: defaultArgs
};
const States = {
  render: () => lit/* html */.dy`
      <div>
        <pharos-radio-button name="base"><span slot="label">Default Radio Button</span></pharos-radio-button>
      </div>
      <div>
        <pharos-radio-button name="disabled" disabled><span slot="label">Disabled input</span></pharos-radio-button>
      </div>
      <div>
        <pharos-radio-button name="checked" checked><span slot="label">Checked button</span></pharos-radio-button>
      </div>
      <div>
        <pharos-radio-button name="checked-disabled" checked disabled>
          <span slot="label">Checked & Disabled</span>
        </pharos-radio-button>
      </div>
      <div>
        <pharos-radio-button name="multi" checked>
          <div slot="label">
            <div>Checked button</div>
            <div>Multiple lines</div>
          </div>
        </pharos-radio-button>
      </div>
      <div>
        <pharos-radio-button name="invalidated" invalidated><span slot="label">Error button</span></pharos-checkbox>
      </div>
      <div>
        <pharos-radio-button name="with-link">
          <span slot="label">
            Label with a <pharos-link href="#">link</pharos-link>
          </span>
        </pharos-radio-button>
      </div>
    `
};
const Events = {
  render: () => lit/* html */.dy`
      <pharos-radio-button
        value="My value"
        @change="${(e) => (0,esm.action)("Change")(e.target.checked)}"
        @input="${(e) => (0,esm.action)("Input")(e.target.value)}"
        @click="${(e) => (0,esm.action)("Click")(e.target.checked)}"
      >
        <span slot="label">I fire events</span>
      </pharos-radio-button>
    `,
  parameters: { options: { selectedPanel: "addon-actions" } }
};
const Validity = {
  ...Base,
  args: {
    ...Base.args,
    invalidated: true,
    required: true,
    message: "This field is required, please make a selection"
  }
};


/***/ }),

/***/ "./packages/pharos/src/components/radio-group/pharos-radio-group.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Base": () => (/* binding */ Base),
  "Events": () => (/* binding */ Events),
  "FormData": () => (/* binding */ FormData),
  "Validity": () => (/* binding */ Validity),
  "default": () => (/* binding */ pharos_radio_group_wc_stories)
});

// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./node_modules/@storybook/addon-actions/dist/esm/index.js + 8 modules
var esm = __webpack_require__("./node_modules/@storybook/addon-actions/dist/esm/index.js");
// EXTERNAL MODULE: ./packages/pharos/src/utils/createFormData.ts
var createFormData = __webpack_require__("./packages/pharos/src/utils/createFormData.ts");
;// CONCATENATED MODULE: ./packages/pharos/src/components/radio-group/storyArgs.ts
const defaultArgs = {
  horizontal: false,
  disabled: false,
  hideLabel: false,
  required: false,
  invalidated: false,
  validated: false,
  name: "group1",
  message: ""
};

// EXTERNAL MODULE: ./.storybook/docsPageConfig.jsx + 4 modules
var docsPageConfig = __webpack_require__("./.storybook/docsPageConfig.jsx");
;// CONCATENATED MODULE: ./packages/pharos/src/components/radio-group/pharos-radio-group.wc.stories.jsx





/* harmony default export */ const pharos_radio_group_wc_stories = ({
  title: "Forms/Radio Group",
  component: "pharos-radio-group",
  subcomponents: { PharosRadioButton: "pharos-radio-button" },
  parameters: {
    docs: { page: (0,docsPageConfig/* configureDocsPage */.k)("radio-group") },
    options: { selectedPanel: "addon-controls" }
  }
});
const Base = {
  render: (args) => lit/* html */.dy`
      <pharos-radio-group
        name=${args.name}
        ?horizontal=${args.horizontal}
        ?disabled=${args.disabled}
        ?hide-label=${args.hideLabel}
        ?required=${args.required}
        ?invalidated=${args.invalidated}
        ?validated=${args.validated}
        .message=${args.message}
      >
        <span slot="legend">Radio Group Header</span>
        <pharos-radio-button value="1"
          ><span slot="label">Radio Button 1</span></pharos-radio-button
        >
        <pharos-radio-button value="2"
          ><span slot="label">Radio Button 2</span></pharos-radio-button
        >
        <pharos-radio-button value="3"
          ><span slot="label">Radio Button 3</span></pharos-radio-button
        >
        <pharos-radio-button value="4"
          ><span slot="label">Radio Button 4</span></pharos-radio-button
        >
      </pharos-radio-group>
    `,
  args: defaultArgs
};
const Events = {
  render: () => lit/* html */.dy` <pharos-radio-group
      @change="${(e) => (0,esm.action)("Change")(e.target.value)}"
      name="radio-group2"
    >
      <span slot="legend">Radio Group Header</span>
      <pharos-radio-button value="1"><span slot="label">Radio Button 1</span></pharos-radio-button>
      <pharos-radio-button value="2" checked
        ><span slot="label">Radio Button 2</span></pharos-radio-button
      >
      <pharos-radio-button value="3"><span slot="label">Radio Button 3</span></pharos-radio-button>
    </pharos-radio-group>`,
  parameters: { options: { selectedPanel: "addon-actions" } }
};
const Validity = {
  ...Base,
  args: {
    ...Base.args,
    invalidated: true,
    required: true,
    message: "This field is required, please make a selection"
  }
};
const FormData = {
  render: () => lit/* html */.dy`
      <form name="my-form" action="https://httpbin.org/post" method="POST">
        <pharos-radio-group
          style="margin-bottom: 0.5rem;"
          @change="${(e) => (0,esm.action)("Change")(e.target.value)}"
          name="radio-group4"
          required
        >
          <span slot="legend">Radio Group Header</span>
          <pharos-radio-button value="1"
            ><span slot="label">Radio Button 1</span></pharos-radio-button
          >
          <pharos-radio-button value="2"
            ><span slot="label">Radio Button 2</span></pharos-radio-button
          >
          <pharos-radio-button value="3"
            ><span slot="label">Radio Button 3</span></pharos-radio-button
          >
        </pharos-radio-group>
        <pharos-button
          type="submit"
          value="Submit"
          @click="${(e) => {
    e.preventDefault();
    const form = document.querySelector('form[name="my-form"]');
    const formData = (0,createFormData/* default */.Z)(form);
    const xhr = new XMLHttpRequest();
    xhr.open("POST", "https://httpbin.org/post", true);
    xhr.onload = function() {
      const response = JSON.parse(this.responseText);
      (0,esm.action)("FormData")(JSON.stringify(response.form));
    };
    xhr.send(formData);
  }}"
          >Submit</pharos-button
        >
      </form>
    `
};


/***/ }),

/***/ "./packages/pharos/src/components/select/pharos-select.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Base": () => (/* binding */ Base),
  "Events": () => (/* binding */ Events),
  "FormData": () => (/* binding */ FormData),
  "States": () => (/* binding */ States),
  "Validity": () => (/* binding */ Validity),
  "WithOptionGroups": () => (/* binding */ WithOptionGroups),
  "default": () => (/* binding */ pharos_select_wc_stories)
});

// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./node_modules/@storybook/addon-actions/dist/esm/index.js + 8 modules
var esm = __webpack_require__("./node_modules/@storybook/addon-actions/dist/esm/index.js");
// EXTERNAL MODULE: ./packages/pharos/src/utils/createFormData.ts
var createFormData = __webpack_require__("./packages/pharos/src/utils/createFormData.ts");
// EXTERNAL MODULE: ./.storybook/docsPageConfig.jsx + 4 modules
var docsPageConfig = __webpack_require__("./.storybook/docsPageConfig.jsx");
;// CONCATENATED MODULE: ./packages/pharos/src/components/select/storyArgs.ts
const defaultArgs = {
  disabled: false,
  hideLabel: false,
  required: false,
  invalidated: false,
  validated: false,
  message: "",
  value: 3
};

;// CONCATENATED MODULE: ./packages/pharos/src/components/select/pharos-select.wc.stories.jsx





/* harmony default export */ const pharos_select_wc_stories = ({
  title: "Forms/Select",
  component: "pharos-select",
  parameters: {
    docs: { page: (0,docsPageConfig/* configureDocsPage */.k)("select") },
    options: { selectedPanel: "addon-controls" }
  }
});
const Base = {
  render: (args) => lit/* html */.dy`
      <pharos-select
        ?disabled=${args.disabled}
        ?hide-label=${args.hideLabel}
        ?required=${args.required}
        ?invalidated=${args.invalidated}
        .message=${args.message}
        style="display: grid; grid-template-columns: 300px;"
      >
        <span slot="label">Select Demo</span>
        <option value="1">Option 1</option>
        <option value="2">Option 2</option>
        <option value="3" selected>Option 3</option>
        <option value="4">Option 4</option>
        <option value="5">Option 5</option>
      </pharos-select>
    `,
  args: defaultArgs
};
const States = {
  render: () => lit/* html */.dy`
      <pharos-select>
        <span slot="label">Normal Select</span>
        <option value="1">Option 1</option>
        <option value="2" selected>Option 2</option>
      </pharos-select>
      <pharos-select disabled>
        <span slot="label">Disabled Select</span>
        <option value="1">Option 1</option>
        <option value="2" selected>Option 2</option>
      </pharos-select>
      <pharos-select invalidated>
        <span slot="label">Error Select</span>
        <option value="1">Option 1</option>
        <option value="2" selected>Option 2</option>
      </pharos-select>
    `
};
const WithOptionGroups = {
  name: "With option groups",
  render: () => lit/* html */.dy`
      <pharos-select>
        <span slot="label">Normal Select</span>
        <optgroup label="Group 1">
          <option value="1">Option 1</option>
          <option value="2" selected>Option 2</option>
        </optgroup>
        <optgroup label="Group 2">
          <option value="3">Option 3</option>
          <option value="4" selected>Option 4</option>
        </optgroup>
      </pharos-select>
    `
};
const Events = {
  render: () => lit/* html */.dy`
      <pharos-select @change="${(e) => (0,esm.action)("Change")(e.target.value)}">
        <span slot="label">Normal Select</span>
        <option value="1">Option 1 (Value is 1)</option>
        <option value="2">Option 2 (Value is 2)</option>
      </pharos-select>
    `,
  parameters: { options: { selectedPanel: "addon-actions" } }
};
const Validity = {
  ...Base,
  args: {
    ...Base.args,
    invalidated: true,
    required: true,
    message: "This field is required, please make a selection"
  }
};
const FormData = {
  render: () => lit/* html */.dy`
      <form name="my-form" action="https://httpbin.org/post" method="POST">
        <pharos-select name="my-select" required style="margin-bottom: 0.5rem;">
          <span slot="label">Select Demo</span>
          <option value="">Select an option</option>
          <option value="">----------------</option>
          <option value="1">Option 1</option>
          <option value="2">Option 2</option>
          <option value="3">Option 3</option>
        </pharos-select>
        <pharos-button
          type="submit"
          value="Submit"
          @click="${(e) => {
    e.preventDefault();
    const form = document.querySelector('form[name="my-form"]');
    const formData = (0,createFormData/* default */.Z)(form);
    const xhr = new XMLHttpRequest();
    xhr.open("POST", "https://httpbin.org/post", true);
    xhr.onload = function() {
      const response = JSON.parse(this.responseText);
      (0,esm.action)("FormData")(JSON.stringify(response.form));
    };
    xhr.send(formData);
  }}"
          >Submit</pharos-button
        >
      </form>
    `
};


/***/ }),

/***/ "./packages/pharos/src/components/sidenav/pharos-sidenav.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Base": () => (/* binding */ Base),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/lit/index.js");
/* harmony import */ var _config_docsPageConfig__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./.storybook/docsPageConfig.jsx");


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  title: "Components/Sidenav",
  component: "pharos-sidenav",
  subcomponents: {
    PharosSideNavMenu: "pharos-sidenav-menu",
    PharosSidenavSection: "pharos-sidenav-section",
    PharosSidenavLink: "pharos-sidenav-link",
    PharosSidenavButton: "pharos-sidenav-button"
  },
  parameters: {
    docs: { page: (0,_config_docsPageConfig__WEBPACK_IMPORTED_MODULE_1__/* .configureDocsPage */ .k)("sidenav") }
  }
});
const Base = {
  render: () => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
      <pharos-sidenav-button></pharos-sidenav-button>
      <pharos-sidenav>
        <pharos-link slot="top" href="/" id="jstor-logo">
          <img src="./images/jstor-logo-inverse.svg" alt="Pharos Home" width="72" height="100" />
        </pharos-link>
        <pharos-input-group
          slot="top"
          name="my-input-group"
          placeholder="Search"
          hide-label
          on-background
        >
          <span slot="label">Search</span>
          <pharos-button
            name="search-button"
            icon="search"
            variant="subtle"
            label="search"
            on-background
          ></pharos-button>
        </pharos-input-group>
        <pharos-sidenav-section show-divider>
          <pharos-sidenav-link href="#">Menu item</pharos-sidenav-link>
          <pharos-sidenav-menu label="Menu item w/accordion">
            <pharos-sidenav-link href="#">Menu item 1</pharos-sidenav-link>
            <pharos-sidenav-link href="#">Menu item 2</pharos-sidenav-link>
          </pharos-sidenav-menu>
          <pharos-sidenav-link href="#">Menu item</pharos-sidenav-link>
          <pharos-sidenav-link href="#" target="_blank" external>External link</pharos-sidenav-link>
          <pharos-sidenav-link href="#" target="_blank" external>External link</pharos-sidenav-link>
        </pharos-sidenav-section>
        <pharos-sidenav-section label="Section Heading" show-divider>
          <pharos-sidenav-menu label="Menu item w/accordion">
            <pharos-sidenav-link href="#">Menu item 1</pharos-sidenav-link>
            <pharos-sidenav-link href="#">Menu item 2</pharos-sidenav-link>
            <pharos-sidenav-link href="#">Menu item 3</pharos-sidenav-link>
          </pharos-sidenav-menu>
          <pharos-sidenav-menu label="Menu item w/accordion">
            <pharos-sidenav-link href="#">Menu item 1</pharos-sidenav-link>
            <pharos-sidenav-link href="#">Menu item 2</pharos-sidenav-link>
          </pharos-sidenav-menu>
          <pharos-sidenav-menu label="Menu item w/accordion">
            <pharos-sidenav-link href="#">Menu item 1</pharos-sidenav-link>
            <pharos-sidenav-link href="#">Menu item 2</pharos-sidenav-link>
            <pharos-sidenav-link href="#">Menu item 3</pharos-sidenav-link>
          </pharos-sidenav-menu>
        </pharos-sidenav-section>
        <pharos-sidenav-section label="Section Heading">
          <pharos-sidenav-menu label="Menu item w/accordion">
            <pharos-sidenav-link href="#">Menu item 1</pharos-sidenav-link>
            <pharos-sidenav-link href="#">Menu item 2</pharos-sidenav-link>
            <pharos-sidenav-link href="#">Menu item 3</pharos-sidenav-link>
            <pharos-sidenav-link href="#">Menu item 4</pharos-sidenav-link>
          </pharos-sidenav-menu>
          <pharos-sidenav-menu label="Menu item w/accordion">
            <pharos-sidenav-link href="#">Menu item 1</pharos-sidenav-link>
            <pharos-sidenav-link href="#">Menu item 2</pharos-sidenav-link>
          </pharos-sidenav-menu>
          <pharos-sidenav-menu label="Menu item w/accordion">
            <pharos-sidenav-link href="#">Menu item 1</pharos-sidenav-link>
            <pharos-sidenav-link href="#">Menu item 2</pharos-sidenav-link>
            <pharos-sidenav-link href="#">Menu item 3</pharos-sidenav-link>
          </pharos-sidenav-menu>
          <pharos-sidenav-link href="#">Menu item</pharos-sidenav-link>
        </pharos-sidenav-section>
      </pharos-sidenav>
    `,
  parameters: {
    chromatic: { viewports: [320, 1200] },
    docs: { disable: true }
  }
};


/***/ }),

/***/ "./packages/pharos/src/components/tabs/pharos-tabs.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Base": () => (/* binding */ Base),
/* harmony export */   "Events": () => (/* binding */ Events),
/* harmony export */   "HorizontalScrolling": () => (/* binding */ HorizontalScrolling),
/* harmony export */   "PanelOrder": () => (/* binding */ PanelOrder),
/* harmony export */   "PanelSeparator": () => (/* binding */ PanelSeparator),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _storybook_addon_actions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/@storybook/addon-actions/dist/esm/index.js");
/* harmony import */ var lit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/lit/index.js");
/* harmony import */ var _config_docsPageConfig__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./.storybook/docsPageConfig.jsx");



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  title: "Components/Tabs",
  component: "pharos-tabs",
  subcomponents: { PharosTab: "pharos-tab", PharosTabPanel: "pharos-tab-panel" },
  parameters: {
    docs: { page: (0,_config_docsPageConfig__WEBPACK_IMPORTED_MODULE_2__/* .configureDocsPage */ .k)("tabs") },
    options: { selectedPanel: "addon-controls" }
  }
});
const Base = {
  render: () => lit__WEBPACK_IMPORTED_MODULE_1__/* .html */ .dy`
      <pharos-tabs>
        <pharos-tab id="tab-1" data-panel-id="panel-1">Tab 1</pharos-tab>
        <pharos-tab id="tab-2" data-panel-id="panel-2">Tab 2</pharos-tab>
        <pharos-tab id="tab-3" data-panel-id="panel-3">Tab 3</pharos-tab>
        <pharos-tab-panel id="panel-1" slot="panel">Panel 1</pharos-tab-panel>
        <pharos-tab-panel id="panel-2" slot="panel">Panel 2</pharos-tab-panel>
        <pharos-tab-panel id="panel-3" slot="panel">Panel 3</pharos-tab-panel>
      </pharos-tabs>
    `
};
const Events = {
  render: () => lit__WEBPACK_IMPORTED_MODULE_1__/* .html */ .dy`
      <pharos-tabs @pharos-tab-selected="${(e) => (0,_storybook_addon_actions__WEBPACK_IMPORTED_MODULE_0__.action)("Selected")(e.target.id)}">
        <pharos-tab id="tab-1" data-panel-id="panel-1">Tab 1</pharos-tab>
        <pharos-tab id="tab-2" data-panel-id="panel-2">Tab 2</pharos-tab>
        <pharos-tab id="tab-3" data-panel-id="panel-3" selected>Tab 3</pharos-tab>
        <pharos-tab-panel id="panel-1" slot="panel">Panel 1</pharos-tab-panel>
        <pharos-tab-panel id="panel-2" slot="panel">Panel 2</pharos-tab-panel>
        <pharos-tab-panel id="panel-3" slot="panel">Panel 3</pharos-tab-panel>
      </pharos-tabs>
    `,
  parameters: { options: { selectedPanel: "addon-controls" } }
};
const PanelOrder = {
  render: () => lit__WEBPACK_IMPORTED_MODULE_1__/* .html */ .dy`
      <pharos-tabs>
        <pharos-tab id="tab-1" data-panel-id="panel-1">Tab 1</pharos-tab>
        <pharos-tab id="tab-2" data-panel-id="panel-2">Tab 2</pharos-tab>
        <pharos-tab id="tab-3" data-panel-id="panel-3">Tab 3</pharos-tab>
        <pharos-tab-panel id="panel-2" slot="panel"
          >I am the panel for tab 2 but listed 1st in the DOM</pharos-tab-panel
        >
        <pharos-tab-panel id="panel-3" slot="panel"
          >I am the panel for tab 3 but listed 2nd in the DOM</pharos-tab-panel
        >
        <pharos-tab-panel id="panel-1" slot="panel"
          >I am the panel for tab 1 but listed 3rd in the DOM</pharos-tab-panel
        >
      </pharos-tabs>
    `
};
const PanelSeparator = {
  render: () => lit__WEBPACK_IMPORTED_MODULE_1__/* .html */ .dy`
      <pharos-tabs panel-separator style="width: 100%">
        <pharos-tab id="tab-1" data-panel-id="panel-1">Tab 1</pharos-tab>
        <pharos-tab id="tab-2" data-panel-id="panel-2">Tab 2</pharos-tab>
        <pharos-tab id="tab-3" data-panel-id="panel-3">Tab 3</pharos-tab>
        <pharos-tab-panel id="panel-1" slot="panel"
          >Panel 1 with a panel separator</pharos-tab-panel
        >
        <pharos-tab-panel id="panel-2" slot="panel"
          >Panel 2 with a panel separator</pharos-tab-panel
        >
        <pharos-tab-panel id="panel-3" slot="panel"
          >Panel 3 with a panel separator</pharos-tab-panel
        >
      </pharos-tabs>
    `
};
const HorizontalScrolling = {
  render: () => lit__WEBPACK_IMPORTED_MODULE_1__/* .html */ .dy`
      <pharos-tabs panel-separator style="width: 100%">
        <pharos-tab id="tab-1" data-panel-id="panel-1">Tab 1</pharos-tab>
        <pharos-tab id="tab-2" data-panel-id="panel-2">Tab 2</pharos-tab>
        <pharos-tab id="tab-3" data-panel-id="panel-3">Tab 3</pharos-tab>
        <pharos-tab id="tab-4" data-panel-id="panel-4">Tab 4</pharos-tab>
        <pharos-tab id="tab-5" data-panel-id="panel-5">Tab 5</pharos-tab>
        <pharos-tab id="tab-6" data-panel-id="panel-6">Tab 6</pharos-tab>
        <pharos-tab id="tab-7" data-panel-id="panel-7" selected>Tab 7</pharos-tab>
        <pharos-tab id="tab-8" data-panel-id="panel-8">Tab 8</pharos-tab>
        <pharos-tab id="tab-9" data-panel-id="panel-9">Tab 9</pharos-tab>
        <pharos-tab-panel id="panel-1" slot="panel"
          >Panel 1 with a panel separator</pharos-tab-panel
        >
        <pharos-tab-panel id="panel-2" slot="panel"
          >Panel 2 with a panel separator</pharos-tab-panel
        >
        <pharos-tab-panel id="panel-3" slot="panel"
          >Panel 3 with a panel separator</pharos-tab-panel
        >
        <pharos-tab-panel id="panel-4" slot="panel"
          >Panel 4 with a panel separator</pharos-tab-panel
        >
        <pharos-tab-panel id="panel-5" slot="panel"
          >Panel 5 with a panel separator</pharos-tab-panel
        >
        <pharos-tab-panel id="panel-6" slot="panel"
          >Panel 6 with a panel separator</pharos-tab-panel
        >
        <pharos-tab-panel id="panel-7" slot="panel"
          >Panel 7 with a panel separator</pharos-tab-panel
        >
        <pharos-tab-panel id="panel-8" slot="panel"
          >Panel 8 with a panel separator</pharos-tab-panel
        >
        <pharos-tab-panel id="panel-9" slot="panel"
          >Panel 9 with a panel separator</pharos-tab-panel
        >
      </pharos-tabs>
    `,
  parameters: {
    viewport: { defaultViewport: "mobile1" },
    chromatic: { viewports: [320, 1200] }
  }
};


/***/ }),

/***/ "./packages/pharos/src/components/text-input/pharos-text-input.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Base": () => (/* binding */ Base),
  "CustomErrorMessage": () => (/* binding */ CustomErrorMessage),
  "Events": () => (/* binding */ Events),
  "FormData": () => (/* binding */ FormData),
  "States": () => (/* binding */ States),
  "Validity": () => (/* binding */ Validity),
  "default": () => (/* binding */ pharos_text_input_wc_stories)
});

// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./node_modules/@storybook/addon-actions/dist/esm/index.js + 8 modules
var esm = __webpack_require__("./node_modules/@storybook/addon-actions/dist/esm/index.js");
// EXTERNAL MODULE: ./node_modules/lit/directives/if-defined.js + 1 modules
var if_defined = __webpack_require__("./node_modules/lit/directives/if-defined.js");
// EXTERNAL MODULE: ./packages/pharos/src/utils/createFormData.ts
var createFormData = __webpack_require__("./packages/pharos/src/utils/createFormData.ts");
// EXTERNAL MODULE: ./packages/pharos/src/components/text-input/pharos-text-input.ts + 1 modules
var pharos_text_input = __webpack_require__("./packages/pharos/src/components/text-input/pharos-text-input.ts");
;// CONCATENATED MODULE: ./packages/pharos/src/components/text-input/storyArgs.ts

const defaultArgs = {
  name: "story-input",
  type: "text",
  label: "I am a label",
  hideLabel: false,
  validated: false,
  invalidated: false,
  required: false,
  message: "",
  placeholder: "placeholder",
  disabled: false,
  readonly: false,
  value: ""
};
const argTypes = {
  type: {
    options: pharos_text_input/* allTypes */._,
    control: {
      type: "inline-radio"
    }
  }
};

// EXTERNAL MODULE: ./.storybook/docsPageConfig.jsx + 4 modules
var docsPageConfig = __webpack_require__("./.storybook/docsPageConfig.jsx");
;// CONCATENATED MODULE: ./packages/pharos/src/components/text-input/pharos-text-input.wc.stories.jsx






/* harmony default export */ const pharos_text_input_wc_stories = ({
  title: "Forms/Text Input",
  component: "pharos-text-input",
  parameters: {
    docs: { page: (0,docsPageConfig/* configureDocsPage */.k)("text-input") },
    options: { selectedPanel: "addon-controls" }
  },
  argTypes: argTypes
});
const Base = {
  render: (args) => lit/* html */.dy`
      <div style="display: grid; grid-gap: 1rem; grid-template-columns: 300px;">
        <pharos-text-input
          name="${args.name}"
          type="${(0,if_defined/* ifDefined */.o)(args.type)}"
          ?hide-label="${args.hideLabel}"
          ?validated="${args.validated}"
          ?invalidated="${args.invalidated}"
          ?required="${args.required}"
          .message="${args.message}"
          .placeholder=${args.placeholder}
          ?disabled=${args.disabled}
          ?readonly=${args.readonly}
          .value=${args.value}
        >
          <span slot="label">${args.label}</span>
        </pharos-text-input>
      </div>
    `,
  args: defaultArgs
};
const States = {
  render: () => lit/* html */.dy`
      <div
        style="display: grid; grid-gap: 1rem; grid-template-columns: repeat(2, 300px); 1rem 300px"
      >
        <pharos-text-input name="default"><span slot="label">Empty input</span></pharos-text-input>
        <pharos-text-input name="disabled" disabled
          ><span slot="label">Disabled input</span></pharos-text-input
        >
        <pharos-text-input name="readonly" readonly value="Example text"
          ><span slot="label">Read only input</span></pharos-text-input
        >
        <pharos-text-input name="placeholder" placeholder="example placeholder text"
          ><span slot="label">Placeholder for input</span></pharos-text-input
        >
        <pharos-text-input name="provided" value="This value was provided"
          ><span slot="label">Value provided</span></pharos-text-input
        >
        <pharos-text-input name="hidden" hide-label value="Hidden label input"
          ><span slot="label">Hidden label</span></pharos-text-input
        >
        <pharos-text-input name="validated" value="A validated value" validated
          ><span slot="label">Validated input</span></pharos-text-input
        >
        <pharos-text-input name="prominent" placeholder="so prominent" variant="prominent"
          ><span slot="label">Prominent input</span></pharos-text-input
        >
      </div>
    `
};
const Events = {
  render: () => lit/* html */.dy`
      <div style="display: grid; grid-gap: 1rem; grid-template-columns: 300px;">
        <pharos-text-input
          placeholder="Enter some text"
          @change="${(e) => (0,esm.action)("Change")(e.target.value)}"
          @input="${(e) => (0,esm.action)("Input")(e.target.value)}"
        >
          <span slot="label">I fire events on input</span>
        </pharos-text-input>
      </div>
    `,
  parameters: { options: { selectedPanel: "addon-actions" } }
};
const Validity = {
  ...Base,
  args: {
    ...Base.args,
    label: "Test me out",
    required: true,
    invalidated: true,
    message: "This password does not meet the requirements"
  }
};
const CustomErrorMessage = {
  render: (args) => lit/* html */.dy`
      <div style="display: grid; grid-gap: 1rem; grid-template-columns: 300px;">
        <pharos-text-input
          placeholder="Enter some text"
          @change="${(e) => (0,esm.action)("Change")(e.target.value)}"
          @input="${(e) => (0,esm.action)("Input")(e.target.value)}"
          ?required="${args.required}"
          ?invalidated=${args.invalidated}
          ?validated=${args.validated}
          .message=${args.message}
        >
          <span slot="label">I am invalid</span>
          <span slot="message">
            <ul style="margin: 0;padding-inline-start: 1.5rem;">
              <li>One upper or lowercase letter</li>
              <li>One number or special character</li>
              <li>6 character minimum</li>
              <li>No whitespace</li>
            </ul>
          </span>
        </pharos-text-input>
      </div>
    `,
  args: {
    ...Base.args,
    invalidated: true,
    message: "This password does not meet the requirements"
  }
};
const FormData = {
  render: () => lit/* html */.dy`
      <div style="display: grid; grid-gap: 1rem; grid-template-columns: 300px;">
        <form name="my-form" action="https://httpbin.org/post" method="POST">
          <pharos-text-input
            style="margin-bottom: 0.5rem;"
            name="my-text-input"
            placeholder="Enter some text"
            @change="${(e) => (0,esm.action)("Change")(e.target.value)}"
            @input="${(e) => (0,esm.action)("Input")(e.target.value)}"
            required
          >
            <span slot="label">Test me out</span>
          </pharos-text-input>
          <pharos-button
            type="submit"
            value="Submit"
            @click="${(e) => {
    e.preventDefault();
    const form = document.querySelector('form[name="my-form"]');
    const formData = (0,createFormData/* default */.Z)(form);
    const xhr = new XMLHttpRequest();
    xhr.open("POST", "https://httpbin.org/post", true);
    xhr.onload = function() {
      const response = JSON.parse(this.responseText);
      (0,esm.action)("FormData")(JSON.stringify(response.form));
    };
    xhr.send(formData);
  }}"
            >Submit
          </pharos-button>
        </form>
      </div>
    `
};


/***/ }),

/***/ "./packages/pharos/src/components/textarea/pharos-textarea.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Base": () => (/* binding */ Base),
  "CustomErrorMessage": () => (/* binding */ CustomErrorMessage),
  "Events": () => (/* binding */ Events),
  "FormData": () => (/* binding */ FormData),
  "States": () => (/* binding */ States),
  "Validity": () => (/* binding */ Validity),
  "default": () => (/* binding */ pharos_textarea_wc_stories)
});

// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./node_modules/@storybook/addon-actions/dist/esm/index.js + 8 modules
var esm = __webpack_require__("./node_modules/@storybook/addon-actions/dist/esm/index.js");
// EXTERNAL MODULE: ./node_modules/lit/directives/if-defined.js + 1 modules
var if_defined = __webpack_require__("./node_modules/lit/directives/if-defined.js");
// EXTERNAL MODULE: ./packages/pharos/src/utils/createFormData.ts
var createFormData = __webpack_require__("./packages/pharos/src/utils/createFormData.ts");
// EXTERNAL MODULE: ./.storybook/docsPageConfig.jsx + 4 modules
var docsPageConfig = __webpack_require__("./.storybook/docsPageConfig.jsx");
;// CONCATENATED MODULE: ./packages/pharos/src/components/textarea/storyArgs.ts
const defaultArgs = {
  name: "story-input",
  label: "I am a label",
  disabled: false,
  hideLabel: false,
  invalidated: false,
  validated: false,
  message: "",
  placeholder: "Enter some text",
  readonly: false,
  required: false,
  value: "Some text",
  rows: 2,
  columns: 20
};

;// CONCATENATED MODULE: ./packages/pharos/src/components/textarea/pharos-textarea.wc.stories.jsx






/* harmony default export */ const pharos_textarea_wc_stories = ({
  title: "Forms/Textarea",
  component: "pharos-textarea",
  parameters: {
    docs: { page: (0,docsPageConfig/* configureDocsPage */.k)("textarea") },
    options: { selectedPanel: "addon-controls" }
  }
});
const Base = {
  render: (args) => lit/* html */.dy`
      <div style="display: grid; grid-gap: 1rem; grid-template-columns: 250px;">
        <pharos-textarea
          name="story-input"
          .cols="${args.columns}"
          ?disabled=${args.disabled}
          ?hide-label="${args.hideLabel}"
          ?invalidated=${args.invalidated}
          .message=${args.message}
          .placeholder=${args.placeholder}
          .resize="${(0,if_defined/* ifDefined */.o)(args.resize)}"
          ?readonly=${args.readonly}
          ?required=${args.required}
          .rows="${args.rows}"
          ?validated=${args.validated}
          .value=${args.value}
        >
          <span slot="label">${args.label}</span>
        </pharos-textarea>
      </div>
    `,
  args: defaultArgs
};
const States = {
  render: () => lit/* html */.dy`
      <div style="display: grid; grid-gap: 1rem; grid-template-columns: repeat(2, 250px);">
        <pharos-textarea name="default"><span slot="label">Empty textarea</span></pharos-textarea>
        <pharos-textarea name="disabled" disabled
          ><span slot="label">Disabled textarea</span></pharos-textarea
        >
        <pharos-textarea name="readonly" readonly value="Example text"
          ><span slot="label">Read only textarea</span></pharos-textarea
        >
        <pharos-textarea name="placeholder" placeholder="Placeholder text"
          ><span slot="label">Placeholder for textarea</span></pharos-textarea
        >
        <pharos-textarea name="provided" value="This value is provided"
          ><span slot="label">Value provided textarea</span></pharos-textarea
        >
        <pharos-textarea name="resize" resize="none"
          ><span slot="label">non-resizeable textarea</span></pharos-textarea
        >
      </div>
    `
};
const Events = {
  render: () => lit/* html */.dy`
      <div style="display: grid; grid-gap: 1rem; grid-template-columns: 250px;">
        <pharos-textarea
          placeholder="Enter some text"
          @change="${(e) => (0,esm.action)("Change")(e.target.value)}"
          @input="${(e) => (0,esm.action)("Input")(e.target.value)}"
        >
          <span slot="label">I fire events on input</span>
        </pharos-textarea>
      </div>
    `,
  parameters: { options: { selectedPanel: "addon-actions" } }
};
const Validity = {
  ...Base,
  args: {
    ...Base.args,
    label: "Test me out",
    required: true,
    value: "",
    placeholder: "",
    invalidated: true,
    message: "This field does not meet the requirements"
  }
};
const CustomErrorMessage = {
  render: (args) => lit/* html */.dy`
      <div style="display: grid; grid-gap: 1rem; grid-template-columns: 350px;">
        <pharos-textarea
          placeholder="Enter some text"
          @change="${(e) => (0,esm.action)("Change")(e.target.value)}"
          @input="${(e) => (0,esm.action)("Input")(e.target.value)}"
          ?required=${args.required}
          ?invalidated=${args.invalidated}
          ?validated=${args.validated}
          .message=${args.message}
        >
          <span slot="label">I am invalid</span>
          <span slot="message">
            <p>Must be over 100 characters long</p>
          </span>
        </pharos-textarea>
      </div>
    `,
  args: {
    ...Base.args,
    invalidated: true,
    message: "This field does not meet the requirements"
  }
};
const FormData = {
  render: () => lit/* html */.dy`
      <div style="display: grid; grid-gap: 1rem; grid-template-columns: 350px;">
        <form name="my-form" action="https://httpbin.org/post" method="POST">
          <pharos-textarea
            name="my-textarea"
            placeholder="Enter some text"
            style="margin-bottom: 0.5rem;"
            @change="${(e) => (0,esm.action)("Change")(e.target.value)}"
            @input="${(e) => (0,esm.action)("Input")(e.target.value)}"
            required
          >
            <span slot="label">I am invalid</span>
          </pharos-textarea>
          <pharos-button
            type="submit"
            value="Submit"
            @click="${(e) => {
    e.preventDefault();
    const form = document.querySelector('form[name="my-form"]');
    const formData = (0,createFormData/* default */.Z)(form);
    const xhr = new XMLHttpRequest();
    xhr.open("POST", "https://httpbin.org/post", true);
    xhr.onload = function() {
      const response = JSON.parse(this.responseText);
      (0,esm.action)("FormData")(JSON.stringify(response.form));
    };
    xhr.send(formData);
  }}"
          >
            Submit
          </pharos-button>
        </form>
      </div>
    `
};


/***/ }),

/***/ "./packages/pharos/src/components/toast/pharos-toast.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Base": () => (/* binding */ Base),
/* harmony export */   "Error": () => (/* binding */ Error),
/* harmony export */   "Info": () => (/* binding */ Info),
/* harmony export */   "LongContent": () => (/* binding */ LongContent),
/* harmony export */   "UpdateableToast": () => (/* binding */ UpdateableToast),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _storybook_client_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/@storybook/addons/dist/esm/hooks.js");
/* harmony import */ var lit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/lit/index.js");
/* harmony import */ var _config_docsPageConfig__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./.storybook/docsPageConfig.jsx");



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  title: "Components/Toast",
  component: "pharos-toast",
  subcomponents: { PharosToaster: "pharos-toaster" },
  parameters: {
    docs: { page: (0,_config_docsPageConfig__WEBPACK_IMPORTED_MODULE_1__/* .configureDocsPage */ .k)("toast") },
    options: { selectedPanel: "addon-controls" },
    chromatic: { delay: 500 }
  }
});
const Base = {
  render: () => {
    const effect = () => {
      (0,_storybook_client_api__WEBPACK_IMPORTED_MODULE_2__/* .useEffect */ .d4)(() => {
        document.querySelector("#success-toast-button").click();
      });
    };
    effect();
    return lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
      <pharos-button
        id="success-toast-button"
        @click="${() => {
      const event = new CustomEvent("pharos-toast-open", {
        detail: {
          content: 'The item has moved to your <pharos-link href="#" on-background bold>Workspace</pharos-link>.'
        }
      });
      document.dispatchEvent(event);
    }}"
      >
        Have a toast!
      </pharos-button>
      <pharos-toaster></pharos-toaster>
    `;
  },
  parameters: { chromatic: { viewports: [320, 1200] } }
};
const Error = {
  render: () => {
    const effect = () => {
      (0,_storybook_client_api__WEBPACK_IMPORTED_MODULE_2__/* .useEffect */ .d4)(() => {
        document.querySelector("#error-toast-button").click();
      });
    };
    effect();
    return lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
      <pharos-button
        id="error-toast-button"
        @click="${() => {
      const event = new CustomEvent("pharos-toast-open", {
        detail: {
          status: "error",
          content: 'Sorry, we were unable to move the item. Please try again later. If the issue persists, <pharos-link href="#" on-background bold>contact JSTOR Support</pharos-link>.'
        }
      });
      document.dispatchEvent(event);
    }}"
      >
        I have a bad feeling about this
      </pharos-button>
      <pharos-toaster></pharos-toaster>
    `;
  }
};
const LongContent = {
  render: () => {
    const effect = () => {
      (0,_storybook_client_api__WEBPACK_IMPORTED_MODULE_2__/* .useEffect */ .d4)(() => {
        setTimeout(() => {
          document.querySelector("#long-toast-button").click();
        }, 300);
      });
    };
    effect();
    return lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
      <pharos-button
        id="long-toast-button"
        @click="${() => {
      const event = new CustomEvent("pharos-toast-open", {
        detail: {
          content: 'This is a notification for longer content, which may even include a <pharos-link href="#" on-background bold>link</pharos-link>.'
        }
      });
      document.dispatchEvent(event);
    }}"
      >
        Click to me see a long name
      </pharos-button>
      <pharos-toaster></pharos-toaster>
    `;
  },
  parameters: { chromatic: { viewports: [320, 1200] } }
};
const Info = {
  render: () => {
    const effect = () => {
      (0,_storybook_client_api__WEBPACK_IMPORTED_MODULE_2__/* .useEffect */ .d4)(() => {
        document.querySelector("#info-toast-button").click();
      });
    };
    effect();
    return lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
      <pharos-button
        id="info-toast-button"
        @click="${() => {
      const event = new CustomEvent("pharos-toast-open", {
        detail: {
          status: "info",
          content: "We are working on your request."
        }
      });
      document.dispatchEvent(event);
    }}"
      >
        Click me to know more
      </pharos-button>
      <pharos-toaster></pharos-toaster>
    `;
  }
};
const UpdateableToast = {
  render: () => {
    const effect = () => {
      (0,_storybook_client_api__WEBPACK_IMPORTED_MODULE_2__/* .useEffect */ .d4)(() => {
        document.querySelector("#info-toast-button").click();
      });
    };
    effect();
    return lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
      <pharos-button
        id="info-toast-button"
        @click="${() => {
      const event = new CustomEvent("pharos-toast-open", {
        detail: {
          status: "info",
          content: "Saving 15 items to your Workspace",
          indefinite: true
        }
      });
      document.dispatchEvent(event);
      setTimeout(() => {
        const updateEvent = new CustomEvent("pharos-toast-update", {
          detail: {
            status: "success",
            content: "15 items succsessfully saved"
          }
        });
        document.dispatchEvent(updateEvent);
      }, "3000");
      setTimeout(() => {
        const updateEvent = new CustomEvent("pharos-toast-close", {});
        document.dispatchEvent(updateEvent);
      }, "6000");
    }}"
      >
        Save items to Workspace
      </pharos-button>
      <pharos-toaster></pharos-toaster>
    `;
  }
};


/***/ }),

/***/ "./packages/pharos/src/components/toggle-button-group/pharos-toggle-button-group.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Base": () => (/* binding */ Base),
/* harmony export */   "Events": () => (/* binding */ Events),
/* harmony export */   "IconsOnly": () => (/* binding */ IconsOnly),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _storybook_addon_actions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/@storybook/addon-actions/dist/esm/index.js");
/* harmony import */ var lit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/lit/index.js");
/* harmony import */ var _config_docsPageConfig__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./.storybook/docsPageConfig.jsx");



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  title: "Components/Toggle Button Group",
  component: "pharos-toggle-button-group",
  subcomponents: { PharosToggleButton: "pharos-toggle-button" },
  parameters: {
    docs: { page: (0,_config_docsPageConfig__WEBPACK_IMPORTED_MODULE_2__/* .configureDocsPage */ .k)("toggle-button-group") },
    options: { selectedPanel: "addon-controls" }
  }
});
const Base = {
  render: () => lit__WEBPACK_IMPORTED_MODULE_1__/* .html */ .dy`
      <pharos-toggle-button-group>
        <pharos-toggle-button
          @click="${() => {
    document.querySelector("#list-view").style.display = "block";
    document.querySelector("#gallery-view").style.display = "none";
    document.querySelector("#presentation-view").style.display = "none";
  }}"
          icon-left="view-list"
          id="view-list-button"
        >
          List </pharos-toggle-button
        ><pharos-toggle-button
          @click="${() => {
    document.querySelector("#list-view").style.display = "none";
    document.querySelector("#gallery-view").style.display = "block";
    document.querySelector("#presentation-view").style.display = "none";
  }}"
          icon-left="view-gallery"
          id="view-gallery-button"
        >
          Gallery </pharos-toggle-button
        ><pharos-toggle-button
          @click="${() => {
    document.querySelector("#list-view").style.display = "none";
    document.querySelector("#gallery-view").style.display = "none";
    document.querySelector("#presentation-view").style.display = "block";
  }}"
          icon-left="image"
          id="view-presentation-button"
        >
          Presentation
        </pharos-toggle-button>
      </pharos-toggle-button-group>
      <div id="list-view">List view</div>
      <div id="gallery-view" style="display: none">Gallery view</div>
      <div id="presentation-view" style="display: none">Presentation view</div>
    `
};
const Events = {
  render: () => lit__WEBPACK_IMPORTED_MODULE_1__/* .html */ .dy`
      <pharos-toggle-button-group
        @pharos-toggle-button-selected="${(e) => (0,_storybook_addon_actions__WEBPACK_IMPORTED_MODULE_0__.action)("Selected")(e.target.id)}"
      >
        <pharos-toggle-button id="list-mode-button" icon-left="view-list">
          List </pharos-toggle-button
        ><pharos-toggle-button id="gallery-mode-button" icon-left="view-gallery">
          Gallery
        </pharos-toggle-button>
      </pharos-toggle-button-group>
    `,
  parameters: { options: { selectedPanel: "addon-actions" } }
};
const IconsOnly = {
  render: () => lit__WEBPACK_IMPORTED_MODULE_1__/* .html */ .dy`
      <pharos-toggle-button-group>
        <pharos-toggle-button icon="view-list" id="view-list-button"></pharos-toggle-button
        ><pharos-toggle-button icon="view-gallery" id="view-gallery-button"></pharos-toggle-button
        ><pharos-toggle-button icon="image" id="view-presentation-button"></pharos-toggle-button>
      </pharos-toggle-button-group>
    `
};


/***/ }),

/***/ "./packages/pharos/src/components/tooltip/pharos-tooltip.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Base": () => (/* binding */ Base),
  "CustomBoundary": () => (/* binding */ CustomBoundary),
  "DismissBehavior": () => (/* binding */ DismissBehavior),
  "Fallbacks": () => (/* binding */ Fallbacks),
  "FullWidth": () => (/* binding */ FullWidth),
  "MultipleTriggers": () => (/* binding */ MultipleTriggers),
  "Placement": () => (/* binding */ Placement),
  "default": () => (/* binding */ pharos_tooltip_wc_stories)
});

// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./node_modules/lit/directives/if-defined.js + 1 modules
var if_defined = __webpack_require__("./node_modules/lit/directives/if-defined.js");
// EXTERNAL MODULE: ./node_modules/@storybook/addons/dist/esm/hooks.js
var hooks = __webpack_require__("./node_modules/@storybook/addons/dist/esm/hooks.js");
// EXTERNAL MODULE: ./packages/pharos/src/components/base/overlay-element.ts
var overlay_element = __webpack_require__("./packages/pharos/src/components/base/overlay-element.ts");
;// CONCATENATED MODULE: ./packages/pharos/src/components/tooltip/storyArgs.ts

const defaultArgs = {
  fullWidth: false,
  open: false,
  targetText: "Focus here",
  tooltipText: "Hi there again!",
  id: "my-tooltip",
  placement: "top",
  fallbackPlacements: []
};
const argTypes = {
  placement: {
    options: overlay_element/* allPlacements */.e2,
    control: {
      type: "inline-radio"
    }
  },
  fallbackPlacements: {
    control: { type: "array" }
  }
};

// EXTERNAL MODULE: ./.storybook/docsPageConfig.jsx + 4 modules
var docsPageConfig = __webpack_require__("./.storybook/docsPageConfig.jsx");
;// CONCATENATED MODULE: ./packages/pharos/src/components/tooltip/pharos-tooltip.wc.stories.jsx





/* harmony default export */ const pharos_tooltip_wc_stories = ({
  title: "Components/Tooltip",
  component: "pharos-tooltip",
  parameters: {
    docs: { page: (0,docsPageConfig/* configureDocsPage */.k)("tooltip") },
    options: { selectedPanel: "addon-controls" },
    chromatic: { delay: 800 }
  },
  argTypes: argTypes
});
const Base = {
  render: (args) => {
    const effect = () => {
      (0,hooks/* useEffect */.d4)(() => {
        setTimeout(() => {
          document.querySelector("#my-button").dispatchEvent(new Event("mouseenter"));
        }, 700);
      });
    };
    effect();
    return lit/* html */.dy`
      <div style="display: grid; grid-gap: 8rem; margin-top: 5rem; justify-content: space-evenly;">
        <pharos-button id="my-button" data-tooltip-id="${args.id}"
          >${args.targetText}</pharos-button
        >
        <pharos-tooltip
          id="${args.id}"
          ?full-width="${args.fullWidth}"
          ?open="${args.open}"
          .placement="${(0,if_defined/* ifDefined */.o)(args.placement)}"
          .fallbackPlacements="${args.fallbackPlacements}"
          >${args.tooltipText}
        </pharos-tooltip>
      </div>
    `;
  },
  args: defaultArgs
};
const Placement = {
  ...Base,
  args: {
    ...Base.args,
    targetText: "Placement",
    id: "my-placement-tooltip"
  }
};
const DismissBehavior = {
  render: () => lit/* html */.dy`
      <div
        style="display: grid; grid-template-columns: repeat(3, auto); grid-gap: 8rem; margin-top: 5rem; justify-content: space-evenly;"
      >
        <pharos-button data-tooltip-id="my-hi-tooltip">Focus here</pharos-button>
        <pharos-tooltip id="my-hi-tooltip">Hi there!</pharos-tooltip>
        <pharos-button data-tooltip-id="my-again-tooltip">Then hover here</pharos-button>
        <pharos-tooltip id="my-again-tooltip">Hi there again!</pharos-tooltip>
        <pharos-button data-tooltip-id="my-yo-tooltip">Then focus me</pharos-button>
        <pharos-tooltip id="my-yo-tooltip">Yo!</pharos-tooltip>
      </div>
    `
};
const Fallbacks = {
  ...Base,
  args: {
    ...Base.args,
    id: "my-fallback-tooltip",
    targetText: "Fallback Placement",
    fallbackPlacements: ["top"]
  }
};
const FullWidth = {
  ...Base,
  args: {
    ...Base.args,
    fullWidth: true,
    placement: "auto",
    targetText: "Hover here to see a tooltip that is as wide as me. If you resize the window while its open, its width will continue to match mine!",
    tooltipText: `When using the fullWidth attribute, the display of the tooltip will always be the size of the button that triggers the tooltip, regardless of the length of the text.`,
    id: "my-full-tooltip"
  }
};
const MultipleTriggers = {
  render: () => lit/* html */.dy`
      <div
        style="display: grid; grid-template-columns: repeat(3, auto); grid-gap: 8rem; margin-top: 5rem; justify-content: space-evenly;"
      >
        <pharos-button data-tooltip-id="my-multi-tooltip">Focus here</pharos-button>
        <pharos-button data-tooltip-id="my-multi-tooltip">Then hover here</pharos-button>
        <pharos-button data-tooltip-id="my-multi-tooltip">Then focus me</pharos-button>
        <pharos-tooltip id="my-multi-tooltip" full-width>Hi there!</pharos-tooltip>
      </div>
    `
};
const CustomBoundary = {
  render: () => lit/* html */.dy`
      <div style="display: grid; grid-gap: 8rem; margin-top: 5rem; justify-content: space-evenly;">
        <pharos-button id="my-button" data-dropdown-menu-id="my-menu" icon-right="chevron-down"
          >Click Me</pharos-button
        >
        <pharos-dropdown-menu id="my-menu">
          <pharos-dropdown-menu-item>Menu item 1</pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item>Menu item 2</pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item data-tooltip-id="my-tooltip"
            >Hover on Me</pharos-dropdown-menu-item
          >
          <pharos-tooltip id="my-tooltip" boundary="my-menu"
            >Even very long tooltips, such as this one, will stay within the boundaries of the
            Tooltip.</pharos-tooltip
          >
        </pharos-dropdown-menu>
      </div>
    `
};


/***/ }),

/***/ "./packages/pharos/src/pages/home/wc/home.pages.stories.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Home": () => (/* binding */ Home),
  "default": () => (/* binding */ home_pages_stories)
});

// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js
var injectStylesIntoStyleTag = __webpack_require__("./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
var injectStylesIntoStyleTag_default = /*#__PURE__*/__webpack_require__.n(injectStylesIntoStyleTag);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleDomAPI.js
var styleDomAPI = __webpack_require__("./node_modules/style-loader/dist/runtime/styleDomAPI.js");
var styleDomAPI_default = /*#__PURE__*/__webpack_require__.n(styleDomAPI);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertBySelector.js
var insertBySelector = __webpack_require__("./node_modules/style-loader/dist/runtime/insertBySelector.js");
var insertBySelector_default = /*#__PURE__*/__webpack_require__.n(insertBySelector);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js
var setAttributesWithoutAttributes = __webpack_require__("./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js");
var setAttributesWithoutAttributes_default = /*#__PURE__*/__webpack_require__.n(setAttributesWithoutAttributes);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertStyleElement.js
var insertStyleElement = __webpack_require__("./node_modules/style-loader/dist/runtime/insertStyleElement.js");
var insertStyleElement_default = /*#__PURE__*/__webpack_require__.n(insertStyleElement);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleTagTransform.js
var styleTagTransform = __webpack_require__("./node_modules/style-loader/dist/runtime/styleTagTransform.js");
var styleTagTransform_default = /*#__PURE__*/__webpack_require__.n(styleTagTransform);
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[12].use[1]!./node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[12].use[2]!./packages/pharos/src/pages/home/home.scss
var home = __webpack_require__("./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[12].use[1]!./node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[12].use[2]!./packages/pharos/src/pages/home/home.scss");
;// CONCATENATED MODULE: ./packages/pharos/src/pages/home/home.scss

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (styleTagTransform_default());
options.setAttributes = (setAttributesWithoutAttributes_default());

      options.insert = insertBySelector_default().bind(null, "head");
    
options.domAPI = (styleDomAPI_default());
options.insertStyleElement = (insertStyleElement_default());

var update = injectStylesIntoStyleTag_default()(home/* default */.Z, options);




       /* harmony default export */ const home_home = (home/* default */.Z && home/* default.locals */.Z.locals ? home/* default.locals */.Z.locals : undefined);

// EXTERNAL MODULE: ./packages/pharos/src/pages/shared/viewports.ts
var viewports = __webpack_require__("./packages/pharos/src/pages/shared/viewports.ts");
// EXTERNAL MODULE: ./packages/pharos/src/pages/shared/wc/header-revised.ts + 1 modules
var header_revised = __webpack_require__("./packages/pharos/src/pages/shared/wc/header-revised.ts");
// EXTERNAL MODULE: ./packages/pharos/src/pages/shared/wc/footer.ts + 1 modules
var footer = __webpack_require__("./packages/pharos/src/pages/shared/wc/footer.ts");
;// CONCATENATED MODULE: ./packages/pharos/src/pages/home/wc/collection-card.ts

const CollectionCard = (card) => lit/* html */.dy`
  <div>
    <img
      src="./images/home/${card.image}"
      alt="${card.title}"
      width="99.9%"
      class="home-page__image--collection"
    />
    <pharos-heading level="2" preset="3">${card.title}</pharos-heading>
    <pharos-link href="#">${card.link}</pharos-link>
  </div>
`;

;// CONCATENATED MODULE: ./packages/pharos/src/pages/home/wc/hero-search.ts

const HeroSearch = () => lit/* html */.dy`
  <div class="home-page__container--input">
    <pharos-icon name="search" class="home-page__icon--search"></pharos-icon>
    <input class="home-page__input" placeholder="Search JSTOR..." />
  </div>
`;

;// CONCATENATED MODULE: ./packages/pharos/src/pages/home/mocks.ts
const publicCollectionCards = [
  {
    image: "highlight_collection_1.png",
    title: "Open Collections",
    link: "Learn more about our Open Collections"
  },
  {
    image: "highlight_collection_2.png",
    title: "Special collections from the archive",
    link: "Learn more"
  }
];
const communityCollectionCards = [
  {
    image: "community_collection_1.png",
    title: "Open Artstor: Science Museum Group",
    link: "Artstor Digital Library"
  },
  {
    image: "community_collection_2.png",
    title: "Albright College Nicaragua Revolution",
    link: "David Schwartz Collection"
  },
  {
    image: "community_collection_3.png",
    title: "Muhlenberg College Helen Richards Horn Bookplate Collection",
    link: "Muhlenberg College Special Collections & Archives"
  },
  {
    image: "community_collection_4.png",
    title: "Lebanese Research Center for Migration and Diaspora Studies (LERC): The...",
    link: "Notre Dame University-Louaize"
  }
];

// EXTERNAL MODULE: ./packages/pharos/src/styles/variables.ts
var variables = __webpack_require__("./packages/pharos/src/styles/variables.ts");
;// CONCATENATED MODULE: ./packages/pharos/src/pages/home/wc/home.pages.stories.ts









/* harmony default export */ const home_pages_stories = ({
  title: "Pages/Home",
  parameters: {
    chromatic: { viewports: viewports/* breakpoints */.A },
    layout: "fullscreen",
    viewport: {
      viewports: viewports/* viewports */.U
    }
  }
});
const Home = {
  render: () => lit/* html */.dy`
    <div class="home-page__container">
      ${(0,header_revised/* HeaderRevised */.h)()}
      <main>
        <pharos-layout class="home-page__container--main-content" row-gap="${variables/* PharosSpacing7X */.Og2}">
          <div class="home-page__container--top" slot="top">
            <pharos-heading level="1" preset="7" no-margin class="home-page__heading"
              >Knowledge for everyone
            </pharos-heading>
            ${HeroSearch()}
          </div>
          <div
            class="home-page__hero"
            slot="top"
            style="background-image: url('./images/home/hero.jpg')"
          ></div>
          <pharos-link href="#" class="home-page__hero-link"
            >Tō kaidō gojo santsugi. Okazaki. Plate No 39. From the series: Fifty-three stations of
            the Tō kaidō Road, Kihei Sanoya, circa 1838.
          </pharos-link>
          ${publicCollectionCards.map(
    (card) => lit/* html */.dy` <div class="home-page__collection-card--open">${CollectionCard(card)}</div>`
  )}
          <div class="home-page__container--access">
            <pharos-heading level="3" preset="5"
              >JSTOR provides free access to hundreds of thousands of articles, images and books.
              Log in through your institution or learn about your other options, including free
              onsite reading.
            </pharos-heading>
            <ul class="home-page__list--access">
              <li>
                <pharos-link href="#">Find my institution</pharos-link>
              </li>
              <li>
                <pharos-link href="#">Learn about JPASS</pharos-link>
              </li>
              <li>
                <pharos-link href="#">Learn more about access</pharos-link>
              </li>
            </ul>
          </div>
          ${communityCollectionCards.map(
    (card) => lit/* html */.dy` <div class="home-page__collection-card--community">
                ${CollectionCard(card)}
              </div>`
  )}
        </pharos-layout>
      </main>
      ${(0,footer/* Footer */.$)()}
    </div>
  `
};


/***/ }),

/***/ "./packages/pharos/src/pages/item-detail/wc/item-detail.pages.stories.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ItemDetail": () => (/* binding */ ItemDetail),
  "default": () => (/* binding */ item_detail_pages_stories)
});

// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js
var injectStylesIntoStyleTag = __webpack_require__("./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
var injectStylesIntoStyleTag_default = /*#__PURE__*/__webpack_require__.n(injectStylesIntoStyleTag);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleDomAPI.js
var styleDomAPI = __webpack_require__("./node_modules/style-loader/dist/runtime/styleDomAPI.js");
var styleDomAPI_default = /*#__PURE__*/__webpack_require__.n(styleDomAPI);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertBySelector.js
var insertBySelector = __webpack_require__("./node_modules/style-loader/dist/runtime/insertBySelector.js");
var insertBySelector_default = /*#__PURE__*/__webpack_require__.n(insertBySelector);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js
var setAttributesWithoutAttributes = __webpack_require__("./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js");
var setAttributesWithoutAttributes_default = /*#__PURE__*/__webpack_require__.n(setAttributesWithoutAttributes);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertStyleElement.js
var insertStyleElement = __webpack_require__("./node_modules/style-loader/dist/runtime/insertStyleElement.js");
var insertStyleElement_default = /*#__PURE__*/__webpack_require__.n(insertStyleElement);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleTagTransform.js
var styleTagTransform = __webpack_require__("./node_modules/style-loader/dist/runtime/styleTagTransform.js");
var styleTagTransform_default = /*#__PURE__*/__webpack_require__.n(styleTagTransform);
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[12].use[1]!./node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[12].use[2]!./packages/pharos/src/pages/item-detail/item-detail.scss
var item_detail = __webpack_require__("./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[12].use[1]!./node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[12].use[2]!./packages/pharos/src/pages/item-detail/item-detail.scss");
;// CONCATENATED MODULE: ./packages/pharos/src/pages/item-detail/item-detail.scss

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (styleTagTransform_default());
options.setAttributes = (setAttributesWithoutAttributes_default());

      options.insert = insertBySelector_default().bind(null, "head");
    
options.domAPI = (styleDomAPI_default());
options.insertStyleElement = (insertStyleElement_default());

var update = injectStylesIntoStyleTag_default()(item_detail/* default */.Z, options);




       /* harmony default export */ const item_detail_item_detail = (item_detail/* default */.Z && item_detail/* default.locals */.Z.locals ? item_detail/* default.locals */.Z.locals : undefined);

// EXTERNAL MODULE: ./packages/pharos/src/pages/shared/viewports.ts
var viewports = __webpack_require__("./packages/pharos/src/pages/shared/viewports.ts");
// EXTERNAL MODULE: ./packages/pharos/src/pages/shared/wc/header-revised.ts + 1 modules
var header_revised = __webpack_require__("./packages/pharos/src/pages/shared/wc/header-revised.ts");
// EXTERNAL MODULE: ./packages/pharos/src/pages/shared/wc/footer.ts + 1 modules
var footer = __webpack_require__("./packages/pharos/src/pages/shared/wc/footer.ts");
;// CONCATENATED MODULE: ./packages/pharos/src/pages/item-detail/wc/item-carousel/item-carousel-item.ts

const ItemCarouselItem = (item) => lit/* html */.dy`
  <pharos-link href="#" subtle flex>
    <div class="item-detail-page__grid--carousel-item">
      <img src="./images/item-detail/${item.image}" alt="${item.title}" />
      <pharos-heading preset="1--bold" level="3" no-margin>${item.title}</pharos-heading>
    </div>
  </pharos-link>
  <span class="item-detail-page__text--item-metadata">${item.metadata}</span>
`;

// EXTERNAL MODULE: ./packages/pharos/src/pages/item-detail/mocks.ts
var mocks = __webpack_require__("./packages/pharos/src/pages/item-detail/mocks.ts");
;// CONCATENATED MODULE: ./packages/pharos/src/pages/item-detail/wc/item-carousel/item-carousel.ts



const ItemCarousel = () => lit/* html */.dy`
  <div class="item-detail-page__container--top-bar">
    <pharos-heading level="2" preset="3" no-margin>In this collection</pharos-heading>
    <div class="item-detail-page__container--carousel-buttons">
      <pharos-button
        label="backward"
        variant="subtle"
        icon="chevron-left-large"
        icon-condensed
      ></pharos-button>
      <pharos-button
        label="forward"
        variant="subtle"
        icon="chevron-right-large"
        icon-condensed
      ></pharos-button>
    </div>
  </div>
  <ul class="item-detail-page__list item-detail-page__grid--items">
    ${mocks/* items.map */.ev.map((item) => lit/* html */.dy`<li>${ItemCarouselItem(item)}</li>`)}
  </ul>
`;

;// CONCATENATED MODULE: ./packages/pharos/src/pages/item-detail/wc/collection-carousel/collection-carousel-item.ts

const CollectionCarouselItem = (collection) => lit/* html */.dy`
  <pharos-link href="#" subtle flex>
    <div class="item-detail-page__grid--carousel-item item-detail-page__grid--open-collection">
      <img src="./images/item-detail/${collection.image}" alt="${collection.title}" />
      <pharos-heading preset="1--bold" level="3" no-margin>${collection.title}</pharos-heading>
    </div>
  </pharos-link>
  <span class="item-detail-page__text--collection-items">${collection.items} items</span>
`;

;// CONCATENATED MODULE: ./packages/pharos/src/pages/item-detail/wc/collection-carousel/collection-carousel.ts



const CollectionCarousel = () => lit/* html */.dy`
  <div class="item-detail-page__container--top-bar">
    <pharos-heading level="2" preset="3" no-margin>Explore our open collections</pharos-heading>
    <div class="item-detail-page__container--carousel-buttons">
      <pharos-button
        label="backward"
        variant="subtle"
        icon="chevron-left-large"
        icon-condensed
      ></pharos-button>
      <pharos-button
        label="forward"
        variant="subtle"
        icon="chevron-right-large"
        icon-condensed
      ></pharos-button>
    </div>
  </div>
  <ul class="item-detail-page__list item-detail-page__grid--collections">
    ${mocks/* collections.map */.sh.map((collection) => lit/* html */.dy`<li>${CollectionCarouselItem(collection)}</li>`)}
  </ul>
`;

;// CONCATENATED MODULE: ./packages/pharos/src/pages/item-detail/wc/metadata.ts


const Metadata = () => lit/* html */.dy`
  <div class="item-detail-page__container--metadata">
    <img
      src="./images/item-detail/portal-logo.png"
      alt="portal logo"
      class="item-detail-page__image--collection"
    />
    <div class="item-detail-page__label--type">${mocks/* item.type */.wc.type}</div>
    <pharos-heading level="1" preset="3" class="item-detail-page__heading--metadata"
      >${mocks/* item.title */.wc.title}</pharos-heading
    >
    <div class="item-detail-page__grid--metadata">
      ${mocks/* metadata.map */.Pu.map(
  (field) => lit/* html */.dy`
          <div>
            <div class="item-detail-page__label--content">${field.label}</div>
            <span class="item-detail-page__text--metadata">${field.value}</span>
          </div>
        `
)}
    </div>
  </div>
`;

;// CONCATENATED MODULE: ./packages/pharos/src/pages/item-detail/wc/item-detail.pages.stories.ts








/* harmony default export */ const item_detail_pages_stories = ({
  title: "Pages/Item Detail",
  parameters: {
    chromatic: { viewports: viewports/* breakpoints */.A },
    layout: "fullscreen",
    viewport: {
      viewports: viewports/* viewports */.U
    }
  }
});
const ItemDetail = {
  render: () => lit/* html */.dy`
    <div class="item-detail-page__container">
      ${(0,header_revised/* HeaderRevised */.h)(true)}
      <main>
        <pharos-layout
          preset="2-col"
          rows="max-content 1fr"
          class="item-detail-page__container--main-content"
        >
          <div class="item-detail-page__container--top" slot="top">
            <pharos-link href="#" class="item-detail-page__button--back" subtle flex>
              <pharos-icon
                name="arrow-left"
                style="margin-right: var(--pharos-spacing-one-quarter-x)"
              ></pharos-icon>
              Back to results
            </pharos-link>
            <pharos-button
              variant="subtle"
              icon="arrow-left"
              href="#"
              label="Back to results"
              class="item-detail-page__button--mobile-back"
            ></pharos-button>
            <div class="item-detail-page__container--action-buttons">
              <pharos-button variant="secondary" icon-left="cite">Cite</pharos-button>
              <pharos-button variant="secondary" icon-left="share">Share</pharos-button>
              <pharos-button variant="secondary" icon-left="save">Save</pharos-button>
              <pharos-button variant="secondary" icon-left="download">Download</pharos-button>
            </div>
            <div class="item-detail-page__container--mobile-buttons">
              <pharos-button variant="subtle" icon="cite" label="Cite"></pharos-button>
              <pharos-button variant="subtle" icon="share" label="Share"></pharos-button>
              <pharos-button variant="subtle" icon="save" label="Save"></pharos-button>
              <pharos-button variant="subtle" icon="download" label="Download"></pharos-button>
            </div>
          </div>
          <div class="item-detail-page__container--viewer"></div>
          <div class="item-detail-page__container--collections">
            ${ItemCarousel()} ${CollectionCarousel()}
          </div>
          ${Metadata()}
        </pharos-layout>
      </main>
      ${(0,footer/* Footer */.$)()}
    </div>
  `
};


/***/ }),

/***/ "./packages/pharos/src/pages/reports/wc/reports.pages.stories.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Reports": () => (/* binding */ Reports),
  "default": () => (/* binding */ reports_pages_stories)
});

// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js
var injectStylesIntoStyleTag = __webpack_require__("./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
var injectStylesIntoStyleTag_default = /*#__PURE__*/__webpack_require__.n(injectStylesIntoStyleTag);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleDomAPI.js
var styleDomAPI = __webpack_require__("./node_modules/style-loader/dist/runtime/styleDomAPI.js");
var styleDomAPI_default = /*#__PURE__*/__webpack_require__.n(styleDomAPI);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertBySelector.js
var insertBySelector = __webpack_require__("./node_modules/style-loader/dist/runtime/insertBySelector.js");
var insertBySelector_default = /*#__PURE__*/__webpack_require__.n(insertBySelector);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js
var setAttributesWithoutAttributes = __webpack_require__("./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js");
var setAttributesWithoutAttributes_default = /*#__PURE__*/__webpack_require__.n(setAttributesWithoutAttributes);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertStyleElement.js
var insertStyleElement = __webpack_require__("./node_modules/style-loader/dist/runtime/insertStyleElement.js");
var insertStyleElement_default = /*#__PURE__*/__webpack_require__.n(insertStyleElement);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleTagTransform.js
var styleTagTransform = __webpack_require__("./node_modules/style-loader/dist/runtime/styleTagTransform.js");
var styleTagTransform_default = /*#__PURE__*/__webpack_require__.n(styleTagTransform);
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[12].use[1]!./node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[12].use[2]!./packages/pharos/src/pages/reports/reports.scss
var reports = __webpack_require__("./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[12].use[1]!./node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[12].use[2]!./packages/pharos/src/pages/reports/reports.scss");
;// CONCATENATED MODULE: ./packages/pharos/src/pages/reports/reports.scss

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (styleTagTransform_default());
options.setAttributes = (setAttributesWithoutAttributes_default());

      options.insert = insertBySelector_default().bind(null, "head");
    
options.domAPI = (styleDomAPI_default());
options.insertStyleElement = (insertStyleElement_default());

var update = injectStylesIntoStyleTag_default()(reports/* default */.Z, options);




       /* harmony default export */ const reports_reports = (reports/* default */.Z && reports/* default.locals */.Z.locals ? reports/* default.locals */.Z.locals : undefined);

// EXTERNAL MODULE: ./packages/pharos/src/pages/shared/viewports.ts
var viewports = __webpack_require__("./packages/pharos/src/pages/shared/viewports.ts");
;// CONCATENATED MODULE: ./packages/pharos/src/pages/reports/wc/sidenav.ts

const Sidenav = () => lit/* html */.dy`
  <pharos-sidenav class="reports-page__sidenav" main-content-id="main-content">
    <pharos-link slot="top" href="/" id="jstor-logo">
      <img src="./images/jstor-logo-inverse.svg" alt="Pharos Home" width="72" height="100" />
    </pharos-link>
    <pharos-sidenav-section>
      <pharos-sidenav-link href="#">Home</pharos-sidenav-link>
      <pharos-sidenav-menu label="Reports" expanded>
        <pharos-sidenav-link href="#" is-active>COUNTER 5</pharos-sidenav-link>
        <pharos-sidenav-link href="#">Books at JSTOR</pharos-sidenav-link>
        <pharos-sidenav-link href="#">COUNTER 4</pharos-sidenav-link>
      </pharos-sidenav-menu>
      <pharos-sidenav-link href="#">Holdings</pharos-sidenav-link>
      <pharos-sidenav-link href="#">Access Methods</pharos-sidenav-link>
      <pharos-sidenav-link href="#">Account</pharos-sidenav-link>
      <pharos-sidenav-link href="#" target="_blank" external>Support</pharos-sidenav-link>
      <pharos-sidenav-link href="#" target="_blank" external>For Librarians</pharos-sidenav-link>
    </pharos-sidenav-section>
  </pharos-sidenav>
`;

;// CONCATENATED MODULE: ./packages/pharos/src/pages/reports/wc/create-report-modal.ts

const CreateReportModal = () => lit/* html */.dy`
  <pharos-modal id="create-report-modal" header="Create Report" size="large">
    <form class="reports-page__form--create-modal">
      <pharos-select name="report" required>
        <span slot="label">Select Report</span>
        <option value="">Select a Report</option>
        <optgroup label="Master Reports">
          <option value="DR">DR - Database Master Report</option>
        </optgroup>
        <optgroup label="Standard Reports">
          <option value="ALL" selected>ALL - All Standard Reports</option>
        </optgroup>
      </pharos-select>
      <fieldset class="reports-page__fieldset--type">
        <legend class="reports-page__legend">
          <span>Report Type</span>
        </legend>
        <pharos-button name="is-scheduled" value="yes" disabled>Scheduled</pharos-button>
        <pharos-button name="is-scheduled" value="no">One-time</pharos-button>
      </fieldset>
      <fieldset class="reports-page__fieldset--date">
        <legend class="reports-page__legend">
          <span>Report Date Range</span>
        </legend>
        <div class="reports-page__grid--date-group">
          <pharos-input-group name="start-date">
            <span slot="label">Start Date</span>
            <pharos-button
              name="start-button"
              icon="calendar"
              variant="subtle"
              label="calendar"
            ></pharos-button>
          </pharos-input-group>
          <pharos-input-group name="end-date">
            <span slot="label">End Date</span>
            <pharos-button
              name="end-button"
              icon="calendar"
              variant="subtle"
              label="calendar"
            ></pharos-button>
          </pharos-input-group>
        </div>
      </fieldset>
      <pharos-radio-group name="format">
        <span slot="legend">Report Format</span>
        <pharos-radio-button value="xlsx" checked
          ><span slot="label">XLSX</span></pharos-radio-button
        >
        <pharos-radio-button value="tsv"><span slot="label">TSV</span></pharos-radio-button>
        <pharos-radio-button value="json"><span slot="label">JSON</span></pharos-radio-button>
      </pharos-radio-group>
      <pharos-text-input name="name" required>
        <span slot="label">Report Name</span>
      </pharos-text-input>
      <pharos-text-input name="email" value="human@ithaka.org" type="email" required>
        <span slot="label">Email Report To</span>
      </pharos-text-input>
    </form>
    <pharos-button slot="footer" type="button" variant="secondary" data-modal-close>
      Cancel
    </pharos-button>
    <pharos-button slot="footer" type="button"> Continue </pharos-button>
  </pharos-modal>
`;

;// CONCATENATED MODULE: ./packages/pharos/src/pages/reports/wc/reports-table.ts

const ReportsTable = (table) => {
  const isHistory = !Object.keys(table.rows[0]).includes("frequency");
  const tableCols = () => {
    return isHistory ? lit/* html */.dy`<colgroup>
          <col style="width: 30%" />
          <col />
          <col />
          <col style="width: 25%" />
          <col />
        </colgroup>` : lit/* html */.dy`<colgroup>
          <col style="width: 30%" />
          <col style="width: 30%" />
          <col />
          <col />
        </colgroup>`;
  };
  return lit/* html */.dy`
    <table class="reports-page__table">
      ${tableCols()}
      <thead>
        <tr>
          ${table.columns.map(
    (column) => lit/* html */.dy` <th class="reports-page__table-header">${column}</th> `
  )}
        </tr>
      </thead>
      <tbody>
        ${table.rows.map((row) => {
    return lit/* html */.dy`
            <tr class="reports-page__table-row">
              ${Object.keys(row).map((field) => {
      const value = row[field];
      if (Array.isArray(value)) {
        return lit/* html */.dy`
                    <td class="reports-page__table-cell">
                      ${value.map((item) => lit/* html */.dy`<p>${item}</p>`)}
                    </td>
                  `;
      }
      return lit/* html */.dy`<td class="reports-page__table-cell">${value}</td>`;
    })}
              ${isHistory ? lit/* html */.dy`<td class="reports-page__table-cell--download">
                    <pharos-button
                      variant="secondary"
                      @click="${() => {
      const event = new CustomEvent("pharos-toast-open", {
        detail: {
          status: "error",
          content: 'Sorry, we were unable to process your download. Please try again later. If the issue persists, <pharos-link href="#" on-background bold>contact JSTOR Support</pharos-link>.'
        }
      });
      document.dispatchEvent(event);
    }}"
                      >Download</pharos-button
                    >
                  </td>` : null}
            </tr>
          `;
  })}
      </tbody>
    </table>
  `;
};

;// CONCATENATED MODULE: ./packages/pharos/src/pages/reports/mocks.ts
const historyColumns = ["Report Info", "Type", "Format", "Date", ""];
const historyRows = [
  {
    info: ["Platform Usage", "University of Mainz", "2020-09-01 \u2013 2020-11-30"],
    type: "PR_P1",
    format: "JSON",
    date: "12/17/2020, 9:51:18 AM"
  },
  {
    info: ["Platform Usage", "University of Mainz", "2020-09-01 \u2013 2020-11-30"],
    type: "PR_P1",
    format: "JSON",
    date: "12/17/2020, 9:51:18 AM"
  },
  {
    info: ["Platform Usage", "University of Mainz", "2020-09-01 \u2013 2020-11-30"],
    type: "PR_P1",
    format: "JSON",
    date: "12/17/2020, 9:51:18 AM"
  }
];
const historyTable = {
  columns: historyColumns,
  rows: historyRows
};
const scheduledColumns = ["Schedule Info", "Frequency", "Format", "Recipient"];
const scheduledRows = [
  {
    info: ["PR", "Platform Master Report", "University of Mainz"],
    frequency: ["Monthly", "Previous month usage"],
    format: "XLSX",
    recipient: "human@ithaka.org"
  },
  {
    info: ["PR_P1", "Platform Master Report", "University of Mainz"],
    frequency: ["Monthly", "Previous month usage"],
    format: "TSV",
    recipient: "human@ithaka.org"
  },
  {
    info: ["PR", "Platform Master Report", "University of Mainz"],
    frequency: ["Monthly", "Previous month usage"],
    format: "XLSX",
    recipient: "human@ithaka.org"
  }
];
const scheduledTable = {
  columns: scheduledColumns,
  rows: scheduledRows
};

;// CONCATENATED MODULE: ./packages/pharos/src/pages/reports/wc/reports.pages.stories.ts







/* harmony default export */ const reports_pages_stories = ({
  title: "Pages/Reports",
  parameters: {
    chromatic: { viewports: viewports/* breakpoints */.A },
    layout: "fullscreen",
    viewport: {
      viewports: viewports/* viewports */.U
    }
  }
});
const Reports = {
  render: () => lit/* html */.dy`
    <div class="reports-page__container">
      ${Sidenav()}
      <main id="main-content">
        <pharos-layout preset="1-col--sidenav" class="reports-page__container--main-content">
          <div class="reports-page__container--top" slot="top">
            <div class="reports-page__container--nav-header">
              <pharos-sidenav-button></pharos-sidenav-button>
              <img src="./images/reports/jstor-horizontal.svg" alt="logo" width="96" height="24" />
              <span class="reports-page__separator">/</span>
              <pharos-heading level="1" preset="4" no-margin>Admin</pharos-heading>
            </div>
            <pharos-button
              variant="subtle"
              icon-right="chevron-down"
              class="reports-page__button--user"
              >Gerry Larry Burla
            </pharos-button>
          </div>
          <div class="reports-page__container--disclaimer">
            <pharos-heading level="2" preset="5--bold">COUNTER 5 Usage Reports</pharos-heading>
            <p>
              Welcome to the COUNTER 5 reporting service for participating institutions. JSTOR
              offers COUNTER 5 compliant reports for usage beginning January 2019. COUNTER 4 reports
              are still available for usage from January 2017 - April 2019 from the
              <pharos-link href="#">COUNTER 4 reporting service</pharos-link>. Please visit our
              COUNTER 5
              <pharos-link href="#">support page</pharos-link>
              for more information on JSTOR usage reports.
            </p>
          </div>
          <div class="reports-page__container--table">
            <pharos-button class="reports-page__button--create" data-modal-id="create-report-modal"
              >Create Report
            </pharos-button>
            <pharos-tabs>
              <pharos-tab id="tab-1" data-panel-id="panel-1">Report History</pharos-tab>
              <pharos-tab id="tab-2" data-panel-id="panel-2">Scheduled Reports</pharos-tab>
              <pharos-tab-panel id="panel-1" slot="panel" style="overflow: visible">
                ${ReportsTable(historyTable)}
              </pharos-tab-panel>
              <pharos-tab-panel id="panel-2" slot="panel">
                ${ReportsTable(scheduledTable)}
              </pharos-tab-panel>
            </pharos-tabs>
          </div>
        </pharos-layout>
      </main>
    </div>
    <pharos-toaster></pharos-toaster>
    ${CreateReportModal()}
  `
};


/***/ }),

/***/ "./packages/pharos/src/pages/search/wc/search.pages.stories.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Search": () => (/* binding */ Search),
  "default": () => (/* binding */ search_pages_stories)
});

// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js
var injectStylesIntoStyleTag = __webpack_require__("./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
var injectStylesIntoStyleTag_default = /*#__PURE__*/__webpack_require__.n(injectStylesIntoStyleTag);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleDomAPI.js
var styleDomAPI = __webpack_require__("./node_modules/style-loader/dist/runtime/styleDomAPI.js");
var styleDomAPI_default = /*#__PURE__*/__webpack_require__.n(styleDomAPI);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertBySelector.js
var insertBySelector = __webpack_require__("./node_modules/style-loader/dist/runtime/insertBySelector.js");
var insertBySelector_default = /*#__PURE__*/__webpack_require__.n(insertBySelector);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js
var setAttributesWithoutAttributes = __webpack_require__("./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js");
var setAttributesWithoutAttributes_default = /*#__PURE__*/__webpack_require__.n(setAttributesWithoutAttributes);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertStyleElement.js
var insertStyleElement = __webpack_require__("./node_modules/style-loader/dist/runtime/insertStyleElement.js");
var insertStyleElement_default = /*#__PURE__*/__webpack_require__.n(insertStyleElement);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleTagTransform.js
var styleTagTransform = __webpack_require__("./node_modules/style-loader/dist/runtime/styleTagTransform.js");
var styleTagTransform_default = /*#__PURE__*/__webpack_require__.n(styleTagTransform);
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[12].use[1]!./node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[12].use[2]!./packages/pharos/src/pages/search/search.scss
var search = __webpack_require__("./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[12].use[1]!./node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[12].use[2]!./packages/pharos/src/pages/search/search.scss");
;// CONCATENATED MODULE: ./packages/pharos/src/pages/search/search.scss

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (styleTagTransform_default());
options.setAttributes = (setAttributesWithoutAttributes_default());

      options.insert = insertBySelector_default().bind(null, "head");
    
options.domAPI = (styleDomAPI_default());
options.insertStyleElement = (insertStyleElement_default());

var update = injectStylesIntoStyleTag_default()(search/* default */.Z, options);




       /* harmony default export */ const search_search = (search/* default */.Z && search/* default.locals */.Z.locals ? search/* default.locals */.Z.locals : undefined);

;// CONCATENATED MODULE: ./packages/pharos/src/pages/shared/wc/header.ts

const accountNav = (section) => lit/* html */.dy`
  <pharos-dropdown-menu-nav label="profile">
    <pharos-dropdown-menu-nav-link
      href="/account/profile"
      id="profile-link-${section}"
      data-dropdown-menu-id="profile-menu-${section}"
      data-dropdown-menu-hover
      ><span class="hide-for-small">human@ithaka.org</span
      ><span class="show-for-small" style="display: none"
        >Account</span
      ></pharos-dropdown-menu-nav-link
    >
    <pharos-dropdown-menu id="profile-menu-${section}">
      <pharos-dropdown-menu-item link="/account/profile">Profile</pharos-dropdown-menu-item>
      <pharos-dropdown-menu-item link="/account/workspace">Workspace</pharos-dropdown-menu-item>
      <pharos-dropdown-menu-item link="/account/read-online"
        >Free Article Views</pharos-dropdown-menu-item
      >
      <pharos-dropdown-menu-item link="/account/subscriptions"
        >JPASS Downloads</pharos-dropdown-menu-item
      >
      <pharos-dropdown-menu-item link="/account/purchases"
        >Puchase History</pharos-dropdown-menu-item
      >
      <pharos-dropdown-menu-item link="/action/doLogout">Logout</pharos-dropdown-menu-item>
    </pharos-dropdown-menu>
  </pharos-dropdown-menu-nav>
`;
const Header = () => lit/* html */.dy`
  <pharos-header>
    <div id="pds" slot="top" class="hide-for-small">
      <div
        tabindex="0"
        style="display: flex"
        data-dropdown-menu-id="pds-menu"
        data-dropdown-menu-hover
      >
        <span>Access provided by&nbsp;</span>
        <span style="font-weight: bold">JSTOR</span>
        <pharos-icon name="chevron-down" style="margin-left: 1rem"></pharos-icon>
      </div>
      <pharos-dropdown-menu id="pds-menu" placement="bottom">
        <div style="padding: 1rem">
          <p>
            Please contact
            <pharos-link href="//jstor.org">JSTOR</pharos-link> for additional help and information.
          </p>
        </div>
      </pharos-dropdown-menu>
    </div>
    <span slot="top" class="show-for-small" style="display: none; font-weight: bold">JSTOR</span>
    <pharos-link slot="start" href="/" id="jstor-logo">
      <img src="./images/jstor-logo.svg" alt="JSTOR Home" width="65" height="90" />
    </pharos-link>
    <div slot="center">
      <pharos-input-group
        name="my-input-group"
        hide-label
        placeholder="Search JSTOR"
        class="header-example__input-group"
      >
        <span slot="label">Search JSTOR</span>
        <pharos-button
          name="search-button"
          icon="search"
          variant="subtle"
          label="search"
        ></pharos-button>
      </pharos-input-group>
    </div>
    <div slot="end-top">${accountNav("end")}</div>
    <div slot="end-bottom" style="display: flex;">
      <pharos-dropdown-menu-nav label="main navigation" style="display: inline-block">
        <pharos-dropdown-menu-nav-link href="/action/showAdvancedSearch" id="adv-search-menu-link">
          Advanced Search
        </pharos-dropdown-menu-nav-link>
        <pharos-dropdown-menu-nav-link
          href="/subjects"
          id="browse-link"
          data-dropdown-menu-id="browse-menu"
          data-dropdown-menu-hover
        >
          Browse
        </pharos-dropdown-menu-nav-link>
        <pharos-dropdown-menu id="browse-menu">
          <pharos-dropdown-menu-item link="/subjects">by Subject</pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item link="/action/showJournals?browseType=title">
            by Title
          </pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item link="/site/collection-list">
            by Collections
          </pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item link="/publishers">by Publisher</pharos-dropdown-menu-item>
        </pharos-dropdown-menu>
        <pharos-dropdown-menu-nav-link
          href="/account/workspace"
          id="tools-link"
          data-dropdown-menu-id="tools-menu"
          data-dropdown-menu-hover
        >
          Tools
        </pharos-dropdown-menu-nav-link>
        <pharos-dropdown-menu id="tools-menu">
          <pharos-dropdown-menu-item link="/account/workspace">
            Workspace
          </pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item link="/analyze">Text Analyzer</pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item link="/understand">
            The JSTOR Understanding Series
          </pharos-dropdown-menu-item>
          <pharos-dropdown-menu-item link="/dfr">Data for Research</pharos-dropdown-menu-item>
        </pharos-dropdown-menu>
      </pharos-dropdown-menu-nav>
    </div>
  </pharos-header>
`;

// EXTERNAL MODULE: ./packages/pharos/src/pages/shared/wc/footer.ts + 1 modules
var footer = __webpack_require__("./packages/pharos/src/pages/shared/wc/footer.ts");
;// CONCATENATED MODULE: ./packages/pharos/src/pages/search/wc/facets/multi-select-facet.ts

const MultiSelectFacet = (name, legend, items) => lit/* html */.dy`
  <pharos-checkbox-group name="${name}">
    <span slot="legend">${legend}</span>
    ${items.map(
  (item) => lit/* html */.dy`<pharos-checkbox value="${item.value}"
          ><span slot="label">${item.label}</span></pharos-checkbox
        >`
)}
  </pharos-checkbox-group>
`;

;// CONCATENATED MODULE: ./packages/pharos/src/pages/search/wc/facets/single-select-facet.ts

const SingleSelectFacet = (name, legend, items) => lit/* html */.dy`
  <pharos-radio-group name="${name}">
    <span slot="legend">${legend}</span>
    ${items.map(
  (item) => lit/* html */.dy`<pharos-radio-button value="${item.value}"
          ><span slot="label">${item.label}</span></pharos-radio-button
        >`
)}
  </pharos-radio-group>
`;

;// CONCATENATED MODULE: ./packages/pharos/src/pages/search/wc/facets/date-range-facet.ts

const DateRangeFacet = () => lit/* html */.dy`
  <fieldset class="search-page__fieldset--date">
    <legend>
      <pharos-heading level="3" preset="legend">Date</pharos-heading>
    </legend>
    <small class="search-page__text--description">(YYYY, YYYY/MM or YYYY/MM/DD)</small>
    <div class="search-page__grid--date">
      <pharos-text-input name="from">
        <span slot="label">From</span>
      </pharos-text-input>
      <pharos-text-input name="to">
        <span slot="label">To</span>
      </pharos-text-input>
      <pharos-button disabled>Apply</pharos-button>
    </div>
  </fieldset>
`;

;// CONCATENATED MODULE: ./packages/pharos/src/pages/search/wc/facets/facet-filters.ts




const academicContentItems = [
  { label: "Journals", value: "journals" },
  { label: "Books", value: "books" },
  { label: "Research Reports", value: "reports" }
];
const primarySourceContentItems = [
  { label: "Serials", value: "serials" },
  { label: "Images", value: "images" },
  { label: "Documents", value: "documents" },
  { label: "Books", value: "books" }
];
const subjectsItems = [
  { label: "African American Studies", value: "african-american" },
  { label: "Agriculture", value: "agriculture" },
  { label: "American Studies", value: "american" },
  { label: "Anthropology", value: "anthropology" },
  { label: "Aquatic Studies", value: "aquatic" },
  { label: "Archaeology", value: "archaeology" },
  { label: "Architecture & Architectural History", value: "architecture" },
  { label: "Art & Art History", value: "art" },
  { label: "Asian Studies", value: "asian" },
  { label: "Astronomy", value: "astronomy" },
  { label: "Botany & Plant Sciences", value: "botany" },
  { label: "British Studies", value: "british" }
];
const accessTypeItems = [
  { label: "All content", value: "all" },
  { label: "Content I can access", value: "access" }
];
const FacetFilters = () => lit/* html */.dy`
  <aside>
    <div class="search-page__grid--facets">
      <pharos-heading level="2" preset="1--bold">Filters</pharos-heading>
      <form class="search-page__form">
        <div class="search-page__facet">
          ${MultiSelectFacet("academic-content", "academic content", academicContentItems)}
        </div>
        <div class="search-page__facet">
          ${MultiSelectFacet(
  "primary-source-content",
  "primary source content",
  primarySourceContentItems
)}
        </div>
        <div class="search-page__facet">${DateRangeFacet()}</div>
        <div class="search-page__facet">
          ${MultiSelectFacet("subjects", "subjects", subjectsItems)}
        </div>
        <div class="search-page__facet">
          ${SingleSelectFacet("access-type", "access type", accessTypeItems)}
        </div>
      </form>
    </div>
  </aside>
`;

;// CONCATENATED MODULE: ./packages/pharos/src/pages/search/wc/search-results/search-results-item.ts

const SearchResultsItem = (result) => lit/* html */.dy`
  <div class="search-page__grid--result">
    <div style="justify-self: center">
      <pharos-checkbox name="doi" value="${result.doi}" hide-label
        ><span slot="label">${result.title}</span></pharos-checkbox
      >
    </div>
    <div>
      <span class="search-page__text--content-type">${result.type}</span>
      <pharos-link href="/stable/${result.doi}" subtle style="display: flex">
        <pharos-heading level="3" preset="3">${result.title}</pharos-heading>
      </pharos-link>
      <pharos-link href="#">${result.author}</pharos-link>
      <p class="search-page__text--metadata">${result.metadata}</p>
      <p class="search-page__text--snippet">${result.snippet}</p>
    </div>
    <div class="search-page__container--action-buttons">
      <ul class="search-page__list--action-buttons">
        <li class="search-page__list-item--action-buttons">
          <pharos-button icon-left="download" full-width>Download PDF</pharos-button>
        </li>
        <li class="search-page__list-item--action-buttons">
          <pharos-button icon-left="save" variant="secondary" full-width>Save</pharos-button>
        </li>
        <li class="search-page__list-item--action-buttons">
          <pharos-button icon-left="cite" variant="secondary" full-width>Cite</pharos-button>
        </li>
      </ul>
    </div>
  </div>
`;

;// CONCATENATED MODULE: ./packages/pharos/src/pages/search/mocks.ts
const imageResults = [
  {
    image: "result_1.png",
    title: "Eyrie; students sitting at tables"
  },
  {
    image: "result_2.png",
    title: "Entrance to Central from Howard Payne side covered in ivy"
  },
  {
    image: "result_3.png",
    title: "Cupples Hall and Brannock Hall; two students sitting..."
  },
  {
    image: "result_4.png",
    title: "Group Photograph of Navy V-12 Central Cadets in Front of..."
  },
  {
    image: "result_5.png",
    title: "South Hall"
  }
];
const searchResults = [
  {
    doi: "1234",
    type: "journal article",
    title: "Interpretations of the American Civil War",
    author: "Richard Enmale",
    metadata: "Science & Society, Vol. 1, No. 2 (Winter, 1937), pp. 127-136",
    snippet: `...Our Presbyterians and the American Civil War Documentary Heritage Presbyterians and the American Civil War Presbyterians North and South recorded their experiences during the Civil War in words, images, and music. The Presbyterian Historical Society holds a rich collection of these sermons.`
  },
  {
    doi: "5678",
    type: "journal article",
    title: "Women and Images of Women in the Spanish Civil War",
    author: "Frances Lannon",
    metadata: "Transactions of the Royal Historical Society, Vol. 1 (1991), pp. 213-228",
    snippet: `...WOMEN IN THE SPANISH CIVIL WAR By Frances Lannon READ 12 OCTOBER 1990 AT the end of the Spanish Civil War in the spring of 1939, General Franco celebrated his victory by decreeing that full military honours be accorded to two statues of the Virgin Mary.' The first was Our Lady...`
  },
  {
    doi: "9999",
    type: "journal article",
    title: "Memory as a Cultural System: Abraham Lincoln in World War II",
    author: "Barry Schwartz",
    metadata: "American Sociological Review, Vol. 61, No. 5 (Oct., 1996), pp. 908-927",
    snippet: '...in 1940 were born during the late nineteenth century, when Civil War resentments were fading and remembrances of Lincoln were more positive and vivid than ever. This generation understood the meaning of World War II by "keying" it to the Civil War. Patterned arrays of images of Lincoln were invoked by...'
  },
  {
    doi: "7777",
    type: "journal article",
    title: "Materialism(s) in Recent Visual Rhetorical Histories: A Commentary",
    author: "Eric Scott Jenkins",
    metadata: "Rhetoric and Public Affairs, Vol. 21, No. 1 (Spring 2018), pp. 157-174",
    snippet: "...ERIC SCOTT JENKINS Making Photography Matter: A Viewer's History from the Civil War to the Great Depression. By Cara A. Finnegan. Urbana: University of Illinois Press, 2015; pp. xiii 240. $50.00 cloth. Posters for Peace: Visual Rhetoric and Civic Action. By Thomas W. Benson. University Park: Pennsylvania State University Press, 2015;..."
  }
];

;// CONCATENATED MODULE: ./packages/pharos/src/pages/search/wc/search-results/search-results.ts



const SearchResults = () => lit/* html */.dy`
  <div class="search-page__container--search-results">
    <div class="search-page__container--results-top-bar">
      <pharos-heading level="3" preset="2">721,120 text results</pharos-heading>
      <pharos-button
        variant="secondary"
        icon-right="chevron-down"
        data-dropdown-menu-id="sort-dropdown"
        style="margin-left: auto"
        >Sort by: Relevance</pharos-button
      >
    </div>
    <pharos-dropdown-menu id="sort-dropdown" show-selected full-width>
      <pharos-dropdown-menu-item selected>Relevance</pharos-dropdown-menu-item>
      <pharos-dropdown-menu-item>Newest</pharos-dropdown-menu-item>
      <pharos-dropdown-menu-item>Oldest</pharos-dropdown-menu-item>
    </pharos-dropdown-menu>
    <ol class="search-page__list--results">
      ${searchResults.map(
  (result) => lit/* html */.dy`<li class="search-page__list-item--results">${SearchResultsItem(result)}</li>`
)}
    </ol>
    <div class="search-page__container--results-pagination">
      <pharos-pagination
        total-results="132"
        page-size="4"
        current-page="1"
        style="margin-left: auto"
      ></pharos-pagination>
    </div>
  </div>
`;

;// CONCATENATED MODULE: ./packages/pharos/src/pages/search/wc/image-results/image-results-item.ts

const ImageResultsItem = (result) => lit/* html */.dy`
  <pharos-link href="#" subtle flex>
    <div class="search-page__grid--image">
      <img src="./images/search/${result.image}" alt="${result.title}" width="99%" />
      <pharos-heading preset="1--bold" level="3" no-margin>${result.title}</pharos-heading>
    </div>
  </pharos-link>
`;

;// CONCATENATED MODULE: ./packages/pharos/src/pages/search/wc/image-results/image-results.ts



const ImageResults = () => lit/* html */.dy`
  <div class="search-page__container--image-results">
    <div class="search-page__container--results-top-bar">
      <pharos-heading level="3" preset="2">1,429 image results</pharos-heading>
      <pharos-button variant="secondary" icon-right="arrow-right" style="margin-left: auto"
        >View all image results</pharos-button
      >
    </div>
    <ul class="search-page__list--results search-page__grid--image-results">
      ${imageResults.map((result) => lit/* html */.dy`<li>${ImageResultsItem(result)}</li>`)}
      <li>
        <pharos-link href="#" subtle flex>
          <div class="search-page__grid--image search-page__container--all-images">
            View all images
          </div>
        </pharos-link>
      </li>
    </ul>
  </div>
`;

;// CONCATENATED MODULE: ./packages/pharos/src/pages/search/wc/search.pages.stories.ts







/* harmony default export */ const search_pages_stories = ({
  title: "Pages/Search",
  parameters: {
    chromatic: { viewports: [1440] },
    layout: "fullscreen"
  }
});
const Search = {
  render: () => lit/* html */.dy`
    <div class="search-page__container">
      ${Header()}
      <main class="search-page__container--main-content">
        <div class="search-page__container--results-content">
          <pharos-heading level="2" preset="5--bold">722,549 search results</pharos-heading>
          <pharos-link href="/help" style="margin-left: auto">Search help</pharos-link>
        </div>
        ${ImageResults()} ${SearchResults()}
      </main>
      ${FacetFilters()} ${(0,footer/* Footer */.$)()}
    </div>
  `
};


/***/ }),

/***/ "./packages/pharos/src/styles/sass.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Mixins": () => (/* binding */ Mixins),
  "default": () => (/* binding */ sass_wc_stories)
});

// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
;// CONCATENATED MODULE: ./packages/pharos/sass.json
const sass_namespaceObject = JSON.parse('[{"description":"Styles for icon buttons.\\n","commentRange":{"start":224,"end":226},"context":{"type":"mixin","name":"icon-button","code":"\\n  display: flex;\\n  flex-direction: column;\\n  align-items: center;\\n  justify-content: center;\\n  cursor: pointer;\\n  box-sizing: border-box;\\n  background: none;\\n  margin: 0;\\n","line":{"start":227,"end":236}},"access":"public","group":["buttons"],"file":{"path":"_mixins.scss","name":"_mixins.scss"}},{"description":"Base styles for buttons.\\n","commentRange":{"start":248,"end":253},"context":{"type":"mixin","name":"button-base","code":"\\n  @include font-base($font-weight: var(--pharos-font-weight-bold));\\n  @include transition-base(border-color, background, color);\\n\\n  color: $color;\\n  background-color: $background-color;\\n  border: 1px solid $border-color;\\n  padding: var(--pharos-spacing-one-quarter-x) var(--pharos-spacing-three-quarters-x);\\n  border-radius: var(--pharos-radius-base-standard);\\n  cursor: pointer;\\n  display: flex;\\n  align-items: center;\\n  justify-content: center;\\n  margin: 0;\\n  appearance: none;\\n\\n  [data-pharos-component=\'PharosIcon\'] {\\n    @include transition-base(fill, stroke);\\n\\n    fill: $color;\\n    stroke: $color;\\n    stroke-width: 0;\\n  }\\n\\n  [data-pharos-component=\'PharosIcon\']:first-child:not(:only-child) {\\n    margin-right: var(--pharos-spacing-one-quarter-x);\\n  }\\n\\n  [data-pharos-component=\'PharosIcon\']:last-child:not(:only-child) {\\n    margin-left: var(--pharos-spacing-one-quarter-x);\\n  }\\n","line":{"start":254,"end":289}},"parameter":[{"type":"string","name":"color","default":"var(--pharos-button-color-base-primary-text-base)","description":"The color of the text"},{"type":"string","name":"background-color","default":"vvar(--pharos-button-color-base-primary-background-base)","description":"The color of the background"},{"type":"string","name":"border-color","default":"var(--pharos-button-color-base-primary-border-base)","description":"The color of the border"}],"access":"public","group":["buttons"],"require":[{"type":"mixin","name":"font-base"},{"type":"mixin","name":"transition-base"},{"type":"mixin","name":"transition-base"}],"file":{"path":"_mixins.scss","name":"_mixins.scss"}},{"description":"Hover styles for buttons.\\n","commentRange":{"start":291,"end":296},"context":{"type":"mixin","name":"button-hover","code":"\\n  &:hover:not([disabled]),\\n  &:active:not([disabled]) {\\n    color: $color;\\n    background-color: $background-color;\\n    border: 2px solid $border-color;\\n    padding: calc(var(--pharos-spacing-one-quarter-x) - 1px)\\n      calc(var(--pharos-spacing-three-quarters-x) - 1px);\\n\\n    [data-pharos-component=\'PharosIcon\'] {\\n      fill: $color;\\n      stroke: $color;\\n    }\\n  }\\n","line":{"start":297,"end":315}},"parameter":[{"type":"string","name":"color","default":"var(--pharos-button-color-base-primary-text-hover)","description":"The color of the text"},{"type":"string","name":"background-color","default":"var(--pharos-button-color-base-primary-background-hover)","description":"The color of the background"},{"type":"string","name":"border-color","default":"var(--pharos-button-color-base-primary-border-hover)","description":"The color of the border"}],"access":"public","group":["buttons"],"require":[],"file":{"path":"_mixins.scss","name":"_mixins.scss"}},{"description":"Styles for large buttons.\\n","commentRange":{"start":317,"end":319},"context":{"type":"mixin","name":"button-large","code":"\\n  padding: var(--pharos-spacing-one-half-x) var(--pharos-spacing-three-quarters-x);\\n\\n  &:hover:not([disabled]),\\n  &:active:not([disabled]) {\\n    padding: calc(var(--pharos-spacing-one-half-x) - 1px)\\n      calc(var(--pharos-spacing-three-quarters-x) - 1px);\\n  }\\n","line":{"start":320,"end":328}},"access":"public","group":["buttons"],"require":[],"file":{"path":"_mixins.scss","name":"_mixins.scss"}},{"description":"Color styles for buttons.\\n","commentRange":{"start":330,"end":335},"context":{"type":"mixin","name":"button-color","code":"\\n  color: $color;\\n  background-color: $background-color;\\n  border-color: $border-color;\\n\\n  [data-pharos-component=\'PharosIcon\'] {\\n    fill: $color;\\n    stroke: $color;\\n  }\\n","line":{"start":336,"end":349}},"parameter":[{"type":"string","name":"color","default":"var(--pharos-button-color-base-primary-text-base)","description":"The color of the text"},{"type":"string","name":"background-color","default":"var(--pharos-button-color-base-primary-background-base)","description":"The color of the background"},{"type":"string","name":"border-color","default":"var(--pharos-button-color-base-primary-border-base)","description":"The color of the border"}],"access":"public","group":["buttons"],"require":[],"file":{"path":"_mixins.scss","name":"_mixins.scss"}},{"description":"Base styles for inputs\\n","commentRange":{"start":7,"end":9},"context":{"type":"mixin","name":"input-base","code":"\\n  @include font-base;\\n\\n  margin: 0;\\n  padding: var(--pharos-spacing-one-half-x) var(--pharos-spacing-three-quarters-x);\\n  width: 100%;\\n  display: block;\\n  box-sizing: border-box;\\n  border: 1px solid var(--pharos-form-element-color-border-base);\\n  border-radius: var(--pharos-radius-base-standard);\\n  transition: transform var(--pharos-transition-base) 0s;\\n  color: var(--pharos-form-element-color-text-base);\\n","line":{"start":10,"end":22}},"access":"public","group":["form-elements"],"require":[{"type":"mixin","name":"font-base"}],"file":{"path":"_mixins.scss","name":"_mixins.scss"}},{"description":"Placeholder styles for inputs\\n","commentRange":{"start":24,"end":26},"context":{"type":"mixin","name":"input-placeholder","code":"\\n  &::placeholder {\\n    color: var(--pharos-form-element-color-text-placeholder);\\n    opacity: 1;\\n  }\\n","line":{"start":27,"end":32}},"access":"public","group":["form-elements"],"require":[],"file":{"path":"_mixins.scss","name":"_mixins.scss"}},{"description":"Focus styles for inputs\\n","commentRange":{"start":34,"end":36},"context":{"type":"mixin","name":"input-focus","code":"\\n  outline: none;\\n  border: 2px solid var(--pharos-form-element-color-border-focus);\\n  transition: transform var(--pharos-transition-base) 0s;\\n","line":{"start":37,"end":41}},"access":"public","group":["form-elements"],"require":[],"file":{"path":"_mixins.scss","name":"_mixins.scss"}},{"description":"Wrapper styles for inputs\\n","commentRange":{"start":43,"end":45},"context":{"type":"mixin","name":"input-wrapper","code":"\\n  position: relative;\\n  display: flex;\\n  align-items: center;\\n  width: 100%;\\n","line":{"start":46,"end":51}},"access":"public","group":["form-elements"],"file":{"path":"_mixins.scss","name":"_mixins.scss"}},{"description":"Styles for input\'s invalid state\\n","commentRange":{"start":53,"end":55},"context":{"type":"mixin","name":"input-invalid","code":"\\n  border: 2px solid var(--pharos-form-element-color-border-invalid);\\n","line":{"start":56,"end":58}},"access":"public","group":["form-elements"],"require":[],"file":{"path":"_mixins.scss","name":"_mixins.scss"}},{"description":"Styles for input\'s disabled state\\n","commentRange":{"start":60,"end":62},"context":{"type":"mixin","name":"input-disabled","code":"\\n  color: var(--pharos-form-element-color-text-disabled);\\n  background-color: var(--pharos-form-element-color-background-disabled);\\n  border-color: var(--pharos-form-element-color-background-disabled);\\n  pointer-events: none;\\n","line":{"start":63,"end":68}},"access":"public","group":["form-elements"],"require":[],"file":{"path":"_mixins.scss","name":"_mixins.scss"}},{"description":"Styles for input\'s required state\\n","commentRange":{"start":70,"end":72},"context":{"type":"mixin","name":"input-required","code":"\\n  &:required {\\n    box-shadow: none;\\n  }\\n","line":{"start":73,"end":77}},"access":"public","group":["form-elements"],"file":{"path":"_mixins.scss","name":"_mixins.scss"}},{"description":"Styles for input states with thicker borders\\n","commentRange":{"start":79,"end":81},"context":{"type":"mixin","name":"input-padding-thick-border","code":"\\n  padding: calc(var(--pharos-spacing-one-half-x) - 1px)\\n    calc(var(--pharos-spacing-three-quarters-x) - 1px);\\n","line":{"start":82,"end":85}},"access":"public","group":["form-elements"],"require":[],"file":{"path":"_mixins.scss","name":"_mixins.scss"}},{"description":"Styles for prominent input states with thicker borders\\n","commentRange":{"start":87,"end":89},"context":{"type":"mixin","name":"input-padding-thick-border-prominent","code":"\\n  padding: calc(var(--pharos-spacing-1-x) - 1px);\\n","line":{"start":90,"end":92}},"access":"public","group":["form-elements"],"require":[],"file":{"path":"_mixins.scss","name":"_mixins.scss"}},{"description":"Styles for inputs on a background\\n","commentRange":{"start":94,"end":96},"context":{"type":"mixin","name":"input-on-background","code":"\\n  background-color: var(--pharos-color-marble-gray-20);\\n  border-color: var(--pharos-color-marble-gray-20);\\n  color: var(--pharos-color-text-white);\\n  caret-color: var(--pharos-color-text-white);\\n\\n  &::placeholder {\\n    color: var(--pharos-color-marble-gray-base);\\n  }\\n","line":{"start":97,"end":106}},"access":"public","group":["form-elements"],"require":[],"file":{"path":"_mixins.scss","name":"_mixins.scss"}},{"description":"Styles for input options\\n","commentRange":{"start":108,"end":110},"context":{"type":"mixin","name":"option-input","code":"\\n  @include hidden;\\n\\n  display: block;\\n  box-sizing: border-box;\\n","line":{"start":111,"end":116}},"access":"public","group":["form-elements"],"require":[{"type":"mixin","name":"hidden"}],"file":{"path":"_mixins.scss","name":"_mixins.scss"}},{"description":"Wrapper styles for input options\\n","commentRange":{"start":118,"end":120},"context":{"type":"mixin","name":"option-wrapper","code":"\\n  display: inline-flex;\\n  align-items: flex-start;\\n  position: relative;\\n","line":{"start":121,"end":125}},"access":"public","group":["form-elements"],"file":{"path":"_mixins.scss","name":"_mixins.scss"}},{"description":"Base styles for labels\\n","commentRange":{"start":191,"end":193},"context":{"type":"mixin","name":"label-base","code":"\\n  color: var(--pharos-form-element-color-text-base);\\n  margin-bottom: $margin-bottom;\\n  display: block;\\n  padding: 0;\\n  text-transform: $text-transform;\\n","line":{"start":194,"end":200}},"access":"public","group":["form-elements"],"require":[],"file":{"path":"_mixins.scss","name":"_mixins.scss"},"usedBy":[{"description":"Styles for labels of form elements\\n","context":{"type":"mixin","name":"form-element-label","code":"\\n  @include font-base(\\n    $font-size: var(--pharos-form-element-size-text-label),\\n    $font-weight: var(--pharos-font-weight-bold),\\n    $line-height: var(--pharos-line-height-small)\\n  );\\n  @include label-base;\\n","line":{"start":205,"end":212}}},{"description":"Styles for labels of grouped form elements\\n","context":{"type":"mixin","name":"groupable-element-label","code":"\\n  @include font-base;\\n  @include label-base($margin-bottom: 0, $text-transform: none);\\n\\n  padding-left: var(--pharos-spacing-one-quarter-x);\\n","line":{"start":217,"end":222}}}]},{"description":"Styles for labels of form elements\\n","commentRange":{"start":202,"end":204},"context":{"type":"mixin","name":"form-element-label","code":"\\n  @include font-base(\\n    $font-size: var(--pharos-form-element-size-text-label),\\n    $font-weight: var(--pharos-font-weight-bold),\\n    $line-height: var(--pharos-line-height-small)\\n  );\\n  @include label-base;\\n","line":{"start":205,"end":212}},"access":"public","group":["form-elements"],"require":[{"type":"mixin","name":"font-base"},{"type":"mixin","name":"label-base"}],"file":{"path":"_mixins.scss","name":"_mixins.scss"},"usedBy":[{"description":"Base styles for content labels.\\n","context":{"type":"mixin","name":"content-label","code":"\\n  @include form-element-label($args...);\\n","line":{"start":441,"end":443}}}]},{"description":"Styles for labels of grouped form elements\\n","commentRange":{"start":214,"end":216},"context":{"type":"mixin","name":"groupable-element-label","code":"\\n  @include font-base;\\n  @include label-base($margin-bottom: 0, $text-transform: none);\\n\\n  padding-left: var(--pharos-spacing-one-quarter-x);\\n","line":{"start":217,"end":222}},"access":"public","group":["form-elements"],"require":[{"type":"mixin","name":"font-base"},{"type":"mixin","name":"label-base"}],"file":{"path":"_mixins.scss","name":"_mixins.scss"}},{"description":"Styles to hide an element\\n","commentRange":{"start":127,"end":129},"context":{"type":"mixin","name":"hidden","code":"\\n  border: 0;\\n  clip: rect(0 0 0 0);\\n  clip-path: inset(50%);\\n  height: 1px;\\n  width: 1px;\\n  margin: -1px;\\n  overflow: hidden;\\n  padding: 0;\\n  position: absolute;\\n  white-space: nowrap;\\n","line":{"start":130,"end":141}},"access":"public","group":["interaction"],"require":[],"file":{"path":"_mixins.scss","name":"_mixins.scss"},"usedBy":[{"description":"Styles for input options\\n","context":{"type":"mixin","name":"option-input","code":"\\n  @include hidden;\\n\\n  display: block;\\n  box-sizing: border-box;\\n","line":{"start":111,"end":116}}}]},{"description":"Focus styles for most interactive components.\\n","commentRange":{"start":238,"end":240},"context":{"type":"mixin","name":"interactive-focus","code":"\\n  &:focus {\\n    outline: 2px solid var(--pharos-color-focus);\\n    outline-offset: 2px;\\n  }\\n","line":{"start":241,"end":246}},"access":"public","group":["interaction"],"require":[],"file":{"path":"_mixins.scss","name":"_mixins.scss"}},{"description":"Base styles for transitions.\\n","commentRange":{"start":428,"end":431},"context":{"type":"mixin","name":"transition-base","code":"\\n  transition-property: $properties;\\n  transition-duration: var(--pharos-transition-duration-default);\\n  transition-timing-function: ease-in-out;\\n","line":{"start":432,"end":436}},"parameter":[{"type":"string","name":"properties","description":"The transition properties to style"}],"access":"public","group":["interaction"],"require":[],"file":{"path":"_mixins.scss","name":"_mixins.scss"},"usedBy":[{"description":"Base styles for buttons.\\n","context":{"type":"mixin","name":"button-base","code":"\\n  @include font-base($font-weight: var(--pharos-font-weight-bold));\\n  @include transition-base(border-color, background, color);\\n\\n  color: $color;\\n  background-color: $background-color;\\n  border: 1px solid $border-color;\\n  padding: var(--pharos-spacing-one-quarter-x) var(--pharos-spacing-three-quarters-x);\\n  border-radius: var(--pharos-radius-base-standard);\\n  cursor: pointer;\\n  display: flex;\\n  align-items: center;\\n  justify-content: center;\\n  margin: 0;\\n  appearance: none;\\n\\n  [data-pharos-component=\'PharosIcon\'] {\\n    @include transition-base(fill, stroke);\\n\\n    fill: $color;\\n    stroke: $color;\\n    stroke-width: 0;\\n  }\\n\\n  [data-pharos-component=\'PharosIcon\']:first-child:not(:only-child) {\\n    margin-right: var(--pharos-spacing-one-quarter-x);\\n  }\\n\\n  [data-pharos-component=\'PharosIcon\']:last-child:not(:only-child) {\\n    margin-left: var(--pharos-spacing-one-quarter-x);\\n  }\\n","line":{"start":254,"end":289}}},{"description":"Base styles for buttons.\\n","context":{"type":"mixin","name":"button-base","code":"\\n  @include font-base($font-weight: var(--pharos-font-weight-bold));\\n  @include transition-base(border-color, background, color);\\n\\n  color: $color;\\n  background-color: $background-color;\\n  border: 1px solid $border-color;\\n  padding: var(--pharos-spacing-one-quarter-x) var(--pharos-spacing-three-quarters-x);\\n  border-radius: var(--pharos-radius-base-standard);\\n  cursor: pointer;\\n  display: flex;\\n  align-items: center;\\n  justify-content: center;\\n  margin: 0;\\n  appearance: none;\\n\\n  [data-pharos-component=\'PharosIcon\'] {\\n    @include transition-base(fill, stroke);\\n\\n    fill: $color;\\n    stroke: $color;\\n    stroke-width: 0;\\n  }\\n\\n  [data-pharos-component=\'PharosIcon\']:first-child:not(:only-child) {\\n    margin-right: var(--pharos-spacing-one-quarter-x);\\n  }\\n\\n  [data-pharos-component=\'PharosIcon\']:last-child:not(:only-child) {\\n    margin-left: var(--pharos-spacing-one-quarter-x);\\n  }\\n","line":{"start":254,"end":289}}}]},{"description":"Creates a media query that starts at the passed breakpoint.\\n","commentRange":{"start":445,"end":448},"context":{"type":"mixin","name":"at-least","code":"\\n  @if map-has-key(variables.$breakpoints, $breakpoint) {\\n    $width: map.get(variables.$breakpoints, $breakpoint, width);\\n    @media screen and (min-width: $width) {\\n      @content;\\n    }\\n  } @else {\\n    @error \'Unknown breakpoint `#{$breakpoint}`. \' + \'Available breakpoints are: #{map.keys(variables.$breakpoints)}.\';\\n  }\\n","line":{"start":449,"end":458}},"parameter":[{"type":"string","name":"breakpoint","description":"The breakpoint to use as the minimum"}],"access":"public","group":["layout"],"content":"","require":[],"throw":["Unknown breakpoint `#{$breakpoint}`. "],"file":{"path":"_mixins.scss","name":"_mixins.scss"},"usedBy":[{"description":"Sets margins for the layout\'s outer grid.\\n","context":{"type":"mixin","name":"layout-base-columns","code":"\\n  $breakpoints: map.get(variables.$layouts, $layout);\\n  $fixed-margin: $layout != \'1-col\';\\n\\n  @each $breakpoint, $margin in $breakpoints {\\n    $i: list.index($breakpoints, $breakpoint $margin);\\n\\n    @if $i != length($breakpoints) {\\n      $upper: list.nth(map.keys($breakpoints), $i + 1);\\n      $max-margin: list.nth(map.values($breakpoints), $i + 1);\\n\\n      @include between($breakpoint, $upper) {\\n        $layout-margin: if($fixed-margin, $margin, minmax($margin, $max-margin));\\n\\n        grid-template-columns: $layout-margin auto $layout-margin;\\n        grid-template-rows: auto;\\n      }\\n    } @else {\\n      @include at-least($breakpoint) {\\n        grid-template-columns: minmax($margin, 1fr) auto minmax($margin, 1fr);\\n        grid-template-rows: auto;\\n      }\\n    }\\n  }\\n","line":{"start":528,"end":552}}},{"description":"Sets widths for the layout\'s inner grid.\\n","context":{"type":"mixin","name":"layout-content-width","code":"\\n  $breakpoints: map.get(variables.$layouts, $layout);\\n  $fixed-width: $layout == \'1-col\';\\n  $property: if($fixed-width, width, min-width);\\n\\n  @if $fixed-width {\\n    @include at-least(medium) {\\n      margin: auto;\\n    }\\n  }\\n\\n  @each $breakpoint, $margin in $breakpoints {\\n    $i: list.index($breakpoints, $breakpoint $margin);\\n\\n    @if $i == 1 {\\n      @include until($breakpoint) {\\n        #{$property}: functions.content-width(\\n          map.get(variables.$breakpoints, $breakpoint, width),\\n          $margin\\n        );\\n      }\\n    } @else if $i != length($breakpoints) {\\n      $upper: list.nth(map.keys($breakpoints), $i + 1);\\n\\n      @include between($breakpoint, $upper) {\\n        #{$property}: functions.content-width(\\n          map.get(variables.$breakpoints, $breakpoint, width),\\n          $margin,\\n          $sidenav: string.index($layout, \'--sidenav\') and $i > 2\\n        );\\n      }\\n    } @else {\\n      @include at-least($breakpoint) {\\n        #{$property}: functions.content-width(\\n          map.get(variables.$breakpoints, $breakpoint, width),\\n          $margin,\\n          $sidenav: string.index($layout, \'--sidenav\')\\n        );\\n      }\\n    }\\n  }\\n","line":{"start":558,"end":599}}},{"description":"Sets widths for the layout\'s inner grid.\\n","context":{"type":"mixin","name":"layout-content-width","code":"\\n  $breakpoints: map.get(variables.$layouts, $layout);\\n  $fixed-width: $layout == \'1-col\';\\n  $property: if($fixed-width, width, min-width);\\n\\n  @if $fixed-width {\\n    @include at-least(medium) {\\n      margin: auto;\\n    }\\n  }\\n\\n  @each $breakpoint, $margin in $breakpoints {\\n    $i: list.index($breakpoints, $breakpoint $margin);\\n\\n    @if $i == 1 {\\n      @include until($breakpoint) {\\n        #{$property}: functions.content-width(\\n          map.get(variables.$breakpoints, $breakpoint, width),\\n          $margin\\n        );\\n      }\\n    } @else if $i != length($breakpoints) {\\n      $upper: list.nth(map.keys($breakpoints), $i + 1);\\n\\n      @include between($breakpoint, $upper) {\\n        #{$property}: functions.content-width(\\n          map.get(variables.$breakpoints, $breakpoint, width),\\n          $margin,\\n          $sidenav: string.index($layout, \'--sidenav\') and $i > 2\\n        );\\n      }\\n    } @else {\\n      @include at-least($breakpoint) {\\n        #{$property}: functions.content-width(\\n          map.get(variables.$breakpoints, $breakpoint, width),\\n          $margin,\\n          $sidenav: string.index($layout, \'--sidenav\')\\n        );\\n      }\\n    }\\n  }\\n","line":{"start":558,"end":599}}}]},{"description":"Creates a media query that ranges up to the passed breakpoint.\\n","commentRange":{"start":460,"end":463},"context":{"type":"mixin","name":"until","code":"\\n  @if map-has-key(variables.$breakpoints, $breakpoint) {\\n    $width: map.get(variables.$breakpoints, $breakpoint, width);\\n    @media screen and (max-width: $width) {\\n      @content;\\n    }\\n  } @else {\\n    @error \'Unknown breakpoint `#{$breakpoint}`. \' + \'Available breakpoints are: #{map.keys(variables.$breakpoints)}.\';\\n  }\\n","line":{"start":464,"end":473}},"parameter":[{"type":"string","name":"breakpoint","description":"The breakpoint to use as the maximum"}],"access":"public","group":["layout"],"content":"","require":[],"throw":["Unknown breakpoint `#{$breakpoint}`. "],"file":{"path":"_mixins.scss","name":"_mixins.scss"},"usedBy":[{"description":"Base style for the layout\'s inner grid.\\n","context":{"type":"mixin","name":"layout-content","code":"\\n  display: grid;\\n  grid-area: content;\\n  grid-template-columns: repeat(map.get(variables.$breakpoints, large, columns), 1fr);\\n  grid-template-rows: auto;\\n  column-gap: var(--pharos-spacing-gutter);\\n  padding: 0;\\n  margin: 0;\\n  list-style: none;\\n\\n  @include until(medium) {\\n    grid-template-columns: repeat(map.get(variables.$breakpoints, medium, columns), 1fr);\\n    grid-template-rows: auto;\\n  }\\n\\n  @include until(small) {\\n    grid-template-columns: repeat(map.get(variables.$breakpoints, small, columns), 1fr);\\n    grid-template-rows: auto;\\n  }\\n","line":{"start":503,"end":522}}},{"description":"Base style for the layout\'s inner grid.\\n","context":{"type":"mixin","name":"layout-content","code":"\\n  display: grid;\\n  grid-area: content;\\n  grid-template-columns: repeat(map.get(variables.$breakpoints, large, columns), 1fr);\\n  grid-template-rows: auto;\\n  column-gap: var(--pharos-spacing-gutter);\\n  padding: 0;\\n  margin: 0;\\n  list-style: none;\\n\\n  @include until(medium) {\\n    grid-template-columns: repeat(map.get(variables.$breakpoints, medium, columns), 1fr);\\n    grid-template-rows: auto;\\n  }\\n\\n  @include until(small) {\\n    grid-template-columns: repeat(map.get(variables.$breakpoints, small, columns), 1fr);\\n    grid-template-rows: auto;\\n  }\\n","line":{"start":503,"end":522}}},{"description":"Sets widths for the layout\'s inner grid.\\n","context":{"type":"mixin","name":"layout-content-width","code":"\\n  $breakpoints: map.get(variables.$layouts, $layout);\\n  $fixed-width: $layout == \'1-col\';\\n  $property: if($fixed-width, width, min-width);\\n\\n  @if $fixed-width {\\n    @include at-least(medium) {\\n      margin: auto;\\n    }\\n  }\\n\\n  @each $breakpoint, $margin in $breakpoints {\\n    $i: list.index($breakpoints, $breakpoint $margin);\\n\\n    @if $i == 1 {\\n      @include until($breakpoint) {\\n        #{$property}: functions.content-width(\\n          map.get(variables.$breakpoints, $breakpoint, width),\\n          $margin\\n        );\\n      }\\n    } @else if $i != length($breakpoints) {\\n      $upper: list.nth(map.keys($breakpoints), $i + 1);\\n\\n      @include between($breakpoint, $upper) {\\n        #{$property}: functions.content-width(\\n          map.get(variables.$breakpoints, $breakpoint, width),\\n          $margin,\\n          $sidenav: string.index($layout, \'--sidenav\') and $i > 2\\n        );\\n      }\\n    } @else {\\n      @include at-least($breakpoint) {\\n        #{$property}: functions.content-width(\\n          map.get(variables.$breakpoints, $breakpoint, width),\\n          $margin,\\n          $sidenav: string.index($layout, \'--sidenav\')\\n        );\\n      }\\n    }\\n  }\\n","line":{"start":558,"end":599}}}]},{"description":"Creates a media query that ranges between the two passed breakpoints.\\n","commentRange":{"start":475,"end":479},"context":{"type":"mixin","name":"between","code":"\\n  @if map-has-key(variables.$breakpoints, $lower) and map-has-key(variables.$breakpoints, $upper) {\\n    $lower-width: functions.calculate-px(map.get(variables.$breakpoints, $lower, width));\\n    $upper-width: functions.calculate-px(map.get(variables.$breakpoints, $upper, width));\\n    @media screen and (min-width: $lower-width) and (max-width: $upper-width - 1) {\\n      @content;\\n    }\\n  } @else {\\n    @error \'Unknown breakpoint range `#{$lower}` - `#{$upper}`. \' + \'Available breakpoints are: #{map.keys(variables.$breakpoints)}.\';\\n  }\\n","line":{"start":480,"end":490}},"parameter":[{"type":"string","name":"lower","description":"The breakpoint to use as the lower bounds"},{"type":"string","name":"upper","description":"The breakpoint to use as the upper bounds"}],"access":"public","group":["layout"],"content":"","require":[],"throw":["Unknown breakpoint range `#{$lower}` - `#{$upper}`. "],"file":{"path":"_mixins.scss","name":"_mixins.scss"},"usedBy":[{"description":"Sets margins for the layout\'s outer grid.\\n","context":{"type":"mixin","name":"layout-base-columns","code":"\\n  $breakpoints: map.get(variables.$layouts, $layout);\\n  $fixed-margin: $layout != \'1-col\';\\n\\n  @each $breakpoint, $margin in $breakpoints {\\n    $i: list.index($breakpoints, $breakpoint $margin);\\n\\n    @if $i != length($breakpoints) {\\n      $upper: list.nth(map.keys($breakpoints), $i + 1);\\n      $max-margin: list.nth(map.values($breakpoints), $i + 1);\\n\\n      @include between($breakpoint, $upper) {\\n        $layout-margin: if($fixed-margin, $margin, minmax($margin, $max-margin));\\n\\n        grid-template-columns: $layout-margin auto $layout-margin;\\n        grid-template-rows: auto;\\n      }\\n    } @else {\\n      @include at-least($breakpoint) {\\n        grid-template-columns: minmax($margin, 1fr) auto minmax($margin, 1fr);\\n        grid-template-rows: auto;\\n      }\\n    }\\n  }\\n","line":{"start":528,"end":552}}},{"description":"Sets widths for the layout\'s inner grid.\\n","context":{"type":"mixin","name":"layout-content-width","code":"\\n  $breakpoints: map.get(variables.$layouts, $layout);\\n  $fixed-width: $layout == \'1-col\';\\n  $property: if($fixed-width, width, min-width);\\n\\n  @if $fixed-width {\\n    @include at-least(medium) {\\n      margin: auto;\\n    }\\n  }\\n\\n  @each $breakpoint, $margin in $breakpoints {\\n    $i: list.index($breakpoints, $breakpoint $margin);\\n\\n    @if $i == 1 {\\n      @include until($breakpoint) {\\n        #{$property}: functions.content-width(\\n          map.get(variables.$breakpoints, $breakpoint, width),\\n          $margin\\n        );\\n      }\\n    } @else if $i != length($breakpoints) {\\n      $upper: list.nth(map.keys($breakpoints), $i + 1);\\n\\n      @include between($breakpoint, $upper) {\\n        #{$property}: functions.content-width(\\n          map.get(variables.$breakpoints, $breakpoint, width),\\n          $margin,\\n          $sidenav: string.index($layout, \'--sidenav\') and $i > 2\\n        );\\n      }\\n    } @else {\\n      @include at-least($breakpoint) {\\n        #{$property}: functions.content-width(\\n          map.get(variables.$breakpoints, $breakpoint, width),\\n          $margin,\\n          $sidenav: string.index($layout, \'--sidenav\')\\n        );\\n      }\\n    }\\n  }\\n","line":{"start":558,"end":599}}}]},{"description":"Base style for the layout\'s outer grid.\\n","commentRange":{"start":492,"end":494},"context":{"type":"mixin","name":"layout-base","code":"\\n  display: grid;\\n  grid-template-areas: \'. content .\';\\n","line":{"start":495,"end":498}},"access":"public","group":["layout"],"file":{"path":"_mixins.scss","name":"_mixins.scss"}},{"description":"Base style for the layout\'s inner grid.\\n","commentRange":{"start":500,"end":502},"context":{"type":"mixin","name":"layout-content","code":"\\n  display: grid;\\n  grid-area: content;\\n  grid-template-columns: repeat(map.get(variables.$breakpoints, large, columns), 1fr);\\n  grid-template-rows: auto;\\n  column-gap: var(--pharos-spacing-gutter);\\n  padding: 0;\\n  margin: 0;\\n  list-style: none;\\n\\n  @include until(medium) {\\n    grid-template-columns: repeat(map.get(variables.$breakpoints, medium, columns), 1fr);\\n    grid-template-rows: auto;\\n  }\\n\\n  @include until(small) {\\n    grid-template-columns: repeat(map.get(variables.$breakpoints, small, columns), 1fr);\\n    grid-template-rows: auto;\\n  }\\n","line":{"start":503,"end":522}},"access":"public","group":["layout"],"require":[{"type":"mixin","name":"until"},{"type":"mixin","name":"until"}],"file":{"path":"_mixins.scss","name":"_mixins.scss"}},{"description":"Sets margins for the layout\'s outer grid.\\n","commentRange":{"start":524,"end":527},"context":{"type":"mixin","name":"layout-base-columns","code":"\\n  $breakpoints: map.get(variables.$layouts, $layout);\\n  $fixed-margin: $layout != \'1-col\';\\n\\n  @each $breakpoint, $margin in $breakpoints {\\n    $i: list.index($breakpoints, $breakpoint $margin);\\n\\n    @if $i != length($breakpoints) {\\n      $upper: list.nth(map.keys($breakpoints), $i + 1);\\n      $max-margin: list.nth(map.values($breakpoints), $i + 1);\\n\\n      @include between($breakpoint, $upper) {\\n        $layout-margin: if($fixed-margin, $margin, minmax($margin, $max-margin));\\n\\n        grid-template-columns: $layout-margin auto $layout-margin;\\n        grid-template-rows: auto;\\n      }\\n    } @else {\\n      @include at-least($breakpoint) {\\n        grid-template-columns: minmax($margin, 1fr) auto minmax($margin, 1fr);\\n        grid-template-rows: auto;\\n      }\\n    }\\n  }\\n","line":{"start":528,"end":552}},"parameter":[{"type":"string","name":"layout","description":"The layout preset"}],"access":"public","group":["layout"],"require":[{"type":"mixin","name":"between"},{"type":"mixin","name":"at-least"}],"file":{"path":"_mixins.scss","name":"_mixins.scss"}},{"description":"Sets widths for the layout\'s inner grid.\\n","commentRange":{"start":554,"end":557},"context":{"type":"mixin","name":"layout-content-width","code":"\\n  $breakpoints: map.get(variables.$layouts, $layout);\\n  $fixed-width: $layout == \'1-col\';\\n  $property: if($fixed-width, width, min-width);\\n\\n  @if $fixed-width {\\n    @include at-least(medium) {\\n      margin: auto;\\n    }\\n  }\\n\\n  @each $breakpoint, $margin in $breakpoints {\\n    $i: list.index($breakpoints, $breakpoint $margin);\\n\\n    @if $i == 1 {\\n      @include until($breakpoint) {\\n        #{$property}: functions.content-width(\\n          map.get(variables.$breakpoints, $breakpoint, width),\\n          $margin\\n        );\\n      }\\n    } @else if $i != length($breakpoints) {\\n      $upper: list.nth(map.keys($breakpoints), $i + 1);\\n\\n      @include between($breakpoint, $upper) {\\n        #{$property}: functions.content-width(\\n          map.get(variables.$breakpoints, $breakpoint, width),\\n          $margin,\\n          $sidenav: string.index($layout, \'--sidenav\') and $i > 2\\n        );\\n      }\\n    } @else {\\n      @include at-least($breakpoint) {\\n        #{$property}: functions.content-width(\\n          map.get(variables.$breakpoints, $breakpoint, width),\\n          $margin,\\n          $sidenav: string.index($layout, \'--sidenav\')\\n        );\\n      }\\n    }\\n  }\\n","line":{"start":558,"end":599}},"parameter":[{"type":"string","name":"layout","description":"The layout preset"}],"access":"public","group":["layout"],"require":[{"type":"mixin","name":"at-least"},{"type":"mixin","name":"until"},{"type":"mixin","name":"between"},{"type":"mixin","name":"at-least"}],"file":{"path":"_mixins.scss","name":"_mixins.scss"}},{"description":"Base styles for links.\\n","commentRange":{"start":351,"end":353},"context":{"type":"mixin","name":"link-base","code":"\\n  @include font-base($font-size: inherit, $line-height: inherit);\\n  @include underline;\\n\\n  letter-spacing: inherit;\\n  color: var(--pharos-color-interactive-secondary);\\n  transition-property: color, text-decoration-color;\\n  transition-duration: 200ms;\\n  transition-timing-function: ease-in-out;\\n","line":{"start":354,"end":363}},"access":"public","group":["links"],"require":[{"type":"mixin","name":"font-base"},{"type":"mixin","name":"underline"}],"file":{"path":"_mixins.scss","name":"_mixins.scss"}},{"description":"Hover style for links.\\n","commentRange":{"start":365,"end":367},"context":{"type":"mixin","name":"link-hover","code":"\\n  &:hover {\\n    @include no-underline;\\n\\n    color: var(--pharos-color-hover-primary);\\n  }\\n","line":{"start":368,"end":374}},"access":"public","group":["links"],"require":[{"type":"mixin","name":"no-underline"}],"file":{"path":"_mixins.scss","name":"_mixins.scss"}},{"description":"Base styles for underlines.\\n","commentRange":{"start":376,"end":379},"context":{"type":"mixin","name":"underline","code":"\\n  text-decoration: underline;\\n  text-decoration-color: $text-decoration-color;\\n","line":{"start":380,"end":383}},"parameter":[{"type":"string","name":"text-decoration-color","default":"var(--pharos-color-interactive-secondary)","description":"The color of the underline"}],"access":"public","group":["links"],"require":[],"file":{"path":"_mixins.scss","name":"_mixins.scss"},"usedBy":[{"description":"Base styles for links.\\n","context":{"type":"mixin","name":"link-base","code":"\\n  @include font-base($font-size: inherit, $line-height: inherit);\\n  @include underline;\\n\\n  letter-spacing: inherit;\\n  color: var(--pharos-color-interactive-secondary);\\n  transition-property: color, text-decoration-color;\\n  transition-duration: 200ms;\\n  transition-timing-function: ease-in-out;\\n","line":{"start":354,"end":363}}}]},{"description":"Removes underlines.\\n","commentRange":{"start":386,"end":388},"context":{"type":"mixin","name":"no-underline","code":"\\n  text-decoration-style: solid;\\n  text-decoration-line: underline;\\n  text-decoration-color: transparent;\\n","line":{"start":389,"end":393}},"access":"public","group":["links"],"file":{"path":"_mixins.scss","name":"_mixins.scss"},"usedBy":[{"description":"Hover style for links.\\n","context":{"type":"mixin","name":"link-hover","code":"\\n  &:hover {\\n    @include no-underline;\\n\\n    color: var(--pharos-color-hover-primary);\\n  }\\n","line":{"start":368,"end":374}}}]},{"description":"Base styles for font.\\n","commentRange":{"start":143,"end":149},"context":{"type":"mixin","name":"font-base","code":"\\n  @if $font-family == var(--pharos-font-family-sans-serif) {\\n    @include letter-spacing-sans-serif($font-size);\\n  } @else if $font-family == var(--pharos-font-family-serif) {\\n    @include letter-spacing-serif($font-size);\\n  } @else {\\n    @error \'Unknown font-family #{$font-family}.\';\\n  }\\n\\n  font-family: $font-family;\\n  font-size: $font-size;\\n  font-weight: $font-weight;\\n  line-height: $line-height;\\n  text-rendering: optimizelegibility;\\n  -webkit-font-smoothing: antialiased;\\n  -moz-osx-font-smoothing: grayscale;\\n","line":{"start":150,"end":171}},"parameter":[{"type":"string","name":"font-family","default":"var(--pharos-font-family-sans-serif)","description":"The font family of the font"},{"type":"string","name":"font-size","default":"var(--pharos-font-size-base)","description":"The size of the font"},{"type":"string","name":"font-weight","default":"var(--pharos-font-weight-regular)","description":"The weight of the font"},{"type":"string","name":"line-height","default":"var(--pharos-line-height-medium)","description":"The line height of the font"}],"access":"public","group":["typography"],"require":[{"type":"mixin","name":"letter-spacing-sans-serif"},{"type":"mixin","name":"letter-spacing-serif"}],"throw":["Unknown font-family #{$font-family}."],"file":{"path":"_mixins.scss","name":"_mixins.scss"},"usedBy":[{"description":"Base styles for buttons.\\n","context":{"type":"mixin","name":"button-base","code":"\\n  @include font-base($font-weight: var(--pharos-font-weight-bold));\\n  @include transition-base(border-color, background, color);\\n\\n  color: $color;\\n  background-color: $background-color;\\n  border: 1px solid $border-color;\\n  padding: var(--pharos-spacing-one-quarter-x) var(--pharos-spacing-three-quarters-x);\\n  border-radius: var(--pharos-radius-base-standard);\\n  cursor: pointer;\\n  display: flex;\\n  align-items: center;\\n  justify-content: center;\\n  margin: 0;\\n  appearance: none;\\n\\n  [data-pharos-component=\'PharosIcon\'] {\\n    @include transition-base(fill, stroke);\\n\\n    fill: $color;\\n    stroke: $color;\\n    stroke-width: 0;\\n  }\\n\\n  [data-pharos-component=\'PharosIcon\']:first-child:not(:only-child) {\\n    margin-right: var(--pharos-spacing-one-quarter-x);\\n  }\\n\\n  [data-pharos-component=\'PharosIcon\']:last-child:not(:only-child) {\\n    margin-left: var(--pharos-spacing-one-quarter-x);\\n  }\\n","line":{"start":254,"end":289}}},{"description":"Base styles for inputs\\n","context":{"type":"mixin","name":"input-base","code":"\\n  @include font-base;\\n\\n  margin: 0;\\n  padding: var(--pharos-spacing-one-half-x) var(--pharos-spacing-three-quarters-x);\\n  width: 100%;\\n  display: block;\\n  box-sizing: border-box;\\n  border: 1px solid var(--pharos-form-element-color-border-base);\\n  border-radius: var(--pharos-radius-base-standard);\\n  transition: transform var(--pharos-transition-base) 0s;\\n  color: var(--pharos-form-element-color-text-base);\\n","line":{"start":10,"end":22}}},{"description":"Styles for labels of form elements\\n","context":{"type":"mixin","name":"form-element-label","code":"\\n  @include font-base(\\n    $font-size: var(--pharos-form-element-size-text-label),\\n    $font-weight: var(--pharos-font-weight-bold),\\n    $line-height: var(--pharos-line-height-small)\\n  );\\n  @include label-base;\\n","line":{"start":205,"end":212}}},{"description":"Styles for labels of grouped form elements\\n","context":{"type":"mixin","name":"groupable-element-label","code":"\\n  @include font-base;\\n  @include label-base($margin-bottom: 0, $text-transform: none);\\n\\n  padding-left: var(--pharos-spacing-one-quarter-x);\\n","line":{"start":217,"end":222}}},{"description":"Base styles for links.\\n","context":{"type":"mixin","name":"link-base","code":"\\n  @include font-base($font-size: inherit, $line-height: inherit);\\n  @include underline;\\n\\n  letter-spacing: inherit;\\n  color: var(--pharos-color-interactive-secondary);\\n  transition-property: color, text-decoration-color;\\n  transition-duration: 200ms;\\n  transition-timing-function: ease-in-out;\\n","line":{"start":354,"end":363}}}]},{"description":"Letter spacing for serif type\\n","commentRange":{"start":173,"end":175},"context":{"type":"mixin","name":"letter-spacing-serif","code":"\\n  @if $font-size != inherit {\\n    letter-spacing: calc(#{$font-size} * -0.01);\\n  }\\n","line":{"start":176,"end":180}},"access":"public","group":["typography"],"require":[],"file":{"path":"_mixins.scss","name":"_mixins.scss"},"usedBy":[{"description":"Base styles for font.\\n","context":{"type":"mixin","name":"font-base","code":"\\n  @if $font-family == var(--pharos-font-family-sans-serif) {\\n    @include letter-spacing-sans-serif($font-size);\\n  } @else if $font-family == var(--pharos-font-family-serif) {\\n    @include letter-spacing-serif($font-size);\\n  } @else {\\n    @error \'Unknown font-family #{$font-family}.\';\\n  }\\n\\n  font-family: $font-family;\\n  font-size: $font-size;\\n  font-weight: $font-weight;\\n  line-height: $line-height;\\n  text-rendering: optimizelegibility;\\n  -webkit-font-smoothing: antialiased;\\n  -moz-osx-font-smoothing: grayscale;\\n","line":{"start":150,"end":171}}}]},{"description":"Letter spacing for sans-serif type\\n","commentRange":{"start":182,"end":184},"context":{"type":"mixin","name":"letter-spacing-sans-serif","code":"\\n  @if $font-size != inherit {\\n    letter-spacing: calc(#{$font-size} * -0.02);\\n  }\\n","line":{"start":185,"end":189}},"access":"public","group":["typography"],"require":[],"file":{"path":"_mixins.scss","name":"_mixins.scss"},"usedBy":[{"description":"Base styles for font.\\n","context":{"type":"mixin","name":"font-base","code":"\\n  @if $font-family == var(--pharos-font-family-sans-serif) {\\n    @include letter-spacing-sans-serif($font-size);\\n  } @else if $font-family == var(--pharos-font-family-serif) {\\n    @include letter-spacing-serif($font-size);\\n  } @else {\\n    @error \'Unknown font-family #{$font-family}.\';\\n  }\\n\\n  font-family: $font-family;\\n  font-size: $font-size;\\n  font-weight: $font-weight;\\n  line-height: $line-height;\\n  text-rendering: optimizelegibility;\\n  -webkit-font-smoothing: antialiased;\\n  -moz-osx-font-smoothing: grayscale;\\n","line":{"start":150,"end":171}}}]},{"description":"Removes bullets from lists.\\n","commentRange":{"start":395,"end":397},"context":{"type":"mixin","name":"no-bullet","code":"\\n  list-style-type: none;\\n","line":{"start":398,"end":400}},"access":"public","group":["typography"],"file":{"path":"_mixins.scss","name":"_mixins.scss"},"usedBy":[{"description":"Base styles for inline lists.\\n","context":{"type":"mixin","name":"list-inline","code":"\\n  @include no-bullet;\\n\\n  display: flex;\\n  flex-wrap: wrap;\\n  align-items: center;\\n\\n  li:not(:last-child) {\\n    margin-right: $margin-right;\\n    margin-bottom: 0;\\n  }\\n","line":{"start":406,"end":417}}}]},{"description":"Base styles for inline lists.\\n","commentRange":{"start":402,"end":405},"context":{"type":"mixin","name":"list-inline","code":"\\n  @include no-bullet;\\n\\n  display: flex;\\n  flex-wrap: wrap;\\n  align-items: center;\\n\\n  li:not(:last-child) {\\n    margin-right: $margin-right;\\n    margin-bottom: 0;\\n  }\\n","line":{"start":406,"end":417}},"parameter":[{"type":"string","name":"margin-right","default":"var(--pharos-spacing-one-and-a-half-x)","description":"The margin between list items"}],"access":"public","group":["typography"],"require":[{"type":"mixin","name":"no-bullet"}],"file":{"path":"_mixins.scss","name":"_mixins.scss"}},{"description":"Base style for nested lists.\\n","commentRange":{"start":419,"end":421},"context":{"type":"mixin","name":"list-nested","code":"\\n  > li:not(:last-child) {\\n    margin-bottom: var(--pharos-spacing-three-quarters-x);\\n  }\\n","line":{"start":422,"end":426}},"access":"public","group":["typography"],"require":[],"file":{"path":"_mixins.scss","name":"_mixins.scss"}},{"description":"Base styles for content labels.\\n","commentRange":{"start":438,"end":440},"context":{"type":"mixin","name":"content-label","code":"\\n  @include form-element-label($args...);\\n","line":{"start":441,"end":443}},"access":"public","group":["typography"],"require":[{"type":"mixin","name":"form-element-label"}],"file":{"path":"_mixins.scss","name":"_mixins.scss"}},{"description":"Truncates text based on number of lines.\\n","commentRange":{"start":601,"end":604},"context":{"type":"mixin","name":"truncate-text","code":"\\n  overflow: hidden;\\n  -webkit-line-clamp: $lines;\\n  -webkit-box-orient: vertical;\\n  display: -webkit-box;\\n  white-space: normal;\\n","line":{"start":605,"end":611}},"parameter":[{"type":"number","name":"lines","default":"1","description":"The number of lines allowed before truncating"}],"access":"public","group":["typography"],"require":[],"file":{"path":"_mixins.scss","name":"_mixins.scss"}}]');
;// CONCATENATED MODULE: ./packages/pharos/src/styles/sass.wc.stories.jsx


/* harmony default export */ const sass_wc_stories = ({
  title: "Styles/Sass",
  parameters: { options: { selectedPanel: "addon-controls" } }
});
const tableTitle = (title) => {
  return title.split("-").map((str) => str[0].toUpperCase() + str.slice(1)).join(" ");
};
const MixinTable = (title) => {
  const mixins = sass_namespaceObject.filter((value) => value.context.type === "mixin");
  return lit/* html */.dy`
    <div class="token-table-container" style="width: 100%">
      <h2>${tableTitle(title)}</h2>
      <table class="token-table" style="table-layout: fixed">
        <thead>
          <tr>
            <th style="width:20%">Name</th>
            <th style="width:20%">Description</th>
            <th style="width:60%">Code</th>
          </tr>
        </thead>
        <tbody>
          ${mixins.map((mixin) => {
    if (mixin.group.includes(title)) {
      return lit/* html */.dy`
                <tr>
                  <td>
                    <code style="font-size: var(--pharos-font-size-small)"
                      >${mixin.context.name}</code
                    >
                  </td>
                  <td>${mixin.description}</td>
                  <td>
                    <div
                      style="background-color:var(--pharos-color-marble-gray-97); border-style: solid; border-color: var(--pharos-color-marble-gray-80); padding-bottom:var(--pharos-spacing-one-eighth-x); border-width: 1px"
                    >
                      <code
                        style="background-color:var(--pharos-color-marble-gray-97); font-size:var(--pharos-font-size-micro); white-space: pre;"
                      >
                        ${mixin.context.code}</code
                      >
                    </div>
                  </td>
                </tr>
              `;
    }
  })}
        </tbody>
      </table>
      <br />
      <br />
    </div>
  `;
};
const Mixins = {
  render: () => lit/* html */.dy`
    ${MixinTable("buttons")} ${MixinTable("form-elements")} ${MixinTable("interaction")}
    ${MixinTable("layout")} ${MixinTable("links")} ${MixinTable("typography")}
  `
};


/***/ }),

/***/ "./packages/pharos/src/styles/tokens.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AliasColors": () => (/* binding */ AliasColors),
/* harmony export */   "FontFamily": () => (/* binding */ FontFamily),
/* harmony export */   "FontSize": () => (/* binding */ FontSize),
/* harmony export */   "FontWeight": () => (/* binding */ FontWeight),
/* harmony export */   "GlobalColors": () => (/* binding */ GlobalColors),
/* harmony export */   "LineHeight": () => (/* binding */ LineHeight),
/* harmony export */   "Radius": () => (/* binding */ Radius),
/* harmony export */   "Spacing": () => (/* binding */ Spacing),
/* harmony export */   "Transitions": () => (/* binding */ Transitions),
/* harmony export */   "TypeScale": () => (/* binding */ TypeScale),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/lit/index.js");
/* harmony import */ var _tokens_ts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./packages/pharos/src/styles/tokens.ts");


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  title: "Styles/Design Tokens",
  parameters: { options: { selectedPanel: "addon-controls" } }
});
const toTokenFormat = (text) => {
  return lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`<code style="font-size:var(--pharos-font-size-small);"
    >$${text.replace(/([a-z])([A-Z]|[0-9])/g, "$1-$2").replace(/([0-9])([a-z]|[A-Z])/g, "$1-$2").replace(/([A-Z])([A-Z])/g, "$1-$2").toLowerCase()}
  </code>`;
};
const ColorRow = (color) => {
  let OGColorHtml = lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy``;
  if (color.original.value.startsWith("{color.")) {
    const OGColorToken = "$pharos-" + color.original.value.substring(1).split(".").slice(0, -1).join("-").replace(" ", "-").toLowerCase();
    OGColorHtml = lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy` <div>${OGColorToken}</div> `;
  }
  return lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
    <tr>
      <td style="width:50%">${toTokenFormat(color.name)}</td>
      <td style="width:25%">
        ${OGColorHtml}
        <div>${color.value}</div>
      </td>
      <td style="width:25%">
        <div class="color-example" style="background-color:${color.value};"></div>
      </td>
    </tr>
  `;
};
const TokenTable = (title, content) => {
  return lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
    <div class="token-table-container">
      <h2>${title}</h2>
      <table class="token-table">
        ${content}
      </table>
      <br />
      <br />
    </div>
  `;
};
const UiColorTokens = () => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
  ${TokenTable(
  "Alias color tokens",
  lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
      <thead>
        <tr>
          <th>Token</th>
          <th>Value</th>
          <th>Example</th>
        </tr>
      </thead>
      <tbody>
        ${Object.keys(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color.interactive */ .Z.color.interactive).map(
    (key) => ColorRow(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color.interactive */ .Z.color.interactive[key])
  )}
        ${Object.keys(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color.ui */ .Z.color.ui).map((key) => ColorRow(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color.ui */ .Z.color.ui[key]))}
        ${ColorRow(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color.disabled */ .Z.color.disabled)} ${ColorRow(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color.overlay */ .Z.color.overlay)}
        ${Object.keys(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color.feedback */ .Z.color.feedback).map((key) => ColorRow(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color.feedback */ .Z.color.feedback[key]))}
      </tbody>
    `
)}
  ${TokenTable(
  "Text color tokens",
  lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
      <thead>
        <tr>
          <th>Token</th>
          <th>Value</th>
          <th>Example</th>
        </tr>
      </thead>
      <tbody>
        ${Object.keys(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color.text */ .Z.color.text).map((key) => ColorRow(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color.text */ .Z.color.text[key]))}
      </tbody>
    `
)}
  ${TokenTable(
  "Interaction color tokens",
  lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
      <thead>
        <tr>
          <th>Token</th>
          <th>Value</th>
          <th>Example</th>
        </tr>
      </thead>
      <tbody>
        ${ColorRow(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color.focus */ .Z.color.focus)}
        ${Object.keys(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color.hover */ .Z.color.hover).map((key) => ColorRow(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color.hover */ .Z.color.hover[key]))}
      </tbody>
    `
)}
`;
const AliasColors = {
  render: () => UiColorTokens()
};
const GlobalColorTokens = () => {
  let colorTokens = [];
  Object.keys(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color */ .Z.color).filter((key) => key !== "brand" && key !== "base").map((key) => {
    const currentToken = _tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color */ .Z.color[key];
    if (currentToken.value) {
      colorTokens.push(currentToken);
    } else {
      Object.keys(currentToken).map((k) => {
        if (currentToken[k].value) {
          colorTokens.push(currentToken[k]);
        }
      });
    }
  });
  return lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
    ${TokenTable(
    "Primary colors",
    lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
        <thead>
          <tr>
            <th>Token</th>
            <th>Value</th>
            <th>Example</th>
          </tr>
        </thead>
        <tbody>
          ${colorTokens.filter((color) => color.group === "primary").map((color) => ColorRow(color))}
        </tbody>
      `
  )}
    ${TokenTable(
    "Secondary colors",
    lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
        <thead>
          <tr>
            <th>Token</th>
            <th>Value</th>
            <th>Example</th>
          </tr>
        </thead>
        <tbody>
          ${colorTokens.filter((color) => color.group === "secondary").map((color) => ColorRow(color))}
          ${ColorRow(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color["Marble gray"].base */ .Z.color["Marble gray"].base)}
        </tbody>
      `
  )}
    ${TokenTable(
    "Grayscale colors",
    lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
        <thead>
          <tr>
            <th>Token</th>
            <th>Value</th>
            <th>Example</th>
          </tr>
        </thead>
        <tbody>
          ${colorTokens.filter((color) => color.palette === "grayscale").map((color) => ColorRow(color))}
        </tbody>
      `
  )}
    ${TokenTable(
    "Tints",
    lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
        <thead>
          <tr>
            <th>Token</th>
            <th>Value</th>
            <th>Example</th>
          </tr>
        </thead>
        <tbody>
          ${colorTokens.filter((color) => color.group === "tint").map((color) => ColorRow(color))}
        </tbody>
      `
  )}
    ${TokenTable(
    "Feedback color",
    lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
        <thead>
          <tr>
            <th>Token</th>
            <th>Value</th>
            <th>Example</th>
          </tr>
        </thead>
        <tbody>
          ${colorTokens.filter((color) => color.palette === "feedback").map((color) => ColorRow(color))}
        </tbody>
      `
  )}
  `;
};
const GlobalColors = {
  render: () => GlobalColorTokens()
};
const FontFamilyTokens = () => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
  ${TokenTable(
  "Font family tokens",
  lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
      <thead>
        <tr>
          <th style="width:50%">Token</th>
          <th style="width:25%">Value</th>
          <th style="width:25%">Example</th>
        </tr>
      </thead>
      <tbody>
        ${Object.keys(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].font.family */ .Z.font.family).map(
    (key) => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
            <tr>
              <td>${toTokenFormat(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].font.family */ .Z.font.family[key].name)}</td>
              <td>${_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].font.family */ .Z.font.family[key].value}</td>
              <td>
                <div
                  style="font-family:${_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].font.family */ .Z.font.family[key].value};font-size:1.5rem;line-height: normal;"
                >
                  ABCDEFGHIJKLMNOPQRSTUVWXYZ
                </div>
                <div
                  style="font-family:${_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].font.family */ .Z.font.family[key].value};font-size:1.5rem;line-height: normal;"
                >
                  abcdefghijklmnopqrstuvwxyz
                </div>
              </td>
            </tr>
          `
  )}
      </tbody>
    `
)}
`;
const FontFamily = {
  render: () => FontFamilyTokens()
};
const FontWeightTokens = () => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
  ${TokenTable(
  "Font weight tokens",
  lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
      <thead>
        <tr>
          <th style="width:50%">Token</th>
          <th style="width:25%">Value</th>
          <th style="width:25%">Example</th>
        </tr>
      </thead>
      <tbody>
        ${Object.keys(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].font.weight */ .Z.font.weight).map(
    (key) => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
              <tr>
                <td>${toTokenFormat(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].font.weight */ .Z.font.weight[key].name)}</td>
                <td>${_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].font.weight */ .Z.font.weight[key].value}</td>
                <td>
                  <div style="font-weight:${_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].font.weight */ .Z.font.weight[key].value};line-height: normal;">
                    ABCDEFGHIJKLMNOPQRSTUVWXYZ
                  </div>
                  <div style="font-weight:${_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].font.weight */ .Z.font.weight[key].value};line-height: normal;">
                    abcdefghijlkmnopqrstuvwxyz
                  </div>
                </td>
              </tr>
            `
  )}
      </tbody>
    `
)}
`;
const FontWeight = {
  render: () => FontWeightTokens()
};
const FontSizeTokens = () => {
  const baseValue = _tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].font.size.base.value */ .Z.font.size.base.value;
  const basePixels = _tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].type.scale */ .Z.type.scale[baseValue].comment;
  const basePx = basePixels.substring(0, basePixels.length - 2);
  return lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
    ${TokenTable(
    "Font size tokens",
    lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
        <thead>
          <tr>
            <th style="width:50%">Token</th>
            <th style="width:25%">Value</th>
            <th style="width:25%">Example</th>
          </tr>
        </thead>
        <tbody>
          ${Object.keys(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].font.size */ .Z.font.size).map((key) => {
      const tokenPixel = _tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].type.scale */ .Z.type.scale[_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].font.size */ .Z.font.size[key].value].comment;
      const tokenPx = tokenPixel.substring(0, tokenPixel.length - 2);
      const tokenRem = tokenPx / basePx;
      return lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
              <tr>
                <td>${toTokenFormat(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].font.size */ .Z.font.size[key].name)}</td>
                <td>${tokenPx}px | ${tokenRem}rem</td>
                <td>
                  <div style="font-size:${tokenPixel};line-height: normal;">
                    ABCDEFGHIJKLMNOPQRSTUVWXYZ
                  </div>
                  <div style="font-size:${tokenPixel};line-height: normal;">
                    abcdefghijklmnopqrstuvwxyz
                  </div>
                </td>
              </tr>
            `;
    })}
        </tbody>
      `
  )}
  `;
};
const FontSize = {
  render: () => FontSizeTokens()
};
const LineHeightToken = () => {
  const fontSizeMap = [12, 14, 16, 24, 32, 54, 16];
  return lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
    ${TokenTable(
    "Line height tokens",
    lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
        <thead>
          <tr>
            <th style="width:30%">Token</th>
            <th style="width:20%">Value</th>
            <th style="width:50%">Example</th>
          </tr>
        </thead>
        <tbody>
          ${Object.keys(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"]["line-height"] */ .Z["line-height"]).filter((key) => key !== "brand" && key !== "base").map((key, i) => {
      const tokenPixel = _tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"]["line-height"] */ .Z["line-height"][key].comment;
      return lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
                <tr>
                  <td>${toTokenFormat(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"]["line-height"] */ .Z["line-height"][key].name)}</td>
                  <td>
                    ${tokenPixel ? tokenPixel + " | " : ""}${_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"]["line-height"] */ .Z["line-height"][key].value}
                  </td>
                  <td>
                    <div
                      class="line-height-example"
                      style="line-height:${_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"]["line-height"] */ .Z["line-height"][key].value};font-size:${fontSizeMap[i]}px;${fontSizeMap[i] >= 24 ? "font-family: var(--pharos-font-family-serif)" : null}"
                    >
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                      incididunt ut labore et dolore magna aliqua.
                    </div>
                  </td>
                </tr>
              `;
    })}
        </tbody>
      `
  )}
  `;
};
const LineHeight = {
  render: () => LineHeightToken()
};
const SpacingTokens = () => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
  ${TokenTable(
  "Spacing tokens",
  lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
      <thead>
        <tr>
          <th style="width:50%">Token</th>
          <th style="width:25%">Value</th>
          <th style="width:25%">Example</th>
        </tr>
      </thead>
      <tbody>
        ${Object.keys(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].spacing */ .Z.spacing).filter((key) => key !== "brand").map(
    (key) => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
              <tr>
                <td>${toTokenFormat(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].spacing */ .Z.spacing[key].name)}</td>
                <td>${_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].spacing */ .Z.spacing[key].comment} | ${_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].spacing */ .Z.spacing[key].value}</td>
                <td>
                  <div class="spacing-example" style="height:${_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].spacing */ .Z.spacing[key].value};" />
                </td>
              </tr>
            `
  )}
      </tbody>
    `
)}
`;
const Spacing = {
  render: () => SpacingTokens()
};
const RadiusTokens = () => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
  ${TokenTable(
  "Border radius tokens",
  lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
      <thead>
        <tr>
          <th style="width:50%">Token</th>
          <th style="width:25%">Value</th>
          <th style="width:25%">Example</th>
        </tr>
      </thead>
      <tbody>
        ${Object.keys(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].radius.base */ .Z.radius.base).map(
    (key) => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
            <tr>
              <td>${toTokenFormat(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].radius.base */ .Z.radius.base[key].name)}</td>
              <td>${_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].radius.base */ .Z.radius.base[key].comment} | ${_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].radius.base */ .Z.radius.base[key].value}</td>
              <td>
                <div
                  class="radius-example"
                  style="border-radius:${_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].radius.base */ .Z.radius.base[key].value};"
                />
              </td>
            </tr>
          `
  )}
      </tbody>
    `
)}
`;
const Radius = {
  render: () => RadiusTokens()
};
const TransitionRow = (transition, widthRem, color) => {
  return lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
    <tr>
      <td>${toTokenFormat(transition.name)}</td>
      <td>${transition.value}</td>
      <td>
        <div
          class="transition-example"
          style="width:${widthRem}rem;transition:${transition.value};background:var(${color})"
          onmouseover='this.style.background="var(--pharos-color-jstor-red)"'
          onmouseout='this.style.background="var(${color})"'
        />
      </td>
    </tr>
  `;
};
const TransitionTokens = () => {
  const exampleRems = [1, 2, 5, 10, 20];
  const exampleColors = [
    "--pharos-color-living-coral-90",
    "--pharos-color-living-coral-80",
    "--pharos-color-glacier-blue-80",
    "--pharos-color-glacier-blue-40",
    "--pharos-color-night-blue-base"
  ];
  return lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
    ${TokenTable(
    "Transition tokens",
    lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
        <thead>
          <tr>
            <th style="width:40%">Token</th>
            <th style="width:30%">Value</th>
            <th style="width:30%">Example (Hover)</th>
          </tr>
        </thead>
        <tbody>
          ${TransitionRow(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].transition.base */ .Z.transition.base, 5, "--pharos-color-living-coral-80")}
          ${Object.keys(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].transition.duration */ .Z.transition.duration).map(
      (key, i) => TransitionRow(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].transition.duration */ .Z.transition.duration[key], exampleRems[i], exampleColors[i])
    )}
        </tbody>
      `
  )}
  `;
};
const Transitions = {
  render: () => TransitionTokens()
};
const TypeTokens = () => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
  ${TokenTable(
  "Type scale tokens",
  lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
      <thead>
        <tr>
          <th style="width:30%">Token</th>
          <th style="width:15%">Value</th>
          <th style="width:20%">Sans-Serif</th>
          <th style="width:35%">Serif</th>
        </tr>
      </thead>
      <tbody>
        ${Object.keys(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].type.scale */ .Z.type.scale).map(
    (key) => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
            <tr>
              <td>${toTokenFormat(_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].type.scale */ .Z.type.scale[key].name)}</td>
              <td>
                ${_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].type.scale */ .Z.type.scale[key].comment} |
                ${_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].type.scale */ .Z.type.scale[key].comment.substring(
      0,
      _tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].type.scale */ .Z.type.scale[key].comment.length - 2
    ) / 16}rem
              </td>
              <td>
                ${_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].type.scale */ .Z.type.scale[key].value < 10 ? lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`<span
                      class="token-type-sans-serif"
                      style="font-size:${_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].type.scale */ .Z.type.scale[key].comment};"
                      >GT America</span
                    >` : lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`<pharos-icon name="dash-small"></pharos-icon>`}
              </td>
              <td>
                ${_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].type.scale */ .Z.type.scale[key].value > 5 ? lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`<span
                      class="token-type-serif"
                      style="font-size:${_tokens_ts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].type.scale */ .Z.type.scale[key].comment};"
                      >Ivar Headline</span
                    >` : lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`<pharos-icon name="dash-small"></pharos-icon>`}
              </td>
            </tr>
          `
  )}
      </tbody>
    `
)}
`;
const TypeScale = {
  render: () => TypeTokens()
};


/***/ }),

/***/ "./packages/pharos/src/styles/typography.wc.stories.jsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BringToAttentionText": () => (/* binding */ BringToAttentionText),
/* harmony export */   "IdiomaticText": () => (/* binding */ IdiomaticText),
/* harmony export */   "InlineList": () => (/* binding */ InlineList),
/* harmony export */   "ListWithoutBullets": () => (/* binding */ ListWithoutBullets),
/* harmony export */   "NestedLists": () => (/* binding */ NestedLists),
/* harmony export */   "OrderedList": () => (/* binding */ OrderedList),
/* harmony export */   "PlainText": () => (/* binding */ PlainText),
/* harmony export */   "SmallText": () => (/* binding */ SmallText),
/* harmony export */   "StressEmphasisText": () => (/* binding */ StressEmphasisText),
/* harmony export */   "StrongText": () => (/* binding */ StrongText),
/* harmony export */   "Tables": () => (/* binding */ Tables),
/* harmony export */   "UnorderedList": () => (/* binding */ UnorderedList),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/lit/index.js");

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  title: "Styles/Typography",
  parameters: { options: { selectedPanel: "addon-controls" } }
});
const theirNames = ["Item 1", "Item 2", "Item 3", "Item 4", "Item 5"];
const list = lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
  ${theirNames.map((name) => {
  return lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy` <li>${name}</li> `;
})}
`;
const PlainText = {
  render: (args) => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy` <span>${args.text}</span> `,
  args: { text: "I am plain text" }
};
const BringToAttentionText = {
  name: "Bring to Attention Text",
  render: (args) => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy` <span> This is an example of how to bring attention to <b>${args.text}</b>. </span>`,
  args: { text: "specific text" }
};
const StrongText = {
  render: (args) => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy` <span> This is an example of <strong>${args.text}</strong>. </span>`,
  args: { text: "strong text" }
};
const SmallText = {
  render: (args) => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`<span>This is an example of <small>${args.text}</small></span>`,
  args: { text: "small text" }
};
const IdiomaticText = {
  render: (args) => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`<span
      ><i>${args.text}</i> is a beacon leading ships safely toward our collective knowledge.</span
    >`,
  args: { text: "Pharos" }
};
const StressEmphasisText = {
  render: (args) => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`<span>This is an example of <em>${args.text}</em>.</span>`,
  args: { text: "emphasized text" }
};
const Tables = {
  render: (args) => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
    <table class="typography-table-example" style="border-collapse: collapse;">
      <thead>
        <tr>
          <th>${args.header}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="typography-table-example">Item 1</td>
        </tr>
        <tr>
          <td class="typography-table-example">Item 2</td>
        </tr>
        <tr>
          <td class="typography-table-example">Item 3</td>
        </tr>
      </tbody>
    </table>
  `,
  args: { header: "Header" }
};
const OrderedList = {
  render: () => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy` <ol>
    ${list}
  </ol>`
};
const UnorderedList = {
  render: () => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy` <ul>
    ${list}
  </ul>`
};
const ListWithoutBullets = {
  name: "List without Bullets",
  render: () => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy` <ul class="list-example__no-bullets">
    ${list}
  </ul>`
};
const NestedLists = {
  render: () => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
    <ul class="list-example__nested">
      <li>
        Item 1
        <ul>
          <li>Item 1.1</li>
        </ul>
      </li>
      <li>
        Item 2
        <ul>
          <li>Item 2.1</li>
        </ul>
      </li>
    </ul>
  `
};
const InlineList = {
  render: () => lit__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy` <ul class="list-example__inline">
    ${list}
  </ul>`
};


/***/ }),

/***/ "./packages/pharos/src/components/base/anchor-element.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": () => (/* binding */ AnchorElement)
/* harmony export */ });
/* harmony import */ var _pharos_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./packages/pharos/src/components/base/pharos-element.ts");
/* harmony import */ var lit_decorators_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/lit/decorators.js");
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};


const TARGETS = ["_blank", "_parent", "_self", "_top"];
class AnchorElement extends _pharos_element__WEBPACK_IMPORTED_MODULE_1__/* .PharosElement */ .Z {
  update(changedProperties) {
    super.update && super.update(changedProperties);
    if (changedProperties.has("target") && this.target && !TARGETS.includes(this.target)) {
      throw new Error(
        `${this.target} is not a valid target. Valid targets are: ${TARGETS.join(", ")}`
      );
    }
  }
}
__decorateClass([
  (0,lit_decorators_js__WEBPACK_IMPORTED_MODULE_0__/* .property */ .Cb)({ type: String, reflect: true })
], AnchorElement.prototype, "download", 2);
__decorateClass([
  (0,lit_decorators_js__WEBPACK_IMPORTED_MODULE_0__/* .property */ .Cb)({ type: String, reflect: true })
], AnchorElement.prototype, "href", 2);
__decorateClass([
  (0,lit_decorators_js__WEBPACK_IMPORTED_MODULE_0__/* .property */ .Cb)({ type: String, reflect: true })
], AnchorElement.prototype, "hreflang", 2);
__decorateClass([
  (0,lit_decorators_js__WEBPACK_IMPORTED_MODULE_0__/* .property */ .Cb)({ type: String, reflect: true })
], AnchorElement.prototype, "ping", 2);
__decorateClass([
  (0,lit_decorators_js__WEBPACK_IMPORTED_MODULE_0__/* .property */ .Cb)({ type: String, reflect: true })
], AnchorElement.prototype, "rel", 2);
__decorateClass([
  (0,lit_decorators_js__WEBPACK_IMPORTED_MODULE_0__/* .property */ .Cb)({ type: String, reflect: true })
], AnchorElement.prototype, "target", 2);


/***/ }),

/***/ "./packages/pharos/src/components/base/form-element.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": () => (/* binding */ FormElement)
});

// EXTERNAL MODULE: ./packages/pharos/src/components/base/pharos-element.ts
var pharos_element = __webpack_require__("./packages/pharos/src/components/base/pharos-element.ts");
// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./node_modules/lit/decorators.js + 6 modules
var decorators = __webpack_require__("./node_modules/lit/decorators.js");
;// CONCATENATED MODULE: ./packages/pharos/src/components/base/form-element.css.ts

const formElementStyles = lit/* css */.iv`
        :host([disabled]){pointer-events:none}:host([required]) .required-indicator{color:var(--pharos-form-element-color-text-required)}:host([required]) .required-indicator__text{clip:rect(0 0 0 0);border:0;-webkit-clip-path:inset(50%);clip-path:inset(50%);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}.input-message{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;display:block;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-font-size-small);font-weight:var(--pharos-font-weight-regular);letter-spacing:calc(var(--pharos-font-size-small)*-.02);line-height:var(--pharos-line-height-small);padding:var(--pharos-spacing-one-half-x) 0;text-rendering:optimizelegibility}.input-message__text{margin-bottom:var(--pharos-spacing-one-half-x)}:host([invalidated]) .input-message__text{color:var(--pharos-form-element-color-text-invalid)}label[for=input-element]{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:var(--pharos-form-element-color-text-base);display:block;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-form-element-size-text-label);font-weight:var(--pharos-font-weight-bold);letter-spacing:calc(var(--pharos-form-element-size-text-label)*-.02);line-height:var(--pharos-line-height-small);margin-bottom:var(--pharos-spacing-one-quarter-x);padding:0;text-rendering:optimizelegibility;text-transform:uppercase}:host([hide-label]) label[for=input-element]{clip:rect(0 0 0 0);border:0;-webkit-clip-path:inset(50%);clip-path:inset(50%);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}label[for=textarea-element]{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:var(--pharos-form-element-color-text-base);display:block;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-form-element-size-text-label);font-weight:var(--pharos-font-weight-bold);letter-spacing:calc(var(--pharos-form-element-size-text-label)*-.02);line-height:var(--pharos-line-height-small);margin-bottom:var(--pharos-spacing-one-quarter-x);padding:0;text-rendering:optimizelegibility;text-transform:uppercase}:host([hide-label]) label[for=textarea-element]{clip:rect(0 0 0 0);border:0;-webkit-clip-path:inset(50%);clip-path:inset(50%);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}label[for=select-element]{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:var(--pharos-form-element-color-text-base);display:block;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-form-element-size-text-label);font-weight:var(--pharos-font-weight-bold);letter-spacing:calc(var(--pharos-form-element-size-text-label)*-.02);line-height:var(--pharos-line-height-small);margin-bottom:var(--pharos-spacing-one-quarter-x);padding:0;text-rendering:optimizelegibility;text-transform:uppercase}:host([hide-label]) label[for=select-element]{clip:rect(0 0 0 0);border:0;-webkit-clip-path:inset(50%);clip-path:inset(50%);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}label[for=radio-element]{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:var(--pharos-form-element-color-text-base);display:block;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-font-size-base);font-weight:var(--pharos-font-weight-regular);letter-spacing:calc(var(--pharos-font-size-base)*-.02);line-height:var(--pharos-line-height-medium);margin-bottom:0;padding:0;padding-left:var(--pharos-spacing-one-quarter-x);text-rendering:optimizelegibility;text-transform:none}:host([hide-label]) label[for=radio-element]{clip:rect(0 0 0 0);border:0;-webkit-clip-path:inset(50%);clip-path:inset(50%);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}:host([on-background]) label[for=radio-element]{color:var(--pharos-color-text-white)}:host(:hover) label[for=radio-element]{cursor:pointer}:host([disabled]) label[for=radio-element]{color:var(--pharos-form-element-color-text-disabled);pointer-events:none}label[for=checkbox-element]{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:var(--pharos-form-element-color-text-base);display:block;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-font-size-base);font-weight:var(--pharos-font-weight-regular);letter-spacing:calc(var(--pharos-font-size-base)*-.02);line-height:var(--pharos-line-height-medium);margin-bottom:0;padding:0;padding-left:var(--pharos-spacing-one-quarter-x);text-rendering:optimizelegibility;text-transform:none}:host([hide-label]) label[for=checkbox-element]{clip:rect(0 0 0 0);border:0;-webkit-clip-path:inset(50%);clip-path:inset(50%);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}:host([on-background]) label[for=checkbox-element]{color:var(--pharos-color-text-white)}:host(:hover) label[for=checkbox-element]{cursor:pointer}:host([disabled]) label[for=checkbox-element]{color:var(--pharos-form-element-color-text-disabled);pointer-events:none}legend#legend{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:var(--pharos-form-element-color-text-base);display:block;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-form-element-size-text-label);font-weight:var(--pharos-font-weight-bold);letter-spacing:calc(var(--pharos-form-element-size-text-label)*-.02);line-height:var(--pharos-line-height-small);margin-bottom:var(--pharos-spacing-one-quarter-x);padding:0;text-rendering:optimizelegibility;text-transform:uppercase}:host([hide-label]) legend#legend{clip:rect(0 0 0 0);border:0;-webkit-clip-path:inset(50%);clip-path:inset(50%);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}
      `;

// EXTERNAL MODULE: ./packages/pharos/src/utils/mixins/focus.ts
var mixins_focus = __webpack_require__("./packages/pharos/src/utils/mixins/focus.ts");
;// CONCATENATED MODULE: ./packages/pharos/src/components/base/form-element.ts
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};





class FormElement extends (0,mixins_focus/* default */.Z)(pharos_element/* PharosElement */.Z) {
  constructor() {
    super(...arguments);
    this.name = "";
    this.required = false;
    this.disabled = false;
    this.invalidated = false;
    this.validated = false;
    this.message = "";
    this.hideLabel = false;
  }
  static get styles() {
    return [formElementStyles];
  }
  updated(changedProperties) {
    if (changedProperties.has("validated") && this.validated) {
      this.removeAttribute("invalidated");
    } else if (changedProperties.has("invalidated") && this.invalidated) {
      this.removeAttribute("validated");
    }
  }
  get requiredIndicator() {
    const content = this.required ? lit/* html */.dy`<span class="required-indicator"
          >*<span class="required-indicator__text">required</span></span
        >` : lit/* nothing */.Ld;
    return content;
  }
  get messageContent() {
    const messageSlot = [...this.children].filter((child) => child.slot === "message");
    const content = this.message || messageSlot.length ? lit/* html */.dy`<div id="message" class="input-message">
            ${this.message ? lit/* html */.dy`<div class="input-message__text">${this.message}</div>` : lit/* nothing */.Ld}
            <slot name="message"></slot>
          </div>` : lit/* nothing */.Ld;
    return content;
  }
  get messageId() {
    const messageSlot = [...this.children].filter((child) => child.slot === "message");
    return this.message || messageSlot.length ? "message" : void 0;
  }
}
__decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], FormElement.prototype, "name", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], FormElement.prototype, "required", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], FormElement.prototype, "disabled", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], FormElement.prototype, "invalidated", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], FormElement.prototype, "validated", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], FormElement.prototype, "message", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true, attribute: "hide-label" })
], FormElement.prototype, "hideLabel", 2);


/***/ }),

/***/ "./packages/pharos/src/components/base/overlay-element.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gm": () => (/* binding */ OverlayElement),
/* harmony export */   "e2": () => (/* binding */ allPlacements)
/* harmony export */ });
/* unused harmony export allStrategies */
/* harmony import */ var _pharos_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./packages/pharos/src/components/base/pharos-element.ts");
/* harmony import */ var lit_decorators_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/lit/decorators.js");
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};



const allStrategies = ["absolute", "fixed"];
const SIDES = ["top", "right", "bottom", "left"];
const allPlacements = SIDES.reduce(
  (acc, side) => acc.concat(side, `${side}-start`, `${side}-end`),
  []
);
class OverlayElement extends _pharos_element__WEBPACK_IMPORTED_MODULE_1__/* .PharosElement */ .Z {
  constructor() {
    super(...arguments);
    this.open = false;
    this.placement = "top";
    this.strategy = "absolute";
  }
  update(changedProperties) {
    var _a, _b, _c;
    super.update && super.update(changedProperties);
    if (changedProperties.has("placement")) {
      if (this.placement !== "auto" && !allPlacements.includes(this.placement)) {
        throw new Error(
          `${this.placement} is not a valid placement. Valid placements are: ${allPlacements.join(
            ", "
          )}`
        );
      }
      if (this.placement === "auto") {
        console.warn(
          "The auto placement will be removed in the next major version of Pharos, as this is now the default behavior."
        );
      }
    }
    if (changedProperties.has("fallbackPlacements")) {
      const invalid = (_a = this.fallbackPlacements) == null ? void 0 : _a.filter(
        (fallback) => fallback !== "auto" && !allPlacements.includes(fallback)
      );
      if ((_b = this.fallbackPlacements) == null ? void 0 : _b.includes("auto")) {
        console.warn(
          "The auto placement will be removed in the next major version of Pharos, as this is now the default behavior."
        );
      }
      this._filteredFallbackPlacements = (_c = this.fallbackPlacements) == null ? void 0 : _c.filter(
        (fallback) => fallback !== "auto"
      );
      if (invalid == null ? void 0 : invalid.length) {
        throw new Error(
          `${invalid.join(", ")} are not valid fallbacks. Valid fallbacks are: ${allPlacements.join(
            ", "
          )}`
        );
      }
    }
    if (changedProperties.has("strategy") && !allStrategies.includes(this.strategy)) {
      throw new Error(
        `${this.strategy} is not a valid positioning strategy. Valid strategies are: ${allStrategies.join(", ")}`
      );
    }
  }
}
__decorateClass([
  (0,lit_decorators_js__WEBPACK_IMPORTED_MODULE_0__/* .property */ .Cb)({ type: Boolean, reflect: true })
], OverlayElement.prototype, "open", 2);
__decorateClass([
  (0,lit_decorators_js__WEBPACK_IMPORTED_MODULE_0__/* .property */ .Cb)({ reflect: true })
], OverlayElement.prototype, "placement", 2);
__decorateClass([
  (0,lit_decorators_js__WEBPACK_IMPORTED_MODULE_0__/* .property */ .Cb)({ attribute: false })
], OverlayElement.prototype, "fallbackPlacements", 2);
__decorateClass([
  (0,lit_decorators_js__WEBPACK_IMPORTED_MODULE_0__/* .property */ .Cb)({ reflect: true })
], OverlayElement.prototype, "strategy", 2);


/***/ }),

/***/ "./packages/pharos/src/components/base/pharos-element.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ PharosElement)
/* harmony export */ });
/* harmony import */ var lit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/lit/index.js");

class PharosElement extends lit__WEBPACK_IMPORTED_MODULE_0__/* .LitElement */ .oi {
  connectedCallback() {
    super.connectedCallback && super.connectedCallback();
    this.dataset.pharosComponent = this.constructor.name;
  }
}


/***/ }),

/***/ "./packages/pharos/src/components/button/pharos-button.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": () => (/* binding */ PharosButton)
});

// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./node_modules/lit/decorators.js + 6 modules
var decorators = __webpack_require__("./node_modules/lit/decorators.js");
// EXTERNAL MODULE: ./node_modules/lit/directives/if-defined.js + 1 modules
var if_defined = __webpack_require__("./node_modules/lit/directives/if-defined.js");
;// CONCATENATED MODULE: ./packages/pharos/src/components/button/pharos-button.css.ts

const buttonStyles = lit/* css */.iv`
        :host{contain:layout;display:inline-flex}:host #button-element:active:not([disabled]),:host #button-element:hover:not([disabled]){background-color:var(--pharos-button-color-base-primary-background-hover);border:2px solid var(--pharos-button-color-base-primary-border-hover);color:var(--pharos-button-color-base-primary-text-hover);padding:calc(var(--pharos-spacing-one-quarter-x) - 1px) calc(var(--pharos-spacing-three-quarters-x) - 1px)}:host #button-element:active:not([disabled]) [data-pharos-component=PharosIcon],:host #button-element:hover:not([disabled]) [data-pharos-component=PharosIcon]{fill:var(--pharos-button-color-base-primary-text-hover);stroke:var(--pharos-button-color-base-primary-text-hover)}:host #button-element:focus{outline:2px solid var(--pharos-color-focus);outline-offset:2px}:host([variant=primary]) #button-element{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--pharos-button-color-base-primary-background-base);border:1px solid var(--pharos-button-color-base-primary-border-base);border-radius:var(--pharos-radius-base-standard);color:var(--pharos-button-color-base-primary-text-base);cursor:pointer;display:flex;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-font-size-base);font-weight:var(--pharos-font-weight-bold);justify-content:center;letter-spacing:calc(var(--pharos-font-size-base)*-.02);line-height:var(--pharos-line-height-medium);margin:0;padding:var(--pharos-spacing-one-quarter-x) var(--pharos-spacing-three-quarters-x);text-rendering:optimizelegibility;transition-duration:var(--pharos-transition-duration-default);transition-property:border-color,background,color;transition-timing-function:ease-in-out}:host([variant=primary]) #button-element [data-pharos-component=PharosIcon]{fill:var(--pharos-button-color-base-primary-text-base);stroke:var(--pharos-button-color-base-primary-text-base);stroke-width:0;transition-duration:var(--pharos-transition-duration-default);transition-property:fill,stroke;transition-timing-function:ease-in-out}:host([variant=primary]) #button-element [data-pharos-component=PharosIcon]:first-child:not(:only-child){margin-right:var(--pharos-spacing-one-quarter-x)}:host([variant=primary]) #button-element [data-pharos-component=PharosIcon]:last-child:not(:only-child){margin-left:var(--pharos-spacing-one-quarter-x)}:host([variant=secondary]) #button-element{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--pharos-button-color-base-secondary-background-base);border:1px solid var(--pharos-button-color-base-secondary-border-base);border-radius:var(--pharos-radius-base-standard);color:var(--pharos-button-color-base-secondary-text-base);cursor:pointer;display:flex;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-font-size-base);font-weight:var(--pharos-font-weight-bold);justify-content:center;letter-spacing:calc(var(--pharos-font-size-base)*-.02);line-height:var(--pharos-line-height-medium);margin:0;padding:var(--pharos-spacing-one-quarter-x) var(--pharos-spacing-three-quarters-x);text-rendering:optimizelegibility;transition-duration:var(--pharos-transition-duration-default);transition-property:border-color,background,color;transition-timing-function:ease-in-out}:host([variant=secondary]) #button-element [data-pharos-component=PharosIcon]{fill:var(--pharos-button-color-base-secondary-text-base);stroke:var(--pharos-button-color-base-secondary-text-base);stroke-width:0;transition-duration:var(--pharos-transition-duration-default);transition-property:fill,stroke;transition-timing-function:ease-in-out}:host([variant=secondary]) #button-element [data-pharos-component=PharosIcon]:first-child:not(:only-child){margin-right:var(--pharos-spacing-one-quarter-x)}:host([variant=secondary]) #button-element [data-pharos-component=PharosIcon]:last-child:not(:only-child){margin-left:var(--pharos-spacing-one-quarter-x)}:host([variant=subtle]) #button-element{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--pharos-button-color-base-subtle-background-base);border:1px solid var(--pharos-button-color-base-subtle-border-base);border-radius:var(--pharos-radius-base-standard);color:var(--pharos-button-color-base-subtle-text-base);cursor:pointer;display:flex;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-font-size-base);font-weight:var(--pharos-font-weight-bold);justify-content:center;letter-spacing:calc(var(--pharos-font-size-base)*-.02);line-height:var(--pharos-line-height-medium);margin:0;padding:var(--pharos-spacing-one-quarter-x) var(--pharos-spacing-three-quarters-x);text-rendering:optimizelegibility;transition-duration:var(--pharos-transition-duration-default);transition-property:border-color,background,color;transition-timing-function:ease-in-out}:host([variant=subtle]) #button-element [data-pharos-component=PharosIcon]{fill:var(--pharos-button-color-base-subtle-text-base);stroke:var(--pharos-button-color-base-subtle-text-base);stroke-width:0;transition-duration:var(--pharos-transition-duration-default);transition-property:fill,stroke;transition-timing-function:ease-in-out}:host([variant=subtle]) #button-element [data-pharos-component=PharosIcon]:first-child:not(:only-child){margin-right:var(--pharos-spacing-one-quarter-x)}:host([variant=subtle]) #button-element [data-pharos-component=PharosIcon]:last-child:not(:only-child){margin-left:var(--pharos-spacing-one-quarter-x)}:host([variant=overlay]) #button-element{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--pharos-button-color-base-overlay-background-base);border:1px solid var(--pharos-button-color-base-overlay-border-base);border-radius:var(--pharos-radius-base-standard);color:var(--pharos-button-color-base-overlay-text-base);cursor:pointer;display:flex;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-font-size-base);font-weight:var(--pharos-font-weight-bold);justify-content:center;letter-spacing:calc(var(--pharos-font-size-base)*-.02);line-height:var(--pharos-line-height-medium);margin:0;opacity:.9;padding:var(--pharos-spacing-one-quarter-x) var(--pharos-spacing-three-quarters-x);text-rendering:optimizelegibility;transition-duration:var(--pharos-transition-duration-default);transition-property:border-color,background,color;transition-timing-function:ease-in-out}:host([variant=overlay]) #button-element [data-pharos-component=PharosIcon]{fill:var(--pharos-button-color-base-overlay-text-base);stroke:var(--pharos-button-color-base-overlay-text-base);stroke-width:0;transition-duration:var(--pharos-transition-duration-default);transition-property:fill,stroke;transition-timing-function:ease-in-out}:host([variant=overlay]) #button-element [data-pharos-component=PharosIcon]:first-child:not(:only-child){margin-right:var(--pharos-spacing-one-quarter-x)}:host([variant=overlay]) #button-element [data-pharos-component=PharosIcon]:last-child:not(:only-child){margin-left:var(--pharos-spacing-one-quarter-x)}:host([href]) #button-element{text-decoration-color:transparent;text-decoration-line:underline;text-decoration-style:solid}:host([large]) #button-element{padding:var(--pharos-spacing-one-half-x) var(--pharos-spacing-three-quarters-x)}:host([large]) #button-element:active:not([disabled]),:host([large]) #button-element:hover:not([disabled]){padding:calc(var(--pharos-spacing-one-half-x) - 1px) calc(var(--pharos-spacing-three-quarters-x) - 1px)}:host([icon]) #button-element{padding:var(--pharos-button-padding-base)}:host([disabled]){pointer-events:none}:host([disabled]) #button-element{background-color:var(--pharos-button-color-base-primary-background-disabled);border-color:var(--pharos-button-color-base-primary-border-disabled);color:var(--pharos-button-color-base-primary-text-disabled)}:host([disabled]) #button-element [data-pharos-component=PharosIcon]{fill:var(--pharos-button-color-base-primary-text-disabled);stroke:var(--pharos-button-color-base-primary-text-disabled)}:host([full-width]){width:100%}:host([full-width]) #button-element{flex:auto;justify-content:start}:host([icon-condensed][icon]) #button-element{border:0;padding:var(--pharos-button-padding-condensed)}:host([icon][large]) #button-element{padding:var(--pharos-button-padding-large)}:host([on-background][variant=secondary]:not([disabled])) #button-element{background-color:var(--pharos-button-color-on-background-secondary-background-base);border-color:var(--pharos-button-color-on-background-secondary-border-base);color:var(--pharos-button-color-on-background-secondary-text-base)}:host([on-background][variant=secondary]:not([disabled])) #button-element [data-pharos-component=PharosIcon]{fill:var(--pharos-button-color-on-background-secondary-text-base);stroke:var(--pharos-button-color-on-background-secondary-text-base)}:host([on-background][variant=subtle]:not([disabled])) #button-element{background-color:var(--pharos-button-color-on-background-subtle-background-base);border-color:var(--pharos-button-color-on-background-subtle-border-base);color:var(--pharos-button-color-on-background-subtle-text-base)}:host([on-background][variant=subtle]:not([disabled])) #button-element [data-pharos-component=PharosIcon]{fill:var(--pharos-button-color-on-background-subtle-text-base);stroke:var(--pharos-button-color-on-background-subtle-text-base)}:host([on-background][disabled]) #button-element{background-color:var(--pharos-button-color-on-background-primary-background-disabled);border-color:var(--pharos-button-color-on-background-primary-border-disabled);color:var(--pharos-button-color-on-background-primary-text-disabled)}:host([on-background][disabled]) #button-element [data-pharos-component=PharosIcon]{fill:var(--pharos-button-color-on-background-primary-text-disabled);stroke:var(--pharos-button-color-on-background-primary-text-disabled)}:host([variant=subtle][disabled]) #button-element{background-color:var(--pharos-button-color-base-subtle-background-disabled);border-color:var(--pharos-button-color-base-subtle-border-disabled);color:var(--pharos-button-color-base-subtle-text-disabled)}:host([variant=subtle][disabled]) #button-element [data-pharos-component=PharosIcon]{fill:var(--pharos-button-color-base-subtle-text-disabled);stroke:var(--pharos-button-color-base-subtle-text-disabled)}:host([icon]:not([disabled])) #button-element:active,:host([icon]:not([disabled])) #button-element:hover{padding:calc(var(--pharos-button-padding-base) - 1px)}:host([variant=subtle]:not([disabled])) #button-element:active,:host([variant=subtle]:not([disabled])) #button-element:hover{background-color:var(--pharos-button-color-base-subtle-background-hover);border-color:var(--pharos-button-color-base-subtle-border-hover);color:var(--pharos-button-color-base-subtle-text-hover)}:host([variant=subtle]:not([disabled])) #button-element:active [data-pharos-component=PharosIcon],:host([variant=subtle]:not([disabled])) #button-element:hover [data-pharos-component=PharosIcon]{fill:var(--pharos-button-color-base-subtle-text-hover);stroke:var(--pharos-button-color-base-subtle-text-hover)}:host([variant=overlay]:not([disabled])) #button-element:active,:host([variant=overlay]:not([disabled])) #button-element:hover{background-color:var(--pharos-button-color-base-overlay-background-hover);border-color:var(--pharos-button-color-base-overlay-border-hover);color:var(--pharos-button-color-base-overlay-text-hover)}:host([variant=overlay]:not([disabled])) #button-element:active [data-pharos-component=PharosIcon],:host([variant=overlay]:not([disabled])) #button-element:hover [data-pharos-component=PharosIcon]{fill:var(--pharos-button-color-base-overlay-text-hover);stroke:var(--pharos-button-color-base-overlay-text-hover)}:host([icon-condensed][icon]:not([disabled])) #button-element:active,:host([icon-condensed][icon]:not([disabled])) #button-element:hover{padding:var(--pharos-button-padding-condensed)}:host([on-background][variant=primary]:not([disabled])) #button-element:active,:host([on-background][variant=primary]:not([disabled])) #button-element:hover,:host([on-background][variant=secondary]:not([disabled])) #button-element:active,:host([on-background][variant=secondary]:not([disabled])) #button-element:hover{background-color:var(--pharos-button-color-on-background-primary-background-hover);border-color:var(--pharos-button-color-on-background-primary-border-hover);color:var(--pharos-button-color-on-background-primary-text-hover)}:host([on-background][variant=primary]:not([disabled])) #button-element:active [data-pharos-component=PharosIcon],:host([on-background][variant=primary]:not([disabled])) #button-element:hover [data-pharos-component=PharosIcon],:host([on-background][variant=secondary]:not([disabled])) #button-element:active [data-pharos-component=PharosIcon],:host([on-background][variant=secondary]:not([disabled])) #button-element:hover [data-pharos-component=PharosIcon]{fill:var(--pharos-button-color-on-background-primary-text-hover);stroke:var(--pharos-button-color-on-background-primary-text-hover)}:host([on-background][variant=subtle]:not([disabled])) #button-element:active,:host([on-background][variant=subtle]:not([disabled])) #button-element:hover{background-color:var(--pharos-button-color-on-background-subtle-background-hover);border-color:var(--pharos-button-color-on-background-subtle-border-hover);color:var(--pharos-button-color-on-background-subtle-text-hover)}:host([on-background][variant=subtle]:not([disabled])) #button-element:active [data-pharos-component=PharosIcon],:host([on-background][variant=subtle]:not([disabled])) #button-element:hover [data-pharos-component=PharosIcon]{fill:var(--pharos-button-color-on-background-subtle-text-hover);stroke:var(--pharos-button-color-on-background-subtle-text-hover)}:host([icon][large]:not([disabled])) #button-element:active,:host([icon][large]:not([disabled])) #button-element:hover{padding:calc(var(--pharos-button-padding-large) - 1px)}
      `;

// EXTERNAL MODULE: ./packages/pharos/src/components/base/anchor-element.ts
var anchor_element = __webpack_require__("./packages/pharos/src/components/base/anchor-element.ts");
// EXTERNAL MODULE: ./packages/pharos/src/utils/mixins/focus.ts
var mixins_focus = __webpack_require__("./packages/pharos/src/utils/mixins/focus.ts");
// EXTERNAL MODULE: ./packages/pharos/src/utils/mixins/scoped-registry.ts
var scoped_registry = __webpack_require__("./packages/pharos/src/utils/mixins/scoped-registry.ts");
// EXTERNAL MODULE: ./packages/pharos/src/components/icon/pharos-icon.ts + 1 modules
var pharos_icon = __webpack_require__("./packages/pharos/src/components/icon/pharos-icon.ts");
;// CONCATENATED MODULE: ./packages/pharos/src/components/button/pharos-button.ts
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};








const TYPES = ["button", "submit", "reset"];
const VARIANTS = ["primary", "secondary", "subtle", "overlay"];
class PharosButton extends (0,scoped_registry/* default */.Z)((0,mixins_focus/* default */.Z)(anchor_element/* AnchorElement */.u)) {
  constructor() {
    super();
    this.autofocus = false;
    this.disabled = false;
    this.variant = "primary";
    this.iconCondensed = false;
    this.onBackground = false;
    this.large = false;
    this.fullWidth = false;
    this.pressed = "undefined";
    this._stopClickLeak = this._stopClickLeak.bind(this);
  }
  static get styles() {
    return [buttonStyles];
  }
  firstUpdated() {
    this._formButton = document.createElement("button");
    this._formButton.addEventListener("click", this._stopClickLeak);
    this.addEventListener("click", this._handleClick);
  }
  update(changedProperties) {
    super.update && super.update(changedProperties);
    if (changedProperties.has("type") && this.type && !TYPES.includes(this.type)) {
      throw new Error(`${this.type} is not a valid type. Valid types are: ${TYPES.join(", ")}`);
    }
    if (changedProperties.has("variant") && this.variant && !VARIANTS.includes(this.variant)) {
      throw new Error(
        `${this.variant} is not a valid variant. Valid variants are: ${VARIANTS.join(", ")}`
      );
    }
  }
  connectedCallback() {
    super.connectedCallback && super.connectedCallback();
    this._form = this.closest("form");
  }
  disconnectedCallback() {
    super.disconnectedCallback && super.disconnectedCallback();
  }
  _handleKeyup(event) {
    switch (event.key) {
      case " ":
      case "Spacebar":
        event.preventDefault();
        this._button.click();
        break;
    }
  }
  _handleClick(event) {
    var _a, _b;
    if ((this.type === "submit" || this.type === "reset") && this._form && !event.defaultPrevented) {
      this._formButton.type = this.type;
      (_a = this._form) == null ? void 0 : _a.appendChild(this._formButton);
      this._formButton.click();
      (_b = this._form) == null ? void 0 : _b.removeChild(this._formButton);
    }
  }
  _stopClickLeak(event) {
    if (event.target === this._formButton) {
      event.stopImmediatePropagation();
    }
  }
  _renderIcon(direction = "") {
    let icon;
    if (direction === "left") {
      icon = this.iconLeft;
    } else if (direction === "right") {
      icon = this.iconRight;
    } else {
      icon = this.icon;
    }
    return icon ? lit/* html */.dy` <pharos-icon name="${icon}"></pharos-icon> ` : lit/* nothing */.Ld;
  }
  get buttonContent() {
    return this.icon ? lit/* html */.dy`${this._renderIcon()}` : lit/* html */.dy`
          ${this._renderIcon("left")}
          <slot></slot>
          ${this._renderIcon("right")}
        `;
  }
  render() {
    return this.href ? lit/* html */.dy`
          <a
            id="button-element"
            role="button"
            download=${(0,if_defined/* ifDefined */.o)(this.download)}
            href=${(0,if_defined/* ifDefined */.o)(this.href)}
            hreflang=${(0,if_defined/* ifDefined */.o)(this.hreflang)}
            ping=${(0,if_defined/* ifDefined */.o)(this.ping)}
            rel=${(0,if_defined/* ifDefined */.o)(this.rel)}
            target=${(0,if_defined/* ifDefined */.o)(this.target)}
            aria-label=${(0,if_defined/* ifDefined */.o)(this.label)}
            aria-pressed=${(0,if_defined/* ifDefined */.o)(this.pressed)}
            @keyup=${this._handleKeyup}
          >
            ${this.buttonContent}
          </a>
        ` : lit/* html */.dy`
          <button
            id="button-element"
            name="${(0,if_defined/* ifDefined */.o)(this.name)}"
            value="${(0,if_defined/* ifDefined */.o)(this.value)}"
            ?autofocus=${this.autofocus}
            ?disabled=${this.disabled}
            type="${(0,if_defined/* ifDefined */.o)(this.type)}"
            aria-label=${(0,if_defined/* ifDefined */.o)(this.label)}
            aria-pressed=${(0,if_defined/* ifDefined */.o)(this.pressed)}
          >
            ${this.buttonContent}
          </button>
        `;
  }
}
PharosButton.elementDefinitions = {
  "pharos-icon": pharos_icon/* PharosIcon */.b
};
__decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], PharosButton.prototype, "autofocus", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], PharosButton.prototype, "disabled", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosButton.prototype, "type", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosButton.prototype, "variant", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosButton.prototype, "icon", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true, attribute: "icon-condensed" })
], PharosButton.prototype, "iconCondensed", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true, attribute: "icon-right" })
], PharosButton.prototype, "iconRight", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true, attribute: "icon-left" })
], PharosButton.prototype, "iconLeft", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true, attribute: "on-background" })
], PharosButton.prototype, "onBackground", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], PharosButton.prototype, "large", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosButton.prototype, "label", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true, attribute: "full-width" })
], PharosButton.prototype, "fullWidth", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosButton.prototype, "name", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosButton.prototype, "value", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosButton.prototype, "pressed", 2);
__decorateClass([
  (0,decorators/* query */.IO)("#button-element")
], PharosButton.prototype, "_button", 2);


/***/ }),

/***/ "./packages/pharos/src/components/heading/pharos-heading.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rW": () => (/* binding */ PharosHeading),
  "Mk": () => (/* binding */ allLevels),
  "KX": () => (/* binding */ allPresets)
});

// EXTERNAL MODULE: ./packages/pharos/src/components/base/pharos-element.ts
var pharos_element = __webpack_require__("./packages/pharos/src/components/base/pharos-element.ts");
// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./node_modules/lit/decorators.js + 6 modules
var decorators = __webpack_require__("./node_modules/lit/decorators.js");
;// CONCATENATED MODULE: ./packages/pharos/src/components/heading/pharos-heading.css.ts

const headingStyles = lit/* css */.iv`
        :host{contain:layout;display:block}.heading{font-family:var(--pharos-font-family-serif);font-weight:var(--pharos-font-weight-regular);margin-bottom:.5em;margin-top:0}:host([preset="1"]) .heading,:host([preset="1--bold"]) .heading{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-font-size-base);font-weight:var(--pharos-font-weight-regular);letter-spacing:calc(var(--pharos-font-size-base)*-.02);line-height:var(--pharos-line-height-small);text-rendering:optimizelegibility}:host([preset="2"]) .heading,:host([preset="2--bold"]) .heading{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-type-scale-5);font-weight:var(--pharos-font-weight-regular);letter-spacing:calc(var(--pharos-type-scale-5)*-.02);line-height:var(--pharos-line-height-medium);text-rendering:optimizelegibility}:host([preset="3"]) .heading,:host([preset="3--bold"]) .heading{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:var(--pharos-font-family-serif);font-size:var(--pharos-type-scale-6);font-weight:var(--pharos-font-weight-regular);letter-spacing:calc(var(--pharos-type-scale-6)*-.01);line-height:var(--pharos-line-height-large);text-rendering:optimizelegibility}:host([preset="4"]) .heading,:host([preset="4--bold"]) .heading{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-type-scale-6);font-weight:var(--pharos-font-weight-regular);letter-spacing:calc(var(--pharos-type-scale-6)*-.02);line-height:var(--pharos-line-height-large);text-rendering:optimizelegibility}:host([preset="5"]) .heading,:host([preset="5--bold"]) .heading{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:var(--pharos-font-family-serif);font-size:var(--pharos-type-scale-8);font-weight:var(--pharos-font-weight-regular);letter-spacing:calc(var(--pharos-type-scale-8)*-.01);line-height:var(--pharos-line-height-xlarge);text-rendering:optimizelegibility}:host([preset="6"]) .heading,:host([preset="6--bold"]) .heading{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-type-scale-8);font-weight:var(--pharos-font-weight-regular);letter-spacing:calc(var(--pharos-type-scale-8)*-.02);line-height:var(--pharos-line-height-xlarge);text-rendering:optimizelegibility}:host([preset="7"]) .heading,:host([preset="7--bold"]) .heading{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:var(--pharos-font-family-serif);font-size:var(--pharos-type-scale-12);font-weight:var(--pharos-font-weight-regular);letter-spacing:calc(var(--pharos-type-scale-12)*-.01);line-height:var(--pharos-line-height-heading-large);text-rendering:optimizelegibility}:host([preset=legend]) .heading{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:var(--pharos-form-element-color-text-base);color:inherit;display:block;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-form-element-size-text-label);font-weight:var(--pharos-font-weight-bold);letter-spacing:calc(var(--pharos-form-element-size-text-label)*-.02);line-height:var(--pharos-line-height-small);margin-bottom:0;padding:0;text-rendering:optimizelegibility;text-transform:uppercase}:host([preset$="--bold"]) .heading{font-weight:var(--pharos-font-weight-bold)}:host([no-margin]) .heading{margin-bottom:0}
      `;

// EXTERNAL MODULE: ./node_modules/lit/directives/unsafe-html.js
var unsafe_html = __webpack_require__("./node_modules/lit/directives/unsafe-html.js");
;// CONCATENATED MODULE: ./packages/pharos/src/components/heading/pharos-heading.ts
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};





const allLevels = [1, 2, 3, 4, 5, 6];
const allPresets = [
  "1",
  "1--bold",
  "2",
  "2--bold",
  "3",
  "3--bold",
  "4",
  "4--bold",
  "5",
  "5--bold",
  "6",
  "6--bold",
  "7",
  "7--bold",
  "legend"
];
class PharosHeading extends pharos_element/* PharosElement */.Z {
  constructor() {
    super(...arguments);
    this.noMargin = false;
  }
  static get styles() {
    return [headingStyles];
  }
  update(changedProperties) {
    super.update && super.update(changedProperties);
    if (!this.level) {
      throw new Error(`level is a required attribute.`);
    }
    if (changedProperties.has("level") && !allLevels.includes(this.level)) {
      throw new Error(
        `${this.level} is not a valid heading level. Valid levels are: ${allLevels.join(", ")}`
      );
    }
    if (changedProperties.has("preset") && !allPresets.includes(this.preset)) {
      throw new Error(
        `${this.preset} is not a valid preset.
        Available presets are ${allPresets.join(", ")}.`
      );
    }
  }
  render() {
    const template = `
      <h${this.level} class="heading">
        <slot></slot>
      </h${this.level}>
    `;
    return lit/* html */.dy`${(0,unsafe_html/* unsafeHTML */.A)(template)}`;
  }
}
__decorateClass([
  (0,decorators/* property */.Cb)({ type: Number, reflect: true })
], PharosHeading.prototype, "level", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosHeading.prototype, "preset", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true, attribute: "no-margin" })
], PharosHeading.prototype, "noMargin", 2);


/***/ }),

/***/ "./packages/pharos/src/components/icon/pharos-icon.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": () => (/* binding */ PharosIcon)
});

// EXTERNAL MODULE: ./packages/pharos/src/components/base/pharos-element.ts
var pharos_element = __webpack_require__("./packages/pharos/src/components/base/pharos-element.ts");
// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./node_modules/lit/decorators.js + 6 modules
var decorators = __webpack_require__("./node_modules/lit/decorators.js");
// EXTERNAL MODULE: ./node_modules/lit/directives/unsafe-svg.js + 1 modules
var unsafe_svg = __webpack_require__("./node_modules/lit/directives/unsafe-svg.js");
;// CONCATENATED MODULE: ./packages/pharos/src/components/icon/pharos-icon.css.ts

const iconStyles = lit/* css */.iv`
        :host{contain:content;display:inline-flex}.icon{display:block}
      `;

;// CONCATENATED MODULE: ./packages/pharos/src/components/icon/pharos-icon.ts
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};





const SMALL_ICON_SIZE = 16;
const LARGE_ICON_SIZE = 24;
class PharosIcon extends pharos_element/* PharosElement */.Z {
  constructor() {
    super(...arguments);
    this.description = "";
    this._svg = "";
  }
  static get styles() {
    return [iconStyles];
  }
  async updated(changedProperties) {
    if (changedProperties.has("name")) {
      try {
        const icon = await Promise.resolve().then(() => __toESM(__webpack_require__("./packages/pharos/src/styles/icons sync recursive ^\\.\\/.*$")(`./${this.name}`)));
        this._svg = atob(icon.default);
      } catch (e) {
        throw new Error(`No icon named "${this.name}"`);
      }
    }
  }
  _getIconSize() {
    var _a;
    return ((_a = this.name) == null ? void 0 : _a.endsWith("-small")) ? SMALL_ICON_SIZE : LARGE_ICON_SIZE;
  }
  render() {
    const size = this._getIconSize();
    return lit/* html */.dy`
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 ${size} ${size}"
        class="icon"
        role="img"
        aria-hidden=${this.description === ""}
        aria-label=${this.description || ""}
        height="${size}"
        width="${size}"
        focusable="false"
      >
        ${(0,unsafe_svg/* unsafeSVG */.c)(this._svg)}
      </svg>
    `;
  }
}
__decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosIcon.prototype, "name", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosIcon.prototype, "description", 2);
__decorateClass([
  (0,decorators/* state */.SB)()
], PharosIcon.prototype, "_svg", 2);


/***/ }),

/***/ "./packages/pharos/src/components/link/pharos-link.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": () => (/* binding */ PharosLink)
});

// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./node_modules/lit/decorators.js + 6 modules
var decorators = __webpack_require__("./node_modules/lit/decorators.js");
// EXTERNAL MODULE: ./node_modules/lit/directives/if-defined.js + 1 modules
var if_defined = __webpack_require__("./node_modules/lit/directives/if-defined.js");
// EXTERNAL MODULE: ./node_modules/lit/directives/class-map.js + 1 modules
var class_map = __webpack_require__("./node_modules/lit/directives/class-map.js");
;// CONCATENATED MODULE: ./packages/pharos/src/components/link/pharos-link.css.ts

const linkStyles = lit/* css */.iv`
        :host{contain:layout}#link-element{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:var(--pharos-color-interactive-secondary);font-family:var(--pharos-font-family-sans-serif);font-size:inherit;font-weight:var(--pharos-font-weight-regular);letter-spacing:inherit;line-height:inherit;text-decoration:underline;text-decoration-color:var(--pharos-color-interactive-secondary);text-rendering:optimizelegibility;transition-duration:.2s;transition-property:color,text-decoration-color;transition-timing-function:ease-in-out}#link-element:hover{color:var(--pharos-color-hover-primary);text-decoration-color:transparent;text-decoration-line:underline;text-decoration-style:solid}#link-element:focus{outline:2px solid var(--pharos-color-focus);outline-offset:2px}#link-element:active{text-decoration:underline;text-decoration-color:var(--pharos-color-hover-primary)}#link-element.link--alert:hover{color:var(--pharos-color-interactive-secondary)}#link-element.link--alert:active{text-decoration:underline;text-decoration-color:var(--pharos-color-interactive-secondary)}:host(:not([href])) #link-element{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:transparent;border:none;color:var(--pharos-color-interactive-secondary);cursor:pointer;font-family:var(--pharos-font-family-sans-serif);font-size:inherit;font-weight:var(--pharos-font-weight-regular);letter-spacing:inherit;line-height:inherit;padding:0;text-align:left;text-decoration:underline;text-decoration-color:var(--pharos-color-interactive-secondary);text-rendering:optimizelegibility;transition-duration:.2s;transition-property:color,text-decoration-color;transition-timing-function:ease-in-out}:host(:not([href])) #link-element:hover{color:var(--pharos-color-hover-primary);text-decoration-color:transparent;text-decoration-line:underline;text-decoration-style:solid}:host(:not([href])) #link-element:focus{outline:2px solid var(--pharos-color-focus);outline-offset:2px}:host([on-background]) #link-element{color:var(--pharos-color-interactive-tertiary);text-decoration:underline;text-decoration-color:var(--pharos-color-interactive-tertiary)}:host([on-background]) #link-element:hover{color:var(--pharos-color-interactive-tertiary);text-decoration-color:transparent;text-decoration-line:underline;text-decoration-style:solid}:host([on-background]) #link-element:active{text-decoration:underline;text-decoration-color:var(--pharos-color-interactive-tertiary)}:host([subtle]) #link-element{text-decoration-color:transparent;text-decoration-line:underline;text-decoration-style:solid}:host([subtle]) #link-element:hover{text-decoration:underline;text-decoration-color:var(--pharos-color-hover-primary)}:host([subtle]) #link-element:active{text-decoration-color:transparent;text-decoration-line:underline;text-decoration-style:solid}:host([subtle]) #link-element.link--hover{color:var(--pharos-color-hover-primary);text-decoration:underline;text-decoration-color:var(--pharos-color-hover-primary)}:host([bold]) #link-element{font-weight:var(--pharos-font-weight-bold)}:host([flex]) #link-element{display:inline-flex;min-width:0}:host([indicate-visited]) #link-element:visited{color:var(--pharos-color-night-blue-base);text-decoration:underline;text-decoration-color:var(--pharos-color-night-blue-base)}:host([indicate-visited]) #link-element:visited:hover{color:var(--pharos-color-hover-primary);text-decoration-color:transparent;text-decoration-color:var(--pharos-color-hover-primary);text-decoration-line:underline;text-decoration-style:solid}:host([subtle]:not([href])) #link-element{text-decoration-color:transparent;text-decoration-line:underline;text-decoration-style:solid}:host([skip]:not(:focus-within)){clip:rect(0 0 0 0);border:0;-webkit-clip-path:inset(50%);clip-path:inset(50%);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}:host([on-background][subtle]) #link-element:hover{text-decoration:underline;text-decoration-color:var(--pharos-color-interactive-tertiary)}:host([on-background][subtle]) #link-element:active{text-decoration-color:transparent;text-decoration-line:underline;text-decoration-style:solid}:host([no-hover]) #link-element:hover{color:var(--pharos-color-interactive-secondary);text-decoration:underline;text-decoration-color:var(--pharos-color-interactive-secondary)}:host([no-hover][subtle]) #link-element:hover{text-decoration-color:transparent;text-decoration-line:underline;text-decoration-style:solid}
      `;

// EXTERNAL MODULE: ./packages/pharos/src/utils/deepSelector.ts
var deepSelector = __webpack_require__("./packages/pharos/src/utils/deepSelector.ts");
// EXTERNAL MODULE: ./packages/pharos/src/components/base/anchor-element.ts
var anchor_element = __webpack_require__("./packages/pharos/src/components/base/anchor-element.ts");
// EXTERNAL MODULE: ./packages/pharos/src/utils/mixins/focus.ts
var mixins_focus = __webpack_require__("./packages/pharos/src/utils/mixins/focus.ts");
;// CONCATENATED MODULE: ./packages/pharos/src/components/link/pharos-link.ts
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};








class PharosLink extends (0,mixins_focus/* default */.Z)(anchor_element/* AnchorElement */.u) {
  constructor() {
    super(...arguments);
    this.subtle = false;
    this.onBackground = false;
    this.bold = false;
    this.flex = false;
    this.skip = false;
    this.noHover = false;
    this.indicateVisited = false;
    this._alert = false;
    this._hover = false;
  }
  static get styles() {
    return [linkStyles];
  }
  async _handleClick() {
    if (this.skip && this.href) {
      const target = (0,deepSelector/* default */.Z)(this.href);
      await new Promise((resolve) => requestAnimationFrame(resolve));
      (target == null ? void 0 : target.focus) && (target == null ? void 0 : target.focus());
    }
  }
  get appendContent() {
    return lit/* nothing */.Ld;
  }
  render() {
    return this.href !== void 0 ? lit/* html */.dy`<a
          id="link-element"
          class="${(0,class_map/* classMap */.$)({
      [`link--alert`]: this._alert,
      [`link--hover`]: this._hover
    })}"
          download=${(0,if_defined/* ifDefined */.o)(this.download)}
          href=${(0,if_defined/* ifDefined */.o)(this.href)}
          hreflang=${(0,if_defined/* ifDefined */.o)(this.hreflang)}
          ping=${(0,if_defined/* ifDefined */.o)(this.ping)}
          rel=${(0,if_defined/* ifDefined */.o)(this.rel)}
          target=${(0,if_defined/* ifDefined */.o)(this.target)}
          type=${(0,if_defined/* ifDefined */.o)(this.type)}
          aria-label=${(0,if_defined/* ifDefined */.o)(this.label)}
          @click=${this._handleClick}
          ><slot></slot>${this.appendContent}</a
        >` : lit/* html */.dy`<button
          id="link-element"
          class="${(0,class_map/* classMap */.$)({
      [`link--alert`]: this._alert,
      [`link--hover`]: this._hover
    })}"
          aria-label=${(0,if_defined/* ifDefined */.o)(this.label)}
        >
          <slot></slot>
          ${this.appendContent}
        </button>`;
  }
}
__decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosLink.prototype, "type", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], PharosLink.prototype, "subtle", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true, attribute: "on-background" })
], PharosLink.prototype, "onBackground", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosLink.prototype, "label", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], PharosLink.prototype, "bold", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], PharosLink.prototype, "flex", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], PharosLink.prototype, "skip", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true, attribute: "no-hover" })
], PharosLink.prototype, "noHover", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], PharosLink.prototype, "indicateVisited", 2);
__decorateClass([
  (0,decorators/* state */.SB)()
], PharosLink.prototype, "_alert", 2);
__decorateClass([
  (0,decorators/* state */.SB)()
], PharosLink.prototype, "_hover", 2);


/***/ }),

/***/ "./packages/pharos/src/components/modal/pharos-modal.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": () => (/* binding */ PharosModal),
  "g": () => (/* binding */ allSizes)
});

// EXTERNAL MODULE: ./packages/pharos/src/components/base/pharos-element.ts
var pharos_element = __webpack_require__("./packages/pharos/src/components/base/pharos-element.ts");
// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./node_modules/lit/decorators.js + 6 modules
var decorators = __webpack_require__("./node_modules/lit/decorators.js");
// EXTERNAL MODULE: ./node_modules/lit/directives/class-map.js + 1 modules
var class_map = __webpack_require__("./node_modules/lit/directives/class-map.js");
// EXTERNAL MODULE: ./node_modules/lit/directives/if-defined.js + 1 modules
var if_defined = __webpack_require__("./node_modules/lit/directives/if-defined.js");
;// CONCATENATED MODULE: ./packages/pharos/src/components/modal/pharos-modal.css.ts

const modalStyles = lit/* css */.iv`
        :host{bottom:0;contain:strict;display:block;left:0;pointer-events:none;position:fixed;right:0;top:0;z-index:9000}.modal__overlay{align-items:center;background-color:transparent;display:flex;height:100vh;justify-content:center;left:0;overflow-y:scroll;position:fixed;top:0;transition:visibility var(--pharos-transition-duration-default) ease-in-out,background-color var(--pharos-transition-duration-default) ease-in-out;visibility:hidden;width:100vw}.modal__dialog{max-height:calc(100vh - var(--pharos-spacing-2-x));max-width:100%;pointer-events:none;visibility:hidden;z-index:9001}.modal__dialog--small{width:28rem}.modal__dialog--medium{width:39rem}.modal__dialog--large{width:48rem}:host([open]){pointer-events:auto}:host([open]) .modal__overlay{background-color:rgba(0,0,0,.5);visibility:visible}:host([open]) .modal__dialog{visibility:visible}@media only screen and (max-width:570px){.modal__overlay{display:block;height:100%;overflow-y:visible;transition-duration:var(--pharos-transition-duration-long)}.modal__dialog{height:100%;max-height:100vh;min-width:100vw;position:relative;top:100%;transition:visibility var(--pharos-transition-duration-long) linear var(--pharos-transition-duration-long),top var(--pharos-transition-duration-long) ease-in-out}:host([open]) .modal__dialog{top:0;transition:visibility 0s linear 0s,top var(--pharos-transition-duration-long) ease-in-out}}.modal__content{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-clip:padding-box;background-color:var(--pharos-modal-color-background-content);border:1px solid var(--pharos-modal-color-border-content);border-radius:var(--pharos-radius-base-standard);display:flex;flex-direction:column;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-font-size-base);font-weight:var(--pharos-font-weight-regular);height:100%;letter-spacing:calc(var(--pharos-font-size-base)*-.02);line-height:var(--pharos-line-height-medium);outline:0;overflow-y:scroll;pointer-events:auto;position:relative;text-rendering:optimizelegibility}.modal__body{flex:1 1 auto;padding:0 var(--pharos-modal-spacing-base);position:relative}.modal__header{align-items:flex-start;justify-content:space-between}.modal__footer,.modal__header{display:flex;padding:var(--pharos-modal-spacing-base)}.modal__footer{align-items:center;flex-wrap:wrap;justify-content:flex-end}.modal__footer--empty{padding:0 0 var(--pharos-modal-spacing-base)}slot[name=footer]::slotted(*){margin-left:var(--pharos-spacing-1-x)}:host([footer-divider]) .modal__footer{border-top:1px solid var(--pharos-modal-color-border-content)}
      `;

// EXTERNAL MODULE: ./packages/pharos/src/utils/focusable.ts
var focusable = __webpack_require__("./packages/pharos/src/utils/focusable.ts");
// EXTERNAL MODULE: ./packages/pharos/src/utils/mixins/scoped-registry.ts
var scoped_registry = __webpack_require__("./packages/pharos/src/utils/mixins/scoped-registry.ts");
// EXTERNAL MODULE: ./packages/pharos/src/components/button/pharos-button.ts + 1 modules
var pharos_button = __webpack_require__("./packages/pharos/src/components/button/pharos-button.ts");
// EXTERNAL MODULE: ./packages/pharos/src/components/heading/pharos-heading.ts + 1 modules
var pharos_heading = __webpack_require__("./packages/pharos/src/components/heading/pharos-heading.ts");
// EXTERNAL MODULE: ./node_modules/@ithaka/focus-trap/index.js + 4 modules
var focus_trap = __webpack_require__("./node_modules/@ithaka/focus-trap/index.js");
;// CONCATENATED MODULE: ./packages/pharos/src/components/modal/pharos-modal.ts
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};











const CLOSE_BUTTONS = `[data-modal-close],[data-pharos-component="PharosButton"]#close-button`;
const FOCUS_ELEMENT = `[data-modal-focus]`;
const allSizes = ["small", "medium", "large"];
class PharosModal extends (0,scoped_registry/* default */.Z)(pharos_element/* PharosElement */.Z) {
  constructor() {
    super();
    this.open = false;
    this.header = "";
    this.footerDivider = false;
    this.size = "medium";
    this._currentTrigger = null;
    this._isFooterEmpty = true;
    this._handleKeydown = this._handleKeydown.bind(this);
    this._handleTriggerClick = this._handleTriggerClick.bind(this);
  }
  static get styles() {
    return [modalStyles];
  }
  firstUpdated() {
    this._addTriggerListeners();
  }
  update(changedProperties) {
    super.update && super.update(changedProperties);
    if (changedProperties.has("size") && !allSizes.includes(this.size)) {
      throw new Error(`${this.size} is not a valid size. Valid sizes are: ${allSizes.join(", ")}`);
    }
  }
  updated(changedProperties) {
    if (changedProperties.has("open")) {
      const body = document.querySelector("body");
      if (this.open) {
        body == null ? void 0 : body.classList.add("pharos-modal__body");
        this._focusContents();
      } else {
        body == null ? void 0 : body.classList.remove("pharos-modal__body");
        this._returnTriggerFocus();
      }
      if (changedProperties.get("open") !== void 0) {
        this._emitVisibilityChange();
      }
    }
  }
  connectedCallback() {
    super.connectedCallback && super.connectedCallback();
    document.addEventListener("keydown", this._handleKeydown);
    this._addTriggerListeners();
  }
  disconnectedCallback() {
    document.removeEventListener("keydown", this._handleKeydown);
    this._triggers.forEach((trigger) => {
      trigger.removeEventListener("click", this._handleTriggerClick);
    });
    super.disconnectedCallback && super.disconnectedCallback();
  }
  _addTriggerListeners() {
    const id = this.getAttribute("id");
    this._triggers = document.querySelectorAll(`[data-modal-id="${id}"]`);
    this._triggers.forEach((trigger) => {
      trigger.addEventListener("click", this._handleTriggerClick);
    });
  }
  _closeModal(trigger) {
    if (this.open) {
      const details = {
        bubbles: true,
        composed: true,
        detail: trigger
      };
      if (this.dispatchEvent(
        new CustomEvent("pharos-modal-close", {
          ...details,
          cancelable: true
        })
      )) {
        this.open = false;
      }
    }
  }
  _openModal(trigger) {
    if (!this.open) {
      const details = {
        bubbles: true,
        composed: true,
        detail: trigger
      };
      if (this.dispatchEvent(new CustomEvent("pharos-modal-open", { ...details, cancelable: true }))) {
        this.open = true;
      }
    }
  }
  _handleKeydown(event) {
    if ((event.key === "Escape" || event.key === "Esc") && this.open) {
      event.stopPropagation();
      this._closeModal(event.target);
    }
  }
  _handleDialogClick(event) {
    if (event.target.matches(CLOSE_BUTTONS)) {
      this._closeModal(event.target);
    }
  }
  _handleTriggerClick(event) {
    event.preventDefault();
    this._openModal(event.target);
  }
  async _focusContents() {
    var _a;
    this._currentTrigger = this.ownerDocument.activeElement;
    const focusElement = this.querySelector(FOCUS_ELEMENT);
    if (focusElement) {
      await 0;
      focusElement.focus();
    } else {
      const tabbable = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector(focusable/* default */.Z);
      if (tabbable) {
        await 0;
        tabbable.focus();
      }
    }
  }
  _returnTriggerFocus() {
    if (this._currentTrigger && typeof this._currentTrigger.focus === "function") {
      this._currentTrigger.focus();
      this._currentTrigger = null;
    }
  }
  _emitVisibilityChange() {
    const details = {
      bubbles: true,
      composed: true
    };
    if (this.open) {
      this.dispatchEvent(new CustomEvent("pharos-modal-opened", details));
    } else {
      this.dispatchEvent(new CustomEvent("pharos-modal-closed", details));
    }
  }
  get descriptionContent() {
    const descriptionSlot = [...this.children].filter((child) => child.slot === "description");
    const content = descriptionSlot.length ? lit/* html */.dy` <div id="description">
          <slot name="description"></slot>
        </div>` : lit/* nothing */.Ld;
    return content;
  }
  get descriptionId() {
    const descriptionSlot = [...this.children].filter((child) => child.slot === "description");
    return descriptionSlot.length ? "description" : void 0;
  }
  _handleFooterSlotchange(e) {
    this._isFooterEmpty = e.target.assignedNodes({ flatten: true }).length === 0;
  }
  render() {
    return lit/* html */.dy`
      <div class="modal__overlay">
        <div
          role="dialog"
          class=${(0,class_map/* classMap */.$)({
      [`modal__dialog`]: true,
      [`modal__dialog--${this.size}`]: this.size
    })}
          aria-modal="true"
          aria-labelledby="modal-header"
          aria-describedby="${(0,if_defined/* ifDefined */.o)(this.descriptionId)}"
          @click=${this._handleDialogClick}
        >
          <focus-trap>
            <div class="modal__content">
              <div class="modal__header">
                <pharos-heading id="modal-header" level="2" preset="5" no-margin
                  >${this.header}</pharos-heading
                >
                <pharos-button
                  id="close-button"
                  type="button"
                  variant="subtle"
                  icon="close"
                  label="Close modal"
                ></pharos-button>
              </div>
              <div class="modal__body">
                ${this.descriptionContent}
                <slot></slot>
              </div>
              <div class="modal__footer${this._isFooterEmpty ? "--empty" : ""}">
                <slot @slotchange=${this._handleFooterSlotchange} name="footer"></slot>
              </div>
            </div>
          </focus-trap>
        </div>
      </div>
    `;
  }
}
PharosModal.elementDefinitions = {
  "pharos-button": pharos_button/* PharosButton */.b,
  "pharos-heading": pharos_heading/* PharosHeading */.rW,
  "focus-trap": focus_trap/* FocusTrap */.iQ
};
__decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], PharosModal.prototype, "open", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosModal.prototype, "header", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true, attribute: "footer-divider" })
], PharosModal.prototype, "footerDivider", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosModal.prototype, "size", 2);
__decorateClass([
  (0,decorators/* state */.SB)()
], PharosModal.prototype, "_isFooterEmpty", 2);


/***/ }),

/***/ "./packages/pharos/src/components/text-input/pharos-text-input.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": () => (/* binding */ PharosTextInput),
  "_": () => (/* binding */ allTypes)
});

// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./node_modules/lit/decorators.js + 6 modules
var decorators = __webpack_require__("./node_modules/lit/decorators.js");
// EXTERNAL MODULE: ./node_modules/lit/directives/if-defined.js + 1 modules
var if_defined = __webpack_require__("./node_modules/lit/directives/if-defined.js");
;// CONCATENATED MODULE: ./packages/pharos/src/components/text-input/pharos-text-input.css.ts

const textInputStyles = lit/* css */.iv`
        ::-webkit-search-cancel-button{display:none}:host{display:block;width:100%}#input-element{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;border:1px solid var(--pharos-form-element-color-border-base);border-radius:var(--pharos-radius-base-standard);box-sizing:border-box;color:var(--pharos-form-element-color-text-base);display:block;font-family:var(--pharos-font-family-sans-serif);font-size:var(--pharos-font-size-base);font-weight:var(--pharos-font-weight-regular);letter-spacing:calc(var(--pharos-font-size-base)*-.02);line-height:var(--pharos-line-height-medium);margin:0;padding:var(--pharos-spacing-one-half-x) var(--pharos-spacing-three-quarters-x);text-rendering:optimizelegibility;transition:transform var(--pharos-transition-base) 0s;width:100%}#input-element:required{box-shadow:none}#input-element::-moz-placeholder{color:var(--pharos-form-element-color-text-placeholder);opacity:1}#input-element::placeholder{color:var(--pharos-form-element-color-text-placeholder);opacity:1}#input-element:focus{border:2px solid var(--pharos-form-element-color-border-focus);outline:none;padding:calc(var(--pharos-spacing-one-half-x) - 1px) calc(var(--pharos-spacing-three-quarters-x) - 1px);transition:transform var(--pharos-transition-base) 0s}:host([disabled]) #input-element{background-color:var(--pharos-form-element-color-background-disabled);border-color:var(--pharos-form-element-color-background-disabled);color:var(--pharos-form-element-color-text-disabled);pointer-events:none}:host([invalidated]) #input-element{border:2px solid var(--pharos-form-element-color-border-invalid);padding:calc(var(--pharos-spacing-one-half-x) - 1px) calc(var(--pharos-spacing-three-quarters-x) - 1px)}.input-wrapper{align-items:center;display:flex;position:relative;width:100%}.input__icon{position:absolute;right:var(--pharos-spacing-three-quarters-x);top:50%;transform:translateY(-50%)}:host([invalidated]) .input__icon{fill:var(--pharos-text-input-color-icon-invalid)}:host([validated]) .input__icon{fill:var(--pharos-text-input-color-icon-valid)}:host([invalidated]) #input-element,:host([validated]) #input-element{padding-right:2.5rem}:host([variant=prominent]) #input-element{padding:var(--pharos-spacing-1-x)}:host([invalidated][variant=prominent]) #input-element{padding:calc(var(--pharos-spacing-1-x) - 1px)}:host([on-background]) #input-element{background-color:var(--pharos-color-marble-gray-20);border-color:var(--pharos-color-marble-gray-20);caret-color:var(--pharos-color-text-white);color:var(--pharos-color-text-white)}:host([on-background]) #input-element::-moz-placeholder{color:var(--pharos-color-marble-gray-base)}:host([on-background]) #input-element::placeholder{color:var(--pharos-color-marble-gray-base)}:host([on-background]) #input-element:focus{border:2px solid var(--pharos-form-element-color-border-focus);outline:none;padding:calc(var(--pharos-spacing-one-half-x) - 1px) calc(var(--pharos-spacing-three-quarters-x) - 1px);transition:transform var(--pharos-transition-base) 0s}:host([variant=prominent]) #input-element:focus{padding:calc(var(--pharos-spacing-1-x) - 1px)}
      `;

// EXTERNAL MODULE: ./packages/pharos/src/components/base/form-element.ts + 1 modules
var form_element = __webpack_require__("./packages/pharos/src/components/base/form-element.ts");
// EXTERNAL MODULE: ./packages/pharos/src/utils/mixins/form.ts
var mixins_form = __webpack_require__("./packages/pharos/src/utils/mixins/form.ts");
// EXTERNAL MODULE: ./packages/pharos/src/utils/mixins/scoped-registry.ts
var scoped_registry = __webpack_require__("./packages/pharos/src/utils/mixins/scoped-registry.ts");
// EXTERNAL MODULE: ./packages/pharos/src/components/icon/pharos-icon.ts + 1 modules
var pharos_icon = __webpack_require__("./packages/pharos/src/components/icon/pharos-icon.ts");
;// CONCATENATED MODULE: ./packages/pharos/src/components/text-input/pharos-text-input.ts
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};








const allTypes = [
  "email",
  "hidden",
  "number",
  "password",
  "search",
  "tel",
  "text",
  "url"
];
const VARIANTS = ["primary", "prominent"];
const SUBMITTABLE = [
  'input[type="submit"]:not([disabled])',
  'button[type="submit"]:not([disabled])',
  '[data-pharos-component="PharosButton"][type="submit"]:not([disabled])'
];
const BLOCKING = [
  '[data-pharos-component="PharosTextInput"]',
  '[data-pharos-component="PharosInputGroup"]',
  'input[type="text"]',
  'input[type="search"]',
  'input[type="url"]',
  'input[type="tel"]',
  'input[type="email"]',
  'input[type="password"]',
  'input[type="date"]',
  'input[type="month"]',
  'input[type="week"]',
  'input[type="time"]',
  'input[type="datetime-local"]',
  'input[type="number"]'
];
class PharosTextInput extends (0,scoped_registry/* default */.Z)((0,mixins_form/* default */.Z)(form_element/* FormElement */.W)) {
  constructor() {
    super(...arguments);
    this.value = "";
    this.type = "text";
    this.variant = "primary";
    this.readonly = false;
    this.placeholder = "";
    this.onBackground = false;
  }
  static get styles() {
    return [super.styles, textInputStyles];
  }
  firstUpdated() {
    this._input.defaultValue = this.value;
  }
  update(changedProperties) {
    super.update && super.update(changedProperties);
    if (changedProperties.has("type") && !allTypes.includes(this.type)) {
      throw new Error(
        `${this.type} is not a valid text input type. Valid types are: ${allTypes.join(", ")}`
      );
    }
    if (changedProperties.has("variant") && this.variant && !VARIANTS.includes(this.variant)) {
      throw new Error(
        `${this.variant} is not a valid variant. Valid variants are: ${VARIANTS.join(", ")}`
      );
    }
  }
  onChange() {
    this.dispatchEvent(
      new Event("change", {
        bubbles: true,
        composed: true
      })
    );
  }
  onInput() {
    this.value = this._input.value;
  }
  _renderIcons() {
    if (this.invalidated) {
      return lit/* html */.dy` <pharos-icon class="input__icon" name="exclamation"></pharos-icon> `;
    } else if (this.validated) {
      return lit/* html */.dy` <pharos-icon class="input__icon" name="checkmark"></pharos-icon> `;
    }
    return lit/* nothing */.Ld;
  }
  _handleKeydown(event) {
    if (event.key === "Enter") {
      const form = this.closest("form");
      const submitElement = form == null ? void 0 : form.querySelector(SUBMITTABLE.join(","));
      if (submitElement) {
        const clickEvent = new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          composed: true
        });
        submitElement.dispatchEvent(clickEvent);
      } else {
        const blockingElements = form == null ? void 0 : form.querySelectorAll(BLOCKING.join(","));
        if (blockingElements && blockingElements.length <= 1) {
          form == null ? void 0 : form.submit();
        }
      }
    }
  }
  _handleFormdata(event) {
    const { formData } = event;
    if (!this.disabled) {
      formData.append(this.name, this.value);
    }
  }
  _handleFormReset() {
    this.value = this._input.defaultValue;
  }
  get prependContent() {
    return lit/* nothing */.Ld;
  }
  get appendContent() {
    return lit/* nothing */.Ld;
  }
  render() {
    return lit/* html */.dy`
      <label for="input-element">
        <slot name="label"></slot>
        ${this.requiredIndicator}
      </label>
      <div class="input-wrapper">
        ${this.prependContent}
        <input
          id="input-element"
          name="${this.name}"
          .type="${this.type}"
          .value=${this.value}
          ?required="${this.required}"
          ?disabled=${this.disabled}
          ?readonly=${this.readonly}
          placeholder="${this.placeholder}"
          autocomplete="${(0,if_defined/* ifDefined */.o)(this.autocomplete)}"
          maxlength=${(0,if_defined/* ifDefined */.o)(this.maxlength)}
          minlength=${(0,if_defined/* ifDefined */.o)(this.minlength)}
          pattern=${(0,if_defined/* ifDefined */.o)(this.pattern)}
          aria-required="${this.required}"
          aria-invalid="${this.invalidated}"
          aria-describedby="${(0,if_defined/* ifDefined */.o)(this.messageId)}"
          @change=${this.onChange}
          @input=${this.onInput}
          @keydown=${this._handleKeydown}
        />
        ${this._renderIcons()} ${this.appendContent}
      </div>
      ${this.messageContent}
    `;
  }
}
PharosTextInput.elementDefinitions = {
  "pharos-icon": pharos_icon/* PharosIcon */.b
};
__decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosTextInput.prototype, "value", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosTextInput.prototype, "type", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosTextInput.prototype, "variant", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true })
], PharosTextInput.prototype, "readonly", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosTextInput.prototype, "autocomplete", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosTextInput.prototype, "placeholder", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: Number, reflect: true })
], PharosTextInput.prototype, "minlength", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: Number, reflect: true })
], PharosTextInput.prototype, "maxlength", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: String, reflect: true })
], PharosTextInput.prototype, "pattern", 2);
__decorateClass([
  (0,decorators/* property */.Cb)({ type: Boolean, reflect: true, attribute: "on-background" })
], PharosTextInput.prototype, "onBackground", 2);
__decorateClass([
  (0,decorators/* query */.IO)("#input-element")
], PharosTextInput.prototype, "_input", 2);
__decorateClass([
  (0,decorators/* query */.IO)(".input__icon")
], PharosTextInput.prototype, "_inputIcon", 2);


/***/ }),

/***/ "./packages/pharos/src/pages/item-detail/mocks.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pu": () => (/* binding */ metadata),
/* harmony export */   "ev": () => (/* binding */ items),
/* harmony export */   "sh": () => (/* binding */ collections),
/* harmony export */   "wc": () => (/* binding */ item)
/* harmony export */ });
const metadata = [
  { label: "Work Type", value: "bultos" },
  { label: "Date", value: "ca. 1830-50" },
  { label: "Material", value: "pigment on carved wood (plant material)" },
  { label: "Measurements", value: "18.6 x 7.3 x 7.3 cm" },
  {
    label: "Description",
    value: "Holy card featuring St. Joseph holding a child and surrounded by seated and kneeling figures. In a circular tin frame with a rectangular window. A crescent shape is attached to the top of the frame, as well as four inverted triangular shapes attached along the frame's perimeter. Frame is further embellished with decorative stamping and red and green painted designs throughout."
  },
  { label: "Collection", value: "Regis University: Santo Collection" },
  { label: "ID Number", value: "RU0228" },
  {
    label: "Source",
    value: "Thomas J. Steele, S.J.: The Regis University Collection of New Mexico and Colorado Santos."
  },
  { label: "Cultural Context", value: "Colonial Spanish American" },
  { label: "Location (Creation)", value: "Mexico" },
  {
    label: "Acquisition Note",
    value: "1994, gift of Carolyn and Margaret Schmidt."
  },
  {
    label: "Rights",
    value: "Image copyright is held by Regis University or the artist. Commercial use or distribution is not permitted without prior permission of the copyright holder."
  },
  {
    label: "License",
    value: "Use of this image is in accordance with the Artstor Terms & Conditions"
  },
  { label: "Filename", value: "RU0228-A.jpg" },
  { label: "SSID", value: "24409476" }
];
const item = {
  title: "Santo Ni\xF1o de Atocha",
  type: "sculpture"
};
const collections = [
  {
    title: "Pratt Institute Buildings",
    items: 546,
    image: "open_collection_1.png"
  },
  {
    title: "Roanoke College Freshwater Fish Collection",
    items: 839,
    image: "open_collection_2.png"
  },
  {
    title: "Folger Shakespeare Library",
    items: 84,
    image: "open_collection_3.png"
  }
];
const items = [
  {
    title: "Eyrie; students sitting at tables",
    metadata: "Central Methodist University Archives",
    image: "collection_1.png"
  },
  {
    title: "Entrance to Central from Howard Payne side covered in ivy",
    metadata: "Central Methodist University Archives",
    image: "collection_2.png"
  },
  {
    title: "Cupples Hall and Brannock Hall; two students sitting...",
    metadata: "Central Methodist University Archives",
    image: "collection_3.png"
  },
  {
    title: "Group Photograph of Navy V-12 Central Cadets in Front of...",
    metadata: "Central Methodist University Archives",
    image: "collection_4.png"
  },
  {
    title: "South Hall",
    metadata: "Pratt Institute Buildings Image Collection",
    image: "collection_5.png"
  },
  {
    title: "The Shen-Wu Gate [plate 109, Photographs of gs...",
    metadata: "Palace Buildings of Peking 1906",
    image: "collection_6.png"
  }
];


/***/ }),

/***/ "./packages/pharos/src/pages/shared/viewports.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": () => (/* binding */ breakpoints),
/* harmony export */   "U": () => (/* binding */ viewports)
/* harmony export */ });
const viewports = {
  small: {
    name: "360 / 22.5",
    styles: {
      width: "360px",
      height: "560px"
    }
  },
  medium: {
    name: "768 / 48",
    styles: {
      width: "768px",
      height: "1024px"
    }
  },
  large: {
    name: "1056 / 66",
    styles: {
      width: "1056px",
      height: "768px"
    }
  },
  xLarge: {
    name: "1360 / 85",
    styles: {
      width: "1360px",
      height: "768px"
    }
  },
  max: {
    name: "1584 / 99",
    styles: {
      width: "1584px",
      height: "990px"
    }
  }
};
const breakpoints = [1584, 1360, 1056, 768, 360];


/***/ }),

/***/ "./packages/pharos/src/pages/shared/wc/footer.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": () => (/* binding */ Footer)
});

// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
;// CONCATENATED MODULE: ./packages/pharos/src/pages/search/initTranslateWidget.ts
const initTranslateWidget = () => {
  const scriptId = "google-translate-script";
  const prevScript = document.head.querySelector(`#${scriptId}`);
  prevScript && document.head.removeChild(prevScript);
  const script = document.createElement("script");
  script.async = true;
  script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
  script.id = scriptId;
  document.head.appendChild(script);
};
/* harmony default export */ const search_initTranslateWidget = (initTranslateWidget);

;// CONCATENATED MODULE: ./packages/pharos/src/pages/shared/wc/footer.ts


const Footer = () => {
  search_initTranslateWidget();
  return lit/* html */.dy`
    <pharos-footer>
      <ul slot="links-group">
        <li>
          <pharos-link id="subject-link" on-background subtle href="/subjects" target="_blank"
            >By Subject</pharos-link
          >
        </li>
        <li>
          <pharos-link
            id="title-link"
            on-background
            subtle
            href="/action/showJournals?browseType=title"
            target="_blank"
            >By Title</pharos-link
          >
        </li>
        <li>
          <pharos-link
            id="collections-link"
            on-background
            subtle
            href="/site/collection-list"
            target="_blank"
            >By Collections</pharos-link
          >
        </li>
        <li>
          <pharos-link id="publisher-link" on-background subtle href="/publishers" target="_blank"
            >By Publisher</pharos-link
          >
        </li>
        <li>
          <pharos-link
            id="adv-search-link"
            on-background
            subtle
            href="/action/showAdvancedSearch"
            target="_blank"
            >Advanced Search</pharos-link
          >
        </li>
        <li>
          <pharos-link id="dfr-link" on-background subtle href="/dfr" target="_blank"
            >Data for Research</pharos-link
          >
        </li>
      </ul>
      <ul slot="links-group">
        <li>
          <pharos-link
            id="access-link"
            on-background
            subtle
            href="https://support.jstor.org/hc/en-us/articles/360000313328-Need-Help-Logging-in-To-JSTOR"
            target="_blank"
            >Get Access</pharos-link
          >
        </li>
        <li>
          <pharos-link
            id="support-link"
            on-background
            subtle
            href="https://support.jstor.org"
            target="_blank"
            >Support</pharos-link
          >
        </li>
        <li>
          <pharos-link
            id="libguides-link"
            on-background
            subtle
            href="https://guides.jstor.org"
            target="_blank"
            >LibGuides</pharos-link
          >
        </li>
        <li>
          <pharos-link
            id="research-link"
            on-background
            subtle
            href="https://guides.jstor.org/researchbasics"
            target="_blank"
            >Research Basics</pharos-link
          >
        </li>
      </ul>
      <ul slot="links-group">
        <li>
          <pharos-link
            id="about-link"
            on-background
            subtle
            href="https://about.jstor.org"
            target="_blank"
            >About JSTOR</pharos-link
          >
        </li>
        <li>
          <pharos-link
            id="mission-link"
            on-background
            subtle
            href="https://about.jstor.org/mission-history/"
            target="_blank"
            >Mission and History</pharos-link
          >
        </li>
        <li>
          <pharos-link
            id="in-jstor-link"
            on-background
            subtle
            href="https://about.jstor.org/whats-in-jstor/"
            target="_blank"
            >What's in JSTOR</pharos-link
          >
        </li>
        <li>
          <pharos-link
            id="get-jstor-link"
            on-background
            subtle
            href="https://about.jstor.org/get-jstor/"
            target="_blank"
            >Get JSTOR</pharos-link
          >
        </li>
        <li>
          <pharos-link
            id="news-link"
            on-background
            subtle
            href="https://about.jstor.org/news/"
            target="_blank"
            >News</pharos-link
          >
        </li>
        <li>
          <pharos-link
            id="webinars-link"
            on-background
            subtle
            href="https://about.jstor.org/webinars/"
            target="_blank"
            >Webinars</pharos-link
          >
        </li>
      </ul>
      <ul slot="links-group">
        <li>
          <pharos-link
            id="labs-link"
            on-background
            subtle
            href="https://labs.jstor.org/"
            target="_blank"
            >JSTOR Labs</pharos-link
          >
        </li>
        <li>
          <pharos-link
            id="daily-link"
            on-background
            subtle
            href="https://daily.jstor.org/"
            target="_blank"
            >JSTOR Daily</pharos-link
          >
        </li>
        <li>
          <pharos-link
            id="careers-link"
            on-background
            subtle
            href="https://www.ithaka.org/careers/"
            target="_blank"
            >Careers</pharos-link
          >
        </li>
        <li>
          <pharos-link id="contact-link" on-background subtle href="/contact-us/" target="_blank"
            >Contact Us</pharos-link
          >
        </li>
      </ul>
      <ul slot="button-links">
        <li>
          <pharos-button
            id="for-librarians-link"
            variant="secondary"
            on-background
            href="https://about.jstor.org/librarians/"
            target="_blank"
            >For Librarians</pharos-button
          >
        </li>
        <li>
          <pharos-button
            id="for-publishers-link"
            variant="secondary"
            on-background
            href="https://about.jstor.org/publishers/"
            target="_blank"
            >For Publishers</pharos-button
          >
        </li>
      </ul>
      <ul slot="social-links">
        <li>
          <pharos-link
            id="twitter-link"
            href="https://twitter.com/JSTOR"
            target="_blank"
            label="twitter - This link opens in a new window"
          >
            <pharos-icon name="twitter"></pharos-icon>
          </pharos-link>
        </li>
        <li>
          <pharos-link
            id="facebook-link"
            href="https://www.facebook.com/JSTOR.org"
            target="_blank"
            label="facebook - This link opens in a new window"
          >
            <pharos-icon name="facebook"></pharos-icon>
          </pharos-link>
        </li>
        <li>
          <pharos-link
            id="instagram-link"
            href="https://www.instagram.com/jstor_org"
            target="_blank"
            label="instagram - This link opens in a new window"
          >
            <pharos-icon name="instagram"></pharos-icon>
          </pharos-link>
        </li>
        <li>
          <pharos-link
            id="youtube-link"
            href="https://www.youtube.com/channel/UCQM-7sUBV6Z-PVas0S4k0lw"
            target="_blank"
            label="youtube - This link opens in a new window"
          >
            <pharos-icon name="youtube"></pharos-icon>
          </pharos-link>
        </li>
        <li>
          <pharos-link
            id="linkedin-link"
            href="https://www.linkedin.com/company/ithaka"
            target="_blank"
            label="linkedin - This link opens in a new window"
          >
            <pharos-icon name="linkedin"></pharos-icon>
          </pharos-link>
        </li>
        <li>
          <pharos-link
            id="tumblr-link"
            href="https://jstor.tumblr.com"
            target="_blank"
            label="tumblr - This link opens in a new window"
          >
            <pharos-icon name="tumblr"></pharos-icon>
          </pharos-link>
        </li>
      </ul>
      <span id="misson-text" slot="mission-statement"
        >JSTOR is part of
        <pharos-link on-background href="https://www.ithaka.org">ITHAKA</pharos-link>, a
        not-for-profit organization helping the academic community use digital technologies to
        preserve the scholarly record and to advance research and teaching in sustainable
        ways.</span
      >
      <span id="copyright-text" slot="copyright-statement"
        >&copy;2000-${new Date().getFullYear()} ITHAKA. All Rights Reserved. JSTOR&reg;, the JSTOR
        logo, JPASS&reg;, Artstor&reg;, Reveal Digital&trade; and ITHAKA&reg; are registered
        trademarks of ITHAKA.</span
      >
      <ul slot="legal-links">
        <li>
          <pharos-link
            id="terms-link"
            on-background
            subtle
            href="https://about.jstor.org/terms"
            target="_blank"
            >Terms & Conditions of Use</pharos-link
          >
        </li>
        <li>
          <pharos-link
            id="privacy-link"
            on-background
            subtle
            href="https://www.ithaka.org/privacypolicy"
            target="_blank"
            >Privacy Policy</pharos-link
          >
        </li>
        <li>
          <pharos-link
            id="cookie-link"
            on-background
            subtle
            href="https://www.ithaka.org/cookies"
            target="_blank"
            >Cookie Policy</pharos-link
          >
        </li>
        <li>
          <pharos-link
            id="accessibility-link"
            on-background
            subtle
            href="https://about.jstor.org/accessibility"
            target="_blank"
            >Accessibility</pharos-link
          >
        </li>
      </ul>
      <div slot="google-widget" id="google_translate_element" aria-hidden="true"></div>
    </pharos-footer>
  `;
};


/***/ }),

/***/ "./packages/pharos/src/pages/shared/wc/header-revised.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": () => (/* binding */ HeaderRevised)
});

// EXTERNAL MODULE: ./node_modules/lit/index.js + 2 modules
var lit = __webpack_require__("./node_modules/lit/index.js");
// EXTERNAL MODULE: ./node_modules/lit/directives/class-map.js + 1 modules
var class_map = __webpack_require__("./node_modules/lit/directives/class-map.js");
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js
var injectStylesIntoStyleTag = __webpack_require__("./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
var injectStylesIntoStyleTag_default = /*#__PURE__*/__webpack_require__.n(injectStylesIntoStyleTag);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleDomAPI.js
var styleDomAPI = __webpack_require__("./node_modules/style-loader/dist/runtime/styleDomAPI.js");
var styleDomAPI_default = /*#__PURE__*/__webpack_require__.n(styleDomAPI);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertBySelector.js
var insertBySelector = __webpack_require__("./node_modules/style-loader/dist/runtime/insertBySelector.js");
var insertBySelector_default = /*#__PURE__*/__webpack_require__.n(insertBySelector);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js
var setAttributesWithoutAttributes = __webpack_require__("./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js");
var setAttributesWithoutAttributes_default = /*#__PURE__*/__webpack_require__.n(setAttributesWithoutAttributes);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertStyleElement.js
var insertStyleElement = __webpack_require__("./node_modules/style-loader/dist/runtime/insertStyleElement.js");
var insertStyleElement_default = /*#__PURE__*/__webpack_require__.n(insertStyleElement);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleTagTransform.js
var styleTagTransform = __webpack_require__("./node_modules/style-loader/dist/runtime/styleTagTransform.js");
var styleTagTransform_default = /*#__PURE__*/__webpack_require__.n(styleTagTransform);
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[12].use[1]!./node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[12].use[2]!./packages/pharos/src/pages/shared/styles/header-revised.scss
var header_revised = __webpack_require__("./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[12].use[1]!./node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[12].use[2]!./packages/pharos/src/pages/shared/styles/header-revised.scss");
;// CONCATENATED MODULE: ./packages/pharos/src/pages/shared/styles/header-revised.scss

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (styleTagTransform_default());
options.setAttributes = (setAttributesWithoutAttributes_default());

      options.insert = insertBySelector_default().bind(null, "head");
    
options.domAPI = (styleDomAPI_default());
options.insertStyleElement = (insertStyleElement_default());

var update = injectStylesIntoStyleTag_default()(header_revised/* default */.Z, options);




       /* harmony default export */ const styles_header_revised = (header_revised/* default */.Z && header_revised/* default.locals */.Z.locals ? header_revised/* default.locals */.Z.locals : undefined);

;// CONCATENATED MODULE: ./packages/pharos/src/pages/shared/wc/header-revised.ts



const HeaderRevised = (showSearch = false) => lit/* html */.dy`
  <div
    class="${(0,class_map/* classMap */.$)({
  [`header-revised__container`]: true,
  [`header-revised__container--with-search`]: showSearch
})}"
  >
    <div class="header-revised__container--content">
      <pharos-link href="/" id="jstor-logo" class="header-revised__logo" flex>
        <img
          src="./images/jstor-logo.svg"
          alt="JSTOR Home"
          width="82"
          height="115"
          class="header-revised__image--logo"
        />
        <img
          src="./images/jstor-logo.svg"
          alt="JSTOR Home"
          width="64"
          height="89"
          class="header-revised__image--logo-medium"
        />
        <img
          src="./images/jstor-logo.svg"
          alt="JSTOR Home"
          width="43"
          height="60"
          class="header-revised__image--logo-small"
        />
      </pharos-link>
      <div class="header-revised__nav">
        <pharos-input-group
          name="my-input-group"
          hide-label
          class="${(0,class_map/* classMap */.$)({
  [`header-revised__input-group`]: true,
  [`header-revised__input-group--show`]: showSearch
})}"
        >
          <span slot="label">Search</span>
          <pharos-button
            name="search-button"
            icon="search"
            variant="subtle"
            label="search"
          ></pharos-button>
        </pharos-input-group>
        <pharos-dropdown-menu-nav label="main navigation">
          <pharos-dropdown-menu-nav-link
            href="/action/showAdvancedSearch"
            id="adv-search-menu-link"
            data-dropdown-menu-id="search-menu"
            data-dropdown-menu-hover
            >Search</pharos-dropdown-menu-nav-link
          >
          <pharos-dropdown-menu id="search-menu">
            <pharos-dropdown-menu-item link="/action/showAdvancedSearch"
              >Advanced Search</pharos-dropdown-menu-item
            >
            <pharos-dropdown-menu-item link="/action/doImageSearch"
              >Image Search</pharos-dropdown-menu-item
            >
          </pharos-dropdown-menu>
          <pharos-dropdown-menu-nav-link
            href="/subjects"
            id="browse-link"
            data-dropdown-menu-id="browse-menu"
            data-dropdown-menu-hover
            >Browse</pharos-dropdown-menu-nav-link
          >
          <pharos-dropdown-menu id="browse-menu">
            <pharos-dropdown-menu-item link="/subjects">by Subject</pharos-dropdown-menu-item>
            <pharos-dropdown-menu-item link="/action/showJournals?browseType=title"
              >by Title</pharos-dropdown-menu-item
            >
            <pharos-dropdown-menu-item link="/site/collection-list"
              >by Collections</pharos-dropdown-menu-item
            >
            <pharos-dropdown-menu-item link="/publishers">by Publisher</pharos-dropdown-menu-item>
          </pharos-dropdown-menu>
          <pharos-dropdown-menu-nav-link
            href="/account/workspace"
            id="tools-link"
            data-dropdown-menu-id="tools-menu"
            data-dropdown-menu-hover
            class="hide-for-small"
            >Tools</pharos-dropdown-menu-nav-link
          >
          <pharos-dropdown-menu id="tools-menu">
            <pharos-dropdown-menu-item link="/account/workspace"
              >Workspace</pharos-dropdown-menu-item
            >
            <pharos-dropdown-menu-item link="/analyze">Text Analyzer</pharos-dropdown-menu-item>
            <pharos-dropdown-menu-item link="/understand"
              >The JSTOR Understanding Series</pharos-dropdown-menu-item
            >
            <pharos-dropdown-menu-item link="/dfr">Data for Research</pharos-dropdown-menu-item>
          </pharos-dropdown-menu>
        </pharos-dropdown-menu-nav>
      </div>
      <div class="header-revised__container--account">
        <pharos-button
          variant="subtle"
          icon-left="checkmark-inverse"
          icon-right="chevron-down"
          class="header-revised__button--pds"
          >Access provided by JSTOR</pharos-button
        >
        <div class="header-revised__grid--account">
          <div class="header-revised__grid--account-links">
            <pharos-link href="//about.jstor.org" target="_blank" bold>About</pharos-link>
            <pharos-link href="//support.jstor.org" target="_blank" bold>Support</pharos-link>
          </div>
          <div class="header-revised__grid--account-buttons">
            <pharos-button variant="secondary" href="//support.jstor.org" target="_blank"
              >Register</pharos-button
            >
            <pharos-button href="//support.jstor.org" target="_blank">Log in</pharos-button>
          </div>
        </div>
        <svg
          width="20"
          height="16"
          viewBox="0 0 20 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="header-revised__icon"
        >
          <path d="M0 1H20" stroke="black" stroke-width="2" />
          <path d="M0 15H20" stroke="black" stroke-width="2" />
          <path d="M0 8H20" stroke="black" stroke-width="2" />
        </svg>
      </div>
    </div>
  </div>
`;


/***/ }),

/***/ "./packages/pharos/src/styles/icons/academic-content.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTcuOTQ5OTUgMTUuOTQ5N0gxMS45NVYxMy45NDk3SDcuOTQ5OTVWMTUuOTQ5N1oiLz4KPHBhdGggZD0iTTE1Ljk1IDkuOTQ5NzFINy45NDk5NVY3Ljk0OTcxSDE1Ljk1VjkuOTQ5NzFaIi8+CjxwYXRoIGQ9Ik03Ljk0OTk1IDEyLjk0OTdIMTUuOTVWMTAuOTQ5N0g3Ljk0OTk1VjEyLjk0OTdaIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTkuOTUgMy45NDk3MUgzLjk0OTk1VjE5Ljk0OTdIMTkuOTVWMy45NDk3MVpNNS45NDk5NSAxNy45NDk3VjUuOTQ5NzFIMTcuOTVWMTcuOTQ5N0g1Ljk0OTk1WiIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/add.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTExLjA3MDcgMTIuOTI5M1YyMEgxMy4wNzA3VjEyLjkyOTNIMjBWMTAuOTI5M0gxMy4wNzA3VjRIMTEuMDcwN1YxMC45MjkzSDRWMTIuOTI5M0gxMS4wNzA3WiIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/arrow-down.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTEyLjQxNDIgMTkuNzA3MkwxOS44Mjg0IDEyLjI5M0wxOC40MTQyIDEwLjg3ODhMMTMuNDE0NCAxNS44Nzg2VjQuMjkzMDlMMTEuNDE0NCA0LjI5MzA5TDExLjQxNDQgMTUuODc4OUw2LjQxNDIxIDEwLjg3ODhMNSAxMi4yOTNMMTIuNDE0MiAxOS43MDcyWiIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/arrow-left.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTguNDE0MjcgMTFMMTMuNDE0MSA2LjAwMDE1TDExLjk5OTkgNC41ODU5NEw0LjU4NTY5IDEyLjAwMDJMMTEuOTk5OSAxOS40MTQ0TDEzLjQxNDEgMTguMDAwMUw4LjQxMzk3IDEzSDIwVjExSDguNDE0MjdaIi8+Cg==");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/arrow-right.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTE5LjQxNDEgMTIuMDAwMkwxMS45OTk5IDQuNTg1OTRMMTAuNTg1NyA2LjAwMDE1TDE1LjU4NTUgMTFINFYxM0gxNS41ODU4TDEwLjU4NTcgMTguMDAwMkwxMS45OTk5IDE5LjQxNDRMMTkuNDE0MSAxMi4wMDAyWiIvPg==");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/arrow-up.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTEzLjI5MyA4LjEyMTU1TDE4LjI5MjkgMTMuMTIxNEwxOS43MDcxIDExLjcwNzJMMTIuMjkyOSA0LjI5Mjk3TDQuODc4NjYgMTEuNzA3Mkw2LjI5Mjg4IDEzLjEyMTRMMTEuMjkzIDguMTIxMjRMMTEuMjkzIDE5LjcwNzNIMTMuMjkzVjguMTIxNTVaIi8+Cg==");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/attachment.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNy42NTY4IDYuMzQzMkMxNi4wOTQ3IDQuNzgxMTEgMTMuNTYyIDQuNzgxMTEgMTEuOTk5OSA2LjM0MzJMNS4xNjQ1NiAxMy4xNzg2QzQuMjUzMzMgMTQuMDg5OCA0LjI1MzMzIDE1LjU2NzIgNS4xNjQ1NiAxNi40Nzg0QzYuMDc1NzggMTcuMzg5NiA3LjU1MzE2IDE3LjM4OTYgOC40NjQzOSAxNi40Nzg0TDE1LjAzNjMgOS45MDY0NUMxNS4yOTY3IDkuNjQ2MTEgMTUuMjk2NyA5LjIyNDAxIDE1LjAzNjMgOC45NjM2N0MxNC43NzYgOC43MDMzMyAxNC4zNTM5IDguNzAzMzMgMTQuMDkzNSA4Ljk2MzY3TDcuMTQ2MDEgMTUuOTExMkw1LjczMTc5IDE0LjQ5N0wxMi42NzkzIDcuNTQ5NDZDMTMuNzIwNyA2LjUwODA3IDE1LjQwOTIgNi41MDgwNiAxNi40NTA1IDcuNTQ5NDZDMTcuNDkxOSA4LjU5MDg1IDE3LjQ5MTkgMTAuMjc5MyAxNi40NTA1IDExLjMyMDdMOS44Nzg2IDE3Ljg5MjZDOC4xODYzMyAxOS41ODQ5IDUuNDQyNjIgMTkuNTg0OSAzLjc1MDM0IDE3Ljg5MjZDMi4wNTgwNyAxNi4yMDAzIDIuMDU4MDcgMTMuNDU2NiAzLjc1MDM0IDExLjc2NDRMMTAuNTg1NyA0LjkyODk5QzEyLjkyODkgMi41ODU4NCAxNi43Mjc4IDIuNTg1ODQgMTkuMDcxIDQuOTI4OTlDMjEuNDE0MSA3LjI3MjEzIDIxLjQxNDEgMTEuMDcxMSAxOS4wNzEgMTMuNDE0M0wxMi4wMjg3IDIwLjQ1NjZMMTAuNjE0NSAxOS4wNDIzTDE3LjY1NjggMTIuMDAwMUMxOS4yMTg5IDEwLjQzOCAxOS4yMTg5IDcuOTA1MyAxNy42NTY4IDYuMzQzMloiLz4K");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/base.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iOSIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/book.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjcxNDI5IDNDNi4yMTUyMyAzIDUgNC4yMTUyMyA1IDUuNzE0MjlDNSA1LjcxNDQgNSA1LjcxNDUgNSA1LjcxNDYxVjE4LjAwMDNDNSAxOS42NTcyIDYuMzQzMTUgMjEuMDAwNCA4IDIxLjAwMDRIMTlWOC40Mjg1OFY3LjQyODlWNi40Mjg1OEgxNy4wNTk1VjNINy43MTQyOVpNMTcgOC40Mjg1OEg3LjcxNDI5QzcuNDY3MDggOC40Mjg1OCA3LjIyNzU5IDguMzk1NTQgNyA4LjMzMzYyVjE4LjAwMDNDNyAxOC41NTI2IDcuNDQ3NzIgMTkuMDAwNCA4IDE5LjAwMDRIMTdWOC40Mjg1OFpNNyA1LjcxNDYxQzcuMDAwMTcgNi4xMDg5NSA3LjMxOTkgNi40Mjg1OCA3LjcxNDI5IDYuNDI4NThIMTUuMDU5NVY1LjAwMDAxSDcuNzE0MjlDNy4zMTk4IDUuMDAwMDEgNyA1LjMxOTggNyA1LjcxNDI5QzcgNS43MTQ0IDcgNS43MTQ1IDcgNS43MTQ2MVoiLz4K");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/calendar.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNCA0Ljk5OTk5TDEwIDQuOTk5OTlWM0g4VjQuOTk5OTlMNCA0Ljk5OTk5VjIwSDIwTDIwIDQuOTk5OTlMMTYgNC45OTk5OVYzSDE0VjQuOTk5OTlaTTggOC41VjYuOTk5OTlMNiA2Ljk5OTk5TDYgMTBIMThMMTggNi45OTk5OUwxNiA2Ljk5OTk5VjguNUgxNFY2Ljk5OTk5TDEwIDYuOTk5OTlWOC41SDhaTTYgMTJMNiAxOEwxOCAxOEwxOCAxMkg2WiIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/checkmark-filled-circle.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiAyMUMxNi45NzA2IDIxIDIxIDE2Ljk3MDYgMjEgMTJDMjEgNy4wMjk0NCAxNi45NzA2IDMgMTIgM0M3LjAyOTQ0IDMgMyA3LjAyOTQ0IDMgMTJDMyAxNi45NzA2IDcuMDI5NDQgMjEgMTIgMjFaTTE1LjI5MjkgOC4yOTI5MUwxMC44MTkzIDEyLjc2NjZMOC43MDcxMiAxMC42NTQ0TDcuMjkyOTEgMTIuMDY4NkwxMC44MTkzIDE1LjU5NUwxNi43MDcxIDkuNzA3MTJMMTUuMjkyOSA4LjI5MjkxWiIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/checkmark-inverse.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTE0LjI4MjcgOS4zNTMyN0wxMS4wODQ3IDEyLjY0NTVMOS42ODcxNSAxMS4zMjM2TDguMzEyODEgMTIuNzc2NUwxMS4xNDQxIDE1LjQ1NDZMMTUuNzE3MyAxMC43NDY4TDE0LjI4MjcgOS4zNTMyN1oiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiAzQzcuMDI5NDQgMyAzIDcuMDI5NDQgMyAxMkMzIDE2Ljk3MDYgNy4wMjk0NCAyMSAxMiAyMUMxNi45NzA2IDIxIDIxIDE2Ljk3MDYgMjEgMTJDMjEgNy4wMjk0NCAxNi45NzA2IDMgMTIgM1pNNSAxMkM1IDguMTM0MDEgOC4xMzQwMSA1IDEyIDVDMTUuODY2IDUgMTkgOC4xMzQwMSAxOSAxMkMxOSAxNS44NjYgMTUuODY2IDE5IDEyIDE5QzguMTM0MDEgMTkgNSAxNS44NjYgNSAxMloiLz4K");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/checkmark-small.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTEyIDVMNi44MTkyNSAxMEw0IDcuMjc5MTEiIHN0cm9rZS13aWR0aD0iMiIgZmlsbD0ibm9uZSIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/checkmark.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOS40MTQxIDguMDAwMDNMOS43NDk5MSAxNy42NjQyTDQuNTg1NjkgMTIuNUw1Ljk5OTkxIDExLjA4NThMOS43NDk5MSAxNC44MzU4TDE3Ljk5OTkgNi41ODU4MkwxOS40MTQxIDguMDAwMDNaIi8+Cg==");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/chevron-down.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiAxNC41ODU4TDcuNzA3MDYgMTAuMjkyOUw2LjI5Mjg1IDExLjcwNzFMMTIgMTcuNDE0MkwxNy43MDcxIDExLjcwNzFMMTYuMjkyOCAxMC4yOTI5TDEyIDE0LjU4NThaIi8+Cg==");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/chevron-left-large.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjQxNDIgMTJMMTYuNzA3MSAyMC4yOTI5TDE1LjI5MjkgMjEuNzA3MUw1LjU4NTc3IDEyTDE1LjI5MjkgMi4yOTI4OEwxNi43MDcxIDMuNzA3MDlMOC40MTQyIDEyWiIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/chevron-left.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS40MTQyIDcuOTk5OTdMMTEuNDE0MiAxMkwxNS40MTQyIDE2TDE0IDE3LjQxNDJMOC41ODU4MiAxMkwxNCA2LjU4NTc1TDE1LjQxNDIgNy45OTk5N1oiLz4K");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/chevron-right-large.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS41ODU4IDEyTDcuMjkyOTEgMy43MDcxMkw4LjcwNzEyIDIuMjkyOTFMMTguNDE0MiAxMkw4LjcwNzEyIDIxLjcwNzFMNy4yOTI5MSAyMC4yOTI5TDE1LjU4NTggMTJaIi8+Cg==");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/chevron-right.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjU4NTgyIDcuOTk5OTdMMTIuNTg1OCAxMkw4LjU4NTgyIDE2TDEwIDE3LjQxNDJMMTUuNDE0MiAxMkwxMCA2LjU4NTc1TDguNTg1ODIgNy45OTk5N1oiLz4K");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/chevron-up.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS45NSA4LjUzNTc3TDE3LjM2NDIgMTMuOTVMMTUuOTUgMTUuMzY0MkwxMS45NSAxMS4zNjQyTDcuOTQ5OTggMTUuMzY0Mkw2LjUzNTc3IDEzLjk1TDExLjk1IDguNTM1NzdaIi8+Cg==");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/circle.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiAxOUMxNS44NjYgMTkgMTkgMTUuODY2IDE5IDEyQzE5IDguMTM0MDEgMTUuODY2IDUgMTIgNUM4LjEzNDAxIDUgNSA4LjEzNDAxIDUgMTJDNSAxNS44NjYgOC4xMzQwMSAxOSAxMiAxOVpNMTIgMjFDMTYuOTcwNiAyMSAyMSAxNi45NzA2IDIxIDEyQzIxIDcuMDI5NDQgMTYuOTcwNiAzIDEyIDNDNy4wMjk0NCAzIDMgNy4wMjk0NCAzIDEyQzMgMTYuOTcwNiA3LjAyOTQ0IDIxIDEyIDIxWiIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/cite.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDVIMjBWMThIMTUuNDY4NEwxMi45Njg0IDIxSDExLjAzMTZMOC41MzE2MiAxOEg0VjVaTTYgN1YxNkg5LjQ2ODM3TDExLjk2ODQgMTlIMTIuMDMxNkwxNC41MzE2IDE2SDE4VjdINlpNMTYgMTFIOFY5SDE2VjExWk0xMyAxNEg4VjEySDEzVjE0WiIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/close-inverse.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTExLjk5OTggMTMuNDE0M0w5Ljk5OTgyIDE1LjQxNDNMOC41ODU2IDE0LjAwMDFMMTAuNTg1NiAxMi4wMDAxTDguNTg1NiAxMC4wMDAxTDkuOTk5ODIgOC41ODU4NUwxMS45OTk4IDEwLjU4NThMMTMuOTk5OCA4LjU4NTg1TDE1LjQxNCAxMC4wMDAxTDEzLjQxNCAxMi4wMDAxTDE1LjQxNCAxNC4wMDAxTDEzLjk5OTggMTUuNDE0M0wxMS45OTk4IDEzLjQxNDNaIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMyAxMkMzIDcuMDI5NDQgNy4wMjk0NCAzIDEyIDNDMTYuOTcwNiAzIDIxIDcuMDI5NDQgMjEgMTJDMjEgMTYuOTcwNiAxNi45NzA2IDIxIDEyIDIxQzcuMDI5NDQgMjEgMyAxNi45NzA2IDMgMTJaTTEyIDVDOC4xMzQwMSA1IDUgOC4xMzQwMSA1IDEyQzUgMTUuODY2IDguMTM0MDEgMTkgMTIgMTlDMTUuODY2IDE5IDE5IDE1Ljg2NiAxOSAxMkMxOSA4LjEzNDAxIDE1Ljg2NiA1IDEyIDVaIi8+Cg==");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/close.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTEzLjQxNDQgMTIuMDAwMkwxOS40MTQ0IDYuMDAwMTVMMTguMDAwMiA0LjU4NTk0TDEyLjAwMDIgMTAuNTg1OUw2LjAwMDE1IDQuNTg1OTRMNC41ODU5NCA2LjAwMDE1TDEwLjU4NTkgMTIuMDAwMkw0LjU4NTk0IDE4LjAwMDJMNi4wMDAxNSAxOS40MTQ0TDEyLjAwMDIgMTMuNDE0NEwxOC4wMDAyIDE5LjQxNDRMMTkuNDE0NCAxOC4wMDAyTDEzLjQxNDQgMTIuMDAwMloiLz4K");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/collapse.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDIwVjRINlYyMEg0Wk0xNCA2LjU4NTc5TDE5LjQxNDIgMTJMMTQgMTcuNDE0MkwxMi41ODU4IDE2TDE1LjU4NTggMTNIOFYxMUgxNS41ODU4TDEyLjU4NTggOEwxNCA2LjU4NTc5WiIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/copy.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMCA0LjAwMDAzSDlMOSA5LjAwMDAzTDQgOS4wMDAwM1YyMEgxNVYxNUwyMCAxNVY0LjAwMDAzWk0xNSAxM0wxOCAxM1Y2LjAwMDAzTDExIDYuMDAwMDNWOS4wMDAwM0wxNSA5LjAwMDAzVjEzWk02IDE4TDYgMTFMMTMgMTFMMTMgMThMNiAxOFoiLz4K");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/dash-small.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTUgOEgxMSIgc3Ryb2tlLXdpZHRoPSIyIi8+Cg==");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/delete.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTEwIDZIMTRWNEgxMFY2WiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIwIDguMDAwODVWMTAuMDAwOUgxOFYyMC4wMDA5SDZWMTAuMDAwOUg0VjguMDAwODVIMjBaTTggMTAuMDAwOVYxOC4wMDA5SDExVjEwLjAwMDlIOFpNMTMgMTAuMDAwOVYxOC4wMDA5SDE2VjEwLjAwMDlIMTNaIi8+Cg==");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/download.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTEzIDRWMTIuNTg1N0wxNy4wMDAxIDguNTg1NjRMMTguNDE0MyA5Ljk5OTg1TDEyLjAwMDEgMTYuNDE0MUw1LjU4NTg4IDkuOTk5ODVMNy4wMDAwOSA4LjU4NTY0TDExIDEyLjU4NTVWNEgxM1oiLz4KPHBhdGggZD0iTTIwIDE4SDRWMjBIMjBWMThaIi8+Cg==");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/edit.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC41OTg4IDMuMDAyNzVMNC4wMDQ2NCAxMy41OTY5VjE5LjAxMTFMOS40MTg4MyAxOS4wMTExTDIwLjAxMyA4LjQxNjk0TDE0LjU5ODggMy4wMDI3NVpNNi4wMDQ2NCAxNy4wMTExVjE0LjQyNTNMMTIuMDA3OSA4LjQyMjA5TDE0LjU5MzcgMTEuMDA3OUw4LjU5MDQxIDE3LjAxMTFMNi4wMDQ2NCAxNy4wMTExWk0xNi4wMDc5IDkuNTkzNjVMMTcuMTg0NiA4LjQxNjk0TDE0LjU5ODggNS44MzExN0wxMy40MjIxIDcuMDA3ODdMMTYuMDA3OSA5LjU5MzY1WiIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/ellipses-horizontal.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDEyQzggMTMuMTA0NiA3LjEwNDU3IDE0IDYgMTRDNC44OTU0MyAxNCA0IDEzLjEwNDYgNCAxMkM0IDEwLjg5NTQgNC44OTU0MyAxMCA2IDEwQzcuMTA0NTcgMTAgOCAxMC44OTU0IDggMTJaTTE0IDEyQzE0IDEzLjEwNDYgMTMuMTA0NiAxNCAxMiAxNEMxMC44OTU0IDE0IDEwIDEzLjEwNDYgMTAgMTJDMTAgMTAuODk1NCAxMC44OTU0IDEwIDEyIDEwQzEzLjEwNDYgMTAgMTQgMTAuODk1NCAxNCAxMlpNMjAgMTJDMjAgMTMuMTA0NiAxOS4xMDQ2IDE0IDE4IDE0QzE2Ljg5NTQgMTQgMTYgMTMuMTA0NiAxNiAxMkMxNiAxMC44OTU0IDE2Ljg5NTQgMTAgMTggMTBDMTkuMTA0NiAxMCAyMCAxMC44OTU0IDIwIDEyWiIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/ellipses-vertical.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiA4QzEwLjg5NTQgOCAxMCA3LjEwNDU3IDEwIDZDMTAgNC44OTU0MyAxMC44OTU0IDQgMTIgNEMxMy4xMDQ2IDQgMTQgNC44OTU0MyAxNCA2QzE0IDcuMTA0NTcgMTMuMTA0NiA4IDEyIDhaTTEyIDE0QzEwLjg5NTQgMTQgMTAgMTMuMTA0NiAxMCAxMkMxMCAxMC44OTU0IDEwLjg5NTQgMTAgMTIgMTBDMTMuMTA0NiAxMCAxNCAxMC44OTU0IDE0IDEyQzE0IDEzLjEwNDYgMTMuMTA0NiAxNCAxMiAxNFpNMTIgMjBDMTAuODk1NCAyMCAxMCAxOS4xMDQ2IDEwIDE4QzEwIDE2Ljg5NTQgMTAuODk1NCAxNiAxMiAxNkMxMy4xMDQ2IDE2IDE0IDE2Ljg5NTQgMTQgMThDMTQgMTkuMTA0NiAxMy4xMDQ2IDIwIDEyIDIwWiIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/email.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDE5VjVIMjBWMTlINFpNMTcuNTg1OCA3SDYuNDE0MTVMMTIgMTIuNTg1OEwxNy41ODU4IDdaTTYgOS40MTQyN1YxN0gxOFY5LjQxNDE4TDEyIDE1LjQxNDJMNiA5LjQxNDI3WiIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/exclamation-inverse.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTEyLjk1IDguMDAwMDZWMTMuMDAwMUgxMC45NVY4LjAwMDA2SDEyLjk1WiIvPgo8cGF0aCBkPSJNMTIuOTUgMTUuMDAwMUMxMi45NSAxNC40NDc4IDEyLjUwMjMgMTQuMDAwMSAxMS45NSAxNC4wMDAxQzExLjM5NzcgMTQuMDAwMSAxMC45NSAxNC40NDc4IDEwLjk1IDE1LjAwMDFWMTUuMDkwMUMxMC45NSAxNS42NDIzIDExLjM5NzcgMTYuMDkwMSAxMS45NSAxNi4wOTAxQzEyLjUwMjMgMTYuMDkwMSAxMi45NSAxNS42NDIzIDEyLjk1IDE1LjA5MDFWMTUuMDAwMVoiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zIDEyQzMgNy4wMjk0NCA3LjAyOTQ0IDMgMTIgM0MxNi45NzA2IDMgMjEgNy4wMjk0NCAyMSAxMkMyMSAxNi45NzA2IDE2Ljk3MDYgMjEgMTIgMjFDNy4wMjk0NCAyMSAzIDE2Ljk3MDYgMyAxMlpNMTIgNUM4LjEzNDAxIDUgNSA4LjEzNDAxIDUgMTJDNSAxNS44NjYgOC4xMzQwMSAxOSAxMiAxOUMxNS44NjYgMTkgMTkgMTUuODY2IDE5IDEyQzE5IDguMTM0MDEgMTUuODY2IDUgMTIgNVoiLz4K");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/exclamation.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTEzIDE3Ljg2NjVDMTMgMTcuMzE0MiAxMi41NTIzIDE2Ljg2NjUgMTIgMTYuODY2NUMxMS40NDc3IDE2Ljg2NjUgMTEgMTcuMzE0MiAxMSAxNy44NjY1SDEzWk0xMSAxOEMxMSAxOC41NTIzIDExLjQ0NzcgMTkgMTIgMTlDMTIuNTUyMyAxOSAxMyAxOC41NTIzIDEzIDE4SDExWk0xMyA2VjVIMTFWNkgxM1pNMTEgMTMuNDE2NlYxNC40MTY2SDEzVjEzLjQxNjZIMTFaTTExIDE3Ljg2NjVWMThIMTNWMTcuODY2NUgxMVpNMTEgNlYxMy40MTY2SDEzVjZIMTFaIi8+Cg==");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/expand.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOCAyMFY0SDIwVjIwSDE4Wk0xMS40MTQyIDguMDAwMDJMMTAuNzA3MSA4LjcwNzEzTDguNDE0MiAxMUwxNiAxMVYxM0w4LjQxNDIxIDEzTDEwLjcwNzEgMTUuMjkyOUwxMS40MTQyIDE2TDkuOTk5OTkgMTcuNDE0M0w5LjI5Mjg5IDE2LjcwNzFMNS4yOTI4OSAxMi43MDcxTDQuNTg1NzggMTJMNS4yOTI4OSAxMS4yOTI5TDkuMjkyODkgNy4yOTI5MUw5Ljk5OTk5IDYuNTg1ODFMMTEuNDE0MiA4LjAwMDAyWiIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/facebook.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTIwIDEyLjA0ODlDMjAgNy42MDM2MSAxNi40MTgzIDQgMTIgNEM3LjU4MTcyIDQgNCA3LjYwMzYxIDQgMTIuMDQ4OUM0IDE2LjA2NjMgNi45MjU0NyAxOS4zOTYyIDEwLjc1IDIwVjE0LjM3NTVIOC43MTg3NVYxMi4wNDg5SDEwLjc1VjEwLjI3NTZDMTAuNzUgOC4yNTgzNyAxMS45NDQ0IDcuMTQ0MSAxMy43NzE3IDcuMTQ0MUMxNC42NDcgNy4xNDQxIDE1LjU2MjUgNy4zMDEzIDE1LjU2MjUgNy4zMDEzVjkuMjgyMDhIMTQuNTUzOEMxMy41NiA5LjI4MjA4IDEzLjI1IDkuOTAyNTcgMTMuMjUgMTAuNTM5MVYxMi4wNDg5SDE1LjQ2ODhMMTUuMTE0MSAxNC4zNzU1SDEzLjI1VjIwQzE3LjA3NDUgMTkuMzk2MiAyMCAxNi4wNjYzIDIwIDEyLjA0ODlaIi8+Cg==");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/filetype-pdf.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("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");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/filetype-ppt.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05IDE2VjhIMTEuNTg3OUMxMi40MzUyIDggMTMuMDM4NSA4LjAzNDQzIDEzLjM0ODEgOC4xMjEyQzEzLjgyMjkgOC4yNTE3NCAxNC4yMTc0IDguNTM3NDIgMTQuNTI3NiA4Ljk2MTY5QzE0Ljg1MTYgOS40MDEzNiAxNSA5Ljk1NDUzIDE1IDEwLjU5MjJDMTUgMTEuMDgxNCAxNC45MTU0IDExLjUxNzcgMTQuNzI4NCAxMS44ODU2QzE0LjU1MTcgMTIuMjMzNCAxNC4zMjA1IDEyLjUxNzkgMTQuMDMxOSAxMi43Mjg4QzEzLjc2MzcgMTIuOTIzNyAxMy40ODEyIDEzLjA1OTQgMTMuMTg2MyAxMy4xMjY3TDEzLjE4MDMgMTMuMTI4MUMxMi44MTIxIDEzLjIwNDUgMTIuMjk5NCAxMy4yMzk0IDExLjY1NDYgMTMuMjM5NEgxMS4wNjA0VjE2SDlaTTEyLjc5MjcgMTAuOTg3QzEyLjg1OTUgMTAuODg2MSAxMi44OTY3IDEwLjc2NTYgMTIuODk2NyAxMC42MTIyQzEyLjg5NjcgMTAuNDE3NiAxMi44NDQzIDEwLjI4MzMgMTIuNzU2NyAxMC4xODE4QzEyLjY1NzkgMTAuMDY3MiAxMi41MzQ2IDkuOTk0NjMgMTIuMzczMyA5Ljk2NDEzTDEyLjM3MDggOS45NjM2NUMxMi4yMzczIDkuOTM3MjUgMTEuOTI5NSA5LjkxOTYzIDExLjQxNjUgOS45MTk2M0gxMS4wNjA0VjExLjMxNDhIMTEuNTA3QzExLjc3ODggMTEuMzE0OCAxMS45OTkyIDExLjMwNTMgMTIuMTcwNiAxMS4yODc3QzEyLjM0NzUgMTEuMjY5NSAxMi40NTE5IDExLjI0NDMgMTIuNTAzNSAxMS4yMjMyQzEyLjYzMzkgMTEuMTcgMTIuNzI1MSAxMS4wOTIyIDEyLjc5MDIgMTAuOTkwOUwxMi43OTI3IDEwLjk4N1oiIC8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTUuNDE0MiA0SDRWMjBIMjBWOC41ODU3OUwxNS40MTQyIDRaTTYgMThWNkgxNC41ODU4TDE4IDkuNDE0MjFWMThINloiLz4K");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/filetype-zip.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDRIMTUuNDE0MkwyMCA4LjU4NTc5VjIwSDRWNFpNNiA2VjE4SDE4VjkuNDE0MjFMMTQuNTg1OCA2SDZaTTEzLjY2NjYgMTBWMTQuNDQ0NEgxNC44MTEzVjEyLjkxMDhIMTUuMTQxNEMxNS40OTk2IDEyLjkxMDggMTUuNzg0NSAxMi44OTE0IDE1Ljk4OSAxMi44NDg5TDE1Ljk5MjQgMTIuODQ4MkMxNi4xNTYyIDEyLjgxMDggMTYuMzEzMSAxMi43MzU0IDE2LjQ2MjEgMTIuNjI3MUMxNi42MjI1IDEyLjUxIDE2Ljc1MDkgMTIuMzUxOSAxNi44NDkxIDEyLjE1ODdDMTYuOTUzIDExLjk1NDMgMTcgMTEuNzExOSAxNyAxMS40NDAxQzE3IDExLjA4NTggMTYuOTE3NSAxMC43Nzg1IDE2LjczNzUgMTAuNTM0M0MxNi41NjUyIDEwLjI5ODYgMTYuMzQ2IDEwLjEzOTkgMTYuMDgyMiAxMC4wNjczQzE1LjkxMDIgMTAuMDE5MSAxNS41NzUxIDEwIDE1LjEwNDQgMTBIMTMuNjY2NlpNMTUuODMxNCAxMS40NTEyQzE1LjgzMTQgMTEuNTM2NSAxNS44MTA4IDExLjYwMzQgMTUuNzczNyAxMS42NTk1TDE1Ljc3MjMgMTEuNjYxNkMxNS43MzYxIDExLjcxNzkgMTUuNjg1NCAxMS43NjExIDE1LjYxMyAxMS43OTA3QzE1LjU4NDMgMTEuODAyNCAxNS41MjY0IDExLjgxNjQgMTUuNDI4MSAxMS44MjY1QzE1LjMzMjggMTEuODM2MyAxNS4yMTA0IDExLjg0MTUgMTUuMDU5NCAxMS44NDE1SDE0LjgxMTNWMTEuMDY2NUgxNS4wMDkxQzE1LjI5NDEgMTEuMDY2NSAxNS40NjUxIDExLjA3NjIgMTUuNTM5MyAxMS4wOTA5TDE1LjU0MDcgMTEuMDkxMkMxNS42MzAzIDExLjEwODEgMTUuNjk4OCAxMS4xNDg0IDE1Ljc1MzcgMTEuMjEyMUMxNS44MDI0IDExLjI2ODUgMTUuODMxNCAxMS4zNDMxIDE1LjgzMTQgMTEuNDUxMlpNMTEuNDQ0NSAxMEgxMi41NTU2VjE0LjQ0NDRIMTEuNDQ0NVYxMFpNMTAuMzMzMyAxMEg3VjExLjExMTFIOC42NTA1MUw3IDEzLjMzMzNWMTQuNDQ0NEgxMC4zMzMzVjEzLjMzMzNIOC41ODc5MkwxMC4zMzMzIDExLjExMTFWMTBaIi8+Cg==");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/fit-to-view.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTExLjk5OTggNi4wODU4MkwxNS40MTQgOS41MDAwM0wxMy45OTk4IDEwLjkxNDJMMTEuOTk5OCA4LjkxNDI0TDkuOTk5NzUgMTAuOTE0Mkw4LjU4NTU0IDkuNTAwMDNMMTEuOTk5OCA2LjA4NTgyWiIvPgo8cGF0aCBkPSJNOS45OTk3NCAxMy4wODU4TDExLjk5OTggMTUuMDg1OEwxMy45OTk4IDEzLjA4NThMMTUuNDE0IDE0LjVMMTEuOTk5OCAxNy45MTQyTDguNTg1NTQgMTQuNUw5Ljk5OTc0IDEzLjA4NThaIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTkuOTk5OCA0LjAwMDA2SDMuOTk5NzZWMjBIMTkuOTk5OFY0LjAwMDA2Wk01Ljk5OTc2IDE4VjYuMDAwMDZIMTcuOTk5OFYxOEg1Ljk5OTc2WiIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/fit-to-width.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTYuMDg1NzUgMTIuMDAwMkw5LjQ5OTk3IDguNTg1OTdMMTAuOTE0MiAxMC4wMDAyTDguOTE0MTggMTIuMDAwMkwxMC45MTQyIDE0LjAwMDJMOS40OTk5NyAxNS40MTQ0TDYuMDg1NzUgMTIuMDAwMloiLz4KPHBhdGggZD0iTTEzLjA4NTggMTQuMDAwMkwxNS4wODU3IDEyLjAwMDJMMTMuMDg1OCAxMC4wMDAyTDE0LjUgOC41ODU5N0wxNy45MTQxIDEyLjAwMDJMMTQuNSAxNS40MTQ0TDEzLjA4NTggMTQuMDAwMloiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDQuMDAwMThMNCAyMC4wMDAyTDIwIDIwLjAwMDJMMjAgNC4wMDAxOEw0IDQuMDAwMThaTTE4IDE4LjAwMDJMNiAxOC4wMDAyTDYgNi4wMDAxOEwxOCA2LjAwMDE4TDE4IDE4LjAwMDJaIi8+Cg==");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/folder-new.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTEzIDEySDE1VjE0SDEzVjE2SDExVjE0SDlWMTJIMTFWMTBIMTNWMTJaIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNCA1SDEyLjYxOEwxMy42MTggN0gyMFYxOUg0VjVaTTYgN1YxN0gxOFY5SDEyLjM4MkwxMS4zODIgN0g2WiIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/folder-selected.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDVIMTIuNjE4TDEzLjYxOCA2Ljk5OTk5SDIwVjE5SDRWNVpNMTUuMDcxMSA5LjI5MjkxTDEwLjgyODUgMTMuNTM1Nkw4LjcwNzEyIDExLjQxNDJMNy4yOTI5MSAxMi44Mjg0TDEwLjgyODUgMTYuMzY0TDE2LjQ4NTMgMTAuNzA3MUwxNS4wNzExIDkuMjkyOTFaIi8+Cg==");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/folder.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjk5OTg4IDQuOTk5OTRIMTIuNjE3OUwxMy42MTc5IDYuOTk5OTRIMTkuOTk5OVYxOC45OTk5SDMuOTk5ODhWNC45OTk5NFpNNS45OTk4OCA2Ljk5OTk0VjE2Ljk5OTlIMTcuOTk5OVY4Ljk5OTk0SDEyLjM4MThMMTEuMzgxOCA2Ljk5OTk0SDUuOTk5ODhaIi8+Cg==");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/fullscreen-minimize.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTE2LjQxNCA5LjAwMDAzTDIwLjcwNjkgNC43MDcwNkwxOS4yOTI3IDMuMjkyODVMMTQuOTk5OCA3LjU4NTc0VjQuMDAwMDNIMTIuOTk5OFYxMUgxOS45OTk4VjkuMDAwMDNIMTYuNDE0WiIvPgo8cGF0aCBkPSJNMTAuOTk5OCAyMFYxM0gzLjk5OTgzVjE1SDcuNTg1NzVMMy4yOTI5MSAxOS4yOTI5TDQuNzA3MTIgMjAuNzA3MUw4Ljk5OTgzIDE2LjQxNDRWMjBIMTAuOTk5OFoiLz4K");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/fullscreen.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTE5Ljk5OTggMTFWNEgxMi45OTk4VjZIMTYuNTg1NUwxMi4yOTI3IDEwLjI5MjhMMTMuNzA2OSAxMS43MDdMMTcuOTk5OCA3LjQxNDE0VjExSDE5Ljk5OThaIi8+CjxwYXRoIGQ9Ik03LjQxNDE0IDE4TDExLjcwNzEgMTMuNzA3TDEwLjI5MjkgMTIuMjkyOEw1Ljk5OTgyIDE2LjU4NTlWMTNIMy45OTk4MlYyMEgxMC45OTk4VjE4SDcuNDE0MTRaIi8+Cg==");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/google-color.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTE5LjUzNDUgMTAuNTQ1NUMxOS42MjkxIDExLjA2OTEgMTkuNjggMTEuNjE0NiAxOS42OCAxMi4xODE4QzE5LjY4IDE0LjYxODIgMTguODA3MyAxNi42NjkxIDE3LjI5NDUgMTguMDYxOEwxNC43MDkxIDE2LjA1NDZDMTUuNTU2NCAxNS40ODc0IDE2LjEyIDE0LjY0IDE2LjMwNTUgMTMuNjRIMTJWMTAuNTQ1NUgxOS41MzQ1WiIgZmlsbD0iIzQyODVGNCIvPgo8cGF0aCBkPSJNNC44NTA4NCAxNS41OTI2QzQuODUwODEgMTUuNTkyNSA0Ljg1MDg2IDE1LjU5MjcgNC44NTA4NCAxNS41OTI2TDcuNTIzNTggMTMuNTIwMUM4LjE1MjY4IDE1LjQxMSA5LjkxNjMxIDE2LjgxODIgMTEuOTk5OSAxNi44MTgyQzEzLjA3NjMgMTYuODE4MiAxMy45OTI3IDE2LjUzNDYgMTQuNzA5IDE2LjA1NDZMMTcuMjk0NSAxOC4wNjE5QzE1Ljk3MDggMTkuMjgzNyAxNC4xNTk5IDIwIDExLjk5OTkgMjBDOC44NzI2NiAyMCA2LjE2NzIgMTguMjA3MSA0Ljg1MDg0IDE1LjU5MjZaIiBmaWxsPSIjMzRBODUzIi8+CjxwYXRoIGQ9Ik00Ljg1MDg5IDguNDA3MzVMNy41MjM1NiAxMC40OEM3LjUyMzUzIDEwLjQ4MDEgNy41MjM1OCAxMC40Nzk5IDcuNTIzNTYgMTAuNDhDNy4zNjM1NiAxMC45NiA3LjI3MjczIDExLjQ3MjggNy4yNzI3MyAxMkM3LjI3MjczIDEyLjUyNzMgNy4zNjM2NCAxMy4wNCA3LjUyMzY0IDEzLjUyTDQuODUwOTEgMTUuNTkyOEM0LjMwOTA5IDE0LjUxMjggNCAxMy4yOTEgNCAxMkM0IDEwLjcwOTEgNC4zMDkwOCA5LjQ4NzM0IDQuODUwODkgOC40MDczNVoiIGZpbGw9IiNGQkJDMDUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS45OTk5IDcuMTgxODJDMTMuMTc0NSA3LjE4MTgyIDE0LjIyOSA3LjU4NTQ1IDE1LjA1ODEgOC4zNzgxOEwxNy4zNTI2IDYuMDgzNjRDMTUuOTY3MiA0Ljc5MjczIDE0LjE1NjMgNCAxMS45OTk5IDRDOC44NzI2NSA0IDYuMTY3MTkgNS43OTI3MyA0Ljg1MDgzIDguNDA3MjdMNy41MjM1NiAxMC40OEM4LjE1MjY1IDguNTg5MDkgOS45MTYyOCA3LjE4MTgyIDExLjk5OTkgNy4xODE4MloiIGZpbGw9IiNFQTQzMzUiLz4K");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/google.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTE1LjA1ODEgOC4zNzgxOEMxNC4yMjkgNy41ODU0NSAxMy4xNzQ1IDcuMTgxODIgMTEuOTk5OSA3LjE4MTgyQzkuOTE2MzcgNy4xODE4MiA4LjE1MjggOC41ODg5NyA3LjUyMzY0IDEwLjQ3OThDNy4zNjM2NCAxMC45NTk4IDcuMjcyNzMgMTEuNDcyNyA3LjI3MjczIDEyQzcuMjcyNzMgMTIuNTI3MyA3LjM2MzY0IDEzLjA0IDcuNTIzNjQgMTMuNTJDOC4xNTI3NCAxNS40MTA5IDkuOTE2MyAxNi44MTgyIDExLjk5OTkgMTYuODE4MkMxMy4wNzYzIDE2LjgxODIgMTMuOTkyNiAxNi41MzQ2IDE0LjcwOSAxNi4wNTQ2QzE1LjU1NjMgMTUuNDg3MiAxNi4xMiAxNC42NCAxNi4zMDU1IDEzLjY0SDEyVjEwLjU0NTVIMTkuNTM0NUMxOS42MjkxIDExLjA2OTEgMTkuNjggMTEuNjE0NiAxOS42OCAxMi4xODE4QzE5LjY4IDE0LjYxODIgMTguODA3MyAxNi42NjkxIDE3LjI5NDUgMTguMDYxOEMxNS45NzA5IDE5LjI4MzcgMTQuMTU5OSAyMCAxMS45OTk5IDIwQzguODcyNjUgMjAgNi4xNjcxOSAxOC4yMDczIDQuODUwODMgMTUuNTkyN0M0LjMwOTA2IDE0LjUxMjggNCAxMy4yOTA5IDQgMTJDNCAxMC43MDkxIDQuMzA5MDggOS40ODczMSA0Ljg1MDg5IDguNDA3MzJDNi4xNjcyNiA1Ljc5Mjc4IDguODcyNjUgNCAxMS45OTk5IDRDMTQuMTU2MyA0IDE1Ljk2NzIgNC43OTI3MyAxNy4zNTI2IDYuMDgzNjRMMTUuMDU4MSA4LjM3ODE4WiIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/image.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTE3IDE2TDEyLjk2NzkgMTBMMTEuMDA4NiAxMi44MjQ3TDEwLjE2NTYgMTEuODE3Nkw3IDE2SDE3WiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIwIDRINFYyMEgyMFY0Wk02IDE4VjZIMThWMThINloiLz4K");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/info-inverse.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiA1QzguMTM0MDEgNSA1IDguMTM0MDEgNSAxMkM1IDE1Ljg2NiA4LjEzNDAxIDE5IDEyIDE5QzE1Ljg2NiAxOSAxOSAxNS44NjYgMTkgMTJDMTkgOC4xMzQwMSAxNS44NjYgNSAxMiA1Wk0zIDEyQzMgNy4wMjk0NCA3LjAyOTQ0IDMgMTIgM0MxNi45NzA2IDMgMjEgNy4wMjk0NCAyMSAxMkMyMSAxNi45NzA2IDE2Ljk3MDYgMjEgMTIgMjFDNy4wMjk0NCAyMSAzIDE2Ljk3MDYgMyAxMloiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi45OTk4IDExLjAwMDFWMTYuMDAwMUgxMC45OTk4VjExLjAwMDFIMTIuOTk5OFoiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS45OTk4IDguMDAwMDZDMTIuNTUyMSA4LjAwMDA2IDEyLjk5OTggOC40Mjg1IDEyLjk5OTggOC45NTdWOS4wNDMxMkMxMi45OTk4IDkuNTcxNjMgMTIuNTUyMSAxMC4wMDAxIDExLjk5OTggMTAuMDAwMUMxMS40NDc1IDEwLjAwMDEgMTAuOTk5OCA5LjU3MTYzIDEwLjk5OTggOS4wNDMxMlY4Ljk1N0MxMC45OTk4IDguNDI4NSAxMS40NDc1IDguMDAwMDYgMTEuOTk5OCA4LjAwMDA2WiIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/instagram.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi41NzkyIDguMDkyNzFDMTAuODkzNiA3Ljg0Mjc2IDkuMjM3NzMgOC43MDE5NiA4LjQ3MTYyIDEwLjIyNEM3LjcwNTUxIDExLjc0NjEgOC4wMDE4OSAxMy41ODc5IDkuMjA2ODEgMTQuNzkyOUMxMC40MTE3IDE1Ljk5NzggMTIuMjUzNSAxNi4yOTQyIDEzLjc3NTYgMTUuNTI4QzE1LjI5NzcgMTQuNzYxOSAxNi4xNTY5IDEzLjEwNjEgMTUuOTA3IDExLjQyMDVDMTUuNjUxNyA5LjY5OTM1IDE0LjMwMDMgOC4zNDc5MyAxMi41NzkyIDguMDkyNzFaTTkuODExNDcgMTAuODk4NEMxMC4yODY2IDkuOTU0MzcgMTEuMzEzNyA5LjQyMTQ2IDEyLjM1OTIgOS41NzY0OUMxMy40MjY3IDkuNzM0NzkgMTQuMjY0OSAxMC41NzMgMTQuNDIzMiAxMS42NDA1QzE0LjU3ODIgMTIuNjg2IDE0LjA0NTMgMTMuNzEzIDEzLjEwMTIgMTQuMTg4MkMxMi4xNTcyIDE0LjY2MzQgMTEuMDE0OCAxNC40Nzk1IDEwLjI2NzUgMTMuNzMyMkM5LjUyMDEyIDEyLjk4NDkgOS4zMzYzIDExLjg0MjUgOS44MTE0NyAxMC44OTg0WiIvPgo8cGF0aCBkPSJNMTYuODc1MyA3LjYxOTQ1QzE2Ljg3NTMgNy4xMjk2MiAxNi40NzgyIDYuNzMyNTQgMTUuOTg4NCA2LjczMjU0TDE1Ljg4NTYgNi43Mzc2TDE1Ljg3NzkgNi43Mzg1QzE1LjQzNjYgNi43ODk3NSAxNS4wOTQyIDcuMTY0NTIgMTUuMDk0MiA3LjYxOTQ1QzE1LjA5NDIgOC4xMDkyNyAxNS40OTEzIDguNTA2NTMgMTUuOTgxMSA4LjUwNjUzTDE2LjA4MzkgOC41MDEyOUwxNi4wOTE3IDguNTAwMzlDMTYuNTMyOSA4LjQ0OTE1IDE2Ljg3NTMgOC4wNzQzNyAxNi44NzUzIDcuNjE5NDVaIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOC41NzE0MyAzLjI1QzUuNjMyNDggMy4yNSAzLjI1IDUuNjMyNDggMy4yNSA4LjU3MTQzVjE1LjQyODZDMy4yNSAxOC4zNjc1IDUuNjMyNDggMjAuNzUgOC41NzE0MyAyMC43NUgxNS40Mjg2QzE4LjM2NzUgMjAuNzUgMjAuNzUgMTguMzY3NSAyMC43NSAxNS40Mjg2VjguNTcxNDNDMjAuNzUgNS42MzI0OCAxOC4zNjc1IDMuMjUgMTUuNDI4NiAzLjI1SDguNTcxNDNaTTQuNzUgOC41NzE0M0M0Ljc1IDYuNDYwOTEgNi40NjA5MSA0Ljc1IDguNTcxNDMgNC43NUgxNS40Mjg2QzE3LjUzOTEgNC43NSAxOS4yNSA2LjQ2MDkxIDE5LjI1IDguNTcxNDNWMTUuNDI4NkMxOS4yNSAxNy41MzkxIDE3LjUzOTEgMTkuMjUgMTUuNDI4NiAxOS4yNUg4LjU3MTQzQzYuNDYwOTEgMTkuMjUgNC43NSAxNy41MzkxIDQuNzUgMTUuNDI4NlY4LjU3MTQzWiIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/laptop.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMCA1SDRWMTZIMjBWNVpNNiAxNFY3SDE4VjE0SDZaTTIgMTlIMjJWMTdIMlYxOVoiLz4K");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/link-add.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTIwLjAyOTMgMy45NzA3VjEuOTYyMzRIMTguMDI5M1YzLjk3MDdIMTYuMDIwOVY1Ljk3MDdIMTguMDI5M1Y3Ljk3OTA4SDIwLjAyOTNWNS45NzA3SDIyLjAzNzZWMy45NzA3SDIwLjAyOTNaIi8+CjxwYXRoIGQ9Ik01Ljk3MDcgMTJDNS45NzA3IDEwLjkyNjYgNi44ODkwOSA5Ljk4NzQzIDguMTA4NzggOS45ODc0M0gxMC45OTE2VjcuOTg3NDNIOC4xMDg3OEM1Ljg2MjI1IDcuOTg3NDMgMy45NzA3IDkuNzQ1ODMgMy45NzA3IDEyQzMuOTcwNyAxMy4wNzc3IDQuNDE3MDIgMTQuMTAyNSA1LjE5NzI5IDE0Ljg1MTZDNS45NzYxNyAxNS41OTkzIDcuMDI0MTcgMTYuMDEyNSA4LjEwODc4IDE2LjAxMjVIMTAuOTkxNlYxNC4wMTI1SDguMTA4NzhDNy41Mjg4NSAxNC4wMTI1IDYuOTgwNDggMTMuNzkxIDYuNTgyMzYgMTMuNDA4OEM2LjE4NTYyIDEzLjAyNzkgNS45NzA3IDEyLjUyMDMgNS45NzA3IDEyWiIvPgo8cGF0aCBkPSJNMTUuODkxMiA3Ljk4NzQzSDEzLjAwODRWOS45ODc0M0gxNS44OTEyQzE2LjQ3MTEgOS45ODc0MyAxNy4wMTk1IDEwLjIwOSAxNy40MTc2IDEwLjU5MTJDMTcuODE0NCAxMC45NzIgMTguMDI5MyAxMS40Nzk3IDE4LjAyOTMgMTJDMTguMDI5MyAxMy4wNzM0IDE3LjExMDkgMTQuMDEyNSAxNS44OTEyIDE0LjAxMjVIMTMuMDA4NFYxNi4wMTI1SDE1Ljg5MTJDMTguMTM3NyAxNi4wMTI1IDIwLjAyOTMgMTQuMjU0MSAyMC4wMjkzIDEyQzIwLjAyOTMgMTAuOTIyMyAxOS41ODMgOS44OTc0NSAxOC44MDI3IDkuMTQ4NEMxOC4wMjM4IDguNDAwNjcgMTYuOTc1OCA3Ljk4NzQzIDE1Ljg5MTIgNy45ODc0M1oiLz4KPHBhdGggZD0iTTE1LjAwODMgMTFIOC45OTE2MVYxM0gxNS4wMDgzVjExWiIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/link-external.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTE0LjU4NTkgOEg5VjZIMThWMTVIMTZWOS40MTQzTDcuNzA3MTggMTcuNzA3MUw2LjI5Mjk3IDE2LjI5MjlMMTQuNTg1OSA4WiIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/link.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTYgMTJDNiAxMC45MzM1IDYuOTEyNTMgMTAgOC4xMjUgMTBIMTFWOEg4LjEyNUM1Ljg4NTY5IDggNCA5Ljc1Mjc4IDQgMTJDNCAxMy4wNzQzIDQuNDQ0OTQgMTQuMDk2IDUuMjIyNzYgMTQuODQyN0M1Ljk5OTE5IDE1LjU4ODEgNy4wNDM4NSAxNiA4LjEyNSAxNkgxMVYxNEg4LjEyNUM3LjU0ODU0IDE0IDcuMDAzNSAxMy43Nzk4IDYuNjA3ODIgMTMuMzk5OUM2LjIxMzU0IDEzLjAyMTQgNiAxMi41MTcgNiAxMloiLz4KPHBhdGggZD0iTTE1Ljg3NSA4SDEzVjEwSDE1Ljg3NUMxNi40NTE1IDEwIDE2Ljk5NjUgMTAuMjIwMiAxNy4zOTIyIDEwLjYwMDFDMTcuNzg2NSAxMC45Nzg2IDE4IDExLjQ4MyAxOCAxMkMxOCAxMy4wNjY1IDE3LjA4NzUgMTQgMTUuODc1IDE0SDEzVjE2SDE1Ljg3NUMxOC4xMTQzIDE2IDIwIDE0LjI0NzIgMjAgMTJDMjAgMTAuOTI1NyAxOS41NTUxIDkuOTA0IDE4Ljc3NzIgOS4xNTcyOUMxOC4wMDA4IDguNDExOTIgMTYuOTU2MSA4IDE1Ljg3NSA4WiIvPgo8cGF0aCBkPSJNMTUgMTFIOVYxM0gxNVYxMVoiLz4K");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/linkedin.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNi45OTM2IDE2LjY2SDE0Ljg0MTFWMTIuODY3QzE0Ljg0MTEgMTEuOTg1MyAxNC41Mjk0IDExLjM4MzQgMTMuNzUwNCAxMS4zODM0QzEzLjE1NTcgMTEuMzgzNCAxMi44MDE4IDExLjc4OTQgMTIuNjQ1OSAxMi4xODEyQzEyLjU4OTMgMTIuMzIxIDEyLjU3NSAxMi41MTcgMTIuNTc1IDEyLjcxMzFWMTYuNjZIMTAuNDIyNVYxMS45OTkxQzEwLjQyMjUgMTEuMTQ1NSAxMC4zOTQyIDEwLjQzMTcgMTAuMzY1OSA5LjgxNTc3SDEyLjIzNTFMMTIuMzM0NCAxMC43Njc2SDEyLjM3NjlDMTIuNjYwMSAxMC4zMTk2IDEzLjM1NDEgOS42NjE3MiAxNC41MTU0IDkuNjYxNzJDMTUuOTMxNiA5LjY2MTcyIDE2Ljk5MzYgMTAuNTk5NiAxNi45OTM2IDEyLjYxNTFWMTYuNjZaTTguMDQzNCA5LjEyODQ0QzcuMzYzNzkgOS4xMjg0NCA2LjkyNDc0IDguNjE4MjQgNi45MjQ3NCA3Ljk4ODM5QzYuOTI0NzQgNy4zNDM0NSA3LjM3Nzg0IDYuODQ4NDQgOC4wNzE2OSA2Ljg0ODQ0QzguNzY1NjIgNi44NDg0NCA5LjE5MDUzIDcuMzQzNDUgOS4yMDQ2NyA3Ljk4ODM5QzkuMjA0NjcgOC42MTgyNCA4Ljc2NTYyIDkuMTI4NDQgOC4wNDM0IDkuMTI4NDRWOS4xMjg0NFpNNi45ODE1MSAxNi42NTk5SDkuMTM0MTRWOS44MTU2M0g2Ljk4MTUxVjE2LjY1OTlaTTE4LjM4NjkgNEg1LjYxMzA3QzQuNzIyMDQgNCA0IDQuNzE2MDggNCA1LjU5OTU1VjE4LjQwMDVDNCAxOS4yODM5IDQuNzIyMDQgMjAgNS42MTMwNyAyMEgxOC4zODY5QzE5LjI3OCAyMCAyMCAxOS4yODM5IDIwIDE4LjQwMDVWNS41OTk1NUMyMCA0LjcxNjA4IDE5LjI3OCA0IDE4LjM4NjkgNFY0WiIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/menu.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTIwIDdINFY1SDIwVjdaIi8+CjxwYXRoIGQ9Ik0yMCAxOUg0VjE3SDIwVjE5WiIvPgo8cGF0aCBkPSJNNCAxM0gyMFYxMUg0VjEzWiIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/move.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDRIMjBWMjBINFY0Wk02IDZWMThIMThWNkg2Wk0xMiA3LjU4NTc5TDE2LjQxNDIgMTJMMTIgMTYuNDE0MkwxMC41ODU4IDE1TDEyLjU4NTggMTNIOFYxMUgxMi41ODU4TDEwLjU4NTggOUwxMiA3LjU4NTc5WiIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/new.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMSAxNC40MTQyVjIwSDEzVjE0LjQxNDJMMTUuMjkyOCAxNi43MDdMMTYuNzA3MSAxNS4yOTI4TDE0LjQxNDIgMTNIMjBWMTFIMTQuNDE0MkwxNi43MDcxIDguNzA3MTFMMTUuMjkyOSA3LjI5MjlMMTMgOS41ODU3N1Y0SDExVjkuNTg1NzdMOC43MDcxMyA3LjI5MjlMNy4yOTI5MiA4LjcwNzExTDkuNTg1ODEgMTFINFYxM0g5LjU4NTc3TDcuMjkyOTQgMTUuMjkyOEw4LjcwNzE1IDE2LjcwN0wxMSAxNC40MTQyWiIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/partial-circle.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOSAxMkMxOSA4LjEzNDAxIDE1Ljg2NiA1IDEyIDVMMTEgNUwxMSAzTDEyIDNDMTYuOTcwNiAzIDIxIDcuMDI5NDQgMjEgMTJDMjEgMTYuOTcwNiAxNi45NzA2IDIxIDEyIDIxQzcuMDI5NDQgMjEgMyAxNi45NzA2IDMgMTJMMyAxMUw1IDExTDUgMTJDNSAxNS44NjYgOC4xMzQwMSAxOSAxMiAxOUMxNS44NjYgMTkgMTkgMTUuODY2IDE5IDEyWiIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/primary-source.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS40MTQyIDRINFYyMEgyMFY4LjU4NTc5TDE1LjQxNDIgNFpNNiAxOFY2SDEzVjExSDE4VjE4SDZaTTE3LjU4NTggOUwxNSA2LjQxNDIxVjlIMTcuNTg1OFoiLz4K");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/profile.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjMzMzMxIDEwLjIyMjJDOC4zMzMzMSA4LjE5NzE2IDkuOTc0OTQgNi41NTU1NCAxMiA2LjU1NTU0QzE0LjAyNSA2LjU1NTU0IDE1LjY2NjYgOC4xOTcxNiAxNS42NjY2IDEwLjIyMjJDMTUuNjY2NiAxMi4yNDczIDE0LjAyNSAxMy44ODg5IDEyIDEzLjg4ODlDOS45NzQ5NCAxMy44ODg5IDguMzMzMzEgMTIuMjQ3MyA4LjMzMzMxIDEwLjIyMjJaTTEyIDguNTU1NTRDMTEuMDc5NSA4LjU1NTU0IDEwLjMzMzMgOS4zMDE3MyAxMC4zMzMzIDEwLjIyMjJDMTAuMzMzMyAxMS4xNDI3IDExLjA3OTUgMTEuODg4OSAxMiAxMS44ODg5QzEyLjkyMDUgMTEuODg4OSAxMy42NjY2IDExLjE0MjcgMTMuNjY2NiAxMC4yMjIyQzEzLjY2NjYgOS4zMDE3MyAxMi45MjA1IDguNTU1NTQgMTIgOC41NTU1NFoiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiAzQzcuMDI5NDQgMyAzIDcuMDI5NDQgMyAxMkMzIDE2Ljk3MDYgNy4wMjk0NCAyMSAxMiAyMUMxNi45NzA2IDIxIDIxIDE2Ljk3MDYgMjEgMTJDMjEgNy4wMjk0NCAxNi45NzA2IDMgMTIgM1pNNSAxMkM1IDguMTM0MDEgOC4xMzQwMSA1IDEyIDVDMTUuODY2IDUgMTkgOC4xMzQwMSAxOSAxMkMxOSAxNC4wNjg4IDE4LjEwMjUgMTUuOTI4MSAxNi42NzU2IDE3LjIwOTZDMTUuNzI1MyAxNS42MjA0IDEzLjk4NzkgMTQuNTU1NSAxMiAxNC41NTU1QzEwLjAxMiAxNC41NTU1IDguMjc0NjEgMTUuNjIwNiA3LjMyNDM2IDE3LjIwOTVDNS44OTc0OSAxNS45MjggNSAxNC4wNjg4IDUgMTJaTTguOTkwODggMTguMzIyQzkuOTAyNDUgMTguNzU2NyAxMC45MjI4IDE5IDEyIDE5QzEzLjA3NzIgMTkgMTQuMDk3NSAxOC43NTY3IDE1LjAwOTEgMTguMzIyQzE0LjQxOTggMTcuMjY3NSAxMy4yOTIxIDE2LjU1NTUgMTIgMTYuNTU1NUMxMC43MDggMTYuNTU1NSA5LjU4MDMyIDE3LjI2NzQgOC45OTA4OCAxOC4zMjJaIi8+Cg==");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/question-inverse.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("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");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/save.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS41MzMzIDE4Ljk1TDExLjk1IDE1LjExNTZMOC4zNjY2MiAxOC45NUg2Ljk0OTk1VjQuOTUwMDFIMTYuOTVWMTguOTVIMTUuNTMzM1oiIHN0cm9rZS13aWR0aD0iMiIgZmlsbD0ibm9uZSIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/saved.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS41MzMzIDE4Ljk1TDExLjk1IDE1LjExNTZMOC4zNjY2MiAxOC45NUg2Ljk0OTk1VjQuOTUwMDFIMTYuOTVWMTguOTVIMTUuNTMzM1oiIHN0cm9rZS13aWR0aD0iMiIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/search.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS45MDU0IDE3LjMyMDFDMTQuNTUwNyAxOC4zNzMgMTIuODQ4NiAxOSAxMSAxOUM2LjU4MTcyIDE5IDMgMTUuNDE4MyAzIDExQzMgNi41ODE3MiA2LjU4MTcyIDMgMTEgM0MxNS40MTgzIDMgMTkgNi41ODE3MiAxOSAxMUMxOSAxMi44NDg4IDE4LjM3MjggMTQuNTUxMiAxNy4zMTk2IDE1LjkwNTlMMjEuNTIyNCAyMC4xMDg3TDIwLjEwODIgMjEuNTIyOUwxNS45MDU0IDE3LjMyMDFaTTUgMTFDNSA3LjY4NjI5IDcuNjg2MjkgNSAxMSA1QzE0LjMxMzcgNSAxNyA3LjY4NjI5IDE3IDExQzE3IDEyLjUyNDQgMTYuNDMxNSAxMy45MTYgMTUuNDk1IDE0Ljk3NDNMMTQuOTc0MyAxNS40OTVDMTMuOTE2IDE2LjQzMTUgMTIuNTI0NCAxNyAxMSAxN0M3LjY4NjI5IDE3IDUgMTQuMzEzNyA1IDExWiIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/share.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTExLjk5OTkgNC4wODU5NEwxOC40MTQxIDEwLjUwMDJMMTYuOTk5OSAxMS45MTQ0TDEzIDcuOTE0NDZWMTZIMTFWNy45MTQyN0w2Ljk5OTkxIDExLjkxNDRMNS41ODU2OSAxMC41MDAyTDExLjk5OTkgNC4wODU5NFoiLz4KPHBhdGggZD0iTTYgMTVWMThIMThWMTVIMjBWMjBINFYxNUg2WiIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/shift-down.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjcwNzExIDQuMjkyOTFMMTkuNzA3MSA0LjI5MjkxTDE5LjcwNzEgNi4yOTI5MUwzLjcwNzExIDYuMjkyOTFMMy43MDcxMSA0LjI5MjkxWk0xNy4xMjEzIDE0LjI5MjlMMTEuNzA3MSAxOS43MDcxTDYuMjkyODkgMTQuMjkyOUw3LjcwNzExIDEyLjg3ODdMMTAuNzA3MSAxNS44Nzg3TDEwLjcwNzEgOC4yOTI5MUwxMi43MDcxIDguMjkyOTFMMTIuNzA3MSAxNS44Nzg3TDE1LjcwNzEgMTIuODc4N0wxNy4xMjEzIDE0LjI5MjlaIiAvPg==");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/shift-left.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOCAyMFY0SDIwVjIwSDE4Wk0xMS40MTQyIDguMDAwMDJMMTAuNzA3MSA4LjcwNzEzTDguNDE0MiAxMUwxNiAxMVYxM0w4LjQxNDIxIDEzTDEwLjcwNzEgMTUuMjkyOUwxMS40MTQyIDE2TDkuOTk5OTkgMTcuNDE0M0w5LjI5Mjg5IDE2LjcwNzFMNS4yOTI4OSAxMi43MDcxTDQuNTg1NzggMTJMNS4yOTI4OSAxMS4yOTI5TDkuMjkyODkgNy4yOTI5MUw5Ljk5OTk5IDYuNTg1ODFMMTEuNDE0MiA4LjAwMDAyWiIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/shift-right.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDIwVjRINlYyMEg0Wk0xNCA2LjU4NTc5TDE5LjQxNDIgMTJMMTQgMTcuNDE0MkwxMi41ODU4IDE2TDE1LjU4NTggMTNIOFYxMUgxNS41ODU4TDEyLjU4NTggOEwxNCA2LjU4NTc5WiIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/shift-up.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjI5Mjg5IDE3LjcwNzFMMjAuMjkyOSAxNy43MDcxTDIwLjI5MjkgMTkuNzA3MUw0LjI5Mjg5IDE5LjcwNzFMNC4yOTI4OSAxNy43MDcxWk0xNi4yOTI5IDExLjEyMTNMMTUuNTg1OCAxMC40MTQyTDEzLjI5MjkgOC4xMjEzM0wxMy4yOTI5IDE1LjcwNzFMMTEuMjkyOSAxNS43MDcxTDExLjI5MjkgOC4xMjEzM0w4Ljk5OTk2IDEwLjQxNDJMOC4yOTI4NSAxMS4xMjEzTDYuODc4NjQgOS43MDcxMkw3LjU4NTc1IDkuMDAwMDFMMTEuNTg1OCA1LjAwMDAxTDEyLjI5MjkgNC4yOTI5MUwxMyA1LjAwMDAxTDE3IDkuMDAwMDFMMTcuNzA3MSA5LjcwNzEyTDE2LjI5MjkgMTEuMTIxM1oiIC8+Cg==");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/tumblr.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMy4zODc5IDIwQzEwLjk3NzQgMjAgOS4xODk1OCAxOC43NjQ2IDkuMTg5NTggMTUuODAxNlYxMS4wNjA5SDdWOC40ODk2NEM5LjQxMDU1IDcuODY2OTIgMTAuNDE0OSA1Ljc5Nzg3IDEwLjUyNTQgNEgxMy4wMjY0VjguMDc3ODRIMTUuOTM5MVYxMS4wNjA5SDEzLjAyNjRWMTUuMTg5MUMxMy4wMjY0IDE2LjQyNDQgMTMuNjQ5MiAxNi44NTYyIDE0LjY0MzQgMTYuODU2MkgxNi4wNTk3VjIwSDEzLjM4NzlaIi8+Cg==");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/twitter.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTkuMDMxNjggMTlDMTUuMDY5NCAxOSAxOC4zNzE4IDEzLjk5ODEgMTguMzcxOCA5LjY2MDQ0QzE4LjM3MTggOS41MTgzNyAxOC4zNzE4IDkuMzc2OTQgMTguMzYyMiA5LjIzNjE1QzE5LjAwNDcgOC43NzE0OCAxOS41NTkzIDguMTk2MTMgMjAgNy41MzcwNUMxOS40MDA5IDcuODAyNTEgMTguNzY1MyA3Ljk3NjYgMTguMTE0NiA4LjA1MzVDMTguNzk5OCA3LjY0MzI4IDE5LjMxMjcgNi45OTgwNiAxOS41NTc4IDYuMjM3OTRDMTguOTEzNCA2LjYyMDI4IDE4LjIwODQgNi44ODk3NCAxNy40NzMzIDcuMDM0NjlDMTYuOTc4MyA2LjUwODQ0IDE2LjMyMzcgNi4xNTk5NyAxNS42MTA4IDYuMDQzMjFDMTQuODk3OCA1LjkyNjQ0IDE0LjE2NjMgNi4wNDc4OSAxMy41MjkzIDYuMzg4NzZDMTIuODkyMyA2LjcyOTYzIDEyLjM4NTUgNy4yNzA5MiAxMi4wODcyIDcuOTI4ODZDMTEuNzg4OCA4LjU4NjggMTEuNzE1NyA5LjMyNDcyIDExLjg3OSAxMC4wMjg0QzEwLjU3MzkgOS45NjI5OSA5LjI5NzE1IDkuNjIzODUgOC4xMzE2MSA5LjAzMzAyQzYuOTY2MDcgOC40NDIxOCA1LjkzNzgyIDcuNjEyODUgNS4xMTM2IDYuNTk4ODdDNC42OTM4MiA3LjMyMTQ5IDQuNTY1MjUgOC4xNzY5MiA0Ljc1NDA3IDguOTkxQzQuOTQyODggOS44MDUwOCA1LjQzNDg5IDEwLjUxNjYgNi4xMjk5MiAxMC45ODA3QzUuNjA3NTEgMTAuOTY1MiA1LjA5NjUgMTAuODI0MyA0LjY0IDEwLjU2OThDNC42NCAxMC41ODMzIDQuNjQgMTAuNTk3MyA0LjY0IDEwLjYxMTRDNC42NDAyMSAxMS4zNjkzIDQuOTAyNTcgMTIuMTAzNyA1LjM4MjU4IDEyLjY5MDJDNS44NjI1OSAxMy4yNzY3IDYuNTMwNzEgMTMuNjc5MSA3LjI3MzYgMTMuODI5MUM2Ljc5MDMyIDEzLjk2MDkgNi4yODMyNSAxMy45ODAyIDUuNzkxMzYgMTMuODg1NEM2LjAwMTEzIDE0LjUzNzcgNi40MDk1MSAxNS4xMDggNi45NTk0MSAxNS41MTY4QzcuNTA5MyAxNS45MjU1IDguMTczMTkgMTYuMTUyMSA4Ljg1ODI0IDE2LjE2NUM3LjY5NTgzIDE3LjA3ODUgNi4yNTk4OCAxNy41NzQ0IDQuNzgxNDQgMTcuNTcyOUM0LjUyMDI2IDE3LjU3MjQgNC4yNTkzMyAxNy41NTY2IDQgMTcuNTI1NUM1LjUwMTIxIDE4LjQ4ODggNy4yNDc5NCAxOC45OTk4IDkuMDMxNjggMTguOTk3NCIvPgo=");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/video.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDRIMjBWMjBINFY0Wk02IDZWMThIMThWNkg2WiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE1IDEyTDEwIDE1VjlMMTUgMTJaIi8+Cg==");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/view-gallery.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjk5OTc2IDQuMDAwMDZIMTkuOTk5OFYyMC4wMDAxSDMuOTk5NzZWNC4wMDAwNlpNNS45OTk3NiA2LjAwMDA2VjExLjAwMDFIMTAuOTk5OFY2LjAwMDA2SDUuOTk5NzZaTTEyLjk5OTggNi4wMDAwNlYxMS4wMDAxSDE3Ljk5OThWNi4wMDAwNkgxMi45OTk4Wk0xMC45OTk4IDEzLjAwMDFINS45OTk3NlYxOC4wMDAxSDEwLjk5OThWMTMuMDAwMVpNMTIuOTk5OCAxOC4wMDAxVjEzLjAwMDFIMTcuOTk5OFYxOC4wMDAxSDEyLjk5OThaIi8+Cg==");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/view-grid.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDRIMjAuMDE2NFYyMC4wMzIzSDRWNFpNNiAxNS4zNTQ4VjE4LjAzMjNIOC42NzIxMlYxNS4zNTQ4SDZaTTYgMTMuMzU0OEg4LjY3MjEyVjEwLjY3NzZINlYxMy4zNTQ4Wk0xMC42NzIxIDE1LjM1NDhWMTguMDMyM0gxMy4zNDQzVjE1LjM1NDhMMTAuNjcyMSAxNS4zNTQ4Wk0xMy4zNDQzIDEzLjM1NDhMMTAuNjcyMSAxMy4zNTQ4VjEwLjY3NzZIMTMuMzQ0M1YxMy4zNTQ4Wk0xNS4zNDQzIDE1LjM1NDhWMTguMDMyM0gxOC4wMTY0VjE1LjM1NDhIMTUuMzQ0M1pNMTguMDE2NCAxMy4zNTQ4SDE1LjM0NDNWMTAuNjc3NkgxOC4wMTY0VjEzLjM1NDhaTTYgOC42Nzc2NEg4LjY3MjEyVjZINlY4LjY3NzY0Wk0xOC4wMTY0IDguNjc3NjRIMTUuMzQ0M1Y2SDE4LjAxNjRWOC42Nzc2NFpNMTAuNjcyMSA2SDEzLjM0NDNWOC42Nzc2NEgxMC42NzIxVjZaIi8+Cg==");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/view-list.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjk5OTc2IDQuMDAwMDZIMTkuOTk5OFYyMC4wMDAxSDMuOTk5NzZWNC4wMDAwNlpNNS45OTk3NiA2LjAwMDA2VjE4LjAwMDFIMTcuOTk5OFY2LjAwMDA2SDUuOTk5NzZaTTkuOTk5NzYgMTAuMDAwMUg3Ljk5OTc2VjguMDAwMDZIOS45OTk3NlYxMC4wMDAxWk0xNS45OTk4IDEwLjAwMDFIMTAuOTk5OFY4LjAwMDA2SDE1Ljk5OThWMTAuMDAwMVpNOS45OTk3NiAxMy4wMDAxSDcuOTk5NzZWMTEuMDAwMUg5Ljk5OTc2VjEzLjAwMDFaTTE1Ljk5OTggMTMuMDAwMUgxMC45OTk4VjExLjAwMDFIMTUuOTk5OFYxMy4wMDAxWk05Ljk5OTc2IDE2LjAwMDFINy45OTk3NlYxNC4wMDAxSDkuOTk5NzZWMTYuMDAwMVpNMTUuOTk5OCAxNi4wMDAxSDEwLjk5OThWMTQuMDAwMUgxNS45OTk4VjE2LjAwMDFaIi8+Cg==");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/workspace-selected.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTE1Ljk5OTggNC4wMDAwNkg3Ljk5OTgyVjcuNUg5Ljk5OTgyVjYuMDAwMDZIMTMuOTk5OFY3LjVIMTUuOTk5OFY0LjAwMDA2WiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE5Ljk5OTggNy4wMDAwNkgzLjk5OTgyVjIwSDE5Ljk5OThWNy4wMDAwNlpNMTAuODI4NSAxNC41MzU2TDE1LjA3MTEgMTAuMjkyOUwxNi40ODUzIDExLjcwNzFMMTAuODI4NSAxNy4zNjRMNy4yOTI5MSAxMy44Mjg0TDguNzA3MTIgMTIuNDE0MkwxMC44Mjg1IDE0LjUzNTZaIi8+Cg==");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/workspace.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDRIMTZWN0gyMFYyMEg0VjdIOFY0Wk0xMCA2VjdIMTRWNkgxMFpNNiA5VjEySDE4VjlINlpNMTggMTRIMTRWMTZIMTBWMTRINlYxOEgxOFYxNFoiLz4K");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/youtube.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi42NjQ5IDYuMDAzMDRMMTEuODM4NCA2TDExLjEwMDQgNi4wMDU3NUwxMC41ODExIDYuMDEzMTRDMTAuMjI5NiA2LjAxOTA5IDkuODY5MTMgNi4wMjcxNSA5LjUwOTM4IDYuMDM3NjlMOC42MzY0MSA2LjA2ODYzTDguMTk5MTcgNi4wODkxQzcuMjE2NjYgNi4xMzk4NiA2LjUwMDI3IDYuMjEyMTIgNi4wOTQ3MSA2LjMxNjUxQzUuMjE2OTIgNi41NTU0NSA0LjU0NjE1IDcuMjIxIDQuMzI2OTkgOC4wNjM3M0M0LjEwMDU0IDkuMjY0MiAzLjk5NDM1IDEwLjQzOTUgNC4wMDAzOSAxMS42MTY3QzMuOTkyNjYgMTIuNzk1NiA0LjA5ODg1IDEzLjk3OTkgNC4zMTc2MiAxNS4xNDcyQzQuNTczOTYgMTYuMDI0OSA1LjI0MDggMTYuNjYwMSA2LjA5MTAxIDE2Ljg4NEM2LjU0MDk1IDE2Ljk5OTggNy4zNjM1NyAxNy4wNzU3IDguNTA1NiAxNy4xMjdMOC45NzkzMiAxNy4xNDYzQzkuNDc1NDYgMTcuMTY0NiA5Ljk5NzQyIDE3LjE3NzkgMTAuNTI1OCAxNy4xODcxTDExLjU3OTkgMTcuMkgxMi40MjAxTDEzLjQ3NDIgMTcuMTg3MUMxNC4wMDI2IDE3LjE3NzkgMTQuNTI0NSAxNy4xNjQ2IDE1LjAyMDcgMTcuMTQ2M0wxNS40OTQ0IDE3LjEyN0wxNi4xNDA4IDE3LjA5MzJDMTYuOTUwMiAxNy4wNDM4IDE3LjU0NzkgMTYuOTc2OSAxNy45MDUzIDE2Ljg4NDlDMTguNzgzMSAxNi42NDYgMTkuNDUzOCAxNS45ODA0IDE5LjY3MyAxNS4xMzc3QzE5Ljg5NzggMTMuOTQ1OSAyMC4wMDQgMTIuNzc5NiAxOS45OTk2IDExLjYxMTJDMjAuMDA3MyAxMC40MzE1IDE5LjkwMTEgOS4yNDcyNCAxOS42ODI0IDguMDc5OTVDMTkuNDUzOCA3LjE5NTMzIDE4Ljc4MzEgNi41Mjk3OSAxNy45MTQ1IDYuMjkzMjlDMTcuMzg1NiA2LjE2ODU2IDE2LjM4NTIgNi4wOTUzOCAxNC45ODA2IDYuMDQ5TDE0LjM5NzQgNi4wMzE5NEMxMy44MTEyIDYuMDE2ODkgMTMuMjIwNSA2LjAwNzcxIDEyLjY2NDkgNi4wMDMwNFpNMTQuMzMzNSAxMS42MTM0TDEwLjUwMDQgOS41MTU0MVYxMy43MTE0TDE0LjMzMzUgMTEuNjEzNFoiLz4K");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/zoom-in.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTEyIDcuOTk5OTdWOS45OTk5N0gxNFYxMkgxMlYxNEgxMFYxMkg4VjkuOTk5OTdIMTBWNy45OTk5N0gxMloiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDExQzQgNy4xMzQgNy4xMzQwMSA0IDExIDRDMTQuODY2IDQgMTggNy4xMzQgMTggMTFDMTggMTIuNTcyMyAxNy40ODE2IDE0LjAyMzUgMTYuNjA2NCAxNS4xOTIxTDIxLjUyMjYgMjAuMTA4M0wyMC4xMDgzIDIxLjUyMjVMMTUuMTkyMiAxNi42MDYzQzE0LjAyMzYgMTcuNDgxNiAxMi41NzI0IDE4IDExIDE4QzcuMTM0MDEgMTggNCAxNC44NjYgNCAxMVpNMTEgNkM4LjIzODU3IDYgNiA4LjIzODU3IDYgMTFDNiAxMy43NjE0IDguMjM4NTcgMTYgMTEgMTZDMTMuNzYxNCAxNiAxNiAxMy43NjE0IDE2IDExQzE2IDguMjM4NTcgMTMuNzYxNCA2IDExIDZaIi8+Cg==");


/***/ }),

/***/ "./packages/pharos/src/styles/icons/zoom-out.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("PHBhdGggZD0iTTE0IDEyVjkuOTk5OTdIOFYxMkgxNFoiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDExQzQgNy4xMzQgNy4xMzQwMSA0IDExIDRDMTQuODY2IDQgMTggNy4xMzQgMTggMTFDMTggMTIuNTcyMyAxNy40ODE2IDE0LjAyMzUgMTYuNjA2NCAxNS4xOTIxTDIxLjUyMjYgMjAuMTA4M0wyMC4xMDgzIDIxLjUyMjVMMTUuMTkyMiAxNi42MDYzQzE0LjAyMzYgMTcuNDgxNiAxMi41NzI0IDE4IDExIDE4QzcuMTM0MDEgMTggNCAxNC44NjYgNCAxMVpNMTEgNkM4LjIzODU3IDYgNiA4LjIzODU3IDYgMTFDNiAxMy43NjE0IDguMjM4NTcgMTYgMTEgMTZDMTMuNzYxNCAxNiAxNiAxMy43NjE0IDE2IDExQzE2IDguMjM4NTcgMTMuNzYxNCA2IDExIDZaIi8+Cg==");


/***/ }),

/***/ "./packages/pharos/src/styles/tokens.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const tokens = {
  "asset": {
    "icon": {
      "academic-content": {
        "value": "assets/icons/academic-content.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/academic-content.svg"
        },
        "name": "PharosAssetIconAcademicContent",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "academic-content"
        },
        "path": [
          "asset",
          "icon",
          "academic-content"
        ]
      },
      "add": {
        "value": "assets/icons/add.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/add.svg"
        },
        "name": "PharosAssetIconAdd",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "add"
        },
        "path": [
          "asset",
          "icon",
          "add"
        ]
      },
      "arrow-down": {
        "value": "assets/icons/arrow-down.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/arrow-down.svg"
        },
        "name": "PharosAssetIconArrowDown",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "arrow-down"
        },
        "path": [
          "asset",
          "icon",
          "arrow-down"
        ]
      },
      "arrow-left": {
        "value": "assets/icons/arrow-left.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/arrow-left.svg"
        },
        "name": "PharosAssetIconArrowLeft",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "arrow-left"
        },
        "path": [
          "asset",
          "icon",
          "arrow-left"
        ]
      },
      "arrow-right": {
        "value": "assets/icons/arrow-right.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/arrow-right.svg"
        },
        "name": "PharosAssetIconArrowRight",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "arrow-right"
        },
        "path": [
          "asset",
          "icon",
          "arrow-right"
        ]
      },
      "arrow-up": {
        "value": "assets/icons/arrow-up.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/arrow-up.svg"
        },
        "name": "PharosAssetIconArrowUp",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "arrow-up"
        },
        "path": [
          "asset",
          "icon",
          "arrow-up"
        ]
      },
      "attachment": {
        "value": "assets/icons/attachment.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/attachment.svg"
        },
        "name": "PharosAssetIconAttachment",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "attachment"
        },
        "path": [
          "asset",
          "icon",
          "attachment"
        ]
      },
      "base": {
        "value": "assets/icons/base.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/base.svg"
        },
        "name": "PharosAssetIconBase",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "base"
        },
        "path": [
          "asset",
          "icon",
          "base"
        ]
      },
      "book": {
        "value": "assets/icons/book.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/book.svg"
        },
        "name": "PharosAssetIconBook",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "book"
        },
        "path": [
          "asset",
          "icon",
          "book"
        ]
      },
      "calendar": {
        "value": "assets/icons/calendar.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/calendar.svg"
        },
        "name": "PharosAssetIconCalendar",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "calendar"
        },
        "path": [
          "asset",
          "icon",
          "calendar"
        ]
      },
      "checkmark-filled-circle": {
        "value": "assets/icons/checkmark-filled-circle.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/checkmark-filled-circle.svg"
        },
        "name": "PharosAssetIconCheckmarkFilledCircle",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "checkmark-filled-circle"
        },
        "path": [
          "asset",
          "icon",
          "checkmark-filled-circle"
        ]
      },
      "checkmark-inverse": {
        "value": "assets/icons/checkmark-inverse.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/checkmark-inverse.svg"
        },
        "name": "PharosAssetIconCheckmarkInverse",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "checkmark-inverse"
        },
        "path": [
          "asset",
          "icon",
          "checkmark-inverse"
        ]
      },
      "checkmark-small": {
        "value": "assets/icons/checkmark-small.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/checkmark-small.svg"
        },
        "name": "PharosAssetIconCheckmarkSmall",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "checkmark-small"
        },
        "path": [
          "asset",
          "icon",
          "checkmark-small"
        ]
      },
      "checkmark": {
        "value": "assets/icons/checkmark.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/checkmark.svg"
        },
        "name": "PharosAssetIconCheckmark",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "checkmark"
        },
        "path": [
          "asset",
          "icon",
          "checkmark"
        ]
      },
      "chevron-down": {
        "value": "assets/icons/chevron-down.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/chevron-down.svg"
        },
        "name": "PharosAssetIconChevronDown",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "chevron-down"
        },
        "path": [
          "asset",
          "icon",
          "chevron-down"
        ]
      },
      "chevron-left-large": {
        "value": "assets/icons/chevron-left-large.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/chevron-left-large.svg"
        },
        "name": "PharosAssetIconChevronLeftLarge",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "chevron-left-large"
        },
        "path": [
          "asset",
          "icon",
          "chevron-left-large"
        ]
      },
      "chevron-left": {
        "value": "assets/icons/chevron-left.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/chevron-left.svg"
        },
        "name": "PharosAssetIconChevronLeft",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "chevron-left"
        },
        "path": [
          "asset",
          "icon",
          "chevron-left"
        ]
      },
      "chevron-right-large": {
        "value": "assets/icons/chevron-right-large.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/chevron-right-large.svg"
        },
        "name": "PharosAssetIconChevronRightLarge",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "chevron-right-large"
        },
        "path": [
          "asset",
          "icon",
          "chevron-right-large"
        ]
      },
      "chevron-right": {
        "value": "assets/icons/chevron-right.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/chevron-right.svg"
        },
        "name": "PharosAssetIconChevronRight",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "chevron-right"
        },
        "path": [
          "asset",
          "icon",
          "chevron-right"
        ]
      },
      "chevron-up": {
        "value": "assets/icons/chevron-up.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/chevron-up.svg"
        },
        "name": "PharosAssetIconChevronUp",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "chevron-up"
        },
        "path": [
          "asset",
          "icon",
          "chevron-up"
        ]
      },
      "circle": {
        "value": "assets/icons/circle.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/circle.svg"
        },
        "name": "PharosAssetIconCircle",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "circle"
        },
        "path": [
          "asset",
          "icon",
          "circle"
        ]
      },
      "cite": {
        "value": "assets/icons/cite.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/cite.svg"
        },
        "name": "PharosAssetIconCite",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "cite"
        },
        "path": [
          "asset",
          "icon",
          "cite"
        ]
      },
      "close-inverse": {
        "value": "assets/icons/close-inverse.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/close-inverse.svg"
        },
        "name": "PharosAssetIconCloseInverse",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "close-inverse"
        },
        "path": [
          "asset",
          "icon",
          "close-inverse"
        ]
      },
      "close": {
        "value": "assets/icons/close.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/close.svg"
        },
        "name": "PharosAssetIconClose",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "close"
        },
        "path": [
          "asset",
          "icon",
          "close"
        ]
      },
      "collapse": {
        "value": "assets/icons/shift-right.svg",
        "deprecated": true,
        "deprecated_comment": "Use shift-<direction> instead",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/shift-right.svg",
          "deprecated": true,
          "deprecated_comment": "Use shift-<direction> instead"
        },
        "name": "PharosAssetIconCollapse",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "collapse"
        },
        "path": [
          "asset",
          "icon",
          "collapse"
        ]
      },
      "copy": {
        "value": "assets/icons/copy.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/copy.svg"
        },
        "name": "PharosAssetIconCopy",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "copy"
        },
        "path": [
          "asset",
          "icon",
          "copy"
        ]
      },
      "dash-small": {
        "value": "assets/icons/dash-small.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/dash-small.svg"
        },
        "name": "PharosAssetIconDashSmall",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "dash-small"
        },
        "path": [
          "asset",
          "icon",
          "dash-small"
        ]
      },
      "delete": {
        "value": "assets/icons/delete.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/delete.svg"
        },
        "name": "PharosAssetIconDelete",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "delete"
        },
        "path": [
          "asset",
          "icon",
          "delete"
        ]
      },
      "download": {
        "value": "assets/icons/download.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/download.svg"
        },
        "name": "PharosAssetIconDownload",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "download"
        },
        "path": [
          "asset",
          "icon",
          "download"
        ]
      },
      "edit": {
        "value": "assets/icons/edit.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/edit.svg"
        },
        "name": "PharosAssetIconEdit",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "edit"
        },
        "path": [
          "asset",
          "icon",
          "edit"
        ]
      },
      "ellipses-horizontal": {
        "value": "assets/icons/ellipses-horizontal.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/ellipses-horizontal.svg"
        },
        "name": "PharosAssetIconEllipsesHorizontal",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "ellipses-horizontal"
        },
        "path": [
          "asset",
          "icon",
          "ellipses-horizontal"
        ]
      },
      "ellipses-vertical": {
        "value": "assets/icons/ellipses-vertical.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/ellipses-vertical.svg"
        },
        "name": "PharosAssetIconEllipsesVertical",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "ellipses-vertical"
        },
        "path": [
          "asset",
          "icon",
          "ellipses-vertical"
        ]
      },
      "email": {
        "value": "assets/icons/email.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/email.svg"
        },
        "name": "PharosAssetIconEmail",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "email"
        },
        "path": [
          "asset",
          "icon",
          "email"
        ]
      },
      "exclamation-inverse": {
        "value": "assets/icons/exclamation-inverse.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/exclamation-inverse.svg"
        },
        "name": "PharosAssetIconExclamationInverse",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "exclamation-inverse"
        },
        "path": [
          "asset",
          "icon",
          "exclamation-inverse"
        ]
      },
      "exclamation": {
        "value": "assets/icons/exclamation.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/exclamation.svg"
        },
        "name": "PharosAssetIconExclamation",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "exclamation"
        },
        "path": [
          "asset",
          "icon",
          "exclamation"
        ]
      },
      "expand": {
        "value": "assets/icons/shift-left.svg",
        "deprecated": true,
        "deprecated_comment": "Use shift-<direction> instead",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/shift-left.svg",
          "deprecated": true,
          "deprecated_comment": "Use shift-<direction> instead"
        },
        "name": "PharosAssetIconExpand",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "expand"
        },
        "path": [
          "asset",
          "icon",
          "expand"
        ]
      },
      "facebook": {
        "value": "assets/icons/facebook.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/facebook.svg"
        },
        "name": "PharosAssetIconFacebook",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "facebook"
        },
        "path": [
          "asset",
          "icon",
          "facebook"
        ]
      },
      "filetype-pdf": {
        "value": "assets/icons/filetype-pdf.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/filetype-pdf.svg"
        },
        "name": "PharosAssetIconFiletypePdf",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "filetype-pdf"
        },
        "path": [
          "asset",
          "icon",
          "filetype-pdf"
        ]
      },
      "filetype-ppt": {
        "value": "assets/icons/filetype-ppt.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/filetype-ppt.svg"
        },
        "name": "PharosAssetIconFiletypePpt",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "filetype-ppt"
        },
        "path": [
          "asset",
          "icon",
          "filetype-ppt"
        ]
      },
      "filetype-zip": {
        "value": "assets/icons/filetype-zip.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/filetype-zip.svg"
        },
        "name": "PharosAssetIconFiletypeZip",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "filetype-zip"
        },
        "path": [
          "asset",
          "icon",
          "filetype-zip"
        ]
      },
      "fit-to-view": {
        "value": "assets/icons/fit-to-view.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/fit-to-view.svg"
        },
        "name": "PharosAssetIconFitToView",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "fit-to-view"
        },
        "path": [
          "asset",
          "icon",
          "fit-to-view"
        ]
      },
      "fit-to-width": {
        "value": "assets/icons/fit-to-width.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/fit-to-width.svg"
        },
        "name": "PharosAssetIconFitToWidth",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "fit-to-width"
        },
        "path": [
          "asset",
          "icon",
          "fit-to-width"
        ]
      },
      "folder-new": {
        "value": "assets/icons/folder-new.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/folder-new.svg"
        },
        "name": "PharosAssetIconFolderNew",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "folder-new"
        },
        "path": [
          "asset",
          "icon",
          "folder-new"
        ]
      },
      "folder": {
        "value": "assets/icons/folder.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/folder.svg"
        },
        "name": "PharosAssetIconFolder",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "folder"
        },
        "path": [
          "asset",
          "icon",
          "folder"
        ]
      },
      "folder-selected": {
        "value": "assets/icons/folder-selected.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/folder-selected.svg"
        },
        "name": "PharosAssetIconFolderSelected",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "folder-selected"
        },
        "path": [
          "asset",
          "icon",
          "folder-selected"
        ]
      },
      "fullscreen-minimize": {
        "value": "assets/icons/fullscreen-minimize.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/fullscreen-minimize.svg"
        },
        "name": "PharosAssetIconFullscreenMinimize",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "fullscreen-minimize"
        },
        "path": [
          "asset",
          "icon",
          "fullscreen-minimize"
        ]
      },
      "fullscreen": {
        "value": "assets/icons/fullscreen.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/fullscreen.svg"
        },
        "name": "PharosAssetIconFullscreen",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "fullscreen"
        },
        "path": [
          "asset",
          "icon",
          "fullscreen"
        ]
      },
      "google-color": {
        "value": "assets/icons/google-color.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/google-color.svg"
        },
        "name": "PharosAssetIconGoogleColor",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "google-color"
        },
        "path": [
          "asset",
          "icon",
          "google-color"
        ]
      },
      "google": {
        "value": "assets/icons/google.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/google.svg"
        },
        "name": "PharosAssetIconGoogle",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "google"
        },
        "path": [
          "asset",
          "icon",
          "google"
        ]
      },
      "image": {
        "value": "assets/icons/image.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/image.svg"
        },
        "name": "PharosAssetIconImage",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "image"
        },
        "path": [
          "asset",
          "icon",
          "image"
        ]
      },
      "info-inverse": {
        "value": "assets/icons/info-inverse.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/info-inverse.svg"
        },
        "name": "PharosAssetIconInfoInverse",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "info-inverse"
        },
        "path": [
          "asset",
          "icon",
          "info-inverse"
        ]
      },
      "instagram": {
        "value": "assets/icons/instagram.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/instagram.svg"
        },
        "name": "PharosAssetIconInstagram",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "instagram"
        },
        "path": [
          "asset",
          "icon",
          "instagram"
        ]
      },
      "laptop": {
        "value": "assets/icons/laptop.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/laptop.svg"
        },
        "name": "PharosAssetIconLaptop",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "laptop"
        },
        "path": [
          "asset",
          "icon",
          "laptop"
        ]
      },
      "link-add": {
        "value": "assets/icons/link-add.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/link-add.svg"
        },
        "name": "PharosAssetIconLinkAdd",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "link-add"
        },
        "path": [
          "asset",
          "icon",
          "link-add"
        ]
      },
      "link-external": {
        "value": "assets/icons/link-external.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/link-external.svg"
        },
        "name": "PharosAssetIconLinkExternal",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "link-external"
        },
        "path": [
          "asset",
          "icon",
          "link-external"
        ]
      },
      "link": {
        "value": "assets/icons/link.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/link.svg"
        },
        "name": "PharosAssetIconLink",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "link"
        },
        "path": [
          "asset",
          "icon",
          "link"
        ]
      },
      "linkedin": {
        "value": "assets/icons/linkedin.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/linkedin.svg"
        },
        "name": "PharosAssetIconLinkedin",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "linkedin"
        },
        "path": [
          "asset",
          "icon",
          "linkedin"
        ]
      },
      "menu": {
        "value": "assets/icons/menu.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/menu.svg"
        },
        "name": "PharosAssetIconMenu",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "menu"
        },
        "path": [
          "asset",
          "icon",
          "menu"
        ]
      },
      "move": {
        "value": "assets/icons/move.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/move.svg"
        },
        "name": "PharosAssetIconMove",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "move"
        },
        "path": [
          "asset",
          "icon",
          "move"
        ]
      },
      "new": {
        "value": "assets/icons/new.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/new.svg"
        },
        "name": "PharosAssetIconNew",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "new"
        },
        "path": [
          "asset",
          "icon",
          "new"
        ]
      },
      "partial-circle": {
        "value": "assets/icons/partial-circle.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/partial-circle.svg"
        },
        "name": "PharosAssetIconPartialCircle",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "partial-circle"
        },
        "path": [
          "asset",
          "icon",
          "partial-circle"
        ]
      },
      "primary-source": {
        "value": "assets/icons/primary-source.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/primary-source.svg"
        },
        "name": "PharosAssetIconPrimarySource",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "primary-source"
        },
        "path": [
          "asset",
          "icon",
          "primary-source"
        ]
      },
      "profile": {
        "value": "assets/icons/profile.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/profile.svg"
        },
        "name": "PharosAssetIconProfile",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "profile"
        },
        "path": [
          "asset",
          "icon",
          "profile"
        ]
      },
      "question-inverse": {
        "value": "assets/icons/question-inverse.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/question-inverse.svg"
        },
        "name": "PharosAssetIconQuestionInverse",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "question-inverse"
        },
        "path": [
          "asset",
          "icon",
          "question-inverse"
        ]
      },
      "save": {
        "value": "assets/icons/save.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/save.svg"
        },
        "name": "PharosAssetIconSave",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "save"
        },
        "path": [
          "asset",
          "icon",
          "save"
        ]
      },
      "saved": {
        "value": "assets/icons/saved.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/saved.svg"
        },
        "name": "PharosAssetIconSaved",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "saved"
        },
        "path": [
          "asset",
          "icon",
          "saved"
        ]
      },
      "search": {
        "value": "assets/icons/search.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/search.svg"
        },
        "name": "PharosAssetIconSearch",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "search"
        },
        "path": [
          "asset",
          "icon",
          "search"
        ]
      },
      "share": {
        "value": "assets/icons/share.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/share.svg"
        },
        "name": "PharosAssetIconShare",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "share"
        },
        "path": [
          "asset",
          "icon",
          "share"
        ]
      },
      "shift-left": {
        "value": "assets/icons/shift-left.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/shift-left.svg"
        },
        "name": "PharosAssetIconShiftLeft",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "shift-left"
        },
        "path": [
          "asset",
          "icon",
          "shift-left"
        ]
      },
      "shift-right": {
        "value": "assets/icons/shift-right.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/shift-right.svg"
        },
        "name": "PharosAssetIconShiftRight",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "shift-right"
        },
        "path": [
          "asset",
          "icon",
          "shift-right"
        ]
      },
      "shift-up": {
        "value": "assets/icons/shift-up.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/shift-up.svg"
        },
        "name": "PharosAssetIconShiftUp",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "shift-up"
        },
        "path": [
          "asset",
          "icon",
          "shift-up"
        ]
      },
      "shift-down": {
        "value": "assets/icons/shift-down.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/shift-down.svg"
        },
        "name": "PharosAssetIconShiftDown",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "shift-down"
        },
        "path": [
          "asset",
          "icon",
          "shift-down"
        ]
      },
      "tumblr": {
        "value": "assets/icons/tumblr.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/tumblr.svg"
        },
        "name": "PharosAssetIconTumblr",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "tumblr"
        },
        "path": [
          "asset",
          "icon",
          "tumblr"
        ]
      },
      "twitter": {
        "value": "assets/icons/twitter.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/twitter.svg"
        },
        "name": "PharosAssetIconTwitter",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "twitter"
        },
        "path": [
          "asset",
          "icon",
          "twitter"
        ]
      },
      "video": {
        "value": "assets/icons/video.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/video.svg"
        },
        "name": "PharosAssetIconVideo",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "video"
        },
        "path": [
          "asset",
          "icon",
          "video"
        ]
      },
      "view-gallery": {
        "value": "assets/icons/view-gallery.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/view-gallery.svg"
        },
        "name": "PharosAssetIconViewGallery",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "view-gallery"
        },
        "path": [
          "asset",
          "icon",
          "view-gallery"
        ]
      },
      "view-grid": {
        "value": "assets/icons/view-grid.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/view-grid.svg"
        },
        "name": "PharosAssetIconViewGrid",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "view-grid"
        },
        "path": [
          "asset",
          "icon",
          "view-grid"
        ]
      },
      "view-list": {
        "value": "assets/icons/view-list.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/view-list.svg"
        },
        "name": "PharosAssetIconViewList",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "view-list"
        },
        "path": [
          "asset",
          "icon",
          "view-list"
        ]
      },
      "workspace": {
        "value": "assets/icons/workspace.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/workspace.svg"
        },
        "name": "PharosAssetIconWorkspace",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "workspace"
        },
        "path": [
          "asset",
          "icon",
          "workspace"
        ]
      },
      "workspace-selected": {
        "value": "assets/icons/workspace-selected.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/workspace-selected.svg"
        },
        "name": "PharosAssetIconWorkspaceSelected",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "workspace-selected"
        },
        "path": [
          "asset",
          "icon",
          "workspace-selected"
        ]
      },
      "youtube": {
        "value": "assets/icons/youtube.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/youtube.svg"
        },
        "name": "PharosAssetIconYoutube",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "youtube"
        },
        "path": [
          "asset",
          "icon",
          "youtube"
        ]
      },
      "zoom-in": {
        "value": "assets/icons/zoom-in.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/zoom-in.svg"
        },
        "name": "PharosAssetIconZoomIn",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "zoom-in"
        },
        "path": [
          "asset",
          "icon",
          "zoom-in"
        ]
      },
      "zoom-out": {
        "value": "assets/icons/zoom-out.svg",
        "filePath": "tokens/assets/icons.json",
        "isSource": true,
        "original": {
          "value": "assets/icons/zoom-out.svg"
        },
        "name": "PharosAssetIconZoomOut",
        "attributes": {
          "category": "asset",
          "type": "icon",
          "item": "zoom-out"
        },
        "path": [
          "asset",
          "icon",
          "zoom-out"
        ]
      }
    }
  },
  "breakpoint": {
    "small": {
      "value": "22.5rem",
      "comment": "360px",
      "filePath": "tokens/breakpoint/base.json",
      "isSource": true,
      "original": {
        "value": "22.5rem",
        "comment": "360px"
      },
      "name": "PharosBreakpointSmall",
      "attributes": {
        "category": "breakpoint",
        "type": "small"
      },
      "path": [
        "breakpoint",
        "small"
      ]
    },
    "medium": {
      "value": "48rem",
      "comment": "768px",
      "filePath": "tokens/breakpoint/base.json",
      "isSource": true,
      "original": {
        "value": "48rem",
        "comment": "768px"
      },
      "name": "PharosBreakpointMedium",
      "attributes": {
        "category": "breakpoint",
        "type": "medium"
      },
      "path": [
        "breakpoint",
        "medium"
      ]
    },
    "large": {
      "value": "66rem",
      "comment": "1056px",
      "filePath": "tokens/breakpoint/base.json",
      "isSource": true,
      "original": {
        "value": "66rem",
        "comment": "1056px"
      },
      "name": "PharosBreakpointLarge",
      "attributes": {
        "category": "breakpoint",
        "type": "large"
      },
      "path": [
        "breakpoint",
        "large"
      ]
    },
    "xlarge": {
      "value": "85rem",
      "comment": "1360px",
      "filePath": "tokens/breakpoint/base.json",
      "isSource": true,
      "original": {
        "value": "85rem",
        "comment": "1360px"
      },
      "name": "PharosBreakpointXlarge",
      "attributes": {
        "category": "breakpoint",
        "type": "xlarge"
      },
      "path": [
        "breakpoint",
        "xlarge"
      ]
    },
    "max": {
      "value": "99rem",
      "comment": "1584px",
      "filePath": "tokens/breakpoint/base.json",
      "isSource": true,
      "original": {
        "value": "99rem",
        "comment": "1584px"
      },
      "name": "PharosBreakpointMax",
      "attributes": {
        "category": "breakpoint",
        "type": "max"
      },
      "path": [
        "breakpoint",
        "max"
      ]
    }
  },
  "color": {
    "JSTOR red": {
      "value": "#990000",
      "group": "primary",
      "palette": "primary",
      "filePath": "tokens/color/base.json",
      "isSource": true,
      "original": {
        "value": "hsl(0, 100%, 30%)",
        "group": "primary",
        "palette": "primary"
      },
      "name": "PharosColorJstorRed",
      "attributes": {
        "category": "color",
        "type": "JSTOR red"
      },
      "path": [
        "color",
        "JSTOR red"
      ]
    },
    "Night blue": {
      "15": {
        "value": "#071d46",
        "group": "tint",
        "palette": "secondary",
        "order": "1",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "hsl(219, 82%, 15%)",
          "group": "tint",
          "palette": "secondary",
          "order": "1"
        },
        "name": "PharosColorNightBlue15",
        "attributes": {
          "category": "color",
          "type": "Night blue",
          "item": "15"
        },
        "path": [
          "color",
          "Night blue",
          "15"
        ]
      },
      "60": {
        "value": "#8091b3",
        "group": "tint",
        "palette": "secondary",
        "order": "2",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "hsl(219, 25%, 60%)",
          "group": "tint",
          "palette": "secondary",
          "order": "2"
        },
        "name": "PharosColorNightBlue60",
        "attributes": {
          "category": "color",
          "type": "Night blue",
          "item": "60"
        },
        "path": [
          "color",
          "Night blue",
          "60"
        ]
      },
      "base": {
        "value": "#0d3071",
        "group": "primary",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "hsl(219, 79.4%, 24.7%)",
          "group": "primary"
        },
        "name": "PharosColorNightBlueBase",
        "attributes": {
          "category": "color",
          "type": "Night blue",
          "item": "base"
        },
        "path": [
          "color",
          "Night blue",
          "base"
        ]
      }
    },
    "Glacier blue": {
      "40": {
        "value": "#0ba3c1",
        "group": "tint",
        "palette": "secondary",
        "order": "1",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "hsl(190, 89%, 40%)",
          "group": "tint",
          "palette": "secondary",
          "order": "1"
        },
        "name": "PharosColorGlacierBlue40",
        "attributes": {
          "category": "color",
          "type": "Glacier blue",
          "item": "40"
        },
        "path": [
          "color",
          "Glacier blue",
          "40"
        ]
      },
      "70": {
        "value": "#79deec",
        "group": "tint",
        "palette": "secondary",
        "order": "1",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "hsl(187, 75%, 70%)",
          "group": "tint",
          "palette": "secondary",
          "order": "1"
        },
        "name": "PharosColorGlacierBlue70",
        "attributes": {
          "category": "color",
          "type": "Glacier blue",
          "item": "70"
        },
        "path": [
          "color",
          "Glacier blue",
          "70"
        ]
      },
      "80": {
        "value": "#b4dee4",
        "group": "tint",
        "palette": "secondary",
        "order": "2",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "hsl(188, 47%, 80%)",
          "group": "tint",
          "palette": "secondary",
          "order": "2"
        },
        "name": "PharosColorGlacierBlue80",
        "attributes": {
          "category": "color",
          "type": "Glacier blue",
          "item": "80"
        },
        "path": [
          "color",
          "Glacier blue",
          "80"
        ]
      },
      "90": {
        "value": "#dcedef",
        "group": "tint",
        "palette": "secondary",
        "order": "2",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "hsl(186.3,37.3%,90%)",
          "group": "tint",
          "palette": "secondary",
          "order": "2"
        },
        "name": "PharosColorGlacierBlue90",
        "attributes": {
          "category": "color",
          "type": "Glacier blue",
          "item": "90"
        },
        "path": [
          "color",
          "Glacier blue",
          "90"
        ]
      },
      "base": {
        "value": "#27cae1",
        "group": "primary",
        "palette": "secondary",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "hsl(187.4, 75.6%, 51.8%)",
          "group": "primary",
          "palette": "secondary"
        },
        "name": "PharosColorGlacierBlueBase",
        "attributes": {
          "category": "color",
          "type": "Glacier blue",
          "item": "base"
        },
        "path": [
          "color",
          "Glacier blue",
          "base"
        ]
      }
    },
    "Living coral": {
      "50": {
        "value": "#c83737",
        "group": "tint",
        "palette": "secondary",
        "order": "1",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "hsl(0, 57%, 50%)",
          "group": "tint",
          "palette": "secondary",
          "order": "1"
        },
        "name": "PharosColorLivingCoral50",
        "attributes": {
          "category": "color",
          "type": "Living coral",
          "item": "50"
        },
        "path": [
          "color",
          "Living coral",
          "50"
        ]
      },
      "53": {
        "value": "#dd3431",
        "group": "tint",
        "palette": "secondary",
        "order": "1",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "hsl(1, 72%, 53%)",
          "group": "tint",
          "palette": "secondary",
          "order": "1"
        },
        "name": "PharosColorLivingCoral53",
        "attributes": {
          "category": "color",
          "type": "Living coral",
          "item": "53"
        },
        "path": [
          "color",
          "Living coral",
          "53"
        ]
      },
      "80": {
        "value": "#fc9c9c",
        "group": "tint",
        "palette": "secondary",
        "order": "2",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "hsl(0, 94%, 80%)",
          "group": "tint",
          "palette": "secondary",
          "order": "2"
        },
        "name": "PharosColorLivingCoral80",
        "attributes": {
          "category": "color",
          "type": "Living coral",
          "item": "80"
        },
        "path": [
          "color",
          "Living coral",
          "80"
        ]
      },
      "90": {
        "value": "#f4d7d7",
        "group": "tint",
        "palette": "secondary",
        "order": "3",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "hsl(0, 57%, 90%)",
          "group": "tint",
          "palette": "secondary",
          "order": "3"
        },
        "name": "PharosColorLivingCoral90",
        "attributes": {
          "category": "color",
          "type": "Living coral",
          "item": "90"
        },
        "path": [
          "color",
          "Living coral",
          "90"
        ]
      },
      "base": {
        "value": "#fb4848",
        "group": "secondary",
        "palette": "secondary",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "hsl(0, 95.7%, 63.3%)",
          "group": "secondary",
          "palette": "secondary"
        },
        "name": "PharosColorLivingCoralBase",
        "attributes": {
          "category": "color",
          "type": "Living coral",
          "item": "base"
        },
        "path": [
          "color",
          "Living coral",
          "base"
        ]
      }
    },
    "Marble gray": {
      "10": {
        "value": "#1a1a19",
        "group": "neutrals",
        "palette": "grayscale",
        "order": "1",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "hsl(60, 2%, 10%)",
          "group": "neutrals",
          "palette": "grayscale",
          "order": "1"
        },
        "name": "PharosColorMarbleGray10",
        "attributes": {
          "category": "color",
          "type": "Marble gray",
          "item": "10"
        },
        "path": [
          "color",
          "Marble gray",
          "10"
        ]
      },
      "20": {
        "value": "#343332",
        "group": "neutrals",
        "palette": "grayscale",
        "order": "2",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "hsl(30, 2%, 20%)",
          "group": "neutrals",
          "palette": "grayscale",
          "order": "2"
        },
        "name": "PharosColorMarbleGray20",
        "attributes": {
          "category": "color",
          "type": "Marble gray",
          "item": "20"
        },
        "path": [
          "color",
          "Marble gray",
          "20"
        ]
      },
      "40": {
        "value": "#676765",
        "group": "neutrals",
        "palette": "grayscale",
        "order": "3",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "hsl(60, 1%, 40%)",
          "group": "neutrals",
          "palette": "grayscale",
          "order": "3"
        },
        "name": "PharosColorMarbleGray40",
        "attributes": {
          "category": "color",
          "type": "Marble gray",
          "item": "40"
        },
        "path": [
          "color",
          "Marble gray",
          "40"
        ]
      },
      "50": {
        "value": "#81807e",
        "group": "neutrals",
        "palette": "grayscale",
        "order": "4",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "hsl(40, 1.2%, 50%)",
          "group": "neutrals",
          "palette": "grayscale",
          "order": "4"
        },
        "name": "PharosColorMarbleGray50",
        "attributes": {
          "category": "color",
          "type": "Marble gray",
          "item": "50"
        },
        "path": [
          "color",
          "Marble gray",
          "50"
        ]
      },
      "80": {
        "value": "#d1cfc7",
        "group": "neutrals",
        "palette": "grayscale",
        "order": "5",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "hsl(48, 9.8%, 80%)",
          "group": "neutrals",
          "palette": "grayscale",
          "order": "5"
        },
        "name": "PharosColorMarbleGray80",
        "attributes": {
          "category": "color",
          "type": "Marble gray",
          "item": "80"
        },
        "path": [
          "color",
          "Marble gray",
          "80"
        ]
      },
      "94": {
        "value": "#f2f1ed",
        "group": "neutrals",
        "palette": "grayscale",
        "order": "6",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "hsl(48, 16%, 94%)",
          "group": "neutrals",
          "palette": "grayscale",
          "order": "6"
        },
        "name": "PharosColorMarbleGray94",
        "attributes": {
          "category": "color",
          "type": "Marble gray",
          "item": "94"
        },
        "path": [
          "color",
          "Marble gray",
          "94"
        ]
      },
      "97": {
        "value": "#f9f8f6",
        "group": "neutrals",
        "palette": "grayscale",
        "order": "7",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "hsl(40, 20%, 97.1%)",
          "group": "neutrals",
          "palette": "grayscale",
          "order": "7"
        },
        "name": "PharosColorMarbleGray97",
        "attributes": {
          "category": "color",
          "type": "Marble gray",
          "item": "97"
        },
        "path": [
          "color",
          "Marble gray",
          "97"
        ]
      },
      "base": {
        "value": "#eae8e1",
        "group": "secondary, neutrals",
        "palette": "grayscale",
        "order": "5",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "hsl(46.7, 17.6%, 90%)",
          "group": "secondary, neutrals",
          "palette": "grayscale",
          "order": "5"
        },
        "name": "PharosColorMarbleGrayBase",
        "attributes": {
          "category": "color",
          "type": "Marble gray",
          "item": "base"
        },
        "path": [
          "color",
          "Marble gray",
          "base"
        ]
      }
    },
    "Black": {
      "value": "#000000",
      "group": "secondary",
      "palette": "primary",
      "filePath": "tokens/color/base.json",
      "isSource": true,
      "original": {
        "value": "hsl(0, 0%, 0%)",
        "group": "secondary",
        "palette": "primary"
      },
      "name": "PharosColorBlack",
      "attributes": {
        "category": "color",
        "type": "Black"
      },
      "path": [
        "color",
        "Black"
      ]
    },
    "White": {
      "value": "#ffffff",
      "palette": "primary",
      "filePath": "tokens/color/base.json",
      "isSource": true,
      "original": {
        "value": "hsl(0, 0%, 100%)",
        "palette": "primary"
      },
      "name": "PharosColorWhite",
      "attributes": {
        "category": "color",
        "type": "White"
      },
      "path": [
        "color",
        "White"
      ]
    },
    "Yellow": {
      "97": {
        "value": "#fdf9f2",
        "group": "",
        "palette": "feedback",
        "order": "1",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "hsl(38.2,73.3%,97.1%)",
          "group": "",
          "palette": "feedback",
          "order": "1"
        },
        "name": "PharosColorYellow97",
        "attributes": {
          "category": "color",
          "type": "Yellow",
          "item": "97"
        },
        "path": [
          "color",
          "Yellow",
          "97"
        ]
      },
      "base": {
        "value": "#faa926",
        "group": "",
        "palette": "feedback",
        "order": "1",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "hsl(37.1, 95.5%, 56.5%)",
          "group": "",
          "palette": "feedback",
          "order": "1"
        },
        "name": "PharosColorYellowBase",
        "attributes": {
          "category": "color",
          "type": "Yellow",
          "item": "base"
        },
        "path": [
          "color",
          "Yellow",
          "base"
        ]
      }
    },
    "Green": {
      "93": {
        "value": "#e9f1eb",
        "group": "",
        "palette": "feedback",
        "order": "1",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "hsl(135,22.2%,92.9%)",
          "group": "",
          "palette": "feedback",
          "order": "1"
        },
        "name": "PharosColorGreen93",
        "attributes": {
          "category": "color",
          "type": "Green",
          "item": "93"
        },
        "path": [
          "color",
          "Green",
          "93"
        ]
      },
      "base": {
        "value": "#268241",
        "group": "",
        "palette": "feedback",
        "order": "1",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "hsl(137.6, 54.8%, 32.9%)",
          "group": "",
          "palette": "feedback",
          "order": "1"
        },
        "name": "PharosColorGreenBase",
        "attributes": {
          "category": "color",
          "type": "Green",
          "item": "base"
        },
        "path": [
          "color",
          "Green",
          "base"
        ]
      }
    },
    "interactive": {
      "primary": {
        "value": "#990000",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "{color.JSTOR red.value}"
        },
        "name": "PharosColorInteractivePrimary",
        "attributes": {
          "category": "color",
          "type": "interactive",
          "item": "primary"
        },
        "path": [
          "color",
          "interactive",
          "primary"
        ]
      },
      "secondary": {
        "value": "#000000",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "{color.Black.value}"
        },
        "name": "PharosColorInteractiveSecondary",
        "attributes": {
          "category": "color",
          "type": "interactive",
          "item": "secondary"
        },
        "path": [
          "color",
          "interactive",
          "secondary"
        ]
      },
      "tertiary": {
        "value": "#ffffff",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "{color.White.value}"
        },
        "name": "PharosColorInteractiveTertiary",
        "attributes": {
          "category": "color",
          "type": "interactive",
          "item": "tertiary"
        },
        "path": [
          "color",
          "interactive",
          "tertiary"
        ]
      }
    },
    "ui": {
      "10": {
        "value": "#ffffff",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "{color.White.value}"
        },
        "name": "PharosColorUi10",
        "attributes": {
          "category": "color",
          "type": "ui",
          "item": "10"
        },
        "path": [
          "color",
          "ui",
          "10"
        ]
      },
      "20": {
        "value": "#f2f1ed",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "{color.Marble gray.94.value}"
        },
        "name": "PharosColorUi20",
        "attributes": {
          "category": "color",
          "type": "ui",
          "item": "20"
        },
        "path": [
          "color",
          "ui",
          "20"
        ]
      },
      "30": {
        "value": "#eae8e1",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "{color.Marble gray.base.value}"
        },
        "name": "PharosColorUi30",
        "attributes": {
          "category": "color",
          "type": "ui",
          "item": "30"
        },
        "path": [
          "color",
          "ui",
          "30"
        ]
      },
      "40": {
        "value": "#d1cfc7",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "{color.Marble gray.80.value}"
        },
        "name": "PharosColorUi40",
        "attributes": {
          "category": "color",
          "type": "ui",
          "item": "40"
        },
        "path": [
          "color",
          "ui",
          "40"
        ]
      },
      "50": {
        "value": "#81807e",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "{color.Marble gray.50.value}"
        },
        "name": "PharosColorUi50",
        "attributes": {
          "category": "color",
          "type": "ui",
          "item": "50"
        },
        "path": [
          "color",
          "ui",
          "50"
        ]
      }
    },
    "disabled": {
      "value": "#eae8e1",
      "filePath": "tokens/color/base.json",
      "isSource": true,
      "original": {
        "value": "{color.ui.30.value}"
      },
      "name": "PharosColorDisabled",
      "attributes": {
        "category": "color",
        "type": "disabled"
      },
      "path": [
        "color",
        "disabled"
      ]
    },
    "overlay": {
      "value": "#000000",
      "filePath": "tokens/color/base.json",
      "isSource": true,
      "original": {
        "value": "hsla(0, 0%, 0%, 0.5)"
      },
      "name": "PharosColorOverlay",
      "attributes": {
        "category": "color",
        "type": "overlay"
      },
      "path": [
        "color",
        "overlay"
      ]
    },
    "feedback": {
      "error": {
        "value": "#dd3431",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "{color.Living coral.53.value}"
        },
        "name": "PharosColorFeedbackError",
        "attributes": {
          "category": "color",
          "type": "feedback",
          "item": "error"
        },
        "path": [
          "color",
          "feedback",
          "error"
        ]
      },
      "success": {
        "value": "#268241",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "{color.Green.base.value}"
        },
        "name": "PharosColorFeedbackSuccess",
        "attributes": {
          "category": "color",
          "type": "feedback",
          "item": "success"
        },
        "path": [
          "color",
          "feedback",
          "success"
        ]
      },
      "warning": {
        "value": "#faa926",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "{color.Yellow.base.value}"
        },
        "name": "PharosColorFeedbackWarning",
        "attributes": {
          "category": "color",
          "type": "feedback",
          "item": "warning"
        },
        "path": [
          "color",
          "feedback",
          "warning"
        ]
      },
      "info": {
        "value": "#0ba3c1",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "{color.Glacier blue.40.value}"
        },
        "name": "PharosColorFeedbackInfo",
        "attributes": {
          "category": "color",
          "type": "feedback",
          "item": "info"
        },
        "path": [
          "color",
          "feedback",
          "info"
        ]
      }
    },
    "text": {
      "10": {
        "value": "#1a1a19",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "{color.Marble gray.10.value}"
        },
        "name": "PharosColorText10",
        "attributes": {
          "category": "color",
          "type": "text",
          "item": "10"
        },
        "path": [
          "color",
          "text",
          "10"
        ]
      },
      "20": {
        "value": "#343332",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "{color.Marble gray.20.value}"
        },
        "name": "PharosColorText20",
        "attributes": {
          "category": "color",
          "type": "text",
          "item": "20"
        },
        "path": [
          "color",
          "text",
          "20"
        ]
      },
      "40": {
        "value": "#676765",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "{color.Marble gray.40.value}"
        },
        "name": "PharosColorText40",
        "attributes": {
          "category": "color",
          "type": "text",
          "item": "40"
        },
        "path": [
          "color",
          "text",
          "40"
        ]
      },
      "50": {
        "value": "#81807e",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "{color.Marble gray.50.value}"
        },
        "name": "PharosColorText50",
        "attributes": {
          "category": "color",
          "type": "text",
          "item": "50"
        },
        "path": [
          "color",
          "text",
          "50"
        ]
      },
      "base": {
        "value": "#000000",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "{color.Black.value}"
        },
        "name": "PharosColorTextBase",
        "attributes": {
          "category": "color",
          "type": "text",
          "item": "base"
        },
        "path": [
          "color",
          "text",
          "base"
        ]
      },
      "disabled": {
        "value": "#676765",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "{color.text.40.value}"
        },
        "name": "PharosColorTextDisabled",
        "attributes": {
          "category": "color",
          "type": "text",
          "item": "disabled"
        },
        "path": [
          "color",
          "text",
          "disabled"
        ]
      },
      "placeholder": {
        "value": "#676765",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "{color.text.40.value}"
        },
        "name": "PharosColorTextPlaceholder",
        "attributes": {
          "category": "color",
          "type": "text",
          "item": "placeholder"
        },
        "path": [
          "color",
          "text",
          "placeholder"
        ]
      },
      "white": {
        "value": "#ffffff",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "{color.White.value}"
        },
        "name": "PharosColorTextWhite",
        "attributes": {
          "category": "color",
          "type": "text",
          "item": "white"
        },
        "path": [
          "color",
          "text",
          "white"
        ]
      }
    },
    "focus": {
      "value": "#0ba3c1",
      "filePath": "tokens/color/base.json",
      "isSource": true,
      "original": {
        "value": "{color.Glacier blue.40.value}"
      },
      "name": "PharosColorFocus",
      "attributes": {
        "category": "color",
        "type": "focus"
      },
      "path": [
        "color",
        "focus"
      ]
    },
    "hover": {
      "primary": {
        "value": "#990000",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "{color.interactive.primary.value}"
        },
        "name": "PharosColorHoverPrimary",
        "attributes": {
          "category": "color",
          "type": "hover",
          "item": "primary"
        },
        "path": [
          "color",
          "hover",
          "primary"
        ]
      },
      "secondary": {
        "value": "#ffffff",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "{color.ui.10.value}"
        },
        "name": "PharosColorHoverSecondary",
        "attributes": {
          "category": "color",
          "type": "hover",
          "item": "secondary"
        },
        "path": [
          "color",
          "hover",
          "secondary"
        ]
      },
      "row": {
        "value": "#f2f1ed",
        "filePath": "tokens/color/base.json",
        "isSource": true,
        "original": {
          "value": "{color.ui.20.value}"
        },
        "name": "PharosColorHoverRow",
        "attributes": {
          "category": "color",
          "type": "hover",
          "item": "row"
        },
        "path": [
          "color",
          "hover",
          "row"
        ]
      }
    }
  },
  "alert": {
    "color": {
      "background": {
        "base": {
          "value": "#f2f1ed",
          "filePath": "tokens/components/alert.json",
          "isSource": true,
          "original": {
            "value": "{color.Marble gray.94.value}"
          },
          "name": "PharosAlertColorBackgroundBase",
          "attributes": {
            "category": "alert",
            "type": "color",
            "item": "background",
            "subitem": "base"
          },
          "path": [
            "alert",
            "color",
            "background",
            "base"
          ]
        },
        "info": {
          "value": "#dcedef",
          "filePath": "tokens/components/alert.json",
          "isSource": true,
          "original": {
            "value": "{color.Glacier blue.90.value}"
          },
          "name": "PharosAlertColorBackgroundInfo",
          "attributes": {
            "category": "alert",
            "type": "color",
            "item": "background",
            "subitem": "info"
          },
          "path": [
            "alert",
            "color",
            "background",
            "info"
          ]
        },
        "error": {
          "value": "#f4d7d7",
          "filePath": "tokens/components/alert.json",
          "isSource": true,
          "original": {
            "value": "{color.Living coral.90.value}"
          },
          "name": "PharosAlertColorBackgroundError",
          "attributes": {
            "category": "alert",
            "type": "color",
            "item": "background",
            "subitem": "error"
          },
          "path": [
            "alert",
            "color",
            "background",
            "error"
          ]
        },
        "success": {
          "value": "#e9f1eb",
          "filePath": "tokens/components/alert.json",
          "isSource": true,
          "original": {
            "value": "{color.Green.93.value}"
          },
          "name": "PharosAlertColorBackgroundSuccess",
          "attributes": {
            "category": "alert",
            "type": "color",
            "item": "background",
            "subitem": "success"
          },
          "path": [
            "alert",
            "color",
            "background",
            "success"
          ]
        },
        "warning": {
          "value": "#fdf9f2",
          "filePath": "tokens/components/alert.json",
          "isSource": true,
          "original": {
            "value": "{color.Yellow.97.value}"
          },
          "name": "PharosAlertColorBackgroundWarning",
          "attributes": {
            "category": "alert",
            "type": "color",
            "item": "background",
            "subitem": "warning"
          },
          "path": [
            "alert",
            "color",
            "background",
            "warning"
          ]
        }
      },
      "icon": {
        "base": {
          "value": "#000000",
          "filePath": "tokens/components/alert.json",
          "isSource": true,
          "original": {
            "value": "{color.Black.value}"
          },
          "name": "PharosAlertColorIconBase",
          "attributes": {
            "category": "alert",
            "type": "color",
            "item": "icon",
            "subitem": "base"
          },
          "path": [
            "alert",
            "color",
            "icon",
            "base"
          ]
        },
        "info": {
          "value": "#0ba3c1",
          "filePath": "tokens/components/alert.json",
          "isSource": true,
          "original": {
            "value": "{color.Glacier blue.40.value}"
          },
          "name": "PharosAlertColorIconInfo",
          "attributes": {
            "category": "alert",
            "type": "color",
            "item": "icon",
            "subitem": "info"
          },
          "path": [
            "alert",
            "color",
            "icon",
            "info"
          ]
        },
        "error": {
          "value": "#dd3431",
          "filePath": "tokens/components/alert.json",
          "isSource": true,
          "original": {
            "value": "{color.feedback.error.value}"
          },
          "name": "PharosAlertColorIconError",
          "attributes": {
            "category": "alert",
            "type": "color",
            "item": "icon",
            "subitem": "error"
          },
          "path": [
            "alert",
            "color",
            "icon",
            "error"
          ]
        },
        "success": {
          "value": "#268241",
          "filePath": "tokens/components/alert.json",
          "isSource": true,
          "original": {
            "value": "{color.feedback.success.value}"
          },
          "name": "PharosAlertColorIconSuccess",
          "attributes": {
            "category": "alert",
            "type": "color",
            "item": "icon",
            "subitem": "success"
          },
          "path": [
            "alert",
            "color",
            "icon",
            "success"
          ]
        },
        "warning": {
          "value": "#faa926",
          "filePath": "tokens/components/alert.json",
          "isSource": true,
          "original": {
            "value": "{color.feedback.warning.value}"
          },
          "name": "PharosAlertColorIconWarning",
          "attributes": {
            "category": "alert",
            "type": "color",
            "item": "icon",
            "subitem": "warning"
          },
          "path": [
            "alert",
            "color",
            "icon",
            "warning"
          ]
        }
      },
      "text": {
        "base": {
          "value": "#000000",
          "filePath": "tokens/components/alert.json",
          "isSource": true,
          "original": {
            "value": "{color.text.base.value}"
          },
          "name": "PharosAlertColorTextBase",
          "attributes": {
            "category": "alert",
            "type": "color",
            "item": "text",
            "subitem": "base"
          },
          "path": [
            "alert",
            "color",
            "text",
            "base"
          ]
        },
        "inverse": {
          "value": "#ffffff",
          "filePath": "tokens/components/alert.json",
          "isSource": true,
          "original": {
            "value": "{color.text.white.value}"
          },
          "name": "PharosAlertColorTextInverse",
          "attributes": {
            "category": "alert",
            "type": "color",
            "item": "text",
            "subitem": "inverse"
          },
          "path": [
            "alert",
            "color",
            "text",
            "inverse"
          ]
        }
      },
      "link": {
        "base": {
          "value": "#000000",
          "filePath": "tokens/components/alert.json",
          "isSource": true,
          "original": {
            "value": "{color.interactive.secondary.value}"
          },
          "name": "PharosAlertColorLinkBase",
          "attributes": {
            "category": "alert",
            "type": "color",
            "item": "link",
            "subitem": "base"
          },
          "path": [
            "alert",
            "color",
            "link",
            "base"
          ]
        },
        "inverse": {
          "value": "#ffffff",
          "filePath": "tokens/components/alert.json",
          "isSource": true,
          "original": {
            "value": "{color.White.value}"
          },
          "name": "PharosAlertColorLinkInverse",
          "attributes": {
            "category": "alert",
            "type": "color",
            "item": "link",
            "subitem": "inverse"
          },
          "path": [
            "alert",
            "color",
            "link",
            "inverse"
          ]
        }
      },
      "border": {
        "base": {
          "value": "#f2f1ed",
          "filePath": "tokens/components/alert.json",
          "isSource": true,
          "original": {
            "value": "{color.Marble gray.94.value}"
          },
          "name": "PharosAlertColorBorderBase",
          "attributes": {
            "category": "alert",
            "type": "color",
            "item": "border",
            "subitem": "base"
          },
          "path": [
            "alert",
            "color",
            "border",
            "base"
          ]
        },
        "info": {
          "value": "#0ba3c1",
          "filePath": "tokens/components/alert.json",
          "isSource": true,
          "original": {
            "value": "{color.Glacier blue.40.value}"
          },
          "name": "PharosAlertColorBorderInfo",
          "attributes": {
            "category": "alert",
            "type": "color",
            "item": "border",
            "subitem": "info"
          },
          "path": [
            "alert",
            "color",
            "border",
            "info"
          ]
        },
        "error": {
          "value": "#dd3431",
          "filePath": "tokens/components/alert.json",
          "isSource": true,
          "original": {
            "value": "{color.feedback.error.value}"
          },
          "name": "PharosAlertColorBorderError",
          "attributes": {
            "category": "alert",
            "type": "color",
            "item": "border",
            "subitem": "error"
          },
          "path": [
            "alert",
            "color",
            "border",
            "error"
          ]
        },
        "success": {
          "value": "#268241",
          "filePath": "tokens/components/alert.json",
          "isSource": true,
          "original": {
            "value": "{color.feedback.success.value}"
          },
          "name": "PharosAlertColorBorderSuccess",
          "attributes": {
            "category": "alert",
            "type": "color",
            "item": "border",
            "subitem": "success"
          },
          "path": [
            "alert",
            "color",
            "border",
            "success"
          ]
        },
        "warning": {
          "value": "#faa926",
          "filePath": "tokens/components/alert.json",
          "isSource": true,
          "original": {
            "value": "{color.feedback.warning.value}"
          },
          "name": "PharosAlertColorBorderWarning",
          "attributes": {
            "category": "alert",
            "type": "color",
            "item": "border",
            "subitem": "warning"
          },
          "path": [
            "alert",
            "color",
            "border",
            "warning"
          ]
        }
      }
    }
  },
  "button": {
    "padding": {
      "base": {
        "value": "0.25rem",
        "filePath": "tokens/components/button.json",
        "isSource": true,
        "original": {
          "value": "{spacing.one-quarter-x.value}"
        },
        "name": "PharosButtonPaddingBase",
        "attributes": {
          "category": "button",
          "type": "padding",
          "item": "base"
        },
        "path": [
          "button",
          "padding",
          "base"
        ]
      },
      "condensed": {
        "value": "0.125rem",
        "filePath": "tokens/components/button.json",
        "isSource": true,
        "original": {
          "value": "{spacing.one-eighth-x.value}"
        },
        "name": "PharosButtonPaddingCondensed",
        "attributes": {
          "category": "button",
          "type": "padding",
          "item": "condensed"
        },
        "path": [
          "button",
          "padding",
          "condensed"
        ]
      },
      "large": {
        "value": "0.5rem",
        "filePath": "tokens/components/button.json",
        "isSource": true,
        "original": {
          "value": "{spacing.one-half-x.value}"
        },
        "name": "PharosButtonPaddingLarge",
        "attributes": {
          "category": "button",
          "type": "padding",
          "item": "large"
        },
        "path": [
          "button",
          "padding",
          "large"
        ]
      }
    },
    "color": {
      "base": {
        "primary": {
          "background": {
            "base": {
              "value": "#990000",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.interactive.primary.value}"
              },
              "name": "PharosButtonColorBasePrimaryBackgroundBase",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "primary",
                "state": "background"
              },
              "path": [
                "button",
                "color",
                "base",
                "primary",
                "background",
                "base"
              ]
            },
            "hover": {
              "value": "transparent",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "transparent"
              },
              "name": "PharosButtonColorBasePrimaryBackgroundHover",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "primary",
                "state": "background"
              },
              "path": [
                "button",
                "color",
                "base",
                "primary",
                "background",
                "hover"
              ]
            },
            "disabled": {
              "value": "#eae8e1",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.disabled.value}"
              },
              "name": "PharosButtonColorBasePrimaryBackgroundDisabled",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "primary",
                "state": "background"
              },
              "path": [
                "button",
                "color",
                "base",
                "primary",
                "background",
                "disabled"
              ]
            }
          },
          "text": {
            "base": {
              "value": "#ffffff",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.text.white.value}"
              },
              "name": "PharosButtonColorBasePrimaryTextBase",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "primary",
                "state": "text"
              },
              "path": [
                "button",
                "color",
                "base",
                "primary",
                "text",
                "base"
              ]
            },
            "hover": {
              "value": "#990000",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.interactive.primary.value}"
              },
              "name": "PharosButtonColorBasePrimaryTextHover",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "primary",
                "state": "text"
              },
              "path": [
                "button",
                "color",
                "base",
                "primary",
                "text",
                "hover"
              ]
            },
            "disabled": {
              "value": "#676765",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.text.disabled.value}"
              },
              "name": "PharosButtonColorBasePrimaryTextDisabled",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "primary",
                "state": "text"
              },
              "path": [
                "button",
                "color",
                "base",
                "primary",
                "text",
                "disabled"
              ]
            }
          },
          "border": {
            "base": {
              "value": "#990000",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.interactive.primary.value}"
              },
              "name": "PharosButtonColorBasePrimaryBorderBase",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "primary",
                "state": "border"
              },
              "path": [
                "button",
                "color",
                "base",
                "primary",
                "border",
                "base"
              ]
            },
            "hover": {
              "value": "#990000",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.interactive.primary.value}"
              },
              "name": "PharosButtonColorBasePrimaryBorderHover",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "primary",
                "state": "border"
              },
              "path": [
                "button",
                "color",
                "base",
                "primary",
                "border",
                "hover"
              ]
            },
            "disabled": {
              "value": "#eae8e1",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.disabled.value}"
              },
              "name": "PharosButtonColorBasePrimaryBorderDisabled",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "primary",
                "state": "border"
              },
              "path": [
                "button",
                "color",
                "base",
                "primary",
                "border",
                "disabled"
              ]
            }
          }
        },
        "secondary": {
          "background": {
            "base": {
              "value": "transparent",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "transparent"
              },
              "name": "PharosButtonColorBaseSecondaryBackgroundBase",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "secondary",
                "state": "background"
              },
              "path": [
                "button",
                "color",
                "base",
                "secondary",
                "background",
                "base"
              ]
            },
            "hover": {
              "value": "transparent",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "transparent"
              },
              "name": "PharosButtonColorBaseSecondaryBackgroundHover",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "secondary",
                "state": "background"
              },
              "path": [
                "button",
                "color",
                "base",
                "secondary",
                "background",
                "hover"
              ]
            },
            "disabled": {
              "value": "#eae8e1",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.disabled.value}"
              },
              "name": "PharosButtonColorBaseSecondaryBackgroundDisabled",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "secondary",
                "state": "background"
              },
              "path": [
                "button",
                "color",
                "base",
                "secondary",
                "background",
                "disabled"
              ]
            }
          },
          "text": {
            "base": {
              "value": "#000000",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.text.base.value}"
              },
              "name": "PharosButtonColorBaseSecondaryTextBase",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "secondary",
                "state": "text"
              },
              "path": [
                "button",
                "color",
                "base",
                "secondary",
                "text",
                "base"
              ]
            },
            "hover": {
              "value": "#990000",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.interactive.primary.value}"
              },
              "name": "PharosButtonColorBaseSecondaryTextHover",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "secondary",
                "state": "text"
              },
              "path": [
                "button",
                "color",
                "base",
                "secondary",
                "text",
                "hover"
              ]
            },
            "disabled": {
              "value": "#676765",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.text.disabled.value}"
              },
              "name": "PharosButtonColorBaseSecondaryTextDisabled",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "secondary",
                "state": "text"
              },
              "path": [
                "button",
                "color",
                "base",
                "secondary",
                "text",
                "disabled"
              ]
            }
          },
          "border": {
            "base": {
              "value": "#d1cfc7",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.ui.40.value}"
              },
              "name": "PharosButtonColorBaseSecondaryBorderBase",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "secondary",
                "state": "border"
              },
              "path": [
                "button",
                "color",
                "base",
                "secondary",
                "border",
                "base"
              ]
            },
            "hover": {
              "value": "#990000",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.interactive.primary.value}"
              },
              "name": "PharosButtonColorBaseSecondaryBorderHover",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "secondary",
                "state": "border"
              },
              "path": [
                "button",
                "color",
                "base",
                "secondary",
                "border",
                "hover"
              ]
            },
            "disabled": {
              "value": "#eae8e1",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.disabled.value}"
              },
              "name": "PharosButtonColorBaseSecondaryBorderDisabled",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "secondary",
                "state": "border"
              },
              "path": [
                "button",
                "color",
                "base",
                "secondary",
                "border",
                "disabled"
              ]
            }
          }
        },
        "subtle": {
          "background": {
            "base": {
              "value": "transparent",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "transparent"
              },
              "name": "PharosButtonColorBaseSubtleBackgroundBase",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "subtle",
                "state": "background"
              },
              "path": [
                "button",
                "color",
                "base",
                "subtle",
                "background",
                "base"
              ]
            },
            "hover": {
              "value": "#f2f1ed",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.ui.20.value}"
              },
              "name": "PharosButtonColorBaseSubtleBackgroundHover",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "subtle",
                "state": "background"
              },
              "path": [
                "button",
                "color",
                "base",
                "subtle",
                "background",
                "hover"
              ]
            },
            "disabled": {
              "value": "transparent",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "transparent"
              },
              "name": "PharosButtonColorBaseSubtleBackgroundDisabled",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "subtle",
                "state": "background"
              },
              "path": [
                "button",
                "color",
                "base",
                "subtle",
                "background",
                "disabled"
              ]
            }
          },
          "text": {
            "base": {
              "value": "#000000",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.text.base.value}"
              },
              "name": "PharosButtonColorBaseSubtleTextBase",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "subtle",
                "state": "text"
              },
              "path": [
                "button",
                "color",
                "base",
                "subtle",
                "text",
                "base"
              ]
            },
            "hover": {
              "value": "#990000",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.interactive.primary.value}"
              },
              "name": "PharosButtonColorBaseSubtleTextHover",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "subtle",
                "state": "text"
              },
              "path": [
                "button",
                "color",
                "base",
                "subtle",
                "text",
                "hover"
              ]
            },
            "disabled": {
              "value": "#676765",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.text.disabled.value}"
              },
              "name": "PharosButtonColorBaseSubtleTextDisabled",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "subtle",
                "state": "text"
              },
              "path": [
                "button",
                "color",
                "base",
                "subtle",
                "text",
                "disabled"
              ]
            }
          },
          "border": {
            "base": {
              "value": "transparent",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "transparent"
              },
              "name": "PharosButtonColorBaseSubtleBorderBase",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "subtle",
                "state": "border"
              },
              "path": [
                "button",
                "color",
                "base",
                "subtle",
                "border",
                "base"
              ]
            },
            "hover": {
              "value": "#f2f1ed",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.ui.20.value}"
              },
              "name": "PharosButtonColorBaseSubtleBorderHover",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "subtle",
                "state": "border"
              },
              "path": [
                "button",
                "color",
                "base",
                "subtle",
                "border",
                "hover"
              ]
            },
            "disabled": {
              "value": "transparent",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "transparent"
              },
              "name": "PharosButtonColorBaseSubtleBorderDisabled",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "subtle",
                "state": "border"
              },
              "path": [
                "button",
                "color",
                "base",
                "subtle",
                "border",
                "disabled"
              ]
            }
          }
        },
        "overlay": {
          "background": {
            "base": {
              "value": "#1a1a19",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.Marble gray.10.value}"
              },
              "name": "PharosButtonColorBaseOverlayBackgroundBase",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "overlay",
                "state": "background"
              },
              "path": [
                "button",
                "color",
                "base",
                "overlay",
                "background",
                "base"
              ]
            },
            "hover": {
              "value": "#343332",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.Marble gray.20.value}"
              },
              "name": "PharosButtonColorBaseOverlayBackgroundHover",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "overlay",
                "state": "background"
              },
              "path": [
                "button",
                "color",
                "base",
                "overlay",
                "background",
                "hover"
              ]
            },
            "disabled": {
              "value": "#eae8e1",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.disabled.value}"
              },
              "name": "PharosButtonColorBaseOverlayBackgroundDisabled",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "overlay",
                "state": "background"
              },
              "path": [
                "button",
                "color",
                "base",
                "overlay",
                "background",
                "disabled"
              ]
            }
          },
          "text": {
            "base": {
              "value": "#ffffff",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.text.white.value}"
              },
              "name": "PharosButtonColorBaseOverlayTextBase",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "overlay",
                "state": "text"
              },
              "path": [
                "button",
                "color",
                "base",
                "overlay",
                "text",
                "base"
              ]
            },
            "hover": {
              "value": "#ffffff",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.text.white.value}"
              },
              "name": "PharosButtonColorBaseOverlayTextHover",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "overlay",
                "state": "text"
              },
              "path": [
                "button",
                "color",
                "base",
                "overlay",
                "text",
                "hover"
              ]
            },
            "disabled": {
              "value": "#676765",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.text.disabled.value}"
              },
              "name": "PharosButtonColorBaseOverlayTextDisabled",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "overlay",
                "state": "text"
              },
              "path": [
                "button",
                "color",
                "base",
                "overlay",
                "text",
                "disabled"
              ]
            }
          },
          "border": {
            "base": {
              "value": "#1a1a19",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.Marble gray.10.value}"
              },
              "name": "PharosButtonColorBaseOverlayBorderBase",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "overlay",
                "state": "border"
              },
              "path": [
                "button",
                "color",
                "base",
                "overlay",
                "border",
                "base"
              ]
            },
            "hover": {
              "value": "#343332",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.Marble gray.20.value}"
              },
              "name": "PharosButtonColorBaseOverlayBorderHover",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "overlay",
                "state": "border"
              },
              "path": [
                "button",
                "color",
                "base",
                "overlay",
                "border",
                "hover"
              ]
            },
            "disabled": {
              "value": "#eae8e1",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.disabled.value}"
              },
              "name": "PharosButtonColorBaseOverlayBorderDisabled",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "base",
                "subitem": "overlay",
                "state": "border"
              },
              "path": [
                "button",
                "color",
                "base",
                "overlay",
                "border",
                "disabled"
              ]
            }
          }
        }
      },
      "on-background": {
        "primary": {
          "background": {
            "base": {
              "value": "#990000",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.interactive.primary.value}"
              },
              "name": "PharosButtonColorOnBackgroundPrimaryBackgroundBase",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "primary",
                "state": "background"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "primary",
                "background",
                "base"
              ]
            },
            "hover": {
              "value": "transparent",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "transparent"
              },
              "name": "PharosButtonColorOnBackgroundPrimaryBackgroundHover",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "primary",
                "state": "background"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "primary",
                "background",
                "hover"
              ]
            },
            "disabled": {
              "value": "#343332",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.Marble gray.20.value}"
              },
              "name": "PharosButtonColorOnBackgroundPrimaryBackgroundDisabled",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "primary",
                "state": "background"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "primary",
                "background",
                "disabled"
              ]
            }
          },
          "text": {
            "base": {
              "value": "#ffffff",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.text.white.value}"
              },
              "name": "PharosButtonColorOnBackgroundPrimaryTextBase",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "primary",
                "state": "text"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "primary",
                "text",
                "base"
              ]
            },
            "hover": {
              "value": "#ffffff",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.text.white.value}"
              },
              "name": "PharosButtonColorOnBackgroundPrimaryTextHover",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "primary",
                "state": "text"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "primary",
                "text",
                "hover"
              ]
            },
            "disabled": {
              "value": "#81807e",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.Marble gray.50.value}"
              },
              "name": "PharosButtonColorOnBackgroundPrimaryTextDisabled",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "primary",
                "state": "text"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "primary",
                "text",
                "disabled"
              ]
            }
          },
          "border": {
            "base": {
              "value": "#990000",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.interactive.primary.value}"
              },
              "name": "PharosButtonColorOnBackgroundPrimaryBorderBase",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "primary",
                "state": "border"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "primary",
                "border",
                "base"
              ]
            },
            "hover": {
              "value": "#ffffff",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.ui.10.value}"
              },
              "name": "PharosButtonColorOnBackgroundPrimaryBorderHover",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "primary",
                "state": "border"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "primary",
                "border",
                "hover"
              ]
            },
            "disabled": {
              "value": "#343332",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.Marble gray.20.value}"
              },
              "name": "PharosButtonColorOnBackgroundPrimaryBorderDisabled",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "primary",
                "state": "border"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "primary",
                "border",
                "disabled"
              ]
            }
          }
        },
        "secondary": {
          "background": {
            "base": {
              "value": "transparent",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "transparent"
              },
              "name": "PharosButtonColorOnBackgroundSecondaryBackgroundBase",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "secondary",
                "state": "background"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "secondary",
                "background",
                "base"
              ]
            },
            "hover": {
              "value": "transparent",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "transparent"
              },
              "name": "PharosButtonColorOnBackgroundSecondaryBackgroundHover",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "secondary",
                "state": "background"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "secondary",
                "background",
                "hover"
              ]
            },
            "disabled": {
              "value": "#343332",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.Marble gray.20.value}"
              },
              "name": "PharosButtonColorOnBackgroundSecondaryBackgroundDisabled",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "secondary",
                "state": "background"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "secondary",
                "background",
                "disabled"
              ]
            }
          },
          "text": {
            "base": {
              "value": "#ffffff",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.text.white.value}"
              },
              "name": "PharosButtonColorOnBackgroundSecondaryTextBase",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "secondary",
                "state": "text"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "secondary",
                "text",
                "base"
              ]
            },
            "hover": {
              "value": "#ffffff",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.text.white.value}"
              },
              "name": "PharosButtonColorOnBackgroundSecondaryTextHover",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "secondary",
                "state": "text"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "secondary",
                "text",
                "hover"
              ]
            },
            "disabled": {
              "value": "#81807e",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.Marble gray.50.value}"
              },
              "name": "PharosButtonColorOnBackgroundSecondaryTextDisabled",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "secondary",
                "state": "text"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "secondary",
                "text",
                "disabled"
              ]
            }
          },
          "border": {
            "base": {
              "value": "#81807e",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.Marble gray.50.value}"
              },
              "name": "PharosButtonColorOnBackgroundSecondaryBorderBase",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "secondary",
                "state": "border"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "secondary",
                "border",
                "base"
              ]
            },
            "hover": {
              "value": "#ffffff",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.ui.10.value}"
              },
              "name": "PharosButtonColorOnBackgroundSecondaryBorderHover",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "secondary",
                "state": "border"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "secondary",
                "border",
                "hover"
              ]
            },
            "disabled": {
              "value": "#343332",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.Marble gray.20.value}"
              },
              "name": "PharosButtonColorOnBackgroundSecondaryBorderDisabled",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "secondary",
                "state": "border"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "secondary",
                "border",
                "disabled"
              ]
            }
          }
        },
        "subtle": {
          "background": {
            "base": {
              "value": "transparent",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "transparent"
              },
              "name": "PharosButtonColorOnBackgroundSubtleBackgroundBase",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "subtle",
                "state": "background"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "subtle",
                "background",
                "base"
              ]
            },
            "hover": {
              "value": "#343332",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.Marble gray.20.value}"
              },
              "name": "PharosButtonColorOnBackgroundSubtleBackgroundHover",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "subtle",
                "state": "background"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "subtle",
                "background",
                "hover"
              ]
            },
            "disabled": {
              "value": "transparent",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "transparent"
              },
              "name": "PharosButtonColorOnBackgroundSubtleBackgroundDisabled",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "subtle",
                "state": "background"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "subtle",
                "background",
                "disabled"
              ]
            }
          },
          "text": {
            "base": {
              "value": "#ffffff",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.text.white.value}"
              },
              "name": "PharosButtonColorOnBackgroundSubtleTextBase",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "subtle",
                "state": "text"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "subtle",
                "text",
                "base"
              ]
            },
            "hover": {
              "value": "#ffffff",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.text.white.value}"
              },
              "name": "PharosButtonColorOnBackgroundSubtleTextHover",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "subtle",
                "state": "text"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "subtle",
                "text",
                "hover"
              ]
            },
            "disabled": {
              "value": "#81807e",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.Marble gray.50.value}"
              },
              "name": "PharosButtonColorOnBackgroundSubtleTextDisabled",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "subtle",
                "state": "text"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "subtle",
                "text",
                "disabled"
              ]
            }
          },
          "border": {
            "base": {
              "value": "transparent",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "transparent"
              },
              "name": "PharosButtonColorOnBackgroundSubtleBorderBase",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "subtle",
                "state": "border"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "subtle",
                "border",
                "base"
              ]
            },
            "hover": {
              "value": "#343332",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.Marble gray.20.value}"
              },
              "name": "PharosButtonColorOnBackgroundSubtleBorderHover",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "subtle",
                "state": "border"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "subtle",
                "border",
                "hover"
              ]
            },
            "disabled": {
              "value": "transparent",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "transparent"
              },
              "name": "PharosButtonColorOnBackgroundSubtleBorderDisabled",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "subtle",
                "state": "border"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "subtle",
                "border",
                "disabled"
              ]
            }
          }
        },
        "overlay": {
          "background": {
            "base": {
              "value": "#1a1a19",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.Marble gray.10.value}"
              },
              "name": "PharosButtonColorOnBackgroundOverlayBackgroundBase",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "overlay",
                "state": "background"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "overlay",
                "background",
                "base"
              ]
            },
            "hover": {
              "value": "#343332",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.Marble gray.20.value}"
              },
              "name": "PharosButtonColorOnBackgroundOverlayBackgroundHover",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "overlay",
                "state": "background"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "overlay",
                "background",
                "hover"
              ]
            },
            "disabled": {
              "value": "#343332",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.Marble gray.20.value}"
              },
              "name": "PharosButtonColorOnBackgroundOverlayBackgroundDisabled",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "overlay",
                "state": "background"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "overlay",
                "background",
                "disabled"
              ]
            }
          },
          "text": {
            "base": {
              "value": "#ffffff",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.text.white.value}"
              },
              "name": "PharosButtonColorOnBackgroundOverlayTextBase",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "overlay",
                "state": "text"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "overlay",
                "text",
                "base"
              ]
            },
            "hover": {
              "value": "#ffffff",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.text.white.value}"
              },
              "name": "PharosButtonColorOnBackgroundOverlayTextHover",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "overlay",
                "state": "text"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "overlay",
                "text",
                "hover"
              ]
            },
            "disabled": {
              "value": "#81807e",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.Marble gray.50.value}"
              },
              "name": "PharosButtonColorOnBackgroundOverlayTextDisabled",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "overlay",
                "state": "text"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "overlay",
                "text",
                "disabled"
              ]
            }
          },
          "border": {
            "base": {
              "value": "#1a1a19",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.Marble gray.10.value}"
              },
              "name": "PharosButtonColorOnBackgroundOverlayBorderBase",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "overlay",
                "state": "border"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "overlay",
                "border",
                "base"
              ]
            },
            "hover": {
              "value": "#343332",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.Marble gray.20.value}"
              },
              "name": "PharosButtonColorOnBackgroundOverlayBorderHover",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "overlay",
                "state": "border"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "overlay",
                "border",
                "hover"
              ]
            },
            "disabled": {
              "value": "#343332",
              "filePath": "tokens/components/button.json",
              "isSource": true,
              "original": {
                "value": "{color.Marble gray.20.value}"
              },
              "name": "PharosButtonColorOnBackgroundOverlayBorderDisabled",
              "attributes": {
                "category": "button",
                "type": "color",
                "item": "on-background",
                "subitem": "overlay",
                "state": "border"
              },
              "path": [
                "button",
                "color",
                "on-background",
                "overlay",
                "border",
                "disabled"
              ]
            }
          }
        }
      }
    }
  },
  "checkbox-group": {
    "spacing": {
      "vertical": {
        "value": "0.5rem",
        "filePath": "tokens/components/checkbox-group.json",
        "isSource": true,
        "original": {
          "value": "{spacing.one-half-x.value}"
        },
        "name": "PharosCheckboxGroupSpacingVertical",
        "attributes": {
          "category": "checkbox-group",
          "type": "spacing",
          "item": "vertical"
        },
        "path": [
          "checkbox-group",
          "spacing",
          "vertical"
        ]
      },
      "horizontal": {
        "value": "1.5rem",
        "filePath": "tokens/components/checkbox-group.json",
        "isSource": true,
        "original": {
          "value": "{spacing.one-and-a-half-x.value}"
        },
        "name": "PharosCheckboxGroupSpacingHorizontal",
        "attributes": {
          "category": "checkbox-group",
          "type": "spacing",
          "item": "horizontal"
        },
        "path": [
          "checkbox-group",
          "spacing",
          "horizontal"
        ]
      }
    }
  },
  "checkbox": {
    "color": {
      "background": {
        "base": {
          "value": "#ffffff",
          "filePath": "tokens/components/checkbox.json",
          "isSource": true,
          "original": {
            "value": "{color.ui.10.value}"
          },
          "name": "PharosCheckboxColorBackgroundBase",
          "attributes": {
            "category": "checkbox",
            "type": "color",
            "item": "background",
            "subitem": "base"
          },
          "path": [
            "checkbox",
            "color",
            "background",
            "base"
          ]
        }
      }
    }
  },
  "combobox": {
    "color": {
      "text": {
        "hover": {
          "value": "#990000",
          "filePath": "tokens/components/combobox.json",
          "isSource": true,
          "original": {
            "value": "{color.hover.primary.value}"
          },
          "name": "PharosComboboxColorTextHover",
          "attributes": {
            "category": "combobox",
            "type": "color",
            "item": "text",
            "subitem": "hover"
          },
          "path": [
            "combobox",
            "color",
            "text",
            "hover"
          ]
        },
        "selected": {
          "value": "#000000",
          "filePath": "tokens/components/combobox.json",
          "isSource": true,
          "original": {
            "value": "{color.text.base.value}"
          },
          "name": "PharosComboboxColorTextSelected",
          "attributes": {
            "category": "combobox",
            "type": "color",
            "item": "text",
            "subitem": "selected"
          },
          "path": [
            "combobox",
            "color",
            "text",
            "selected"
          ]
        }
      },
      "icon": {
        "clear": {
          "value": "#81807e",
          "filePath": "tokens/components/combobox.json",
          "isSource": true,
          "original": {
            "value": "{color.ui.50.value}"
          },
          "name": "PharosComboboxColorIconClear",
          "attributes": {
            "category": "combobox",
            "type": "color",
            "item": "icon",
            "subitem": "clear"
          },
          "path": [
            "combobox",
            "color",
            "icon",
            "clear"
          ]
        },
        "dropdown": {
          "value": "#000000",
          "filePath": "tokens/components/combobox.json",
          "isSource": true,
          "original": {
            "value": "{color.interactive.secondary.value}"
          },
          "name": "PharosComboboxColorIconDropdown",
          "attributes": {
            "category": "combobox",
            "type": "color",
            "item": "icon",
            "subitem": "dropdown"
          },
          "path": [
            "combobox",
            "color",
            "icon",
            "dropdown"
          ]
        },
        "checkmark": {
          "value": "#000000",
          "filePath": "tokens/components/combobox.json",
          "isSource": true,
          "original": {
            "value": "{color.interactive.secondary.value}"
          },
          "name": "PharosComboboxColorIconCheckmark",
          "attributes": {
            "category": "combobox",
            "type": "color",
            "item": "icon",
            "subitem": "checkmark"
          },
          "path": [
            "combobox",
            "color",
            "icon",
            "checkmark"
          ]
        },
        "focus": {
          "value": "#990000",
          "filePath": "tokens/components/combobox.json",
          "isSource": true,
          "original": {
            "value": "{color.interactive.primary.value}"
          },
          "name": "PharosComboboxColorIconFocus",
          "attributes": {
            "category": "combobox",
            "type": "color",
            "item": "icon",
            "subitem": "focus"
          },
          "path": [
            "combobox",
            "color",
            "icon",
            "focus"
          ]
        }
      }
    },
    "size": {
      "height": {
        "list": {
          "value": "15rem",
          "comment": "TODO: Update with core token value",
          "filePath": "tokens/components/combobox.json",
          "isSource": true,
          "original": {
            "value": "15rem",
            "comment": "TODO: Update with core token value"
          },
          "name": "PharosComboboxSizeHeightList",
          "attributes": {
            "category": "combobox",
            "type": "size",
            "item": "height",
            "subitem": "list"
          },
          "path": [
            "combobox",
            "size",
            "height",
            "list"
          ]
        },
        "clear": {
          "value": "1.875rem",
          "comment": "TODO: Update with core token value",
          "filePath": "tokens/components/combobox.json",
          "isSource": true,
          "original": {
            "value": "1.875rem",
            "comment": "TODO: Update with core token value"
          },
          "name": "PharosComboboxSizeHeightClear",
          "attributes": {
            "category": "combobox",
            "type": "size",
            "item": "height",
            "subitem": "clear"
          },
          "path": [
            "combobox",
            "size",
            "height",
            "clear"
          ]
        }
      }
    }
  },
  "dropdown-menu-item": {
    "color": {
      "text": {
        "base": {
          "value": "#000000",
          "filePath": "tokens/components/dropdown-menu-item.json",
          "isSource": true,
          "original": {
            "value": "{color.Black.value}"
          },
          "name": "PharosDropdownMenuItemColorTextBase",
          "attributes": {
            "category": "dropdown-menu-item",
            "type": "color",
            "item": "text",
            "subitem": "base"
          },
          "path": [
            "dropdown-menu-item",
            "color",
            "text",
            "base"
          ]
        },
        "hover": {
          "value": "#990000",
          "filePath": "tokens/components/dropdown-menu-item.json",
          "isSource": true,
          "original": {
            "value": "{color.JSTOR red.value}"
          },
          "name": "PharosDropdownMenuItemColorTextHover",
          "attributes": {
            "category": "dropdown-menu-item",
            "type": "color",
            "item": "text",
            "subitem": "hover"
          },
          "path": [
            "dropdown-menu-item",
            "color",
            "text",
            "hover"
          ]
        },
        "disabled": {
          "value": "#676765",
          "filePath": "tokens/components/dropdown-menu-item.json",
          "isSource": true,
          "original": {
            "value": "{color.Marble gray.40.value}"
          },
          "name": "PharosDropdownMenuItemColorTextDisabled",
          "attributes": {
            "category": "dropdown-menu-item",
            "type": "color",
            "item": "text",
            "subitem": "disabled"
          },
          "path": [
            "dropdown-menu-item",
            "color",
            "text",
            "disabled"
          ]
        },
        "description": {
          "value": "#676765",
          "filePath": "tokens/components/dropdown-menu-item.json",
          "isSource": true,
          "original": {
            "value": "{color.Marble gray.40.value}"
          },
          "name": "PharosDropdownMenuItemColorTextDescription",
          "attributes": {
            "category": "dropdown-menu-item",
            "type": "color",
            "item": "text",
            "subitem": "description"
          },
          "path": [
            "dropdown-menu-item",
            "color",
            "text",
            "description"
          ]
        }
      },
      "border": {
        "base": {
          "value": "#d1cfc7",
          "filePath": "tokens/components/dropdown-menu-item.json",
          "isSource": true,
          "original": {
            "value": "{color.Marble gray.80.value}"
          },
          "name": "PharosDropdownMenuItemColorBorderBase",
          "attributes": {
            "category": "dropdown-menu-item",
            "type": "color",
            "item": "border",
            "subitem": "base"
          },
          "path": [
            "dropdown-menu-item",
            "color",
            "border",
            "base"
          ]
        }
      },
      "background": {
        "base": {
          "value": "#ffffff",
          "filePath": "tokens/components/dropdown-menu-item.json",
          "isSource": true,
          "original": {
            "value": "{color.White.value}"
          },
          "name": "PharosDropdownMenuItemColorBackgroundBase",
          "attributes": {
            "category": "dropdown-menu-item",
            "type": "color",
            "item": "background",
            "subitem": "base"
          },
          "path": [
            "dropdown-menu-item",
            "color",
            "background",
            "base"
          ]
        },
        "active": {
          "value": "#eae8e1",
          "filePath": "tokens/components/dropdown-menu-item.json",
          "isSource": true,
          "original": {
            "value": "{color.Marble gray.base.value}"
          },
          "name": "PharosDropdownMenuItemColorBackgroundActive",
          "attributes": {
            "category": "dropdown-menu-item",
            "type": "color",
            "item": "background",
            "subitem": "active"
          },
          "path": [
            "dropdown-menu-item",
            "color",
            "background",
            "active"
          ]
        },
        "disabled": {
          "value": "#eae8e1",
          "filePath": "tokens/components/dropdown-menu-item.json",
          "isSource": true,
          "original": {
            "value": "{color.Marble gray.base.value}"
          },
          "name": "PharosDropdownMenuItemColorBackgroundDisabled",
          "attributes": {
            "category": "dropdown-menu-item",
            "type": "color",
            "item": "background",
            "subitem": "disabled"
          },
          "path": [
            "dropdown-menu-item",
            "color",
            "background",
            "disabled"
          ]
        },
        "hover": {
          "value": "#f2f1ed",
          "filePath": "tokens/components/dropdown-menu-item.json",
          "isSource": true,
          "original": {
            "value": "{color.Marble gray.94.value}"
          },
          "name": "PharosDropdownMenuItemColorBackgroundHover",
          "attributes": {
            "category": "dropdown-menu-item",
            "type": "color",
            "item": "background",
            "subitem": "hover"
          },
          "path": [
            "dropdown-menu-item",
            "color",
            "background",
            "hover"
          ]
        }
      },
      "icon": {
        "base": {
          "value": "#000000",
          "filePath": "tokens/components/dropdown-menu-item.json",
          "isSource": true,
          "original": {
            "value": "{color.Black.value}"
          },
          "name": "PharosDropdownMenuItemColorIconBase",
          "attributes": {
            "category": "dropdown-menu-item",
            "type": "color",
            "item": "icon",
            "subitem": "base"
          },
          "path": [
            "dropdown-menu-item",
            "color",
            "icon",
            "base"
          ]
        }
      }
    }
  },
  "dropdown-menu": {
    "color": {
      "border": {
        "base": {
          "value": "#d1cfc7",
          "filePath": "tokens/components/dropdown-menu.json",
          "isSource": true,
          "original": {
            "value": "{color.Marble gray.80.value}"
          },
          "name": "PharosDropdownMenuColorBorderBase",
          "attributes": {
            "category": "dropdown-menu",
            "type": "color",
            "item": "border",
            "subitem": "base"
          },
          "path": [
            "dropdown-menu",
            "color",
            "border",
            "base"
          ]
        }
      }
    },
    "size": {
      "width": {
        "min": {
          "value": "9rem",
          "comment": "TODO: Update with core token value",
          "filePath": "tokens/components/dropdown-menu.json",
          "isSource": true,
          "original": {
            "value": "9rem",
            "comment": "TODO: Update with core token value"
          },
          "name": "PharosDropdownMenuSizeWidthMin",
          "attributes": {
            "category": "dropdown-menu",
            "type": "size",
            "item": "width",
            "subitem": "min"
          },
          "path": [
            "dropdown-menu",
            "size",
            "width",
            "min"
          ]
        },
        "max": {
          "value": "17rem",
          "comment": "TODO: Update with core token value",
          "filePath": "tokens/components/dropdown-menu.json",
          "isSource": true,
          "original": {
            "value": "17rem",
            "comment": "TODO: Update with core token value"
          },
          "name": "PharosDropdownMenuSizeWidthMax",
          "attributes": {
            "category": "dropdown-menu",
            "type": "size",
            "item": "width",
            "subitem": "max"
          },
          "path": [
            "dropdown-menu",
            "size",
            "width",
            "max"
          ]
        }
      }
    }
  },
  "form-element": {
    "color": {
      "text": {
        "base": {
          "value": "#000000",
          "filePath": "tokens/components/form-element.json",
          "isSource": true,
          "original": {
            "value": "{color.text.base.value}"
          },
          "name": "PharosFormElementColorTextBase",
          "attributes": {
            "category": "form-element",
            "type": "color",
            "item": "text",
            "subitem": "base"
          },
          "path": [
            "form-element",
            "color",
            "text",
            "base"
          ]
        },
        "required": {
          "value": "#dd3431",
          "filePath": "tokens/components/form-element.json",
          "isSource": true,
          "original": {
            "value": "{color.feedback.error.value}"
          },
          "name": "PharosFormElementColorTextRequired",
          "attributes": {
            "category": "form-element",
            "type": "color",
            "item": "text",
            "subitem": "required"
          },
          "path": [
            "form-element",
            "color",
            "text",
            "required"
          ]
        },
        "invalid": {
          "value": "#dd3431",
          "filePath": "tokens/components/form-element.json",
          "isSource": true,
          "original": {
            "value": "{color.feedback.error.value}"
          },
          "name": "PharosFormElementColorTextInvalid",
          "attributes": {
            "category": "form-element",
            "type": "color",
            "item": "text",
            "subitem": "invalid"
          },
          "path": [
            "form-element",
            "color",
            "text",
            "invalid"
          ]
        },
        "disabled": {
          "value": "#676765",
          "filePath": "tokens/components/form-element.json",
          "isSource": true,
          "original": {
            "value": "{color.text.disabled.value}"
          },
          "name": "PharosFormElementColorTextDisabled",
          "attributes": {
            "category": "form-element",
            "type": "color",
            "item": "text",
            "subitem": "disabled"
          },
          "path": [
            "form-element",
            "color",
            "text",
            "disabled"
          ]
        },
        "placeholder": {
          "value": "#676765",
          "filePath": "tokens/components/form-element.json",
          "isSource": true,
          "original": {
            "value": "{color.text.placeholder.value}"
          },
          "name": "PharosFormElementColorTextPlaceholder",
          "attributes": {
            "category": "form-element",
            "type": "color",
            "item": "text",
            "subitem": "placeholder"
          },
          "path": [
            "form-element",
            "color",
            "text",
            "placeholder"
          ]
        }
      },
      "background": {
        "disabled": {
          "value": "#eae8e1",
          "filePath": "tokens/components/form-element.json",
          "isSource": true,
          "original": {
            "value": "{color.disabled.value}"
          },
          "name": "PharosFormElementColorBackgroundDisabled",
          "attributes": {
            "category": "form-element",
            "type": "color",
            "item": "background",
            "subitem": "disabled"
          },
          "path": [
            "form-element",
            "color",
            "background",
            "disabled"
          ]
        },
        "selected": {
          "value": "#000000",
          "filePath": "tokens/components/form-element.json",
          "isSource": true,
          "original": {
            "value": "{color.interactive.secondary.value}"
          },
          "name": "PharosFormElementColorBackgroundSelected",
          "attributes": {
            "category": "form-element",
            "type": "color",
            "item": "background",
            "subitem": "selected"
          },
          "path": [
            "form-element",
            "color",
            "background",
            "selected"
          ]
        }
      },
      "border": {
        "base": {
          "value": "#81807e",
          "filePath": "tokens/components/form-element.json",
          "isSource": true,
          "original": {
            "value": "{color.ui.50.value}"
          },
          "name": "PharosFormElementColorBorderBase",
          "attributes": {
            "category": "form-element",
            "type": "color",
            "item": "border",
            "subitem": "base"
          },
          "path": [
            "form-element",
            "color",
            "border",
            "base"
          ]
        },
        "focus": {
          "value": "#0ba3c1",
          "filePath": "tokens/components/form-element.json",
          "isSource": true,
          "original": {
            "value": "{color.focus.value}"
          },
          "name": "PharosFormElementColorBorderFocus",
          "attributes": {
            "category": "form-element",
            "type": "color",
            "item": "border",
            "subitem": "focus"
          },
          "path": [
            "form-element",
            "color",
            "border",
            "focus"
          ]
        },
        "invalid": {
          "value": "#dd3431",
          "filePath": "tokens/components/form-element.json",
          "isSource": true,
          "original": {
            "value": "{color.feedback.error.value}"
          },
          "name": "PharosFormElementColorBorderInvalid",
          "attributes": {
            "category": "form-element",
            "type": "color",
            "item": "border",
            "subitem": "invalid"
          },
          "path": [
            "form-element",
            "color",
            "border",
            "invalid"
          ]
        },
        "disabled": {
          "value": "#d1cfc7",
          "filePath": "tokens/components/form-element.json",
          "isSource": true,
          "original": {
            "value": "{color.ui.40.value}"
          },
          "name": "PharosFormElementColorBorderDisabled",
          "attributes": {
            "category": "form-element",
            "type": "color",
            "item": "border",
            "subitem": "disabled"
          },
          "path": [
            "form-element",
            "color",
            "border",
            "disabled"
          ]
        }
      }
    },
    "size": {
      "text": {
        "label": {
          "value": "2",
          "filePath": "tokens/components/form-element.json",
          "isSource": true,
          "original": {
            "value": "{font.size.small.value}"
          },
          "name": "PharosFormElementSizeTextLabel",
          "attributes": {
            "category": "form-element",
            "type": "size",
            "item": "text",
            "subitem": "label"
          },
          "path": [
            "form-element",
            "size",
            "text",
            "label"
          ]
        },
        "input": {
          "value": "3",
          "filePath": "tokens/components/form-element.json",
          "isSource": true,
          "original": {
            "value": "{font.size.base.value}"
          },
          "name": "PharosFormElementSizeTextInput",
          "attributes": {
            "category": "form-element",
            "type": "size",
            "item": "text",
            "subitem": "input"
          },
          "path": [
            "form-element",
            "size",
            "text",
            "input"
          ]
        }
      }
    }
  },
  "loading-spinner": {
    "color": {
      "stroke": {
        "primary": {
          "value": "#990000",
          "filePath": "tokens/components/loading-spinner.json",
          "isSource": true,
          "original": {
            "value": "{color.JSTOR red.value}"
          },
          "name": "PharosLoadingSpinnerColorStrokePrimary",
          "attributes": {
            "category": "loading-spinner",
            "type": "color",
            "item": "stroke",
            "subitem": "primary"
          },
          "path": [
            "loading-spinner",
            "color",
            "stroke",
            "primary"
          ]
        },
        "secondary": {
          "value": "#fb4848",
          "filePath": "tokens/components/loading-spinner.json",
          "isSource": true,
          "original": {
            "value": "{color.Living coral.base.value}"
          },
          "name": "PharosLoadingSpinnerColorStrokeSecondary",
          "attributes": {
            "category": "loading-spinner",
            "type": "color",
            "item": "stroke",
            "subitem": "secondary"
          },
          "path": [
            "loading-spinner",
            "color",
            "stroke",
            "secondary"
          ]
        }
      }
    }
  },
  "modal": {
    "color": {
      "background": {
        "content": {
          "value": "#ffffff",
          "filePath": "tokens/components/modal.json",
          "isSource": true,
          "original": {
            "value": "{color.White.value}"
          },
          "name": "PharosModalColorBackgroundContent",
          "attributes": {
            "category": "modal",
            "type": "color",
            "item": "background",
            "subitem": "content"
          },
          "path": [
            "modal",
            "color",
            "background",
            "content"
          ]
        }
      },
      "border": {
        "content": {
          "value": "#eae8e1",
          "filePath": "tokens/components/modal.json",
          "isSource": true,
          "original": {
            "value": "{color.Marble gray.base.value}"
          },
          "name": "PharosModalColorBorderContent",
          "attributes": {
            "category": "modal",
            "type": "color",
            "item": "border",
            "subitem": "content"
          },
          "path": [
            "modal",
            "color",
            "border",
            "content"
          ]
        }
      },
      "icon": {
        "close": {
          "value": "#81807e",
          "filePath": "tokens/components/modal.json",
          "isSource": true,
          "original": {
            "value": "{color.Marble gray.50.value}"
          },
          "name": "PharosModalColorIconClose",
          "attributes": {
            "category": "modal",
            "type": "color",
            "item": "icon",
            "subitem": "close"
          },
          "path": [
            "modal",
            "color",
            "icon",
            "close"
          ]
        },
        "focus": {
          "value": "#990000",
          "filePath": "tokens/components/modal.json",
          "isSource": true,
          "original": {
            "value": "{color.JSTOR red.value}"
          },
          "name": "PharosModalColorIconFocus",
          "attributes": {
            "category": "modal",
            "type": "color",
            "item": "icon",
            "subitem": "focus"
          },
          "path": [
            "modal",
            "color",
            "icon",
            "focus"
          ]
        }
      }
    },
    "spacing": {
      "base": {
        "value": "2rem",
        "filePath": "tokens/components/modal.json",
        "isSource": true,
        "original": {
          "value": "{spacing.2-x.value}"
        },
        "name": "PharosModalSpacingBase",
        "attributes": {
          "category": "modal",
          "type": "spacing",
          "item": "base"
        },
        "path": [
          "modal",
          "spacing",
          "base"
        ]
      }
    },
    "size": {
      "width": {
        "base": {
          "value": "40rem",
          "comment": "TODO: Update with core token value",
          "filePath": "tokens/components/modal.json",
          "isSource": true,
          "original": {
            "value": "40rem",
            "comment": "TODO: Update with core token value"
          },
          "name": "PharosModalSizeWidthBase",
          "attributes": {
            "category": "modal",
            "type": "size",
            "item": "width",
            "subitem": "base"
          },
          "path": [
            "modal",
            "size",
            "width",
            "base"
          ]
        }
      }
    }
  },
  "radio-button": {
    "color": {
      "background": {
        "base": {
          "value": "#ffffff",
          "filePath": "tokens/components/radio-button.json",
          "isSource": true,
          "original": {
            "value": "{color.ui.10.value}"
          },
          "name": "PharosRadioButtonColorBackgroundBase",
          "attributes": {
            "category": "radio-button",
            "type": "color",
            "item": "background",
            "subitem": "base"
          },
          "path": [
            "radio-button",
            "color",
            "background",
            "base"
          ]
        }
      }
    }
  },
  "radio-group": {
    "spacing": {
      "vertical": {
        "value": "0.5rem",
        "filePath": "tokens/components/radio-group.json",
        "isSource": true,
        "original": {
          "value": "{spacing.one-half-x.value}"
        },
        "name": "PharosRadioGroupSpacingVertical",
        "attributes": {
          "category": "radio-group",
          "type": "spacing",
          "item": "vertical"
        },
        "path": [
          "radio-group",
          "spacing",
          "vertical"
        ]
      },
      "horizontal": {
        "value": "1.5rem",
        "filePath": "tokens/components/radio-group.json",
        "isSource": true,
        "original": {
          "value": "{spacing.one-and-a-half-x.value}"
        },
        "name": "PharosRadioGroupSpacingHorizontal",
        "attributes": {
          "category": "radio-group",
          "type": "spacing",
          "item": "horizontal"
        },
        "path": [
          "radio-group",
          "spacing",
          "horizontal"
        ]
      }
    }
  },
  "text-input": {
    "color": {
      "icon": {
        "valid": {
          "value": "#268241",
          "filePath": "tokens/components/text-input.json",
          "isSource": true,
          "original": {
            "value": "{color.feedback.success.value}"
          },
          "name": "PharosTextInputColorIconValid",
          "attributes": {
            "category": "text-input",
            "type": "color",
            "item": "icon",
            "subitem": "valid"
          },
          "path": [
            "text-input",
            "color",
            "icon",
            "valid"
          ]
        },
        "invalid": {
          "value": "#dd3431",
          "filePath": "tokens/components/text-input.json",
          "isSource": true,
          "original": {
            "value": "{color.feedback.error.value}"
          },
          "name": "PharosTextInputColorIconInvalid",
          "attributes": {
            "category": "text-input",
            "type": "color",
            "item": "icon",
            "subitem": "invalid"
          },
          "path": [
            "text-input",
            "color",
            "icon",
            "invalid"
          ]
        }
      }
    }
  },
  "textarea": {
    "size": {
      "height": {
        "base": {
          "value": "3.5rem",
          "comment": "TODO: Update with core token value",
          "filePath": "tokens/components/textarea.json",
          "isSource": true,
          "original": {
            "value": "3.5rem",
            "comment": "TODO: Update with core token value"
          },
          "name": "PharosTextareaSizeHeightBase",
          "attributes": {
            "category": "textarea",
            "type": "size",
            "item": "height",
            "subitem": "base"
          },
          "path": [
            "textarea",
            "size",
            "height",
            "base"
          ]
        }
      }
    }
  },
  "tooltip": {
    "color": {
      "background": {
        "base": {
          "value": "#343332",
          "filePath": "tokens/components/tooltip.json",
          "isSource": true,
          "original": {
            "value": "{color.Marble gray.20.value}"
          },
          "name": "PharosTooltipColorBackgroundBase",
          "attributes": {
            "category": "tooltip",
            "type": "color",
            "item": "background",
            "subitem": "base"
          },
          "path": [
            "tooltip",
            "color",
            "background",
            "base"
          ]
        }
      },
      "text": {
        "base": {
          "value": "#ffffff",
          "filePath": "tokens/components/tooltip.json",
          "isSource": true,
          "original": {
            "value": "{color.text.white.value}"
          },
          "name": "PharosTooltipColorTextBase",
          "attributes": {
            "category": "tooltip",
            "type": "color",
            "item": "text",
            "subitem": "base"
          },
          "path": [
            "tooltip",
            "color",
            "text",
            "base"
          ]
        }
      }
    },
    "size": {
      "text": {
        "base": {
          "value": "2",
          "filePath": "tokens/components/tooltip.json",
          "isSource": true,
          "original": {
            "value": "{font.size.small.value}"
          },
          "name": "PharosTooltipSizeTextBase",
          "attributes": {
            "category": "tooltip",
            "type": "size",
            "item": "text",
            "subitem": "base"
          },
          "path": [
            "tooltip",
            "size",
            "text",
            "base"
          ]
        }
      }
    }
  },
  "font": {
    "family": {
      "sans-serif": {
        "value": "GT America Standard, Helvetica, Helvetica Neue, Arial, Segoe UI, Roboto, Droid Sans, sans-serif",
        "filePath": "tokens/font.json",
        "isSource": true,
        "original": {
          "value": "GT America Standard, Helvetica, Helvetica Neue, Arial, Segoe UI, Roboto, Droid Sans, sans-serif"
        },
        "name": "PharosFontFamilySansSerif",
        "attributes": {
          "category": "font",
          "type": "family",
          "item": "sans-serif"
        },
        "path": [
          "font",
          "family",
          "sans-serif"
        ]
      },
      "serif": {
        "value": "Ivar Headline, Times, Georgia, serif",
        "filePath": "tokens/font.json",
        "isSource": true,
        "original": {
          "value": "Ivar Headline, Times, Georgia, serif"
        },
        "name": "PharosFontFamilySerif",
        "attributes": {
          "category": "font",
          "type": "family",
          "item": "serif"
        },
        "path": [
          "font",
          "family",
          "serif"
        ]
      },
      "body": {
        "value": "GT America Standard, Helvetica, Helvetica Neue, Arial, Segoe UI, Roboto, Droid Sans, sans-serif",
        "filePath": "tokens/font.json",
        "isSource": true,
        "original": {
          "value": "{font.family.sans-serif.value}"
        },
        "name": "PharosFontFamilyBody",
        "attributes": {
          "category": "font",
          "type": "family",
          "item": "body"
        },
        "path": [
          "font",
          "family",
          "body"
        ]
      }
    },
    "weight": {
      "regular": {
        "value": "400",
        "filePath": "tokens/font.json",
        "isSource": true,
        "original": {
          "value": "400"
        },
        "name": "PharosFontWeightRegular",
        "attributes": {
          "category": "font",
          "type": "weight",
          "item": "regular"
        },
        "path": [
          "font",
          "weight",
          "regular"
        ]
      },
      "bold": {
        "value": "700",
        "filePath": "tokens/font.json",
        "isSource": true,
        "original": {
          "value": "700"
        },
        "name": "PharosFontWeightBold",
        "attributes": {
          "category": "font",
          "type": "weight",
          "item": "bold"
        },
        "path": [
          "font",
          "weight",
          "bold"
        ]
      }
    },
    "size": {
      "micro": {
        "value": "1",
        "filePath": "tokens/font.json",
        "isSource": true,
        "original": {
          "value": "{type.scale.1.value}"
        },
        "name": "PharosFontSizeMicro",
        "attributes": {
          "category": "font",
          "type": "size",
          "item": "micro"
        },
        "path": [
          "font",
          "size",
          "micro"
        ]
      },
      "small": {
        "value": "2",
        "filePath": "tokens/font.json",
        "isSource": true,
        "original": {
          "value": "{type.scale.2.value}"
        },
        "name": "PharosFontSizeSmall",
        "attributes": {
          "category": "font",
          "type": "size",
          "item": "small"
        },
        "path": [
          "font",
          "size",
          "small"
        ]
      },
      "base": {
        "value": "3",
        "filePath": "tokens/font.json",
        "isSource": true,
        "original": {
          "value": "{type.scale.3.value}"
        },
        "name": "PharosFontSizeBase",
        "attributes": {
          "category": "font",
          "type": "size",
          "item": "base"
        },
        "path": [
          "font",
          "size",
          "base"
        ]
      },
      "large": {
        "value": "5",
        "filePath": "tokens/font.json",
        "isSource": true,
        "original": {
          "value": "{type.scale.5.value}"
        },
        "name": "PharosFontSizeLarge",
        "attributes": {
          "category": "font",
          "type": "size",
          "item": "large"
        },
        "path": [
          "font",
          "size",
          "large"
        ]
      },
      "xlarge": {
        "value": "6",
        "filePath": "tokens/font.json",
        "isSource": true,
        "original": {
          "value": "{type.scale.6.value}"
        },
        "name": "PharosFontSizeXlarge",
        "attributes": {
          "category": "font",
          "type": "size",
          "item": "xlarge"
        },
        "path": [
          "font",
          "size",
          "xlarge"
        ]
      }
    }
  },
  "line-height": {
    "xsmall": {
      "value": "1rem",
      "comment": "16px",
      "filePath": "tokens/line-height/base.json",
      "isSource": true,
      "original": {
        "value": "1rem",
        "comment": "16px"
      },
      "name": "PharosLineHeightXsmall",
      "attributes": {
        "category": "line-height",
        "type": "xsmall"
      },
      "path": [
        "line-height",
        "xsmall"
      ]
    },
    "small": {
      "value": "1.25rem",
      "comment": "20px",
      "filePath": "tokens/line-height/base.json",
      "isSource": true,
      "original": {
        "value": "1.25rem",
        "comment": "20px"
      },
      "name": "PharosLineHeightSmall",
      "attributes": {
        "category": "line-height",
        "type": "small"
      },
      "path": [
        "line-height",
        "small"
      ]
    },
    "medium": {
      "value": "1.5rem",
      "comment": "24px",
      "filePath": "tokens/line-height/base.json",
      "isSource": true,
      "original": {
        "value": "1.5rem",
        "comment": "24px"
      },
      "name": "PharosLineHeightMedium",
      "attributes": {
        "category": "line-height",
        "type": "medium"
      },
      "path": [
        "line-height",
        "medium"
      ]
    },
    "large": {
      "value": "1.75rem",
      "comment": "28px",
      "filePath": "tokens/line-height/base.json",
      "isSource": true,
      "original": {
        "value": "1.75rem",
        "comment": "28px"
      },
      "name": "PharosLineHeightLarge",
      "attributes": {
        "category": "line-height",
        "type": "large"
      },
      "path": [
        "line-height",
        "large"
      ]
    },
    "xlarge": {
      "value": "2.25rem",
      "comment": "36px",
      "filePath": "tokens/line-height/base.json",
      "isSource": true,
      "original": {
        "value": "2.25rem",
        "comment": "36px"
      },
      "name": "PharosLineHeightXlarge",
      "attributes": {
        "category": "line-height",
        "type": "xlarge"
      },
      "path": [
        "line-height",
        "xlarge"
      ]
    },
    "heading-large": {
      "value": "1",
      "filePath": "tokens/line-height/base.json",
      "isSource": true,
      "original": {
        "value": "1"
      },
      "name": "PharosLineHeightHeadingLarge",
      "attributes": {
        "category": "line-height",
        "type": "heading-large"
      },
      "path": [
        "line-height",
        "heading-large"
      ]
    },
    "text-base-condensed": {
      "value": "1.25rem",
      "comment": "20px",
      "filePath": "tokens/line-height/base.json",
      "isSource": true,
      "original": {
        "value": "{line-height.small.value}",
        "comment": "20px"
      },
      "name": "PharosLineHeightTextBaseCondensed",
      "attributes": {
        "category": "line-height",
        "type": "text-base-condensed"
      },
      "path": [
        "line-height",
        "text-base-condensed"
      ]
    }
  },
  "radius": {
    "base": {
      "standard": {
        "value": "0.125rem",
        "comment": "2px",
        "filePath": "tokens/radius/base.json",
        "isSource": true,
        "original": {
          "value": "0.125rem",
          "comment": "2px"
        },
        "name": "PharosRadiusBaseStandard",
        "attributes": {
          "category": "radius",
          "type": "base",
          "item": "standard"
        },
        "path": [
          "radius",
          "base",
          "standard"
        ]
      }
    }
  },
  "spacing": {
    "one-eighth-x": {
      "value": "0.125rem",
      "comment": "2px",
      "filePath": "tokens/spacing/base.json",
      "isSource": true,
      "original": {
        "value": "0.125rem",
        "comment": "2px"
      },
      "name": "PharosSpacingOneEighthX",
      "attributes": {
        "category": "spacing",
        "type": "one-eighth-x"
      },
      "path": [
        "spacing",
        "one-eighth-x"
      ]
    },
    "one-quarter-x": {
      "value": "0.25rem",
      "comment": "4px",
      "filePath": "tokens/spacing/base.json",
      "isSource": true,
      "original": {
        "value": "0.25rem",
        "comment": "4px"
      },
      "name": "PharosSpacingOneQuarterX",
      "attributes": {
        "category": "spacing",
        "type": "one-quarter-x"
      },
      "path": [
        "spacing",
        "one-quarter-x"
      ]
    },
    "one-half-x": {
      "value": "0.5rem",
      "comment": "8px",
      "filePath": "tokens/spacing/base.json",
      "isSource": true,
      "original": {
        "value": "0.5rem",
        "comment": "8px"
      },
      "name": "PharosSpacingOneHalfX",
      "attributes": {
        "category": "spacing",
        "type": "one-half-x"
      },
      "path": [
        "spacing",
        "one-half-x"
      ]
    },
    "three-quarters-x": {
      "value": "0.75rem",
      "comment": "12px",
      "filePath": "tokens/spacing/base.json",
      "isSource": true,
      "original": {
        "value": "0.75rem",
        "comment": "12px"
      },
      "name": "PharosSpacingThreeQuartersX",
      "attributes": {
        "category": "spacing",
        "type": "three-quarters-x"
      },
      "path": [
        "spacing",
        "three-quarters-x"
      ]
    },
    "1-x": {
      "value": "1rem",
      "comment": "16px",
      "filePath": "tokens/spacing/base.json",
      "isSource": true,
      "original": {
        "value": "1rem",
        "comment": "16px"
      },
      "name": "PharosSpacing1X",
      "attributes": {
        "category": "spacing",
        "type": "1-x"
      },
      "path": [
        "spacing",
        "1-x"
      ]
    },
    "one-and-a-half-x": {
      "value": "1.5rem",
      "comment": "24px",
      "filePath": "tokens/spacing/base.json",
      "isSource": true,
      "original": {
        "value": "1.5rem",
        "comment": "24px"
      },
      "name": "PharosSpacingOneAndAHalfX",
      "attributes": {
        "category": "spacing",
        "type": "one-and-a-half-x"
      },
      "path": [
        "spacing",
        "one-and-a-half-x"
      ]
    },
    "2-x": {
      "value": "2rem",
      "comment": "32px",
      "filePath": "tokens/spacing/base.json",
      "isSource": true,
      "original": {
        "value": "2rem",
        "comment": "32px"
      },
      "name": "PharosSpacing2X",
      "attributes": {
        "category": "spacing",
        "type": "2-x"
      },
      "path": [
        "spacing",
        "2-x"
      ]
    },
    "3-x": {
      "value": "3rem",
      "comment": "48px",
      "filePath": "tokens/spacing/base.json",
      "isSource": true,
      "original": {
        "value": "3rem",
        "comment": "48px"
      },
      "name": "PharosSpacing3X",
      "attributes": {
        "category": "spacing",
        "type": "3-x"
      },
      "path": [
        "spacing",
        "3-x"
      ]
    },
    "three-and-a-half-x": {
      "value": "3.5rem",
      "comment": "56px",
      "filePath": "tokens/spacing/base.json",
      "isSource": true,
      "original": {
        "value": "3.5rem",
        "comment": "56px"
      },
      "name": "PharosSpacingThreeAndAHalfX",
      "attributes": {
        "category": "spacing",
        "type": "three-and-a-half-x"
      },
      "path": [
        "spacing",
        "three-and-a-half-x"
      ]
    },
    "5-x": {
      "value": "5rem",
      "comment": "80px",
      "filePath": "tokens/spacing/base.json",
      "isSource": true,
      "original": {
        "value": "5rem",
        "comment": "80px"
      },
      "name": "PharosSpacing5X",
      "attributes": {
        "category": "spacing",
        "type": "5-x"
      },
      "path": [
        "spacing",
        "5-x"
      ]
    },
    "7-x": {
      "value": "7rem",
      "comment": "112px",
      "filePath": "tokens/spacing/base.json",
      "isSource": true,
      "original": {
        "value": "7rem",
        "comment": "112px"
      },
      "name": "PharosSpacing7X",
      "attributes": {
        "category": "spacing",
        "type": "7-x"
      },
      "path": [
        "spacing",
        "7-x"
      ]
    },
    "10-x": {
      "value": "10rem",
      "comment": "160px",
      "filePath": "tokens/spacing/base.json",
      "isSource": true,
      "original": {
        "value": "10rem",
        "comment": "160px"
      },
      "name": "PharosSpacing10X",
      "attributes": {
        "category": "spacing",
        "type": "10-x"
      },
      "path": [
        "spacing",
        "10-x"
      ]
    },
    "gutter": {
      "value": "3rem",
      "comment": "48px",
      "filePath": "tokens/spacing/base.json",
      "isSource": true,
      "original": {
        "value": "{spacing.3-x.value}",
        "comment": "48px"
      },
      "name": "PharosSpacingGutter",
      "attributes": {
        "category": "spacing",
        "type": "gutter"
      },
      "path": [
        "spacing",
        "gutter"
      ]
    }
  },
  "transition": {
    "base": {
      "value": "250ms cubic-bezier(0.17, 0.67, 0.83, 0.67)",
      "filePath": "tokens/transition/base.json",
      "isSource": true,
      "original": {
        "value": "250ms cubic-bezier(0.17, 0.67, 0.83, 0.67)"
      },
      "name": "PharosTransitionBase",
      "attributes": {
        "category": "transition",
        "type": "base"
      },
      "path": [
        "transition",
        "base"
      ]
    },
    "duration": {
      "shorter": {
        "value": "50ms",
        "filePath": "tokens/transition/base.json",
        "isSource": true,
        "original": {
          "value": "50ms"
        },
        "name": "PharosTransitionDurationShorter",
        "attributes": {
          "category": "transition",
          "type": "duration",
          "item": "shorter"
        },
        "path": [
          "transition",
          "duration",
          "shorter"
        ]
      },
      "short": {
        "value": "100ms",
        "filePath": "tokens/transition/base.json",
        "isSource": true,
        "original": {
          "value": "100ms"
        },
        "name": "PharosTransitionDurationShort",
        "attributes": {
          "category": "transition",
          "type": "duration",
          "item": "short"
        },
        "path": [
          "transition",
          "duration",
          "short"
        ]
      },
      "default": {
        "value": "250ms",
        "filePath": "tokens/transition/base.json",
        "isSource": true,
        "original": {
          "value": "250ms"
        },
        "name": "PharosTransitionDurationDefault",
        "attributes": {
          "category": "transition",
          "type": "duration",
          "item": "default"
        },
        "path": [
          "transition",
          "duration",
          "default"
        ]
      },
      "long": {
        "value": "500ms",
        "filePath": "tokens/transition/base.json",
        "isSource": true,
        "original": {
          "value": "500ms"
        },
        "name": "PharosTransitionDurationLong",
        "attributes": {
          "category": "transition",
          "type": "duration",
          "item": "long"
        },
        "path": [
          "transition",
          "duration",
          "long"
        ]
      },
      "longer": {
        "value": "1000ms",
        "filePath": "tokens/transition/base.json",
        "isSource": true,
        "original": {
          "value": "1000ms"
        },
        "name": "PharosTransitionDurationLonger",
        "attributes": {
          "category": "transition",
          "type": "duration",
          "item": "longer"
        },
        "path": [
          "transition",
          "duration",
          "longer"
        ]
      }
    },
    "curve": {
      "base": {
        "value": "cubic-bezier(0.17, 0.67, 0.83, 0.67)",
        "filePath": "tokens/transition/base.json",
        "isSource": true,
        "original": {
          "value": "cubic-bezier(0.17, 0.67, 0.83, 0.67)"
        },
        "name": "PharosTransitionCurveBase",
        "attributes": {
          "category": "transition",
          "type": "curve",
          "item": "base"
        },
        "path": [
          "transition",
          "curve",
          "base"
        ]
      }
    }
  },
  "type": {
    "scale": {
      "1": {
        "value": "1",
        "comment": "12px",
        "filePath": "tokens/type/scale.json",
        "isSource": true,
        "original": {
          "value": "1",
          "comment": "12px"
        },
        "name": "PharosTypeScale1",
        "attributes": {
          "category": "type",
          "type": "scale",
          "item": "1"
        },
        "path": [
          "type",
          "scale",
          "1"
        ]
      },
      "2": {
        "value": "2",
        "comment": "14px",
        "filePath": "tokens/type/scale.json",
        "isSource": true,
        "original": {
          "value": "2",
          "comment": "14px"
        },
        "name": "PharosTypeScale2",
        "attributes": {
          "category": "type",
          "type": "scale",
          "item": "2"
        },
        "path": [
          "type",
          "scale",
          "2"
        ]
      },
      "3": {
        "value": "3",
        "comment": "16px",
        "filePath": "tokens/type/scale.json",
        "isSource": true,
        "original": {
          "value": "3",
          "comment": "16px"
        },
        "name": "PharosTypeScale3",
        "attributes": {
          "category": "type",
          "type": "scale",
          "item": "3"
        },
        "path": [
          "type",
          "scale",
          "3"
        ]
      },
      "4": {
        "value": "4",
        "comment": "18px",
        "filePath": "tokens/type/scale.json",
        "isSource": true,
        "original": {
          "value": "4",
          "comment": "18px"
        },
        "name": "PharosTypeScale4",
        "attributes": {
          "category": "type",
          "type": "scale",
          "item": "4"
        },
        "path": [
          "type",
          "scale",
          "4"
        ]
      },
      "5": {
        "value": "5",
        "comment": "20px",
        "filePath": "tokens/type/scale.json",
        "isSource": true,
        "original": {
          "value": "5",
          "comment": "20px"
        },
        "name": "PharosTypeScale5",
        "attributes": {
          "category": "type",
          "type": "scale",
          "item": "5"
        },
        "path": [
          "type",
          "scale",
          "5"
        ]
      },
      "6": {
        "value": "6",
        "comment": "24px",
        "filePath": "tokens/type/scale.json",
        "isSource": true,
        "original": {
          "value": "6",
          "comment": "24px"
        },
        "name": "PharosTypeScale6",
        "attributes": {
          "category": "type",
          "type": "scale",
          "item": "6"
        },
        "path": [
          "type",
          "scale",
          "6"
        ]
      },
      "7": {
        "value": "7",
        "comment": "28px",
        "filePath": "tokens/type/scale.json",
        "isSource": true,
        "original": {
          "value": "7",
          "comment": "28px"
        },
        "name": "PharosTypeScale7",
        "attributes": {
          "category": "type",
          "type": "scale",
          "item": "7"
        },
        "path": [
          "type",
          "scale",
          "7"
        ]
      },
      "8": {
        "value": "8",
        "comment": "32px",
        "filePath": "tokens/type/scale.json",
        "isSource": true,
        "original": {
          "value": "8",
          "comment": "32px"
        },
        "name": "PharosTypeScale8",
        "attributes": {
          "category": "type",
          "type": "scale",
          "item": "8"
        },
        "path": [
          "type",
          "scale",
          "8"
        ]
      },
      "9": {
        "value": "9",
        "comment": "36px",
        "filePath": "tokens/type/scale.json",
        "isSource": true,
        "original": {
          "value": "9",
          "comment": "36px"
        },
        "name": "PharosTypeScale9",
        "attributes": {
          "category": "type",
          "type": "scale",
          "item": "9"
        },
        "path": [
          "type",
          "scale",
          "9"
        ]
      },
      "10": {
        "value": "10",
        "comment": "42px",
        "filePath": "tokens/type/scale.json",
        "isSource": true,
        "original": {
          "value": "10",
          "comment": "42px"
        },
        "name": "PharosTypeScale10",
        "attributes": {
          "category": "type",
          "type": "scale",
          "item": "10"
        },
        "path": [
          "type",
          "scale",
          "10"
        ]
      },
      "11": {
        "value": "11",
        "comment": "48px",
        "filePath": "tokens/type/scale.json",
        "isSource": true,
        "original": {
          "value": "11",
          "comment": "48px"
        },
        "name": "PharosTypeScale11",
        "attributes": {
          "category": "type",
          "type": "scale",
          "item": "11"
        },
        "path": [
          "type",
          "scale",
          "11"
        ]
      },
      "12": {
        "value": "12",
        "comment": "54px",
        "filePath": "tokens/type/scale.json",
        "isSource": true,
        "original": {
          "value": "12",
          "comment": "54px"
        },
        "name": "PharosTypeScale12",
        "attributes": {
          "category": "type",
          "type": "scale",
          "item": "12"
        },
        "path": [
          "type",
          "scale",
          "12"
        ]
      },
      "13": {
        "value": "13",
        "comment": "60px",
        "filePath": "tokens/type/scale.json",
        "isSource": true,
        "original": {
          "value": "13",
          "comment": "60px"
        },
        "name": "PharosTypeScale13",
        "attributes": {
          "category": "type",
          "type": "scale",
          "item": "13"
        },
        "path": [
          "type",
          "scale",
          "13"
        ]
      },
      "14": {
        "value": "14",
        "comment": "68px",
        "filePath": "tokens/type/scale.json",
        "isSource": true,
        "original": {
          "value": "14",
          "comment": "68px"
        },
        "name": "PharosTypeScale14",
        "attributes": {
          "category": "type",
          "type": "scale",
          "item": "14"
        },
        "path": [
          "type",
          "scale",
          "14"
        ]
      }
    }
  }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (tokens);


/***/ }),

/***/ "./packages/pharos/src/styles/variables.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$m_": () => (/* binding */ PharosLoadingSpinnerColorStrokePrimary),
/* harmony export */   "Crc": () => (/* binding */ PharosLoadingSpinnerColorStrokeSecondary),
/* harmony export */   "I8l": () => (/* binding */ PharosColorNightBlueBase),
/* harmony export */   "Og2": () => (/* binding */ PharosSpacing7X),
/* harmony export */   "cnU": () => (/* binding */ PharosSpacing1X),
/* harmony export */   "eEy": () => (/* binding */ PharosSpacingThreeQuartersX),
/* harmony export */   "gyN": () => (/* binding */ PharosColorGlacierBlueBase),
/* harmony export */   "rrP": () => (/* binding */ PharosSpacingThreeAndAHalfX),
/* harmony export */   "wGb": () => (/* binding */ PharosSpacingOneAndAHalfX)
/* harmony export */ });
/* unused harmony exports PharosAssetIconAcademicContent, PharosAssetIconAdd, PharosAssetIconArrowDown, PharosAssetIconArrowLeft, PharosAssetIconArrowRight, PharosAssetIconArrowUp, PharosAssetIconAttachment, PharosAssetIconBase, PharosAssetIconBook, PharosAssetIconCalendar, PharosAssetIconCheckmarkFilledCircle, PharosAssetIconCheckmarkInverse, PharosAssetIconCheckmarkSmall, PharosAssetIconCheckmark, PharosAssetIconChevronDown, PharosAssetIconChevronLeftLarge, PharosAssetIconChevronLeft, PharosAssetIconChevronRightLarge, PharosAssetIconChevronRight, PharosAssetIconChevronUp, PharosAssetIconCircle, PharosAssetIconCite, PharosAssetIconCloseInverse, PharosAssetIconClose, PharosAssetIconCollapse, PharosAssetIconCopy, PharosAssetIconDashSmall, PharosAssetIconDelete, PharosAssetIconDownload, PharosAssetIconEdit, PharosAssetIconEllipsesHorizontal, PharosAssetIconEllipsesVertical, PharosAssetIconEmail, PharosAssetIconExclamationInverse, PharosAssetIconExclamation, PharosAssetIconExpand, PharosAssetIconFacebook, PharosAssetIconFiletypePdf, PharosAssetIconFiletypePpt, PharosAssetIconFiletypeZip, PharosAssetIconFitToView, PharosAssetIconFitToWidth, PharosAssetIconFolderNew, PharosAssetIconFolder, PharosAssetIconFolderSelected, PharosAssetIconFullscreenMinimize, PharosAssetIconFullscreen, PharosAssetIconGoogleColor, PharosAssetIconGoogle, PharosAssetIconImage, PharosAssetIconInfoInverse, PharosAssetIconInstagram, PharosAssetIconLaptop, PharosAssetIconLinkAdd, PharosAssetIconLinkExternal, PharosAssetIconLink, PharosAssetIconLinkedin, PharosAssetIconMenu, PharosAssetIconMove, PharosAssetIconNew, PharosAssetIconPartialCircle, PharosAssetIconPrimarySource, PharosAssetIconProfile, PharosAssetIconQuestionInverse, PharosAssetIconSave, PharosAssetIconSaved, PharosAssetIconSearch, PharosAssetIconShare, PharosAssetIconShiftLeft, PharosAssetIconShiftRight, PharosAssetIconShiftUp, PharosAssetIconShiftDown, PharosAssetIconTumblr, PharosAssetIconTwitter, PharosAssetIconVideo, PharosAssetIconViewGallery, PharosAssetIconViewGrid, PharosAssetIconViewList, PharosAssetIconWorkspace, PharosAssetIconWorkspaceSelected, PharosAssetIconYoutube, PharosAssetIconZoomIn, PharosAssetIconZoomOut, PharosBreakpointSmall, PharosBreakpointMedium, PharosBreakpointLarge, PharosBreakpointXlarge, PharosBreakpointMax, PharosColorJstorRed, PharosColorNightBlue15, PharosColorNightBlue60, PharosColorGlacierBlue40, PharosColorGlacierBlue70, PharosColorGlacierBlue80, PharosColorGlacierBlue90, PharosColorLivingCoral50, PharosColorLivingCoral53, PharosColorLivingCoral80, PharosColorLivingCoral90, PharosColorLivingCoralBase, PharosColorMarbleGray10, PharosColorMarbleGray20, PharosColorMarbleGray40, PharosColorMarbleGray50, PharosColorMarbleGray80, PharosColorMarbleGray94, PharosColorMarbleGray97, PharosColorMarbleGrayBase, PharosColorBlack, PharosColorWhite, PharosColorYellow97, PharosColorYellowBase, PharosColorGreen93, PharosColorGreenBase, PharosColorInteractivePrimary, PharosColorInteractiveSecondary, PharosColorInteractiveTertiary, PharosColorUi10, PharosColorUi20, PharosColorUi30, PharosColorUi40, PharosColorUi50, PharosColorDisabled, PharosColorOverlay, PharosColorFeedbackError, PharosColorFeedbackSuccess, PharosColorFeedbackWarning, PharosColorFeedbackInfo, PharosColorText10, PharosColorText20, PharosColorText40, PharosColorText50, PharosColorTextBase, PharosColorTextDisabled, PharosColorTextPlaceholder, PharosColorTextWhite, PharosColorFocus, PharosColorHoverPrimary, PharosColorHoverSecondary, PharosColorHoverRow, PharosAlertColorBackgroundBase, PharosAlertColorBackgroundInfo, PharosAlertColorBackgroundError, PharosAlertColorBackgroundSuccess, PharosAlertColorBackgroundWarning, PharosAlertColorIconBase, PharosAlertColorIconInfo, PharosAlertColorIconError, PharosAlertColorIconSuccess, PharosAlertColorIconWarning, PharosAlertColorTextBase, PharosAlertColorTextInverse, PharosAlertColorLinkBase, PharosAlertColorLinkInverse, PharosAlertColorBorderBase, PharosAlertColorBorderInfo, PharosAlertColorBorderError, PharosAlertColorBorderSuccess, PharosAlertColorBorderWarning, PharosButtonPaddingBase, PharosButtonPaddingCondensed, PharosButtonPaddingLarge, PharosButtonColorBasePrimaryBackgroundBase, PharosButtonColorBasePrimaryBackgroundHover, PharosButtonColorBasePrimaryBackgroundDisabled, PharosButtonColorBasePrimaryTextBase, PharosButtonColorBasePrimaryTextHover, PharosButtonColorBasePrimaryTextDisabled, PharosButtonColorBasePrimaryBorderBase, PharosButtonColorBasePrimaryBorderHover, PharosButtonColorBasePrimaryBorderDisabled, PharosButtonColorBaseSecondaryBackgroundBase, PharosButtonColorBaseSecondaryBackgroundHover, PharosButtonColorBaseSecondaryBackgroundDisabled, PharosButtonColorBaseSecondaryTextBase, PharosButtonColorBaseSecondaryTextHover, PharosButtonColorBaseSecondaryTextDisabled, PharosButtonColorBaseSecondaryBorderBase, PharosButtonColorBaseSecondaryBorderHover, PharosButtonColorBaseSecondaryBorderDisabled, PharosButtonColorBaseSubtleBackgroundBase, PharosButtonColorBaseSubtleBackgroundHover, PharosButtonColorBaseSubtleBackgroundDisabled, PharosButtonColorBaseSubtleTextBase, PharosButtonColorBaseSubtleTextHover, PharosButtonColorBaseSubtleTextDisabled, PharosButtonColorBaseSubtleBorderBase, PharosButtonColorBaseSubtleBorderHover, PharosButtonColorBaseSubtleBorderDisabled, PharosButtonColorBaseOverlayBackgroundBase, PharosButtonColorBaseOverlayBackgroundHover, PharosButtonColorBaseOverlayBackgroundDisabled, PharosButtonColorBaseOverlayTextBase, PharosButtonColorBaseOverlayTextHover, PharosButtonColorBaseOverlayTextDisabled, PharosButtonColorBaseOverlayBorderBase, PharosButtonColorBaseOverlayBorderHover, PharosButtonColorBaseOverlayBorderDisabled, PharosButtonColorOnBackgroundPrimaryBackgroundBase, PharosButtonColorOnBackgroundPrimaryBackgroundHover, PharosButtonColorOnBackgroundPrimaryBackgroundDisabled, PharosButtonColorOnBackgroundPrimaryTextBase, PharosButtonColorOnBackgroundPrimaryTextHover, PharosButtonColorOnBackgroundPrimaryTextDisabled, PharosButtonColorOnBackgroundPrimaryBorderBase, PharosButtonColorOnBackgroundPrimaryBorderHover, PharosButtonColorOnBackgroundPrimaryBorderDisabled, PharosButtonColorOnBackgroundSecondaryBackgroundBase, PharosButtonColorOnBackgroundSecondaryBackgroundHover, PharosButtonColorOnBackgroundSecondaryBackgroundDisabled, PharosButtonColorOnBackgroundSecondaryTextBase, PharosButtonColorOnBackgroundSecondaryTextHover, PharosButtonColorOnBackgroundSecondaryTextDisabled, PharosButtonColorOnBackgroundSecondaryBorderBase, PharosButtonColorOnBackgroundSecondaryBorderHover, PharosButtonColorOnBackgroundSecondaryBorderDisabled, PharosButtonColorOnBackgroundSubtleBackgroundBase, PharosButtonColorOnBackgroundSubtleBackgroundHover, PharosButtonColorOnBackgroundSubtleBackgroundDisabled, PharosButtonColorOnBackgroundSubtleTextBase, PharosButtonColorOnBackgroundSubtleTextHover, PharosButtonColorOnBackgroundSubtleTextDisabled, PharosButtonColorOnBackgroundSubtleBorderBase, PharosButtonColorOnBackgroundSubtleBorderHover, PharosButtonColorOnBackgroundSubtleBorderDisabled, PharosButtonColorOnBackgroundOverlayBackgroundBase, PharosButtonColorOnBackgroundOverlayBackgroundHover, PharosButtonColorOnBackgroundOverlayBackgroundDisabled, PharosButtonColorOnBackgroundOverlayTextBase, PharosButtonColorOnBackgroundOverlayTextHover, PharosButtonColorOnBackgroundOverlayTextDisabled, PharosButtonColorOnBackgroundOverlayBorderBase, PharosButtonColorOnBackgroundOverlayBorderHover, PharosButtonColorOnBackgroundOverlayBorderDisabled, PharosCheckboxGroupSpacingVertical, PharosCheckboxGroupSpacingHorizontal, PharosCheckboxColorBackgroundBase, PharosComboboxColorTextHover, PharosComboboxColorTextSelected, PharosComboboxColorIconClear, PharosComboboxColorIconDropdown, PharosComboboxColorIconCheckmark, PharosComboboxColorIconFocus, PharosComboboxSizeHeightList, PharosComboboxSizeHeightClear, PharosDropdownMenuItemColorTextBase, PharosDropdownMenuItemColorTextHover, PharosDropdownMenuItemColorTextDisabled, PharosDropdownMenuItemColorTextDescription, PharosDropdownMenuItemColorBorderBase, PharosDropdownMenuItemColorBackgroundBase, PharosDropdownMenuItemColorBackgroundActive, PharosDropdownMenuItemColorBackgroundDisabled, PharosDropdownMenuItemColorBackgroundHover, PharosDropdownMenuItemColorIconBase, PharosDropdownMenuColorBorderBase, PharosDropdownMenuSizeWidthMin, PharosDropdownMenuSizeWidthMax, PharosFormElementColorTextBase, PharosFormElementColorTextRequired, PharosFormElementColorTextInvalid, PharosFormElementColorTextDisabled, PharosFormElementColorTextPlaceholder, PharosFormElementColorBackgroundDisabled, PharosFormElementColorBackgroundSelected, PharosFormElementColorBorderBase, PharosFormElementColorBorderFocus, PharosFormElementColorBorderInvalid, PharosFormElementColorBorderDisabled, PharosFormElementSizeTextLabel, PharosFormElementSizeTextInput, PharosModalColorBackgroundContent, PharosModalColorBorderContent, PharosModalColorIconClose, PharosModalColorIconFocus, PharosModalSpacingBase, PharosModalSizeWidthBase, PharosRadioButtonColorBackgroundBase, PharosRadioGroupSpacingVertical, PharosRadioGroupSpacingHorizontal, PharosTextInputColorIconValid, PharosTextInputColorIconInvalid, PharosTextareaSizeHeightBase, PharosTooltipColorBackgroundBase, PharosTooltipColorTextBase, PharosTooltipSizeTextBase, PharosFontFamilySansSerif, PharosFontFamilySerif, PharosFontFamilyBody, PharosFontWeightRegular, PharosFontWeightBold, PharosFontSizeMicro, PharosFontSizeSmall, PharosFontSizeBase, PharosFontSizeLarge, PharosFontSizeXlarge, PharosLineHeightXsmall, PharosLineHeightSmall, PharosLineHeightMedium, PharosLineHeightLarge, PharosLineHeightXlarge, PharosLineHeightHeadingLarge, PharosLineHeightTextBaseCondensed, PharosRadiusBaseStandard, PharosSpacingOneEighthX, PharosSpacingOneQuarterX, PharosSpacingOneHalfX, PharosSpacing2X, PharosSpacing3X, PharosSpacing5X, PharosSpacing10X, PharosSpacingGutter, PharosTransitionBase, PharosTransitionDurationShorter, PharosTransitionDurationShort, PharosTransitionDurationDefault, PharosTransitionDurationLong, PharosTransitionDurationLonger, PharosTransitionCurveBase, PharosTypeScale1, PharosTypeScale2, PharosTypeScale3, PharosTypeScale4, PharosTypeScale5, PharosTypeScale6, PharosTypeScale7, PharosTypeScale8, PharosTypeScale9, PharosTypeScale10, PharosTypeScale11, PharosTypeScale12, PharosTypeScale13, PharosTypeScale14 */
const PharosAssetIconAcademicContent = "assets/icons/academic-content.svg";
const PharosAssetIconAdd = "assets/icons/add.svg";
const PharosAssetIconArrowDown = "assets/icons/arrow-down.svg";
const PharosAssetIconArrowLeft = "assets/icons/arrow-left.svg";
const PharosAssetIconArrowRight = "assets/icons/arrow-right.svg";
const PharosAssetIconArrowUp = "assets/icons/arrow-up.svg";
const PharosAssetIconAttachment = "assets/icons/attachment.svg";
const PharosAssetIconBase = "assets/icons/base.svg";
const PharosAssetIconBook = "assets/icons/book.svg";
const PharosAssetIconCalendar = "assets/icons/calendar.svg";
const PharosAssetIconCheckmarkFilledCircle = "assets/icons/checkmark-filled-circle.svg";
const PharosAssetIconCheckmarkInverse = "assets/icons/checkmark-inverse.svg";
const PharosAssetIconCheckmarkSmall = "assets/icons/checkmark-small.svg";
const PharosAssetIconCheckmark = "assets/icons/checkmark.svg";
const PharosAssetIconChevronDown = "assets/icons/chevron-down.svg";
const PharosAssetIconChevronLeftLarge = "assets/icons/chevron-left-large.svg";
const PharosAssetIconChevronLeft = "assets/icons/chevron-left.svg";
const PharosAssetIconChevronRightLarge = "assets/icons/chevron-right-large.svg";
const PharosAssetIconChevronRight = "assets/icons/chevron-right.svg";
const PharosAssetIconChevronUp = "assets/icons/chevron-up.svg";
const PharosAssetIconCircle = "assets/icons/circle.svg";
const PharosAssetIconCite = "assets/icons/cite.svg";
const PharosAssetIconCloseInverse = "assets/icons/close-inverse.svg";
const PharosAssetIconClose = "assets/icons/close.svg";
const PharosAssetIconCollapse = "assets/icons/shift-right.svg";
const PharosAssetIconCopy = "assets/icons/copy.svg";
const PharosAssetIconDashSmall = "assets/icons/dash-small.svg";
const PharosAssetIconDelete = "assets/icons/delete.svg";
const PharosAssetIconDownload = "assets/icons/download.svg";
const PharosAssetIconEdit = "assets/icons/edit.svg";
const PharosAssetIconEllipsesHorizontal = "assets/icons/ellipses-horizontal.svg";
const PharosAssetIconEllipsesVertical = "assets/icons/ellipses-vertical.svg";
const PharosAssetIconEmail = "assets/icons/email.svg";
const PharosAssetIconExclamationInverse = "assets/icons/exclamation-inverse.svg";
const PharosAssetIconExclamation = "assets/icons/exclamation.svg";
const PharosAssetIconExpand = "assets/icons/shift-left.svg";
const PharosAssetIconFacebook = "assets/icons/facebook.svg";
const PharosAssetIconFiletypePdf = "assets/icons/filetype-pdf.svg";
const PharosAssetIconFiletypePpt = "assets/icons/filetype-ppt.svg";
const PharosAssetIconFiletypeZip = "assets/icons/filetype-zip.svg";
const PharosAssetIconFitToView = "assets/icons/fit-to-view.svg";
const PharosAssetIconFitToWidth = "assets/icons/fit-to-width.svg";
const PharosAssetIconFolderNew = "assets/icons/folder-new.svg";
const PharosAssetIconFolder = "assets/icons/folder.svg";
const PharosAssetIconFolderSelected = "assets/icons/folder-selected.svg";
const PharosAssetIconFullscreenMinimize = "assets/icons/fullscreen-minimize.svg";
const PharosAssetIconFullscreen = "assets/icons/fullscreen.svg";
const PharosAssetIconGoogleColor = "assets/icons/google-color.svg";
const PharosAssetIconGoogle = "assets/icons/google.svg";
const PharosAssetIconImage = "assets/icons/image.svg";
const PharosAssetIconInfoInverse = "assets/icons/info-inverse.svg";
const PharosAssetIconInstagram = "assets/icons/instagram.svg";
const PharosAssetIconLaptop = "assets/icons/laptop.svg";
const PharosAssetIconLinkAdd = "assets/icons/link-add.svg";
const PharosAssetIconLinkExternal = "assets/icons/link-external.svg";
const PharosAssetIconLink = "assets/icons/link.svg";
const PharosAssetIconLinkedin = "assets/icons/linkedin.svg";
const PharosAssetIconMenu = "assets/icons/menu.svg";
const PharosAssetIconMove = "assets/icons/move.svg";
const PharosAssetIconNew = "assets/icons/new.svg";
const PharosAssetIconPartialCircle = "assets/icons/partial-circle.svg";
const PharosAssetIconPrimarySource = "assets/icons/primary-source.svg";
const PharosAssetIconProfile = "assets/icons/profile.svg";
const PharosAssetIconQuestionInverse = "assets/icons/question-inverse.svg";
const PharosAssetIconSave = "assets/icons/save.svg";
const PharosAssetIconSaved = "assets/icons/saved.svg";
const PharosAssetIconSearch = "assets/icons/search.svg";
const PharosAssetIconShare = "assets/icons/share.svg";
const PharosAssetIconShiftLeft = "assets/icons/shift-left.svg";
const PharosAssetIconShiftRight = "assets/icons/shift-right.svg";
const PharosAssetIconShiftUp = "assets/icons/shift-up.svg";
const PharosAssetIconShiftDown = "assets/icons/shift-down.svg";
const PharosAssetIconTumblr = "assets/icons/tumblr.svg";
const PharosAssetIconTwitter = "assets/icons/twitter.svg";
const PharosAssetIconVideo = "assets/icons/video.svg";
const PharosAssetIconViewGallery = "assets/icons/view-gallery.svg";
const PharosAssetIconViewGrid = "assets/icons/view-grid.svg";
const PharosAssetIconViewList = "assets/icons/view-list.svg";
const PharosAssetIconWorkspace = "assets/icons/workspace.svg";
const PharosAssetIconWorkspaceSelected = "assets/icons/workspace-selected.svg";
const PharosAssetIconYoutube = "assets/icons/youtube.svg";
const PharosAssetIconZoomIn = "assets/icons/zoom-in.svg";
const PharosAssetIconZoomOut = "assets/icons/zoom-out.svg";
const PharosBreakpointSmall = "22.5rem";
const PharosBreakpointMedium = "48rem";
const PharosBreakpointLarge = "66rem";
const PharosBreakpointXlarge = "85rem";
const PharosBreakpointMax = "99rem";
const PharosColorJstorRed = "#990000";
const PharosColorNightBlue15 = "#071d46";
const PharosColorNightBlue60 = "#8091b3";
const PharosColorNightBlueBase = "#0d3071";
const PharosColorGlacierBlue40 = "#0ba3c1";
const PharosColorGlacierBlue70 = "#79deec";
const PharosColorGlacierBlue80 = "#b4dee4";
const PharosColorGlacierBlue90 = "#dcedef";
const PharosColorGlacierBlueBase = "#27cae1";
const PharosColorLivingCoral50 = "#c83737";
const PharosColorLivingCoral53 = "#dd3431";
const PharosColorLivingCoral80 = "#fc9c9c";
const PharosColorLivingCoral90 = "#f4d7d7";
const PharosColorLivingCoralBase = "#fb4848";
const PharosColorMarbleGray10 = "#1a1a19";
const PharosColorMarbleGray20 = "#343332";
const PharosColorMarbleGray40 = "#676765";
const PharosColorMarbleGray50 = "#81807e";
const PharosColorMarbleGray80 = "#d1cfc7";
const PharosColorMarbleGray94 = "#f2f1ed";
const PharosColorMarbleGray97 = "#f9f8f6";
const PharosColorMarbleGrayBase = "#eae8e1";
const PharosColorBlack = "#000000";
const PharosColorWhite = "#ffffff";
const PharosColorYellow97 = "#fdf9f2";
const PharosColorYellowBase = "#faa926";
const PharosColorGreen93 = "#e9f1eb";
const PharosColorGreenBase = "#268241";
const PharosColorInteractivePrimary = "#990000";
const PharosColorInteractiveSecondary = "#000000";
const PharosColorInteractiveTertiary = "#ffffff";
const PharosColorUi10 = "#ffffff";
const PharosColorUi20 = "#f2f1ed";
const PharosColorUi30 = "#eae8e1";
const PharosColorUi40 = "#d1cfc7";
const PharosColorUi50 = "#81807e";
const PharosColorDisabled = "#eae8e1";
const PharosColorOverlay = "#000000";
const PharosColorFeedbackError = "#dd3431";
const PharosColorFeedbackSuccess = "#268241";
const PharosColorFeedbackWarning = "#faa926";
const PharosColorFeedbackInfo = "#0ba3c1";
const PharosColorText10 = "#1a1a19";
const PharosColorText20 = "#343332";
const PharosColorText40 = "#676765";
const PharosColorText50 = "#81807e";
const PharosColorTextBase = "#000000";
const PharosColorTextDisabled = "#676765";
const PharosColorTextPlaceholder = "#676765";
const PharosColorTextWhite = "#ffffff";
const PharosColorFocus = "#0ba3c1";
const PharosColorHoverPrimary = "#990000";
const PharosColorHoverSecondary = "#ffffff";
const PharosColorHoverRow = "#f2f1ed";
const PharosAlertColorBackgroundBase = "#f2f1ed";
const PharosAlertColorBackgroundInfo = "#dcedef";
const PharosAlertColorBackgroundError = "#f4d7d7";
const PharosAlertColorBackgroundSuccess = "#e9f1eb";
const PharosAlertColorBackgroundWarning = "#fdf9f2";
const PharosAlertColorIconBase = "#000000";
const PharosAlertColorIconInfo = "#0ba3c1";
const PharosAlertColorIconError = "#dd3431";
const PharosAlertColorIconSuccess = "#268241";
const PharosAlertColorIconWarning = "#faa926";
const PharosAlertColorTextBase = "#000000";
const PharosAlertColorTextInverse = "#ffffff";
const PharosAlertColorLinkBase = "#000000";
const PharosAlertColorLinkInverse = "#ffffff";
const PharosAlertColorBorderBase = "#f2f1ed";
const PharosAlertColorBorderInfo = "#0ba3c1";
const PharosAlertColorBorderError = "#dd3431";
const PharosAlertColorBorderSuccess = "#268241";
const PharosAlertColorBorderWarning = "#faa926";
const PharosButtonPaddingBase = "0.25rem";
const PharosButtonPaddingCondensed = "0.125rem";
const PharosButtonPaddingLarge = "0.5rem";
const PharosButtonColorBasePrimaryBackgroundBase = "#990000";
const PharosButtonColorBasePrimaryBackgroundHover = "transparent";
const PharosButtonColorBasePrimaryBackgroundDisabled = "#eae8e1";
const PharosButtonColorBasePrimaryTextBase = "#ffffff";
const PharosButtonColorBasePrimaryTextHover = "#990000";
const PharosButtonColorBasePrimaryTextDisabled = "#676765";
const PharosButtonColorBasePrimaryBorderBase = "#990000";
const PharosButtonColorBasePrimaryBorderHover = "#990000";
const PharosButtonColorBasePrimaryBorderDisabled = "#eae8e1";
const PharosButtonColorBaseSecondaryBackgroundBase = "transparent";
const PharosButtonColorBaseSecondaryBackgroundHover = "transparent";
const PharosButtonColorBaseSecondaryBackgroundDisabled = "#eae8e1";
const PharosButtonColorBaseSecondaryTextBase = "#000000";
const PharosButtonColorBaseSecondaryTextHover = "#990000";
const PharosButtonColorBaseSecondaryTextDisabled = "#676765";
const PharosButtonColorBaseSecondaryBorderBase = "#d1cfc7";
const PharosButtonColorBaseSecondaryBorderHover = "#990000";
const PharosButtonColorBaseSecondaryBorderDisabled = "#eae8e1";
const PharosButtonColorBaseSubtleBackgroundBase = "transparent";
const PharosButtonColorBaseSubtleBackgroundHover = "#f2f1ed";
const PharosButtonColorBaseSubtleBackgroundDisabled = "transparent";
const PharosButtonColorBaseSubtleTextBase = "#000000";
const PharosButtonColorBaseSubtleTextHover = "#990000";
const PharosButtonColorBaseSubtleTextDisabled = "#676765";
const PharosButtonColorBaseSubtleBorderBase = "transparent";
const PharosButtonColorBaseSubtleBorderHover = "#f2f1ed";
const PharosButtonColorBaseSubtleBorderDisabled = "transparent";
const PharosButtonColorBaseOverlayBackgroundBase = "#1a1a19";
const PharosButtonColorBaseOverlayBackgroundHover = "#343332";
const PharosButtonColorBaseOverlayBackgroundDisabled = "#eae8e1";
const PharosButtonColorBaseOverlayTextBase = "#ffffff";
const PharosButtonColorBaseOverlayTextHover = "#ffffff";
const PharosButtonColorBaseOverlayTextDisabled = "#676765";
const PharosButtonColorBaseOverlayBorderBase = "#1a1a19";
const PharosButtonColorBaseOverlayBorderHover = "#343332";
const PharosButtonColorBaseOverlayBorderDisabled = "#eae8e1";
const PharosButtonColorOnBackgroundPrimaryBackgroundBase = "#990000";
const PharosButtonColorOnBackgroundPrimaryBackgroundHover = "transparent";
const PharosButtonColorOnBackgroundPrimaryBackgroundDisabled = "#343332";
const PharosButtonColorOnBackgroundPrimaryTextBase = "#ffffff";
const PharosButtonColorOnBackgroundPrimaryTextHover = "#ffffff";
const PharosButtonColorOnBackgroundPrimaryTextDisabled = "#81807e";
const PharosButtonColorOnBackgroundPrimaryBorderBase = "#990000";
const PharosButtonColorOnBackgroundPrimaryBorderHover = "#ffffff";
const PharosButtonColorOnBackgroundPrimaryBorderDisabled = "#343332";
const PharosButtonColorOnBackgroundSecondaryBackgroundBase = "transparent";
const PharosButtonColorOnBackgroundSecondaryBackgroundHover = "transparent";
const PharosButtonColorOnBackgroundSecondaryBackgroundDisabled = "#343332";
const PharosButtonColorOnBackgroundSecondaryTextBase = "#ffffff";
const PharosButtonColorOnBackgroundSecondaryTextHover = "#ffffff";
const PharosButtonColorOnBackgroundSecondaryTextDisabled = "#81807e";
const PharosButtonColorOnBackgroundSecondaryBorderBase = "#81807e";
const PharosButtonColorOnBackgroundSecondaryBorderHover = "#ffffff";
const PharosButtonColorOnBackgroundSecondaryBorderDisabled = "#343332";
const PharosButtonColorOnBackgroundSubtleBackgroundBase = "transparent";
const PharosButtonColorOnBackgroundSubtleBackgroundHover = "#343332";
const PharosButtonColorOnBackgroundSubtleBackgroundDisabled = "transparent";
const PharosButtonColorOnBackgroundSubtleTextBase = "#ffffff";
const PharosButtonColorOnBackgroundSubtleTextHover = "#ffffff";
const PharosButtonColorOnBackgroundSubtleTextDisabled = "#81807e";
const PharosButtonColorOnBackgroundSubtleBorderBase = "transparent";
const PharosButtonColorOnBackgroundSubtleBorderHover = "#343332";
const PharosButtonColorOnBackgroundSubtleBorderDisabled = "transparent";
const PharosButtonColorOnBackgroundOverlayBackgroundBase = "#1a1a19";
const PharosButtonColorOnBackgroundOverlayBackgroundHover = "#343332";
const PharosButtonColorOnBackgroundOverlayBackgroundDisabled = "#343332";
const PharosButtonColorOnBackgroundOverlayTextBase = "#ffffff";
const PharosButtonColorOnBackgroundOverlayTextHover = "#ffffff";
const PharosButtonColorOnBackgroundOverlayTextDisabled = "#81807e";
const PharosButtonColorOnBackgroundOverlayBorderBase = "#1a1a19";
const PharosButtonColorOnBackgroundOverlayBorderHover = "#343332";
const PharosButtonColorOnBackgroundOverlayBorderDisabled = "#343332";
const PharosCheckboxGroupSpacingVertical = "0.5rem";
const PharosCheckboxGroupSpacingHorizontal = "1.5rem";
const PharosCheckboxColorBackgroundBase = "#ffffff";
const PharosComboboxColorTextHover = "#990000";
const PharosComboboxColorTextSelected = "#000000";
const PharosComboboxColorIconClear = "#81807e";
const PharosComboboxColorIconDropdown = "#000000";
const PharosComboboxColorIconCheckmark = "#000000";
const PharosComboboxColorIconFocus = "#990000";
const PharosComboboxSizeHeightList = "15rem";
const PharosComboboxSizeHeightClear = "1.875rem";
const PharosDropdownMenuItemColorTextBase = "#000000";
const PharosDropdownMenuItemColorTextHover = "#990000";
const PharosDropdownMenuItemColorTextDisabled = "#676765";
const PharosDropdownMenuItemColorTextDescription = "#676765";
const PharosDropdownMenuItemColorBorderBase = "#d1cfc7";
const PharosDropdownMenuItemColorBackgroundBase = "#ffffff";
const PharosDropdownMenuItemColorBackgroundActive = "#eae8e1";
const PharosDropdownMenuItemColorBackgroundDisabled = "#eae8e1";
const PharosDropdownMenuItemColorBackgroundHover = "#f2f1ed";
const PharosDropdownMenuItemColorIconBase = "#000000";
const PharosDropdownMenuColorBorderBase = "#d1cfc7";
const PharosDropdownMenuSizeWidthMin = "9rem";
const PharosDropdownMenuSizeWidthMax = "17rem";
const PharosFormElementColorTextBase = "#000000";
const PharosFormElementColorTextRequired = "#dd3431";
const PharosFormElementColorTextInvalid = "#dd3431";
const PharosFormElementColorTextDisabled = "#676765";
const PharosFormElementColorTextPlaceholder = "#676765";
const PharosFormElementColorBackgroundDisabled = "#eae8e1";
const PharosFormElementColorBackgroundSelected = "#000000";
const PharosFormElementColorBorderBase = "#81807e";
const PharosFormElementColorBorderFocus = "#0ba3c1";
const PharosFormElementColorBorderInvalid = "#dd3431";
const PharosFormElementColorBorderDisabled = "#d1cfc7";
const PharosFormElementSizeTextLabel = "2";
const PharosFormElementSizeTextInput = "3";
const PharosLoadingSpinnerColorStrokePrimary = "#990000";
const PharosLoadingSpinnerColorStrokeSecondary = "#fb4848";
const PharosModalColorBackgroundContent = "#ffffff";
const PharosModalColorBorderContent = "#eae8e1";
const PharosModalColorIconClose = "#81807e";
const PharosModalColorIconFocus = "#990000";
const PharosModalSpacingBase = "2rem";
const PharosModalSizeWidthBase = "40rem";
const PharosRadioButtonColorBackgroundBase = "#ffffff";
const PharosRadioGroupSpacingVertical = "0.5rem";
const PharosRadioGroupSpacingHorizontal = "1.5rem";
const PharosTextInputColorIconValid = "#268241";
const PharosTextInputColorIconInvalid = "#dd3431";
const PharosTextareaSizeHeightBase = "3.5rem";
const PharosTooltipColorBackgroundBase = "#343332";
const PharosTooltipColorTextBase = "#ffffff";
const PharosTooltipSizeTextBase = "2";
const PharosFontFamilySansSerif = "GT America Standard, Helvetica, Helvetica Neue, Arial, Segoe UI, Roboto, Droid Sans, sans-serif";
const PharosFontFamilySerif = "Ivar Headline, Times, Georgia, serif";
const PharosFontFamilyBody = "GT America Standard, Helvetica, Helvetica Neue, Arial, Segoe UI, Roboto, Droid Sans, sans-serif";
const PharosFontWeightRegular = "400";
const PharosFontWeightBold = "700";
const PharosFontSizeMicro = "1";
const PharosFontSizeSmall = "2";
const PharosFontSizeBase = "3";
const PharosFontSizeLarge = "5";
const PharosFontSizeXlarge = "6";
const PharosLineHeightXsmall = "1rem";
const PharosLineHeightSmall = "1.25rem";
const PharosLineHeightMedium = "1.5rem";
const PharosLineHeightLarge = "1.75rem";
const PharosLineHeightXlarge = "2.25rem";
const PharosLineHeightHeadingLarge = "1";
const PharosLineHeightTextBaseCondensed = "1.25rem";
const PharosRadiusBaseStandard = "0.125rem";
const PharosSpacingOneEighthX = "0.125rem";
const PharosSpacingOneQuarterX = "0.25rem";
const PharosSpacingOneHalfX = "0.5rem";
const PharosSpacingThreeQuartersX = "0.75rem";
const PharosSpacing1X = "1rem";
const PharosSpacingOneAndAHalfX = "1.5rem";
const PharosSpacing2X = "2rem";
const PharosSpacing3X = "3rem";
const PharosSpacingThreeAndAHalfX = "3.5rem";
const PharosSpacing5X = "5rem";
const PharosSpacing7X = "7rem";
const PharosSpacing10X = "10rem";
const PharosSpacingGutter = "3rem";
const PharosTransitionBase = "250ms cubic-bezier(0.17, 0.67, 0.83, 0.67)";
const PharosTransitionDurationShorter = "50ms";
const PharosTransitionDurationShort = "100ms";
const PharosTransitionDurationDefault = "250ms";
const PharosTransitionDurationLong = "500ms";
const PharosTransitionDurationLonger = "1000ms";
const PharosTransitionCurveBase = "cubic-bezier(0.17, 0.67, 0.83, 0.67)";
const PharosTypeScale1 = "1";
const PharosTypeScale2 = "2";
const PharosTypeScale3 = "3";
const PharosTypeScale4 = "4";
const PharosTypeScale5 = "5";
const PharosTypeScale6 = "6";
const PharosTypeScale7 = "7";
const PharosTypeScale8 = "8";
const PharosTypeScale9 = "9";
const PharosTypeScale10 = "10";
const PharosTypeScale11 = "11";
const PharosTypeScale12 = "12";
const PharosTypeScale13 = "13";
const PharosTypeScale14 = "14";


/***/ }),

/***/ "./packages/pharos/src/utils/createFormData.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const createFormData = (form) => {
  const formData = new FormData(form);
  if (window.FormDataEvent === void 0) {
    const event = new CustomEvent("formdata", {
      bubbles: true,
      cancelable: false,
      composed: false
    });
    event.formData = formData;
    form.dispatchEvent(event);
    for (const [inputName, inputValue] of formData.entries()) {
      const element = form.elements[inputName];
      if (element) {
        element.value = inputValue;
      } else {
        const hiddenInput = document.createElement("input");
        hiddenInput.type = "hidden";
        hiddenInput.value = inputValue;
        hiddenInput.name = inputName;
        form.appendChild(hiddenInput);
      }
    }
  }
  return formData;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (createFormData);


/***/ }),

/***/ "./packages/pharos/src/utils/deepSelector.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const deepSelector = (selectors, root = document) => {
  if (!root)
    return null;
  const inRoot = root.querySelector(selectors);
  if (inRoot) {
    return inRoot;
  } else {
    let inChild = null;
    for (const child of [...root.querySelectorAll("*")].filter((x) => x.shadowRoot)) {
      inChild = deepSelector(selectors, child.shadowRoot);
      if (inChild)
        break;
    }
    return inChild;
  }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (deepSelector);


/***/ }),

/***/ "./packages/pharos/src/utils/focusable.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const focusable = `
  a[href],
  area[href],
  button:not([disabled]),
  details,
  iframe,
  input:not([disabled]),
  select:not([disabled]),
  textarea:not([disabled]),
  [contentEditable="true"],
  [tabindex]:not([tabindex="-1"]),
  [data-pharos-component="PharosCheckbox"]:not([disabled]),
  [data-pharos-component="PharosRadioButton"]:not([disabled]),
  [data-pharos-component="PharosTextInput"]:not([disabled]),
  [data-pharos-component="PharosInputGroup"]:not([disabled]),
  [data-pharos-component="PharosSelect"]:not([disabled]),
  [data-pharos-component="PharosInputGroupSelect"]:not([disabled]),
  [data-pharos-component="PharosTextarea"]:not([disabled]),
  [data-pharos-component="PharosCombobox"]:not([disabled]),
  [data-pharos-component="PharosAlert"],
  [data-pharos-component="PharosDropdownMenuItem"]:not([disabled]),
  [data-pharos-component="PharosLink"][href],
  [data-pharos-component="PharosButton"]:not([disabled]),
  [data-pharos-component="PharosTab"],
  [data-pharos-component="PharosDropdownMenuNavLink"][href],
  [data-pharos-component="PharosSidenavLink"][href],
  [data-pharos-component="PharosToast"],
  [data-pharos-component="PharosBreadcrumbItem"][href],
  [data-pharos-component="PharosSidenavButton"]:not([disabled])
`;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (focusable);


/***/ }),

/***/ "./packages/pharos/src/utils/iconNames.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": () => (/* binding */ iconNames)
/* harmony export */ });
/* harmony import */ var _styles_tokens__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./packages/pharos/src/styles/tokens.ts");

const iconNames = Object.keys(_styles_tokens__WEBPACK_IMPORTED_MODULE_0__/* ["default"].asset.icon */ .Z.asset.icon).sort();


/***/ }),

/***/ "./packages/pharos/src/utils/mixins/focus.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _open_wc_dedupe_mixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/@open-wc/dedupe-mixin/src/dedupeMixin.js");
/* harmony import */ var _focusable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./packages/pharos/src/utils/focusable.ts");


const FocusMixinImplementation = (Base) => {
  class Focus extends Base {
    focus() {
      var _a;
      const target = ((_a = this.shadowRoot) == null ? void 0 : _a.querySelector(_focusable__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)) || this.querySelector(_focusable__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);
      target == null ? void 0 : target.focus();
    }
  }
  return Focus;
};
const FocusMixin = (0,_open_wc_dedupe_mixin__WEBPACK_IMPORTED_MODULE_1__/* .dedupeMixin */ .S)(FocusMixinImplementation);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FocusMixin);


/***/ }),

/***/ "./packages/pharos/src/utils/mixins/form.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _open_wc_dedupe_mixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/@open-wc/dedupe-mixin/src/dedupeMixin.js");

const FormMixinImplementation = (Base) => {
  class Form extends Base {
    constructor(...args) {
      super(...args);
      this._handleFormdata = this._handleFormdata.bind(this);
      this._handleFormReset = this._handleFormReset.bind(this);
    }
    connectedCallback() {
      super.connectedCallback && super.connectedCallback();
      const form = this.closest("form");
      if (form) {
        form.addEventListener("formdata", this._handleFormdata);
        form.addEventListener("reset", this._handleFormReset);
      }
    }
    disconnectedCallback() {
      const form = this.closest("form");
      if (form) {
        form.removeEventListener("formdata", this._handleFormdata);
        form.removeEventListener("reset", this._handleFormReset);
      }
      super.disconnectedCallback && super.disconnectedCallback();
    }
  }
  return Form;
};
const FormMixin = (0,_open_wc_dedupe_mixin__WEBPACK_IMPORTED_MODULE_0__/* .dedupeMixin */ .S)(FormMixinImplementation);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FormMixin);


/***/ }),

/***/ "./packages/pharos/src/utils/mixins/scoped-registry.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _lit_labs_scoped_registry_mixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/@lit-labs/scoped-registry-mixin/scoped-registry-mixin.js");
/* harmony import */ var _open_wc_dedupe_mixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/@open-wc/dedupe-mixin/src/dedupeMixin.js");


const ScopedRegistryMixin = (0,_open_wc_dedupe_mixin__WEBPACK_IMPORTED_MODULE_1__/* .dedupeMixin */ .S)(_lit_labs_scoped_registry_mixin__WEBPACK_IMPORTED_MODULE_0__/* .ScopedRegistryHost */ .T);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ScopedRegistryMixin);


/***/ }),

/***/ "./storybook-init-framework-entry.js":
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _storybook_web_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/@storybook/web-components/dist/esm/client/index.js");



/***/ }),

/***/ "./packages/pharos/src/styles/icons sync recursive ^\\.\\/.*$":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var map = {
	"./academic-content": "./packages/pharos/src/styles/icons/academic-content.ts",
	"./academic-content.ts": "./packages/pharos/src/styles/icons/academic-content.ts",
	"./add": "./packages/pharos/src/styles/icons/add.ts",
	"./add.ts": "./packages/pharos/src/styles/icons/add.ts",
	"./arrow-down": "./packages/pharos/src/styles/icons/arrow-down.ts",
	"./arrow-down.ts": "./packages/pharos/src/styles/icons/arrow-down.ts",
	"./arrow-left": "./packages/pharos/src/styles/icons/arrow-left.ts",
	"./arrow-left.ts": "./packages/pharos/src/styles/icons/arrow-left.ts",
	"./arrow-right": "./packages/pharos/src/styles/icons/arrow-right.ts",
	"./arrow-right.ts": "./packages/pharos/src/styles/icons/arrow-right.ts",
	"./arrow-up": "./packages/pharos/src/styles/icons/arrow-up.ts",
	"./arrow-up.ts": "./packages/pharos/src/styles/icons/arrow-up.ts",
	"./attachment": "./packages/pharos/src/styles/icons/attachment.ts",
	"./attachment.ts": "./packages/pharos/src/styles/icons/attachment.ts",
	"./base": "./packages/pharos/src/styles/icons/base.ts",
	"./base.ts": "./packages/pharos/src/styles/icons/base.ts",
	"./book": "./packages/pharos/src/styles/icons/book.ts",
	"./book.ts": "./packages/pharos/src/styles/icons/book.ts",
	"./calendar": "./packages/pharos/src/styles/icons/calendar.ts",
	"./calendar.ts": "./packages/pharos/src/styles/icons/calendar.ts",
	"./checkmark": "./packages/pharos/src/styles/icons/checkmark.ts",
	"./checkmark-filled-circle": "./packages/pharos/src/styles/icons/checkmark-filled-circle.ts",
	"./checkmark-filled-circle.ts": "./packages/pharos/src/styles/icons/checkmark-filled-circle.ts",
	"./checkmark-inverse": "./packages/pharos/src/styles/icons/checkmark-inverse.ts",
	"./checkmark-inverse.ts": "./packages/pharos/src/styles/icons/checkmark-inverse.ts",
	"./checkmark-small": "./packages/pharos/src/styles/icons/checkmark-small.ts",
	"./checkmark-small.ts": "./packages/pharos/src/styles/icons/checkmark-small.ts",
	"./checkmark.ts": "./packages/pharos/src/styles/icons/checkmark.ts",
	"./chevron-down": "./packages/pharos/src/styles/icons/chevron-down.ts",
	"./chevron-down.ts": "./packages/pharos/src/styles/icons/chevron-down.ts",
	"./chevron-left": "./packages/pharos/src/styles/icons/chevron-left.ts",
	"./chevron-left-large": "./packages/pharos/src/styles/icons/chevron-left-large.ts",
	"./chevron-left-large.ts": "./packages/pharos/src/styles/icons/chevron-left-large.ts",
	"./chevron-left.ts": "./packages/pharos/src/styles/icons/chevron-left.ts",
	"./chevron-right": "./packages/pharos/src/styles/icons/chevron-right.ts",
	"./chevron-right-large": "./packages/pharos/src/styles/icons/chevron-right-large.ts",
	"./chevron-right-large.ts": "./packages/pharos/src/styles/icons/chevron-right-large.ts",
	"./chevron-right.ts": "./packages/pharos/src/styles/icons/chevron-right.ts",
	"./chevron-up": "./packages/pharos/src/styles/icons/chevron-up.ts",
	"./chevron-up.ts": "./packages/pharos/src/styles/icons/chevron-up.ts",
	"./circle": "./packages/pharos/src/styles/icons/circle.ts",
	"./circle.ts": "./packages/pharos/src/styles/icons/circle.ts",
	"./cite": "./packages/pharos/src/styles/icons/cite.ts",
	"./cite.ts": "./packages/pharos/src/styles/icons/cite.ts",
	"./close": "./packages/pharos/src/styles/icons/close.ts",
	"./close-inverse": "./packages/pharos/src/styles/icons/close-inverse.ts",
	"./close-inverse.ts": "./packages/pharos/src/styles/icons/close-inverse.ts",
	"./close.ts": "./packages/pharos/src/styles/icons/close.ts",
	"./collapse": "./packages/pharos/src/styles/icons/collapse.ts",
	"./collapse.ts": "./packages/pharos/src/styles/icons/collapse.ts",
	"./copy": "./packages/pharos/src/styles/icons/copy.ts",
	"./copy.ts": "./packages/pharos/src/styles/icons/copy.ts",
	"./dash-small": "./packages/pharos/src/styles/icons/dash-small.ts",
	"./dash-small.ts": "./packages/pharos/src/styles/icons/dash-small.ts",
	"./delete": "./packages/pharos/src/styles/icons/delete.ts",
	"./delete.ts": "./packages/pharos/src/styles/icons/delete.ts",
	"./download": "./packages/pharos/src/styles/icons/download.ts",
	"./download.ts": "./packages/pharos/src/styles/icons/download.ts",
	"./edit": "./packages/pharos/src/styles/icons/edit.ts",
	"./edit.ts": "./packages/pharos/src/styles/icons/edit.ts",
	"./ellipses-horizontal": "./packages/pharos/src/styles/icons/ellipses-horizontal.ts",
	"./ellipses-horizontal.ts": "./packages/pharos/src/styles/icons/ellipses-horizontal.ts",
	"./ellipses-vertical": "./packages/pharos/src/styles/icons/ellipses-vertical.ts",
	"./ellipses-vertical.ts": "./packages/pharos/src/styles/icons/ellipses-vertical.ts",
	"./email": "./packages/pharos/src/styles/icons/email.ts",
	"./email.ts": "./packages/pharos/src/styles/icons/email.ts",
	"./exclamation": "./packages/pharos/src/styles/icons/exclamation.ts",
	"./exclamation-inverse": "./packages/pharos/src/styles/icons/exclamation-inverse.ts",
	"./exclamation-inverse.ts": "./packages/pharos/src/styles/icons/exclamation-inverse.ts",
	"./exclamation.ts": "./packages/pharos/src/styles/icons/exclamation.ts",
	"./expand": "./packages/pharos/src/styles/icons/expand.ts",
	"./expand.ts": "./packages/pharos/src/styles/icons/expand.ts",
	"./facebook": "./packages/pharos/src/styles/icons/facebook.ts",
	"./facebook.ts": "./packages/pharos/src/styles/icons/facebook.ts",
	"./filetype-pdf": "./packages/pharos/src/styles/icons/filetype-pdf.ts",
	"./filetype-pdf.ts": "./packages/pharos/src/styles/icons/filetype-pdf.ts",
	"./filetype-ppt": "./packages/pharos/src/styles/icons/filetype-ppt.ts",
	"./filetype-ppt.ts": "./packages/pharos/src/styles/icons/filetype-ppt.ts",
	"./filetype-zip": "./packages/pharos/src/styles/icons/filetype-zip.ts",
	"./filetype-zip.ts": "./packages/pharos/src/styles/icons/filetype-zip.ts",
	"./fit-to-view": "./packages/pharos/src/styles/icons/fit-to-view.ts",
	"./fit-to-view.ts": "./packages/pharos/src/styles/icons/fit-to-view.ts",
	"./fit-to-width": "./packages/pharos/src/styles/icons/fit-to-width.ts",
	"./fit-to-width.ts": "./packages/pharos/src/styles/icons/fit-to-width.ts",
	"./folder": "./packages/pharos/src/styles/icons/folder.ts",
	"./folder-new": "./packages/pharos/src/styles/icons/folder-new.ts",
	"./folder-new.ts": "./packages/pharos/src/styles/icons/folder-new.ts",
	"./folder-selected": "./packages/pharos/src/styles/icons/folder-selected.ts",
	"./folder-selected.ts": "./packages/pharos/src/styles/icons/folder-selected.ts",
	"./folder.ts": "./packages/pharos/src/styles/icons/folder.ts",
	"./fullscreen": "./packages/pharos/src/styles/icons/fullscreen.ts",
	"./fullscreen-minimize": "./packages/pharos/src/styles/icons/fullscreen-minimize.ts",
	"./fullscreen-minimize.ts": "./packages/pharos/src/styles/icons/fullscreen-minimize.ts",
	"./fullscreen.ts": "./packages/pharos/src/styles/icons/fullscreen.ts",
	"./google": "./packages/pharos/src/styles/icons/google.ts",
	"./google-color": "./packages/pharos/src/styles/icons/google-color.ts",
	"./google-color.ts": "./packages/pharos/src/styles/icons/google-color.ts",
	"./google.ts": "./packages/pharos/src/styles/icons/google.ts",
	"./image": "./packages/pharos/src/styles/icons/image.ts",
	"./image.ts": "./packages/pharos/src/styles/icons/image.ts",
	"./info-inverse": "./packages/pharos/src/styles/icons/info-inverse.ts",
	"./info-inverse.ts": "./packages/pharos/src/styles/icons/info-inverse.ts",
	"./instagram": "./packages/pharos/src/styles/icons/instagram.ts",
	"./instagram.ts": "./packages/pharos/src/styles/icons/instagram.ts",
	"./laptop": "./packages/pharos/src/styles/icons/laptop.ts",
	"./laptop.ts": "./packages/pharos/src/styles/icons/laptop.ts",
	"./link": "./packages/pharos/src/styles/icons/link.ts",
	"./link-add": "./packages/pharos/src/styles/icons/link-add.ts",
	"./link-add.ts": "./packages/pharos/src/styles/icons/link-add.ts",
	"./link-external": "./packages/pharos/src/styles/icons/link-external.ts",
	"./link-external.ts": "./packages/pharos/src/styles/icons/link-external.ts",
	"./link.ts": "./packages/pharos/src/styles/icons/link.ts",
	"./linkedin": "./packages/pharos/src/styles/icons/linkedin.ts",
	"./linkedin.ts": "./packages/pharos/src/styles/icons/linkedin.ts",
	"./menu": "./packages/pharos/src/styles/icons/menu.ts",
	"./menu.ts": "./packages/pharos/src/styles/icons/menu.ts",
	"./move": "./packages/pharos/src/styles/icons/move.ts",
	"./move.ts": "./packages/pharos/src/styles/icons/move.ts",
	"./new": "./packages/pharos/src/styles/icons/new.ts",
	"./new.ts": "./packages/pharos/src/styles/icons/new.ts",
	"./partial-circle": "./packages/pharos/src/styles/icons/partial-circle.ts",
	"./partial-circle.ts": "./packages/pharos/src/styles/icons/partial-circle.ts",
	"./primary-source": "./packages/pharos/src/styles/icons/primary-source.ts",
	"./primary-source.ts": "./packages/pharos/src/styles/icons/primary-source.ts",
	"./profile": "./packages/pharos/src/styles/icons/profile.ts",
	"./profile.ts": "./packages/pharos/src/styles/icons/profile.ts",
	"./question-inverse": "./packages/pharos/src/styles/icons/question-inverse.ts",
	"./question-inverse.ts": "./packages/pharos/src/styles/icons/question-inverse.ts",
	"./save": "./packages/pharos/src/styles/icons/save.ts",
	"./save.ts": "./packages/pharos/src/styles/icons/save.ts",
	"./saved": "./packages/pharos/src/styles/icons/saved.ts",
	"./saved.ts": "./packages/pharos/src/styles/icons/saved.ts",
	"./search": "./packages/pharos/src/styles/icons/search.ts",
	"./search.ts": "./packages/pharos/src/styles/icons/search.ts",
	"./share": "./packages/pharos/src/styles/icons/share.ts",
	"./share.ts": "./packages/pharos/src/styles/icons/share.ts",
	"./shift-down": "./packages/pharos/src/styles/icons/shift-down.ts",
	"./shift-down.ts": "./packages/pharos/src/styles/icons/shift-down.ts",
	"./shift-left": "./packages/pharos/src/styles/icons/shift-left.ts",
	"./shift-left.ts": "./packages/pharos/src/styles/icons/shift-left.ts",
	"./shift-right": "./packages/pharos/src/styles/icons/shift-right.ts",
	"./shift-right.ts": "./packages/pharos/src/styles/icons/shift-right.ts",
	"./shift-up": "./packages/pharos/src/styles/icons/shift-up.ts",
	"./shift-up.ts": "./packages/pharos/src/styles/icons/shift-up.ts",
	"./tumblr": "./packages/pharos/src/styles/icons/tumblr.ts",
	"./tumblr.ts": "./packages/pharos/src/styles/icons/tumblr.ts",
	"./twitter": "./packages/pharos/src/styles/icons/twitter.ts",
	"./twitter.ts": "./packages/pharos/src/styles/icons/twitter.ts",
	"./video": "./packages/pharos/src/styles/icons/video.ts",
	"./video.ts": "./packages/pharos/src/styles/icons/video.ts",
	"./view-gallery": "./packages/pharos/src/styles/icons/view-gallery.ts",
	"./view-gallery.ts": "./packages/pharos/src/styles/icons/view-gallery.ts",
	"./view-grid": "./packages/pharos/src/styles/icons/view-grid.ts",
	"./view-grid.ts": "./packages/pharos/src/styles/icons/view-grid.ts",
	"./view-list": "./packages/pharos/src/styles/icons/view-list.ts",
	"./view-list.ts": "./packages/pharos/src/styles/icons/view-list.ts",
	"./workspace": "./packages/pharos/src/styles/icons/workspace.ts",
	"./workspace-selected": "./packages/pharos/src/styles/icons/workspace-selected.ts",
	"./workspace-selected.ts": "./packages/pharos/src/styles/icons/workspace-selected.ts",
	"./workspace.ts": "./packages/pharos/src/styles/icons/workspace.ts",
	"./youtube": "./packages/pharos/src/styles/icons/youtube.ts",
	"./youtube.ts": "./packages/pharos/src/styles/icons/youtube.ts",
	"./zoom-in": "./packages/pharos/src/styles/icons/zoom-in.ts",
	"./zoom-in.ts": "./packages/pharos/src/styles/icons/zoom-in.ts",
	"./zoom-out": "./packages/pharos/src/styles/icons/zoom-out.ts",
	"./zoom-out.ts": "./packages/pharos/src/styles/icons/zoom-out.ts"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./packages/pharos/src/styles/icons sync recursive ^\\.\\/.*$";

/***/ }),

/***/ "./packages/pharos sync recursive ^\\.(?:(?:^%7C\\/%7C(?:(?:(?%21(?:^%7C\\/)\\.).)*?)\\/)(?%21\\.)(?=.)[^/]*?\\.(wc%7Cdocs%7Cpages)\\.stories\\.(js%7Cjsx%7Cmdx%7Cts))$":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var map = {
	"./docs/1.intro.docs.stories.mdx": "./packages/pharos/docs/1.intro.docs.stories.mdx",
	"./docs/2.changelog.docs.stories.mdx": "./packages/pharos/docs/2.changelog.docs.stories.mdx",
	"./src/components/alert/pharos-alert.wc.stories.jsx": "./packages/pharos/src/components/alert/pharos-alert.wc.stories.jsx",
	"./src/components/breadcrumb/pharos-breadcrumb.wc.stories.jsx": "./packages/pharos/src/components/breadcrumb/pharos-breadcrumb.wc.stories.jsx",
	"./src/components/button/pharos-button.wc.stories.jsx": "./packages/pharos/src/components/button/pharos-button.wc.stories.jsx",
	"./src/components/checkbox-group/pharos-checkbox-group.wc.stories.jsx": "./packages/pharos/src/components/checkbox-group/pharos-checkbox-group.wc.stories.jsx",
	"./src/components/checkbox/pharos-checkbox.wc.stories.jsx": "./packages/pharos/src/components/checkbox/pharos-checkbox.wc.stories.jsx",
	"./src/components/combobox/pharos-combobox.wc.stories.jsx": "./packages/pharos/src/components/combobox/pharos-combobox.wc.stories.jsx",
	"./src/components/dropdown-menu-nav/pharos-dropdown-menu-nav.wc.stories.jsx": "./packages/pharos/src/components/dropdown-menu-nav/pharos-dropdown-menu-nav.wc.stories.jsx",
	"./src/components/dropdown-menu/pharos-dropdown-menu.wc.stories.jsx": "./packages/pharos/src/components/dropdown-menu/pharos-dropdown-menu.wc.stories.jsx",
	"./src/components/footer/pharos-footer.wc.stories.jsx": "./packages/pharos/src/components/footer/pharos-footer.wc.stories.jsx",
	"./src/components/header/pharos-header.wc.stories.jsx": "./packages/pharos/src/components/header/pharos-header.wc.stories.jsx",
	"./src/components/heading/pharos-heading.wc.stories.jsx": "./packages/pharos/src/components/heading/pharos-heading.wc.stories.jsx",
	"./src/components/icon/pharos-icon.wc.stories.jsx": "./packages/pharos/src/components/icon/pharos-icon.wc.stories.jsx",
	"./src/components/image-card/pharos-image-card.wc.stories.jsx": "./packages/pharos/src/components/image-card/pharos-image-card.wc.stories.jsx",
	"./src/components/input-group/pharos-input-group.wc.stories.jsx": "./packages/pharos/src/components/input-group/pharos-input-group.wc.stories.jsx",
	"./src/components/layout/pharos-layout.wc.stories.jsx": "./packages/pharos/src/components/layout/pharos-layout.wc.stories.jsx",
	"./src/components/link/pharos-link.wc.stories.jsx": "./packages/pharos/src/components/link/pharos-link.wc.stories.jsx",
	"./src/components/loading-spinner/pharos-loading-spinner.wc.stories.jsx": "./packages/pharos/src/components/loading-spinner/pharos-loading-spinner.wc.stories.jsx",
	"./src/components/modal/pharos-modal.wc.stories.jsx": "./packages/pharos/src/components/modal/pharos-modal.wc.stories.jsx",
	"./src/components/pagination/pharos-pagination.wc.stories.jsx": "./packages/pharos/src/components/pagination/pharos-pagination.wc.stories.jsx",
	"./src/components/progress-bar/pharos-progress-bar.wc.stories.jsx": "./packages/pharos/src/components/progress-bar/pharos-progress-bar.wc.stories.jsx",
	"./src/components/radio-button/pharos-radio-button.wc.stories.jsx": "./packages/pharos/src/components/radio-button/pharos-radio-button.wc.stories.jsx",
	"./src/components/radio-group/pharos-radio-group.wc.stories.jsx": "./packages/pharos/src/components/radio-group/pharos-radio-group.wc.stories.jsx",
	"./src/components/select/pharos-select.wc.stories.jsx": "./packages/pharos/src/components/select/pharos-select.wc.stories.jsx",
	"./src/components/sidenav/pharos-sidenav.wc.stories.jsx": "./packages/pharos/src/components/sidenav/pharos-sidenav.wc.stories.jsx",
	"./src/components/tabs/pharos-tabs.wc.stories.jsx": "./packages/pharos/src/components/tabs/pharos-tabs.wc.stories.jsx",
	"./src/components/text-input/pharos-text-input.wc.stories.jsx": "./packages/pharos/src/components/text-input/pharos-text-input.wc.stories.jsx",
	"./src/components/textarea/pharos-textarea.wc.stories.jsx": "./packages/pharos/src/components/textarea/pharos-textarea.wc.stories.jsx",
	"./src/components/toast/pharos-toast.wc.stories.jsx": "./packages/pharos/src/components/toast/pharos-toast.wc.stories.jsx",
	"./src/components/toggle-button-group/pharos-toggle-button-group.wc.stories.jsx": "./packages/pharos/src/components/toggle-button-group/pharos-toggle-button-group.wc.stories.jsx",
	"./src/components/tooltip/pharos-tooltip.wc.stories.jsx": "./packages/pharos/src/components/tooltip/pharos-tooltip.wc.stories.jsx",
	"./src/pages/home/wc/home.pages.stories.ts": "./packages/pharos/src/pages/home/wc/home.pages.stories.ts",
	"./src/pages/item-detail/wc/item-detail.pages.stories.ts": "./packages/pharos/src/pages/item-detail/wc/item-detail.pages.stories.ts",
	"./src/pages/reports/wc/reports.pages.stories.ts": "./packages/pharos/src/pages/reports/wc/reports.pages.stories.ts",
	"./src/pages/search/wc/search.pages.stories.ts": "./packages/pharos/src/pages/search/wc/search.pages.stories.ts",
	"./src/styles/sass.wc.stories.jsx": "./packages/pharos/src/styles/sass.wc.stories.jsx",
	"./src/styles/tokens.wc.stories.jsx": "./packages/pharos/src/styles/tokens.wc.stories.jsx",
	"./src/styles/typography.wc.stories.jsx": "./packages/pharos/src/styles/typography.wc.stories.jsx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./packages/pharos sync recursive ^\\.(?:(?:^%7C\\/%7C(?:(?:(?%21(?:^%7C\\/)\\.).)*?)\\/)(?%21\\.)(?=.)[^/]*?\\.(wc%7Cdocs%7Cpages)\\.stories\\.(js%7Cjsx%7Cmdx%7Cts))$";

/***/ }),

/***/ "?4f7e":
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ "./generated-stories-entry.cjs":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


var _frameworkImportPath = __webpack_require__("./node_modules/@storybook/web-components/dist/esm/client/index.js");

/* eslint-disable import/no-unresolved */
(0, _frameworkImportPath.configure)([__webpack_require__("./packages/pharos sync recursive ^\\.(?:(?:^%7C\\/%7C(?:(?:(?%21(?:^%7C\\/)\\.).)*?)\\/)(?%21\\.)(?=.)[^/]*?\\.(wc%7Cdocs%7Cpages)\\.stories\\.(js%7Cjsx%7Cmdx%7Cts))$")], module, false);

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [883], () => (__webpack_exec__("./node_modules/@storybook/core-client/dist/esm/globals/polyfills.js"), __webpack_exec__("./node_modules/@storybook/core-client/dist/esm/globals/globals.js"), __webpack_exec__("./storybook-init-framework-entry.js"), __webpack_exec__("./node_modules/@storybook/web-components/dist/esm/client/preview/config-generated-config-entry.js"), __webpack_exec__("./node_modules/@storybook/web-components/dist/esm/client/docs/config-generated-config-entry.js"), __webpack_exec__("./node_modules/@storybook/addon-docs/preview.js-generated-config-entry.js"), __webpack_exec__("./node_modules/@storybook/addon-actions/preview.js-generated-config-entry.js"), __webpack_exec__("./node_modules/@storybook/addon-a11y/preview.js-generated-config-entry.js"), __webpack_exec__("./node_modules/@storybook/addon-measure/preview.js-generated-config-entry.js"), __webpack_exec__("./node_modules/@storybook/addon-outline/preview.js-generated-config-entry.js"), __webpack_exec__("./node_modules/@storybook/addon-backgrounds/preview.js-generated-config-entry.js"), __webpack_exec__("./.storybook/wc/preview.js-generated-config-entry.js"), __webpack_exec__("./generated-stories-entry.cjs")));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);